var Jw = Object.defineProperty;
var Xw = (e, t, n) => t in e ? Jw(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Y8 = (e, t, n) => (Xw(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as pe from "react";
import M, { createContext as Qe, forwardRef as Ji, useRef as be, useMemo as _e, useEffect as Re, createRef as N2, useState as ke, useContext as Ue, useId as Mt, useReducer as Ca, useLayoutEffect as w4, useCallback as ft, Fragment as n1, isValidElement as ws, cloneElement as ls, createElement as za, Component as Qw, useSyncExternalStore as ex, useDebugValue as $m, memo as tx } from "react";
import * as xs from "react-dom";
import rx, { createPortal as Wm, flushSync as O1, findDOMNode as nx } from "react-dom";
import Ym from "isomorphic-dompurify";
function Js(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var g0 = { exports: {} }, wo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pc;
function ax() {
  if (Pc)
    return wo;
  Pc = 1;
  var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return wo.Fragment = n, wo.jsx = o, wo.jsxs = o, wo;
}
var xo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ec;
function ix() {
  return Ec || (Ec = 1, process.env.NODE_ENV !== "production" && function() {
    var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, f = "@@iterator";
    function C(g) {
      if (g === null || typeof g != "object")
        return null;
      var E = m && g[m] || g[f];
      return typeof E == "function" ? E : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(g) {
      {
        for (var E = arguments.length, R = new Array(E > 1 ? E - 1 : 0), X = 1; X < E; X++)
          R[X - 1] = arguments[X];
        w("error", g, R);
      }
    }
    function w(g, E, R) {
      {
        var X = _.ReactDebugCurrentFrame, ce = X.getStackAddendum();
        ce !== "" && (E += "%s", R = R.concat([ce]));
        var ue = R.map(function(ie) {
          return String(ie);
        });
        ue.unshift("Warning: " + E), Function.prototype.apply.call(console[g], console, ue);
      }
    }
    var k = !1, b = !1, S = !1, P = !1, O = !1, A;
    A = Symbol.for("react.module.reference");
    function L(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || O || g === a || g === c || g === u || P || g === h || k || b || S || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === d || g.$$typeof === o || g.$$typeof === s || g.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === A || g.getModuleId !== void 0));
    }
    function I(g, E, R) {
      var X = g.displayName;
      if (X)
        return X;
      var ce = E.displayName || E.name || "";
      return ce !== "" ? R + "(" + ce + ")" : R;
    }
    function D(g) {
      return g.displayName || "Context";
    }
    function U(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case s:
            var E = g;
            return D(E) + ".Consumer";
          case o:
            var R = g;
            return D(R._context) + ".Provider";
          case l:
            return I(g, g.render, "ForwardRef");
          case d:
            var X = g.displayName || null;
            return X !== null ? X : U(g.type) || "Memo";
          case p: {
            var ce = g, ue = ce._payload, ie = ce._init;
            try {
              return U(ie(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, $ = 0, ee, Z, G, W, j, T, F;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function Y() {
      {
        if ($ === 0) {
          ee = console.log, Z = console.info, G = console.warn, W = console.error, j = console.group, T = console.groupCollapsed, F = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        $++;
      }
    }
    function Q() {
      {
        if ($--, $ === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, g, {
              value: ee
            }),
            info: z({}, g, {
              value: Z
            }),
            warn: z({}, g, {
              value: G
            }),
            error: z({}, g, {
              value: W
            }),
            group: z({}, g, {
              value: j
            }),
            groupCollapsed: z({}, g, {
              value: T
            }),
            groupEnd: z({}, g, {
              value: F
            })
          });
        }
        $ < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = _.ReactCurrentDispatcher, re;
    function q(g, E, R) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ce) {
            var X = ce.stack.trim().match(/\n( *(at )?)/);
            re = X && X[1] || "";
          }
        return `
` + re + g;
      }
    }
    var he = !1, me;
    {
      var Ne = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Ne();
    }
    function K(g, E) {
      if (!g || he)
        return "";
      {
        var R = me.get(g);
        if (R !== void 0)
          return R;
      }
      var X;
      he = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = V.current, V.current = null, Y();
      try {
        if (E) {
          var ie = function() {
            throw Error();
          };
          if (Object.defineProperty(ie.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ie, []);
            } catch (He) {
              X = He;
            }
            Reflect.construct(g, [], ie);
          } else {
            try {
              ie.call();
            } catch (He) {
              X = He;
            }
            g.call(ie.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (He) {
            X = He;
          }
          g();
        }
      } catch (He) {
        if (He && X && typeof He.stack == "string") {
          for (var ne = He.stack.split(`
`), je = X.stack.split(`
`), we = ne.length - 1, xe = je.length - 1; we >= 1 && xe >= 0 && ne[we] !== je[xe]; )
            xe--;
          for (; we >= 1 && xe >= 0; we--, xe--)
            if (ne[we] !== je[xe]) {
              if (we !== 1 || xe !== 1)
                do
                  if (we--, xe--, xe < 0 || ne[we] !== je[xe]) {
                    var ze = `
` + ne[we].replace(" at new ", " at ");
                    return g.displayName && ze.includes("<anonymous>") && (ze = ze.replace("<anonymous>", g.displayName)), typeof g == "function" && me.set(g, ze), ze;
                  }
                while (we >= 1 && xe >= 0);
              break;
            }
        }
      } finally {
        he = !1, V.current = ue, Q(), Error.prepareStackTrace = ce;
      }
      var Yt = g ? g.displayName || g.name : "", Nt = Yt ? q(Yt) : "";
      return typeof g == "function" && me.set(g, Nt), Nt;
    }
    function Ee(g, E, R) {
      return K(g, !1);
    }
    function J(g) {
      var E = g.prototype;
      return !!(E && E.isReactComponent);
    }
    function te(g, E, R) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return K(g, J(g));
      if (typeof g == "string")
        return q(g);
      switch (g) {
        case c:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case l:
            return Ee(g.render);
          case d:
            return te(g.type, E, R);
          case p: {
            var X = g, ce = X._payload, ue = X._init;
            try {
              return te(ue(ce), E, R);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, Pe = {}, Ze = _.ReactDebugCurrentFrame;
    function _t(g) {
      if (g) {
        var E = g._owner, R = te(g.type, g._source, E ? E.type : null);
        Ze.setExtraStackFrame(R);
      } else
        Ze.setExtraStackFrame(null);
    }
    function st(g, E, R, X, ce) {
      {
        var ue = Function.call.bind(ye);
        for (var ie in g)
          if (ue(g, ie)) {
            var ne = void 0;
            try {
              if (typeof g[ie] != "function") {
                var je = Error((X || "React class") + ": " + R + " type `" + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw je.name = "Invariant Violation", je;
              }
              ne = g[ie](E, ie, X, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (we) {
              ne = we;
            }
            ne && !(ne instanceof Error) && (_t(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", R, ie, typeof ne), _t(null)), ne instanceof Error && !(ne.message in Pe) && (Pe[ne.message] = !0, _t(ce), v("Failed %s type: %s", R, ne.message), _t(null));
          }
      }
    }
    var L1 = Array.isArray;
    function $t(g) {
      return L1(g);
    }
    function Qt(g) {
      {
        var E = typeof Symbol == "function" && Symbol.toStringTag, R = E && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return R;
      }
    }
    function Ie(g) {
      try {
        return lt(g), !1;
      } catch {
        return !0;
      }
    }
    function lt(g) {
      return "" + g;
    }
    function C1(g) {
      if (Ie(g))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qt(g)), lt(g);
    }
    var At = _.ReactCurrentOwner, g1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, Ce, Le;
    Le = {};
    function ct(g) {
      if (ye.call(g, "ref")) {
        var E = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function y1(g) {
      if (ye.call(g, "key")) {
        var E = Object.getOwnPropertyDescriptor(g, "key").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function $1(g, E) {
      if (typeof g.ref == "string" && At.current && E && At.current.stateNode !== E) {
        var R = U(At.current.type);
        Le[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(At.current.type), g.ref), Le[R] = !0);
      }
    }
    function Xr(g, E) {
      {
        var R = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        R.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function e2(g, E) {
      {
        var R = function() {
          Ce || (Ce = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        R.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var t2 = function(g, E, R, X, ce, ue, ie) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: g,
        key: E,
        ref: R,
        props: ie,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function r2(g, E, R, X, ce) {
      {
        var ue, ie = {}, ne = null, je = null;
        R !== void 0 && (C1(R), ne = "" + R), y1(E) && (C1(E.key), ne = "" + E.key), ct(E) && (je = E.ref, $1(E, ce));
        for (ue in E)
          ye.call(E, ue) && !g1.hasOwnProperty(ue) && (ie[ue] = E[ue]);
        if (g && g.defaultProps) {
          var we = g.defaultProps;
          for (ue in we)
            ie[ue] === void 0 && (ie[ue] = we[ue]);
        }
        if (ne || je) {
          var xe = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          ne && Xr(ie, xe), je && e2(ie, xe);
        }
        return t2(g, ne, je, ce, X, At.current, ie);
      }
    }
    var er = _.ReactCurrentOwner, Qr = _.ReactDebugCurrentFrame;
    function Wt(g) {
      if (g) {
        var E = g._owner, R = te(g.type, g._source, E ? E.type : null);
        Qr.setExtraStackFrame(R);
      } else
        Qr.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function rr(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function en() {
      {
        if (er.current) {
          var g = U(er.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function n2(g) {
      return "";
    }
    var tn = {};
    function a2(g) {
      {
        var E = en();
        if (!E) {
          var R = typeof g == "string" ? g : g.displayName || g.name;
          R && (E = `

Check the top-level render call using <` + R + ">.");
        }
        return E;
      }
    }
    function rn(g, E) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var R = a2(E);
        if (tn[R])
          return;
        tn[R] = !0;
        var X = "";
        g && g._owner && g._owner !== er.current && (X = " It was passed a child from " + U(g._owner.type) + "."), Wt(g), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, X), Wt(null);
      }
    }
    function nn(g, E) {
      {
        if (typeof g != "object")
          return;
        if ($t(g))
          for (var R = 0; R < g.length; R++) {
            var X = g[R];
            rr(X) && rn(X, E);
          }
        else if (rr(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var ce = C(g);
          if (typeof ce == "function" && ce !== g.entries)
            for (var ue = ce.call(g), ie; !(ie = ue.next()).done; )
              rr(ie.value) && rn(ie.value, E);
        }
      }
    }
    function i2(g) {
      {
        var E = g.type;
        if (E == null || typeof E == "string")
          return;
        var R;
        if (typeof E == "function")
          R = E.propTypes;
        else if (typeof E == "object" && (E.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        E.$$typeof === d))
          R = E.propTypes;
        else
          return;
        if (R) {
          var X = U(E);
          st(R, g.props, "prop", X, g);
        } else if (E.PropTypes !== void 0 && !tr) {
          tr = !0;
          var ce = U(E);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof E.getDefaultProps == "function" && !E.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function o2(g) {
      {
        for (var E = Object.keys(g.props), R = 0; R < E.length; R++) {
          var X = E[R];
          if (X !== "children" && X !== "key") {
            Wt(g), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Wt(null);
            break;
          }
        }
        g.ref !== null && (Wt(g), v("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var an = {};
    function on(g, E, R, X, ce, ue) {
      {
        var ie = L(g);
        if (!ie) {
          var ne = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var je = n2();
          je ? ne += je : ne += en();
          var we;
          g === null ? we = "null" : $t(g) ? we = "array" : g !== void 0 && g.$$typeof === t ? (we = "<" + (U(g.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : we = typeof g, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", we, ne);
        }
        var xe = r2(g, E, R, ce, ue);
        if (xe == null)
          return xe;
        if (ie) {
          var ze = E.children;
          if (ze !== void 0)
            if (X)
              if ($t(ze)) {
                for (var Yt = 0; Yt < ze.length; Yt++)
                  nn(ze[Yt], g);
                Object.freeze && Object.freeze(ze);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              nn(ze, g);
        }
        if (ye.call(E, "key")) {
          var Nt = U(g), He = Object.keys(E).filter(function(p2) {
            return p2 !== "key";
          }), nr = He.length > 0 ? "{key: someKey, " + He.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!an[Nt + nr]) {
            var d2 = He.length > 0 ? "{" + He.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nr, Nt, d2, Nt), an[Nt + nr] = !0;
          }
        }
        return g === r ? o2(xe) : i2(xe), xe;
      }
    }
    function s2(g, E, R) {
      return on(g, E, R, !0);
    }
    function l2(g, E, R) {
      return on(g, E, R, !1);
    }
    var c2 = l2, u2 = s2;
    xo.Fragment = r, xo.jsx = c2, xo.jsxs = u2;
  }()), xo;
}
process.env.NODE_ENV === "production" ? g0.exports = ax() : g0.exports = ix();
var x = g0.exports, Ri = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function A5(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var y0 = { exports: {} }, So = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tc;
function ox() {
  if (Tc)
    return So;
  Tc = 1;
  var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return So.Fragment = n, So.jsx = o, So.jsxs = o, So;
}
var L9 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lc;
function sx() {
  return Lc || (Lc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, f = "@@iterator";
    function C(g) {
      if (g === null || typeof g != "object")
        return null;
      var E = m && g[m] || g[f];
      return typeof E == "function" ? E : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(g) {
      {
        for (var E = arguments.length, R = new Array(E > 1 ? E - 1 : 0), X = 1; X < E; X++)
          R[X - 1] = arguments[X];
        w("error", g, R);
      }
    }
    function w(g, E, R) {
      {
        var X = _.ReactDebugCurrentFrame, ce = X.getStackAddendum();
        ce !== "" && (E += "%s", R = R.concat([ce]));
        var ue = R.map(function(ie) {
          return String(ie);
        });
        ue.unshift("Warning: " + E), Function.prototype.apply.call(console[g], console, ue);
      }
    }
    var k = !1, b = !1, S = !1, P = !1, O = !1, A;
    A = Symbol.for("react.module.reference");
    function L(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || O || g === a || g === c || g === u || P || g === h || k || b || S || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === d || g.$$typeof === o || g.$$typeof === s || g.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === A || g.getModuleId !== void 0));
    }
    function I(g, E, R) {
      var X = g.displayName;
      if (X)
        return X;
      var ce = E.displayName || E.name || "";
      return ce !== "" ? R + "(" + ce + ")" : R;
    }
    function D(g) {
      return g.displayName || "Context";
    }
    function U(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case s:
            var E = g;
            return D(E) + ".Consumer";
          case o:
            var R = g;
            return D(R._context) + ".Provider";
          case l:
            return I(g, g.render, "ForwardRef");
          case d:
            var X = g.displayName || null;
            return X !== null ? X : U(g.type) || "Memo";
          case p: {
            var ce = g, ue = ce._payload, ie = ce._init;
            try {
              return U(ie(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, $ = 0, ee, Z, G, W, j, T, F;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function Y() {
      {
        if ($ === 0) {
          ee = console.log, Z = console.info, G = console.warn, W = console.error, j = console.group, T = console.groupCollapsed, F = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        $++;
      }
    }
    function Q() {
      {
        if ($--, $ === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, g, {
              value: ee
            }),
            info: z({}, g, {
              value: Z
            }),
            warn: z({}, g, {
              value: G
            }),
            error: z({}, g, {
              value: W
            }),
            group: z({}, g, {
              value: j
            }),
            groupCollapsed: z({}, g, {
              value: T
            }),
            groupEnd: z({}, g, {
              value: F
            })
          });
        }
        $ < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = _.ReactCurrentDispatcher, re;
    function q(g, E, R) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ce) {
            var X = ce.stack.trim().match(/\n( *(at )?)/);
            re = X && X[1] || "";
          }
        return `
` + re + g;
      }
    }
    var he = !1, me;
    {
      var Ne = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Ne();
    }
    function K(g, E) {
      if (!g || he)
        return "";
      {
        var R = me.get(g);
        if (R !== void 0)
          return R;
      }
      var X;
      he = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = V.current, V.current = null, Y();
      try {
        if (E) {
          var ie = function() {
            throw Error();
          };
          if (Object.defineProperty(ie.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ie, []);
            } catch (He) {
              X = He;
            }
            Reflect.construct(g, [], ie);
          } else {
            try {
              ie.call();
            } catch (He) {
              X = He;
            }
            g.call(ie.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (He) {
            X = He;
          }
          g();
        }
      } catch (He) {
        if (He && X && typeof He.stack == "string") {
          for (var ne = He.stack.split(`
`), je = X.stack.split(`
`), we = ne.length - 1, xe = je.length - 1; we >= 1 && xe >= 0 && ne[we] !== je[xe]; )
            xe--;
          for (; we >= 1 && xe >= 0; we--, xe--)
            if (ne[we] !== je[xe]) {
              if (we !== 1 || xe !== 1)
                do
                  if (we--, xe--, xe < 0 || ne[we] !== je[xe]) {
                    var ze = `
` + ne[we].replace(" at new ", " at ");
                    return g.displayName && ze.includes("<anonymous>") && (ze = ze.replace("<anonymous>", g.displayName)), typeof g == "function" && me.set(g, ze), ze;
                  }
                while (we >= 1 && xe >= 0);
              break;
            }
        }
      } finally {
        he = !1, V.current = ue, Q(), Error.prepareStackTrace = ce;
      }
      var Yt = g ? g.displayName || g.name : "", Nt = Yt ? q(Yt) : "";
      return typeof g == "function" && me.set(g, Nt), Nt;
    }
    function Ee(g, E, R) {
      return K(g, !1);
    }
    function J(g) {
      var E = g.prototype;
      return !!(E && E.isReactComponent);
    }
    function te(g, E, R) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return K(g, J(g));
      if (typeof g == "string")
        return q(g);
      switch (g) {
        case c:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case l:
            return Ee(g.render);
          case d:
            return te(g.type, E, R);
          case p: {
            var X = g, ce = X._payload, ue = X._init;
            try {
              return te(ue(ce), E, R);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, Pe = {}, Ze = _.ReactDebugCurrentFrame;
    function _t(g) {
      if (g) {
        var E = g._owner, R = te(g.type, g._source, E ? E.type : null);
        Ze.setExtraStackFrame(R);
      } else
        Ze.setExtraStackFrame(null);
    }
    function st(g, E, R, X, ce) {
      {
        var ue = Function.call.bind(ye);
        for (var ie in g)
          if (ue(g, ie)) {
            var ne = void 0;
            try {
              if (typeof g[ie] != "function") {
                var je = Error((X || "React class") + ": " + R + " type `" + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw je.name = "Invariant Violation", je;
              }
              ne = g[ie](E, ie, X, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (we) {
              ne = we;
            }
            ne && !(ne instanceof Error) && (_t(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", R, ie, typeof ne), _t(null)), ne instanceof Error && !(ne.message in Pe) && (Pe[ne.message] = !0, _t(ce), v("Failed %s type: %s", R, ne.message), _t(null));
          }
      }
    }
    var L1 = Array.isArray;
    function $t(g) {
      return L1(g);
    }
    function Qt(g) {
      {
        var E = typeof Symbol == "function" && Symbol.toStringTag, R = E && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return R;
      }
    }
    function Ie(g) {
      try {
        return lt(g), !1;
      } catch {
        return !0;
      }
    }
    function lt(g) {
      return "" + g;
    }
    function C1(g) {
      if (Ie(g))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qt(g)), lt(g);
    }
    var At = _.ReactCurrentOwner, g1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, Ce, Le;
    Le = {};
    function ct(g) {
      if (ye.call(g, "ref")) {
        var E = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function y1(g) {
      if (ye.call(g, "key")) {
        var E = Object.getOwnPropertyDescriptor(g, "key").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function $1(g, E) {
      if (typeof g.ref == "string" && At.current && E && At.current.stateNode !== E) {
        var R = U(At.current.type);
        Le[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(At.current.type), g.ref), Le[R] = !0);
      }
    }
    function Xr(g, E) {
      {
        var R = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        R.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function e2(g, E) {
      {
        var R = function() {
          Ce || (Ce = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        R.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var t2 = function(g, E, R, X, ce, ue, ie) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: g,
        key: E,
        ref: R,
        props: ie,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function r2(g, E, R, X, ce) {
      {
        var ue, ie = {}, ne = null, je = null;
        R !== void 0 && (C1(R), ne = "" + R), y1(E) && (C1(E.key), ne = "" + E.key), ct(E) && (je = E.ref, $1(E, ce));
        for (ue in E)
          ye.call(E, ue) && !g1.hasOwnProperty(ue) && (ie[ue] = E[ue]);
        if (g && g.defaultProps) {
          var we = g.defaultProps;
          for (ue in we)
            ie[ue] === void 0 && (ie[ue] = we[ue]);
        }
        if (ne || je) {
          var xe = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          ne && Xr(ie, xe), je && e2(ie, xe);
        }
        return t2(g, ne, je, ce, X, At.current, ie);
      }
    }
    var er = _.ReactCurrentOwner, Qr = _.ReactDebugCurrentFrame;
    function Wt(g) {
      if (g) {
        var E = g._owner, R = te(g.type, g._source, E ? E.type : null);
        Qr.setExtraStackFrame(R);
      } else
        Qr.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function rr(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function en() {
      {
        if (er.current) {
          var g = U(er.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function n2(g) {
      return "";
    }
    var tn = {};
    function a2(g) {
      {
        var E = en();
        if (!E) {
          var R = typeof g == "string" ? g : g.displayName || g.name;
          R && (E = `

Check the top-level render call using <` + R + ">.");
        }
        return E;
      }
    }
    function rn(g, E) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var R = a2(E);
        if (tn[R])
          return;
        tn[R] = !0;
        var X = "";
        g && g._owner && g._owner !== er.current && (X = " It was passed a child from " + U(g._owner.type) + "."), Wt(g), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, X), Wt(null);
      }
    }
    function nn(g, E) {
      {
        if (typeof g != "object")
          return;
        if ($t(g))
          for (var R = 0; R < g.length; R++) {
            var X = g[R];
            rr(X) && rn(X, E);
          }
        else if (rr(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var ce = C(g);
          if (typeof ce == "function" && ce !== g.entries)
            for (var ue = ce.call(g), ie; !(ie = ue.next()).done; )
              rr(ie.value) && rn(ie.value, E);
        }
      }
    }
    function i2(g) {
      {
        var E = g.type;
        if (E == null || typeof E == "string")
          return;
        var R;
        if (typeof E == "function")
          R = E.propTypes;
        else if (typeof E == "object" && (E.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        E.$$typeof === d))
          R = E.propTypes;
        else
          return;
        if (R) {
          var X = U(E);
          st(R, g.props, "prop", X, g);
        } else if (E.PropTypes !== void 0 && !tr) {
          tr = !0;
          var ce = U(E);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof E.getDefaultProps == "function" && !E.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function o2(g) {
      {
        for (var E = Object.keys(g.props), R = 0; R < E.length; R++) {
          var X = E[R];
          if (X !== "children" && X !== "key") {
            Wt(g), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Wt(null);
            break;
          }
        }
        g.ref !== null && (Wt(g), v("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var an = {};
    function on(g, E, R, X, ce, ue) {
      {
        var ie = L(g);
        if (!ie) {
          var ne = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var je = n2();
          je ? ne += je : ne += en();
          var we;
          g === null ? we = "null" : $t(g) ? we = "array" : g !== void 0 && g.$$typeof === t ? (we = "<" + (U(g.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : we = typeof g, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", we, ne);
        }
        var xe = r2(g, E, R, ce, ue);
        if (xe == null)
          return xe;
        if (ie) {
          var ze = E.children;
          if (ze !== void 0)
            if (X)
              if ($t(ze)) {
                for (var Yt = 0; Yt < ze.length; Yt++)
                  nn(ze[Yt], g);
                Object.freeze && Object.freeze(ze);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              nn(ze, g);
        }
        if (ye.call(E, "key")) {
          var Nt = U(g), He = Object.keys(E).filter(function(p2) {
            return p2 !== "key";
          }), nr = He.length > 0 ? "{key: someKey, " + He.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!an[Nt + nr]) {
            var d2 = He.length > 0 ? "{" + He.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nr, Nt, d2, Nt), an[Nt + nr] = !0;
          }
        }
        return g === r ? o2(xe) : i2(xe), xe;
      }
    }
    function s2(g, E, R) {
      return on(g, E, R, !0);
    }
    function l2(g, E, R) {
      return on(g, E, R, !1);
    }
    var c2 = l2, u2 = s2;
    L9.Fragment = r, L9.jsx = c2, L9.jsxs = u2;
  }()), L9;
}
process.env.NODE_ENV === "production" ? y0.exports = ox() : y0.exports = sx();
var y = y0.exports;
const qm = typeof document < "u" ? M.useLayoutEffect : () => {
};
var q8;
const lx = (q8 = M.useInsertionEffect) !== null && q8 !== void 0 ? q8 : qm;
function cx(e) {
  const t = be(null);
  return lx(() => {
    t.current = e;
  }, [
    e
  ]), ft((...n) => {
    const r = t.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
const Ya = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, M2 = (e) => e && "window" in e && e.window === e ? e : Ya(e).defaultView || window;
function Jm(e, t) {
  return t && e ? e.contains(t) : !1;
}
const v0 = (e = document) => e.activeElement;
function Xm(e) {
  return e.target;
}
function O5(e) {
  var t;
  if (typeof window > "u" || window.navigator == null)
    return !1;
  let n = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(n) && n.some((r) => e.test(r.brand)) || e.test(window.navigator.userAgent);
}
function x4(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function ga(e) {
  if (process.env.NODE_ENV === "test")
    return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const S4 = ga(function() {
  return x4(/^Mac/i);
}), ux = ga(function() {
  return x4(/^iPhone/i);
}), dx = ga(function() {
  return x4(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  S4() && navigator.maxTouchPoints > 1;
}), px = ga(function() {
  return ux() || dx();
});
ga(function() {
  return S4() || px();
});
ga(function() {
  return O5(/AppleWebKit/i) && !hx();
});
const hx = ga(function() {
  return O5(/Chrome/i);
}), mx = ga(function() {
  return O5(/Android/i);
});
ga(function() {
  return O5(/Firefox/i);
});
function Qm() {
  let e = be(/* @__PURE__ */ new Map()), t = ft((a, i, o, s) => {
    let l = s != null && s.once ? (...c) => {
      e.current.delete(o), o(...c);
    } : o;
    e.current.set(o, {
      type: i,
      eventTarget: a,
      fn: l,
      options: s
    }), a.addEventListener(i, l, s);
  }, []), n = ft((a, i, o, s) => {
    var l;
    let c = ((l = e.current.get(o)) === null || l === void 0 ? void 0 : l.fn) || o;
    a.removeEventListener(i, c, s), e.current.delete(o);
  }, []), r = ft(() => {
    e.current.forEach((a, i) => {
      n(a.eventTarget, a.type, i, a.options);
    });
  }, [
    n
  ]);
  return Re(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function fx(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : mx() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function ef(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function Cx(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function tf(e) {
  let t = be({
    isFocused: !1,
    observer: null
  });
  qm(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = cx((r) => {
    e == null || e(r);
  });
  return ft((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = r.target, i = (o) => {
        if (t.current.isFocused = !1, a.disabled) {
          let s = ef(o);
          n(s);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let s = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
let gx = !1, Xs = null, b0 = /* @__PURE__ */ new Set(), ps = /* @__PURE__ */ new Map(), G2 = !1, _0 = !1;
const yx = {
  Tab: !0,
  Escape: !0
};
function k4(e, t) {
  for (let n of b0)
    n(e, t);
}
function vx(e) {
  return !(e.metaKey || !S4() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function A6(e) {
  G2 = !0, vx(e) && (Xs = "keyboard", k4("keyboard", e));
}
function Fr(e) {
  Xs = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (G2 = !0, k4("pointer", e));
}
function rf(e) {
  fx(e) && (G2 = !0, Xs = "virtual");
}
function nf(e) {
  e.target === window || e.target === document || gx || !e.isTrusted || (!G2 && !_0 && (Xs = "virtual", k4("virtual", e)), G2 = !1, _0 = !1);
}
function af() {
  G2 = !1, _0 = !0;
}
function w0(e) {
  if (typeof window > "u" || typeof document > "u" || ps.get(M2(e)))
    return;
  const t = M2(e), n = Ya(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    G2 = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", A6, !0), n.addEventListener("keyup", A6, !0), n.addEventListener("click", rf, !0), t.addEventListener("focus", nf, !0), t.addEventListener("blur", af, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", Fr, !0), n.addEventListener("pointermove", Fr, !0), n.addEventListener("pointerup", Fr, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", Fr, !0), n.addEventListener("mousemove", Fr, !0), n.addEventListener("mouseup", Fr, !0)), t.addEventListener("beforeunload", () => {
    of(e);
  }, {
    once: !0
  }), ps.set(t, {
    focus: r
  });
}
const of = (e, t) => {
  const n = M2(e), r = Ya(e);
  t && r.removeEventListener("DOMContentLoaded", t), ps.has(n) && (n.HTMLElement.prototype.focus = ps.get(n).focus, r.removeEventListener("keydown", A6, !0), r.removeEventListener("keyup", A6, !0), r.removeEventListener("click", rf, !0), n.removeEventListener("focus", nf, !0), n.removeEventListener("blur", af, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", Fr, !0), r.removeEventListener("pointermove", Fr, !0), r.removeEventListener("pointerup", Fr, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", Fr, !0), r.removeEventListener("mousemove", Fr, !0), r.removeEventListener("mouseup", Fr, !0)), ps.delete(n));
};
function bx(e) {
  const t = Ya(e);
  let n;
  return t.readyState !== "loading" ? w0(e) : (n = () => {
    w0(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => of(e, n);
}
typeof document < "u" && bx();
function sf() {
  return Xs !== "pointer";
}
const _x = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function wx(e, t, n) {
  let r = Ya(n == null ? void 0 : n.target);
  const a = typeof window < "u" ? M2(n == null ? void 0 : n.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? M2(n == null ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement, o = typeof window < "u" ? M2(n == null ? void 0 : n.target).HTMLElement : HTMLElement, s = typeof window < "u" ? M2(n == null ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
  return e = e || r.activeElement instanceof a && !_x.has(r.activeElement.type) || r.activeElement instanceof i || r.activeElement instanceof o && r.activeElement.isContentEditable, !(e && t === "keyboard" && n instanceof s && !yx[n.key]);
}
function xx(e, t, n) {
  w0(), Re(() => {
    let r = (a, i) => {
      wx(!!(n != null && n.isTextInput), a, i) && e(sf());
    };
    return b0.add(r), () => {
      b0.delete(r);
    };
  }, t);
}
function Sx(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: a } = e;
  const i = ft((l) => {
    if (l.target === l.currentTarget)
      return r && r(l), a && a(!1), !0;
  }, [
    r,
    a
  ]), o = tf(i), s = ft((l) => {
    const c = Ya(l.target), u = c ? v0(c) : v0();
    l.target === l.currentTarget && u === Xm(l.nativeEvent) && (n && n(l), a && a(!0), o(l));
  }, [
    a,
    n,
    o
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || a || r) ? s : void 0,
      onBlur: !t && (r || a) ? i : void 0
    }
  };
}
function kx(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = e, i = be({
    isFocusWithin: !1
  }), { addGlobalListener: o, removeAllGlobalListeners: s } = Qm(), l = ft((d) => {
    d.currentTarget.contains(d.target) && i.current.isFocusWithin && !d.currentTarget.contains(d.relatedTarget) && (i.current.isFocusWithin = !1, s(), n && n(d), a && a(!1));
  }, [
    n,
    a,
    i,
    s
  ]), c = tf(l), u = ft((d) => {
    if (!d.currentTarget.contains(d.target))
      return;
    const p = Ya(d.target), h = v0(p);
    if (!i.current.isFocusWithin && h === Xm(d.nativeEvent)) {
      r && r(d), a && a(!0), i.current.isFocusWithin = !0, c(d);
      let m = d.currentTarget;
      o(p, "focus", (f) => {
        if (i.current.isFocusWithin && !Jm(m, f.target)) {
          let C = new p.defaultView.FocusEvent("blur", {
            relatedTarget: f.target
          });
          Cx(C, m);
          let _ = ef(C);
          l(_);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    a,
    c,
    o,
    l
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: u,
      onBlur: l
    }
  };
}
let O6 = !1, A9 = 0;
function x0() {
  O6 = !0, setTimeout(() => {
    O6 = !1;
  }, 50);
}
function Ac(e) {
  e.pointerType === "touch" && x0();
}
function Mx() {
  if (!(typeof document > "u"))
    return A9 === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", Ac) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", x0)), A9++, () => {
      A9--, !(A9 > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", Ac) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", x0));
    };
}
function X1(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: a } = e, [i, o] = ke(!1), s = be({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Re(Mx, []);
  let { addGlobalListener: l, removeAllGlobalListeners: c } = Qm(), { hoverProps: u, triggerHoverEnd: d } = _e(() => {
    let p = (f, C) => {
      if (s.pointerType = C, a || C === "touch" || s.isHovered || !f.currentTarget.contains(f.target))
        return;
      s.isHovered = !0;
      let _ = f.currentTarget;
      s.target = _, l(Ya(f.target), "pointerover", (v) => {
        s.isHovered && s.target && !Jm(s.target, v.target) && h(v, v.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: _,
        pointerType: C
      }), n && n(!0), o(!0);
    }, h = (f, C) => {
      let _ = s.target;
      s.pointerType = "", s.target = null, !(C === "touch" || !s.isHovered || !_) && (s.isHovered = !1, c(), r && r({
        type: "hoverend",
        target: _,
        pointerType: C
      }), n && n(!1), o(!1));
    }, m = {};
    return typeof PointerEvent < "u" ? (m.onPointerEnter = (f) => {
      O6 && f.pointerType === "mouse" || p(f, f.pointerType);
    }, m.onPointerLeave = (f) => {
      !a && f.currentTarget.contains(f.target) && h(f, f.pointerType);
    }) : process.env.NODE_ENV === "test" && (m.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, m.onMouseEnter = (f) => {
      !s.ignoreEmulatedMouseEvents && !O6 && p(f, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, m.onMouseLeave = (f) => {
      !a && f.currentTarget.contains(f.target) && h(f, "mouse");
    }), {
      hoverProps: m,
      triggerHoverEnd: h
    };
  }, [
    t,
    n,
    r,
    a,
    s,
    l,
    c
  ]);
  return Re(() => {
    a && d({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    a
  ]), {
    hoverProps: u,
    isHovered: i
  };
}
function Z1(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, a = be({
    isFocused: !1,
    isFocusVisible: t || sf()
  }), [i, o] = ke(!1), [s, l] = ke(() => a.current.isFocused && a.current.isFocusVisible), c = ft(() => l(a.current.isFocused && a.current.isFocusVisible), []), u = ft((h) => {
    a.current.isFocused = h, o(h), c();
  }, [
    c
  ]);
  xx((h) => {
    a.current.isFocusVisible = h, c();
  }, [], {
    isTextInput: n
  });
  let { focusProps: d } = Sx({
    isDisabled: r,
    onFocusChange: u
  }), { focusWithinProps: p } = kx({
    isDisabled: !r,
    onFocusWithinChange: u
  });
  return {
    isFocused: i,
    isFocusVisible: s,
    focusProps: r ? p : d
  };
}
var Px = Object.defineProperty, Ex = (e, t, n) => t in e ? Px(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, J8 = (e, t, n) => (Ex(e, typeof t != "symbol" ? t + "" : t, n), n);
let Tx = class {
  constructor() {
    J8(this, "current", this.detect()), J8(this, "handoffState", "pending"), J8(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, j2 = new Tx();
function $r(e) {
  return j2.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function Qs(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function jr() {
  let e = [], t = { addEventListener(n, r, a, i) {
    return n.addEventListener(r, a, i), t.add(() => n.removeEventListener(r, a, i));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return Qs(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, a) {
    let i = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: a }), this.add(() => {
      Object.assign(n.style, { [r]: i });
    });
  }, group(n) {
    let r = jr();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.includes(n) || e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0)
        for (let a of e.splice(r, 1))
          a();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function Wr() {
  let [e] = ke(jr);
  return Re(() => () => e.dispose(), [e]), e;
}
let Je = (e, t) => {
  j2.isServer ? Re(e, t) : w4(e, t);
};
function G1(e) {
  let t = be(e);
  return Je(() => {
    t.current = e;
  }, [e]), t;
}
let ae = function(e) {
  let t = G1(e);
  return M.useCallback((...n) => t.current(...n), [t]);
};
function Lx(e) {
  let t = e.width / 2, n = e.height / 2;
  return { top: e.clientY - n, right: e.clientX + t, bottom: e.clientY + n, left: e.clientX - t };
}
function Ax(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function _n({ disabled: e = !1 } = {}) {
  let t = be(null), [n, r] = ke(!1), a = Wr(), i = ae(() => {
    t.current = null, r(!1), a.dispose();
  }), o = ae((s) => {
    if (a.dispose(), t.current === null) {
      t.current = s.currentTarget, r(!0);
      {
        let l = $r(s.currentTarget);
        a.addEventListener(l, "pointerup", i, !1), a.addEventListener(l, "pointermove", (c) => {
          if (t.current) {
            let u = Lx(c);
            r(Ax(u, t.current.getBoundingClientRect()));
          }
        }, !1), a.addEventListener(l, "pointercancel", i, !1);
      }
    }
  });
  return { pressed: n, pressProps: e ? {} : { onPointerDown: o, onPointerUp: i, onClick: i } };
}
let lf = Qe(void 0);
function _r() {
  return Ue(lf);
}
function cf({ value: e, children: t }) {
  return M.createElement(lf.Provider, { value: e }, t);
}
function S0(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function ht(e, t, ...n) {
  if (e in t) {
    let a = t[e];
    return typeof a == "function" ? a(...n) : a;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((a) => `"${a}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, ht), r;
}
var I1 = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(I1 || {}), Ia = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Ia || {});
function Ve() {
  let e = Nx();
  return ft((t) => Ox({ mergeRefs: e, ...t }), [e]);
}
function Ox({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: a, visible: i = !0, name: o, mergeRefs: s }) {
  s = s ?? jx;
  let l = uf(t, e);
  if (i)
    return O9(l, n, r, o, s);
  let c = a ?? 0;
  if (c & 2) {
    let { static: u = !1, ...d } = l;
    if (u)
      return O9(d, n, r, o, s);
  }
  if (c & 1) {
    let { unmount: u = !0, ...d } = l;
    return ht(u ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return O9({ ...d, hidden: !0, style: { display: "none" } }, n, r, o, s);
    } });
  }
  return O9(l, n, r, o, s);
}
function O9(e, t = {}, n, r, a) {
  let { as: i = n, children: o, refName: s = "ref", ...l } = X8(e, ["unmount", "static"]), c = e.ref !== void 0 ? { [s]: e.ref } : {}, u = typeof o == "function" ? o(t) : o;
  "className" in l && l.className && typeof l.className == "function" && (l.className = l.className(t)), l["aria-labelledby"] && l["aria-labelledby"] === l.id && (l["aria-labelledby"] = void 0);
  let d = {};
  if (t) {
    let p = !1, h = [];
    for (let [m, f] of Object.entries(t))
      typeof f == "boolean" && (p = !0), f === !0 && h.push(m.replace(/([A-Z])/g, (C) => `-${C.toLowerCase()}`));
    if (p) {
      d["data-headlessui-state"] = h.join(" ");
      for (let m of h)
        d[`data-${m}`] = "";
    }
  }
  if (i === n1 && (Object.keys(ja(l)).length > 0 || Object.keys(ja(d)).length > 0))
    if (!ws(u) || Array.isArray(u) && u.length > 1) {
      if (Object.keys(ja(l)).length > 0)
        throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(ja(l)).concat(Object.keys(ja(d))).map((p) => `  - ${p}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((p) => `  - ${p}`).join(`
`)].join(`
`));
    } else {
      let p = u.props, h = p == null ? void 0 : p.className, m = typeof h == "function" ? (..._) => S0(h(..._), l.className) : S0(h, l.className), f = m ? { className: m } : {}, C = uf(u.props, ja(X8(l, ["ref"])));
      for (let _ in d)
        _ in C && delete d[_];
      return ls(u, Object.assign({}, C, d, c, { ref: a(Rx(u), c.ref) }, f));
    }
  return za(i, Object.assign({}, X8(l, ["ref"]), i !== n1 && c, i !== n1 && d), u);
}
function Nx() {
  let e = be([]), t = ft((n) => {
    for (let r of e.current)
      r != null && (typeof r == "function" ? r(n) : r.current = n);
  }, []);
  return (...n) => {
    if (!n.every((r) => r == null))
      return e.current = n, t;
  };
}
function jx(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e)
      n != null && (typeof n == "function" ? n(t) : n.current = t);
  };
}
function uf(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let a in r)
      a.startsWith("on") && typeof r[a] == "function" ? (n[a] != null || (n[a] = []), n[a].push(r[a])) : t[a] = r[a];
  if (t.disabled || t["aria-disabled"])
    for (let r in n)
      /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(r) && (n[r] = [(a) => {
        var i;
        return (i = a == null ? void 0 : a.preventDefault) == null ? void 0 : i.call(a);
      }]);
  for (let r in n)
    Object.assign(t, { [r](a, ...i) {
      let o = n[r];
      for (let s of o) {
        if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented)
          return;
        s(a, ...i);
      }
    } });
  return t;
}
function f1(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let a in r)
      a.startsWith("on") && typeof r[a] == "function" ? (n[a] != null || (n[a] = []), n[a].push(r[a])) : t[a] = r[a];
  for (let r in n)
    Object.assign(t, { [r](...a) {
      let i = n[r];
      for (let o of i)
        o == null || o(...a);
    } });
  return t;
}
function De(e) {
  var t;
  return Object.assign(Ji(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function ja(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function X8(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t)
    r in n && delete n[r];
  return n;
}
function Rx(e) {
  return M.version.split(".")[0] >= "19" ? e.props.ref : e.ref;
}
let Dx = "button";
function Ix(e, t) {
  var n;
  let r = _r(), { disabled: a = r || !1, autoFocus: i = !1, ...o } = e, { isFocusVisible: s, focusProps: l } = Z1({ autoFocus: i }), { isHovered: c, hoverProps: u } = X1({ isDisabled: a }), { pressed: d, pressProps: p } = _n({ disabled: a }), h = f1({ ref: t, type: (n = o.type) != null ? n : "button", disabled: a || void 0, autoFocus: i }, l, u, p), m = _e(() => ({ disabled: a, hover: c, focus: s, active: d, autofocus: i }), [a, c, s, d, i]);
  return Ve()({ ourProps: h, theirProps: o, slot: m, defaultTag: Dx, name: "Button" });
}
let Hx = De(Ix);
function e9(e, t, n) {
  let [r, a] = ke(n), i = e !== void 0, o = be(i), s = be(!1), l = be(!1);
  return i && !o.current && !s.current ? (s.current = !0, o.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && o.current && !l.current && (l.current = !0, o.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : r, ae((c) => (i || a(c), t == null ? void 0 : t(c)))];
}
function t9(e) {
  let [t] = ke(e);
  return t;
}
function df(e = {}, t = null, n = []) {
  for (let [r, a] of Object.entries(e))
    hf(n, pf(t, r), a);
  return n;
}
function pf(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function hf(e, t, n) {
  if (Array.isArray(n))
    for (let [r, a] of n.entries())
      hf(e, pf(t, r.toString()), a);
  else
    n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : df(n, t, e);
}
function N5(e) {
  var t, n;
  let r = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (r) {
    for (let a of r.elements)
      if (a !== e && (a.tagName === "INPUT" && a.type === "submit" || a.tagName === "BUTTON" && a.type === "submit" || a.nodeName === "INPUT" && a.type === "image")) {
        a.click();
        return;
      }
    (n = r.requestSubmit) == null || n.call(r);
  }
}
let Fx = "span";
var gn = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(gn || {});
function Vx(e, t) {
  var n;
  let { features: r = 1, ...a } = e, i = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : (n = a["aria-hidden"]) != null ? n : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return Ve()({ ourProps: i, theirProps: a, slot: {}, defaultTag: Fx, name: "Hidden" });
}
let yn = De(Vx), mf = Qe(null);
function Bx(e) {
  let [t, n] = ke(null);
  return M.createElement(mf.Provider, { value: { target: t } }, e.children, M.createElement(yn, { features: gn.Hidden, ref: n }));
}
function zx({ children: e }) {
  let t = Ue(mf);
  if (!t)
    return M.createElement(M.Fragment, null, e);
  let { target: n } = t;
  return n ? Wm(M.createElement(M.Fragment, null, e), n) : null;
}
function r9({ data: e, form: t, disabled: n, onReset: r, overrides: a }) {
  let [i, o] = ke(null), s = Wr();
  return Re(() => {
    if (r && i)
      return s.addEventListener(i, "reset", r);
  }, [i, t, r]), M.createElement(zx, null, M.createElement(Gx, { setForm: o, formId: t }), df(e).map(([l, c]) => M.createElement(yn, { features: gn.Hidden, ...ja({ key: l, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: n, name: l, value: c, ...a }) })));
}
function Gx({ setForm: e, formId: t }) {
  return Re(() => {
    if (t) {
      let n = document.getElementById(t);
      n && e(n);
    }
  }, [e, t]), t ? null : M.createElement(yn, { features: gn.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (n) => {
    if (!n)
      return;
    let r = n.closest("form");
    r && e(r);
  } });
}
let ff = Qe(void 0);
function ya() {
  return Ue(ff);
}
function Ux({ id: e, children: t }) {
  return M.createElement(ff.Provider, { value: e }, t);
}
function ea(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && Zx(n) ? !1 : r;
}
function Zx(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let Cf = Symbol();
function M4(e, t = !0) {
  return Object.assign(e, { [Cf]: t });
}
function et(...e) {
  let t = be(e);
  Re(() => {
    t.current = e;
  }, [e]);
  let n = ae((r) => {
    for (let a of t.current)
      a != null && (typeof a == "function" ? a(r) : a.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[Cf])) ? void 0 : n;
}
let j5 = Qe(null);
j5.displayName = "DescriptionContext";
function gf() {
  let e = Ue(j5);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, gf), t;
  }
  return e;
}
function qa() {
  var e, t;
  return (t = (e = Ue(j5)) == null ? void 0 : e.value) != null ? t : void 0;
}
function Xi() {
  let [e, t] = ke([]);
  return [e.length > 0 ? e.join(" ") : void 0, _e(() => function(n) {
    let r = ae((i) => (t((o) => [...o, i]), () => t((o) => {
      let s = o.slice(), l = s.indexOf(i);
      return l !== -1 && s.splice(l, 1), s;
    }))), a = _e(() => ({ register: r, slot: n.slot, name: n.name, props: n.props, value: n.value }), [r, n.slot, n.name, n.props, n.value]);
    return M.createElement(j5.Provider, { value: a }, n.children);
  }, [t])];
}
let Kx = "p";
function $x(e, t) {
  let n = Mt(), r = _r(), { id: a = `headlessui-description-${n}`, ...i } = e, o = gf(), s = et(t);
  Je(() => o.register(a), [a, o.register]);
  let l = r || !1, c = _e(() => ({ ...o.slot, disabled: l }), [o.slot, l]), u = { ref: s, ...o.props, id: a };
  return Ve()({ ourProps: u, theirProps: i, slot: c, defaultTag: Kx, name: o.name || "Description" });
}
let Wx = De($x), P4 = Object.assign(Wx, {});
var Se = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Se || {});
let R5 = Qe(null);
R5.displayName = "LabelContext";
function E4() {
  let e = Ue(R5);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, E4), t;
  }
  return e;
}
function wn(e) {
  var t, n, r;
  let a = (n = (t = Ue(R5)) == null ? void 0 : t.value) != null ? n : void 0;
  return ((r = e == null ? void 0 : e.length) != null ? r : 0) > 0 ? [a, ...e].filter(Boolean).join(" ") : a;
}
function va({ inherit: e = !1 } = {}) {
  let t = wn(), [n, r] = ke([]), a = e ? [t, ...n].filter(Boolean) : n;
  return [a.length > 0 ? a.join(" ") : void 0, _e(() => function(i) {
    let o = ae((l) => (r((c) => [...c, l]), () => r((c) => {
      let u = c.slice(), d = u.indexOf(l);
      return d !== -1 && u.splice(d, 1), u;
    }))), s = _e(() => ({ register: o, slot: i.slot, name: i.name, props: i.props, value: i.value }), [o, i.slot, i.name, i.props, i.value]);
    return M.createElement(R5.Provider, { value: s }, i.children);
  }, [r])];
}
let Yx = "label";
function qx(e, t) {
  var n;
  let r = Mt(), a = E4(), i = ya(), o = _r(), { id: s = `headlessui-label-${r}`, htmlFor: l = i ?? ((n = a.props) == null ? void 0 : n.htmlFor), passive: c = !1, ...u } = e, d = et(t);
  Je(() => a.register(s), [s, a.register]);
  let p = ae((C) => {
    let _ = C.currentTarget;
    if (_ instanceof HTMLLabelElement && C.preventDefault(), a.props && "onClick" in a.props && typeof a.props.onClick == "function" && a.props.onClick(C), _ instanceof HTMLLabelElement) {
      let v = document.getElementById(_.htmlFor);
      if (v) {
        let w = v.getAttribute("disabled");
        if (w === "true" || w === "")
          return;
        let k = v.getAttribute("aria-disabled");
        if (k === "true" || k === "")
          return;
        (v instanceof HTMLInputElement && (v.type === "radio" || v.type === "checkbox") || v.role === "radio" || v.role === "checkbox" || v.role === "switch") && v.click(), v.focus({ preventScroll: !0 });
      }
    }
  }), h = o || !1, m = _e(() => ({ ...a.slot, disabled: h }), [a.slot, h]), f = { ref: d, ...a.props, id: s, htmlFor: l, onClick: p };
  return c && ("onClick" in f && (delete f.htmlFor, delete f.onClick), "onClick" in u && delete u.onClick), Ve()({ ourProps: f, theirProps: u, slot: m, defaultTag: l ? Yx : "div", name: a.name || "Label" });
}
let Jx = De(qx), n9 = Object.assign(Jx, {}), Xx = "span";
function Qx(e, t) {
  let n = Mt(), r = ya(), a = _r(), { id: i = r || `headlessui-checkbox-${n}`, disabled: o = a || !1, autoFocus: s = !1, checked: l, defaultChecked: c, onChange: u, name: d, value: p, form: h, indeterminate: m = !1, ...f } = e, C = t9(c), [_, v] = e9(l, u, C ?? !1), w = wn(), k = qa(), b = Wr(), [S, P] = ke(!1), O = ae(() => {
    P(!0), v == null || v(!_), b.nextFrame(() => {
      P(!1);
    });
  }), A = ae((F) => {
    if (ea(F.currentTarget))
      return F.preventDefault();
    F.preventDefault(), O();
  }), L = ae((F) => {
    F.key === Se.Space ? (F.preventDefault(), O()) : F.key === Se.Enter && N5(F.currentTarget);
  }), I = ae((F) => F.preventDefault()), { isFocusVisible: D, focusProps: U } = Z1({ autoFocus: s }), { isHovered: z, hoverProps: $ } = X1({ isDisabled: o }), { pressed: ee, pressProps: Z } = _n({ disabled: o }), G = f1({ ref: t, id: i, role: "checkbox", "aria-checked": m ? "mixed" : _ ? "true" : "false", "aria-labelledby": w, "aria-describedby": k, "aria-disabled": o ? !0 : void 0, indeterminate: m ? "true" : void 0, tabIndex: o ? void 0 : 0, onKeyUp: o ? void 0 : L, onKeyPress: o ? void 0 : I, onClick: o ? void 0 : A }, U, $, Z), W = _e(() => ({ checked: _, disabled: o, hover: z, focus: D, active: ee, indeterminate: m, changing: S, autofocus: s }), [_, m, o, z, D, ee, S, s]), j = ft(() => {
    if (C !== void 0)
      return v == null ? void 0 : v(C);
  }, [v, C]), T = Ve();
  return M.createElement(M.Fragment, null, d != null && M.createElement(r9, { disabled: o, data: { [d]: p || "on" }, overrides: { type: "checkbox", checked: _ }, form: h, onReset: j }), T({ ourProps: G, theirProps: f, slot: W, defaultTag: Xx, name: "Checkbox" }));
}
De(Qx);
let yf = Qe(() => {
});
function eS() {
  return Ue(yf);
}
function T4({ value: e, children: t }) {
  return M.createElement(yf.Provider, { value: e }, t);
}
function tS(e, t) {
  let n = eS();
  return M.createElement(Hx, { ref: t, ...f1({ onClick: n }, e) });
}
De(tS);
function ii(e, t, n) {
  let r = n.initialDeps ?? [], a;
  return () => {
    var i, o, s, l;
    let c;
    n.key && (i = n.debug) != null && i.call(n) && (c = Date.now());
    const u = e();
    if (!(u.length !== r.length || u.some((p, h) => r[h] !== p)))
      return a;
    r = u;
    let d;
    if (n.key && (o = n.debug) != null && o.call(n) && (d = Date.now()), a = t(...u), n.key && (s = n.debug) != null && s.call(n)) {
      const p = Math.round((Date.now() - c) * 100) / 100, h = Math.round((Date.now() - d) * 100) / 100, m = h / 16, f = (C, _) => {
        for (C = String(C); C.length < _; )
          C = " " + C;
        return C;
      };
      console.info(
        `%c⏱ ${f(h, 5)} /${f(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * m, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (l = n == null ? void 0 : n.onChange) == null || l.call(n, a), a;
  };
}
function Q8(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined");
  return e;
}
const rS = (e, t) => Math.abs(e - t) < 1, nS = (e, t, n) => {
  let r;
  return function(...a) {
    e.clearTimeout(r), r = e.setTimeout(() => t.apply(this, a), n);
  };
}, aS = (e) => e, iS = (e) => {
  const t = Math.max(e.startIndex - e.overscan, 0), n = Math.min(e.endIndex + e.overscan, e.count - 1), r = [];
  for (let a = t; a <= n; a++)
    r.push(a);
  return r;
}, oS = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  const a = (o) => {
    const { width: s, height: l } = o;
    t({ width: Math.round(s), height: Math.round(l) });
  };
  if (a(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((o) => {
    const s = o[0];
    if (s != null && s.borderBoxSize) {
      const l = s.borderBoxSize[0];
      if (l) {
        a({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    a(n.getBoundingClientRect());
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, Oc = {
  passive: !0
}, sS = typeof window > "u" ? !0 : "onscrollend" in window, lS = (e, t) => {
  const n = e.scrollElement;
  if (!n)
    return;
  const r = e.targetWindow;
  if (!r)
    return;
  let a = 0;
  const i = sS ? () => {
  } : nS(
    r,
    () => {
      t(a, !1);
    },
    e.options.isScrollingResetDelay
  ), o = (c) => () => {
    const { horizontal: u, isRtl: d } = e.options;
    a = u ? n.scrollLeft * (d && -1 || 1) : n.scrollTop, i(), t(a, c);
  }, s = o(!0), l = o(!1);
  return l(), n.addEventListener("scroll", s, Oc), n.addEventListener("scrollend", l, Oc), () => {
    n.removeEventListener("scroll", s), n.removeEventListener("scrollend", l);
  };
}, cS = (e, t, n) => {
  if (t != null && t.borderBoxSize) {
    const r = t.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    e.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, uS = (e, {
  adjustments: t = 0,
  behavior: n
}, r) => {
  var a, i;
  const o = e + t;
  (i = (a = r.scrollElement) == null ? void 0 : a.scrollTo) == null || i.call(a, {
    [r.options.horizontal ? "left" : "top"]: o,
    behavior: n
  });
};
class dS {
  constructor(t) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((a) => {
        a.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var a;
          (a = r()) == null || a.disconnect(), n = null;
        },
        observe: (a) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(a, { box: "border-box" });
        },
        unobserve: (a) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(a);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, a]) => {
        typeof a > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: aS,
        rangeExtractor: iS,
        onChange: () => {
        },
        measureElement: cS,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...n
      };
    }, this.notify = (n) => {
      var r, a;
      (a = (r = this.options).onChange) == null || a.call(r, this, n);
    }, this.maybeNotify = ii(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((a) => {
          this.observer.observe(a);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (a) => {
            this.scrollRect = a, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (a, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < a ? "forward" : "backward" : null, this.scrollOffset = a, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let o = r - 1; o >= 0; o--) {
        const s = n[o];
        if (a.has(s.lane))
          continue;
        const l = i.get(
          s.lane
        );
        if (l == null || s.end > l.end ? i.set(s.lane, s) : s.end < l.end && a.set(s.lane, !0), a.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((o, s) => o.end === s.end ? o.index - s.index : o.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = ii(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, a, i, o) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: a,
        getItemKey: i,
        enabled: o
      }),
      {
        key: !1
      }
    ), this.getMeasurements = ii(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: a, getItemKey: i, enabled: o }, s) => {
        if (!o)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < n; u++) {
          const d = i(u), p = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), h = p ? p.end + this.options.gap : r + a, m = s.get(d), f = typeof m == "number" ? m : this.options.estimateSize(u), C = h + f, _ = p ? p.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: h,
            size: f,
            end: C,
            key: d,
            lane: _
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = ii(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, a) => this.range = n.length > 0 && r > 0 ? pS({
        measurements: n,
        outerSize: r,
        scrollOffset: a
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = ii(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, a, i) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: a,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, a = n.getAttribute(r);
      return a ? parseInt(a, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const a = this.indexFromElement(n), i = this.measurementsCache[a];
      if (!i)
        return;
      const o = i.key, s = this.elementsCache.get(o);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(o, n)), n.isConnected && this.resizeItem(a, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const a = this.measurementsCache[n];
      if (!a)
        return;
      const i = this.itemSizeCache.get(a.key) ?? a.size, o = r - i;
      o !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(a, o, this) : a.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", o), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += o,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(a.index), this.itemSizeCache = new Map(this.itemSizeCache.set(a.key, r)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((r, a) => {
          r.isConnected || (this.observer.unobserve(r), this.elementsCache.delete(a));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = ii(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const a = [];
        for (let i = 0, o = n.length; i < o; i++) {
          const s = n[i], l = r[s];
          a.push(l);
        }
        return a;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return Q8(
          r[vf(
            0,
            r.length - 1,
            (a) => Q8(r[a]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const a = this.getSize(), i = this.getScrollOffset();
      r === "auto" && (n <= i ? r = "start" : n >= i + a ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - a : r === "center" && (n = n - a / 2);
      const o = this.options.horizontal ? "scrollWidth" : "scrollHeight", s = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[o] : this.scrollElement[o] : 0) - a;
      return Math.max(Math.min(s, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const a = this.measurementsCache[n];
      if (!a)
        return;
      const i = this.getSize(), o = this.getScrollOffset();
      if (r === "auto")
        if (a.end >= o + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (a.start <= o + this.options.scrollPaddingStart)
          r = "start";
        else
          return [o, r];
      const s = r === "end" ? a.end + this.options.scrollPaddingEnd : a.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(s, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: a } = {}) => {
      this.cancelScrollToIndex(), a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: a
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: a } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), a === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i)
        return;
      const [o, s] = i;
      this._scrollToOffset(o, { adjustments: void 0, behavior: a }), a !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [l] = Q8(
            this.getOffsetForIndex(n, s)
          );
          rS(l, this.getScrollOffset()) || this.scrollToIndex(n, { align: s, behavior: a });
        } else
          this.scrollToIndex(n, { align: s, behavior: a });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let a;
      return r.length === 0 ? a = this.options.paddingStart : a = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((i) => i.end)
      ), Math.max(
        a - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: a
    }) => {
      this.options.scrollToFn(n, { behavior: a, adjustments: r }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(t);
  }
}
const vf = (e, t, n, r) => {
  for (; e <= t; ) {
    const a = (e + t) / 2 | 0, i = n(a);
    if (i < r)
      e = a + 1;
    else if (i > r)
      t = a - 1;
    else
      return a;
  }
  return e > 0 ? e - 1 : 0;
};
function pS({
  measurements: e,
  outerSize: t,
  scrollOffset: n
}) {
  const r = e.length - 1, a = vf(0, r, (o) => e[o].start, n);
  let i = a;
  for (; i < r && e[i].end < n + t; )
    i++;
  return { startIndex: a, endIndex: i };
}
const hS = typeof document < "u" ? pe.useLayoutEffect : pe.useEffect;
function mS(e) {
  const t = pe.useReducer(() => ({}), {})[1], n = {
    ...e,
    onChange: (a, i) => {
      var o;
      i ? O1(t) : t(), (o = e.onChange) == null || o.call(e, a, i);
    }
  }, [r] = pe.useState(
    () => new dS(n)
  );
  return r.setOptions(n), pe.useEffect(() => r._didMount(), []), hS(() => r._willUpdate()), r;
}
function fS(e) {
  return mS({
    observeElementRect: oS,
    observeElementOffset: lS,
    scrollToFn: uS,
    ...e
  });
}
function CS(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function L4(e = CS) {
  return ft((t, n) => {
    if (typeof e == "string") {
      let r = e;
      return (t == null ? void 0 : t[r]) === (n == null ? void 0 : n[r]);
    }
    return e(t, n);
  }, [e]);
}
function gS(e) {
  if (e === null)
    return { width: 0, height: 0 };
  let { width: t, height: n } = e.getBoundingClientRect();
  return { width: t, height: n };
}
function Ss(e, t = !1) {
  let [n, r] = Ca(() => ({}), {}), a = _e(() => gS(e), [e, n]);
  return Je(() => {
    if (!e)
      return;
    let i = new ResizeObserver(r);
    return i.observe(e), () => {
      i.disconnect();
    };
  }, [e]), t ? { width: `${a.width}px`, height: `${a.height}px` } : a;
}
let yS = class extends Map {
  constructor(t) {
    super(), this.factory = t;
  }
  get(t) {
    let n = super.get(t);
    return n === void 0 && (n = this.factory(t), this.set(t, n)), n;
  }
};
function bf(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(a) {
    return r.add(a), () => r.delete(a);
  }, dispatch(a, ...i) {
    let o = t[a].call(n, ...i);
    o && (n = o, r.forEach((s) => s()));
  } };
}
function _f(e) {
  return ex(e.subscribe, e.getSnapshot, e.getSnapshot);
}
let vS = new yS(() => bf(() => [], { ADD(e) {
  return this.includes(e) ? this : [...this, e];
}, REMOVE(e) {
  let t = this.indexOf(e);
  if (t === -1)
    return this;
  let n = this.slice();
  return n.splice(t, 1), n;
} }));
function Qi(e, t) {
  let n = vS.get(t), r = Mt(), a = _f(n);
  if (Je(() => {
    if (e)
      return n.dispatch("ADD", r), () => n.dispatch("REMOVE", r);
  }, [n, e]), !e)
    return !1;
  let i = a.indexOf(r), o = a.length;
  return i === -1 && (i = o, o += 1), i === o - 1;
}
let k0 = /* @__PURE__ */ new Map(), hs = /* @__PURE__ */ new Map();
function Nc(e) {
  var t;
  let n = (t = hs.get(e)) != null ? t : 0;
  return hs.set(e, n + 1), n !== 0 ? () => jc(e) : (k0.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0, () => jc(e));
}
function jc(e) {
  var t;
  let n = (t = hs.get(e)) != null ? t : 1;
  if (n === 1 ? hs.delete(e) : hs.set(e, n - 1), n !== 1)
    return;
  let r = k0.get(e);
  r && (r["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", r["aria-hidden"]), e.inert = r.inert, k0.delete(e));
}
function D5(e, { allowed: t, disallowed: n } = {}) {
  let r = Qi(e, "inert-others");
  Je(() => {
    var a, i;
    if (!r)
      return;
    let o = jr();
    for (let l of (a = n == null ? void 0 : n()) != null ? a : [])
      l && o.add(Nc(l));
    let s = (i = t == null ? void 0 : t()) != null ? i : [];
    for (let l of s) {
      if (!l)
        continue;
      let c = $r(l);
      if (!c)
        continue;
      let u = l.parentElement;
      for (; u && u !== c.body; ) {
        for (let d of u.children)
          s.some((p) => d.contains(p)) || o.add(Nc(d));
        u = u.parentElement;
      }
    }
    return o.dispose;
  }, [r, t, n]);
}
function a9(e, t, n) {
  let r = G1((a) => {
    let i = a.getBoundingClientRect();
    i.x === 0 && i.y === 0 && i.width === 0 && i.height === 0 && n();
  });
  Re(() => {
    if (!e)
      return;
    let a = t === null ? null : t instanceof HTMLElement ? t : t.current;
    if (!a)
      return;
    let i = jr();
    if (typeof ResizeObserver < "u") {
      let o = new ResizeObserver(() => r.current(a));
      o.observe(a), i.add(() => o.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let o = new IntersectionObserver(() => r.current(a));
      o.observe(a), i.add(() => o.disconnect());
    }
    return () => i.dispose();
  }, [t, r, e]);
}
let N6 = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), bS = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var St = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(St || {}), Vr = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Vr || {}), _S = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(_S || {});
function i9(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(N6)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function wS(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(bS)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var o9 = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(o9 || {});
function s9(e, t = 0) {
  var n;
  return e === ((n = $r(e)) == null ? void 0 : n.body) ? !1 : ht(t, { 0() {
    return e.matches(N6);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(N6))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
function wf(e) {
  let t = $r(e);
  jr().nextFrame(() => {
    t && !s9(t.activeElement, 0) && zn(e);
  });
}
var xS = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(xS || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function zn(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let SS = ["textarea", "input"].join(",");
function kS(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, SS)) != null ? n : !1;
}
function In(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let a = t(n), i = t(r);
    if (a === null || i === null)
      return 0;
    let o = a.compareDocumentPosition(i);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function xf(e, t) {
  return b1(i9(), t, { relativeTo: e });
}
function b1(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: a = [] } = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, o = Array.isArray(e) ? n ? In(e) : e : t & 64 ? wS(e) : i9(e);
  a.length > 0 && o.length > 1 && (o = o.filter((h) => !a.some((m) => m != null && "current" in m ? (m == null ? void 0 : m.current) === h : m === h))), r = r ?? i.activeElement;
  let s = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, o.indexOf(r)) - 1;
    if (t & 4)
      return Math.max(0, o.indexOf(r)) + 1;
    if (t & 8)
      return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = t & 32 ? { preventScroll: !0 } : {}, u = 0, d = o.length, p;
  do {
    if (u >= d || u + d <= 0)
      return 0;
    let h = l + u;
    if (t & 16)
      h = (h + d) % d;
    else {
      if (h < 0)
        return 3;
      if (h >= d)
        return 1;
    }
    p = o[h], p == null || p.focus(c), u += s;
  } while (p !== i.activeElement);
  return t & 6 && kS(p) && p.select(), 2;
}
function Sf() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function MS() {
  return /Android/gi.test(window.navigator.userAgent);
}
function kf() {
  return Sf() || MS();
}
function ko(e, t, n, r) {
  let a = G1(n);
  Re(() => {
    if (!e)
      return;
    function i(o) {
      a.current(o);
    }
    return document.addEventListener(t, i, r), () => document.removeEventListener(t, i, r);
  }, [e, t, r]);
}
function Mf(e, t, n, r) {
  let a = G1(n);
  Re(() => {
    if (!e)
      return;
    function i(o) {
      a.current(o);
    }
    return window.addEventListener(t, i, r), () => window.removeEventListener(t, i, r);
  }, [e, t, r]);
}
const Rc = 30;
function l9(e, t, n) {
  let r = Qi(e, "outside-click"), a = G1(n), i = ft(function(l, c) {
    if (l.defaultPrevented)
      return;
    let u = c(l);
    if (u === null || !u.getRootNode().contains(u) || !u.isConnected)
      return;
    let d = function p(h) {
      return typeof h == "function" ? p(h()) : Array.isArray(h) || h instanceof Set ? h : [h];
    }(t);
    for (let p of d)
      if (p !== null && (p.contains(u) || l.composed && l.composedPath().includes(p)))
        return;
    return !s9(u, o9.Loose) && u.tabIndex !== -1 && l.preventDefault(), a.current(l, u);
  }, [a, t]), o = be(null);
  ko(r, "pointerdown", (l) => {
    var c, u;
    o.current = ((u = (c = l.composedPath) == null ? void 0 : c.call(l)) == null ? void 0 : u[0]) || l.target;
  }, !0), ko(r, "mousedown", (l) => {
    var c, u;
    o.current = ((u = (c = l.composedPath) == null ? void 0 : c.call(l)) == null ? void 0 : u[0]) || l.target;
  }, !0), ko(r, "click", (l) => {
    kf() || o.current && (i(l, () => o.current), o.current = null);
  }, !0);
  let s = be({ x: 0, y: 0 });
  ko(r, "touchstart", (l) => {
    s.current.x = l.touches[0].clientX, s.current.y = l.touches[0].clientY;
  }, !0), ko(r, "touchend", (l) => {
    let c = { x: l.changedTouches[0].clientX, y: l.changedTouches[0].clientY };
    if (!(Math.abs(c.x - s.current.x) >= Rc || Math.abs(c.y - s.current.y) >= Rc))
      return i(l, () => l.target instanceof HTMLElement ? l.target : null);
  }, !0), Mf(r, "blur", (l) => i(l, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Yr(...e) {
  return _e(() => $r(...e), [...e]);
}
function I5(e, t, n, r) {
  let a = G1(n);
  Re(() => {
    e = e ?? window;
    function i(o) {
      a.current(o);
    }
    return e.addEventListener(t, i, r), () => e.removeEventListener(t, i, r);
  }, [e, t, r]);
}
function Pf(e) {
  let t = be({ value: "", selectionStart: null, selectionEnd: null });
  return I5(e, "blur", (n) => {
    let r = n.target;
    r instanceof HTMLInputElement && (t.current = { value: r.value, selectionStart: r.selectionStart, selectionEnd: r.selectionEnd });
  }), ae(() => {
    if (document.activeElement !== e && e instanceof HTMLInputElement && e.isConnected) {
      if (e.focus({ preventScroll: !0 }), e.value !== t.current.value)
        e.setSelectionRange(e.value.length, e.value.length);
      else {
        let { selectionStart: n, selectionEnd: r } = t.current;
        n !== null && r !== null && e.setSelectionRange(n, r);
      }
      t.current = { value: "", selectionStart: null, selectionEnd: null };
    }
  });
}
function Q2(e, t) {
  return _e(() => {
    var n;
    if (e.type)
      return e.type;
    let r = (n = e.as) != null ? n : "button";
    if (typeof r == "string" && r.toLowerCase() === "button" || (t == null ? void 0 : t.tagName) === "BUTTON" && !t.hasAttribute("type"))
      return "button";
  }, [e.type, e.as, t]);
}
function PS() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement, a = (n = t.defaultView) != null ? n : window;
    e = Math.max(0, a.innerWidth - r.clientWidth);
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, a = Math.max(0, r.clientWidth - r.offsetWidth), i = Math.max(0, e - a);
    n.style(r, "paddingRight", `${i}px`);
  } };
}
function ES() {
  return Sf() ? { before({ doc: e, d: t, meta: n }) {
    function r(a) {
      return n.containers.flatMap((i) => i()).some((i) => i.contains(a));
    }
    t.microTask(() => {
      var a;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let s = jr();
        s.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => s.dispose()));
      }
      let i = (a = window.scrollY) != null ? a : window.pageYOffset, o = null;
      t.addEventListener(e, "click", (s) => {
        if (s.target instanceof HTMLElement)
          try {
            let l = s.target.closest("a");
            if (!l)
              return;
            let { hash: c } = new URL(l.href), u = e.querySelector(c);
            u && !r(u) && (o = u);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (s) => {
        if (s.target instanceof HTMLElement)
          if (r(s.target)) {
            let l = s.target;
            for (; l.parentElement && r(l.parentElement); )
              l = l.parentElement;
            t.style(l, "overscrollBehavior", "contain");
          } else
            t.style(s.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (s) => {
        if (s.target instanceof HTMLElement) {
          if (s.target.tagName === "INPUT")
            return;
          if (r(s.target)) {
            let l = s.target;
            for (; l.parentElement && l.dataset.headlessuiPortal !== "" && !(l.scrollHeight > l.clientHeight || l.scrollWidth > l.clientWidth); )
              l = l.parentElement;
            l.dataset.headlessuiPortal === "" && s.preventDefault();
          } else
            s.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var s;
        let l = (s = window.scrollY) != null ? s : window.pageYOffset;
        i !== l && window.scrollTo(0, i), o && o.isConnected && (o.scrollIntoView({ block: "nearest" }), o = null);
      });
    });
  } } : {};
}
function TS() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function LS(e) {
  let t = {};
  for (let n of e)
    Object.assign(t, n(t));
  return t;
}
let P2 = bf(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: jr(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: LS(n) }, a = [ES(), PS(), TS()];
  a.forEach(({ before: i }) => i == null ? void 0 : i(r)), a.forEach(({ after: i }) => i == null ? void 0 : i(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
P2.subscribe(() => {
  let e = P2.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e)
    t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", a = n.count !== 0;
    (a && !r || !a && r) && P2.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && P2.dispatch("TEARDOWN", n);
  }
});
function AS(e, t, n = () => ({ containers: [] })) {
  let r = _f(P2), a = t ? r.get(t) : void 0, i = a ? a.count > 0 : !1;
  return Je(() => {
    if (!(!t || !e))
      return P2.dispatch("PUSH", t, n), () => P2.dispatch("POP", t, n);
  }, [e, t]), i;
}
function c9(e, t, n = () => [document.body]) {
  let r = Qi(e, "scroll-lock");
  AS(r, t, (a) => {
    var i;
    return { containers: [...(i = a.containers) != null ? i : [], n] };
  });
}
function Dc(e) {
  return [e.screenX, e.screenY];
}
function A4() {
  let e = be([-1, -1]);
  return { wasMoved(t) {
    let n = Dc(t);
    return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
  }, update(t) {
    e.current = Dc(t);
  } };
}
function OS(e = 0) {
  let [t, n] = ke(e), r = ft((l) => n(l), [t]), a = ft((l) => n((c) => c | l), [t]), i = ft((l) => (t & l) === l, [t]), o = ft((l) => n((c) => c & ~l), [n]), s = ft((l) => n((c) => c ^ l), [n]);
  return { flags: t, setFlag: r, addFlag: a, hasFlag: i, removeFlag: o, toggleFlag: s };
}
var Ic, Hc;
typeof process < "u" && typeof globalThis < "u" && typeof Element < "u" && ((Ic = process == null ? void 0 : process.env) == null ? void 0 : Ic.NODE_ENV) === "test" && typeof ((Hc = Element == null ? void 0 : Element.prototype) == null ? void 0 : Hc.getAnimations) > "u" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var NS = ((e) => (e[e.None = 0] = "None", e[e.Closed = 1] = "Closed", e[e.Enter = 2] = "Enter", e[e.Leave = 4] = "Leave", e))(NS || {});
function ei(e) {
  let t = {};
  for (let n in e)
    e[n] === !0 && (t[`data-${n}`] = "");
  return t;
}
function ti(e, t, n, r) {
  let [a, i] = ke(n), { hasFlag: o, addFlag: s, removeFlag: l } = OS(e && a ? 3 : 0), c = be(!1), u = be(!1), d = Wr();
  return Je(() => {
    var p;
    if (e) {
      if (n && i(!0), !t) {
        n && s(3);
        return;
      }
      return (p = r == null ? void 0 : r.start) == null || p.call(r, n), jS(t, { inFlight: c, prepare() {
        u.current ? u.current = !1 : u.current = c.current, c.current = !0, !u.current && (n ? (s(3), l(4)) : (s(4), l(2)));
      }, run() {
        u.current ? n ? (l(3), s(4)) : (l(4), s(3)) : n ? l(1) : s(1);
      }, done() {
        var h;
        u.current && typeof t.getAnimations == "function" && t.getAnimations().length > 0 || (c.current = !1, l(7), n || i(!1), (h = r == null ? void 0 : r.end) == null || h.call(r, n));
      } });
    }
  }, [e, n, t, d]), e ? [a, { closed: o(1), enter: o(2), leave: o(4), transition: o(2) || o(4) }] : [n, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function jS(e, { prepare: t, run: n, done: r, inFlight: a }) {
  let i = jr();
  return DS(e, { prepare: t, inFlight: a }), i.nextFrame(() => {
    n(), i.requestAnimationFrame(() => {
      i.add(RS(e, r));
    });
  }), i.dispose;
}
function RS(e, t) {
  var n, r;
  let a = jr();
  if (!e)
    return a.dispose;
  let i = !1;
  a.add(() => {
    i = !0;
  });
  let o = (r = (n = e.getAnimations) == null ? void 0 : n.call(e).filter((s) => s instanceof CSSTransition)) != null ? r : [];
  return o.length === 0 ? (t(), a.dispose) : (Promise.allSettled(o.map((s) => s.finished)).then(() => {
    i || t();
  }), a.dispose);
}
function DS(e, { inFlight: t, prepare: n }) {
  if (t != null && t.current) {
    n();
    return;
  }
  let r = e.style.transition;
  e.style.transition = "none", n(), e.offsetHeight, e.style.transition = r;
}
function Ef(e, { container: t, accept: n, walk: r }) {
  let a = be(n), i = be(r);
  Re(() => {
    a.current = n, i.current = r;
  }, [n, r]), Je(() => {
    if (!t || !e)
      return;
    let o = $r(t);
    if (!o)
      return;
    let s = a.current, l = i.current, c = Object.assign((d) => s(d), { acceptNode: s }), u = o.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, c, !1);
    for (; u.nextNode(); )
      l(u.currentNode);
  }, [t, e, a, i]);
}
function ks(e, t) {
  let n = be([]), r = ae(e);
  Re(() => {
    let a = [...n.current];
    for (let [i, o] of t.entries())
      if (n.current[i] !== o) {
        let s = r(t, a);
        return n.current = t, s;
      }
  }, [r, ...t]);
}
function H5() {
  return typeof window < "u";
}
function eo(e) {
  return Tf(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Er(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ta(e) {
  var t;
  return (t = (Tf(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Tf(e) {
  return H5() ? e instanceof Node || e instanceof Er(e).Node : !1;
}
function q1(e) {
  return H5() ? e instanceof Element || e instanceof Er(e).Element : !1;
}
function qn(e) {
  return H5() ? e instanceof HTMLElement || e instanceof Er(e).HTMLElement : !1;
}
function Fc(e) {
  return !H5() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Er(e).ShadowRoot;
}
const IS = /* @__PURE__ */ new Set(["inline", "contents"]);
function u9(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = vn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !IS.has(a);
}
const HS = /* @__PURE__ */ new Set(["table", "td", "th"]);
function FS(e) {
  return HS.has(eo(e));
}
const VS = [":popover-open", ":modal"];
function F5(e) {
  return VS.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const BS = ["transform", "translate", "scale", "rotate", "perspective"], zS = ["transform", "translate", "scale", "rotate", "perspective", "filter"], GS = ["paint", "layout", "strict", "content"];
function O4(e) {
  const t = N4(), n = q1(e) ? vn(e) : e;
  return BS.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || zS.some((r) => (n.willChange || "").includes(r)) || GS.some((r) => (n.contain || "").includes(r));
}
function US(e) {
  let t = Za(e);
  for (; qn(t) && !Di(t); ) {
    if (O4(t))
      return t;
    if (F5(t))
      return null;
    t = Za(t);
  }
  return null;
}
function N4() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const ZS = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Di(e) {
  return ZS.has(eo(e));
}
function vn(e) {
  return Er(e).getComputedStyle(e);
}
function V5(e) {
  return q1(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Za(e) {
  if (eo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Fc(e) && e.host || // Fallback.
    ta(e)
  );
  return Fc(t) ? t.host : t;
}
function Lf(e) {
  const t = Za(e);
  return Di(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : qn(t) && u9(t) ? t : Lf(t);
}
function Ms(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = Lf(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), o = Er(a);
  if (i) {
    const s = M0(o);
    return t.concat(o, o.visualViewport || [], u9(a) ? a : [], s && n ? Ms(s) : []);
  }
  return t.concat(a, Ms(a, [], n));
}
function M0(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function KS() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
const U2 = Math.min, W1 = Math.max, Ps = Math.round, N9 = Math.floor, Gn = (e) => ({
  x: e,
  y: e
}), $S = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, WS = {
  start: "end",
  end: "start"
};
function Vc(e, t, n) {
  return W1(e, U2(t, n));
}
function to(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ka(e) {
  return e.split("-")[0];
}
function d9(e) {
  return e.split("-")[1];
}
function Af(e) {
  return e === "x" ? "y" : "x";
}
function Of(e) {
  return e === "y" ? "height" : "width";
}
const YS = /* @__PURE__ */ new Set(["top", "bottom"]);
function pa(e) {
  return YS.has(Ka(e)) ? "y" : "x";
}
function Nf(e) {
  return Af(pa(e));
}
function qS(e, t, n) {
  n === void 0 && (n = !1);
  const r = d9(e), a = Nf(e), i = Of(a);
  let o = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = j6(o)), [o, j6(o)];
}
function JS(e) {
  const t = j6(e);
  return [P0(e), t, P0(t)];
}
function P0(e) {
  return e.replace(/start|end/g, (t) => WS[t]);
}
const Bc = ["left", "right"], zc = ["right", "left"], XS = ["top", "bottom"], QS = ["bottom", "top"];
function ek(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? zc : Bc : t ? Bc : zc;
    case "left":
    case "right":
      return t ? XS : QS;
    default:
      return [];
  }
}
function tk(e, t, n, r) {
  const a = d9(e);
  let i = ek(Ka(e), n === "start", r);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(P0)))), i;
}
function j6(e) {
  return e.replace(/left|right|bottom|top/g, (t) => $S[t]);
}
function rk(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function nk(e) {
  return typeof e != "number" ? rk(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function R6(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function Gc(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = pa(t), o = Nf(t), s = Of(o), l = Ka(t), c = i === "y", u = r.x + r.width / 2 - a.width / 2, d = r.y + r.height / 2 - a.height / 2, p = r[s] / 2 - a[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - a.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - a.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (d9(t)) {
    case "start":
      h[o] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      h[o] += p * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const ak = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = n, s = i.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let c = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: u,
    y: d
  } = Gc(c, r, l), p = r, h = {}, m = 0;
  for (let f = 0; f < s.length; f++) {
    const {
      name: C,
      fn: _
    } = s[f], {
      x: v,
      y: w,
      data: k,
      reset: b
    } = await _({
      x: u,
      y: d,
      initialPlacement: r,
      placement: p,
      strategy: a,
      middlewareData: h,
      rects: c,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = v ?? u, d = w ?? d, h = {
      ...h,
      [C]: {
        ...h[C],
        ...k
      }
    }, b && m <= 50 && (m++, typeof b == "object" && (b.placement && (p = b.placement), b.rects && (c = b.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : b.rects), {
      x: u,
      y: d
    } = Gc(c, p, l)), f = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: a,
    middlewareData: h
  };
};
async function B5(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = to(t, e), m = nk(h), f = s[p ? d === "floating" ? "reference" : "floating" : d], C = R6(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(f))) == null || n ? f : f.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), _ = d === "floating" ? {
    x: r,
    y: a,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), w = await (i.isElement == null ? void 0 : i.isElement(v)) ? await (i.getScale == null ? void 0 : i.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = R6(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: _,
    offsetParent: v,
    strategy: l
  }) : _);
  return {
    top: (C.top - k.top + m.top) / w.y,
    bottom: (k.bottom - C.bottom + m.bottom) / w.y,
    left: (C.left - k.left + m.left) / w.x,
    right: (k.right - C.right + m.right) / w.x
  };
}
const ik = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: f = !0,
        ...C
      } = to(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const _ = Ka(a), v = pa(s), w = Ka(s) === s, k = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), b = p || (w || !f ? [j6(s)] : JS(s)), S = m !== "none";
      !p && S && b.push(...tk(s, f, m, k));
      const P = [s, ...b], O = await B5(t, C), A = [];
      let L = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (u && A.push(O[_]), d) {
        const z = qS(a, o, k);
        A.push(O[z[0]], O[z[1]]);
      }
      if (L = [...L, {
        placement: a,
        overflows: A
      }], !A.every((z) => z <= 0)) {
        var I, D;
        const z = (((I = i.flip) == null ? void 0 : I.index) || 0) + 1, $ = P[z];
        if ($ && (!(d === "alignment" && v !== pa($)) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        L.every((Z) => pa(Z.placement) === v ? Z.overflows[0] > 0 : !0)))
          return {
            data: {
              index: z,
              overflows: L
            },
            reset: {
              placement: $
            }
          };
        let ee = (D = L.filter((Z) => Z.overflows[0] <= 0).sort((Z, G) => Z.overflows[1] - G.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!ee)
          switch (h) {
            case "bestFit": {
              var U;
              const Z = (U = L.filter((G) => {
                if (S) {
                  const W = pa(G.placement);
                  return W === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  W === "y";
                }
                return !0;
              }).map((G) => [G.placement, G.overflows.filter((W) => W > 0).reduce((W, j) => W + j, 0)]).sort((G, W) => G[1] - W[1])[0]) == null ? void 0 : U[0];
              Z && (ee = Z);
              break;
            }
            case "initialPlacement":
              ee = s;
              break;
          }
        if (a !== ee)
          return {
            reset: {
              placement: ee
            }
          };
      }
      return {};
    }
  };
}, ok = /* @__PURE__ */ new Set(["left", "top"]);
async function sk(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), o = Ka(n), s = d9(n), l = pa(n) === "y", c = ok.has(o) ? -1 : 1, u = i && l ? -1 : 1, d = to(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof m == "number" && (h = s === "end" ? m * -1 : m), l ? {
    x: h * u,
    y: p * c
  } : {
    x: p * c,
    y: h * u
  };
}
const lk = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: i,
        placement: o,
        middlewareData: s
      } = t, l = await sk(t, e);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: a + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, ck = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (C) => {
            let {
              x: _,
              y: v
            } = C;
            return {
              x: _,
              y: v
            };
          }
        },
        ...l
      } = to(e, t), c = {
        x: n,
        y: r
      }, u = await B5(t, l), d = pa(Ka(a)), p = Af(d);
      let h = c[p], m = c[d];
      if (i) {
        const C = p === "y" ? "top" : "left", _ = p === "y" ? "bottom" : "right", v = h + u[C], w = h - u[_];
        h = Vc(v, h, w);
      }
      if (o) {
        const C = d === "y" ? "top" : "left", _ = d === "y" ? "bottom" : "right", v = m + u[C], w = m - u[_];
        m = Vc(v, m, w);
      }
      const f = s.fn({
        ...t,
        [p]: h,
        [d]: m
      });
      return {
        ...f,
        data: {
          x: f.x - n,
          y: f.y - r,
          enabled: {
            [p]: i,
            [d]: o
          }
        }
      };
    }
  };
}, uk = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        rects: i,
        platform: o,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = to(e, t), u = await B5(t, c), d = Ka(a), p = d9(a), h = pa(a) === "y", {
        width: m,
        height: f
      } = i.floating;
      let C, _;
      d === "top" || d === "bottom" ? (C = d, _ = p === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (_ = d, C = p === "end" ? "top" : "bottom");
      const v = f - u.top - u.bottom, w = m - u.left - u.right, k = U2(f - u[C], v), b = U2(m - u[_], w), S = !t.middlewareData.shift;
      let P = k, O = b;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (O = w), (r = t.middlewareData.shift) != null && r.enabled.y && (P = v), S && !p) {
        const L = W1(u.left, 0), I = W1(u.right, 0), D = W1(u.top, 0), U = W1(u.bottom, 0);
        h ? O = m - 2 * (L !== 0 || I !== 0 ? L + I : W1(u.left, u.right)) : P = f - 2 * (D !== 0 || U !== 0 ? D + U : W1(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: O,
        availableHeight: P
      });
      const A = await o.getDimensions(s.floating);
      return m !== A.width || f !== A.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function jf(e) {
  const t = vn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = qn(e), i = a ? e.offsetWidth : n, o = a ? e.offsetHeight : r, s = Ps(n) !== i || Ps(r) !== o;
  return s && (n = i, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function j4(e) {
  return q1(e) ? e : e.contextElement;
}
function Pi(e) {
  const t = j4(e);
  if (!qn(t))
    return Gn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = jf(t);
  let o = (i ? Ps(n.width) : n.width) / r, s = (i ? Ps(n.height) : n.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const dk = /* @__PURE__ */ Gn(0);
function Rf(e) {
  const t = Er(e);
  return !N4() || !t.visualViewport ? dk : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function pk(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Er(e) ? !1 : t;
}
function Z2(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = j4(e);
  let o = Gn(1);
  t && (r ? q1(r) && (o = Pi(r)) : o = Pi(e));
  const s = pk(i, n, r) ? Rf(i) : Gn(0);
  let l = (a.left + s.x) / o.x, c = (a.top + s.y) / o.y, u = a.width / o.x, d = a.height / o.y;
  if (i) {
    const p = Er(i), h = r && q1(r) ? Er(r) : r;
    let m = p, f = M0(m);
    for (; f && r && h !== m; ) {
      const C = Pi(f), _ = f.getBoundingClientRect(), v = vn(f), w = _.left + (f.clientLeft + parseFloat(v.paddingLeft)) * C.x, k = _.top + (f.clientTop + parseFloat(v.paddingTop)) * C.y;
      l *= C.x, c *= C.y, u *= C.x, d *= C.y, l += w, c += k, m = Er(f), f = M0(m);
    }
  }
  return R6({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function z5(e, t) {
  const n = V5(e).scrollLeft;
  return t ? t.left + n : Z2(ta(e)).left + n;
}
function Df(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - z5(e, n), a = n.top + t.scrollTop;
  return {
    x: r,
    y: a
  };
}
function hk(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const i = a === "fixed", o = ta(r), s = t ? F5(t.floating) : !1;
  if (r === o || s && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Gn(1);
  const u = Gn(0), d = qn(r);
  if ((d || !d && !i) && ((eo(r) !== "body" || u9(o)) && (l = V5(r)), qn(r))) {
    const h = Z2(r);
    c = Pi(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  const p = o && !d && !i ? Df(o, l) : Gn(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + p.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + p.y
  };
}
function mk(e) {
  return Array.from(e.getClientRects());
}
function fk(e) {
  const t = ta(e), n = V5(e), r = e.ownerDocument.body, a = W1(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = W1(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + z5(e);
  const s = -n.scrollTop;
  return vn(r).direction === "rtl" && (o += W1(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
const Uc = 25;
function Ck(e, t) {
  const n = Er(e), r = ta(e), a = n.visualViewport;
  let i = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = N4();
    (!u || u && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  const c = z5(r);
  if (c <= 0) {
    const u = r.ownerDocument, d = u.body, p = getComputedStyle(d), h = u.compatMode === "CSS1Compat" && parseFloat(p.marginLeft) + parseFloat(p.marginRight) || 0, m = Math.abs(r.clientWidth - d.clientWidth - h);
    m <= Uc && (i -= m);
  } else
    c <= Uc && (i += c);
  return {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
const gk = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function yk(e, t) {
  const n = Z2(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = qn(e) ? Pi(e) : Gn(1), o = e.clientWidth * i.x, s = e.clientHeight * i.y, l = a * i.x, c = r * i.y;
  return {
    width: o,
    height: s,
    x: l,
    y: c
  };
}
function Zc(e, t, n) {
  let r;
  if (t === "viewport")
    r = Ck(e, n);
  else if (t === "document")
    r = fk(ta(e));
  else if (q1(t))
    r = yk(t, n);
  else {
    const a = Rf(e);
    r = {
      x: t.x - a.x,
      y: t.y - a.y,
      width: t.width,
      height: t.height
    };
  }
  return R6(r);
}
function If(e, t) {
  const n = Za(e);
  return n === t || !q1(n) || Di(n) ? !1 : vn(n).position === "fixed" || If(n, t);
}
function vk(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ms(e, [], !1).filter((s) => q1(s) && eo(s) !== "body"), a = null;
  const i = vn(e).position === "fixed";
  let o = i ? Za(e) : e;
  for (; q1(o) && !Di(o); ) {
    const s = vn(o), l = O4(o);
    !l && s.position === "fixed" && (a = null), (i ? !l && !a : !l && s.position === "static" && a && gk.has(a.position) || u9(o) && !l && If(e, o)) ? r = r.filter((c) => c !== o) : a = s, o = Za(o);
  }
  return t.set(e, r), r;
}
function bk(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const i = [...n === "clippingAncestors" ? F5(t) ? [] : vk(t, this._c) : [].concat(n), r], o = i[0], s = i.reduce((l, c) => {
    const u = Zc(t, c, a);
    return l.top = W1(u.top, l.top), l.right = U2(u.right, l.right), l.bottom = U2(u.bottom, l.bottom), l.left = W1(u.left, l.left), l;
  }, Zc(t, o, a));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function _k(e) {
  const {
    width: t,
    height: n
  } = jf(e);
  return {
    width: t,
    height: n
  };
}
function wk(e, t, n) {
  const r = qn(t), a = ta(t), i = n === "fixed", o = Z2(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Gn(0);
  function c() {
    l.x = z5(a);
  }
  if (r || !r && !i)
    if ((eo(t) !== "body" || u9(a)) && (s = V5(t)), r) {
      const h = Z2(t, !0, i, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else
      a && c();
  i && !r && a && c();
  const u = a && !r && !i ? Df(a, s) : Gn(0), d = o.left + s.scrollLeft - l.x - u.x, p = o.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: p,
    width: o.width,
    height: o.height
  };
}
function e7(e) {
  return vn(e).position === "static";
}
function Kc(e, t) {
  if (!qn(e) || vn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return ta(e) === n && (n = n.ownerDocument.body), n;
}
function Hf(e, t) {
  const n = Er(e);
  if (F5(e))
    return n;
  if (!qn(e)) {
    let a = Za(e);
    for (; a && !Di(a); ) {
      if (q1(a) && !e7(a))
        return a;
      a = Za(a);
    }
    return n;
  }
  let r = Kc(e, t);
  for (; r && FS(r) && e7(r); )
    r = Kc(r, t);
  return r && Di(r) && e7(r) && !O4(r) ? n : r || US(e) || n;
}
const xk = async function(e) {
  const t = this.getOffsetParent || Hf, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: wk(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Sk(e) {
  return vn(e).direction === "rtl";
}
const kk = {
  convertOffsetParentRelativeRectToViewportRelativeRect: hk,
  getDocumentElement: ta,
  getClippingRect: bk,
  getOffsetParent: Hf,
  getElementRects: xk,
  getClientRects: mk,
  getDimensions: _k,
  getScale: Pi,
  isElement: q1,
  isRTL: Sk
};
function Ff(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Mk(e, t) {
  let n = null, r;
  const a = ta(e);
  function i() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: p,
      height: h
    } = c;
    if (s || t(), !p || !h)
      return;
    const m = N9(d), f = N9(a.clientWidth - (u + p)), C = N9(a.clientHeight - (d + h)), _ = N9(u), v = {
      rootMargin: -m + "px " + -f + "px " + -C + "px " + -_ + "px",
      threshold: W1(0, U2(1, l)) || 1
    };
    let w = !0;
    function k(b) {
      const S = b[0].intersectionRatio;
      if (S !== l) {
        if (!w)
          return o();
        S ? o(!1, S) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !Ff(c, e.getBoundingClientRect()) && o(), w = !1;
    }
    try {
      n = new IntersectionObserver(k, {
        ...v,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(k, v);
    }
    n.observe(e);
  }
  return o(!0), i;
}
function Pk(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = j4(e), u = a || i ? [...c ? Ms(c) : [], ...Ms(t)] : [];
  u.forEach((_) => {
    a && _.addEventListener("scroll", n, {
      passive: !0
    }), i && _.addEventListener("resize", n);
  });
  const d = c && s ? Mk(c, n) : null;
  let p = -1, h = null;
  o && (h = new ResizeObserver((_) => {
    let [v] = _;
    v && v.target === c && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var w;
      (w = h) == null || w.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let m, f = l ? Z2(e) : null;
  l && C();
  function C() {
    const _ = Z2(e);
    f && !Ff(f, _) && n(), f = _, m = requestAnimationFrame(C);
  }
  return n(), () => {
    var _;
    u.forEach((v) => {
      a && v.removeEventListener("scroll", n), i && v.removeEventListener("resize", n);
    }), d == null || d(), (_ = h) == null || _.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const t7 = B5, Ek = lk, Tk = ck, Lk = ik, Ak = uk, Ok = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: kk,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return ak(e, t, {
    ...a,
    platform: i
  });
};
var Nk = typeof document < "u", jk = function() {
}, a6 = Nk ? w4 : jk;
function D6(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!D6(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = a[r];
      if (!(i === "_owner" && e.$$typeof) && !D6(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Vf(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function $c(e, t) {
  const n = Vf(e);
  return Math.round(t * n) / n;
}
function r7(e) {
  const t = pe.useRef(e);
  return a6(() => {
    t.current = e;
  }), t;
}
function Rk(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = pe.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = pe.useState(r);
  D6(p, r) || h(r);
  const [m, f] = pe.useState(null), [C, _] = pe.useState(null), v = pe.useCallback((G) => {
    G !== S.current && (S.current = G, f(G));
  }, []), w = pe.useCallback((G) => {
    G !== P.current && (P.current = G, _(G));
  }, []), k = i || m, b = o || C, S = pe.useRef(null), P = pe.useRef(null), O = pe.useRef(u), A = l != null, L = r7(l), I = r7(a), D = r7(c), U = pe.useCallback(() => {
    if (!S.current || !P.current)
      return;
    const G = {
      placement: t,
      strategy: n,
      middleware: p
    };
    I.current && (G.platform = I.current), Ok(S.current, P.current, G).then((W) => {
      const j = {
        ...W,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: D.current !== !1
      };
      z.current && !D6(O.current, j) && (O.current = j, xs.flushSync(() => {
        d(j);
      }));
    });
  }, [p, t, n, I, D]);
  a6(() => {
    c === !1 && O.current.isPositioned && (O.current.isPositioned = !1, d((G) => ({
      ...G,
      isPositioned: !1
    })));
  }, [c]);
  const z = pe.useRef(!1);
  a6(() => (z.current = !0, () => {
    z.current = !1;
  }), []), a6(() => {
    if (k && (S.current = k), b && (P.current = b), k && b) {
      if (L.current)
        return L.current(k, b, U);
      U();
    }
  }, [k, b, U, L, A]);
  const $ = pe.useMemo(() => ({
    reference: S,
    floating: P,
    setReference: v,
    setFloating: w
  }), [v, w]), ee = pe.useMemo(() => ({
    reference: k,
    floating: b
  }), [k, b]), Z = pe.useMemo(() => {
    const G = {
      position: n,
      left: 0,
      top: 0
    };
    if (!ee.floating)
      return G;
    const W = $c(ee.floating, u.x), j = $c(ee.floating, u.y);
    return s ? {
      ...G,
      transform: "translate(" + W + "px, " + j + "px)",
      ...Vf(ee.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: W,
      top: j
    };
  }, [n, s, ee.floating, u.x, u.y]);
  return pe.useMemo(() => ({
    ...u,
    update: U,
    refs: $,
    elements: ee,
    floatingStyles: Z
  }), [u, U, $, ee, Z]);
}
const Bf = (e, t) => ({
  ...Ek(e),
  options: [e, t]
}), Dk = (e, t) => ({
  ...Tk(e),
  options: [e, t]
}), Ik = (e, t) => ({
  ...Lk(e),
  options: [e, t]
}), Hk = (e, t) => ({
  ...Ak(e),
  options: [e, t]
}), zf = {
  ...pe
}, Fk = zf.useInsertionEffect, Vk = Fk || ((e) => e());
function Gf(e) {
  const t = pe.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Vk(() => {
    t.current = e;
  }), pe.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
      r[a] = arguments[a];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
var E0 = typeof document < "u" ? w4 : Re;
let Wc = !1, Bk = 0;
const Yc = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + Bk++
);
function zk() {
  const [e, t] = pe.useState(() => Wc ? Yc() : void 0);
  return E0(() => {
    e == null && t(Yc());
  }, []), pe.useEffect(() => {
    Wc = !0;
  }, []), e;
}
const Gk = zf.useId, Uk = Gk || zk;
let Es;
process.env.NODE_ENV !== "production" && (Es = /* @__PURE__ */ new Set());
function Zk() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const a = "Floating UI: " + n.join(" ");
  if (!((e = Es) != null && e.has(a))) {
    var i;
    (i = Es) == null || i.add(a), console.warn(a);
  }
}
function Kk() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const a = "Floating UI: " + n.join(" ");
  if (!((e = Es) != null && e.has(a))) {
    var i;
    (i = Es) == null || i.add(a), console.error(a);
  }
}
function $k() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((a) => a(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((a) => a !== n)) || []);
    }
  };
}
const Wk = /* @__PURE__ */ pe.createContext(null), Yk = /* @__PURE__ */ pe.createContext(null), qk = () => {
  var e;
  return ((e = pe.useContext(Wk)) == null ? void 0 : e.id) || null;
}, Jk = () => pe.useContext(Yk), Xk = "data-floating-ui-focusable";
function Qk(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, a = Uk(), i = pe.useRef({}), [o] = pe.useState(() => $k()), s = qk() != null;
  if (process.env.NODE_ENV !== "production") {
    const h = r.reference;
    h && !q1(h) && Kk("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = pe.useState(r.reference), u = Gf((h, m, f) => {
    i.current.openEvent = h ? m : void 0, o.emit("openchange", {
      open: h,
      event: m,
      reason: f,
      nested: s
    }), n == null || n(h, m, f);
  }), d = pe.useMemo(() => ({
    setPositionReference: c
  }), []), p = pe.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return pe.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: u,
    elements: p,
    events: o,
    floatingId: a,
    refs: d
  }), [t, u, p, o, a, d]);
}
function eM(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = Qk({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, a = r.elements, [i, o] = pe.useState(null), [s, l] = pe.useState(null), c = (a == null ? void 0 : a.domReference) || i, u = pe.useRef(null), d = Jk();
  E0(() => {
    c && (u.current = c);
  }, [c]);
  const p = Rk({
    ...e,
    elements: {
      ...a,
      ...s && {
        reference: s
      }
    }
  }), h = pe.useCallback((v) => {
    const w = q1(v) ? {
      getBoundingClientRect: () => v.getBoundingClientRect(),
      contextElement: v
    } : v;
    l(w), p.refs.setReference(w);
  }, [p.refs]), m = pe.useCallback((v) => {
    (q1(v) || v === null) && (u.current = v, o(v)), (q1(p.refs.reference.current) || p.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    v !== null && !q1(v)) && p.refs.setReference(v);
  }, [p.refs]), f = pe.useMemo(() => ({
    ...p.refs,
    setReference: m,
    setPositionReference: h,
    domReference: u
  }), [p.refs, m, h]), C = pe.useMemo(() => ({
    ...p.elements,
    domReference: c
  }), [p.elements, c]), _ = pe.useMemo(() => ({
    ...p,
    ...r,
    refs: f,
    elements: C,
    nodeId: t
  }), [p, f, C, t, r]);
  return E0(() => {
    r.dataRef.current.floatingContext = _;
    const v = d == null ? void 0 : d.nodesRef.current.find((w) => w.id === t);
    v && (v.context = _);
  }), pe.useMemo(() => ({
    ...p,
    context: _,
    refs: f,
    elements: C
  }), [p, f, C, _]);
}
const qc = "active", Jc = "selected";
function n7(e, t, n) {
  const r = /* @__PURE__ */ new Map(), a = n === "item";
  let i = e;
  if (a && e) {
    const {
      [qc]: o,
      [Jc]: s,
      ...l
    } = e;
    i = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [Xk]: ""
    },
    ...i,
    ...t.map((o) => {
      const s = o ? o[n] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((o, s) => (s && Object.entries(s).forEach((l) => {
      let [c, u] = l;
      if (!(a && [qc, Jc].includes(c)))
        if (c.indexOf("on") === 0) {
          if (r.has(c) || r.set(c, []), typeof u == "function") {
            var d;
            (d = r.get(c)) == null || d.push(u), o[c] = function() {
              for (var p, h = arguments.length, m = new Array(h), f = 0; f < h; f++)
                m[f] = arguments[f];
              return (p = r.get(c)) == null ? void 0 : p.map((C) => C(...m)).find((C) => C !== void 0);
            };
          }
        } else
          o[c] = u;
    }), o), {})
  };
}
function tM(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s == null ? void 0 : s.reference), n = e.map((s) => s == null ? void 0 : s.floating), r = e.map((s) => s == null ? void 0 : s.item), a = pe.useCallback(
    (s) => n7(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = pe.useCallback(
    (s) => n7(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), o = pe.useCallback(
    (s) => n7(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return pe.useMemo(() => ({
    getReferenceProps: a,
    getFloatingProps: i,
    getItemProps: o
  }), [a, i, o]);
}
function Xc(e, t) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: t
      }
    }
  };
}
const rM = (e) => ({
  name: "inner",
  options: e,
  async fn(t) {
    const {
      listRef: n,
      overflowRef: r,
      onFallbackChange: a,
      offset: i = 0,
      index: o = 0,
      minItemsVisible: s = 4,
      referenceOverflowThreshold: l = 0,
      scrollRef: c,
      ...u
    } = to(e, t), {
      rects: d,
      elements: {
        floating: p
      }
    } = t, h = n.current[o], m = (c == null ? void 0 : c.current) || p, f = p.clientTop || m.clientTop, C = p.clientTop !== 0, _ = m.clientTop !== 0, v = p === m;
    if (process.env.NODE_ENV !== "production" && (t.placement.startsWith("bottom") || Zk('`placement` side must be "bottom" when using the `inner`', "middleware.")), !h)
      return {};
    const w = {
      ...t,
      ...await Bf(-h.offsetTop - p.clientTop - d.reference.height / 2 - h.offsetHeight / 2 - i).fn(t)
    }, k = await t7(Xc(w, m.scrollHeight + f + p.clientTop), u), b = await t7(w, {
      ...u,
      elementContext: "reference"
    }), S = W1(0, k.top), P = w.y + S, O = (m.scrollHeight > m.clientHeight ? (A) => A : Ps)(W1(0, m.scrollHeight + (C && v || _ ? f * 2 : 0) - S - W1(0, k.bottom)));
    if (m.style.maxHeight = O + "px", m.scrollTop = S, a) {
      const A = m.offsetHeight < h.offsetHeight * U2(s, n.current.length) - 1 || b.top >= -l || b.bottom >= -l;
      xs.flushSync(() => a(A));
    }
    return r && (r.current = await t7(Xc({
      ...w,
      y: P
    }, m.offsetHeight + f + p.clientTop), u)), {
      y: P
    };
  }
});
function nM(e, t) {
  const {
    open: n,
    elements: r
  } = e, {
    enabled: a = !0,
    overflowRef: i,
    scrollRef: o,
    onChange: s
  } = t, l = Gf(s), c = pe.useRef(!1), u = pe.useRef(null), d = pe.useRef(null);
  pe.useEffect(() => {
    if (!a)
      return;
    function h(f) {
      if (f.ctrlKey || !m || i.current == null)
        return;
      const C = f.deltaY, _ = i.current.top >= -0.5, v = i.current.bottom >= -0.5, w = m.scrollHeight - m.clientHeight, k = C < 0 ? -1 : 1, b = C < 0 ? "max" : "min";
      m.scrollHeight <= m.clientHeight || (!_ && C > 0 || !v && C < 0 ? (f.preventDefault(), xs.flushSync(() => {
        l((S) => S + Math[b](C, w * k));
      })) : /firefox/i.test(KS()) && (m.scrollTop += C));
    }
    const m = (o == null ? void 0 : o.current) || r.floating;
    if (n && m)
      return m.addEventListener("wheel", h), requestAnimationFrame(() => {
        u.current = m.scrollTop, i.current != null && (d.current = {
          ...i.current
        });
      }), () => {
        u.current = null, d.current = null, m.removeEventListener("wheel", h);
      };
  }, [a, n, r.floating, i, o, l]);
  const p = pe.useMemo(() => ({
    onKeyDown() {
      c.current = !0;
    },
    onWheel() {
      c.current = !1;
    },
    onPointerMove() {
      c.current = !1;
    },
    onScroll() {
      const h = (o == null ? void 0 : o.current) || r.floating;
      if (!(!i.current || !h || !c.current)) {
        if (u.current !== null) {
          const m = h.scrollTop - u.current;
          (i.current.bottom < -0.5 && m < -1 || i.current.top < -0.5 && m > 1) && xs.flushSync(() => l((f) => f + m));
        }
        requestAnimationFrame(() => {
          u.current = h.scrollTop;
        });
      }
    }
  }), [r.floating, l, i, o]);
  return pe.useMemo(() => a ? {
    floating: p
  } : {}, [a, p]);
}
let ro = Qe({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
ro.displayName = "FloatingContext";
let R4 = Qe(null);
R4.displayName = "PlacementContext";
function G5(e) {
  return _e(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function U5() {
  return Ue(ro).setReference;
}
function Uf() {
  return Ue(ro).getReferenceProps;
}
function Z5() {
  let { getFloatingProps: e, slot: t } = Ue(ro);
  return ft((...n) => Object.assign({}, e(...n), { "data-anchor": t.anchor }), [e, t]);
}
function K5(e = null) {
  e === !1 && (e = null), typeof e == "string" && (e = { to: e });
  let t = Ue(R4), n = _e(() => e, [JSON.stringify(e, (a, i) => {
    var o;
    return (o = i == null ? void 0 : i.outerHTML) != null ? o : i;
  })]);
  Je(() => {
    t == null || t(n ?? null);
  }, [t, n]);
  let r = Ue(ro);
  return _e(() => [r.setFloating, e ? r.styles : {}], [r.setFloating, e, r.styles]);
}
let Qc = 4;
function $5({ children: e, enabled: t = !0 }) {
  let [n, r] = ke(null), [a, i] = ke(0), o = be(null), [s, l] = ke(null);
  aM(s);
  let c = t && n !== null && s !== null, { to: u = "bottom", gap: d = 0, offset: p = 0, padding: h = 0, inner: m } = iM(n, s), [f, C = "center"] = u.split(" ");
  Je(() => {
    c && i(0);
  }, [c]);
  let { refs: _, floatingStyles: v, context: w } = eM({ open: c, placement: f === "selection" ? C === "center" ? "bottom" : `bottom-${C}` : C === "center" ? `${f}` : `${f}-${C}`, strategy: "absolute", transform: !1, middleware: [Bf({ mainAxis: f === "selection" ? 0 : d, crossAxis: p }), Dk({ padding: h }), f !== "selection" && Ik({ padding: h }), f === "selection" && m ? rM({ ...m, padding: h, overflowRef: o, offset: a, minItemsVisible: Qc, referenceOverflowThreshold: h, onFallbackChange(I) {
    var D, U;
    if (!I)
      return;
    let z = w.elements.floating;
    if (!z)
      return;
    let $ = parseFloat(getComputedStyle(z).scrollPaddingBottom) || 0, ee = Math.min(Qc, z.childElementCount), Z = 0, G = 0;
    for (let W of (U = (D = w.elements.floating) == null ? void 0 : D.childNodes) != null ? U : [])
      if (W instanceof HTMLElement) {
        let j = W.offsetTop, T = j + W.clientHeight + $, F = z.scrollTop, N = F + z.clientHeight;
        if (j >= F && T <= N)
          ee--;
        else {
          G = Math.max(0, Math.min(T, N) - Math.max(j, F)), Z = W.clientHeight;
          break;
        }
      }
    ee >= 1 && i((W) => {
      let j = Z * ee - G + $;
      return W >= j ? W : j;
    });
  } }) : null, Hk({ padding: h, apply({ availableWidth: I, availableHeight: D, elements: U }) {
    Object.assign(U.floating.style, { overflow: "auto", maxWidth: `${I}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${D}px)` });
  } })].filter(Boolean), whileElementsMounted: Pk }), [k = f, b = C] = w.placement.split("-");
  f === "selection" && (k = "selection");
  let S = _e(() => ({ anchor: [k, b].filter(Boolean).join(" ") }), [k, b]), P = nM(w, { overflowRef: o, onChange: i }), { getReferenceProps: O, getFloatingProps: A } = tM([P]), L = ae((I) => {
    l(I), _.setFloating(I);
  });
  return pe.createElement(R4.Provider, { value: r }, pe.createElement(ro.Provider, { value: { setFloating: L, setReference: _.setReference, styles: v, getReferenceProps: O, getFloatingProps: A, slot: S } }, e));
}
function aM(e) {
  Je(() => {
    if (!e)
      return;
    let t = new MutationObserver(() => {
      let n = window.getComputedStyle(e).maxHeight, r = parseFloat(n);
      if (isNaN(r))
        return;
      let a = parseInt(n);
      isNaN(a) || r !== a && (e.style.maxHeight = `${Math.ceil(r)}px`);
    });
    return t.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function iM(e, t) {
  var n, r, a;
  let i = a7((n = e == null ? void 0 : e.gap) != null ? n : "var(--anchor-gap, 0)", t), o = a7((r = e == null ? void 0 : e.offset) != null ? r : "var(--anchor-offset, 0)", t), s = a7((a = e == null ? void 0 : e.padding) != null ? a : "var(--anchor-padding, 0)", t);
  return { ...e, gap: i, offset: o, padding: s };
}
function a7(e, t, n = void 0) {
  let r = Wr(), a = ae((l, c) => {
    if (l == null)
      return [n, null];
    if (typeof l == "number")
      return [l, null];
    if (typeof l == "string") {
      if (!c)
        return [n, null];
      let u = eu(l, c);
      return [u, (d) => {
        let p = Zf(l);
        {
          let h = p.map((m) => window.getComputedStyle(c).getPropertyValue(m));
          r.requestAnimationFrame(function m() {
            r.nextFrame(m);
            let f = !1;
            for (let [_, v] of p.entries()) {
              let w = window.getComputedStyle(c).getPropertyValue(v);
              if (h[_] !== w) {
                h[_] = w, f = !0;
                break;
              }
            }
            if (!f)
              return;
            let C = eu(l, c);
            u !== C && (d(C), u = C);
          });
        }
        return r.dispose;
      }];
    }
    return [n, null];
  }), i = _e(() => a(e, t)[0], [e, t]), [o = i, s] = ke();
  return Je(() => {
    let [l, c] = a(e, t);
    if (s(l), !!c)
      return c(s);
  }, [e, t]), o;
}
function Zf(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let n = t[1].indexOf(",");
    if (n === -1)
      return [t[1]];
    let r = t[1].slice(0, n).trim(), a = t[1].slice(n + 1).trim();
    return a ? [r, ...Zf(a)] : [r];
  }
  return [];
}
function eu(e, t) {
  let n = document.createElement("div");
  t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
  let r = parseFloat(window.getComputedStyle(n).marginTop) || 0;
  return t.removeChild(n), r;
}
function oM({ children: e, freeze: t }) {
  let n = I6(t, e);
  return M.createElement(M.Fragment, null, n);
}
function I6(e, t) {
  let [n, r] = ke(t);
  return !e && n !== t && r(t), e ? n : t;
}
let W5 = Qe(null);
W5.displayName = "OpenClosedContext";
var Et = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Et || {});
function ra() {
  return Ue(W5);
}
function no({ value: e, children: t }) {
  return M.createElement(W5.Provider, { value: e }, t);
}
function D4({ children: e }) {
  return M.createElement(W5.Provider, { value: null }, e);
}
function sM(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let On = [];
sM(() => {
  function e(t) {
    if (!(t.target instanceof HTMLElement) || t.target === document.body || On[0] === t.target)
      return;
    let n = t.target;
    n = n.closest(N6), On.unshift(n ?? t.target), On = On.filter((r) => r != null && r.isConnected), On.splice(10);
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function lM(e) {
  throw new Error("Unexpected object: " + e);
}
var Be = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Be || {});
function Ga(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let r = t.resolveActiveIndex(), a = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < n.length; ++i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return r;
    }
    case 1: {
      a === -1 && (a = n.length);
      for (let i = a - 1; i >= 0; --i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return r;
    }
    case 2: {
      for (let i = a + 1; i < n.length; ++i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return r;
    }
    case 3: {
      for (let i = n.length - 1; i >= 0; --i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return r;
    }
    case 4: {
      for (let i = 0; i < n.length; ++i)
        if (t.resolveId(n[i], i, n) === e.id)
          return i;
      return r;
    }
    case 5:
      return null;
    default:
      lM(e);
  }
}
var I4 = ((e) => (e[e.Left = 0] = "Left", e[e.Right = 2] = "Right", e))(I4 || {});
function Kf(e) {
  let t = ae(e), n = be(!1);
  Re(() => (n.current = !1, () => {
    n.current = !0, Qs(() => {
      n.current && t();
    });
  }), [t]);
}
function cM() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in pe ? ((t) => t.useSyncExternalStore)(pe)(() => () => {
  }, () => !1, () => !e) : !1;
}
function p9() {
  let e = cM(), [t, n] = pe.useState(j2.isHandoffComplete);
  return t && j2.isHandoffComplete === !1 && n(!1), pe.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), pe.useEffect(() => j2.handoff(), []), e ? !1 : t;
}
let $f = Qe(!1);
function uM() {
  return Ue($f);
}
function tu(e) {
  return M.createElement($f.Provider, { value: e.force }, e.children);
}
function dM(e) {
  let t = uM(), n = Ue(Yf), r = Yr(e), [a, i] = ke(() => {
    var o;
    if (!t && n !== null)
      return (o = n.current) != null ? o : null;
    if (j2.isServer)
      return null;
    let s = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (s)
      return s;
    if (r === null)
      return null;
    let l = r.createElement("div");
    return l.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(l);
  });
  return Re(() => {
    a !== null && (r != null && r.body.contains(a) || r == null || r.body.appendChild(a));
  }, [a, r]), Re(() => {
    t || n !== null && i(n.current);
  }, [n, i, t]), a;
}
let Wf = n1, pM = De(function(e, t) {
  let n = e, r = be(null), a = et(M4((d) => {
    r.current = d;
  }), t), i = Yr(r), o = dM(r), [s] = ke(() => {
    var d;
    return j2.isServer ? null : (d = i == null ? void 0 : i.createElement("div")) != null ? d : null;
  }), l = Ue(T0), c = p9();
  Je(() => {
    !o || !s || o.contains(s) || (s.setAttribute("data-headlessui-portal", ""), o.appendChild(s));
  }, [o, s]), Je(() => {
    if (s && l)
      return l.register(s);
  }, [l, s]), Kf(() => {
    var d;
    !o || !s || (s instanceof Node && o.contains(s) && o.removeChild(s), o.childNodes.length <= 0 && ((d = o.parentElement) == null || d.removeChild(o)));
  });
  let u = Ve();
  return c ? !o || !s ? null : Wm(u({ ourProps: { ref: a }, theirProps: n, slot: {}, defaultTag: Wf, name: "Portal" }), s) : null;
});
function hM(e, t) {
  let n = et(t), { enabled: r = !0, ...a } = e, i = Ve();
  return r ? M.createElement(pM, { ...a, ref: n }) : i({ ourProps: { ref: n }, theirProps: a, slot: {}, defaultTag: Wf, name: "Portal" });
}
let mM = n1, Yf = Qe(null);
function fM(e, t) {
  let { target: n, ...r } = e, a = { ref: et(t) }, i = Ve();
  return M.createElement(Yf.Provider, { value: n }, i({ ourProps: a, theirProps: r, defaultTag: mM, name: "Popover.Group" }));
}
let T0 = Qe(null);
function qf() {
  let e = Ue(T0), t = be([]), n = ae((i) => (t.current.push(i), e && e.register(i), () => r(i))), r = ae((i) => {
    let o = t.current.indexOf(i);
    o !== -1 && t.current.splice(o, 1), e && e.unregister(i);
  }), a = _e(() => ({ register: n, unregister: r, portals: t }), [n, r, t]);
  return [t, _e(() => function({ children: i }) {
    return M.createElement(T0.Provider, { value: a }, i);
  }, [a])];
}
let CM = De(hM), Jf = De(fM), h9 = Object.assign(CM, { Group: Jf });
var gM = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(gM || {}), yM = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(yM || {}), vM = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(vM || {}), bM = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.SetTyping = 3] = "SetTyping", e[e.RegisterOption = 4] = "RegisterOption", e[e.UnregisterOption = 5] = "UnregisterOption", e[e.SetActivationTrigger = 6] = "SetActivationTrigger", e[e.UpdateVirtualConfiguration = 7] = "UpdateVirtualConfiguration", e[e.SetInputElement = 8] = "SetInputElement", e[e.SetButtonElement = 9] = "SetButtonElement", e[e.SetOptionsElement = 10] = "SetOptionsElement", e))(bM || {});
function i7(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = t(e.options.slice()), a = r.length > 0 && r[0].dataRef.current.order !== null ? r.sort((o, s) => o.dataRef.current.order - s.dataRef.current.order) : In(r, (o) => o.dataRef.current.domRef.current), i = n ? a.indexOf(n) : null;
  return i === -1 && (i = null), { options: a, activeOptionIndex: i };
}
let _M = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1, isTyping: !1, activationTrigger: 2, __demoMode: !1 };
}, 0(e) {
  var t, n;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0)
    return e;
  if ((n = e.dataRef.current) != null && n.value) {
    let r = e.dataRef.current.calculateIndex(e.dataRef.current.value);
    if (r !== -1)
      return { ...e, activeOptionIndex: r, comboboxState: 0, __demoMode: !1 };
  }
  return { ...e, comboboxState: 0, __demoMode: !1 };
}, 3(e, t) {
  return e.isTyping === t.isTyping ? e : { ...e, isTyping: t.isTyping };
}, 2(e, t) {
  var n, r, a, i;
  if ((n = e.dataRef.current) != null && n.disabled || e.optionsElement && !((r = e.dataRef.current) != null && r.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  if (e.virtual) {
    let { options: c, disabled: u } = e.virtual, d = t.focus === Be.Specific ? t.idx : Ga(t, { resolveItems: () => c, resolveActiveIndex: () => {
      var h, m;
      return (m = (h = e.activeOptionIndex) != null ? h : c.findIndex((f) => !u(f))) != null ? m : null;
    }, resolveDisabled: u, resolveId() {
      throw new Error("Function not implemented.");
    } }), p = (a = t.trigger) != null ? a : 2;
    return e.activeOptionIndex === d && e.activationTrigger === p ? e : { ...e, activeOptionIndex: d, activationTrigger: p, isTyping: !1, __demoMode: !1 };
  }
  let o = i7(e);
  if (o.activeOptionIndex === null) {
    let c = o.options.findIndex((u) => !u.dataRef.current.disabled);
    c !== -1 && (o.activeOptionIndex = c);
  }
  let s = t.focus === Be.Specific ? t.idx : Ga(t, { resolveItems: () => o.options, resolveActiveIndex: () => o.activeOptionIndex, resolveId: (c) => c.id, resolveDisabled: (c) => c.dataRef.current.disabled }), l = (i = t.trigger) != null ? i : 2;
  return e.activeOptionIndex === s && e.activationTrigger === l ? e : { ...e, ...o, isTyping: !1, activeOptionIndex: s, activationTrigger: l, __demoMode: !1 };
}, 4: (e, t) => {
  var n, r, a;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: [...e.options, t.payload] };
  let i = t.payload, o = i7(e, (l) => (l.push(i), l));
  e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.payload.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(i));
  let s = { ...e, ...o, activationTrigger: 2 };
  return (a = e.dataRef.current) != null && a.__demoMode && e.dataRef.current.value === void 0 && (s.activeOptionIndex = 0), s;
}, 5: (e, t) => {
  var n;
  if ((n = e.dataRef.current) != null && n.virtual)
    return { ...e, options: e.options.filter((a) => a.id !== t.id) };
  let r = i7(e, (a) => {
    let i = a.findIndex((o) => o.id === t.id);
    return i !== -1 && a.splice(i, 1), a;
  });
  return { ...e, ...r, activationTrigger: 2 };
}, 6: (e, t) => e.activationTrigger === t.trigger ? e : { ...e, activationTrigger: t.trigger }, 7: (e, t) => {
  var n, r;
  if (e.virtual === null)
    return { ...e, virtual: { options: t.options, disabled: (n = t.disabled) != null ? n : () => !1 } };
  if (e.virtual.options === t.options && e.virtual.disabled === t.disabled)
    return e;
  let a = e.activeOptionIndex;
  if (e.activeOptionIndex !== null) {
    let i = t.options.indexOf(e.virtual.options[e.activeOptionIndex]);
    i !== -1 ? a = i : a = null;
  }
  return { ...e, activeOptionIndex: a, virtual: { options: t.options, disabled: (r = t.disabled) != null ? r : () => !1 } };
}, 8: (e, t) => e.inputElement === t.element ? e : { ...e, inputElement: t.element }, 9: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 10: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, H4 = Qe(null);
H4.displayName = "ComboboxActionsContext";
function m9(e) {
  let t = Ue(H4);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, m9), n;
  }
  return t;
}
let Xf = Qe(null);
function wM(e) {
  let t = ao("VirtualProvider"), { options: n } = t.virtual, [r, a] = _e(() => {
    let c = t.optionsElement;
    if (!c)
      return [0, 0];
    let u = window.getComputedStyle(c);
    return [parseFloat(u.paddingBlockStart || u.paddingTop), parseFloat(u.paddingBlockEnd || u.paddingBottom)];
  }, [t.optionsElement]), i = fS({ enabled: n.length !== 0, scrollPaddingStart: r, scrollPaddingEnd: a, count: n.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return t.optionsElement;
  }, overscan: 12 }), [o, s] = ke(0);
  Je(() => {
    s((c) => c + 1);
  }, [n]);
  let l = i.getVirtualItems();
  return l.length === 0 ? null : M.createElement(Xf.Provider, { value: i }, M.createElement("div", { style: { position: "relative", width: "100%", height: `${i.getTotalSize()}px` }, ref: (c) => {
    c && t.activationTrigger !== 0 && t.activeOptionIndex !== null && n.length > t.activeOptionIndex && i.scrollToIndex(t.activeOptionIndex);
  } }, l.map((c) => {
    var u;
    return M.createElement(n1, { key: c.key }, M.cloneElement((u = e.children) == null ? void 0 : u.call(e, { ...e.slot, option: n[c.index] }), { key: `${o}-${c.key}`, "data-index": c.index, "aria-setsize": n.length, "aria-posinset": c.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${c.start}px)`, overflowAnchor: "none" } }));
  })));
}
let Ts = Qe(null);
Ts.displayName = "ComboboxDataContext";
function ao(e) {
  let t = Ue(Ts);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ao), n;
  }
  return t;
}
function xM(e, t) {
  return ht(t.type, _M, e, t);
}
let SM = n1;
function kM(e, t) {
  var n, r;
  let a = _r(), { value: i, defaultValue: o, onChange: s, form: l, name: c, by: u, disabled: d = a || !1, onClose: p, __demoMode: h = !1, multiple: m = !1, immediate: f = !1, virtual: C = null, nullable: _, ...v } = e, w = t9(o), [k = m ? [] : void 0, b] = e9(i, s, w), [S, P] = Ca(xM, { dataRef: N2(), comboboxState: h ? 0 : 1, isTyping: !1, options: [], virtual: C ? { options: C.options, disabled: (n = C.disabled) != null ? n : () => !1 } : null, activeOptionIndex: null, activationTrigger: 2, inputElement: null, buttonElement: null, optionsElement: null, __demoMode: h }), O = be(!1), A = be({ static: !1, hold: !1 }), L = L4(u), I = ae((J) => C ? u === null ? C.options.indexOf(J) : C.options.findIndex((te) => L(te, J)) : S.options.findIndex((te) => L(te.dataRef.current.value, J))), D = ft((J) => ht(z.mode, { 1: () => k.some((te) => L(te, J)), 0: () => L(k, J) }), [k]), U = ae((J) => S.activeOptionIndex === I(J)), z = _e(() => ({ ...S, immediate: f, optionsPropsRef: A, value: k, defaultValue: w, disabled: d, mode: m ? 1 : 0, virtual: C ? S.virtual : null, get activeOptionIndex() {
    if (O.current && S.activeOptionIndex === null && (C ? C.options.length > 0 : S.options.length > 0)) {
      if (C) {
        let te = C.options.findIndex((ye) => {
          var Pe, Ze;
          return !((Ze = (Pe = C.disabled) == null ? void 0 : Pe.call(C, ye)) != null && Ze);
        });
        if (te !== -1)
          return te;
      }
      let J = S.options.findIndex((te) => !te.dataRef.current.disabled);
      if (J !== -1)
        return J;
    }
    return S.activeOptionIndex;
  }, calculateIndex: I, compare: L, isSelected: D, isActive: U }), [k, w, d, m, h, S, C]);
  Je(() => {
    var J;
    C && P({ type: 7, options: C.options, disabled: (J = C.disabled) != null ? J : null });
  }, [C, C == null ? void 0 : C.options, C == null ? void 0 : C.disabled]), Je(() => {
    S.dataRef.current = z;
  }, [z]);
  let $ = z.comboboxState === 0;
  l9($, [z.buttonElement, z.inputElement, z.optionsElement], () => q.closeCombobox());
  let ee = _e(() => {
    var J, te, ye;
    return { open: z.comboboxState === 0, disabled: d, activeIndex: z.activeOptionIndex, activeOption: z.activeOptionIndex === null ? null : z.virtual ? z.virtual.options[(J = z.activeOptionIndex) != null ? J : 0] : (ye = (te = z.options[z.activeOptionIndex]) == null ? void 0 : te.dataRef.current.value) != null ? ye : null, value: k };
  }, [z, d, k]), Z = ae(() => {
    if (z.activeOptionIndex !== null) {
      if (q.setIsTyping(!1), z.virtual)
        N(z.virtual.options[z.activeOptionIndex]);
      else {
        let { dataRef: J } = z.options[z.activeOptionIndex];
        N(J.current.value);
      }
      q.goToOption(Be.Specific, z.activeOptionIndex);
    }
  }), G = ae(() => {
    P({ type: 0 }), O.current = !0;
  }), W = ae(() => {
    P({ type: 1 }), O.current = !1, p == null || p();
  }), j = ae((J) => {
    P({ type: 3, isTyping: J });
  }), T = ae((J, te, ye) => (O.current = !1, J === Be.Specific ? P({ type: 2, focus: Be.Specific, idx: te, trigger: ye }) : P({ type: 2, focus: J, trigger: ye }))), F = ae((J, te) => (P({ type: 4, payload: { id: J, dataRef: te } }), () => {
    z.isActive(te.current.value) && (O.current = !0), P({ type: 5, id: J });
  })), N = ae((J) => ht(z.mode, { 0() {
    return b == null ? void 0 : b(J);
  }, 1() {
    let te = z.value.slice(), ye = te.findIndex((Pe) => L(Pe, J));
    return ye === -1 ? te.push(J) : te.splice(ye, 1), b == null ? void 0 : b(te);
  } })), Y = ae((J) => {
    P({ type: 6, trigger: J });
  }), Q = ae((J) => {
    P({ type: 8, element: J });
  }), V = ae((J) => {
    P({ type: 9, element: J });
  }), re = ae((J) => {
    P({ type: 10, element: J });
  }), q = _e(() => ({ onChange: N, registerOption: F, goToOption: T, setIsTyping: j, closeCombobox: W, openCombobox: G, setActivationTrigger: Y, selectActiveOption: Z, setInputElement: Q, setButtonElement: V, setOptionsElement: re }), []), [he, me] = va(), Ne = t === null ? {} : { ref: t }, K = ft(() => {
    if (w !== void 0)
      return b == null ? void 0 : b(w);
  }, [b, w]), Ee = Ve();
  return M.createElement(me, { value: he, props: { htmlFor: (r = z.inputElement) == null ? void 0 : r.id }, slot: { open: z.comboboxState === 0, disabled: d } }, M.createElement($5, null, M.createElement(H4.Provider, { value: q }, M.createElement(Ts.Provider, { value: z }, M.createElement(no, { value: ht(z.comboboxState, { 0: Et.Open, 1: Et.Closed }) }, c != null && M.createElement(r9, { disabled: d, data: k != null ? { [c]: k } : {}, form: l, onReset: K }), Ee({ ourProps: Ne, theirProps: v, slot: ee, defaultTag: SM, name: "Combobox" }))))));
}
let MM = "input";
function PM(e, t) {
  var n, r, a, i, o;
  let s = ao("Combobox.Input"), l = m9("Combobox.Input"), c = Mt(), u = ya(), { id: d = u || `headlessui-combobox-input-${c}`, onChange: p, displayValue: h, disabled: m = s.disabled || !1, autoFocus: f = !1, type: C = "text", ..._ } = e, v = be(null), w = et(v, t, U5(), l.setInputElement), k = Yr(s.inputElement), b = Wr(), S = ae(() => {
    l.onChange(null), s.optionsElement && (s.optionsElement.scrollTop = 0), l.goToOption(Be.Nothing);
  }), P = _e(() => {
    var N;
    return typeof h == "function" && s.value !== void 0 ? (N = h(s.value)) != null ? N : "" : typeof s.value == "string" ? s.value : "";
  }, [s.value, h]);
  ks(([N, Y], [Q, V]) => {
    if (s.isTyping)
      return;
    let re = v.current;
    re && ((V === 0 && Y === 1 || N !== Q) && (re.value = N), requestAnimationFrame(() => {
      if (s.isTyping || !re || (k == null ? void 0 : k.activeElement) !== re)
        return;
      let { selectionStart: q, selectionEnd: he } = re;
      Math.abs((he ?? 0) - (q ?? 0)) === 0 && q === 0 && re.setSelectionRange(re.value.length, re.value.length);
    }));
  }, [P, s.comboboxState, k, s.isTyping]), ks(([N], [Y]) => {
    if (N === 0 && Y === 1) {
      if (s.isTyping)
        return;
      let Q = v.current;
      if (!Q)
        return;
      let V = Q.value, { selectionStart: re, selectionEnd: q, selectionDirection: he } = Q;
      Q.value = "", Q.value = V, he !== null ? Q.setSelectionRange(re, q, he) : Q.setSelectionRange(re, q);
    }
  }, [s.comboboxState]);
  let O = be(!1), A = ae(() => {
    O.current = !0;
  }), L = ae(() => {
    b.nextFrame(() => {
      O.current = !1;
    });
  }), I = ae((N) => {
    switch (l.setIsTyping(!0), N.key) {
      case Se.Enter:
        if (s.comboboxState !== 0 || O.current)
          return;
        if (N.preventDefault(), N.stopPropagation(), s.activeOptionIndex === null) {
          l.closeCombobox();
          return;
        }
        l.selectActiveOption(), s.mode === 0 && l.closeCombobox();
        break;
      case Se.ArrowDown:
        return N.preventDefault(), N.stopPropagation(), ht(s.comboboxState, { 0: () => l.goToOption(Be.Next), 1: () => l.openCombobox() });
      case Se.ArrowUp:
        return N.preventDefault(), N.stopPropagation(), ht(s.comboboxState, { 0: () => l.goToOption(Be.Previous), 1: () => {
          O1(() => l.openCombobox()), s.value || l.goToOption(Be.Last);
        } });
      case Se.Home:
        if (N.shiftKey)
          break;
        return N.preventDefault(), N.stopPropagation(), l.goToOption(Be.First);
      case Se.PageUp:
        return N.preventDefault(), N.stopPropagation(), l.goToOption(Be.First);
      case Se.End:
        if (N.shiftKey)
          break;
        return N.preventDefault(), N.stopPropagation(), l.goToOption(Be.Last);
      case Se.PageDown:
        return N.preventDefault(), N.stopPropagation(), l.goToOption(Be.Last);
      case Se.Escape:
        return s.comboboxState !== 0 ? void 0 : (N.preventDefault(), s.optionsElement && !s.optionsPropsRef.current.static && N.stopPropagation(), s.mode === 0 && s.value === null && S(), l.closeCombobox());
      case Se.Tab:
        if (s.comboboxState !== 0)
          return;
        s.mode === 0 && s.activationTrigger !== 1 && l.selectActiveOption(), l.closeCombobox();
        break;
    }
  }), D = ae((N) => {
    p == null || p(N), s.mode === 0 && N.target.value === "" && S(), l.openCombobox();
  }), U = ae((N) => {
    var Y, Q, V;
    let re = (Y = N.relatedTarget) != null ? Y : On.find((q) => q !== N.currentTarget);
    if (!((Q = s.optionsElement) != null && Q.contains(re)) && !((V = s.buttonElement) != null && V.contains(re)) && s.comboboxState === 0)
      return N.preventDefault(), s.mode === 0 && s.value === null && S(), l.closeCombobox();
  }), z = ae((N) => {
    var Y, Q, V;
    let re = (Y = N.relatedTarget) != null ? Y : On.find((q) => q !== N.currentTarget);
    (Q = s.buttonElement) != null && Q.contains(re) || (V = s.optionsElement) != null && V.contains(re) || s.disabled || s.immediate && s.comboboxState !== 0 && b.microTask(() => {
      O1(() => l.openCombobox()), l.setActivationTrigger(1);
    });
  }), $ = wn(), ee = qa(), { isFocused: Z, focusProps: G } = Z1({ autoFocus: f }), { isHovered: W, hoverProps: j } = X1({ isDisabled: m }), T = _e(() => ({ open: s.comboboxState === 0, disabled: m, hover: W, focus: Z, autofocus: f }), [s, W, Z, f, m]), F = f1({ ref: w, id: d, role: "combobox", type: C, "aria-controls": (n = s.optionsElement) == null ? void 0 : n.id, "aria-expanded": s.comboboxState === 0, "aria-activedescendant": s.activeOptionIndex === null ? void 0 : s.virtual ? (r = s.options.find((N) => !N.dataRef.current.disabled && s.compare(N.dataRef.current.value, s.virtual.options[s.activeOptionIndex]))) == null ? void 0 : r.id : (a = s.options[s.activeOptionIndex]) == null ? void 0 : a.id, "aria-labelledby": $, "aria-describedby": ee, "aria-autocomplete": "list", defaultValue: (o = (i = e.defaultValue) != null ? i : s.defaultValue !== void 0 ? h == null ? void 0 : h(s.defaultValue) : null) != null ? o : s.defaultValue, disabled: m || void 0, autoFocus: f, onCompositionStart: A, onCompositionEnd: L, onKeyDown: I, onChange: D, onFocus: z, onBlur: U }, G, j);
  return Ve()({ ourProps: F, theirProps: _, slot: T, defaultTag: MM, name: "Combobox.Input" });
}
let EM = "button";
function TM(e, t) {
  var n;
  let r = ao("Combobox.Button"), a = m9("Combobox.Button"), i = et(t, a.setButtonElement), o = Mt(), { id: s = `headlessui-combobox-button-${o}`, disabled: l = r.disabled || !1, autoFocus: c = !1, ...u } = e, d = Pf(r.inputElement), p = ae((P) => {
    switch (P.key) {
      case Se.Space:
      case Se.Enter:
        P.preventDefault(), P.stopPropagation(), r.comboboxState === 1 && O1(() => a.openCombobox()), d();
        return;
      case Se.ArrowDown:
        P.preventDefault(), P.stopPropagation(), r.comboboxState === 1 && (O1(() => a.openCombobox()), r.value || a.goToOption(Be.First)), d();
        return;
      case Se.ArrowUp:
        P.preventDefault(), P.stopPropagation(), r.comboboxState === 1 && (O1(() => a.openCombobox()), r.value || a.goToOption(Be.Last)), d();
        return;
      case Se.Escape:
        if (r.comboboxState !== 0)
          return;
        P.preventDefault(), r.optionsElement && !r.optionsPropsRef.current.static && P.stopPropagation(), O1(() => a.closeCombobox()), d();
        return;
      default:
        return;
    }
  }), h = ae((P) => {
    P.preventDefault(), !ea(P.currentTarget) && (P.button === I4.Left && (r.comboboxState === 0 ? a.closeCombobox() : a.openCombobox()), d());
  }), m = wn([s]), { isFocusVisible: f, focusProps: C } = Z1({ autoFocus: c }), { isHovered: _, hoverProps: v } = X1({ isDisabled: l }), { pressed: w, pressProps: k } = _n({ disabled: l }), b = _e(() => ({ open: r.comboboxState === 0, active: w || r.comboboxState === 0, disabled: l, value: r.value, hover: _, focus: f }), [r, _, f, w, l]), S = f1({ ref: i, id: s, type: Q2(e, r.buttonElement), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (n = r.optionsElement) == null ? void 0 : n.id, "aria-expanded": r.comboboxState === 0, "aria-labelledby": m, disabled: l || void 0, autoFocus: c, onMouseDown: h, onKeyDown: p }, C, v, k);
  return Ve()({ ourProps: S, theirProps: u, slot: b, defaultTag: EM, name: "Combobox.Button" });
}
let LM = "div", AM = I1.RenderStrategy | I1.Static;
function OM(e, t) {
  var n, r, a;
  let i = Mt(), { id: o = `headlessui-combobox-options-${i}`, hold: s = !1, anchor: l, portal: c = !1, modal: u = !0, transition: d = !1, ...p } = e, h = ao("Combobox.Options"), m = m9("Combobox.Options"), f = G5(l);
  f && (c = !0);
  let [C, _] = K5(f), [v, w] = ke(null), k = Z5(), b = et(t, f ? C : null, m.setOptionsElement, w), S = Yr(h.optionsElement), P = ra(), [O, A] = ti(d, v, P !== null ? (P & Et.Open) === Et.Open : h.comboboxState === 0);
  a9(O, h.inputElement, m.closeCombobox);
  let L = h.__demoMode ? !1 : u && h.comboboxState === 0;
  c9(L, S);
  let I = h.__demoMode ? !1 : u && h.comboboxState === 0;
  D5(I, { allowed: ft(() => [h.inputElement, h.buttonElement, h.optionsElement], [h.inputElement, h.buttonElement, h.optionsElement]) }), Je(() => {
    var F;
    h.optionsPropsRef.current.static = (F = e.static) != null ? F : !1;
  }, [h.optionsPropsRef, e.static]), Je(() => {
    h.optionsPropsRef.current.hold = s;
  }, [h.optionsPropsRef, s]), Ef(h.comboboxState === 0, { container: h.optionsElement, accept(F) {
    return F.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : F.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(F) {
    F.setAttribute("role", "none");
  } });
  let D = wn([(n = h.buttonElement) == null ? void 0 : n.id]), U = _e(() => ({ open: h.comboboxState === 0, option: void 0 }), [h.comboboxState]), z = ae(() => {
    m.setActivationTrigger(0);
  }), $ = ae((F) => {
    F.preventDefault(), m.setActivationTrigger(0);
  }), ee = f1(f ? k() : {}, { "aria-labelledby": D, role: "listbox", "aria-multiselectable": h.mode === 1 ? !0 : void 0, id: o, ref: b, style: { ...p.style, ..._, "--input-width": Ss(h.inputElement, !0).width, "--button-width": Ss(h.buttonElement, !0).width }, onWheel: h.activationTrigger === 0 ? void 0 : z, onMouseDown: $, ...ei(A) }), Z = O && h.comboboxState === 1, G = I6(Z, (r = h.virtual) == null ? void 0 : r.options), W = I6(Z, h.value), j = ae((F) => h.compare(W, F));
  if (h.virtual) {
    if (G === void 0)
      throw new Error("Missing `options` in virtual mode");
    Object.assign(p, { children: M.createElement(Ts.Provider, { value: G !== h.virtual.options ? { ...h, virtual: { ...h.virtual, options: G } } : h }, M.createElement(wM, { slot: U }, p.children)) });
  }
  let T = Ve();
  return M.createElement(h9, { enabled: c ? e.static || O : !1 }, M.createElement(Ts.Provider, { value: h.mode === 1 ? h : { ...h, isSelected: j } }, T({ ourProps: ee, theirProps: { ...p, children: M.createElement(oM, { freeze: Z }, typeof p.children == "function" ? (a = p.children) == null ? void 0 : a.call(p, U) : p.children) }, slot: U, defaultTag: LM, features: AM, visible: O, name: "Combobox.Options" })));
}
let NM = "div";
function jM(e, t) {
  var n, r, a, i;
  let o = ao("Combobox.Option"), s = m9("Combobox.Option"), l = Mt(), { id: c = `headlessui-combobox-option-${l}`, value: u, disabled: d = (a = (r = (n = o.virtual) == null ? void 0 : n.disabled) == null ? void 0 : r.call(n, u)) != null ? a : !1, order: p = null, ...h } = e, m = Pf(o.inputElement), f = o.virtual ? o.activeOptionIndex === o.calculateIndex(u) : o.activeOptionIndex === null ? !1 : ((i = o.options[o.activeOptionIndex]) == null ? void 0 : i.id) === c, C = o.isSelected(u), _ = be(null), v = G1({ disabled: d, value: u, domRef: _, order: p }), w = Ue(Xf), k = et(t, _, w ? w.measureElement : null), b = ae(() => {
    s.setIsTyping(!1), s.onChange(u);
  });
  Je(() => s.registerOption(c, v), [v, c]);
  let S = be(!(o.virtual || o.__demoMode));
  Je(() => {
    if (!o.virtual && !o.__demoMode)
      return jr().requestAnimationFrame(() => {
        S.current = !0;
      });
  }, [o.virtual, o.__demoMode]), Je(() => {
    if (S.current && o.comboboxState === 0 && f && o.activationTrigger !== 0)
      return jr().requestAnimationFrame(() => {
        var $, ee;
        (ee = ($ = _.current) == null ? void 0 : $.scrollIntoView) == null || ee.call($, { block: "nearest" });
      });
  }, [_, f, o.comboboxState, o.activationTrigger, o.activeOptionIndex]);
  let P = ae(($) => {
    $.preventDefault(), $.button === I4.Left && (d || (b(), kf() || requestAnimationFrame(() => m()), o.mode === 0 && s.closeCombobox()));
  }), O = ae(() => {
    if (d)
      return s.goToOption(Be.Nothing);
    let $ = o.calculateIndex(u);
    s.goToOption(Be.Specific, $);
  }), A = A4(), L = ae(($) => A.update($)), I = ae(($) => {
    if (!A.wasMoved($) || d || f)
      return;
    let ee = o.calculateIndex(u);
    s.goToOption(Be.Specific, ee, 0);
  }), D = ae(($) => {
    A.wasMoved($) && (d || f && (o.optionsPropsRef.current.hold || s.goToOption(Be.Nothing)));
  }), U = _e(() => ({ active: f, focus: f, selected: C, disabled: d }), [f, C, d]), z = { id: c, ref: k, role: "option", tabIndex: d === !0 ? void 0 : -1, "aria-disabled": d === !0 ? !0 : void 0, "aria-selected": C, disabled: void 0, onMouseDown: P, onFocus: O, onPointerEnter: L, onMouseEnter: L, onPointerMove: I, onMouseMove: I, onPointerLeave: D, onMouseLeave: D };
  return Ve()({ ourProps: z, theirProps: h, slot: U, defaultTag: NM, name: "Combobox.Option" });
}
let RM = De(kM), F4 = De(TM), Qf = De(PM), DM = n9, eC = De(OM), tC = De(jM), IM = Object.assign(RM, { Input: Qf, Button: F4, Label: DM, Options: eC, Option: tC }), HM = n1;
function FM(e, t) {
  let { ...n } = e, r = !1, { isFocusVisible: a, focusProps: i } = Z1(), { isHovered: o, hoverProps: s } = X1({ isDisabled: r }), { pressed: l, pressProps: c } = _n({ disabled: r }), u = f1({ ref: t }, i, s, c), d = _e(() => ({ hover: o, focus: a, active: l }), [o, a, l]);
  return Ve()({ ourProps: u, theirProps: n, slot: d, defaultTag: HM, name: "DataInteractive" });
}
De(FM);
function VM(e, t = typeof document < "u" ? document.defaultView : null, n) {
  let r = Qi(e, "escape");
  I5(t, "keydown", (a) => {
    r && (a.defaultPrevented || a.key === Se.Escape && n(a));
  });
}
function BM() {
  var e;
  let [t] = ke(() => typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [n, r] = ke((e = t == null ? void 0 : t.matches) != null ? e : !1);
  return Je(() => {
    if (!t)
      return;
    function a(i) {
      r(i.matches);
    }
    return t.addEventListener("change", a), () => t.removeEventListener("change", a);
  }, [t]), n;
}
function rC({ defaultContainers: e = [], portals: t, mainTreeNode: n } = {}) {
  let r = Yr(n), a = ae(() => {
    var i, o;
    let s = [];
    for (let l of e)
      l !== null && (l instanceof HTMLElement ? s.push(l) : "current" in l && l.current instanceof HTMLElement && s.push(l.current));
    if (t != null && t.current)
      for (let l of t.current)
        s.push(l);
    for (let l of (i = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? i : [])
      l !== document.body && l !== document.head && l instanceof HTMLElement && l.id !== "headlessui-portal-root" && (n && (l.contains(n) || l.contains((o = n == null ? void 0 : n.getRootNode()) == null ? void 0 : o.host)) || s.some((c) => l.contains(c)) || s.push(l));
    return s;
  });
  return { resolveContainers: a, contains: ae((i) => a().some((o) => o.contains(i))) };
}
let nC = Qe(null);
function H6({ children: e, node: t }) {
  let [n, r] = ke(null), a = V4(t ?? n);
  return M.createElement(nC.Provider, { value: a }, e, a === null && M.createElement(yn, { features: gn.Hidden, ref: (i) => {
    var o, s;
    if (i) {
      for (let l of (s = (o = $r(i)) == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? s : [])
        if (l !== document.body && l !== document.head && l instanceof HTMLElement && l != null && l.contains(i)) {
          r(l);
          break;
        }
    }
  } }));
}
function V4(e = null) {
  var t;
  return (t = Ue(nC)) != null ? t : e;
}
function Y5() {
  let e = be(!1);
  return Je(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
var Pr = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Pr || {});
function B4() {
  let e = be(0);
  return Mf(!0, "keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function aC(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.current)
    n.current instanceof HTMLElement && t.add(n.current);
  return t;
}
let zM = "div";
var S2 = ((e) => (e[e.None = 0] = "None", e[e.InitialFocus = 1] = "InitialFocus", e[e.TabLock = 2] = "TabLock", e[e.FocusLock = 4] = "FocusLock", e[e.RestoreFocus = 8] = "RestoreFocus", e[e.AutoFocus = 16] = "AutoFocus", e))(S2 || {});
function GM(e, t) {
  let n = be(null), r = et(n, t), { initialFocus: a, initialFocusFallback: i, containers: o, features: s = 15, ...l } = e;
  p9() || (s = 0);
  let c = Yr(n);
  $M(s, { ownerDocument: c });
  let u = WM(s, { ownerDocument: c, container: n, initialFocus: a, initialFocusFallback: i });
  YM(s, { ownerDocument: c, container: n, containers: o, previousActiveElement: u });
  let d = B4(), p = ae((v) => {
    let w = n.current;
    w && ((k) => k())(() => {
      ht(d.current, { [Pr.Forwards]: () => {
        b1(w, St.First, { skipElements: [v.relatedTarget, i] });
      }, [Pr.Backwards]: () => {
        b1(w, St.Last, { skipElements: [v.relatedTarget, i] });
      } });
    });
  }), h = Qi(!!(s & 2), "focus-trap#tab-lock"), m = Wr(), f = be(!1), C = { ref: r, onKeyDown(v) {
    v.key == "Tab" && (f.current = !0, m.requestAnimationFrame(() => {
      f.current = !1;
    }));
  }, onBlur(v) {
    if (!(s & 4))
      return;
    let w = aC(o);
    n.current instanceof HTMLElement && w.add(n.current);
    let k = v.relatedTarget;
    k instanceof HTMLElement && k.dataset.headlessuiFocusGuard !== "true" && (iC(w, k) || (f.current ? b1(n.current, ht(d.current, { [Pr.Forwards]: () => St.Next, [Pr.Backwards]: () => St.Previous }) | St.WrapAround, { relativeTo: v.target }) : v.target instanceof HTMLElement && zn(v.target)));
  } }, _ = Ve();
  return M.createElement(M.Fragment, null, h && M.createElement(yn, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: gn.Focusable }), _({ ourProps: C, theirProps: l, defaultTag: zM, name: "FocusTrap" }), h && M.createElement(yn, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: p, features: gn.Focusable }));
}
let UM = De(GM), ZM = Object.assign(UM, { features: S2 });
function KM(e = !0) {
  let t = be(On.slice());
  return ks(([n], [r]) => {
    r === !0 && n === !1 && Qs(() => {
      t.current.splice(0);
    }), r === !1 && n === !0 && (t.current = On.slice());
  }, [e, On, t]), ae(() => {
    var n;
    return (n = t.current.find((r) => r != null && r.isConnected)) != null ? n : null;
  });
}
function $M(e, { ownerDocument: t }) {
  let n = !!(e & 8), r = KM(n);
  ks(() => {
    n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && zn(r());
  }, [n]), Kf(() => {
    n && zn(r());
  });
}
function WM(e, { ownerDocument: t, container: n, initialFocus: r, initialFocusFallback: a }) {
  let i = be(null), o = Qi(!!(e & 1), "focus-trap#initial-focus"), s = Y5();
  return ks(() => {
    if (e === 0)
      return;
    if (!o) {
      a != null && a.current && zn(a.current);
      return;
    }
    let l = n.current;
    l && Qs(() => {
      if (!s.current)
        return;
      let c = t == null ? void 0 : t.activeElement;
      if (r != null && r.current) {
        if ((r == null ? void 0 : r.current) === c) {
          i.current = c;
          return;
        }
      } else if (l.contains(c)) {
        i.current = c;
        return;
      }
      if (r != null && r.current)
        zn(r.current);
      else {
        if (e & 16) {
          if (b1(l, St.First | St.AutoFocus) !== Vr.Error)
            return;
        } else if (b1(l, St.First) !== Vr.Error)
          return;
        if (a != null && a.current && (zn(a.current), (t == null ? void 0 : t.activeElement) === a.current))
          return;
        console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      i.current = t == null ? void 0 : t.activeElement;
    });
  }, [a, o, e]), i;
}
function YM(e, { ownerDocument: t, container: n, containers: r, previousActiveElement: a }) {
  let i = Y5(), o = !!(e & 4);
  I5(t == null ? void 0 : t.defaultView, "focus", (s) => {
    if (!o || !i.current)
      return;
    let l = aC(r);
    n.current instanceof HTMLElement && l.add(n.current);
    let c = a.current;
    if (!c)
      return;
    let u = s.target;
    u && u instanceof HTMLElement ? iC(l, u) ? (a.current = u, zn(u)) : (s.preventDefault(), s.stopPropagation(), zn(c)) : zn(a.current);
  }, !0);
}
function iC(e, t) {
  for (let n of e)
    if (n.contains(t))
      return !0;
  return !1;
}
function oC(e) {
  var t;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : lC) !== n1 || M.Children.count(e.children) === 1;
}
let q5 = Qe(null);
q5.displayName = "TransitionContext";
var qM = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(qM || {});
function JM() {
  let e = Ue(q5);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function XM() {
  let e = Ue(J5);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let J5 = Qe(null);
J5.displayName = "NestingContext";
function X5(e) {
  return "children" in e ? X5(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function sC(e, t) {
  let n = G1(e), r = be([]), a = Y5(), i = Wr(), o = ae((h, m = Ia.Hidden) => {
    let f = r.current.findIndex(({ el: C }) => C === h);
    f !== -1 && (ht(m, { [Ia.Unmount]() {
      r.current.splice(f, 1);
    }, [Ia.Hidden]() {
      r.current[f].state = "hidden";
    } }), i.microTask(() => {
      var C;
      !X5(r) && a.current && ((C = n.current) == null || C.call(n));
    }));
  }), s = ae((h) => {
    let m = r.current.find(({ el: f }) => f === h);
    return m ? m.state !== "visible" && (m.state = "visible") : r.current.push({ el: h, state: "visible" }), () => o(h, Ia.Unmount);
  }), l = be([]), c = be(Promise.resolve()), u = be({ enter: [], leave: [] }), d = ae((h, m, f) => {
    l.current.splice(0), t && (t.chains.current[m] = t.chains.current[m].filter(([C]) => C !== h)), t == null || t.chains.current[m].push([h, new Promise((C) => {
      l.current.push(C);
    })]), t == null || t.chains.current[m].push([h, new Promise((C) => {
      Promise.all(u.current[m].map(([_, v]) => v)).then(() => C());
    })]), m === "enter" ? c.current = c.current.then(() => t == null ? void 0 : t.wait.current).then(() => f(m)) : f(m);
  }), p = ae((h, m, f) => {
    Promise.all(u.current[m].splice(0).map(([C, _]) => _)).then(() => {
      var C;
      (C = l.current.shift()) == null || C();
    }).then(() => f(m));
  });
  return _e(() => ({ children: r, register: s, unregister: o, onStart: d, onStop: p, wait: c, chains: u }), [s, o, r, d, p, u, c]);
}
let lC = n1, cC = I1.RenderStrategy;
function QM(e, t) {
  var n, r;
  let { transition: a = !0, beforeEnter: i, afterEnter: o, beforeLeave: s, afterLeave: l, enter: c, enterFrom: u, enterTo: d, entered: p, leave: h, leaveFrom: m, leaveTo: f, ...C } = e, [_, v] = ke(null), w = be(null), k = oC(e), b = et(...k ? [w, t, v] : t === null ? [] : [t]), S = (n = C.unmount) == null || n ? Ia.Unmount : Ia.Hidden, { show: P, appear: O, initial: A } = JM(), [L, I] = ke(P ? "visible" : "hidden"), D = XM(), { register: U, unregister: z } = D;
  Je(() => U(w), [U, w]), Je(() => {
    if (S === Ia.Hidden && w.current) {
      if (P && L !== "visible") {
        I("visible");
        return;
      }
      return ht(L, { hidden: () => z(w), visible: () => U(w) });
    }
  }, [L, w, U, z, P, S]);
  let $ = p9();
  Je(() => {
    if (k && $ && L === "visible" && w.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [w, L, $, k]);
  let ee = A && !O, Z = O && P && A, G = be(!1), W = sC(() => {
    G.current || (I("hidden"), z(w));
  }, D), j = ae((re) => {
    G.current = !0;
    let q = re ? "enter" : "leave";
    W.onStart(w, q, (he) => {
      he === "enter" ? i == null || i() : he === "leave" && (s == null || s());
    });
  }), T = ae((re) => {
    let q = re ? "enter" : "leave";
    G.current = !1, W.onStop(w, q, (he) => {
      he === "enter" ? o == null || o() : he === "leave" && (l == null || l());
    }), q === "leave" && !X5(W) && (I("hidden"), z(w));
  });
  Re(() => {
    k && a || (j(P), T(P));
  }, [P, k, a]);
  let F = !(!a || !k || !$ || ee), [, N] = ti(F, _, P, { start: j, end: T }), Y = ja({ ref: b, className: ((r = S0(C.className, Z && c, Z && u, N.enter && c, N.enter && N.closed && u, N.enter && !N.closed && d, N.leave && h, N.leave && !N.closed && m, N.leave && N.closed && f, !N.transition && P && p)) == null ? void 0 : r.trim()) || void 0, ...ei(N) }), Q = 0;
  L === "visible" && (Q |= Et.Open), L === "hidden" && (Q |= Et.Closed), N.enter && (Q |= Et.Opening), N.leave && (Q |= Et.Closing);
  let V = Ve();
  return M.createElement(J5.Provider, { value: W }, M.createElement(no, { value: Q }, V({ ourProps: Y, theirProps: C, defaultTag: lC, features: cC, visible: L === "visible", name: "Transition.Child" })));
}
function eP(e, t) {
  let { show: n, appear: r = !1, unmount: a = !0, ...i } = e, o = be(null), s = oC(e), l = et(...s ? [o, t] : t === null ? [] : [t]);
  p9();
  let c = ra();
  if (n === void 0 && c !== null && (n = (c & Et.Open) === Et.Open), n === void 0)
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [u, d] = ke(n ? "visible" : "hidden"), p = sC(() => {
    n || d("hidden");
  }), [h, m] = ke(!0), f = be([n]);
  Je(() => {
    h !== !1 && f.current[f.current.length - 1] !== n && (f.current.push(n), m(!1));
  }, [f, n]);
  let C = _e(() => ({ show: n, appear: r, initial: h }), [n, r, h]);
  Je(() => {
    n ? d("visible") : !X5(p) && o.current !== null && d("hidden");
  }, [n, p]);
  let _ = { unmount: a }, v = ae(() => {
    var b;
    h && m(!1), (b = e.beforeEnter) == null || b.call(e);
  }), w = ae(() => {
    var b;
    h && m(!1), (b = e.beforeLeave) == null || b.call(e);
  }), k = Ve();
  return M.createElement(J5.Provider, { value: p }, M.createElement(q5.Provider, { value: C }, k({ ourProps: { ..._, as: n1, children: M.createElement(uC, { ref: l, ..._, ...i, beforeEnter: v, beforeLeave: w }) }, theirProps: {}, defaultTag: n1, features: cC, visible: u === "visible", name: "Transition" })));
}
function tP(e, t) {
  let n = Ue(q5) !== null, r = ra() !== null;
  return M.createElement(M.Fragment, null, !n && r ? M.createElement(L0, { ref: t, ...e }) : M.createElement(uC, { ref: t, ...e }));
}
let L0 = De(eP), uC = De(QM), z4 = De(tP), i6 = Object.assign(L0, { Child: z4, Root: L0 });
var rP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(rP || {}), nP = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(nP || {});
let aP = { 0(e, t) {
  return e.titleId === t.id ? e : { ...e, titleId: t.id };
} }, G4 = Qe(null);
G4.displayName = "DialogContext";
function Q5(e) {
  let t = Ue(G4);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Q5), n;
  }
  return t;
}
function iP(e, t) {
  return ht(t.type, aP, e, t);
}
let ru = De(function(e, t) {
  let n = Mt(), { id: r = `headlessui-dialog-${n}`, open: a, onClose: i, initialFocus: o, role: s = "dialog", autoFocus: l = !0, __demoMode: c = !1, unmount: u = !1, ...d } = e, p = be(!1);
  s = function() {
    return s === "dialog" || s === "alertdialog" ? s : (p.current || (p.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let h = ra();
  a === void 0 && h !== null && (a = (h & Et.Open) === Et.Open);
  let m = be(null), f = et(m, t), C = Yr(m), _ = a ? 0 : 1, [v, w] = Ca(iP, { titleId: null, descriptionId: null, panelRef: N2() }), k = ae(() => i(!1)), b = ae((T) => w({ type: 0, id: T })), S = p9() ? _ === 0 : !1, [P, O] = qf(), A = { get current() {
    var T;
    return (T = v.panelRef.current) != null ? T : m.current;
  } }, L = V4(), { resolveContainers: I } = rC({ mainTreeNode: L, portals: P, defaultContainers: [A] }), D = h !== null ? (h & Et.Closing) === Et.Closing : !1;
  D5(c || D ? !1 : S, { allowed: ae(() => {
    var T, F;
    return [(F = (T = m.current) == null ? void 0 : T.closest("[data-headlessui-portal]")) != null ? F : null];
  }), disallowed: ae(() => {
    var T;
    return [(T = L == null ? void 0 : L.closest("body > *:not(#headlessui-portal-root)")) != null ? T : null];
  }) }), l9(S, I, (T) => {
    T.preventDefault(), k();
  }), VM(S, C == null ? void 0 : C.defaultView, (T) => {
    T.preventDefault(), T.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), k();
  }), c9(c || D ? !1 : S, C, I), a9(S, m, k);
  let [U, z] = Xi(), $ = _e(() => [{ dialogState: _, close: k, setTitleId: b, unmount: u }, v], [_, v, k, b, u]), ee = _e(() => ({ open: _ === 0 }), [_]), Z = { ref: f, id: r, role: s, tabIndex: -1, "aria-modal": c ? void 0 : _ === 0 ? !0 : void 0, "aria-labelledby": v.titleId, "aria-describedby": U, unmount: u }, G = !BM(), W = S2.None;
  S && !c && (W |= S2.RestoreFocus, W |= S2.TabLock, l && (W |= S2.AutoFocus), G && (W |= S2.InitialFocus));
  let j = Ve();
  return M.createElement(D4, null, M.createElement(tu, { force: !0 }, M.createElement(h9, null, M.createElement(G4.Provider, { value: $ }, M.createElement(Jf, { target: m }, M.createElement(tu, { force: !1 }, M.createElement(z, { slot: ee }, M.createElement(O, null, M.createElement(ZM, { initialFocus: o, initialFocusFallback: m, containers: I, features: W }, M.createElement(T4, { value: k }, j({ ourProps: Z, theirProps: d, slot: ee, defaultTag: oP, features: sP, visible: _ === 0, name: "Dialog" })))))))))));
}), oP = "div", sP = I1.RenderStrategy | I1.Static;
function lP(e, t) {
  let { transition: n = !1, open: r, ...a } = e, i = ra(), o = e.hasOwnProperty("open") || i !== null, s = e.hasOwnProperty("onClose");
  if (!o && !s)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!o)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!s)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (!i && typeof e.open != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
  if (typeof e.onClose != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
  return (r !== void 0 || n) && !a.static ? M.createElement(H6, null, M.createElement(i6, { show: r, transition: n, unmount: a.unmount }, M.createElement(ru, { ref: t, ...a }))) : M.createElement(H6, null, M.createElement(ru, { ref: t, open: r, ...a }));
}
let cP = "div";
function uP(e, t) {
  let n = Mt(), { id: r = `headlessui-dialog-panel-${n}`, transition: a = !1, ...i } = e, [{ dialogState: o, unmount: s }, l] = Q5("Dialog.Panel"), c = et(t, l.panelRef), u = _e(() => ({ open: o === 0 }), [o]), d = ae((C) => {
    C.stopPropagation();
  }), p = { ref: c, id: r, onClick: d }, h = a ? z4 : n1, m = a ? { unmount: s } : {}, f = Ve();
  return M.createElement(h, { ...m }, f({ ourProps: p, theirProps: i, slot: u, defaultTag: cP, name: "Dialog.Panel" }));
}
let dP = "div";
function pP(e, t) {
  let { transition: n = !1, ...r } = e, [{ dialogState: a, unmount: i }] = Q5("Dialog.Backdrop"), o = _e(() => ({ open: a === 0 }), [a]), s = { ref: t, "aria-hidden": !0 }, l = n ? z4 : n1, c = n ? { unmount: i } : {}, u = Ve();
  return M.createElement(l, { ...c }, u({ ourProps: s, theirProps: r, slot: o, defaultTag: dP, name: "Dialog.Backdrop" }));
}
let hP = "h2";
function mP(e, t) {
  let n = Mt(), { id: r = `headlessui-dialog-title-${n}`, ...a } = e, [{ dialogState: i, setTitleId: o }] = Q5("Dialog.Title"), s = et(t);
  Re(() => (o(r), () => o(null)), [r, o]);
  let l = _e(() => ({ open: i === 0 }), [i]), c = { ref: s, id: r };
  return Ve()({ ourProps: c, theirProps: a, slot: l, defaultTag: hP, name: "Dialog.Title" });
}
let fP = De(lP), CP = De(uP);
De(pP);
let gP = De(mP), nu = Object.assign(fP, { Panel: CP, Title: gP, Description: P4 });
var au;
let yP = (au = M.startTransition) != null ? au : function(e) {
  e();
};
var vP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(vP || {}), bP = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.SetButtonElement = 4] = "SetButtonElement", e[e.SetPanelElement = 5] = "SetPanelElement", e))(bP || {});
let _P = { 0: (e) => ({ ...e, disclosureState: ht(e.disclosureState, { 0: 1, 1: 0 }) }), 1: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, 2(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 3(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
}, 4(e, t) {
  return e.buttonElement === t.element ? e : { ...e, buttonElement: t.element };
}, 5(e, t) {
  return e.panelElement === t.element ? e : { ...e, panelElement: t.element };
} }, U4 = Qe(null);
U4.displayName = "DisclosureContext";
function Z4(e) {
  let t = Ue(U4);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Z4), n;
  }
  return t;
}
let K4 = Qe(null);
K4.displayName = "DisclosureAPIContext";
function dC(e) {
  let t = Ue(K4);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, dC), n;
  }
  return t;
}
let $4 = Qe(null);
$4.displayName = "DisclosurePanelContext";
function wP() {
  return Ue($4);
}
function xP(e, t) {
  return ht(t.type, _P, e, t);
}
let SP = n1;
function kP(e, t) {
  let { defaultOpen: n = !1, ...r } = e, a = be(null), i = et(t, M4((f) => {
    a.current = f;
  }, e.as === void 0 || e.as === n1)), o = Ca(xP, { disclosureState: n ? 0 : 1, buttonElement: null, panelElement: null, buttonId: null, panelId: null }), [{ disclosureState: s, buttonId: l }, c] = o, u = ae((f) => {
    c({ type: 1 });
    let C = $r(a);
    if (!C || !l)
      return;
    let _ = f ? f instanceof HTMLElement ? f : f.current instanceof HTMLElement ? f.current : C.getElementById(l) : C.getElementById(l);
    _ == null || _.focus();
  }), d = _e(() => ({ close: u }), [u]), p = _e(() => ({ open: s === 0, close: u }), [s, u]), h = { ref: i }, m = Ve();
  return M.createElement(U4.Provider, { value: o }, M.createElement(K4.Provider, { value: d }, M.createElement(T4, { value: u }, M.createElement(no, { value: ht(s, { 0: Et.Open, 1: Et.Closed }) }, m({ ourProps: h, theirProps: r, slot: p, defaultTag: SP, name: "Disclosure" })))));
}
let MP = "button";
function PP(e, t) {
  let n = Mt(), { id: r = `headlessui-disclosure-button-${n}`, disabled: a = !1, autoFocus: i = !1, ...o } = e, [s, l] = Z4("Disclosure.Button"), c = wP(), u = c === null ? !1 : c === s.panelId, d = be(null), p = et(d, t, ae((A) => {
    if (!u)
      return l({ type: 4, element: A });
  }));
  Re(() => {
    if (!u)
      return l({ type: 2, buttonId: r }), () => {
        l({ type: 2, buttonId: null });
      };
  }, [r, l, u]);
  let h = ae((A) => {
    var L;
    if (u) {
      if (s.disclosureState === 1)
        return;
      switch (A.key) {
        case Se.Space:
        case Se.Enter:
          A.preventDefault(), A.stopPropagation(), l({ type: 0 }), (L = s.buttonElement) == null || L.focus();
          break;
      }
    } else
      switch (A.key) {
        case Se.Space:
        case Se.Enter:
          A.preventDefault(), A.stopPropagation(), l({ type: 0 });
          break;
      }
  }), m = ae((A) => {
    switch (A.key) {
      case Se.Space:
        A.preventDefault();
        break;
    }
  }), f = ae((A) => {
    var L;
    ea(A.currentTarget) || a || (u ? (l({ type: 0 }), (L = s.buttonElement) == null || L.focus()) : l({ type: 0 }));
  }), { isFocusVisible: C, focusProps: _ } = Z1({ autoFocus: i }), { isHovered: v, hoverProps: w } = X1({ isDisabled: a }), { pressed: k, pressProps: b } = _n({ disabled: a }), S = _e(() => ({ open: s.disclosureState === 0, hover: v, active: k, disabled: a, focus: C, autofocus: i }), [s, v, k, C, a, i]), P = Q2(e, s.buttonElement), O = f1(u ? { ref: p, type: P, disabled: a || void 0, autoFocus: i, onKeyDown: h, onClick: f } : { ref: p, id: r, type: P, "aria-expanded": s.disclosureState === 0, "aria-controls": s.panelElement ? s.panelId : void 0, disabled: a || void 0, autoFocus: i, onKeyDown: h, onKeyUp: m, onClick: f }, _, w, b);
  return Ve()({ ourProps: O, theirProps: o, slot: S, defaultTag: MP, name: "Disclosure.Button" });
}
let EP = "div", TP = I1.RenderStrategy | I1.Static;
function LP(e, t) {
  let n = Mt(), { id: r = `headlessui-disclosure-panel-${n}`, transition: a = !1, ...i } = e, [o, s] = Z4("Disclosure.Panel"), { close: l } = dC("Disclosure.Panel"), [c, u] = ke(null), d = et(t, ae((v) => {
    yP(() => s({ type: 5, element: v }));
  }), u);
  Re(() => (s({ type: 3, panelId: r }), () => {
    s({ type: 3, panelId: null });
  }), [r, s]);
  let p = ra(), [h, m] = ti(a, c, p !== null ? (p & Et.Open) === Et.Open : o.disclosureState === 0), f = _e(() => ({ open: o.disclosureState === 0, close: l }), [o.disclosureState, l]), C = { ref: d, id: r, ...ei(m) }, _ = Ve();
  return M.createElement(D4, null, M.createElement($4.Provider, { value: o.panelId }, _({ ourProps: C, theirProps: i, slot: f, defaultTag: EP, features: TP, visible: h, name: "Disclosure.Panel" })));
}
let AP = De(kP), OP = De(PP), NP = De(LP);
Object.assign(AP, { Button: OP, Panel: NP });
let jP = "div";
function RP(e, t) {
  let n = `headlessui-control-${Mt()}`, [r, a] = va(), [i, o] = Xi(), s = _r(), { disabled: l = s || !1, ...c } = e, u = _e(() => ({ disabled: l }), [l]), d = { ref: t, disabled: l || void 0, "aria-disabled": l || void 0 }, p = Ve();
  return M.createElement(cf, { value: l }, M.createElement(a, { value: r }, M.createElement(o, { value: i }, M.createElement(Ux, { id: n }, p({ ourProps: d, theirProps: { ...c, children: M.createElement(Bx, null, typeof c.children == "function" ? c.children(u) : c.children) }, slot: u, defaultTag: jP, name: "Field" })))));
}
let DP = De(RP);
function IP(e) {
  let t = typeof e == "string" ? e : void 0, [n, r] = ke(t);
  return [t ?? n, ft((a) => {
    t || a instanceof HTMLElement && r(a.tagName.toLowerCase());
  }, [t])];
}
let iu = "fieldset";
function HP(e, t) {
  var n;
  let r = _r(), { disabled: a = r || !1, ...i } = e, [o, s] = IP((n = e.as) != null ? n : iu), l = et(t, s), [c, u] = va(), d = _e(() => ({ disabled: a }), [a]), p = o === "fieldset" ? { ref: l, "aria-labelledby": c, disabled: a || void 0 } : { ref: l, role: "group", "aria-labelledby": c, "aria-disabled": a || void 0 }, h = Ve();
  return M.createElement(cf, { value: a }, M.createElement(u, null, h({ ourProps: p, theirProps: i, slot: d, defaultTag: iu, name: "Fieldset" })));
}
De(HP);
let FP = "input";
function VP(e, t) {
  let n = Mt(), r = ya(), a = _r(), { id: i = r || `headlessui-input-${n}`, disabled: o = a || !1, autoFocus: s = !1, invalid: l = !1, ...c } = e, u = wn(), d = qa(), { isFocused: p, focusProps: h } = Z1({ autoFocus: s }), { isHovered: m, hoverProps: f } = X1({ isDisabled: o }), C = f1({ ref: t, id: i, "aria-labelledby": u, "aria-describedby": d, "aria-invalid": l ? "" : void 0, disabled: o || void 0, autoFocus: s }, h, f), _ = _e(() => ({ disabled: o, invalid: l, hover: m, focus: p, autofocus: s }), [o, l, m, p, s]);
  return Ve()({ ourProps: C, theirProps: c, slot: _, defaultTag: FP, name: "Input" });
}
De(VP);
function BP(e, t) {
  return M.createElement(n9, { as: "div", ref: t, ...e });
}
De(BP);
function pC(e, t) {
  let n = be({ left: 0, top: 0 });
  if (Je(() => {
    if (!t)
      return;
    let a = t.getBoundingClientRect();
    a && (n.current = a);
  }, [e, t]), t == null || !e || t === document.activeElement)
    return !1;
  let r = t.getBoundingClientRect();
  return r.top !== n.current.top || r.left !== n.current.left;
}
let ou = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function su(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", a = e.cloneNode(!0);
  if (!(a instanceof HTMLElement))
    return r;
  let i = !1;
  for (let s of a.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    s.remove(), i = !0;
  let o = i ? (n = a.innerText) != null ? n : "" : r;
  return ou.test(o) && (o = o.replace(ou, "")), o;
}
function zP(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((a) => {
      let i = document.getElementById(a);
      if (i) {
        let o = i.getAttribute("aria-label");
        return typeof o == "string" ? o.trim() : su(i).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0)
      return r.join(", ");
  }
  return su(e).trim();
}
function hC(e) {
  let t = be(""), n = be("");
  return ae(() => {
    let r = e.current;
    if (!r)
      return "";
    let a = r.innerText;
    if (t.current === a)
      return n.current;
    let i = zP(r).trim().toLowerCase();
    return t.current = a, n.current = i, i;
  });
}
var GP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(GP || {}), UP = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(UP || {}), ZP = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(ZP || {}), KP = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetOptionsElement = 8] = "SetOptionsElement", e))(KP || {});
function o7(e, t = (n) => n) {
  let n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = In(t(e.options.slice()), (i) => i.dataRef.current.domRef.current), a = n ? r.indexOf(n) : null;
  return a === -1 && (a = null), { options: r, activeOptionIndex: a };
}
let $P = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1, __demoMode: !1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0)
    return e;
  let t = e.activeOptionIndex, { isSelected: n } = e.dataRef.current, r = e.options.findIndex((a) => n(a.dataRef.current.value));
  return r !== -1 && (t = r), { ...e, listboxState: 0, activeOptionIndex: t, __demoMode: !1 };
}, 2(e, t) {
  var n, r, a, i, o;
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let s = { ...e, searchQuery: "", activationTrigger: (n = t.trigger) != null ? n : 1, __demoMode: !1 };
  if (t.focus === Be.Nothing)
    return { ...s, activeOptionIndex: null };
  if (t.focus === Be.Specific)
    return { ...s, activeOptionIndex: e.options.findIndex((u) => u.id === t.id) };
  if (t.focus === Be.Previous) {
    let u = e.activeOptionIndex;
    if (u !== null) {
      let d = e.options[u].dataRef.current.domRef, p = Ga(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.options[p].dataRef.current.domRef;
        if (((r = d.current) == null ? void 0 : r.previousElementSibling) === h.current || ((a = h.current) == null ? void 0 : a.previousElementSibling) === null)
          return { ...s, activeOptionIndex: p };
      }
    }
  } else if (t.focus === Be.Next) {
    let u = e.activeOptionIndex;
    if (u !== null) {
      let d = e.options[u].dataRef.current.domRef, p = Ga(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.options[p].dataRef.current.domRef;
        if (((i = d.current) == null ? void 0 : i.nextElementSibling) === h.current || ((o = h.current) == null ? void 0 : o.nextElementSibling) === null)
          return { ...s, activeOptionIndex: p };
      }
    }
  }
  let l = o7(e), c = Ga(t, { resolveItems: () => l.options, resolveActiveIndex: () => l.activeOptionIndex, resolveId: (u) => u.id, resolveDisabled: (u) => u.dataRef.current.disabled });
  return { ...s, ...l, activeOptionIndex: c };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + t.value.toLowerCase(), a = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find((o) => {
    var s;
    return !o.dataRef.current.disabled && ((s = o.dataRef.current.textValue) == null ? void 0 : s.startsWith(r));
  }), i = a ? e.options.indexOf(a) : -1;
  return i === -1 || i === e.activeOptionIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeOptionIndex: i, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let n = { id: t.id, dataRef: t.dataRef }, r = o7(e, (a) => [...a, n]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(n)), { ...e, ...r };
}, 6: (e, t) => {
  let n = o7(e, (r) => {
    let a = r.findIndex((i) => i.id === t.id);
    return a !== -1 && r.splice(a, 1), r;
  });
  return { ...e, ...n, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, W4 = Qe(null);
W4.displayName = "ListboxActionsContext";
function e8(e) {
  let t = Ue(W4);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, e8), n;
  }
  return t;
}
let t8 = Qe(null);
t8.displayName = "ListboxDataContext";
function f9(e) {
  let t = Ue(t8);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, f9), n;
  }
  return t;
}
function WP(e, t) {
  return ht(t.type, $P, e, t);
}
let YP = n1;
function qP(e, t) {
  var n;
  let r = _r(), { value: a, defaultValue: i, form: o, name: s, onChange: l, by: c, invalid: u = !1, disabled: d = r || !1, horizontal: p = !1, multiple: h = !1, __demoMode: m = !1, ...f } = e;
  const C = p ? "horizontal" : "vertical";
  let _ = et(t), v = t9(i), [w = h ? [] : void 0, k] = e9(a, l, v), [b, S] = Ca(WP, { dataRef: N2(), listboxState: m ? 0 : 1, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1, optionsVisible: !1, buttonElement: null, optionsElement: null, __demoMode: m }), P = be({ static: !1, hold: !1 }), O = be(/* @__PURE__ */ new Map()), A = L4(c), L = ft((K) => ht(I.mode, { 1: () => w.some((Ee) => A(Ee, K)), 0: () => A(w, K) }), [w]), I = _e(() => ({ ...b, value: w, disabled: d, invalid: u, mode: h ? 1 : 0, orientation: C, compare: A, isSelected: L, optionsPropsRef: P, listRef: O }), [w, d, u, h, b, O]);
  Je(() => {
    b.dataRef.current = I;
  }, [I]);
  let D = I.listboxState === 0;
  l9(D, [I.buttonElement, I.optionsElement], (K, Ee) => {
    var J;
    S({ type: 1 }), s9(Ee, o9.Loose) || (K.preventDefault(), (J = I.buttonElement) == null || J.focus());
  });
  let U = _e(() => ({ open: I.listboxState === 0, disabled: d, invalid: u, value: w }), [I, d, w, u]), z = ae((K) => {
    let Ee = I.options.find((J) => J.id === K);
    Ee && T(Ee.dataRef.current.value);
  }), $ = ae(() => {
    if (I.activeOptionIndex !== null) {
      let { dataRef: K, id: Ee } = I.options[I.activeOptionIndex];
      T(K.current.value), S({ type: 2, focus: Be.Specific, id: Ee });
    }
  }), ee = ae(() => S({ type: 0 })), Z = ae(() => S({ type: 1 })), G = Wr(), W = ae((K, Ee, J) => {
    G.dispose(), G.microTask(() => K === Be.Specific ? S({ type: 2, focus: Be.Specific, id: Ee, trigger: J }) : S({ type: 2, focus: K, trigger: J }));
  }), j = ae((K, Ee) => (S({ type: 5, id: K, dataRef: Ee }), () => S({ type: 6, id: K }))), T = ae((K) => ht(I.mode, { 0() {
    return k == null ? void 0 : k(K);
  }, 1() {
    let Ee = I.value.slice(), J = Ee.findIndex((te) => A(te, K));
    return J === -1 ? Ee.push(K) : Ee.splice(J, 1), k == null ? void 0 : k(Ee);
  } })), F = ae((K) => S({ type: 3, value: K })), N = ae(() => S({ type: 4 })), Y = ae((K) => {
    S({ type: 7, element: K });
  }), Q = ae((K) => {
    S({ type: 8, element: K });
  }), V = _e(() => ({ onChange: T, registerOption: j, goToOption: W, closeListbox: Z, openListbox: ee, selectActiveOption: $, selectOption: z, search: F, clearSearch: N, setButtonElement: Y, setOptionsElement: Q }), []), [re, q] = va({ inherit: !0 }), he = { ref: _ }, me = ft(() => {
    if (v !== void 0)
      return k == null ? void 0 : k(v);
  }, [k, v]), Ne = Ve();
  return M.createElement(q, { value: re, props: { htmlFor: (n = I.buttonElement) == null ? void 0 : n.id }, slot: { open: I.listboxState === 0, disabled: d } }, M.createElement($5, null, M.createElement(W4.Provider, { value: V }, M.createElement(t8.Provider, { value: I }, M.createElement(no, { value: ht(I.listboxState, { 0: Et.Open, 1: Et.Closed }) }, s != null && w != null && M.createElement(r9, { disabled: d, data: { [s]: w }, form: o, onReset: me }), Ne({ ourProps: he, theirProps: f, slot: U, defaultTag: YP, name: "Listbox" }))))));
}
let JP = "button";
function XP(e, t) {
  var n;
  let r = f9("Listbox.Button"), a = e8("Listbox.Button"), i = Mt(), o = ya(), { id: s = o || `headlessui-listbox-button-${i}`, disabled: l = r.disabled || !1, autoFocus: c = !1, ...u } = e, d = et(t, U5(), a.setButtonElement), p = Uf(), h = ae((I) => {
    switch (I.key) {
      case Se.Enter:
        N5(I.currentTarget);
        break;
      case Se.Space:
      case Se.ArrowDown:
        I.preventDefault(), O1(() => a.openListbox()), r.value || a.goToOption(Be.First);
        break;
      case Se.ArrowUp:
        I.preventDefault(), O1(() => a.openListbox()), r.value || a.goToOption(Be.Last);
        break;
    }
  }), m = ae((I) => {
    switch (I.key) {
      case Se.Space:
        I.preventDefault();
        break;
    }
  }), f = ae((I) => {
    var D;
    if (ea(I.currentTarget))
      return I.preventDefault();
    r.listboxState === 0 ? (O1(() => a.closeListbox()), (D = r.buttonElement) == null || D.focus({ preventScroll: !0 })) : (I.preventDefault(), a.openListbox());
  }), C = ae((I) => I.preventDefault()), _ = wn([s]), v = qa(), { isFocusVisible: w, focusProps: k } = Z1({ autoFocus: c }), { isHovered: b, hoverProps: S } = X1({ isDisabled: l }), { pressed: P, pressProps: O } = _n({ disabled: l }), A = _e(() => ({ open: r.listboxState === 0, active: P || r.listboxState === 0, disabled: l, invalid: r.invalid, value: r.value, hover: b, focus: w, autofocus: c }), [r.listboxState, r.value, l, b, w, P, r.invalid, c]), L = f1(p(), { ref: d, id: s, type: Q2(e, r.buttonElement), "aria-haspopup": "listbox", "aria-controls": (n = r.optionsElement) == null ? void 0 : n.id, "aria-expanded": r.listboxState === 0, "aria-labelledby": _, "aria-describedby": v, disabled: l || void 0, autoFocus: c, onKeyDown: h, onKeyUp: m, onKeyPress: C, onClick: f }, k, S, O);
  return Ve()({ ourProps: L, theirProps: u, slot: A, defaultTag: JP, name: "Listbox.Button" });
}
let mC = Qe(!1), QP = "div", eE = I1.RenderStrategy | I1.Static;
function tE(e, t) {
  var n, r;
  let a = Mt(), { id: i = `headlessui-listbox-options-${a}`, anchor: o, portal: s = !1, modal: l = !0, transition: c = !1, ...u } = e, d = G5(o), [p, h] = ke(null);
  d && (s = !0);
  let m = f9("Listbox.Options"), f = e8("Listbox.Options"), C = Yr(m.optionsElement), _ = ra(), [v, w] = ti(c, p, _ !== null ? (_ & Et.Open) === Et.Open : m.listboxState === 0);
  a9(v, m.buttonElement, f.closeListbox);
  let k = m.__demoMode ? !1 : l && m.listboxState === 0;
  c9(k, C);
  let b = m.__demoMode ? !1 : l && m.listboxState === 0;
  D5(b, { allowed: ft(() => [m.buttonElement, m.optionsElement], [m.buttonElement, m.optionsElement]) });
  let S = m.listboxState !== 0, P = pC(S, m.buttonElement) ? !1 : v, O = v && m.listboxState === 1, A = I6(O, m.value), L = ae((N) => m.compare(A, N)), I = _e(() => {
    var N;
    if (d == null || !((N = d == null ? void 0 : d.to) != null && N.includes("selection")))
      return null;
    let Y = m.options.findIndex((Q) => L(Q.dataRef.current.value));
    return Y === -1 && (Y = 0), Y;
  }, [d, m.options]), D = (() => {
    if (d == null)
      return;
    if (I === null)
      return { ...d, inner: void 0 };
    let N = Array.from(m.listRef.current.values());
    return { ...d, inner: { listRef: { current: N }, index: I } };
  })(), [U, z] = K5(D), $ = Z5(), ee = et(t, d ? U : null, f.setOptionsElement, h), Z = Wr();
  Re(() => {
    var N;
    let Y = m.optionsElement;
    Y && m.listboxState === 0 && Y !== ((N = $r(Y)) == null ? void 0 : N.activeElement) && (Y == null || Y.focus({ preventScroll: !0 }));
  }, [m.listboxState, m.optionsElement]);
  let G = ae((N) => {
    var Y, Q;
    switch (Z.dispose(), N.key) {
      case Se.Space:
        if (m.searchQuery !== "")
          return N.preventDefault(), N.stopPropagation(), f.search(N.key);
      case Se.Enter:
        if (N.preventDefault(), N.stopPropagation(), m.activeOptionIndex !== null) {
          let { dataRef: V } = m.options[m.activeOptionIndex];
          f.onChange(V.current.value);
        }
        m.mode === 0 && (O1(() => f.closeListbox()), (Y = m.buttonElement) == null || Y.focus({ preventScroll: !0 }));
        break;
      case ht(m.orientation, { vertical: Se.ArrowDown, horizontal: Se.ArrowRight }):
        return N.preventDefault(), N.stopPropagation(), f.goToOption(Be.Next);
      case ht(m.orientation, { vertical: Se.ArrowUp, horizontal: Se.ArrowLeft }):
        return N.preventDefault(), N.stopPropagation(), f.goToOption(Be.Previous);
      case Se.Home:
      case Se.PageUp:
        return N.preventDefault(), N.stopPropagation(), f.goToOption(Be.First);
      case Se.End:
      case Se.PageDown:
        return N.preventDefault(), N.stopPropagation(), f.goToOption(Be.Last);
      case Se.Escape:
        N.preventDefault(), N.stopPropagation(), O1(() => f.closeListbox()), (Q = m.buttonElement) == null || Q.focus({ preventScroll: !0 });
        return;
      case Se.Tab:
        N.preventDefault(), N.stopPropagation(), O1(() => f.closeListbox()), xf(m.buttonElement, N.shiftKey ? St.Previous : St.Next);
        break;
      default:
        N.key.length === 1 && (f.search(N.key), Z.setTimeout(() => f.clearSearch(), 350));
        break;
    }
  }), W = (n = m.buttonElement) == null ? void 0 : n.id, j = _e(() => ({ open: m.listboxState === 0 }), [m.listboxState]), T = f1(d ? $() : {}, { id: i, ref: ee, "aria-activedescendant": m.activeOptionIndex === null || (r = m.options[m.activeOptionIndex]) == null ? void 0 : r.id, "aria-multiselectable": m.mode === 1 ? !0 : void 0, "aria-labelledby": W, "aria-orientation": m.orientation, onKeyDown: G, role: "listbox", tabIndex: m.listboxState === 0 ? 0 : void 0, style: { ...u.style, ...z, "--button-width": Ss(m.buttonElement, !0).width }, ...ei(w) }), F = Ve();
  return M.createElement(h9, { enabled: s ? e.static || v : !1 }, M.createElement(t8.Provider, { value: m.mode === 1 ? m : { ...m, isSelected: L } }, F({ ourProps: T, theirProps: u, slot: j, defaultTag: QP, features: eE, visible: P, name: "Listbox.Options" })));
}
let rE = "div";
function nE(e, t) {
  let n = Mt(), { id: r = `headlessui-listbox-option-${n}`, disabled: a = !1, value: i, ...o } = e, s = Ue(mC) === !0, l = f9("Listbox.Option"), c = e8("Listbox.Option"), u = l.activeOptionIndex !== null ? l.options[l.activeOptionIndex].id === r : !1, d = l.isSelected(i), p = be(null), h = hC(p), m = G1({ disabled: a, value: i, domRef: p, get textValue() {
    return h();
  } }), f = et(t, p, (A) => {
    A ? l.listRef.current.set(r, A) : l.listRef.current.delete(r);
  });
  Je(() => {
    if (!l.__demoMode && l.listboxState === 0 && u && l.activationTrigger !== 0)
      return jr().requestAnimationFrame(() => {
        var A, L;
        (L = (A = p.current) == null ? void 0 : A.scrollIntoView) == null || L.call(A, { block: "nearest" });
      });
  }, [p, u, l.__demoMode, l.listboxState, l.activationTrigger, l.activeOptionIndex]), Je(() => {
    if (!s)
      return c.registerOption(r, m);
  }, [m, r, s]);
  let C = ae((A) => {
    var L;
    if (a)
      return A.preventDefault();
    c.onChange(i), l.mode === 0 && (O1(() => c.closeListbox()), (L = l.buttonElement) == null || L.focus({ preventScroll: !0 }));
  }), _ = ae(() => {
    if (a)
      return c.goToOption(Be.Nothing);
    c.goToOption(Be.Specific, r);
  }), v = A4(), w = ae((A) => {
    v.update(A), !a && (u || c.goToOption(Be.Specific, r, 0));
  }), k = ae((A) => {
    v.wasMoved(A) && (a || u || c.goToOption(Be.Specific, r, 0));
  }), b = ae((A) => {
    v.wasMoved(A) && (a || u && c.goToOption(Be.Nothing));
  }), S = _e(() => ({ active: u, focus: u, selected: d, disabled: a, selectedOption: d && s }), [u, d, a, s]), P = s ? {} : { id: r, ref: f, role: "option", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-selected": d, disabled: void 0, onClick: C, onFocus: _, onPointerEnter: w, onMouseEnter: w, onPointerMove: k, onMouseMove: k, onPointerLeave: b, onMouseLeave: b }, O = Ve();
  return !d && s ? null : O({ ourProps: P, theirProps: o, slot: S, defaultTag: rE, name: "Listbox.Option" });
}
let aE = n1;
function iE(e, t) {
  let { options: n, placeholder: r, ...a } = e, i = { ref: et(t) }, o = f9("ListboxSelectedOption"), s = _e(() => ({}), []), l = o.value === void 0 || o.value === null || o.mode === 1 && Array.isArray(o.value) && o.value.length === 0, c = Ve();
  return M.createElement(mC.Provider, { value: !0 }, c({ ourProps: i, theirProps: { ...a, children: M.createElement(M.Fragment, null, r && l ? r : n) }, slot: s, defaultTag: aE, name: "ListboxSelectedOption" }));
}
let oE = De(qP), fC = De(XP), sE = n9, CC = De(tE), lE = De(nE), cE = De(iE), uE = Object.assign(oE, { Button: fC, Label: sE, Options: CC, Option: lE, SelectedOption: cE });
var dE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(dE || {}), pE = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(pE || {}), hE = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetItemsElement = 8] = "SetItemsElement", e))(hE || {});
function s7(e, t = (n) => n) {
  let n = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, r = In(t(e.items.slice()), (i) => i.dataRef.current.domRef.current), a = n ? r.indexOf(n) : null;
  return a === -1 && (a = null), { items: r, activeItemIndex: a };
}
let mE = { 1(e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, 0(e) {
  return e.menuState === 0 ? e : { ...e, __demoMode: !1, menuState: 0 };
}, 2: (e, t) => {
  var n, r, a, i, o;
  if (e.menuState === 1)
    return e;
  let s = { ...e, searchQuery: "", activationTrigger: (n = t.trigger) != null ? n : 1, __demoMode: !1 };
  if (t.focus === Be.Nothing)
    return { ...s, activeItemIndex: null };
  if (t.focus === Be.Specific)
    return { ...s, activeItemIndex: e.items.findIndex((u) => u.id === t.id) };
  if (t.focus === Be.Previous) {
    let u = e.activeItemIndex;
    if (u !== null) {
      let d = e.items[u].dataRef.current.domRef, p = Ga(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.items[p].dataRef.current.domRef;
        if (((r = d.current) == null ? void 0 : r.previousElementSibling) === h.current || ((a = h.current) == null ? void 0 : a.previousElementSibling) === null)
          return { ...s, activeItemIndex: p };
      }
    }
  } else if (t.focus === Be.Next) {
    let u = e.activeItemIndex;
    if (u !== null) {
      let d = e.items[u].dataRef.current.domRef, p = Ga(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (h) => h.id, resolveDisabled: (h) => h.dataRef.current.disabled });
      if (p !== null) {
        let h = e.items[p].dataRef.current.domRef;
        if (((i = d.current) == null ? void 0 : i.nextElementSibling) === h.current || ((o = h.current) == null ? void 0 : o.nextElementSibling) === null)
          return { ...s, activeItemIndex: p };
      }
    }
  }
  let l = s7(e), c = Ga(t, { resolveItems: () => l.items, resolveActiveIndex: () => l.activeItemIndex, resolveId: (u) => u.id, resolveDisabled: (u) => u.dataRef.current.disabled });
  return { ...s, ...l, activeItemIndex: c };
}, 3: (e, t) => {
  let n = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + t.value.toLowerCase(), a = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + n).concat(e.items.slice(0, e.activeItemIndex + n)) : e.items).find((o) => {
    var s;
    return ((s = o.dataRef.current.textValue) == null ? void 0 : s.startsWith(r)) && !o.dataRef.current.disabled;
  }), i = a ? e.items.indexOf(a) : -1;
  return i === -1 || i === e.activeItemIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeItemIndex: i, activationTrigger: 1 };
}, 4(e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, 5: (e, t) => {
  let n = s7(e, (r) => [...r, { id: t.id, dataRef: t.dataRef }]);
  return { ...e, ...n };
}, 6: (e, t) => {
  let n = s7(e, (r) => {
    let a = r.findIndex((i) => i.id === t.id);
    return a !== -1 && r.splice(a, 1), r;
  });
  return { ...e, ...n, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.itemsElement === t.element ? e : { ...e, itemsElement: t.element } }, Y4 = Qe(null);
Y4.displayName = "MenuContext";
function r8(e) {
  let t = Ue(Y4);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, r8), n;
  }
  return t;
}
function fE(e, t) {
  return ht(t.type, mE, e, t);
}
let CE = n1;
function gE(e, t) {
  let { __demoMode: n = !1, ...r } = e, a = Ca(fE, { __demoMode: n, menuState: n ? 0 : 1, buttonElement: null, itemsElement: null, items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: i, itemsElement: o, buttonElement: s }, l] = a, c = et(t);
  l9(i === 0, [s, o], (m, f) => {
    l({ type: 1 }), s9(f, o9.Loose) || (m.preventDefault(), s == null || s.focus());
  });
  let u = ae(() => {
    l({ type: 1 });
  }), d = _e(() => ({ open: i === 0, close: u }), [i, u]), p = { ref: c }, h = Ve();
  return M.createElement($5, null, M.createElement(Y4.Provider, { value: a }, M.createElement(no, { value: ht(i, { 0: Et.Open, 1: Et.Closed }) }, h({ ourProps: p, theirProps: r, slot: d, defaultTag: CE, name: "Menu" }))));
}
let yE = "button";
function vE(e, t) {
  var n;
  let r = Mt(), { id: a = `headlessui-menu-button-${r}`, disabled: i = !1, autoFocus: o = !1, ...s } = e, [l, c] = r8("Menu.Button"), u = Uf(), d = et(t, U5(), ae((P) => c({ type: 7, element: P }))), p = ae((P) => {
    switch (P.key) {
      case Se.Space:
      case Se.Enter:
      case Se.ArrowDown:
        P.preventDefault(), P.stopPropagation(), O1(() => c({ type: 0 })), c({ type: 2, focus: Be.First });
        break;
      case Se.ArrowUp:
        P.preventDefault(), P.stopPropagation(), O1(() => c({ type: 0 })), c({ type: 2, focus: Be.Last });
        break;
    }
  }), h = ae((P) => {
    switch (P.key) {
      case Se.Space:
        P.preventDefault();
        break;
    }
  }), m = ae((P) => {
    var O;
    if (ea(P.currentTarget))
      return P.preventDefault();
    i || (l.menuState === 0 ? (O1(() => c({ type: 1 })), (O = l.buttonElement) == null || O.focus({ preventScroll: !0 })) : (P.preventDefault(), c({ type: 0 })));
  }), { isFocusVisible: f, focusProps: C } = Z1({ autoFocus: o }), { isHovered: _, hoverProps: v } = X1({ isDisabled: i }), { pressed: w, pressProps: k } = _n({ disabled: i }), b = _e(() => ({ open: l.menuState === 0, active: w || l.menuState === 0, disabled: i, hover: _, focus: f, autofocus: o }), [l, _, f, w, i, o]), S = f1(u(), { ref: d, id: a, type: Q2(e, l.buttonElement), "aria-haspopup": "menu", "aria-controls": (n = l.itemsElement) == null ? void 0 : n.id, "aria-expanded": l.menuState === 0, disabled: i || void 0, autoFocus: o, onKeyDown: p, onKeyUp: h, onClick: m }, C, v, k);
  return Ve()({ ourProps: S, theirProps: s, slot: b, defaultTag: yE, name: "Menu.Button" });
}
let bE = "div", _E = I1.RenderStrategy | I1.Static;
function wE(e, t) {
  var n, r;
  let a = Mt(), { id: i = `headlessui-menu-items-${a}`, anchor: o, portal: s = !1, modal: l = !0, transition: c = !1, ...u } = e, d = G5(o), [p, h] = r8("Menu.Items"), [m, f] = K5(d), C = Z5(), [_, v] = ke(null), w = et(t, d ? m : null, ae((G) => h({ type: 8, element: G })), v), k = Yr(p.itemsElement);
  d && (s = !0);
  let b = ra(), [S, P] = ti(c, _, b !== null ? (b & Et.Open) === Et.Open : p.menuState === 0);
  a9(S, p.buttonElement, () => {
    h({ type: 1 });
  });
  let O = p.__demoMode ? !1 : l && p.menuState === 0;
  c9(O, k);
  let A = p.__demoMode ? !1 : l && p.menuState === 0;
  D5(A, { allowed: ft(() => [p.buttonElement, p.itemsElement], [p.buttonElement, p.itemsElement]) });
  let L = p.menuState !== 0, I = pC(L, p.buttonElement) ? !1 : S;
  Re(() => {
    let G = p.itemsElement;
    G && p.menuState === 0 && G !== (k == null ? void 0 : k.activeElement) && G.focus({ preventScroll: !0 });
  }, [p.menuState, p.itemsElement, k]), Ef(p.menuState === 0, { container: p.itemsElement, accept(G) {
    return G.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : G.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(G) {
    G.setAttribute("role", "none");
  } });
  let D = Wr(), U = ae((G) => {
    var W, j, T;
    switch (D.dispose(), G.key) {
      case Se.Space:
        if (p.searchQuery !== "")
          return G.preventDefault(), G.stopPropagation(), h({ type: 3, value: G.key });
      case Se.Enter:
        if (G.preventDefault(), G.stopPropagation(), h({ type: 1 }), p.activeItemIndex !== null) {
          let { dataRef: F } = p.items[p.activeItemIndex];
          (j = (W = F.current) == null ? void 0 : W.domRef.current) == null || j.click();
        }
        wf(p.buttonElement);
        break;
      case Se.ArrowDown:
        return G.preventDefault(), G.stopPropagation(), h({ type: 2, focus: Be.Next });
      case Se.ArrowUp:
        return G.preventDefault(), G.stopPropagation(), h({ type: 2, focus: Be.Previous });
      case Se.Home:
      case Se.PageUp:
        return G.preventDefault(), G.stopPropagation(), h({ type: 2, focus: Be.First });
      case Se.End:
      case Se.PageDown:
        return G.preventDefault(), G.stopPropagation(), h({ type: 2, focus: Be.Last });
      case Se.Escape:
        G.preventDefault(), G.stopPropagation(), O1(() => h({ type: 1 })), (T = p.buttonElement) == null || T.focus({ preventScroll: !0 });
        break;
      case Se.Tab:
        G.preventDefault(), G.stopPropagation(), O1(() => h({ type: 1 })), xf(p.buttonElement, G.shiftKey ? St.Previous : St.Next);
        break;
      default:
        G.key.length === 1 && (h({ type: 3, value: G.key }), D.setTimeout(() => h({ type: 4 }), 350));
        break;
    }
  }), z = ae((G) => {
    switch (G.key) {
      case Se.Space:
        G.preventDefault();
        break;
    }
  }), $ = _e(() => ({ open: p.menuState === 0 }), [p.menuState]), ee = f1(d ? C() : {}, { "aria-activedescendant": p.activeItemIndex === null || (n = p.items[p.activeItemIndex]) == null ? void 0 : n.id, "aria-labelledby": (r = p.buttonElement) == null ? void 0 : r.id, id: i, onKeyDown: U, onKeyUp: z, role: "menu", tabIndex: p.menuState === 0 ? 0 : void 0, ref: w, style: { ...u.style, ...f, "--button-width": Ss(p.buttonElement, !0).width }, ...ei(P) }), Z = Ve();
  return M.createElement(h9, { enabled: s ? e.static || S : !1 }, Z({ ourProps: ee, theirProps: u, slot: $, defaultTag: bE, features: _E, visible: I, name: "Menu.Items" }));
}
let xE = n1;
function SE(e, t) {
  let n = Mt(), { id: r = `headlessui-menu-item-${n}`, disabled: a = !1, ...i } = e, [o, s] = r8("Menu.Item"), l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === r : !1, c = be(null), u = et(t, c);
  Je(() => {
    if (!o.__demoMode && o.menuState === 0 && l && o.activationTrigger !== 0)
      return jr().requestAnimationFrame(() => {
        var I, D;
        (D = (I = c.current) == null ? void 0 : I.scrollIntoView) == null || D.call(I, { block: "nearest" });
      });
  }, [o.__demoMode, c, l, o.menuState, o.activationTrigger, o.activeItemIndex]);
  let d = hC(c), p = be({ disabled: a, domRef: c, get textValue() {
    return d();
  } });
  Je(() => {
    p.current.disabled = a;
  }, [p, a]), Je(() => (s({ type: 5, id: r, dataRef: p }), () => s({ type: 6, id: r })), [p, r]);
  let h = ae(() => {
    s({ type: 1 });
  }), m = ae((I) => {
    if (a)
      return I.preventDefault();
    s({ type: 1 }), wf(o.buttonElement);
  }), f = ae(() => {
    if (a)
      return s({ type: 2, focus: Be.Nothing });
    s({ type: 2, focus: Be.Specific, id: r });
  }), C = A4(), _ = ae((I) => {
    C.update(I), !a && (l || s({ type: 2, focus: Be.Specific, id: r, trigger: 0 }));
  }), v = ae((I) => {
    C.wasMoved(I) && (a || l || s({ type: 2, focus: Be.Specific, id: r, trigger: 0 }));
  }), w = ae((I) => {
    C.wasMoved(I) && (a || l && s({ type: 2, focus: Be.Nothing }));
  }), [k, b] = va(), [S, P] = Xi(), O = _e(() => ({ active: l, focus: l, disabled: a, close: h }), [l, a, h]), A = { id: r, ref: u, role: "menuitem", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-labelledby": k, "aria-describedby": S, disabled: void 0, onClick: m, onFocus: f, onPointerEnter: _, onMouseEnter: _, onPointerMove: v, onMouseMove: v, onPointerLeave: w, onMouseLeave: w }, L = Ve();
  return M.createElement(b, null, M.createElement(P, null, L({ ourProps: A, theirProps: i, slot: O, defaultTag: xE, name: "Menu.Item" })));
}
let kE = "div";
function ME(e, t) {
  let [n, r] = va(), a = e, i = { ref: t, "aria-labelledby": n, role: "group" }, o = Ve();
  return M.createElement(r, null, o({ ourProps: i, theirProps: a, slot: {}, defaultTag: kE, name: "Menu.Section" }));
}
let PE = "header";
function EE(e, t) {
  let n = Mt(), { id: r = `headlessui-menu-heading-${n}`, ...a } = e, i = E4();
  Je(() => i.register(r), [r, i.register]);
  let o = { id: r, ref: t, role: "presentation", ...i.props };
  return Ve()({ ourProps: o, theirProps: a, slot: {}, defaultTag: PE, name: "Menu.Heading" });
}
let TE = "div";
function LE(e, t) {
  let n = e, r = { ref: t, role: "separator" };
  return Ve()({ ourProps: r, theirProps: n, slot: {}, defaultTag: TE, name: "Menu.Separator" });
}
let AE = De(gE), OE = De(vE), NE = De(wE), jE = De(SE), RE = De(ME), DE = De(EE), IE = De(LE);
Object.assign(AE, { Button: OE, Items: NE, Item: jE, Section: RE, Heading: DE, Separator: IE });
var HE = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(HE || {}), FE = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(FE || {});
let VE = { 0: (e) => ({ ...e, popoverState: ht(e.popoverState, { 0: 1, 1: 0 }), __demoMode: !1 }), 1(e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1, __demoMode: !1 };
}, 2(e, t) {
  return e.button === t.button ? e : { ...e, button: t.button };
}, 3(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 4(e, t) {
  return e.panel === t.panel ? e : { ...e, panel: t.panel };
}, 5(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, q4 = Qe(null);
q4.displayName = "PopoverContext";
function n8(e) {
  let t = Ue(q4);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, n8), n;
  }
  return t;
}
let a8 = Qe(null);
a8.displayName = "PopoverAPIContext";
function J4(e) {
  let t = Ue(a8);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, J4), n;
  }
  return t;
}
let X4 = Qe(null);
X4.displayName = "PopoverGroupContext";
function gC() {
  return Ue(X4);
}
let i8 = Qe(null);
i8.displayName = "PopoverPanelContext";
function BE() {
  return Ue(i8);
}
function zE(e, t) {
  return ht(t.type, VE, e, t);
}
let GE = "div";
function UE(e, t) {
  var n;
  let { __demoMode: r = !1, ...a } = e, i = be(null), o = et(t, M4((W) => {
    i.current = W;
  })), s = be([]), l = Ca(zE, { __demoMode: r, popoverState: r ? 0 : 1, buttons: s, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: N2(), afterPanelSentinel: N2(), afterButtonSentinel: N2() }), [{ popoverState: c, button: u, buttonId: d, panel: p, panelId: h, beforePanelSentinel: m, afterPanelSentinel: f, afterButtonSentinel: C }, _] = l, v = Yr((n = i.current) != null ? n : u), w = _e(() => {
    if (!u || !p)
      return !1;
    for (let Q of document.querySelectorAll("body > *"))
      if (Number(Q == null ? void 0 : Q.contains(u)) ^ Number(Q == null ? void 0 : Q.contains(p)))
        return !0;
    let W = i9(), j = W.indexOf(u), T = (j + W.length - 1) % W.length, F = (j + 1) % W.length, N = W[T], Y = W[F];
    return !p.contains(N) && !p.contains(Y);
  }, [u, p]), k = G1(d), b = G1(h), S = _e(() => ({ buttonId: k, panelId: b, close: () => _({ type: 1 }) }), [k, b, _]), P = gC(), O = P == null ? void 0 : P.registerPopover, A = ae(() => {
    var W;
    return (W = P == null ? void 0 : P.isFocusWithinPopoverGroup()) != null ? W : (v == null ? void 0 : v.activeElement) && ((u == null ? void 0 : u.contains(v.activeElement)) || (p == null ? void 0 : p.contains(v.activeElement)));
  });
  Re(() => O == null ? void 0 : O(S), [O, S]);
  let [L, I] = qf(), D = V4(u), U = rC({ mainTreeNode: D, portals: L, defaultContainers: [u, p] });
  I5(v == null ? void 0 : v.defaultView, "focus", (W) => {
    var j, T, F, N, Y, Q;
    W.target !== window && W.target instanceof HTMLElement && c === 0 && (A() || u && p && (U.contains(W.target) || (T = (j = m.current) == null ? void 0 : j.contains) != null && T.call(j, W.target) || (N = (F = f.current) == null ? void 0 : F.contains) != null && N.call(F, W.target) || (Q = (Y = C.current) == null ? void 0 : Y.contains) != null && Q.call(Y, W.target) || _({ type: 1 })));
  }, !0), l9(c === 0, U.resolveContainers, (W, j) => {
    _({ type: 1 }), s9(j, o9.Loose) || (W.preventDefault(), u == null || u.focus());
  });
  let z = ae((W) => {
    _({ type: 1 });
    let j = W ? W instanceof HTMLElement ? W : "current" in W && W.current instanceof HTMLElement ? W.current : u : u;
    j == null || j.focus();
  }), $ = _e(() => ({ close: z, isPortalled: w }), [z, w]), ee = _e(() => ({ open: c === 0, close: z }), [c, z]), Z = { ref: o }, G = Ve();
  return M.createElement(H6, { node: D }, M.createElement($5, null, M.createElement(i8.Provider, { value: null }, M.createElement(q4.Provider, { value: l }, M.createElement(a8.Provider, { value: $ }, M.createElement(T4, { value: z }, M.createElement(no, { value: ht(c, { 0: Et.Open, 1: Et.Closed }) }, M.createElement(I, null, G({ ourProps: Z, theirProps: a, slot: ee, defaultTag: GE, name: "Popover" })))))))));
}
let ZE = "button";
function KE(e, t) {
  let n = Mt(), { id: r = `headlessui-popover-button-${n}`, disabled: a = !1, autoFocus: i = !1, ...o } = e, [s, l] = n8("Popover.Button"), { isPortalled: c } = J4("Popover.Button"), u = be(null), d = `headlessui-focus-sentinel-${Mt()}`, p = gC(), h = p == null ? void 0 : p.closeOthers, m = BE() !== null;
  Re(() => {
    if (!m)
      return l({ type: 3, buttonId: r }), () => {
        l({ type: 3, buttonId: null });
      };
  }, [m, r, l]);
  let [f] = ke(() => Symbol()), C = et(u, t, U5(), ae((j) => {
    if (!m) {
      if (j)
        s.buttons.current.push(f);
      else {
        let T = s.buttons.current.indexOf(f);
        T !== -1 && s.buttons.current.splice(T, 1);
      }
      s.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), j && l({ type: 2, button: j });
    }
  })), _ = et(u, t), v = Yr(u), w = ae((j) => {
    var T, F, N;
    if (m) {
      if (s.popoverState === 1)
        return;
      switch (j.key) {
        case Se.Space:
        case Se.Enter:
          j.preventDefault(), (F = (T = j.target).click) == null || F.call(T), l({ type: 1 }), (N = s.button) == null || N.focus();
          break;
      }
    } else
      switch (j.key) {
        case Se.Space:
        case Se.Enter:
          j.preventDefault(), j.stopPropagation(), s.popoverState === 1 && (h == null || h(s.buttonId)), l({ type: 0 });
          break;
        case Se.Escape:
          if (s.popoverState !== 0)
            return h == null ? void 0 : h(s.buttonId);
          if (!u.current || v != null && v.activeElement && !u.current.contains(v.activeElement))
            return;
          j.preventDefault(), j.stopPropagation(), l({ type: 1 });
          break;
      }
  }), k = ae((j) => {
    m || j.key === Se.Space && j.preventDefault();
  }), b = ae((j) => {
    var T, F;
    ea(j.currentTarget) || a || (m ? (l({ type: 1 }), (T = s.button) == null || T.focus()) : (j.preventDefault(), j.stopPropagation(), s.popoverState === 1 && (h == null || h(s.buttonId)), l({ type: 0 }), (F = s.button) == null || F.focus()));
  }), S = ae((j) => {
    j.preventDefault(), j.stopPropagation();
  }), { isFocusVisible: P, focusProps: O } = Z1({ autoFocus: i }), { isHovered: A, hoverProps: L } = X1({ isDisabled: a }), { pressed: I, pressProps: D } = _n({ disabled: a }), U = s.popoverState === 0, z = _e(() => ({ open: U, active: I || U, disabled: a, hover: A, focus: P, autofocus: i }), [U, A, P, I, a, i]), $ = Q2(e, s.button), ee = f1(m ? { ref: _, type: $, onKeyDown: w, onClick: b, disabled: a || void 0, autoFocus: i } : { ref: C, id: s.buttonId, type: $, "aria-expanded": s.popoverState === 0, "aria-controls": s.panel ? s.panelId : void 0, disabled: a || void 0, autoFocus: i, onKeyDown: w, onKeyUp: k, onClick: b, onMouseDown: S }, O, L, D), Z = B4(), G = ae(() => {
    let j = s.panel;
    if (!j)
      return;
    function T() {
      ht(Z.current, { [Pr.Forwards]: () => b1(j, St.First), [Pr.Backwards]: () => b1(j, St.Last) }) === Vr.Error && b1(i9().filter((F) => F.dataset.headlessuiFocusGuard !== "true"), ht(Z.current, { [Pr.Forwards]: St.Next, [Pr.Backwards]: St.Previous }), { relativeTo: s.button });
    }
    T();
  }), W = Ve();
  return M.createElement(M.Fragment, null, W({ ourProps: ee, theirProps: o, slot: z, defaultTag: ZE, name: "Popover.Button" }), U && !m && c && M.createElement(yn, { id: d, ref: s.afterButtonSentinel, features: gn.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: G }));
}
let $E = "div", WE = I1.RenderStrategy | I1.Static;
function yC(e, t) {
  let n = Mt(), { id: r = `headlessui-popover-backdrop-${n}`, transition: a = !1, ...i } = e, [{ popoverState: o }, s] = n8("Popover.Backdrop"), [l, c] = ke(null), u = et(t, c), d = ra(), [p, h] = ti(a, l, d !== null ? (d & Et.Open) === Et.Open : o === 0), m = ae((_) => {
    if (ea(_.currentTarget))
      return _.preventDefault();
    s({ type: 1 });
  }), f = _e(() => ({ open: o === 0 }), [o]), C = { ref: u, id: r, "aria-hidden": !0, onClick: m, ...ei(h) };
  return Ve()({ ourProps: C, theirProps: i, slot: f, defaultTag: $E, features: WE, visible: p, name: "Popover.Backdrop" });
}
let YE = "div", qE = I1.RenderStrategy | I1.Static;
function JE(e, t) {
  let n = Mt(), { id: r = `headlessui-popover-panel-${n}`, focus: a = !1, anchor: i, portal: o = !1, modal: s = !1, transition: l = !1, ...c } = e, [u, d] = n8("Popover.Panel"), { close: p, isPortalled: h } = J4("Popover.Panel"), m = `headlessui-focus-sentinel-before-${n}`, f = `headlessui-focus-sentinel-after-${n}`, C = be(null), _ = G5(i), [v, w] = K5(_), k = Z5();
  _ && (o = !0);
  let [b, S] = ke(null), P = et(C, t, _ ? v : null, ae((j) => d({ type: 4, panel: j })), S), O = Yr(C);
  Je(() => (d({ type: 5, panelId: r }), () => {
    d({ type: 5, panelId: null });
  }), [r, d]);
  let A = ra(), [L, I] = ti(l, b, A !== null ? (A & Et.Open) === Et.Open : u.popoverState === 0);
  a9(L, u.button, () => {
    d({ type: 1 });
  });
  let D = u.__demoMode ? !1 : s && L;
  c9(D, O);
  let U = ae((j) => {
    var T;
    switch (j.key) {
      case Se.Escape:
        if (u.popoverState !== 0 || !C.current || O != null && O.activeElement && !C.current.contains(O.activeElement))
          return;
        j.preventDefault(), j.stopPropagation(), d({ type: 1 }), (T = u.button) == null || T.focus();
        break;
    }
  });
  Re(() => {
    var j;
    e.static || u.popoverState === 1 && ((j = e.unmount) == null || j) && d({ type: 4, panel: null });
  }, [u.popoverState, e.unmount, e.static, d]), Re(() => {
    if (u.__demoMode || !a || u.popoverState !== 0 || !C.current)
      return;
    let j = O == null ? void 0 : O.activeElement;
    C.current.contains(j) || b1(C.current, St.First);
  }, [u.__demoMode, a, C.current, u.popoverState]);
  let z = _e(() => ({ open: u.popoverState === 0, close: p }), [u.popoverState, p]), $ = f1(_ ? k() : {}, { ref: P, id: r, onKeyDown: U, onBlur: a && u.popoverState === 0 ? (j) => {
    var T, F, N, Y, Q;
    let V = j.relatedTarget;
    V && C.current && ((T = C.current) != null && T.contains(V) || (d({ type: 1 }), ((N = (F = u.beforePanelSentinel.current) == null ? void 0 : F.contains) != null && N.call(F, V) || (Q = (Y = u.afterPanelSentinel.current) == null ? void 0 : Y.contains) != null && Q.call(Y, V)) && V.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1, style: { ...c.style, ...w, "--button-width": Ss(u.button, !0).width }, ...ei(I) }), ee = B4(), Z = ae(() => {
    let j = C.current;
    if (!j)
      return;
    function T() {
      ht(ee.current, { [Pr.Forwards]: () => {
        var F;
        b1(j, St.First) === Vr.Error && ((F = u.afterPanelSentinel.current) == null || F.focus());
      }, [Pr.Backwards]: () => {
        var F;
        (F = u.button) == null || F.focus({ preventScroll: !0 });
      } });
    }
    T();
  }), G = ae(() => {
    let j = C.current;
    if (!j)
      return;
    function T() {
      ht(ee.current, { [Pr.Forwards]: () => {
        if (!u.button)
          return;
        let F = i9(), N = F.indexOf(u.button), Y = F.slice(0, N + 1), Q = [...F.slice(N + 1), ...Y];
        for (let V of Q.slice())
          if (V.dataset.headlessuiFocusGuard === "true" || b != null && b.contains(V)) {
            let re = Q.indexOf(V);
            re !== -1 && Q.splice(re, 1);
          }
        b1(Q, St.First, { sorted: !1 });
      }, [Pr.Backwards]: () => {
        var F;
        b1(j, St.Previous) === Vr.Error && ((F = u.button) == null || F.focus());
      } });
    }
    T();
  }), W = Ve();
  return M.createElement(D4, null, M.createElement(i8.Provider, { value: r }, M.createElement(a8.Provider, { value: { close: p, isPortalled: h } }, M.createElement(h9, { enabled: o ? e.static || L : !1 }, L && h && M.createElement(yn, { id: m, ref: u.beforePanelSentinel, features: gn.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: Z }), W({ ourProps: $, theirProps: c, slot: z, defaultTag: YE, features: qE, visible: L, name: "Popover.Panel" }), L && h && M.createElement(yn, { id: f, ref: u.afterPanelSentinel, features: gn.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: G })))));
}
let XE = "div";
function QE(e, t) {
  let n = be(null), r = et(n, t), [a, i] = ke([]), o = ae((f) => {
    i((C) => {
      let _ = C.indexOf(f);
      if (_ !== -1) {
        let v = C.slice();
        return v.splice(_, 1), v;
      }
      return C;
    });
  }), s = ae((f) => (i((C) => [...C, f]), () => o(f))), l = ae(() => {
    var f;
    let C = $r(n);
    if (!C)
      return !1;
    let _ = C.activeElement;
    return (f = n.current) != null && f.contains(_) ? !0 : a.some((v) => {
      var w, k;
      return ((w = C.getElementById(v.buttonId.current)) == null ? void 0 : w.contains(_)) || ((k = C.getElementById(v.panelId.current)) == null ? void 0 : k.contains(_));
    });
  }), c = ae((f) => {
    for (let C of a)
      C.buttonId.current !== f && C.close();
  }), u = _e(() => ({ registerPopover: s, unregisterPopover: o, isFocusWithinPopoverGroup: l, closeOthers: c }), [s, o, l, c]), d = _e(() => ({}), []), p = e, h = { ref: r }, m = Ve();
  return M.createElement(H6, null, M.createElement(X4.Provider, { value: u }, m({ ourProps: h, theirProps: p, slot: d, defaultTag: XE, name: "Popover.Group" })));
}
let eT = De(UE), tT = De(KE), rT = De(yC), nT = De(yC), aT = De(JE), iT = De(QE);
Object.assign(eT, { Button: tT, Backdrop: nT, Overlay: rT, Panel: aT, Group: iT });
var oT = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(oT || {});
let sT = { 0(e, t) {
  let n = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: In(n, (r) => r.element.current) };
}, 1(e, t) {
  let n = e.options.slice(), r = e.options.findIndex((a) => a.id === t.id);
  return r === -1 ? e : (n.splice(r, 1), { ...e, options: n });
} }, Q4 = Qe(null);
Q4.displayName = "RadioGroupDataContext";
function e3(e) {
  let t = Ue(Q4);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, e3), n;
  }
  return t;
}
let t3 = Qe(null);
t3.displayName = "RadioGroupActionsContext";
function r3(e) {
  let t = Ue(t3);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, r3), n;
  }
  return t;
}
function lT(e, t) {
  return ht(t.type, sT, e, t);
}
let cT = "div";
function uT(e, t) {
  let n = Mt(), r = _r(), { id: a = `headlessui-radiogroup-${n}`, value: i, form: o, name: s, onChange: l, by: c, disabled: u = r || !1, defaultValue: d, ...p } = e, h = L4(c), [m, f] = Ca(lT, { options: [] }), C = m.options, [_, v] = va(), [w, k] = Xi(), b = be(null), S = et(b, t), P = t9(d), [O, A] = e9(i, l, P), L = _e(() => C.find((T) => !T.propsRef.current.disabled), [C]), I = _e(() => C.some((T) => h(T.propsRef.current.value, O)), [C, O]), D = ae((T) => {
    var F;
    if (u || h(T, O))
      return !1;
    let N = (F = C.find((Y) => h(Y.propsRef.current.value, T))) == null ? void 0 : F.propsRef.current;
    return N != null && N.disabled ? !1 : (A == null || A(T), !0);
  }), U = ae((T) => {
    let F = b.current;
    if (!F)
      return;
    let N = $r(F), Y = C.filter((Q) => Q.propsRef.current.disabled === !1).map((Q) => Q.element.current);
    switch (T.key) {
      case Se.Enter:
        N5(T.currentTarget);
        break;
      case Se.ArrowLeft:
      case Se.ArrowUp:
        if (T.preventDefault(), T.stopPropagation(), b1(Y, St.Previous | St.WrapAround) === Vr.Success) {
          let Q = C.find((V) => V.element.current === (N == null ? void 0 : N.activeElement));
          Q && D(Q.propsRef.current.value);
        }
        break;
      case Se.ArrowRight:
      case Se.ArrowDown:
        if (T.preventDefault(), T.stopPropagation(), b1(Y, St.Next | St.WrapAround) === Vr.Success) {
          let Q = C.find((V) => V.element.current === (N == null ? void 0 : N.activeElement));
          Q && D(Q.propsRef.current.value);
        }
        break;
      case Se.Space:
        {
          T.preventDefault(), T.stopPropagation();
          let Q = C.find((V) => V.element.current === (N == null ? void 0 : N.activeElement));
          Q && D(Q.propsRef.current.value);
        }
        break;
    }
  }), z = ae((T) => (f({ type: 0, ...T }), () => f({ type: 1, id: T.id }))), $ = _e(() => ({ value: O, firstOption: L, containsCheckedOption: I, disabled: u, compare: h, ...m }), [O, L, I, u, h, m]), ee = _e(() => ({ registerOption: z, change: D }), [z, D]), Z = { ref: S, id: a, role: "radiogroup", "aria-labelledby": _, "aria-describedby": w, onKeyDown: U }, G = _e(() => ({ value: O }), [O]), W = ft(() => {
    if (P !== void 0)
      return D(P);
  }, [D, P]), j = Ve();
  return M.createElement(k, { name: "RadioGroup.Description" }, M.createElement(v, { name: "RadioGroup.Label" }, M.createElement(t3.Provider, { value: ee }, M.createElement(Q4.Provider, { value: $ }, s != null && M.createElement(r9, { disabled: u, data: { [s]: O || "on" }, overrides: { type: "radio", checked: O != null }, form: o, onReset: W }), j({ ourProps: Z, theirProps: p, slot: G, defaultTag: cT, name: "RadioGroup" })))));
}
let dT = "div";
function pT(e, t) {
  var n;
  let r = e3("RadioGroup.Option"), a = r3("RadioGroup.Option"), i = Mt(), { id: o = `headlessui-radiogroup-option-${i}`, value: s, disabled: l = r.disabled || !1, autoFocus: c = !1, ...u } = e, d = be(null), p = et(d, t), [h, m] = va(), [f, C] = Xi(), _ = G1({ value: s, disabled: l });
  Je(() => a.registerOption({ id: o, element: d, propsRef: _ }), [o, a, d, _]);
  let v = ae((D) => {
    var U;
    if (ea(D.currentTarget))
      return D.preventDefault();
    a.change(s) && ((U = d.current) == null || U.focus());
  }), w = ((n = r.firstOption) == null ? void 0 : n.id) === o, { isFocusVisible: k, focusProps: b } = Z1({ autoFocus: c }), { isHovered: S, hoverProps: P } = X1({ isDisabled: l }), O = r.compare(r.value, s), A = f1({ ref: p, id: o, role: "radio", "aria-checked": O ? "true" : "false", "aria-labelledby": h, "aria-describedby": f, "aria-disabled": l ? !0 : void 0, tabIndex: l ? -1 : O || !r.containsCheckedOption && w ? 0 : -1, onClick: l ? void 0 : v, autoFocus: c }, b, P), L = _e(() => ({ checked: O, disabled: l, active: k, hover: S, focus: k, autofocus: c }), [O, l, S, k, c]), I = Ve();
  return M.createElement(C, { name: "RadioGroup.Description" }, M.createElement(m, { name: "RadioGroup.Label" }, I({ ourProps: A, theirProps: u, slot: L, defaultTag: dT, name: "RadioGroup.Option" })));
}
let hT = "span";
function mT(e, t) {
  var n;
  let r = e3("Radio"), a = r3("Radio"), i = Mt(), o = ya(), s = _r(), { id: l = o || `headlessui-radio-${i}`, value: c, disabled: u = r.disabled || s || !1, autoFocus: d = !1, ...p } = e, h = be(null), m = et(h, t), f = wn(), C = qa(), _ = G1({ value: c, disabled: u });
  Je(() => a.registerOption({ id: l, element: h, propsRef: _ }), [l, a, h, _]);
  let v = ae((I) => {
    var D;
    if (ea(I.currentTarget))
      return I.preventDefault();
    a.change(c) && ((D = h.current) == null || D.focus());
  }), { isFocusVisible: w, focusProps: k } = Z1({ autoFocus: d }), { isHovered: b, hoverProps: S } = X1({ isDisabled: u }), P = ((n = r.firstOption) == null ? void 0 : n.id) === l, O = r.compare(r.value, c), A = f1({ ref: m, id: l, role: "radio", "aria-checked": O ? "true" : "false", "aria-labelledby": f, "aria-describedby": C, "aria-disabled": u ? !0 : void 0, tabIndex: u ? -1 : O || !r.containsCheckedOption && P ? 0 : -1, autoFocus: d, onClick: u ? void 0 : v }, k, S), L = _e(() => ({ checked: O, disabled: u, hover: b, focus: w, autofocus: d }), [O, u, b, w, d]);
  return Ve()({ ourProps: A, theirProps: p, slot: L, defaultTag: hT, name: "Radio" });
}
let fT = De(uT), CT = De(pT), gT = De(mT), yT = n9, vT = P4;
Object.assign(fT, { Option: CT, Radio: gT, Label: yT, Description: vT });
let bT = "select";
function _T(e, t) {
  let n = Mt(), r = ya(), a = _r(), { id: i = r || `headlessui-select-${n}`, disabled: o = a || !1, invalid: s = !1, autoFocus: l = !1, ...c } = e, u = wn(), d = qa(), { isFocusVisible: p, focusProps: h } = Z1({ autoFocus: l }), { isHovered: m, hoverProps: f } = X1({ isDisabled: o }), { pressed: C, pressProps: _ } = _n({ disabled: o }), v = f1({ ref: t, id: i, "aria-labelledby": u, "aria-describedby": d, "aria-invalid": s ? "" : void 0, disabled: o || void 0, autoFocus: l }, h, f, _), w = _e(() => ({ disabled: o, invalid: s, hover: m, focus: p, active: C, autofocus: l }), [o, s, m, p, C, l]);
  return Ve()({ ourProps: v, theirProps: c, slot: w, defaultTag: bT, name: "Select" });
}
De(_T);
let n3 = Qe(null);
n3.displayName = "GroupContext";
let wT = n1;
function xT(e) {
  var t;
  let [n, r] = ke(null), [a, i] = va(), [o, s] = Xi(), l = _e(() => ({ switch: n, setSwitch: r }), [n, r]), c = {}, u = e, d = Ve();
  return M.createElement(s, { name: "Switch.Description", value: o }, M.createElement(i, { name: "Switch.Label", value: a, props: { htmlFor: (t = l.switch) == null ? void 0 : t.id, onClick(p) {
    n && (p.currentTarget instanceof HTMLLabelElement && p.preventDefault(), n.click(), n.focus({ preventScroll: !0 }));
  } } }, M.createElement(n3.Provider, { value: l }, d({ ourProps: c, theirProps: u, slot: {}, defaultTag: wT, name: "Switch.Group" }))));
}
let ST = "button";
function kT(e, t) {
  var n;
  let r = Mt(), a = ya(), i = _r(), { id: o = a || `headlessui-switch-${r}`, disabled: s = i || !1, checked: l, defaultChecked: c, onChange: u, name: d, value: p, form: h, autoFocus: m = !1, ...f } = e, C = Ue(n3), [_, v] = ke(null), w = be(null), k = et(w, t, C === null ? null : C.setSwitch, v), b = t9(c), [S, P] = e9(l, u, b ?? !1), O = Wr(), [A, L] = ke(!1), I = ae(() => {
    L(!0), P == null || P(!S), O.nextFrame(() => {
      L(!1);
    });
  }), D = ae((re) => {
    if (ea(re.currentTarget))
      return re.preventDefault();
    re.preventDefault(), I();
  }), U = ae((re) => {
    re.key === Se.Space ? (re.preventDefault(), I()) : re.key === Se.Enter && N5(re.currentTarget);
  }), z = ae((re) => re.preventDefault()), $ = wn(), ee = qa(), { isFocusVisible: Z, focusProps: G } = Z1({ autoFocus: m }), { isHovered: W, hoverProps: j } = X1({ isDisabled: s }), { pressed: T, pressProps: F } = _n({ disabled: s }), N = _e(() => ({ checked: S, disabled: s, hover: W, focus: Z, active: T, autofocus: m, changing: A }), [S, W, Z, T, s, A, m]), Y = f1({ id: o, ref: k, role: "switch", type: Q2(e, _), tabIndex: e.tabIndex === -1 ? 0 : (n = e.tabIndex) != null ? n : 0, "aria-checked": S, "aria-labelledby": $, "aria-describedby": ee, disabled: s || void 0, autoFocus: m, onClick: D, onKeyUp: U, onKeyPress: z }, G, j, F), Q = ft(() => {
    if (b !== void 0)
      return P == null ? void 0 : P(b);
  }, [P, b]), V = Ve();
  return M.createElement(M.Fragment, null, d != null && M.createElement(r9, { disabled: s, data: { [d]: p || "on" }, overrides: { type: "checkbox", checked: S }, form: h, onReset: Q }), V({ ourProps: Y, theirProps: f, slot: N, defaultTag: ST, name: "Switch" }));
}
let MT = De(kT), PT = xT, ET = n9, TT = P4;
Object.assign(MT, { Group: PT, Label: ET, Description: TT });
function LT({ onFocus: e }) {
  let [t, n] = ke(!0), r = Y5();
  return t ? M.createElement(yn, { as: "button", type: "button", features: gn.Focusable, onFocus: (a) => {
    a.preventDefault();
    let i, o = 50;
    function s() {
      if (o-- <= 0) {
        i && cancelAnimationFrame(i);
        return;
      }
      if (e()) {
        if (cancelAnimationFrame(i), !r.current)
          return;
        n(!1);
        return;
      }
      i = requestAnimationFrame(s);
    }
    i = requestAnimationFrame(s);
  } }) : null;
}
const vC = pe.createContext(null);
function AT() {
  return { groups: /* @__PURE__ */ new Map(), get(e, t) {
    var n;
    let r = this.groups.get(e);
    r || (r = /* @__PURE__ */ new Map(), this.groups.set(e, r));
    let a = (n = r.get(t)) != null ? n : 0;
    r.set(t, a + 1);
    let i = Array.from(r.keys()).indexOf(t);
    function o() {
      let s = r.get(t);
      s > 1 ? r.set(t, s - 1) : r.delete(t);
    }
    return [i, o];
  } };
}
function OT({ children: e }) {
  let t = pe.useRef(AT());
  return pe.createElement(vC.Provider, { value: t }, e);
}
function bC(e) {
  let t = pe.useContext(vC);
  if (!t)
    throw new Error("You must wrap your component in a <StableCollection>");
  let n = pe.useId(), [r, a] = t.current.get(e, n);
  return pe.useEffect(() => a, []), r;
}
var NT = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(NT || {}), jT = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(jT || {}), RT = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(RT || {});
let DT = { 0(e, t) {
  var n;
  let r = In(e.tabs, (u) => u.current), a = In(e.panels, (u) => u.current), i = r.filter((u) => {
    var d;
    return !((d = u.current) != null && d.hasAttribute("disabled"));
  }), o = { ...e, tabs: r, panels: a };
  if (t.index < 0 || t.index > r.length - 1) {
    let u = ht(Math.sign(t.index - e.selectedIndex), { [-1]: () => 1, 0: () => ht(Math.sign(t.index), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 });
    if (i.length === 0)
      return o;
    let d = ht(u, { 0: () => r.indexOf(i[0]), 1: () => r.indexOf(i[i.length - 1]) });
    return { ...o, selectedIndex: d === -1 ? e.selectedIndex : d };
  }
  let s = r.slice(0, t.index), l = [...r.slice(t.index), ...s].find((u) => i.includes(u));
  if (!l)
    return o;
  let c = (n = r.indexOf(l)) != null ? n : e.selectedIndex;
  return c === -1 && (c = e.selectedIndex), { ...o, selectedIndex: c };
}, 1(e, t) {
  if (e.tabs.includes(t.tab))
    return e;
  let n = e.tabs[e.selectedIndex], r = In([...e.tabs, t.tab], (i) => i.current), a = e.selectedIndex;
  return e.info.current.isControlled || (a = r.indexOf(n), a === -1 && (a = e.selectedIndex)), { ...e, tabs: r, selectedIndex: a };
}, 2(e, t) {
  return { ...e, tabs: e.tabs.filter((n) => n !== t.tab) };
}, 3(e, t) {
  return e.panels.includes(t.panel) ? e : { ...e, panels: In([...e.panels, t.panel], (n) => n.current) };
}, 4(e, t) {
  return { ...e, panels: e.panels.filter((n) => n !== t.panel) };
} }, a3 = Qe(null);
a3.displayName = "TabsDataContext";
function Ii(e) {
  let t = Ue(a3);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Ii), n;
  }
  return t;
}
let i3 = Qe(null);
i3.displayName = "TabsActionsContext";
function o3(e) {
  let t = Ue(i3);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, o3), n;
  }
  return t;
}
function IT(e, t) {
  return ht(t.type, DT, e, t);
}
let HT = "div";
function FT(e, t) {
  let { defaultIndex: n = 0, vertical: r = !1, manual: a = !1, onChange: i, selectedIndex: o = null, ...s } = e;
  const l = r ? "vertical" : "horizontal", c = a ? "manual" : "auto";
  let u = o !== null, d = G1({ isControlled: u }), p = et(t), [h, m] = Ca(IT, { info: d, selectedIndex: o ?? n, tabs: [], panels: [] }), f = _e(() => ({ selectedIndex: h.selectedIndex }), [h.selectedIndex]), C = G1(i || (() => {
  })), _ = G1(h.tabs), v = _e(() => ({ orientation: l, activation: c, ...h }), [l, c, h]), w = ae((L) => (m({ type: 1, tab: L }), () => m({ type: 2, tab: L }))), k = ae((L) => (m({ type: 3, panel: L }), () => m({ type: 4, panel: L }))), b = ae((L) => {
    S.current !== L && C.current(L), u || m({ type: 0, index: L });
  }), S = G1(u ? e.selectedIndex : h.selectedIndex), P = _e(() => ({ registerTab: w, registerPanel: k, change: b }), []);
  Je(() => {
    m({ type: 0, index: o ?? n });
  }, [o]), Je(() => {
    if (S.current === void 0 || h.tabs.length <= 0)
      return;
    let L = In(h.tabs, (I) => I.current);
    L.some((I, D) => h.tabs[D] !== I) && b(L.indexOf(h.tabs[S.current]));
  });
  let O = { ref: p }, A = Ve();
  return M.createElement(OT, null, M.createElement(i3.Provider, { value: P }, M.createElement(a3.Provider, { value: v }, v.tabs.length <= 0 && M.createElement(LT, { onFocus: () => {
    var L, I;
    for (let D of _.current)
      if (((L = D.current) == null ? void 0 : L.tabIndex) === 0)
        return (I = D.current) == null || I.focus(), !0;
    return !1;
  } }), A({ ourProps: O, theirProps: s, slot: f, defaultTag: HT, name: "Tabs" }))));
}
let VT = "div";
function BT(e, t) {
  let { orientation: n, selectedIndex: r } = Ii("Tab.List"), a = et(t), i = _e(() => ({ selectedIndex: r }), [r]), o = e, s = { ref: a, role: "tablist", "aria-orientation": n };
  return Ve()({ ourProps: s, theirProps: o, slot: i, defaultTag: VT, name: "Tabs.List" });
}
let zT = "button";
function GT(e, t) {
  var n, r;
  let a = Mt(), { id: i = `headlessui-tabs-tab-${a}`, disabled: o = !1, autoFocus: s = !1, ...l } = e, { orientation: c, activation: u, selectedIndex: d, tabs: p, panels: h } = Ii("Tab"), m = o3("Tab"), f = Ii("Tab"), [C, _] = ke(null), v = be(null), w = et(v, t, _);
  Je(() => m.registerTab(v), [m, v]);
  let k = bC("tabs"), b = p.indexOf(v);
  b === -1 && (b = k);
  let S = b === d, P = ae((j) => {
    var T;
    let F = j();
    if (F === Vr.Success && u === "auto") {
      let N = (T = $r(v)) == null ? void 0 : T.activeElement, Y = f.tabs.findIndex((Q) => Q.current === N);
      Y !== -1 && m.change(Y);
    }
    return F;
  }), O = ae((j) => {
    let T = p.map((F) => F.current).filter(Boolean);
    if (j.key === Se.Space || j.key === Se.Enter) {
      j.preventDefault(), j.stopPropagation(), m.change(b);
      return;
    }
    switch (j.key) {
      case Se.Home:
      case Se.PageUp:
        return j.preventDefault(), j.stopPropagation(), P(() => b1(T, St.First));
      case Se.End:
      case Se.PageDown:
        return j.preventDefault(), j.stopPropagation(), P(() => b1(T, St.Last));
    }
    if (P(() => ht(c, { vertical() {
      return j.key === Se.ArrowUp ? b1(T, St.Previous | St.WrapAround) : j.key === Se.ArrowDown ? b1(T, St.Next | St.WrapAround) : Vr.Error;
    }, horizontal() {
      return j.key === Se.ArrowLeft ? b1(T, St.Previous | St.WrapAround) : j.key === Se.ArrowRight ? b1(T, St.Next | St.WrapAround) : Vr.Error;
    } })) === Vr.Success)
      return j.preventDefault();
  }), A = be(!1), L = ae(() => {
    var j;
    A.current || (A.current = !0, (j = v.current) == null || j.focus({ preventScroll: !0 }), m.change(b), Qs(() => {
      A.current = !1;
    }));
  }), I = ae((j) => {
    j.preventDefault();
  }), { isFocusVisible: D, focusProps: U } = Z1({ autoFocus: s }), { isHovered: z, hoverProps: $ } = X1({ isDisabled: o }), { pressed: ee, pressProps: Z } = _n({ disabled: o }), G = _e(() => ({ selected: S, hover: z, active: ee, focus: D, autofocus: s, disabled: o }), [S, z, D, ee, s, o]), W = f1({ ref: w, onKeyDown: O, onMouseDown: I, onClick: L, id: i, role: "tab", type: Q2(e, C), "aria-controls": (r = (n = h[b]) == null ? void 0 : n.current) == null ? void 0 : r.id, "aria-selected": S, tabIndex: S ? 0 : -1, disabled: o || void 0, autoFocus: s }, U, $, Z);
  return Ve()({ ourProps: W, theirProps: l, slot: G, defaultTag: zT, name: "Tabs.Tab" });
}
let UT = "div";
function ZT(e, t) {
  let { selectedIndex: n } = Ii("Tab.Panels"), r = et(t), a = _e(() => ({ selectedIndex: n }), [n]), i = e, o = { ref: r };
  return Ve()({ ourProps: o, theirProps: i, slot: a, defaultTag: UT, name: "Tabs.Panels" });
}
let KT = "div", $T = I1.RenderStrategy | I1.Static;
function WT(e, t) {
  var n, r, a, i;
  let o = Mt(), { id: s = `headlessui-tabs-panel-${o}`, tabIndex: l = 0, ...c } = e, { selectedIndex: u, tabs: d, panels: p } = Ii("Tab.Panel"), h = o3("Tab.Panel"), m = be(null), f = et(m, t);
  Je(() => h.registerPanel(m), [h, m]);
  let C = bC("panels"), _ = p.indexOf(m);
  _ === -1 && (_ = C);
  let v = _ === u, { isFocusVisible: w, focusProps: k } = Z1(), b = _e(() => ({ selected: v, focus: w }), [v, w]), S = f1({ ref: f, id: s, role: "tabpanel", "aria-labelledby": (r = (n = d[_]) == null ? void 0 : n.current) == null ? void 0 : r.id, tabIndex: v ? l : -1 }, k), P = Ve();
  return !v && ((a = c.unmount) == null || a) && !((i = c.static) != null && i) ? M.createElement(yn, { "aria-hidden": "true", ...S }) : P({ ourProps: S, theirProps: c, slot: b, defaultTag: KT, features: $T, visible: v, name: "Tabs.Panel" });
}
let YT = De(GT), qT = De(FT), JT = De(BT), XT = De(ZT), QT = De(WT);
Object.assign(YT, { Group: qT, List: JT, Panels: XT, Panel: QT });
let eL = "textarea";
function tL(e, t) {
  let n = Mt(), r = ya(), a = _r(), { id: i = r || `headlessui-textarea-${n}`, disabled: o = a || !1, autoFocus: s = !1, invalid: l = !1, ...c } = e, u = wn(), d = qa(), { isFocused: p, focusProps: h } = Z1({ autoFocus: s }), { isHovered: m, hoverProps: f } = X1({ isDisabled: o }), C = f1({ ref: t, id: i, "aria-labelledby": u, "aria-describedby": d, "aria-invalid": l ? "" : void 0, disabled: o || void 0, autoFocus: s }, h, f), _ = _e(() => ({ disabled: o, invalid: l, hover: m, focus: p, autofocus: s }), [o, l, m, p, s]);
  return Ve()({ ourProps: C, theirProps: c, slot: _, defaultTag: eL, name: "Textarea" });
}
De(tL);
const s3 = "-", rL = (e) => {
  const t = aL(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const i = a.split(s3);
      return i[0] === "" && i.length !== 1 && i.shift(), _C(i, t) || nL(a);
    },
    getConflictingClassGroupIds: (a, i) => {
      const o = n[a] || [];
      return i && r[a] ? [...o, ...r[a]] : o;
    }
  };
}, _C = (e, t) => {
  var n;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], a = t.nextPart.get(r), i = a ? _C(e.slice(1), a) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(s3);
  return (n = t.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : n.classGroupId;
}, lu = /^\[(.+)\]$/, nL = (e) => {
  if (lu.test(e)) {
    const t = lu.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, aL = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return oL(Object.entries(e.classGroups), n).forEach(([a, i]) => {
    A0(i, r, a, t);
  }), r;
}, A0 = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? t : cu(t, a);
      i.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (iL(a)) {
        A0(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      A0(o, cu(t, i), n, r);
    });
  });
}, cu = (e, t) => {
  let n = e;
  return t.split(s3).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, iL = (e) => e.isThemeGetter, oL = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, s]) => [t + o, s])) : i);
  return [n, a];
}) : e, sL = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (i, o) => {
    n.set(i, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = n.get(i);
      if (o !== void 0)
        return o;
      if ((o = r.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      n.has(i) ? n.set(i, o) : a(i, o);
    }
  };
}, wC = "!", lL = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], i = t.length, o = (s) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let C = 0; C < s.length; C++) {
      let _ = s[C];
      if (c === 0) {
        if (_ === a && (r || s.slice(C, C + i) === t)) {
          l.push(s.slice(u, C)), u = C + i;
          continue;
        }
        if (_ === "/") {
          d = C;
          continue;
        }
      }
      _ === "[" ? c++ : _ === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(u), h = p.startsWith(wC), m = h ? p.substring(1) : p, f = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: f
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: o
  }) : o;
}, cL = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, uL = (e) => ({
  cache: sL(e.cacheSize),
  parseClassName: lL(e),
  ...rL(e)
}), dL = /\s+/, pL = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, i = [], o = e.trim().split(dL);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const c = o[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(c);
    let m = !!h, f = r(m ? p.substring(0, h) : p);
    if (!f) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (f = r(p), !f) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const C = cL(u).join(":"), _ = d ? C + wC : C, v = _ + f;
    if (i.includes(v))
      continue;
    i.push(v);
    const w = a(f, m);
    for (let k = 0; k < w.length; ++k) {
      const b = w[k];
      i.push(_ + b);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function F6() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = xC(t)) && (r && (r += " "), r += n);
  return r;
}
const xC = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = xC(e[r])) && (n && (n += " "), n += t);
  return n;
};
function hL(e, ...t) {
  let n, r, a, i = o;
  function o(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = uL(c), r = n.cache.get, a = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = pL(l, n);
    return a(l, u), u;
  }
  return function() {
    return i(F6.apply(null, arguments));
  };
}
const e1 = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, SC = /^\[(?:([a-z-]+):)?(.+)\]$/i, mL = /^\d+\/\d+$/, fL = /* @__PURE__ */ new Set(["px", "full", "screen"]), CL = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, gL = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, yL = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, vL = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, bL = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, na = (e) => Ei(e) || fL.has(e) || mL.test(e), _a = (e) => io(e, "length", EL), Ei = (e) => !!e && !Number.isNaN(Number(e)), l7 = (e) => io(e, "number", Ei), Mo = (e) => !!e && Number.isInteger(Number(e)), _L = (e) => e.endsWith("%") && Ei(e.slice(0, -1)), at = (e) => SC.test(e), wa = (e) => CL.test(e), wL = /* @__PURE__ */ new Set(["length", "size", "percentage"]), xL = (e) => io(e, wL, kC), SL = (e) => io(e, "position", kC), kL = /* @__PURE__ */ new Set(["image", "url"]), ML = (e) => io(e, kL, LL), PL = (e) => io(e, "", TL), Po = () => !0, io = (e, t, n) => {
  const r = SC.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, EL = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  gL.test(e) && !yL.test(e)
), kC = () => !1, TL = (e) => vL.test(e), LL = (e) => bL.test(e), AL = () => {
  const e = e1("colors"), t = e1("spacing"), n = e1("blur"), r = e1("brightness"), a = e1("borderColor"), i = e1("borderRadius"), o = e1("borderSpacing"), s = e1("borderWidth"), l = e1("contrast"), c = e1("grayscale"), u = e1("hueRotate"), d = e1("invert"), p = e1("gap"), h = e1("gradientColorStops"), m = e1("gradientColorStopPositions"), f = e1("inset"), C = e1("margin"), _ = e1("opacity"), v = e1("padding"), w = e1("saturate"), k = e1("scale"), b = e1("sepia"), S = e1("skew"), P = e1("space"), O = e1("translate"), A = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", at, t], D = () => [at, t], U = () => ["", na, _a], z = () => ["auto", Ei, at], $ = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ee = () => ["solid", "dashed", "dotted", "double", "none"], Z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], W = () => ["", "0", at], j = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [Ei, at];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Po],
      spacing: [na, _a],
      blur: ["none", "", wa, at],
      brightness: T(),
      borderColor: [e],
      borderRadius: ["none", "", "full", wa, at],
      borderSpacing: D(),
      borderWidth: U(),
      contrast: T(),
      grayscale: W(),
      hueRotate: T(),
      invert: W(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [_L, _a],
      inset: I(),
      margin: I(),
      opacity: T(),
      padding: D(),
      saturate: T(),
      scale: T(),
      sepia: W(),
      skew: T(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", at]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [wa]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": j()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": j()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...$(), at]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: A()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": A()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": A()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Mo, at]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", at]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: W()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: W()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Mo, at]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Po]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Mo, at]
        }, at]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": z()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": z()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Po]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Mo, at]
        }, at]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": z()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": z()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", at]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", at]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...G()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...G(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...G(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [C]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [C]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [C]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [C]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [C]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [C]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [C]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [C]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [C]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", at, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [at, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [at, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [wa]
        }, wa]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [at, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [at, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [at, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [at, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", wa, _a]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", l7]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Po]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", at]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Ei, l7]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", na, at]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", at]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", at]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ee(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", na, _a]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", na, at]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", at]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", at]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...$(), SL]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", xL]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, ML]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ee(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ee()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ee()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [na, at]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [na, _a]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: U()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [na, _a]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", wa, PL]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Po]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", wa, at]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [b]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [b]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", at]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: T()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", at]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: T()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", at]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [k]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [k]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [k]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Mo, at]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", at]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", at]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", at]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [na, _a, l7]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Fe = /* @__PURE__ */ hL(AL);
function l3(e) {
  return /* @__PURE__ */ y.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", width: "19", height: "16", ...e, children: /* @__PURE__ */ y.jsx("path", { d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" }) });
}
var MC = /* @__PURE__ */ ((e) => (e.small = "small", e.medium = "medium", e.big = "big", e))(MC || {});
function PC({
  opened: e,
  onClose: t,
  children: n,
  title: r,
  size: a = "small",
  isFetching: i,
  afterLeave: o,
  afterEnter: s,
  className: l,
  contentClassName: c,
  isCentered: u,
  dialogClassName: d,
  backdropClassName: p,
  dialogContentClassName: h,
  dialogContentWrapperClassName: m,
  dialogContentWrapper1ClassName: f,
  titleClassName: C,
  closeIconWrapperClassName: _,
  closeIconClassName: v,
  ...w
}) {
  return /* @__PURE__ */ y.jsx(i6.Root, { afterEnter: s, show: e, as: n1, children: /* @__PURE__ */ y.jsxs(
    nu,
    {
      className: Fe("relative z-10", d),
      onClose: i ? () => {
      } : t,
      children: [
        /* @__PURE__ */ y.jsx(
          i6.Child,
          {
            as: n1,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ y.jsx(
              "div",
              {
                className: Fe(
                  "fixed inset-0 bg-[#000000]/20 transition-opacity",
                  p
                )
              }
            )
          }
        ),
        /* @__PURE__ */ y.jsx(
          "div",
          {
            className: Fe("fixed inset-0 z-10 overflow-y-auto", m),
            children: /* @__PURE__ */ y.jsx(
              "div",
              {
                id: "modal-background",
                className: Fe(
                  "flex min-h-full w-full items-end justify-center text-center sm:items-center sm:p-0 lg:p-4",
                  f
                ),
                children: /* @__PURE__ */ y.jsx(
                  i6.Child,
                  {
                    as: n1,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    enterTo: "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
                    leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    afterLeave: o,
                    children: /* @__PURE__ */ y.jsxs(
                      nu.Panel,
                      {
                        className: Fe(
                          "relative w-full",
                          a === "small" ? "max-w-2xl" : a === "medium" ? "max-w-4xl" : "max-w-7xl",
                          "bg-background-secondary transform rounded-lg text-left shadow-xl transition-all sm:my-8",
                          l
                        ),
                        ...w,
                        children: [
                          /* @__PURE__ */ y.jsxs(
                            "div",
                            {
                              className: Fe(
                                "flex w-full items-start p-6 lg:p-10 lg:pb-0",
                                u ? "justify-center" : "justify-between",
                                h
                              ),
                              children: [
                                /* @__PURE__ */ y.jsx("h3", { className: Fe(u ? "px-6 lg:px-10" : "", C), children: r }),
                                /* @__PURE__ */ y.jsx(
                                  "button",
                                  {
                                    className: Fe(
                                      "focus-ring rounded-full",
                                      u && "absolute right-6 top-6 lg:right-10 lg:top-10",
                                      _
                                    ),
                                    disabled: i,
                                    onClick: t,
                                    children: /* @__PURE__ */ y.jsx(
                                      l3,
                                      {
                                        className: Fe(
                                          "cursor-pointer",
                                          i && "fill-text-secondary pointer-events-none",
                                          v
                                        )
                                      }
                                    )
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ y.jsx(
                            "div",
                            {
                              className: Fe(
                                "bg-background-secondary rounded-lg p-6 lg:p-10",
                                c
                              ),
                              children: n
                            }
                          )
                        ]
                      }
                    )
                  }
                )
              }
            )
          }
        )
      ]
    }
  ) });
}
const V6 = ({ small: e = !1, type: t = "light", className: n, style: r }) => /* @__PURE__ */ y.jsxs("div", { role: "status", className: n, style: r, children: [
  /* @__PURE__ */ y.jsxs(
    "svg",
    {
      "aria-hidden": "true",
      className: `${e ? "h-5 w-5" : "h-8 w-8"} animate-spin ${t === "light" ? "fill-brand-primary text-background-secondary" : "fill-background-secondary text-text-primary"}`,
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ y.jsx("span", { className: "sr-only", children: "Loading..." })
] }), OL = (e) => /* @__PURE__ */ y.jsxs(
  "svg",
  {
    version: "1.1",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 210.2",
    ...e,
    children: [
      /* @__PURE__ */ y.jsx(
        "path",
        {
          id: "XMLID_34_",
          d: `M93.6,27.1C87.6,34.2,78,39.8,68.4,39c-1.2-9.6,3.5-19.8,9-26.1c6-7.3,16.5-12.5,25-12.9
	C103.4,10,99.5,19.8,93.6,27.1 M102.3,40.9c-13.9-0.8-25.8,7.9-32.4,7.9c-6.7,0-16.8-7.5-27.8-7.3c-14.3,0.2-27.6,8.3-34.9,21.2
	c-15,25.8-3.9,64,10.6,85c7.1,10.4,15.6,21.8,26.8,21.4c10.6-0.4,14.8-6.9,27.6-6.9c12.9,0,16.6,6.9,27.8,6.7
	c11.6-0.2,18.9-10.4,26-20.8c8.1-11.8,11.4-23.3,11.6-23.9c-0.2-0.2-22.4-8.7-22.6-34.3c-0.2-21.4,17.5-31.6,18.3-32.2
	C123.3,42.9,107.7,41.3,102.3,40.9 M182.6,11.9v155.9h24.2v-53.3h33.5c30.6,0,52.1-21,52.1-51.4c0-30.4-21.1-51.2-51.3-51.2H182.6z
	 M206.8,32.3h27.9c21,0,33,11.2,33,30.9c0,19.7-12,31-33.1,31h-27.8V32.3z M336.6,169c15.2,0,29.3-7.7,35.7-19.9h0.5v18.7h22.4V90.2
	c0-22.5-18-37-45.7-37c-25.7,0-44.7,14.7-45.4,34.9h21.8c1.8-9.6,10.7-15.9,22.9-15.9c14.8,0,23.1,6.9,23.1,19.6v8.6l-30.2,1.8
	c-28.1,1.7-43.3,13.2-43.3,33.2C298.4,155.6,314.1,169,336.6,169z M343.1,150.5c-12.9,0-21.1-6.2-21.1-15.7c0-9.8,7.9-15.5,23-16.4
	l26.9-1.7v8.8C371.9,140.1,359.5,150.5,343.1,150.5z M425.1,210.2c23.6,0,34.7-9,44.4-36.3L512,54.7h-24.6l-28.5,92.1h-0.5
	l-28.5-92.1h-25.3l41,113.5l-2.2,6.9c-3.7,11.7-9.7,16.2-20.4,16.2c-1.9,0-5.6-0.2-7.1-0.4v18.7C417.3,210,423.3,210.2,425.1,210.2z
	`
        }
      ),
      /* @__PURE__ */ y.jsx("g", {}),
      /* @__PURE__ */ y.jsx("g", {}),
      /* @__PURE__ */ y.jsx("g", {}),
      /* @__PURE__ */ y.jsx("g", {}),
      /* @__PURE__ */ y.jsx("g", {}),
      /* @__PURE__ */ y.jsx("g", {})
    ]
  }
);
function c3(e) {
  return /* @__PURE__ */ y.jsx(
    "svg",
    {
      width: "15",
      height: "9",
      viewBox: "0 0 15 9",
      fill: "none",
      stroke: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ y.jsx(
        "path",
        {
          d: "M1.5 1.5L7.5 7.5L13.5 1.5",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function NL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "24",
      height: "10",
      viewBox: "0 0 24 10",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("path", { d: "M4.75347 9.9973C8.35951 9.9973 10.1625 7.57135 11.9656 5.14539H0V9.9973H4.75347Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M19.1778 0.293716C15.5717 0.293716 13.7687 2.71967 11.9657 5.14562H23.9312V0.293716H19.1778Z" })
      ]
    }
  );
}
function jL(e) {
  return /* @__PURE__ */ y.jsx(
    "svg",
    {
      width: "21",
      height: "15",
      viewBox: "0 0 21 15",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ y.jsx(
        "path",
        {
          d: "M0.535394 0.862247C0.535394 0.75915 0.619218 0.675638 0.721353 0.675638H19.443C19.5455 0.675638 19.6292 0.759223 19.6292 0.862247V13.4278C19.6292 13.5308 19.5455 13.6144 19.443 13.6144H0.721353C0.619218 13.6144 0.535394 13.5309 0.535394 13.4278V0.862247ZM0.721353 14.2511H19.443C19.8964 14.2511 20.2646 13.8816 20.2646 13.4278V0.862247C20.2646 0.408374 19.8964 0.0389313 19.443 0.0389313H0.721353C0.26825 0.0389313 -0.1 0.408403 -0.1 0.862247V13.4278C-0.1 13.8816 0.26825 14.2511 0.721353 14.2511ZM17.3582 8.55702C17.3582 8.38228 17.2172 8.23931 17.0414 8.23931C16.866 8.23931 16.7251 8.38248 16.7251 8.55702V11.8459C16.7251 12.0206 16.8662 12.1633 17.0414 12.1633C17.217 12.1633 17.3582 12.0208 17.3582 11.8459V8.55702ZM16.1986 8.55702C16.1986 8.38218 16.0571 8.23931 15.8817 8.23931C15.7066 8.23931 15.5651 8.38228 15.5651 8.55702V11.8459C15.5651 12.0208 15.7067 12.1633 15.8817 12.1633C16.0569 12.1633 16.1986 12.0209 16.1986 11.8459V8.55702ZM15.0389 8.55702C15.0389 8.38199 14.8969 8.23931 14.7217 8.23931C14.5466 8.23931 14.4052 8.38228 14.4052 8.55702V11.8459C14.4052 12.0208 14.5468 12.1633 14.7217 12.1633C14.8967 12.1633 15.0389 12.0211 15.0389 11.8459V8.55702ZM13.879 8.55702C13.879 8.38199 13.7369 8.23931 13.5618 8.23931C13.3866 8.23931 13.2452 8.38228 13.2452 8.55702V11.8459C13.2452 12.0208 13.3868 12.1633 13.5618 12.1633C13.7367 12.1633 13.879 12.0211 13.879 11.8459V8.55702ZM12.719 8.55702C12.719 8.38209 12.5774 8.23931 12.4018 8.23931C12.2269 8.23931 12.0855 8.38238 12.0855 8.55702V11.8459C12.0855 12.0207 12.227 12.1633 12.4018 12.1633C12.5772 12.1633 12.719 12.021 12.719 11.8459V8.55702ZM11.5593 8.55702C11.5593 8.38199 11.4173 8.23931 11.2421 8.23931C11.0674 8.23931 10.9256 8.38218 10.9256 8.55702V11.8459C10.9256 12.0209 11.0676 12.1633 11.2421 12.1633C11.4171 12.1633 11.5593 12.0211 11.5593 11.8459V8.55702ZM10.3994 8.55702C10.3994 8.38209 10.2574 8.23931 10.0825 8.23931C9.90752 8.23931 9.76559 8.38209 9.76559 8.55702V11.8459C9.76559 12.021 9.90771 12.1633 10.0825 12.1633C10.2572 12.1633 10.3994 12.021 10.3994 11.8459V8.55702ZM9.2394 8.55702C9.2394 8.38209 9.09746 8.23931 8.92251 8.23931C8.74755 8.23931 8.60561 8.38209 8.60561 8.55702V11.8459C8.60561 12.021 8.74774 12.1633 8.92251 12.1633C9.09727 12.1633 9.2394 12.021 9.2394 11.8459V8.55702ZM8.07942 8.55702C8.07942 8.38218 7.93791 8.23931 7.76253 8.23931C7.58738 8.23931 7.44596 8.38228 7.44596 8.55702V11.8459C7.44596 12.0208 7.58757 12.1633 7.76253 12.1633C7.93772 12.1633 8.07942 12.0209 8.07942 11.8459V8.55702ZM6.91977 8.55702C6.91977 8.38218 6.77826 8.23931 6.60288 8.23931C6.42792 8.23931 6.28599 8.38209 6.28599 8.55702V11.8459C6.28599 12.021 6.42812 12.1633 6.60288 12.1633C6.77806 12.1633 6.91977 12.0209 6.91977 11.8459V8.55702ZM5.7598 8.55702C5.7598 8.38218 5.61828 8.23931 5.44291 8.23931C5.26795 8.23931 5.12602 8.38209 5.12602 8.55702V11.8459C5.12602 12.021 5.26814 12.1633 5.44291 12.1633C5.61809 12.1633 5.7598 12.0209 5.7598 11.8459V8.55702ZM4.59982 8.55702C4.59982 8.38218 4.45831 8.23931 4.28293 8.23931C4.10778 8.23931 3.96636 8.38228 3.96636 8.55702V11.8459C3.96636 12.0208 4.10797 12.1633 4.28293 12.1633C4.45812 12.1633 4.59982 12.0209 4.59982 11.8459V8.55702ZM3.43985 8.55702C3.43985 8.38218 3.29833 8.23931 3.12296 8.23931C2.94761 8.23931 2.80671 8.38248 2.80671 8.55702V11.8459C2.80671 12.0206 2.94781 12.1633 3.12296 12.1633C3.29814 12.1633 3.43985 12.0209 3.43985 11.8459V8.55702Z",
          strokeWidth: "0.2"
        }
      )
    }
  );
}
function RL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.9039 2.72621H18.3769V1.35165C18.3769 0.59564 17.7813 0 17.0253 0C16.2693 0 15.6736 0.59564 15.6736 1.35165V2.72621H12.3518V1.35165C12.3518 0.59564 11.7561 0 11.0001 0C10.2441 0 9.64848 0.59564 9.64848 1.35165V2.72621H6.32663V1.35165C6.32663 0.59564 5.73099 0 4.97498 0C4.21897 0 3.62333 0.59564 3.62333 1.35165V2.72621H3.09642C1.46986 2.72621 0.141113 4.05495 0.141113 5.68151V18.8086C0.141113 20.4351 1.46985 21.7639 3.09642 21.7639H18.9039C20.5304 21.7639 21.8592 20.4351 21.8592 18.8086V5.68151C21.8592 4.05495 20.5304 2.72621 18.9039 2.72621H18.9039ZM18.9039 19.7937H3.0964C2.54658 19.7937 2.1113 19.3584 2.1113 18.8086V8.79719H19.889V18.8086C19.889 19.3584 19.4537 19.7937 18.9039 19.7937Z"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 10.767H4.53961C4.33343 10.767 4.15015 10.9502 4.15015 11.1564V12.8975C4.15015 13.1037 4.33343 13.287 4.53961 13.287H7.26582C7.472 13.287 7.65528 13.1037 7.65528 12.8975V11.1564C7.65528 10.9502 7.472 10.767 7.26582 10.767Z"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 10.767H9.62554C9.41936 10.767 9.23608 10.9502 9.23608 11.1564V12.8975C9.23608 13.1037 9.41936 13.287 9.62554 13.287H12.3747C12.5809 13.287 12.7641 13.1037 12.7641 12.8975V11.1564C12.7641 10.9502 12.5809 10.767 12.3747 10.767Z"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 10.767H14.7347C14.5285 10.767 14.3452 10.9502 14.3452 11.1564V12.8975C14.3452 13.1037 14.5285 13.287 14.7347 13.287H17.4609C17.6671 13.287 17.8504 13.1037 17.8504 12.8975V11.1564C17.8733 10.9502 17.69 10.767 17.4838 10.767H17.4838Z"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.26582 15.281H4.53961C4.33343 15.281 4.15015 15.4643 4.15015 15.6705V17.4116C4.15015 17.6178 4.33343 17.801 4.53961 17.801H7.26582C7.472 17.801 7.65528 17.6178 7.65528 17.4116V15.6705C7.65528 15.4643 7.472 15.281 7.26582 15.281Z"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.3747 15.281H9.62554C9.41936 15.281 9.23608 15.4643 9.23608 15.6705V17.4116C9.23608 17.6178 9.41936 17.801 9.62554 17.801H12.3747C12.5809 17.801 12.7641 17.6178 12.7641 17.4116V15.6705C12.7641 15.4643 12.5809 15.281 12.3747 15.281Z"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.4838 15.281H14.7347C14.5285 15.281 14.3452 15.4643 14.3452 15.6705V17.4116C14.3452 17.6178 14.5285 17.801 14.7347 17.801H17.4609C17.6671 17.801 17.8504 17.6178 17.8504 17.4116V15.6705C17.8733 15.4643 17.69 15.281 17.4838 15.281H17.4838Z"
          }
        )
      ]
    }
  );
}
function DL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "48",
      height: "48",
      viewBox: "0 0 48 48",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("path", { d: "M22.3346 26.8581C22.5382 26.7636 22.7637 26.7709 22.9673 26.8727L24.4946 27.6363V24.8218H20.5601V27.68L22.3346 26.8581Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M37.2945 37.92C36.8218 37.6727 36.2909 37.6291 35.8109 37.8036L25.7164 41.4254C25.2218 41.7018 24.6473 41.8545 24.0436 41.8545H17.9564C17.5564 41.8545 17.2291 41.5273 17.2291 41.1273C17.2291 40.7273 17.5564 40.4 17.9564 40.4H24.0436C24.3855 40.4 24.72 40.3127 25.0036 40.1673C25.04 40.1454 25.0764 40.1236 25.1127 40.1018C25.5418 39.8327 25.8545 39.4109 25.9345 38.9236C26.0218 38.3854 25.8764 37.8691 25.5345 37.4691C25.1927 37.0691 24.6982 36.8436 24.1745 36.8436H19.6291C18.2982 36.8436 16.9673 36.3636 15.8836 35.4982C14.1091 34.08 10.4364 32.1891 5.58545 35.1491V43.9782C6.82909 43.9854 9.43272 44.2109 13.0545 45.6291C16.4509 46.96 20.0655 47.2654 23.5127 46.5163C27.0473 45.7454 32.3345 44.1818 37.3964 41.0763C37.7964 40.8291 38.0945 40.4145 38.2036 39.9345C38.3927 39.1345 38.0145 38.3054 37.2945 37.92Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M19.6293 35.3746H24.1748C25.1275 35.3746 26.022 35.7891 26.6402 36.5164C27.2584 37.2436 27.5202 38.2036 27.3675 39.1491C27.3602 39.2 27.3529 39.2436 27.3384 39.2946L32.3129 37.5127V26.0218C32.3129 25.36 31.7748 24.8291 31.1202 24.8291H25.942V28.8218C25.942 29.0764 25.8111 29.3091 25.6002 29.44C25.4839 29.5127 25.3529 29.5491 25.2148 29.5491C25.1057 29.5491 24.9893 29.52 24.8875 29.4691L22.6184 28.3346L20.1239 29.4836C19.8984 29.5855 19.6366 29.5709 19.4257 29.4327C19.2148 29.3018 19.0911 29.0691 19.0911 28.8218V24.8291H13.9129C13.2511 24.8291 12.7202 25.3673 12.7202 26.0218V32.3418C14.4657 32.7491 15.8548 33.6073 16.7857 34.3564C17.6293 35.0255 18.6111 35.3746 19.6293 35.3746Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M4.13102 32.7419L1.0183 32.6982L0.981934 45.8764L4.08739 45.9201L4.13102 45.8764V32.7419Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M25.782 10.9455C25.2147 10.611 24.5674 10.4219 23.8911 10.4219C21.8329 10.4219 20.1602 12.0946 20.1602 14.1528C20.1602 16.211 21.8329 17.8837 23.8911 17.8837C24.9529 17.8837 25.942 17.4255 26.6402 16.6619C26.0292 16.4873 25.4765 16.1382 25.0692 15.6437C24.0583 14.4219 24.182 12.5528 25.3456 11.3819L25.782 10.9455Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M32.3783 5.76718C32.4874 6.03627 32.4292 6.349 32.2183 6.55991L26.371 12.4072C25.731 13.0472 25.651 14.0581 26.1892 14.7126C26.4946 15.0835 26.9237 15.3017 27.3965 15.3235C27.8692 15.3526 28.3201 15.1708 28.6546 14.8363L33.5055 9.98536C33.7892 9.70173 34.2474 9.70173 34.531 9.98536C35.5201 10.9599 36.8292 11.4545 38.2183 11.469C39.5055 11.4472 40.7128 10.9526 41.6437 10.0726V1.09082H29.0401C27.8183 1.09082 26.6619 1.57082 25.7965 2.43627L22.9092 5.32355H31.7092C32.0001 5.31627 32.2692 5.49809 32.3783 5.76718Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M14.0222 15.6434C14.8456 15.6434 15.5131 14.9759 15.5131 14.1525C15.5131 13.3291 14.8456 12.6616 14.0222 12.6616C13.1988 12.6616 12.5312 13.3291 12.5312 14.1525C12.5312 14.9759 13.1988 15.6434 14.0222 15.6434Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M43.1055 1.09082H47.0255V9.64355H43.1055V1.09082Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M34.0584 11.4983L29.6875 15.8692C29.3384 16.2183 28.902 16.4655 28.4366 16.6183C27.5347 18.2765 25.7966 19.3383 23.8911 19.3383C21.0329 19.3383 18.7057 17.011 18.7057 14.1528C18.7057 11.2946 21.0329 8.96736 23.8911 8.96736C24.9457 8.96736 25.9711 9.29463 26.8293 9.891L29.9493 6.771H9.82565C9.55656 6.771 9.33838 6.98918 9.33838 7.25827V21.0328C9.33838 21.3019 9.55656 21.5201 9.82565 21.5201H37.9638C38.2329 21.5201 38.4511 21.3019 38.4511 21.0328V12.9019C38.3784 12.9019 38.3129 12.9165 38.2402 12.9165C36.7057 12.9165 35.2438 12.4437 34.0584 11.4983ZM14.022 17.0983C12.4002 17.0983 11.0766 15.7746 11.0766 14.1528C11.0766 12.531 12.4002 11.2074 14.022 11.2074C15.6438 11.2074 16.9675 12.531 16.9675 14.1528C16.9675 15.7746 15.6438 17.0983 14.022 17.0983Z" })
      ]
    }
  );
}
function IL(e) {
  return /* @__PURE__ */ y.jsx(
    "svg",
    {
      width: "16",
      height: "13",
      viewBox: "0 0 16 13",
      fill: "none",
      stroke: "rgb(var(--background-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ y.jsx(
        "path",
        {
          d: "M0.999756 7.84424L4.99976 11.8442L14.9998 1.84424",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    }
  );
}
function HL(e) {
  return /* @__PURE__ */ y.jsx(
    "svg",
    {
      width: "19",
      height: "15",
      viewBox: "0 0 19 15",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ y.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.0035 0.218132H1.88928C0.84752 0.218132 0 1.06565 0 2.10741V12.1836C0 13.2254 0.84752 14.0729 1.88928 14.0729H17.0035C18.0453 14.0729 18.8928 13.2254 18.8928 12.1836V2.10741C18.8928 1.06565 18.0453 0.218132 17.0035 0.218132ZM15.744 4.62646H3.14879C2.80074 4.62646 2.51903 4.34476 2.51903 3.9967C2.51903 3.64865 2.80074 3.36694 3.14879 3.36694H15.744C16.0921 3.36694 16.3738 3.64865 16.3738 3.9967C16.3738 4.34476 16.0921 4.62646 15.744 4.62646ZM6.92737 10.9241H3.1488V7.14551H6.92737V10.9241Z"
        }
      )
    }
  );
}
function FL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "22",
      height: "19",
      viewBox: "0 0 22 19",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("path", { d: "M-0.000106812 4.07082C-0.000106812 2.90389 0.339278 1.90757 1.05149 1.19147L2.29012 2.43686C0.911525 3.81801 2.11547 8.11214 6.04069 12.0625C9.96591 16.0129 14.2392 17.2222 15.6165 15.8386L16.8552 17.084C14.5315 19.4203 9.23883 17.7627 4.80825 13.3067C1.73521 10.2156 -0.000106812 6.70857 -0.000106812 4.07082Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M7.81099 18.1573C6.65039 18.1573 5.65949 17.8161 4.94604 17.1L6.18467 15.8546C7.56079 17.2382 11.8316 16.0277 15.7605 12.0786C19.6894 8.1294 20.8909 3.83527 19.5148 2.45163L20.7534 1.20624C23.0783 3.5426 21.4285 8.86418 16.9967 13.319C13.9224 16.4138 10.4344 18.1573 7.81099 18.1573Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M17.4053 11.5363C16.6534 9.35934 15.1175 7.03294 13.08 4.98551C8.64939 0.529482 3.35672 -1.12939 1.03305 1.20822C0.868316 1.37511 1.01076 1.78733 1.35262 2.13106C1.69448 2.47479 2.10447 2.61677 2.26921 2.45113C3.64656 1.06749 7.91736 2.27802 11.8451 6.22842C13.703 8.09651 15.0878 10.1826 15.7554 12.1129C16.34 13.8054 16.2831 15.1704 15.6018 15.8553C15.4358 16.021 15.5795 16.4344 15.9201 16.7769C16.2608 17.1194 16.672 17.2639 16.838 17.097C18.0283 15.9002 18.2302 13.9225 17.4053 11.5363Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M20.751 1.20826C19.5582 0.00894456 17.5937 -0.194055 15.218 0.636625C13.0541 1.39134 10.7391 2.93687 8.70281 4.9843C4.27223 9.43909 2.62237 14.7607 4.94604 17.0983C5.11202 17.2639 5.522 17.1207 5.86387 16.7782C6.20573 16.4357 6.34817 16.0223 6.18219 15.8554C4.80236 14.4717 6.01002 10.1776 9.93896 6.22721C11.7969 4.35912 13.8716 2.96676 15.7915 2.29549C17.4748 1.70891 18.8323 1.76495 19.5148 2.44992C19.6795 2.61556 20.0908 2.47234 20.4314 2.12861C20.772 1.78488 20.9157 1.3739 20.751 1.20826Z" })
      ]
    }
  );
}
function VL(e) {
  return /* @__PURE__ */ y.jsx(
    "svg",
    {
      width: "56",
      height: "59",
      viewBox: "0 0 56 59",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ y.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M28 58.165C43.464 58.165 56 45.181 56 29.165C56 27.12 55.817 25.101 55.464 23.137H27.512L47.768 45.165C26.4 63.072 0.073 17.275 13.577 8.73C15.863 7.283 19.133 7.127 23.385 8.263L24.03 8.443C24.248 8.506 24.468 8.573 24.69 8.643L25.365 8.861L25.708 8.978L26.404 9.226C26.757 9.354 27.114 9.491 27.477 9.634L28.211 9.93L28.959 10.246C29.211 10.354 29.466 10.466 29.722 10.581L30.5 10.935L31.293 11.309L32.1 11.702L32.923 12.115L33.339 12.328L34.183 12.77L35.043 13.23L35.916 13.711L36.805 14.211L37.255 14.468L38.165 14.997L39.09 15.545C39.246 15.638 39.402 15.731 39.558 15.826L40.985 16.699L41.955 17.305L42.939 17.931L43.938 18.576L44.952 19.24L45.98 19.924L47.023 20.627L48.616 21.718L49.154 22.091L38.543 1.11C36.197 0.207001 33.228 0.038 30.418 0.00699997L28.95 0H28C12.536 0 0 13.149 0 29.165C0 45.181 12.536 58.165 28 58.165Z"
        }
      )
    }
  );
}
function BL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "26",
      height: "22",
      viewBox: "0 0 26 22",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M7.62919 4.03262V19.4089H14.3212C20.3975 19.4089 23.0326 15.9768 23.0326 11.1231C23.0326 6.47761 20.3975 2.87352 14.3212 2.87352H8.78829C8.14535 2.87352 7.62919 3.39874 7.62919 4.03262Z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M2.73866 21.7997H13.5509C17.3649 21.7997 20.3397 20.8565 22.3619 19.0428C24.3859 17.2276 25.4412 14.5533 25.4412 11.1229C25.4412 9.1476 25.0571 6.48868 23.3725 4.32192C21.6842 2.15039 18.704 0.491309 13.5509 0.491309H2.73866C1.72355 0.491309 0.9 1.31485 0.9 2.32997V19.961C0.9 20.9762 1.72355 21.7997 2.73866 21.7997ZM1.67955 2.32997C1.67955 1.74225 2.15095 1.27086 2.73866 1.27086H13.5509C15.6357 1.27086 18.4163 1.59408 20.6727 2.98558C22.9212 4.37219 24.6617 6.82698 24.6617 11.1229C24.6617 14.3254 23.6728 16.7946 21.7996 18.4647C19.9246 20.1364 17.1491 21.0202 13.5509 21.0202H2.73866C2.15095 21.0202 1.67955 20.5488 1.67955 19.961V2.32997Z",
            strokeWidth: "0.2"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M9.9854 9.04946C10.2208 9.04946 10.4382 9.08568 10.6464 9.15813C10.8547 9.23057 11.0268 9.34829 11.1807 9.49318C11.3256 9.64712 11.4433 9.83729 11.5339 10.0546C11.6154 10.281 11.6607 10.5436 11.6607 10.8515C11.6607 11.1232 11.6244 11.3677 11.5611 11.5941C11.4886 11.8204 11.389 12.0197 11.2532 12.1827C11.1173 12.3457 10.9453 12.4724 10.737 12.5721C10.5287 12.6626 10.2842 12.7169 10.0035 12.7169H8.41879V9.04041H9.9854V9.04946ZM9.93106 12.0468C10.0488 12.0468 10.1575 12.0287 10.2752 11.9925C10.3838 11.9563 10.4834 11.8929 10.5649 11.8023C10.6464 11.7118 10.7189 11.6031 10.7732 11.4582C10.8276 11.3133 10.8547 11.1503 10.8547 10.9421C10.8547 10.761 10.8366 10.5889 10.8004 10.444C10.7642 10.2991 10.7008 10.1633 10.6193 10.0637C10.5378 9.96407 10.4291 9.87351 10.2933 9.81918C10.1575 9.76485 9.99445 9.73768 9.79523 9.73768H9.21568V12.0559H9.93106V12.0468Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M14.9314 9.04946V9.72862H12.9935V10.5165H14.7775V11.1413H12.9935V12.0378H14.9767V12.7169H12.1876V9.04041H14.9314V9.04946Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M17.7008 9.04926L19.0773 12.7258H18.2351L17.9544 11.9108H16.5779L16.2882 12.7258H15.4732L16.8587 9.04926H17.7008ZM17.7461 11.3041L17.2843 9.95482H17.2752L16.7953 11.3041H17.7461Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M20.3893 9.04926V12.0466H22.1823V12.7258H19.5834V9.04926H20.3893Z",
            fill: "rgb(var(--background-secondary))",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M4.60354 12.5799C5.53877 12.5799 6.29693 11.8217 6.29693 10.8865C6.29693 9.95125 5.53877 9.1931 4.60354 9.1931C3.66832 9.1931 2.91016 9.95125 2.91016 10.8865C2.91016 11.8217 3.66832 12.5799 4.60354 12.5799Z",
            stroke: "none"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M5.87874 19.4088C4.45703 19.4088 3.31603 18.2588 3.31603 16.8461V14.8449C3.31603 14.1385 3.88653 13.559 4.60192 13.559C5.30825 13.559 5.8878 14.1295 5.8878 14.8449V19.4088H5.87874Z",
            stroke: "none"
          }
        )
      ]
    }
  );
}
function zL(e) {
  return /* @__PURE__ */ y.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "931.999",
      height: "931.999",
      viewBox: "0 0 931.999 931.999",
      fill: "rgb(var(--fill-primary))",
      stroke: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ y.jsx(
        "path",
        {
          id: "Exclusion_3",
          "data-name": "Exclusion 3",
          d: "M466,931.5a472.963,472.963,0,0,1-47.595-2.4,466.666,466.666,0,0,1-46.22-7.054c-15-3.069-30.006-6.928-44.611-11.471-14.441-4.492-28.83-9.758-42.768-15.653-13.808-5.84-27.5-12.435-40.691-19.6-13.1-7.115-26.011-14.96-38.38-23.317A468.069,468.069,0,0,1,80,726.266c-8.357-12.369-16.2-25.282-23.317-38.38-7.167-13.193-13.762-26.883-19.6-40.691-5.9-13.938-11.162-28.327-15.653-42.768-4.543-14.605-8.4-29.614-11.471-44.611A466.67,466.67,0,0,1,2.9,513.595a472.483,472.483,0,0,1,0-95.189,466.668,466.668,0,0,1,7.054-46.22c3.069-15,6.928-30.006,11.471-44.611,4.492-14.441,9.758-28.83,15.653-42.768,5.84-13.808,12.435-27.5,19.6-40.691C63.8,231.017,71.644,218.1,80,205.735A468.069,468.069,0,0,1,205.735,80c12.369-8.357,25.282-16.2,38.38-23.317,13.193-7.167,26.883-13.762,40.691-19.6,13.938-5.9,28.327-11.162,42.768-15.653,14.605-4.543,29.614-8.4,44.611-11.471A466.668,466.668,0,0,1,418.406,2.9a472.483,472.483,0,0,1,95.189,0,466.67,466.67,0,0,1,46.22,7.054c15,3.069,30.006,6.928,44.611,11.471,14.441,4.492,28.83,9.758,42.768,15.653,13.808,5.84,27.5,12.435,40.691,19.6C700.983,63.8,713.9,71.644,726.266,80A468.069,468.069,0,0,1,852,205.735c8.357,12.369,16.2,25.282,23.317,38.38,7.167,13.193,13.762,26.883,19.6,40.691,5.9,13.938,11.162,28.327,15.653,42.768,4.543,14.605,8.4,29.614,11.471,44.611a466.666,466.666,0,0,1,7.054,46.22,472.43,472.43,0,0,1,0,95.189,466.667,466.667,0,0,1-7.054,46.22c-3.069,15-6.928,30.006-11.471,44.611-4.492,14.441-9.758,28.83-15.653,42.768-5.84,13.808-12.435,27.5-19.6,40.691-7.115,13.1-14.96,26.011-23.317,38.38A468.07,468.07,0,0,1,726.266,852c-12.369,8.357-25.282,16.2-38.38,23.317-13.193,7.167-26.883,13.762-40.691,19.6-13.938,5.9-28.327,11.162-42.768,15.653-14.605,4.543-29.614,8.4-44.611,11.471a466.667,466.667,0,0,1-46.22,7.054A472.963,472.963,0,0,1,466,931.5ZM591.545,364.758a80.927,80.927,0,0,1,15.924,1.594,83.7,83.7,0,0,1,15.106,4.568A85.8,85.8,0,0,1,648.74,387.7,83.147,83.147,0,0,1,659,399.281a78.754,78.754,0,0,1,7.845,13.276,72.539,72.539,0,0,1,6.849,30.37v218.92H766V442.927a167.974,167.974,0,0,0-11.76-62.213,180.051,180.051,0,0,0-33.721-53.795,170.406,170.406,0,0,0-112.982-56.757c-5.238-.42-10.266-.624-15.369-.624a174.2,174.2,0,0,0-69.106,14.241,173.135,173.135,0,0,0-57.581,40.436,175.252,175.252,0,0,0-57.425-40.359,171.956,171.956,0,0,0-68.64-14.319C243.794,269.539,166,347.321,166,442.927v218.92h92.308V442.927a71.8,71.8,0,0,1,5.875-28.312,78.778,78.778,0,0,1,6.832-12.631,83.117,83.117,0,0,1,8.974-11.238A84.939,84.939,0,0,1,303,373.58a81.077,81.077,0,0,1,13.354-5.362,76.388,76.388,0,0,1,14.133-2.838c2.655-.2,5.4-.416,7.891-.416a81.331,81.331,0,0,1,15.895,1.576,83.049,83.049,0,0,1,15.03,4.524,84.18,84.18,0,0,1,25.931,16.664,81.736,81.736,0,0,1,10.135,11.526A78.109,78.109,0,0,1,413.1,412.5a73.5,73.5,0,0,1,6.742,30.425v218.92h92.777V442.927a73.82,73.82,0,0,1,5.666-28.257,79.5,79.5,0,0,1,6.623-12.661,82.439,82.439,0,0,1,8.74-11.289A83.346,83.346,0,0,1,544.2,381.1a81.81,81.81,0,0,1,12.055-7.662,76.21,76.21,0,0,1,27.4-8.261C586.31,364.969,589.052,364.758,591.545,364.758Z",
          transform: "translate(-0.001 -0.001)",
          strokeWidth: "1"
        }
      )
    }
  );
}
function GL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "18",
      height: "21",
      viewBox: "0 0 18 21",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.67824 19.4354L9.29538 15.5267L9.3387 15.3101C9.37119 15.1261 9.46863 14.9528 9.6094 14.8229C9.75013 14.7038 9.94504 14.628 10.1291 14.628H10.6163C11.4284 14.628 12.1863 14.5414 12.8468 14.3682C13.5506 14.1841 14.1786 13.9026 14.7199 13.5236C15.283 13.123 15.7594 12.6033 16.1275 11.9753C16.5173 11.3148 16.8096 10.5244 16.9829 9.62575C17.1345 8.82452 17.167 8.10991 17.0695 7.50357C16.9612 6.85392 16.7122 6.31255 16.3333 5.86862C16.095 5.59794 15.8027 5.37056 15.4454 5.17567H15.4346V5.16485C15.5645 4.36362 15.5537 3.70314 15.4237 3.12928C15.2938 2.55543 15.0123 2.03572 14.59 1.54847C13.7022 0.54152 12.0889 0.0218048 9.8043 0.0218048H3.51355C3.30784 0.0218048 3.10211 0.0975972 2.9397 0.23835C2.7773 0.379114 2.66902 0.563184 2.63654 0.768897L0.00546765 17.3998C-0.016197 17.5514 0.0271323 17.703 0.124567 17.8221C0.222013 17.9412 0.373609 18.0062 0.525194 18.0062H4.43389V18.0278L4.1632 19.7278C4.14154 19.8577 4.18486 19.9984 4.27149 20.0959C4.35809 20.1933 4.48802 20.2583 4.61796 20.2583H7.89866C8.08273 20.2583 8.25597 20.1933 8.39673 20.0742C8.53748 19.9551 8.62411 19.7927 8.65659 19.6087L8.67825 19.4354"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.4549 5.16492C15.4333 5.28402 15.4116 5.40313 15.3899 5.53305C14.5562 9.79905 11.7194 11.2716 8.09223 11.2716H6.24074C5.79683 11.2716 5.42869 11.5964 5.35291 12.0295L4.14023 19.7278C4.09691 20.0093 4.31346 20.2692 4.60582 20.2692H7.88651C8.27631 20.2692 8.60113 19.9877 8.66609 19.6087L8.69858 19.4463L9.31576 15.5376L9.35907 15.3211C9.42403 14.9421 9.74884 14.6606 10.1386 14.6606H10.6259C13.7983 14.6606 16.2886 13.3721 17.0141 9.64748C17.3172 8.08833 17.1656 6.78904 16.3536 5.87953C16.1046 5.57636 15.8014 5.34899 15.4549 5.16493"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.5792 4.81794C14.4492 4.78546 14.3193 4.75298 14.1894 4.7205C14.0595 4.68801 13.9187 4.66636 13.7779 4.6447C13.2799 4.56891 12.7385 4.5256 12.1538 4.5256H7.21651C7.0974 4.5256 6.9783 4.55809 6.88086 4.6014C6.65348 4.70967 6.48024 4.92622 6.44776 5.18607L5.3975 11.8341L5.36501 12.029C5.42997 11.5959 5.80894 11.2711 6.25286 11.2711H8.10436C11.7316 11.2711 14.5683 9.79856 15.402 5.53255C15.4237 5.40262 15.4454 5.28352 15.467 5.16442C15.2613 5.05614 15.0339 4.95869 14.7849 4.87208C14.7091 4.85043 14.6441 4.8396 14.5792 4.81794",
            fill: "#B3BCC7",
            className: "group-aria-checked:fill-brand-primary-hover group-aria-checked:easy-out group-aria-checked:transition-colors group-aria-checked:duration-75"
          }
        )
      ]
    }
  );
}
function UL(e) {
  return /* @__PURE__ */ y.jsx(
    "svg",
    {
      width: "49",
      height: "47",
      viewBox: "0 0 50 50",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--fill-primary))",
      ...e,
      children: /* @__PURE__ */ y.jsx("path", { d: "M44.5947 49.5015H3.30047C1.91372 49.5015 0.732422 48.3202 0.732422 46.8821L0.732422 42.2082C0.732422 40.7701 1.91372 39.5888 3.30047 39.5888H44.5947C46.0328 39.5888 47.1628 40.7701 47.2141 42.2082V46.8307C47.2141 48.3202 46.0328 49.5015 44.5947 49.5015ZM44.5947 23.5642L3.30047 23.5642C2.63278 23.5642 1.96509 23.3074 1.50284 22.7937C0.989227 22.2801 0.732422 21.6638 0.732422 20.9448L0.732422 16.2709C0.732422 14.8328 1.91372 13.6515 3.30047 13.6515H44.5947C46.0328 13.6515 47.1628 14.7814 47.2141 16.2709V20.9448C47.1628 22.4342 46.0328 23.5642 44.5947 23.5642ZM26.567 10.6212H3.30047C2.63278 10.6212 1.96509 10.3644 1.50284 9.85078C1.04059 9.33717 0.732422 8.72084 0.732422 8.00178L0.732422 3.32793C0.732422 1.88982 1.91372 0.708518 3.30047 0.708518H26.5156C27.9537 0.708518 29.0837 1.88982 29.0837 3.27657V7.95042C29.135 9.49125 28.0051 10.6726 26.567 10.6212ZM47.2141 36.5585H3.30047C2.63278 36.5585 1.96509 36.3017 1.50284 35.7881C1.04059 35.2745 0.732422 34.6581 0.732422 33.9391L0.732422 29.2652C0.732422 27.8271 1.91372 26.6458 3.30047 26.6458L47.1628 26.6458C48.6009 26.6458 49.7308 27.8271 49.7308 29.2652V33.9391C49.7822 35.3772 48.6009 36.5071 47.2141 36.5585Z" })
    }
  );
}
function ZL(e) {
  return /* @__PURE__ */ y.jsx(
    "svg",
    {
      width: "20",
      height: "21",
      viewBox: "0 0 20 21",
      fill: "rgb(var(--rgb-color-green))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ y.jsx("path", { d: "M9.93709 10.61C10.8847 10.5968 11.8073 10.3037 12.5888 9.76761C13.3703 9.23151 13.9758 8.47632 14.3293 7.597C14.6828 6.71768 14.7684 5.75348 14.5754 4.82564C14.3823 3.8978 13.9193 3.04773 13.2445 2.38233C12.5697 1.71692 11.7132 1.26588 10.7827 1.08592C9.85225 0.90596 8.88935 1.00511 8.01508 1.3709C7.14082 1.7367 6.39421 2.35281 5.86915 3.14176C5.34408 3.93072 5.06399 4.8573 5.06409 5.80501C5.06841 6.44052 5.1979 7.06895 5.44515 7.6544C5.69241 8.23986 6.05259 8.77086 6.50512 9.21707C6.95765 9.66329 7.49366 10.016 8.08253 10.255C8.6714 10.494 9.30159 10.6146 9.93709 10.61ZM9.93709 13.01C6.68409 13.013 0.190094 14.622 0.190094 17.818V20.218H19.6831V17.818C19.6831 14.622 13.1901 13.013 9.93709 13.013V13.01Z" })
    }
  );
}
function KL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      version: "1.1",
      fill: "rgb(var(--fill-primary))",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "20px",
      viewBox: "0 0 298 294",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M244.285446,208.610062
	C242.970535,209.638763 241.936996,211.008606 240.866455,211.038147
	C226.915070,211.423294 213.323441,212.234283 202.526245,199.743088
	C191.444809,186.923065 178.474030,175.756104 166.753845,163.461746
	C157.923599,154.198914 143.357864,154.168411 134.603729,163.190262
	C121.496552,176.698273 108.021919,189.849380 94.731537,203.180161
	C89.298790,208.629440 82.626717,210.348587 75.120163,211.342804
	C60.985691,213.214874 50.329533,208.886612 41.561268,197.525284
	C35.426071,189.575714 27.253853,183.221161 20.883156,175.425507
	C8.642242,160.446579 10.216591,137.694260 24.153507,123.132507
	C33.826618,113.025703 43.814171,103.215714 53.828175,93.444191
	C55.185833,92.119408 57.495472,91.183701 59.401691,91.115700
	C65.546120,90.896507 71.750221,90.741402 77.853561,91.346245
	C87.652054,92.317268 94.438049,98.733185 100.955849,105.375687
	C112.375610,117.013977 123.608986,128.844330 135.293442,140.210785
	C144.487930,149.155029 157.356705,148.646927 166.649048,139.429947
	C179.301895,126.879730 192.115875,114.471695 204.310608,101.486053
	C214.881454,90.229607 227.898621,89.801460 241.426010,92.080154
	C244.539246,92.604576 247.171005,96.638344 249.796814,99.283035
	C257.645477,107.188202 265.340271,115.245918 273.169800,123.170311
	C288.713440,138.902252 288.759369,163.937805 273.159729,179.690308
	C263.665131,189.277969 254.089081,198.784973 244.285446,208.610062
z`
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M99.133804,254.866470
	C89.211319,245.070602 79.538452,235.525192 69.900787,226.014526
	C77.181381,224.578506 84.190994,224.060730 90.499619,221.683029
	C95.720055,219.715469 100.687065,216.152695 104.766792,212.251404
	C117.882652,199.709244 130.526199,186.673599 143.371429,173.847855
	C148.933350,168.294357 151.991394,168.267914 157.623703,173.866959
	C170.023743,186.193771 182.537323,198.413330 194.675293,210.994354
	C202.944809,219.565735 212.734009,224.177948 224.546219,224.728470
	C225.302353,224.763702 226.052200,224.934326 228.588257,225.296951
	C219.519348,234.040939 211.361176,241.787537 203.339722,249.673203
	C194.672058,258.194153 186.151550,266.864594 177.532349,275.435120
	C161.107605,291.767181 136.428574,291.868164 119.855301,275.622467
	C112.958298,268.861816 106.203102,261.956482 99.133804,254.866470
z`
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            opacity: "1.000000",
            stroke: "none",
            d: `
M93.157654,81.812546
	C85.493309,79.981094 78.150978,78.351784 70.817352,76.724403
	C70.913933,76.604439 71.581711,75.602051 72.415405,74.764885
	C88.518112,58.595020 104.543739,42.346703 120.786789,26.318796
	C135.627319,11.674816 158.966370,10.582329 174.536713,24.857964
	C190.414688,39.415646 205.186234,55.179058 220.474991,70.381584
	C222.722427,72.616348 225.151276,74.668686 227.593521,76.894150
	C220.952347,78.432266 214.797546,79.087257 209.311203,81.357597
	C204.392059,83.393204 199.630020,86.613060 195.805130,90.342636
	C182.501434,103.314796 169.612640,116.713509 156.616074,129.998932
	C152.699371,134.002716 149.133774,134.139923 145.126892,130.125793
	C132.536896,117.513069 120.106400,104.735985 107.298668,92.348724
	C103.197273,88.381973 98.113815,85.430618 93.157654,81.812546
z`
          }
        )
      ]
    }
  );
}
function $L(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "19",
      height: "22",
      viewBox: "0 0 19 22",
      fill: "rgb(var(--fill-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("path", { d: "M11.19 9.44064L7.94 21.8806H0L1.61 15.7606L11.19 9.44064Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M18.3994 0.41037L12.7594 21.8804H8.88938L12.6994 7.34037L6.85938 11.1904L7.89937 7.36037L18.3994 0.41037Z" })
      ]
    }
  );
}
function WL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "49",
      height: "47",
      viewBox: "0 0 49 47",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      fill: "rgb(var(--fill-primary))",
      children: [
        /* @__PURE__ */ y.jsx("path", { d: "M26.5134 0.399902H13.6093L0.300049 23.4596L13.6093 46.5193L16.2422 41.9768L5.56587 23.4596L16.2422 4.97133H23.8805L26.5134 0.399902Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M17.4285 16.0526L20.0325 11.539L16.2423 4.97119L13.6094 9.48476L17.4285 16.0526Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M32.358 4.97119L34.9909 9.51369L16.2423 41.9766L13.6094 37.4341L32.358 4.97119Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M22.1155 46.5193L24.7195 41.9768H32.3578L43.0341 23.4596L32.3578 4.97133L34.9907 0.399902L48.2999 23.4596L34.9907 46.5193H22.1155Z" }),
        /* @__PURE__ */ y.jsx("path", { d: "M31.1139 30.7798L28.481 35.3223L32.358 41.9769L34.9909 37.4633L31.1139 30.7798Z" })
      ]
    }
  );
}
function YL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2004_5212",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2004_5212)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M50.282 12.0475C49.8323 12.0475 49.4428 11.9905 49.1135 11.8765C48.7905 11.7562 48.5403 11.5662 48.363 11.3065C48.1857 11.0405 48.0843 10.6858 48.059 10.2425L47.888 6.414H49.2275L49.389 9.777C49.4017 10.0367 49.4428 10.2362 49.5125 10.3755C49.5885 10.5085 49.6962 10.6003 49.8355 10.651C49.9748 10.6953 50.1553 10.7175 50.377 10.7175C50.6177 10.7175 50.7887 10.7808 50.89 10.9075C50.9913 11.0278 51.042 11.1798 51.042 11.3635C51.042 11.5598 50.9755 11.7245 50.8425 11.8575C50.7158 11.9842 50.529 12.0475 50.282 12.0475ZM48.5435 11.164C48.1192 11.259 47.7107 11.3033 47.318 11.297C46.9253 11.2843 46.5738 11.2147 46.2635 11.088C45.9532 10.955 45.7062 10.765 45.5225 10.518C45.3452 10.271 45.2565 9.9575 45.2565 9.5775C45.2565 9.24183 45.3293 8.93783 45.475 8.6655C45.627 8.38683 45.836 8.143 46.102 7.934C46.3743 7.725 46.691 7.54767 47.052 7.402C47.413 7.25633 47.8057 7.1455 48.23 7.0695L48.363 8.4185C48.0907 8.43117 47.8437 8.46917 47.622 8.5325C47.4067 8.5895 47.2198 8.6655 47.0615 8.7605C46.9095 8.8555 46.7923 8.96317 46.71 9.0835C46.6277 9.1975 46.5865 9.321 46.5865 9.454C46.5865 9.56167 46.6245 9.65033 46.7005 9.72C46.7765 9.78967 46.8778 9.84667 47.0045 9.891C47.1312 9.929 47.2768 9.95117 47.4415 9.9575C47.6062 9.96383 47.774 9.95433 47.945 9.929C48.1223 9.90367 48.2965 9.8625 48.4675 9.8055L48.5435 11.164ZM48.572 5.4355C48.3883 5.4355 48.23 5.37217 48.097 5.2455C47.9703 5.1125 47.907 4.95733 47.907 4.78C47.907 4.59633 47.9703 4.438 48.097 4.305C48.23 4.172 48.3883 4.1055 48.572 4.1055C48.7493 4.1055 48.9013 4.172 49.028 4.305C49.1547 4.438 49.218 4.59633 49.218 4.78C49.218 4.95733 49.1547 5.1125 49.028 5.2455C48.9013 5.37217 48.7493 5.4355 48.572 5.4355ZM46.9285 5.426C46.7448 5.426 46.5865 5.36267 46.4535 5.236C46.3268 5.103 46.2635 4.94783 46.2635 4.7705C46.2635 4.58683 46.3268 4.4285 46.4535 4.2955C46.5865 4.1625 46.7448 4.096 46.9285 4.096C47.1058 4.096 47.2578 4.1625 47.3845 4.2955C47.5112 4.4285 47.5745 4.58683 47.5745 4.7705C47.5745 4.94783 47.5112 5.103 47.3845 5.236C47.2578 5.36267 47.1058 5.426 46.9285 5.426ZM57.5083 12.0475C57.1853 12.0475 56.875 12.019 56.5773 11.962C56.2796 11.8987 56.0105 11.8163 55.7698 11.715C55.5355 11.6137 55.3423 11.4997 55.1903 11.373L56.0453 10.4515C56.2733 10.5465 56.5076 10.6162 56.7483 10.6605C56.989 10.6985 57.274 10.7175 57.6033 10.7175C57.844 10.7175 58.015 10.7808 58.1163 10.9075C58.224 11.0278 58.2778 11.1798 58.2778 11.3635C58.2778 11.5598 58.2113 11.7245 58.0783 11.8575C57.9453 11.9842 57.7553 12.0475 57.5083 12.0475ZM50.2788 12.0475L50.3738 10.7175H52.5018C53.0971 10.7175 53.5911 10.6953 53.9838 10.651C54.3828 10.6067 54.6995 10.5433 54.9338 10.461C55.1681 10.3723 55.3328 10.271 55.4278 10.157C55.5291 10.043 55.5798 9.9195 55.5798 9.7865C55.5798 9.66617 55.5513 9.55217 55.4943 9.4445C55.4373 9.3305 55.3518 9.23867 55.2378 9.169C55.1238 9.09933 54.975 9.0645 54.7913 9.0645C54.557 9.0645 54.3226 9.1215 54.0883 9.2355C53.854 9.34317 53.626 9.492 53.4043 9.682C53.1826 9.86567 52.9705 10.0715 52.7678 10.2995C52.5715 10.5275 52.391 10.7587 52.2263 10.993L50.7918 10.7935C51.0578 10.3818 51.346 9.99233 51.6563 9.625C51.973 9.25133 52.3055 8.92517 52.6538 8.6465C53.0085 8.3615 53.3726 8.13983 53.7463 7.9815C54.1263 7.81683 54.5126 7.7345 54.9053 7.7345C55.3233 7.7345 55.6811 7.82 55.9788 7.991C56.2765 8.162 56.5045 8.39633 56.6628 8.694C56.8275 8.99167 56.9098 9.33683 56.9098 9.7295C56.9098 10.1412 56.7926 10.5117 56.5583 10.841C56.3303 11.1703 55.9408 11.4427 55.3898 11.658C55.1555 11.7467 54.9021 11.8195 54.6298 11.8765C54.3575 11.9335 54.0376 11.9747 53.6703 12C53.303 12.0317 52.8628 12.0475 52.3498 12.0475H50.2788ZM51.2668 11.0785L51.0673 5.046H52.3973L52.5683 9.606L51.2668 11.0785ZM57.5151 12.0475L57.6101 10.7175C57.8191 10.7175 57.9901 10.7017 58.1231 10.67C58.2561 10.632 58.3638 10.5528 58.4461 10.4325C58.5348 10.3058 58.6108 10.119 58.6741 9.872C58.7438 9.61867 58.8198 9.27667 58.9021 8.846L60.1371 9.074C60.1181 9.169 60.096 9.27983 60.0706 9.4065C60.0453 9.53317 60.0231 9.663 60.0041 9.796C59.9851 9.92267 59.9756 10.0367 59.9756 10.138C59.9756 10.3153 60.0326 10.4578 60.1466 10.5655C60.2606 10.6668 60.476 10.7175 60.7926 10.7175C60.951 10.7175 61.0871 10.7017 61.2011 10.67C61.3215 10.632 61.4228 10.5528 61.5051 10.4325C61.5938 10.3058 61.6698 10.1127 61.7331 9.853C61.8028 9.587 61.8693 9.22917 61.9326 8.7795L63.1866 8.979C63.1613 9.12467 63.136 9.27983 63.1106 9.4445C63.0853 9.60917 63.0631 9.76117 63.0441 9.9005C63.0251 10.0398 63.0156 10.1538 63.0156 10.2425C63.0156 10.3248 63.0378 10.404 63.0821 10.48C63.1328 10.5497 63.2215 10.6067 63.3481 10.651C63.4811 10.6953 63.668 10.7175 63.9086 10.7175C64.0796 10.7175 64.2253 10.6953 64.3456 10.651C64.4723 10.6067 64.5673 10.5338 64.6306 10.4325C64.7003 10.3312 64.7351 10.1982 64.7351 10.0335C64.7351 9.79917 64.6813 9.492 64.5736 9.112C64.466 8.732 64.3393 8.333 64.1936 7.915L65.5331 7.516C65.6345 7.78833 65.7231 8.07967 65.7991 8.39C65.8815 8.694 65.9448 8.99167 65.9891 9.283C66.0398 9.568 66.0651 9.81817 66.0651 10.0335C66.0651 10.3565 66.0145 10.6447 65.9131 10.898C65.8118 11.145 65.6693 11.354 65.4856 11.525C65.302 11.696 65.0835 11.8258 64.8301 11.9145C64.5768 12.0032 64.2981 12.0475 63.9941 12.0475C63.6268 12.0475 63.326 12.0127 63.0916 11.943C62.8573 11.867 62.6768 11.7435 62.5501 11.5725C62.4298 11.3952 62.3506 11.1545 62.3126 10.8505H62.6356C62.5026 11.2242 62.3538 11.4965 62.1891 11.6675C62.0245 11.8322 61.8281 11.9367 61.6001 11.981C61.3785 12.0253 61.0998 12.0475 60.7641 12.0475C60.5551 12.0475 60.3398 12.0253 60.1181 11.981C59.9028 11.9303 59.7096 11.8163 59.5386 11.639C59.3676 11.4617 59.241 11.1862 59.1586 10.8125L59.6716 10.7935C59.5386 11.1672 59.3645 11.4427 59.1491 11.62C58.9401 11.7973 58.6995 11.9145 58.4271 11.9715C58.1548 12.0222 57.8508 12.0475 57.5151 12.0475ZM67.302 12L67.1025 5.046H68.4325L68.632 12H67.302ZM69.6811 14.185L69.4056 12.855C69.8553 12.798 70.248 12.7283 70.5836 12.646C70.9193 12.57 71.2011 12.4623 71.4291 12.323C71.6571 12.1837 71.8281 11.9937 71.9421 11.753C72.0561 11.506 72.1131 11.1893 72.1131 10.803C72.1131 10.4293 72.0561 10.1317 71.9421 9.91C71.8281 9.68833 71.6761 9.5775 71.4861 9.5775C71.3531 9.5775 71.2423 9.625 71.1536 9.72C71.065 9.80867 70.9985 9.91633 70.9541 10.043C70.9161 10.1633 70.8971 10.271 70.8971 10.366C70.8971 10.423 70.913 10.4832 70.9446 10.5465C70.9763 10.6098 71.046 10.6637 71.1536 10.708C71.2613 10.7523 71.4291 10.7777 71.6571 10.784C71.8915 10.7903 72.2081 10.7682 72.6071 10.7175H74.2031C74.4438 10.7175 74.6148 10.7808 74.7161 10.9075C74.8238 11.0278 74.8776 11.1798 74.8776 11.3635C74.8776 11.5598 74.8111 11.7245 74.6781 11.8575C74.5451 11.9842 74.3551 12.0475 74.1081 12.0475H71.4956C71.0966 12.0475 70.7546 12 70.4696 11.905C70.1846 11.81 69.9661 11.658 69.8141 11.449C69.6621 11.2337 69.5861 10.9487 69.5861 10.594C69.5861 10.309 69.6336 10.024 69.7286 9.739C69.83 9.454 69.9693 9.19433 70.1466 8.96C70.324 8.71933 70.5298 8.52933 70.7641 8.39C71.0048 8.24433 71.2645 8.1715 71.5431 8.1715C71.9231 8.1715 72.2556 8.28867 72.5406 8.523C72.8256 8.75733 73.0473 9.06767 73.2056 9.454C73.3703 9.84033 73.4526 10.2615 73.4526 10.7175C73.4526 11.4332 73.3006 12.0412 72.9966 12.5415C72.6926 13.0418 72.2588 13.4282 71.6951 13.7005C71.1315 13.9792 70.4601 14.1407 69.6811 14.185ZM74.1216 12.0475L74.2166 10.7175C74.4952 10.7175 74.7137 10.6985 74.8721 10.6605C75.0367 10.6225 75.1539 10.5528 75.2236 10.4515C75.2932 10.3438 75.3281 10.1918 75.3281 9.9955C75.3281 9.81817 75.3027 9.606 75.2521 9.359C75.2077 9.112 75.1476 8.8555 75.0716 8.5895C74.9956 8.3235 74.9196 8.07967 74.8436 7.858L76.1546 7.497C76.2306 7.71233 76.3066 7.9625 76.3826 8.2475C76.4586 8.5325 76.5219 8.827 76.5726 9.131C76.6296 9.42867 76.6581 9.71683 76.6581 9.9955C76.6581 10.3438 76.6137 10.6383 76.5251 10.879C76.4364 11.1133 76.3129 11.3097 76.1546 11.468C76.0026 11.62 75.8189 11.7403 75.6036 11.829C75.3946 11.9113 75.1634 11.9683 74.9101 12C74.6567 12.0317 74.3939 12.0475 74.1216 12.0475ZM75.2901 14.2325C75.1064 14.2325 74.9481 14.1692 74.8151 14.0425C74.6884 13.9158 74.6251 13.7607 74.6251 13.577C74.6251 13.3933 74.6884 13.2318 74.8151 13.0925C74.9481 12.9595 75.1064 12.893 75.2901 12.893C75.4737 12.893 75.6289 12.9595 75.7556 13.0925C75.8886 13.2318 75.9551 13.3933 75.9551 13.577C75.9551 13.7607 75.8886 13.9158 75.7556 14.0425C75.6289 14.1692 75.4737 14.2325 75.2901 14.2325ZM79.5824 11.734C79.5824 11.5883 79.5951 11.4173 79.6204 11.221C79.6458 11.0247 79.6933 10.803 79.7629 10.556C79.8326 10.3027 79.9371 10.0208 80.0764 9.7105L81.2449 10.119C81.1753 10.3153 81.1151 10.4958 81.0644 10.6605C81.0138 10.8188 80.9758 10.9677 80.9504 11.107C80.9251 11.24 80.9124 11.373 80.9124 11.506C80.9124 11.791 80.9821 12.038 81.1214 12.247C81.2671 12.4623 81.4634 12.627 81.7104 12.741C81.9638 12.8613 82.2551 12.9215 82.5844 12.9215C83.1228 12.9215 83.5344 12.8328 83.8194 12.6555C84.1108 12.4845 84.3071 12.2122 84.4084 11.8385C84.5161 11.4585 84.5573 10.9677 84.5319 10.366L84.3419 5.046H85.6814L85.8239 9.5395C85.8366 9.85617 85.8809 10.1 85.9569 10.271C86.0329 10.442 86.1501 10.5592 86.3084 10.6225C86.4731 10.6858 86.6853 10.7175 86.9449 10.7175C87.1856 10.7175 87.3566 10.7808 87.4579 10.9075C87.5593 11.0278 87.6099 11.1798 87.6099 11.3635C87.6099 11.5598 87.5434 11.7245 87.4104 11.8575C87.2774 11.9842 87.0906 12.0475 86.8499 12.0475C86.7106 12.0475 86.5618 12.0285 86.4034 11.9905C86.2451 11.9525 86.0931 11.8923 85.9474 11.81C85.8018 11.7277 85.6751 11.62 85.5674 11.487C85.4598 11.3477 85.3869 11.1767 85.3489 10.974L85.8619 10.7175C85.8619 11.3572 85.7859 11.8987 85.6339 12.342C85.4883 12.7853 85.2729 13.1432 84.9879 13.4155C84.7093 13.6878 84.3641 13.8842 83.9524 14.0045C83.5471 14.1312 83.0784 14.1945 82.5464 14.1945C82.1411 14.1945 81.7579 14.1438 81.3969 14.0425C81.0423 13.9412 80.7288 13.7892 80.4564 13.5865C80.1841 13.3838 79.9688 13.1273 79.8104 12.817C79.6584 12.513 79.5824 12.152 79.5824 11.734ZM86.8501 12.0475L86.9451 10.7175C87.1034 10.7175 87.2238 10.6858 87.3061 10.6225C87.3884 10.5592 87.4708 10.4483 87.5531 10.29C87.6354 10.1317 87.7494 9.91633 87.8951 9.644C88.0534 9.34 88.2181 9.08667 88.3891 8.884C88.5601 8.675 88.7311 8.51033 88.9021 8.39C89.0794 8.26333 89.2536 8.17467 89.4246 8.124C89.6019 8.067 89.7761 8.0385 89.9471 8.0385C90.1814 8.0385 90.3999 8.08917 90.6026 8.1905C90.8116 8.2855 91.0111 8.45333 91.2011 8.694C91.3911 8.92833 91.5716 9.25133 91.7426 9.663C91.8629 9.948 91.9833 10.1665 92.1036 10.3185C92.2239 10.4705 92.3474 10.575 92.4741 10.632C92.6071 10.689 92.7401 10.7175 92.8731 10.7175C93.1138 10.7175 93.2848 10.7808 93.3861 10.9075C93.4874 11.0278 93.5381 11.1798 93.5381 11.3635C93.5381 11.5598 93.4716 11.7245 93.3386 11.8575C93.2056 11.9842 93.0188 12.0475 92.7781 12.0475C92.4678 12.0475 92.1859 11.9968 91.9326 11.8955C91.6793 11.7942 91.4798 11.6422 91.3341 11.4395L91.6096 11.2305C91.5526 11.3635 91.4671 11.5028 91.3531 11.6485C91.2454 11.7942 91.1029 11.9177 90.9256 12.019C90.7546 12.1203 90.5488 12.171 90.3081 12.171C90.1498 12.171 89.9629 12.1393 89.7476 12.076C89.5386 12.019 89.3201 11.9208 89.0921 11.7815C88.8704 11.6358 88.6646 11.4395 88.4746 11.1925C88.3543 11.4142 88.2213 11.5883 88.0756 11.715C87.9299 11.8353 87.7589 11.9208 87.5626 11.9715C87.3663 12.0222 87.1288 12.0475 86.8501 12.0475ZM89.0256 10.0715C89.0889 10.1665 89.1649 10.2615 89.2536 10.3565C89.3423 10.4515 89.4404 10.537 89.5481 10.613C89.6558 10.6827 89.7698 10.7397 89.8901 10.784C90.0168 10.8283 90.1403 10.8505 90.2606 10.8505C90.3873 10.8505 90.4918 10.803 90.5741 10.708C90.6564 10.6067 90.6596 10.4578 90.5836 10.2615C90.5519 10.1792 90.5076 10.0873 90.4506 9.986C90.3999 9.87833 90.3398 9.777 90.2701 9.682C90.2068 9.587 90.1339 9.50783 90.0516 9.4445C89.9756 9.38117 89.8964 9.3495 89.8141 9.3495C89.7318 9.3495 89.6463 9.37483 89.5576 9.4255C89.4689 9.47617 89.3803 9.55533 89.2916 9.663C89.2029 9.76433 89.1143 9.9005 89.0256 10.0715ZM92.7403 12.0475L92.8353 10.7175C93.2787 10.7175 93.6777 10.689 94.0323 10.632C94.387 10.5687 94.6973 10.4863 94.9633 10.385C95.2357 10.2837 95.4605 10.1665 95.6378 10.0335C95.8215 9.9005 95.9577 9.76117 96.0463 9.6155C96.1413 9.4635 96.1888 9.31467 96.1888 9.169C96.1888 9.08667 96.1667 9.01067 96.1223 8.941C96.0843 8.865 96.0178 8.80483 95.9228 8.7605C95.8278 8.70983 95.698 8.6845 95.5333 8.6845C95.451 8.6845 95.3528 8.694 95.2388 8.713C95.1248 8.732 95.0108 8.7605 94.8968 8.7985C94.7828 8.83017 94.6752 8.8745 94.5738 8.9315C94.7068 9.03283 94.8525 9.16267 95.0108 9.321C95.1692 9.473 95.3275 9.6345 95.4858 9.8055C95.6442 9.97017 95.7803 10.1317 95.8943 10.29C96.0273 10.347 96.173 10.404 96.3313 10.461C96.496 10.5117 96.6733 10.556 96.8633 10.594C97.0533 10.632 97.2528 10.6637 97.4618 10.689C97.6708 10.708 97.8862 10.7175 98.1078 10.7175C98.3485 10.7175 98.5195 10.7808 98.6208 10.9075C98.7285 11.0278 98.7823 11.1798 98.7823 11.3635C98.7823 11.5598 98.7158 11.7245 98.5828 11.8575C98.4498 11.9842 98.2598 12.0475 98.0128 12.0475C97.5062 12.0475 97.0565 12.0095 96.6638 11.9335C96.2712 11.8512 95.9197 11.734 95.6093 11.582C95.3053 11.4237 95.0203 11.2337 94.7543 11.012C94.6783 10.879 94.5707 10.7365 94.4313 10.5845C94.2983 10.4262 94.1558 10.2742 94.0038 10.1285C93.8582 9.98283 93.7252 9.8625 93.6048 9.7675C93.5732 9.74217 93.5352 9.67567 93.4908 9.568C93.4528 9.454 93.418 9.33683 93.3863 9.2165C93.3547 9.08983 93.3388 9.00117 93.3388 8.9505C93.3388 8.80483 93.4053 8.64967 93.5383 8.485C93.6777 8.32033 93.8613 8.16833 94.0893 8.029C94.3237 7.88333 94.5802 7.76617 94.8588 7.6775C95.1438 7.5825 95.432 7.535 95.7233 7.535C96.116 7.535 96.4422 7.59517 96.7018 7.7155C96.9678 7.8295 97.1673 7.991 97.3003 8.2C97.4333 8.40267 97.4998 8.64017 97.4998 8.9125C97.4998 9.2165 97.4333 9.5205 97.3003 9.8245C97.1673 10.1222 96.971 10.404 96.7113 10.67C96.458 10.936 96.1382 11.1735 95.7518 11.3825C95.3718 11.5852 94.9285 11.7467 94.4218 11.867C93.9215 11.9873 93.361 12.0475 92.7403 12.0475ZM98.02 12.0475L98.115 10.7175C98.495 10.7175 98.7864 10.6985 98.989 10.6605C99.1917 10.6225 99.331 10.5528 99.407 10.4515C99.4894 10.3438 99.5305 10.1918 99.5305 9.9955C99.5305 9.81817 99.5052 9.606 99.4545 9.359C99.4102 9.112 99.35 8.8555 99.274 8.5895C99.2044 8.3235 99.1284 8.07967 99.046 7.858L100.357 7.497C100.439 7.71233 100.519 7.9625 100.595 8.2475C100.671 8.5325 100.734 8.827 100.785 9.131C100.835 9.42867 100.861 9.71683 100.861 9.9955C100.861 10.4262 100.791 10.7777 100.652 11.05C100.512 11.316 100.316 11.5218 100.063 11.6675C99.8155 11.8132 99.5179 11.9145 99.1695 11.9715C98.8212 12.0222 98.438 12.0475 98.02 12.0475ZM100.367 14.2515C100.183 14.2515 100.025 14.185 99.8915 14.052C99.7649 13.9253 99.7015 13.7733 99.7015 13.596C99.7015 13.4123 99.7649 13.254 99.8915 13.121C100.025 12.988 100.183 12.9215 100.367 12.9215C100.544 12.9215 100.696 12.988 100.823 13.121C100.949 13.254 101.013 13.4123 101.013 13.596C101.013 13.7733 100.949 13.9253 100.823 14.052C100.696 14.185 100.544 14.2515 100.367 14.2515ZM98.723 14.2515C98.5394 14.2515 98.381 14.185 98.248 14.052C98.1214 13.9253 98.058 13.7733 98.058 13.596C98.058 13.4123 98.1214 13.254 98.248 13.121C98.381 12.988 98.5394 12.9215 98.723 12.9215C98.9004 12.9215 99.0524 12.988 99.179 13.121C99.3057 13.254 99.369 13.4123 99.369 13.596C99.369 13.7733 99.3057 13.9253 99.179 14.052C99.0524 14.185 98.9004 14.2515 98.723 14.2515Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function qL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2003_5139",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2003_5139)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.0629 12.0978C52.7322 12.0978 52.4376 12.0405 52.179 11.9258C51.9203 11.8088 51.7157 11.6368 51.565 11.4096C51.4165 11.1802 51.3423 10.8946 51.3423 10.5527C51.3423 10.2649 51.3952 10.0231 51.5009 9.82741C51.6066 9.63175 51.7505 9.47431 51.9327 9.35511C52.1149 9.23591 52.3218 9.14595 52.5534 9.08523C52.7873 9.0245 53.0325 8.98177 53.2889 8.95703C53.5903 8.92554 53.8332 8.89631 54.0176 8.86932C54.202 8.84008 54.3358 8.79735 54.419 8.74112C54.5022 8.6849 54.5439 8.60168 54.5439 8.49148V8.47124C54.5439 8.25758 54.4764 8.09227 54.3414 7.97532C54.2087 7.85837 54.0198 7.79989 53.7747 7.79989C53.516 7.79989 53.3103 7.85724 53.1573 7.97195C53.0044 8.0844 52.9032 8.22609 52.8537 8.39702L51.5245 8.28906C51.592 7.97419 51.7247 7.70206 51.9226 7.47266C52.1205 7.241 52.3758 7.06333 52.6884 6.93963C53.0033 6.81368 53.3676 6.75071 53.7814 6.75071C54.0693 6.75071 54.3448 6.78445 54.608 6.85192C54.8733 6.91939 55.1084 7.02397 55.313 7.16566C55.5199 7.30735 55.683 7.48952 55.8022 7.71218C55.9214 7.93259 55.981 8.19685 55.981 8.50497V12H54.6181V11.2814H54.5776C54.4944 11.4434 54.383 11.5862 54.2436 11.7099C54.1042 11.8313 53.9366 11.9269 53.7409 11.9966C53.5453 12.0641 53.3192 12.0978 53.0629 12.0978ZM53.4744 11.106C53.6858 11.106 53.8725 11.0644 54.0344 10.9812C54.1964 10.8957 54.3234 10.781 54.4157 10.6371C54.5079 10.4931 54.554 10.3301 54.554 10.1479V9.59801C54.509 9.62725 54.4471 9.65424 54.3684 9.67898C54.292 9.70147 54.2054 9.72283 54.1087 9.74308C54.012 9.76107 53.9152 9.77794 53.8185 9.79368C53.7218 9.80717 53.6341 9.81954 53.5554 9.83079C53.3867 9.85553 53.2394 9.89489 53.1135 9.94886C52.9875 10.0028 52.8897 10.0759 52.82 10.1681C52.7502 10.2581 52.7154 10.3706 52.7154 10.5055C52.7154 10.7012 52.7862 10.8507 52.9279 10.9542C53.0719 11.0554 53.254 11.106 53.4744 11.106ZM61.404 4.91548L61.8426 5.85334C61.6964 5.97479 61.5345 6.06475 61.3568 6.12322C61.1791 6.17945 60.9666 6.21656 60.7192 6.23455C60.474 6.25254 60.1749 6.26491 59.8218 6.27166C59.4215 6.27616 59.0954 6.34026 58.8435 6.46396C58.5916 6.58765 58.4004 6.7822 58.27 7.04759C58.1395 7.31072 58.0541 7.65483 58.0136 8.0799H58.0642C58.2194 7.76278 58.4375 7.51764 58.7187 7.34446C59.002 7.17128 59.3518 7.08469 59.7678 7.08469C60.2087 7.08469 60.5944 7.1814 60.925 7.37482C61.2578 7.56824 61.5165 7.846 61.7009 8.2081C61.8853 8.57019 61.9775 9.00426 61.9775 9.5103C61.9775 10.0366 61.8741 10.4943 61.6672 10.8833C61.4625 11.2702 61.1713 11.5704 60.7934 11.7841C60.4156 11.9955 59.9658 12.1012 59.444 12.1012C58.92 12.1012 58.4679 11.991 58.0878 11.7706C57.71 11.5502 57.4176 11.2252 57.2107 10.7956C57.006 10.3661 56.9037 9.83754 56.9037 9.21005V8.78498C56.9037 7.53675 57.1466 6.61127 57.6324 6.00852C58.1182 5.40578 58.8322 5.0999 59.7746 5.09091C60.031 5.08641 60.2626 5.08529 60.4695 5.08754C60.6765 5.08978 60.8575 5.07966 61.0127 5.05717C61.1701 5.03468 61.3006 4.98745 61.404 4.91548ZM59.4507 10.9879C59.6711 10.9879 59.8601 10.9306 60.0175 10.8159C60.1772 10.7012 60.2997 10.537 60.3852 10.3233C60.4729 10.1097 60.5168 9.8544 60.5168 9.55753C60.5168 9.2629 60.4729 9.01326 60.3852 8.80859C60.2997 8.60168 60.1772 8.44425 60.0175 8.33629C59.8578 8.22834 59.6666 8.17436 59.444 8.17436C59.2776 8.17436 59.128 8.20472 58.9953 8.26545C58.8626 8.32617 58.749 8.41613 58.6546 8.53533C58.5624 8.65228 58.4904 8.79735 58.4387 8.97053C58.3892 9.14145 58.3644 9.33712 58.3644 9.55753C58.3644 10.0006 58.46 10.3503 58.6512 10.6067C58.8446 10.8609 59.1111 10.9879 59.4507 10.9879ZM65.2727 12.1012C64.7487 12.1012 64.2955 11.9899 63.9131 11.7672C63.533 11.5423 63.2395 11.2297 63.0326 10.8294C62.8257 10.4268 62.7223 9.96011 62.7223 9.42933C62.7223 8.89406 62.8257 8.42625 63.0326 8.02592C63.2395 7.62334 63.533 7.31072 63.9131 7.08807C64.2955 6.86316 64.7487 6.75071 65.2727 6.75071C65.7967 6.75071 66.2488 6.86316 66.6289 7.08807C67.0112 7.31072 67.3058 7.62334 67.5127 8.02592C67.7197 8.42625 67.8231 8.89406 67.8231 9.42933C67.8231 9.96011 67.7197 10.4268 67.5127 10.8294C67.3058 11.2297 67.0112 11.5423 66.6289 11.7672C66.2488 11.9899 65.7967 12.1012 65.2727 12.1012ZM65.2794 10.9879C65.5178 10.9879 65.7169 10.9205 65.8766 10.7855C66.0362 10.6483 66.1566 10.4616 66.2375 10.2255C66.3207 9.98935 66.3623 9.72058 66.3623 9.41921C66.3623 9.11784 66.3207 8.84908 66.2375 8.61293C66.1566 8.37678 66.0362 8.1901 65.8766 8.05291C65.7169 7.91572 65.5178 7.84712 65.2794 7.84712C65.0388 7.84712 64.8364 7.91572 64.6722 8.05291C64.5103 8.1901 64.3877 8.37678 64.3045 8.61293C64.2235 8.84908 64.183 9.11784 64.183 9.41921C64.183 9.72058 64.2235 9.98935 64.3045 10.2255C64.3877 10.4616 64.5103 10.6483 64.6722 10.7855C64.8364 10.9205 65.0388 10.9879 65.2794 10.9879ZM68.2558 7.94833V6.81818H72.9518V7.94833H71.2819V12H69.9122V7.94833H68.2558ZM75.1151 12.0978C74.7845 12.0978 74.4899 12.0405 74.2312 11.9258C73.9726 11.8088 73.7679 11.6368 73.6172 11.4096C73.4688 11.1802 73.3946 10.8946 73.3946 10.5527C73.3946 10.2649 73.4474 10.0231 73.5531 9.82741C73.6588 9.63175 73.8028 9.47431 73.985 9.35511C74.1671 9.23591 74.374 9.14595 74.6057 9.08523C74.8396 9.0245 75.0847 8.98177 75.3411 8.95703C75.6425 8.92554 75.8854 8.89631 76.0698 8.86932C76.2542 8.84008 76.3881 8.79735 76.4713 8.74112C76.5545 8.6849 76.5961 8.60168 76.5961 8.49148V8.47124C76.5961 8.25758 76.5286 8.09227 76.3937 7.97532C76.261 7.85837 76.0721 7.79989 75.8269 7.79989C75.5683 7.79989 75.3625 7.85724 75.2096 7.97195C75.0566 8.0844 74.9554 8.22609 74.9059 8.39702L73.5767 8.28906C73.6442 7.97419 73.7769 7.70206 73.9748 7.47266C74.1727 7.241 74.428 7.06333 74.7406 6.93963C75.0555 6.81368 75.4198 6.75071 75.8337 6.75071C76.1216 6.75071 76.3971 6.78445 76.6602 6.85192C76.9256 6.91939 77.1606 7.02397 77.3653 7.16566C77.5722 7.30735 77.7352 7.48952 77.8544 7.71218C77.9736 7.93259 78.0332 8.19685 78.0332 8.50497V12H76.6703V11.2814H76.6298C76.5466 11.4434 76.4353 11.5862 76.2959 11.7099C76.1564 11.8313 75.9889 11.9269 75.7932 11.9966C75.5975 12.0641 75.3715 12.0978 75.1151 12.0978ZM75.5267 11.106C75.7381 11.106 75.9248 11.0644 76.0867 10.9812C76.2486 10.8957 76.3757 10.781 76.4679 10.6371C76.5601 10.4931 76.6062 10.3301 76.6062 10.1479V9.59801C76.5612 9.62725 76.4994 9.65424 76.4207 9.67898C76.3442 9.70147 76.2576 9.72283 76.1609 9.74308C76.0642 9.76107 75.9675 9.77794 75.8708 9.79368C75.7741 9.80717 75.6864 9.81954 75.6076 9.83079C75.439 9.85553 75.2917 9.89489 75.1657 9.94886C75.0398 10.0028 74.9419 10.0759 74.8722 10.1681C74.8025 10.2581 74.7676 10.3706 74.7676 10.5055C74.7676 10.7012 74.8385 10.8507 74.9802 10.9542C75.1241 11.0554 75.3063 11.106 75.5267 11.106ZM81.5097 12.1012C80.9767 12.1012 80.5179 11.9933 80.1333 11.7773C79.751 11.5592 79.4563 11.2511 79.2494 10.853C79.0425 10.4527 78.9391 9.97923 78.9391 9.43271C78.9391 8.89968 79.0425 8.43188 79.2494 8.0293C79.4563 7.62672 79.7476 7.31297 80.1232 7.08807C80.501 6.86316 80.9441 6.75071 81.4524 6.75071C81.7942 6.75071 82.1125 6.80581 82.4071 6.91602C82.704 7.02397 82.9626 7.18703 83.183 7.40518C83.4057 7.62334 83.5789 7.89773 83.7025 8.22834C83.8262 8.5567 83.8881 8.94129 83.8881 9.3821V9.77681H79.5126V8.88619H82.5353C82.5353 8.67927 82.4903 8.49598 82.4003 8.33629C82.3104 8.17661 82.1856 8.05179 82.0259 7.96183C81.8684 7.86961 81.6851 7.82351 81.476 7.82351C81.2578 7.82351 81.0644 7.87411 80.8957 7.97532C80.7293 8.07428 80.5989 8.2081 80.5044 8.37678C80.4099 8.54321 80.3616 8.72875 80.3593 8.93342V9.78018C80.3593 10.0366 80.4066 10.2581 80.501 10.4448C80.5977 10.6315 80.7338 10.7754 80.9092 10.8766C81.0847 10.9778 81.2927 11.0284 81.5333 11.0284C81.693 11.0284 81.8392 11.0059 81.9719 10.9609C82.1046 10.916 82.2182 10.8485 82.3126 10.7585C82.4071 10.6686 82.4791 10.5584 82.5285 10.4279L83.8577 10.5156C83.7903 10.835 83.6519 11.1139 83.4428 11.3523C83.2359 11.5884 82.9682 11.7728 82.6399 11.9055C82.3138 12.036 81.937 12.1012 81.5097 12.1012ZM84.4262 7.94833V6.81818H89.1222V7.94833H87.4523V12H86.0826V7.94833H84.4262ZM95.7985 8.83558V9.96573H93.0929V8.83558H95.7985ZM93.5652 6.81818V12H92.1922V6.81818H93.5652ZM96.6993 6.81818V12H95.3363V6.81818H96.6993ZM99.2919 12.0978C98.9612 12.0978 98.6666 12.0405 98.408 11.9258C98.1493 11.8088 97.9447 11.6368 97.794 11.4096C97.6456 11.1802 97.5713 10.8946 97.5713 10.5527C97.5713 10.2649 97.6242 10.0231 97.7299 9.82741C97.8356 9.63175 97.9795 9.47431 98.1617 9.35511C98.3439 9.23591 98.5508 9.14595 98.7824 9.08523C99.0164 9.0245 99.2615 8.98177 99.5179 8.95703C99.8193 8.92554 100.062 8.89631 100.247 8.86932C100.431 8.84008 100.565 8.79735 100.648 8.74112C100.731 8.6849 100.773 8.60168 100.773 8.49148V8.47124C100.773 8.25758 100.705 8.09227 100.57 7.97532C100.438 7.85837 100.249 7.79989 100.004 7.79989C99.745 7.79989 99.5393 7.85724 99.3863 7.97195C99.2334 8.0844 99.1322 8.22609 99.0827 8.39702L97.7535 8.28906C97.821 7.97419 97.9537 7.70206 98.1516 7.47266C98.3495 7.241 98.6048 7.06333 98.9174 6.93963C99.2323 6.81368 99.5966 6.75071 100.01 6.75071C100.298 6.75071 100.574 6.78445 100.837 6.85192C101.102 6.91939 101.337 7.02397 101.542 7.16566C101.749 7.30735 101.912 7.48952 102.031 7.71218C102.15 7.93259 102.21 8.19685 102.21 8.50497V12H100.847V11.2814H100.807C100.723 11.4434 100.612 11.5862 100.473 11.7099C100.333 11.8313 100.166 11.9269 99.9699 11.9966C99.7743 12.0641 99.5483 12.0978 99.2919 12.0978ZM99.7034 11.106C99.9148 11.106 100.102 11.0644 100.263 10.9812C100.425 10.8957 100.552 10.781 100.645 10.6371C100.737 10.4931 100.783 10.3301 100.783 10.1479V9.59801C100.738 9.62725 100.676 9.65424 100.597 9.67898C100.521 9.70147 100.434 9.72283 100.338 9.74308C100.241 9.76107 100.144 9.77794 100.048 9.79368C99.9508 9.80717 99.8631 9.81954 99.7844 9.83079C99.6157 9.85553 99.4684 9.89489 99.3425 9.94886C99.2165 10.0028 99.1187 10.0759 99.049 10.1681C98.9792 10.2581 98.9444 10.3706 98.9444 10.5055C98.9444 10.7012 99.0152 10.8507 99.1569 10.9542C99.3009 11.0554 99.483 11.106 99.7034 11.106Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function JL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2003_5115",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2003_5115)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M51.9496 8.54545C51.9496 9.29889 51.8068 9.93987 51.5211 10.4684C51.2377 10.9969 50.8509 11.4006 50.3606 11.6795C49.8726 11.9561 49.3238 12.0945 48.7143 12.0945C48.1003 12.0945 47.5493 11.955 47.0613 11.6761C46.5732 11.3973 46.1875 10.9935 45.9041 10.465C45.6207 9.93649 45.479 9.29664 45.479 8.54545C45.479 7.79202 45.6207 7.15104 45.9041 6.62251C46.1875 6.09399 46.5732 5.69141 47.0613 5.41477C47.5493 5.13589 48.1003 4.99645 48.7143 4.99645C49.3238 4.99645 49.8726 5.13589 50.3606 5.41477C50.8509 5.69141 51.2377 6.09399 51.5211 6.62251C51.8068 7.15104 51.9496 7.79202 51.9496 8.54545ZM50.4686 8.54545C50.4686 8.05741 50.3955 7.64583 50.2493 7.31072C50.1054 6.97562 49.9018 6.72147 49.6387 6.5483C49.3755 6.37512 49.0674 6.28853 48.7143 6.28853C48.3612 6.28853 48.0531 6.37512 47.79 6.5483C47.5268 6.72147 47.3221 6.97562 47.176 7.31072C47.032 7.64583 46.96 8.05741 46.96 8.54545C46.96 9.0335 47.032 9.44508 47.176 9.78018C47.3221 10.1153 47.5268 10.3694 47.79 10.5426C48.0531 10.7158 48.3612 10.8024 48.7143 10.8024C49.0674 10.8024 49.3755 10.7158 49.6387 10.5426C49.9018 10.3694 50.1054 10.1153 50.2493 9.78018C50.3955 9.44508 50.4686 9.0335 50.4686 8.54545ZM54.4418 9.00426V12H53.0047V6.81818H54.3743V7.73242H54.4351C54.5498 7.43105 54.7421 7.19265 55.0119 7.01722C55.2818 6.83955 55.6091 6.75071 55.9937 6.75071C56.3535 6.75071 56.6672 6.82943 56.9349 6.98686C57.2025 7.14429 57.4106 7.3692 57.559 7.66158C57.7074 7.9517 57.7816 8.29806 57.7816 8.70064V12H56.3445V8.95703C56.3468 8.63991 56.2658 8.39252 56.1016 8.21484C55.9374 8.03492 55.7114 7.94496 55.4235 7.94496C55.2301 7.94496 55.0592 7.98656 54.9107 8.06978C54.7645 8.15299 54.6498 8.27444 54.5666 8.43413C54.4857 8.59156 54.4441 8.78161 54.4418 9.00426ZM60.8238 12.0843C60.4302 12.0843 60.0737 11.9831 59.7544 11.7807C59.4372 11.5761 59.1853 11.2758 58.9987 10.88C58.8142 10.4819 58.722 9.99384 58.722 9.41584C58.722 8.82209 58.8176 8.32842 59.0088 7.93484C59.2 7.539 59.4541 7.24325 59.7712 7.04759C60.0906 6.84967 60.4403 6.75071 60.8204 6.75071C61.1105 6.75071 61.3523 6.80019 61.5457 6.89915C61.7414 6.99586 61.8988 7.11731 62.018 7.26349C62.1395 7.40743 62.2317 7.54912 62.2947 7.68857H62.3385V5.09091H63.7723V12H62.3554V11.1701H62.2947C62.2272 11.314 62.1316 11.4569 62.0079 11.5985C61.8865 11.738 61.7279 11.8538 61.5322 11.946C61.3388 12.0382 61.1027 12.0843 60.8238 12.0843ZM61.2792 10.9407C61.5109 10.9407 61.7065 10.8777 61.8662 10.7518C62.0281 10.6236 62.1518 10.4448 62.2373 10.2154C62.325 9.98597 62.3689 9.71721 62.3689 9.40909C62.3689 9.10097 62.3261 8.83333 62.2407 8.60618C62.1552 8.37902 62.0315 8.2036 61.8696 8.0799C61.7077 7.9562 61.5109 7.89435 61.2792 7.89435C61.0431 7.89435 60.844 7.95845 60.6821 8.08665C60.5202 8.21484 60.3976 8.39252 60.3144 8.61967C60.2311 8.84683 60.1895 9.10997 60.1895 9.40909C60.1895 9.71046 60.2311 9.97698 60.3144 10.2086C60.3998 10.438 60.5224 10.618 60.6821 10.7484C60.844 10.8766 61.0431 10.9407 61.2792 10.9407ZM67.3154 12.1012C66.7824 12.1012 66.3236 11.9933 65.939 11.7773C65.5566 11.5592 65.262 11.2511 65.0551 10.853C64.8482 10.4527 64.7447 9.97923 64.7447 9.43271C64.7447 8.89968 64.8482 8.43188 65.0551 8.0293C65.262 7.62672 65.5533 7.31297 65.9288 7.08807C66.3067 6.86316 66.7497 6.75071 67.258 6.75071C67.5999 6.75071 67.9181 6.80581 68.2128 6.91602C68.5096 7.02397 68.7683 7.18703 68.9887 7.40518C69.2113 7.62334 69.3845 7.89773 69.5082 8.22834C69.6319 8.5567 69.6938 8.94129 69.6938 9.3821V9.77681H65.3182V8.88619H68.341C68.341 8.67927 68.296 8.49598 68.206 8.33629C68.116 8.17661 67.9912 8.05179 67.8315 7.96183C67.6741 7.86961 67.4908 7.82351 67.2816 7.82351C67.0635 7.82351 66.8701 7.87411 66.7014 7.97532C66.535 8.07428 66.4045 8.2081 66.3101 8.37678C66.2156 8.54321 66.1672 8.72875 66.165 8.93342V9.78018C66.165 10.0366 66.2122 10.2581 66.3067 10.4448C66.4034 10.6315 66.5395 10.7754 66.7149 10.8766C66.8903 10.9778 67.0984 11.0284 67.339 11.0284C67.4987 11.0284 67.6449 11.0059 67.7776 10.9609C67.9103 10.916 68.0238 10.8485 68.1183 10.7585C68.2128 10.6686 68.2847 10.5584 68.3342 10.4279L69.6634 10.5156C69.5959 10.835 69.4576 11.1139 69.2484 11.3523C69.0415 11.5884 68.7739 11.7728 68.4455 11.9055C68.1194 12.036 67.7427 12.1012 67.3154 12.1012ZM70.6316 12V6.81818H72.0249V7.7223H72.0789C72.1733 7.40069 72.3319 7.15779 72.5546 6.99361C72.7772 6.82718 73.0336 6.74396 73.3237 6.74396C73.3957 6.74396 73.4733 6.74846 73.5565 6.75746C73.6397 6.76645 73.7128 6.77882 73.7758 6.79457V8.06978C73.7083 8.04954 73.615 8.03155 73.4958 8.0158C73.3766 8.00006 73.2675 7.99219 73.1685 7.99219C72.9571 7.99219 72.7682 8.03829 72.6018 8.1305C72.4376 8.22047 72.3072 8.34641 72.2104 8.50835C72.116 8.67028 72.0688 8.85695 72.0688 9.06836V12H70.6316ZM78.8303 8.29581L77.5146 8.37678C77.4921 8.26432 77.4437 8.16312 77.3695 8.07315C77.2953 7.98094 77.1974 7.90785 77.076 7.85387C76.9568 7.79764 76.814 7.76953 76.6475 7.76953C76.4249 7.76953 76.2371 7.81676 76.0842 7.91122C75.9312 8.00343 75.8548 8.12713 75.8548 8.28232C75.8548 8.40601 75.9042 8.51059 76.0032 8.59606C76.1022 8.68152 76.272 8.75012 76.5126 8.80185L77.4505 8.99077C77.9542 9.09422 78.3298 9.26065 78.5772 9.49006C78.8246 9.71946 78.9483 10.0208 78.9483 10.3942C78.9483 10.7338 78.8482 11.0318 78.6481 11.2882C78.4502 11.5446 78.178 11.7447 77.8317 11.8887C77.4876 12.0304 77.0906 12.1012 76.6408 12.1012C75.9548 12.1012 75.4083 11.9584 75.0012 11.6728C74.5964 11.3849 74.3591 10.9935 74.2894 10.4988L75.7029 10.4245C75.7457 10.6337 75.8491 10.7934 76.0133 10.9036C76.1775 11.0115 76.3878 11.0655 76.6442 11.0655C76.8961 11.0655 77.0985 11.0172 77.2514 10.9205C77.4066 10.8215 77.4853 10.6944 77.4876 10.5392C77.4853 10.4088 77.4302 10.302 77.3223 10.2188C77.2143 10.1333 77.0479 10.0681 76.823 10.0231L75.9256 9.84428C75.4196 9.74308 75.0429 9.56765 74.7955 9.318C74.5503 9.06836 74.4277 8.75012 74.4277 8.36328C74.4277 8.03042 74.5177 7.74367 74.6976 7.50302C74.8798 7.26237 75.1351 7.07682 75.4634 6.94638C75.794 6.81593 76.1809 6.75071 76.6239 6.75071C77.2784 6.75071 77.7934 6.88903 78.169 7.16566C78.5469 7.44229 78.7673 7.81901 78.8303 8.29581ZM82.6095 6.81818V7.89773H79.4889V6.81818H82.6095ZM80.1974 5.5767H81.6345V10.4077C81.6345 10.5404 81.6548 10.6438 81.6953 10.718C81.7358 10.79 81.792 10.8406 81.8639 10.8699C81.9382 10.8991 82.0236 10.9137 82.1203 10.9137C82.1878 10.9137 82.2553 10.9081 82.3228 10.8968C82.3902 10.8833 82.442 10.8732 82.4779 10.8665L82.704 11.9359C82.632 11.9584 82.5308 11.9843 82.4003 12.0135C82.2699 12.045 82.1113 12.0641 81.9247 12.0708C81.5783 12.0843 81.2747 12.0382 81.0138 11.9325C80.7552 11.8268 80.5539 11.6626 80.4099 11.44C80.266 11.2173 80.1951 10.9362 80.1974 10.5966V5.5767ZM85.8515 12.1012C85.3185 12.1012 84.8597 11.9933 84.4751 11.7773C84.0928 11.5592 83.7981 11.2511 83.5912 10.853C83.3843 10.4527 83.2809 9.97923 83.2809 9.43271C83.2809 8.89968 83.3843 8.43188 83.5912 8.0293C83.7981 7.62672 84.0894 7.31297 84.465 7.08807C84.8428 6.86316 85.2859 6.75071 85.7942 6.75071C86.136 6.75071 86.4543 6.80581 86.7489 6.91602C87.0458 7.02397 87.3044 7.18703 87.5248 7.40518C87.7475 7.62334 87.9206 7.89773 88.0443 8.22834C88.168 8.5567 88.2299 8.94129 88.2299 9.3821V9.77681H83.8544V8.88619H86.8771C86.8771 8.67927 86.8321 8.49598 86.7421 8.33629C86.6522 8.17661 86.5274 8.05179 86.3677 7.96183C86.2102 7.86961 86.0269 7.82351 85.8178 7.82351C85.5996 7.82351 85.4062 7.87411 85.2375 7.97532C85.0711 8.07428 84.9407 8.2081 84.8462 8.37678C84.7517 8.54321 84.7034 8.72875 84.7011 8.93342V9.78018C84.7011 10.0366 84.7484 10.2581 84.8428 10.4448C84.9395 10.6315 85.0756 10.7754 85.251 10.8766C85.4264 10.9778 85.6345 11.0284 85.8751 11.0284C86.0348 11.0284 86.181 11.0059 86.3137 10.9609C86.4464 10.916 86.56 10.8485 86.6544 10.7585C86.7489 10.6686 86.8209 10.5584 86.8703 10.4279L88.1995 10.5156C88.1321 10.835 87.9937 11.1139 87.7846 11.3523C87.5777 11.5884 87.31 11.7728 86.9817 11.9055C86.6556 12.036 86.2788 12.1012 85.8515 12.1012ZM92.4907 9.79368V6.81818H93.9279V12H92.5481V11.0588H92.4941C92.3771 11.3624 92.1826 11.6064 91.9105 11.7908C91.6406 11.9753 91.3111 12.0675 90.922 12.0675C90.5757 12.0675 90.2709 11.9888 90.0078 11.8313C89.7446 11.6739 89.5388 11.4501 89.3904 11.16C89.2442 10.8699 89.17 10.5224 89.1677 10.1175V6.81818H90.6049V9.86115C90.6071 10.167 90.6892 10.4088 90.8512 10.5865C91.0131 10.7641 91.2301 10.853 91.5023 10.853C91.6754 10.853 91.8374 10.8136 91.9881 10.7349C92.1387 10.6539 92.2602 10.5347 92.3524 10.3773C92.4469 10.2199 92.493 10.0253 92.4907 9.79368ZM96.5146 9.00426V12H95.0774V6.81818H96.4471V7.73242H96.5078C96.6225 7.43105 96.8148 7.19265 97.0847 7.01722C97.3546 6.83955 97.6818 6.75071 98.0664 6.75071C98.4263 6.75071 98.74 6.82943 99.0076 6.98686C99.2753 7.14429 99.4833 7.3692 99.6317 7.66158C99.7802 7.9517 99.8544 8.29806 99.8544 8.70064V12H98.4173V8.95703C98.4195 8.63991 98.3385 8.39252 98.1744 8.21484C98.0102 8.03492 97.7842 7.94496 97.4963 7.94496C97.3029 7.94496 97.1319 7.98656 96.9835 8.06978C96.8373 8.15299 96.7226 8.27444 96.6394 8.43413C96.5584 8.59156 96.5168 8.78161 96.5146 9.00426ZM102.897 12.0843C102.503 12.0843 102.146 11.9831 101.827 11.7807C101.51 11.5761 101.258 11.2758 101.071 10.88C100.887 10.4819 100.795 9.99384 100.795 9.41584C100.795 8.82209 100.89 8.32842 101.082 7.93484C101.273 7.539 101.527 7.24325 101.844 7.04759C102.163 6.84967 102.513 6.75071 102.893 6.75071C103.183 6.75071 103.425 6.80019 103.618 6.89915C103.814 6.99586 103.972 7.11731 104.091 7.26349C104.212 7.40743 104.304 7.54912 104.367 7.68857H104.411V5.09091H105.845V12H104.428V11.1701H104.367C104.3 11.314 104.204 11.4569 104.081 11.5985C103.959 11.738 103.801 11.8538 103.605 11.946C103.412 12.0382 103.175 12.0843 102.897 12.0843ZM103.352 10.9407C103.584 10.9407 103.779 10.8777 103.939 10.7518C104.101 10.6236 104.225 10.4448 104.31 10.2154C104.398 9.98597 104.442 9.71721 104.442 9.40909C104.442 9.10097 104.399 8.83333 104.313 8.60618C104.228 8.37902 104.104 8.2036 103.942 8.0799C103.78 7.9562 103.584 7.89435 103.352 7.89435C103.116 7.89435 102.917 7.95845 102.755 8.08665C102.593 8.21484 102.47 8.39252 102.387 8.61967C102.304 8.84683 102.262 9.10997 102.262 9.40909C102.262 9.71046 102.304 9.97698 102.387 10.2086C102.473 10.438 102.595 10.618 102.755 10.7484C102.917 10.8766 103.116 10.9407 103.352 10.9407ZM111.135 12.0843C110.741 12.0843 110.385 11.9831 110.065 11.7807C109.748 11.5761 109.496 11.2758 109.31 10.88C109.125 10.4819 109.033 9.99384 109.033 9.41584C109.033 8.82209 109.129 8.32842 109.32 7.93484C109.511 7.539 109.765 7.24325 110.082 7.04759C110.402 6.84967 110.751 6.75071 111.131 6.75071C111.422 6.75071 111.663 6.80019 111.857 6.89915C112.052 6.99586 112.21 7.11731 112.329 7.26349C112.451 7.40743 112.543 7.54912 112.606 7.68857H112.65V5.09091H114.083V12H112.666V11.1701H112.606C112.538 11.314 112.443 11.4569 112.319 11.5985C112.197 11.738 112.039 11.8538 111.843 11.946C111.65 12.0382 111.414 12.0843 111.135 12.0843ZM111.59 10.9407C111.822 10.9407 112.018 10.8777 112.177 10.7518C112.339 10.6236 112.463 10.4448 112.548 10.2154C112.636 9.98597 112.68 9.71721 112.68 9.40909C112.68 9.10097 112.637 8.83333 112.552 8.60618C112.466 8.37902 112.343 8.2036 112.181 8.0799C112.019 7.9562 111.822 7.89435 111.59 7.89435C111.354 7.89435 111.155 7.95845 110.993 8.08665C110.831 8.21484 110.709 8.39252 110.625 8.61967C110.542 8.84683 110.501 9.10997 110.501 9.40909C110.501 9.71046 110.542 9.97698 110.625 10.2086C110.711 10.438 110.833 10.618 110.993 10.7484C111.155 10.8766 111.354 10.9407 111.59 10.9407ZM117.606 12.1012C117.082 12.1012 116.629 11.9899 116.247 11.7672C115.867 11.5423 115.573 11.2297 115.366 10.8294C115.159 10.4268 115.056 9.96011 115.056 9.42933C115.056 8.89406 115.159 8.42625 115.366 8.02592C115.573 7.62334 115.867 7.31072 116.247 7.08807C116.629 6.86316 117.082 6.75071 117.606 6.75071C118.13 6.75071 118.582 6.86316 118.962 7.08807C119.345 7.31072 119.639 7.62334 119.846 8.02592C120.053 8.42625 120.157 8.89406 120.157 9.42933C120.157 9.96011 120.053 10.4268 119.846 10.8294C119.639 11.2297 119.345 11.5423 118.962 11.7672C118.582 11.9899 118.13 12.1012 117.606 12.1012ZM117.613 10.9879C117.851 10.9879 118.05 10.9205 118.21 10.7855C118.37 10.6483 118.49 10.4616 118.571 10.2255C118.654 9.98935 118.696 9.72058 118.696 9.41921C118.696 9.11784 118.654 8.84908 118.571 8.61293C118.49 8.37678 118.37 8.1901 118.21 8.05291C118.05 7.91572 117.851 7.84712 117.613 7.84712C117.372 7.84712 117.17 7.91572 117.006 8.05291C116.844 8.1901 116.721 8.37678 116.638 8.61293C116.557 8.84908 116.517 9.11784 116.517 9.41921C116.517 9.72058 116.557 9.98935 116.638 10.2255C116.721 10.4616 116.844 10.6483 117.006 10.7855C117.17 10.9205 117.372 10.9879 117.613 10.9879ZM123.432 12.1012C122.908 12.1012 122.455 11.9899 122.073 11.7672C121.693 11.5423 121.399 11.2297 121.192 10.8294C120.985 10.4268 120.882 9.96011 120.882 9.42933C120.882 8.89406 120.985 8.42625 121.192 8.02592C121.399 7.62334 121.693 7.31072 122.073 7.08807C122.455 6.86316 122.908 6.75071 123.432 6.75071C123.956 6.75071 124.408 6.86316 124.789 7.08807C125.171 7.31072 125.465 7.62334 125.672 8.02592C125.879 8.42625 125.983 8.89406 125.983 9.42933C125.983 9.96011 125.879 10.4268 125.672 10.8294C125.465 11.2297 125.171 11.5423 124.789 11.7672C124.408 11.9899 123.956 12.1012 123.432 12.1012ZM123.439 10.9879C123.677 10.9879 123.877 10.9205 124.036 10.7855C124.196 10.6483 124.316 10.4616 124.397 10.2255C124.48 9.98935 124.522 9.72058 124.522 9.41921C124.522 9.11784 124.48 8.84908 124.397 8.61293C124.316 8.37678 124.196 8.1901 124.036 8.05291C123.877 7.91572 123.677 7.84712 123.439 7.84712C123.198 7.84712 122.996 7.91572 122.832 8.05291C122.67 8.1901 122.547 8.37678 122.464 8.61293C122.383 8.84908 122.343 9.11784 122.343 9.41921C122.343 9.72058 122.383 9.98935 122.464 10.2255C122.547 10.4616 122.67 10.6483 122.832 10.7855C122.996 10.9205 123.198 10.9879 123.439 10.9879ZM126.917 12V6.81818H128.311V7.7223H128.365C128.459 7.40069 128.618 7.15779 128.84 6.99361C129.063 6.82718 129.319 6.74396 129.609 6.74396C129.681 6.74396 129.759 6.74846 129.842 6.75746C129.925 6.76645 129.998 6.77882 130.061 6.79457V8.06978C129.994 8.04954 129.901 8.03155 129.781 8.0158C129.662 8.00006 129.553 7.99219 129.454 7.99219C129.243 7.99219 129.054 8.03829 128.887 8.1305C128.723 8.22047 128.593 8.34641 128.496 8.50835C128.402 8.67028 128.354 8.85695 128.354 9.06836V12H126.917Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function XL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2003_5091",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2003_5091)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M49.8681 5.09091H51.3288V9.57777C51.3288 10.0816 51.2085 10.5224 50.9679 10.9002C50.7295 11.2781 50.3955 11.5727 49.9659 11.7841C49.5363 11.9933 49.0359 12.0978 48.4647 12.0978C47.8912 12.0978 47.3896 11.9933 46.96 11.7841C46.5305 11.5727 46.1965 11.2781 45.9581 10.9002C45.7197 10.5224 45.6005 10.0816 45.6005 9.57777V5.09091H47.0613V9.45295C47.0613 9.71609 47.1186 9.94999 47.2333 10.1547C47.3503 10.3593 47.5144 10.5201 47.7259 10.6371C47.9373 10.754 48.1835 10.8125 48.4647 10.8125C48.748 10.8125 48.9943 10.754 49.2035 10.6371C49.4149 10.5201 49.5779 10.3593 49.6926 10.1547C49.8096 9.94999 49.8681 9.71609 49.8681 9.45295V5.09091ZM53.9408 9.00426V12H52.5037V6.81818H53.8734V7.73242H53.9341C54.0488 7.43105 54.2411 7.19265 54.511 7.01722C54.7809 6.83955 55.1081 6.75071 55.4927 6.75071C55.8525 6.75071 56.1663 6.82943 56.4339 6.98686C56.7015 7.14429 56.9096 7.3692 57.058 7.66158C57.2065 7.9517 57.2807 8.29806 57.2807 8.70064V12H55.8435V8.95703C55.8458 8.63991 55.7648 8.39252 55.6006 8.21484C55.4364 8.03492 55.2104 7.94496 54.9225 7.94496C54.7291 7.94496 54.5582 7.98656 54.4098 8.06978C54.2636 8.15299 54.1489 8.27444 54.0657 8.43413C53.9847 8.59156 53.9431 8.78161 53.9408 9.00426ZM61.1696 6.81818V7.89773H58.049V6.81818H61.1696ZM58.7575 5.5767H60.1946V10.4077C60.1946 10.5404 60.2148 10.6438 60.2553 10.718C60.2958 10.79 60.352 10.8406 60.424 10.8699C60.4982 10.8991 60.5837 10.9137 60.6804 10.9137C60.7479 10.9137 60.8153 10.9081 60.8828 10.8968C60.9503 10.8833 61.002 10.8732 61.038 10.8665L61.264 11.9359C61.1921 11.9584 61.0909 11.9843 60.9604 12.0135C60.83 12.045 60.6714 12.0641 60.4847 12.0708C60.1384 12.0843 59.8348 12.0382 59.5739 11.9325C59.3152 11.8268 59.1139 11.6626 58.97 11.44C58.8261 11.2173 58.7552 10.9362 58.7575 10.5966V5.5767ZM64.4116 12.1012C63.8786 12.1012 63.4197 11.9933 63.0352 11.7773C62.6528 11.5592 62.3582 11.2511 62.1513 10.853C61.9444 10.4527 61.8409 9.97923 61.8409 9.43271C61.8409 8.89968 61.9444 8.43188 62.1513 8.0293C62.3582 7.62672 62.6494 7.31297 63.025 7.08807C63.4029 6.86316 63.8459 6.75071 64.3542 6.75071C64.6961 6.75071 65.0143 6.80581 65.3089 6.91602C65.6058 7.02397 65.8645 7.18703 66.0849 7.40518C66.3075 7.62334 66.4807 7.89773 66.6044 8.22834C66.7281 8.5567 66.79 8.94129 66.79 9.3821V9.77681H62.4144V8.88619H65.4371C65.4371 8.67927 65.3922 8.49598 65.3022 8.33629C65.2122 8.17661 65.0874 8.05179 64.9277 7.96183C64.7703 7.86961 64.587 7.82351 64.3778 7.82351C64.1597 7.82351 63.9663 7.87411 63.7976 7.97532C63.6312 8.07428 63.5007 8.2081 63.4062 8.37678C63.3118 8.54321 63.2634 8.72875 63.2612 8.93342V9.78018C63.2612 10.0366 63.3084 10.2581 63.4029 10.4448C63.4996 10.6315 63.6357 10.7754 63.8111 10.8766C63.9865 10.9778 64.1945 11.0284 64.4352 11.0284C64.5949 11.0284 64.7411 11.0059 64.8738 10.9609C65.0065 10.916 65.12 10.8485 65.2145 10.7585C65.3089 10.6686 65.3809 10.5584 65.4304 10.4279L66.7596 10.5156C66.6921 10.835 66.5538 11.1139 66.3446 11.3523C66.1377 11.5884 65.8701 11.7728 65.5417 11.9055C65.2156 12.036 64.8389 12.1012 64.4116 12.1012ZM67.7278 12V6.81818H69.1211V7.7223H69.1751C69.2695 7.40069 69.4281 7.15779 69.6507 6.99361C69.8734 6.82718 70.1298 6.74396 70.4199 6.74396C70.4919 6.74396 70.5695 6.74846 70.6527 6.75746C70.7359 6.76645 70.809 6.77882 70.872 6.79457V8.06978C70.8045 8.04954 70.7112 8.03155 70.592 8.0158C70.4728 8.00006 70.3637 7.99219 70.2647 7.99219C70.0533 7.99219 69.8644 8.03829 69.698 8.1305C69.5338 8.22047 69.4033 8.34641 69.3066 8.50835C69.2122 8.67028 69.165 8.85695 69.165 9.06836V12H67.7278ZM75.9264 8.29581L74.6108 8.37678C74.5883 8.26432 74.5399 8.16312 74.4657 8.07315C74.3915 7.98094 74.2936 7.90785 74.1722 7.85387C74.053 7.79764 73.9102 7.76953 73.7437 7.76953C73.5211 7.76953 73.3333 7.81676 73.1804 7.91122C73.0274 8.00343 72.951 8.12713 72.951 8.28232C72.951 8.40601 73.0004 8.51059 73.0994 8.59606C73.1983 8.68152 73.3681 8.75012 73.6088 8.80185L74.5467 8.99077C75.0504 9.09422 75.426 9.26065 75.6734 9.49006C75.9208 9.71946 76.0445 10.0208 76.0445 10.3942C76.0445 10.7338 75.9444 11.0318 75.7443 11.2882C75.5464 11.5446 75.2742 11.7447 74.9279 11.8887C74.5838 12.0304 74.1868 12.1012 73.737 12.1012C73.051 12.1012 72.5045 11.9584 72.0974 11.6728C71.6926 11.3849 71.4553 10.9935 71.3856 10.4988L72.7991 10.4245C72.8419 10.6337 72.9453 10.7934 73.1095 10.9036C73.2737 11.0115 73.484 11.0655 73.7404 11.0655C73.9923 11.0655 74.1947 11.0172 74.3476 10.9205C74.5028 10.8215 74.5815 10.6944 74.5838 10.5392C74.5815 10.4088 74.5264 10.302 74.4185 10.2188C74.3105 10.1333 74.1441 10.0681 73.9192 10.0231L73.0218 9.84428C72.5158 9.74308 72.139 9.56765 71.8916 9.318C71.6465 9.06836 71.5239 8.75012 71.5239 8.36328C71.5239 8.03042 71.6139 7.74367 71.7938 7.50302C71.976 7.26237 72.2313 7.07682 72.5596 6.94638C72.8902 6.81593 73.2771 6.75071 73.7201 6.75071C74.3746 6.75071 74.8896 6.88903 75.2652 7.16566C75.6431 7.44229 75.8635 7.81901 75.9264 8.29581ZM79.7057 6.81818V7.89773H76.5851V6.81818H79.7057ZM77.2936 5.5767H78.7307V10.4077C78.7307 10.5404 78.751 10.6438 78.7915 10.718C78.8319 10.79 78.8882 10.8406 78.9601 10.8699C79.0344 10.8991 79.1198 10.9137 79.2165 10.9137C79.284 10.9137 79.3515 10.9081 79.4189 10.8968C79.4864 10.8833 79.5381 10.8732 79.5741 10.8665L79.8002 11.9359C79.7282 11.9584 79.627 11.9843 79.4965 12.0135C79.3661 12.045 79.2075 12.0641 79.0209 12.0708C78.6745 12.0843 78.3709 12.0382 78.11 11.9325C77.8514 11.8268 77.6501 11.6626 77.5061 11.44C77.3622 11.2173 77.2913 10.9362 77.2936 10.5966V5.5767ZM83.9648 9.79368V6.81818H85.402V12H84.0222V11.0588H83.9682C83.8513 11.3624 83.6567 11.6064 83.3846 11.7908C83.1147 11.9753 82.7852 12.0675 82.3961 12.0675C82.0498 12.0675 81.745 11.9888 81.4819 11.8313C81.2188 11.6739 81.013 11.4501 80.8645 11.16C80.7183 10.8699 80.6441 10.5224 80.6419 10.1175V6.81818H82.079V9.86115C82.0813 10.167 82.1634 10.4088 82.3253 10.5865C82.4872 10.7641 82.7042 10.853 82.9764 10.853C83.1496 10.853 83.3115 10.8136 83.4622 10.7349C83.6129 10.6539 83.7343 10.5347 83.8265 10.3773C83.921 10.2199 83.9671 10.0253 83.9648 9.79368ZM82.0014 6.10973C81.808 6.10973 81.6416 6.04226 81.5021 5.90732C81.3627 5.77012 81.293 5.60819 81.293 5.42152C81.293 5.23035 81.3627 5.06842 81.5021 4.93572C81.6416 4.80303 81.808 4.73668 82.0014 4.73668C82.1971 4.73668 82.3624 4.80303 82.4973 4.93572C82.6345 5.06842 82.7031 5.23035 82.7031 5.42152C82.7031 5.60819 82.6345 5.77012 82.4973 5.90732C82.3624 6.04226 82.1971 6.10973 82.0014 6.10973ZM84.0661 6.10973C83.8726 6.10973 83.7062 6.04226 83.5668 5.90732C83.4273 5.77012 83.3576 5.60819 83.3576 5.42152C83.3576 5.23035 83.4273 5.06842 83.5668 4.93572C83.7062 4.80303 83.8726 4.73668 84.0661 4.73668C84.2617 4.73668 84.427 4.80303 84.562 4.93572C84.6992 5.06842 84.7678 5.23035 84.7678 5.42152C84.7678 5.60819 84.6992 5.77012 84.562 5.90732C84.427 6.04226 84.2617 6.10973 84.0661 6.10973ZM89.3078 6.81818V7.89773H86.1872V6.81818H89.3078ZM86.8956 5.5767H88.3328V10.4077C88.3328 10.5404 88.353 10.6438 88.3935 10.718C88.434 10.79 88.4902 10.8406 88.5622 10.8699C88.6364 10.8991 88.7219 10.9137 88.8186 10.9137C88.8861 10.9137 88.9535 10.9081 89.021 10.8968C89.0885 10.8833 89.1402 10.8732 89.1762 10.8665L89.4022 11.9359C89.3302 11.9584 89.229 11.9843 89.0986 12.0135C88.9681 12.045 88.8096 12.0641 88.6229 12.0708C88.2766 12.0843 87.9729 12.0382 87.712 11.9325C87.4534 11.8268 87.2521 11.6626 87.1082 11.44C86.9642 11.2173 86.8934 10.9362 86.8956 10.5966V5.5767ZM90.2169 12V11.1431L92.7539 8.00231V7.9652H90.3046V6.81818H94.4845V7.75266L92.1028 10.8159V10.853H94.5722V12H90.2169ZM98.4274 6.81818V7.89773H95.3068V6.81818H98.4274ZM96.0153 5.5767H97.4524V10.4077C97.4524 10.5404 97.4727 10.6438 97.5131 10.718C97.5536 10.79 97.6098 10.8406 97.6818 10.8699C97.756 10.8991 97.8415 10.9137 97.9382 10.9137C98.0057 10.9137 98.0732 10.9081 98.1406 10.8968C98.2081 10.8833 98.2598 10.8732 98.2958 10.8665L98.5218 11.9359C98.4499 11.9584 98.3487 11.9843 98.2182 12.0135C98.0878 12.045 97.9292 12.0641 97.7425 12.0708C97.3962 12.0843 97.0926 12.0382 96.8317 11.9325C96.573 11.8268 96.3717 11.6626 96.2278 11.44C96.0839 11.2173 96.013 10.9362 96.0153 10.5966V5.5767ZM106.393 6.81818L104.582 12H102.962L101.151 6.81818H102.669L103.745 10.5257H103.799L104.872 6.81818H106.393ZM109.303 12.1012C108.779 12.1012 108.326 11.9899 107.943 11.7672C107.563 11.5423 107.27 11.2297 107.063 10.8294C106.856 10.4268 106.753 9.96011 106.753 9.42933C106.753 8.89406 106.856 8.42625 107.063 8.02592C107.27 7.62334 107.563 7.31072 107.943 7.08807C108.326 6.86316 108.779 6.75071 109.303 6.75071C109.827 6.75071 110.279 6.86316 110.659 7.08807C111.041 7.31072 111.336 7.62334 111.543 8.02592C111.75 8.42625 111.853 8.89406 111.853 9.42933C111.853 9.96011 111.75 10.4268 111.543 10.8294C111.336 11.2297 111.041 11.5423 110.659 11.7672C110.279 11.9899 109.827 12.1012 109.303 12.1012ZM109.31 10.9879C109.548 10.9879 109.747 10.9205 109.907 10.7855C110.067 10.6483 110.187 10.4616 110.268 10.2255C110.351 9.98935 110.393 9.72058 110.393 9.41921C110.393 9.11784 110.351 8.84908 110.268 8.61293C110.187 8.37678 110.067 8.1901 109.907 8.05291C109.747 7.91572 109.548 7.84712 109.31 7.84712C109.069 7.84712 108.867 7.91572 108.702 8.05291C108.541 8.1901 108.418 8.37678 108.335 8.61293C108.254 8.84908 108.213 9.11784 108.213 9.41921C108.213 9.72058 108.254 9.98935 108.335 10.2255C108.418 10.4616 108.541 10.6483 108.702 10.7855C108.867 10.9205 109.069 10.9879 109.31 10.9879ZM114.225 9.00426V12H112.788V6.81818H114.158V7.73242H114.218C114.333 7.43105 114.525 7.19265 114.795 7.01722C115.065 6.83955 115.392 6.75071 115.777 6.75071C116.137 6.75071 116.45 6.82943 116.718 6.98686C116.986 7.14429 117.194 7.3692 117.342 7.66158C117.491 7.9517 117.565 8.29806 117.565 8.70064V12H116.128V8.95703C116.13 8.63991 116.049 8.39252 115.885 8.21484C115.721 8.03492 115.495 7.94496 115.207 7.94496C115.013 7.94496 114.842 7.98656 114.694 8.06978C114.548 8.15299 114.433 8.27444 114.35 8.43413C114.269 8.59156 114.227 8.78161 114.225 9.00426Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function QL(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2003_5067",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2003_5067)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM54.8466 12.1012C54.3136 12.1012 53.8548 11.9933 53.4702 11.7773C53.0879 11.5592 52.7932 11.2511 52.5863 10.853C52.3794 10.4527 52.276 9.97923 52.276 9.43271C52.276 8.89968 52.3794 8.43188 52.5863 8.0293C52.7932 7.62672 53.0845 7.31297 53.4601 7.08807C53.8379 6.86316 54.281 6.75071 54.7893 6.75071C55.1311 6.75071 55.4494 6.80581 55.744 6.91602C56.0409 7.02397 56.2995 7.18703 56.5199 7.40518C56.7426 7.62334 56.9158 7.89773 57.0395 8.22834C57.1632 8.5567 57.225 8.94129 57.225 9.3821V9.77681H52.8495V8.88619H55.8722C55.8722 8.67927 55.8272 8.49598 55.7373 8.33629C55.6473 8.17661 55.5225 8.05179 55.3628 7.96183C55.2054 7.86961 55.0221 7.82351 54.8129 7.82351C54.5947 7.82351 54.4013 7.87411 54.2326 7.97532C54.0662 8.07428 53.9358 8.2081 53.8413 8.37678C53.7468 8.54321 53.6985 8.72875 53.6962 8.93342V9.78018C53.6962 10.0366 53.7435 10.2581 53.8379 10.4448C53.9346 10.6315 54.0707 10.7754 54.2461 10.8766C54.4216 10.9778 54.6296 11.0284 54.8703 11.0284C55.0299 11.0284 55.1761 11.0059 55.3088 10.9609C55.4415 10.916 55.5551 10.8485 55.6495 10.7585C55.744 10.6686 55.816 10.5584 55.8655 10.4279L57.1946 10.5156C57.1272 10.835 56.9889 11.1139 56.7797 11.3523C56.5728 11.5884 56.3051 11.7728 55.9768 11.9055C55.6507 12.036 55.274 12.1012 54.8466 12.1012ZM62.4743 8.29581L61.1586 8.37678C61.1361 8.26432 61.0878 8.16312 61.0135 8.07315C60.9393 7.98094 60.8415 7.90785 60.72 7.85387C60.6008 7.79764 60.458 7.76953 60.2916 7.76953C60.0689 7.76953 59.8811 7.81676 59.7282 7.91122C59.5753 8.00343 59.4988 8.12713 59.4988 8.28232C59.4988 8.40601 59.5483 8.51059 59.6472 8.59606C59.7462 8.68152 59.916 8.75012 60.1566 8.80185L61.0945 8.99077C61.5983 9.09422 61.9739 9.26065 62.2213 9.49006C62.4687 9.71946 62.5924 10.0208 62.5924 10.3942C62.5924 10.7338 62.4923 11.0318 62.2921 11.2882C62.0942 11.5446 61.8221 11.7447 61.4757 11.8887C61.1316 12.0304 60.7347 12.1012 60.2848 12.1012C59.5989 12.1012 59.0524 11.9584 58.6453 11.6728C58.2405 11.3849 58.0032 10.9935 57.9335 10.4988L59.347 10.4245C59.3897 10.6337 59.4932 10.7934 59.6574 10.9036C59.8215 11.0115 60.0318 11.0655 60.2882 11.0655C60.5401 11.0655 60.7425 11.0172 60.8955 10.9205C61.0506 10.8215 61.1294 10.6944 61.1316 10.5392C61.1294 10.4088 61.0743 10.302 60.9663 10.2188C60.8584 10.1333 60.6919 10.0681 60.467 10.0231L59.5696 9.84428C59.0636 9.74308 58.6869 9.56765 58.4395 9.318C58.1944 9.06836 58.0718 8.75012 58.0718 8.36328C58.0718 8.03042 58.1617 7.74367 58.3417 7.50302C58.5238 7.26237 58.7791 7.07682 59.1075 6.94638C59.4381 6.81593 59.8249 6.75071 60.268 6.75071C60.9225 6.75071 61.4375 6.88903 61.8131 7.16566C62.1909 7.44229 62.4113 7.81901 62.4743 8.29581ZM65.8588 12.1012C65.3258 12.1012 64.867 11.9933 64.4824 11.7773C64.1001 11.5592 63.8055 11.2511 63.5985 10.853C63.3916 10.4527 63.2882 9.97923 63.2882 9.43271C63.2882 8.89968 63.3916 8.43188 63.5985 8.0293C63.8055 7.62672 64.0967 7.31297 64.4723 7.08807C64.8501 6.86316 65.2932 6.75071 65.8015 6.75071C66.1433 6.75071 66.4616 6.80581 66.7562 6.91602C67.0531 7.02397 67.3117 7.18703 67.5321 7.40518C67.7548 7.62334 67.928 7.89773 68.0517 8.22834C68.1754 8.5567 68.2372 8.94129 68.2372 9.3821V9.77681H63.8617V8.88619H66.8844C66.8844 8.67927 66.8394 8.49598 66.7495 8.33629C66.6595 8.17661 66.5347 8.05179 66.375 7.96183C66.2176 7.86961 66.0343 7.82351 65.8251 7.82351C65.6069 7.82351 65.4135 7.87411 65.2449 7.97532C65.0784 8.07428 64.948 8.2081 64.8535 8.37678C64.7591 8.54321 64.7107 8.72875 64.7085 8.93342V9.78018C64.7085 10.0366 64.7557 10.2581 64.8501 10.4448C64.9469 10.6315 65.0829 10.7754 65.2583 10.8766C65.4338 10.9778 65.6418 11.0284 65.8825 11.0284C66.0421 11.0284 66.1883 11.0059 66.321 10.9609C66.4537 10.916 66.5673 10.8485 66.6618 10.7585C66.7562 10.6686 66.8282 10.5584 66.8777 10.4279L68.2069 10.5156C68.1394 10.835 68.0011 11.1139 67.7919 11.3523C67.585 11.5884 67.3174 11.7728 66.989 11.9055C66.6629 12.036 66.2862 12.1012 65.8588 12.1012ZM70.6122 9.00426V12H69.1751V6.81818H70.5447V7.73242H70.6055C70.7202 7.43105 70.9125 7.19265 71.1824 7.01722C71.4522 6.83955 71.7795 6.75071 72.1641 6.75071C72.5239 6.75071 72.8377 6.82943 73.1053 6.98686C73.3729 7.14429 73.581 7.3692 73.7294 7.66158C73.8778 7.9517 73.9521 8.29806 73.9521 8.70064V12H72.5149V8.95703C72.5172 8.63991 72.4362 8.39252 72.272 8.21484C72.1078 8.03492 71.8818 7.94496 71.5939 7.94496C71.4005 7.94496 71.2296 7.98656 71.0811 8.06978C70.935 8.15299 70.8203 8.27444 70.737 8.43413C70.6561 8.59156 70.6145 8.78161 70.6122 9.00426ZM79.7302 6.81818L77.9185 12H76.2992L74.4876 6.81818H76.0057L77.0819 10.5257H77.1359L78.2087 6.81818H79.7302ZM82.6399 12.1012C82.1158 12.1012 81.6627 11.9899 81.2803 11.7672C80.9002 11.5423 80.6067 11.2297 80.3998 10.8294C80.1929 10.4268 80.0894 9.96011 80.0894 9.42933C80.0894 8.89406 80.1929 8.42625 80.3998 8.02592C80.6067 7.62334 80.9002 7.31072 81.2803 7.08807C81.6627 6.86316 82.1158 6.75071 82.6399 6.75071C83.1639 6.75071 83.616 6.86316 83.996 7.08807C84.3784 7.31072 84.673 7.62334 84.8799 8.02592C85.0868 8.42625 85.1903 8.89406 85.1903 9.42933C85.1903 9.96011 85.0868 10.4268 84.8799 10.8294C84.673 11.2297 84.3784 11.5423 83.996 11.7672C83.616 11.9899 83.1639 12.1012 82.6399 12.1012ZM82.6466 10.9879C82.885 10.9879 83.0841 10.9205 83.2437 10.7855C83.4034 10.6483 83.5237 10.4616 83.6047 10.2255C83.6879 9.98935 83.7295 9.72058 83.7295 9.41921C83.7295 9.11784 83.6879 8.84908 83.6047 8.61293C83.5237 8.37678 83.4034 8.1901 83.2437 8.05291C83.0841 7.91572 82.885 7.84712 82.6466 7.84712C82.406 7.84712 82.2036 7.91572 82.0394 8.05291C81.8774 8.1901 81.7549 8.37678 81.6717 8.61293C81.5907 8.84908 81.5502 9.11784 81.5502 9.41921C81.5502 9.72058 81.5907 9.98935 81.6717 10.2255C81.7549 10.4616 81.8774 10.6483 82.0394 10.7855C82.2036 10.9205 82.406 10.9879 82.6466 10.9879ZM87.5619 5.09091V12H86.1248V5.09091H87.5619ZM93.5441 6.81818L91.7325 12H90.1132L88.3016 6.81818H89.8197L90.8959 10.5257H90.9498L92.0226 6.81818H93.5441ZM94.2796 12V6.81818H95.7167V12H94.2796ZM95.0015 6.15021C94.7878 6.15021 94.6046 6.07937 94.4516 5.93768C94.3009 5.79374 94.2256 5.62169 94.2256 5.42152C94.2256 5.2236 94.3009 5.0538 94.4516 4.91211C94.6046 4.76817 94.7878 4.6962 95.0015 4.6962C95.2152 4.6962 95.3973 4.76817 95.548 4.91211C95.701 5.0538 95.7774 5.2236 95.7774 5.42152C95.7774 5.62169 95.701 5.79374 95.548 5.93768C95.3973 6.07937 95.2152 6.15021 95.0015 6.15021ZM98.7774 12.0843C98.3838 12.0843 98.0273 11.9831 97.708 11.7807C97.3908 11.5761 97.139 11.2758 96.9523 10.88C96.7679 10.4819 96.6756 9.99384 96.6756 9.41584C96.6756 8.82209 96.7712 8.32842 96.9624 7.93484C97.1536 7.539 97.4077 7.24325 97.7248 7.04759C98.0442 6.84967 98.3939 6.75071 98.774 6.75071C99.0641 6.75071 99.3059 6.80019 99.4993 6.89915C99.695 6.99586 99.8524 7.11731 99.9716 7.26349C100.093 7.40743 100.185 7.54912 100.248 7.68857H100.292V5.09091H101.726V12H100.309V11.1701H100.248C100.181 11.314 100.085 11.4569 99.9615 11.5985C99.8401 11.738 99.6815 11.8538 99.4858 11.946C99.2924 12.0382 99.0563 12.0843 98.7774 12.0843ZM99.2328 10.9407C99.4645 10.9407 99.6601 10.8777 99.8198 10.7518C99.9818 10.6236 100.105 10.4448 100.191 10.2154C100.279 9.98597 100.322 9.71721 100.322 9.40909C100.322 9.10097 100.28 8.83333 100.194 8.60618C100.109 8.37902 99.9851 8.2036 99.8232 8.0799C99.6613 7.9562 99.4645 7.89435 99.2328 7.89435C98.9967 7.89435 98.7976 7.95845 98.6357 8.08665C98.4738 8.21484 98.3512 8.39252 98.268 8.61967C98.1848 8.84683 98.1432 9.10997 98.1432 9.40909C98.1432 9.71046 98.1848 9.97698 98.268 10.2086C98.3534 10.438 98.476 10.618 98.6357 10.7484C98.7976 10.8766 98.9967 10.9407 99.2328 10.9407ZM105.249 12.1012C104.725 12.1012 104.272 11.9899 103.889 11.7672C103.509 11.5423 103.216 11.2297 103.009 10.8294C102.802 10.4268 102.698 9.96011 102.698 9.42933C102.698 8.89406 102.802 8.42625 103.009 8.02592C103.216 7.62334 103.509 7.31072 103.889 7.08807C104.272 6.86316 104.725 6.75071 105.249 6.75071C105.773 6.75071 106.225 6.86316 106.605 7.08807C106.987 7.31072 107.282 7.62334 107.489 8.02592C107.696 8.42625 107.799 8.89406 107.799 9.42933C107.799 9.96011 107.696 10.4268 107.489 10.8294C107.282 11.2297 106.987 11.5423 106.605 11.7672C106.225 11.9899 105.773 12.1012 105.249 12.1012ZM105.256 10.9879C105.494 10.9879 105.693 10.9205 105.853 10.7855C106.012 10.6483 106.133 10.4616 106.214 10.2255C106.297 9.98935 106.338 9.72058 106.338 9.41921C106.338 9.11784 106.297 8.84908 106.214 8.61293C106.133 8.37678 106.012 8.1901 105.853 8.05291C105.693 7.91572 105.494 7.84712 105.256 7.84712C105.015 7.84712 104.812 7.91572 104.648 8.05291C104.486 8.1901 104.364 8.37678 104.281 8.61293C104.2 8.84908 104.159 9.11784 104.159 9.41921C104.159 9.72058 104.2 9.98935 104.281 10.2255C104.364 10.4616 104.486 10.6483 104.648 10.7855C104.812 10.9205 105.015 10.9879 105.256 10.9879ZM110.932 13.9432V6.81818H112.349V7.68857H112.413C112.476 7.54912 112.567 7.40743 112.687 7.26349C112.808 7.11731 112.966 6.99586 113.159 6.89915C113.355 6.80019 113.598 6.75071 113.888 6.75071C114.265 6.75071 114.614 6.84967 114.933 7.04759C115.253 7.24325 115.508 7.539 115.699 7.93484C115.89 8.32842 115.986 8.82209 115.986 9.41584C115.986 9.99384 115.893 10.4819 115.706 10.88C115.522 11.2758 115.27 11.5761 114.95 11.7807C114.633 11.9831 114.278 12.0843 113.884 12.0843C113.605 12.0843 113.368 12.0382 113.172 11.946C112.979 11.8538 112.82 11.738 112.697 11.5985C112.573 11.4569 112.479 11.314 112.413 11.1701H112.37V13.9432H110.932ZM112.339 9.40909C112.339 9.71721 112.382 9.98597 112.467 10.2154C112.553 10.4448 112.677 10.6236 112.838 10.7518C113 10.8777 113.197 10.9407 113.429 10.9407C113.663 10.9407 113.861 10.8766 114.023 10.7484C114.185 10.618 114.307 10.438 114.39 10.2086C114.476 9.97698 114.519 9.71046 114.519 9.40909C114.519 9.10997 114.477 8.84683 114.394 8.61967C114.31 8.39252 114.188 8.21484 114.026 8.08665C113.864 7.95845 113.665 7.89435 113.429 7.89435C113.195 7.89435 112.997 7.9562 112.835 8.0799C112.675 8.2036 112.553 8.37902 112.467 8.60618C112.382 8.83333 112.339 9.10097 112.339 9.40909ZM119.285 12.1012C118.761 12.1012 118.308 11.9899 117.926 11.7672C117.546 11.5423 117.252 11.2297 117.045 10.8294C116.838 10.4268 116.735 9.96011 116.735 9.42933C116.735 8.89406 116.838 8.42625 117.045 8.02592C117.252 7.62334 117.546 7.31072 117.926 7.08807C118.308 6.86316 118.761 6.75071 119.285 6.75071C119.809 6.75071 120.261 6.86316 120.642 7.08807C121.024 7.31072 121.319 7.62334 121.525 8.02592C121.732 8.42625 121.836 8.89406 121.836 9.42933C121.836 9.96011 121.732 10.4268 121.525 10.8294C121.319 11.2297 121.024 11.5423 120.642 11.7672C120.261 11.9899 119.809 12.1012 119.285 12.1012ZM119.292 10.9879C119.531 10.9879 119.73 10.9205 119.889 10.7855C120.049 10.6483 120.169 10.4616 120.25 10.2255C120.333 9.98935 120.375 9.72058 120.375 9.41921C120.375 9.11784 120.333 8.84908 120.25 8.61293C120.169 8.37678 120.049 8.1901 119.889 8.05291C119.73 7.91572 119.531 7.84712 119.292 7.84712C119.051 7.84712 118.849 7.91572 118.685 8.05291C118.523 8.1901 118.4 8.37678 118.317 8.61293C118.236 8.84908 118.196 9.11784 118.196 9.41921C118.196 9.72058 118.236 9.98935 118.317 10.2255C118.4 10.4616 118.523 10.6483 118.685 10.7855C118.849 10.9205 119.051 10.9879 119.292 10.9879ZM122.77 12V6.81818H124.164V7.7223H124.218C124.312 7.40069 124.471 7.15779 124.693 6.99361C124.916 6.82718 125.172 6.74396 125.462 6.74396C125.534 6.74396 125.612 6.74846 125.695 6.75746C125.778 6.76645 125.851 6.77882 125.914 6.79457V8.06978C125.847 8.04954 125.754 8.03155 125.634 8.0158C125.515 8.00006 125.406 7.99219 125.307 7.99219C125.096 7.99219 124.907 8.03829 124.74 8.1305C124.576 8.22047 124.446 8.34641 124.349 8.50835C124.255 8.67028 124.207 8.85695 124.207 9.06836V12H122.77Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function eA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2003_5043",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2003_5043)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8481 5.09091 49.2934 5.18424 49.6623 5.37092C50.0334 5.55534 50.3156 5.81735 50.5091 6.15696C50.7047 6.49432 50.8026 6.89128 50.8026 7.34783C50.8026 7.80664 50.7036 8.20135 50.5057 8.53196C50.3078 8.86032 50.021 9.11222 49.6454 9.28764C49.2721 9.46307 48.82 9.55078 48.2892 9.55078H46.4641V8.37678H48.0531C48.332 8.37678 48.5636 8.33854 48.748 8.26207C48.9325 8.18561 49.0697 8.0709 49.1596 7.91797C49.2518 7.76503 49.2979 7.57499 49.2979 7.34783C49.2979 7.11843 49.2518 6.92501 49.1596 6.76758C49.0697 6.61014 48.9313 6.49094 48.7447 6.40998C48.5603 6.32676 48.3275 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM49.3317 8.85582L51.0488 12H49.4363L47.7562 8.85582H49.3317ZM54.0859 12.1012C53.5529 12.1012 53.0941 11.9933 52.7095 11.7773C52.3271 11.5592 52.0325 11.2511 51.8256 10.853C51.6187 10.4527 51.5152 9.97923 51.5152 9.43271C51.5152 8.89968 51.6187 8.43188 51.8256 8.0293C52.0325 7.62672 52.3238 7.31297 52.6994 7.08807C53.0772 6.86316 53.5203 6.75071 54.0285 6.75071C54.3704 6.75071 54.6886 6.80581 54.9833 6.91602C55.2801 7.02397 55.5388 7.18703 55.7592 7.40518C55.9818 7.62334 56.155 7.89773 56.2787 8.22834C56.4024 8.5567 56.4643 8.94129 56.4643 9.3821V9.77681H52.0887V8.88619H55.1115C55.1115 8.67927 55.0665 8.49598 54.9765 8.33629C54.8866 8.17661 54.7617 8.05179 54.6021 7.96183C54.4446 7.86961 54.2613 7.82351 54.0522 7.82351C53.834 7.82351 53.6406 7.87411 53.4719 7.97532C53.3055 8.07428 53.175 8.2081 53.0806 8.37678C52.9861 8.54321 52.9378 8.72875 52.9355 8.93342V9.78018C52.9355 10.0366 52.9827 10.2581 53.0772 10.4448C53.1739 10.6315 53.31 10.7754 53.4854 10.8766C53.6608 10.9778 53.8689 11.0284 54.1095 11.0284C54.2692 11.0284 54.4154 11.0059 54.5481 10.9609C54.6808 10.916 54.7943 10.8485 54.8888 10.7585C54.9833 10.6686 55.0552 10.5584 55.1047 10.4279L56.4339 10.5156C56.3664 10.835 56.2281 11.1139 56.019 11.3523C55.812 11.5884 55.5444 11.7728 55.216 11.9055C54.8899 12.036 54.5132 12.1012 54.0859 12.1012ZM58.8797 12.0978C58.5491 12.0978 58.2545 12.0405 57.9959 11.9258C57.7372 11.8088 57.5326 11.6368 57.3819 11.4096C57.2334 11.1802 57.1592 10.8946 57.1592 10.5527C57.1592 10.2649 57.2121 10.0231 57.3178 9.82741C57.4235 9.63175 57.5674 9.47431 57.7496 9.35511C57.9318 9.23591 58.1387 9.14595 58.3703 9.08523C58.6042 9.0245 58.8494 8.98177 59.1058 8.95703C59.4072 8.92554 59.6501 8.89631 59.8345 8.86932C60.0189 8.84008 60.1527 8.79735 60.2359 8.74112C60.3191 8.6849 60.3608 8.60168 60.3608 8.49148V8.47124C60.3608 8.25758 60.2933 8.09227 60.1583 7.97532C60.0256 7.85837 59.8367 7.79989 59.5916 7.79989C59.3329 7.79989 59.1271 7.85724 58.9742 7.97195C58.8213 8.0844 58.7201 8.22609 58.6706 8.39702L57.3414 8.28906C57.4089 7.97419 57.5416 7.70206 57.7395 7.47266C57.9374 7.241 58.1927 7.06333 58.5053 6.93963C58.8201 6.81368 59.1845 6.75071 59.5983 6.75071C59.8862 6.75071 60.1617 6.78445 60.4248 6.85192C60.6902 6.91939 60.9253 7.02397 61.1299 7.16566C61.3368 7.30735 61.4999 7.48952 61.6191 7.71218C61.7383 7.93259 61.7979 8.19685 61.7979 8.50497V12H60.435V11.2814H60.3945C60.3113 11.4434 60.1999 11.5862 60.0605 11.7099C59.9211 11.8313 59.7535 11.9269 59.5578 11.9966C59.3622 12.0641 59.1361 12.0978 58.8797 12.0978ZM59.2913 11.106C59.5027 11.106 59.6894 11.0644 59.8513 10.9812C60.0133 10.8957 60.1403 10.781 60.2326 10.6371C60.3248 10.4931 60.3709 10.3301 60.3709 10.1479V9.59801C60.3259 9.62725 60.264 9.65424 60.1853 9.67898C60.1089 9.70147 60.0223 9.72283 59.9256 9.74308C59.8289 9.76107 59.7321 9.77794 59.6354 9.79368C59.5387 9.80717 59.451 9.81954 59.3723 9.83079C59.2036 9.85553 59.0563 9.89489 58.9304 9.94886C58.8044 10.0028 58.7066 10.0759 58.6369 10.1681C58.5671 10.2581 58.5323 10.3706 58.5323 10.5055C58.5323 10.7012 58.6031 10.8507 58.7448 10.9542C58.8887 11.0554 59.0709 11.106 59.2913 11.106ZM64.35 5.09091V12H62.9129V5.09091H64.35ZM65.5012 12V6.81818H66.9384V12H65.5012ZM66.2232 6.15021C66.0095 6.15021 65.8262 6.07937 65.6733 5.93768C65.5226 5.79374 65.4473 5.62169 65.4473 5.42152C65.4473 5.2236 65.5226 5.0538 65.6733 4.91211C65.8262 4.76817 66.0095 4.6962 66.2232 4.6962C66.4368 4.6962 66.619 4.76817 66.7697 4.91211C66.9226 5.0538 66.9991 5.2236 66.9991 5.42152C66.9991 5.62169 66.9226 5.79374 66.7697 5.93768C66.619 6.07937 66.4368 6.15021 66.2232 6.15021ZM68.0626 12V11.1431L70.5996 8.00231V7.9652H68.1503V6.81818H72.3302V7.75266L69.9485 10.8159V10.853H72.4179V12H68.0626ZM73.4899 12V11.1431L76.0268 8.00231V7.9652H73.5776V6.81818H77.7575V7.75266L75.3757 10.8159V10.853H77.8452V12H73.4899ZM80.4217 12.0978C80.0911 12.0978 79.7965 12.0405 79.5379 11.9258C79.2792 11.8088 79.0746 11.6368 78.9239 11.4096C78.7754 11.1802 78.7012 10.8946 78.7012 10.5527C78.7012 10.2649 78.7541 10.0231 78.8598 9.82741C78.9655 9.63175 79.1094 9.47431 79.2916 9.35511C79.4738 9.23591 79.6807 9.14595 79.9123 9.08523C80.1462 9.0245 80.3914 8.98177 80.6478 8.95703C80.9491 8.92554 81.192 8.89631 81.3765 8.86932C81.5609 8.84008 81.6947 8.79735 81.7779 8.74112C81.8611 8.6849 81.9027 8.60168 81.9027 8.49148V8.47124C81.9027 8.25758 81.8353 8.09227 81.7003 7.97532C81.5676 7.85837 81.3787 7.79989 81.1336 7.79989C80.8749 7.79989 80.6691 7.85724 80.5162 7.97195C80.3633 8.0844 80.2621 8.22609 80.2126 8.39702L78.8834 8.28906C78.9509 7.97419 79.0836 7.70206 79.2815 7.47266C79.4794 7.241 79.7347 7.06333 80.0473 6.93963C80.3621 6.81368 80.7265 6.75071 81.1403 6.75071C81.4282 6.75071 81.7037 6.78445 81.9668 6.85192C82.2322 6.91939 82.4673 7.02397 82.6719 7.16566C82.8788 7.30735 83.0419 7.48952 83.1611 7.71218C83.2803 7.93259 83.3399 8.19685 83.3399 8.50497V12H81.977V11.2814H81.9365C81.8533 11.4434 81.7419 11.5862 81.6025 11.7099C81.4631 11.8313 81.2955 11.9269 81.0998 11.9966C80.9042 12.0641 80.6781 12.0978 80.4217 12.0978ZM80.8333 11.106C81.0447 11.106 81.2314 11.0644 81.3933 10.9812C81.5553 10.8957 81.6823 10.781 81.7745 10.6371C81.8668 10.4931 81.9129 10.3301 81.9129 10.1479V9.59801C81.8679 9.62725 81.806 9.65424 81.7273 9.67898C81.6508 9.70147 81.5643 9.72283 81.4676 9.74308C81.3708 9.76107 81.2741 9.77794 81.1774 9.79368C81.0807 9.80717 80.993 9.81954 80.9143 9.83079C80.7456 9.85553 80.5983 9.89489 80.4723 9.94886C80.3464 10.0028 80.2486 10.0759 80.1788 10.1681C80.1091 10.2581 80.0743 10.3706 80.0743 10.5055C80.0743 10.7012 80.1451 10.8507 80.2868 10.9542C80.4307 11.0554 80.6129 11.106 80.8333 11.106ZM87.2111 6.81818V7.89773H84.0905V6.81818H87.2111ZM84.799 5.5767H86.2361V10.4077C86.2361 10.5404 86.2563 10.6438 86.2968 10.718C86.3373 10.79 86.3935 10.8406 86.4655 10.8699C86.5397 10.8991 86.6252 10.9137 86.7219 10.9137C86.7894 10.9137 86.8568 10.9081 86.9243 10.8968C86.9918 10.8833 87.0435 10.8732 87.0795 10.8665L87.3055 11.9359C87.2336 11.9584 87.1324 11.9843 87.0019 12.0135C86.8715 12.045 86.7129 12.0641 86.5262 12.0708C86.1799 12.0843 85.8763 12.0382 85.6154 11.9325C85.3567 11.8268 85.1554 11.6626 85.0115 11.44C84.8676 11.2173 84.7967 10.9362 84.799 10.5966V5.5767ZM90.4328 12.1012C89.9088 12.1012 89.4556 11.9899 89.0733 11.7672C88.6932 11.5423 88.3997 11.2297 88.1928 10.8294C87.9859 10.4268 87.8824 9.96011 87.8824 9.42933C87.8824 8.89406 87.9859 8.42625 88.1928 8.02592C88.3997 7.62334 88.6932 7.31072 89.0733 7.08807C89.4556 6.86316 89.9088 6.75071 90.4328 6.75071C90.9569 6.75071 91.4089 6.86316 91.789 7.08807C92.1714 7.31072 92.466 7.62334 92.6729 8.02592C92.8798 8.42625 92.9833 8.89406 92.9833 9.42933C92.9833 9.96011 92.8798 10.4268 92.6729 10.8294C92.466 11.2297 92.1714 11.5423 91.789 11.7672C91.4089 11.9899 90.9569 12.1012 90.4328 12.1012ZM90.4396 10.9879C90.678 10.9879 90.877 10.9205 91.0367 10.7855C91.1964 10.6483 91.3167 10.4616 91.3977 10.2255C91.4809 9.98935 91.5225 9.72058 91.5225 9.41921C91.5225 9.11784 91.4809 8.84908 91.3977 8.61293C91.3167 8.37678 91.1964 8.1901 91.0367 8.05291C90.877 7.91572 90.678 7.84712 90.4396 7.84712C90.1989 7.84712 89.9965 7.91572 89.8323 8.05291C89.6704 8.1901 89.5478 8.37678 89.4646 8.61293C89.3837 8.84908 89.3432 9.11784 89.3432 9.41921C89.3432 9.72058 89.3837 9.98935 89.4646 10.2255C89.5478 10.4616 89.6704 10.6483 89.8323 10.7855C89.9965 10.9205 90.1989 10.9879 90.4396 10.9879ZM98.4577 12.1012C97.927 12.1012 97.4704 11.9888 97.0881 11.7638C96.708 11.5367 96.4156 11.2218 96.2109 10.8192C96.0085 10.4167 95.9073 9.95336 95.9073 9.42933C95.9073 8.89856 96.0096 8.433 96.2143 8.03267C96.4212 7.63009 96.7147 7.31635 97.0948 7.09144C97.4749 6.86429 97.927 6.75071 98.451 6.75071C98.9031 6.75071 99.2989 6.8328 99.6385 6.99698C99.9781 7.16116 100.247 7.39169 100.445 7.68857C100.643 7.98544 100.752 8.33404 100.772 8.73438H99.4158C99.3776 8.47573 99.2764 8.2677 99.1122 8.11026C98.9503 7.95058 98.7377 7.87074 98.4746 7.87074C98.252 7.87074 98.0574 7.93146 97.891 8.05291C97.7268 8.17211 97.5986 8.34641 97.5064 8.57582C97.4142 8.80522 97.3681 9.08298 97.3681 9.40909C97.3681 9.7397 97.4131 10.0208 97.503 10.2525C97.5952 10.4841 97.7246 10.6607 97.891 10.7821C98.0574 10.9036 98.252 10.9643 98.4746 10.9643C98.6388 10.9643 98.7861 10.9306 98.9165 10.8631C99.0492 10.7956 99.1583 10.6978 99.2438 10.5696C99.3315 10.4392 99.3888 10.2828 99.4158 10.1007H100.772C100.75 10.4965 100.642 10.8451 100.448 11.1465C100.257 11.4456 99.9927 11.6795 99.6554 11.8482C99.318 12.0169 98.9188 12.1012 98.4577 12.1012ZM104.033 12.1012C103.509 12.1012 103.056 11.9899 102.674 11.7672C102.294 11.5423 102 11.2297 101.793 10.8294C101.586 10.4268 101.483 9.96011 101.483 9.42933C101.483 8.89406 101.586 8.42625 101.793 8.02592C102 7.62334 102.294 7.31072 102.674 7.08807C103.056 6.86316 103.509 6.75071 104.033 6.75071C104.557 6.75071 105.01 6.86316 105.39 7.08807C105.772 7.31072 106.067 7.62334 106.273 8.02592C106.48 8.42625 106.584 8.89406 106.584 9.42933C106.584 9.96011 106.48 10.4268 106.273 10.8294C106.067 11.2297 105.772 11.5423 105.39 11.7672C105.01 11.9899 104.557 12.1012 104.033 12.1012ZM104.04 10.9879C104.279 10.9879 104.478 10.9205 104.637 10.7855C104.797 10.6483 104.917 10.4616 104.998 10.2255C105.081 9.98935 105.123 9.72058 105.123 9.41921C105.123 9.11784 105.081 8.84908 104.998 8.61293C104.917 8.37678 104.797 8.1901 104.637 8.05291C104.478 7.91572 104.279 7.84712 104.04 7.84712C103.8 7.84712 103.597 7.91572 103.433 8.05291C103.271 8.1901 103.148 8.37678 103.065 8.61293C102.984 8.84908 102.944 9.11784 102.944 9.41921C102.944 9.72058 102.984 9.98935 103.065 10.2255C103.148 10.4616 103.271 10.6483 103.433 10.7855C103.597 10.9205 103.8 10.9879 104.04 10.9879ZM108.955 9.00426V12H107.518V6.81818H108.888V7.73242H108.949C109.063 7.43105 109.256 7.19265 109.526 7.01722C109.795 6.83955 110.123 6.75071 110.507 6.75071C110.867 6.75071 111.181 6.82943 111.449 6.98686C111.716 7.14429 111.924 7.3692 112.073 7.66158C112.221 7.9517 112.295 8.29806 112.295 8.70064V12H110.858V8.95703C110.86 8.63991 110.779 8.39252 110.615 8.21484C110.451 8.03492 110.225 7.94496 109.937 7.94496C109.744 7.94496 109.573 7.98656 109.424 8.06978C109.278 8.15299 109.164 8.27444 109.08 8.43413C108.999 8.59156 108.958 8.78161 108.955 9.00426Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function tA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2002_5019",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2002_5019)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H50.1751V6.29528H47.0613V7.94158H49.8714V9.14595H47.0613V12H45.6005ZM54.1289 9.79368V6.81818H55.5661V12H54.1863V11.0588H54.1323C54.0153 11.3624 53.8208 11.6064 53.5487 11.7908C53.2788 11.9753 52.9493 12.0675 52.5602 12.0675C52.2138 12.0675 51.9091 11.9888 51.646 11.8313C51.3828 11.6739 51.177 11.4501 51.0286 11.16C50.8824 10.8699 50.8082 10.5224 50.8059 10.1175V6.81818H52.2431V9.86115C52.2453 10.167 52.3274 10.4088 52.4893 10.5865C52.6513 10.7641 52.8683 10.853 53.1404 10.853C53.3136 10.853 53.4756 10.8136 53.6262 10.7349C53.7769 10.6539 53.8984 10.5347 53.9906 10.3773C54.085 10.2199 54.1312 10.0253 54.1289 9.79368ZM58.1527 9.00426V12H56.7156V6.81818H58.0853V7.73242H58.146C58.2607 7.43105 58.453 7.19265 58.7229 7.01722C58.9928 6.83955 59.32 6.75071 59.7046 6.75071C60.0644 6.75071 60.3782 6.82943 60.6458 6.98686C60.9135 7.14429 61.1215 7.3692 61.2699 7.66158C61.4184 7.9517 61.4926 8.29806 61.4926 8.70064V12H60.0554V8.95703C60.0577 8.63991 59.9767 8.39252 59.8125 8.21484C59.6484 8.03492 59.4223 7.94496 59.1345 7.94496C58.941 7.94496 58.7701 7.98656 58.6217 8.06978C58.4755 8.15299 58.3608 8.27444 58.2776 8.43413C58.1966 8.59156 58.155 8.78161 58.1527 9.00426ZM64.9665 12.1012C64.4358 12.1012 63.9792 11.9888 63.5969 11.7638C63.2168 11.5367 62.9244 11.2218 62.7197 10.8192C62.5173 10.4167 62.4161 9.95336 62.4161 9.42933C62.4161 8.89856 62.5184 8.433 62.7231 8.03267C62.93 7.63009 63.2235 7.31635 63.6036 7.09144C63.9837 6.86429 64.4358 6.75071 64.9598 6.75071C65.4118 6.75071 65.8077 6.8328 66.1473 6.99698C66.4869 7.16116 66.7557 7.39169 66.9536 7.68857C67.1515 7.98544 67.2606 8.33404 67.2808 8.73438H65.9246C65.8864 8.47573 65.7852 8.2677 65.621 8.11026C65.4591 7.95058 65.2465 7.87074 64.9834 7.87074C64.7607 7.87074 64.5662 7.93146 64.3998 8.05291C64.2356 8.17211 64.1074 8.34641 64.0152 8.57582C63.923 8.80522 63.8769 9.08298 63.8769 9.40909C63.8769 9.7397 63.9218 10.0208 64.0118 10.2525C64.104 10.4841 64.2333 10.6607 64.3998 10.7821C64.5662 10.9036 64.7607 10.9643 64.9834 10.9643C65.1476 10.9643 65.2949 10.9306 65.4253 10.8631C65.558 10.7956 65.6671 10.6978 65.7526 10.5696C65.8403 10.4392 65.8976 10.2828 65.9246 10.1007H67.2808C67.2583 10.4965 67.1504 10.8451 66.9569 11.1465C66.7658 11.4456 66.5015 11.6795 66.1642 11.8482C65.8268 12.0169 65.4276 12.1012 64.9665 12.1012ZM68.2009 12V6.81818H69.6381V12H68.2009ZM68.9229 6.15021C68.7092 6.15021 68.5259 6.07937 68.373 5.93768C68.2223 5.79374 68.147 5.62169 68.147 5.42152C68.147 5.2236 68.2223 5.0538 68.373 4.91211C68.5259 4.76817 68.7092 4.6962 68.9229 4.6962C69.1366 4.6962 69.3187 4.76817 69.4694 4.91211C69.6224 5.0538 69.6988 5.2236 69.6988 5.42152C69.6988 5.62169 69.6224 5.79374 69.4694 5.93768C69.3187 6.07937 69.1366 6.15021 68.9229 6.15021ZM73.1306 12.1012C72.6066 12.1012 72.1534 11.9899 71.771 11.7672C71.391 11.5423 71.0974 11.2297 70.8905 10.8294C70.6836 10.4268 70.5802 9.96011 70.5802 9.42933C70.5802 8.89406 70.6836 8.42625 70.8905 8.02592C71.0974 7.62334 71.391 7.31072 71.771 7.08807C72.1534 6.86316 72.6066 6.75071 73.1306 6.75071C73.6546 6.75071 74.1067 6.86316 74.4868 7.08807C74.8691 7.31072 75.1637 7.62334 75.3706 8.02592C75.5776 8.42625 75.681 8.89406 75.681 9.42933C75.681 9.96011 75.5776 10.4268 75.3706 10.8294C75.1637 11.2297 74.8691 11.5423 74.4868 11.7672C74.1067 11.9899 73.6546 12.1012 73.1306 12.1012ZM73.1373 10.9879C73.3757 10.9879 73.5748 10.9205 73.7345 10.7855C73.8941 10.6483 74.0145 10.4616 74.0954 10.2255C74.1787 9.98935 74.2203 9.72058 74.2203 9.41921C74.2203 9.11784 74.1787 8.84908 74.0954 8.61293C74.0145 8.37678 73.8941 8.1901 73.7345 8.05291C73.5748 7.91572 73.3757 7.84712 73.1373 7.84712C72.8967 7.84712 72.6943 7.91572 72.5301 8.05291C72.3682 8.1901 72.2456 8.37678 72.1624 8.61293C72.0814 8.84908 72.0409 9.11784 72.0409 9.41921C72.0409 9.72058 72.0814 9.98935 72.1624 10.2255C72.2456 10.4616 72.3682 10.6483 72.5301 10.7855C72.6943 10.9205 72.8967 10.9879 73.1373 10.9879ZM78.0526 9.00426V12H76.6155V6.81818H77.9852V7.73242H78.0459C78.1606 7.43105 78.3529 7.19265 78.6228 7.01722C78.8927 6.83955 79.2199 6.75071 79.6045 6.75071C79.9643 6.75071 80.2781 6.82943 80.5457 6.98686C80.8134 7.14429 81.0214 7.3692 81.1698 7.66158C81.3183 7.9517 81.3925 8.29806 81.3925 8.70064V12H79.9553V8.95703C79.9576 8.63991 79.8766 8.39252 79.7124 8.21484C79.5483 8.03492 79.3222 7.94496 79.0344 7.94496C78.8409 7.94496 78.67 7.98656 78.5216 8.06978C78.3754 8.15299 78.2607 8.27444 78.1775 8.43413C78.0965 8.59156 78.0549 8.78161 78.0526 9.00426ZM84.0028 12.0978C83.6722 12.0978 83.3776 12.0405 83.1189 11.9258C82.8603 11.8088 82.6556 11.6368 82.5049 11.4096C82.3565 11.1802 82.2823 10.8946 82.2823 10.5527C82.2823 10.2649 82.3351 10.0231 82.4408 9.82741C82.5465 9.63175 82.6905 9.47431 82.8726 9.35511C83.0548 9.23591 83.2617 9.14595 83.4934 9.08523C83.7273 9.0245 83.9724 8.98177 84.2288 8.95703C84.5302 8.92554 84.7731 8.89631 84.9575 8.86932C85.1419 8.84008 85.2758 8.79735 85.359 8.74112C85.4422 8.6849 85.4838 8.60168 85.4838 8.49148V8.47124C85.4838 8.25758 85.4163 8.09227 85.2814 7.97532C85.1487 7.85837 84.9598 7.79989 84.7146 7.79989C84.456 7.79989 84.2502 7.85724 84.0973 7.97195C83.9443 8.0844 83.8431 8.22609 83.7936 8.39702L82.4644 8.28906C82.5319 7.97419 82.6646 7.70206 82.8625 7.47266C83.0604 7.241 83.3157 7.06333 83.6283 6.93963C83.9432 6.81368 84.3075 6.75071 84.7214 6.75071C85.0092 6.75071 85.2848 6.78445 85.5479 6.85192C85.8133 6.91939 86.0483 7.02397 86.253 7.16566C86.4599 7.30735 86.6229 7.48952 86.7421 7.71218C86.8613 7.93259 86.9209 8.19685 86.9209 8.50497V12H85.558V11.2814H85.5175C85.4343 11.4434 85.323 11.5862 85.1835 11.7099C85.0441 11.8313 84.8766 11.9269 84.6809 11.9966C84.4852 12.0641 84.2592 12.0978 84.0028 12.0978ZM84.4144 11.106C84.6258 11.106 84.8125 11.0644 84.9744 10.9812C85.1363 10.8957 85.2634 10.781 85.3556 10.6371C85.4478 10.4931 85.4939 10.3301 85.4939 10.1479V9.59801C85.4489 9.62725 85.3871 9.65424 85.3084 9.67898C85.2319 9.70147 85.1453 9.72283 85.0486 9.74308C84.9519 9.76107 84.8552 9.77794 84.7585 9.79368C84.6618 9.80717 84.5741 9.81954 84.4953 9.83079C84.3267 9.85553 84.1793 9.89489 84.0534 9.94886C83.9275 10.0028 83.8296 10.0759 83.7599 10.1681C83.6902 10.2581 83.6553 10.3706 83.6553 10.5055C83.6553 10.7012 83.7262 10.8507 83.8679 10.9542C84.0118 11.0554 84.194 11.106 84.4144 11.106ZM92.5759 12.1012C92.0451 12.1012 91.5886 11.9888 91.2062 11.7638C90.8261 11.5367 90.5338 11.2218 90.3291 10.8192C90.1267 10.4167 90.0255 9.95336 90.0255 9.42933C90.0255 8.89856 90.1278 8.433 90.3325 8.03267C90.5394 7.63009 90.8329 7.31635 91.213 7.09144C91.5931 6.86429 92.0451 6.75071 92.5692 6.75071C93.0212 6.75071 93.4171 6.8328 93.7567 6.99698C94.0963 7.16116 94.365 7.39169 94.5629 7.68857C94.7609 7.98544 94.8699 8.33404 94.8902 8.73438H93.534C93.4958 8.47573 93.3946 8.2677 93.2304 8.11026C93.0684 7.95058 92.8559 7.87074 92.5928 7.87074C92.3701 7.87074 92.1756 7.93146 92.0091 8.05291C91.845 8.17211 91.7168 8.34641 91.6246 8.57582C91.5323 8.80522 91.4862 9.08298 91.4862 9.40909C91.4862 9.7397 91.5312 10.0208 91.6212 10.2525C91.7134 10.4841 91.8427 10.6607 92.0091 10.7821C92.1756 10.9036 92.3701 10.9643 92.5928 10.9643C92.757 10.9643 92.9043 10.9306 93.0347 10.8631C93.1674 10.7956 93.2765 10.6978 93.3619 10.5696C93.4497 10.4392 93.507 10.2828 93.534 10.1007H94.8902C94.8677 10.4965 94.7597 10.8451 94.5663 11.1465C94.3751 11.4456 94.1109 11.6795 93.7735 11.8482C93.4362 12.0169 93.037 12.1012 92.5759 12.1012ZM98.1516 12.1012C97.6276 12.1012 97.1744 11.9899 96.792 11.7672C96.4119 11.5423 96.1184 11.2297 95.9115 10.8294C95.7046 10.4268 95.6012 9.96011 95.6012 9.42933C95.6012 8.89406 95.7046 8.42625 95.9115 8.02592C96.1184 7.62334 96.4119 7.31072 96.792 7.08807C97.1744 6.86316 97.6276 6.75071 98.1516 6.75071C98.6756 6.75071 99.1277 6.86316 99.5078 7.08807C99.8901 7.31072 100.185 7.62334 100.392 8.02592C100.599 8.42625 100.702 8.89406 100.702 9.42933C100.702 9.96011 100.599 10.4268 100.392 10.8294C100.185 11.2297 99.8901 11.5423 99.5078 11.7672C99.1277 11.9899 98.6756 12.1012 98.1516 12.1012ZM98.1583 10.9879C98.3967 10.9879 98.5958 10.9205 98.7555 10.7855C98.9151 10.6483 99.0355 10.4616 99.1164 10.2255C99.1996 9.98935 99.2413 9.72058 99.2413 9.41921C99.2413 9.11784 99.1996 8.84908 99.1164 8.61293C99.0355 8.37678 98.9151 8.1901 98.7555 8.05291C98.5958 7.91572 98.3967 7.84712 98.1583 7.84712C97.9177 7.84712 97.7153 7.91572 97.5511 8.05291C97.3892 8.1901 97.2666 8.37678 97.1834 8.61293C97.1024 8.84908 97.0619 9.11784 97.0619 9.41921C97.0619 9.72058 97.1024 9.98935 97.1834 10.2255C97.2666 10.4616 97.3892 10.6483 97.5511 10.7855C97.7153 10.9205 97.9177 10.9879 98.1583 10.9879ZM103.074 9.00426V12H101.636V6.81818H103.006V7.73242H103.067C103.182 7.43105 103.374 7.19265 103.644 7.01722C103.914 6.83955 104.241 6.75071 104.625 6.75071C104.985 6.75071 105.299 6.82943 105.567 6.98686C105.834 7.14429 106.042 7.3692 106.191 7.66158C106.339 7.9517 106.413 8.29806 106.413 8.70064V12H104.976V8.95703C104.979 8.63991 104.898 8.39252 104.733 8.21484C104.569 8.03492 104.343 7.94496 104.055 7.94496C103.862 7.94496 103.691 7.98656 103.543 8.06978C103.396 8.15299 103.282 8.27444 103.198 8.43413C103.117 8.59156 103.076 8.78161 103.074 9.00426Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function rA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2002_4995",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2002_4995)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8481 5.09091 49.2934 5.18424 49.6623 5.37092C50.0334 5.55534 50.3156 5.81735 50.5091 6.15696C50.7047 6.49432 50.8026 6.89128 50.8026 7.34783C50.8026 7.80664 50.7036 8.20135 50.5057 8.53196C50.3078 8.86032 50.021 9.11222 49.6454 9.28764C49.2721 9.46307 48.82 9.55078 48.2892 9.55078H46.4641V8.37678H48.0531C48.332 8.37678 48.5636 8.33854 48.748 8.26207C48.9325 8.18561 49.0697 8.0709 49.1596 7.91797C49.2518 7.76503 49.2979 7.57499 49.2979 7.34783C49.2979 7.11843 49.2518 6.92501 49.1596 6.76758C49.0697 6.61014 48.9313 6.49094 48.7447 6.40998C48.5603 6.32676 48.3275 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM49.3317 8.85582L51.0488 12H49.4363L47.7562 8.85582H49.3317ZM54.0859 12.1012C53.5529 12.1012 53.0941 11.9933 52.7095 11.7773C52.3271 11.5592 52.0325 11.2511 51.8256 10.853C51.6187 10.4527 51.5152 9.97923 51.5152 9.43271C51.5152 8.89968 51.6187 8.43188 51.8256 8.0293C52.0325 7.62672 52.3238 7.31297 52.6994 7.08807C53.0772 6.86316 53.5203 6.75071 54.0285 6.75071C54.3704 6.75071 54.6886 6.80581 54.9833 6.91602C55.2801 7.02397 55.5388 7.18703 55.7592 7.40518C55.9818 7.62334 56.155 7.89773 56.2787 8.22834C56.4024 8.5567 56.4643 8.94129 56.4643 9.3821V9.77681H52.0887V8.88619H55.1115C55.1115 8.67927 55.0665 8.49598 54.9765 8.33629C54.8866 8.17661 54.7617 8.05179 54.6021 7.96183C54.4446 7.86961 54.2613 7.82351 54.0522 7.82351C53.834 7.82351 53.6406 7.87411 53.4719 7.97532C53.3055 8.07428 53.175 8.2081 53.0806 8.37678C52.9861 8.54321 52.9378 8.72875 52.9355 8.93342V9.78018C52.9355 10.0366 52.9827 10.2581 53.0772 10.4448C53.1739 10.6315 53.31 10.7754 53.4854 10.8766C53.6608 10.9778 53.8689 11.0284 54.1095 11.0284C54.2692 11.0284 54.4154 11.0059 54.5481 10.9609C54.6808 10.916 54.7943 10.8485 54.8888 10.7585C54.9833 10.6686 55.0552 10.5584 55.1047 10.4279L56.4339 10.5156C56.3664 10.835 56.2281 11.1139 56.019 11.3523C55.812 11.5884 55.5444 11.7728 55.216 11.9055C54.8899 12.036 54.5132 12.1012 54.0859 12.1012ZM53.4786 6.15021L54.1938 4.61523H55.523L54.4941 6.15021H53.4786ZM58.8797 12.0978C58.5491 12.0978 58.2545 12.0405 57.9959 11.9258C57.7372 11.8088 57.5326 11.6368 57.3819 11.4096C57.2334 11.1802 57.1592 10.8946 57.1592 10.5527C57.1592 10.2649 57.2121 10.0231 57.3178 9.82741C57.4235 9.63175 57.5674 9.47431 57.7496 9.35511C57.9318 9.23591 58.1387 9.14595 58.3703 9.08523C58.6042 9.0245 58.8494 8.98177 59.1058 8.95703C59.4072 8.92554 59.6501 8.89631 59.8345 8.86932C60.0189 8.84008 60.1527 8.79735 60.2359 8.74112C60.3191 8.6849 60.3608 8.60168 60.3608 8.49148V8.47124C60.3608 8.25758 60.2933 8.09227 60.1583 7.97532C60.0256 7.85837 59.8367 7.79989 59.5916 7.79989C59.3329 7.79989 59.1271 7.85724 58.9742 7.97195C58.8213 8.0844 58.7201 8.22609 58.6706 8.39702L57.3414 8.28906C57.4089 7.97419 57.5416 7.70206 57.7395 7.47266C57.9374 7.241 58.1927 7.06333 58.5053 6.93963C58.8201 6.81368 59.1845 6.75071 59.5983 6.75071C59.8862 6.75071 60.1617 6.78445 60.4248 6.85192C60.6902 6.91939 60.9253 7.02397 61.1299 7.16566C61.3368 7.30735 61.4999 7.48952 61.6191 7.71218C61.7383 7.93259 61.7979 8.19685 61.7979 8.50497V12H60.435V11.2814H60.3945C60.3113 11.4434 60.1999 11.5862 60.0605 11.7099C59.9211 11.8313 59.7535 11.9269 59.5578 11.9966C59.3622 12.0641 59.1361 12.0978 58.8797 12.0978ZM59.2913 11.106C59.5027 11.106 59.6894 11.0644 59.8513 10.9812C60.0133 10.8957 60.1403 10.781 60.2326 10.6371C60.3248 10.4931 60.3709 10.3301 60.3709 10.1479V9.59801C60.3259 9.62725 60.264 9.65424 60.1853 9.67898C60.1089 9.70147 60.0223 9.72283 59.9256 9.74308C59.8289 9.76107 59.7321 9.77794 59.6354 9.79368C59.5387 9.80717 59.451 9.81954 59.3723 9.83079C59.2036 9.85553 59.0563 9.89489 58.9304 9.94886C58.8044 10.0028 58.7066 10.0759 58.6369 10.1681C58.5671 10.2581 58.5323 10.3706 58.5323 10.5055C58.5323 10.7012 58.6031 10.8507 58.7448 10.9542C58.8887 11.0554 59.0709 11.106 59.2913 11.106ZM64.35 5.09091V12H62.9129V5.09091H64.35ZM65.5012 12V6.81818H66.9384V12H65.5012ZM66.2232 6.15021C66.0095 6.15021 65.8262 6.07937 65.6733 5.93768C65.5226 5.79374 65.4473 5.62169 65.4473 5.42152C65.4473 5.2236 65.5226 5.0538 65.6733 4.91211C65.8262 4.76817 66.0095 4.6962 66.2232 4.6962C66.4368 4.6962 66.619 4.76817 66.7697 4.91211C66.9226 5.0538 66.9991 5.2236 66.9991 5.42152C66.9991 5.62169 66.9226 5.79374 66.7697 5.93768C66.619 6.07937 66.4368 6.15021 66.2232 6.15021ZM72.4011 8.29581L71.0854 8.37678C71.0629 8.26432 71.0145 8.16312 70.9403 8.07315C70.8661 7.98094 70.7682 7.90785 70.6468 7.85387C70.5276 7.79764 70.3848 7.76953 70.2184 7.76953C69.9957 7.76953 69.8079 7.81676 69.655 7.91122C69.502 8.00343 69.4256 8.12713 69.4256 8.28232C69.4256 8.40601 69.475 8.51059 69.574 8.59606C69.673 8.68152 69.8428 8.75012 70.0834 8.80185L71.0213 8.99077C71.5251 9.09422 71.9006 9.26065 72.148 9.49006C72.3954 9.71946 72.5191 10.0208 72.5191 10.3942C72.5191 10.7338 72.419 11.0318 72.2189 11.2882C72.021 11.5446 71.7488 11.7447 71.4025 11.8887C71.0584 12.0304 70.6614 12.1012 70.2116 12.1012C69.5256 12.1012 68.9791 11.9584 68.572 11.6728C68.1672 11.3849 67.9299 10.9935 67.8602 10.4988L69.2737 10.4245C69.3165 10.6337 69.4199 10.7934 69.5841 10.9036C69.7483 11.0115 69.9586 11.0655 70.215 11.0655C70.4669 11.0655 70.6693 11.0172 70.8222 10.9205C70.9774 10.8215 71.0561 10.6944 71.0584 10.5392C71.0561 10.4088 71.001 10.302 70.8931 10.2188C70.7851 10.1333 70.6187 10.0681 70.3938 10.0231L69.4964 9.84428C68.9904 9.74308 68.6137 9.56765 68.3663 9.318C68.1211 9.06836 67.9985 8.75012 67.9985 8.36328C67.9985 8.03042 68.0885 7.74367 68.2684 7.50302C68.4506 7.26237 68.7059 7.07682 69.0342 6.94638C69.3648 6.81593 69.7517 6.75071 70.1947 6.75071C70.8492 6.75071 71.3642 6.88903 71.7398 7.16566C72.1177 7.44229 72.3381 7.81901 72.4011 8.29581ZM75.7856 12.1012C75.2526 12.1012 74.7938 11.9933 74.4092 11.7773C74.0268 11.5592 73.7322 11.2511 73.5253 10.853C73.3184 10.4527 73.2149 9.97923 73.2149 9.43271C73.2149 8.89968 73.3184 8.43188 73.5253 8.0293C73.7322 7.62672 74.0235 7.31297 74.3991 7.08807C74.7769 6.86316 75.22 6.75071 75.7282 6.75071C76.0701 6.75071 76.3883 6.80581 76.683 6.91602C76.9798 7.02397 77.2385 7.18703 77.4589 7.40518C77.6816 7.62334 77.8547 7.89773 77.9784 8.22834C78.1021 8.5567 78.164 8.94129 78.164 9.3821V9.77681H73.7884V8.88619H76.8112C76.8112 8.67927 76.7662 8.49598 76.6762 8.33629C76.5863 8.17661 76.4614 8.05179 76.3018 7.96183C76.1443 7.86961 75.961 7.82351 75.7519 7.82351C75.5337 7.82351 75.3403 7.87411 75.1716 7.97532C75.0052 8.07428 74.8747 8.2081 74.7803 8.37678C74.6858 8.54321 74.6375 8.72875 74.6352 8.93342V9.78018C74.6352 10.0366 74.6824 10.2581 74.7769 10.4448C74.8736 10.6315 75.0097 10.7754 75.1851 10.8766C75.3605 10.9778 75.5686 11.0284 75.8092 11.0284C75.9689 11.0284 76.1151 11.0059 76.2478 10.9609C76.3805 10.916 76.4941 10.8485 76.5885 10.7585C76.683 10.6686 76.7549 10.5584 76.8044 10.4279L78.1336 10.5156C78.0661 10.835 77.9278 11.1139 77.7187 11.3523C77.5117 11.5884 77.2441 11.7728 76.9157 11.9055C76.5896 12.036 76.2129 12.1012 75.7856 12.1012ZM75.1784 6.15021L75.8936 4.61523H77.2227L76.1938 6.15021H75.1784ZM82.7782 12.0978C82.4476 12.0978 82.153 12.0405 81.8943 11.9258C81.6357 11.8088 81.431 11.6368 81.2803 11.4096C81.1319 11.1802 81.0577 10.8946 81.0577 10.5527C81.0577 10.2649 81.1105 10.0231 81.2162 9.82741C81.3219 9.63175 81.4659 9.47431 81.648 9.35511C81.8302 9.23591 82.0371 9.14595 82.2688 9.08523C82.5027 9.0245 82.7478 8.98177 83.0042 8.95703C83.3056 8.92554 83.5485 8.89631 83.7329 8.86932C83.9173 8.84008 84.0512 8.79735 84.1344 8.74112C84.2176 8.6849 84.2592 8.60168 84.2592 8.49148V8.47124C84.2592 8.25758 84.1917 8.09227 84.0568 7.97532C83.9241 7.85837 83.7352 7.79989 83.49 7.79989C83.2314 7.79989 83.0256 7.85724 82.8726 7.97195C82.7197 8.0844 82.6185 8.22609 82.569 8.39702L81.2398 8.28906C81.3073 7.97419 81.44 7.70206 81.6379 7.47266C81.8358 7.241 82.0911 7.06333 82.4037 6.93963C82.7186 6.81368 83.0829 6.75071 83.4968 6.75071C83.7846 6.75071 84.0601 6.78445 84.3233 6.85192C84.5887 6.91939 84.8237 7.02397 85.0284 7.16566C85.2353 7.30735 85.3983 7.48952 85.5175 7.71218C85.6367 7.93259 85.6963 8.19685 85.6963 8.50497V12H84.3334V11.2814H84.2929C84.2097 11.4434 84.0984 11.5862 83.9589 11.7099C83.8195 11.8313 83.6519 11.9269 83.4563 11.9966C83.2606 12.0641 83.0346 12.0978 82.7782 12.0978ZM83.1898 11.106C83.4012 11.106 83.5878 11.0644 83.7498 10.9812C83.9117 10.8957 84.0388 10.781 84.131 10.6371C84.2232 10.4931 84.2693 10.3301 84.2693 10.1479V9.59801C84.2243 9.62725 84.1625 9.65424 84.0838 9.67898C84.0073 9.70147 83.9207 9.72283 83.824 9.74308C83.7273 9.76107 83.6306 9.77794 83.5339 9.79368C83.4372 9.80717 83.3494 9.81954 83.2707 9.83079C83.1021 9.85553 82.9547 9.89489 82.8288 9.94886C82.7028 10.0028 82.605 10.0759 82.5353 10.1681C82.4656 10.2581 82.4307 10.3706 82.4307 10.5055C82.4307 10.7012 82.5016 10.8507 82.6432 10.9542C82.7872 11.0554 82.9694 11.106 83.1898 11.106ZM91.4567 6.81818L89.6451 12H88.0258L86.2142 6.81818H87.7323L88.8085 10.5257H88.8624L89.9352 6.81818H91.4567ZM94.3867 12.1012C93.8536 12.1012 93.3948 11.9933 93.0103 11.7773C92.6279 11.5592 92.3333 11.2511 92.1264 10.853C91.9195 10.4527 91.816 9.97923 91.816 9.43271C91.816 8.89968 91.9195 8.43188 92.1264 8.0293C92.3333 7.62672 92.6245 7.31297 93.0001 7.08807C93.378 6.86316 93.821 6.75071 94.3293 6.75071C94.6712 6.75071 94.9894 6.80581 95.284 6.91602C95.5809 7.02397 95.8396 7.18703 96.06 7.40518C96.2826 7.62334 96.4558 7.89773 96.5795 8.22834C96.7032 8.5567 96.765 8.94129 96.765 9.3821V9.77681H92.3895V8.88619H95.4122C95.4122 8.67927 95.3673 8.49598 95.2773 8.33629C95.1873 8.17661 95.0625 8.05179 94.9028 7.96183C94.7454 7.86961 94.5621 7.82351 94.3529 7.82351C94.1348 7.82351 93.9414 7.87411 93.7727 7.97532C93.6063 8.07428 93.4758 8.2081 93.3813 8.37678C93.2869 8.54321 93.2385 8.72875 93.2363 8.93342V9.78018C93.2363 10.0366 93.2835 10.2581 93.378 10.4448C93.4747 10.6315 93.6108 10.7754 93.7862 10.8766C93.9616 10.9778 94.1696 11.0284 94.4103 11.0284C94.57 11.0284 94.7162 11.0059 94.8489 10.9609C94.9815 10.916 95.0951 10.8485 95.1896 10.7585C95.284 10.6686 95.356 10.5584 95.4055 10.4279L96.7347 10.5156C96.6672 10.835 96.5289 11.1139 96.3197 11.3523C96.1128 11.5884 95.8452 11.7728 95.5168 11.9055C95.1907 12.036 94.814 12.1012 94.3867 12.1012ZM100.044 12.1012C99.5134 12.1012 99.0568 11.9888 98.6745 11.7638C98.2944 11.5367 98.002 11.2218 97.7974 10.8192C97.5949 10.4167 97.4937 9.95336 97.4937 9.42933C97.4937 8.89856 97.5961 8.433 97.8007 8.03267C98.0076 7.63009 98.3012 7.31635 98.6812 7.09144C99.0613 6.86429 99.5134 6.75071 100.037 6.75071C100.489 6.75071 100.885 6.8328 101.225 6.99698C101.565 7.16116 101.833 7.39169 102.031 7.68857C102.229 7.98544 102.338 8.33404 102.358 8.73438H101.002C100.964 8.47573 100.863 8.2677 100.699 8.11026C100.537 7.95058 100.324 7.87074 100.061 7.87074C99.8384 7.87074 99.6438 7.93146 99.4774 8.05291C99.3132 8.17211 99.185 8.34641 99.0928 8.57582C99.0006 8.80522 98.9545 9.08298 98.9545 9.40909C98.9545 9.7397 98.9995 10.0208 99.0894 10.2525C99.1817 10.4841 99.311 10.6607 99.4774 10.7821C99.6438 10.9036 99.8384 10.9643 100.061 10.9643C100.225 10.9643 100.373 10.9306 100.503 10.8631C100.636 10.7956 100.745 10.6978 100.83 10.5696C100.918 10.4392 100.975 10.2828 101.002 10.1007H102.358C102.336 10.4965 102.228 10.8451 102.035 11.1465C101.843 11.4456 101.579 11.6795 101.242 11.8482C100.904 12.0169 100.505 12.1012 100.044 12.1012Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function uu(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2001_4947",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2001_4947)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M46.1005 12V5.09091H48.8263C49.3504 5.09091 49.7968 5.19099 50.1657 5.39116C50.5345 5.58907 50.8156 5.86458 51.0091 6.21768C51.2047 6.56854 51.3026 6.97337 51.3026 7.43217C51.3026 7.89098 51.2036 8.29581 51.0057 8.64666C50.8078 8.99751 50.521 9.27077 50.1454 9.46644C49.7721 9.66211 49.32 9.75994 48.7892 9.75994H47.0518V8.58931H48.5531C48.8342 8.58931 49.0659 8.54096 49.248 8.44425C49.4325 8.34529 49.5697 8.20922 49.6596 8.03604C49.7518 7.86062 49.7979 7.65933 49.7979 7.43217C49.7979 7.20277 49.7518 7.0026 49.6596 6.83168C49.5697 6.6585 49.4325 6.52468 49.248 6.43022C49.0636 6.33351 48.8297 6.28516 48.5463 6.28516H47.5613V12H46.1005ZM54.4822 12.1012C53.9581 12.1012 53.5049 11.9899 53.1226 11.7672C52.7425 11.5423 52.449 11.2297 52.2421 10.8294C52.0352 10.4268 51.9317 9.96011 51.9317 9.42933C51.9317 8.89406 52.0352 8.42625 52.2421 8.02592C52.449 7.62334 52.7425 7.31072 53.1226 7.08807C53.5049 6.86316 53.9581 6.75071 54.4822 6.75071C55.0062 6.75071 55.4582 6.86316 55.8383 7.08807C56.2207 7.31072 56.5153 7.62334 56.7222 8.02592C56.9291 8.42625 57.0326 8.89406 57.0326 9.42933C57.0326 9.96011 56.9291 10.4268 56.7222 10.8294C56.5153 11.2297 56.2207 11.5423 55.8383 11.7672C55.4582 11.9899 55.0062 12.1012 54.4822 12.1012ZM54.4889 10.9879C54.7273 10.9879 54.9263 10.9205 55.086 10.7855C55.2457 10.6483 55.366 10.4616 55.447 10.2255C55.5302 9.98935 55.5718 9.72058 55.5718 9.41921C55.5718 9.11784 55.5302 8.84908 55.447 8.61293C55.366 8.37678 55.2457 8.1901 55.086 8.05291C54.9263 7.91572 54.7273 7.84712 54.4889 7.84712C54.2483 7.84712 54.0458 7.91572 53.8817 8.05291C53.7197 8.1901 53.5972 8.37678 53.5139 8.61293C53.433 8.84908 53.3925 9.11784 53.3925 9.41921C53.3925 9.72058 53.433 9.98935 53.5139 10.2255C53.5972 10.4616 53.7197 10.6483 53.8817 10.7855C54.0458 10.9205 54.2483 10.9879 54.4889 10.9879ZM58.8594 12L57.4492 6.81818H58.9032L59.7061 10.2997H59.7534L60.59 6.81818H62.017L62.8672 10.2795H62.911L63.7005 6.81818H65.1511L63.7443 12H62.2228L61.3322 8.74112H61.2681L60.3775 12H58.8594ZM68.1494 12.1012C67.6163 12.1012 67.1575 11.9933 66.7729 11.7773C66.3906 11.5592 66.096 11.2511 65.8891 10.853C65.6822 10.4527 65.5787 9.97923 65.5787 9.43271C65.5787 8.89968 65.6822 8.43188 65.8891 8.0293C66.096 7.62672 66.3872 7.31297 66.7628 7.08807C67.1407 6.86316 67.5837 6.75071 68.092 6.75071C68.4339 6.75071 68.7521 6.80581 69.0467 6.91602C69.3436 7.02397 69.6023 7.18703 69.8227 7.40518C70.0453 7.62334 70.2185 7.89773 70.3422 8.22834C70.4659 8.5567 70.5277 8.94129 70.5277 9.3821V9.77681H66.1522V8.88619H69.1749C69.1749 8.67927 69.13 8.49598 69.04 8.33629C68.95 8.17661 68.8252 8.05179 68.6655 7.96183C68.5081 7.86961 68.3248 7.82351 68.1156 7.82351C67.8975 7.82351 67.7041 7.87411 67.5354 7.97532C67.3689 8.07428 67.2385 8.2081 67.144 8.37678C67.0496 8.54321 67.0012 8.72875 66.999 8.93342V9.78018C66.999 10.0366 67.0462 10.2581 67.1407 10.4448C67.2374 10.6315 67.3734 10.7754 67.5489 10.8766C67.7243 10.9778 67.9323 11.0284 68.173 11.0284C68.3327 11.0284 68.4789 11.0059 68.6116 10.9609C68.7442 10.916 68.8578 10.8485 68.9523 10.7585C69.0467 10.6686 69.1187 10.5584 69.1682 10.4279L70.4974 10.5156C70.4299 10.835 70.2916 11.1139 70.0824 11.3523C69.8755 11.5884 69.6079 11.7728 69.2795 11.9055C68.9534 12.036 68.5767 12.1012 68.1494 12.1012ZM71.4656 12V6.81818H72.8589V7.7223H72.9129C73.0073 7.40069 73.1659 7.15779 73.3885 6.99361C73.6112 6.82718 73.8676 6.74396 74.1577 6.74396C74.2297 6.74396 74.3073 6.74846 74.3905 6.75746C74.4737 6.76645 74.5468 6.77882 74.6098 6.79457V8.06978C74.5423 8.04954 74.449 8.03155 74.3298 8.0158C74.2106 8.00006 74.1015 7.99219 74.0025 7.99219C73.7911 7.99219 73.6022 8.03829 73.4358 8.1305C73.2716 8.22047 73.1411 8.34641 73.0444 8.50835C72.95 8.67028 72.9027 8.85695 72.9027 9.06836V12H71.4656ZM77.4731 12.1012C76.9401 12.1012 76.4813 11.9933 76.0967 11.7773C75.7143 11.5592 75.4197 11.2511 75.2128 10.853C75.0059 10.4527 74.9024 9.97923 74.9024 9.43271C74.9024 8.89968 75.0059 8.43188 75.2128 8.0293C75.4197 7.62672 75.711 7.31297 76.0866 7.08807C76.4644 6.86316 76.9075 6.75071 77.4157 6.75071C77.7576 6.75071 78.0758 6.80581 78.3705 6.91602C78.6673 7.02397 78.926 7.18703 79.1464 7.40518C79.3691 7.62334 79.5422 7.89773 79.6659 8.22834C79.7896 8.5567 79.8515 8.94129 79.8515 9.3821V9.77681H75.4759V8.88619H78.4987C78.4987 8.67927 78.4537 8.49598 78.3637 8.33629C78.2738 8.17661 78.1489 8.05179 77.9893 7.96183C77.8318 7.86961 77.6485 7.82351 77.4394 7.82351C77.2212 7.82351 77.0278 7.87411 76.8591 7.97532C76.6927 8.07428 76.5622 8.2081 76.4678 8.37678C76.3733 8.54321 76.325 8.72875 76.3227 8.93342V9.78018C76.3227 10.0366 76.3699 10.2581 76.4644 10.4448C76.5611 10.6315 76.6972 10.7754 76.8726 10.8766C77.048 10.9778 77.2561 11.0284 77.4967 11.0284C77.6564 11.0284 77.8026 11.0059 77.9353 10.9609C78.068 10.916 78.1816 10.8485 78.276 10.7585C78.3705 10.6686 78.4424 10.5584 78.4919 10.4279L79.8211 10.5156C79.7536 10.835 79.6153 11.1139 79.4062 11.3523C79.1992 11.5884 78.9316 11.7728 78.6032 11.9055C78.2771 12.036 77.9004 12.1012 77.4731 12.1012ZM82.6988 12.0843C82.3052 12.0843 81.9487 11.9831 81.6294 11.7807C81.3122 11.5761 81.0603 11.2758 80.8737 10.88C80.6892 10.4819 80.597 9.99384 80.597 9.41584C80.597 8.82209 80.6926 8.32842 80.8838 7.93484C81.075 7.539 81.3291 7.24325 81.6462 7.04759C81.9656 6.84967 82.3153 6.75071 82.6954 6.75071C82.9855 6.75071 83.2273 6.80019 83.4207 6.89915C83.6164 6.99586 83.7738 7.11731 83.893 7.26349C84.0145 7.40743 84.1067 7.54912 84.1697 7.68857H84.2135V5.09091H85.6473V12H84.2304V11.1701H84.1697C84.1022 11.314 84.0066 11.4569 83.8829 11.5985C83.7615 11.738 83.6029 11.8538 83.4072 11.946C83.2138 12.0382 82.9777 12.0843 82.6988 12.0843ZM83.1542 10.9407C83.3859 10.9407 83.5815 10.8777 83.7412 10.7518C83.9031 10.6236 84.0268 10.4448 84.1123 10.2154C84.2 9.98597 84.2439 9.71721 84.2439 9.40909C84.2439 9.10097 84.2011 8.83333 84.1157 8.60618C84.0302 8.37902 83.9065 8.2036 83.7446 8.0799C83.5827 7.9562 83.3859 7.89435 83.1542 7.89435C82.9181 7.89435 82.719 7.95845 82.5571 8.08665C82.3952 8.21484 82.2726 8.39252 82.1894 8.61967C82.1061 8.84683 82.0645 9.10997 82.0645 9.40909C82.0645 9.71046 82.1061 9.97698 82.1894 10.2086C82.2748 10.438 82.3974 10.618 82.5571 10.7484C82.719 10.8766 82.9181 10.9407 83.1542 10.9407ZM89.0546 12V5.09091H90.4917V7.68857H90.5356C90.5986 7.54912 90.6897 7.40743 90.8089 7.26349C90.9303 7.11731 91.0877 6.99586 91.2812 6.89915C91.4768 6.80019 91.7197 6.75071 92.0099 6.75071C92.3877 6.75071 92.7363 6.84967 93.0557 7.04759C93.375 7.24325 93.6303 7.539 93.8215 7.93484C94.0126 8.32842 94.1082 8.82209 94.1082 9.41584C94.1082 9.99384 94.0149 10.4819 93.8282 10.88C93.6438 11.2758 93.3919 11.5761 93.0725 11.7807C92.7554 11.9831 92.4001 12.0843 92.0065 12.0843C91.7276 12.0843 91.4903 12.0382 91.2947 11.946C91.1012 11.8538 90.9427 11.738 90.819 11.5985C90.6953 11.4569 90.6008 11.314 90.5356 11.1701H90.4715V12H89.0546ZM90.4614 9.40909C90.4614 9.71721 90.5041 9.98597 90.5896 10.2154C90.675 10.4448 90.7987 10.6236 90.9607 10.7518C91.1226 10.8777 91.3194 10.9407 91.551 10.9407C91.7849 10.9407 91.9829 10.8766 92.1448 10.7484C92.3067 10.618 92.4293 10.438 92.5125 10.2086C92.598 9.97698 92.6407 9.71046 92.6407 9.40909C92.6407 9.10997 92.5991 8.84683 92.5159 8.61967C92.4327 8.39252 92.3101 8.21484 92.1482 8.08665C91.9862 7.95845 91.7872 7.89435 91.551 7.89435C91.3171 7.89435 91.1192 7.9562 90.9573 8.0799C90.7976 8.2036 90.675 8.37902 90.5896 8.60618C90.5041 8.83333 90.4614 9.10097 90.4614 9.40909ZM95.7874 13.9432C95.6052 13.9432 95.4343 13.9286 95.2746 13.8993C95.1172 13.8723 94.9868 13.8375 94.8833 13.7947L95.2072 12.7219C95.3758 12.7737 95.5277 12.8018 95.6626 12.8063C95.7998 12.8108 95.9179 12.7793 96.0168 12.7118C96.118 12.6444 96.2001 12.5297 96.2631 12.3677L96.3474 12.1484L94.4886 6.81818H96L97.0728 10.6236H97.1267L98.2097 6.81818H99.7311L97.7171 12.56C97.6204 12.8389 97.4888 13.0818 97.3224 13.2887C97.1582 13.4979 96.9502 13.6587 96.6983 13.7711C96.4464 13.8858 96.1428 13.9432 95.7874 13.9432Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function nA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4404 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8042H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2004_5187",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2004_5187)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M49.9115 6.2335V6.7085H52.486V6.2335H49.9115ZM49.9115 5.0365V5.502H52.486V5.0365H49.9115ZM48.876 4.2195H53.5785V7.516H48.876V4.2195ZM48.4105 7.9625H54.063V8.884H48.4105V7.9625ZM50.662 8.466H51.7355V12.3325L50.662 11.867V8.466ZM49.788 10.1475C49.9463 10.6162 50.1553 10.9645 50.415 11.1925C50.6747 11.4142 50.9723 11.563 51.308 11.639C51.6437 11.7087 52.0047 11.7435 52.391 11.7435C52.4733 11.7435 52.5968 11.7435 52.7615 11.7435C52.9325 11.7435 53.1162 11.7435 53.3125 11.7435C53.5152 11.7435 53.7083 11.7435 53.892 11.7435C54.0757 11.7372 54.2182 11.7308 54.3195 11.7245C54.2752 11.8005 54.2308 11.8987 54.1865 12.019C54.1485 12.1393 54.1137 12.2628 54.082 12.3895C54.0503 12.5162 54.025 12.627 54.006 12.722H53.626H52.353C51.9603 12.722 51.5993 12.6935 51.27 12.6365C50.9407 12.5795 50.6398 12.4687 50.3675 12.304C50.0952 12.1393 49.8513 11.9018 49.636 11.5915C49.427 11.2812 49.2497 10.8758 49.104 10.3755L49.788 10.1475ZM51.441 9.7105H53.55V10.6035H51.441V9.7105ZM48.971 9.169L50.0065 9.2925C49.9052 10.0652 49.731 10.7523 49.484 11.354C49.237 11.9493 48.9013 12.4433 48.477 12.836C48.42 12.7727 48.3408 12.6967 48.2395 12.608C48.1382 12.5193 48.0337 12.4338 47.926 12.3515C47.8183 12.2692 47.7233 12.2027 47.641 12.152C48.04 11.8417 48.344 11.4268 48.553 10.9075C48.762 10.3882 48.9013 9.80867 48.971 9.169ZM45.2185 8.751C45.6048 8.66867 46.0672 8.55783 46.6055 8.4185C47.1438 8.27283 47.6885 8.124 48.2395 7.972L48.3915 8.998C47.8912 9.14367 47.3845 9.2925 46.8715 9.4445C46.3585 9.59017 45.8898 9.72317 45.4655 9.8435L45.2185 8.751ZM45.3135 5.73H48.3345V6.775H45.3135V5.73ZM46.3395 3.9345H47.3845V11.525C47.3845 11.7847 47.356 11.9905 47.299 12.1425C47.2483 12.2945 47.1502 12.4148 47.0045 12.5035C46.8588 12.5922 46.6783 12.6492 46.463 12.6745C46.254 12.7062 45.9943 12.722 45.684 12.722C45.6713 12.5827 45.6365 12.4085 45.5795 12.1995C45.5225 11.9968 45.4592 11.8227 45.3895 11.677C45.5605 11.6833 45.722 11.6865 45.874 11.6865C46.026 11.6865 46.1305 11.6833 46.1875 11.677C46.2445 11.677 46.2825 11.6675 46.3015 11.6485C46.3268 11.6232 46.3395 11.5788 46.3395 11.5155V3.9345ZM56.8085 3.944L57.882 4.2765C57.6793 4.81483 57.4387 5.35633 57.16 5.901C56.8813 6.43933 56.5773 6.94917 56.248 7.4305C55.925 7.91183 55.5893 8.33617 55.241 8.7035C55.2093 8.6085 55.1587 8.48817 55.089 8.3425C55.0193 8.1905 54.9433 8.0385 54.861 7.8865C54.7787 7.72817 54.7058 7.60467 54.6425 7.516C54.9275 7.22467 55.203 6.889 55.469 6.509C55.7413 6.129 55.9915 5.7205 56.2195 5.2835C56.4475 4.84017 56.6438 4.39367 56.8085 3.944ZM55.849 6.5945L56.9605 5.4735L56.97 5.483V12.836H55.849V6.5945ZM57.7395 5.787H63.62V6.8795H57.7395V5.787ZM57.502 8.77H63.696V9.891H57.502V8.77ZM58.7845 4.001H59.896V9.3495H58.7845V4.001ZM61.2735 3.982H62.385V9.359H61.2735V3.982ZM59.041 10.271L60.105 10.6035C59.953 10.8822 59.7693 11.1577 59.554 11.43C59.3387 11.7023 59.1138 11.9557 58.8795 12.19C58.6515 12.4307 58.4235 12.6365 58.1955 12.8075C58.1258 12.7442 58.0372 12.665 57.9295 12.57C57.8282 12.4813 57.7205 12.3927 57.6065 12.304C57.4925 12.2153 57.3912 12.1457 57.3025 12.095C57.6445 11.8733 57.9707 11.601 58.281 11.278C58.5913 10.9487 58.8447 10.613 59.041 10.271ZM61.1215 10.765L62.0335 10.2615C62.2425 10.4642 62.4483 10.6827 62.651 10.917C62.8537 11.1513 63.0405 11.3825 63.2115 11.6105C63.3888 11.8385 63.5345 12.0443 63.6485 12.228L62.689 12.836C62.5877 12.6397 62.4515 12.4212 62.2805 12.1805C62.1095 11.9462 61.9227 11.7055 61.72 11.4585C61.5173 11.2052 61.3178 10.974 61.1215 10.765ZM69.3295 7.9055H70.5075V11.202C70.5075 11.3857 70.5265 11.5028 70.5645 11.5535C70.6088 11.5978 70.7102 11.62 70.8685 11.62C70.9002 11.62 70.954 11.62 71.03 11.62C71.106 11.62 71.1883 11.62 71.277 11.62C71.372 11.62 71.4575 11.62 71.5335 11.62C71.6158 11.62 71.6823 11.62 71.733 11.62C71.8407 11.62 71.9198 11.582 71.9705 11.506C72.0275 11.4237 72.0687 11.2685 72.094 11.0405C72.1193 10.8062 72.1383 10.461 72.151 10.005C72.2333 10.0683 72.3378 10.1317 72.4645 10.195C72.5912 10.2583 72.721 10.3153 72.854 10.366C72.987 10.4167 73.1042 10.4547 73.2055 10.48C73.1675 11.05 73.101 11.4965 73.006 11.8195C72.9173 12.1362 72.7812 12.3578 72.5975 12.4845C72.4138 12.6175 72.1605 12.684 71.8375 12.684C71.7805 12.684 71.6982 12.684 71.5905 12.684C71.4892 12.684 71.3783 12.684 71.258 12.684C71.1377 12.684 71.0237 12.684 70.916 12.684C70.8147 12.684 70.7355 12.684 70.6785 12.684C70.3238 12.684 70.0483 12.6365 69.852 12.5415C69.6557 12.4528 69.5195 12.3008 69.4435 12.0855C69.3675 11.8702 69.3295 11.5788 69.3295 11.2115V7.9055ZM64.5035 7.1835H73.025V8.2855H64.5035V7.1835ZM65.368 4.5995H72.151V5.692H65.368V4.5995ZM66.679 8.0575H67.9045C67.8665 8.57683 67.8032 9.07083 67.7145 9.5395C67.6258 10.0082 67.4833 10.4483 67.287 10.86C67.0907 11.2653 66.8088 11.6358 66.4415 11.9715C66.0742 12.3008 65.5928 12.5858 64.9975 12.8265C64.9342 12.6808 64.8328 12.5162 64.6935 12.3325C64.5542 12.1552 64.4212 12.0095 64.2945 11.8955C64.8138 11.7055 65.2255 11.4775 65.5295 11.2115C65.8335 10.9392 66.0647 10.6415 66.223 10.3185C66.3813 9.98917 66.489 9.6345 66.546 9.2545C66.603 8.86817 66.6473 8.46917 66.679 8.0575Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function aA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5620",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5620)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M51.4739 5.09091V12H50.03V6.27841H47.2367V12H45.7928V5.09091H51.4739ZM55.1789 12.1012C54.6549 12.1012 54.2017 11.9899 53.8194 11.7672C53.4393 11.5423 53.1458 11.2297 52.9389 10.8294C52.732 10.4268 52.6285 9.96011 52.6285 9.42933C52.6285 8.89406 52.732 8.42625 52.9389 8.02592C53.1458 7.62334 53.4393 7.31072 53.8194 7.08807C54.2017 6.86316 54.6549 6.75071 55.1789 6.75071C55.703 6.75071 56.155 6.86316 56.5351 7.08807C56.9175 7.31072 57.2121 7.62334 57.419 8.02592C57.6259 8.42625 57.7294 8.89406 57.7294 9.42933C57.7294 9.96011 57.6259 10.4268 57.419 10.8294C57.2121 11.2297 56.9175 11.5423 56.5351 11.7672C56.155 11.9899 55.703 12.1012 55.1789 12.1012ZM55.1857 10.9879C55.4241 10.9879 55.6231 10.9205 55.7828 10.7855C55.9425 10.6483 56.0628 10.4616 56.1438 10.2255C56.227 9.98935 56.2686 9.72058 56.2686 9.41921C56.2686 9.11784 56.227 8.84908 56.1438 8.61293C56.0628 8.37678 55.9425 8.1901 55.7828 8.05291C55.6231 7.91572 55.4241 7.84712 55.1857 7.84712C54.945 7.84712 54.7426 7.91572 54.5784 8.05291C54.4165 8.1901 54.2939 8.37678 54.2107 8.61293C54.1297 8.84908 54.0893 9.11784 54.0893 9.41921C54.0893 9.72058 54.1297 9.98935 54.2107 10.2255C54.2939 10.4616 54.4165 10.6483 54.5784 10.7855C54.7426 10.9205 54.945 10.9879 55.1857 10.9879ZM58.6638 12V6.81818H60.101V8.82883H60.5058L61.916 6.81818H63.6028L61.7709 9.38885L63.623 12H61.916L60.6374 10.1614H60.101V12H58.6638ZM64.2302 13.9432V6.81818H65.6472V7.68857H65.7112C65.7742 7.54912 65.8653 7.40743 65.9845 7.26349C66.106 7.11731 66.2634 6.99586 66.4568 6.89915C66.6525 6.80019 66.8954 6.75071 67.1855 6.75071C67.5633 6.75071 67.9119 6.84967 68.2313 7.04759C68.5507 7.24325 68.8059 7.539 68.9971 7.93484C69.1883 8.32842 69.2839 8.82209 69.2839 9.41584C69.2839 9.99384 69.1905 10.4819 69.0039 10.88C68.8194 11.2758 68.5675 11.5761 68.2482 11.7807C67.9311 11.9831 67.5757 12.0843 67.1821 12.0843C66.9032 12.0843 66.666 12.0382 66.4703 11.946C66.2769 11.8538 66.1183 11.738 65.9946 11.5985C65.8709 11.4569 65.7765 11.314 65.7112 11.1701H65.6674V13.9432H64.2302ZM65.637 9.40909C65.637 9.71721 65.6798 9.98597 65.7652 10.2154C65.8507 10.4448 65.9744 10.6236 66.1363 10.7518C66.2983 10.8777 66.495 10.9407 66.7267 10.9407C66.9606 10.9407 67.1585 10.8766 67.3204 10.7484C67.4824 10.618 67.605 10.438 67.6882 10.2086C67.7736 9.97698 67.8164 9.71046 67.8164 9.40909C67.8164 9.10997 67.7748 8.84683 67.6915 8.61967C67.6083 8.39252 67.4858 8.21484 67.3238 8.08665C67.1619 7.95845 66.9628 7.89435 66.7267 7.89435C66.4928 7.89435 66.2949 7.9562 66.1329 8.0799C65.9733 8.2036 65.8507 8.37902 65.7652 8.60618C65.6798 8.83333 65.637 9.10097 65.637 9.40909ZM72.6035 12.1012C72.0704 12.1012 71.6116 11.9933 71.2271 11.7773C70.8447 11.5592 70.5501 11.2511 70.3432 10.853C70.1363 10.4527 70.0328 9.97923 70.0328 9.43271C70.0328 8.89968 70.1363 8.43188 70.3432 8.0293C70.5501 7.62672 70.8413 7.31297 71.2169 7.08807C71.5948 6.86316 72.0378 6.75071 72.5461 6.75071C72.888 6.75071 73.2062 6.80581 73.5008 6.91602C73.7977 7.02397 74.0564 7.18703 74.2768 7.40518C74.4994 7.62334 74.6726 7.89773 74.7963 8.22834C74.92 8.5567 74.9818 8.94129 74.9818 9.3821V9.77681H70.6063V8.88619H73.629C73.629 8.67927 73.5841 8.49598 73.4941 8.33629C73.4041 8.17661 73.2793 8.05179 73.1196 7.96183C72.9622 7.86961 72.7789 7.82351 72.5697 7.82351C72.3516 7.82351 72.1582 7.87411 71.9895 7.97532C71.823 8.07428 71.6926 8.2081 71.5981 8.37678C71.5037 8.54321 71.4553 8.72875 71.4531 8.93342V9.78018C71.4531 10.0366 71.5003 10.2581 71.5948 10.4448C71.6915 10.6315 71.8275 10.7754 72.003 10.8766C72.1784 10.9778 72.3864 11.0284 72.6271 11.0284C72.7868 11.0284 72.933 11.0059 73.0657 10.9609C73.1983 10.916 73.3119 10.8485 73.4064 10.7585C73.5008 10.6686 73.5728 10.5584 73.6223 10.4279L74.9515 10.5156C74.884 10.835 74.7457 11.1139 74.5365 11.3523C74.3296 11.5884 74.062 11.7728 73.7336 11.9055C73.4075 12.036 73.0308 12.1012 72.6035 12.1012ZM77.3568 9.00426V12H75.9197V5.09091H77.3164V7.73242H77.3771C77.494 7.42655 77.683 7.18703 77.9438 7.01385C78.2047 6.83842 78.532 6.75071 78.9256 6.75071C79.2854 6.75071 79.5992 6.82943 79.8668 6.98686C80.1367 7.14205 80.3458 7.36583 80.4943 7.6582C80.645 7.94833 80.7192 8.29581 80.7169 8.70064V12H79.2798V8.95703C79.282 8.63767 79.2011 8.38915 79.0369 8.21147C78.875 8.03379 78.6478 7.94496 78.3554 7.94496C78.1598 7.94496 77.9866 7.98656 77.8359 8.06978C77.6875 8.15299 77.5705 8.27444 77.485 8.43413C77.4018 8.59156 77.3591 8.78161 77.3568 9.00426ZM74.9312 6.44371V5.59695H78.2947V6.44371H74.9312ZM84.2094 12.1012C83.6764 12.1012 83.2176 11.9933 82.833 11.7773C82.4507 11.5592 82.156 11.2511 81.9491 10.853C81.7422 10.4527 81.6388 9.97923 81.6388 9.43271C81.6388 8.89968 81.7422 8.43188 81.9491 8.0293C82.156 7.62672 82.4473 7.31297 82.8229 7.08807C83.2007 6.86316 83.6438 6.75071 84.1521 6.75071C84.4939 6.75071 84.8122 6.80581 85.1068 6.91602C85.4037 7.02397 85.6623 7.18703 85.8827 7.40518C86.1054 7.62334 86.2786 7.89773 86.4023 8.22834C86.526 8.5567 86.5878 8.94129 86.5878 9.3821V9.77681H82.2123V8.88619H85.235C85.235 8.67927 85.19 8.49598 85.1001 8.33629C85.0101 8.17661 84.8853 8.05179 84.7256 7.96183C84.5682 7.86961 84.3849 7.82351 84.1757 7.82351C83.9575 7.82351 83.7641 7.87411 83.5954 7.97532C83.429 8.07428 83.2986 8.2081 83.2041 8.37678C83.1096 8.54321 83.0613 8.72875 83.059 8.93342V9.78018C83.059 10.0366 83.1063 10.2581 83.2007 10.4448C83.2974 10.6315 83.4335 10.7754 83.6089 10.8766C83.7844 10.9778 83.9924 11.0284 84.233 11.0284C84.3927 11.0284 84.5389 11.0059 84.6716 10.9609C84.8043 10.916 84.9179 10.8485 85.0123 10.7585C85.1068 10.6686 85.1788 10.5584 85.2282 10.4279L86.5574 10.5156C86.49 10.835 86.3517 11.1139 86.1425 11.3523C85.9356 11.5884 85.6679 11.7728 85.3396 11.9055C85.0135 12.036 84.6367 12.1012 84.2094 12.1012ZM93.2734 6.81818V7.94833H91.121V12H89.7244V6.81818H93.2734ZM95.4418 12.0978C95.1112 12.0978 94.8165 12.0405 94.5579 11.9258C94.2992 11.8088 94.0946 11.6368 93.9439 11.4096C93.7955 11.1802 93.7212 10.8946 93.7212 10.5527C93.7212 10.2649 93.7741 10.0231 93.8798 9.82741C93.9855 9.63175 94.1294 9.47431 94.3116 9.35511C94.4938 9.23591 94.7007 9.14595 94.9324 9.08523C95.1663 9.0245 95.4114 8.98177 95.6678 8.95703C95.9692 8.92554 96.2121 8.89631 96.3965 8.86932C96.5809 8.84008 96.7147 8.79735 96.7979 8.74112C96.8812 8.6849 96.9228 8.60168 96.9228 8.49148V8.47124C96.9228 8.25758 96.8553 8.09227 96.7203 7.97532C96.5877 7.85837 96.3987 7.79989 96.1536 7.79989C95.8949 7.79989 95.6892 7.85724 95.5362 7.97195C95.3833 8.0844 95.2821 8.22609 95.2326 8.39702L93.9034 8.28906C93.9709 7.97419 94.1036 7.70206 94.3015 7.47266C94.4994 7.241 94.7547 7.06333 95.0673 6.93963C95.3822 6.81368 95.7465 6.75071 96.1603 6.75071C96.4482 6.75071 96.7237 6.78445 96.9869 6.85192C97.2522 6.91939 97.4873 7.02397 97.6919 7.16566C97.8989 7.30735 98.0619 7.48952 98.1811 7.71218C98.3003 7.93259 98.3599 8.19685 98.3599 8.50497V12H96.997V11.2814H96.9565C96.8733 11.4434 96.762 11.5862 96.6225 11.7099C96.4831 11.8313 96.3155 11.9269 96.1199 11.9966C95.9242 12.0641 95.6982 12.0978 95.4418 12.0978ZM95.8533 11.106C96.0647 11.106 96.2514 11.0644 96.4134 10.9812C96.5753 10.8957 96.7024 10.781 96.7946 10.6371C96.8868 10.4931 96.9329 10.3301 96.9329 10.1479V9.59801C96.8879 9.62725 96.8261 9.65424 96.7473 9.67898C96.6709 9.70147 96.5843 9.72283 96.4876 9.74308C96.3909 9.76107 96.2942 9.77794 96.1974 9.79368C96.1007 9.80717 96.013 9.81954 95.9343 9.83079C95.7656 9.85553 95.6183 9.89489 95.4924 9.94886C95.3664 10.0028 95.2686 10.0759 95.1989 10.1681C95.1291 10.2581 95.0943 10.3706 95.0943 10.5055C95.0943 10.7012 95.1651 10.8507 95.3068 10.9542C95.4508 11.0554 95.6329 11.106 95.8533 11.106Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function iA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5548",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5548)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M51.9496 8.54545C51.9496 9.29889 51.8068 9.93987 51.5211 10.4684C51.2377 10.9969 50.8509 11.4006 50.3606 11.6795C49.8726 11.9561 49.3238 12.0945 48.7143 12.0945C48.1003 12.0945 47.5493 11.955 47.0613 11.6761C46.5732 11.3973 46.1875 10.9935 45.9041 10.465C45.6207 9.93649 45.479 9.29664 45.479 8.54545C45.479 7.79202 45.6207 7.15104 45.9041 6.62251C46.1875 6.09399 46.5732 5.69141 47.0613 5.41477C47.5493 5.13589 48.1003 4.99645 48.7143 4.99645C49.3238 4.99645 49.8726 5.13589 50.3606 5.41477C50.8509 5.69141 51.2377 6.09399 51.5211 6.62251C51.8068 7.15104 51.9496 7.79202 51.9496 8.54545ZM50.4686 8.54545C50.4686 8.05741 50.3955 7.64583 50.2493 7.31072C50.1054 6.97562 49.9018 6.72147 49.6387 6.5483C49.3755 6.37512 49.0674 6.28853 48.7143 6.28853C48.3612 6.28853 48.0531 6.37512 47.79 6.5483C47.5268 6.72147 47.3221 6.97562 47.176 7.31072C47.032 7.64583 46.96 8.05741 46.96 8.54545C46.96 9.0335 47.032 9.44508 47.176 9.78018C47.3221 10.1153 47.5268 10.3694 47.79 10.5426C48.0531 10.7158 48.3612 10.8024 48.7143 10.8024C49.0674 10.8024 49.3755 10.7158 49.6387 10.5426C49.9018 10.3694 50.1054 10.1153 50.2493 9.78018C50.3955 9.44508 50.4686 9.0335 50.4686 8.54545ZM53.0316 12V5.09091H54.4688V7.68857H54.5127C54.5756 7.54912 54.6667 7.40743 54.7859 7.26349C54.9074 7.11731 55.0648 6.99586 55.2582 6.89915C55.4539 6.80019 55.6968 6.75071 55.9869 6.75071C56.3647 6.75071 56.7133 6.84967 57.0327 7.04759C57.3521 7.24325 57.6073 7.539 57.7985 7.93484C57.9897 8.32842 58.0853 8.82209 58.0853 9.41584C58.0853 9.99384 57.9919 10.4819 57.8053 10.88C57.6208 11.2758 57.3689 11.5761 57.0496 11.7807C56.7325 11.9831 56.3771 12.0843 55.9835 12.0843C55.7046 12.0843 55.4674 12.0382 55.2717 11.946C55.0783 11.8538 54.9197 11.738 54.796 11.5985C54.6723 11.4569 54.5779 11.314 54.5127 11.1701H54.4486V12H53.0316ZM54.4384 9.40909C54.4384 9.71721 54.4812 9.98597 54.5666 10.2154C54.6521 10.4448 54.7758 10.6236 54.9377 10.7518C55.0997 10.8777 55.2964 10.9407 55.5281 10.9407C55.762 10.9407 55.9599 10.8766 56.1218 10.7484C56.2838 10.618 56.4064 10.438 56.4896 10.2086C56.575 9.97698 56.6178 9.71046 56.6178 9.40909C56.6178 9.10997 56.5762 8.84683 56.4929 8.61967C56.4097 8.39252 56.2872 8.21484 56.1252 8.08665C55.9633 7.95845 55.7642 7.89435 55.5281 7.89435C55.2942 7.89435 55.0963 7.9562 54.9343 8.0799C54.7747 8.2036 54.6521 8.37902 54.5666 8.60618C54.4812 8.83333 54.4384 9.10097 54.4384 9.40909ZM63.3556 8.29581L62.04 8.37678C62.0175 8.26432 61.9691 8.16312 61.8949 8.07315C61.8207 7.98094 61.7228 7.90785 61.6014 7.85387C61.4822 7.79764 61.3394 7.76953 61.1729 7.76953C60.9503 7.76953 60.7625 7.81676 60.6096 7.91122C60.4566 8.00343 60.3801 8.12713 60.3801 8.28232C60.3801 8.40601 60.4296 8.51059 60.5286 8.59606C60.6275 8.68152 60.7973 8.75012 61.038 8.80185L61.9759 8.99077C62.4796 9.09422 62.8552 9.26065 63.1026 9.49006C63.35 9.71946 63.4737 10.0208 63.4737 10.3942C63.4737 10.7338 63.3736 11.0318 63.1735 11.2882C62.9756 11.5446 62.7034 11.7447 62.3571 11.8887C62.013 12.0304 61.616 12.1012 61.1662 12.1012C60.4802 12.1012 59.9337 11.9584 59.5266 11.6728C59.1218 11.3849 58.8845 10.9935 58.8148 10.4988L60.2283 10.4245C60.2711 10.6337 60.3745 10.7934 60.5387 10.9036C60.7029 11.0115 60.9132 11.0655 61.1696 11.0655C61.4215 11.0655 61.6239 11.0172 61.7768 10.9205C61.932 10.8215 62.0107 10.6944 62.013 10.5392C62.0107 10.4088 61.9556 10.302 61.8477 10.2188C61.7397 10.1333 61.5733 10.0681 61.3484 10.0231L60.451 9.84428C59.945 9.74308 59.5682 9.56765 59.3208 9.318C59.0757 9.06836 58.9531 8.75012 58.9531 8.36328C58.9531 8.03042 59.0431 7.74367 59.223 7.50302C59.4052 7.26237 59.6605 7.07682 59.9888 6.94638C60.3194 6.81593 60.7063 6.75071 61.1493 6.75071C61.8038 6.75071 62.3188 6.88903 62.6944 7.16566C63.0723 7.44229 63.2927 7.81901 63.3556 8.29581ZM66.4602 7.50302V8.29918L63.7343 9.17294V8.37678L66.4602 7.50302ZM65.8158 5.09091V12H64.3787V5.09091H65.8158ZM70.29 9.79368V6.81818H71.7272V12H70.3474V11.0588H70.2934C70.1765 11.3624 69.9819 11.6064 69.7098 11.7908C69.4399 11.9753 69.1104 12.0675 68.7213 12.0675C68.375 12.0675 68.0702 11.9888 67.8071 11.8313C67.5439 11.6739 67.3382 11.4501 67.1897 11.16C67.0435 10.8699 66.9693 10.5224 66.9671 10.1175V6.81818H68.4042V9.86115C68.4065 10.167 68.4885 10.4088 68.6505 10.5865C68.8124 10.7641 69.0294 10.853 69.3016 10.853C69.4748 10.853 69.6367 10.8136 69.7874 10.7349C69.9381 10.6539 70.0595 10.5347 70.1517 10.3773C70.2462 10.2199 70.2923 10.0253 70.29 9.79368ZM75.2112 14.0511C74.7457 14.0511 74.3465 13.987 74.0136 13.8588C73.683 13.7329 73.4199 13.5608 73.2242 13.3427C73.0285 13.1245 72.9015 12.8794 72.843 12.6072L74.1722 12.4284C74.2127 12.5319 74.2768 12.6286 74.3645 12.7186C74.4522 12.8085 74.568 12.8805 74.712 12.9345C74.8581 12.9907 75.0358 13.0188 75.245 13.0188C75.5576 13.0188 75.8151 12.9424 76.0175 12.7894C76.2222 12.6387 76.3245 12.3857 76.3245 12.0304V11.0824H76.2638C76.2008 11.2263 76.1064 11.3624 75.9804 11.4906C75.8545 11.6188 75.6925 11.7234 75.4946 11.8043C75.2967 11.8853 75.0606 11.9258 74.7862 11.9258C74.3971 11.9258 74.0429 11.8358 73.7235 11.6559C73.4064 11.4737 73.1534 11.196 72.9644 10.8226C72.7778 10.447 72.6844 9.97248 72.6844 9.39897C72.6844 8.81197 72.78 8.32167 72.9712 7.92809C73.1624 7.53451 73.4165 7.23988 73.7336 7.04421C74.053 6.84854 74.4027 6.75071 74.7828 6.75071C75.0729 6.75071 75.3158 6.80019 75.5115 6.89915C75.7072 6.99586 75.8646 7.11731 75.9838 7.26349C76.1052 7.40743 76.1986 7.54912 76.2638 7.68857H76.3178V6.81818H77.7448V12.0506C77.7448 12.4914 77.6369 12.8603 77.4209 13.1571C77.205 13.454 76.9059 13.6767 76.5236 13.8251C76.1435 13.9758 75.706 14.0511 75.2112 14.0511ZM75.2416 10.8462C75.4733 10.8462 75.6689 10.7889 75.8286 10.6742C75.9905 10.5572 76.1142 10.3908 76.1997 10.1749C76.2874 9.95674 76.3313 9.69585 76.3313 9.39222C76.3313 9.0886 76.2885 8.82546 76.2031 8.60281C76.1176 8.3779 75.9939 8.2036 75.832 8.0799C75.6701 7.9562 75.4733 7.89435 75.2416 7.89435C75.0055 7.89435 74.8064 7.95845 74.6445 8.08665C74.4826 8.21259 74.36 8.38802 74.2768 8.61293C74.1936 8.83783 74.1519 9.0976 74.1519 9.39222C74.1519 9.69135 74.1936 9.94999 74.2768 10.1681C74.3622 10.3841 74.4848 10.5516 74.6445 10.6708C74.8064 10.7878 75.0055 10.8462 75.2416 10.8462ZM78.8884 12V6.81818H80.3256V12H78.8884ZM79.6104 6.15021C79.3967 6.15021 79.2134 6.07937 79.0605 5.93768C78.9098 5.79374 78.8345 5.62169 78.8345 5.42152C78.8345 5.2236 78.9098 5.0538 79.0605 4.91211C79.2134 4.76817 79.3967 4.6962 79.6104 4.6962C79.8241 4.6962 80.0062 4.76817 80.1569 4.91211C80.3099 5.0538 80.3863 5.2236 80.3863 5.42152C80.3863 5.62169 80.3099 5.79374 80.1569 5.93768C80.0062 6.07937 79.8241 6.15021 79.6104 6.15021ZM82.499 12L81.0889 6.81818H82.5429L83.3458 10.2997H83.393L84.2297 6.81818H85.6567L86.5068 10.2795H86.5507L87.3401 6.81818H88.7907L87.384 12H85.8625L84.9719 8.74112H84.9078L84.0171 12H82.499ZM91.035 12.0978C90.7044 12.0978 90.4098 12.0405 90.1511 11.9258C89.8925 11.8088 89.6878 11.6368 89.5372 11.4096C89.3887 11.1802 89.3145 10.8946 89.3145 10.5527C89.3145 10.2649 89.3674 10.0231 89.4731 9.82741C89.5788 9.63175 89.7227 9.47431 89.9049 9.35511C90.087 9.23591 90.294 9.14595 90.5256 9.08523C90.7595 9.0245 91.0047 8.98177 91.2611 8.95703C91.5624 8.92554 91.8053 8.89631 91.9897 8.86932C92.1742 8.84008 92.308 8.79735 92.3912 8.74112C92.4744 8.6849 92.516 8.60168 92.516 8.49148V8.47124C92.516 8.25758 92.4486 8.09227 92.3136 7.97532C92.1809 7.85837 91.992 7.79989 91.7468 7.79989C91.4882 7.79989 91.2824 7.85724 91.1295 7.97195C90.9765 8.0844 90.8753 8.22609 90.8259 8.39702L89.4967 8.28906C89.5641 7.97419 89.6968 7.70206 89.8948 7.47266C90.0927 7.241 90.3479 7.06333 90.6606 6.93963C90.9754 6.81368 91.3398 6.75071 91.7536 6.75071C92.0415 6.75071 92.317 6.78445 92.5801 6.85192C92.8455 6.91939 93.0805 7.02397 93.2852 7.16566C93.4921 7.30735 93.6552 7.48952 93.7744 7.71218C93.8936 7.93259 93.9532 8.19685 93.9532 8.50497V12H92.5902V11.2814H92.5498C92.4665 11.4434 92.3552 11.5862 92.2158 11.7099C92.0763 11.8313 91.9088 11.9269 91.7131 11.9966C91.5174 12.0641 91.2914 12.0978 91.035 12.0978ZM91.4466 11.106C91.658 11.106 91.8447 11.0644 92.0066 10.9812C92.1685 10.8957 92.2956 10.781 92.3878 10.6371C92.48 10.4931 92.5261 10.3301 92.5261 10.1479V9.59801C92.4812 9.62725 92.4193 9.65424 92.3406 9.67898C92.2641 9.70147 92.1775 9.72283 92.0808 9.74308C91.9841 9.76107 91.8874 9.77794 91.7907 9.79368C91.694 9.80717 91.6063 9.81954 91.5276 9.83079C91.3589 9.85553 91.2116 9.89489 91.0856 9.94886C90.9597 10.0028 90.8618 10.0759 90.7921 10.1681C90.7224 10.2581 90.6875 10.3706 90.6875 10.5055C90.6875 10.7012 90.7584 10.8507 90.9001 10.9542C91.044 11.0554 91.2262 11.106 91.4466 11.106ZM96.5053 9.00426V12H95.0681V6.81818H96.4378V7.73242H96.4985C96.6132 7.43105 96.8055 7.19265 97.0754 7.01722C97.3453 6.83955 97.6725 6.75071 98.0571 6.75071C98.417 6.75071 98.7307 6.82943 98.9984 6.98686C99.266 7.14429 99.474 7.3692 99.6225 7.66158C99.7709 7.9517 99.8451 8.29806 99.8451 8.70064V12H98.408V8.95703C98.4102 8.63991 98.3293 8.39252 98.1651 8.21484C98.0009 8.03492 97.7749 7.94496 97.487 7.94496C97.2936 7.94496 97.1226 7.98656 96.9742 8.06978C96.828 8.15299 96.7133 8.27444 96.6301 8.43413C96.5491 8.59156 96.5075 8.78161 96.5053 9.00426ZM103.339 12.1012C102.806 12.1012 102.347 11.9933 101.963 11.7773C101.581 11.5592 101.286 11.2511 101.079 10.853C100.872 10.4527 100.769 9.97923 100.769 9.43271C100.769 8.89968 100.872 8.43188 101.079 8.0293C101.286 7.62672 101.577 7.31297 101.953 7.08807C102.331 6.86316 102.774 6.75071 103.282 6.75071C103.624 6.75071 103.942 6.80581 104.237 6.91602C104.534 7.02397 104.792 7.18703 105.013 7.40518C105.235 7.62334 105.408 7.89773 105.532 8.22834C105.656 8.5567 105.718 8.94129 105.718 9.3821V9.77681H101.342V8.88619H104.365C104.365 8.67927 104.32 8.49598 104.23 8.33629C104.14 8.17661 104.015 8.05179 103.855 7.96183C103.698 7.86961 103.515 7.82351 103.306 7.82351C103.087 7.82351 102.894 7.87411 102.725 7.97532C102.559 8.07428 102.428 8.2081 102.334 8.37678C102.24 8.54321 102.191 8.72875 102.189 8.93342V9.78018C102.189 10.0366 102.236 10.2581 102.331 10.4448C102.427 10.6315 102.563 10.7754 102.739 10.8766C102.914 10.9778 103.122 11.0284 103.363 11.0284C103.523 11.0284 103.669 11.0059 103.801 10.9609C103.934 10.916 104.048 10.8485 104.142 10.7585C104.237 10.6686 104.309 10.5584 104.358 10.4279L105.687 10.5156C105.62 10.835 105.482 11.1139 105.272 11.3523C105.065 11.5884 104.798 11.7728 104.469 11.9055C104.143 12.036 103.767 12.1012 103.339 12.1012ZM108.854 13.9432V6.81818H110.271V7.68857H110.335C110.398 7.54912 110.489 7.40743 110.609 7.26349C110.73 7.11731 110.887 6.99586 111.081 6.89915C111.277 6.80019 111.519 6.75071 111.81 6.75071C112.187 6.75071 112.536 6.84967 112.855 7.04759C113.175 7.24325 113.43 7.539 113.621 7.93484C113.812 8.32842 113.908 8.82209 113.908 9.41584C113.908 9.99384 113.815 10.4819 113.628 10.88C113.443 11.2758 113.192 11.5761 112.872 11.7807C112.555 11.9831 112.2 12.0843 111.806 12.0843C111.527 12.0843 111.29 12.0382 111.094 11.946C110.901 11.8538 110.742 11.738 110.619 11.5985C110.495 11.4569 110.4 11.314 110.335 11.1701H110.291V13.9432H108.854ZM110.261 9.40909C110.261 9.71721 110.304 9.98597 110.389 10.2154C110.475 10.4448 110.598 10.6236 110.76 10.7518C110.922 10.8777 111.119 10.9407 111.351 10.9407C111.585 10.9407 111.783 10.8766 111.944 10.7484C112.106 10.618 112.229 10.438 112.312 10.2086C112.398 9.97698 112.44 9.71046 112.44 9.40909C112.44 9.10997 112.399 8.84683 112.316 8.61967C112.232 8.39252 112.11 8.21484 111.948 8.08665C111.786 7.95845 111.587 7.89435 111.351 7.89435C111.117 7.89435 110.919 7.9562 110.757 8.0799C110.597 8.2036 110.475 8.37902 110.389 8.60618C110.304 8.83333 110.261 9.10097 110.261 9.40909ZM114.866 12V6.81818H116.259V7.7223H116.313C116.408 7.40069 116.566 7.15779 116.789 6.99361C117.012 6.82718 117.268 6.74396 117.558 6.74396C117.63 6.74396 117.708 6.74846 117.791 6.75746C117.874 6.76645 117.947 6.77882 118.01 6.79457V8.06978C117.943 8.04954 117.849 8.03155 117.73 8.0158C117.611 8.00006 117.502 7.99219 117.403 7.99219C117.192 7.99219 117.003 8.03829 116.836 8.1305C116.672 8.22047 116.542 8.34641 116.445 8.50835C116.35 8.67028 116.303 8.85695 116.303 9.06836V12H114.866ZM118.726 12V11.1431L121.263 8.00231V7.9652H118.814V6.81818H122.994V7.75266L120.612 10.8159V10.853H123.081V12H118.726ZM126.394 12.1012C125.86 12.1012 125.402 11.9933 125.017 11.7773C124.635 11.5592 124.34 11.2511 124.133 10.853C123.926 10.4527 123.823 9.97923 123.823 9.43271C123.823 8.89968 123.926 8.43188 124.133 8.0293C124.34 7.62672 124.631 7.31297 125.007 7.08807C125.385 6.86316 125.828 6.75071 126.336 6.75071C126.678 6.75071 126.996 6.80581 127.291 6.91602C127.588 7.02397 127.846 7.18703 128.067 7.40518C128.289 7.62334 128.463 7.89773 128.586 8.22834C128.71 8.5567 128.772 8.94129 128.772 9.3821V9.77681H124.396V8.88619H127.419C127.419 8.67927 127.374 8.49598 127.284 8.33629C127.194 8.17661 127.069 8.05179 126.91 7.96183C126.752 7.86961 126.569 7.82351 126.36 7.82351C126.142 7.82351 125.948 7.87411 125.78 7.97532C125.613 8.07428 125.483 8.2081 125.388 8.37678C125.294 8.54321 125.245 8.72875 125.243 8.93342V9.78018C125.243 10.0366 125.29 10.2581 125.385 10.4448C125.482 10.6315 125.618 10.7754 125.793 10.8766C125.968 10.9778 126.176 11.0284 126.417 11.0284C126.577 11.0284 126.723 11.0059 126.856 10.9609C126.988 10.916 127.102 10.8485 127.196 10.7585C127.291 10.6686 127.363 10.5584 127.412 10.4279L128.742 10.5156C128.674 10.835 128.536 11.1139 128.327 11.3523C128.12 11.5884 127.852 11.7728 127.524 11.9055C127.198 12.036 126.821 12.1012 126.394 12.1012ZM129.683 12V11.1431L132.22 8.00231V7.9652H129.77V6.81818H133.95V7.75266L131.569 10.8159V10.853H134.038V12H129.683Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function oA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5524",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5524)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM52.4851 12V6.81818H53.9223V12H52.4851ZM53.2071 6.15021C52.9934 6.15021 52.8101 6.07937 52.6572 5.93768C52.5065 5.79374 52.4312 5.62169 52.4312 5.42152C52.4312 5.2236 52.5065 5.0538 52.6572 4.91211C52.8101 4.76817 52.9934 4.6962 53.2071 4.6962C53.4207 4.6962 53.6029 4.76817 53.7536 4.91211C53.9065 5.0538 53.983 5.2236 53.983 5.42152C53.983 5.62169 53.9065 5.79374 53.7536 5.93768C53.6029 6.07937 53.4207 6.15021 53.2071 6.15021ZM55.0735 13.9432V6.81818H56.4904V7.68857H56.5545C56.6175 7.54912 56.7086 7.40743 56.8278 7.26349C56.9492 7.11731 57.1067 6.99586 57.3001 6.89915C57.4957 6.80019 57.7386 6.75071 58.0288 6.75071C58.4066 6.75071 58.7552 6.84967 59.0746 7.04759C59.3939 7.24325 59.6492 7.539 59.8404 7.93484C60.0315 8.32842 60.1271 8.82209 60.1271 9.41584C60.1271 9.99384 60.0338 10.4819 59.8471 10.88C59.6627 11.2758 59.4108 11.5761 59.0914 11.7807C58.7743 11.9831 58.419 12.0843 58.0254 12.0843C57.7465 12.0843 57.5092 12.0382 57.3136 11.946C57.1201 11.8538 56.9616 11.738 56.8379 11.5985C56.7142 11.4569 56.6197 11.314 56.5545 11.1701H56.5107V13.9432H55.0735ZM56.4803 9.40909C56.4803 9.71721 56.523 9.98597 56.6085 10.2154C56.694 10.4448 56.8176 10.6236 56.9796 10.7518C57.1415 10.8777 57.3383 10.9407 57.57 10.9407C57.8039 10.9407 58.0018 10.8766 58.1637 10.7484C58.3256 10.618 58.4482 10.438 58.5314 10.2086C58.6169 9.97698 58.6596 9.71046 58.6596 9.40909C58.6596 9.10997 58.618 8.84683 58.5348 8.61967C58.4516 8.39252 58.329 8.21484 58.1671 8.08665C58.0051 7.95845 57.8061 7.89435 57.57 7.89435C57.3361 7.89435 57.1381 7.9562 56.9762 8.0799C56.8165 8.2036 56.694 8.37902 56.6085 8.60618C56.523 8.83333 56.4803 9.10097 56.4803 9.40909ZM63.4467 12.1012C62.9137 12.1012 62.4549 11.9933 62.0703 11.7773C61.688 11.5592 61.3933 11.2511 61.1864 10.853C60.9795 10.4527 60.8761 9.97923 60.8761 9.43271C60.8761 8.89968 60.9795 8.43188 61.1864 8.0293C61.3933 7.62672 61.6846 7.31297 62.0602 7.08807C62.438 6.86316 62.8811 6.75071 63.3894 6.75071C63.7312 6.75071 64.0495 6.80581 64.3441 6.91602C64.641 7.02397 64.8996 7.18703 65.12 7.40518C65.3427 7.62334 65.5159 7.89773 65.6396 8.22834C65.7633 8.5567 65.8251 8.94129 65.8251 9.3821V9.77681H61.4496V8.88619H64.4723C64.4723 8.67927 64.4273 8.49598 64.3374 8.33629C64.2474 8.17661 64.1226 8.05179 63.9629 7.96183C63.8055 7.86961 63.6222 7.82351 63.413 7.82351C63.1948 7.82351 63.0014 7.87411 62.8327 7.97532C62.6663 8.07428 62.5359 8.2081 62.4414 8.37678C62.3469 8.54321 62.2986 8.72875 62.2963 8.93342V9.78018C62.2963 10.0366 62.3436 10.2581 62.438 10.4448C62.5347 10.6315 62.6708 10.7754 62.8462 10.8766C63.0217 10.9778 63.2297 11.0284 63.4703 11.0284C63.63 11.0284 63.7762 11.0059 63.9089 10.9609C64.0416 10.916 64.1552 10.8485 64.2496 10.7585C64.3441 10.6686 64.4161 10.5584 64.4656 10.4279L65.7947 10.5156C65.7273 10.835 65.589 11.1139 65.3798 11.3523C65.1729 11.5884 64.9052 11.7728 64.5769 11.9055C64.2508 12.036 63.8741 12.1012 63.4467 12.1012ZM66.763 12V6.81818H68.1562V7.7223H68.2102C68.3047 7.40069 68.4632 7.15779 68.6859 6.99361C68.9086 6.82718 69.165 6.74396 69.4551 6.74396C69.527 6.74396 69.6046 6.74846 69.6879 6.75746C69.7711 6.76645 69.8442 6.77882 69.9071 6.79457V8.06978C69.8397 8.04954 69.7463 8.03155 69.6271 8.0158C69.5079 8.00006 69.3989 7.99219 69.2999 7.99219C69.0885 7.99219 68.8996 8.03829 68.7331 8.1305C68.569 8.22047 68.4385 8.34641 68.3418 8.50835C68.2473 8.67028 68.2001 8.85695 68.2001 9.06836V12H66.763ZM74.9616 8.29581L73.6459 8.37678C73.6234 8.26432 73.5751 8.16312 73.5008 8.07315C73.4266 7.98094 73.3288 7.90785 73.2073 7.85387C73.0881 7.79764 72.9453 7.76953 72.7789 7.76953C72.5562 7.76953 72.3684 7.81676 72.2155 7.91122C72.0626 8.00343 71.9861 8.12713 71.9861 8.28232C71.9861 8.40601 72.0356 8.51059 72.1345 8.59606C72.2335 8.68152 72.4033 8.75012 72.644 8.80185L73.5818 8.99077C74.0856 9.09422 74.4612 9.26065 74.7086 9.49006C74.956 9.71946 75.0797 10.0208 75.0797 10.3942C75.0797 10.7338 74.9796 11.0318 74.7794 11.2882C74.5815 11.5446 74.3094 11.7447 73.963 11.8887C73.6189 12.0304 73.222 12.1012 72.7722 12.1012C72.0862 12.1012 71.5397 11.9584 71.1326 11.6728C70.7278 11.3849 70.4905 10.9935 70.4208 10.4988L71.8343 10.4245C71.877 10.6337 71.9805 10.7934 72.1447 10.9036C72.3088 11.0115 72.5191 11.0655 72.7755 11.0655C73.0274 11.0655 73.2298 11.0172 73.3828 10.9205C73.538 10.8215 73.6167 10.6944 73.6189 10.5392C73.6167 10.4088 73.5616 10.302 73.4536 10.2188C73.3457 10.1333 73.1792 10.0681 72.9543 10.0231L72.057 9.84428C71.5509 9.74308 71.1742 9.56765 70.9268 9.318C70.6817 9.06836 70.5591 8.75012 70.5591 8.36328C70.5591 8.03042 70.649 7.74367 70.829 7.50302C71.0111 7.26237 71.2664 7.07682 71.5948 6.94638C71.9254 6.81593 72.3122 6.75071 72.7553 6.75071C73.4098 6.75071 73.9248 6.88903 74.3004 7.16566C74.6782 7.44229 74.8986 7.81901 74.9616 8.29581ZM78.3461 12.1012C77.8131 12.1012 77.3543 11.9933 76.9697 11.7773C76.5874 11.5592 76.2928 11.2511 76.0858 10.853C75.8789 10.4527 75.7755 9.97923 75.7755 9.43271C75.7755 8.89968 75.8789 8.43188 76.0858 8.0293C76.2928 7.62672 76.584 7.31297 76.9596 7.08807C77.3374 6.86316 77.7805 6.75071 78.2888 6.75071C78.6307 6.75071 78.9489 6.80581 79.2435 6.91602C79.5404 7.02397 79.799 7.18703 80.0194 7.40518C80.2421 7.62334 80.4153 7.89773 80.539 8.22834C80.6627 8.5567 80.7245 8.94129 80.7245 9.3821V9.77681H76.349V8.88619H79.3717C79.3717 8.67927 79.3267 8.49598 79.2368 8.33629C79.1468 8.17661 79.022 8.05179 78.8623 7.96183C78.7049 7.86961 78.5216 7.82351 78.3124 7.82351C78.0943 7.82351 77.9008 7.87411 77.7322 7.97532C77.5657 8.07428 77.4353 8.2081 77.3408 8.37678C77.2464 8.54321 77.198 8.72875 77.1958 8.93342V9.78018C77.1958 10.0366 77.243 10.2581 77.3374 10.4448C77.4342 10.6315 77.5702 10.7754 77.7456 10.8766C77.9211 10.9778 78.1291 11.0284 78.3698 11.0284C78.5294 11.0284 78.6756 11.0059 78.8083 10.9609C78.941 10.916 79.0546 10.8485 79.1491 10.7585C79.2435 10.6686 79.3155 10.5584 79.365 10.4279L80.6942 10.5156C80.6267 10.835 80.4884 11.1139 80.2792 11.3523C80.0723 11.5884 79.8047 11.7728 79.4763 11.9055C79.1502 12.036 78.7735 12.1012 78.3461 12.1012ZM81.6624 12V6.81818H83.032V7.73242H83.0928C83.2007 7.4288 83.3807 7.18928 83.6325 7.01385C83.8844 6.83842 84.1858 6.75071 84.5367 6.75071C84.892 6.75071 85.1945 6.83955 85.4442 7.01722C85.6938 7.19265 85.8602 7.43105 85.9434 7.73242H85.9974C86.1031 7.43555 86.2943 7.19827 86.5709 7.0206C86.8498 6.84067 87.1793 6.75071 87.5594 6.75071C88.0429 6.75071 88.4354 6.90477 88.7368 7.21289C89.0404 7.51876 89.1922 7.95283 89.1922 8.51509V12H87.7584V8.79847C87.7584 8.51059 87.682 8.29469 87.529 8.15075C87.3761 8.00681 87.1849 7.93484 86.9555 7.93484C86.6946 7.93484 86.4911 8.01805 86.3449 8.18448C86.1987 8.34866 86.1256 8.5657 86.1256 8.83558V12H84.7323V8.76811C84.7323 8.51397 84.6592 8.31155 84.5131 8.16087C84.3691 8.01018 84.1791 7.93484 83.9429 7.93484C83.7832 7.93484 83.6393 7.97532 83.5111 8.05629C83.3852 8.135 83.2851 8.24633 83.2108 8.39027C83.1366 8.53196 83.0995 8.69839 83.0995 8.88956V12H81.6624ZM90.3544 12V5.09091H91.7915V7.68857H91.8354C91.8984 7.54912 91.9895 7.40743 92.1087 7.26349C92.2301 7.11731 92.3875 6.99586 92.581 6.89915C92.7766 6.80019 93.0195 6.75071 93.3097 6.75071C93.6875 6.75071 94.0361 6.84967 94.3555 7.04759C94.6748 7.24325 94.9301 7.539 95.1213 7.93484C95.3124 8.32842 95.408 8.82209 95.408 9.41584C95.408 9.99384 95.3147 10.4819 95.128 10.88C94.9436 11.2758 94.6917 11.5761 94.3723 11.7807C94.0552 11.9831 93.6999 12.0843 93.3063 12.0843C93.0274 12.0843 92.7901 12.0382 92.5945 11.946C92.401 11.8538 92.2425 11.738 92.1188 11.5985C91.9951 11.4569 91.9006 11.314 91.8354 11.1701H91.7713V12H90.3544ZM91.7612 9.40909C91.7612 9.71721 91.8039 9.98597 91.8894 10.2154C91.9748 10.4448 92.0985 10.6236 92.2605 10.7518C92.4224 10.8777 92.6192 10.9407 92.8509 10.9407C93.0848 10.9407 93.2827 10.8766 93.4446 10.7484C93.6065 10.618 93.7291 10.438 93.8123 10.2086C93.8978 9.97698 93.9405 9.71046 93.9405 9.40909C93.9405 9.10997 93.8989 8.84683 93.8157 8.61967C93.7325 8.39252 93.6099 8.21484 93.448 8.08665C93.286 7.95845 93.087 7.89435 92.8509 7.89435C92.617 7.89435 92.419 7.9562 92.2571 8.0799C92.0974 8.2036 91.9748 8.37902 91.8894 8.60618C91.8039 8.83333 91.7612 9.10097 91.7612 9.40909ZM97.8446 12.0978C97.514 12.0978 97.2194 12.0405 96.9607 11.9258C96.7021 11.8088 96.4974 11.6368 96.3467 11.4096C96.1983 11.1802 96.1241 10.8946 96.1241 10.5527C96.1241 10.2649 96.1769 10.0231 96.2826 9.82741C96.3883 9.63175 96.5323 9.47431 96.7144 9.35511C96.8966 9.23591 97.1035 9.14595 97.3352 9.08523C97.5691 9.0245 97.8142 8.98177 98.0706 8.95703C98.372 8.92554 98.6149 8.89631 98.7993 8.86932C98.9837 8.84008 99.1176 8.79735 99.2008 8.74112C99.284 8.6849 99.3256 8.60168 99.3256 8.49148V8.47124C99.3256 8.25758 99.2581 8.09227 99.1232 7.97532C98.9905 7.85837 98.8016 7.79989 98.5564 7.79989C98.2978 7.79989 98.092 7.85724 97.9391 7.97195C97.7861 8.0844 97.6849 8.22609 97.6354 8.39702L96.3062 8.28906C96.3737 7.97419 96.5064 7.70206 96.7043 7.47266C96.9022 7.241 97.1575 7.06333 97.4701 6.93963C97.785 6.81368 98.1493 6.75071 98.5632 6.75071C98.851 6.75071 99.1266 6.78445 99.3897 6.85192C99.6551 6.91939 99.8901 7.02397 100.095 7.16566C100.302 7.30735 100.465 7.48952 100.584 7.71218C100.703 7.93259 100.763 8.19685 100.763 8.50497V12H99.3998V11.2814H99.3593C99.2761 11.4434 99.1648 11.5862 99.0253 11.7099C98.8859 11.8313 98.7184 11.9269 98.5227 11.9966C98.327 12.0641 98.101 12.0978 97.8446 12.0978ZM98.2562 11.106C98.4676 11.106 98.6543 11.0644 98.8162 10.9812C98.9781 10.8957 99.1052 10.781 99.1974 10.6371C99.2896 10.4931 99.3357 10.3301 99.3357 10.1479V9.59801C99.2907 9.62725 99.2289 9.65424 99.1502 9.67898C99.0737 9.70147 98.9871 9.72283 98.8904 9.74308C98.7937 9.76107 98.697 9.77794 98.6003 9.79368C98.5036 9.80717 98.4159 9.81954 98.3371 9.83079C98.1685 9.85553 98.0211 9.89489 97.8952 9.94886C97.7693 10.0028 97.6714 10.0759 97.6017 10.1681C97.532 10.2581 97.4971 10.3706 97.4971 10.5055C97.4971 10.7012 97.568 10.8507 97.7097 10.9542C97.8536 11.0554 98.0358 11.106 98.2562 11.106ZM103.315 9.00426V12H101.878V5.09091H103.274V7.73242H103.335C103.452 7.42655 103.641 7.18703 103.902 7.01385C104.163 6.83842 104.49 6.75071 104.884 6.75071C105.243 6.75071 105.557 6.82943 105.825 6.98686C106.095 7.14205 106.304 7.36583 106.452 7.6582C106.603 7.94833 106.677 8.29581 106.675 8.70064V12H105.238V8.95703C105.24 8.63767 105.159 8.38915 104.995 8.21147C104.833 8.03379 104.606 7.94496 104.313 7.94496C104.118 7.94496 103.945 7.98656 103.794 8.06978C103.645 8.15299 103.529 8.27444 103.443 8.43413C103.36 8.59156 103.317 8.78161 103.315 9.00426ZM109.108 10.5089L109.112 8.78498H109.321L110.98 6.81818H112.63L110.4 9.42259H110.059L109.108 10.5089ZM107.806 12V5.09091H109.243V12H107.806ZM111.045 12L109.52 9.74308L110.478 8.72763L112.728 12H111.045ZM114.813 12.0978C114.482 12.0978 114.188 12.0405 113.929 11.9258C113.67 11.8088 113.466 11.6368 113.315 11.4096C113.167 11.1802 113.092 10.8946 113.092 10.5527C113.092 10.2649 113.145 10.0231 113.251 9.82741C113.357 9.63175 113.501 9.47431 113.683 9.35511C113.865 9.23591 114.072 9.14595 114.303 9.08523C114.537 9.0245 114.782 8.98177 115.039 8.95703C115.34 8.92554 115.583 8.89631 115.768 8.86932C115.952 8.84008 116.086 8.79735 116.169 8.74112C116.252 8.6849 116.294 8.60168 116.294 8.49148V8.47124C116.294 8.25758 116.226 8.09227 116.091 7.97532C115.959 7.85837 115.77 7.79989 115.525 7.79989C115.266 7.79989 115.06 7.85724 114.907 7.97195C114.754 8.0844 114.653 8.22609 114.604 8.39702L113.275 8.28906C113.342 7.97419 113.475 7.70206 113.673 7.47266C113.871 7.241 114.126 7.06333 114.438 6.93963C114.753 6.81368 115.118 6.75071 115.531 6.75071C115.819 6.75071 116.095 6.78445 116.358 6.85192C116.623 6.91939 116.858 7.02397 117.063 7.16566C117.27 7.30735 117.433 7.48952 117.552 7.71218C117.671 7.93259 117.731 8.19685 117.731 8.50497V12H116.368V11.2814H116.328C116.244 11.4434 116.133 11.5862 115.994 11.7099C115.854 11.8313 115.687 11.9269 115.491 11.9966C115.295 12.0641 115.069 12.0978 114.813 12.0978ZM115.224 11.106C115.436 11.106 115.623 11.0644 115.784 10.9812C115.946 10.8957 116.073 10.781 116.166 10.6371C116.258 10.4931 116.304 10.3301 116.304 10.1479V9.59801C116.259 9.62725 116.197 9.65424 116.118 9.67898C116.042 9.70147 115.955 9.72283 115.859 9.74308C115.762 9.76107 115.665 9.77794 115.569 9.79368C115.472 9.80717 115.384 9.81954 115.305 9.83079C115.137 9.85553 114.989 9.89489 114.863 9.94886C114.738 10.0028 114.64 10.0759 114.57 10.1681C114.5 10.2581 114.465 10.3706 114.465 10.5055C114.465 10.7012 114.536 10.8507 114.678 10.9542C114.822 11.0554 115.004 11.106 115.224 11.106ZM120.283 9.00426V12H118.846V6.81818H120.216V7.73242H120.276C120.391 7.43105 120.583 7.19265 120.853 7.01722C121.123 6.83955 121.45 6.75071 121.835 6.75071C122.195 6.75071 122.509 6.82943 122.776 6.98686C123.044 7.14429 123.252 7.3692 123.4 7.66158C123.549 7.9517 123.623 8.29806 123.623 8.70064V12H122.186V8.95703C122.188 8.63991 122.107 8.39252 121.943 8.21484C121.779 8.03492 121.553 7.94496 121.265 7.94496C121.071 7.94496 120.9 7.98656 120.752 8.06978C120.606 8.15299 120.491 8.27444 120.408 8.43413C120.327 8.59156 120.285 8.78161 120.283 9.00426ZM129.296 12.1012C128.772 12.1012 128.318 11.9899 127.936 11.7672C127.556 11.5423 127.262 11.2297 127.056 10.8294C126.849 10.4268 126.745 9.96011 126.745 9.42933C126.745 8.89406 126.849 8.42625 127.056 8.02592C127.262 7.62334 127.556 7.31072 127.936 7.08807C128.318 6.86316 128.772 6.75071 129.296 6.75071C129.82 6.75071 130.272 6.86316 130.652 7.08807C131.034 7.31072 131.329 7.62334 131.536 8.02592C131.743 8.42625 131.846 8.89406 131.846 9.42933C131.846 9.96011 131.743 10.4268 131.536 10.8294C131.329 11.2297 131.034 11.5423 130.652 11.7672C130.272 11.9899 129.82 12.1012 129.296 12.1012ZM129.302 10.9879C129.541 10.9879 129.74 10.9205 129.9 10.7855C130.059 10.6483 130.18 10.4616 130.26 10.2255C130.344 9.98935 130.385 9.72058 130.385 9.41921C130.385 9.11784 130.344 8.84908 130.26 8.61293C130.18 8.37678 130.059 8.1901 129.9 8.05291C129.74 7.91572 129.541 7.84712 129.302 7.84712C129.062 7.84712 128.859 7.91572 128.695 8.05291C128.533 8.1901 128.411 8.37678 128.327 8.61293C128.246 8.84908 128.206 9.11784 128.206 9.41921C128.206 9.72058 128.246 9.98935 128.327 10.2255C128.411 10.4616 128.533 10.6483 128.695 10.7855C128.859 10.9205 129.062 10.9879 129.302 10.9879ZM134.218 5.09091V12H132.781V5.09091H134.218ZM137.73 12.1012C137.197 12.1012 136.739 11.9933 136.354 11.7773C135.972 11.5592 135.677 11.2511 135.47 10.853C135.263 10.4527 135.16 9.97923 135.16 9.43271C135.16 8.89968 135.263 8.43188 135.47 8.0293C135.677 7.62672 135.968 7.31297 136.344 7.08807C136.722 6.86316 137.165 6.75071 137.673 6.75071C138.015 6.75071 138.333 6.80581 138.628 6.91602C138.925 7.02397 139.183 7.18703 139.404 7.40518C139.626 7.62334 139.8 7.89773 139.923 8.22834C140.047 8.5567 140.109 8.94129 140.109 9.3821V9.77681H135.733V8.88619H138.756C138.756 8.67927 138.711 8.49598 138.621 8.33629C138.531 8.17661 138.406 8.05179 138.247 7.96183C138.089 7.86961 137.906 7.82351 137.697 7.82351C137.479 7.82351 137.285 7.87411 137.116 7.97532C136.95 8.07428 136.82 8.2081 136.725 8.37678C136.631 8.54321 136.582 8.72875 136.58 8.93342V9.78018C136.58 10.0366 136.627 10.2581 136.722 10.4448C136.818 10.6315 136.955 10.7754 137.13 10.8766C137.305 10.9778 137.513 11.0284 137.754 11.0284C137.914 11.0284 138.06 11.0059 138.193 10.9609C138.325 10.916 138.439 10.8485 138.533 10.7585C138.628 10.6686 138.7 10.5584 138.749 10.4279L140.078 10.5156C140.011 10.835 139.873 11.1139 139.663 11.3523C139.457 11.5884 139.189 11.7728 138.861 11.9055C138.534 12.036 138.158 12.1012 137.73 12.1012ZM142.484 9.00426V12H141.047V5.09091H142.443V7.73242H142.504C142.621 7.42655 142.81 7.18703 143.071 7.01385C143.332 6.83842 143.659 6.75071 144.053 6.75071C144.412 6.75071 144.726 6.82943 144.994 6.98686C145.264 7.14205 145.473 7.36583 145.621 7.6582C145.772 7.94833 145.846 8.29581 145.844 8.70064V12H144.407V8.95703C144.409 8.63767 144.328 8.38915 144.164 8.21147C144.002 8.03379 143.775 7.94496 143.482 7.94496C143.287 7.94496 143.114 7.98656 142.963 8.06978C142.814 8.15299 142.697 8.27444 142.612 8.43413C142.529 8.59156 142.486 8.78161 142.484 9.00426Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function sA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5500",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5500)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM52.4851 12V6.81818H53.8784V7.7223H53.9324C54.0269 7.40069 54.1854 7.15779 54.4081 6.99361C54.6307 6.82718 54.8871 6.74396 55.1772 6.74396C55.2492 6.74396 55.3268 6.74846 55.41 6.75746C55.4932 6.76645 55.5663 6.77882 55.6293 6.79457V8.06978C55.5618 8.04954 55.4685 8.03155 55.3493 8.0158C55.2301 8.00006 55.121 7.99219 55.0221 7.99219C54.8107 7.99219 54.6217 8.03829 54.4553 8.1305C54.2911 8.22047 54.1607 8.34641 54.064 8.50835C53.9695 8.67028 53.9223 8.85695 53.9223 9.06836V12H52.4851ZM58.4926 12.1012C57.9596 12.1012 57.5008 11.9933 57.1162 11.7773C56.7339 11.5592 56.4392 11.2511 56.2323 10.853C56.0254 10.4527 55.922 9.97923 55.922 9.43271C55.922 8.89968 56.0254 8.43188 56.2323 8.0293C56.4392 7.62672 56.7305 7.31297 57.1061 7.08807C57.4839 6.86316 57.927 6.75071 58.4353 6.75071C58.7771 6.75071 59.0954 6.80581 59.39 6.91602C59.6869 7.02397 59.9455 7.18703 60.1659 7.40518C60.3886 7.62334 60.5618 7.89773 60.6855 8.22834C60.8092 8.5567 60.871 8.94129 60.871 9.3821V9.77681H56.4955V8.88619H59.5182C59.5182 8.67927 59.4732 8.49598 59.3833 8.33629C59.2933 8.17661 59.1685 8.05179 59.0088 7.96183C58.8514 7.86961 58.6681 7.82351 58.4589 7.82351C58.2407 7.82351 58.0473 7.87411 57.8786 7.97532C57.7122 8.07428 57.5818 8.2081 57.4873 8.37678C57.3928 8.54321 57.3445 8.72875 57.3422 8.93342V9.78018C57.3422 10.0366 57.3895 10.2581 57.4839 10.4448C57.5806 10.6315 57.7167 10.7754 57.8921 10.8766C58.0676 10.9778 58.2756 11.0284 58.5162 11.0284C58.6759 11.0284 58.8221 11.0059 58.9548 10.9609C59.0875 10.916 59.2011 10.8485 59.2955 10.7585C59.39 10.6686 59.462 10.5584 59.5115 10.4279L60.8406 10.5156C60.7732 10.835 60.6349 11.1139 60.4257 11.3523C60.2188 11.5884 59.9511 11.7728 59.6228 11.9055C59.2967 12.036 58.92 12.1012 58.4926 12.1012ZM66.5007 6.81818L64.6891 12H63.0697L61.2581 6.81818H62.7762L63.8524 10.5257H63.9064L64.9792 6.81818H66.5007ZM69.4306 12.1012C68.8976 12.1012 68.4388 11.9933 68.0542 11.7773C67.6719 11.5592 67.3772 11.2511 67.1703 10.853C66.9634 10.4527 66.86 9.97923 66.86 9.43271C66.86 8.89968 66.9634 8.43188 67.1703 8.0293C67.3772 7.62672 67.6685 7.31297 68.0441 7.08807C68.4219 6.86316 68.865 6.75071 69.3733 6.75071C69.7151 6.75071 70.0334 6.80581 70.328 6.91602C70.6249 7.02397 70.8835 7.18703 71.1039 7.40518C71.3266 7.62334 71.4997 7.89773 71.6234 8.22834C71.7471 8.5567 71.809 8.94129 71.809 9.3821V9.77681H67.4335V8.88619H70.4562C70.4562 8.67927 70.4112 8.49598 70.3212 8.33629C70.2313 8.17661 70.1065 8.05179 69.9468 7.96183C69.7893 7.86961 69.606 7.82351 69.3969 7.82351C69.1787 7.82351 68.9853 7.87411 68.8166 7.97532C68.6502 8.07428 68.5198 8.2081 68.4253 8.37678C68.3308 8.54321 68.2825 8.72875 68.2802 8.93342V9.78018C68.2802 10.0366 68.3275 10.2581 68.4219 10.4448C68.5186 10.6315 68.6547 10.7754 68.8301 10.8766C69.0055 10.9778 69.2136 11.0284 69.4542 11.0284C69.6139 11.0284 69.7601 11.0059 69.8928 10.9609C70.0255 10.916 70.1391 10.8485 70.2335 10.7585C70.328 10.6686 70.4 10.5584 70.4494 10.4279L71.7786 10.5156C71.7112 10.835 71.5728 11.1139 71.3637 11.3523C71.1568 11.5884 70.8891 11.7728 70.5608 11.9055C70.2347 12.036 69.8579 12.1012 69.4306 12.1012ZM75.5031 6.81818V7.89773H72.3825V6.81818H75.5031ZM73.091 5.5767H74.5281V10.4077C74.5281 10.5404 74.5483 10.6438 74.5888 10.718C74.6293 10.79 74.6855 10.8406 74.7575 10.8699C74.8317 10.8991 74.9172 10.9137 75.0139 10.9137C75.0814 10.9137 75.1488 10.9081 75.2163 10.8968C75.2838 10.8833 75.3355 10.8732 75.3715 10.8665L75.5975 11.9359C75.5256 11.9584 75.4243 11.9843 75.2939 12.0135C75.1635 12.045 75.0049 12.0641 74.8182 12.0708C74.4719 12.0843 74.1682 12.0382 73.9074 11.9325C73.6487 11.8268 73.4474 11.6626 73.3035 11.44C73.1595 11.2173 73.0887 10.9362 73.091 10.5966V5.5767ZM80.1156 12.0978C79.785 12.0978 79.4904 12.0405 79.2317 11.9258C78.9731 11.8088 78.7684 11.6368 78.6177 11.4096C78.4693 11.1802 78.3951 10.8946 78.3951 10.5527C78.3951 10.2649 78.4479 10.0231 78.5536 9.82741C78.6593 9.63175 78.8033 9.47431 78.9854 9.35511C79.1676 9.23591 79.3745 9.14595 79.6062 9.08523C79.8401 9.0245 80.0852 8.98177 80.3416 8.95703C80.643 8.92554 80.8859 8.89631 81.0703 8.86932C81.2547 8.84008 81.3886 8.79735 81.4718 8.74112C81.555 8.6849 81.5966 8.60168 81.5966 8.49148V8.47124C81.5966 8.25758 81.5291 8.09227 81.3942 7.97532C81.2615 7.85837 81.0726 7.79989 80.8274 7.79989C80.5688 7.79989 80.363 7.85724 80.21 7.97195C80.0571 8.0844 79.9559 8.22609 79.9064 8.39702L78.5772 8.28906C78.6447 7.97419 78.7774 7.70206 78.9753 7.47266C79.1732 7.241 79.4285 7.06333 79.7411 6.93963C80.056 6.81368 80.4203 6.75071 80.8342 6.75071C81.122 6.75071 81.3975 6.78445 81.6607 6.85192C81.9261 6.91939 82.1611 7.02397 82.3658 7.16566C82.5727 7.30735 82.7357 7.48952 82.8549 7.71218C82.9741 7.93259 83.0337 8.19685 83.0337 8.50497V12H81.6708V11.2814H81.6303C81.5471 11.4434 81.4358 11.5862 81.2963 11.7099C81.1569 11.8313 80.9893 11.9269 80.7937 11.9966C80.598 12.0641 80.372 12.0978 80.1156 12.0978ZM80.5272 11.106C80.7386 11.106 80.9252 11.0644 81.0872 10.9812C81.2491 10.8957 81.3762 10.781 81.4684 10.6371C81.5606 10.4931 81.6067 10.3301 81.6067 10.1479V9.59801C81.5617 9.62725 81.4999 9.65424 81.4212 9.67898C81.3447 9.70147 81.2581 9.72283 81.1614 9.74308C81.0647 9.76107 80.968 9.77794 80.8713 9.79368C80.7746 9.80717 80.6868 9.81954 80.6081 9.83079C80.4395 9.85553 80.2921 9.89489 80.1662 9.94886C80.0402 10.0028 79.9424 10.0759 79.8727 10.1681C79.803 10.2581 79.7681 10.3706 79.7681 10.5055C79.7681 10.7012 79.839 10.8507 79.9806 10.9542C80.1246 11.0554 80.3068 11.106 80.5272 11.106ZM86.9353 6.81818V7.89773H83.7371V6.81818H86.9353ZM84.4692 12V6.44371C84.4692 6.06812 84.5423 5.75663 84.6885 5.50923C84.8369 5.26184 85.0393 5.07629 85.2957 4.95259C85.5521 4.82889 85.8434 4.76704 86.1695 4.76704C86.3899 4.76704 86.5912 4.78391 86.7733 4.81765C86.9578 4.85138 87.095 4.88175 87.1849 4.90874L86.9285 5.98828C86.8723 5.97029 86.8026 5.95342 86.7194 5.93768C86.6384 5.92193 86.5552 5.91406 86.4697 5.91406C86.2583 5.91406 86.111 5.96354 86.0278 6.0625C85.9446 6.15921 85.903 6.29528 85.903 6.4707V12H84.4692Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function lA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2007_5476",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2007_5476)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.9822 12.1012C53.4581 12.1012 53.0049 11.9899 52.6226 11.7672C52.2425 11.5423 51.949 11.2297 51.7421 10.8294C51.5352 10.4268 51.4317 9.96011 51.4317 9.42933C51.4317 8.89406 51.5352 8.42625 51.7421 8.02592C51.949 7.62334 52.2425 7.31072 52.6226 7.08807C53.0049 6.86316 53.4581 6.75071 53.9822 6.75071C54.5062 6.75071 54.9582 6.86316 55.3383 7.08807C55.7207 7.31072 56.0153 7.62334 56.2222 8.02592C56.4291 8.42625 56.5326 8.89406 56.5326 9.42933C56.5326 9.96011 56.4291 10.4268 56.2222 10.8294C56.0153 11.2297 55.7207 11.5423 55.3383 11.7672C54.9582 11.9899 54.5062 12.1012 53.9822 12.1012ZM53.9889 10.9879C54.2273 10.9879 54.4263 10.9205 54.586 10.7855C54.7457 10.6483 54.866 10.4616 54.947 10.2255C55.0302 9.98935 55.0718 9.72058 55.0718 9.41921C55.0718 9.11784 55.0302 8.84908 54.947 8.61293C54.866 8.37678 54.7457 8.1901 54.586 8.05291C54.4263 7.91572 54.2273 7.84712 53.9889 7.84712C53.7483 7.84712 53.5458 7.91572 53.3817 8.05291C53.2197 8.1901 53.0972 8.37678 53.0139 8.61293C52.933 8.84908 52.8925 9.11784 52.8925 9.41921C52.8925 9.72058 52.933 9.98935 53.0139 10.2255C53.0972 10.4616 53.2197 10.6483 53.3817 10.7855C53.5458 10.9205 53.7483 10.9879 53.9889 10.9879ZM58.9042 9.00426V12H57.4671V5.09091H58.8637V7.73242H58.9244C59.0414 7.42655 59.2303 7.18703 59.4912 7.01385C59.7521 6.83842 60.0793 6.75071 60.4729 6.75071C60.8328 6.75071 61.1465 6.82943 61.4142 6.98686C61.684 7.14205 61.8932 7.36583 62.0416 7.6582C62.1923 7.94833 62.2665 8.29581 62.2643 8.70064V12H60.8271V8.95703C60.8294 8.63767 60.7484 8.38915 60.5843 8.21147C60.4223 8.03379 60.1952 7.94496 59.9028 7.94496C59.7071 7.94496 59.5339 7.98656 59.3833 8.06978C59.2348 8.15299 59.1179 8.27444 59.0324 8.43413C58.9492 8.59156 58.9065 8.78161 58.9042 9.00426ZM64.8729 12.0978C64.5423 12.0978 64.2477 12.0405 63.989 11.9258C63.7304 11.8088 63.5257 11.6368 63.375 11.4096C63.2266 11.1802 63.1524 10.8946 63.1524 10.5527C63.1524 10.2649 63.2052 10.0231 63.3109 9.82741C63.4167 9.63175 63.5606 9.47431 63.7428 9.35511C63.9249 9.23591 64.1319 9.14595 64.3635 9.08523C64.5974 9.0245 64.8426 8.98177 65.0989 8.95703C65.4003 8.92554 65.6432 8.89631 65.8276 8.86932C66.0121 8.84008 66.1459 8.79735 66.2291 8.74112C66.3123 8.6849 66.3539 8.60168 66.3539 8.49148V8.47124C66.3539 8.25758 66.2864 8.09227 66.1515 7.97532C66.0188 7.85837 65.8299 7.79989 65.5847 7.79989C65.3261 7.79989 65.1203 7.85724 64.9674 7.97195C64.8144 8.0844 64.7132 8.22609 64.6638 8.39702L63.3346 8.28906C63.402 7.97419 63.5347 7.70206 63.7326 7.47266C63.9306 7.241 64.1858 7.06333 64.4984 6.93963C64.8133 6.81368 65.1777 6.75071 65.5915 6.75071C65.8794 6.75071 66.1549 6.78445 66.418 6.85192C66.6834 6.91939 66.9184 7.02397 67.1231 7.16566C67.33 7.30735 67.4931 7.48952 67.6123 7.71218C67.7315 7.93259 67.7911 8.19685 67.7911 8.50497V12H66.4281V11.2814H66.3877C66.3044 11.4434 66.1931 11.5862 66.0537 11.7099C65.9142 11.8313 65.7467 11.9269 65.551 11.9966C65.3553 12.0641 65.1293 12.0978 64.8729 12.0978ZM65.2845 11.106C65.4959 11.106 65.6826 11.0644 65.8445 10.9812C66.0064 10.8957 66.1335 10.781 66.2257 10.6371C66.3179 10.4931 66.364 10.3301 66.364 10.1479V9.59801C66.3191 9.62725 66.2572 9.65424 66.1785 9.67898C66.102 9.70147 66.0154 9.72283 65.9187 9.74308C65.822 9.76107 65.7253 9.77794 65.6286 9.79368C65.5319 9.80717 65.4442 9.81954 65.3655 9.83079C65.1968 9.85553 65.0495 9.89489 64.9235 9.94886C64.7976 10.0028 64.6997 10.0759 64.63 10.1681C64.5603 10.2581 64.5254 10.3706 64.5254 10.5055C64.5254 10.7012 64.5963 10.8507 64.738 10.9542C64.8819 11.0554 65.0641 11.106 65.2845 11.106ZM65.1293 6.15021L65.8445 4.61523H67.1737L66.1448 6.15021H65.1293ZM70.3432 9.00426V12H68.906V6.81818H70.2757V7.73242H70.3364C70.4511 7.43105 70.6434 7.19265 70.9133 7.01722C71.1832 6.83955 71.5104 6.75071 71.895 6.75071C72.2549 6.75071 72.5686 6.82943 72.8362 6.98686C73.1039 7.14429 73.3119 7.3692 73.4604 7.66158C73.6088 7.9517 73.683 8.29806 73.683 8.70064V12H72.2459V8.95703C72.2481 8.63991 72.1672 8.39252 72.003 8.21484C71.8388 8.03492 71.6128 7.94496 71.3249 7.94496C71.1315 7.94496 70.9605 7.98656 70.8121 8.06978C70.6659 8.15299 70.5512 8.27444 70.468 8.43413C70.387 8.59156 70.3454 8.78161 70.3432 9.00426ZM70.6131 4.66584L71.2911 5.48899L71.9692 4.66584H73.1938V4.71307L71.8242 6.19744H70.7547L69.3884 4.71307V4.66584H70.6131ZM76.2933 12.0978C75.9627 12.0978 75.6681 12.0405 75.4094 11.9258C75.1508 11.8088 74.9461 11.6368 74.7955 11.4096C74.647 11.1802 74.5728 10.8946 74.5728 10.5527C74.5728 10.2649 74.6257 10.0231 74.7314 9.82741C74.8371 9.63175 74.981 9.47431 75.1632 9.35511C75.3453 9.23591 75.5523 9.14595 75.7839 9.08523C76.0178 9.0245 76.263 8.98177 76.5194 8.95703C76.8207 8.92554 77.0636 8.89631 77.248 8.86932C77.4325 8.84008 77.5663 8.79735 77.6495 8.74112C77.7327 8.6849 77.7743 8.60168 77.7743 8.49148V8.47124C77.7743 8.25758 77.7069 8.09227 77.5719 7.97532C77.4392 7.85837 77.2503 7.79989 77.0051 7.79989C76.7465 7.79989 76.5407 7.85724 76.3878 7.97195C76.2348 8.0844 76.1336 8.22609 76.0842 8.39702L74.755 8.28906C74.8224 7.97419 74.9551 7.70206 75.1531 7.47266C75.351 7.241 75.6062 7.06333 75.9189 6.93963C76.2337 6.81368 76.5981 6.75071 77.0119 6.75071C77.2998 6.75071 77.5753 6.78445 77.8384 6.85192C78.1038 6.91939 78.3388 7.02397 78.5435 7.16566C78.7504 7.30735 78.9135 7.48952 79.0327 7.71218C79.1519 7.93259 79.2115 8.19685 79.2115 8.50497V12H77.8485V11.2814H77.8081C77.7248 11.4434 77.6135 11.5862 77.4741 11.7099C77.3346 11.8313 77.1671 11.9269 76.9714 11.9966C76.7757 12.0641 76.5497 12.0978 76.2933 12.0978ZM76.7049 11.106C76.9163 11.106 77.103 11.0644 77.2649 10.9812C77.4268 10.8957 77.5539 10.781 77.6461 10.6371C77.7383 10.4931 77.7844 10.3301 77.7844 10.1479V9.59801C77.7395 9.62725 77.6776 9.65424 77.5989 9.67898C77.5224 9.70147 77.4358 9.72283 77.3391 9.74308C77.2424 9.76107 77.1457 9.77794 77.049 9.79368C76.9523 9.80717 76.8646 9.81954 76.7859 9.83079C76.6172 9.85553 76.4699 9.89489 76.3439 9.94886C76.218 10.0028 76.1201 10.0759 76.0504 10.1681C75.9807 10.2581 75.9458 10.3706 75.9458 10.5055C75.9458 10.7012 76.0167 10.8507 76.1584 10.9542C76.3023 11.0554 76.4845 11.106 76.7049 11.106ZM81.7636 9.00426V12H80.3264V6.81818H81.6961V7.73242H81.7568C81.8715 7.43105 82.0638 7.19265 82.3337 7.01722C82.6036 6.83955 82.9308 6.75071 83.3154 6.75071C83.6753 6.75071 83.989 6.82943 84.2567 6.98686C84.5243 7.14429 84.7323 7.3692 84.8808 7.66158C85.0292 7.9517 85.1034 8.29806 85.1034 8.70064V12H83.6663V8.95703C83.6685 8.63991 83.5876 8.39252 83.4234 8.21484C83.2592 8.03492 83.0332 7.94496 82.7453 7.94496C82.5519 7.94496 82.3809 7.98656 82.2325 8.06978C82.0863 8.15299 81.9716 8.27444 81.8884 8.43413C81.8074 8.59156 81.7658 8.78161 81.7636 9.00426ZM86.9378 13.9432C86.7556 13.9432 86.5847 13.9286 86.425 13.8993C86.2676 13.8723 86.1371 13.8375 86.0337 13.7947L86.3576 12.7219C86.5262 12.7737 86.678 12.8018 86.813 12.8063C86.9502 12.8108 87.0683 12.7793 87.1672 12.7118C87.2684 12.6444 87.3505 12.5297 87.4135 12.3677L87.4978 12.1484L85.639 6.81818H87.1503L88.2231 10.6236H88.2771L89.36 6.81818H90.8815L88.8675 12.56C88.7708 12.8389 88.6392 13.0818 88.4728 13.2887C88.3086 13.4979 88.1006 13.6587 87.8487 13.7711C87.5968 13.8858 87.2932 13.9432 86.9378 13.9432ZM87.734 6.15021L88.4492 4.61523H89.7784L88.7494 6.15021H87.734Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function cA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2007_5452",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2007_5452)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.9822 12.1012C53.4581 12.1012 53.0049 11.9899 52.6226 11.7672C52.2425 11.5423 51.949 11.2297 51.7421 10.8294C51.5352 10.4268 51.4317 9.96011 51.4317 9.42933C51.4317 8.89406 51.5352 8.42625 51.7421 8.02592C51.949 7.62334 52.2425 7.31072 52.6226 7.08807C53.0049 6.86316 53.4581 6.75071 53.9822 6.75071C54.5062 6.75071 54.9582 6.86316 55.3383 7.08807C55.7207 7.31072 56.0153 7.62334 56.2222 8.02592C56.4291 8.42625 56.5326 8.89406 56.5326 9.42933C56.5326 9.96011 56.4291 10.4268 56.2222 10.8294C56.0153 11.2297 55.7207 11.5423 55.3383 11.7672C54.9582 11.9899 54.5062 12.1012 53.9822 12.1012ZM53.9889 10.9879C54.2273 10.9879 54.4263 10.9205 54.586 10.7855C54.7457 10.6483 54.866 10.4616 54.947 10.2255C55.0302 9.98935 55.0718 9.72058 55.0718 9.41921C55.0718 9.11784 55.0302 8.84908 54.947 8.61293C54.866 8.37678 54.7457 8.1901 54.586 8.05291C54.4263 7.91572 54.2273 7.84712 53.9889 7.84712C53.7483 7.84712 53.5458 7.91572 53.3817 8.05291C53.2197 8.1901 53.0972 8.37678 53.0139 8.61293C52.933 8.84908 52.8925 9.11784 52.8925 9.41921C52.8925 9.72058 52.933 9.98935 53.0139 10.2255C53.0972 10.4616 53.2197 10.6483 53.3817 10.7855C53.5458 10.9205 53.7483 10.9879 53.9889 10.9879ZM58.3594 12L56.9492 6.81818H58.4032L59.2061 10.2997H59.2534L60.09 6.81818H61.517L62.3672 10.2795H62.411L63.2005 6.81818H64.6511L63.2443 12H61.7228L60.8322 8.74112H60.7681L59.8775 12H58.3594ZM67.6494 12.1012C67.1163 12.1012 66.6575 11.9933 66.2729 11.7773C65.8906 11.5592 65.596 11.2511 65.3891 10.853C65.1822 10.4527 65.0787 9.97923 65.0787 9.43271C65.0787 8.89968 65.1822 8.43188 65.3891 8.0293C65.596 7.62672 65.8872 7.31297 66.2628 7.08807C66.6407 6.86316 67.0837 6.75071 67.592 6.75071C67.9339 6.75071 68.2521 6.80581 68.5467 6.91602C68.8436 7.02397 69.1023 7.18703 69.3227 7.40518C69.5453 7.62334 69.7185 7.89773 69.8422 8.22834C69.9659 8.5567 70.0277 8.94129 70.0277 9.3821V9.77681H65.6522V8.88619H68.6749C68.6749 8.67927 68.63 8.49598 68.54 8.33629C68.45 8.17661 68.3252 8.05179 68.1655 7.96183C68.0081 7.86961 67.8248 7.82351 67.6156 7.82351C67.3975 7.82351 67.2041 7.87411 67.0354 7.97532C66.8689 8.07428 66.7385 8.2081 66.644 8.37678C66.5496 8.54321 66.5012 8.72875 66.499 8.93342V9.78018C66.499 10.0366 66.5462 10.2581 66.6407 10.4448C66.7374 10.6315 66.8734 10.7754 67.0489 10.8766C67.2243 10.9778 67.4323 11.0284 67.673 11.0284C67.8327 11.0284 67.9789 11.0059 68.1116 10.9609C68.2442 10.916 68.3578 10.8485 68.4523 10.7585C68.5467 10.6686 68.6187 10.5584 68.6682 10.4279L69.9974 10.5156C69.9299 10.835 69.7916 11.1139 69.5824 11.3523C69.3755 11.5884 69.1079 11.7728 68.7795 11.9055C68.4534 12.036 68.0767 12.1012 67.6494 12.1012ZM70.9656 12V6.81818H72.3589V7.7223H72.4129C72.5073 7.40069 72.6659 7.15779 72.8885 6.99361C73.1112 6.82718 73.3676 6.74396 73.6577 6.74396C73.7297 6.74396 73.8073 6.74846 73.8905 6.75746C73.9737 6.76645 74.0468 6.77882 74.1098 6.79457V8.06978C74.0423 8.04954 73.949 8.03155 73.8298 8.0158C73.7106 8.00006 73.6015 7.99219 73.5025 7.99219C73.2911 7.99219 73.1022 8.03829 72.9358 8.1305C72.7716 8.22047 72.6411 8.34641 72.5444 8.50835C72.45 8.67028 72.4027 8.85695 72.4027 9.06836V12H70.9656ZM76.9731 12.1012C76.4401 12.1012 75.9813 11.9933 75.5967 11.7773C75.2143 11.5592 74.9197 11.2511 74.7128 10.853C74.5059 10.4527 74.4024 9.97923 74.4024 9.43271C74.4024 8.89968 74.5059 8.43188 74.7128 8.0293C74.9197 7.62672 75.211 7.31297 75.5866 7.08807C75.9644 6.86316 76.4075 6.75071 76.9157 6.75071C77.2576 6.75071 77.5758 6.80581 77.8705 6.91602C78.1673 7.02397 78.426 7.18703 78.6464 7.40518C78.8691 7.62334 79.0422 7.89773 79.1659 8.22834C79.2896 8.5567 79.3515 8.94129 79.3515 9.3821V9.77681H74.9759V8.88619H77.9987C77.9987 8.67927 77.9537 8.49598 77.8637 8.33629C77.7738 8.17661 77.6489 8.05179 77.4893 7.96183C77.3318 7.86961 77.1485 7.82351 76.9394 7.82351C76.7212 7.82351 76.5278 7.87411 76.3591 7.97532C76.1927 8.07428 76.0622 8.2081 75.9678 8.37678C75.8733 8.54321 75.825 8.72875 75.8227 8.93342V9.78018C75.8227 10.0366 75.8699 10.2581 75.9644 10.4448C76.0611 10.6315 76.1972 10.7754 76.3726 10.8766C76.548 10.9778 76.7561 11.0284 76.9967 11.0284C77.1564 11.0284 77.3026 11.0059 77.4353 10.9609C77.568 10.916 77.6816 10.8485 77.776 10.7585C77.8705 10.6686 77.9424 10.5584 77.9919 10.4279L79.3211 10.5156C79.2536 10.835 79.1153 11.1139 78.9062 11.3523C78.6992 11.5884 78.4316 11.7728 78.1032 11.9055C77.7771 12.036 77.4004 12.1012 76.9731 12.1012ZM82.1988 12.0843C81.8052 12.0843 81.4487 11.9831 81.1294 11.7807C80.8122 11.5761 80.5603 11.2758 80.3737 10.88C80.1892 10.4819 80.097 9.99384 80.097 9.41584C80.097 8.82209 80.1926 8.32842 80.3838 7.93484C80.575 7.539 80.8291 7.24325 81.1462 7.04759C81.4656 6.84967 81.8153 6.75071 82.1954 6.75071C82.4855 6.75071 82.7273 6.80019 82.9207 6.89915C83.1164 6.99586 83.2738 7.11731 83.393 7.26349C83.5145 7.40743 83.6067 7.54912 83.6697 7.68857H83.7135V5.09091H85.1473V12H83.7304V11.1701H83.6697C83.6022 11.314 83.5066 11.4569 83.3829 11.5985C83.2615 11.738 83.1029 11.8538 82.9072 11.946C82.7138 12.0382 82.4777 12.0843 82.1988 12.0843ZM82.6542 10.9407C82.8859 10.9407 83.0815 10.8777 83.2412 10.7518C83.4031 10.6236 83.5268 10.4448 83.6123 10.2154C83.7 9.98597 83.7439 9.71721 83.7439 9.40909C83.7439 9.10097 83.7011 8.83333 83.6157 8.60618C83.5302 8.37902 83.4065 8.2036 83.2446 8.0799C83.0827 7.9562 82.8859 7.89435 82.6542 7.89435C82.4181 7.89435 82.219 7.95845 82.0571 8.08665C81.8952 8.21484 81.7726 8.39252 81.6894 8.61967C81.6061 8.84683 81.5645 9.10997 81.5645 9.40909C81.5645 9.71046 81.6061 9.97698 81.6894 10.2086C81.7748 10.438 81.8974 10.618 82.0571 10.7484C82.219 10.8766 82.4181 10.9407 82.6542 10.9407ZM88.5546 12V5.09091H89.9917V7.68857H90.0356C90.0986 7.54912 90.1897 7.40743 90.3089 7.26349C90.4303 7.11731 90.5877 6.99586 90.7812 6.89915C90.9768 6.80019 91.2197 6.75071 91.5099 6.75071C91.8877 6.75071 92.2363 6.84967 92.5557 7.04759C92.875 7.24325 93.1303 7.539 93.3215 7.93484C93.5126 8.32842 93.6082 8.82209 93.6082 9.41584C93.6082 9.99384 93.5149 10.4819 93.3282 10.88C93.1438 11.2758 92.8919 11.5761 92.5725 11.7807C92.2554 11.9831 91.9001 12.0843 91.5065 12.0843C91.2276 12.0843 90.9903 12.0382 90.7947 11.946C90.6012 11.8538 90.4427 11.738 90.319 11.5985C90.1953 11.4569 90.1008 11.314 90.0356 11.1701H89.9715V12H88.5546ZM89.9614 9.40909C89.9614 9.71721 90.0041 9.98597 90.0896 10.2154C90.175 10.4448 90.2987 10.6236 90.4607 10.7518C90.6226 10.8777 90.8194 10.9407 91.051 10.9407C91.2849 10.9407 91.4829 10.8766 91.6448 10.7484C91.8067 10.618 91.9293 10.438 92.0125 10.2086C92.098 9.97698 92.1407 9.71046 92.1407 9.40909C92.1407 9.10997 92.0991 8.84683 92.0159 8.61967C91.9327 8.39252 91.8101 8.21484 91.6482 8.08665C91.4862 7.95845 91.2872 7.89435 91.051 7.89435C90.8171 7.89435 90.6192 7.9562 90.4573 8.0799C90.2976 8.2036 90.175 8.37902 90.0896 8.60618C90.0041 8.83333 89.9614 9.10097 89.9614 9.40909ZM95.2874 13.9432C95.1052 13.9432 94.9343 13.9286 94.7746 13.8993C94.6172 13.8723 94.4868 13.8375 94.3833 13.7947L94.7072 12.7219C94.8758 12.7737 95.0277 12.8018 95.1626 12.8063C95.2998 12.8108 95.4179 12.7793 95.5168 12.7118C95.618 12.6444 95.7001 12.5297 95.7631 12.3677L95.8474 12.1484L93.9886 6.81818H95.5L96.5728 10.6236H96.6267L97.7097 6.81818H99.2311L97.2171 12.56C97.1204 12.8389 96.9888 13.0818 96.8224 13.2887C96.6582 13.4979 96.4502 13.6587 96.1983 13.7711C95.9464 13.8858 95.6428 13.9432 95.2874 13.9432Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function uA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2007_5428",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2007_5428)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.9822 12.1012C53.4581 12.1012 53.0049 11.9899 52.6226 11.7672C52.2425 11.5423 51.949 11.2297 51.7421 10.8294C51.5352 10.4268 51.4317 9.96011 51.4317 9.42933C51.4317 8.89406 51.5352 8.42625 51.7421 8.02592C51.949 7.62334 52.2425 7.31072 52.6226 7.08807C53.0049 6.86316 53.4581 6.75071 53.9822 6.75071C54.5062 6.75071 54.9582 6.86316 55.3383 7.08807C55.7207 7.31072 56.0153 7.62334 56.2222 8.02592C56.4291 8.42625 56.5326 8.89406 56.5326 9.42933C56.5326 9.96011 56.4291 10.4268 56.2222 10.8294C56.0153 11.2297 55.7207 11.5423 55.3383 11.7672C54.9582 11.9899 54.5062 12.1012 53.9822 12.1012ZM53.9889 10.9879C54.2273 10.9879 54.4263 10.9205 54.586 10.7855C54.7457 10.6483 54.866 10.4616 54.947 10.2255C55.0302 9.98935 55.0718 9.72058 55.0718 9.41921C55.0718 9.11784 55.0302 8.84908 54.947 8.61293C54.866 8.37678 54.7457 8.1901 54.586 8.05291C54.4263 7.91572 54.2273 7.84712 53.9889 7.84712C53.7483 7.84712 53.5458 7.91572 53.3817 8.05291C53.2197 8.1901 53.0972 8.37678 53.0139 8.61293C52.933 8.84908 52.8925 9.11784 52.8925 9.41921C52.8925 9.72058 52.933 9.98935 53.0139 10.2255C53.0972 10.4616 53.2197 10.6483 53.3817 10.7855C53.5458 10.9205 53.7483 10.9879 53.9889 10.9879ZM58.9042 9.00426V12H57.4671V5.09091H58.8637V7.73242H58.9244C59.0414 7.42655 59.2303 7.18703 59.4912 7.01385C59.7521 6.83842 60.0793 6.75071 60.4729 6.75071C60.8328 6.75071 61.1465 6.82943 61.4142 6.98686C61.684 7.14205 61.8932 7.36583 62.0416 7.6582C62.1923 7.94833 62.2665 8.29581 62.2643 8.70064V12H60.8271V8.95703C60.8294 8.63767 60.7484 8.38915 60.5843 8.21147C60.4223 8.03379 60.1952 7.94496 59.9028 7.94496C59.7071 7.94496 59.5339 7.98656 59.3833 8.06978C59.2348 8.15299 59.1179 8.27444 59.0324 8.43413C58.9492 8.59156 58.9065 8.78161 58.9042 9.00426ZM64.8729 12.0978C64.5423 12.0978 64.2477 12.0405 63.989 11.9258C63.7304 11.8088 63.5257 11.6368 63.375 11.4096C63.2266 11.1802 63.1524 10.8946 63.1524 10.5527C63.1524 10.2649 63.2052 10.0231 63.3109 9.82741C63.4167 9.63175 63.5606 9.47431 63.7428 9.35511C63.9249 9.23591 64.1319 9.14595 64.3635 9.08523C64.5974 9.0245 64.8426 8.98177 65.0989 8.95703C65.4003 8.92554 65.6432 8.89631 65.8276 8.86932C66.0121 8.84008 66.1459 8.79735 66.2291 8.74112C66.3123 8.6849 66.3539 8.60168 66.3539 8.49148V8.47124C66.3539 8.25758 66.2864 8.09227 66.1515 7.97532C66.0188 7.85837 65.8299 7.79989 65.5847 7.79989C65.3261 7.79989 65.1203 7.85724 64.9674 7.97195C64.8144 8.0844 64.7132 8.22609 64.6638 8.39702L63.3346 8.28906C63.402 7.97419 63.5347 7.70206 63.7326 7.47266C63.9306 7.241 64.1858 7.06333 64.4984 6.93963C64.8133 6.81368 65.1777 6.75071 65.5915 6.75071C65.8794 6.75071 66.1549 6.78445 66.418 6.85192C66.6834 6.91939 66.9184 7.02397 67.1231 7.16566C67.33 7.30735 67.4931 7.48952 67.6123 7.71218C67.7315 7.93259 67.7911 8.19685 67.7911 8.50497V12H66.4281V11.2814H66.3877C66.3044 11.4434 66.1931 11.5862 66.0537 11.7099C65.9142 11.8313 65.7467 11.9269 65.551 11.9966C65.3553 12.0641 65.1293 12.0978 64.8729 12.0978ZM65.2845 11.106C65.4959 11.106 65.6826 11.0644 65.8445 10.9812C66.0064 10.8957 66.1335 10.781 66.2257 10.6371C66.3179 10.4931 66.364 10.3301 66.364 10.1479V9.59801C66.3191 9.62725 66.2572 9.65424 66.1785 9.67898C66.102 9.70147 66.0154 9.72283 65.9187 9.74308C65.822 9.76107 65.7253 9.77794 65.6286 9.79368C65.5319 9.80717 65.4442 9.81954 65.3655 9.83079C65.1968 9.85553 65.0495 9.89489 64.9235 9.94886C64.7976 10.0028 64.6997 10.0759 64.63 10.1681C64.5603 10.2581 64.5254 10.3706 64.5254 10.5055C64.5254 10.7012 64.5963 10.8507 64.738 10.9542C64.8819 11.0554 65.0641 11.106 65.2845 11.106ZM65.1293 6.15021L65.8445 4.61523H67.1737L66.1448 6.15021H65.1293ZM70.3432 9.00426V12H68.906V6.81818H70.2757V7.73242H70.3364C70.4511 7.43105 70.6434 7.19265 70.9133 7.01722C71.1832 6.83955 71.5104 6.75071 71.895 6.75071C72.2549 6.75071 72.5686 6.82943 72.8362 6.98686C73.1039 7.14429 73.3119 7.3692 73.4604 7.66158C73.6088 7.9517 73.683 8.29806 73.683 8.70064V12H72.2459V8.95703C72.2481 8.63991 72.1672 8.39252 72.003 8.21484C71.8388 8.03492 71.6128 7.94496 71.3249 7.94496C71.1315 7.94496 70.9605 7.98656 70.8121 8.06978C70.6659 8.15299 70.5512 8.27444 70.468 8.43413C70.387 8.59156 70.3454 8.78161 70.3432 9.00426ZM77.1772 12.1012C76.6442 12.1012 76.1854 11.9933 75.8008 11.7773C75.4184 11.5592 75.1238 11.2511 74.9169 10.853C74.71 10.4527 74.6065 9.97923 74.6065 9.43271C74.6065 8.89968 74.71 8.43188 74.9169 8.0293C75.1238 7.62672 75.4151 7.31297 75.7907 7.08807C76.1685 6.86316 76.6116 6.75071 77.1199 6.75071C77.4617 6.75071 77.7799 6.80581 78.0746 6.91602C78.3714 7.02397 78.6301 7.18703 78.8505 7.40518C79.0732 7.62334 79.2463 7.89773 79.37 8.22834C79.4937 8.5567 79.5556 8.94129 79.5556 9.3821V9.77681H75.18V8.88619H78.2028C78.2028 8.67927 78.1578 8.49598 78.0678 8.33629C77.9779 8.17661 77.853 8.05179 77.6934 7.96183C77.5359 7.86961 77.3526 7.82351 77.1435 7.82351C76.9253 7.82351 76.7319 7.87411 76.5632 7.97532C76.3968 8.07428 76.2663 8.2081 76.1719 8.37678C76.0774 8.54321 76.0291 8.72875 76.0268 8.93342V9.78018C76.0268 10.0366 76.074 10.2581 76.1685 10.4448C76.2652 10.6315 76.4013 10.7754 76.5767 10.8766C76.7521 10.9778 76.9602 11.0284 77.2008 11.0284C77.3605 11.0284 77.5067 11.0059 77.6394 10.9609C77.7721 10.916 77.8857 10.8485 77.9801 10.7585C78.0746 10.6686 78.1465 10.5584 78.196 10.4279L79.5252 10.5156C79.4577 10.835 79.3194 11.1139 79.1103 11.3523C78.9034 11.5884 78.6357 11.7728 78.3074 11.9055C77.9812 12.036 77.6045 12.1012 77.1772 12.1012ZM76.408 4.66584L77.0861 5.48899L77.7642 4.66584H78.9888V4.71307L77.6191 6.19744H76.5497L75.1834 4.71307V4.66584H76.408ZM81.9306 9.00426V12H80.4934V6.81818H81.8631V7.73242H81.9238C82.0385 7.43105 82.2308 7.19265 82.5007 7.01722C82.7706 6.83955 83.0978 6.75071 83.4824 6.75071C83.8423 6.75071 84.156 6.82943 84.4237 6.98686C84.6913 7.14429 84.8993 7.3692 85.0478 7.66158C85.1962 7.9517 85.2704 8.29806 85.2704 8.70064V12H83.8333V8.95703C83.8355 8.63991 83.7546 8.39252 83.5904 8.21484C83.4262 8.03492 83.2002 7.94496 82.9123 7.94496C82.7189 7.94496 82.5479 7.98656 82.3995 8.06978C82.2533 8.15299 82.1386 8.27444 82.0554 8.43413C81.9744 8.59156 81.9328 8.78161 81.9306 9.00426ZM88.7444 12.1012C88.2203 12.1012 87.7671 11.9899 87.3848 11.7672C87.0047 11.5423 86.7112 11.2297 86.5043 10.8294C86.2974 10.4268 86.1939 9.96011 86.1939 9.42933C86.1939 8.89406 86.2974 8.42625 86.5043 8.02592C86.7112 7.62334 87.0047 7.31072 87.3848 7.08807C87.7671 6.86316 88.2203 6.75071 88.7444 6.75071C89.2684 6.75071 89.7205 6.86316 90.1005 7.08807C90.4829 7.31072 90.7775 7.62334 90.9844 8.02592C91.1913 8.42625 91.2948 8.89406 91.2948 9.42933C91.2948 9.96011 91.1913 10.4268 90.9844 10.8294C90.7775 11.2297 90.4829 11.5423 90.1005 11.7672C89.7205 11.9899 89.2684 12.1012 88.7444 12.1012ZM88.7511 10.9879C88.9895 10.9879 89.1886 10.9205 89.3482 10.7855C89.5079 10.6483 89.6282 10.4616 89.7092 10.2255C89.7924 9.98935 89.834 9.72058 89.834 9.41921C89.834 9.11784 89.7924 8.84908 89.7092 8.61293C89.6282 8.37678 89.5079 8.1901 89.3482 8.05291C89.1886 7.91572 88.9895 7.84712 88.7511 7.84712C88.5105 7.84712 88.308 7.91572 88.1439 8.05291C87.9819 8.1901 87.8594 8.37678 87.7761 8.61293C87.6952 8.84908 87.6547 9.11784 87.6547 9.41921C87.6547 9.72058 87.6952 9.98935 87.7761 10.2255C87.8594 10.4616 87.9819 10.6483 88.1439 10.7855C88.308 10.9205 88.5105 10.9879 88.7511 10.9879Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function dA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2005_5380",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2005_5380)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M51.6966 7.50977H50.2189C50.1919 7.3186 50.1368 7.14879 50.0536 7.00035C49.9704 6.84967 49.8636 6.72147 49.7331 6.61577C49.6027 6.51006 49.452 6.4291 49.2811 6.37287C49.1124 6.31664 48.9291 6.28853 48.7312 6.28853C48.3736 6.28853 48.0621 6.37737 47.7967 6.55504C47.5313 6.73047 47.3255 6.98686 47.1793 7.32422C47.0331 7.65933 46.96 8.06641 46.96 8.54545C46.96 9.038 47.0331 9.45182 47.1793 9.78693C47.3278 10.122 47.5347 10.3751 47.8001 10.546C48.0655 10.7169 48.3725 10.8024 48.7211 10.8024C48.9167 10.8024 49.0978 10.7765 49.2642 10.7248C49.4329 10.6731 49.5824 10.5977 49.7129 10.4988C49.8433 10.3975 49.9513 10.275 50.0368 10.131C50.1245 9.9871 50.1852 9.82292 50.2189 9.63849L51.6966 9.64524C51.6583 9.96236 51.5627 10.2682 51.4098 10.5629C51.2591 10.8552 51.0556 11.1172 50.7992 11.3489C50.545 11.5783 50.2414 11.7605 49.8883 11.8954C49.5375 12.0281 49.1405 12.0945 48.6974 12.0945C48.0812 12.0945 47.5302 11.955 47.0444 11.6761C46.5608 11.3973 46.1785 10.9935 45.8974 10.465C45.6185 9.93649 45.479 9.29664 45.479 8.54545C45.479 7.79202 45.6207 7.15104 45.9041 6.62251C46.1875 6.09399 46.5721 5.69141 47.0579 5.41477C47.5437 5.13589 48.0902 4.99645 48.6974 4.99645C49.0978 4.99645 49.4689 5.05267 49.8107 5.16513C50.1548 5.27758 50.4596 5.44176 50.725 5.65767C50.9904 5.87133 51.2063 6.13334 51.3727 6.44371C51.5414 6.75408 51.6493 7.10943 51.6966 7.50977ZM56.04 9.79368V6.81818H57.4772V12H56.0974V11.0588H56.0434C55.9265 11.3624 55.7319 11.6064 55.4598 11.7908C55.1899 11.9753 54.8604 12.0675 54.4713 12.0675C54.125 12.0675 53.8202 11.9888 53.5571 11.8313C53.2939 11.6739 53.0882 11.4501 52.9397 11.16C52.7935 10.8699 52.7193 10.5224 52.7171 10.1175V6.81818H54.1542V9.86115C54.1565 10.167 54.2385 10.4088 54.4005 10.5865C54.5624 10.7641 54.7794 10.853 55.0516 10.853C55.2248 10.853 55.3867 10.8136 55.5374 10.7349C55.6881 10.6539 55.8095 10.5347 55.9017 10.3773C55.9962 10.2199 56.0423 10.0253 56.04 9.79368ZM65.1369 8.29581L63.8212 8.37678C63.7987 8.26432 63.7504 8.16312 63.6761 8.07315C63.6019 7.98094 63.5041 7.90785 63.3826 7.85387C63.2634 7.79764 63.1206 7.76953 62.9542 7.76953C62.7315 7.76953 62.5437 7.81676 62.3908 7.91122C62.2379 8.00343 62.1614 8.12713 62.1614 8.28232C62.1614 8.40601 62.2109 8.51059 62.3098 8.59606C62.4088 8.68152 62.5786 8.75012 62.8192 8.80185L63.7571 8.99077C64.2609 9.09422 64.6365 9.26065 64.8839 9.49006C65.1313 9.71946 65.255 10.0208 65.255 10.3942C65.255 10.7338 65.1549 11.0318 64.9547 11.2882C64.7568 11.5446 64.4847 11.7447 64.1383 11.8887C63.7942 12.0304 63.3973 12.1012 62.9474 12.1012C62.2615 12.1012 61.715 11.9584 61.3079 11.6728C60.9031 11.3849 60.6658 10.9935 60.5961 10.4988L62.0096 10.4245C62.0523 10.6337 62.1558 10.7934 62.32 10.9036C62.4841 11.0115 62.6944 11.0655 62.9508 11.0655C63.2027 11.0655 63.4051 11.0172 63.5581 10.9205C63.7132 10.8215 63.792 10.6944 63.7942 10.5392C63.792 10.4088 63.7369 10.302 63.6289 10.2188C63.521 10.1333 63.3545 10.0681 63.1296 10.0231L62.2322 9.84428C61.7262 9.74308 61.3495 9.56765 61.1021 9.318C60.8569 9.06836 60.7344 8.75012 60.7344 8.36328C60.7344 8.03042 60.8243 7.74367 61.0043 7.50302C61.1864 7.26237 61.4417 7.07682 61.7701 6.94638C62.1007 6.81593 62.4875 6.75071 62.9306 6.75071C63.585 6.75071 64.1001 6.88903 64.4757 7.16566C64.8535 7.44229 65.0739 7.81901 65.1369 8.29581ZM66.1599 13.9432V6.81818H67.5768V7.68857H67.6409C67.7039 7.54912 67.795 7.40743 67.9142 7.26349C68.0356 7.11731 68.1931 6.99586 68.3865 6.89915C68.5822 6.80019 68.8251 6.75071 69.1152 6.75071C69.493 6.75071 69.8416 6.84967 70.161 7.04759C70.4804 7.24325 70.7356 7.539 70.9268 7.93484C71.118 8.32842 71.2136 8.82209 71.2136 9.41584C71.2136 9.99384 71.1202 10.4819 70.9335 10.88C70.7491 11.2758 70.4972 11.5761 70.1779 11.7807C69.8608 11.9831 69.5054 12.0843 69.1118 12.0843C68.8329 12.0843 68.5957 12.0382 68.4 11.946C68.2066 11.8538 68.048 11.738 67.9243 11.5985C67.8006 11.4569 67.7062 11.314 67.6409 11.1701H67.5971V13.9432H66.1599ZM67.5667 9.40909C67.5667 9.71721 67.6094 9.98597 67.6949 10.2154C67.7804 10.4448 67.9041 10.6236 68.066 10.7518C68.2279 10.8777 68.4247 10.9407 68.6564 10.9407C68.8903 10.9407 69.0882 10.8766 69.2501 10.7484C69.4121 10.618 69.5346 10.438 69.6179 10.2086C69.7033 9.97698 69.746 9.71046 69.746 9.40909C69.746 9.10997 69.7044 8.84683 69.6212 8.61967C69.538 8.39252 69.4154 8.21484 69.2535 8.08665C69.0916 7.95845 68.8925 7.89435 68.6564 7.89435C68.4225 7.89435 68.2246 7.9562 68.0626 8.0799C67.903 8.2036 67.7804 8.37902 67.6949 8.60618C67.6094 8.83333 67.5667 9.10097 67.5667 9.40909ZM72.1717 12V6.81818H73.5649V7.7223H73.6189C73.7134 7.40069 73.8719 7.15779 74.0946 6.99361C74.3172 6.82718 74.5736 6.74396 74.8638 6.74396C74.9357 6.74396 75.0133 6.74846 75.0965 6.75746C75.1798 6.76645 75.2529 6.77882 75.3158 6.79457V8.06978C75.2484 8.04954 75.155 8.03155 75.0358 8.0158C74.9166 8.00006 74.8075 7.99219 74.7086 7.99219C74.4972 7.99219 74.3083 8.03829 74.1418 8.1305C73.9776 8.22047 73.8472 8.34641 73.7505 8.50835C73.656 8.67028 73.6088 8.85695 73.6088 9.06836V12H72.1717ZM76.0589 12V6.81818H77.496V12H76.0589ZM76.7808 6.15021C76.5671 6.15021 76.3838 6.07937 76.2309 5.93768C76.0802 5.79374 76.0049 5.62169 76.0049 5.42152C76.0049 5.2236 76.0802 5.0538 76.2309 4.91211C76.3838 4.76817 76.5671 4.6962 76.7808 4.6962C76.9945 4.6962 77.1766 4.76817 77.3273 4.91211C77.4803 5.0538 77.5567 5.2236 77.5567 5.42152C77.5567 5.62169 77.4803 5.79374 77.3273 5.93768C77.1766 6.07937 76.9945 6.15021 76.7808 6.15021ZM78.6472 6.81818H80.0844V12.2564C80.0844 12.6567 80.0057 12.9806 79.8482 13.228C79.6908 13.4754 79.4648 13.6564 79.1701 13.7711C78.8778 13.8858 78.528 13.9432 78.121 13.9432C78.0715 13.9432 78.0243 13.9421 77.9793 13.9398C77.932 13.9398 77.8826 13.9387 77.8308 13.9364V12.813C77.8691 12.8153 77.9028 12.8164 77.932 12.8164C77.959 12.8187 77.9883 12.8198 78.0198 12.8198C78.2514 12.8198 78.4133 12.7703 78.5055 12.6713C78.6 12.5746 78.6472 12.4284 78.6472 12.2328V6.81818ZM79.3624 6.15021C79.151 6.15021 78.9689 6.07937 78.8159 5.93768C78.663 5.79374 78.5865 5.62169 78.5865 5.42152C78.5865 5.2236 78.663 5.0538 78.8159 4.91211C78.9689 4.76817 79.151 4.6962 79.3624 4.6962C79.5783 4.6962 79.7616 4.76817 79.9123 4.91211C80.0653 5.0538 80.1417 5.2236 80.1417 5.42152C80.1417 5.62169 80.0653 5.79374 79.9123 5.93768C79.7616 6.07937 79.5783 6.15021 79.3624 6.15021ZM81.2356 12V6.81818H82.6728V12H81.2356ZM81.9576 6.15021C81.7439 6.15021 81.5606 6.07937 81.4077 5.93768C81.257 5.79374 81.1816 5.62169 81.1816 5.42152C81.1816 5.2236 81.257 5.0538 81.4077 4.91211C81.5606 4.76817 81.7439 4.6962 81.9576 4.6962C82.1712 4.6962 82.3534 4.76817 82.5041 4.91211C82.657 5.0538 82.7335 5.2236 82.7335 5.42152C82.7335 5.62169 82.657 5.79374 82.5041 5.93768C82.3534 6.07937 82.1712 6.15021 81.9576 6.15021ZM85.2611 9.00426V12H83.824V6.81818H85.1937V7.73242H85.2544C85.3691 7.43105 85.5614 7.19265 85.8313 7.01722C86.1012 6.83955 86.4284 6.75071 86.813 6.75071C87.1728 6.75071 87.4866 6.82943 87.7542 6.98686C88.0219 7.14429 88.2299 7.3692 88.3783 7.66158C88.5268 7.9517 88.601 8.29806 88.601 8.70064V12H87.1638V8.95703C87.1661 8.63991 87.0851 8.39252 86.9209 8.21484C86.7568 8.03492 86.5307 7.94496 86.2429 7.94496C86.0494 7.94496 85.8785 7.98656 85.7301 8.06978C85.5839 8.15299 85.4692 8.27444 85.386 8.43413C85.305 8.59156 85.2634 8.78161 85.2611 9.00426ZM93.0566 9.79368V6.81818H94.4938V12H93.114V11.0588H93.06C92.9431 11.3624 92.7485 11.6064 92.4764 11.7908C92.2065 11.9753 91.877 12.0675 91.4879 12.0675C91.1416 12.0675 90.8368 11.9888 90.5737 11.8313C90.3105 11.6739 90.1048 11.4501 89.9563 11.16C89.8101 10.8699 89.7359 10.5224 89.7337 10.1175V6.81818H91.1708V9.86115C91.1731 10.167 91.2551 10.4088 91.4171 10.5865C91.579 10.7641 91.796 10.853 92.0682 10.853C92.2414 10.853 92.4033 10.8136 92.554 10.7349C92.7047 10.6539 92.8261 10.5347 92.9183 10.3773C93.0128 10.2199 93.0589 10.0253 93.0566 9.79368ZM97.0805 5.09091V12H95.6433V5.09091H97.0805Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function pA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2004_5260",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2004_5260)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94963 17.0117 9.48337 19.0999 9.48713C20.109 9.48285 21.1161 9.57578 22.1074 9.76463C22.8795 9.90043 23.6388 10.1012 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.667 5.2835H53.9775V6.338H48.667V5.2835ZM48.8285 7.478H52.8945V8.504H48.8285V7.478ZM50.7095 3.925H51.84V8.0385H50.7095V3.925ZM50.0635 8.295C50.4118 9.17533 50.9438 9.929 51.6595 10.556C52.3752 11.1767 53.2713 11.6168 54.348 11.8765C54.2657 11.9588 54.177 12.057 54.082 12.171C53.987 12.285 53.8983 12.4022 53.816 12.5225C53.74 12.6492 53.6735 12.7632 53.6165 12.8645C52.4765 12.5288 51.536 12 50.795 11.278C50.0603 10.556 49.4745 9.65983 49.0375 8.5895L50.0635 8.295ZM52.771 7.478H52.9895L53.1795 7.44L53.911 7.7345C53.721 8.4375 53.4613 9.0645 53.132 9.6155C52.809 10.1665 52.4227 10.6478 51.973 11.0595C51.5297 11.4712 51.0325 11.8227 50.4815 12.114C49.9368 12.4053 49.351 12.6428 48.724 12.8265C48.686 12.7315 48.6322 12.6175 48.5625 12.4845C48.4928 12.3578 48.4168 12.2312 48.3345 12.1045C48.2585 11.9842 48.1857 11.8828 48.116 11.8005C48.686 11.6675 49.2212 11.4807 49.7215 11.24C50.2282 10.9993 50.6842 10.7048 51.0895 10.3565C51.4948 10.0082 51.84 9.60917 52.125 9.1595C52.4163 8.7035 52.6317 8.20317 52.771 7.6585V7.478ZM45.2565 8.751C45.5352 8.694 45.8518 8.6275 46.2065 8.5515C46.5612 8.46917 46.9317 8.3805 47.318 8.2855C47.7107 8.18417 48.097 8.086 48.477 7.991L48.6195 9.036C48.1002 9.18167 47.5682 9.32733 47.0235 9.473C46.4852 9.61233 45.9943 9.73583 45.551 9.8435L45.2565 8.751ZM45.38 5.7395H48.5435V6.794H45.38V5.7395ZM46.482 3.925H47.603V11.5915C47.603 11.8638 47.5713 12.076 47.508 12.228C47.451 12.3863 47.3402 12.5098 47.1755 12.5985C47.0172 12.6808 46.8208 12.7347 46.5865 12.76C46.3522 12.7853 46.064 12.798 45.722 12.798C45.703 12.6523 45.6618 12.4782 45.5985 12.2755C45.5352 12.0792 45.4687 11.9082 45.399 11.7625C45.589 11.7688 45.7695 11.772 45.9405 11.772C46.1178 11.772 46.2382 11.772 46.3015 11.772C46.4218 11.772 46.482 11.7087 46.482 11.582V3.925ZM60.1715 7.0125C60.3678 7.36717 60.6022 7.72183 60.8745 8.0765C61.1532 8.43117 61.454 8.77633 61.777 9.112C62.1 9.44767 62.4325 9.76117 62.7745 10.0525C63.1165 10.3438 63.4585 10.594 63.8005 10.803C63.7055 10.879 63.5978 10.9772 63.4775 11.0975C63.3635 11.2178 63.2527 11.3413 63.145 11.468C63.0437 11.5947 62.955 11.7118 62.879 11.8195C62.5433 11.5662 62.2045 11.2748 61.8625 10.9455C61.5268 10.6098 61.2007 10.2488 60.884 9.8625C60.5673 9.46983 60.2665 9.0645 59.9815 8.6465C59.7028 8.2285 59.4527 7.8105 59.231 7.3925L60.1715 7.0125ZM58.509 7.0505L59.5445 7.421C59.3165 7.88333 59.06 8.333 58.775 8.77C58.49 9.207 58.1765 9.61867 57.8345 10.005C57.4988 10.385 57.1378 10.7365 56.7515 11.0595C56.3715 11.3825 55.9788 11.6612 55.5735 11.8955C55.5102 11.7942 55.4247 11.6833 55.317 11.563C55.2157 11.4363 55.1112 11.3128 55.0035 11.1925C54.9022 11.0722 54.804 10.9708 54.709 10.8885C55.1017 10.6985 55.4848 10.4642 55.8585 10.1855C56.2322 9.9005 56.5837 9.59017 56.913 9.2545C57.2487 8.9125 57.5527 8.55467 57.825 8.181C58.0973 7.80733 58.3253 7.4305 58.509 7.0505ZM55.0795 6.262H63.392V7.3925H55.0795V6.262ZM58.6515 3.9345H59.9055V12.855H58.6515V3.9345ZM60.257 4.7135L61.093 4.02C61.2703 4.14667 61.4603 4.29233 61.663 4.457C61.8657 4.61533 62.062 4.77367 62.252 4.932C62.442 5.09033 62.5972 5.23283 62.7175 5.3595L61.8245 6.148C61.7168 6.015 61.5712 5.86617 61.3875 5.7015C61.2102 5.5305 61.0202 5.3595 60.8175 5.1885C60.6148 5.01117 60.428 4.85283 60.257 4.7135ZM67.1255 8.4565C67.6195 9.3875 68.3795 10.1285 69.4055 10.6795C70.4315 11.2305 71.7077 11.5915 73.234 11.7625C73.1517 11.8512 73.063 11.9588 72.968 12.0855C72.8793 12.2185 72.7938 12.3547 72.7115 12.494C72.6292 12.6333 72.5595 12.76 72.5025 12.874C71.4385 12.7157 70.498 12.4655 69.681 12.1235C68.8703 11.7878 68.1673 11.3477 67.572 10.803C66.9767 10.252 66.47 9.59333 66.052 8.827L67.1255 8.4565ZM65.121 7.421H71.2105V8.5325H65.121V7.421ZM64.6555 5.179H72.8065V6.3095H64.6555V5.179ZM68.123 3.925H69.3105V7.9245H68.123V3.925ZM70.8495 7.421H71.087L71.2865 7.3735L72.094 7.8295C71.809 8.60217 71.4258 9.2735 70.9445 9.8435C70.4695 10.4135 69.9185 10.898 69.2915 11.297C68.6645 11.6897 67.9805 12.0127 67.2395 12.266C66.4985 12.5193 65.7163 12.7157 64.893 12.855C64.8613 12.7473 64.8075 12.6238 64.7315 12.4845C64.6618 12.3452 64.5858 12.209 64.5035 12.076C64.4212 11.943 64.342 11.8353 64.266 11.753C65.064 11.6453 65.8145 11.4933 66.5175 11.297C67.2205 11.0943 67.857 10.8315 68.427 10.5085C69.0033 10.1792 69.4973 9.78017 69.909 9.3115C70.3207 8.8365 70.6342 8.27283 70.8495 7.6205V7.421ZM77.3285 5.008H82.297V6.0435H77.3285V5.008ZM77.015 8.6655H82.6485V9.6915H77.015V8.6655ZM76.9295 6.87H82.715V7.9055H76.9295V6.87ZM79.2855 3.9725H80.3685V7.4115H79.2855V3.9725ZM80.511 7.7345H81.594V11.658C81.594 11.9367 81.5623 12.152 81.499 12.304C81.4357 12.4623 81.3122 12.5858 81.1285 12.6745C80.9512 12.7568 80.7327 12.8075 80.473 12.8265C80.2197 12.8455 79.922 12.855 79.58 12.855C79.561 12.6967 79.5198 12.513 79.4565 12.304C79.3932 12.1013 79.3267 11.9272 79.257 11.7815C79.4723 11.7878 79.6877 11.7942 79.903 11.8005C80.1183 11.8005 80.2577 11.7973 80.321 11.791C80.397 11.791 80.4477 11.7815 80.473 11.7625C80.4983 11.7372 80.511 11.6928 80.511 11.6295V7.7345ZM77.528 10.2425L78.4305 9.739C78.5698 9.89733 78.7092 10.0747 78.8485 10.271C78.9878 10.461 79.1145 10.651 79.2285 10.841C79.3425 11.0247 79.4343 11.1957 79.504 11.354L78.5255 11.9145C78.4748 11.7625 78.3957 11.5915 78.288 11.4015C78.1803 11.2052 78.06 11.0057 77.927 10.803C77.8003 10.6003 77.6673 10.4135 77.528 10.2425ZM73.6995 8.751C74.0858 8.66233 74.5482 8.54833 75.0865 8.409C75.6312 8.26967 76.1758 8.124 76.7205 7.972L76.863 8.998C76.3627 9.14367 75.856 9.2925 75.343 9.4445C74.8363 9.59017 74.3708 9.72317 73.9465 9.8435L73.6995 8.751ZM73.8515 5.73H76.787V6.775H73.8515V5.73ZM74.925 3.9345H75.97V11.5915C75.97 11.8512 75.9415 12.057 75.8845 12.209C75.8338 12.3673 75.7357 12.4908 75.59 12.5795C75.4443 12.6618 75.2638 12.7188 75.0485 12.7505C74.8395 12.7822 74.5798 12.7948 74.2695 12.7885C74.2568 12.6492 74.222 12.475 74.165 12.266C74.108 12.0633 74.0447 11.886 73.975 11.734C74.146 11.7403 74.3043 11.7467 74.45 11.753C74.602 11.753 74.7065 11.7498 74.7635 11.7435C74.8205 11.7435 74.8617 11.734 74.887 11.715C74.9123 11.6897 74.925 11.6453 74.925 11.582V3.9345Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function hA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.418 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.675C133.04 21.0981 133.378 21.6101 133.623 22.2111C133.874 22.8058 134 23.4405 134 24.115C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5457C124.848 26.6321 124.388 25.4885 124.388 24.115C124.388 22.7415 124.848 21.5948 125.768 20.675C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4589 126.991 24.115C126.991 24.7527 127.2 25.2892 127.617 25.7246C128.04 26.1599 128.567 26.3776 129.199 26.3776C129.818 26.3776 130.339 26.1599 130.762 25.7246C131.185 25.2892 131.397 24.7527 131.397 24.115C131.397 23.4589 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.7011C113.571 24.0751 113.547 24.4216 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.396C110.803 26.2182 111.076 25.9913 111.235 25.7154L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4272 104.3 24.0598C104.3 22.7169 104.763 21.5886 105.689 20.675C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.7011ZM106.885 23.048H110.913C110.858 22.5882 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4385 108.973 21.4385C108.421 21.4385 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6326 101.771 20.3071C102.476 20.9816 102.828 21.8738 102.828 22.9837V28.7322H100.152V23.609C100.152 23.0634 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.045 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0634 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4793H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.7011C86.8614 24.0751 86.8368 24.4216 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.396C84.0929 26.2182 84.3657 25.9913 84.5251 25.7154L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4272 77.5901 24.0598C77.5901 22.7169 78.053 21.5886 78.9789 20.675C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.7011ZM80.1747 23.048H84.2032C84.148 22.5882 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4385 82.2625 21.4385C81.7107 21.4385 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.8861C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0097C75.2171 26.2672 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5585 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5309 67.1598 26.35 67.1598 26.1293C67.1598 25.9392 67.0648 25.7828 66.8747 25.6602C66.6907 25.5314 66.4517 25.4302 66.1573 25.3567C65.863 25.2831 65.538 25.2095 65.1823 25.1359C64.8267 25.0562 64.471 24.955 64.1154 24.8324C63.7598 24.7036 63.4348 24.5473 63.1404 24.3633C62.8461 24.1732 62.6039 23.9096 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6623 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.346 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.9101 66.1941 23.0021C66.5007 23.0878 66.8104 23.1737 67.123 23.2596C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7716 68.6223 23.9463 68.8614 24.1426C69.1006 24.3326 69.2937 24.584 69.4408 24.8968C69.5942 25.2095 69.6738 25.5651 69.68 25.9637C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5585 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5309 49.2795 26.35 49.2795 26.1293C49.2795 25.9392 49.1844 25.7828 48.9944 25.6602C48.8104 25.5314 48.5713 25.4302 48.2769 25.3567C47.9826 25.2831 47.6576 25.2095 47.302 25.1359C46.9463 25.0562 46.5907 24.955 46.2351 24.8324C45.8794 24.7036 45.5544 24.5473 45.2601 24.3633C44.9658 24.1732 44.7236 23.9096 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6623 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.346 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.9101 48.3137 23.0021C48.6203 23.0878 48.93 23.1737 49.2427 23.2596C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7716 50.7419 23.9463 50.981 24.1426C51.2202 24.3326 51.4133 24.584 51.5605 24.8968C51.7138 25.2095 51.7936 25.5651 51.7996 25.9637C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2004_5308",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2004_5308)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM52.4851 12V6.81818H53.8784V7.7223H53.9324C54.0269 7.40069 54.1854 7.15779 54.4081 6.99361C54.6307 6.82718 54.8871 6.74396 55.1772 6.74396C55.2492 6.74396 55.3268 6.74846 55.41 6.75746C55.4932 6.76645 55.5663 6.77882 55.6293 6.79457V8.06978C55.5618 8.04954 55.4685 8.03155 55.3493 8.0158C55.2301 8.00006 55.121 7.99219 55.0221 7.99219C54.8107 7.99219 54.6217 8.03829 54.4553 8.1305C54.2911 8.22047 54.1607 8.34641 54.064 8.50835C53.9695 8.67028 53.9223 8.85695 53.9223 9.06836V12H52.4851ZM56.3723 12V6.81818H57.8095V12H56.3723ZM57.0943 6.15021C56.8806 6.15021 56.6973 6.07937 56.5444 5.93768C56.3937 5.79374 56.3184 5.62169 56.3184 5.42152C56.3184 5.2236 56.3937 5.0538 56.5444 4.91211C56.6973 4.76817 56.8806 4.6962 57.0943 4.6962C57.3079 4.6962 57.4901 4.76817 57.6408 4.91211C57.7937 5.0538 57.8702 5.2236 57.8702 5.42152C57.8702 5.62169 57.7937 5.79374 57.6408 5.93768C57.4901 6.07937 57.3079 6.15021 57.0943 6.15021ZM63.7917 6.81818L61.9801 12H60.3608L58.5491 6.81818H60.0672L61.1434 10.5257H61.1974L62.2702 6.81818H63.7917ZM68.8386 8.29581L67.5229 8.37678C67.5004 8.26432 67.452 8.16312 67.3778 8.07315C67.3036 7.98094 67.2057 7.90785 67.0843 7.85387C66.9651 7.79764 66.8223 7.76953 66.6559 7.76953C66.4332 7.76953 66.2454 7.81676 66.0925 7.91122C65.9395 8.00343 65.8631 8.12713 65.8631 8.28232C65.8631 8.40601 65.9125 8.51059 66.0115 8.59606C66.1105 8.68152 66.2803 8.75012 66.5209 8.80185L67.4588 8.99077C67.9626 9.09422 68.3381 9.26065 68.5855 9.49006C68.8329 9.71946 68.9566 10.0208 68.9566 10.3942C68.9566 10.7338 68.8565 11.0318 68.6564 11.2882C68.4585 11.5446 68.1863 11.7447 67.84 11.8887C67.4959 12.0304 67.0989 12.1012 66.6491 12.1012C65.9631 12.1012 65.4166 11.9584 65.0095 11.6728C64.6047 11.3849 64.3674 10.9935 64.2977 10.4988L65.7112 10.4245C65.754 10.6337 65.8574 10.7934 66.0216 10.9036C66.1858 11.0115 66.3961 11.0655 66.6525 11.0655C66.9044 11.0655 67.1068 11.0172 67.2597 10.9205C67.4149 10.8215 67.4936 10.6944 67.4959 10.5392C67.4936 10.4088 67.4385 10.302 67.3306 10.2188C67.2226 10.1333 67.0562 10.0681 66.8313 10.0231L65.9339 9.84428C65.4279 9.74308 65.0512 9.56765 64.8038 9.318C64.5586 9.06836 64.436 8.75012 64.436 8.36328C64.436 8.03042 64.526 7.74367 64.7059 7.50302C64.8881 7.26237 65.1434 7.07682 65.4717 6.94638C65.8023 6.81593 66.1892 6.75071 66.6322 6.75071C67.2867 6.75071 67.8017 6.88903 68.1773 7.16566C68.5552 7.44229 68.7756 7.81901 68.8386 8.29581ZM73.538 12.0978C73.2073 12.0978 72.9127 12.0405 72.6541 11.9258C72.3954 11.8088 72.1908 11.6368 72.0401 11.4096C71.8916 11.1802 71.8174 10.8946 71.8174 10.5527C71.8174 10.2649 71.8703 10.0231 71.976 9.82741C72.0817 9.63175 72.2256 9.47431 72.4078 9.35511C72.59 9.23591 72.7969 9.14595 73.0285 9.08523C73.2624 9.0245 73.5076 8.98177 73.764 8.95703C74.0654 8.92554 74.3083 8.89631 74.4927 8.86932C74.6771 8.84008 74.8109 8.79735 74.8941 8.74112C74.9773 8.6849 75.019 8.60168 75.019 8.49148V8.47124C75.019 8.25758 74.9515 8.09227 74.8165 7.97532C74.6838 7.85837 74.4949 7.79989 74.2498 7.79989C73.9911 7.79989 73.7853 7.85724 73.6324 7.97195C73.4795 8.0844 73.3783 8.22609 73.3288 8.39702L71.9996 8.28906C72.0671 7.97419 72.1998 7.70206 72.3977 7.47266C72.5956 7.241 72.8509 7.06333 73.1635 6.93963C73.4784 6.81368 73.8427 6.75071 74.2565 6.75071C74.5444 6.75071 74.8199 6.78445 75.0831 6.85192C75.3484 6.91939 75.5835 7.02397 75.7881 7.16566C75.995 7.30735 76.1581 7.48952 76.2773 7.71218C76.3965 7.93259 76.4561 8.19685 76.4561 8.50497V12H75.0932V11.2814H75.0527C74.9695 11.4434 74.8581 11.5862 74.7187 11.7099C74.5793 11.8313 74.4117 11.9269 74.216 11.9966C74.0204 12.0641 73.7943 12.0978 73.538 12.0978ZM73.9495 11.106C74.1609 11.106 74.3476 11.0644 74.5095 10.9812C74.6715 10.8957 74.7985 10.781 74.8908 10.6371C74.983 10.4931 75.0291 10.3301 75.0291 10.1479V9.59801C74.9841 9.62725 74.9222 9.65424 74.8435 9.67898C74.7671 9.70147 74.6805 9.72283 74.5838 9.74308C74.4871 9.76107 74.3903 9.77794 74.2936 9.79368C74.1969 9.80717 74.1092 9.81954 74.0305 9.83079C73.8618 9.85553 73.7145 9.89489 73.5886 9.94886C73.4626 10.0028 73.3648 10.0759 73.2951 10.1681C73.2253 10.2581 73.1905 10.3706 73.1905 10.5055C73.1905 10.7012 73.2613 10.8507 73.403 10.9542C73.5469 11.0554 73.7291 11.106 73.9495 11.106ZM82.2165 6.81818L80.4049 12H78.7856L76.9739 6.81818H78.4921L79.5682 10.5257H79.6222L80.695 6.81818H82.2165Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function mA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2673L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5483 72.8809 27.8861C72.2064 27.2177 71.8691 26.2949 71.8691 25.1176V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4027 74.6652 25.7461 74.9411 26.0097C75.2171 26.2673 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5740",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5740)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7638 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 5.09091H47.402L49.3047 9.73295H49.3857L51.2884 5.09091H53.0898V12H51.6729V7.50302H51.6156L49.8276 11.9663H48.8627L47.0748 7.48615H47.0174V12H45.6005V5.09091ZM57.5894 9.79368V6.81818H59.0265V12H57.6467V11.0588H57.5927C57.4758 11.3624 57.2812 11.6064 57.0091 11.7908C56.7392 11.9753 56.4097 12.0675 56.0206 12.0675C55.6743 12.0675 55.3695 11.9888 55.1064 11.8313C54.8433 11.6739 54.6375 11.4501 54.489 11.16C54.3428 10.8699 54.2686 10.5224 54.2664 10.1175V6.81818H55.7035V9.86115C55.7058 10.167 55.7879 10.4088 55.9498 10.5865C56.1117 10.7641 56.3288 10.853 56.6009 10.853C56.7741 10.853 56.936 10.8136 57.0867 10.7349C57.2374 10.6539 57.3588 10.5347 57.451 10.3773C57.5455 10.2199 57.5916 10.0253 57.5894 9.79368ZM61.6132 9.00426V12H60.176V6.81818H61.5457V7.73242H61.6064C61.7211 7.43105 61.9134 7.19265 62.1833 7.01722C62.4532 6.83955 62.7805 6.75071 63.165 6.75071C63.5249 6.75071 63.8386 6.82943 64.1063 6.98686C64.3739 7.14429 64.5819 7.3692 64.7304 7.66158C64.8788 7.9517 64.953 8.29806 64.953 8.70064V12H63.5159V8.95703C63.5181 8.63991 63.4372 8.39252 63.273 8.21484C63.1088 8.03492 62.8828 7.94496 62.5949 7.94496C62.4015 7.94496 62.2306 7.98656 62.0821 8.06978C61.9359 8.15299 61.8212 8.27444 61.738 8.43413C61.657 8.59156 61.6154 8.78161 61.6132 9.00426ZM67.9952 12.0843C67.6016 12.0843 67.2451 11.9831 66.9257 11.7807C66.6086 11.5761 66.3567 11.2758 66.1701 10.88C65.9856 10.4819 65.8934 9.99384 65.8934 9.41584C65.8934 8.82209 65.989 8.32842 66.1802 7.93484C66.3713 7.539 66.6255 7.24325 66.9426 7.04759C67.262 6.84967 67.6117 6.75071 67.9918 6.75071C68.2819 6.75071 68.5237 6.80019 68.7171 6.89915C68.9128 6.99586 69.0702 7.11731 69.1894 7.26349C69.3109 7.40743 69.4031 7.54912 69.466 7.68857H69.5099V5.09091H70.9437V12H69.5268V11.1701H69.466C69.3986 11.314 69.303 11.4569 69.1793 11.5985C69.0578 11.738 68.8993 11.8538 68.7036 11.946C68.5102 12.0382 68.274 12.0843 67.9952 12.0843ZM68.4506 10.9407C68.6822 10.9407 68.8779 10.8777 69.0376 10.7518C69.1995 10.6236 69.3232 10.4448 69.4087 10.2154C69.4964 9.98597 69.5403 9.71721 69.5403 9.40909C69.5403 9.10097 69.4975 8.83333 69.4121 8.60618C69.3266 8.37902 69.2029 8.2036 69.041 8.0799C68.879 7.9562 68.6822 7.89435 68.4506 7.89435C68.2144 7.89435 68.0154 7.95845 67.8535 8.08665C67.6915 8.21484 67.569 8.39252 67.4858 8.61967C67.4025 8.84683 67.3609 9.10997 67.3609 9.40909C67.3609 9.71046 67.4025 9.97698 67.4858 10.2086C67.5712 10.438 67.6938 10.618 67.8535 10.7484C68.0154 10.8766 68.2144 10.9407 68.4506 10.9407ZM74.4868 12.1012C73.9537 12.1012 73.4949 11.9933 73.1104 11.7773C72.728 11.5592 72.4334 11.2511 72.2265 10.853C72.0196 10.4527 71.9161 9.97923 71.9161 9.43271C71.9161 8.89968 72.0196 8.43188 72.2265 8.0293C72.4334 7.62672 72.7246 7.31297 73.1002 7.08807C73.4781 6.86316 73.9211 6.75071 74.4294 6.75071C74.7713 6.75071 75.0895 6.80581 75.3841 6.91602C75.681 7.02397 75.9397 7.18703 76.1601 7.40518C76.3827 7.62334 76.5559 7.89773 76.6796 8.22834C76.8033 8.5567 76.8651 8.94129 76.8651 9.3821V9.77681H72.4896V8.88619H75.5123C75.5123 8.67927 75.4674 8.49598 75.3774 8.33629C75.2874 8.17661 75.1626 8.05179 75.0029 7.96183C74.8455 7.86961 74.6622 7.82351 74.453 7.82351C74.2349 7.82351 74.0415 7.87411 73.8728 7.97532C73.7064 8.07428 73.5759 8.2081 73.4814 8.37678C73.387 8.54321 73.3386 8.72875 73.3364 8.93342V9.78018C73.3364 10.0366 73.3836 10.2581 73.4781 10.4448C73.5748 10.6315 73.7108 10.7754 73.8863 10.8766C74.0617 10.9778 74.2697 11.0284 74.5104 11.0284C74.6701 11.0284 74.8163 11.0059 74.949 10.9609C75.0816 10.916 75.1952 10.8485 75.2897 10.7585C75.3841 10.6686 75.4561 10.5584 75.5056 10.4279L76.8348 10.5156C76.7673 10.835 76.629 11.1139 76.4198 11.3523C76.2129 11.5884 75.9453 11.7728 75.6169 11.9055C75.2908 12.036 74.9141 12.1012 74.4868 12.1012ZM73.3667 6.10973C73.1733 6.10973 73.0069 6.04226 72.8675 5.90732C72.728 5.77012 72.6583 5.60819 72.6583 5.42152C72.6583 5.23035 72.728 5.06842 72.8675 4.93572C73.0069 4.80303 73.1733 4.73668 73.3667 4.73668C73.5624 4.73668 73.7277 4.80303 73.8627 4.93572C73.9999 5.06842 74.0684 5.23035 74.0684 5.42152C74.0684 5.60819 73.9999 5.77012 73.8627 5.90732C73.7277 6.04226 73.5624 6.10973 73.3667 6.10973ZM75.4314 6.10973C75.238 6.10973 75.0715 6.04226 74.9321 5.90732C74.7926 5.77012 74.7229 5.60819 74.7229 5.42152C74.7229 5.23035 74.7926 5.06842 74.9321 4.93572C75.0715 4.80303 75.238 4.73668 75.4314 4.73668C75.627 4.73668 75.7923 4.80303 75.9273 4.93572C76.0645 5.06842 76.1331 5.23035 76.1331 5.42152C76.1331 5.60819 76.0645 5.77012 75.9273 5.90732C75.7923 6.04226 75.627 6.10973 75.4314 6.10973ZM82.1144 8.29581L80.7987 8.37678C80.7762 8.26432 80.7279 8.16312 80.6537 8.07315C80.5795 7.98094 80.4816 7.90785 80.3602 7.85387C80.241 7.79764 80.0982 7.76953 79.9317 7.76953C79.7091 7.76953 79.5213 7.81676 79.3683 7.91122C79.2154 8.00343 79.1389 8.12713 79.1389 8.28232C79.1389 8.40601 79.1884 8.51059 79.2874 8.59606C79.3863 8.68152 79.5561 8.75012 79.7968 8.80185L80.7346 8.99077C81.2384 9.09422 81.614 9.26065 81.8614 9.49006C82.1088 9.71946 82.2325 10.0208 82.2325 10.3942C82.2325 10.7338 82.1324 11.0318 81.9323 11.2882C81.7343 11.5446 81.4622 11.7447 81.1159 11.8887C80.7718 12.0304 80.3748 12.1012 79.925 12.1012C79.239 12.1012 78.6925 11.9584 78.2854 11.6728C77.8806 11.3849 77.6433 10.9935 77.5736 10.4988L78.9871 10.4245C79.0299 10.6337 79.1333 10.7934 79.2975 10.9036C79.4617 11.0115 79.672 11.0655 79.9284 11.0655C80.1802 11.0655 80.3827 11.0172 80.5356 10.9205C80.6908 10.8215 80.7695 10.6944 80.7718 10.5392C80.7695 10.4088 80.7144 10.302 80.6064 10.2188C80.4985 10.1333 80.3321 10.0681 80.1072 10.0231L79.2098 9.84428C78.7037 9.74308 78.327 9.56765 78.0796 9.318C77.8345 9.06836 77.7119 8.75012 77.7119 8.36328C77.7119 8.03042 77.8019 7.74367 77.9818 7.50302C78.164 7.26237 78.4192 7.07682 78.7476 6.94638C79.0782 6.81593 79.4651 6.75071 79.9081 6.75071C80.5626 6.75071 81.0776 6.88903 81.4532 7.16566C81.8311 7.44229 82.0515 7.81901 82.1144 8.29581ZM86.4604 9.79368V6.81818H87.8976V12H86.5178V11.0588H86.4638C86.3469 11.3624 86.1523 11.6064 85.8802 11.7908C85.6103 11.9753 85.2808 12.0675 84.8917 12.0675C84.5454 12.0675 84.2406 11.9888 83.9775 11.8313C83.7144 11.6739 83.5086 11.4501 83.3601 11.16C83.2139 10.8699 83.1397 10.5224 83.1375 10.1175V6.81818H84.5746V9.86115C84.5769 10.167 84.659 10.4088 84.8209 10.5865C84.9828 10.7641 85.1999 10.853 85.472 10.853C85.6452 10.853 85.8071 10.8136 85.9578 10.7349C86.1085 10.6539 86.2299 10.5347 86.3221 10.3773C86.4166 10.2199 86.4627 10.0253 86.4604 9.79368ZM90.5248 12.0978C90.1942 12.0978 89.8995 12.0405 89.6409 11.9258C89.3823 11.8088 89.1776 11.6368 89.0269 11.4096C88.8785 11.1802 88.8042 10.8946 88.8042 10.5527C88.8042 10.2649 88.8571 10.0231 88.9628 9.82741C89.0685 9.63175 89.2124 9.47431 89.3946 9.35511C89.5768 9.23591 89.7837 9.14595 90.0154 9.08523C90.2493 9.0245 90.4944 8.98177 90.7508 8.95703C91.0522 8.92554 91.2951 8.89631 91.4795 8.86932C91.6639 8.84008 91.7977 8.79735 91.8809 8.74112C91.9642 8.6849 92.0058 8.60168 92.0058 8.49148V8.47124C92.0058 8.25758 91.9383 8.09227 91.8034 7.97532C91.6707 7.85837 91.4817 7.79989 91.2366 7.79989C90.978 7.79989 90.7722 7.85724 90.6192 7.97195C90.4663 8.0844 90.3651 8.22609 90.3156 8.39702L88.9864 8.28906C89.0539 7.97419 89.1866 7.70206 89.3845 7.47266C89.5824 7.241 89.8377 7.06333 90.1503 6.93963C90.4652 6.81368 90.8295 6.75071 91.2433 6.75071C91.5312 6.75071 91.8067 6.78445 92.0699 6.85192C92.3353 6.91939 92.5703 7.02397 92.7749 7.16566C92.9819 7.30735 93.1449 7.48952 93.2641 7.71218C93.3833 7.93259 93.4429 8.19685 93.4429 8.50497V12H92.08V11.2814H92.0395C91.9563 11.4434 91.845 11.5862 91.7055 11.7099C91.5661 11.8313 91.3985 11.9269 91.2029 11.9966C91.0072 12.0641 90.7812 12.0978 90.5248 12.0978ZM90.9363 11.106C91.1478 11.106 91.3344 11.0644 91.4964 10.9812C91.6583 10.8957 91.7854 10.781 91.8776 10.6371C91.9698 10.4931 92.0159 10.3301 92.0159 10.1479V9.59801C91.9709 9.62725 91.9091 9.65424 91.8303 9.67898C91.7539 9.70147 91.6673 9.72283 91.5706 9.74308C91.4739 9.76107 91.3772 9.77794 91.2805 9.79368C91.1837 9.80717 91.096 9.81954 91.0173 9.83079C90.8486 9.85553 90.7013 9.89489 90.5754 9.94886C90.4494 10.0028 90.3516 10.0759 90.2819 10.1681C90.2122 10.2581 90.1773 10.3706 90.1773 10.5055C90.1773 10.7012 90.2481 10.8507 90.3898 10.9542C90.5338 11.0554 90.7159 11.106 90.9363 11.106ZM94.5579 12V6.81818H95.9512V7.7223H96.0051C96.0996 7.40069 96.2582 7.15779 96.4808 6.99361C96.7035 6.82718 96.9599 6.74396 97.25 6.74396C97.322 6.74396 97.3996 6.74846 97.4828 6.75746C97.566 6.76645 97.6391 6.77882 97.7021 6.79457V8.06978C97.6346 8.04954 97.5413 8.03155 97.4221 8.0158C97.3029 8.00006 97.1938 7.99219 97.0948 7.99219C96.8834 7.99219 96.6945 8.03829 96.5281 8.1305C96.3639 8.22047 96.2334 8.34641 96.1367 8.50835C96.0423 8.67028 95.995 8.85695 95.995 9.06836V12H94.5579ZM102.081 9.00426V12H100.644V6.81818H102.013V7.73242H102.074C102.189 7.43105 102.381 7.19265 102.651 7.01722C102.921 6.83955 103.248 6.75071 103.633 6.75071C103.993 6.75071 104.306 6.82943 104.574 6.98686C104.842 7.14429 105.05 7.3692 105.198 7.66158C105.347 7.9517 105.421 8.29806 105.421 8.70064V12H103.984V8.95703C103.986 8.63991 103.905 8.39252 103.741 8.21484C103.577 8.03492 103.351 7.94496 103.063 7.94496C102.869 7.94496 102.698 7.98656 102.55 8.06978C102.404 8.15299 102.289 8.27444 102.206 8.43413C102.125 8.59156 102.083 8.78161 102.081 9.00426ZM108.888 14.0511C108.422 14.0511 108.023 13.987 107.69 13.8588C107.36 13.7329 107.097 13.5608 106.901 13.3427C106.705 13.1245 106.578 12.8794 106.52 12.6072L107.849 12.4284C107.889 12.5319 107.954 12.6286 108.041 12.7186C108.129 12.8085 108.245 12.8805 108.389 12.9345C108.535 12.9907 108.713 13.0188 108.922 13.0188C109.234 13.0188 109.492 12.9424 109.694 12.7894C109.899 12.6387 110.001 12.3857 110.001 12.0304V11.0824H109.941C109.878 11.2263 109.783 11.3624 109.657 11.4906C109.531 11.6188 109.369 11.7234 109.171 11.8043C108.973 11.8853 108.737 11.9258 108.463 11.9258C108.074 11.9258 107.72 11.8358 107.4 11.6559C107.083 11.4737 106.83 11.196 106.641 10.8226C106.455 10.447 106.361 9.97248 106.361 9.39897C106.361 8.81197 106.457 8.32167 106.648 7.92809C106.839 7.53451 107.093 7.23988 107.41 7.04421C107.73 6.84854 108.079 6.75071 108.46 6.75071C108.75 6.75071 108.993 6.80019 109.188 6.89915C109.384 6.99586 109.541 7.11731 109.661 7.26349C109.782 7.40743 109.875 7.54912 109.941 7.68857H109.995V6.81818H111.422V12.0506C111.422 12.4914 111.314 12.8603 111.098 13.1571C110.882 13.454 110.583 13.6767 110.2 13.8251C109.82 13.9758 109.383 14.0511 108.888 14.0511ZM108.918 10.8462C109.15 10.8462 109.346 10.7889 109.505 10.6742C109.667 10.5572 109.791 10.3908 109.876 10.1749C109.964 9.95674 110.008 9.69585 110.008 9.39222C110.008 9.0886 109.965 8.82546 109.88 8.60281C109.794 8.3779 109.671 8.2036 109.509 8.0799C109.347 7.9562 109.15 7.89435 108.918 7.89435C108.682 7.89435 108.483 7.95845 108.321 8.08665C108.159 8.21259 108.037 8.38802 107.954 8.61293C107.87 8.83783 107.829 9.0976 107.829 9.39222C107.829 9.69135 107.87 9.94999 107.954 10.1681C108.039 10.3841 108.162 10.5516 108.321 10.6708C108.483 10.7878 108.682 10.8462 108.918 10.8462ZM114.043 12.0978C113.712 12.0978 113.418 12.0405 113.159 11.9258C112.9 11.8088 112.696 11.6368 112.545 11.4096C112.397 11.1802 112.322 10.8946 112.322 10.5527C112.322 10.2649 112.375 10.0231 112.481 9.82741C112.587 9.63175 112.731 9.47431 112.913 9.35511C113.095 9.23591 113.302 9.14595 113.533 9.08523C113.767 9.0245 114.012 8.98177 114.269 8.95703C114.57 8.92554 114.813 8.89631 114.998 8.86932C115.182 8.84008 115.316 8.79735 115.399 8.74112C115.482 8.6849 115.524 8.60168 115.524 8.49148V8.47124C115.524 8.25758 115.456 8.09227 115.321 7.97532C115.189 7.85837 115 7.79989 114.755 7.79989C114.496 7.79989 114.29 7.85724 114.137 7.97195C113.984 8.0844 113.883 8.22609 113.834 8.39702L112.504 8.28906C112.572 7.97419 112.705 7.70206 112.903 7.47266C113.1 7.241 113.356 7.06333 113.668 6.93963C113.983 6.81368 114.348 6.75071 114.761 6.75071C115.049 6.75071 115.325 6.78445 115.588 6.85192C115.853 6.91939 116.088 7.02397 116.293 7.16566C116.5 7.30735 116.663 7.48952 116.782 7.71218C116.901 7.93259 116.961 8.19685 116.961 8.50497V12H115.598V11.2814H115.558C115.474 11.4434 115.363 11.5862 115.224 11.7099C115.084 11.8313 114.917 11.9269 114.721 11.9966C114.525 12.0641 114.299 12.0978 114.043 12.0978ZM114.454 11.106C114.666 11.106 114.852 11.0644 115.014 10.9812C115.176 10.8957 115.303 10.781 115.396 10.6371C115.488 10.4931 115.534 10.3301 115.534 10.1479V9.59801C115.489 9.62725 115.427 9.65424 115.348 9.67898C115.272 9.70147 115.185 9.72283 115.089 9.74308C114.992 9.76107 114.895 9.77794 114.799 9.79368C114.702 9.80717 114.614 9.81954 114.535 9.83079C114.367 9.85553 114.219 9.89489 114.093 9.94886C113.967 10.0028 113.87 10.0759 113.8 10.1681C113.73 10.2581 113.695 10.3706 113.695 10.5055C113.695 10.7012 113.766 10.8507 113.908 10.9542C114.052 11.0554 114.234 11.106 114.454 11.106Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function fA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2673L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5483 72.8809 27.8861C72.2064 27.2177 71.8691 26.2949 71.8691 25.1176V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4027 74.6652 25.7461 74.9411 26.0097C75.2171 26.2673 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5716",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5716)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7638 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H47.0613V7.94158H50.0266V5.09091H51.484V12H50.0266V9.14595H47.0613V12H45.6005ZM54.139 12.0978C53.8084 12.0978 53.5138 12.0405 53.2551 11.9258C52.9965 11.8088 52.7918 11.6368 52.6412 11.4096C52.4927 11.1802 52.4185 10.8946 52.4185 10.5527C52.4185 10.2649 52.4714 10.0231 52.5771 9.82741C52.6828 9.63175 52.8267 9.47431 53.0089 9.35511C53.1911 9.23591 53.398 9.14595 53.6296 9.08523C53.8635 9.0245 54.1087 8.98177 54.3651 8.95703C54.6664 8.92554 54.9093 8.89631 55.0938 8.86932C55.2782 8.84008 55.412 8.79735 55.4952 8.74112C55.5784 8.6849 55.62 8.60168 55.62 8.49148V8.47124C55.62 8.25758 55.5526 8.09227 55.4176 7.97532C55.2849 7.85837 55.096 7.79989 54.8509 7.79989C54.5922 7.79989 54.3864 7.85724 54.2335 7.97195C54.0806 8.0844 53.9793 8.22609 53.9299 8.39702L52.6007 8.28906C52.6681 7.97419 52.8008 7.70206 52.9988 7.47266C53.1967 7.241 53.4519 7.06333 53.7646 6.93963C54.0794 6.81368 54.4438 6.75071 54.8576 6.75071C55.1455 6.75071 55.421 6.78445 55.6841 6.85192C55.9495 6.91939 56.1845 7.02397 56.3892 7.16566C56.5961 7.30735 56.7592 7.48952 56.8784 7.71218C56.9976 7.93259 57.0572 8.19685 57.0572 8.50497V12H55.6942V11.2814H55.6538C55.5705 11.4434 55.4592 11.5862 55.3198 11.7099C55.1803 11.8313 55.0128 11.9269 54.8171 11.9966C54.6214 12.0641 54.3954 12.0978 54.139 12.0978ZM54.5506 11.106C54.762 11.106 54.9487 11.0644 55.1106 10.9812C55.2725 10.8957 55.3996 10.781 55.4918 10.6371C55.584 10.4931 55.6301 10.3301 55.6301 10.1479V9.59801C55.5852 9.62725 55.5233 9.65424 55.4446 9.67898C55.3681 9.70147 55.2815 9.72283 55.1848 9.74308C55.0881 9.76107 54.9914 9.77794 54.8947 9.79368C54.798 9.80717 54.7103 9.81954 54.6316 9.83079C54.4629 9.85553 54.3156 9.89489 54.1896 9.94886C54.0637 10.0028 53.9658 10.0759 53.8961 10.1681C53.8264 10.2581 53.7915 10.3706 53.7915 10.5055C53.7915 10.7012 53.8624 10.8507 54.0041 10.9542C54.148 11.0554 54.3302 11.106 54.5506 11.106ZM62.7121 12.1012C62.1881 12.1012 61.7349 11.9899 61.3526 11.7672C60.9725 11.5423 60.679 11.2297 60.4721 10.8294C60.2652 10.4268 60.1617 9.96011 60.1617 9.42933C60.1617 8.89406 60.2652 8.42625 60.4721 8.02592C60.679 7.62334 60.9725 7.31072 61.3526 7.08807C61.7349 6.86316 62.1881 6.75071 62.7121 6.75071C63.2362 6.75071 63.6882 6.86316 64.0683 7.08807C64.4507 7.31072 64.7453 7.62334 64.9522 8.02592C65.1591 8.42625 65.2626 8.89406 65.2626 9.42933C65.2626 9.96011 65.1591 10.4268 64.9522 10.8294C64.7453 11.2297 64.4507 11.5423 64.0683 11.7672C63.6882 11.9899 63.2362 12.1012 62.7121 12.1012ZM62.7189 10.9879C62.9573 10.9879 63.1563 10.9205 63.316 10.7855C63.4757 10.6483 63.596 10.4616 63.677 10.2255C63.7602 9.98935 63.8018 9.72058 63.8018 9.41921C63.8018 9.11784 63.7602 8.84908 63.677 8.61293C63.596 8.37678 63.4757 8.1901 63.316 8.05291C63.1563 7.91572 62.9573 7.84712 62.7189 7.84712C62.4782 7.84712 62.2758 7.91572 62.1116 8.05291C61.9497 8.1901 61.8271 8.37678 61.7439 8.61293C61.663 8.84908 61.6225 9.11784 61.6225 9.41921C61.6225 9.72058 61.663 9.98935 61.7439 10.2255C61.8271 10.4616 61.9497 10.6483 62.1116 10.7855C62.2758 10.9205 62.4782 10.9879 62.7189 10.9879ZM68.5383 12.1012C68.0075 12.1012 67.551 11.9888 67.1686 11.7638C66.7885 11.5367 66.4962 11.2218 66.2915 10.8192C66.0891 10.4167 65.9879 9.95336 65.9879 9.42933C65.9879 8.89856 66.0902 8.433 66.2949 8.03267C66.5018 7.63009 66.7953 7.31635 67.1754 7.09144C67.5555 6.86429 68.0075 6.75071 68.5316 6.75071C68.9836 6.75071 69.3795 6.8328 69.7191 6.99698C70.0587 7.16116 70.3274 7.39169 70.5253 7.68857C70.7233 7.98544 70.8323 8.33404 70.8526 8.73438H69.4964C69.4582 8.47573 69.357 8.2677 69.1928 8.11026C69.0309 7.95058 68.8183 7.87074 68.5552 7.87074C68.3325 7.87074 68.138 7.93146 67.9715 8.05291C67.8074 8.17211 67.6792 8.34641 67.587 8.57582C67.4947 8.80522 67.4486 9.08298 67.4486 9.40909C67.4486 9.7397 67.4936 10.0208 67.5836 10.2525C67.6758 10.4841 67.8051 10.6607 67.9715 10.7821C68.138 10.9036 68.3325 10.9643 68.5552 10.9643C68.7194 10.9643 68.8667 10.9306 68.9971 10.8631C69.1298 10.7956 69.2389 10.6978 69.3244 10.5696C69.4121 10.4392 69.4694 10.2828 69.4964 10.1007H70.8526C70.8301 10.4965 70.7221 10.8451 70.5287 11.1465C70.3376 11.4456 70.0733 11.6795 69.7359 11.8482C69.3986 12.0169 68.9994 12.1012 68.5383 12.1012ZM75.3791 8.83558V9.96573H72.6735V8.83558H75.3791ZM73.1458 6.81818V12H71.7727V6.81818H73.1458ZM76.2798 6.81818V12H74.9169V6.81818H76.2798ZM79.7361 12.1012C79.212 12.1012 78.7588 11.9899 78.3765 11.7672C77.9964 11.5423 77.7029 11.2297 77.496 10.8294C77.2891 10.4268 77.1856 9.96011 77.1856 9.42933C77.1856 8.89406 77.2891 8.42625 77.496 8.02592C77.7029 7.62334 77.9964 7.31072 78.3765 7.08807C78.7588 6.86316 79.212 6.75071 79.7361 6.75071C80.2601 6.75071 80.7122 6.86316 81.0922 7.08807C81.4746 7.31072 81.7692 7.62334 81.9761 8.02592C82.183 8.42625 82.2865 8.89406 82.2865 9.42933C82.2865 9.96011 82.183 10.4268 81.9761 10.8294C81.7692 11.2297 81.4746 11.5423 81.0922 11.7672C80.7122 11.9899 80.2601 12.1012 79.7361 12.1012ZM79.7428 10.9879C79.9812 10.9879 80.1802 10.9205 80.3399 10.7855C80.4996 10.6483 80.6199 10.4616 80.7009 10.2255C80.7841 9.98935 80.8257 9.72058 80.8257 9.41921C80.8257 9.11784 80.7841 8.84908 80.7009 8.61293C80.6199 8.37678 80.4996 8.1901 80.3399 8.05291C80.1802 7.91572 79.9812 7.84712 79.7428 7.84712C79.5022 7.84712 79.2997 7.91572 79.1356 8.05291C78.9736 8.1901 78.8511 8.37678 78.7678 8.61293C78.6869 8.84908 78.6464 9.11784 78.6464 9.41921C78.6464 9.72058 78.6869 9.98935 78.7678 10.2255C78.8511 10.4616 78.9736 10.6483 79.1356 10.7855C79.2997 10.9205 79.5022 10.9879 79.7428 10.9879ZM83.221 12V6.81818H85.4307C86.0694 6.81818 86.5743 6.93963 86.9454 7.18253C87.3165 7.42543 87.502 7.77066 87.502 8.21822C87.502 8.49935 87.3975 8.73325 87.1883 8.91992C86.9791 9.10659 86.689 9.23254 86.3179 9.29776C86.6283 9.32025 86.8925 9.3911 87.1107 9.5103C87.3311 9.62725 87.4987 9.77906 87.6134 9.96573C87.7303 10.1524 87.7888 10.3593 87.7888 10.5865C87.7888 10.8811 87.7101 11.1341 87.5526 11.3455C87.3975 11.5569 87.1692 11.7189 86.8678 11.8313C86.5687 11.9438 86.2032 12 85.7714 12H83.221ZM84.5603 10.9238H85.7714C85.9716 10.9238 86.1279 10.8766 86.2403 10.7821C86.355 10.6854 86.4124 10.5539 86.4124 10.3874C86.4124 10.203 86.355 10.0579 86.2403 9.95224C86.1279 9.84653 85.9716 9.79368 85.7714 9.79368H84.5603V10.9238ZM84.5603 8.95028H85.461C85.605 8.95028 85.7275 8.93004 85.8287 8.88956C85.9322 8.84683 86.0109 8.7861 86.0649 8.70739C86.1211 8.62867 86.1492 8.53533 86.1492 8.42738C86.1492 8.2677 86.0851 8.14287 85.9569 8.05291C85.8287 7.96295 85.6533 7.91797 85.4307 7.91797H84.5603V8.95028ZM88.6946 12V6.81818H90.1317V12H88.6946ZM89.4165 6.15021C89.2029 6.15021 89.0196 6.07937 88.8667 5.93768C88.716 5.79374 88.6406 5.62169 88.6406 5.42152C88.6406 5.2236 88.716 5.0538 88.8667 4.91211C89.0196 4.76817 89.2029 4.6962 89.4165 4.6962C89.6302 4.6962 89.8124 4.76817 89.9631 4.91211C90.116 5.0538 90.1925 5.2236 90.1925 5.42152C90.1925 5.62169 90.116 5.79374 89.9631 5.93768C89.8124 6.07937 89.6302 6.15021 89.4165 6.15021Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function CA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5692",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5692)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M45.6005 12V5.09091H48.3263C48.8504 5.09091 49.2968 5.19099 49.6657 5.39116C50.0345 5.58907 50.3156 5.86458 50.5091 6.21768C50.7047 6.56854 50.8026 6.97337 50.8026 7.43217C50.8026 7.89098 50.7036 8.29581 50.5057 8.64666C50.3078 8.99751 50.021 9.27077 49.6454 9.46644C49.2721 9.66211 48.82 9.75994 48.2892 9.75994H46.5518V8.58931H48.0531C48.3342 8.58931 48.5659 8.54096 48.748 8.44425C48.9325 8.34529 49.0697 8.20922 49.1596 8.03604C49.2518 7.86062 49.2979 7.65933 49.2979 7.43217C49.2979 7.20277 49.2518 7.0026 49.1596 6.83168C49.0697 6.6585 48.9325 6.52468 48.748 6.43022C48.5636 6.33351 48.3297 6.28516 48.0463 6.28516H47.0613V12H45.6005ZM53.9822 12.1012C53.4581 12.1012 53.0049 11.9899 52.6226 11.7672C52.2425 11.5423 51.949 11.2297 51.7421 10.8294C51.5352 10.4268 51.4317 9.96011 51.4317 9.42933C51.4317 8.89406 51.5352 8.42625 51.7421 8.02592C51.949 7.62334 52.2425 7.31072 52.6226 7.08807C53.0049 6.86316 53.4581 6.75071 53.9822 6.75071C54.5062 6.75071 54.9582 6.86316 55.3383 7.08807C55.7207 7.31072 56.0153 7.62334 56.2222 8.02592C56.4291 8.42625 56.5326 8.89406 56.5326 9.42933C56.5326 9.96011 56.4291 10.4268 56.2222 10.8294C56.0153 11.2297 55.7207 11.5423 55.3383 11.7672C54.9582 11.9899 54.5062 12.1012 53.9822 12.1012ZM53.9889 10.9879C54.2273 10.9879 54.4263 10.9205 54.586 10.7855C54.7457 10.6483 54.866 10.4616 54.947 10.2255C55.0302 9.98935 55.0718 9.72058 55.0718 9.41921C55.0718 9.11784 55.0302 8.84908 54.947 8.61293C54.866 8.37678 54.7457 8.1901 54.586 8.05291C54.4263 7.91572 54.2273 7.84712 53.9889 7.84712C53.7483 7.84712 53.5458 7.91572 53.3817 8.05291C53.2197 8.1901 53.0972 8.37678 53.0139 8.61293C52.933 8.84908 52.8925 9.11784 52.8925 9.41921C52.8925 9.72058 52.933 9.98935 53.0139 10.2255C53.0972 10.4616 53.2197 10.6483 53.3817 10.7855C53.5458 10.9205 53.7483 10.9879 53.9889 10.9879ZM59.8016 14.0511C59.336 14.0511 58.9368 13.987 58.604 13.8588C58.2733 13.7329 58.0102 13.5608 57.8145 13.3427C57.6189 13.1245 57.4918 12.8794 57.4333 12.6072L58.7625 12.4284C58.803 12.5319 58.8671 12.6286 58.9548 12.7186C59.0425 12.8085 59.1584 12.8805 59.3023 12.9345C59.4485 12.9907 59.6262 13.0188 59.8353 13.0188C60.1479 13.0188 60.4055 12.9424 60.6079 12.7894C60.8125 12.6387 60.9149 12.3857 60.9149 12.0304V11.0824H60.8541C60.7912 11.2263 60.6967 11.3624 60.5708 11.4906C60.4448 11.6188 60.2829 11.7234 60.085 11.8043C59.887 11.8853 59.6509 11.9258 59.3765 11.9258C58.9874 11.9258 58.6332 11.8358 58.3138 11.6559C57.9967 11.4737 57.7437 11.196 57.5548 10.8226C57.3681 10.447 57.2748 9.97248 57.2748 9.39897C57.2748 8.81197 57.3704 8.32167 57.5615 7.92809C57.7527 7.53451 58.0068 7.23988 58.324 7.04421C58.6433 6.84854 58.993 6.75071 59.3731 6.75071C59.6633 6.75071 59.9062 6.80019 60.1018 6.89915C60.2975 6.99586 60.4549 7.11731 60.5741 7.26349C60.6956 7.40743 60.7889 7.54912 60.8541 7.68857H60.9081V6.81818H62.3351V12.0506C62.3351 12.4914 62.2272 12.8603 62.0113 13.1571C61.7954 13.454 61.4962 13.6767 61.1139 13.8251C60.7338 13.9758 60.2964 14.0511 59.8016 14.0511ZM59.8319 10.8462C60.0636 10.8462 60.2593 10.7889 60.4189 10.6742C60.5809 10.5572 60.7046 10.3908 60.79 10.1749C60.8778 9.95674 60.9216 9.69585 60.9216 9.39222C60.9216 9.0886 60.8789 8.82546 60.7934 8.60281C60.7079 8.3779 60.5843 8.2036 60.4223 8.0799C60.2604 7.9562 60.0636 7.89435 59.8319 7.89435C59.5958 7.89435 59.3968 7.95845 59.2348 8.08665C59.0729 8.21259 58.9503 8.38802 58.8671 8.61293C58.7839 8.83783 58.7423 9.0976 58.7423 9.39222C58.7423 9.69135 58.7839 9.94999 58.8671 10.1681C58.9526 10.3841 59.0751 10.5516 59.2348 10.6708C59.3968 10.7878 59.5958 10.8462 59.8319 10.8462ZM64.9564 12.0978C64.6258 12.0978 64.3312 12.0405 64.0725 11.9258C63.8139 11.8088 63.6092 11.6368 63.4585 11.4096C63.3101 11.1802 63.2359 10.8946 63.2359 10.5527C63.2359 10.2649 63.2887 10.0231 63.3944 9.82741C63.5001 9.63175 63.6441 9.47431 63.8263 9.35511C64.0084 9.23591 64.2153 9.14595 64.447 9.08523C64.6809 9.0245 64.926 8.98177 65.1824 8.95703C65.4838 8.92554 65.7267 8.89631 65.9111 8.86932C66.0956 8.84008 66.2294 8.79735 66.3126 8.74112C66.3958 8.6849 66.4374 8.60168 66.4374 8.49148V8.47124C66.4374 8.25758 66.3699 8.09227 66.235 7.97532C66.1023 7.85837 65.9134 7.79989 65.6682 7.79989C65.4096 7.79989 65.2038 7.85724 65.0509 7.97195C64.8979 8.0844 64.7967 8.22609 64.7472 8.39702L63.4181 8.28906C63.4855 7.97419 63.6182 7.70206 63.8161 7.47266C64.0141 7.241 64.2693 7.06333 64.5819 6.93963C64.8968 6.81368 65.2612 6.75071 65.675 6.75071C65.9629 6.75071 66.2384 6.78445 66.5015 6.85192C66.7669 6.91939 67.0019 7.02397 67.2066 7.16566C67.4135 7.30735 67.5766 7.48952 67.6958 7.71218C67.815 7.93259 67.8746 8.19685 67.8746 8.50497V12H66.5116V11.2814H66.4711C66.3879 11.4434 66.2766 11.5862 66.1372 11.7099C65.9977 11.8313 65.8302 11.9269 65.6345 11.9966C65.4388 12.0641 65.2128 12.0978 64.9564 12.0978ZM65.368 11.106C65.5794 11.106 65.7661 11.0644 65.928 10.9812C66.0899 10.8957 66.217 10.781 66.3092 10.6371C66.4014 10.4931 66.4475 10.3301 66.4475 10.1479V9.59801C66.4026 9.62725 66.3407 9.65424 66.262 9.67898C66.1855 9.70147 66.0989 9.72283 66.0022 9.74308C65.9055 9.76107 65.8088 9.77794 65.7121 9.79368C65.6154 9.80717 65.5277 9.81954 65.449 9.83079C65.2803 9.85553 65.133 9.89489 65.007 9.94886C64.8811 10.0028 64.7832 10.0759 64.7135 10.1681C64.6438 10.2581 64.6089 10.3706 64.6089 10.5055C64.6089 10.7012 64.6798 10.8507 64.8215 10.9542C64.9654 11.0554 65.1476 11.106 65.368 11.106ZM70.4267 9.00426V12H68.9895V6.81818H70.3592V7.73242H70.4199C70.5346 7.43105 70.7269 7.19265 70.9968 7.01722C71.2667 6.83955 71.5939 6.75071 71.9785 6.75071C72.3384 6.75071 72.6521 6.82943 72.9197 6.98686C73.1874 7.14429 73.3954 7.3692 73.5439 7.66158C73.6923 7.9517 73.7665 8.29806 73.7665 8.70064V12H72.3294V8.95703C72.3316 8.63991 72.2507 8.39252 72.0865 8.21484C71.9223 8.03492 71.6963 7.94496 71.4084 7.94496C71.215 7.94496 71.044 7.98656 70.8956 8.06978C70.7494 8.15299 70.6347 8.27444 70.5515 8.43413C70.4705 8.59156 70.4289 8.78161 70.4267 9.00426ZM74.8992 6.81818H76.3363V12.2564C76.3363 12.6567 76.2576 12.9806 76.1002 13.228C75.9428 13.4754 75.7167 13.6564 75.4221 13.7711C75.1297 13.8858 74.78 13.9432 74.3729 13.9432C74.3234 13.9432 74.2762 13.9421 74.2312 13.9398C74.184 13.9398 74.1345 13.9387 74.0828 13.9364V12.813C74.121 12.8153 74.1548 12.8164 74.184 12.8164C74.211 12.8187 74.2402 12.8198 74.2717 12.8198C74.5034 12.8198 74.6653 12.7703 74.7575 12.6713C74.852 12.5746 74.8992 12.4284 74.8992 12.2328V6.81818ZM75.6144 6.15021C75.403 6.15021 75.2208 6.07937 75.0679 5.93768C74.9149 5.79374 74.8385 5.62169 74.8385 5.42152C74.8385 5.2236 74.9149 5.0538 75.0679 4.91211C75.2208 4.76817 75.403 4.6962 75.6144 4.6962C75.8303 4.6962 76.0136 4.76817 76.1643 4.91211C76.3172 5.0538 76.3937 5.2236 76.3937 5.42152C76.3937 5.62169 76.3172 5.79374 76.1643 5.93768C76.0136 6.07937 75.8303 6.15021 75.6144 6.15021ZM78.9652 12.0978C78.6346 12.0978 78.34 12.0405 78.0813 11.9258C77.8227 11.8088 77.618 11.6368 77.4673 11.4096C77.3189 11.1802 77.2447 10.8946 77.2447 10.5527C77.2447 10.2649 77.2975 10.0231 77.4032 9.82741C77.5089 9.63175 77.6529 9.47431 77.835 9.35511C78.0172 9.23591 78.2241 9.14595 78.4558 9.08523C78.6897 9.0245 78.9348 8.98177 79.1912 8.95703C79.4926 8.92554 79.7355 8.89631 79.9199 8.86932C80.1043 8.84008 80.2382 8.79735 80.3214 8.74112C80.4046 8.6849 80.4462 8.60168 80.4462 8.49148V8.47124C80.4462 8.25758 80.3787 8.09227 80.2438 7.97532C80.1111 7.85837 79.9222 7.79989 79.677 7.79989C79.4184 7.79989 79.2126 7.85724 79.0597 7.97195C78.9067 8.0844 78.8055 8.22609 78.756 8.39702L77.4268 8.28906C77.4943 7.97419 77.627 7.70206 77.8249 7.47266C78.0228 7.241 78.2781 7.06333 78.5907 6.93963C78.9056 6.81368 79.2699 6.75071 79.6838 6.75071C79.9717 6.75071 80.2472 6.78445 80.5103 6.85192C80.7757 6.91939 81.0107 7.02397 81.2154 7.16566C81.4223 7.30735 81.5853 7.48952 81.7045 7.71218C81.8237 7.93259 81.8833 8.19685 81.8833 8.50497V12H80.5204V11.2814H80.4799C80.3967 11.4434 80.2854 11.5862 80.146 11.7099C80.0065 11.8313 79.839 11.9269 79.6433 11.9966C79.4476 12.0641 79.2216 12.0978 78.9652 12.0978ZM79.3768 11.106C79.5882 11.106 79.7749 11.0644 79.9368 10.9812C80.0987 10.8957 80.2258 10.781 80.318 10.6371C80.4102 10.4931 80.4563 10.3301 80.4563 10.1479V9.59801C80.4113 9.62725 80.3495 9.65424 80.2708 9.67898C80.1943 9.70147 80.1077 9.72283 80.011 9.74308C79.9143 9.76107 79.8176 9.77794 79.7209 9.79368C79.6242 9.80717 79.5365 9.81954 79.4577 9.83079C79.2891 9.85553 79.1417 9.89489 79.0158 9.94886C78.8899 10.0028 78.792 10.0759 78.7223 10.1681C78.6526 10.2581 78.6177 10.3706 78.6177 10.5055C78.6177 10.7012 78.6886 10.8507 78.8303 10.9542C78.9742 11.0554 79.1564 11.106 79.3768 11.106ZM87.5316 14.0511C87.066 14.0511 86.6668 13.987 86.3339 13.8588C86.0033 13.7329 85.7402 13.5608 85.5445 13.3427C85.3489 13.1245 85.2218 12.8794 85.1633 12.6072L86.4925 12.4284C86.533 12.5319 86.5971 12.6286 86.6848 12.7186C86.7725 12.8085 86.8883 12.8805 87.0323 12.9345C87.1785 12.9907 87.3561 13.0188 87.5653 13.0188C87.8779 13.0188 88.1354 12.9424 88.3378 12.7894C88.5425 12.6387 88.6448 12.3857 88.6448 12.0304V11.0824H88.5841C88.5211 11.2263 88.4267 11.3624 88.3007 11.4906C88.1748 11.6188 88.0129 11.7234 87.8149 11.8043C87.617 11.8853 87.3809 11.9258 87.1065 11.9258C86.7174 11.9258 86.3632 11.8358 86.0438 11.6559C85.7267 11.4737 85.4737 11.196 85.2848 10.8226C85.0981 10.447 85.0047 9.97248 85.0047 9.39897C85.0047 8.81197 85.1003 8.32167 85.2915 7.92809C85.4827 7.53451 85.7368 7.23988 86.0539 7.04421C86.3733 6.84854 86.723 6.75071 87.1031 6.75071C87.3932 6.75071 87.6361 6.80019 87.8318 6.89915C88.0275 6.99586 88.1849 7.11731 88.3041 7.26349C88.4256 7.40743 88.5189 7.54912 88.5841 7.68857H88.6381V6.81818H90.0651V12.0506C90.0651 12.4914 89.9572 12.8603 89.7413 13.1571C89.5253 13.454 89.2262 13.6767 88.8439 13.8251C88.4638 13.9758 88.0264 14.0511 87.5316 14.0511ZM87.5619 10.8462C87.7936 10.8462 87.9892 10.7889 88.1489 10.6742C88.3109 10.5572 88.4346 10.3908 88.52 10.1749C88.6077 9.95674 88.6516 9.69585 88.6516 9.39222C88.6516 9.0886 88.6089 8.82546 88.5234 8.60281C88.4379 8.3779 88.3142 8.2036 88.1523 8.0799C87.9904 7.9562 87.7936 7.89435 87.5619 7.89435C87.3258 7.89435 87.1267 7.95845 86.9648 8.08665C86.8029 8.21259 86.6803 8.38802 86.5971 8.61293C86.5139 8.83783 86.4723 9.0976 86.4723 9.39222C86.4723 9.69135 86.5139 9.94999 86.5971 10.1681C86.6825 10.3841 86.8051 10.5516 86.9648 10.6708C87.1267 10.7878 87.3258 10.8462 87.5619 10.8462ZM92.6864 12.0978C92.3558 12.0978 92.0612 12.0405 91.8025 11.9258C91.5439 11.8088 91.3392 11.6368 91.1885 11.4096C91.0401 11.1802 90.9659 10.8946 90.9659 10.5527C90.9659 10.2649 91.0187 10.0231 91.1244 9.82741C91.2301 9.63175 91.3741 9.47431 91.5562 9.35511C91.7384 9.23591 91.9453 9.14595 92.177 9.08523C92.4109 9.0245 92.656 8.98177 92.9124 8.95703C93.2138 8.92554 93.4567 8.89631 93.6411 8.86932C93.8255 8.84008 93.9594 8.79735 94.0426 8.74112C94.1258 8.6849 94.1674 8.60168 94.1674 8.49148V8.47124C94.1674 8.25758 94.0999 8.09227 93.965 7.97532C93.8323 7.85837 93.6434 7.79989 93.3982 7.79989C93.1396 7.79989 92.9338 7.85724 92.7809 7.97195C92.6279 8.0844 92.5267 8.22609 92.4772 8.39702L91.148 8.28906C91.2155 7.97419 91.3482 7.70206 91.5461 7.47266C91.744 7.241 91.9993 7.06333 92.3119 6.93963C92.6268 6.81368 92.9911 6.75071 93.405 6.75071C93.6928 6.75071 93.9684 6.78445 94.2315 6.85192C94.4969 6.91939 94.7319 7.02397 94.9366 7.16566C95.1435 7.30735 95.3065 7.48952 95.4257 7.71218C95.5449 7.93259 95.6045 8.19685 95.6045 8.50497V12H94.2416V11.2814H94.2011C94.1179 11.4434 94.0066 11.5862 93.8671 11.7099C93.7277 11.8313 93.5601 11.9269 93.3645 11.9966C93.1688 12.0641 92.9428 12.0978 92.6864 12.0978ZM93.098 11.106C93.3094 11.106 93.496 11.0644 93.658 10.9812C93.8199 10.8957 93.947 10.781 94.0392 10.6371C94.1314 10.4931 94.1775 10.3301 94.1775 10.1479V9.59801C94.1325 9.62725 94.0707 9.65424 93.992 9.67898C93.9155 9.70147 93.8289 9.72283 93.7322 9.74308C93.6355 9.76107 93.5388 9.77794 93.4421 9.79368C93.3454 9.80717 93.2576 9.81954 93.1789 9.83079C93.0103 9.85553 92.8629 9.89489 92.737 9.94886C92.611 10.0028 92.5132 10.0759 92.4435 10.1681C92.3738 10.2581 92.3389 10.3706 92.3389 10.5055C92.3389 10.7012 92.4098 10.8507 92.5514 10.9542C92.6954 11.0554 92.8776 11.106 93.098 11.106Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function gA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5668",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5668)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M47.8025 12.1235C47.0932 12.1235 46.558 11.9652 46.197 11.6485C45.836 11.3318 45.6555 10.8695 45.6555 10.2615V9.8815C45.6555 9.62183 45.6903 9.40967 45.76 9.245C45.8297 9.074 45.9152 8.91883 46.0165 8.7795C46.1178 8.64017 46.2002 8.51667 46.2635 8.409C46.3332 8.295 46.368 8.17783 46.368 8.0575C46.368 7.9435 46.3395 7.86433 46.2825 7.82C46.2318 7.76933 46.1622 7.744 46.0735 7.744C46.0102 7.744 45.9437 7.7535 45.874 7.7725C45.8107 7.7915 45.7378 7.82 45.6555 7.858L45.4275 6.965C45.6048 6.87 45.7948 6.80667 45.9975 6.775C46.2065 6.737 46.3902 6.718 46.5485 6.718C46.8272 6.718 47.0488 6.76233 47.2135 6.851C47.3845 6.93967 47.508 7.06633 47.584 7.231C47.66 7.39567 47.698 7.592 47.698 7.82C47.698 8.01633 47.6695 8.1905 47.6125 8.3425C47.5555 8.48817 47.4827 8.64017 47.394 8.7985C47.3117 8.94417 47.2357 9.08033 47.166 9.207C47.1027 9.33367 47.071 9.51733 47.071 9.758V10.138C47.071 10.3407 47.0995 10.5085 47.1565 10.6415C47.2198 10.7682 47.3053 10.8632 47.413 10.9265C47.527 10.9835 47.66 11.012 47.812 11.012C48.059 11.012 48.2427 10.9423 48.363 10.803C48.4833 10.6573 48.5435 10.4515 48.5435 10.1855V6.794H49.959V10.2235C49.959 10.8505 49.7753 11.3255 49.408 11.6485C49.0407 11.9652 48.5055 12.1235 47.8025 12.1235ZM48.5681 6.072C48.2704 6.072 48.0361 6.02767 47.8651 5.939C47.6941 5.85033 47.5737 5.7395 47.5041 5.6065C47.4281 5.46717 47.3901 5.3215 47.3901 5.1695C47.3901 5.06183 47.4059 4.94783 47.4376 4.8275C47.4692 4.70083 47.5167 4.58367 47.5801 4.476L48.6156 4.609C48.6029 4.65333 48.5934 4.70083 48.5871 4.7515C48.5744 4.79583 48.5681 4.837 48.5681 4.875C48.5681 4.96367 48.5966 5.03333 48.6536 5.084C48.7042 5.12833 48.7929 5.1505 48.9196 5.1505H50.9621V6.072H48.5681ZM53.6336 12.1235C52.8102 12.1235 52.2117 11.9335 51.8381 11.5535C51.4707 11.1672 51.2871 10.6098 51.2871 9.8815V6.794H52.7121V9.9575C52.7121 10.2932 52.7849 10.5497 52.9306 10.727C53.0826 10.898 53.3169 10.9835 53.6336 10.9835C53.9502 10.9835 54.1814 10.898 54.3271 10.727C54.4791 10.5497 54.5551 10.2932 54.5551 9.9575V6.794H55.9801V9.8815C55.9801 10.6098 55.7932 11.1672 55.4196 11.5535C55.0522 11.9335 54.4569 12.1235 53.6336 12.1235ZM58.7711 12.095C58.4861 12.095 58.2454 12.0507 58.0491 11.962C57.8527 11.8733 57.7039 11.7403 57.6026 11.563C57.5012 11.3793 57.4506 11.1513 57.4506 10.879V6.794H58.8756V10.708C58.8756 10.8283 58.9009 10.917 58.9516 10.974C59.0086 11.031 59.0941 11.0595 59.2081 11.0595C59.2587 11.0595 59.3126 11.0532 59.3696 11.0405C59.4266 11.0278 59.4804 11.012 59.5311 10.993L59.6641 11.905C59.5437 11.9683 59.4076 12.0158 59.2556 12.0475C59.1036 12.0792 58.9421 12.095 58.7711 12.095ZM60.4531 12V8.9125C60.4531 8.18417 60.6463 7.63 61.0326 7.25C61.4189 6.86367 62.0301 6.6705 62.8661 6.6705C63.7084 6.6705 64.3164 6.86367 64.6901 7.25C65.0701 7.63 65.2601 8.18417 65.2601 8.9125V12H63.8446V8.8935C63.8446 8.55783 63.7654 8.295 63.6071 8.105C63.4551 7.90867 63.2018 7.8105 62.8471 7.8105C62.4988 7.8105 62.2454 7.90867 62.0871 8.105C61.9351 8.295 61.8591 8.55783 61.8591 8.8935V9.72L61.8876 9.7295C62.0079 9.4825 62.1504 9.321 62.3151 9.245C62.4861 9.16267 62.7173 9.1215 63.0086 9.1215H63.2271V10.1855H63.0086C62.6919 10.1855 62.4513 10.2393 62.2866 10.347C62.1219 10.4547 62.0079 10.5972 61.9446 10.7745C61.8876 10.9455 61.8591 11.1387 61.8591 11.354V12H60.4531ZM69.5587 12V8.618C69.5587 8.314 69.4764 8.0955 69.3117 7.9625C69.147 7.8295 68.8937 7.763 68.5517 7.763C68.2224 7.763 67.8994 7.81367 67.5827 7.915C67.2724 8.01 67.0032 8.124 66.7752 8.257V7.079C66.9589 6.99033 67.2185 6.90167 67.5542 6.813C67.8899 6.718 68.2794 6.6705 68.7227 6.6705C69.0457 6.6705 69.3402 6.70533 69.6062 6.775C69.8785 6.83833 70.116 6.94917 70.3187 7.1075C70.5214 7.2595 70.6765 7.46533 70.7842 7.725C70.8982 7.97833 70.9552 8.295 70.9552 8.675V12H69.5587ZM68.0007 12.095C67.456 12.095 67.0349 11.9652 66.7372 11.7055C66.4459 11.4458 66.3002 11.0817 66.3002 10.613C66.3002 10.1063 66.4807 9.701 66.8417 9.397C67.209 9.093 67.7854 8.90933 68.5707 8.846L69.7867 8.751V9.777L68.7322 9.8815C68.3522 9.9195 68.0862 9.9955 67.9342 10.1095C67.7885 10.2235 67.7157 10.3755 67.7157 10.5655C67.7157 10.7555 67.7759 10.898 67.8962 10.993C68.0229 11.088 68.1844 11.1355 68.3807 11.1355C68.4567 11.1355 68.5327 11.1292 68.6087 11.1165C68.6847 11.0975 68.7544 11.0785 68.8177 11.0595L68.9412 11.9525C68.8209 11.9968 68.6784 12.0317 68.5137 12.057C68.349 12.0823 68.178 12.095 68.0007 12.095ZM66.5247 6.072V5.4735L67.4842 5.0745H70.8757V6.072H66.5247ZM68.5197 5.4925V4.419H69.4222V5.4925H68.5197ZM69.9827 5.4925V4.419H70.8757V5.4925H69.9827ZM69.1768 3.9155V2.1485H70.4118V3.9155H69.1768ZM74.3527 12.1235C73.58 12.1235 73.0069 11.9367 72.6332 11.563C72.2595 11.183 72.0727 10.6225 72.0727 9.8815C72.0727 9.75483 72.0759 9.60283 72.0822 9.4255C72.0949 9.24183 72.1107 9.08033 72.1297 8.941H74.4097V9.8435H73.4692V9.9765C73.4692 10.2298 73.5009 10.4388 73.5642 10.6035C73.6275 10.7618 73.7225 10.879 73.8492 10.955C73.9822 11.031 74.1469 11.069 74.3432 11.069C74.5585 11.069 74.739 11.0215 74.8847 10.9265C75.0367 10.8315 75.1507 10.67 75.2267 10.442C75.309 10.214 75.3502 9.9005 75.3502 9.5015C75.3502 9.12783 75.3059 8.8175 75.2172 8.5705C75.1349 8.31717 74.9924 8.12717 74.7897 8.0005C74.5934 7.87383 74.321 7.8105 73.9727 7.8105C73.7827 7.8105 73.5864 7.83267 73.3837 7.877C73.181 7.915 72.9879 7.96567 72.8042 8.029C72.6269 8.09233 72.4717 8.162 72.3387 8.238V7.0505C72.478 6.9745 72.649 6.908 72.8517 6.851C73.0607 6.794 73.2855 6.74967 73.5262 6.718C73.7669 6.68633 74.0044 6.6705 74.2387 6.6705C74.853 6.6705 75.347 6.7845 75.7207 7.0125C76.1007 7.23417 76.3762 7.55083 76.5472 7.9625C76.7245 8.37417 76.8132 8.86183 76.8132 9.4255C76.8132 10.0018 76.7277 10.4927 76.5567 10.898C76.392 11.297 76.1292 11.601 75.7682 11.81C75.4072 12.019 74.9354 12.1235 74.3527 12.1235ZM79.6895 12.095C79.3032 12.095 78.977 12.0222 78.711 11.8765C78.4514 11.7245 78.2519 11.4997 78.1125 11.202C77.9795 10.9043 77.913 10.5402 77.913 10.1095V6.794H79.338V9.8625C79.338 10.2108 79.4077 10.4642 79.547 10.6225C79.6864 10.7808 79.889 10.86 80.155 10.86C80.4907 10.86 80.7504 10.7333 80.934 10.48C81.1177 10.2203 81.2095 9.82133 81.2095 9.283V6.794H82.6345V12H81.5515L81.3995 11.202H81.314C81.2064 11.4553 81.0195 11.6675 80.7535 11.8385C80.4939 12.0095 80.1392 12.095 79.6895 12.095ZM84.3776 7.744V6.1955C84.3776 5.8155 84.308 5.54317 84.1686 5.3785C84.0293 5.21383 83.8203 5.1315 83.5416 5.1315V4.5615L84.5011 4.1055H86.9236V5.1315H85.3276L85.3181 5.1695C85.4828 5.27083 85.6031 5.4165 85.6791 5.6065C85.7615 5.7965 85.8026 6.04667 85.8026 6.357V7.744H84.3776ZM85.6981 12.095C85.4131 12.095 85.1725 12.0507 84.9761 11.962C84.7798 11.8733 84.631 11.7403 84.5296 11.563C84.4283 11.3793 84.3776 11.1513 84.3776 10.879V6.794H85.8026V10.708C85.8026 10.8283 85.828 10.917 85.8786 10.974C85.9356 11.031 86.0211 11.0595 86.1351 11.0595C86.1858 11.0595 86.2396 11.0532 86.2966 11.0405C86.3536 11.0278 86.4075 11.012 86.4581 10.993L86.5911 11.905C86.4708 11.9683 86.3346 12.0158 86.1826 12.0475C86.0306 12.0792 85.8691 12.095 85.6981 12.095ZM89.1454 12.095C88.6324 12.095 88.2239 11.9842 87.9199 11.7625C87.6159 11.5345 87.3974 11.2242 87.2644 10.8315C87.1314 10.4325 87.0649 9.9765 87.0649 9.4635C87.0649 8.9125 87.1251 8.4565 87.2454 8.0955C87.3721 7.72817 87.5494 7.44317 87.7774 7.2405C88.0054 7.0315 88.2746 6.88583 88.5849 6.8035C88.9016 6.71483 89.2467 6.6705 89.6204 6.6705C90.1904 6.6705 90.6464 6.74967 90.9884 6.908C91.3304 7.06633 91.5774 7.29117 91.7294 7.5825C91.8877 7.87383 91.9669 8.21583 91.9669 8.6085V12H90.5419V8.7225C90.5419 8.42483 90.4691 8.2 90.3234 8.048C90.1841 7.88967 89.9497 7.8105 89.6204 7.8105C89.3987 7.8105 89.2024 7.858 89.0314 7.953C88.8667 8.04167 88.7369 8.20317 88.6419 8.4375C88.5532 8.67183 88.5089 9.0075 88.5089 9.4445C88.5089 9.74217 88.5374 10.005 88.5944 10.233C88.6514 10.461 88.7432 10.6383 88.8699 10.765C89.0029 10.8917 89.1802 10.955 89.4019 10.955C89.4716 10.955 89.5381 10.9518 89.6014 10.9455C89.6711 10.9328 89.7312 10.9202 89.7819 10.9075L89.9149 11.9715C89.8136 12.0158 89.6901 12.0475 89.5444 12.0665C89.4051 12.0855 89.2721 12.095 89.1454 12.095ZM95.4989 12.1235C94.9289 12.1235 94.4729 12.057 94.1309 11.924C93.7889 11.7847 93.5387 11.5915 93.3804 11.3445C93.2284 11.0975 93.1524 10.8125 93.1524 10.4895C93.1524 10.2108 93.1935 9.986 93.2759 9.815C93.3645 9.644 93.4754 9.51417 93.6084 9.4255C93.7477 9.3305 93.887 9.26717 94.0264 9.2355V9.1785C93.8807 9.12783 93.7414 9.05817 93.6084 8.9695C93.4754 8.88083 93.3645 8.7605 93.2759 8.6085C93.1935 8.4565 93.1524 8.2665 93.1524 8.0385C93.1524 7.80417 93.2062 7.58567 93.3139 7.383C93.4279 7.18033 93.6084 7.01883 93.8554 6.8985C94.1024 6.77183 94.4285 6.7085 94.8339 6.7085C95.0302 6.7085 95.2202 6.72433 95.4039 6.756C95.5875 6.78133 95.73 6.81933 95.8314 6.87L95.6129 7.8295C95.5622 7.81683 95.4925 7.80417 95.4039 7.7915C95.3215 7.7725 95.236 7.763 95.1474 7.763C94.951 7.763 94.8054 7.8105 94.7104 7.9055C94.6154 7.99417 94.5679 8.11133 94.5679 8.257C94.5679 8.409 94.609 8.52617 94.6914 8.6085C94.7737 8.69083 94.8782 8.74783 95.0049 8.7795C95.1379 8.81117 95.274 8.827 95.4134 8.827H95.6129V9.7105H95.4134C95.141 9.7105 94.9352 9.758 94.7959 9.853C94.6629 9.948 94.5964 10.1032 94.5964 10.3185C94.5964 10.4325 94.6217 10.5465 94.6724 10.6605C94.7294 10.7682 94.8244 10.86 94.9574 10.936C95.0904 11.0057 95.2804 11.0405 95.5274 11.0405C95.7617 11.0405 95.9454 11.0057 96.0784 10.936C96.2114 10.8663 96.3064 10.7745 96.3634 10.6605C96.4204 10.5402 96.4489 10.4072 96.4489 10.2615V6.794H97.8739V10.214C97.8739 10.8663 97.6807 11.3477 97.2944 11.658C96.9144 11.9683 96.3159 12.1235 95.4989 12.1235Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function yA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2672L76.9187 28.6218C76.563 28.7935 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5482 72.8809 27.886C72.2064 27.2176 71.8691 26.2948 71.8691 25.1175V22.0087H70.1492V19.4792H71.8691V17.0511H74.5272V19.4792H76.7991V22.0087H74.5272V24.9795C74.5272 25.4026 74.6652 25.746 74.9411 26.0096C75.2171 26.2672 75.5544 26.3959 75.9529 26.3959C76.2595 26.3959 76.5355 26.3531 76.7807 26.2672Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5644",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5644)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6223C18.5 23.663 19.1445 23.5744 19.7525 23.3618C19.9407 23.2727 20.0964 23.1273 20.1981 22.9456C20.2998 22.7639 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4149 19.6049 21.3231C18.9053 20.9275 18.1724 20.594 17.4146 20.3263C16.6485 20.0432 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7955 13.7376 18.3442C13.3015 17.912 12.9579 17.3956 12.7275 16.8265C12.4734 16.1481 12.352 15.4271 12.3701 14.7029C12.342 13.9696 12.4902 13.2404 12.8022 12.5762C13.1142 11.9121 13.5809 11.3325 14.1632 10.8859C15.3661 9.94964 17.0117 9.48338 19.0999 9.48714C20.109 9.48286 21.1161 9.57579 22.1074 9.76464C22.8795 9.90044 23.6388 10.1013 24.3772 10.3649L23.5317 14.1479C22.9242 13.9433 22.3068 13.7695 21.6818 13.6269C20.9474 13.4678 20.1974 13.3918 19.446 13.4003C17.9329 13.4003 17.1763 13.8251 17.1763 14.6746C17.1733 14.8535 17.2081 15.031 17.2784 15.1956C17.365 15.3766 17.5006 15.5296 17.6699 15.6373C17.9242 15.8092 18.1918 15.9607 18.4701 16.0903C18.8049 16.2546 19.2362 16.4358 19.7582 16.6566C20.6678 16.9693 21.5535 17.3479 22.4082 17.7893C23.0245 18.1067 23.5828 18.526 24.0594 19.0295C24.4512 19.4537 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7658 25.1546 22.4047C25.1984 23.1605 25.0446 23.9146 24.7083 24.5929C24.372 25.2711 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5808 17.8289 27.5808C16.5466 27.6072 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8037 11.9104 26.5388L12.7275 22.5746C13.5541 22.9013 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6209 17.8572 23.6223Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.0497 12H45.6005V5.09091H48.07C48.7649 5.09091 49.3632 5.22923 49.8647 5.50586C50.3662 5.78024 50.752 6.17495 51.0218 6.68999C51.294 7.20502 51.43 7.82126 51.43 8.53871C51.43 9.2584 51.294 9.87689 51.0218 10.3942C50.752 10.9115 50.364 11.3084 49.858 11.585C49.3542 11.8617 48.7514 12 48.0497 12ZM47.0613 10.7484H47.989C48.4208 10.7484 48.784 10.6719 49.0787 10.519C49.3755 10.3638 49.5982 10.1243 49.7466 9.80043C49.8973 9.47431 49.9727 9.05374 49.9727 8.53871C49.9727 8.02817 49.8973 7.61097 49.7466 7.28711C49.5982 6.96325 49.3767 6.72485 49.082 6.57191C48.7874 6.41897 48.4242 6.34251 47.9924 6.34251H47.0613V10.7484ZM52.4851 12V6.81818H53.8784V7.7223H53.9324C54.0269 7.40069 54.1854 7.15779 54.4081 6.99361C54.6307 6.82718 54.8871 6.74396 55.1772 6.74396C55.2492 6.74396 55.3268 6.74846 55.41 6.75746C55.4932 6.76645 55.5663 6.77882 55.6293 6.79457V8.06978C55.5618 8.04954 55.4685 8.03155 55.3493 8.0158C55.2301 8.00006 55.121 7.99219 55.0221 7.99219C54.8107 7.99219 54.6217 8.03829 54.4553 8.1305C54.2911 8.22047 54.1607 8.34641 54.064 8.50835C53.9695 8.67028 53.9223 8.85695 53.9223 9.06836V12H52.4851ZM58.4926 12.1012C57.9596 12.1012 57.5008 11.9933 57.1162 11.7773C56.7339 11.5592 56.4392 11.2511 56.2323 10.853C56.0254 10.4527 55.922 9.97923 55.922 9.43271C55.922 8.89968 56.0254 8.43188 56.2323 8.0293C56.4392 7.62672 56.7305 7.31297 57.1061 7.08807C57.4839 6.86316 57.927 6.75071 58.4353 6.75071C58.7771 6.75071 59.0954 6.80581 59.39 6.91602C59.6869 7.02397 59.9455 7.18703 60.1659 7.40518C60.3886 7.62334 60.5618 7.89773 60.6855 8.22834C60.8092 8.5567 60.871 8.94129 60.871 9.3821V9.77681H56.4955V8.88619H59.5182C59.5182 8.67927 59.4732 8.49598 59.3833 8.33629C59.2933 8.17661 59.1685 8.05179 59.0088 7.96183C58.8514 7.86961 58.6681 7.82351 58.4589 7.82351C58.2407 7.82351 58.0473 7.87411 57.8786 7.97532C57.7122 8.07428 57.5818 8.2081 57.4873 8.37678C57.3928 8.54321 57.3445 8.72875 57.3422 8.93342V9.78018C57.3422 10.0366 57.3895 10.2581 57.4839 10.4448C57.5806 10.6315 57.7167 10.7754 57.8921 10.8766C58.0676 10.9778 58.2756 11.0284 58.5162 11.0284C58.6759 11.0284 58.8221 11.0059 58.9548 10.9609C59.0875 10.916 59.2011 10.8485 59.2955 10.7585C59.39 10.6686 59.462 10.5584 59.5115 10.4279L60.8406 10.5156C60.7732 10.835 60.6349 11.1139 60.4257 11.3523C60.2188 11.5884 59.9511 11.7728 59.6228 11.9055C59.2967 12.036 58.92 12.1012 58.4926 12.1012ZM66.5007 6.81818L64.6891 12H63.0697L61.2581 6.81818H62.7762L63.8524 10.5257H63.9064L64.9792 6.81818H66.5007ZM69.4306 12.1012C68.8976 12.1012 68.4388 11.9933 68.0542 11.7773C67.6719 11.5592 67.3772 11.2511 67.1703 10.853C66.9634 10.4527 66.86 9.97923 66.86 9.43271C66.86 8.89968 66.9634 8.43188 67.1703 8.0293C67.3772 7.62672 67.6685 7.31297 68.0441 7.08807C68.4219 6.86316 68.865 6.75071 69.3733 6.75071C69.7151 6.75071 70.0334 6.80581 70.328 6.91602C70.6249 7.02397 70.8835 7.18703 71.1039 7.40518C71.3266 7.62334 71.4997 7.89773 71.6234 8.22834C71.7471 8.5567 71.809 8.94129 71.809 9.3821V9.77681H67.4335V8.88619H70.4562C70.4562 8.67927 70.4112 8.49598 70.3212 8.33629C70.2313 8.17661 70.1065 8.05179 69.9468 7.96183C69.7893 7.86961 69.606 7.82351 69.3969 7.82351C69.1787 7.82351 68.9853 7.87411 68.8166 7.97532C68.6502 8.07428 68.5198 8.2081 68.4253 8.37678C68.3308 8.54321 68.2825 8.72875 68.2802 8.93342V9.78018C68.2802 10.0366 68.3275 10.2581 68.4219 10.4448C68.5186 10.6315 68.6547 10.7754 68.8301 10.8766C69.0055 10.9778 69.2136 11.0284 69.4542 11.0284C69.6139 11.0284 69.7601 11.0059 69.8928 10.9609C70.0255 10.916 70.1391 10.8485 70.2335 10.7585C70.328 10.6686 70.4 10.5584 70.4494 10.4279L71.7786 10.5156C71.7112 10.835 71.5728 11.1139 71.3637 11.3523C71.1568 11.5884 70.8891 11.7728 70.5608 11.9055C70.2347 12.036 69.8579 12.1012 69.4306 12.1012ZM75.5031 6.81818V7.89773H72.3825V6.81818H75.5031ZM73.091 5.5767H74.5281V10.4077C74.5281 10.5404 74.5483 10.6438 74.5888 10.718C74.6293 10.79 74.6855 10.8406 74.7575 10.8699C74.8317 10.8991 74.9172 10.9137 75.0139 10.9137C75.0814 10.9137 75.1488 10.9081 75.2163 10.8968C75.2838 10.8833 75.3355 10.8732 75.3715 10.8665L75.5975 11.9359C75.5256 11.9584 75.4243 11.9843 75.2939 12.0135C75.1635 12.045 75.0049 12.0641 74.8182 12.0708C74.4719 12.0843 74.1682 12.0382 73.9074 11.9325C73.6487 11.8268 73.4474 11.6626 73.3035 11.44C73.1595 11.2173 73.0887 10.9362 73.091 10.5966V5.5767ZM80.1156 12.0978C79.785 12.0978 79.4904 12.0405 79.2317 11.9258C78.9731 11.8088 78.7684 11.6368 78.6177 11.4096C78.4693 11.1802 78.3951 10.8946 78.3951 10.5527C78.3951 10.2649 78.4479 10.0231 78.5536 9.82741C78.6593 9.63175 78.8033 9.47431 78.9854 9.35511C79.1676 9.23591 79.3745 9.14595 79.6062 9.08523C79.8401 9.0245 80.0852 8.98177 80.3416 8.95703C80.643 8.92554 80.8859 8.89631 81.0703 8.86932C81.2547 8.84008 81.3886 8.79735 81.4718 8.74112C81.555 8.6849 81.5966 8.60168 81.5966 8.49148V8.47124C81.5966 8.25758 81.5291 8.09227 81.3942 7.97532C81.2615 7.85837 81.0726 7.79989 80.8274 7.79989C80.5688 7.79989 80.363 7.85724 80.21 7.97195C80.0571 8.0844 79.9559 8.22609 79.9064 8.39702L78.5772 8.28906C78.6447 7.97419 78.7774 7.70206 78.9753 7.47266C79.1732 7.241 79.4285 7.06333 79.7411 6.93963C80.056 6.81368 80.4203 6.75071 80.8342 6.75071C81.122 6.75071 81.3975 6.78445 81.6607 6.85192C81.9261 6.91939 82.1611 7.02397 82.3658 7.16566C82.5727 7.30735 82.7357 7.48952 82.8549 7.71218C82.9741 7.93259 83.0337 8.19685 83.0337 8.50497V12H81.6708V11.2814H81.6303C81.5471 11.4434 81.4358 11.5862 81.2963 11.7099C81.1569 11.8313 80.9893 11.9269 80.7937 11.9966C80.598 12.0641 80.372 12.0978 80.1156 12.0978ZM80.5272 11.106C80.7386 11.106 80.9252 11.0644 81.0872 10.9812C81.2491 10.8957 81.3762 10.781 81.4684 10.6371C81.5606 10.4931 81.6067 10.3301 81.6067 10.1479V9.59801C81.5617 9.62725 81.4999 9.65424 81.4212 9.67898C81.3447 9.70147 81.2581 9.72283 81.1614 9.74308C81.0647 9.76107 80.968 9.77794 80.8713 9.79368C80.7746 9.80717 80.6868 9.81954 80.6081 9.83079C80.4395 9.85553 80.2921 9.89489 80.1662 9.94886C80.0402 10.0028 79.9424 10.0759 79.8727 10.1681C79.803 10.2581 79.7681 10.3706 79.7681 10.5055C79.7681 10.7012 79.839 10.8507 79.9806 10.9542C80.1246 11.0554 80.3068 11.106 80.5272 11.106ZM88.7941 6.81818L86.9825 12H85.3632L83.5516 6.81818H85.0697L86.1459 10.5257H86.1998L87.2726 6.81818H88.7941Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function vA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2673L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5483 72.8809 27.8861C72.2064 27.2177 71.8691 26.2949 71.8691 25.1176V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4027 74.6652 25.7461 74.9411 26.0097C75.2171 26.2673 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5764",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5764)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7638 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M50.111 7.155V12H48.781V10.404C48.4295 10.5655 48.021 10.6605 47.622 10.6605C46.2825 10.6605 45.627 9.986 45.627 8.675V7.155H45V6.091H50.985V7.155H50.111ZM48.781 7.155H46.9475V8.656C46.9475 9.3305 47.204 9.5965 47.717 9.5965C48.116 9.5965 48.5055 9.378 48.781 9.1215V7.155ZM52.9062 7.155V12H51.5762V7.155H50.8447V6.091H53.7802V7.155H52.9062ZM59.5082 7.155H58.6342V12H57.3137V10.8505C56.9717 11.0405 56.5442 11.1545 56.0407 11.1545C54.7867 11.1545 53.9697 10.537 53.9697 9.416C53.9697 8.3235 54.7487 7.7345 56.0217 7.7345C56.4112 7.7345 56.7437 7.7725 57.0192 7.839L56.9147 8.8745C56.7057 8.827 56.4777 8.7985 56.2117 8.7985C55.6417 8.7985 55.2997 9.036 55.2997 9.454C55.2997 9.8435 55.6037 10.081 56.1167 10.081C56.5917 10.081 57.0477 9.853 57.3137 9.492V7.155H53.6372V6.091H59.5082V7.155ZM62.3821 10.1665C62.0686 10.1665 61.6981 10.2235 61.3751 10.309C60.7196 9.9575 60.2066 9.473 60.2066 8.846C60.2066 8.0955 60.7101 7.706 61.7836 7.706H62.7146V7.155H59.2661V6.091H64.9091V7.155H64.0256V8.6085H62.0021C61.6506 8.6085 61.5081 8.732 61.5081 8.9505C61.5081 9.0835 61.6031 9.2165 61.7266 9.3115C62.0116 9.2545 62.3536 9.1975 62.7526 9.1975C63.9306 9.1975 64.4531 9.739 64.4531 10.556C64.4531 11.392 63.8831 12.0475 62.3441 12.0475C61.2041 12.0475 60.3016 11.6865 59.4561 11.031L60.0356 10.081C60.7481 10.6985 61.4606 11.031 62.2396 11.031C62.8476 11.031 63.1041 10.86 63.1041 10.575C63.1041 10.3185 62.9331 10.1665 62.3821 10.1665ZM62.6228 6.1575C62.2618 5.806 62.0243 5.3595 62.0243 4.856C62.0243 3.944 62.7083 3.488 63.7153 3.488C64.1333 3.488 64.5418 3.564 64.8173 3.697L64.5798 4.5615C64.3708 4.4855 64.1998 4.4475 63.9908 4.4475C63.5443 4.4475 63.2973 4.6945 63.2973 5.103C63.2973 5.4735 63.4968 5.844 63.8483 6.1575H62.6228ZM73.0008 7.155H72.1268V12H70.8063V10.879C70.4263 11.0785 69.9798 11.183 69.4288 11.183C68.1273 11.183 67.3198 10.5085 67.3198 9.4255C67.3198 8.2855 68.1558 7.6965 69.4478 7.6965C69.8563 7.6965 70.1983 7.7345 70.5118 7.8105L70.4073 8.7795C70.1888 8.732 69.9228 8.694 69.6188 8.694C69.5998 8.694 69.5713 8.694 69.5428 8.694L70.4738 9.872C70.5973 9.7865 70.7113 9.6915 70.8063 9.5965V7.155H66.9873V6.091H73.0008V7.155ZM68.5643 9.4635C68.5643 9.9575 68.9253 10.1855 69.4763 10.1855C69.5808 10.1855 69.6853 10.176 69.7803 10.157L68.8018 8.922C68.6498 9.0455 68.5643 9.226 68.5643 9.4635ZM74.9306 7.155V12H73.6006V7.155H72.8691V6.091H75.8046V7.155H74.9306ZM81.8366 6.091V7.155H80.9531V12H79.6326V10.651C79.2811 10.8505 78.8726 10.9645 78.3596 10.9645C76.9821 10.9645 76.1651 10.1665 75.8611 8.5895C76.7636 8.4375 77.1531 8.1905 77.1531 7.763C77.1531 7.5255 77.0581 7.326 76.8871 7.155H75.6616V6.091H81.8366ZM77.3621 9.2165C77.5236 9.6535 77.8371 9.9005 78.3691 9.9005C78.8726 9.9005 79.3001 9.663 79.6326 9.321V7.155H78.2171C78.3881 7.4115 78.4736 7.6775 78.4736 7.9625C78.4736 8.6085 78.0936 8.9695 77.3621 9.2165Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function bA(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 19.2953C129.867 19.2953 130.496 19.4179 131.084 19.6633C131.679 19.9085 132.188 20.2458 132.611 20.6749C133.04 21.0981 133.378 21.6101 133.623 22.211C133.874 22.8058 134 23.4404 134 24.1149C134 25.0163 133.789 25.8349 133.365 26.5707C132.948 27.3066 132.372 27.8829 131.636 28.2999C130.906 28.7107 130.094 28.9161 129.199 28.9161C127.831 28.9161 126.688 28.4593 125.768 27.5456C124.848 26.6321 124.388 25.4884 124.388 24.1149C124.388 22.7414 124.848 21.5948 125.768 20.6749C126.688 19.7552 127.831 19.2953 129.199 19.2953ZM129.199 21.8339C128.567 21.8339 128.04 22.0516 127.617 22.4869C127.2 22.9162 126.991 23.4588 126.991 24.1149C126.991 24.7526 127.2 25.2892 127.617 25.7245C128.04 26.1599 128.567 26.3775 129.199 26.3775C129.818 26.3775 130.339 26.1599 130.762 25.7245C131.185 25.2892 131.397 24.7526 131.397 24.1149C131.397 23.4588 131.185 22.9162 130.762 22.4869C130.345 22.0516 129.824 21.8339 129.199 21.8339Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 15.4783C120.742 15.1594 121.123 15 121.565 15C122.006 15 122.386 15.1594 122.705 15.4783C123.024 15.791 123.183 16.165 123.183 16.6004C123.183 17.0419 123.024 17.4221 122.705 17.7409C122.386 18.0598 122.006 18.2192 121.565 18.2192C121.123 18.2192 120.742 18.0598 120.423 17.7409C120.105 17.4221 119.945 17.0419 119.945 16.6004C119.945 16.165 120.105 15.791 120.423 15.4783ZM120.239 19.4793H122.898V28.7322H120.239V19.4793Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 28.9161C116.129 28.9161 115.721 28.7537 115.383 28.4287C115.052 28.0976 114.887 27.6959 114.887 27.2238C114.887 26.7578 115.052 26.3623 115.383 26.0372C115.721 25.7122 116.129 25.5498 116.607 25.5498C117.091 25.5498 117.499 25.7122 117.83 26.0372C118.167 26.3561 118.336 26.7516 118.336 27.2238C118.336 27.6959 118.167 28.0976 117.83 28.4287C117.499 28.7537 117.091 28.9161 116.607 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 23.701C113.571 24.0751 113.547 24.4215 113.498 24.7404H106.848C106.97 25.3658 107.238 25.8441 107.648 26.1752C108.059 26.5002 108.583 26.6627 109.221 26.6627C109.638 26.6627 110.036 26.5738 110.417 26.3959C110.803 26.2181 111.076 25.9912 111.235 25.7153L113.305 26.9846C112.968 27.5978 112.434 28.073 111.704 28.4103C110.975 28.7475 110.128 28.9161 109.166 28.9161C107.804 28.9161 106.652 28.4501 105.707 27.5181C104.769 26.5799 104.3 25.4271 104.3 24.0597C104.3 22.7169 104.763 21.5886 105.689 20.6749C106.621 19.7552 107.761 19.2953 109.11 19.2953C110.362 19.2953 111.416 19.7215 112.274 20.5738C113.139 21.4261 113.571 22.4685 113.571 23.701ZM106.885 23.048H110.913C110.858 22.5881 110.643 22.2049 110.27 21.8983C109.895 21.5917 109.463 21.4384 108.973 21.4384C108.421 21.4384 107.967 21.5794 107.611 21.8615C107.256 22.1436 107.014 22.5391 106.885 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 19.2953C100.164 19.2953 101.071 19.6325 101.771 20.307C102.476 20.9816 102.828 21.8738 102.828 22.9836V28.7322H100.152V23.609C100.152 23.0633 100.008 22.631 99.7195 22.3122C99.4312 21.9933 99.0479 21.8339 98.5698 21.8339C98.0981 21.8339 97.6989 21.9903 97.3743 22.303C97.0556 22.6096 96.8962 23.0449 96.8962 23.609V28.7322H94.238V23.609C94.238 23.0633 94.0938 22.631 93.8055 22.3122C93.5171 21.9933 93.1281 21.8339 92.6376 21.8339C92.1717 21.8339 91.782 21.9872 91.4697 22.2938C91.1567 22.6004 91.0002 23.0388 91.0002 23.609V28.7322H88.342V19.4792H91.0002V20.5922C91.595 19.7276 92.4753 19.2953 93.6403 19.2953C94.8603 19.2953 95.7341 19.746 96.2615 20.6474C96.5375 20.2427 96.9266 19.9177 97.4294 19.6725C97.9322 19.421 98.472 19.2953 99.0479 19.2953Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 23.701C86.8614 24.0751 86.8368 24.4215 86.7878 24.7404H80.1379C80.2605 25.3658 80.5272 25.8441 80.9381 26.1752C81.3488 26.5002 81.8732 26.6627 82.5109 26.6627C82.9278 26.6627 83.3264 26.5738 83.7066 26.3959C84.0929 26.2181 84.3657 25.9912 84.5251 25.7153L86.5946 26.9846C86.2574 27.5978 85.7239 28.073 84.9942 28.4103C84.2645 28.7475 83.4184 28.9161 82.4557 28.9161C81.0944 28.9161 79.9416 28.4501 78.9974 27.5181C78.0591 26.5799 77.5901 25.4271 77.5901 24.0597C77.5901 22.7169 78.053 21.5886 78.9789 20.6749C79.9109 19.7552 81.0515 19.2953 82.4005 19.2953C83.6514 19.2953 84.706 19.7215 85.5645 20.5738C86.4291 21.4261 86.8614 22.4685 86.8614 23.701ZM80.1747 23.048H84.2032C84.148 22.5881 83.9334 22.2049 83.5594 21.8983C83.1854 21.5917 82.7531 21.4384 82.2625 21.4384C81.7107 21.4384 81.2569 21.5794 80.9013 21.8615C80.5456 22.1436 80.3034 22.5391 80.1747 23.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 26.2673L76.9187 28.6219C76.563 28.7936 76.1092 28.8794 75.5574 28.8794C74.4537 28.8794 73.5615 28.5483 72.8809 27.8861C72.2064 27.2177 71.8691 26.2949 71.8691 25.1176V22.0087H70.1492V19.4793H71.8691V17.0511H74.5272V19.4793H76.7991V22.0087H74.5272V24.9795C74.5272 25.4027 74.6652 25.7461 74.9411 26.0097C75.2171 26.2673 75.5544 26.396 75.9529 26.396C76.2595 26.396 76.5355 26.3531 76.7807 26.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 28.9161C64.3484 28.9161 62.9657 28.5298 61.8804 27.7572L62.6714 25.9085C63.5421 26.5584 64.5845 26.8835 65.7986 26.8835C66.2094 26.8835 66.5374 26.8129 66.7827 26.6719C67.0341 26.5308 67.1598 26.3499 67.1598 26.1293C67.1598 25.9391 67.0648 25.7828 66.8747 25.6601C66.6907 25.5314 66.4517 25.4302 66.1573 25.3566C65.863 25.283 65.538 25.2094 65.1823 25.1359C64.8267 25.0561 64.471 24.955 64.1154 24.8323C63.7598 24.7036 63.4348 24.5472 63.1404 24.3633C62.8461 24.1732 62.6039 23.9095 62.4138 23.5723C62.2299 23.2289 62.1348 22.8272 62.1287 22.3674C62.1164 21.4967 62.4598 20.767 63.1588 20.1783C63.8579 19.5897 64.75 19.2953 65.8354 19.2953C67.3009 19.2953 68.4751 19.6479 69.3581 20.3531L68.6039 22.2754C68.2359 21.9995 67.7853 21.7695 67.2519 21.5856C66.7245 21.4016 66.2155 21.3096 65.725 21.3096C65.3877 21.3096 65.1149 21.3801 64.9064 21.5212C64.6979 21.6622 64.5937 21.837 64.5937 22.0454C64.5937 22.2049 64.6673 22.3459 64.8144 22.4685C64.9616 22.585 65.1517 22.6801 65.3847 22.7537C65.6238 22.8272 65.8936 22.91 66.1941 23.002C66.5007 23.0878 66.8104 23.1737 67.123 23.2595C67.4358 23.3454 67.7423 23.465 68.0428 23.6182C68.3494 23.7715 68.6223 23.9463 68.8614 24.1425C69.1006 24.3326 69.2937 24.584 69.4408 24.8967C69.5942 25.2094 69.6738 25.5651 69.68 25.9636C69.68 26.8221 69.3367 27.5304 68.6498 28.0884C67.9693 28.6402 67.0954 28.9161 66.0285 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 19.4792H61.9724L56.831 31.8043H53.9888L55.6996 27.978L52.1401 19.4792H55.0098L57.0608 24.8875L59.112 19.4792Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 28.9161C46.4681 28.9161 45.0853 28.5298 44 27.7572L44.791 25.9085C45.6617 26.5584 46.7041 26.8835 47.9182 26.8835C48.3291 26.8835 48.6571 26.8129 48.9024 26.6719C49.1538 26.5308 49.2795 26.3499 49.2795 26.1293C49.2795 25.9391 49.1844 25.7828 48.9944 25.6601C48.8104 25.5314 48.5713 25.4302 48.2769 25.3566C47.9826 25.283 47.6576 25.2094 47.302 25.1359C46.9463 25.0561 46.5907 24.955 46.2351 24.8323C45.8794 24.7036 45.5544 24.5472 45.2601 24.3633C44.9658 24.1732 44.7236 23.9095 44.5334 23.5723C44.3495 23.2289 44.2544 22.8272 44.2484 22.3674C44.236 21.4967 44.5795 20.767 45.2784 20.1783C45.9775 19.5897 46.8697 19.2953 47.955 19.2953C49.4205 19.2953 50.5947 19.6479 51.4777 20.3531L50.7235 22.2754C50.3556 21.9995 49.9049 21.7695 49.3715 21.5856C48.8441 21.4016 48.3352 21.3096 47.8446 21.3096C47.5074 21.3096 47.2345 21.3801 47.0261 21.5212C46.8176 21.6622 46.7133 21.837 46.7133 22.0454C46.7133 22.2049 46.7869 22.3459 46.9341 22.4685C47.0812 22.585 47.2713 22.6801 47.5043 22.7537C47.7435 22.8272 48.0133 22.91 48.3137 23.002C48.6203 23.0878 48.93 23.1737 49.2427 23.2595C49.5554 23.3454 49.862 23.465 50.1625 23.6182C50.469 23.7715 50.7419 23.9463 50.981 24.1425C51.2202 24.3326 51.4133 24.584 51.5605 24.8967C51.7138 25.2094 51.7936 25.5651 51.7996 25.9636C51.7996 26.8221 51.4563 27.5304 50.7696 28.0884C50.0889 28.6402 49.2151 28.9161 48.1482 28.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5572",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5572)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7638 20.3424 22.5551 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9609 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.8501 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M44.5057 5.18182H46.0227L47.625 9.09091H47.6932L49.2955 5.18182H50.8125V11H49.6193V7.21307H49.571L48.0653 10.9716H47.2528L45.7472 7.19886H45.6989V11H44.5057V5.18182ZM53.3459 8.71307H54.2237V9.17614H53.6044C53.4624 9.17614 53.3288 9.19508 53.2038 9.23295C53.0788 9.26894 52.9775 9.32576 52.8999 9.40341C52.8222 9.47917 52.7824 9.5767 52.7805 9.69602C52.7843 9.8286 52.8563 9.94508 52.9964 10.0455C53.1366 10.1439 53.3374 10.1932 53.5987 10.1932C53.8696 10.1932 54.0713 10.1553 54.2038 10.0795C54.3364 10.0019 54.4131 9.8892 54.4339 9.74148H55.5874C55.5798 9.96117 55.522 10.1544 55.4141 10.321C55.308 10.4877 55.166 10.6278 54.9879 10.7415C54.8099 10.8532 54.6072 10.9375 54.38 10.9943C54.1527 11.0511 53.9131 11.0795 53.6612 11.0795C53.2805 11.0795 52.9358 11.0284 52.6271 10.9261C52.3203 10.822 52.0769 10.6752 51.897 10.4858C51.719 10.2964 51.629 10.072 51.6271 9.8125C51.629 9.6572 51.6631 9.51326 51.7294 9.38068C51.7957 9.24811 51.898 9.13163 52.0362 9.03125C52.1745 8.93087 52.3516 8.85322 52.5675 8.7983C52.7853 8.74148 53.0447 8.71307 53.3459 8.71307ZM54.2237 8.88068H53.3459C53.0656 8.88068 52.8222 8.85227 52.6158 8.79545C52.4093 8.73674 52.2379 8.65814 52.1016 8.55966C51.9671 8.46117 51.8667 8.34943 51.8004 8.22443C51.7341 8.09754 51.701 7.9678 51.701 7.83523C51.701 7.56629 51.7853 7.33902 51.9538 7.15341C52.1224 6.96591 52.3535 6.82386 52.647 6.72727C52.9406 6.62879 53.2768 6.57955 53.6555 6.57955C53.9983 6.57955 54.308 6.63163 54.5845 6.7358C54.8629 6.83807 55.0855 6.98674 55.2521 7.18182C55.4188 7.375 55.5088 7.60795 55.522 7.88068H54.3544C54.3374 7.73864 54.2597 7.63352 54.1214 7.56534C53.9851 7.49527 53.8099 7.46023 53.5959 7.46023C53.3554 7.46023 53.1726 7.50758 53.0476 7.60227C52.9245 7.69697 52.862 7.80682 52.8601 7.93182C52.862 8.0625 52.9283 8.16761 53.0589 8.24716C53.1896 8.32481 53.3714 8.36364 53.6044 8.36364H54.2237V8.88068ZM61.9588 6.63636V7.58239H58.0043V6.63636H61.9588ZM59.3423 6.63636H60.5156V9.67614C60.5156 9.79167 60.5308 9.88163 60.5611 9.94602C60.5933 10.0085 60.6378 10.053 60.6946 10.0795C60.7514 10.1042 60.8177 10.1165 60.8935 10.1165C60.9825 10.1165 61.0545 10.1108 61.1094 10.0994C61.1643 10.0881 61.223 10.0748 61.2855 10.0597L61.4077 10.9545C61.2865 11.0038 61.1681 11.0369 61.0526 11.054C60.9389 11.071 60.8063 11.0795 60.6548 11.0795C60.2401 11.0795 59.9171 10.964 59.6861 10.733C59.4569 10.5 59.3423 10.1458 59.3423 9.67045V6.63636ZM63.9119 8.47727V11H62.7017V6.63636H63.8551V7.40625H63.9062C64.0047 7.15057 64.1676 6.94886 64.3949 6.80114C64.6222 6.65341 64.8968 6.57955 65.2188 6.57955C65.5237 6.57955 65.7888 6.64583 66.0142 6.77841C66.2396 6.91098 66.4138 7.09943 66.5369 7.34375C66.6619 7.58807 66.7244 7.88068 66.7244 8.22159V12.6364H65.5142V8.4375C65.5142 8.17045 65.446 7.96212 65.3097 7.8125C65.1733 7.66098 64.983 7.58523 64.7386 7.58523C64.5777 7.58523 64.4347 7.62027 64.3097 7.69034C64.1847 7.76042 64.0871 7.86269 64.017 7.99716C63.947 8.12973 63.9119 8.28977 63.9119 8.47727ZM69.0334 11L67.3942 6.63636H68.6442L69.7095 9.8125H69.755C69.9273 9.5303 70.0703 9.26515 70.1839 9.01705C70.2976 8.76894 70.3875 8.52273 70.4538 8.27841C70.5201 8.03409 70.5703 7.77936 70.6044 7.5142C70.6385 7.24716 70.6631 6.95455 70.6783 6.63636H71.8544C71.8393 7.4053 71.6896 8.16477 71.4055 8.91477C71.1233 9.66477 70.7171 10.3598 70.1868 11H69.0334ZM74.608 6.63636H75.7841V9.38636C75.7841 9.57576 75.8068 9.72443 75.8523 9.83239C75.8996 9.94034 75.9621 10.017 76.0398 10.0625C76.1193 10.108 76.2045 10.1307 76.2955 10.1307C76.4811 10.1307 76.6402 10.0653 76.7727 9.93466C76.9072 9.80398 77.0104 9.63636 77.0824 9.43182C77.1563 9.22538 77.1932 9.00947 77.1932 8.78409C77.1875 8.55303 77.1657 8.31345 77.1278 8.06534C77.0919 7.81534 77.0436 7.56913 76.983 7.3267C76.9242 7.08239 76.857 6.85227 76.7812 6.63636H77.8949C77.9763 6.79545 78.0511 6.98958 78.1193 7.21875C78.1894 7.44792 78.2453 7.69697 78.2869 7.96591C78.3286 8.23485 78.3494 8.50758 78.3494 8.78409C78.3494 9.10606 78.3106 9.40625 78.233 9.68466C78.1572 9.96307 78.0379 10.2064 77.875 10.4148C77.7121 10.6231 77.5028 10.786 77.2472 10.9034C76.9934 11.0208 76.6884 11.0795 76.3324 11.0795C75.8134 11.0795 75.3958 10.9432 75.0795 10.6705C74.7652 10.3958 74.608 9.96402 74.608 9.375V6.63636ZM84.2081 6.63636V7.52841H79.3445V6.63636H84.2081ZM81.2223 6.63636V11H80.0462V6.63636H81.2223ZM82.3331 6.63636H83.5007V9.63352C83.5026 9.74905 83.5206 9.83902 83.5547 9.90341C83.5888 9.96591 83.6399 10.0095 83.7081 10.0341C83.7763 10.0587 83.8615 10.071 83.9638 10.071C84.0301 10.071 84.0926 10.0682 84.1513 10.0625C84.21 10.0568 84.2611 10.0521 84.3047 10.0483V10.9375C84.2043 10.9697 84.0935 10.9962 83.9723 11.017C83.853 11.0398 83.7223 11.0511 83.5803 11.0511C83.1996 11.0511 82.8965 10.9527 82.6712 10.7557C82.4477 10.5587 82.335 10.233 82.3331 9.77841V6.63636ZM87.2592 11.0852C86.8179 11.0852 86.4363 10.9915 86.1143 10.804C85.7943 10.6146 85.5471 10.3513 85.3729 10.0142C85.1986 9.67519 85.1115 9.2822 85.1115 8.83523C85.1115 8.38447 85.1986 7.99053 85.3729 7.65341C85.5471 7.31439 85.7943 7.05114 86.1143 6.86364C86.4363 6.67424 86.8179 6.57955 87.2592 6.57955C87.7005 6.57955 88.0812 6.67424 88.4013 6.86364C88.7232 7.05114 88.9714 7.31439 89.1456 7.65341C89.3198 7.99053 89.407 8.38447 89.407 8.83523C89.407 9.2822 89.3198 9.67519 89.1456 10.0142C88.9714 10.3513 88.7232 10.6146 88.4013 10.804C88.0812 10.9915 87.7005 11.0852 87.2592 11.0852ZM87.2649 10.1477C87.4657 10.1477 87.6333 10.0909 87.7678 9.97727C87.9022 9.86174 88.0036 9.70455 88.0717 9.50568C88.1418 9.30682 88.1768 9.08049 88.1768 8.8267C88.1768 8.57292 88.1418 8.34659 88.0717 8.14773C88.0036 7.94886 87.9022 7.79167 87.7678 7.67614C87.6333 7.56061 87.4657 7.50284 87.2649 7.50284C87.0623 7.50284 86.8918 7.56061 86.7536 7.67614C86.6172 7.79167 86.514 7.94886 86.4439 8.14773C86.3757 8.34659 86.3416 8.57292 86.3416 8.8267C86.3416 9.08049 86.3757 9.30682 86.4439 9.50568C86.514 9.70455 86.6172 9.86174 86.7536 9.97727C86.8918 10.0909 87.0623 10.1477 87.2649 10.1477ZM90.2109 8.93182V8.84091C90.2128 8.44886 90.2933 8.09659 90.4524 7.78409C90.6115 7.47159 90.8435 7.22538 91.1484 7.04545C91.4534 6.86364 91.8265 6.77273 92.2678 6.77273C92.3303 6.80682 92.389 6.86742 92.4439 6.95455C92.5007 7.03977 92.5746 7.12784 92.6655 7.21875C92.7564 7.30777 92.8833 7.37784 93.0462 7.42898C93.2526 7.49716 93.4486 7.6089 93.6342 7.7642C93.8217 7.91951 93.9742 8.10511 94.0916 8.32102C94.2109 8.53504 94.2696 8.76515 94.2678 9.01136V9.09091C94.2696 9.46402 94.192 9.80114 94.0348 10.1023C93.8795 10.4015 93.6541 10.6392 93.3587 10.8153C93.0632 10.9915 92.7034 11.0795 92.2791 11.0795C91.8378 11.0795 91.4628 10.9858 91.1541 10.7983C90.8473 10.6089 90.6134 10.3523 90.4524 10.0284C90.2933 9.70455 90.2128 9.33902 90.2109 8.93182ZM91.4098 8.84091V8.93182C91.4117 9.15152 91.4392 9.35227 91.4922 9.53409C91.5471 9.71591 91.6371 9.8608 91.7621 9.96875C91.889 10.0748 92.0613 10.1278 92.2791 10.1278C92.4761 10.1278 92.6314 10.0748 92.745 9.96875C92.8606 9.8608 92.9429 9.71591 92.9922 9.53409C93.0433 9.35227 93.0689 9.15152 93.0689 8.93182V8.84091C93.0689 8.64015 93.0433 8.45549 92.9922 8.28693C92.9429 8.11648 92.8596 7.98011 92.7422 7.87784C92.6267 7.77557 92.4685 7.72443 92.2678 7.72443C92.0594 7.72443 91.8928 7.77557 91.7678 7.87784C91.6428 7.98011 91.5518 8.11648 91.495 8.28693C91.4401 8.45549 91.4117 8.64015 91.4098 8.84091ZM94.5774 6.77273V7.72443H92.2678V6.77273H94.5774ZM99.3026 6.63636V7.58239H95.348V6.63636H99.3026ZM96.6861 6.63636H97.8594V9.67614C97.8594 9.79167 97.8745 9.88163 97.9048 9.94602C97.937 10.0085 97.9815 10.053 98.0384 10.0795C98.0952 10.1042 98.1615 10.1165 98.2372 10.1165C98.3262 10.1165 98.3982 10.1108 98.4531 10.0994C98.508 10.0881 98.5668 10.0748 98.6293 10.0597L98.7514 10.9545C98.6302 11.0038 98.5118 11.0369 98.3963 11.054C98.2827 11.071 98.1501 11.0795 97.9986 11.0795C97.5838 11.0795 97.2609 10.964 97.0298 10.733C96.8007 10.5 96.6861 10.1458 96.6861 9.67045V6.63636ZM101.256 8.47727V11H100.045V6.63636H101.199V7.40625H101.25C101.348 7.15057 101.511 6.94886 101.739 6.80114C101.966 6.65341 102.241 6.57955 102.562 6.57955C102.867 6.57955 103.133 6.64583 103.358 6.77841C103.583 6.91098 103.758 7.09943 103.881 7.34375C104.006 7.58807 104.068 7.88068 104.068 8.22159V12.6364H102.858V8.4375C102.858 8.17045 102.79 7.96212 102.653 7.8125C102.517 7.66098 102.327 7.58523 102.082 7.58523C101.921 7.58523 101.778 7.62027 101.653 7.69034C101.528 7.76042 101.431 7.86269 101.361 7.99716C101.291 8.12973 101.256 8.28977 101.256 8.47727ZM101.682 6.06534L101.986 4.71591H103.068L102.395 6.06534H101.682ZM105.011 12.625V8.69318C105.011 8.23674 105.091 7.85133 105.252 7.53693C105.415 7.22254 105.645 6.98485 105.942 6.82386C106.24 6.66098 106.589 6.57955 106.991 6.57955C107.349 6.57955 107.652 6.6392 107.9 6.75852C108.15 6.87784 108.352 7.04261 108.505 7.25284C108.66 7.46307 108.773 7.70644 108.843 7.98295C108.915 8.25758 108.951 8.55114 108.951 8.86364V8.94318C108.951 9.37121 108.882 9.74527 108.744 10.0653C108.607 10.3854 108.41 10.6345 108.153 10.8125C107.895 10.9905 107.586 11.0795 107.227 11.0795C106.886 11.0795 106.611 10.9981 106.403 10.8352C106.194 10.6705 106.031 10.4432 105.914 10.1534C105.799 9.86174 105.707 9.52367 105.638 9.1392L106.178 8.9375C106.178 9.07008 106.19 9.20549 106.212 9.34375C106.235 9.48201 106.275 9.60985 106.332 9.72727C106.388 9.8428 106.469 9.93655 106.573 10.0085C106.677 10.0805 106.811 10.1165 106.974 10.1165C107.182 10.1165 107.344 10.0587 107.46 9.94318C107.577 9.82765 107.658 9.67992 107.704 9.5C107.751 9.32008 107.774 9.13447 107.772 8.94318V8.86364C107.772 8.63258 107.746 8.41951 107.695 8.22443C107.644 8.02936 107.559 7.87311 107.44 7.75568C107.322 7.63826 107.161 7.57955 106.957 7.57955C106.767 7.57955 106.615 7.63542 106.499 7.74716C106.386 7.8589 106.303 8.00758 106.252 8.19318C106.201 8.37879 106.176 8.58239 106.178 8.80398L106.187 12.625H105.011ZM109.836 6.63636H111.012L110.998 9.63352C111 9.80777 111.04 9.92424 111.117 9.98295C111.197 10.0417 111.31 10.071 111.458 10.071C111.534 10.071 111.599 10.0682 111.654 10.0625C111.709 10.0568 111.758 10.0521 111.802 10.0483V10.9375C111.701 10.9716 111.59 10.9991 111.467 11.0199C111.345 11.0407 111.218 11.0511 111.083 11.0511C110.702 11.0511 110.4 10.9527 110.177 10.7557C109.953 10.5587 109.84 10.233 109.836 9.77841V6.63636ZM115.773 5.30966L115.591 6.23011C115.239 6.13163 114.934 6.08239 114.676 6.08239C114.494 6.08239 114.34 6.10322 114.213 6.14489C114.086 6.18655 113.99 6.24811 113.923 6.32955C113.859 6.41098 113.827 6.51136 113.827 6.63068C113.827 6.82576 113.902 6.97159 114.054 7.06818C114.205 7.16288 114.426 7.21023 114.716 7.21023H115.321V7.88636H114.702C114.241 7.88636 113.858 7.83902 113.551 7.74432C113.246 7.64962 113.017 7.50663 112.864 7.31534C112.71 7.12216 112.634 6.88068 112.634 6.59091C112.634 6.28598 112.714 6.02273 112.875 5.80114C113.036 5.57765 113.264 5.4053 113.56 5.28409C113.855 5.16288 114.205 5.10227 114.608 5.10227C114.814 5.10227 115.014 5.11932 115.207 5.15341C115.401 5.1875 115.589 5.23958 115.773 5.30966ZM114.727 7.54545H115.321V8.2017H114.75C114.477 8.2017 114.246 8.23769 114.057 8.30966C113.867 8.37973 113.723 8.48485 113.625 8.625C113.528 8.76326 113.48 8.93561 113.48 9.14205C113.48 9.38447 113.556 9.58049 113.707 9.73011C113.859 9.87973 114.103 9.99242 114.44 10.0682L114.903 10.1705C115.294 10.2576 115.575 10.3826 115.747 10.5455C115.921 10.7064 116.008 10.9015 116.006 11.1307C116.002 11.2898 115.958 11.4545 115.875 11.625C115.794 11.7955 115.682 11.9583 115.54 12.1136C115.4 12.2708 115.24 12.4129 115.06 12.5398L114.449 12.0881C114.578 11.9612 114.671 11.8419 114.73 11.7301C114.789 11.6203 114.818 11.5265 114.818 11.4489C114.818 11.358 114.782 11.2803 114.71 11.2159C114.64 11.1515 114.531 11.0994 114.384 11.0597L113.668 10.8182C113.177 10.6799 112.823 10.4905 112.605 10.25C112.389 10.0095 112.281 9.68371 112.281 9.27273C112.281 8.70076 112.488 8.26989 112.901 7.98011C113.313 7.69034 113.922 7.54545 114.727 7.54545ZM118.131 8.47727V11H116.92V6.63636H118.074V7.40625H118.125C118.223 7.15057 118.386 6.94886 118.614 6.80114C118.841 6.65341 119.116 6.57955 119.438 6.57955C119.742 6.57955 120.008 6.64583 120.233 6.77841C120.458 6.91098 120.633 7.09943 120.756 7.34375C120.881 7.58807 120.943 7.88068 120.943 8.22159V12.6364H119.733V8.4375C119.733 8.17045 119.665 7.96212 119.528 7.8125C119.392 7.66098 119.202 7.58523 118.957 7.58523C118.796 7.58523 118.653 7.62027 118.528 7.69034C118.403 7.76042 118.306 7.86269 118.236 7.99716C118.166 8.12973 118.131 8.28977 118.131 8.47727ZM127.49 6.63636V7.58239H123.536V6.63636H127.49ZM124.874 6.63636H126.047V9.67614C126.047 9.79167 126.062 9.88163 126.092 9.94602C126.125 10.0085 126.169 10.053 126.226 10.0795C126.283 10.1042 126.349 10.1165 126.425 10.1165C126.514 10.1165 126.586 10.1108 126.641 10.0994C126.696 10.0881 126.754 10.0748 126.817 10.0597L126.939 10.9545C126.818 11.0038 126.699 11.0369 126.584 11.054C126.47 11.071 126.338 11.0795 126.186 11.0795C125.771 11.0795 125.448 10.964 125.217 10.733C124.988 10.5 124.874 10.1458 124.874 9.67045V6.63636ZM130.205 11.0852C129.763 11.0852 129.382 10.9915 129.06 10.804C128.74 10.6146 128.492 10.3513 128.318 10.0142C128.144 9.67519 128.057 9.2822 128.057 8.83523C128.057 8.38447 128.144 7.99053 128.318 7.65341C128.492 7.31439 128.74 7.05114 129.06 6.86364C129.382 6.67424 129.763 6.57955 130.205 6.57955C130.646 6.57955 131.027 6.67424 131.347 6.86364C131.669 7.05114 131.917 7.31439 132.091 7.65341C132.265 7.99053 132.352 8.38447 132.352 8.83523C132.352 9.2822 132.265 9.67519 132.091 10.0142C131.917 10.3513 131.669 10.6146 131.347 10.804C131.027 10.9915 130.646 11.0852 130.205 11.0852ZM130.21 10.1477C130.411 10.1477 130.579 10.0909 130.713 9.97727C130.848 9.86174 130.949 9.70455 131.017 9.50568C131.087 9.30682 131.122 9.08049 131.122 8.8267C131.122 8.57292 131.087 8.34659 131.017 8.14773C130.949 7.94886 130.848 7.79167 130.713 7.67614C130.579 7.56061 130.411 7.50284 130.21 7.50284C130.008 7.50284 129.837 7.56061 129.699 7.67614C129.563 7.79167 129.459 7.94886 129.389 8.14773C129.321 8.34659 129.287 8.57292 129.287 8.8267C129.287 9.08049 129.321 9.30682 129.389 9.50568C129.459 9.70455 129.563 9.86174 129.699 9.97727C129.837 10.0909 130.008 10.1477 130.21 10.1477ZM133.139 6.63636H134.315V9.38636C134.315 9.57576 134.338 9.72443 134.384 9.83239C134.431 9.94034 134.493 10.017 134.571 10.0625C134.651 10.108 134.736 10.1307 134.827 10.1307C135.012 10.1307 135.171 10.0653 135.304 9.93466C135.438 9.80398 135.542 9.63636 135.614 9.43182C135.688 9.22538 135.724 9.00947 135.724 8.78409C135.719 8.55303 135.697 8.31345 135.659 8.06534C135.623 7.81534 135.575 7.56913 135.514 7.3267C135.455 7.08239 135.388 6.85227 135.312 6.63636H136.426C136.508 6.79545 136.582 6.98958 136.651 7.21875C136.721 7.44792 136.777 7.69697 136.818 7.96591C136.86 8.23485 136.881 8.50758 136.881 8.78409C136.881 9.10606 136.842 9.40625 136.764 9.68466C136.688 9.96307 136.569 10.2064 136.406 10.4148C136.243 10.6231 136.034 10.786 135.778 10.9034C135.525 11.0208 135.22 11.0795 134.864 11.0795C134.345 11.0795 133.927 10.9432 133.611 10.6705C133.296 10.3958 133.139 9.96402 133.139 9.375V6.63636Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
function _A(e) {
  return /* @__PURE__ */ y.jsxs(
    "svg",
    {
      width: "163",
      height: "37",
      viewBox: "0 0 163 37",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ y.jsx("rect", { width: "163", height: "37", rx: "18.5", fill: "#181C39" }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M129.199 7.29529C129.867 7.29529 130.496 7.41795 131.084 7.66326C131.679 7.9085 132.188 8.24576 132.611 8.67495C133.04 9.09805 133.378 9.61006 133.623 10.211C133.874 10.8058 134 11.4404 134 12.1149C134 13.0163 133.789 13.8349 133.365 14.5707C132.948 15.3066 132.372 15.8829 131.636 16.2999C130.906 16.7107 130.094 16.9161 129.199 16.9161C127.831 16.9161 126.688 16.4593 125.768 15.5456C124.848 14.6321 124.388 13.4884 124.388 12.1149C124.388 10.7414 124.848 9.59477 125.768 8.67495C126.688 7.7552 127.831 7.29529 129.199 7.29529ZM129.199 9.83385C128.567 9.83385 128.04 10.0516 127.617 10.4869C127.2 10.9162 126.991 11.4588 126.991 12.1149C126.991 12.7526 127.2 13.2892 127.617 13.7245C128.04 14.1599 128.567 14.3775 129.199 14.3775C129.818 14.3775 130.339 14.1599 130.762 13.7245C131.185 13.2892 131.397 12.7526 131.397 12.1149C131.397 11.4588 131.185 10.9162 130.762 10.4869C130.345 10.0516 129.824 9.83385 129.199 9.83385Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M120.423 3.47828C120.742 3.15943 121.123 3 121.565 3C122.006 3 122.386 3.15943 122.705 3.47828C123.024 3.79101 123.183 4.16505 123.183 4.60041C123.183 5.04189 123.024 5.42207 122.705 5.74093C122.386 6.05978 122.006 6.2192 121.565 6.2192C121.123 6.2192 120.742 6.05978 120.423 5.74093C120.105 5.42207 119.945 5.04189 119.945 4.60041C119.945 4.16505 120.105 3.79101 120.423 3.47828ZM120.239 7.47925H122.898V16.7322H120.239V7.47925Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M116.607 16.9161C116.129 16.9161 115.721 16.7537 115.383 16.4287C115.052 16.0976 114.887 15.6959 114.887 15.2238C114.887 14.7578 115.052 14.3623 115.383 14.0372C115.721 13.7122 116.129 13.5498 116.607 13.5498C117.091 13.5498 117.499 13.7122 117.83 14.0372C118.167 14.3561 118.336 14.7516 118.336 15.2238C118.336 15.6959 118.167 16.0976 117.83 16.4287C117.499 16.7537 117.091 16.9161 116.607 16.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M113.571 11.701C113.571 12.0751 113.547 12.4215 113.498 12.7404H106.848C106.97 13.3658 107.238 13.8441 107.648 14.1752C108.059 14.5002 108.583 14.6627 109.221 14.6627C109.638 14.6627 110.036 14.5738 110.417 14.3959C110.803 14.2181 111.076 13.9912 111.235 13.7153L113.305 14.9846C112.968 15.5978 112.434 16.073 111.704 16.4103C110.975 16.7475 110.128 16.9161 109.166 16.9161C107.804 16.9161 106.652 16.4501 105.707 15.5181C104.769 14.5799 104.3 13.4271 104.3 12.0597C104.3 10.7169 104.763 9.58861 105.689 8.67495C106.621 7.7552 107.761 7.29529 109.11 7.29529C110.362 7.29529 111.416 7.72151 112.274 8.57381C113.139 9.42611 113.571 10.4685 113.571 11.701ZM106.885 11.048H110.913C110.858 10.5881 110.643 10.2049 110.27 9.89826C109.895 9.59165 109.463 9.43842 108.973 9.43842C108.421 9.43842 107.967 9.57941 107.611 9.86146C107.256 10.1436 107.014 10.5391 106.885 11.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M99.0479 7.29529C100.164 7.29529 101.071 7.63254 101.771 8.30705C102.476 8.98156 102.828 9.87377 102.828 10.9836V16.7322H100.152V11.609C100.152 11.0633 100.008 10.631 99.7195 10.3122C99.4312 9.99332 99.0479 9.83385 98.5698 9.83385C98.0981 9.83385 97.6989 9.99027 97.3743 10.303C97.0556 10.6096 96.8962 11.0449 96.8962 11.609V16.7322H94.238V11.609C94.238 11.0633 94.0938 10.631 93.8055 10.3122C93.5171 9.99332 93.1281 9.83385 92.6376 9.83385C92.1717 9.83385 91.782 9.98716 91.4697 10.2938C91.1567 10.6004 91.0002 11.0388 91.0002 11.609V16.7322H88.342V7.47924H91.0002V8.59221C91.595 7.7276 92.4753 7.29529 93.6403 7.29529C94.8603 7.29529 95.7341 7.746 96.2615 8.64742C96.5375 8.24271 96.9266 7.9177 97.4294 7.67246C97.9322 7.42099 98.472 7.29529 99.0479 7.29529Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M86.8614 11.701C86.8614 12.0751 86.8368 12.4215 86.7878 12.7404H80.1379C80.2605 13.3658 80.5272 13.8441 80.9381 14.1752C81.3488 14.5002 81.8732 14.6627 82.5109 14.6627C82.9278 14.6627 83.3264 14.5738 83.7066 14.3959C84.0929 14.2181 84.3657 13.9912 84.5251 13.7153L86.5946 14.9846C86.2574 15.5978 85.7239 16.073 84.9942 16.4103C84.2645 16.7475 83.4184 16.9161 82.4557 16.9161C81.0944 16.9161 79.9416 16.4501 78.9974 15.5181C78.0591 14.5799 77.5901 13.4271 77.5901 12.0597C77.5901 10.7169 78.053 9.58861 78.9789 8.67495C79.9109 7.7552 81.0515 7.29529 82.4005 7.29529C83.6514 7.29529 84.706 7.72151 85.5645 8.57381C86.4291 9.42611 86.8614 10.4685 86.8614 11.701ZM80.1747 11.048H84.2032C84.148 10.5881 83.9334 10.2049 83.5594 9.89826C83.1854 9.59165 82.7531 9.43842 82.2625 9.43842C81.7107 9.43842 81.2569 9.57941 80.9013 9.86146C80.5456 10.1436 80.3034 10.5391 80.1747 11.048Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M76.7807 14.2673L76.9187 16.6219C76.563 16.7936 76.1092 16.8794 75.5574 16.8794C74.4537 16.8794 73.5615 16.5483 72.8809 15.8861C72.2064 15.2177 71.8691 14.2949 71.8691 13.1176V10.0087H70.1492V7.47931H71.8691V5.05115H74.5272V7.47931H76.7991V10.0087H74.5272V12.9795C74.5272 13.4027 74.6652 13.7461 74.9411 14.0097C75.2171 14.2673 75.5544 14.396 75.9529 14.396C76.2595 14.396 76.5355 14.3531 76.7807 14.2673Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M66.0285 16.9161C64.3484 16.9161 62.9657 16.5298 61.8804 15.7572L62.6714 13.9085C63.5421 14.5584 64.5845 14.8835 65.7986 14.8835C66.2094 14.8835 66.5374 14.8129 66.7827 14.6719C67.0341 14.5308 67.1598 14.3499 67.1598 14.1293C67.1598 13.9391 67.0648 13.7828 66.8747 13.6601C66.6907 13.5314 66.4517 13.4302 66.1573 13.3566C65.863 13.283 65.538 13.2094 65.1823 13.1359C64.8267 13.0561 64.471 12.955 64.1154 12.8323C63.7598 12.7036 63.4348 12.5472 63.1404 12.3633C62.8461 12.1732 62.6039 11.9095 62.4138 11.5723C62.2299 11.2289 62.1348 10.8272 62.1287 10.3674C62.1164 9.49667 62.4598 8.76696 63.1588 8.17831C63.8579 7.58965 64.75 7.29529 65.8354 7.29529C67.3009 7.29529 68.4751 7.6479 69.3581 8.35305L68.6039 10.2754C68.2359 9.99947 67.7853 9.76952 67.2519 9.58557C66.7245 9.40162 66.2155 9.30961 65.725 9.30961C65.3877 9.30961 65.1149 9.3801 64.9064 9.52116C64.6979 9.66222 64.5937 9.83697 64.5937 10.0454C64.5937 10.2049 64.6673 10.3459 64.8144 10.4685C64.9616 10.585 65.1517 10.6801 65.3847 10.7537C65.6238 10.8272 65.8936 10.91 66.1941 11.002C66.5007 11.0878 66.8104 11.1737 67.123 11.2595C67.4358 11.3454 67.7423 11.465 68.0428 11.6182C68.3494 11.7715 68.6223 11.9463 68.8614 12.1425C69.1006 12.3326 69.2937 12.584 69.4408 12.8967C69.5942 13.2094 69.6738 13.5651 69.68 13.9636C69.68 14.8221 69.3367 15.5304 68.6498 16.0884C67.9693 16.6402 67.0954 16.9161 66.0285 16.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M59.112 7.47925H61.9724L56.831 19.8043H53.9888L55.6996 15.978L52.1401 7.47925H55.0098L57.0608 12.8875L59.112 7.47925Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M48.1482 16.9161C46.4681 16.9161 45.0853 16.5298 44 15.7572L44.791 13.9085C45.6617 14.5584 46.7041 14.8835 47.9182 14.8835C48.3291 14.8835 48.6571 14.8129 48.9024 14.6719C49.1538 14.5308 49.2795 14.3499 49.2795 14.1293C49.2795 13.9391 49.1844 13.7828 48.9944 13.6601C48.8104 13.5314 48.5713 13.4302 48.2769 13.3566C47.9826 13.283 47.6576 13.2094 47.302 13.1359C46.9463 13.0561 46.5907 12.955 46.2351 12.8323C45.8794 12.7036 45.5544 12.5472 45.2601 12.3633C44.9658 12.1732 44.7236 11.9095 44.5334 11.5723C44.3495 11.2289 44.2544 10.8272 44.2484 10.3674C44.236 9.49667 44.5795 8.76696 45.2784 8.17831C45.9775 7.58965 46.8697 7.29529 47.955 7.29529C49.4205 7.29529 50.5947 7.6479 51.4777 8.35305L50.7235 10.2754C50.3556 9.99947 49.9049 9.76952 49.3715 9.58557C48.8441 9.40162 48.3352 9.30961 47.8446 9.30961C47.5074 9.30961 47.2345 9.3801 47.0261 9.52116C46.8176 9.66222 46.7133 9.83697 46.7133 10.0454C46.7133 10.2049 46.7869 10.3459 46.9341 10.4685C47.0812 10.585 47.2713 10.6801 47.5043 10.7537C47.7435 10.8272 48.0133 10.91 48.3137 11.002C48.6203 11.0878 48.93 11.1737 49.2427 11.2595C49.5554 11.3454 49.862 11.465 50.1625 11.6182C50.469 11.7715 50.7419 11.9463 50.981 12.1425C51.2202 12.3326 51.4133 12.584 51.5605 12.8967C51.7138 13.2094 51.7936 13.5651 51.7996 13.9636C51.7996 14.8221 51.4563 15.5304 50.7696 16.0884C50.0889 16.6402 49.2151 16.9161 48.1482 16.9161Z",
            fill: "#00A0FF"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "mask",
          {
            id: "mask0_2008_5572",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "2",
            y: "2",
            width: "33",
            height: "33",
            children: /* @__PURE__ */ y.jsx("path", { d: "M34.5 2.5H2.5V34.5H34.5V2.5Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ y.jsxs("g", { mask: "url(#mask0_2008_5572)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M18.5 34.5C27.3366 34.5 34.5 27.3366 34.5 18.5C34.5 9.66344 27.3366 2.5 18.5 2.5C9.66344 2.5 2.5 9.66344 2.5 18.5C2.5 27.3366 9.66344 34.5 18.5 34.5Z",
              fill: "#00A0FF"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M17.8572 23.6222C18.5 23.6629 19.1445 23.5743 19.7525 23.3617C19.9407 23.2726 20.0964 23.1272 20.1981 22.9455C20.2998 22.7639 20.3424 22.555 20.3199 22.3481C20.3027 22.1291 20.2274 21.9186 20.1017 21.7385C19.976 21.5583 19.8045 21.4148 19.6049 21.323C18.9053 20.9274 18.1724 20.5939 17.4146 20.3262C16.6485 20.0431 15.9563 19.76 15.3378 19.4486C14.7488 19.1683 14.2086 18.7954 13.7376 18.3441C13.3015 17.9119 12.9579 17.3955 12.7275 16.8264C12.4734 16.148 12.352 15.427 12.3701 14.7028C12.342 13.9695 12.4902 13.2403 12.8022 12.5761C13.1142 11.912 13.5809 11.3324 14.1632 10.8859C15.3661 9.94958 17.0117 9.48332 19.0999 9.48708C20.109 9.4828 21.1161 9.57573 22.1074 9.76458C22.8795 9.90038 23.6388 10.1012 24.3772 10.3649L23.5317 14.1478C22.9242 13.9432 22.3068 13.7694 21.6818 13.6268C20.9474 13.4677 20.1974 13.3917 19.446 13.4002C17.9329 13.4002 17.1763 13.825 17.1763 14.6745C17.1733 14.8534 17.2081 15.0309 17.2784 15.1955C17.365 15.3765 17.5006 15.5295 17.6699 15.6372C17.9242 15.8091 18.1918 15.9606 18.4701 16.0902C18.8049 16.2545 19.2362 16.4357 19.7582 16.6565C20.6678 16.9692 21.5535 17.3478 22.4082 17.7892C23.0245 18.1066 23.5828 18.5259 24.0594 19.0294C24.4512 19.4536 24.7421 19.9608 24.9106 20.5132C25.0811 21.129 25.1633 21.7657 25.1546 22.4046C25.1984 23.1604 25.0446 23.9145 24.7083 24.5928C24.372 25.271 23.8648 25.85 23.2366 26.2726C21.9618 27.1447 20.1592 27.5807 17.8289 27.5807C16.5466 27.6071 15.2659 27.476 14.0156 27.19C13.2998 27.0213 12.5964 26.8036 11.9104 26.5387L12.7275 22.5745C13.5541 22.9012 14.4063 23.1589 15.2754 23.3448C16.1238 23.5279 16.9892 23.6208 17.8572 23.6222Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M44.1957 22.0909H45.8319L47.4073 25.0664H47.4748L49.0502 22.0909H50.6864L48.1664 26.5575V29H46.7157V26.5575L44.1957 22.0909ZM51.933 29.0978C51.6024 29.0978 51.3077 29.0405 51.0491 28.9258C50.7905 28.8088 50.5858 28.6368 50.4351 28.4096C50.2867 28.1802 50.2124 27.8946 50.2124 27.5527C50.2124 27.2649 50.2653 27.0231 50.371 26.8274C50.4767 26.6317 50.6206 26.4743 50.8028 26.3551C50.985 26.2359 51.1919 26.146 51.4236 26.0852C51.6575 26.0245 51.9026 25.9818 52.159 25.957C52.4604 25.9255 52.7033 25.8963 52.8877 25.8693C53.0721 25.8401 53.2059 25.7973 53.2892 25.7411C53.3724 25.6849 53.414 25.6017 53.414 25.4915V25.4712C53.414 25.2576 53.3465 25.0923 53.2116 24.9753C53.0789 24.8584 52.8899 24.7999 52.6448 24.7999C52.3862 24.7999 52.1804 24.8572 52.0274 24.9719C51.8745 25.0844 51.7733 25.2261 51.7238 25.397L50.3946 25.2891C50.4621 24.9742 50.5948 24.7021 50.7927 24.4727C50.9906 24.241 51.2459 24.0633 51.5585 23.9396C51.8734 23.8137 52.2377 23.7507 52.6515 23.7507C52.9394 23.7507 53.2149 23.7844 53.4781 23.8519C53.7435 23.9194 53.9785 24.024 54.1832 24.1657C54.3901 24.3074 54.5531 24.4895 54.6723 24.7122C54.7915 24.9326 54.8511 25.1969 54.8511 25.505V29H53.4882V28.2814H53.4477C53.3645 28.4434 53.2532 28.5862 53.1137 28.7099C52.9743 28.8313 52.8067 28.9269 52.6111 28.9966C52.4154 29.0641 52.1894 29.0978 51.933 29.0978ZM52.3445 28.106C52.556 28.106 52.7426 28.0644 52.9046 27.9812C53.0665 27.8957 53.1936 27.781 53.2858 27.6371C53.378 27.4931 53.4241 27.3301 53.4241 27.1479V26.598C53.3791 26.6272 53.3173 26.6542 53.2385 26.679C53.1621 26.7015 53.0755 26.7228 52.9788 26.7431C52.8821 26.7611 52.7854 26.7779 52.6887 26.7937C52.5919 26.8072 52.5042 26.8195 52.4255 26.8308C52.2568 26.8555 52.1095 26.8949 51.9836 26.9489C51.8576 27.0028 51.7598 27.0759 51.6901 27.1681C51.6204 27.2581 51.5855 27.3706 51.5855 27.5055C51.5855 27.7012 51.6563 27.8507 51.798 27.9542C51.942 28.0554 52.1241 28.106 52.3445 28.106ZM55.9661 30.9432V23.8182H57.383V24.6886H57.4471C57.5101 24.5491 57.6011 24.4074 57.7203 24.2635C57.8418 24.1173 57.9992 23.9959 58.1926 23.8991C58.3883 23.8002 58.6312 23.7507 58.9213 23.7507C59.2992 23.7507 59.6478 23.8497 59.9672 24.0476C60.2865 24.2433 60.5418 24.539 60.733 24.9348C60.9241 25.3284 61.0197 25.8221 61.0197 26.4158C61.0197 26.9938 60.9264 27.4819 60.7397 27.88C60.5553 28.2758 60.3034 28.5761 59.984 28.7807C59.6669 28.9831 59.3116 29.0843 58.918 29.0843C58.6391 29.0843 58.4018 29.0382 58.2061 28.946C58.0127 28.8538 57.8542 28.738 57.7305 28.5985C57.6068 28.4569 57.5123 28.314 57.4471 28.1701H57.4032V30.9432H55.9661ZM57.3729 26.4091C57.3729 26.7172 57.4156 26.986 57.5011 27.2154C57.5865 27.4448 57.7102 27.6236 57.8722 27.7518C58.0341 27.8777 58.2309 27.9407 58.4625 27.9407C58.6964 27.9407 58.8944 27.8766 59.0563 27.7484C59.2182 27.618 59.3408 27.438 59.424 27.2086C59.5095 26.977 59.5522 26.7105 59.5522 26.4091C59.5522 26.11 59.5106 25.8468 59.4274 25.6197C59.3442 25.3925 59.2216 25.2148 59.0597 25.0866C58.8977 24.9585 58.6987 24.8944 58.4625 24.8944C58.2286 24.8944 58.0307 24.9562 57.8688 25.0799C57.7091 25.2036 57.5865 25.379 57.5011 25.6062C57.4156 25.8333 57.3729 26.101 57.3729 26.4091ZM61.9778 29V23.8182H63.415V29H61.9778ZM64.5662 29V23.8182H65.9359V24.7324H65.9966C66.1045 24.4288 66.2845 24.1893 66.5364 24.0138C66.7882 23.8384 67.0896 23.7507 67.4405 23.7507C67.7958 23.7507 68.0983 23.8395 68.348 24.0172C68.5976 24.1926 68.764 24.431 68.8473 24.7324H68.9012C69.0069 24.4355 69.1981 24.1983 69.4747 24.0206C69.7536 23.8407 70.0831 23.7507 70.4632 23.7507C70.9467 23.7507 71.3392 23.9048 71.6406 24.2129C71.9442 24.5188 72.096 24.9528 72.096 25.5151V29H70.6622V25.7985C70.6622 25.5106 70.5858 25.2947 70.4328 25.1507C70.2799 25.0068 70.0887 24.9348 69.8593 24.9348C69.5984 24.9348 69.3949 25.0181 69.2487 25.1845C69.1025 25.3487 69.0294 25.5657 69.0294 25.8356V29H67.6361V25.7681C67.6361 25.514 67.563 25.3116 67.4169 25.1609C67.2729 25.0102 67.0829 24.9348 66.8467 24.9348C66.687 24.9348 66.5431 24.9753 66.4149 25.0563C66.289 25.135 66.1889 25.2463 66.1147 25.3903C66.0404 25.532 66.0033 25.6984 66.0033 25.8896V29H64.5662ZM73.2312 29V23.8182H74.6684V29H73.2312Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M154.76 18.4167L149.343 12.9995C149.189 12.8449 148.982 12.76 148.763 12.76C148.543 12.76 148.337 12.845 148.182 12.9995L147.69 13.4915C147.536 13.6459 147.451 13.8521 147.451 14.072C147.451 14.2917 147.536 14.5049 147.69 14.6593L150.851 17.8264H140.81C140.358 17.8264 140 18.1808 140 18.6336V19.3291C140 19.7819 140.358 20.172 140.81 20.172H150.886L147.69 23.3569C147.536 23.5115 147.451 23.7121 147.451 23.932C147.451 24.1516 147.536 24.3552 147.69 24.5097L148.182 25C148.337 25.1547 148.543 25.2389 148.763 25.2389C148.983 25.2389 149.189 25.1536 149.343 24.9989L154.76 19.5819C154.915 19.4268 155.001 19.2197 155 18.9996C155 18.7787 154.915 18.5715 154.76 18.4167Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
const oo = ({
  description: e,
  descriptionClassName: t,
  error: n,
  errorClassName: r,
  className: a
}) => {
  const i = n ? /* @__PURE__ */ y.jsx(
    "p",
    {
      className: Fe("text-danger [&>a]:text-brand-primary text-sm", r),
      ...typeof n == "string" ? {
        dangerouslySetInnerHTML: { __html: n }
      } : {
        children: n
      }
    }
  ) : null;
  return n || e ? /* @__PURE__ */ y.jsxs("div", { className: a, children: [
    e ? /* @__PURE__ */ y.jsx(
      "span",
      {
        className: Fe("[&>a]:text-brand-primary text-sm opacity-70", t),
        children: e
      }
    ) : null,
    i
  ] }) : null;
};
function ba({
  wrapperAs: e = "div",
  wrapperProps: t = { className: "flex justify-between gap-2" },
  label: n,
  required: r,
  labelClassName: a,
  labelRightElement: i,
  requiredSignClassName: o
}) {
  return n || r || i ? /* @__PURE__ */ y.jsxs(e, { ...t, children: [
    (n || r) && /* @__PURE__ */ y.jsxs("span", { className: Fe("flex", a), children: [
      n,
      " ",
      r && /* @__PURE__ */ y.jsx("i", { className: Fe("text-danger", o), children: "*" })
    ] }),
    i
  ] }) : null;
}
Ji(function(e, t) {
  return /* @__PURE__ */ y.jsx(
    "button",
    {
      ref: t,
      ...e,
      onClick: (n) => {
        var r;
        n.preventDefault = () => {
        }, (r = e.onClick) == null || r.call(e, n);
      }
    }
  );
});
Ji(function(e, t) {
  return /* @__PURE__ */ y.jsx(
    "div",
    {
      ref: t,
      ...e,
      onClick: (n) => {
        var r;
        n.preventDefault = () => {
        }, n.stopPropagation = () => {
        }, (r = e.onClick) == null || r.call(e, n);
      }
    }
  );
});
function EC() {
  return (EC = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function wA(e, t) {
  if (e == null)
    return {};
  var n, r, a = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++)
    t.indexOf(n = i[r]) >= 0 || (a[n] = e[n]);
  return a;
}
function du(e) {
  var t = be(e), n = be(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var Ls = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, ms = function(e) {
  return "touches" in e;
}, O0 = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, pu = function(e, t, n) {
  var r = e.getBoundingClientRect(), a = ms(t) ? function(i, o) {
    for (var s = 0; s < i.length; s++)
      if (i[s].identifier === o)
        return i[s];
    return i[0];
  }(t.touches, n) : t;
  return { left: Ls((a.pageX - (r.left + O0(e).pageXOffset)) / r.width), top: Ls((a.pageY - (r.top + O0(e).pageYOffset)) / r.height) };
}, hu = function(e) {
  !ms(e) && e.preventDefault();
}, TC = M.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = wA(e, ["onMove", "onKey"]), a = be(null), i = du(t), o = du(n), s = be(null), l = be(!1), c = _e(function() {
    var h = function(C) {
      hu(C), (ms(C) ? C.touches.length > 0 : C.buttons > 0) && a.current ? i(pu(a.current, C, s.current)) : f(!1);
    }, m = function() {
      return f(!1);
    };
    function f(C) {
      var _ = l.current, v = O0(a.current), w = C ? v.addEventListener : v.removeEventListener;
      w(_ ? "touchmove" : "mousemove", h), w(_ ? "touchend" : "mouseup", m);
    }
    return [function(C) {
      var _ = C.nativeEvent, v = a.current;
      if (v && (hu(_), !function(k, b) {
        return b && !ms(k);
      }(_, l.current) && v)) {
        if (ms(_)) {
          l.current = !0;
          var w = _.changedTouches || [];
          w.length && (s.current = w[0].identifier);
        }
        v.focus(), i(pu(v, _, s.current)), f(!0);
      }
    }, function(C) {
      var _ = C.which || C.keyCode;
      _ < 37 || _ > 40 || (C.preventDefault(), o({ left: _ === 39 ? 0.05 : _ === 37 ? -0.05 : 0, top: _ === 40 ? 0.05 : _ === 38 ? -0.05 : 0 }));
    }, f];
  }, [o, i]), u = c[0], d = c[1], p = c[2];
  return Re(function() {
    return p;
  }, [p]), M.createElement("div", EC({}, r, { onTouchStart: u, onMouseDown: u, className: "react-colorful__interactive", ref: a, onKeyDown: d, tabIndex: 0, role: "slider" }));
}), LC = function(e) {
  return e.filter(Boolean).join(" ");
}, AC = function(e) {
  var t = e.color, n = e.left, r = e.top, a = r === void 0 ? 0.5 : r, i = LC(["react-colorful__pointer", e.className]);
  return M.createElement("div", { className: i, style: { top: 100 * a + "%", left: 100 * n + "%" } }, M.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, E2 = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, xA = function(e) {
  var t = e.s, n = e.v, r = e.a, a = (200 - t) * n / 100;
  return { h: E2(e.h), s: E2(a > 0 && a < 200 ? t * n / 100 / (a <= 100 ? a : 200 - a) * 100 : 0), l: E2(a / 2), a: E2(r, 2) };
}, N0 = function(e) {
  var t = xA(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
};
M.memo(function(e) {
  var t = e.hue, n = e.onChange, r = LC(["react-colorful__hue", e.className]);
  return M.createElement("div", { className: r }, M.createElement(TC, { onMove: function(a) {
    n({ h: 360 * a.left });
  }, onKey: function(a) {
    n({ h: Ls(t + 360 * a.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": E2(t), "aria-valuemax": "360", "aria-valuemin": "0" }, M.createElement(AC, { className: "react-colorful__hue-pointer", left: t / 360, color: N0({ h: t, s: 100, v: 100, a: 1 }) })));
});
M.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: N0({ h: t.h, s: 100, v: 100, a: 1 }) };
  return M.createElement("div", { className: "react-colorful__saturation", style: r }, M.createElement(TC, { onMove: function(a) {
    n({ s: 100 * a.left, v: 100 - 100 * a.top });
  }, onKey: function(a) {
    n({ s: Ls(t.s + 100 * a.left, 0, 100), v: Ls(t.v - 100 * a.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + E2(t.s) + "%, Brightness " + E2(t.v) + "%" }, M.createElement(AC, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: N0(t) })));
});
const mu = (e, t) => ({
  ...e ? {
    "data-test-id": `${t}`
  } : {}
});
function Gr(e) {
  "@babel/helpers - typeof";
  return Gr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gr(e);
}
function SA(e, t) {
  if (Gr(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Gr(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function OC(e) {
  var t = SA(e, "string");
  return Gr(t) == "symbol" ? t : t + "";
}
function Te(e, t, n) {
  return (t = OC(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function vt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function fu(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, OC(r.key), r);
  }
}
function bt(e, t, n) {
  return t && fu(e.prototype, t), n && fu(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var kA = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, MA = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, PA = function(e) {
  return MA[e];
}, EA = function(e) {
  return e.replace(kA, PA);
};
function Cu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gu(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Cu(Object(n), !0).forEach(function(r) {
      Te(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Cu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var yu = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: EA
};
Qe();
function TA() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  yu = gu(gu({}, yu), e);
}
(function() {
  function e() {
    vt(this, e), this.usedNamespaces = {};
  }
  return bt(e, [{
    key: "addUsedNamespaces",
    value: function(t) {
      var n = this;
      t.forEach(function(r) {
        n.usedNamespaces[r] || (n.usedNamespaces[r] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
})();
var LA = {
  type: "3rdParty",
  init: function(e) {
    TA(e.options.react);
  }
};
function vu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function AA(e, t) {
  if (e) {
    if (typeof e == "string")
      return vu(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? vu(e, t) : void 0;
  }
}
const We = (e) => typeof e == "string", Eo = () => {
  let e, t;
  const n = new Promise((r, a) => {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}, bu = (e) => e == null ? "" : "" + e, OA = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, NA = /###/g, _u = (e) => e && e.indexOf("###") > -1 ? e.replace(NA, ".") : e, wu = (e) => !e || We(e), fs = (e, t, n) => {
  const r = We(t) ? t.split(".") : t;
  let a = 0;
  for (; a < r.length - 1; ) {
    if (wu(e))
      return {};
    const i = _u(r[a]);
    !e[i] && n && (e[i] = new n()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++a;
  }
  return wu(e) ? {} : {
    obj: e,
    k: _u(r[a])
  };
}, xu = (e, t, n) => {
  const {
    obj: r,
    k: a
  } = fs(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[a] = n;
    return;
  }
  let i = t[t.length - 1], o = t.slice(0, t.length - 1), s = fs(e, o, Object);
  for (; s.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), s = fs(e, o, Object), s && s.obj && typeof s.obj[`${s.k}.${i}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = n;
}, jA = (e, t, n, r) => {
  const {
    obj: a,
    k: i
  } = fs(e, t, Object);
  a[i] = a[i] || [], a[i].push(n);
}, B6 = (e, t) => {
  const {
    obj: n,
    k: r
  } = fs(e, t);
  if (n)
    return n[r];
}, RA = (e, t, n) => {
  const r = B6(e, n);
  return r !== void 0 ? r : B6(t, n);
}, NC = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? We(e[r]) || e[r] instanceof String || We(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : NC(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, oi = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var DA = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const IA = (e) => We(e) ? e.replace(/[&<>"'\/]/g, (t) => DA[t]) : e;
class HA {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const FA = [" ", ",", "?", "!", ";"], VA = new HA(20), BA = (e, t, n) => {
  t = t || "", n = n || "";
  const r = FA.filter((o) => t.indexOf(o) < 0 && n.indexOf(o) < 0);
  if (r.length === 0)
    return !0;
  const a = VA.getRegExp(`(${r.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !a.test(e);
  if (!i) {
    const o = e.indexOf(n);
    o > 0 && !a.test(e.substring(0, o)) && (i = !0);
  }
  return i;
}, j0 = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let a = e;
  for (let i = 0; i < r.length; ) {
    if (!a || typeof a != "object")
      return;
    let o, s = "";
    for (let l = i; l < r.length; ++l)
      if (l !== i && (s += n), s += r[l], o = a[s], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < r.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    a = o;
  }
  return a;
}, z6 = (e) => e && e.replace("_", "-"), zA = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class G6 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || zA, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, a) {
    return a && !this.debug ? null : (We(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new G6(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new G6(this.logger, t);
  }
}
var Hn = new G6();
class o8 {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const a = this.observers[r].get(n) || 0;
      this.observers[r].set(n, a + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((i) => {
      let [o, s] = i;
      for (let l = 0; l < s; l++)
        o(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((i) => {
      let [o, s] = i;
      for (let l = 0; l < s; l++)
        o.apply(o, [t, ...r]);
    });
  }
}
let Su = class extends o8 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, o = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], r && (Array.isArray(r) ? s.push(...r) : We(r) && i ? s.push(...r.split(i)) : s.push(r)));
    const l = B6(this.data, s);
    return !l && !n && !r && t.indexOf(".") > -1 && (t = s[0], n = s[1], r = s.slice(2).join(".")), l || !o || !We(r) ? l : j0(this.data && this.data[t] && this.data[t][n], r, i);
  }
  addResource(t, n, r, a) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [t, n];
    r && (s = s.concat(o ? r.split(o) : r)), t.indexOf(".") > -1 && (s = t.split("."), a = n, n = s[1]), this.addNamespaces(n), xu(this.data, s, a), i.silent || this.emit("added", t, n, r, a);
  }
  addResources(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (We(r[i]) || Array.isArray(r[i])) && this.addResource(t, n, i, r[i], {
        silent: !0
      });
    a.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), a = r, r = n, n = s[1]), this.addNamespaces(n);
    let l = B6(this.data, s) || {};
    o.skipCopy || (r = JSON.parse(JSON.stringify(r))), a ? NC(l, r, i) : l = {
      ...l,
      ...r
    }, xu(this.data, s, l), o.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((r) => n[r] && Object.keys(n[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
};
var jC = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, a) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, n, r, a));
    }), t;
  }
};
const ku = {};
class U6 extends o8 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), OA(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Hn.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const o = r && t.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !BA(t, r, a);
    if (o && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: We(i) ? [i] : i
        };
      const c = t.split(r);
      (r !== a || r === a && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: We(i) ? [i] : i
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const a = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], n), l = s[s.length - 1], c = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const k = n.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${k}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${k}${o}`;
      }
      return a ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : o;
    }
    const d = this.resolve(t, n);
    let p = d && d.res;
    const h = d && d.usedKey || o, m = d && d.exactUsedKey || o, f = Object.prototype.toString.apply(p), C = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !We(p) && typeof p != "boolean" && typeof p != "number";
    if (v && p && w && C.indexOf(f) < 0 && !(We(_) && Array.isArray(p))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const k = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, p, {
          ...n,
          ns: s
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return a ? (d.res = k, d.usedParams = this.getUsedParamsDetails(n), d) : k;
      }
      if (i) {
        const k = Array.isArray(p), b = k ? [] : {}, S = k ? m : h;
        for (const P in p)
          if (Object.prototype.hasOwnProperty.call(p, P)) {
            const O = `${S}${i}${P}`;
            b[P] = this.translate(O, {
              ...n,
              joinArrays: !1,
              ns: s
            }), b[P] === O && (b[P] = p[P]);
          }
        p = b;
      }
    } else if (v && We(_) && Array.isArray(p))
      p = p.join(_), p && (p = this.extendTranslation(p, t, n, r));
    else {
      let k = !1, b = !1;
      const S = n.count !== void 0 && !We(n.count), P = U6.hasDefaultValue(n), O = S ? this.pluralResolver.getSuffix(c, n.count, n) : "", A = n.ordinal && S ? this.pluralResolver.getSuffix(c, n.count, {
        ordinal: !1
      }) : "", L = S && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), I = L && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${O}`] || n[`defaultValue${A}`] || n.defaultValue;
      !this.isValidLookup(p) && P && (k = !0, p = I), this.isValidLookup(p) || (b = !0, p = o);
      const D = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && b ? void 0 : p, U = P && I !== p && this.options.updateMissing;
      if (b || k || U) {
        if (this.logger.log(U ? "updateKey" : "missingKey", c, l, o, U ? I : p), i) {
          const Z = this.resolve(o, {
            ...n,
            keySeparator: !1
          });
          Z && Z.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let z = [];
        const $ = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && $ && $[0])
          for (let Z = 0; Z < $.length; Z++)
            z.push($[Z]);
        else
          this.options.saveMissingTo === "all" ? z = this.languageUtils.toResolveHierarchy(n.lng || this.language) : z.push(n.lng || this.language);
        const ee = (Z, G, W) => {
          const j = P && W !== p ? W : D;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(Z, l, G, j, U, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(Z, l, G, j, U, n), this.emit("missingKey", Z, l, G, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && S ? z.forEach((Z) => {
          const G = this.pluralResolver.getSuffixes(Z, n);
          L && n[`defaultValue${this.options.pluralSeparator}zero`] && G.indexOf(`${this.options.pluralSeparator}zero`) < 0 && G.push(`${this.options.pluralSeparator}zero`), G.forEach((W) => {
            ee([Z], o + W, n[`defaultValue${W}`] || I);
          });
        }) : ee(z, o, I));
      }
      p = this.extendTranslation(p, t, n, d, r), b && p === o && this.options.appendNamespaceToMissingKey && (p = `${l}:${o}`), (b || k) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, k ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return a ? (d.res = p, d.usedParams = this.getUsedParamsDetails(n), d) : p;
  }
  extendTranslation(t, n, r, a, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = We(t) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const p = t.match(this.interpolator.nestingRegexp);
        u = p && p.length;
      }
      let d = r.replace && !We(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), t = this.interpolator.interpolate(t, d, r.lng || this.language || a.usedLng, r), c) {
        const p = t.match(this.interpolator.nestingRegexp), h = p && p.length;
        u < h && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (r.lng = this.language || a.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var p = arguments.length, h = new Array(p), m = 0; m < p; m++)
          h[m] = arguments[m];
        return i && i[0] === h[0] && !r.context ? (o.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${n[0]}`), null) : o.translate(...h, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = We(s) ? [s] : s;
    return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = jC.handle(l, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, a, i, o, s;
    return We(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const c = this.extractFromKey(l, n), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !We(n.count), h = p && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = n.context !== void 0 && (We(n.context) || typeof n.context == "number") && n.context !== "", f = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((C) => {
        this.isValidLookup(r) || (s = C, !ku[`${f[0]}-${C}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (ku[`${f[0]}-${C}`] = !0, this.logger.warn(`key "${a}" for languages "${f.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach((_) => {
          if (this.isValidLookup(r))
            return;
          o = _;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, _, C, n);
          else {
            let k;
            p && (k = this.pluralResolver.getSuffix(_, n.count, n));
            const b = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (v.push(u + k), n.ordinal && k.indexOf(S) === 0 && v.push(u + k.replace(S, this.options.pluralSeparator)), h && v.push(u + b)), m) {
              const P = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(P), p && (v.push(P + k), n.ordinal && k.indexOf(S) === 0 && v.push(P + k.replace(S, this.options.pluralSeparator)), h && v.push(P + b));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(r) || (i = w, r = this.getResource(_, C, w, n));
        }));
      });
    }), {
      res: r,
      usedKey: a,
      exactUsedKey: i,
      usedLng: o,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, a) : this.resourceStore.getResource(t, n, r, a);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && !We(t.replace);
    let a = r ? t.replace : t;
    if (r && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !r) {
      a = {
        ...a
      };
      for (const i of n)
        delete a[i];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
const c7 = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class Mu {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Hn.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = z6(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = z6(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (We(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(t)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a)
            return a;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((a) => a.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = c7(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = c7(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = c7(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const a = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const a = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(a))
        return n = a;
      n = this.options.supportedLngs.find((i) => {
        if (i === a || !(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), We(t) && (t = [t]), Array.isArray(t))
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), a = [], i = (o) => {
      o && (this.isSupportedCode(o) ? a.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return We(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : We(t) && i(this.formatLanguageCode(t)), r.forEach((o) => {
      a.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), a;
  }
}
let GA = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], UA = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const ZA = ["v1", "v2", "v3"], KA = ["v4"], Pu = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, $A = () => {
  const e = {};
  return GA.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: UA[t.fc]
      };
    });
  }), e;
};
class WA {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = Hn.create("pluralResolver"), (!this.options.compatibilityJSON || KA.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = $A(), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = z6(t === "dev" ? "en" : t), a = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: r,
        type: a
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let o;
      try {
        o = new Intl.PluralRules(r, {
          type: a
        });
      } catch {
        if (!t.match(/-|_/))
          return;
        const s = this.languageUtils.getLanguagePartFromCode(t);
        o = this.getRule(s, n);
      }
      return this.pluralRulesCache[i] = o, o;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((a) => `${n}${a}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((a, i) => Pu[a] - Pu[i]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : r.numbers.map((a) => this.getSuffix(t, a, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(t, r);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : this.getSuffixRetroCompatible(a, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let a = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const i = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !ZA.includes(this.options.compatibilityJSON);
  }
}
const Eu = function(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = RA(e, t, n);
  return !i && a && We(n) && (i = j0(e, n, r), i === void 0 && (i = j0(t, n, r))), i;
}, u7 = (e) => e.replace(/\$/g, "$$$$");
class YA {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Hn.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: a,
      prefix: i,
      prefixEscaped: o,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: p,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: f,
      nestingOptionsSeparator: C,
      maxReplaces: _,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : IA, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = i ? oi(i) : o || "{{", this.suffix = s ? oi(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = p ? oi(p) : h || oi("$t("), this.nestingSuffix = m ? oi(m) : f || oi(")"), this.nestingOptionsSeparator = C || ",", this.maxReplaces = _ || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, a) {
    let i, o, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const C = Eu(n, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(C, void 0, r, {
          ...a,
          ...n,
          interpolationkey: p
        }) : C;
      }
      const h = p.split(this.formatSeparator), m = h.shift().trim(), f = h.join(this.formatSeparator).trim();
      return this.format(Eu(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure), f, r, {
        ...a,
        ...n,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => u7(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? u7(this.escape(p)) : u7(p)
    }].forEach((p) => {
      for (s = 0; i = p.regex.exec(t); ) {
        const h = i[1].trim();
        if (o = c(h), o === void 0)
          if (typeof u == "function") {
            const f = u(t, i, a);
            o = We(f) ? f : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, h))
            o = "";
          else if (d) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), o = "";
        else
          !We(o) && !this.useRawValueToEscape && (o = bu(o));
        const m = p.safeValue(o);
        if (t = t.replace(i[0], m), d ? (p.regex.lastIndex += o.length, p.regex.lastIndex -= i[0].length) : p.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, i, o;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, o);
      const h = p.match(/'/g), m = p.match(/"/g);
      (h && h.length % 2 === 0 && !m || m.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        o = JSON.parse(p), c && (o = {
          ...c,
          ...o
        });
      } catch (f) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, f), `${l}${u}${p}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      o = {
        ...r
      }, o = o.replace && !We(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((d) => d.trim());
        a[1] = u.shift(), l = u, c = !0;
      }
      if (i = n(s.call(this, a[1].trim(), o), o), i && a[0] === t && !We(i))
        return i;
      We(i) || (i = bu(i)), i || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), i = ""), c && (i = l.reduce((u, d) => this.format(u, d, r.lng, {
        ...r,
        interpolationkey: a[1].trim()
      }), i.trim())), t = t.replace(a[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const qA = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const a = r[1].substring(0, r[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((i) => {
      if (i) {
        const [o, ...s] = i.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = o.trim();
        n[c] || (n[c] = l), l === "false" && (n[c] = !1), l === "true" && (n[c] = !0), isNaN(l) || (n[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, si = (e) => {
  const t = {};
  return (n, r, a) => {
    let i = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (i = {
      ...i,
      [a.interpolationkey]: void 0
    });
    const o = r + JSON.stringify(i);
    let s = t[o];
    return s || (s = e(z6(r), a), t[o] = s), s(n);
  };
};
class JA {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Hn.create("formatter"), this.options = t, this.formats = {
      number: si((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      currency: si((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (i) => a.format(i);
      }),
      datetime: si((n, r) => {
        const a = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      relativetime: si((n, r) => {
        const a = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i, r.range || "day");
      }),
      list: si((n, r) => {
        const a = new Intl.ListFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = si(n);
  }
  format(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((s) => s.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = qA(s);
      if (this.formats[l]) {
        let u = o;
        try {
          const d = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, p = d.locale || d.lng || a.locale || a.lng || r;
          u = this.formats[l](o, p, {
            ...c,
            ...a,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return o;
    }, t);
  }
}
const XA = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class QA extends o8 {
  constructor(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = a, this.logger = Hn.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, a.backend, a);
  }
  queueLoad(t, n, r, a) {
    const i = {}, o = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const p = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? o[p] === void 0 && (o[p] = !0) : (this.state[p] = 1, u = !1, o[p] === void 0 && (o[p] = !0), i[p] === void 0 && (i[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const a = t.split("|"), i = a[0], o = a[1];
    n && this.emit("failedLoading", i, o, n), !n && r && this.store.addResourceBundle(i, o, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      jA(l.loaded, [i], o), XA(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: a,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, a + 1, i * 2, o);
        }, i);
        return;
      }
      o(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    We(t) && (t = this.languageUtils.toResolveHierarchy(t)), We(n) && (n = [n]);
    const i = this.queueLoad(t, n, r, a);
    if (!i.toLoad.length)
      return i.pending.length || a(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), a = r[0], i = r[1];
    this.read(a, i, "read", void 0, void 0, (o, s) => {
      o && this.logger.warn(`${n}loading namespace ${i} for language ${a} failed`, o), !o && s && this.logger.log(`${n}loaded namespace ${i} for language ${a}`, s), this.loaded(t, o, s);
    });
  }
  saveMissing(t, n, r, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...o,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, r, a, l) : u = c(t, n, r, a), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, n, r, a, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, a);
    }
  }
}
const Tu = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), We(e[1]) && (t.defaultValue = e[1]), We(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Lu = (e) => (We(e.ns) && (e.ns = [e.ns]), We(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), We(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), j9 = () => {
}, eO = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class As extends o8 {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Lu(t), this.services = {}, this.logger = Hn, this.modules = {
      external: []
    }, eO(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (We(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const a = Tu();
    this.options = {
      ...a,
      ...this.options,
      ...Lu(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const i = (l) => l ? typeof l == "function" ? new l() : l : null;
    if (!this.options.isClone) {
      this.modules.logger ? Hn.init(i(this.modules.logger), this.options) : Hn.init(null, this.options);
      let l;
      this.modules.formatter ? l = this.modules.formatter : typeof Intl < "u" && (l = JA);
      const c = new Mu(this.options);
      this.store = new Su(this.options.resources, this.options);
      const u = this.services;
      u.logger = Hn, u.resourceStore = this.store, u.languageUtils = c, u.pluralResolver = new WA(c, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), l && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (u.formatter = i(l), u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new YA(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new QA(i(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", function(d) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          h[m - 1] = arguments[m];
        t.emit(d, ...h);
      }), this.modules.languageDetector && (u.languageDetector = i(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = i(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new U6(this.services, this.options), this.translator.on("*", function(d) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          h[m - 1] = arguments[m];
        t.emit(d, ...h);
      }), this.modules.external.forEach((d) => {
        d.init && d.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = j9), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const l = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      l.length > 0 && l[0] !== "dev" && (this.options.lng = l[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((l) => {
      this[l] = function() {
        return t.store[l](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((l) => {
      this[l] = function() {
        return t.store[l](...arguments), t;
      };
    });
    const o = Eo(), s = () => {
      const l = (c, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), o.resolve(u), r(c, u);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return l(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, l);
    };
    return this.options.resources || !this.options.initImmediate ? s() : setTimeout(s, 0), o;
  }
  loadResources(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : j9;
    const r = We(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const a = [], i = (o) => {
        !o || o === "cimode" || this.services.languageUtils.toResolveHierarchy(o).forEach((s) => {
          s !== "cimode" && a.indexOf(s) < 0 && a.push(s);
        });
      };
      r ? i(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((o) => i(o)), this.options.preload && this.options.preload.forEach((o) => i(o)), this.services.backendConnector.load(a, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(o);
      });
    } else
      n(null);
  }
  reloadResources(t, n, r) {
    const a = Eo();
    return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = j9), this.services.backendConnector.reload(t, n, (i) => {
      a.resolve(), r(i);
    }), a;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && jC.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const a = Eo();
    this.emit("languageChanging", t);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = We(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        o(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), a;
  }
  getFixedT(t, n, r) {
    var a = this;
    const i = function(o, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = a.options.overloadTranslationOptionHandler([o, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || i.keyPrefix);
      const p = a.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(o) ? h = o.map((m) => `${l.keyPrefix}${p}${m}`) : h = l.keyPrefix ? `${l.keyPrefix}${p}${o}` : o, a.t(h, l);
    };
    return We(t) ? i.lng = t : i.lngs = t, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const o = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, o);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(r, t) && (!a || o(i, t)));
  }
  loadNamespaces(t, n) {
    const r = Eo();
    return this.options.ns ? (We(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = Eo();
    We(t) && (t = [t]);
    const a = this.options.preload || [], i = t.filter((o) => a.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = a.concat(i), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Mu(Tu());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new As(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : j9;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new As(a);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new Su(this.store.data, a), i.services.resourceStore = i.store), i.translator = new U6(i.services, a), i.translator.on("*", function(o) {
      for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
        l[c - 1] = arguments[c];
      i.emit(o, ...l);
    }), i.init(a, n), i.translator.options = a, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Xe = As.createInstance();
Xe.createInstance = As.createInstance;
Xe.createInstance;
Xe.dir;
Xe.init;
Xe.loadResources;
Xe.reloadResources;
Xe.use;
Xe.changeLanguage;
Xe.getFixedT;
Xe.t;
Xe.exists;
Xe.setDefaultNamespace;
Xe.hasLoadedNamespace;
Xe.loadNamespaces;
Xe.loadLanguages;
var Tr = /* @__PURE__ */ ((e) => (e.FRENCH = "fr", e.ENGLISH = "en", e.SPANISH = "es", e.ITALIAN = "it", e.PORTUGUESE = "pt", e.DEUTSCH = "de", e.DUTCH = "nl", e.RUSSIAN = "ru", e.JAPANESE = "ja", e.ARABIC = "ar", e.TURKISH = "tr", e.CHINESE = "zh", e.SWEDISH = "sv", e.ROMANIAN = "ro", e.CZECH = "cs", e.HUNGARIAN = "hu", e.SLOVAK = "sk", e.DANISH = "da", e.INDONESIAN = "id", e.POLISH = "pl", e.GREEK = "el", e.SERBIAN = "sr", e.NORWEGIAN = "no", e.THAI = "th", e.SLOVENIAN = "sl", e.UKRAINIAN = "uk", e.ALBANIA = "sq", e.HINDI = "hi", e))(Tr || {});
const tO = {
  "required-field": "الحقل مطلوب",
  payment: {
    price_plan: "عرض",
    stripe_card: "بطاقة ائتمان أو خصم",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "بطاقات الائتمان (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "بطاقات الائتمان (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "الدفع عند الاستلام",
    xendit_card: "بطاقات الائتمان (Xendit)",
    paystack_card: "بطاقات الإئتمان (Paystack)",
    paypal_connect: "ربط paypal",
    paypal_edit_organization_name: "تعديل اسم المنظمة",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "خطأ",
  "Payment-method": "طريقة دفع",
  price_plan: {
    trial_period: {
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      month_0: "{{count}} شهر",
      month_1: "شهر{{count}}",
      month_2: "شهربن {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان {{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    },
    interval: {
      month_0: "{{count}} شهر",
      month_1: "شهر {{count}}",
      month_2: "شهرين {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان{{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "مجانا",
        trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم",
        unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات"
      }
    }
  },
  affiliate_badge: {
    made_with: "يعمل بواسطة"
  },
  form_select: {
    empty_list: "يبدو أن هذه القائمة فارغة",
    select: "حدد"
  },
  contact_slug: {
    email: "البريد الإلكتروني",
    first_name: "الاسم",
    last_name: "اسم العائلة",
    phone_number: "رقم الهاتف",
    country: "البلد",
    street_address: "عنوان الشارع",
    city: "المدينة",
    postal_code: "الرمز البريدي",
    company_name: "اسم الشركة",
    tax_number: "الرقم الضريبي",
    state_province: "الولاية/المقاطعة",
    street_number: "رقم الشارع",
    neighborhood: "الحي"
  },
  date_picker: {
    apply: "تطبيق",
    clear: "إزالة",
    time: "الوقت",
    all_time: "كل الوقت",
    last_3_months: "آخر 3 أشهر",
    last_pool_period: "فترة التقييم الأخيرة للمجموعة",
    last_month: "الشهر الفائت",
    this_month: "هذا الشهر",
    last_30_days: "آخر 30 يوم",
    title_dates: "تواريخ",
    from: "من",
    to: "إلى"
  },
  copy_clipboard: "تم النسخ في الحافظة",
  payment_inputs: {
    empty_card_number: "أدخل رقم البطاقة",
    invalid_card_number: "رقم البطاقة غير صالح",
    empty_expiry_date: "أدخل تاريخ الانتهاء",
    month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12",
    year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي",
    date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي",
    invalid_expiry_date: "تاريخ الانتهاء غير صالح",
    invalid_cvc: "رمز التحقق غير صالح",
    empty_cvc: "أدخل رمز التحقق",
    card_number_placeholder: "رقم البطاقة",
    expiry_data_placeholder: "الشهر/السنة",
    cvc_placeholder: "رمز التحقق",
    card_holder_placeholder: "حامل البطاقة",
    empty_card_holder: "أدخل اسم حامل البطاقة"
  },
  copy_clipboard_error: "فشل في نسخ النص",
  input: {
    phone_number: "رقم الهاتف",
    phone_search: "بحث",
    search: "بحث"
  },
  "registered-over": "مسجل أكثر من",
  locale: {
    french: "فرنسية",
    german: "ألمانية",
    italian: "ايطالية",
    dutch: "هولندية",
    english: "إنجليزية",
    portuguese: "البرتغالية",
    russian: "الروسية",
    spanish: "الإسبانية",
    japanese: "اليابانية",
    arabic: "العربية",
    turkish: "التركية",
    chinese: "الصينية",
    swedish: "السويدية",
    romanian: "الرومانية",
    czech: "التشيكية",
    hungarian: "الهنغارية",
    slovak: "السلوفاكية",
    danish: "الدانماركية",
    indonesian: "الأندونيسية",
    polish: "البولندية",
    greek: "اليونانية",
    serbian: "الصربية",
    hindi: "الهندية",
    norwegian: "النرويجية",
    thai: "التايلندية",
    slovenian: "السلوفينية",
    ukrainian: "الأوكرانية",
    albania: "الألبانية"
  },
  product: "منتج",
  quantity: "الكمية",
  order_summary: "ملخص الطلب",
  vat: "ضريبة المبيعات",
  total: "المجموع",
  subtotal: "المجموع الفرعي",
  shipping: {
    shipping_method: "طريقة الشحن",
    not_available: "عذرًا! يبدو أننا لا نقدم الشحن إلى هذا الموقع بعد.",
    condition_label: {
      price: "للطلبات التي تتراوح أسعارها بين {{min}} {{currency}} و {{max}} {{currency}}",
      price_min: "للطلبات التي تتراوح أسعارها عند {{min}} {{currency}} أو أكثر",
      quantity: "للطلبات التي تحتوي على بين {{min}} إلى {{max}} عنصر",
      quantity_min: "للطلبات التي تحتوي على {{min}} عنصر أو أكثر",
      weight: "للطلبات التي يبلغ وزنها الإجمالي بين {{min}} غرام إلى {{max}} غرام",
      weight_min: "للطلبات التي يبلغ وزنها الإجمالي {{min}} غرام أو أكثر"
    }
  },
  shipping_fee: "رسوم الشحن",
  total_amount_with_tax_and_shipping: "المجموع (بما في ذلك الضريبة والشحن)",
  vat_percent: "ضريبة المبيعات ({{percent}}%)",
  including_tax: "يشمل {{percent}}٪ ضريبة القيمة المضافة ({{amount}})",
  total_amount_with_tax: "المجموع (شامل الضرائب)",
  total_amount_with_shipping: "المجموع (شامل الشحن)"
}, rO = {
  public_pages_purchase: tO
}, nO = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditní nebo debetní karta",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditní karty (místní)",
    dlocal_boleto: "Boleto (místní)",
    dlocal_pix: "Pix (místní)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditní karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platební trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Dobírka",
    xendit_card: "Kreditní karty (Xendit)",
    paystack_card: "Kreditní karty (Paystack)",
    paypal_connect: "Připojte PayPal",
    paypal_edit_organization_name: "Upravit název organizace",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečte a zaplaťte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Způsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      day_0: "{{count}} den",
      day_1: "{{count}} dny",
      day_2: "{{count}} dní",
      month_0: "{{count}} měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      year_0: "{{count}} rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    },
    interval: {
      month_0: "měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      day_0: "den",
      day_1: "{{count}} dnů",
      day_2: "{{count}} dnů",
      week_0: "týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      year_0: "rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zdarma",
        trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak",
        unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháněno"
  },
  form_select: {
    empty_list: "Vypadá to, že tento seznam je prázdný",
    select: "Vybrat"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Jméno",
    last_name: "Příjmení",
    phone_number: "Telefonní číslo",
    country: "Země",
    street_address: "Ulice",
    city: "Město",
    postal_code: "PSČ",
    company_name: "Název společnosti",
    tax_number: "DIČ",
    state_province: "Stát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Čtvrť"
  },
  date_picker: {
    apply: "Použít",
    clear: "Vymazat",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Poslední 3 měsíce",
    last_pool_period: "Poslední hodnotící období",
    last_month: "Minulý měsíc",
    this_month: "Tento měsíc",
    last_30_days: "Posledních 30 dní",
    title_dates: "Data",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Zkopírováno do schránky",
  payment_inputs: {
    empty_card_number: "Zadejte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadejte datum vypršení platnosti",
    month_out_of_range: "Měsíc vypršení platnosti musí být mezi 01 a 12",
    year_out_of_range: "Rok expirace nemůže být v minulosti",
    date_out_of_range: "Datum expirace nemůže být v minulosti",
    invalid_expiry_date: "Datum expirace je neplatné",
    invalid_cvc: "CVC je neplatné",
    empty_cvc: "Zadejte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držitel karty",
    empty_card_holder: "Zadejte jméno držitele karty"
  },
  copy_clipboard_error: "Kopírování textu se nezdařilo",
  input: {
    phone_number: "Telefonní číslo",
    phone_search: "Hledat",
    search: "Hledat"
  },
  "registered-over": "registrovaných přes",
  locale: {
    french: "Francouzština",
    german: "Němčina",
    italian: "Italština",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalština",
    russian: "Ruština",
    spanish: "Španělština",
    japanese: "Japonština",
    arabic: "Arabština",
    turkish: "Turečtina",
    chinese: "Čínština",
    swedish: "Švédnština",
    romanian: "Rumunština",
    czech: "Čeština",
    hungarian: "Maďarský",
    slovak: "Slovenština",
    danish: "Dánština",
    indonesian: "Indonéština",
    polish: "Polština",
    greek: "Řečtina",
    serbian: "Srbština",
    hindi: "Hindi",
    norwegian: "Norština",
    thai: "Thajština",
    slovenian: "Slovinský",
    ukrainian: "Ukrajinština",
    albania: "Albánština"
  },
  product: "Produkt",
  quantity: "Množství",
  order_summary: "Shrnutí objednávky",
  vat: "Daň z prodeje",
  total: "Celkem",
  subtotal: "Mezisoučet",
  shipping: {
    shipping_method: "Způsob dopravy",
    not_available: "Omlouváme se! Vypadá to, že zatím nenabízíme dopravu na tuto adresu.",
    condition_label: {
      price: "Pro objednávky v cenovém rozmezí {{min}} {{currency}} až {{max}} {{currency}}",
      price_min: "Pro objednávky v ceně {{min}} {{currency}} nebo více",
      quantity: "Pro objednávky obsahující mezi {{min}} a {{max}} položkami",
      quantity_min: "Pro objednávky obsahující {{min}} nebo více položek",
      weight: "Pro objednávky s celkovou hmotností mezi {{min}}g a {{max}}g",
      weight_min: "Pro objednávky s celkovou hmotností {{min}}g nebo více"
    }
  },
  shipping_fee: "Poplatek za dopravu",
  total_amount_with_tax_and_shipping: "Celkem (včetně daně a dopravy)",
  vat_percent: "Daň z prodeje ({{percent}}%)",
  including_tax: "Včetně DPH {{percent}} % ({{amount}})",
  total_amount_with_tax: "Celkem (včetně daně)",
  total_amount_with_shipping: "Celkem (včetně dopravy)"
}, aO = {
  public_pages_purchase: nO
}, iO = {
  "required-field": "Feltet er påkrævet",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredit- eller betalingskort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontant ved levering",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Tilslut PayPal",
    paypal_edit_organization_name: "Rediger organisationens navn",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fejl",
  "Payment-method": "Betalingsmetode",
  price_plan: {
    trial_period: {
      week: "{{count}} uge",
      week_plural: "{{count}} uger",
      day: "{{count}} dag",
      day_plural: "{{count}} dage",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dage",
      week: "uge",
      week_plural: "{{count}} uger",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange"
      }
    }
  },
  affiliate_badge: {
    made_with: "Støttet af"
  },
  form_select: {
    empty_list: "Det ser ud til, at denne liste er tom",
    select: "Vælge"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Fornavn",
    last_name: "Efternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gadeadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "stat/provins",
    street_number: "Gadenummer",
    neighborhood: "Kvarter"
  },
  date_picker: {
    apply: "Anvende",
    clear: "Slet",
    time: "Tid",
    all_time: "Hele tiden",
    last_3_months: "Sidste 3 måneder",
    last_pool_period: "Sidste puljeevalueringsperiode",
    last_month: "Sidste måned",
    this_month: "Denne måned",
    last_30_days: "Sidste 30 dage",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopieret til udklipsholder",
  payment_inputs: {
    empty_card_number: "Indtast et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldigt",
    empty_expiry_date: "Indtast en udløbsdato",
    month_out_of_range: "Udløbsmåned skal være mellem 01 og 12",
    year_out_of_range: "Udløbsåret må ikke ligge i fortiden",
    date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden",
    invalid_expiry_date: "Udløbsdatoen er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Indtast en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Indtast et kortholdernavn"
  },
  copy_clipboard_error: "Teksten kunne ikke kopieres",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søge",
    search: "Søge"
  },
  "registered-over": "registreret over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Hollandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumænsk",
    czech: "Tjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Polsk",
    greek: "Græsk",
    serbian: "Serbisk",
    hindi: "Hindi",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mængde",
  order_summary: "Ordreoversigt",
  vat: "Salgsskat",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Forsendelsesmetode",
    not_available: "Ups! Det ser ud til, at vi endnu ikke tilbyder forsendelse til denne placering.",
    condition_label: {
      price: "For ordrer prissat mellem {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For ordrer prissat til {{min}} {{currency}} eller mere",
      quantity: "For ordrer indeholdende mellem {{min}} og {{max}} varer",
      quantity_min: "For ordrer indeholdende {{min}} eller flere varer",
      weight: "For ordrer med en samlet vægt mellem {{min}}g og {{max}}g",
      weight_min: "For ordrer med en samlet vægt på {{min}}g eller mere"
    }
  },
  shipping_fee: "Forsendelsesgebyr",
  total_amount_with_tax_and_shipping: "I alt (inkl. moms og forsendelse)",
  vat_percent: "Moms ({{percent}} %)",
  including_tax: "Inkluderer {{percent}} % moms ({{amount}})",
  total_amount_with_tax: "Total (inkl. skat)",
  total_amount_with_shipping: "Total (inklusive forsendelse)"
}, oO = {
  public_pages_purchase: iO
}, sO = {
  "required-field": "Das Feld ist erforderlich",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredit- oder Debitkarte",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkarten (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkarten (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Lieferung per Nachnahme",
    xendit_card: "Kreditkarten (Xendit)",
    paystack_card: "Kreditkarten (Paystack)",
    paypal_connect: "PayPal verbinden",
    paypal_edit_organization_name: "Organisationsnamen bearbeiten",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fehler",
  "Payment-method": "Zahlungsmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} Woche",
      week_plural: "{{count}} Wochen",
      day: "{{count}} Tag",
      day_plural: "{{count}} Tage",
      month: "{{count}} Monat",
      month_plural: "{{count}} Monate",
      year: "{{count}} Jahr",
      year_plural: "{{count}} Jahre"
    },
    interval: {
      month: "Monat",
      month_plural: "{{count}} Monate",
      day: "Tag",
      day_plural: "{{count}} Tage",
      week: "Woche",
      week_plural: "{{count}} Wochen",
      year: "Jahr",
      year_plural: "{{count}} Jahre"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Kostenlos",
        trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann",
        unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Unterstützt von"
  },
  form_select: {
    empty_list: "Es sieht so aus, als wäre diese Liste leer",
    select: "Auswählen"
  },
  contact_slug: {
    email: "E-Mail",
    first_name: "Vorname",
    last_name: "Nachname",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Straßenadresse",
    city: "Stadt",
    postal_code: "Postleitzahl",
    company_name: "Firmenname",
    tax_number: "Steuernummer",
    state_province: "Bundesland/Provinz",
    street_number: "Hausnummer",
    neighborhood: "Nachbarschaft"
  },
  date_picker: {
    apply: "Anwenden",
    clear: "Löschen",
    time: "Zeit",
    all_time: "Alle Zeiten",
    last_3_months: "Letzte 3 Monate",
    last_pool_period: "Letzter Pool-Auswertungszeitraum",
    last_month: "Letzter Monat",
    this_month: "Dieser Monat",
    last_30_days: "Letzte 30 Tage",
    title_dates: "Termine",
    from: "Von",
    to: "Nach"
  },
  copy_clipboard: "In die Zwischenablage kopiert",
  payment_inputs: {
    empty_card_number: "Eine Kartennummer eingeben",
    invalid_card_number: "Kartennummer ist ungültig",
    empty_expiry_date: "Geben Sie ein Verfallsdatum ein",
    month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen",
    year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen",
    date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen",
    invalid_expiry_date: "Verfallsdatum ist ungültig",
    invalid_cvc: "CVC ist ungültig",
    empty_cvc: "Einen CVC eingeben",
    card_number_placeholder: "Kartennummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Karteninhaber",
    empty_card_holder: "Name des Karteninhabers eingeben"
  },
  copy_clipboard_error: "Text konnte nicht kopiert werden",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Suchen",
    search: "Suchen"
  },
  "registered-over": "registriert über",
  locale: {
    french: "Französisch",
    german: "Deutsch",
    italian: "Italienisch",
    dutch: "Niederländisch",
    english: "Englisch",
    portuguese: "Portugiesisch",
    russian: "Russisch",
    spanish: "Spanisch",
    japanese: "Japanisch",
    arabic: "Arabisch",
    turkish: "Türkisch",
    chinese: "Chinesisch",
    swedish: "Schwedisch",
    romanian: "Rumänisch",
    czech: "Tschechisch",
    hungarian: "Ungarisch",
    slovak: "Slowakisch",
    danish: "Dänisch",
    indonesian: "Indonesisch",
    polish: "Polnisch",
    greek: "Griechisch",
    serbian: "Serbisch",
    hindi: "Hindi",
    norwegian: "Norwegisch",
    thai: "Thailändisch",
    slovenian: "Slowenisch",
    ukrainian: "Ukrainisch",
    albania: "Albanisch"
  },
  product: "Produkt",
  quantity: "Menge",
  order_summary: "Bestellübersicht",
  vat: "Mehrwertsteuer",
  total: "Gesamt",
  subtotal: "Zwischensumme",
  shipping: {
    shipping_method: "Versandmethode",
    not_available: "Ups! Es scheint, dass wir noch keinen Versand an diesen Standort anbieten.",
    condition_label: {
      price: "Für Bestellungen im Wert von {{min}} {{currency}} bis {{max}} {{currency}}",
      price_min: "Für Bestellungen im Wert von {{min}} {{currency}} oder mehr",
      quantity: "Für Bestellungen mit {{min}} bis {{max}} Artikeln",
      quantity_min: "Für Bestellungen mit {{min}} oder mehr Artikeln",
      weight: "Für Bestellungen mit einem Gesamtgewicht zwischen {{min}}g und {{max}}g",
      weight_min: "Für Bestellungen mit einem Gesamtgewicht von {{min}}g oder mehr"
    }
  },
  shipping_fee: "Versandgebühr",
  total_amount_with_tax_and_shipping: "Gesamt (inklusive Steuern und Versand)",
  vat_percent: "Umsatzsteuer ({{percent}} %)",
  including_tax: "Enthält {{percent}} % MwSt. ({{amount}})",
  total_amount_with_tax: "Gesamtbetrag (inkl. Steuern)",
  total_amount_with_shipping: "Gesamtbetrag (einschließlich Versand)"
}, lO = {
  public_pages_purchase: sO
}, cO = {
  "required-field": "Το πεδίο είναι υποχρεωτικό",
  payment: {
    price_plan: "Πλάνο",
    stripe_card: "Πιστωτική ή χρεωστική κάρτα",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Τραπεζικές κάρτες (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Τραπεζικές κάρτες (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Με αντικαταβολή",
    xendit_card: "Τραπεζικές κάρτες (Xendit)",
    paystack_card: "Τραπεζικές κάρτες (Paystack)",
    paypal_connect: "Σύνδεση με PayPal",
    paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Σφάλμα",
  "Payment-method": "Τρόπος πληρωμής",
  price_plan: {
    trial_period: {
      week: "{{count}} εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      day: "{{count}} ημέρα",
      day_plural: "{{count}} ημέρες",
      month: "{{count}} μήνας",
      month_plural: "{{count}} μήνες",
      year: "{{count}} έτος",
      year_plural: "{{count}} έτη"
    },
    interval: {
      month: "μήνας",
      month_plural: "{{count}} μήνες",
      day: "ημέρα",
      day_plural: "{{count}} ημέρες",
      week: "εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      year: "έτος",
      year_plural: "{{count}} έτη"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Δωρεάν",
        trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} και έπειτα",
        unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή",
    select: "Επιλογή"
  },
  contact_slug: {
    email: "Email",
    first_name: "Όνομα",
    last_name: "Επώνυμο",
    phone_number: "Τηλέφωνο",
    country: "Χώρα",
    street_address: "Διεύθυνση",
    city: "Πόλη",
    postal_code: "Ταχυδρομικός κώδικας",
    company_name: "Επωνυμία εταιρίας",
    tax_number: "Α.Φ.Μ.",
    state_province: "Νομός",
    street_number: "Αριθμός οδού",
    neighborhood: "Γειτονιά"
  },
  date_picker: {
    apply: "Υποβολή",
    clear: "Επαναφορά",
    time: "Χρόνος",
    all_time: "Συνολικά",
    last_3_months: "Τελευταίοι 3 μήνες",
    last_pool_period: "Τελευταία περίοδος αξιολόγησης email",
    last_month: "Προηγούμενος μήνας",
    this_month: "Αυτό το μήνα",
    last_30_days: "Τελευταίες 30 ημέρες",
    title_dates: "Ημερομηνίες",
    from: "Από",
    to: "Προς"
  },
  copy_clipboard: "Επιτυχής αντιγραφή",
  payment_inputs: {
    empty_card_number: "Εισάγετε έναν αριθμό κάρτας",
    invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος",
    empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης",
    month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12",
    year_out_of_range: "Η χρονολογία λήξης δεν μπορεί να είναι στο παρελθόν",
    date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν",
    invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη",
    invalid_cvc: "Το CVC είναι μη έγκυρο",
    empty_cvc: "Εισάγετε το CVC",
    card_number_placeholder: "Αριθμός κάρτας",
    expiry_data_placeholder: "ΜΜ/ΕΕ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Κάτοχος κάρτας",
    empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας"
  },
  copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου",
  input: {
    phone_number: "Τηλέφωνο",
    phone_search: "Αναζήτηση",
    search: "Αναζήτηση"
  },
  "registered-over": "εγγεγραμμένο πάνω από",
  locale: {
    french: "Γαλλικά",
    german: "Γερμανικά",
    italian: "Ιταλικά",
    dutch: "Ολλανδικά",
    english: "Αγγλικά",
    portuguese: "Πορτογαλικά",
    russian: "Ρωσικά",
    spanish: "Ισπανικά",
    japanese: "Ιαπωνικά",
    arabic: "Αραβικά",
    turkish: "Τούρκικα",
    chinese: "Κινέζικα",
    swedish: "Σουηδικά",
    romanian: "Ρουμανικά",
    czech: "Τσέχικα",
    hungarian: "Ουγγρικά",
    slovak: "Σλοβάκικα",
    danish: "Δανικά",
    indonesian: "Ινδονησιακά",
    polish: "Πολωνικά",
    greek: "Ελληνικά",
    serbian: "Σερβικά",
    hindi: "Ινδικά",
    norwegian: "Νορβηγικά",
    thai: "Ταϊλανδέζικα",
    slovenian: "Σλοβενικά",
    ukrainian: "Ουκρανικά",
    albania: "Αλβανικά"
  },
  product: "Προϊόν",
  quantity: "Ποσότητα",
  order_summary: "Σύνοψη Παραγγελίας",
  vat: "Φόρος πωλήσεων",
  total: "Σύνολο",
  subtotal: "Μερικό σύνολο",
  shipping: {
    shipping_method: "Τρόπος αποστολής",
    not_available: "Ωχ. Φαίνεται ότι δεν προσφέρουμε αποστολή σε αυτήν την τοποθεσία ακόμη",
    condition_label: {
      price: "Για παραγγελίες αξίας από {{min}} {{currency}} έως {{max}} {{currency}}",
      price_min: "Για παραγγελίες αξίας τουλάχιστον {{min}} {{currency}}",
      quantity: "Για παραγγελίες που περιέχουν από {{min}} έως {{max}} αντικείμενα",
      quantity_min: "Για παραγγελίες που περιέχουν τουλάχιστον {{min}} αντικείμενα",
      weight: "Για παραγγελίες με συνολικό βάρος από {{min}}g έως {{max}}g",
      weight_min: "Για παραγγελίες με συνολικό βάρος τουλάχιστον {{min}}g"
    }
  },
  shipping_fee: "Χρέωση αποστολής",
  total_amount_with_tax_and_shipping: "Σύνολο (συμπεριλαμβανομένων φόρων και αποστολής)",
  vat_percent: "ΦΠΑ ({{percent}}%)",
  including_tax: "Συμπεριλαμβάνει {{percent}}% ΦΠΑ ({{amount}})",
  total_amount_with_tax: "Σύνολο (συμπεριλαμβανομένου φόρου)",
  total_amount_with_shipping: "Σύνολο (συμπεριλαμβανομένων των μεταφορικών)"
}, uO = {
  public_pages_purchase: cO
}, dO = {
  "required-field": "Field is required",
  payment: {
    price_plan: "Plan",
    stripe_card: "Credit or debit card",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Credit cards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Credit cards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Cash on delivery",
    xendit_card: "Credit cards (Xendit)",
    paystack_card: "Credit cards (Paystack)",
    paypal_connect: "Connect PayPal",
    paypal_edit_organization_name: "Edit organization name",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Payment method",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weeks",
      day: "{{count}} day",
      day_plural: "{{count}} days",
      month: "{{count}} month",
      month_plural: "{{count}} months",
      year: "{{count}} year",
      year_plural: "{{count}} years"
    },
    interval: {
      month: "month",
      month_plural: "{{count}} months",
      day: "day",
      day_plural: "{{count}} days",
      week: "week",
      week_plural: "{{count}} weeks",
      year: "year",
      year_plural: "{{count}} years"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Free",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then",
        unlimited_new: "<bold>{{amount}}</bold> every {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "It looks like this list is empty",
    select: "Select"
  },
  contact_slug: {
    email: "Email",
    first_name: "First name",
    last_name: "Last name",
    phone_number: "Phone number",
    country: "Country",
    street_address: "Street address",
    city: "City",
    postal_code: "Postal code",
    company_name: "Company name",
    tax_number: "Tax number",
    state_province: "State/Province",
    street_number: "Street number",
    neighborhood: "Neighborhood"
  },
  date_picker: {
    apply: "Apply",
    clear: "Clear",
    time: "Time",
    all_time: "All time",
    last_3_months: "Last 3 months",
    last_pool_period: "Last pool evaluation period",
    last_month: "Last month",
    this_month: "This month",
    last_30_days: "Last 30 days",
    title_dates: "Dates",
    from: "From",
    to: "To"
  },
  copy_clipboard: "Copied to clipboard",
  payment_inputs: {
    empty_card_number: "Enter a card number",
    invalid_card_number: "Card number is invalid",
    empty_expiry_date: "Enter an expiry date",
    month_out_of_range: "Expiry month must be between 01 and 12",
    year_out_of_range: "Expiry year cannot be in the past",
    date_out_of_range: "Expiry date cannot be in the past",
    invalid_expiry_date: "Expiry date is invalid",
    invalid_cvc: "CVC is invalid",
    empty_cvc: "Enter a CVC",
    card_number_placeholder: "Card number",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Card holder",
    empty_card_holder: "Enter a card holder name"
  },
  copy_clipboard_error: "Failed to copy text",
  input: {
    phone_number: "Phone number",
    phone_search: "Search",
    search: "Search"
  },
  "registered-over": "registered over",
  locale: {
    french: "French",
    german: "German",
    italian: "Italiano",
    dutch: "Dutch",
    english: "English",
    portuguese: "Portuguese",
    russian: "Russian",
    spanish: "Spanish",
    japanese: "Japanese",
    arabic: "Arabic",
    turkish: "Turkish",
    chinese: "Chinese",
    swedish: "Swedish",
    romanian: "Romanian",
    czech: "Czech",
    hungarian: "Hungarian",
    slovak: "Slovak",
    danish: "Danish",
    indonesian: "Indonesian",
    polish: "Polish",
    greek: "Greek",
    serbian: "Serbian",
    hindi: "Hindi",
    norwegian: "Norwegian",
    thai: "Thai",
    slovenian: "Slovenian",
    ukrainian: "Ukrainian",
    albania: "Albanian"
  },
  product: "Product",
  quantity: "Quantity",
  order_summary: "Order summary",
  vat: "Sales tax",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Shipping method",
    not_available: "Oops! It looks like we don't offer shipping to this location yet",
    condition_label: {
      price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}",
      price_min: "For orders priced at {{min}} {{currency}} or more",
      quantity: "For orders containing between {{min}} to {{max}} items",
      quantity_min: "For orders containing {{min}} or more items",
      weight: "For orders with a total weight between {{min}}g to {{max}}g",
      weight_min: "For orders with a total weight of {{min}}g or more"
    }
  },
  shipping_fee: "Shipping fee",
  total_amount_with_tax_and_shipping: "Total (including tax and Shipping)",
  vat_percent: "Sales tax ({{percent}}%)",
  including_tax: "Includes {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "Total (including tax)",
  total_amount_with_shipping: "Total (including Shipping)"
}, pO = {
  public_pages_purchase: dO
}, hO = {
  "required-field": "El campo es necesario",
  payment: {
    price_plan: "Plan",
    stripe_card: "Tarjeta de crédito o débito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Tarjetas de crédito (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Tarjetas de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pago contra entrega",
    xendit_card: "Tarjetas de crédito (Xendit)",
    paystack_card: "Tarjetas de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar el nombre de la organización",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Método de pago",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} día",
      day_plural: "{{count}} días",
      month: "{{count}} mes",
      month_plural: "{{count}} meses",
      year: "{{count}} año",
      year_plural: "{{count}} años"
    },
    interval: {
      month: "mes",
      month_plural: "{{count}} meses",
      day: "día",
      day_plural: "{{count}} días",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "año",
      year_plural: "{{count}} años"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego",
        unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desarrollado por"
  },
  form_select: {
    empty_list: "Parece que esta lista está vacía",
    select: "Seleccionar"
  },
  contact_slug: {
    email: "Correo",
    first_name: "Nombre",
    last_name: "Apellido",
    phone_number: "Número de teléfono",
    country: "País",
    street_address: "Dirección",
    city: "Ciudad",
    postal_code: "Código postal",
    company_name: "Nombre de la empresa",
    tax_number: "Número de IVA",
    state_province: "Estado/Provincia",
    street_number: "Dirección",
    neighborhood: "Barrio"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Borrar",
    time: "Hola",
    all_time: "Desde siempre",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último periodo de evaluación de la pool",
    last_month: "Último mes",
    this_month: "Este mes",
    last_30_days: "Últimos 30 días",
    title_dates: "Fechas",
    from: "Desde",
    to: "Hasta"
  },
  copy_clipboard: "Copiado en el portapapeles",
  payment_inputs: {
    empty_card_number: "Ingresa un número de tarjeta",
    invalid_card_number: "El número de tarjeta no es válido",
    empty_expiry_date: "Ingresa la fecha de expiración",
    month_out_of_range: "El mes de expiración debe estar entre 01 y 12",
    year_out_of_range: "El año de expiración no puede estar situado en el pasado",
    date_out_of_range: "La fecha de expiración no puede estar situada en el pasado",
    invalid_expiry_date: "La fecha de expiracion no es válida",
    invalid_cvc: "El CVC no es válido",
    empty_cvc: "Ingresa un CVC",
    card_number_placeholder: "Número de tarjeta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titular de la tarjeta",
    empty_card_holder: "Ingresa el nombre del titular de la tarjeta"
  },
  copy_clipboard_error: "Error el copiar el texto",
  input: {
    phone_number: "Teléfono",
    phone_search: "Buscar",
    search: "Buscar"
  },
  "registered-over": "registrado hace más de",
  locale: {
    french: "Francés",
    german: "Alemán",
    italian: "Italiano",
    dutch: "Holandés",
    english: "Inglés",
    portuguese: "Portugués",
    russian: "Ruso",
    spanish: "Español",
    japanese: "Japonés",
    arabic: "árabe",
    turkish: "Turco",
    chinese: "Chino",
    swedish: "Sueco",
    romanian: "Rumano",
    czech: "Checo",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Danés",
    indonesian: "Indonesio",
    polish: "Polaco",
    greek: "Griego",
    serbian: "Serbio",
    hindi: "Hindi",
    norwegian: "Noruego",
    thai: "Tailandés",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanés"
  },
  product: "Producto",
  quantity: "Cantidad",
  order_summary: "Resumen del pedido",
  vat: "IVA",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envío",
    not_available: "¡Vaya! Parece que aún no ofrecemos envíos a esta ubicación",
    condition_label: {
      price: "Para pedidos con precio entre {{min}} {{currency}} y {{max}} {{currency}}",
      price_min: "Para pedidos que cuesten {{min}} {{currency}} o más",
      quantity: "Para pedidos de entre {{min}} y {{max}} artículos",
      quantity_min: "Para pedidos con {{min}} o más artículos",
      weight: "Para pedidos con un peso total entre {{min}}g y {{max}}g",
      weight_min: "Para pedidos con un peso total de {{min}}g o más"
    }
  },
  shipping_fee: "Tarifa de envío",
  total_amount_with_tax_and_shipping: "Total (incluyendo impuestos y envío)",
  vat_percent: "IVA ({{percent}}%)",
  including_tax: "Incluye el {{percent}}% de IVA ({{amount}})",
  total_amount_with_tax: "Total (impuestos incluidos)",
  total_amount_with_shipping: "Total (incluyendo envío)"
}, mO = {
  public_pages_purchase: hO
}, fO = {
  "required-field": "Le champ est obligatoire",
  payment: {
    price_plan: "Plan",
    stripe_card: "Carte de crédit ou de débit",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "BanContact (Stripe)",
    dlocal_card: "Cartes de crédit (Dlocal)",
    dlocal_boleto: "Billet (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartes de crédit (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Paiement à la livraison",
    xendit_card: "Cartes de crédit (Xendit)",
    paystack_card: "Cartes de crédit (Paystack)",
    paypal_connect: "Connectez-vous à PayPal",
    paypal_edit_organization_name: "Modifier le nom de l'organisation",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erreur",
  "Payment-method": "Mode de paiement",
  price_plan: {
    trial_period: {
      week: "{{count}} semaine",
      week_plural: "{{count}} semaines",
      day: "{{count}} jour",
      day_plural: "{{count}} jours",
      month: "{{count}} mois",
      month_plural: "{{count}} mois",
      year: "{{count}} an",
      year_plural: "{{count}} ans"
    },
    interval: {
      month: "mois",
      month_plural: "{{count}} mois",
      day: "jour",
      day_plural: "{{count}} jours",
      week: "semaine",
      week_plural: "{{count}} semaines",
      year: "an",
      year_plural: "{{count}} ans"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis",
        unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois"
      }
    }
  },
  affiliate_badge: {
    made_with: "Développé par"
  },
  form_select: {
    empty_list: "Cette liste semble vide",
    select: "Sélectionner"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prénom",
    last_name: "Nom",
    phone_number: "Numéro de téléphone",
    country: "Pays",
    street_address: "Adresse",
    city: "Ville",
    postal_code: "Code postal",
    company_name: "Nom de l'entreprise",
    tax_number: "Numéro d'identification fiscale",
    state_province: "Région",
    street_number: "Numéro de rue",
    neighborhood: "Quartier"
  },
  date_picker: {
    apply: "Appliquer",
    clear: "Effacer",
    time: "Horaire",
    all_time: "Depuis le début",
    last_3_months: "Les 3 derniers mois",
    last_pool_period: "Dernière période d'évaluation du pool",
    last_month: "Le mois dernier",
    this_month: "Ce mois",
    last_30_days: "Les 30 derniers jours",
    title_dates: "Dates",
    from: "De",
    to: "À"
  },
  copy_clipboard: "Copié dans le presse-papier",
  payment_inputs: {
    empty_card_number: "Entrez un numéro de carte",
    invalid_card_number: "Le numéro de carte est invalide",
    empty_expiry_date: "Entrez une date d'expiration",
    month_out_of_range: "Le mois d’expiration doit être entre 01 et 12",
    year_out_of_range: "L'année d'expiration ne peut pas être dans le passé",
    date_out_of_range: "La date d’expiration ne peut pas être dans le passé",
    invalid_expiry_date: "La date d’expiration est invalide",
    invalid_cvc: "Le code CVC est invalide",
    empty_cvc: "Saisissez le code CVC",
    card_number_placeholder: "Numéro de carte",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titulaire de la carte",
    empty_card_holder: "Saisir le nom du titulaire de la carte"
  },
  copy_clipboard_error: "Échec de la copie du texte",
  input: {
    phone_number: "Numéro de téléphone",
    phone_search: "Recherche",
    search: "Recherche"
  },
  "registered-over": "enregistré plus de",
  locale: {
    french: "Français",
    german: "Allemand",
    italian: "Italiano",
    dutch: "Néerlandais",
    english: "Anglais",
    portuguese: "Portugais",
    russian: "Russe",
    spanish: "Espagnol",
    japanese: "Japonais",
    arabic: "Аrabe",
    turkish: "Turc",
    chinese: "Chinois",
    swedish: "Suédois",
    romanian: "Roumain",
    czech: "Tchèque",
    hungarian: "Hongrois",
    slovak: "Slovaque",
    danish: "Danois",
    indonesian: "Indonésien",
    polish: "Polonais",
    greek: "Grec",
    serbian: "Serbe",
    hindi: "Indien",
    norwegian: "Norvégien",
    thai: "Thaïlandais",
    slovenian: "Slovène",
    ukrainian: "Ukrainien",
    albania: "Albanais"
  },
  product: "Produit",
  quantity: "Quantité",
  order_summary: "Résumé de la commande",
  vat: "TVA",
  total: "Total",
  subtotal: "Sous-total",
  shipping: {
    shipping_method: "Méthode d'expédition",
    not_available: "Oups ! Il semble qu'on ne livre pas encore à cet endroit",
    condition_label: {
      price: "Pour les commandes dont le prix est compris entre {{min}} {{currency}} et {{max}} {{currency}}",
      price_min: "Pour les commandes dont le prix est de {{min}} {{currency}} ou plus",
      quantity: "Pour les commandes contenant entre {{min}} et {{max}} articles",
      quantity_min: "Pour les commandes contenant {{min}} articles ou plus",
      weight: "Pour les commandes avec un poids total compris entre {{min}}g et {{max}}g",
      weight_min: "Pour les commandes avec un poids total de {{min}}g ou plus"
    }
  },
  shipping_fee: "Frais d'expédition",
  total_amount_with_tax_and_shipping: "Total (y compris la TVA et l'expédition)",
  vat_percent: "TVA ({{percent}}%)",
  including_tax: "Comprend {{percent}} % de TVA ({{amount}})",
  total_amount_with_tax: "Total (TVA incluse)",
  total_amount_with_shipping: "Total (y compris livraison)"
}, CO = {
  public_pages_purchase: fO
}, gO = {
  "required-field": "यह फील्ड भरना अनिवार्य है",
  payment: {
    price_plan: "प्लान",
    stripe_card: "क्रेडिट या डेबिट कार्ड",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)",
    dlocal_card: "क्रेडिट कार्ड्स (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "कैश-ऑन-डिलीवरी",
    xendit_card: "क्रेडिट कार्ड्स (Xendit)",
    paystack_card: "क्रेडिट कार्ड्स (Paystack)",
    paypal_connect: "Paypal से जुड़ें",
    paypal_edit_organization_name: "संगठन का नाम एडिट करें",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "एप्पल पे",
    xendit: {
      "3ds": "3D-सिक्योर"
    }
  },
  error: "एरर",
  "Payment-method": "पेमेंट मेथड",
  price_plan: {
    trial_period: {
      week: "{{count}} सप्ताह",
      week_plural: "{{count}} दिन",
      day: "{{count}} दिन",
      day_plural: "{{count}} दिन",
      month: "{{count}} महीना",
      month_plural: "{{count}} महीने",
      year: "{{count}} वर्ष",
      year_plural: "{{count}} वर्ष"
    },
    interval: {
      month: "महीना",
      month_plural: "{{count}} महीने",
      day: "दिन",
      day_plural: "{{count}} दिन",
      week: "सप्ताह",
      week_plural: "{{count}} सप्ताह",
      year: "वर्ष",
      year_plural: "{{count}} वर्ष"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "मुफ्त",
        trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर",
        unlimited_new: "{{amount}} हर {{interval}} पर",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार"
      }
    }
  },
  affiliate_badge: {
    made_with: "द्वारा संचालित"
  },
  form_select: {
    empty_list: "लगता है यह लिस्ट खाली है",
    select: "चूनें"
  },
  contact_slug: {
    email: "ईमेल",
    first_name: "प्रथम नाम",
    last_name: "अंतिम नाम",
    phone_number: "फ़ोन नंबर",
    country: "देश",
    street_address: "सड़क का पता",
    city: "शहर",
    postal_code: "पोस्टल कोड",
    company_name: "कंपनी का नाम",
    tax_number: "टैक्स नंबर",
    state_province: "राज्य/प्रान्त",
    street_number: "सड़क संख्या",
    neighborhood: "पड़ोस"
  },
  date_picker: {
    apply: "लागू करें",
    clear: "हटाएं",
    time: "समय",
    all_time: "सभी समय",
    last_3_months: "पिछले 3 महीने",
    last_pool_period: "पिछले पूल मूल्यांकन अवधि",
    last_month: "पिछले महीने",
    this_month: "इस महीने",
    last_30_days: "पिछले 30 दिन",
    title_dates: "दिनांक",
    from: "से",
    to: "तक"
  },
  copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया",
  payment_inputs: {
    empty_card_number: "कार्ड नंबर दर्ज करें",
    invalid_card_number: "कार्ड नंबर अमान्य है ",
    empty_expiry_date: "समाप्ति तिथि दर्ज करें",
    month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ",
    year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता",
    date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती",
    invalid_expiry_date: "समाप्ति तिथि अमान्य है",
    invalid_cvc: "CVC अमान्य है",
    empty_cvc: "CVC दर्ज करें  ",
    card_number_placeholder: "कार्ड नंबर",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "कार्ड धारक",
    empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें"
  },
  copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल",
  input: {
    phone_number: "फोन नंबर",
    phone_search: "खोजें",
    search: "खोजें"
  },
  "registered-over": "पंजीकृत किया गया",
  locale: {
    french: "फ्रेंच",
    german: "जर्मन",
    italian: "इटैलिनो",
    dutch: "डच",
    english: "अंग्रेज़ी",
    portuguese: "पुर्तगाली",
    russian: "रूसी",
    spanish: "स्पैनिश",
    japanese: "जापानी",
    arabic: "अरबी",
    turkish: "तुर्की",
    chinese: "चीनी",
    swedish: "स्वीडिश",
    romanian: "रोमानियाई",
    czech: "चेक",
    hungarian: "हंगेरीअन ",
    slovak: "स्लोवाक",
    danish: "डैनिश",
    indonesian: "इन्डोनेशियाई",
    polish: "पोलिश",
    greek: "यूनानी",
    serbian: "सर्बियाई",
    hindi: "हिंदी ",
    norwegian: "नार्वेजियन",
    thai: "थाई",
    slovenian: "स्लोवेनियाई",
    ukrainian: "यूक्रेनी",
    albania: "अल्बानियन"
  },
  product: "प्रोडक्ट",
  quantity: "क्वान्टिटी",
  order_summary: "ऑर्डर समरी",
  vat: "सेल्स टैक्स",
  total: "टोटल",
  subtotal: "सब टोटल ",
  shipping: {
    shipping_method: "शिपिंग मेथड",
    not_available: "अरे! ऐसा लगता है कि हम अभी इस स्थान पर शिपिंग की पेशकश नहीं करते है ",
    condition_label: {
      price: "{{min}} {{currency}} से {{max}} {{currency}} के बीच प्राइस वाले ऑर्डर्स के लिए",
      price_min: "{{min}} {{currency}} या अधिक प्राइस वाले ऑर्डर्स के लिए",
      quantity: "{{min}} से {{max}} आइटम वाले ऑर्डर्स के लिए",
      quantity_min: "{{min}} या अधिक आइटम वाले ऑर्डर्स के लिए",
      weight: "{{min}}g से {{max}}g के बीच कुल वजन वाले ऑर्डर्स के लिए",
      weight_min: "{{min}}g या अधिक कुल वजन वाले ऑर्डर्स के लिए"
    }
  },
  shipping_fee: "शिपिंग शुल्क",
  total_amount_with_tax_and_shipping: "कुल (कर और शिपिंग सहित)",
  vat_percent: "सेल्स टैक्स ({{percent}}%)",
  including_tax: "शामिल है {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "कुल (कर सहित)",
  total_amount_with_shipping: "कुल (शिपिंग सहित)"
}, yO = {
  public_pages_purchase: gO
}, vO = {
  "required-field": "A mező kitöltése kötelező",
  payment: {
    price_plan: "Terv",
    stripe_card: "Hitel- vagy betéti kártya",
    stripe_ideal: "iDeal (csík)",
    stripe_bancotact: "Bancontact (csíkos)",
    dlocal_card: "Hitelkártyák (Dlocal)",
    dlocal_boleto: "Boleto (helyi)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Hitelkártyák (Mercado Pago)",
    mercadopago_pix: "PIX (fizetési piac)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Utánvétes fizetés",
    xendit_card: "Hitelkártyák (Xendit)",
    paystack_card: "Hitelkártyák (Paystack)",
    paypal_connect: "Csatlakoztassa a PayPal-t",
    paypal_edit_organization_name: "Szerkessze a szervezet nevét",
    paypal_rest: "PayPal",
    secure_and_pay: "Biztonságos és fizetés",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Hiba",
  "Payment-method": "Fizetési mód",
  price_plan: {
    trial_period: {
      week: "{{count}} hét",
      week_plural: "{{count}} hét",
      day: "{{count}} nap",
      day_plural: "{{count}} nap",
      month: "{{count}} hónap",
      month_plural: "{{count}} hónap",
      year: "{{count}} év",
      year_plural: "{{count}} év"
    },
    interval: {
      month: "hónap",
      month_plural: "{{count}} hónap",
      day: "nap",
      day_plural: "{{count}} nap",
      week: "hét",
      week_plural: "{{count}} hét",
      year: "év",
      year_plural: "{{count}} év"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ingyenes",
        trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Úgy tűnik, hogy ez a lista üres",
    select: "Kiválasztás"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Keresztnév",
    last_name: "Vezetéknév",
    phone_number: "Telefonszám",
    country: "Ország",
    street_address: "Utca cím",
    city: "Város",
    postal_code: "Irányítószám",
    company_name: "Cégnév",
    tax_number: "Adószám",
    state_province: "Állam/Mező",
    street_number: "Utca szám",
    neighborhood: "Környék"
  },
  date_picker: {
    apply: "Alkalmaz",
    clear: "Törlés",
    time: "Idő",
    all_time: "Minden idő",
    last_3_months: "Utolsó 3 hónap",
    last_pool_period: "Utolsó medenceértékelési időszak",
    last_month: "Utolsó hónap",
    this_month: "Ez a hónap",
    last_30_days: "Utolsó 30 nap",
    title_dates: "Dátumok",
    from: "Tól",
    to: "Ig"
  },
  copy_clipboard: "Másolva a vágólapra",
  payment_inputs: {
    empty_card_number: "Adjon meg egy kártyaszámot",
    invalid_card_number: "A kártyaszám érvénytelen",
    empty_expiry_date: "Adjon meg egy lejárati dátumot",
    month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie",
    year_out_of_range: "A lejárati év nem lehet a múltban",
    date_out_of_range: "A lejárati dátum nem lehet a múltban",
    invalid_expiry_date: "A lejárati dátum érvénytelen",
    invalid_cvc: "A CVC érvénytelen",
    empty_cvc: "Adja meg a CVC-t",
    card_number_placeholder: "Kártyaszám",
    expiry_data_placeholder: "HH/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kártyabirtokos",
    empty_card_holder: "Adja meg a kártyabirtokos nevét"
  },
  copy_clipboard_error: "A szöveg másolása nem sikerült",
  input: {
    phone_number: "Telefonszám",
    phone_search: "Keresés",
    search: "Keresés"
  },
  "registered-over": "regisztrált több mint",
  locale: {
    french: "Francia",
    german: "Német",
    italian: "Olasz",
    dutch: "Holland",
    english: "Angol",
    portuguese: "Portugál",
    russian: "Orosz",
    spanish: "Spanyol",
    japanese: "Japán",
    arabic: "Arab",
    turkish: "Török",
    chinese: "Kínai",
    swedish: "Svéd",
    romanian: "Román",
    czech: "Cseh",
    hungarian: "Magyar",
    slovak: "Szlovák",
    danish: "Dán",
    indonesian: "Indonéz",
    polish: "Fényesít",
    greek: "Görög",
    serbian: "Szerb",
    hindi: "Dehogy",
    norwegian: "Norvég",
    thai: "Thai",
    slovenian: "Szlovén",
    ukrainian: "Ukrán",
    albania: "Albán"
  },
  product: "Termék",
  quantity: "Mennyiség",
  order_summary: "Rendelés összegzése",
  vat: "Áfa",
  total: "Összesen",
  subtotal: "Részösszeg",
  shipping: {
    shipping_method: "Szállítási mód",
    not_available: "Hoppá! Úgy tűnik, hogy még nem kínálunk szállítást erre a helyre.",
    condition_label: {
      price: "A {{min}} {{currency}} és {{max}} {{currency}} közötti árú rendelésekhez",
      price_min: "A {{min}} {{currency}} vagy annál drágább rendelésekhez",
      quantity: "A {{min}} és {{max}} közötti tételeket tartalmazó rendelésekhez",
      quantity_min: "A {{min}} vagy annál több tételt tartalmazó rendelésekhez",
      weight: "A {{min}}g és {{max}}g közötti összsúlyú rendelésekhez",
      weight_min: "A {{min}}g vagy annál nehezebb rendelésekhez"
    }
  },
  shipping_fee: "Szállítási díj",
  total_amount_with_tax_and_shipping: "Összesen (beleértve az adót és a szállítást)",
  vat_percent: "Áruforgalmi adó ({{percent}}%)",
  including_tax: "ÁFA {{percent}}%-ot tartalmaz ({{amount}})",
  total_amount_with_tax: "Összesen (beleértve az adót)",
  total_amount_with_shipping: "Összesen (beleértve a szállítást)"
}, bO = {
  public_pages_purchase: vO
}, _O = {
  "required-field": "Bidang wajib diisi",
  payment: {
    price_plan: "Rencana",
    stripe_card: "Kartu kredit atau debit",
    stripe_ideal: "iDeal (Garis)",
    stripe_bancotact: "Bancontact (Garis)",
    dlocal_card: "Kartu kredit (Dlokal)",
    dlocal_boleto: "Boleto (Dlokal)",
    dlocal_pix: "Pix (Dlokal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartu kredit (Mercado Pago)",
    mercadopago_pix: "PIX (Pasar Pembayaran)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Pembayaran pisau cukur",
    flutterwave: "Gelombang bergetar",
    mollie: "Mollie",
    gocardless: "Tanpa kartu",
    cash_on_delivery: "Bayar di tempat",
    xendit_card: "Kartu kredit (Xendit)",
    paystack_card: "Kartu kredit (Paystack)",
    paypal_connect: "Hubungkan PayPal",
    paypal_edit_organization_name: "Edit nama organisasi",
    paypal_rest: "PayPal",
    secure_and_pay: "Amankan dan Bayar",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Kesalahan",
  "Payment-method": "Metode pembayaran",
  price_plan: {
    trial_period: {
      week: "{{count}} minggu",
      day: "{{count}} hari",
      month: "{{count}} bulan",
      year: "{{count}} tahun"
    },
    interval: {
      month: "bulan",
      day: "hari",
      week: "pekan",
      year: "tahun"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bebas",
        trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu",
        unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ditenagai oleh"
  },
  form_select: {
    empty_list: "Sepertinya daftar ini kosong",
    select: "Pilih"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nama depan",
    last_name: "Nama belakang",
    phone_number: "Nomor telepon",
    country: "Negara",
    street_address: "Alamat jalan",
    city: "Kota",
    postal_code: "Kode pos",
    company_name: "Nama perusahaan",
    tax_number: "Nomor pajak",
    state_province: "Negara Bagian/Provinsi",
    street_number: "Nomor jalan",
    neighborhood: "Lingkungan"
  },
  date_picker: {
    apply: "Terapkan",
    clear: "Bersihkan",
    time: "Waktu",
    all_time: "Semua waktu",
    last_3_months: "3 bulan terakhir",
    last_pool_period: "Periode evaluasi kolam terakhir",
    last_month: "Bulan lalu",
    this_month: "Bulan ini",
    last_30_days: "30 hari terakhir",
    title_dates: "Tanggal",
    from: "Dari",
    to: "Ke"
  },
  copy_clipboard: "Disalin ke clipboard",
  payment_inputs: {
    empty_card_number: "Masukkan nomor kartu",
    invalid_card_number: "Nomor kartu tidak valid",
    empty_expiry_date: "Masukkan tanggal kedaluwarsa",
    month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12",
    year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu",
    date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu",
    invalid_expiry_date: "Tanggal kedaluwarsa tidak valid",
    invalid_cvc: "CVC tidak valid",
    empty_cvc: "Masukkan CVC",
    card_number_placeholder: "Nomor kartu",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Pemegang kartu",
    empty_card_holder: "Masukkan nama pemegang kartu"
  },
  copy_clipboard_error: "Gagal menyalin teks",
  input: {
    phone_number: "Nomor telepon",
    phone_search: "Cari",
    search: "Cari"
  },
  "registered-over": "terdaftar lebih dari",
  locale: {
    french: "Perancis",
    german: "Jerman",
    italian: "Italia",
    dutch: "Belanda",
    english: "Bahasa inggris",
    portuguese: "Portugis",
    russian: "Rusia",
    spanish: "Orang Spanyol",
    japanese: "Jepang",
    arabic: "Arab",
    turkish: "Turki",
    chinese: "Cina",
    swedish: "Orang Swedia",
    romanian: "Rumania",
    czech: "Ceko",
    hungarian: "Hongaria",
    slovak: "Orang Slovakia",
    danish: "Orang Denmark",
    indonesian: "Bahasa Indonesia",
    polish: "Polandia",
    greek: "Orang yunani",
    serbian: "Orang Serbia",
    hindi: "Tidak",
    norwegian: "Norwegia",
    thai: "Thai",
    slovenian: "Slovenia",
    ukrainian: "Orang Ukraina",
    albania: "Bahasa Albania"
  },
  product: "Produk",
  quantity: "Kuantitas",
  order_summary: "Ringkasan Pesanan",
  vat: "Pajak penjualan",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metode Pengiriman",
    not_available: "Ups! Sepertinya kami belum menawarkan pengiriman ke lokasi ini.",
    condition_label: {
      price: "Untuk pesanan yang harganya antara {{min}} {{currency}} hingga {{max}} {{currency}}",
      price_min: "Untuk pesanan yang harganya {{min}} {{currency}} atau lebih",
      quantity: "Untuk pesanan yang berisi antara {{min}} hingga {{max}} item",
      quantity_min: "Untuk pesanan yang berisi {{min}} item atau lebih",
      weight: "Untuk pesanan dengan total berat antara {{min}}g hingga {{max}}g",
      weight_min: "Untuk pesanan dengan total berat {{min}}g atau lebih"
    }
  },
  shipping_fee: "Biaya pengiriman",
  total_amount_with_tax_and_shipping: "Total (termasuk pajak dan pengiriman)",
  vat_percent: "Pajak penjualan ({{percent}}%)",
  including_tax: "Termasuk PPN {{percent}}% ({{amount}})",
  total_amount_with_tax: "Total (termasuk pajak)",
  total_amount_with_shipping: "Total (termasuk pengiriman)"
}, wO = {
  public_pages_purchase: _O
}, xO = {
  "required-field": "Il campo è obbligatorio",
  payment: {
    price_plan: "Piano",
    stripe_card: "Carta di credito o di debito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Carte di credito (Dlocal)",
    dlocal_boleto: "Biglietto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carte di credito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Biglietto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contanti alla consegna",
    xendit_card: "Carte di credito (Xendit)",
    paystack_card: "Carte di credito (Paystack)",
    paypal_connect: "Collegare PayPal",
    paypal_edit_organization_name: "Modifica il nome dell'organizzazione",
    paypal_rest: "PayPal",
    secure_and_pay: "Sicurezza e pagamento",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Errore",
  "Payment-method": "Metodo di pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} settimana",
      week_plural: "{{count}} settimane",
      day: "{{count}} giorno",
      day_plural: "{{count}} giorni",
      month: "{{count}} mese",
      month_plural: "{{count}} mesi",
      year: "{{count}} anni",
      year_plural: "{{count}} anni"
    },
    interval: {
      month: "mese",
      month_plural: "{{count}} mesi",
      day: "giorno",
      day_plural: "{{count}} giorni",
      week: "settimana",
      week_plural: "{{count}} settimane",
      year: "anno",
      year_plural: "{{count}} anni"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi",
        unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizzato da"
  },
  form_select: {
    empty_list: "Sembra che questo elenco sia vuoto",
    select: "Selezionare"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Cognome",
    phone_number: "Numero di telefono",
    country: "Paese",
    street_address: "Indirizzo",
    city: "Città",
    postal_code: "Codice postale",
    company_name: "Nome azienda",
    tax_number: "Partita IVA",
    state_province: "Stato/Provincia",
    street_number: "Numero civico",
    neighborhood: "Quartiere"
  },
  date_picker: {
    apply: "Applicare",
    clear: "Chiaro",
    time: "Ora",
    all_time: "Per tutto il periodo",
    last_3_months: "Ultimi 3 mesi",
    last_pool_period: "Ultimo periodo di valutazione del pool",
    last_month: "Ultimo mese",
    this_month: "Questo mese",
    last_30_days: "Ultimi 30 giorni",
    title_dates: "Date",
    from: "Da",
    to: "A"
  },
  copy_clipboard: "Copiato negli appunti",
  payment_inputs: {
    empty_card_number: "Inserire un numero di carta",
    invalid_card_number: "Il numero della carta non è valido",
    empty_expiry_date: "Inserire una data di scadenza",
    month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12",
    year_out_of_range: "L'anno di scadenza non può essere passato",
    date_out_of_range: "La data di scadenza non può essere passata",
    invalid_expiry_date: "La data di scadenza non è valida",
    invalid_cvc: "Il CVC non è valido",
    empty_cvc: "Inserire una CVC",
    card_number_placeholder: "Numero della carta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Portacarte",
    empty_card_holder: "Inserire il nome del titolare della carta"
  },
  copy_clipboard_error: "Impossibile copiare il testo",
  input: {
    phone_number: "Numero di telefono",
    phone_search: "Ricerca",
    search: "Ricerca"
  },
  "registered-over": "registrato oltre",
  locale: {
    french: "Francese",
    german: "Tedesco",
    italian: "Italiano",
    dutch: "Olandese",
    english: "Inglese",
    portuguese: "Portoghese",
    russian: "Russo",
    spanish: "Spagnolo",
    japanese: "Giapponese",
    arabic: "Аrabo",
    turkish: "Turco",
    chinese: "Cinese",
    swedish: "Svedese",
    romanian: "Rumeno",
    czech: "Ceco",
    hungarian: "Ungherese",
    slovak: "Slovacco",
    danish: "Danese",
    indonesian: "Indonesiano",
    polish: "Polacco",
    greek: "Greco",
    serbian: "Serbo",
    hindi: "Hindi",
    norwegian: "Norvegese",
    thai: "Tailandese",
    slovenian: "Sloveno",
    ukrainian: "Ucraino",
    albania: "Albanese"
  },
  product: "Prodotto",
  quantity: "Quantità",
  order_summary: "Riepilogo dell'ordine",
  vat: "Imposta sulle vendite",
  total: "Totale",
  subtotal: "Totale parziale",
  shipping: {
    shipping_method: "Metodo di spedizione",
    not_available: "Ops! Sembra che per ora non offriamo spedizioni in questa località.",
    condition_label: {
      price: "Per ordini con un prezzo compreso tra {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Per ordini con un prezzo di {{min}} {{currency}} o più",
      quantity: "Per ordini contenenti tra {{min}} e {{max}} articoli",
      quantity_min: "Per ordini contenenti {{min}} articoli o più",
      weight: "Per ordini con un peso totale compreso tra {{min}}g e {{max}}g",
      weight_min: "Per ordini con un peso totale di {{min}}g o più"
    }
  },
  shipping_fee: "Spese di spedizione",
  total_amount_with_tax_and_shipping: "Totale (incluso l'imposta e la spedizione)",
  vat_percent: "Imposta sulle vendite ({{percent}}%)",
  including_tax: "Include {{percent}}% di IVA ({{amount}})",
  total_amount_with_tax: "Totale (IVA inclusa)",
  total_amount_with_shipping: "Totale (spedizione inclusa)"
}, SO = {
  public_pages_purchase: xO
}, kO = {
  "required-field": "この項目は必須です",
  payment: {
    price_plan: "プラン",
    stripe_card: "クレジットカードまたはデビットカード",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact（Stripe）",
    dlocal_card: "クレジットカード（Dlocal）",
    dlocal_boleto: "Borelo（Dlocal）",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Paypal",
    mercadopago_card: "クレジットカード (Mercado Pago)",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay ",
    flutterwave: "Flutterwave ",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "着払い",
    xendit_card: "クレジットカード（Xendit）",
    paystack_card: "クレジットカード（Paystack）",
    paypal_connect: "PayPalに接続",
    paypal_edit_organization_name: "組織名を編集",
    paypal_rest: "ペイパル",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Appleペイ",
    xendit: {
      "3ds": "3Dセキュア"
    }
  },
  error: "エラー",
  "Payment-method": "支払い方法",
  price_plan: {
    trial_period: {
      week: `{{count}}週

{{count}}週`,
      day: `{{count}} 日

{{count}} 日`,
      month: `{{count}}ヶ月

{{count}}ヶ月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `ヶ月

{{count}}ヶ月`,
      day: `日

{{count}} 日`,
      week: `週

{{count}}週`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "無料",
        trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は",
        unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回"
      }
    }
  },
  affiliate_badge: {
    made_with: "提供元"
  },
  form_select: {
    empty_list: "このリストが空のようです",
    select: "選択する"
  },
  contact_slug: {
    email: "Eメール",
    first_name: "名",
    last_name: "姓",
    phone_number: "電話番号",
    country: "国",
    street_address: "住所",
    city: "市区町村",
    postal_code: "郵便番号",
    company_name: "法人名",
    tax_number: "法人番号（税番号）",
    state_province: "都道府県",
    street_number: "番地",
    neighborhood: "地域"
  },
  date_picker: {
    apply: "適用",
    clear: "消去",
    time: "時",
    all_time: "全期間",
    last_3_months: "過去3ヶ月",
    last_pool_period: "前回の集計期間",
    last_month: "先月",
    this_month: "今月",
    last_30_days: "過去30日",
    title_dates: "日",
    from: "から",
    to: "へ"
  },
  copy_clipboard: "クリップボードにコピーされました",
  payment_inputs: {
    empty_card_number: "カード番号を入力",
    invalid_card_number: "カード番号が無効です",
    empty_expiry_date: "有効期限を入力してください。",
    month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。",
    year_out_of_range: "有効期限の年は過去にすることはできません。",
    date_out_of_range: "有効期限は過去の日付にすることはできません。",
    invalid_expiry_date: "有効期限が無効です",
    invalid_cvc: "CVCが無効です",
    empty_cvc: "CVCを入力",
    card_number_placeholder: "カード番号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "カード所有者",
    empty_card_holder: "カード所有者の名前を入力してください"
  },
  copy_clipboard_error: "テキストのコピーに失敗しました",
  input: {
    phone_number: "電話番号",
    phone_search: "検索",
    search: "検索"
  },
  "registered-over": "登録された",
  locale: {
    french: "フランス語",
    german: "ドイツ語",
    italian: "イタリア語",
    dutch: "オランダ語",
    english: "英語",
    portuguese: "ポルトガル語",
    russian: "ロシア語",
    spanish: "スペイン語",
    japanese: "日本語",
    arabic: "アラブ",
    turkish: "トルコ語",
    chinese: "中国語",
    swedish: "スウェーデン語",
    romanian: "ルーマニア語",
    czech: "チェコ語",
    hungarian: "ハンガリー語",
    slovak: "スロバキア語",
    danish: "デンマーク語",
    indonesian: "インドネシア語",
    polish: "ポーランド語",
    greek: "ギリシャ語",
    serbian: "セルビア語",
    hindi: "ヒンズー語",
    norwegian: "ノルウェー語",
    thai: "タイ語",
    slovenian: "スロバニア語",
    ukrainian: "ウクライナ語",
    albania: "アルバニア語"
  },
  product: "商品",
  quantity: "数量",
  order_summary: "ご注文内容",
  vat: "消費税",
  total: "合計",
  subtotal: "小計",
  shipping: {
    shipping_method: "配送方法",
    not_available: "おっと！この地域への配送にはまだ対応していないようです。",
    condition_label: {
      price: "{{min}} {{currency}}から{{max}} {{currency}}までの注文の場合",
      price_min: "{{min}} {{currency}}以上の注文の場合",
      quantity: "{{min}}から{{max}}個の商品を含む注文の場合",
      quantity_min: "{{min}}個以上の商品を含む注文の場合",
      weight: "合計重量が {{min}}g から {{max}}g までの注文の場合",
      weight_min: "合計重量が {{min}}g 以上の注文の場合"
    }
  },
  shipping_fee: "送料",
  total_amount_with_tax_and_shipping: "合計（消費税・送料込み）",
  vat_percent: "消費税（{{percent}}%）",
  including_tax: "消費税 {{percent}}% を含む（{{amount}}）",
  total_amount_with_tax: "合計（税込）",
  total_amount_with_shipping: "合計（送料込み）"
}, MO = {
  public_pages_purchase: kO
}, PO = {
  "required-field": "Veld is vereist",
  payment: {
    price_plan: "Plan",
    stripe_card: "Creditcard of debetkaart",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Creditcards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlokaal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Creditcards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contant bij levering",
    xendit_card: "Creditcards (Xendit)",
    paystack_card: "Creditcards (Paystack)",
    paypal_connect: "Verbind PayPal",
    paypal_edit_organization_name: "Organisatienaam bewerken",
    paypal_rest: "PayPal",
    secure_and_pay: "Beveiligd betalen",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fout",
  "Payment-method": "Betaalmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weken",
      day: "{{count}} dag",
      day_plural: "{{count}} dagen",
      month: "{{count}} maand",
      month_plural: "{{count}} maanden",
      year: "{{count}} jaar",
      year_plural: "{{count}} jaren"
    },
    interval: {
      month: "maand",
      month_plural: "{{count}} maanden",
      day: "dag",
      day_plural: "{{count}} dagen",
      week: "week",
      week_plural: "{{count}} weken",
      year: "jaar",
      year_plural: "{{count}} jaren"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan",
        unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ondersteund door"
  },
  form_select: {
    empty_list: "Het lijkt erop dat deze lijst leeg is",
    select: "Selecteer"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Voornaam",
    last_name: "Achternaam",
    phone_number: "Telefoonnummer",
    country: "Land",
    street_address: "Straatadres",
    city: "Plaats",
    postal_code: "Postcode",
    company_name: "Bedrijfsnaam",
    tax_number: "BTW-nummer",
    state_province: "Staat/Provincie",
    street_number: "Huisnummer",
    neighborhood: "Buurt"
  },
  date_picker: {
    apply: "Toepassen",
    clear: "Wissen",
    time: "Tijd",
    all_time: "Alle tijden",
    last_3_months: "Laatste 3 maanden",
    last_pool_period: "Laatste pool-evaluatieperiode",
    last_month: "Afgelopen maand",
    this_month: "Deze maand",
    last_30_days: "Laatste 30 dagen",
    title_dates: "Datum",
    from: "Van",
    to: "Naar"
  },
  copy_clipboard: "Gekopieerd naar klembord",
  payment_inputs: {
    empty_card_number: "Voer een kaartnummer in",
    invalid_card_number: "Kaartnummer is ongeldig",
    empty_expiry_date: "Voer een vervaldatum in",
    month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen",
    year_out_of_range: "Vervaljaar mag niet in het verleden liggen",
    date_out_of_range: "Vervaldatum mag niet in het verleden liggen",
    invalid_expiry_date: "Vervaldatum is ongeldig",
    invalid_cvc: "CVC is ongeldig",
    empty_cvc: "Voer een CVC in",
    card_number_placeholder: "Kaartnummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kaarthouder",
    empty_card_holder: "Voer de naam van de kaarthouder in"
  },
  copy_clipboard_error: "Tekst kopiëren mislukt",
  input: {
    phone_number: "Telefoonnummer",
    phone_search: "Zoek",
    search: "Zoek"
  },
  "registered-over": "geregistreerd over",
  locale: {
    french: "Frans",
    german: "Duits",
    italian: "Italiaans",
    dutch: "Nederlands",
    english: "Engels",
    portuguese: "Portugees",
    russian: "Russisch",
    spanish: "Spaans",
    japanese: "Japans",
    arabic: "Arabisch",
    turkish: "Turks",
    chinese: "Chinees",
    swedish: "Zweeds",
    romanian: "Roemeens",
    czech: "Tsjechisch",
    hungarian: "Hongaars",
    slovak: "Slowaaks",
    danish: "Deens",
    indonesian: "Indonesisch",
    polish: "Pools",
    greek: "Grieks",
    serbian: "Servisch",
    hindi: "Hindi",
    norwegian: "Noors",
    thai: "Thais",
    slovenian: "Sloveens",
    ukrainian: "Oekraïens",
    albania: "Albanees"
  },
  product: "Product",
  quantity: "Aantal",
  order_summary: "Besteloverzicht",
  vat: "Verkoopbelasting",
  total: "Totaal",
  subtotal: "Subtotaal",
  shipping: {
    shipping_method: "Verzendmethode",
    not_available: "Oeps! Het lijkt erop dat we nog geen verzending naar deze locatie aanbieden",
    condition_label: {
      price: "Voor bestellingen geprijsd tussen {{min}} {{currency}} en {{max}} {{currency}}",
      price_min: "Voor bestellingen geprijsd vanaf {{min}} {{currency}} of meer",
      quantity: "Voor bestellingen die tussen de {{min}} en {{max}} artikelen bevatten",
      quantity_min: "Voor bestellingen met {{min}} of meer artikelen",
      weight: "Voor bestellingen met een totaalgewicht tussen {{min}}g en {{max}}g",
      weight_min: "Voor bestellingen met een totaalgewicht van {{min}}g of meer"
    }
  },
  shipping_fee: "Verzendkosten",
  total_amount_with_tax_and_shipping: "Totaal (inclusief BTW en Verzending)",
  vat_percent: "BTW ({{percent}}%)",
  including_tax: "Inclusief {{percent}}% BTW ({{amount}})",
  total_amount_with_tax: "Totaal (incl. belasting)",
  total_amount_with_shipping: "Totaal (incl. verzending)"
}, EO = {
  public_pages_purchase: PO
}, TO = {
  "required-field": "Felt er obligatorisk",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditt- eller debetkort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kredittkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredittkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalingsmarked)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterbølge",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontantbetaling ved levering",
    xendit_card: "Kredittkort (Xendit)",
    paystack_card: "Kredittkort (Paystack)",
    paypal_connect: "Koble til PayPal",
    paypal_edit_organization_name: "Rediger organisasjonsnavn",
    paypal_rest: "PayPal",
    secure_and_pay: "Sikker og betal",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Feil",
  "Payment-method": "Betalingsmåte",
  price_plan: {
    trial_period: {
      week: "{{count}} uke",
      week_plural: "{{count}} uker",
      day: "{{count}} dag",
      day_plural: "{{count}} dager",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dager",
      week: "uke",
      week_plural: "{{count}} uker",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drevet av"
  },
  form_select: {
    empty_list: "Det ser ut som denne listen er tom",
    select: "Velg"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Fornavn",
    last_name: "Etternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gateadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gate nummer",
    neighborhood: "Nabolag"
  },
  date_picker: {
    apply: "Bruk",
    clear: "Fjern",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Siste 3 måneder",
    last_pool_period: "Siste evalueringsperiode for basseng",
    last_month: "Siste måned",
    this_month: "Denne måneden",
    last_30_days: "Siste 30 dager",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopiert til utklippstavlen",
  payment_inputs: {
    empty_card_number: "Skriv inn et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldig",
    empty_expiry_date: "Skriv inn en utløpsdato",
    month_out_of_range: "Utløpsmåned må være mellom 01 og 12",
    year_out_of_range: "Utløpsår kan ikke være i fortiden",
    date_out_of_range: "Utløpsdato kan ikke være i fortiden",
    invalid_expiry_date: "Utløpsdato er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Skriv inn en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Skriv inn navnet til kortholderen"
  },
  copy_clipboard_error: "Kunne ikke kopiere tekst",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søk",
    search: "Søk"
  },
  "registered-over": "registrert over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Nederlandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumensk",
    czech: "Tsjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Pusse",
    greek: "Gresk",
    serbian: "Serbisk",
    hindi: "Nei",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mengde",
  order_summary: "Ordresammendrag",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsum",
  shipping: {
    shipping_method: "Fraktmetode",
    not_available: "Oops! Det ser ut som vi ikke tilbyr frakt til dette stedet ennå.",
    condition_label: {
      price: "For bestillinger priset mellom {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For bestillinger priset til {{min}} {{currency}} eller mer",
      quantity: "For bestillinger som inneholder mellom {{min}} til {{max}} varer",
      quantity_min: "For bestillinger som inneholder {{min}} eller flere varer",
      weight: "For bestillinger med en totalvekt mellom {{min}}g og {{max}}g",
      weight_min: "For bestillinger med en totalvekt på {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktgebyr",
  total_amount_with_tax_and_shipping: "Totalt (inkludert skatt og frakt)",
  vat_percent: "Merverdiavgift ({{percent}}%)",
  including_tax: "Inkludert {{percent}}% MVA ({{amount}})",
  total_amount_with_tax: "Totalbeløp (inkludert skatt)",
  total_amount_with_shipping: "Totalbeløp (inkludert frakt)"
}, LO = {
  public_pages_purchase: TO
}, AO = {
  "required-field": "Pole jest wymagane",
  payment: {
    price_plan: "Plan",
    stripe_card: "Karta kredytowa lub debetowa",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Karty kredytowe (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Karty kredytowe (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Płatność gotówką przy odbiorze",
    xendit_card: "Karty kredytowe (Xendit)",
    paystack_card: "Karty kredytowe (Paystack)",
    paypal_connect: "Połącz PayPala",
    paypal_edit_organization_name: "Edytuj nazwę organizacji",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Błąd",
  "Payment-method": "Metoda płatności",
  price_plan: {
    trial_period: {
      week_0: "{{count}} tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      day_0: "{{count}} dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      month_0: "{{count}} miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      year_0: "{{count}} rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    },
    interval: {
      month_0: "miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      day_0: "dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      week_0: "tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      year_0: "rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bezpłatny",
        trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy"
      }
    }
  },
  affiliate_badge: {
    made_with: "Zasilane przez"
  },
  form_select: {
    empty_list: "Wygląda na to, że ta lista jest pusta",
    select: "Wybierz"
  },
  contact_slug: {
    email: "Email",
    first_name: "Imię",
    last_name: "Nazwisko",
    phone_number: "Numer telefonu",
    country: "Kraj",
    street_address: "Adres",
    city: "Miasto",
    postal_code: "Kod pocztowy",
    company_name: "Nazwa firmy",
    tax_number: "Numer identyfikacji podatkowej",
    state_province: "Stan/Województwo",
    street_number: "Numer ulicy",
    neighborhood: "Osiedle"
  },
  date_picker: {
    apply: "Zastosuj",
    clear: "Wyczyść",
    time: "Czas",
    all_time: "Cały czas",
    last_3_months: "Ostatnie 3 miesiące",
    last_pool_period: "Ostatni okres oceny puli",
    last_month: "Ostatni miesiąc",
    this_month: "Ten miesiąc",
    last_30_days: "Ostatnie 30 dni",
    title_dates: "Daty",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopiowano do schowka",
  payment_inputs: {
    empty_card_number: "Wprowadź numer karty",
    invalid_card_number: "Numer karty jest nieprawidłowy",
    empty_expiry_date: "Wprowadź datę ważności",
    month_out_of_range: "Miesiąc ważności musi być między 01 a 12",
    year_out_of_range: "Rok ważności nie może być w przeszłości",
    date_out_of_range: "Data ważności nie może być w przeszłości",
    invalid_expiry_date: "Data ważności jest nieprawidłowa",
    invalid_cvc: "CVC jest nieprawidłowy",
    empty_cvc: "Wprowadź CVC",
    card_number_placeholder: "Numer karty",
    expiry_data_placeholder: "MM/RR",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Właściciel karty",
    empty_card_holder: "Wprowadź imię i nazwisko właściciela karty"
  },
  copy_clipboard_error: "Nie udało się skopiować tekstu",
  input: {
    phone_number: "Numer telefonu",
    phone_search: "Szukaj",
    search: "Szukaj"
  },
  "registered-over": "zarejestrowano ponad",
  locale: {
    french: "Francuski",
    german: "Niemiecki",
    italian: "Włoski",
    dutch: "Holenderski",
    english: "Angielski",
    portuguese: "Portugalski",
    russian: "Rosyjski",
    spanish: "Hiszpański",
    japanese: "Japoński",
    arabic: "Arabski",
    turkish: "Turecki",
    chinese: "Chiński",
    swedish: "Szwedzki",
    romanian: "Rumuński",
    czech: "Czeski",
    hungarian: "Węgierski",
    slovak: "Słowacki",
    danish: "Duński",
    indonesian: "Indonezyjski",
    polish: "Polski",
    greek: "Grecki",
    serbian: "Serbski",
    hindi: "Hinduski",
    norwegian: "Norweski",
    thai: "Tajski",
    slovenian: "Słoweński",
    ukrainian: "Ukraiński",
    albania: "Albański"
  },
  product: "Produkt",
  quantity: "Ilość",
  order_summary: "Podsumowanie zamówienia",
  vat: "Podatek od sprzedaży",
  total: "Razem",
  subtotal: "Suma częściowa",
  shipping: {
    shipping_method: "Metoda wysyłki",
    not_available: "Ups! Wygląda na to, że nie oferujemy jeszcze wysyłki do tej lokalizacji.",
    condition_label: {
      price: "Dla zamówień w cenie od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Dla zamówień w cenie {{min}} {{currency}} lub więcej",
      quantity: "Dla zamówień zawierających od {{min}} do {{max}} przedmiotów",
      quantity_min: "Dla zamówień zawierających {{min}} lub więcej przedmiotów",
      weight: "Dla zamówień o łącznej wadze od {{min}}g do {{max}}g",
      weight_min: "Dla zamówień o łącznej wadze {{min}}g lub więcej"
    }
  },
  shipping_fee: "Opłata za wysyłkę",
  total_amount_with_tax_and_shipping: "Razem (w tym podatek i wysyłka)",
  vat_percent: "Podatek od sprzedaży ({{percent}}%)",
  including_tax: "Zawiera {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "Razem (z podatkiem)",
  total_amount_with_shipping: "Razem (z wysyłką)"
}, OO = {
  public_pages_purchase: AO
}, NO = {
  "required-field": "O campo é obrigatório",
  payment: {
    price_plan: "Plano",
    stripe_card: "Cartão de crédito ou débito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Cartão de crédito (Dlocal)",
    dlocal_boleto: "Boleto bancário (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartão de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pagamento na entrega",
    xendit_card: "Cartão de crédito (Xendit)",
    paystack_card: "Cartão de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar o nome da empresa",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erro",
  "Payment-method": "Método de pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} dia",
      day_plural: "{{count}} dias",
      month: "{{count}} mês",
      month_plural: "{{count}} meses",
      year: "{{count}} ano",
      year_plural: "{{count}} anos"
    },
    interval: {
      month: "mês",
      month_plural: "{{count}} meses",
      day: "dia",
      day_plural: "{{count}} dias",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "ano",
      year_plural: "{{count}} anos"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois",
        unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desenvolvido por"
  },
  form_select: {
    empty_list: "Parece que essa lista está vazia",
    select: "Selecionar"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Sobrenome",
    phone_number: "Número de telefone",
    country: "País",
    street_address: "Endereço",
    city: "Cidade",
    postal_code: "Código postal",
    company_name: "Nome da empresa",
    tax_number: "CNPJ/NIF",
    state_province: "Estado/Província",
    street_number: "Número",
    neighborhood: "Bairro"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Limpar",
    time: "Horário",
    all_time: "Desde o início",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último período de avaliação do grupo",
    last_month: "Último mês",
    this_month: "Este mês",
    last_30_days: "Últimos 30 dias",
    title_dates: "Datas",
    from: "De",
    to: "Até"
  },
  copy_clipboard: "Copiado para a área de transferência",
  payment_inputs: {
    empty_card_number: "Insira um número de cartão",
    invalid_card_number: "O número do cartão é inválido",
    empty_expiry_date: "Insira uma data de validade",
    month_out_of_range: "O mês de validade deve estar entre 01 e 12",
    year_out_of_range: "O ano de validade não pode estar no passado",
    date_out_of_range: "A data de validade não pode estar no passado",
    invalid_expiry_date: "A data de validade é inválida",
    invalid_cvc: "O CVV é inválido",
    empty_cvc: "Insira o CVV",
    card_number_placeholder: "Número do cartão",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVV",
    card_holder_placeholder: "Titular do cartão",
    empty_card_holder: "Insira o nome do titular do cartão"
  },
  copy_clipboard_error: "Falha ao copiar o texto",
  input: {
    phone_number: "Número de telefone",
    phone_search: "Pesquisar",
    search: "Pesquisar"
  },
  "registered-over": "registrado há mais de",
  locale: {
    french: "Francês",
    german: "Alemão",
    italian: "Italiano",
    dutch: "Holandês",
    english: "Inglês",
    portuguese: "Português",
    russian: "Russo",
    spanish: "Espanhol",
    japanese: "Japonês",
    arabic: "Árabe",
    turkish: "Turco",
    chinese: "Chinês",
    swedish: "Sueco",
    romanian: "Romeno",
    czech: "Tcheco",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Dinamarquês",
    indonesian: "Indonésio",
    polish: "Polonês",
    greek: "Grego",
    serbian: "Sérvio",
    hindi: "Hindi",
    norwegian: "Norueguês",
    thai: "Tailandês",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanês"
  },
  product: "Produto",
  quantity: "Quantidade",
  order_summary: "Resumo do pedido",
  vat: "Imposto",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envio",
    not_available: "Ops! Parece que ainda não oferecemos envio para este local",
    condition_label: {
      price: "Para pedidos com valor entre {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Para pedidos com valor de {{min}} {{currency}} ou mais",
      quantity: "Para pedidos contendo entre {{min}} e {{max}} itens",
      quantity_min: "Para pedidos contendo {{min}} ou mais itens",
      weight: "Para pedidos com peso total entre {{min}}g e {{max}}g",
      weight_min: "Para pedidos com peso total de {{min}}g ou mais"
    }
  },
  shipping_fee: "Taxa de envio",
  total_amount_with_tax_and_shipping: "Total (incluindo imposto e envio)",
  vat_percent: "Imposto ({{percent}}%)",
  including_tax: "Inclui {{percent}}% de imposto (IVA) ({{amount}})",
  total_amount_with_tax: "Total (incluindo impostos)",
  total_amount_with_shipping: "Total (incluindo envio)"
}, jO = {
  public_pages_purchase: NO
}, RO = {
  "required-field": "Câmpul este obligatoriu",
  payment: {
    price_plan: "Plan",
    stripe_card: "Card de credit sau debit",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (stripe)",
    dlocal_card: "Carduri de credit (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carduri de credit (Mercado Pago)",
    mercadopago_pix: "PIX (piață de plată)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Plata la livrare",
    xendit_card: "Carduri de credit (Xendit)",
    paystack_card: "Carduri de credit (Paystack)",
    paypal_connect: "Conectați PayPal",
    paypal_edit_organization_name: "Editați numele organizației",
    paypal_rest: "PayPal",
    secure_and_pay: "Securizat și plătiți",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Eroare",
  "Payment-method": "Modalitate de plată",
  price_plan: {
    trial_period: {
      week_0: "{{count}} săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      day_0: "{{count}} zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      month_0: "{{count}} lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      year_0: "{{count}} an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    },
    interval: {
      month_0: "lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      day_0: "zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      week_0: "săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      year_0: "an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci",
        unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizat de"
  },
  form_select: {
    empty_list: "Se pare că această listă este goală",
    select: "Selectați"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prenume",
    last_name: "Nume de familie",
    phone_number: "Număr de telefon",
    country: "Țară",
    street_address: "Adresă",
    city: "Oraș",
    postal_code: "Cod poștal",
    company_name: "Numele companiei",
    tax_number: "Număr de identificare fiscală",
    state_province: "Stat/Provincie",
    street_number: "Numărul străzii",
    neighborhood: "Cartier"
  },
  date_picker: {
    apply: "Aplică",
    clear: "Șterge",
    time: "Timp",
    all_time: "Tot timpul",
    last_3_months: "Ultimele 3 luni",
    last_pool_period: "Ultima perioadă de evaluare a grupului",
    last_month: "Luna trecută",
    this_month: "Luna aceasta",
    last_30_days: "Ultimele 30 de zile",
    title_dates: "Date",
    from: "De la",
    to: "Către"
  },
  copy_clipboard: "Copiat în clipboard",
  payment_inputs: {
    empty_card_number: "Introduceți un număr de card",
    invalid_card_number: "Numărul cardului este invalid",
    empty_expiry_date: "Introduceți o dată de expirare",
    month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12",
    year_out_of_range: "Anul de expirare nu poate fi în trecut",
    date_out_of_range: "Data de expirare nu poate fi în trecut",
    invalid_expiry_date: "Data de expirare este invalidă",
    invalid_cvc: "CVC este invalid",
    empty_cvc: "Introduceți un CVC",
    card_number_placeholder: "Numărul cardului",
    expiry_data_placeholder: "LL/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titularul cardului",
    empty_card_holder: "Introduceți un nume al titularului cardului"
  },
  copy_clipboard_error: "Copierea textului a eșuat",
  input: {
    phone_number: "Număr de telefon",
    phone_search: "Căutare",
    search: "Caută"
  },
  "registered-over": "înregistrat peste",
  locale: {
    french: "Limba franceza",
    german: "Limba germana",
    italian: "Italiană",
    dutch: "Olandeză",
    english: "Engleză",
    portuguese: "Portugheză",
    russian: "Rusă",
    spanish: "Spaniolă",
    japanese: "Japonez",
    arabic: "Arabic",
    turkish: "Turc",
    chinese: "Chinez",
    swedish: "Suedez",
    romanian: "Română",
    czech: "Ceh",
    hungarian: "Maghiară",
    slovak: "Slovacă",
    danish: "Danez",
    indonesian: "Indoneziană",
    polish: "Lustrui",
    greek: "Greacă",
    serbian: "Sârb",
    hindi: "Nu",
    norwegian: "Norvegian",
    thai: "Thailandez",
    slovenian: "Slovenă",
    ukrainian: "Ucrainean",
    albania: "Albanez"
  },
  product: "Produs",
  quantity: "Cantitate",
  order_summary: "Rezumatul comenzii",
  vat: "Taxa pe vânzări",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metoda de livrare",
    not_available: "Ups! Se pare că nu oferim livrare în această locație încă.",
    condition_label: {
      price: "Pentru comenzi cu prețuri între {{min}} {{currency}} și {{max}} {{currency}}",
      price_min: "Pentru comenzi cu prețuri de {{min}} {{currency}} sau mai mult",
      quantity: "Pentru comenzi care conțin între {{min}} și {{max}} articole",
      quantity_min: "Pentru comenzi care conțin {{min}} sau mai multe articole",
      weight: "Pentru comenzi cu o greutate totală între {{min}}g și {{max}}g",
      weight_min: "Pentru comenzi cu o greutate totală de {{min}}g sau mai mult"
    }
  },
  shipping_fee: "Taxa de livrare",
  total_amount_with_tax_and_shipping: "Total (inclusiv taxe și livrare)",
  vat_percent: "Taxa pe vânzări ({{percent}}%)",
  including_tax: "Incluzând TVA de {{percent}}% ({{amount}})",
  total_amount_with_tax: "Total (inclusiv taxe)",
  total_amount_with_shipping: "Total (inclusiv transport)"
}, DO = {
  public_pages_purchase: RO
}, IO = {
  "required-field": "Поле обязательно для заполнения",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитная или дебетовая карта",
    stripe_ideal: "Разрешить платежи через iDeal",
    stripe_bancotact: "Разрешить платежи через BanContact",
    dlocal_card: "Кредитные карты (Dlocal)",
    dlocal_boleto: "Заготовка (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Разрешить платежи PayPal",
    mercadopago_card: "Кредитные карты",
    mercadopago_pix: "PIX (Платный рынок)",
    mercadopago_boleto: "Билет (Платный рынок)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Оплата наличными при доставке",
    xendit_card: "Кредитные карты (Xendit)",
    paystack_card: "Кредитные карты (Paystack)",
    paypal_connect: "Подключить PayPal",
    paypal_edit_organization_name: "Изменить название организации",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Ошибка",
  "Payment-method": "Способ оплаты",
  price_plan: {
    trial_period: {
      week_0: "{{count}} неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} недель",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      month_0: "месяц",
      month_1: "{{count}} месяца",
      month_2: "{{count}} месяцев",
      year_0: "год",
      year_1: "{{count}} года",
      year_2: "{{count}} лет"
    },
    interval: {
      month_0: "месяц",
      month_1: "{{count}} месяцы",
      month_2: "{{count}} месяца",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      week_0: "неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} неделями",
      year_0: "год",
      year_1: "{{count}} годы",
      year_2: "{{count}} лет"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем",
        unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз"
      }
    }
  },
  affiliate_badge: {
    made_with: "Создано с "
  },
  form_select: {
    empty_list: "Похоже, что этот список пуст.",
    select: "Выбрать"
  },
  contact_slug: {
    email: "Почта",
    first_name: "Имя",
    last_name: "Фамилия",
    phone_number: "Номер телефона",
    country: "Страна",
    street_address: "Адрес",
    city: "Город",
    postal_code: "Почтовый индекс",
    company_name: "Название компании",
    tax_number: "Налоговый номер",
    state_province: "Штат/Область",
    street_number: "Номер улицы",
    neighborhood: "Соседство"
  },
  date_picker: {
    apply: "Применить",
    clear: "Очистить",
    time: "Время",
    all_time: "Все время",
    last_3_months: "Последние 3 месяца",
    last_pool_period: "Последний период оценки пула",
    last_month: "Последний месяц",
    this_month: "В этом месяце",
    last_30_days: "Последние 30 дней",
    title_dates: "Даты",
    from: "От",
    to: "В"
  },
  copy_clipboard: "Номер карты недействителен",
  payment_inputs: {
    empty_card_number: "Введите номер карты",
    invalid_card_number: "Номер карты недействителен",
    empty_expiry_date: "Введите дату окончания срока действия",
    month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12",
    year_out_of_range: "Год окончания срока действия не может быть в прошлом",
    date_out_of_range: "Дата окончания срока действия не может быть в прошлом",
    invalid_expiry_date: "Срок годности недействителен",
    invalid_cvc: "CVC код неправильный",
    empty_cvc: "Введите CVC код",
    card_number_placeholder: "Номер карты",
    expiry_data_placeholder: "М/Г",
    cvc_placeholder: "CVC код",
    card_holder_placeholder: "Держатель карты",
    empty_card_holder: "Введите имя держателя карты"
  },
  copy_clipboard_error: "Не удалось скопировать текст",
  input: {
    phone_number: "Номер телефона",
    phone_search: "Поиск",
    search: "Поиск"
  },
  "registered-over": "зарегистрировано более чем",
  locale: {
    french: "Французский",
    german: "Немецкий",
    italian: "Итальянский",
    dutch: "Голландский",
    english: "Английский",
    portuguese: "Португальский",
    russian: "Русский",
    spanish: "Испанский",
    japanese: "Японский",
    arabic: "Арабский",
    turkish: "Турецкий",
    chinese: "Китайский",
    swedish: "Шведский",
    romanian: "Румынский",
    czech: "Чешский",
    hungarian: "Венгерский",
    slovak: "Словацкий",
    danish: "Датский",
    indonesian: "Индонезийский",
    polish: "Польский",
    greek: "Греческий",
    serbian: "Сербский",
    hindi: "Хинди",
    norwegian: "Норвежский",
    thai: "Тайский",
    slovenian: "Словенский",
    ukrainian: "Украинский",
    albania: "Албанский"
  },
  product: "Продукт",
  quantity: "Количество",
  order_summary: "Итог заказа",
  vat: "Налог с продаж",
  total: "Итого",
  subtotal: "Промежуточный итог",
  shipping: {
    shipping_method: "Способ доставки",
    not_available: "Упс! Похоже, что мы еще не предлагаем доставку в это место.",
    condition_label: {
      price: "Для заказов стоимостью от {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для заказов стоимостью {{min}} {{currency}} или более",
      quantity: "Для заказов, содержащих от {{min}} до {{max}} товаров",
      quantity_min: "Для заказов, содержащих {{min}} или более товаров",
      weight: "Для заказов с общим весом от {{min}}g до {{max}}g",
      weight_min: "Для заказов с общим весом {{min}}g или более"
    }
  },
  shipping_fee: "Стоимость доставки",
  total_amount_with_tax_and_shipping: "Итого (включая налог и доставку)",
  vat_percent: "Налог с продаж ({{percent}}%)",
  including_tax: "Включает {{percent}}% НДС ({{amount}})",
  total_amount_with_tax: "Общая сумма (с налогом)",
  total_amount_with_shipping: "Общая сумма (с учетом доставки)"
}, HO = {
  public_pages_purchase: IO
}, FO = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditná alebo debetná karta",
    stripe_ideal: "iDeal (pruh)",
    stripe_bancotact: "Bancontact (pruh)",
    dlocal_card: "Kreditné karty (miestne)",
    dlocal_boleto: "Boleto (miestne)",
    dlocal_pix: "Pix (miestne)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditné karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platobný trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Platba na dobierku",
    xendit_card: "Kreditné karty (Xendit)",
    paystack_card: "Kreditné karty (Paystack)",
    paypal_connect: "Pripojte PayPal",
    paypal_edit_organization_name: "Upravte názov organizácie",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečiť a zaplatiť",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Spôsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      day_0: "{{count}} deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      month_0: "{{count}} mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      year_0: "{{count}} rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    },
    interval: {
      month_0: "mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      day_0: "deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      week_0: "týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      year_0: "rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zadarmo",
        trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháňané"
  },
  form_select: {
    empty_list: "Zdá sa, že tento zoznam je prázdny",
    select: "Vybrať"
  },
  contact_slug: {
    email: "Email",
    first_name: "Meno",
    last_name: "Priezvisko",
    phone_number: "Telefónne číslo",
    country: "Krajina",
    street_address: "Ulica",
    city: "Mesto",
    postal_code: "PSČ",
    company_name: "Názov spoločnosti",
    tax_number: "Daňové číslo",
    state_province: "Štát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Štvrť"
  },
  date_picker: {
    apply: "Použiť",
    clear: "Vymazať",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Posledné 3 mesiace",
    last_pool_period: "Posledné hodnotenie bazéna",
    last_month: "Minulý mesiac",
    this_month: "Tento mesiac",
    last_30_days: "Posledných 30 dní",
    title_dates: "Dátumy",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopírované do schránky",
  payment_inputs: {
    empty_card_number: "Zadajte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadajte dátum expirácie",
    month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12",
    year_out_of_range: "Rok expirácie nemôže byť v minulosti",
    date_out_of_range: "Dátum expirácie nemôže byť v minulosti",
    invalid_expiry_date: "Dátum expirácie je neplatný",
    invalid_cvc: "CVC je neplatný",
    empty_cvc: "Zadajte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držiteľ karty",
    empty_card_holder: "Zadajte meno držiteľa karty"
  },
  copy_clipboard_error: "Nepodarilo sa skopírovať text",
  input: {
    phone_number: "Telefónne číslo",
    phone_search: "Hľadať",
    search: "Hľadať"
  },
  "registered-over": "registrované viac ako",
  locale: {
    french: "Francúzsky",
    german: "Nemecký",
    italian: "Taliansky",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalčina",
    russian: "Ruský",
    spanish: "španielčina",
    japanese: "Japončina",
    arabic: "Arabčina",
    turkish: "Turecký",
    chinese: "čínsky",
    swedish: "švédsky",
    romanian: "Rumunský",
    czech: "český",
    hungarian: "Maďarský",
    slovak: "Slovenský",
    danish: "Dánčina",
    indonesian: "Indonézsky",
    polish: "Poľský",
    greek: "Grécky",
    serbian: "Srbský",
    hindi: "Nie",
    norwegian: "Nórsky",
    thai: "Thajčina",
    slovenian: "Slovensky",
    ukrainian: "Ukrajinčina",
    albania: "Albánsky"
  },
  product: "Produkt",
  quantity: "Množstvo",
  order_summary: "Zhrnutie objednávky",
  vat: "Daň z predaja",
  total: "Celkom",
  subtotal: "Medzisúčet",
  shipping: {
    shipping_method: "Spôsob dopravy",
    not_available: "Ups! Vyzerá to, že na túto lokalitu zatiaľ nenabízame dopravu.",
    condition_label: {
      price: "Pre objednávky v cene medzi {{min}} {{currency}} a {{max}} {{currency}}",
      price_min: "Pre objednávky v cene {{min}} {{currency}} alebo viac",
      quantity: "Pre objednávky obsahujúce medzi {{min}} a {{max}} položkami",
      quantity_min: "Pre objednávky obsahujúce {{min}} alebo viac položiek",
      weight: "Pre objednávky s celkovou hmotnosťou medzi {{min}}g a {{max}}g",
      weight_min: "Pre objednávky s celkovou hmotnosťou {{min}}g alebo viac"
    }
  },
  shipping_fee: "Poplatok za dopravu",
  total_amount_with_tax_and_shipping: "Celkom (vrátane dane a dopravy)",
  vat_percent: "Daň z predaja ({{percent}}%)",
  including_tax: "Vrátane DPH {{percent}}% ({{amount}})",
  total_amount_with_tax: "Celkom (vrátane dane)",
  total_amount_with_shipping: "Celkom (vrátane dopravy)"
}, VO = {
  public_pages_purchase: FO
}, BO = {
  "required-field": "Polje je obvezno",
  payment: {
    price_plan: "Načrtujte",
    stripe_card: "Kreditna ali debetna kartica",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditne kartice (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditne kartice (Mercado Pago)",
    mercadopago_pix: "PIX (plačilni trg)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Gotovino po povzetju",
    xendit_card: "Kreditne kartice (Xendit)",
    paystack_card: "Kreditne kartice (Paystack)",
    paypal_connect: "Povežite PayPal",
    paypal_edit_organization_name: "Uredi ime organizacije",
    paypal_rest: "PayPal",
    secure_and_pay: "Zavarujte in plačajte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Napaka",
  "Payment-method": "Način plačila",
  price_plan: {
    trial_period: {
      week_0: "{{count}} teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      day_0: "{{count}} dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      month_0: "{{count}} mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      year_0: "{{count}} leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    },
    interval: {
      month_0: "mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      day_0: "dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      week_0: "teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      year_0: "leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Brezplačno",
        trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Zdi se, da je ta seznam prazen",
    select: "Izberi"
  },
  contact_slug: {
    email: "E-pošta",
    first_name: "Ime",
    last_name: "Priimek",
    phone_number: "Telefonska številka",
    country: "Država",
    street_address: "Ulična naslov",
    city: "Mesto",
    postal_code: "Poštna številka",
    company_name: "Ime podjetja",
    tax_number: "Davčna številka",
    state_province: "Država/Provinca",
    street_number: "Številka ulice",
    neighborhood: "Soseska"
  },
  date_picker: {
    apply: "Uporabi",
    clear: "Počisti",
    time: "Čas",
    all_time: "Vse čase",
    last_3_months: "Zadnja 3 meseca",
    last_pool_period: "Zadnje obdobje ocenjevanja bazena",
    last_month: "Zadnji mesec",
    this_month: "Ta mesec",
    last_30_days: "Zadnjih 30 dni",
    title_dates: "Datumi",
    from: "Iz",
    to: "Do"
  },
  copy_clipboard: "Kopirano v odložišče",
  payment_inputs: {
    empty_card_number: "Vnesite številko kartice",
    invalid_card_number: "Številka kartice je neveljavna",
    empty_expiry_date: "Vnesite datum poteka",
    month_out_of_range: "Mesec poteka mora biti med 01 in 12",
    year_out_of_range: "Leto poteka ne more biti v preteklosti",
    date_out_of_range: "Datum poteka ne more biti v preteklosti",
    invalid_expiry_date: "Datum poteka je neveljaven",
    invalid_cvc: "CVC je neveljaven",
    empty_cvc: "Vnesite CVC",
    card_number_placeholder: "Številka kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Imetnik kartice",
    empty_card_holder: "Vnesite ime imetnika kartice"
  },
  copy_clipboard_error: "Kopiranje besedila ni uspelo",
  input: {
    phone_number: "Telefonska številka",
    phone_search: "Iskanje",
    search: "Iskanje"
  },
  "registered-over": "registrirani več kot",
  locale: {
    french: "Francosko",
    german: "Nemški",
    italian: "Italijanski",
    dutch: "Nizozemščina",
    english: "Angleščina",
    portuguese: "Portugalščina",
    russian: "Ruski",
    spanish: "španski",
    japanese: "Japonska",
    arabic: "Arabsko",
    turkish: "Turško",
    chinese: "Kitajski",
    swedish: "švedščina",
    romanian: "Romunščina",
    czech: "češki",
    hungarian: "Madžarski",
    slovak: "Slovaški",
    danish: "Danščina",
    indonesian: "Indonezijski",
    polish: "Poljski",
    greek: "Grški",
    serbian: "Srbsko",
    hindi: "Ne",
    norwegian: "Norveški",
    thai: "Tajska",
    slovenian: "Slovenščina",
    ukrainian: "Ukrajinski",
    albania: "Albanski"
  },
  product: "Izdelek",
  quantity: "Količina",
  order_summary: "Povzetek naročila",
  vat: "Davek na prodajo",
  total: "Skupaj",
  subtotal: "Medseštevek",
  shipping: {
    shipping_method: "Način dostave",
    not_available: "Oups! Zdi se, da še ne ponujamo dostave na to lokacijo.",
    condition_label: {
      price: "Za naročila v vrednosti med {{min}} {{currency}} in {{max}} {{currency}}",
      price_min: "Za naročila v vrednosti {{min}} {{currency}} ali več",
      quantity: "Za naročila, ki vsebujejo med {{min}} in {{max}} artikli",
      quantity_min: "Za naročila, ki vsebujejo {{min}} ali več artiklov",
      weight: "Za naročila s skupno težo med {{min}}g in {{max}}g",
      weight_min: "Za naročila s skupno težo {{min}}g ali več"
    }
  },
  shipping_fee: "Strošek dostave",
  total_amount_with_tax_and_shipping: "Skupaj (vključno z davkom in dostavo)",
  vat_percent: "Davek na prodajo ({{percent}}%)",
  including_tax: "Vključeno {{percent}}% DDV ({{amount}})",
  total_amount_with_tax: "Skupaj (vključno z davkom)",
  total_amount_with_shipping: "Skupaj (vključno s poštnino)"
}, zO = {
  public_pages_purchase: BO
}, GO = {
  "required-field": "Fusha kërkohet",
  payment: {
    price_plan: "Planifikoni",
    stripe_card: "Kartë krediti ose debiti",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (shirit)",
    dlocal_card: "Kartat e kreditit (Dlokale)",
    dlocal_boleto: "Boleto (lokale)",
    dlocal_pix: "Pix (vendor)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartat e kreditit (Mercado Pago)",
    mercadopago_pix: "PIX (Tregu i Pagesave)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Pa kartë",
    cash_on_delivery: "Para ne dore gjate dorezimit",
    xendit_card: "Kartat e kreditit (Xendit)",
    paystack_card: "Kartat e kreditit (Paystack)",
    paypal_connect: "Lidhni PayPal",
    paypal_edit_organization_name: "Redakto emrin e organizatës",
    paypal_rest: "PayPal",
    secure_and_pay: "Siguro dhe Paguaj",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Gabim",
  "Payment-method": "Mënyra e pagesës",
  price_plan: {
    trial_period: {
      week: "{{count}} javë",
      week_plural: "{{count}} javë",
      day: "{{count}} ditë",
      day_plural: "{{count}} ditë",
      month: "{{count}} muaj",
      month_plural: "{{count}} muaj",
      year: "{{count}} vit",
      year_plural: "{{count}} vjet"
    },
    interval: {
      month: "muaj",
      month_plural: "{{count}} muaj",
      day: "ditë",
      day_plural: "{{count}} ditë",
      week: "javë",
      week_plural: "{{count}} javë",
      year: "vit",
      year_plural: "{{count}} vjet"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Falas",
        trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj",
        unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë"
      }
    }
  },
  affiliate_badge: {
    made_with: "E fuqizuar nga"
  },
  form_select: {
    empty_list: "Duket se kjo listë është bosh",
    select: "Zgjidhni"
  },
  contact_slug: {
    email: "Email",
    first_name: "Emri i parë",
    last_name: "Mbiemri",
    phone_number: "Numri i telefonit",
    country: "Shteti",
    street_address: "Adresa e rrugës",
    city: "Qyteti",
    postal_code: "Kodi postar",
    company_name: "Emri i kompanisë",
    tax_number: "Numri i tatimit",
    state_province: "Shteti/Provinca",
    street_number: "Numri i rrugës",
    neighborhood: "Lagja"
  },
  date_picker: {
    apply: "Apliko",
    clear: "Pastro",
    time: "Koha",
    all_time: "Të gjitha kohët",
    last_3_months: "3 muajt e fundit",
    last_pool_period: "Periudha e fundit e vlerësimit të grupit",
    last_month: "Muaji i kaluar",
    this_month: "Ky muaj",
    last_30_days: "30 ditët e fundit",
    title_dates: "Datat",
    from: "Nga",
    to: "Në"
  },
  copy_clipboard: "Kopjuhet në clipboard",
  payment_inputs: {
    empty_card_number: "Shkruani një numër kartelash",
    invalid_card_number: "Numri i kartelës është i pavlefshëm",
    empty_expiry_date: "Shkruani një datë skadimi",
    month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12",
    year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën",
    date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën",
    invalid_expiry_date: "Data e skadencës është e pavlefshme",
    invalid_cvc: "CVC është i pavlefshëm",
    empty_cvc: "Shkruani një CVC",
    card_number_placeholder: "Numri i kartës",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Emri i mbajtësit të kartës",
    empty_card_holder: "Shkruani emrin e mbajtësit të kartës"
  },
  copy_clipboard_error: "Dështoi të kopjohet teksti",
  input: {
    phone_number: "Numri i telefonit",
    phone_search: "Kërko",
    search: "Kërko"
  },
  "registered-over": "regjistruar mbi",
  locale: {
    french: "Frëngjisht",
    german: "Gjermane",
    italian: "Italisht",
    dutch: "Holandeze",
    english: "Anglisht",
    portuguese: "Portugeze",
    russian: "Rusisht",
    spanish: "Spanjisht",
    japanese: "Japoneze",
    arabic: "Arabisht",
    turkish: "Turk",
    chinese: "Kineze",
    swedish: "Suedeze",
    romanian: "Rumun",
    czech: "çeke",
    hungarian: "Hungareze",
    slovak: "Sllovake",
    danish: "Daneze",
    indonesian: "Indonezisht",
    polish: "Polonisht",
    greek: "Greke",
    serbian: "Serb",
    hindi: "Jo",
    norwegian: "Norvegjeze",
    thai: "Thai",
    slovenian: "Slloven",
    ukrainian: "Ukrainase",
    albania: "Shqiptare"
  },
  product: "Produkt",
  quantity: "Sasia",
  order_summary: "Përmbledhja e Porosisë",
  vat: "Tatimi mbi shitjet",
  total: "Totali",
  subtotal: "Nëntotali",
  shipping: {
    shipping_method: "Metoda e Dërgesës",
    not_available: "Ups! Duket se nuk ofrojmë dërgesa në këtë vend akoma.",
    condition_label: {
      price: "Për porositë me çmim midis {{min}} {{currency}} dhe {{max}} {{currency}}",
      price_min: "Për porositë me çmim {{min}} {{currency}} ose më shumë",
      quantity: "Për porositë që përmbajnë midis {{min}} dhe {{max}} artikuj",
      quantity_min: "Për porositë që përmbajnë {{min}} ose më shumë artikuj",
      weight: "Për porositë me një peshë totale midis {{min}}g dhe {{max}}g",
      weight_min: "Për porositë me një peshë totale prej {{min}}g ose më shumë"
    }
  },
  shipping_fee: "Tarifa e dërgesës",
  total_amount_with_tax_and_shipping: "Totali (duke përfshirë taksën dhe dërgesën)",
  vat_percent: "Tatimi mbi shitjet ({{percent}}%)",
  including_tax: "Duke përfshirë TVSH-në {{percent}}% ({{amount}})",
  total_amount_with_tax: "Totali (përfshirë taksën)",
  total_amount_with_shipping: "Totali (përfshirë Transportin)"
}, UO = {
  public_pages_purchase: GO
}, ZO = {
  "required-field": "Поље је обавезно",
  payment: {
    price_plan: "План",
    stripe_card: "Kreditna ili debitna kartica",
    stripe_ideal: "иДеал (Стрипе)",
    stripe_bancotact: "Банцонтацт (Стрипе)",
    dlocal_card: "Кредитне картице (Длоцал)",
    dlocal_boleto: "Болето (Длоцал)",
    dlocal_pix: "Пик (Длоцал)",
    paypal_soap: "ПаиПал",
    mercadopago_card: "Кредитне картице (Мерцадо Паго)",
    mercadopago_pix: "ПИКС (тржиште плаћања)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Разорпаи",
    flutterwave: "Флуттерваве",
    mollie: "Моллие",
    gocardless: "Гоцардлесс",
    cash_on_delivery: "Плаћање поузећем",
    xendit_card: "Кредитне картице (Ксендит)",
    paystack_card: "Кредитне картице (Паистацк)",
    paypal_connect: "Повежите ПаиПал",
    paypal_edit_organization_name: "Измените назив организације",
    paypal_rest: "ПаиПал",
    secure_and_pay: "Осигурајте и платите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Грешка",
  "Payment-method": "Начин плаћања",
  price_plan: {
    trial_period: {
      week_0: "{{count}} недеља",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      day_0: "{{count}} дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      month_0: "{{count}} месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      year_0: "{{count}} година",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    },
    interval: {
      month_0: "месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      day_0: "дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      week_0: "недељу дана",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      year_0: "године",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда",
        unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута"
      }
    }
  },
  affiliate_badge: {
    made_with: "Pokreće"
  },
  form_select: {
    empty_list: "Izgleda da je ova lista prazna",
    select: "Izaberi"
  },
  contact_slug: {
    email: "Email",
    first_name: "Ime",
    last_name: "Prezime",
    phone_number: "Broj telefona",
    country: "Zemlja",
    street_address: "Adresa",
    city: "Grad",
    postal_code: "Poštanski broj",
    company_name: "Naziv kompanije",
    tax_number: "Poreski broj",
    state_province: "Država/Provincija",
    street_number: "Broj ulice",
    neighborhood: "Kraj"
  },
  date_picker: {
    apply: "Primeni",
    clear: "Obriši",
    time: "Vreme",
    all_time: "Sve vreme",
    last_3_months: "Poslednja 3 meseca",
    last_pool_period: "Poslednji period evaluacije",
    last_month: "Prošli mesec",
    this_month: "Ovaj mesec",
    last_30_days: "Poslednjih 30 dana",
    title_dates: "Datumi",
    from: "Od",
    to: "Do"
  },
  copy_clipboard: "Kopirano u međuspremnik",
  payment_inputs: {
    empty_card_number: "Unesite broj kartice",
    invalid_card_number: "Broj kartice je nevažeći",
    empty_expiry_date: "Unesite datum isteka",
    month_out_of_range: "Mesec isteka mora biti između 01 i 12",
    year_out_of_range: "Godina isteka ne može biti u prošlosti",
    date_out_of_range: "Datum isteka ne može biti u prošlosti",
    invalid_expiry_date: "Datum isteka je nevažeći",
    invalid_cvc: "CVC je nevažeći",
    empty_cvc: "Unesite CVC",
    card_number_placeholder: "Broj kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Ime vlasnika kartice",
    empty_card_holder: "Unesite ime vlasnika kartice"
  },
  copy_clipboard_error: "Kopiranje teksta nije uspelo",
  input: {
    phone_number: "Broj telefona",
    phone_search: "Pretraži",
    search: "Pretraži"
  },
  "registered-over": "registrovano više od",
  locale: {
    french: "Француски",
    german: "Немачки",
    italian: "Италијан",
    dutch: "холандски",
    english: "енглески језик",
    portuguese: "португалски",
    russian: "Руски",
    spanish: "Шпански",
    japanese: "јапански",
    arabic: "арапски",
    turkish: "турски",
    chinese: "кинески",
    swedish: "Шведски",
    romanian: "румунски",
    czech: "чешки",
    hungarian: "мађарски",
    slovak: "словачки",
    danish: "дански",
    indonesian: "индонезијски",
    polish: "Пољски",
    greek: "грчки",
    serbian: "Српски",
    hindi: "Јок",
    norwegian: "норвешки",
    thai: "тајландски",
    slovenian: "словеначки",
    ukrainian: "украјински",
    albania: "Албанац"
  },
  product: "Proizvod",
  quantity: "Količina",
  order_summary: "Pregled narudžbine",
  vat: "Porez na promet",
  total: "Ukupno",
  subtotal: "Međuzbir",
  shipping: {
    shipping_method: "Metod isporuke",
    not_available: "Ups! Izgleda da još ne nudimo isporuku na ovu lokaciju.",
    condition_label: {
      price: "Za narudžbine u cenovnom rasponu od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Za narudžbine od {{min}} {{currency}} ili više",
      quantity: "Za narudžbine koje sadrže između {{min}} i {{max}} stavki",
      quantity_min: "Za narudžbine koje sadrže {{min}} ili više stavki",
      weight: "Za narudžbine sa ukupnom težinom između {{min}}g i {{max}}g",
      weight_min: "Za narudžbine sa ukupnom težinom od {{min}}g ili više"
    }
  },
  shipping_fee: "Trošak isporuke",
  total_amount_with_tax_and_shipping: "Ukupno (uključujući porez i isporuku)",
  vat_percent: "Porez na promet ({{percent}}%)",
  including_tax: "Uključujući {{percent}}% PDV ({{amount}})",
  total_amount_with_tax: "Ukupno (uključujući porez)",
  total_amount_with_shipping: "Ukupno (uključujući dostavu)"
}, KO = {
  public_pages_purchase: ZO
}, $O = {
  "required-field": "Fält är obligatoriskt",
  payment: {
    price_plan: "Planen",
    stripe_card: "Kredit- eller betalkort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalningsmarknad)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Fluttervåg",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Postförskott",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Anslut PayPal",
    paypal_edit_organization_name: "Redigera organisationens namn",
    paypal_rest: "PayPal",
    secure_and_pay: "Säkra och betala",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fel",
  "Payment-method": "Betalningsmetod",
  price_plan: {
    trial_period: {
      week: "{{count}} vecka",
      week_plural: "{{count}} veckor",
      day: "{{count}} dag",
      day_plural: "{{count}} dagar",
      month: "{{count}} månad",
      month_plural: "{{count}} månader",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "månad",
      month_plural: "{{count}} månader",
      day: "dag",
      day_plural: "{{count}} dagar",
      week: "vecka",
      week_plural: "{{count}} veckor",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan",
        unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drivs av"
  },
  form_select: {
    empty_list: "Det verkar som att denna lista är tom",
    select: "Välj"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Förnamn",
    last_name: "Efternamn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gatuadress",
    city: "Stad",
    postal_code: "Postnummer",
    company_name: "Företagsnamn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gatu nummer",
    neighborhood: "Grannskap"
  },
  date_picker: {
    apply: "Tillämpa",
    clear: "Rensa",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Senaste 3 månaderna",
    last_pool_period: "Senaste poolutvärderingsperioden",
    last_month: "Senaste månaden",
    this_month: "Denna månad",
    last_30_days: "Senaste 30 dagarna",
    title_dates: "Datum",
    from: "Från",
    to: "Till"
  },
  copy_clipboard: "Kopierad till urklipp",
  payment_inputs: {
    empty_card_number: "Ange ett kortnummer",
    invalid_card_number: "Kortnumret är ogiltigt",
    empty_expiry_date: "Ange ett utgångsdatum",
    month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12",
    year_out_of_range: "Utgångsår kan inte vara i det förflutna",
    date_out_of_range: "Utgångsdatum kan inte vara i det förflutna",
    invalid_expiry_date: "Utgångsdatum är ogiltigt",
    invalid_cvc: "CVC är ogiltigt",
    empty_cvc: "Ange en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortinnehavare",
    empty_card_holder: "Ange ett namn på kortinnehavaren"
  },
  copy_clipboard_error: "Misslyckades med att kopiera text",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Sök",
    search: "Sök"
  },
  "registered-over": "registrerade över",
  locale: {
    french: "Franska",
    german: "Tysk",
    italian: "Italienska",
    dutch: "Holländska",
    english: "Engelsk",
    portuguese: "Portugisiska",
    russian: "Ryska",
    spanish: "Spanska",
    japanese: "Japanska",
    arabic: "Arabiska",
    turkish: "Turkiska",
    chinese: "Kinesiska",
    swedish: "Svenska",
    romanian: "Rumänska",
    czech: "Tjeckiska",
    hungarian: "Ungerska",
    slovak: "Slovakiska",
    danish: "Danska",
    indonesian: "Indonesiska",
    polish: "Putsa",
    greek: "Grekisk",
    serbian: "Serbiska",
    hindi: "Nej",
    norwegian: "Norska",
    thai: "Thai",
    slovenian: "Slovenska",
    ukrainian: "Ukrainska",
    albania: "Albanska"
  },
  product: "Produkt",
  quantity: "Antal",
  order_summary: "Orderöversikt",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsumma",
  shipping: {
    shipping_method: "Fraktmetod",
    not_available: "Oj! Det verkar som om vi inte erbjuder frakt till denna plats än.",
    condition_label: {
      price: "För beställningar prissatta mellan {{min}} {{currency}} och {{max}} {{currency}}",
      price_min: "För beställningar prissatta till {{min}} {{currency}} eller mer",
      quantity: "För beställningar som innehåller mellan {{min}} till {{max}} artiklar",
      quantity_min: "För beställningar som innehåller {{min}} eller fler artiklar",
      weight: "För beställningar med en totalvikt mellan {{min}}g och {{max}}g",
      weight_min: "För beställningar med en totalvikt av {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktavgift",
  total_amount_with_tax_and_shipping: "Totalt (inklusive skatt och frakt)",
  vat_percent: "Moms ({{percent}}%)",
  including_tax: "Inklusive {{percent}}% moms ({{amount}})",
  total_amount_with_tax: "Totalt (inklusive moms)",
  total_amount_with_shipping: "Totalt (inklusive frakt)"
}, WO = {
  public_pages_purchase: $O
}, YO = {
  "required-field": "จำเป็นต้องกรอกข้อมูล",
  payment: {
    price_plan: "วางแผน",
    stripe_card: "บัตรเครดิตหรือเดบิต",
    stripe_ideal: "ไอดีล (ลายทาง)",
    stripe_bancotact: "แบนคอนแทค (ลายทาง)",
    dlocal_card: "บัตรเครดิต (ดีโลคอล)",
    dlocal_boleto: "โบเลโต (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "เพย์พาล",
    mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)",
    mercadopago_pix: "PIX (ตลาดการชำระเงิน)",
    mercadopago_boleto: "โบเลโต (Mercado Pago)",
    razorpay: "เรเซอร์เพย์",
    flutterwave: "กระพือปีก",
    mollie: "มอลลี่",
    gocardless: "ไร้บัตร",
    cash_on_delivery: "เงินสดในการจัดส่ง",
    xendit_card: "บัตรเครดิต (Xendit)",
    paystack_card: "บัตรเครดิต (เพย์สแต็ค)",
    paypal_connect: "เชื่อมต่อเพย์พาล",
    paypal_edit_organization_name: "แก้ไขชื่อองค์กร",
    paypal_rest: "เพย์พาล",
    secure_and_pay: "ปลอดภัยและชำระเงิน",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "ข้อผิดพลาด",
  "Payment-method": "วิธีการชำระเงิน",
  price_plan: {
    trial_period: {
      week: "{{count}} สัปดาห์",
      day: "{{count}} วัน",
      month: "{{count}} เดือน",
      year: "{{count}} ปี"
    },
    interval: {
      month: "เดือน",
      day: "วัน",
      week: "สัปดาห์",
      year: "ปี"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "ฟรี",
        trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น",
        unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง"
      }
    }
  },
  affiliate_badge: {
    made_with: "ขับเคลื่อนโดย"
  },
  form_select: {
    empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า",
    select: "เลือก"
  },
  contact_slug: {
    email: "อีเมล",
    first_name: "ชื่อจริง",
    last_name: "นามสกุล",
    phone_number: "หมายเลขโทรศัพท์",
    country: "ประเทศ",
    street_address: "ที่อยู่ถนน",
    city: "เมือง",
    postal_code: "รหัสไปรษณีย์",
    company_name: "ชื่อบริษัท",
    tax_number: "หมายเลขภาษี",
    state_province: "รัฐ/จังหวัด",
    street_number: "หมายเลขถนน",
    neighborhood: "ย่าน"
  },
  date_picker: {
    apply: "สมัคร",
    clear: "ล้าง",
    time: "เวลา",
    all_time: "ทั้งหมด",
    last_3_months: "3 เดือนที่ผ่านมา",
    last_pool_period: "ช่วงเวลาประเมินผลล่าสุด",
    last_month: "เดือนที่แล้ว",
    this_month: "เดือนนี้",
    last_30_days: "30 วันที่ผ่านมา",
    title_dates: "วันที่",
    from: "จาก",
    to: "ถึง"
  },
  copy_clipboard: "คัดลอกไปยังคลิปบอร์ด",
  payment_inputs: {
    empty_card_number: "กรอกหมายเลขบัตร",
    invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง",
    empty_expiry_date: "กรอกวันที่หมดอายุ",
    month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12",
    year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้",
    date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้",
    invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง",
    invalid_cvc: "CVC ไม่ถูกต้อง",
    empty_cvc: "กรุณาใส่ CVC",
    card_number_placeholder: "หมายเลขบัตร",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "ชื่อผู้ถือบัตร",
    empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร"
  },
  copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้",
  input: {
    phone_number: "หมายเลขโทรศัพท์",
    phone_search: "ค้นหา",
    search: "ค้นหา"
  },
  "registered-over": "ลงทะเบียนมากกว่า",
  locale: {
    french: "ภาษาฝรั่งเศส",
    german: "เยอรมัน",
    italian: "ภาษาอิตาลี",
    dutch: "ภาษาดัตช์",
    english: "ภาษาอังกฤษ",
    portuguese: "โปรตุเกส",
    russian: "ภาษารัสเซีย",
    spanish: "สเปน",
    japanese: "ญี่ปุ่น",
    arabic: "ภาษาอาหรับ",
    turkish: "ภาษาตุรกี",
    chinese: "ชาวจีน",
    swedish: "ภาษาสวีเดน",
    romanian: "โรมาเนีย",
    czech: "เช็ก",
    hungarian: "ภาษาฮังการี",
    slovak: "สโลวัก",
    danish: "ภาษาเดนมาร์ก",
    indonesian: "ชาวอินโดนีเซีย",
    polish: "ขัด",
    greek: "กรีก",
    serbian: "เซอร์เบีย",
    hindi: "ไม่",
    norwegian: "ภาษานอร์เวย์",
    thai: "แบบไทย",
    slovenian: "ภาษาสโลเวเนีย",
    ukrainian: "ภาษายูเครน",
    albania: "แอลเบเนีย"
  },
  product: "ผลิตภัณฑ์",
  quantity: "จำนวน",
  order_summary: "สรุปคำสั่งซื้อ",
  vat: "ภาษีขาย",
  total: "รวม",
  subtotal: "ยอดรวมย่อย",
  shipping: {
    shipping_method: "วิธีการจัดส่ง",
    not_available: "อุ๊บส์! ดูเหมือนว่าเรายังไม่สามารถจัดส่งไปยังสถานที่นี้ได้",
    condition_label: {
      price: "สำหรับคำสั่งซื้อที่มีราคาอยู่ระหว่าง {{min}} {{currency}} ถึง {{max}} {{currency}}",
      price_min: "สำหรับคำสั่งซื้อที่มีราคา {{min}} {{currency}} ขึ้นไป",
      quantity: "สำหรับคำสั่งซื้อที่มีจำนวนระหว่าง {{min}} ถึง {{max}} รายการ",
      quantity_min: "สำหรับคำสั่งซื้อที่มีจำนวน {{min}} รายการขึ้นไป",
      weight: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวมระหว่าง {{min}}g ถึง {{max}}g",
      weight_min: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวม {{min}}g ขึ้นไป"
    }
  },
  shipping_fee: "ค่าจัดส่ง",
  total_amount_with_tax_and_shipping: "รวม (รวมภาษีและค่าจัดส่ง)",
  vat_percent: "ภาษีขาย ({{percent}}%)",
  including_tax: "รวมภาษีมูลค่าเพิ่ม {{percent}}% ({{amount}})",
  total_amount_with_tax: "รวมทั้งภาษีแล้ว",
  total_amount_with_shipping: "รวมค่าส่งแล้ว"
}, qO = {
  public_pages_purchase: YO
}, JO = {
  "required-field": "Alan gereklidir",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredi veya banka kartı",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "İletişimi yasakla (Stripe)",
    dlocal_card: "Kredi kartları (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredi kartları (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Çarpıntı dalgası",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kapıda ödeme",
    xendit_card: "Kredi kartları (Xendit)",
    paystack_card: "Kredi kartları (Paystack)",
    paypal_connect: "PayPal'ı bağlayın",
    paypal_edit_organization_name: "Kuruluş adını düzenleyin",
    paypal_rest: "PayPal",
    secure_and_pay: "Güvenli ve Ödemeli",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Güvenlik"
    }
  },
  error: "Hata",
  "Payment-method": "Ödeme yöntemi",
  price_plan: {
    trial_period: {
      week: "{{count}} hafta",
      week_plural: "{{count}} hafta",
      day: "{{count}} gün",
      day_plural: "{{count}} gün",
      month: "{{count}} ay",
      month_plural: "{{count}} ay",
      year: "{{count}} yıl",
      year_plural: "{{count}} yıl"
    },
    interval: {
      month: "ay",
      month_plural: "{{count}} ay",
      day: "gün",
      day_plural: "{{count}} gün",
      week: "hafta",
      week_plural: "{{count}} hafta",
      year: "yıl",
      year_plural: "{{count}} yıl"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ücretsiz",
        trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra",
        unlimited_new: "<bold>{{amount}}</bold> her {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez"
      }
    }
  },
  affiliate_badge: {
    made_with: "Tarafından desteklenmektedir"
  },
  form_select: {
    empty_list: "Bu liste boş gibi görünüyor",
    select: "Seçin"
  },
  contact_slug: {
    email: "E-posta",
    first_name: "İsim",
    last_name: "Soyisim",
    phone_number: "Telefon numarası",
    country: "Ülke",
    street_address: "Sokak adresi",
    city: "Şehir",
    postal_code: "Posta kodu",
    company_name: "Şirket adı",
    tax_number: "Vergi numarası",
    state_province: "Eyalet/İl",
    street_number: "Sokak numarası",
    neighborhood: "Mahalle"
  },
  date_picker: {
    apply: "Uygula",
    clear: "Temizle",
    time: "Zaman",
    all_time: "Tüm zamanlar",
    last_3_months: "Son 3 ay",
    last_pool_period: "Son havuz değerlendirme dönemi",
    last_month: "Geçen Ay",
    this_month: "Bu Ay",
    last_30_days: "Son 30 gün",
    title_dates: "Tarihler",
    from: "Tarihinden itibaren",
    to: "Tarihine kadar"
  },
  copy_clipboard: "Panoya kopyalandı",
  payment_inputs: {
    empty_card_number: "Bir kart numarası girin",
    invalid_card_number: "Kart numarası geçersiz",
    empty_expiry_date: "Bir son kullanma tarihi girin",
    month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır",
    year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz",
    date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz",
    invalid_expiry_date: "Son kullanma tarihi geçersiz",
    invalid_cvc: "CVC geçersiz",
    empty_cvc: "CVC girin",
    card_number_placeholder: "Kart numarası",
    expiry_data_placeholder: "AA/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kart sahibi",
    empty_card_holder: "Bir kart sahibi adı girin"
  },
  copy_clipboard_error: "Metin kopyalanamadı",
  input: {
    phone_number: "Telefon numarası",
    phone_search: "Ara",
    search: "Ara"
  },
  "registered-over": "kaydedilen",
  locale: {
    french: "Fransızca",
    german: "Almanca",
    italian: "İtalyan",
    dutch: "Flemenkçe",
    english: "İngilizce",
    portuguese: "Portekizce",
    russian: "Rusça",
    spanish: "İspanyol",
    japanese: "Japonca",
    arabic: "Arap",
    turkish: "Türkçe",
    chinese: "Çince",
    swedish: "İsveççe",
    romanian: "Romen",
    czech: "Çek",
    hungarian: "Macarca",
    slovak: "Slovak",
    danish: "Danimarka",
    indonesian: "Endonezya dili",
    polish: "Lehçe",
    greek: "Yunan",
    serbian: "Sırpça",
    hindi: "Hintçe",
    norwegian: "Norveççe",
    thai: "Tay dili",
    slovenian: "Slovence",
    ukrainian: "Ukrayna",
    albania: "Arnavut"
  },
  product: "Ürün",
  quantity: "Miktar",
  order_summary: "Sipariş Özeti",
  vat: "Satış vergisi",
  total: "Toplam",
  subtotal: "Ara Toplam",
  shipping: {
    shipping_method: "Gönderim Yöntemi",
    not_available: "Aman! Görünüşe göre bu konuma henüz gönderim yapmıyoruz.",
    condition_label: {
      price: "{{min}} {{currency}} ile {{max}} {{currency}} arasında fiyatlandırılan siparişler için",
      price_min: "{{min}} {{currency}} veya daha fazla fiyatlandırılan siparişler için",
      quantity: "{{min}} ile {{max}} ürün içeren siparişler için",
      quantity_min: "{{min}} veya daha fazla ürün içeren siparişler için",
      weight: "Toplam ağırlığı {{min}}g ile {{max}}g arasında olan siparişler için",
      weight_min: "Toplam ağırlığı {{min}}g veya daha fazla olan siparişler için"
    }
  },
  shipping_fee: "Gönderim ücreti",
  total_amount_with_tax_and_shipping: "Toplam (vergi ve gönderim dahil)",
  vat_percent: "Satış vergisi ({{percent}}%)",
  including_tax: "KDV dahil {{percent}}% ({{amount}})",
  total_amount_with_tax: "Toplam (vergiler dahil)",
  total_amount_with_shipping: "Toplam (kargo dahil)"
}, XO = {
  public_pages_purchase: JO
}, QO = {
  "required-field": "Поле обов'язкове",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитна або дебетова карта",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Кредитні картки (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Пікс (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Кредитні картки (Mercado Pago)",
    mercadopago_pix: "PIX (платіжний ринок)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Razorpay",
    flutterwave: "Флаттервейв",
    mollie: "Моллі",
    gocardless: "Gocardless",
    cash_on_delivery: "Накладений платіж",
    xendit_card: "Кредитні картки (Xendit)",
    paystack_card: "Кредитні картки (Paystack)",
    paypal_connect: "Підключіть PayPal",
    paypal_edit_organization_name: "Редагувати назву організації",
    paypal_rest: "PayPal",
    secure_and_pay: "Захистіть і заплатите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Помилка",
  "Payment-method": "Спосіб оплати",
  price_plan: {
    trial_period: {
      week_0: "{{count}} тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      day_0: "{{count}} день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      month_0: "{{count}} місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      year_0: "{{count}} рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    },
    interval: {
      month_0: "місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      day_0: "день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      week_0: "тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      year_0: "рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "безкоштовно",
        trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ",
        unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів"
      }
    }
  },
  affiliate_badge: {
    made_with: "Підтримується"
  },
  form_select: {
    empty_list: "Схоже, що цей список порожній",
    select: "Вибрати"
  },
  contact_slug: {
    email: "Електронна пошта",
    first_name: "Ім'я",
    last_name: "Прізвище",
    phone_number: "Номер телефону",
    country: "Країна",
    street_address: "Вулиця",
    city: "Місто",
    postal_code: "Поштовий індекс",
    company_name: "Назва компанії",
    tax_number: "Податковий номер",
    state_province: "Штат/Область",
    street_number: "Номер вулиці",
    neighborhood: "Район"
  },
  date_picker: {
    apply: "Застосувати",
    clear: "Очистити",
    time: "Час",
    all_time: "Весь час",
    last_3_months: "Останні 3 місяці",
    last_pool_period: "Останній період оцінки пулу",
    last_month: "Останній місяць",
    this_month: "Цей місяць",
    last_30_days: "Останні 30 днів",
    title_dates: "Дати",
    from: "З",
    to: "До"
  },
  copy_clipboard: "Скопійовано в буфер обміну",
  payment_inputs: {
    empty_card_number: "Введіть номер картки",
    invalid_card_number: "Номер картки недійсний",
    empty_expiry_date: "Введіть дату закінчення терміну дії",
    month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12",
    year_out_of_range: "Рік закінчення не може бути в минулому",
    date_out_of_range: "Дата закінчення не може бути в минулому",
    invalid_expiry_date: "Дата закінчення недійсна",
    invalid_cvc: "CVC недійсний",
    empty_cvc: "Введіть CVC",
    card_number_placeholder: "Номер картки",
    expiry_data_placeholder: "ММ/РР",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Власник картки",
    empty_card_holder: "Введіть ім'я власника картки"
  },
  copy_clipboard_error: "Не вдалося скопіювати текст",
  input: {
    phone_number: "Номер телефону",
    phone_search: "Пошук",
    search: "Пошук"
  },
  "registered-over": "зареєстровано понад",
  locale: {
    french: "французька",
    german: "Німецький",
    italian: "італійська",
    dutch: "голландська",
    english: "англійська",
    portuguese: "португальська",
    russian: "російський",
    spanish: "Іспанська",
    japanese: "Японський",
    arabic: "арабська",
    turkish: "турецька",
    chinese: "китайський",
    swedish: "шведська",
    romanian: "румунська",
    czech: "чеська",
    hungarian: "угорська",
    slovak: "словацький",
    danish: "датська",
    indonesian: "індонезійська",
    polish: "польський",
    greek: "грецька",
    serbian: "сербська",
    hindi: "ні",
    norwegian: "норвезька",
    thai: "тайська",
    slovenian: "словенська",
    ukrainian: "Українська",
    albania: "албанець"
  },
  product: "Продукт",
  quantity: "Кількість",
  order_summary: "Підсумок замовлення",
  vat: "Податок на продаж",
  total: "Всього",
  subtotal: "Проміжний підсумок",
  shipping: {
    shipping_method: "Спосіб доставки",
    not_available: "Упс! Схоже, що ми ще не пропонуємо доставку в це місце.",
    condition_label: {
      price: "Для замовлень вартістю від {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для замовлень вартістю від {{min}} {{currency}} або більше",
      quantity: "Для замовлень, що містять від {{min}} до {{max}} товарів",
      quantity_min: "Для замовлень, що містять {{min}} або більше товарів",
      weight: "Для замовлень з загальною вагою від {{min}}g до {{max}}g",
      weight_min: "Для замовлень з загальною вагою {{min}}g або більше"
    }
  },
  shipping_fee: "Вартість доставки",
  total_amount_with_tax_and_shipping: "Всього (включаючи податок і доставку)",
  vat_percent: "Податок з продажу ({{percent}}%)",
  including_tax: "З урахуванням ПДВ {{percent}}% ({{amount}})",
  total_amount_with_tax: "Загалом (з урахуванням податку)",
  total_amount_with_shipping: "Загалом (з урахуванням доставки)"
}, eN = {
  public_pages_purchase: QO
}, tN = {
  "required-field": "字段为必填项",
  payment: {
    price_plan: "计划",
    stripe_card: "信用卡或借记卡",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "信用卡（Dlocal）",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "信用卡（Mercado Pago）",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto（Mercado Pago）",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "货到付款",
    xendit_card: "信用卡 (Xendit)",
    paystack_card: "信用卡（Paystack）",
    paypal_connect: "连接 PayPal",
    paypal_edit_organization_name: "编辑组织名称",
    paypal_rest: "PayPal",
    secure_and_pay: "安全与支付",
    stripe_applepay: "苹果支付",
    xendit: {
      "3ds": "3D-安全"
    }
  },
  error: "错误",
  "Payment-method": "付款方式",
  price_plan: {
    trial_period: {
      week: `周

{{count}} 周`,
      day: `{{count}} 天

{{count}} 天`,
      month: `{{count}} 月

{{count}} 月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `月

{{count}} 月`,
      day: `天

{{count}} 天`,
      week: `周

{{count}}周`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "免费",
        trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后",
        unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次"
      }
    }
  },
  affiliate_badge: {
    made_with: "技术支持"
  },
  form_select: {
    empty_list: "看起来这个列表是空的",
    select: "选择"
  },
  contact_slug: {
    email: "电子邮件",
    first_name: "名字",
    last_name: "姓氏",
    phone_number: "电话号码",
    country: "国家",
    street_address: "街道地址",
    city: "城市",
    postal_code: "邮政编码",
    company_name: "公司名称",
    tax_number: "税号",
    state_province: "州/省",
    street_number: "街道号码",
    neighborhood: "街道邻里"
  },
  date_picker: {
    apply: "应用",
    clear: "清除",
    time: "时间",
    all_time: "所有的时间",
    last_3_months: "过去3个月",
    last_pool_period: "最后一个池评估期",
    last_month: "次月",
    this_month: "这个月",
    last_30_days: "过去30天",
    title_dates: "日期",
    from: "从",
    to: "到"
  },
  copy_clipboard: "已复制到剪贴板",
  payment_inputs: {
    empty_card_number: "输入卡号",
    invalid_card_number: "卡号无效",
    empty_expiry_date: "输入到期日期",
    month_out_of_range: "到期月份必须在01到12之间",
    year_out_of_range: "到期年不能是过去的年份",
    date_out_of_range: "过期日期不能是过去时间",
    invalid_expiry_date: "过期日期无效",
    invalid_cvc: "CVC无效",
    empty_cvc: "输入CVC",
    card_number_placeholder: "卡号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "持卡人",
    empty_card_holder: "输入持卡人姓名"
  },
  copy_clipboard_error: "复制文本失败",
  input: {
    phone_number: "电话号码",
    phone_search: "搜索",
    search: "搜索"
  },
  "registered-over": "注册超过",
  locale: {
    french: "法语",
    german: "德语",
    italian: "意大利语",
    dutch: "荷兰语",
    english: "英语",
    portuguese: "葡萄牙语",
    russian: "俄语",
    spanish: "西班牙语",
    japanese: "日语",
    arabic: "阿拉伯语",
    turkish: "土耳其语",
    chinese: "中國人",
    swedish: "瑞典语",
    romanian: "罗马尼亚语",
    czech: "捷克语",
    hungarian: "匈牙利语",
    slovak: "斯洛伐克语",
    danish: "丹麦语",
    indonesian: "印度尼西亚语",
    polish: "波兰语",
    greek: "希腊语",
    serbian: "塞尔维亚语",
    hindi: "印地语",
    norwegian: "挪威语",
    thai: "泰语",
    slovenian: "斯洛文尼亚语",
    ukrainian: "乌克兰语",
    albania: "阿尔巴尼亚语"
  },
  product: "产品",
  quantity: "数量",
  order_summary: "订单摘要",
  vat: "销售税",
  total: "总计",
  subtotal: "小计",
  shipping: {
    shipping_method: "运输方式",
    not_available: "哎呀！看起来我们还不提供该地点的运输服务。",
    condition_label: {
      price: "对于价格在 {{min}} {{currency}} 到 {{max}} {{currency}} 之间的订单",
      price_min: "对于价格在 {{min}} {{currency}} 或以上的订单",
      quantity: "对于包含 {{min}} 到 {{max}} 件商品的订单",
      quantity_min: "对于包含 {{min}} 件或更多商品的订单",
      weight: "对于总重量在 {{min}}g 到 {{max}}g 之间的订单",
      weight_min: "对于总重量在 {{min}}g 或以上的订单"
    }
  },
  shipping_fee: "运费",
  total_amount_with_tax_and_shipping: "总计（包括税费和运费）",
  vat_percent: "销售税 ({{percent}}%)",
  including_tax: "含{{percent}}%增值税（{{amount}}）",
  total_amount_with_tax: "总计（含税）",
  total_amount_with_shipping: "总计（含运费）"
}, rN = {
  public_pages_purchase: tN
}, RC = ["common"], nN = RC[0], aN = Object.values(Tr), iN = {
  ar: { common: rO },
  cs: { common: aO },
  da: { common: oO },
  de: { common: lO },
  el: { common: uO },
  en: { common: pO },
  es: { common: mO },
  fr: { common: CO },
  hi: { common: yO },
  hu: { common: bO },
  id: { common: wO },
  it: { common: SO },
  ja: { common: MO },
  nl: { common: EO },
  no: { common: LO },
  pl: { common: OO },
  pt: { common: jO },
  ro: { common: DO },
  ru: { common: HO },
  sk: { common: VO },
  sl: { common: zO },
  sq: { common: UO },
  sr: { common: KO },
  sv: { common: WO },
  th: { common: qO },
  tr: { common: XO },
  uk: { common: eN },
  zh: { common: rN }
}, oN = {
  supportedLngs: aN,
  load: "languageOnly",
  debug: !1,
  defaultNS: nN,
  react: { useSuspense: !1 },
  returnEmptyString: !1,
  ns: RC,
  compatibilityJSON: "v3",
  fallbackLng: Tr.ENGLISH,
  lng: Tr.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: iN
};
Xe.use(LA).init(oN);
const DC = (e) => {
  switch (e) {
    case ge.stripe_card:
      return Xe.t("public_pages_purchase.payment.stripe_card");
    case ge.stripe_ideal:
      return Xe.t("public_pages_purchase.payment.stripe_ideal");
    case ge.stripe_bancontact:
      return Xe.t("public_pages_purchase.payment.stripe_bancotact");
    case ge.stripe_applepay:
      return Xe.t("public_pages_purchase.payment.stripe_applepay");
    case ge.dlocal_card:
      return Xe.t("public_pages_purchase.payment.dlocal_card");
    case ge.dlocal_boleto:
      return Xe.t("public_pages_purchase.payment.dlocal_boleto");
    case ge.dlocal_pix:
      return Xe.t("public_pages_purchase.payment.dlocal_pix");
    case ge.paypal_soap:
    case ge.paypal_rest:
      return Xe.t("public_pages_purchase.payment.paypal_soap");
    case ge.mercadopago_br_card:
      return Xe.t("public_pages_purchase.payment.mercadopago_card");
    case ge.mercadopago_br_pix:
      return Xe.t("public_pages_purchase.payment.mercadopago_pix");
    case ge.mercadopago_br_boleto:
      return Xe.t("public_pages_purchase.payment.mercadopago_boleto");
    case ge.mercadopago_co_card:
    case ge.mercadopago_ar_card:
    case ge.mercadopago_mx_card:
    case ge.mercadopago_cl_card:
      return Xe.t("public_pages_purchase.payment.mercadopago_card");
    case ge.razorpay:
      return Xe.t("public_pages_purchase.payment.razorpay");
    case ge.flutterwave:
      return Xe.t("public_pages_purchase.payment.flutterwave");
    case ge.mollie:
      return Xe.t("public_pages_purchase.payment.mollie");
    case ge.gocardless:
      return Xe.t("public_pages_purchase.payment.gocardless");
    case ge.cash_on_delivery:
      return Xe.t("public_pages_purchase.payment.cash_on_delivery");
    case ge.xendit_id_card:
    case ge.xendit_ph_card:
      return Xe.t("public_pages_purchase.payment.xendit_card");
    case ge.paystack_gh_card:
    case ge.paystack_ke_card:
    case ge.paystack_ng_card:
    case ge.paystack_za_card:
    case ge.paystack_eg_card:
    case ge.paystack_ci_card:
      return Xe.t("public_pages_purchase.payment.paystack_card");
    case ge.secure_and_pay:
      return Xe.t("public_pages_purchase.payment.secure_and_pay");
  }
}, sN = (e, t) => {
  switch (e) {
    case ge.stripe_card:
    case ge.dlocal_card:
    case ge.mercadopago_br_card:
    case ge.mercadopago_ar_card:
    case ge.mercadopago_co_card:
    case ge.mercadopago_mx_card:
    case ge.mercadopago_cl_card:
    case ge.secure_and_pay:
      return /* @__PURE__ */ y.jsx(HL, { ...t });
    case ge.stripe_applepay:
      return /* @__PURE__ */ y.jsx(OL, { ...t });
    case ge.stripe_ideal:
      return /* @__PURE__ */ y.jsx(BL, { ...t });
    case ge.stripe_bancontact:
      return /* @__PURE__ */ y.jsx(NL, { ...t });
    case ge.dlocal_boleto:
    case ge.mercadopago_br_boleto:
      return /* @__PURE__ */ y.jsx(jL, { ...t });
    case ge.dlocal_pix:
    case ge.mercadopago_br_pix:
      return /* @__PURE__ */ y.jsx(KL, { ...t });
    case ge.paypal_soap:
    case ge.paypal_rest:
      return /* @__PURE__ */ y.jsx(GL, { ...t });
    case ge.razorpay:
      return /* @__PURE__ */ y.jsx($L, { ...t });
    case ge.flutterwave:
      return /* @__PURE__ */ y.jsx(FL, { ...t });
    case ge.mollie:
      return /* @__PURE__ */ y.jsx(zL, { ...t });
    case ge.gocardless:
      return /* @__PURE__ */ y.jsx(VL, { ...t });
    case ge.cash_on_delivery:
      return /* @__PURE__ */ y.jsx(DL, { ...t });
    case ge.xendit_id_card:
    case ge.xendit_ph_card:
      return /* @__PURE__ */ y.jsx(WL, { ...t });
    case ge.paystack_gh_card:
    case ge.paystack_ke_card:
    case ge.paystack_ng_card:
    case ge.paystack_za_card:
    case ge.paystack_eg_card:
    case ge.paystack_ci_card:
      return /* @__PURE__ */ y.jsx(UL, { ...t });
  }
};
var ge = /* @__PURE__ */ ((e) => (e.stripe_card = "stripe:card", e.stripe_ideal = "stripe:ideal", e.stripe_bancontact = "stripe:bancontact", e.stripe_applepay = "stripe:applepay", e.dlocal_card = "dlocal:card", e.dlocal_boleto = "dlocal:boleto", e.dlocal_pix = "dlocal:pix", e.paypal_soap = "paypal-soap", e.paypal_rest = "paypal-rest", e.mercadopago_br_card = "mercadopago-br:card", e.mercadopago_br_pix = "mercadopago-br:pix", e.mercadopago_br_boleto = "mercadopago-br:boleto", e.mercadopago_co_card = "mercadopago-co:card", e.mercadopago_ar_card = "mercadopago-ar:card", e.mercadopago_mx_card = "mercadopago-mx:card", e.mercadopago_cl_card = "mercadopago-cl:card", e.razorpay = "razorpay", e.flutterwave = "flutterwave", e.mollie = "mollie", e.gocardless = "gocardless", e.cash_on_delivery = "cash-on-delivery", e.xendit_id_card = "xendit-id:card", e.xendit_ph_card = "xendit-ph:card", e.paystack_gh_card = "paystack-gh:card", e.paystack_ke_card = "paystack-ke:card", e.paystack_ng_card = "paystack-ng:card", e.paystack_za_card = "paystack-za:card", e.paystack_eg_card = "paystack-eg:card", e.paystack_ci_card = "paystack-ci:card", e.secure_and_pay = "secure-and-pay", e))(ge || {});
function C9(e) {
  const t = Object.keys(Ct).find(
    (n) => Ct[n] === e
  );
  return t ? Tr[t] : Tr.ENGLISH;
}
var Ct = /* @__PURE__ */ ((e) => (e.ENGLISH = "en", e.FRENCH = "fr", e.SPANISH = "es", e.ITALIAN = "it", e.PORTUGUESE = "pt", e.DEUTSCH = "de", e.DUTCH = "nl", e.RUSSIAN = "ru", e.JAPANESE = "jp", e.ARABIC = "ar", e.TURKISH = "tr", e.CHINESE = "zh", e.SWEDISH = "sv", e.ROMANIAN = "ro", e.CZECH = "cs", e.HUNGARIAN = "hu", e.SLOVAK = "sk", e.DANISH = "dk", e.INDONESIAN = "id", e.POLISH = "pl", e.GREEK = "el", e.SERBIAN = "sr", e.NORWEGIAN = "no", e.THAI = "th", e.SLOVENIAN = "sl", e.UKRAINIAN = "ua", e.ALBANIA = "sq", e.HINDI = "hi", e))(Ct || {});
const lN = Qe(null), cN = ({
  children: e,
  locale: t
}) => (Re(() => {
  if (!Xe.isInitialized)
    return;
  const n = C9(t);
  Xe.language !== n && Xe.changeLanguage(n);
}, [t]), /* @__PURE__ */ y.jsx(lN.Provider, { value: { locale: t }, children: e }));
var u3 = /* @__PURE__ */ ((e) => (e.Afghanistan = "AF", e.AlandIslands = "AX", e.Albania = "AL", e.Algeria = "DZ", e.AmericanSamoa = "AS", e.Andorra = "AD", e.Angola = "AO", e.Anguilla = "AI", e.Antarctica = "AQ", e.AntiguaAndBarbuda = "AG", e.Argentina = "AR", e.Armenia = "AM", e.Aruba = "AW", e.Australia = "AU", e.Austria = "AT", e.Azerbaijan = "AZ", e.Bahamas = "BS", e.Bahrain = "BH", e.Bangladesh = "BD", e.Barbados = "BB", e.Belarus = "BY", e.Belgium = "BE", e.Belize = "BZ", e.Benin = "BJ", e.Bermuda = "BM", e.Bhutan = "BT", e.Bolivia = "BO", e.BonaireSintEustatiusSaba = "BQ", e.BosniaAndHerzegovina = "BA", e.Botswana = "BW", e.BouvetIsland = "BV", e.Brazil = "BR", e.BritishIndianOceanTerritory = "IO", e.BruneiDarussalam = "BN", e.Bulgaria = "BG", e.BurkinaFaso = "BF", e.Burundi = "BI", e.Cambodia = "KH", e.Cameroon = "CM", e.Canada = "CA", e.CapeVerde = "CV", e.CaymanIslands = "KY", e.CentralAfricanRepublic = "CF", e.Chad = "TD", e.Chile = "CL", e.China = "CN", e.ChristmasIsland = "CX", e.CocosKeelingIslands = "CC", e.Colombia = "CO", e.Comoros = "KM", e.Congo = "CG", e.CongoDemocraticRepublic = "CD", e.CookIslands = "CK", e.CostaRica = "CR", e.CoteDIvoire = "CI", e.Croatia = "HR", e.Cuba = "CU", e.Curaçao = "CW", e.Cyprus = "CY", e.CzechRepublic = "CZ", e.Denmark = "DK", e.Djibouti = "DJ", e.Dominica = "DM", e.DominicanRepublic = "DO", e.Ecuador = "EC", e.Egypt = "EG", e.ElSalvador = "SV", e.EquatorialGuinea = "GQ", e.Eritrea = "ER", e.Estonia = "EE", e.Ethiopia = "ET", e.FalklandIslands = "FK", e.FaroeIslands = "FO", e.Fiji = "FJ", e.Finland = "FI", e.France = "FR", e.FrenchGuiana = "GF", e.FrenchPolynesia = "PF", e.FrenchSouthernTerritories = "TF", e.Gabon = "GA", e.Gambia = "GM", e.Georgia = "GE", e.Germany = "DE", e.Ghana = "GH", e.Gibraltar = "GI", e.Greece = "GR", e.Greenland = "GL", e.Grenada = "GD", e.Guadeloupe = "GP", e.Guam = "GU", e.Guatemala = "GT", e.Guernsey = "GG", e.Guinea = "GN", e.GuineaBissau = "GW", e.Guyana = "GY", e.Haiti = "HT", e.HeardIslandMcdonaldIslands = "HM", e.HolySeeVaticanCityState = "VA", e.Honduras = "HN", e.HongKong = "HK", e.Hungary = "HU", e.Iceland = "IS", e.India = "IN", e.Indonesia = "ID", e.Iran = "IR", e.Iraq = "IQ", e.Ireland = "IE", e.IsleOfMan = "IM", e.Israel = "IL", e.Italy = "IT", e.Jamaica = "JM", e.Japan = "JP", e.Jersey = "JE", e.Jordan = "JO", e.Kazakhstan = "KZ", e.Kenya = "KE", e.Kiribati = "KI", e.Korea = "KR", e.KoreaDemocraticPeoplesRepublic = "KP", e.Kuwait = "KW", e.Kyrgyzstan = "KG", e.LaoPeoplesDemocraticRepublic = "LA", e.Latvia = "LV", e.Lebanon = "LB", e.Lesotho = "LS", e.Liberia = "LR", e.LibyanArabJamahiriya = "LY", e.Liechtenstein = "LI", e.Lithuania = "LT", e.Luxembourg = "LU", e.Macao = "MO", e.Macedonia = "MK", e.Madagascar = "MG", e.Malawi = "MW", e.Malaysia = "MY", e.Maldives = "MV", e.Mali = "ML", e.Malta = "MT", e.MarshallIslands = "MH", e.Martinique = "MQ", e.Mauritania = "MR", e.Mauritius = "MU", e.Mayotte = "YT", e.Mexico = "MX", e.Micronesia = "FM", e.Moldova = "MD", e.Monaco = "MC", e.Mongolia = "MN", e.Montenegro = "ME", e.Montserrat = "MS", e.Morocco = "MA", e.Mozambique = "MZ", e.Myanmar = "MM", e.Namibia = "NA", e.Nauru = "NR", e.Nepal = "NP", e.Netherlands = "NL", e.NewCaledonia = "NC", e.NewZealand = "NZ", e.Nicaragua = "NI", e.Niger = "NE", e.Nigeria = "NG", e.Niue = "NU", e.NorfolkIsland = "NF", e.NorthernMarianaIslands = "MP", e.Norway = "NO", e.Oman = "OM", e.Pakistan = "PK", e.Palau = "PW", e.PalestinianTerritory = "PS", e.Panama = "PA", e.PapuaNewGuinea = "PG", e.Paraguay = "PY", e.Peru = "PE", e.Philippines = "PH", e.Pitcairn = "PN", e.Poland = "PL", e.Portugal = "PT", e.PuertoRico = "PR", e.Qatar = "QA", e.Reunion = "RE", e.Romania = "RO", e.RussianFederation = "RU", e.Rwanda = "RW", e.SaintBarthelemy = "BL", e.SaintHelena = "SH", e.SaintKittsAndNevis = "KN", e.SaintLucia = "LC", e.SaintMartin = "MF", e.SaintPierreAndMiquelon = "PM", e.SaintVincentAndGrenadines = "VC", e.Samoa = "WS", e.SanMarino = "SM", e.SaoTomeAndPrincipe = "ST", e.SaudiArabia = "SA", e.Senegal = "SN", e.Serbia = "RS", e.Seychelles = "SC", e.SierraLeone = "SL", e.Singapore = "SG", e.SintMaarten = "SX", e.Slovakia = "SK", e.Slovenia = "SI", e.SolomonIslands = "SB", e.Somalia = "SO", e.SouthAfrica = "ZA", e.SouthGeorgiaAndSandwichIsl = "GS", e.SouthSudan = "SS", e.Spain = "ES", e.SriLanka = "LK", e.Sudan = "SD", e.Suriname = "SR", e.SvalbardAndJanMayen = "SJ", e.Swaziland = "SZ", e.Sweden = "SE", e.Switzerland = "CH", e.SyrianArabRepublic = "SY", e.Taiwan = "TW", e.Tajikistan = "TJ", e.Tanzania = "TZ", e.Thailand = "TH", e.TimorLeste = "TL", e.Togo = "TG", e.Tokelau = "TK", e.Tonga = "TO", e.TrinidadAndTobago = "TT", e.Tunisia = "TN", e.Turkey = "TR", e.Turkmenistan = "TM", e.TurksAndCaicosIslands = "TC", e.Tuvalu = "TV", e.Uganda = "UG", e.Ukraine = "UA", e.UnitedArabEmirates = "AE", e.UnitedKingdom = "GB", e.UnitedStates = "US", e.UnitedStatesOutlyingIslands = "UM", e.Uruguay = "UY", e.Uzbekistan = "UZ", e.Vanuatu = "VU", e.Venezuela = "VE", e.Vietnam = "VN", e.VirginIslandsBritish = "VG", e.VirginIslandsUS = "VI", e.WallisAndFutuna = "WF", e.WesternSahara = "EH", e.Yemen = "YE", e.Zambia = "ZM", e.Zimbabwe = "ZW", e))(u3 || {}), IC = {};
const uN = [
  [
    "AF",
    "AFG",
    "004",
    "ISO 3166-2:AF"
  ],
  [
    "AL",
    "ALB",
    "008",
    "ISO 3166-2:AL"
  ],
  [
    "DZ",
    "DZA",
    "012",
    "ISO 3166-2:DZ"
  ],
  [
    "AS",
    "ASM",
    "016",
    "ISO 3166-2:AS"
  ],
  [
    "AD",
    "AND",
    "020",
    "ISO 3166-2:AD"
  ],
  [
    "AO",
    "AGO",
    "024",
    "ISO 3166-2:AO"
  ],
  [
    "AI",
    "AIA",
    "660",
    "ISO 3166-2:AI"
  ],
  [
    "AQ",
    "ATA",
    "010",
    "ISO 3166-2:AQ"
  ],
  [
    "AG",
    "ATG",
    "028",
    "ISO 3166-2:AG"
  ],
  [
    "AR",
    "ARG",
    "032",
    "ISO 3166-2:AR"
  ],
  [
    "AM",
    "ARM",
    "051",
    "ISO 3166-2:AM"
  ],
  [
    "AW",
    "ABW",
    "533",
    "ISO 3166-2:AW"
  ],
  [
    "AU",
    "AUS",
    "036",
    "ISO 3166-2:AU"
  ],
  [
    "AT",
    "AUT",
    "040",
    "ISO 3166-2:AT"
  ],
  [
    "AZ",
    "AZE",
    "031",
    "ISO 3166-2:AZ"
  ],
  [
    "BS",
    "BHS",
    "044",
    "ISO 3166-2:BS"
  ],
  [
    "BH",
    "BHR",
    "048",
    "ISO 3166-2:BH"
  ],
  [
    "BD",
    "BGD",
    "050",
    "ISO 3166-2:BD"
  ],
  [
    "BB",
    "BRB",
    "052",
    "ISO 3166-2:BB"
  ],
  [
    "BY",
    "BLR",
    "112",
    "ISO 3166-2:BY"
  ],
  [
    "BE",
    "BEL",
    "056",
    "ISO 3166-2:BE"
  ],
  [
    "BZ",
    "BLZ",
    "084",
    "ISO 3166-2:BZ"
  ],
  [
    "BJ",
    "BEN",
    "204",
    "ISO 3166-2:BJ"
  ],
  [
    "BM",
    "BMU",
    "060",
    "ISO 3166-2:BM"
  ],
  [
    "BT",
    "BTN",
    "064",
    "ISO 3166-2:BT"
  ],
  [
    "BO",
    "BOL",
    "068",
    "ISO 3166-2:BO"
  ],
  [
    "BA",
    "BIH",
    "070",
    "ISO 3166-2:BA"
  ],
  [
    "BW",
    "BWA",
    "072",
    "ISO 3166-2:BW"
  ],
  [
    "BV",
    "BVT",
    "074",
    "ISO 3166-2:BV"
  ],
  [
    "BR",
    "BRA",
    "076",
    "ISO 3166-2:BR"
  ],
  [
    "IO",
    "IOT",
    "086",
    "ISO 3166-2:IO"
  ],
  [
    "BN",
    "BRN",
    "096",
    "ISO 3166-2:BN"
  ],
  [
    "BG",
    "BGR",
    "100",
    "ISO 3166-2:BG"
  ],
  [
    "BF",
    "BFA",
    "854",
    "ISO 3166-2:BF"
  ],
  [
    "BI",
    "BDI",
    "108",
    "ISO 3166-2:BI"
  ],
  [
    "KH",
    "KHM",
    "116",
    "ISO 3166-2:KH"
  ],
  [
    "CM",
    "CMR",
    "120",
    "ISO 3166-2:CM"
  ],
  [
    "CA",
    "CAN",
    "124",
    "ISO 3166-2:CA"
  ],
  [
    "CV",
    "CPV",
    "132",
    "ISO 3166-2:CV"
  ],
  [
    "KY",
    "CYM",
    "136",
    "ISO 3166-2:KY"
  ],
  [
    "CF",
    "CAF",
    "140",
    "ISO 3166-2:CF"
  ],
  [
    "TD",
    "TCD",
    "148",
    "ISO 3166-2:TD"
  ],
  [
    "CL",
    "CHL",
    "152",
    "ISO 3166-2:CL"
  ],
  [
    "CN",
    "CHN",
    "156",
    "ISO 3166-2:CN"
  ],
  [
    "CX",
    "CXR",
    "162",
    "ISO 3166-2:CX"
  ],
  [
    "CC",
    "CCK",
    "166",
    "ISO 3166-2:CC"
  ],
  [
    "CO",
    "COL",
    "170",
    "ISO 3166-2:CO"
  ],
  [
    "KM",
    "COM",
    "174",
    "ISO 3166-2:KM"
  ],
  [
    "CG",
    "COG",
    "178",
    "ISO 3166-2:CG"
  ],
  [
    "CD",
    "COD",
    "180",
    "ISO 3166-2:CD"
  ],
  [
    "CK",
    "COK",
    "184",
    "ISO 3166-2:CK"
  ],
  [
    "CR",
    "CRI",
    "188",
    "ISO 3166-2:CR"
  ],
  [
    "CI",
    "CIV",
    "384",
    "ISO 3166-2:CI"
  ],
  [
    "HR",
    "HRV",
    "191",
    "ISO 3166-2:HR"
  ],
  [
    "CU",
    "CUB",
    "192",
    "ISO 3166-2:CU"
  ],
  [
    "CY",
    "CYP",
    "196",
    "ISO 3166-2:CY"
  ],
  [
    "CZ",
    "CZE",
    "203",
    "ISO 3166-2:CZ"
  ],
  [
    "DK",
    "DNK",
    "208",
    "ISO 3166-2:DK"
  ],
  [
    "DJ",
    "DJI",
    "262",
    "ISO 3166-2:DJ"
  ],
  [
    "DM",
    "DMA",
    "212",
    "ISO 3166-2:DM"
  ],
  [
    "DO",
    "DOM",
    "214",
    "ISO 3166-2:DO"
  ],
  [
    "EC",
    "ECU",
    "218",
    "ISO 3166-2:EC"
  ],
  [
    "EG",
    "EGY",
    "818",
    "ISO 3166-2:EG"
  ],
  [
    "SV",
    "SLV",
    "222",
    "ISO 3166-2:SV"
  ],
  [
    "GQ",
    "GNQ",
    "226",
    "ISO 3166-2:GQ"
  ],
  [
    "ER",
    "ERI",
    "232",
    "ISO 3166-2:ER"
  ],
  [
    "EE",
    "EST",
    "233",
    "ISO 3166-2:EE"
  ],
  [
    "ET",
    "ETH",
    "231",
    "ISO 3166-2:ET"
  ],
  [
    "FK",
    "FLK",
    "238",
    "ISO 3166-2:FK"
  ],
  [
    "FO",
    "FRO",
    "234",
    "ISO 3166-2:FO"
  ],
  [
    "FJ",
    "FJI",
    "242",
    "ISO 3166-2:FJ"
  ],
  [
    "FI",
    "FIN",
    "246",
    "ISO 3166-2:FI"
  ],
  [
    "FR",
    "FRA",
    "250",
    "ISO 3166-2:FR"
  ],
  [
    "GF",
    "GUF",
    "254",
    "ISO 3166-2:GF"
  ],
  [
    "PF",
    "PYF",
    "258",
    "ISO 3166-2:PF"
  ],
  [
    "TF",
    "ATF",
    "260",
    "ISO 3166-2:TF"
  ],
  [
    "GA",
    "GAB",
    "266",
    "ISO 3166-2:GA"
  ],
  [
    "GM",
    "GMB",
    "270",
    "ISO 3166-2:GM"
  ],
  [
    "GE",
    "GEO",
    "268",
    "ISO 3166-2:GE"
  ],
  [
    "DE",
    "DEU",
    "276",
    "ISO 3166-2:DE"
  ],
  [
    "GH",
    "GHA",
    "288",
    "ISO 3166-2:GH"
  ],
  [
    "GI",
    "GIB",
    "292",
    "ISO 3166-2:GI"
  ],
  [
    "GR",
    "GRC",
    "300",
    "ISO 3166-2:GR"
  ],
  [
    "GL",
    "GRL",
    "304",
    "ISO 3166-2:GL"
  ],
  [
    "GD",
    "GRD",
    "308",
    "ISO 3166-2:GD"
  ],
  [
    "GP",
    "GLP",
    "312",
    "ISO 3166-2:GP"
  ],
  [
    "GU",
    "GUM",
    "316",
    "ISO 3166-2:GU"
  ],
  [
    "GT",
    "GTM",
    "320",
    "ISO 3166-2:GT"
  ],
  [
    "GN",
    "GIN",
    "324",
    "ISO 3166-2:GN"
  ],
  [
    "GW",
    "GNB",
    "624",
    "ISO 3166-2:GW"
  ],
  [
    "GY",
    "GUY",
    "328",
    "ISO 3166-2:GY"
  ],
  [
    "HT",
    "HTI",
    "332",
    "ISO 3166-2:HT"
  ],
  [
    "HM",
    "HMD",
    "334",
    "ISO 3166-2:HM"
  ],
  [
    "VA",
    "VAT",
    "336",
    "ISO 3166-2:VA"
  ],
  [
    "HN",
    "HND",
    "340",
    "ISO 3166-2:HN"
  ],
  [
    "HK",
    "HKG",
    "344",
    "ISO 3166-2:HK"
  ],
  [
    "HU",
    "HUN",
    "348",
    "ISO 3166-2:HU"
  ],
  [
    "IS",
    "ISL",
    "352",
    "ISO 3166-2:IS"
  ],
  [
    "IN",
    "IND",
    "356",
    "ISO 3166-2:IN"
  ],
  [
    "ID",
    "IDN",
    "360",
    "ISO 3166-2:ID"
  ],
  [
    "IR",
    "IRN",
    "364",
    "ISO 3166-2:IR"
  ],
  [
    "IQ",
    "IRQ",
    "368",
    "ISO 3166-2:IQ"
  ],
  [
    "IE",
    "IRL",
    "372",
    "ISO 3166-2:IE"
  ],
  [
    "IL",
    "ISR",
    "376",
    "ISO 3166-2:IL"
  ],
  [
    "IT",
    "ITA",
    "380",
    "ISO 3166-2:IT"
  ],
  [
    "JM",
    "JAM",
    "388",
    "ISO 3166-2:JM"
  ],
  [
    "JP",
    "JPN",
    "392",
    "ISO 3166-2:JP"
  ],
  [
    "JO",
    "JOR",
    "400",
    "ISO 3166-2:JO"
  ],
  [
    "KZ",
    "KAZ",
    "398",
    "ISO 3166-2:KZ"
  ],
  [
    "KE",
    "KEN",
    "404",
    "ISO 3166-2:KE"
  ],
  [
    "KI",
    "KIR",
    "296",
    "ISO 3166-2:KI"
  ],
  [
    "KP",
    "PRK",
    "408",
    "ISO 3166-2:KP"
  ],
  [
    "KR",
    "KOR",
    "410",
    "ISO 3166-2:KR"
  ],
  [
    "KW",
    "KWT",
    "414",
    "ISO 3166-2:KW"
  ],
  [
    "KG",
    "KGZ",
    "417",
    "ISO 3166-2:KG"
  ],
  [
    "LA",
    "LAO",
    "418",
    "ISO 3166-2:LA"
  ],
  [
    "LV",
    "LVA",
    "428",
    "ISO 3166-2:LV"
  ],
  [
    "LB",
    "LBN",
    "422",
    "ISO 3166-2:LB"
  ],
  [
    "LS",
    "LSO",
    "426",
    "ISO 3166-2:LS"
  ],
  [
    "LR",
    "LBR",
    "430",
    "ISO 3166-2:LR"
  ],
  [
    "LY",
    "LBY",
    "434",
    "ISO 3166-2:LY"
  ],
  [
    "LI",
    "LIE",
    "438",
    "ISO 3166-2:LI"
  ],
  [
    "LT",
    "LTU",
    "440",
    "ISO 3166-2:LT"
  ],
  [
    "LU",
    "LUX",
    "442",
    "ISO 3166-2:LU"
  ],
  [
    "MO",
    "MAC",
    "446",
    "ISO 3166-2:MO"
  ],
  [
    "MG",
    "MDG",
    "450",
    "ISO 3166-2:MG"
  ],
  [
    "MW",
    "MWI",
    "454",
    "ISO 3166-2:MW"
  ],
  [
    "MY",
    "MYS",
    "458",
    "ISO 3166-2:MY"
  ],
  [
    "MV",
    "MDV",
    "462",
    "ISO 3166-2:MV"
  ],
  [
    "ML",
    "MLI",
    "466",
    "ISO 3166-2:ML"
  ],
  [
    "MT",
    "MLT",
    "470",
    "ISO 3166-2:MT"
  ],
  [
    "MH",
    "MHL",
    "584",
    "ISO 3166-2:MH"
  ],
  [
    "MQ",
    "MTQ",
    "474",
    "ISO 3166-2:MQ"
  ],
  [
    "MR",
    "MRT",
    "478",
    "ISO 3166-2:MR"
  ],
  [
    "MU",
    "MUS",
    "480",
    "ISO 3166-2:MU"
  ],
  [
    "YT",
    "MYT",
    "175",
    "ISO 3166-2:YT"
  ],
  [
    "MX",
    "MEX",
    "484",
    "ISO 3166-2:MX"
  ],
  [
    "FM",
    "FSM",
    "583",
    "ISO 3166-2:FM"
  ],
  [
    "MD",
    "MDA",
    "498",
    "ISO 3166-2:MD"
  ],
  [
    "MC",
    "MCO",
    "492",
    "ISO 3166-2:MC"
  ],
  [
    "MN",
    "MNG",
    "496",
    "ISO 3166-2:MN"
  ],
  [
    "MS",
    "MSR",
    "500",
    "ISO 3166-2:MS"
  ],
  [
    "MA",
    "MAR",
    "504",
    "ISO 3166-2:MA"
  ],
  [
    "MZ",
    "MOZ",
    "508",
    "ISO 3166-2:MZ"
  ],
  [
    "MM",
    "MMR",
    "104",
    "ISO 3166-2:MM"
  ],
  [
    "NA",
    "NAM",
    "516",
    "ISO 3166-2:NA"
  ],
  [
    "NR",
    "NRU",
    "520",
    "ISO 3166-2:NR"
  ],
  [
    "NP",
    "NPL",
    "524",
    "ISO 3166-2:NP"
  ],
  [
    "NL",
    "NLD",
    "528",
    "ISO 3166-2:NL"
  ],
  [
    "NC",
    "NCL",
    "540",
    "ISO 3166-2:NC"
  ],
  [
    "NZ",
    "NZL",
    "554",
    "ISO 3166-2:NZ"
  ],
  [
    "NI",
    "NIC",
    "558",
    "ISO 3166-2:NI"
  ],
  [
    "NE",
    "NER",
    "562",
    "ISO 3166-2:NE"
  ],
  [
    "NG",
    "NGA",
    "566",
    "ISO 3166-2:NG"
  ],
  [
    "NU",
    "NIU",
    "570",
    "ISO 3166-2:NU"
  ],
  [
    "NF",
    "NFK",
    "574",
    "ISO 3166-2:NF"
  ],
  [
    "MP",
    "MNP",
    "580",
    "ISO 3166-2:MP"
  ],
  [
    "MK",
    "MKD",
    "807",
    "ISO 3166-2:MK"
  ],
  [
    "NO",
    "NOR",
    "578",
    "ISO 3166-2:NO"
  ],
  [
    "OM",
    "OMN",
    "512",
    "ISO 3166-2:OM"
  ],
  [
    "PK",
    "PAK",
    "586",
    "ISO 3166-2:PK"
  ],
  [
    "PW",
    "PLW",
    "585",
    "ISO 3166-2:PW"
  ],
  [
    "PS",
    "PSE",
    "275",
    "ISO 3166-2:PS"
  ],
  [
    "PA",
    "PAN",
    "591",
    "ISO 3166-2:PA"
  ],
  [
    "PG",
    "PNG",
    "598",
    "ISO 3166-2:PG"
  ],
  [
    "PY",
    "PRY",
    "600",
    "ISO 3166-2:PY"
  ],
  [
    "PE",
    "PER",
    "604",
    "ISO 3166-2:PE"
  ],
  [
    "PH",
    "PHL",
    "608",
    "ISO 3166-2:PH"
  ],
  [
    "PN",
    "PCN",
    "612",
    "ISO 3166-2:PN"
  ],
  [
    "PL",
    "POL",
    "616",
    "ISO 3166-2:PL"
  ],
  [
    "PT",
    "PRT",
    "620",
    "ISO 3166-2:PT"
  ],
  [
    "PR",
    "PRI",
    "630",
    "ISO 3166-2:PR"
  ],
  [
    "QA",
    "QAT",
    "634",
    "ISO 3166-2:QA"
  ],
  [
    "RE",
    "REU",
    "638",
    "ISO 3166-2:RE"
  ],
  [
    "RO",
    "ROU",
    "642",
    "ISO 3166-2:RO"
  ],
  [
    "RU",
    "RUS",
    "643",
    "ISO 3166-2:RU"
  ],
  [
    "RW",
    "RWA",
    "646",
    "ISO 3166-2:RW"
  ],
  [
    "SH",
    "SHN",
    "654",
    "ISO 3166-2:SH"
  ],
  [
    "KN",
    "KNA",
    "659",
    "ISO 3166-2:KN"
  ],
  [
    "LC",
    "LCA",
    "662",
    "ISO 3166-2:LC"
  ],
  [
    "PM",
    "SPM",
    "666",
    "ISO 3166-2:PM"
  ],
  [
    "VC",
    "VCT",
    "670",
    "ISO 3166-2:VC"
  ],
  [
    "WS",
    "WSM",
    "882",
    "ISO 3166-2:WS"
  ],
  [
    "SM",
    "SMR",
    "674",
    "ISO 3166-2:SM"
  ],
  [
    "ST",
    "STP",
    "678",
    "ISO 3166-2:ST"
  ],
  [
    "SA",
    "SAU",
    "682",
    "ISO 3166-2:SA"
  ],
  [
    "SN",
    "SEN",
    "686",
    "ISO 3166-2:SN"
  ],
  [
    "SC",
    "SYC",
    "690",
    "ISO 3166-2:SC"
  ],
  [
    "SL",
    "SLE",
    "694",
    "ISO 3166-2:SL"
  ],
  [
    "SG",
    "SGP",
    "702",
    "ISO 3166-2:SG"
  ],
  [
    "SK",
    "SVK",
    "703",
    "ISO 3166-2:SK"
  ],
  [
    "SI",
    "SVN",
    "705",
    "ISO 3166-2:SI"
  ],
  [
    "SB",
    "SLB",
    "090",
    "ISO 3166-2:SB"
  ],
  [
    "SO",
    "SOM",
    "706",
    "ISO 3166-2:SO"
  ],
  [
    "ZA",
    "ZAF",
    "710",
    "ISO 3166-2:ZA"
  ],
  [
    "GS",
    "SGS",
    "239",
    "ISO 3166-2:GS"
  ],
  [
    "ES",
    "ESP",
    "724",
    "ISO 3166-2:ES"
  ],
  [
    "LK",
    "LKA",
    "144",
    "ISO 3166-2:LK"
  ],
  [
    "SD",
    "SDN",
    "729",
    "ISO 3166-2:SD"
  ],
  [
    "SR",
    "SUR",
    "740",
    "ISO 3166-2:SR"
  ],
  [
    "SJ",
    "SJM",
    "744",
    "ISO 3166-2:SJ"
  ],
  [
    "SZ",
    "SWZ",
    "748",
    "ISO 3166-2:SZ"
  ],
  [
    "SE",
    "SWE",
    "752",
    "ISO 3166-2:SE"
  ],
  [
    "CH",
    "CHE",
    "756",
    "ISO 3166-2:CH"
  ],
  [
    "SY",
    "SYR",
    "760",
    "ISO 3166-2:SY"
  ],
  [
    "TW",
    "TWN",
    "158",
    "ISO 3166-2:TW"
  ],
  [
    "TJ",
    "TJK",
    "762",
    "ISO 3166-2:TJ"
  ],
  [
    "TZ",
    "TZA",
    "834",
    "ISO 3166-2:TZ"
  ],
  [
    "TH",
    "THA",
    "764",
    "ISO 3166-2:TH"
  ],
  [
    "TL",
    "TLS",
    "626",
    "ISO 3166-2:TL"
  ],
  [
    "TG",
    "TGO",
    "768",
    "ISO 3166-2:TG"
  ],
  [
    "TK",
    "TKL",
    "772",
    "ISO 3166-2:TK"
  ],
  [
    "TO",
    "TON",
    "776",
    "ISO 3166-2:TO"
  ],
  [
    "TT",
    "TTO",
    "780",
    "ISO 3166-2:TT"
  ],
  [
    "TN",
    "TUN",
    "788",
    "ISO 3166-2:TN"
  ],
  [
    "TR",
    "TUR",
    "792",
    "ISO 3166-2:TR"
  ],
  [
    "TM",
    "TKM",
    "795",
    "ISO 3166-2:TM"
  ],
  [
    "TC",
    "TCA",
    "796",
    "ISO 3166-2:TC"
  ],
  [
    "TV",
    "TUV",
    "798",
    "ISO 3166-2:TV"
  ],
  [
    "UG",
    "UGA",
    "800",
    "ISO 3166-2:UG"
  ],
  [
    "UA",
    "UKR",
    "804",
    "ISO 3166-2:UA"
  ],
  [
    "AE",
    "ARE",
    "784",
    "ISO 3166-2:AE"
  ],
  [
    "GB",
    "GBR",
    "826",
    "ISO 3166-2:GB"
  ],
  [
    "US",
    "USA",
    "840",
    "ISO 3166-2:US"
  ],
  [
    "UM",
    "UMI",
    "581",
    "ISO 3166-2:UM"
  ],
  [
    "UY",
    "URY",
    "858",
    "ISO 3166-2:UY"
  ],
  [
    "UZ",
    "UZB",
    "860",
    "ISO 3166-2:UZ"
  ],
  [
    "VU",
    "VUT",
    "548",
    "ISO 3166-2:VU"
  ],
  [
    "VE",
    "VEN",
    "862",
    "ISO 3166-2:VE"
  ],
  [
    "VN",
    "VNM",
    "704",
    "ISO 3166-2:VN"
  ],
  [
    "VG",
    "VGB",
    "092",
    "ISO 3166-2:VG"
  ],
  [
    "VI",
    "VIR",
    "850",
    "ISO 3166-2:VI"
  ],
  [
    "WF",
    "WLF",
    "876",
    "ISO 3166-2:WF"
  ],
  [
    "EH",
    "ESH",
    "732",
    "ISO 3166-2:EH"
  ],
  [
    "YE",
    "YEM",
    "887",
    "ISO 3166-2:YE"
  ],
  [
    "ZM",
    "ZMB",
    "894",
    "ISO 3166-2:ZM"
  ],
  [
    "ZW",
    "ZWE",
    "716",
    "ISO 3166-2:ZW"
  ],
  [
    "AX",
    "ALA",
    "248",
    "ISO 3166-2:AX"
  ],
  [
    "BQ",
    "BES",
    "535",
    "ISO 3166-2:BQ"
  ],
  [
    "CW",
    "CUW",
    "531",
    "ISO 3166-2:CW"
  ],
  [
    "GG",
    "GGY",
    "831",
    "ISO 3166-2:GG"
  ],
  [
    "IM",
    "IMN",
    "833",
    "ISO 3166-2:IM"
  ],
  [
    "JE",
    "JEY",
    "832",
    "ISO 3166-2:JE"
  ],
  [
    "ME",
    "MNE",
    "499",
    "ISO 3166-2:ME"
  ],
  [
    "BL",
    "BLM",
    "652",
    "ISO 3166-2:BL"
  ],
  [
    "MF",
    "MAF",
    "663",
    "ISO 3166-2:MF"
  ],
  [
    "RS",
    "SRB",
    "688",
    "ISO 3166-2:RS"
  ],
  [
    "SX",
    "SXM",
    "534",
    "ISO 3166-2:SX"
  ],
  [
    "SS",
    "SSD",
    "728",
    "ISO 3166-2:SS"
  ],
  [
    "XK",
    "XKK",
    "983",
    "ISO 3166-2:XK"
  ]
], dN = [
  "br",
  "cy",
  "dv",
  "sw",
  "eu",
  "af",
  "am",
  "ha",
  "ku",
  "ml",
  "mt",
  "no",
  "ps",
  "sd",
  "so",
  "sq",
  "ta",
  "tg",
  "tt",
  "ug",
  "ur",
  "vi",
  "ar",
  "az",
  "be",
  "bg",
  "bn",
  "bs",
  "ca",
  "cs",
  "da",
  "de",
  "el",
  "en",
  "es",
  "et",
  "fa",
  "fi",
  "fr",
  "ga",
  "gl",
  "he",
  "hi",
  "hr",
  "hu",
  "hy",
  "id",
  "is",
  "it",
  "ja",
  "ka",
  "kk",
  "km",
  "ko",
  "ky",
  "lt",
  "lv",
  "mk",
  "mn",
  "mr",
  "ms",
  "nb",
  "nl",
  "nn",
  "pl",
  "pt",
  "ro",
  "ru",
  "sk",
  "sl",
  "sr",
  "sv",
  "th",
  "tk",
  "tr",
  "uk",
  "uz",
  "zh"
];
var s8 = {};
s8.remove = pN;
var o6 = [
  {
    base: " ",
    chars: " "
  },
  {
    base: "0",
    chars: "߀"
  },
  {
    base: "A",
    chars: "ⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
  },
  {
    base: "AA",
    chars: "Ꜳ"
  },
  {
    base: "AE",
    chars: "ÆǼǢ"
  },
  {
    base: "AO",
    chars: "Ꜵ"
  },
  {
    base: "AU",
    chars: "Ꜷ"
  },
  {
    base: "AV",
    chars: "ꜸꜺ"
  },
  {
    base: "AY",
    chars: "Ꜽ"
  },
  {
    base: "B",
    chars: "ⒷＢḂḄḆɃƁ"
  },
  {
    base: "C",
    chars: "ⒸＣꜾḈĆCĈĊČÇƇȻ"
  },
  {
    base: "D",
    chars: "ⒹＤḊĎḌḐḒḎĐƊƉᴅꝹ"
  },
  {
    base: "Dh",
    chars: "Ð"
  },
  {
    base: "DZ",
    chars: "ǱǄ"
  },
  {
    base: "Dz",
    chars: "ǲǅ"
  },
  {
    base: "E",
    chars: "ɛⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎᴇ"
  },
  {
    base: "F",
    chars: "ꝼⒻＦḞƑꝻ"
  },
  {
    base: "G",
    chars: "ⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾɢ"
  },
  {
    base: "H",
    chars: "ⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
  },
  {
    base: "I",
    chars: "ⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
  },
  {
    base: "J",
    chars: "ⒿＪĴɈȷ"
  },
  {
    base: "K",
    chars: "ⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
  },
  {
    base: "L",
    chars: "ⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
  },
  {
    base: "LJ",
    chars: "Ǉ"
  },
  {
    base: "Lj",
    chars: "ǈ"
  },
  {
    base: "M",
    chars: "ⓂＭḾṀṂⱮƜϻ"
  },
  {
    base: "N",
    chars: "ꞤȠⓃＮǸŃÑṄŇṆŅṊṈƝꞐᴎ"
  },
  {
    base: "NJ",
    chars: "Ǌ"
  },
  {
    base: "Nj",
    chars: "ǋ"
  },
  {
    base: "O",
    chars: "ⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
  },
  {
    base: "OE",
    chars: "Œ"
  },
  {
    base: "OI",
    chars: "Ƣ"
  },
  {
    base: "OO",
    chars: "Ꝏ"
  },
  {
    base: "OU",
    chars: "Ȣ"
  },
  {
    base: "P",
    chars: "ⓅＰṔṖƤⱣꝐꝒꝔ"
  },
  {
    base: "Q",
    chars: "ⓆＱꝖꝘɊ"
  },
  {
    base: "R",
    chars: "ⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
  },
  {
    base: "S",
    chars: "ⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
  },
  {
    base: "T",
    chars: "ⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
  },
  {
    base: "Th",
    chars: "Þ"
  },
  {
    base: "TZ",
    chars: "Ꜩ"
  },
  {
    base: "U",
    chars: "ⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
  },
  {
    base: "V",
    chars: "ⓋＶṼṾƲꝞɅ"
  },
  {
    base: "VY",
    chars: "Ꝡ"
  },
  {
    base: "W",
    chars: "ⓌＷẀẂŴẆẄẈⱲ"
  },
  {
    base: "X",
    chars: "ⓍＸẊẌ"
  },
  {
    base: "Y",
    chars: "ⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
  },
  {
    base: "Z",
    chars: "ⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
  },
  {
    base: "a",
    chars: "ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐɑ"
  },
  {
    base: "aa",
    chars: "ꜳ"
  },
  {
    base: "ae",
    chars: "æǽǣ"
  },
  {
    base: "ao",
    chars: "ꜵ"
  },
  {
    base: "au",
    chars: "ꜷ"
  },
  {
    base: "av",
    chars: "ꜹꜻ"
  },
  {
    base: "ay",
    chars: "ꜽ"
  },
  {
    base: "b",
    chars: "ⓑｂḃḅḇƀƃɓƂ"
  },
  {
    base: "c",
    chars: "ｃⓒćĉċčçḉƈȼꜿↄ"
  },
  {
    base: "d",
    chars: "ⓓｄḋďḍḑḓḏđƌɖɗƋᏧԁꞪ"
  },
  {
    base: "dh",
    chars: "ð"
  },
  {
    base: "dz",
    chars: "ǳǆ"
  },
  {
    base: "e",
    chars: "ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇǝ"
  },
  {
    base: "f",
    chars: "ⓕｆḟƒ"
  },
  {
    base: "ff",
    chars: "ﬀ"
  },
  {
    base: "fi",
    chars: "ﬁ"
  },
  {
    base: "fl",
    chars: "ﬂ"
  },
  {
    base: "ffi",
    chars: "ﬃ"
  },
  {
    base: "ffl",
    chars: "ﬄ"
  },
  {
    base: "g",
    chars: "ⓖｇǵĝḡğġǧģǥɠꞡꝿᵹ"
  },
  {
    base: "h",
    chars: "ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
  },
  {
    base: "hv",
    chars: "ƕ"
  },
  {
    base: "i",
    chars: "ⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
  },
  {
    base: "j",
    chars: "ⓙｊĵǰɉ"
  },
  {
    base: "k",
    chars: "ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
  },
  {
    base: "l",
    chars: "ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇɭ"
  },
  {
    base: "lj",
    chars: "ǉ"
  },
  {
    base: "m",
    chars: "ⓜｍḿṁṃɱɯ"
  },
  {
    base: "n",
    chars: "ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥлԉ"
  },
  {
    base: "nj",
    chars: "ǌ"
  },
  {
    base: "o",
    chars: "ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿꝋꝍɵɔᴑ"
  },
  {
    base: "oe",
    chars: "œ"
  },
  {
    base: "oi",
    chars: "ƣ"
  },
  {
    base: "oo",
    chars: "ꝏ"
  },
  {
    base: "ou",
    chars: "ȣ"
  },
  {
    base: "p",
    chars: "ⓟｐṕṗƥᵽꝑꝓꝕρ"
  },
  {
    base: "q",
    chars: "ⓠｑɋꝗꝙ"
  },
  {
    base: "r",
    chars: "ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
  },
  {
    base: "s",
    chars: "ⓢｓśṥŝṡšṧṣṩșşȿꞩꞅẛʂ"
  },
  {
    base: "ss",
    chars: "ß"
  },
  {
    base: "t",
    chars: "ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
  },
  {
    base: "th",
    chars: "þ"
  },
  {
    base: "tz",
    chars: "ꜩ"
  },
  {
    base: "u",
    chars: "ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
  },
  {
    base: "v",
    chars: "ⓥｖṽṿʋꝟʌ"
  },
  {
    base: "vy",
    chars: "ꝡ"
  },
  {
    base: "w",
    chars: "ⓦｗẁẃŵẇẅẘẉⱳ"
  },
  {
    base: "x",
    chars: "ⓧｘẋẍ"
  },
  {
    base: "y",
    chars: "ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
  },
  {
    base: "z",
    chars: "ⓩｚźẑżžẓẕƶȥɀⱬꝣ"
  }
], d3 = {};
for (var R9 = 0; R9 < o6.length; R9 += 1)
  for (var Au = o6[R9].chars, d7 = 0; d7 < Au.length; d7 += 1)
    d3[Au[d7]] = o6[R9].base;
function pN(e) {
  return e.replace(/[^\u0000-\u007e]/g, function(t) {
    return d3[t] || t;
  });
}
s8.replacementList = o6;
s8.diacriticsMap = d3;
(function(e) {
  const t = uN, n = dN, r = s8.remove, a = {}, i = {}, o = {}, s = {}, l = {};
  t.forEach(function(b) {
    const S = b;
    i[S[0]] = S[1], o[S[1]] = S[0], s[S[2]] = S[0], l[S[0]] = S[2];
  });
  function c(b) {
    return ("000" + (b || "")).slice(-3);
  }
  function u(b, S) {
    return Object.prototype.hasOwnProperty.call(b, S);
  }
  function d(b, S) {
    return Object.keys(b).reduce(function(P, O) {
      const A = b[O];
      return P[O] = S(A, O), P;
    }, {});
  }
  function p(b, S) {
    switch (b) {
      case "official":
        return Array.isArray(S) ? S[0] : S;
      case "all":
        return typeof S == "string" ? [S] : S;
      case "alias":
        return Array.isArray(S) ? S[1] || S[0] : S;
      default:
        throw new TypeError(
          "LocaleNameType must be one of these: all, official, alias!"
        );
    }
  }
  e.registerLocale = function(b) {
    if (!b.locale)
      throw new TypeError("Missing localeData.locale");
    if (!b.countries)
      throw new TypeError("Missing localeData.countries");
    a[b.locale] = b.countries;
  };
  function h(b) {
    return o[b];
  }
  e.alpha3ToAlpha2 = h;
  function m(b) {
    return i[b];
  }
  e.alpha2ToAlpha3 = m;
  function f(b) {
    return l[h(b)];
  }
  e.alpha3ToNumeric = f;
  function C(b) {
    return l[b];
  }
  e.alpha2ToNumeric = C;
  function _(b) {
    const S = c(b);
    return m(s[S]);
  }
  e.numericToAlpha3 = _;
  function v(b) {
    const S = c(b);
    return s[S];
  }
  e.numericToAlpha2 = v;
  function w(b) {
    if (typeof b == "string") {
      if (/^[0-9]*$/.test(b))
        return _(b);
      if (b.length === 2)
        return m(b.toUpperCase());
      if (b.length === 3)
        return b.toUpperCase();
    }
    if (typeof b == "number")
      return _(b);
  }
  e.toAlpha3 = w;
  function k(b) {
    if (typeof b == "string") {
      if (/^[0-9]*$/.test(b))
        return v(b);
      if (b.length === 2)
        return b.toUpperCase();
      if (b.length === 3)
        return h(b.toUpperCase());
    }
    if (typeof b == "number")
      return v(b);
  }
  e.toAlpha2 = k, e.getName = function(b, S, P = {}) {
    "select" in P || (P.select = "official");
    try {
      const O = a[S.toLowerCase()][k(b)];
      return p(P.select, O);
    } catch {
      return;
    }
  }, e.getNames = function(b, S = {}) {
    "select" in S || (S.select = "official");
    const P = a[b.toLowerCase()];
    return P === void 0 ? {} : d(P, function(O) {
      return p(S.select, O);
    });
  }, e.getAlpha2Code = function(b, S) {
    const P = (A) => A.toLowerCase(), O = (A, L) => P(A) === P(L);
    try {
      const A = a[S.toLowerCase()];
      for (const L in A)
        if (u(A, L)) {
          if (typeof A[L] == "string" && O(A[L], b))
            return L;
          if (Array.isArray(A[L])) {
            for (const I of A[L])
              if (O(I, b))
                return L;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getSimpleAlpha2Code = function(b, S) {
    const P = (A) => r(A.toLowerCase()), O = (A, L) => P(A) === P(L);
    try {
      const A = a[S.toLowerCase()];
      for (const L in A)
        if (u(A, L)) {
          if (typeof A[L] == "string" && O(A[L], b))
            return L;
          if (Array.isArray(A[L])) {
            for (const I of A[L])
              if (O(I, b))
                return L;
          }
        }
      return;
    } catch {
      return;
    }
  }, e.getAlpha2Codes = function() {
    return i;
  }, e.getAlpha3Code = function(b, S) {
    const P = e.getAlpha2Code(b, S);
    if (P)
      return e.toAlpha3(P);
  }, e.getSimpleAlpha3Code = function(b, S) {
    const P = e.getSimpleAlpha2Code(b, S);
    if (P)
      return e.toAlpha3(P);
  }, e.getAlpha3Codes = function() {
    return o;
  }, e.getNumericCodes = function() {
    return s;
  }, e.langs = function() {
    return Object.keys(a);
  }, e.getSupportedLanguages = function() {
    return n;
  }, e.isValid = function(b) {
    if (!b)
      return !1;
    const S = b.toString().toUpperCase();
    return u(o, S) || u(i, S) || u(s, S);
  };
})(IC);
const R0 = /* @__PURE__ */ A5(IC), HC = "ar", FC = {
  AF: "أفغانستان",
  AL: "ألبانيا",
  DZ: "الجزائر",
  AS: "ساموا الأمريكية",
  AD: "أندورا",
  AO: "أنغولا",
  AI: "أنغويلا",
  AQ: "القارة القطبية الجنوبية",
  AG: "أنتيغوا وباربودا",
  AR: "الأرجنتين",
  AM: "أرمينيا",
  AW: "أروبا",
  AU: "أستراليا",
  AT: "النمسا",
  AZ: "أذربيجان",
  BS: "باهاماس",
  BH: "البحرين",
  BD: "بنغلاديش",
  BB: "باربادوس",
  BY: "روسيا البيضاء",
  BE: "بلجيكا",
  BZ: "بليز",
  BJ: "بنين",
  BM: "برمودا",
  BT: "بوتان",
  BO: "بوليفيا",
  BA: "البوسنة والهرسك",
  BW: "بوتسوانا",
  BV: "جزيرة بوفيه",
  BR: "البرازيل",
  IO: "إقليم المحيط الهندي البريطاني",
  BN: "بروناي",
  BG: "بلغاريا",
  BF: "بوركينا فاسو",
  BI: "بوروندي",
  KH: "كمبوديا",
  CM: "الكاميرون",
  CA: "كندا",
  CV: "الرأس الأخضر",
  KY: "جزر كايمان",
  CF: "جمهورية أفريقيا الوسطى",
  TD: "تشاد",
  CL: "تشيلي",
  CN: "الصين",
  CX: "جزيرة عيد الميلاد",
  CC: "جزر كوكوس",
  CO: "كولومبيا",
  KM: "جزر القمر",
  CG: "جمهورية الكونغو",
  CD: "جمهورية الكونغو الديمقراطية",
  CK: "جزر كوك",
  CR: "كوستاريكا",
  CI: "ساحل العاج",
  HR: "كرواتيا",
  CU: "كوبا",
  CY: "قبرص",
  CZ: "جمهورية التشيك",
  DK: "الدنمارك",
  DJ: "جيبوتي",
  DM: "دومينيكا",
  DO: "جمهورية الدومينيكان",
  EC: "الإكوادور",
  EG: "مصر",
  SV: "السلفادور",
  GQ: "غينيا الاستوائية",
  ER: "إريتريا",
  EE: "إستونيا",
  ET: "إثيوبيا",
  FK: "جزر فوكلاند",
  FO: "جزر فارو",
  FJ: "فيجي",
  FI: "فنلندا",
  FR: "فرنسا",
  GF: "غويانا الفرنسية",
  PF: "بولينزيا الفرنسية",
  TF: "أراض فرنسية جنوبية وأنتارتيكية",
  GA: "الغابون",
  GM: "غامبيا",
  GE: "جورجيا",
  DE: "ألمانيا",
  GH: "غانا",
  GI: "جبل طارق",
  GR: "اليونان",
  GL: "جرينلاند",
  GD: "غرينادا",
  GP: "غوادلوب",
  GU: "غوام",
  GT: "غواتيمالا",
  GN: "غينيا",
  GW: "غينيا بيساو",
  GY: "غيانا",
  HT: "هايتي",
  HM: "جزيرة هيرد وجزر ماكدونالد",
  VA: "الفاتيكان",
  HN: "هندوراس",
  HK: "هونغ كونغ",
  HU: "المجر",
  IS: "آيسلندا",
  IN: "الهند",
  ID: "إندونيسيا",
  IR: "إيران",
  IQ: "العراق",
  IE: "أيرلندا",
  IL: "إسرائيل",
  IT: "إيطاليا",
  JM: "جامايكا",
  JP: "اليابان",
  JO: "الأردن",
  KZ: "كازاخستان",
  KE: "كينيا",
  KI: "كيريباتي",
  KP: "كوريا الشمالية",
  KR: "كوريا الجنوبية",
  KW: "الكويت",
  KG: "قيرغيزستان",
  LA: "لاوس",
  LV: "لاتفيا",
  LB: "لبنان",
  LS: "ليسوتو",
  LR: "ليبيريا",
  LY: "ليبيا",
  LI: "ليختنشتاين",
  LT: "ليتوانيا",
  LU: "لوكسمبورغ",
  MO: "ماكاو",
  MK: "مقدونيا الشمالية",
  MG: "مدغشقر",
  MW: "مالاوي",
  MY: "ماليزيا",
  MV: "جزر المالديف",
  ML: "مالي",
  MT: "مالطا",
  MH: "جزر مارشال",
  MQ: "مارتينيك",
  MR: "موريتانيا",
  MU: "موريشيوس",
  YT: "مايوت",
  MX: "المكسيك",
  FM: "ولايات ميكرونيسيا المتحدة",
  MD: "مولدوفا",
  MC: "موناكو",
  MN: "منغوليا",
  MS: "مونتسرات",
  MA: "المغرب",
  MZ: "موزمبيق",
  MM: "بورما",
  NA: "ناميبيا",
  NR: "ناورو",
  NP: "نيبال",
  NL: "هولندا",
  NC: "كاليدونيا الجديدة",
  NZ: "نيوزيلندا",
  NI: "نيكاراغوا",
  NE: "النيجر",
  NG: "نيجيريا",
  NU: "نييوي",
  NF: "جزيرة نورفولك",
  MP: "جزر ماريانا الشمالية",
  NO: "النرويج",
  OM: "عمان",
  PK: "باكستان",
  PW: "بالاو",
  PS: "فلسطين",
  PA: "بنما",
  PG: "بابوا غينيا الجديدة",
  PY: "باراغواي",
  PE: "بيرو",
  PH: "الفلبين",
  PN: "جزر بيتكيرن",
  PL: "بولندا",
  PT: "البرتغال",
  PR: "بورتوريكو",
  QA: "قطر",
  RE: "لا ريونيون",
  RO: "رومانيا",
  RU: "روسيا",
  RW: "رواندا",
  SH: "سانت هيلينا وأسينشين وتريستان دا كونا",
  KN: "سانت كيتس ونيفيس",
  LC: "سانت لوسيا",
  PM: "سان بيير وميكلون",
  VC: "سانت فينسنت والغرينادين",
  WS: "ساموا",
  SM: "سان مارينو",
  ST: "ساو تومي وبرينسيب",
  SA: "السعودية",
  SN: "السنغال",
  SC: "سيشل",
  SL: "سيراليون",
  SG: "سنغافورة",
  SK: "سلوفاكيا",
  SI: "سلوفينيا",
  SB: "جزر سليمان",
  SO: "الصومال",
  ZA: "جنوب أفريقيا",
  GS: "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  ES: "إسبانيا",
  LK: "سريلانكا",
  SD: "السودان",
  SR: "سورينام",
  SJ: "سفالبارد ويان ماين",
  SZ: "سوازيلاند",
  SE: "السويد",
  CH: "سويسرا",
  SY: "سوريا",
  TW: "تايوان",
  TJ: "طاجيكستان",
  TZ: "تانزانيا",
  TH: "تايلاند",
  TL: "تيمور الشرقية",
  TG: "توغو",
  TK: "توكيلاو",
  TO: "تونغا",
  TT: "ترينيداد وتوباغو",
  TN: "تونس",
  TR: "تركيا",
  TM: "تركمانستان",
  TC: "جزر توركس وكايكوس",
  TV: "توفالو",
  UG: "أوغندا",
  UA: "أوكرانيا",
  AE: "الإمارات العربية المتحدة",
  GB: "المملكة المتحدة",
  US: "الولايات المتحدة",
  UM: "جزر الولايات المتحدة",
  UY: "الأوروغواي",
  UZ: "أوزبكستان",
  VU: "فانواتو",
  VE: "فنزويلا",
  VN: "فيتنام",
  VG: "جزر العذراء البريطانية",
  VI: "جزر العذراء الأمريكية",
  WF: "والس وفوتونا",
  EH: "الصحراء الغربية",
  YE: "اليمن",
  ZM: "زامبيا",
  ZW: "زيمبابوي",
  AX: "جزر أولاند",
  BQ: "الجزر الكاريبية الهولندية",
  CW: "كوراساو",
  GG: "غيرنزي",
  IM: "جزيرة مان",
  JE: "جيرزي",
  ME: "الجبل الأسود",
  BL: "سان بارتيلمي",
  MF: "سانت مارتن (الجزء الفرنسي)",
  RS: "صربيا",
  SX: "سانت مارتن (الجزء الهولندي)",
  SS: "جنوب السودان",
  XK: "كوسوفو"
}, hN = {
  locale: HC,
  countries: FC
}, mN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: FC,
  default: hN,
  locale: HC
}, Symbol.toStringTag, { value: "Module" })), VC = "cs", BC = {
  AF: "Afghánistán",
  AX: "Ålandy",
  AL: "Albánie",
  DZ: "Alžírsko",
  AS: "Americká Samoa",
  VI: "Americké Panenské ostrovy",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktida",
  AG: "Antigua a Barbuda",
  AR: "Argentina",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Austrálie",
  AZ: "Ázerbájdžán",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladéš",
  BB: "Barbados",
  BE: "Belgie",
  BZ: "Belize",
  BY: "Bělorusko",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhútán",
  BO: "Bolívie",
  BQ: "Bonaire, Svatý Eustach a Saba",
  BA: "Bosna a Hercegovina",
  BW: "Botswana",
  BV: "Bouvetův ostrov",
  BR: "Brazílie",
  IO: "Britské indickooceánské území",
  VG: "Britské Panenské ostrovy",
  BN: "Brunej",
  BG: "Bulharsko",
  BF: "Burkina Faso",
  BI: "Burundi",
  CK: "Cookovy ostrovy",
  CW: "Curaçao",
  TD: "Čad",
  ME: "Černá Hora",
  CZ: "Česká republika",
  CN: "Čína",
  DK: "Dánsko",
  CD: "Demokratická republika Kongo",
  DM: "Dominika",
  DO: "Dominikánská republika",
  DJ: "Džibutsko",
  EG: "Egypt",
  EC: "Ekvádor",
  ER: "Eritrea",
  EE: "Estonsko",
  ET: "Etiopie",
  FO: "Faerské ostrovy",
  FK: "Falklandy (Malvíny)",
  FJ: "Fidži",
  PH: "Filipíny",
  FI: "Finsko",
  FR: "Francie",
  GF: "Francouzská Guyana",
  TF: "Francouzská jižní a antarktická území",
  PF: "Francouzská Polynésie",
  GA: "Gabon",
  GM: "Gambie",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GL: "Grónsko",
  GE: "Gruzie",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GG: "Guernsey",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heardův ostrov a McDonaldovy ostrovy",
  HN: "Honduras",
  HK: "Hongkong",
  CL: "Chile",
  HR: "Chorvatsko",
  IN: "Indie",
  ID: "Indonésie",
  IQ: "Irák",
  IR: "Írán",
  IE: "Irsko",
  IS: "Island",
  IT: "Itálie",
  IL: "Izrael",
  JM: "Jamajka",
  JP: "Japonsko",
  YE: "Jemen",
  JE: "Jersey",
  ZA: "Jihoafrická republika",
  GS: "Jižní Georgie a Jižní Sandwichovy ostrovy",
  KR: "Jižní Korea",
  SS: "Jižní Súdán",
  JO: "Jordánsko",
  KY: "Kajmanské ostrovy",
  KH: "Kambodža",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kapverdy",
  QA: "Katar",
  KZ: "Kazachstán",
  KE: "Keňa",
  KI: "Kiribati",
  CC: "Kokosové ostrovy",
  CO: "Kolumbie",
  KM: "Komory",
  CG: "Kongo",
  CR: "Kostarika",
  CU: "Kuba",
  KW: "Kuvajt",
  CY: "Kypr",
  KG: "Kyrgyzstán",
  LA: "Laos",
  LS: "Lesotho",
  LB: "Libanon",
  LR: "Libérie",
  LY: "Libye",
  LI: "Lichtenštejnsko",
  LT: "Litva",
  LV: "Lotyšsko",
  LU: "Lucembursko",
  MO: "Macao",
  MG: "Madagaskar",
  HU: "Maďarsko",
  MY: "Malajsie",
  MW: "Malawi",
  MV: "Maledivy",
  ML: "Mali",
  MT: "Malta",
  IM: "Ostrov Man",
  MA: "Maroko",
  MH: "Marshallovy ostrovy",
  MQ: "Martinik",
  MU: "Mauricius",
  MR: "Mauritánie",
  YT: "Mayotte",
  UM: "Menší odlehlé ostrovy USA",
  MX: "Mexiko",
  FM: "Mikronésie",
  MD: "Moldavsko",
  MC: "Monako",
  MN: "Mongolsko",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  DE: "Německo",
  NP: "Nepál",
  NE: "Niger",
  NG: "Nigérie",
  NI: "Nikaragua",
  NU: "Niue",
  NL: "Nizozemsko",
  NF: "Norfolk",
  NO: "Norsko",
  NC: "Nová Kaledonie",
  NZ: "Nový Zéland",
  OM: "Omán",
  PK: "Pákistán",
  PW: "Palau",
  PS: "Palestinská autonomie",
  PA: "Panama",
  PG: "Papua-Nová Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PN: "Pitcairnovy ostrovy",
  CI: "Pobřeží slonoviny",
  PL: "Polsko",
  PR: "Portoriko",
  PT: "Portugalsko",
  AT: "Rakousko",
  RE: "Réunion",
  GQ: "Rovníková Guinea",
  RO: "Rumunsko",
  RU: "Rusko",
  RW: "Rwanda",
  GR: "Řecko",
  PM: "Saint-Pierre a Miquelon",
  SV: "Salvador",
  WS: "Samoa",
  SM: "San Marino",
  SA: "Saúdská Arábie",
  SN: "Senegal",
  KP: "Severní Korea",
  MK: "Severní Makedonie",
  MP: "Severní Mariany",
  SC: "Seychely",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Slovensko",
  SI: "Slovinsko",
  SO: "Somálsko",
  AE: "Spojené arabské emiráty",
  GB: "Spojené království",
  US: "Spojené státy americké",
  RS: "Srbsko",
  CF: "Středoafrická republika",
  SD: "Súdán",
  SR: "Surinam",
  SH: "Svatá Helena, Ascension a Tristan da Cunha",
  LC: "Svatá Lucie",
  BL: "Svatý Bartoloměj",
  KN: "Svatý Kryštof a Nevis",
  MF: "Svatý Martin (francouzská část)",
  SX: "Svatý Martin (nizozemská část)",
  ST: "Svatý Tomáš a Princův ostrov",
  VC: "Svatý Vincenc a Grenadiny",
  SZ: "Svazijsko",
  SY: "Sýrie",
  SB: "Šalamounovy ostrovy",
  ES: "Španělsko",
  SJ: "Špicberky a Jan Mayen",
  LK: "Šrí Lanka",
  SE: "Švédsko",
  CH: "Švýcarsko",
  TJ: "Tádžikistán",
  TZ: "Tanzanie",
  TH: "Thajsko",
  TW: "Tchaj-wan",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad a Tobago",
  TN: "Tunisko",
  TR: "Turecko",
  TM: "Turkmenistán",
  TC: "Turks a Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrajina",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  CX: "Vánoční ostrov",
  VU: "Vanuatu",
  VA: "Vatikán",
  VE: "Venezuela",
  VN: "Vietnam",
  TL: "Východní Timor",
  WF: "Wallis a Futuna",
  ZM: "Zambie",
  EH: "Západní Sahara",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, fN = {
  locale: VC,
  countries: BC
}, CN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: BC,
  default: fN,
  locale: VC
}, Symbol.toStringTag, { value: "Module" })), zC = "da", GC = {
  AF: "Afghanistan",
  AL: "Albanien",
  DZ: "Algeriet",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenien",
  AW: "Aruba",
  AU: "Australien",
  AT: "Østrig",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviderusland",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnien-Hercegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brasilien",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Kap Verde",
  KY: "Caymanøerne",
  CF: "Den Centralafrikanske Republik",
  TD: "Tchad",
  CL: "Chile",
  CN: "Kina",
  CX: "Juløen",
  CC: "Cocosøerne",
  CO: "Colombia",
  KM: "Comorerne",
  CG: "Congo",
  CD: "Demokratiske Republik Congo",
  CK: "Cookøerne",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatien",
  CU: "Cuba",
  CY: "Cypern",
  CZ: "Tjekkiet",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominikanske Republik",
  EC: "Ecuador",
  EG: "Egypten",
  SV: "El Salvador",
  GQ: "Ækvatorialguinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopien",
  FK: "Falklandsøerne",
  FO: "Færøerne",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrig",
  GF: "Fransk Guiana",
  PF: "Fransk Polynesien",
  TF: "Franske Sydterritorier",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgien",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grækenland",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-øen og McDonald-øerne",
  VA: "Vatikanstaten",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Ungarn",
  IS: "Island",
  IN: "Indien",
  ID: "Indonesien",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Nordkorea",
  KR: "Sydkorea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Nordmakedonien",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldiverne",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløerne",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesien",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongoliet",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holland",
  NC: "Ny Kaledonien",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Nordmarianerne",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palæstina",
  PA: "Panama",
  PG: "Papua Ny Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinerne",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumænien",
  RU: "Rusland",
  RW: "Rwanda",
  SH: "Sankt Helena",
  KN: "Saint Kitts og Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre og Miquelon",
  VC: "Saint Vincent og Grenadinerne",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabien",
  SN: "Senegal",
  SC: "Seychellerne",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakiet",
  SI: "Slovenien",
  SB: "Salomonøerne",
  SO: "Somalia",
  ZA: "Sydafrika",
  GS: "South Georgia og South Sandwich Islands",
  ES: "Spanien",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Norge Svalbard og Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Schweiz",
  SY: "Syrien",
  TW: "Republikken Kina Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Østtimor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunesien",
  TR: "Tyrkiet",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøerne",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "Forenede Arabiske Emirater",
  GB: "Storbritannien",
  US: "USA",
  UM: "USA's ydre småøer",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Britiske Jomfruøer",
  VI: "Amerikanske Jomfruøer",
  WF: "Wallis og Futuna",
  EH: "Vestsahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Ålandsøerne",
  BQ: "Nederlandske Antiller",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint-Barthélemy",
  MF: "Saint Martin (fransk side)",
  RS: "Serbien",
  SX: "Saint Martin (hollandsk side)",
  SS: "Sydsudan",
  XK: "Kosovo"
}, gN = {
  locale: zC,
  countries: GC
}, yN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: GC,
  default: gN,
  locale: zC
}, Symbol.toStringTag, { value: "Module" })), UC = "de", ZC = {
  AF: "Afghanistan",
  EG: "Ägypten",
  AX: "Åland",
  AL: "Albanien",
  DZ: "Algerien",
  AS: "Amerikanisch-Samoa",
  VI: "Amerikanische Jungferninseln",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua und Barbuda",
  GQ: "Äquatorialguinea",
  AR: "Argentinien",
  AM: "Armenien",
  AW: "Aruba",
  AZ: "Aserbaidschan",
  ET: "Äthiopien",
  AU: "Australien",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesch",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgien",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivien",
  BQ: "Bonaire",
  BA: "Bosnien und Herzegowina",
  BW: "Botswana",
  BV: "Bouvetinsel",
  BR: "Brasilien",
  VG: "Britische Jungferninseln",
  IO: "Britisches Territorium im Indischen Ozean",
  BN: "Brunei Darussalam",
  BG: "Bulgarien",
  BF: "Burkina Faso",
  BI: "Burundi",
  CL: "Chile",
  CN: "China",
  CK: "Cookinseln",
  CR: "Costa Rica",
  CI: "Elfenbeinküste",
  CW: "Curaçao",
  DK: "Dänemark",
  DE: "Deutschland",
  DM: "Dominica",
  DO: "Dominikanische Republik",
  DJ: "Dschibuti",
  EC: "Ecuador",
  SV: "El Salvador",
  ER: "Eritrea",
  EE: "Estland",
  FK: "Falklandinseln",
  FO: "Färöer",
  FJ: "Fidschi",
  FI: "Finnland",
  FR: "Frankreich",
  GF: "Französisch-Guayana",
  PF: "Französisch-Polynesien",
  TF: "Französische Süd- und Antarktisgebiete",
  GA: "Gabun",
  GM: "Gambia",
  GE: "Georgien",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GR: "Griechenland",
  GL: "Grönland",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard und McDonaldinseln",
  HN: "Honduras",
  HK: [
    "Hongkong",
    "Hong Kong"
  ],
  IN: "Indien",
  ID: "Indonesien",
  IM: "Insel Man",
  IQ: "Irak",
  IR: "Iran",
  IE: "Irland",
  IS: "Island",
  IL: "Israel",
  IT: "Italien",
  JM: "Jamaika",
  JP: "Japan",
  YE: "Jemen",
  JE: "Jersey",
  JO: "Jordanien",
  KY: "Kaimaninseln",
  KH: "Kambodscha",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kap Verde",
  KZ: "Kasachstan",
  QA: "Katar",
  KE: "Kenia",
  KG: "Kirgisistan",
  KI: "Kiribati",
  CC: "Kokosinseln",
  CO: "Kolumbien",
  KM: "Komoren",
  CD: "Kongo",
  KP: "Nordkorea",
  KR: "Südkorea",
  HR: "Kroatien",
  CU: "Kuba",
  KW: "Kuwait",
  LA: "Laos",
  LS: "Lesotho",
  LV: "Lettland",
  LB: "Libanon",
  LR: "Liberia",
  LY: "Libyen",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Malediven",
  ML: "Mali",
  MT: "Malta",
  MA: "Marokko",
  MH: "Marshallinseln",
  MQ: "Martinique",
  MR: "Mauretanien",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexiko",
  FM: "Mikronesien",
  MD: "Moldawien",
  MC: "Monaco",
  MN: "Mongolei",
  ME: "Montenegro",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NC: "Neukaledonien",
  NZ: "Neuseeland",
  NI: "Nicaragua",
  NL: "Niederlande",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  MK: "Nordmazedonien",
  MP: "Nördliche Marianen",
  NF: "Norfolkinsel",
  NO: "Norwegen",
  OM: "Oman",
  AT: "Österreich",
  TL: "Osttimor",
  PK: "Pakistan",
  PS: "Staat Palästina",
  PW: "Palau",
  PA: "Panama",
  PG: "Papua-Neuguinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippinen",
  PN: "Pitcairninseln",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  TW: "Taiwan",
  CG: "Republik Kongo",
  RE: "Réunion",
  RW: "Ruanda",
  RO: "Rumänien",
  RU: [
    "Russische Föderation",
    "Russland"
  ],
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  SB: "Salomonen",
  ZM: "Sambia",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé und Príncipe",
  SA: "Saudi-Arabien",
  SE: "Schweden",
  CH: "Schweiz",
  SN: "Senegal",
  RS: "Serbien",
  SC: "Seychellen",
  SL: "Sierra Leone",
  ZW: "Simbabwe",
  SG: "Singapur",
  SX: "Sint Maarten",
  SK: "Slowakei",
  SI: "Slowenien",
  SO: "Somalia",
  ES: "Spanien",
  LK: "Sri Lanka",
  SH: "St. Helena",
  KN: "St. Kitts und Nevis",
  LC: "St. Lucia",
  PM: "Saint-Pierre und Miquelon",
  VC: "St. Vincent und die Grenadinen",
  ZA: "Südafrika",
  SD: "Sudan",
  GS: "Südgeorgien und die Südlichen Sandwichinseln",
  SS: "Südsudan",
  SR: "Suriname",
  SJ: "Svalbard und Jan Mayen",
  SZ: "Eswatini",
  SY: "Syrien, Arabische Republik",
  TJ: "Tadschikistan",
  TZ: [
    "Tansania, Vereinigte Republik",
    "Tansania"
  ],
  TH: "Thailand",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad und Tobago",
  TD: "Tschad",
  CZ: [
    "Tschechische Republik",
    "Tschechien"
  ],
  TN: "Tunesien",
  TR: "Türkei",
  TM: "Turkmenistan",
  TC: "Turks- und Caicosinseln",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  HU: "Ungarn",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VA: "Vatikanstadt",
  VE: "Venezuela",
  AE: "Vereinigte Arabische Emirate",
  US: [
    "Vereinigte Staaten von Amerika",
    "Vereinigte Staaten",
    "USA"
  ],
  GB: [
    "Vereinigtes Königreich",
    "Großbritannien"
  ],
  VN: "Vietnam",
  WF: "Wallis und Futuna",
  CX: "Weihnachtsinsel",
  EH: "Westsahara",
  CF: "Zentralafrikanische Republik",
  CY: "Zypern",
  XK: "Kosovo"
}, vN = {
  locale: UC,
  countries: ZC
}, bN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ZC,
  default: vN,
  locale: UC
}, Symbol.toStringTag, { value: "Module" })), KC = "el", $C = {
  AF: "Αφγανιστάν",
  AL: "Αλβανία",
  DZ: "Αλγερία",
  AS: "Αμερικανική Σαμόα",
  AD: "Ανδόρρα",
  AO: "Ανγκόλα",
  AI: "Ανγκουίλα",
  AQ: "Ανταρκτική",
  AG: "Αντίγκουα και Μπαρμπούντα",
  AR: "Αργεντινή",
  AM: "Αρμενία",
  AW: "Αρούμπα",
  AU: "Αυστραλία",
  AT: "Αυστρία",
  AZ: "Αζερμπαϊτζάν",
  BS: "Μπαχάμες",
  BH: "Μπαχρέιν",
  BD: "Μπανγκλαντές",
  BB: "Μπαρμπάντος",
  BY: "Λευκορωσία",
  BE: "Βέλγιο",
  BZ: "Μπελίζ",
  BJ: "Μπενίν",
  BM: "Βερμούδες",
  BT: "Μπουτάν",
  BO: "Βολιβία",
  BA: "Βοσνία και Ερζεγοβίνη",
  BW: "Μποτσουάνα",
  BV: "Μπουβέ",
  BR: "Βραζιλία",
  IO: "Βρετανικό Έδαφος Ινδικού Ωκεανού",
  BN: "Σουλτανάτο του Μπρουνέι",
  BG: "Βουλγαρία",
  BF: "Μπουρκίνα Φάσο",
  BI: "Μπουρουντί",
  KH: "Καμπότζη",
  CM: "Καμερούν",
  CA: "Καναδάς",
  CV: [
    "Δημοκρατία του Πράσινου Ακρωτηρίου",
    "Πράσινο Ακρωτήριο"
  ],
  KY: "Κέιμαν Νήσοι",
  CF: "Κεντροαφρικανική Δημοκρατία",
  TD: "Τσάντ",
  CL: "Χιλή",
  CN: "Κίνα",
  CX: "Νήσος των Χριστουγέννων",
  CC: "Νησιά Κόκος",
  CO: "Κολομβία",
  KM: "Ένωση των Κομορών",
  CG: [
    "Δημοκρατία του Κονγκό",
    "Κονγκό"
  ],
  CD: "Λαϊκή Δημοκρατία του Κονγκό",
  CK: "Νήσοι Κουκ",
  CR: "Κόστα Ρίκα",
  CI: "Ακτή Ελεφαντοστού",
  HR: "Κροατία",
  CU: "Κούβα",
  CY: "Κύπρος",
  CZ: [
    "Τσεχική Δημοκρατία",
    "Τσεχία"
  ],
  DK: "Δανία",
  DJ: "Τζιμπουτί",
  DM: [
    "Κοινοπολιτεία της Δομινίκας",
    "Ντομίνικα"
  ],
  DO: "Δομινικανή Δημοκρατία",
  EC: "Εκουαδόρ",
  EG: "Αίγυπτος",
  SV: "Ελ Σαλβαδόρ",
  GQ: "Ισημερινή-Γουινέα",
  ER: [
    "Κράτος της Ερυθραίας",
    "Ερυθραία"
  ],
  EE: "Εσθονία",
  ET: "Αιθιοπία",
  FK: "Νήσοι Φώκλαντ (Μαλβίνας)",
  FO: "Νήσοι Φερόες",
  FJ: "Δημοκρατία των Φίτζι",
  FI: "Φινλανδία",
  FR: "Γαλλία",
  GF: "Γαλλική Γουιάνα",
  PF: "Γαλλική Πολυνησία",
  TF: "Γαλλικά Νότια και Ανταρκτικά Εδάφη",
  GA: "Γκαμπόν",
  GM: "Γκάμπια",
  GE: "Γεωργία",
  DE: "Γερμανία",
  GH: "Γκάνα",
  GI: "Γιβραλτάρ",
  GR: "Ελλάδα",
  GL: "Γροιλανδία",
  GD: "Γρενάδα",
  GP: "Γουαδελούπη",
  GU: "Γκουάμ",
  GT: "Γουατεμάλα",
  GN: "Γουινέα",
  GW: "Γουινέα-Μπισσάου",
  GY: "Γουιάνα",
  HT: "Αϊτη",
  HM: "Νήσοι Χερντ και Μακντόναλντ",
  VA: [
    "Κράτος της Πόλης του Βατικανού",
    "Βατικανό"
  ],
  HN: "Ονδούρα",
  HK: "Χονγκ Κόνγκ",
  HU: "Ουγγαρία",
  IS: "Ισλανδία",
  IN: "Ινδία",
  ID: "Ινδονησία",
  IR: [
    "Ισλαμική Δημοκρατία του Ιράν",
    "Ιράν"
  ],
  IQ: "Ιράκ",
  IE: "Ιρλανδία",
  IL: "Ισραήλ",
  IT: "Ιταλία",
  JM: "Τζαμάικα",
  JP: "Ιαπωνία",
  JO: "Ιορδανία",
  KZ: "Καζακστάν",
  KE: "Κένυα",
  KI: "Κιριμπάτι",
  KP: [
    "Λαοκρατική Δημοκρατία της Κορέας",
    "Βόρεια Κορέα"
  ],
  KR: [
    "Δημοκρατία της Κορέας",
    "Νότια Κορέα"
  ],
  KW: "Κουβέιτ",
  KG: "Κιργιζία",
  LA: [
    "Λαϊκή Δημοκρατία του Λάος",
    "Λάος"
  ],
  LV: "Λετονία",
  LB: "Λίβανο",
  LS: [
    "Βασίλειο του Λεσότο",
    "Λεσότο"
  ],
  LR: "Λιβερία",
  LY: [
    "Κράτος της Λιβύης",
    "Λιβύη"
  ],
  LI: [
    "Πριγκιπάτο του Λίχτενσταϊν",
    "Λίχτενσταϊν"
  ],
  LT: "Λιθουανία",
  LU: "Λουξεμβούργο",
  MO: "Μακάου",
  MK: [
    "Δημοκρατία της Βόρειας Μακεδονίας",
    "Βόρεια Μακεδονία"
  ],
  MG: "Μαδαγασκάρη",
  MW: "Μαλάουι",
  MY: "Μαλαισία",
  MV: "Μαλβίδες",
  ML: "Μαλί",
  MT: "Μάλτα",
  MH: "Νήσοι Μάρσαλ",
  MQ: "Μαρτινίκα",
  MR: "Μαυριτανία",
  MU: "Μαυρίκιος",
  YT: "Μαγιότ",
  MX: "Μεξικό",
  FM: [
    "Ομόσπονδες Πολιτείες της Μικρονησίας",
    "Μικρονησία"
  ],
  MD: [
    "Δημοκρατία της Μολδαβίας",
    "Μολδαβία"
  ],
  MC: [
    "Πριγκιπάτο του Μονακό",
    "Μονακό"
  ],
  MN: "Μογγολία",
  MS: "Μοντσερράτ",
  MA: "Μαρόκο",
  MZ: "Μοζαμβίκη",
  MM: "Μιανμάρ",
  NA: "Ναμίμπια",
  NR: "Ναουρού",
  NP: "Νεπάλ",
  NL: "Ολλανδία",
  NC: "Νέα Καληδονία",
  NZ: "Νέα Ζηλανδία",
  NI: "Νικαράγουα",
  NE: "Νίγηρας",
  NG: "Νιγηρία",
  NU: "Νιούε",
  NF: "Νησί Νόρφολκ",
  MP: "Βόρειες Μαριάνες Νήσοι",
  NO: "Νορβηγία",
  OM: "Ομάν",
  PK: "Πακιστάν",
  PW: "Παλάου",
  PS: [
    "Κράτος της Παλαιστίνης",
    "Παλαιστίνη"
  ],
  PA: "Παναμάς",
  PG: "Παπούα Νέα Γουινέα",
  PY: "Παραγουάη",
  PE: "Περού",
  PH: "Φιλιππίνες",
  PN: "Νήσοι Πίτκαιρν",
  PL: "Πολωνία",
  PT: "Πορτογαλία",
  PR: "Πουέρτο Ρίκο",
  QA: "Κατάρ",
  RE: "Ρεϋνιόν",
  RO: "Ρουμανία",
  RU: [
    "Ρωσική Ομοσπονδία",
    "Ρωσία"
  ],
  RW: "Ρουάντα",
  SH: "Νήσος Αγίας Ελένης",
  KN: "Ομοσπονδία Αγίου Χριστόφορου και Νέβις",
  LC: "Αγία Λουκία",
  PM: "Σαιν Πιερ και Μικελόν",
  VC: "Άγιος Βικέντιος και Γρεναδίνες",
  WS: "Σαμόα",
  SM: "Άγιος Μαρίνος",
  ST: "Σάο Τομέ και Πρίνσιπε",
  SA: "Σαουδική Αραβία",
  SN: "Σενεγάλη",
  SC: "Σεϋχέλλες",
  SL: "Σιέρα Λεόνε",
  SG: "Σιγκαπούρη",
  SK: "Σλοβακία",
  SI: "Σλοβενία",
  SB: "Νήσοι Σολομώντα",
  SO: "Σομαλία",
  ZA: "Νότια Αφρική",
  GS: "Νότιος Γεωργία και Νότιοι Σάντουιτς Νήσοι",
  ES: "Ισπανία",
  LK: "Σρι Λάνκα",
  SD: "Σουδάν",
  SR: "Σουρινάμ",
  SJ: "Σβάλμπαρντ και Γιαν Μαγιέν",
  SZ: "Σουαζιλάνδη",
  SE: "Σουηδία",
  CH: "Ελβετία",
  SY: [
    "Αραβική Δημοκρατία της Συρίας",
    "Συρία"
  ],
  TW: "Δημοκρατία της Κίνας",
  TJ: "Τατζικιστάν",
  TZ: [
    "Ενωμένη Δημοκρατία της Τανζανίας",
    "Τανζανία"
  ],
  TH: "Ταϊλάνδη",
  TL: "Ανατολικό Τιμόρ",
  TG: "Τογκό",
  TK: "Τοκελάου",
  TO: "Τόνγκα",
  TT: "Τρινιντάντ και Τομπάγκο",
  TN: "Τυνησία",
  TR: "Τουρκία",
  TM: "Τουρκμενιστάν",
  TC: "Τερκς και Κέικος",
  TV: "Τουβαλού",
  UG: "Ουγκάντα",
  UA: "Ουκρανια",
  AE: "Ηνωμένα Αραβικά Εμιράτα",
  GB: "Ηνωμένο Βασίλειο",
  US: [
    "Ηνωμένες Πολιτείες Αμερικής",
    "Αμερική",
    "ΗΠΑ"
  ],
  UM: "Απομακρυσμένες Νησίδες των Ηνωμένων Πολιτειών",
  UY: "Ουρουγουάη",
  UZ: "Ουζμπεκιστάν",
  VU: "Βανουάτου",
  VE: "Βενεζουέλα",
  VN: "Βιετνάμ",
  VG: "Βρετανικές Παρθένοι Νήσοι",
  VI: "Αμερικανικές Παρθένοι Νήσοι",
  WF: "Ουαλίς και Φουτουνά",
  EH: "Δυτική Σαχάρα",
  YE: "Υεμένη",
  ZM: "Ζάμπια",
  ZW: "Ζιμπάμπουε",
  AX: "Νήσοι Ώλαντ",
  BQ: "Μποναίρ, Άγιος Ευστάθιος και Σάμπα",
  CW: "Κουρασάο",
  GG: "Γκουέρνσεϊ",
  IM: "Νήσος του Μαν",
  JE: "Βαϊλάτο του Τζέρσεϊ",
  ME: "Μαυροβούνιο",
  BL: "Άγιος Βαρθολομαίος",
  MF: "Άγιος Μαρτίνος (Γαλλία)",
  RS: "Σερβία",
  SX: "Άγιος Μαρτίνος (Ολλανδία)",
  SS: "Νότιο Σουδάν",
  XK: "Κόσοβο"
}, _N = {
  locale: KC,
  countries: $C
}, wN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: $C,
  default: _N,
  locale: KC
}, Symbol.toStringTag, { value: "Module" })), WC = "en", YC = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: [
    "People's Republic of China",
    "China"
  ],
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: [
    "Republic of the Congo",
    "Congo"
  ],
  CD: [
    "Democratic Republic of the Congo",
    "Congo"
  ],
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: [
    "Cote d'Ivoire",
    "Côte d'Ivoire",
    "Ivory Coast"
  ],
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: [
    "Czech Republic",
    "Czechia"
  ],
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: [
    "Republic of The Gambia",
    "The Gambia",
    "Gambia"
  ],
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Islamic Republic of Iran",
    "Iran"
  ],
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "North Korea",
  KR: [
    "South Korea",
    "Korea, Republic of",
    "Republic of Korea"
  ],
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: [
    "Netherlands",
    "The Netherlands",
    "Netherlands (Kingdom of the)"
  ],
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: [
    "The Republic of North Macedonia",
    "North Macedonia"
  ],
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: [
    "State of Palestine",
    "Palestine"
  ],
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: [
    "Pitcairn",
    "Pitcairn Islands"
  ],
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: [
    "Russian Federation",
    "Russia"
  ],
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: [
    "Taiwan, Province of China",
    "Taiwan"
  ],
  TJ: "Tajikistan",
  TZ: [
    "United Republic of Tanzania",
    "Tanzania"
  ],
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: [
    "Türkiye",
    "Turkey"
  ],
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: [
    "United Arab Emirates",
    "UAE"
  ],
  GB: [
    "United Kingdom",
    "UK",
    "Great Britain"
  ],
  US: [
    "United States of America",
    "United States",
    "USA",
    "U.S.A.",
    "US",
    "U.S."
  ],
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: [
    "Åland Islands",
    "Aland Islands"
  ],
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "South Sudan",
  XK: "Kosovo"
}, xN = {
  locale: WC,
  countries: YC
}, SN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: YC,
  default: xN,
  locale: WC
}, Symbol.toStringTag, { value: "Module" })), qC = "es", JC = {
  AF: "Afganistán",
  AL: "Albania",
  DZ: "Argelia",
  AS: "Samoa Americana",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AQ: "Antártida",
  AG: "Antigua y Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaiyán",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bielorrusia",
  BE: "Bélgica",
  BZ: "Belice",
  BJ: "Benin",
  BM: "Bermudas",
  BT: "Bután",
  BO: "Bolivia",
  BA: "Bosnia y Herzegovina",
  BW: "Botswana",
  BV: "Isla Bouvet",
  BR: "Brasil",
  IO: "Territorio Británico del Océano Índico",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Camboya",
  CM: "Camerún",
  CA: "Canadá",
  CV: "Cabo Verde",
  KY: "Islas Caimán",
  CF: "República Centroafricana",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Isla de Navidad",
  CC: "Islas Cocos (Keeling)",
  CO: "Colombia",
  KM: "Comoras",
  CG: "Congo",
  CD: "Congo (República Democrática del)",
  CK: "Islas Cook",
  CR: "Costa Rica",
  CI: "Costa de Marfil",
  HR: "Croacia",
  CU: "Cuba",
  CY: "Chipre",
  CZ: "República Checa",
  DK: "Dinamarca",
  DJ: "Yibuti",
  DM: "Dominica",
  DO: "República Dominicana",
  EC: "Ecuador",
  EG: "Egipto",
  SV: "El Salvador",
  GQ: "Guinea Ecuatorial",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Etiopía",
  FK: "Islas Malvinas",
  FO: "Islas Feroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Francia",
  GF: "Guayana Francesa",
  PF: "Polinesia Francesa",
  TF: "Tierras Australes Francesas",
  GA: "Gabón",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Alemania",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecia",
  GL: "Groenlandia",
  GD: "Granada",
  GP: "Guadalupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HT: "Haití",
  HM: "Heard e Islas McDonald",
  VA: "Santa Sede",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungría",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IR: [
    "Irán",
    "República Islámica de Irán"
  ],
  IQ: "Iraq",
  IE: "Irlanda",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japón",
  JO: "Jordania",
  KZ: "Kazajistán",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "República Popular Democrática de Corea",
  KR: "República de Corea",
  KW: "Kuwait",
  KG: "Kirguistán",
  LA: "República Democrática Popular de Lao",
  LV: "Letonia",
  LB: "Líbano",
  LS: "Lesoto",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Lituania",
  LU: "Luxemburgo",
  MO: "Macao",
  MK: "Macedonia del Norte",
  MG: "Madagascar",
  MW: "Malaui",
  MY: "Malasia",
  MV: "Maldivas",
  ML: "Malí",
  MT: "Malta",
  MH: "Islas Marshall",
  MQ: "Martinica",
  MR: "Mauritania",
  MU: "Mauricio",
  YT: "Mayotte",
  MX: "México",
  FM: "Micronesia",
  MD: "Moldavia",
  MC: "Mónaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Marruecos",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Países Bajos",
  NC: "Nueva Caledonia",
  NZ: "Nueva Zelanda",
  NI: "Nicaragua",
  NE: "Níger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Isla Norfolk",
  MP: "Islas Marianas del Norte",
  NO: "Noruega",
  OM: "Omán",
  PK: "Pakistán",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panamá",
  PG: "Papua Nueva Guinea",
  PY: "Paraguay",
  PE: "Perú",
  PH: "Filipinas",
  PN: "Pitcairn",
  PL: "Polonia",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Catar",
  RE: "Reunión",
  RO: "Rumanía",
  RU: "Rusia",
  RW: "Ruanda",
  SH: "Santa Helena, Ascensión y Tristán de Acuña",
  KN: "Saint Kitts y Nevis",
  LC: "Santa Lucía",
  PM: "San Pedro y Miquelón",
  VC: "San Vicente y las Granadinas",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Santo Tomé y Príncipe",
  SA: "Arabia Saudita",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leona",
  SG: "Singapur",
  SK: "Eslovaquia",
  SI: "Eslovenia",
  SB: "Islas Salomón",
  SO: "Somalia",
  ZA: "Sudáfrica",
  GS: "Georgia del Sur y las Islas Sandwich del Sur",
  ES: "España",
  LK: "Sri Lanka",
  SD: "Sudán",
  SR: "Suriname",
  SJ: "Svalbard y Jan Mayen",
  SZ: "Esuatini",
  SE: "Suecia",
  CH: "Suiza",
  SY: "República Árabe Siria",
  TW: "Taiwán",
  TJ: "Tayikistán",
  TZ: "Tanzania",
  TH: "Tailandia",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad y Tobago",
  TN: "Túnez",
  TR: "Turquía",
  TM: "Turkmenistán",
  TC: "Islas Turcas y Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ucrania",
  AE: "Emiratos Árabes Unidos",
  GB: "Reino Unido",
  US: "Estados Unidos",
  UM: "Islas Ultramarinas Menores de los Estados Unidos",
  UY: "Uruguay",
  UZ: "Uzbekistán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Islas Vírgenes británicas",
  VI: "Islas Vírgenes de los Estados Unidos",
  WF: "Wallis y Futuna",
  EH: "Sahara Occidental",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabue",
  AX: "Islas Åland",
  BQ: "Bonaire, San Eustaquio y Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isla de Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (francesa)",
  RS: "Serbia",
  SX: "Sint Maarten (neerlandesa)",
  SS: "Sudán del Sur",
  XK: "Kosovo"
}, kN = {
  locale: qC,
  countries: JC
}, MN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: JC,
  default: kN,
  locale: qC
}, Symbol.toStringTag, { value: "Module" })), XC = "fr", QC = {
  AF: "Afghanistan",
  AL: "Albanie",
  DZ: "Algérie",
  AS: "Samoa américaines",
  AD: "Andorre",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctique",
  AG: "Antigua-et-Barbuda",
  AR: "Argentine",
  AM: "Arménie",
  AW: "Aruba",
  AU: "Australie",
  AT: "Autriche",
  AZ: "Azerbaïdjan",
  BS: "Bahamas",
  BH: "Bahreïn",
  BD: "Bangladesh",
  BB: "Barbade",
  BY: "Biélorussie",
  BE: "Belgique",
  BZ: "Belize",
  BJ: "Bénin",
  BM: "Bermudes",
  BT: "Bhoutan",
  BO: "Bolivie",
  BA: "Bosnie-Herzégovine",
  BW: "Botswana",
  BV: "Île Bouvet",
  BR: "Brésil",
  IO: "Océan Indien Britannique",
  BN: "Brunei Darussalam",
  BG: "Bulgarie",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodge",
  CM: "Cameroun",
  CA: "Canada",
  CV: "Cap-Vert",
  KY: "Îles Caïmans",
  CF: "République Centrafricaine",
  TD: "Tchad",
  CL: "Chili",
  CN: "Chine",
  CX: "Île Christmas",
  CC: "Îles Cocos",
  CO: "Colombie",
  KM: "Comores",
  CG: "République du Congo",
  CD: "République démocratique du Congo",
  CK: "Îles Cook",
  CR: "Costa Rica",
  CI: "Côte-d'Ivoire",
  HR: "Croatie",
  CU: "Cuba",
  CY: "Chypre",
  CZ: "République Tchèque",
  DK: "Danemark",
  DJ: "Djibouti",
  DM: "Dominique",
  DO: "République Dominicaine",
  EC: "Équateur",
  EG: "Égypte",
  SV: "El Salvador",
  GQ: "Guinée équatoriale",
  ER: "Érythrée",
  EE: "Estonie",
  ET: "Éthiopie",
  FK: "Îles Malouines",
  FO: "Îles Féroé",
  FJ: "Fidji",
  FI: "Finlande",
  FR: "France",
  GF: "Guyane française",
  PF: "Polynésie française",
  TF: "Terres australes françaises",
  GA: "Gabon",
  GM: "Gambie",
  GE: "Géorgie",
  DE: "Allemagne",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grèce",
  GL: "Groenland",
  GD: "Grenade",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinée",
  GW: "Guinée-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Îles Heard-et-MacDonald",
  VA: "Saint-Siège (Vatican)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongrie",
  IS: "Islande",
  IN: "Inde",
  ID: "Indonésie",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlande",
  IL: "Israël",
  IT: "Italie",
  JM: "Jamaïque",
  JP: "Japon",
  JO: "Jordanie",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Corée du Nord",
  KR: "Corée du Sud",
  KW: "Koweït",
  KG: "Kirghizistan",
  LA: "Laos",
  LV: "Lettonie",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Libye",
  LI: "Liechtenstein",
  LT: "Lituanie",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macédoine du Nord",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaisie",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malte",
  MH: "Îles Marshall",
  MQ: "Martinique",
  MR: "Mauritanie",
  MU: "Maurice",
  YT: "Mayotte",
  MX: "Mexique",
  FM: "Micronésie",
  MD: "Moldavie",
  MC: "Monaco",
  MN: "Mongolie",
  MS: "Montserrat",
  MA: "Maroc",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibie",
  NR: "Nauru",
  NP: "Népal",
  NL: "Pays-Bas",
  NC: "Nouvelle-Calédonie",
  NZ: "Nouvelle-Zélande",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niué",
  NF: "Île Norfolk",
  MP: "Îles Mariannes du Nord",
  NO: "Norvège",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palaos",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papouasie-Nouvelle-Guinée",
  PY: "Paraguay",
  PE: "Pérou",
  PH: "Philippines",
  PN: "Îles Pitcairn",
  PL: "Pologne",
  PT: "Portugal",
  PR: "Porto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roumanie",
  RU: "Russie",
  RW: "Rwanda",
  SH: "Sainte-Hélène",
  KN: "Saint-Christophe-et-Niévès",
  LC: "Sainte-Lucie",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "Saint-Vincent-et-les-Grenadines",
  WS: "Samoa",
  SM: "Saint-Marin",
  ST: "São Tomé-et-Principe",
  SA: "Arabie Saoudite",
  SN: "Sénégal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapour",
  SK: "Slovaquie",
  SI: "Slovénie",
  SB: "Îles Salomon",
  SO: "Somalie",
  ZA: "Afrique du Sud",
  GS: "Géorgie du Sud-et-les Îles Sandwich du Sud",
  ES: "Espagne",
  LK: "Sri Lanka",
  SD: "Soudan",
  SR: "Suriname",
  SJ: "Svalbard et Île Jan Mayen",
  SZ: "Royaume d'Eswatini",
  SE: "Suède",
  CH: "Suisse",
  SY: "Syrie",
  TW: "Taïwan",
  TJ: "Tadjikistan",
  TZ: "République unie de Tanzanie",
  TH: "Thaïlande",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinité-et-Tobago",
  TN: "Tunisie",
  TR: "Turquie",
  TM: "Turkménistan",
  TC: "Îles Turques-et-Caïques",
  TV: "Tuvalu",
  UG: "Ouganda",
  UA: "Ukraine",
  AE: "Émirats Arabes Unis",
  GB: "Royaume-Uni",
  US: "États-Unis d'Amérique",
  UM: "Îles mineures éloignées des États-Unis",
  UY: "Uruguay",
  UZ: "Ouzbékistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Îles vierges britanniques",
  VI: "Îles vierges américaines",
  WF: "Wallis-et-Futuna",
  EH: "Sahara occidental",
  YE: "Yémen",
  ZM: "Zambie",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Saint-Eustache et Saba",
  CW: "Curaçao",
  GG: "Guernesey",
  IM: "Île de Man",
  JE: "Jersey",
  ME: "Monténégro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin (partie française)",
  RS: "Serbie",
  SX: "Saint-Martin (partie néerlandaise)",
  SS: "Soudan du Sud",
  XK: "Kosovo"
}, PN = {
  locale: XC,
  countries: QC
}, EN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: QC,
  default: PN,
  locale: XC
}, Symbol.toStringTag, { value: "Module" })), eg = "hi", tg = {
  AD: "अंडोरा",
  AE: "संयुक्त अरब अमीरात",
  AF: "अफगानिस्तान",
  AG: "एंटीगुआ और बारबूडा",
  AI: "अंग्विला",
  AL: "अल्बानिया",
  AM: "अर्मेनिया",
  AO: "अंगोला",
  AQ: "अंटार्टिका",
  AR: "अर्जेंटिना",
  AS: "अमेरिकान सामोआ",
  AT: "आस्ट्रिया",
  AU: "आस्ट्रेलिया",
  AW: "अरुबा",
  AX: "ऑलैण्ड द्वीपसमूह",
  AZ: "अजरबेजान",
  BA: "बोस्निया हर्जेगोविना",
  BB: "बार्बाडोस",
  BD: "बांग्लादेश",
  BE: "बेल्जियम",
  BF: "बुर्किना फासो",
  BG: "बल्गारिया",
  BH: "बहरीन",
  BI: "बुरुंडी",
  BJ: "बानिन",
  BL: "सेंट_बार्थेलेमी",
  BM: "बर्मूडा",
  BN: "ब्रुनेई",
  BO: "बोलिविया",
  BQ: "कैरिबियन नीदरलैंड",
  BR: "ब्राजील",
  BS: "बहामास",
  BT: "भूटान",
  BV: "बाउवेट",
  BW: "बोत्सवाना",
  BY: "बेलारुस",
  BZ: "बेलिजे",
  CA: "कनाडा",
  CC: "कोकोस (कीलिंग) द्वीप",
  CD: "कांगो लोकतान्त्रिक गणराज्य",
  CF: "सेंट्रल अफ्रीका गणतंत्र",
  CG: "कांगो",
  CH: "स्विट्जरलैंड",
  CI: "आइवरी कोस्ट",
  CK: "कुक द्वीप",
  CL: "चिली",
  CM: "कैमरून",
  CN: "चीन",
  CO: "कोलंबिया",
  CR: "कोस्टा रिका",
  CU: "क्यूबा",
  CV: "केप वर्दे",
  CW: "कुराकाओ",
  CX: "क्रिसमस द्वीप",
  CY: "साइप्रस",
  CZ: "चेक",
  DE: "जर्मनी",
  DJ: "जिबॉती",
  DK: "डैनमार्क",
  DM: "डोमिनिक",
  DO: "डोमिनिक गणतंत्र",
  DZ: "अल्जीरिया",
  EC: "इक्वाडोर",
  EE: "एस्तोनिया",
  EG: "मिस्र",
  EH: "पश्चिमी सहारा",
  ER: "एरिट्रेया",
  ES: "स्पेन",
  ET: "इथियोपिया",
  FI: "फिनलैंड",
  FJ: "फिजी",
  FK: "फाकलैंड द्वीप समूह (मालविनास)",
  FM: "माइक्रोनेशिया",
  FO: "फराओ द्वीप समूह",
  FR: "फ्रांस",
  GA: "गैबोन",
  GB: "ग्रेट ब्रिटेन",
  GD: "ग्रेनेडा",
  GE: "जॉर्जिया",
  GF: "फ्रेंच गुआना",
  GG: "ग्वेर्नसे",
  GH: "घाना",
  GI: "जिब्राल्टर",
  GL: "ग्रीनलैंड",
  GM: "गाम्बिया",
  GN: "गिनी",
  GP: "ग्वाडेलोप",
  GQ: "एक्वेटोरियल गिनी",
  GR: "यूनान",
  GS: "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीप समूह",
  GT: "ग्वाटेमाला",
  GU: "ग्वाम",
  GW: "गिनी-बिसाउ",
  GY: "गुआना",
  HK: "हांग कांग",
  HM: "हर्ड एंड मैकडोनाल्ड द्वीपसमूह",
  HN: "होंडुरास",
  HR: "क्रोएशिया",
  HT: "हैती",
  HU: "हंगरी",
  ID: "इंडोनेशिया",
  IE: "आयरलैंड",
  IL: "इजराइल",
  IM: "आइसल ऑफ मैन",
  IN: "भारत",
  IO: "ब्रितानी हिंद महासागरीय क्षेत्र",
  IQ: "इराक",
  IR: "ईरान",
  IS: "आइसलैंड",
  IT: "इटली",
  JE: "जर्सी",
  JM: "जमैका",
  JO: "जॉर्डन",
  JP: "जापान",
  KE: "केन्या",
  KG: "किर्जिस्तान",
  KH: "कंबोडिया",
  KI: "किरिबिती",
  KM: "कोमोरोस",
  KN: "सेंट किट्स एंड नेविस",
  KP: "उत्तर कोरिया",
  KR: "दक्षिण कोरिया",
  KW: "कुवैत",
  KY: "केमैन आइसलैंड्स",
  KZ: "कज़ाखिस्तान",
  LA: "लाओस",
  LB: "लेबनान",
  LC: "सेंट लुसिया",
  LI: "लिक्टेनिस्टीन",
  LK: "श्री लंका",
  LR: "लाइबेरिया",
  LS: "लेसोथो",
  LT: "लिथुआनिया",
  LU: "लक्जमबर्ग",
  LV: "लात्विया",
  LY: "लीबिया",
  MA: "मोरक्को",
  MC: "मोनाको",
  MD: "मोलदोवा",
  ME: "मोंटेनेग्रो",
  MF: "सेंट मार्टिन की सामूहिकता",
  MG: "मैडागास्कर",
  MH: "मार्शल द्वीपसमूह",
  MK: "मकदूनिया",
  ML: "माली",
  MM: "म्यामांर (बर्मा)",
  MN: "मंगोलिया",
  MO: "मकाओ",
  MP: "उत्तर मैरिना द्वीपसमूह",
  MQ: "मार्टिनिक",
  MR: "मॉरितानिया",
  MS: "मोंटसेराट",
  MT: "माल्टा",
  MU: "मारीशस",
  MV: "मालदीव",
  MW: "मालावी",
  MX: "मेक्सिको",
  MY: "मलयेशिया",
  MZ: "मोजांबिक",
  NA: "नामीबिया",
  NC: "न्यू कैलेडोनिया",
  NE: "नाइजर",
  NF: "नोरफॉक द्वीप",
  NG: "नाइजीरिया",
  NI: "निकारागुआ",
  NL: "नीदरलैंड्स",
  NO: "नॉर्वे",
  NP: "नेपाल",
  NR: "नाउरू",
  NU: "नियू",
  NZ: "न्यूजीलैंड",
  OM: "ओमान",
  PA: "पनामा",
  PE: "पेरू",
  PF: "फ्रैंच गुआना",
  PG: "पापुआ न्यू गिनी",
  PH: "फिलीपींस",
  PK: "पाकिस्तान",
  PL: "पोलैंड",
  PM: "सेंट पिएरे एंड मिक्वेलॉन",
  PN: "पिटकैर्न द्वीपसमूह",
  PR: "पुएर्तो रिको",
  PS: "फिलिस्तीन राज्य",
  PT: "पुर्तगाल",
  PW: "पलाउ",
  PY: "पराग्वे",
  QA: "क़तार",
  RE: "रीयूनियन",
  RO: "रोमानिया",
  RS: "सर्बिया",
  RU: "रूस",
  RW: "रवांडा",
  SA: "सऊदी अरब",
  SB: "सोलोमन द्वीपसमूह",
  SC: "सेशेल्स",
  SD: "सूडान",
  SE: "स्वीडन",
  SG: "सिंगापुर",
  SH: "सेंट हेलेना",
  SI: "स्लोवानिया",
  SJ: "स्यालबार्ड (स्यालबार्ड एंड जन मावेम)",
  SK: "स्लोवाकिया",
  SL: "सियारा लिओन",
  SM: "सैन मारिनो",
  SN: "सेनेगल",
  SO: "सोमालिया",
  SR: "सूरीनाम",
  SS: "दक्षिण सूडान",
  ST: "साओ टॉम एंड प्रिंसिपी",
  SV: "सल्वाडोर",
  SX: "सिण्ट मार्टेन",
  SY: "सीरिया",
  SZ: "स्वाजीलैंड",
  TC: "तुर्क एंड कैकोस द्वीपसमूह",
  TD: "चाड",
  TF: "फ्रांसीसी दक्षिणी क्षेत्र",
  TG: "टोगो",
  TH: "थाईलैंड",
  TJ: "तज़ाकिस्तान",
  TK: "टोकेलू",
  TL: "पूर्वी तिमोर",
  TM: "तुर्कमेनिस्तान",
  TN: "ट्यूनीशिया",
  TO: "टोंगा",
  TR: "तुर्की",
  TT: "ट्रिनिडाड एंड टोबैगो",
  TV: "तुवालू",
  TW: "ताइवान",
  TZ: "तंजानिया",
  UA: "उक्रेन",
  UG: "उगांडा",
  UM: "यूएस माइनर आउटलाइंग द्वीपसमूह",
  US: "यूएसए (संयुक्त राज्य अमेरिका)",
  UY: "उरुग्वे",
  UZ: "उजबेकिस्तान",
  VA: "वेटिकन",
  VC: "सेंट विंसेंट एंड द ग्रेनेंडाइन्स",
  VE: "वेनेजुएला",
  VG: "ब्रितानी वर्जिन द्वीपसमूह",
  VI: "अमेरिकी वर्जिन द्वीपसमूह",
  VN: "विएतनाम",
  VU: "वनातू",
  WF: "वालीज एंड फुटुना",
  WS: "पश्चिमी सामोआ",
  XK: "कोसोवो",
  YE: "यमन",
  YT: "मायोते",
  ZA: "दक्षिण अफ्रीका",
  ZM: "जाम्बिया",
  ZW: "जिंबावे"
}, TN = {
  locale: eg,
  countries: tg
}, LN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: tg,
  default: TN,
  locale: eg
}, Symbol.toStringTag, { value: "Module" })), rg = "hu", ng = {
  AF: "Afganisztán",
  AL: "Albánia",
  DZ: "Algéria",
  AS: "Amerikai Szamoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktisz",
  AG: "Antigua és Barbuda",
  AR: "Argentína",
  AM: "Örményország",
  AW: "Aruba",
  AU: "Ausztrália",
  AT: "Ausztria",
  AZ: "Azerbajdzsán",
  BS: "Bahama-szigetek",
  BH: "Bahrein",
  BD: "Banglades",
  BB: "Barbados",
  BY: "Fehéroroszország",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhután",
  BO: "Bolívia",
  BA: "Bosznia-Hercegovina",
  BW: "Botswana",
  BV: "Bouvet-sziget",
  BR: "Brazília",
  IO: "Brit Indiai-óceáni Terület",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodzsa",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Zöld-foki Köztársaság",
  KY: "Kajmán-szigetek",
  CF: "Közép-afrikai Köztársaság",
  TD: "Csád",
  CL: "Chile",
  CN: "Kína",
  CX: "Karácsony-sziget",
  CC: "Kókusz (Keeling)-szigetek",
  CO: "Kolumbia",
  KM: "Comore-szigetek",
  CG: "Kongói Köztársaság",
  CD: "Kongói Demokratikus Köztársaság",
  CK: "Cook-szigetek",
  CR: "Costa Rica",
  CI: "Elefántcsontpart",
  HR: "Horvátország",
  CU: "Kuba",
  CY: "Ciprus",
  CZ: "Csehország",
  DK: "Dánia",
  DJ: "Dzsibuti",
  DM: "Dominikai Közösség",
  DO: "Dominikai Köztársaság",
  EC: "Ecuador",
  EG: "Egyiptom",
  SV: "Salvador",
  GQ: "Egyenlítői-Guinea",
  ER: "Eritrea",
  EE: "Észtország",
  ET: "Etiópia",
  FK: "Falkland-szigetek",
  FO: "Feröer",
  FJ: "Fidzsi-szigetek",
  FI: "Finnország",
  FR: "Franciaország",
  GF: "Francia Guyana",
  PF: "Francia Polinézia",
  TF: "Francia déli területek",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Grúzia",
  DE: "Németország",
  GH: "Ghána",
  GI: "Gibraltár",
  GR: "Görögország",
  GL: "Grönland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Bissau-Guinea",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard-sziget és McDonald-szigetek",
  VA: "Vatikán",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Magyarország",
  IS: "Izland",
  IN: "India",
  ID: "Indonézia",
  IR: "Irán",
  IQ: "Irak",
  IE: "Írország",
  IL: "Izrael",
  IT: "Olaszország",
  JM: "Jamaica",
  JP: "Japán",
  JO: "Jordánia",
  KZ: "Kazahsztán",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Észak-Korea",
  KR: "Dél-Korea",
  KW: "Kuvait",
  KG: "Kirgizisztán",
  LA: "Laosz",
  LV: "Lettország",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Litvánia",
  LU: "Luxemburg",
  MO: "Makao",
  MK: "Észak-Macedónia",
  MG: "Madagaszkár",
  MW: "Malawi",
  MY: "Malajzia",
  MV: "Maldív-szigetek",
  ML: "Mali",
  MT: "Málta",
  MH: "Marshall-szigetek",
  MQ: "Martinique",
  MR: "Mauritánia",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexikó",
  FM: "Mikronéziai Szövetségi Államok",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongólia",
  MS: "Montserrat",
  MA: "Marokkó",
  MZ: "Mozambik",
  MM: "Mianmar",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepál",
  NL: "Hollandia",
  NC: "Új-Kaledónia",
  NZ: "Új-Zéland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigéria",
  NU: "Niue",
  NF: "Norfolk-sziget",
  MP: "Északi-Mariana-szigetek",
  NO: "Norvégia",
  OM: "Omán",
  PK: "Pakisztán",
  PW: "Palau",
  PS: "Palesztina",
  PA: "Panama",
  PG: "Pápua Új-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Fülöp-szigetek",
  PN: "Pitcairn-szigetek",
  PL: "Lengyelország",
  PT: "Portugália",
  PR: "Puerto Rico",
  QA: "Katar",
  RE: "Réunion",
  RO: "Románia",
  RU: "Oroszország",
  RW: "Ruanda",
  SH: "Saint Helena",
  KN: "Saint Kitts és Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent és a Grenadine-szigetek",
  WS: "Szamoa",
  SM: "San Marino",
  ST: "São Tomé és Príncipe",
  SA: "Szaudi-Arábia",
  SN: "Szenegál",
  SC: "Seychelle-szigetek",
  SL: "Sierra Leone",
  SG: "Szingapúr",
  SK: "Szlovákia",
  SI: "Szlovénia",
  SB: "Salamon-szigetek",
  SO: "Szomália",
  ZA: "Dél-Afrika",
  GS: "Déli-Georgia és Déli-Sandwich-szigetek",
  ES: "Spanyolország",
  LK: "Sri Lanka",
  SD: "Szudán",
  SR: "Suriname",
  SJ: "Spitzbergák és Jan Mayen",
  SZ: "Szváziföld",
  SE: "Svédország",
  CH: "Svájc",
  SY: "Szíria",
  TW: "Tajvan",
  TJ: "Tádzsikisztán",
  TZ: "Tanzánia",
  TH: "Thaiföld",
  TL: "Kelet-Timor",
  TG: "Togo",
  TK: "Tokelau-szigetek",
  TO: "Tonga",
  TT: "Trinidad és Tobago",
  TN: "Tunézia",
  TR: "Törökország",
  TM: "Türkmenisztán",
  TC: "Turks- és Caicos-szigetek",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukrajna",
  AE: "Egyesült Arab Emírségek",
  GB: "Egyesült Királyság",
  US: "Amerikai Egyesült Államok",
  UM: "Az Amerikai Egyesült Államok lakatlan külbirtokai",
  UY: "Uruguay",
  UZ: "Üzbegisztán",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Brit Virgin-szigetek",
  VI: "Amerikai Virgin-szigetek",
  WF: "Wallis és Futuna",
  EH: "Nyugat-Szahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Karibi Hollandia",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man-sziget",
  JE: "Jersey",
  ME: "Montenegró",
  BL: "Saint Barthélemy",
  MF: "Szent Márton-sziget (francia rész)",
  RS: "Szerbia",
  SX: "Szent Márton-sziget (holland rész)",
  SS: "Dél-Szudán",
  XK: "Koszovó"
}, AN = {
  locale: rg,
  countries: ng
}, ON = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ng,
  default: AN,
  locale: rg
}, Symbol.toStringTag, { value: "Module" })), ag = "id", ig = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "Samoa Amerika",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua dan Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahama",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarusia",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia dan Herzegovina",
  BW: "Botswana",
  BV: "Kepulauan Bouvet",
  BR: "Brasil",
  IO: "Teritori Samudra Hindia Britania",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kamboja",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Tanjung Verde",
  KY: "Kepulauan Cayman",
  CF: "Afrika Tengah",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Pulau Natal",
  CC: "Kepulauan Cocos (Keeling)",
  CO: "Kolombia",
  KM: "Komoro",
  CG: "Kongo",
  CD: "Republik Demokratik Kongo",
  CK: "Kepulauan Cook",
  CR: "Kosta Rika",
  CI: "Pantai Gading",
  HR: "Kroasia",
  CU: "Kuba",
  CY: "Siprus",
  CZ: "Republik Ceko",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominika",
  DO: "Republik Dominika",
  EC: "Ekuador",
  EG: "Mesir",
  SV: "El Salvador",
  GQ: "Guinea Khatulistiwa",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Kepulauan Falkland(Malvinas)",
  FO: "Kepulauan Faroe",
  FJ: "Fiji",
  FI: "Finlandia",
  FR: "Perancis",
  GF: "Guyana Perancis",
  PF: "Polinesia Perancis",
  TF: "Antartika Perancis",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Jerman",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Yunani",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatamala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Pulau Heard dan Kepulauan McDonald",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungaria",
  IS: "Islandia",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaika",
  JP: "Jepang",
  JO: "Yordania",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea Utara",
  KR: "Korea Selatan",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxemburg",
  MO: "Makau",
  MK: "Makedonia Utara",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Kepulauan Marshall",
  MQ: "Martinik",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Meksiko",
  FM: "Federasi Mikronesia",
  MD: "Moldova",
  MC: "Monako",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Moroko",
  MZ: "Mozambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Belanda",
  NC: "Kaledonia Baru",
  NZ: "Selandia Baru",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Kepulauan Norfolk",
  MP: "Kepulauan Mariana Utara",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papua Nugini",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipina",
  PN: "Pitcairn",
  PL: "Polandia",
  PT: "Portugal",
  PR: "Puerto Riko",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Rumania",
  RU: "Rusia",
  RW: "Rwanda",
  SH: "Saint Helena",
  KN: "Saint Kitts dan Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre dan Miquelon",
  VC: "Saint Vincent dan the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome dan Principe",
  SA: "Arab Saudi",
  SN: "Senegal",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapura",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Kepulauan Solomon",
  SO: "Somalia",
  ZA: "Afrika Selatan",
  GS: "Georgia Selatan dan Kepulauan Sandwich Selatan",
  ES: "Spanyol",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard dan Jan Mayen",
  SZ: "Eswatini",
  SE: "Sweden",
  CH: "Swiss",
  SY: "Suriah",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad dan Tobago",
  TN: "Tunisia",
  TR: "Turki",
  TM: "Turkmenistan",
  TC: "Turks dan Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Uni Emirat Arab",
  GB: "Britania Raya",
  US: "Amerika Serikat",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Sahara Barat",
  YE: "Yaman",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland Islands",
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Isle of Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: "Saint Martin (French part)",
  RS: "Serbia",
  SX: "Sint Maarten (Dutch part)",
  SS: "Sudan Selatan",
  XK: "Kosovo"
}, NN = {
  locale: ag,
  countries: ig
}, jN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: ig,
  default: NN,
  locale: ag
}, Symbol.toStringTag, { value: "Module" })), og = "it", sg = {
  AD: "Andorra",
  AE: "Emirati Arabi Uniti",
  AF: "Afghanistan",
  AG: "Antigua e Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antartide",
  AR: "Argentina",
  AS: "Samoa Americane",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Isole Åland",
  AZ: "Azerbaigian",
  BA: "Bosnia ed Erzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgio",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Isole BES",
  BR: "Brasile",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Isola Bouvet",
  BW: "Botswana",
  BY: "Bielorussia",
  BZ: "Belize",
  CA: "Canada",
  CC: "Isole Cocos e Keeling",
  CD: "Repubblica Democratica del Congo",
  CF: "Repubblica Centrafricana",
  CG: "Repubblica del Congo",
  CH: "Svizzera",
  CI: "Costa d'Avorio",
  CK: "Isole Cook",
  CL: "Cile",
  CM: "Camerun",
  CN: "Cina",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Capo Verde",
  CW: "Curaçao",
  CX: "Isola del Natale",
  CY: "Cipro",
  CZ: "Repubblica Ceca",
  DE: "Germania",
  DJ: "Gibuti",
  DK: "Danimarca",
  DM: "Dominica",
  DO: "Repubblica Dominicana",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egitto",
  EH: "Sahara Occidentale",
  ER: "Eritrea",
  ES: "Spagna",
  ET: "Etiopia",
  FI: "Finlandia",
  FJ: "Figi",
  FK: "Isole Falkland",
  FM: "Stati Federati di Micronesia",
  FO: "Isole Fær Øer",
  FR: "Francia",
  GA: "Gabon",
  GB: "Regno Unito",
  GD: "Grenada",
  GE: "Georgia",
  GF: "Guyana Francese",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibilterra",
  GL: "Groenlandia",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadalupa",
  GQ: "Guinea Equatoriale",
  GR: "Grecia",
  GS: "Georgia del Sud e isole Sandwich meridionali",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Isole Heard e McDonald",
  HN: "Honduras",
  HR: "Croazia",
  HT: "Haiti",
  HU: "Ungheria",
  ID: "Indonesia",
  IE: "Irlanda",
  IL: "Israele",
  IM: "Isola di Man",
  IN: "India",
  IO: "Territori Britannici dell'Oceano Indiano",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Islanda",
  IT: "Italia",
  JE: "Jersey",
  JM: "Giamaica",
  JO: "Giordania",
  JP: "Giappone",
  KE: "Kenya",
  KG: "Kirghizistan",
  KH: "Cambogia",
  KI: "Kiribati",
  KM: "Comore",
  KN: "Saint Kitts e Nevis",
  KP: "Corea del Nord",
  KR: "Corea del Sud",
  KW: "Kuwait",
  KY: "Isole Cayman",
  KZ: "Kazakistan",
  LA: "Laos",
  LB: "Libano",
  LC: "Santa Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituania",
  LU: "Lussemburgo",
  LV: "Lettonia",
  LY: "Libia",
  MA: "Marocco",
  MC: "Monaco",
  MD: "Moldavia",
  ME: "Montenegro",
  MF: "Saint-Martin",
  MG: "Madagascar",
  MH: "Isole Marshall",
  MK: "Macedonia del Nord",
  ML: "Mali",
  MM: "Birmania  Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Isole Marianne Settentrionali",
  MQ: "Martinica",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldive",
  MW: "Malawi",
  MX: "Messico",
  MY: "Malesia",
  MZ: "Mozambico",
  NA: "Namibia",
  NC: "Nuova Caledonia",
  NE: "Niger",
  NF: "Isola Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Paesi Bassi",
  NO: "Norvegia",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nuova Zelanda",
  OM: "Oman",
  PA: "Panamá",
  PE: "Perù",
  PF: "Polinesia Francese",
  PG: "Papua Nuova Guinea",
  PH: "Filippine",
  PK: "Pakistan",
  PL: "Polonia",
  PM: "Saint Pierre e Miquelon",
  PN: "Isole Pitcairn",
  PR: "Porto Rico",
  PS: "Stato di Palestina",
  PT: "Portogallo",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Ruanda",
  SA: "Arabia Saudita",
  SB: "Isole Salomone",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Svezia",
  SG: "Singapore",
  SH: "Sant'Elena, Isola di Ascensione e Tristan da Cunha",
  SI: "Slovenia",
  SJ: "Svalbard e Jan Mayen",
  SK: "Slovacchia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Sudan del Sud",
  ST: "São Tomé e Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Siria",
  SZ: "Eswatini",
  TC: "Isole Turks e Caicos",
  TD: "Ciad",
  TF: "Territori Francesi del Sud",
  TG: "Togo",
  TH: "Thailandia",
  TJ: "Tagikistan",
  TK: "Tokelau",
  TL: "Timor Est",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turchia",
  TT: "Trinidad e Tobago",
  TV: "Tuvalu",
  TW: [
    "Repubblica di Cina",
    "Taiwan"
  ],
  TZ: "Tanzania",
  UA: "Ucraina",
  UG: "Uganda",
  UM: "Isole minori esterne degli Stati Uniti",
  US: "Stati Uniti d'America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Città del Vaticano",
  VC: "Saint Vincent e Grenadine",
  VE: "Venezuela",
  VG: "Isole Vergini Britanniche",
  VI: "Isole Vergini Americane",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis e Futuna",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Sudafrica",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, RN = {
  locale: og,
  countries: sg
}, DN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: sg,
  default: RN,
  locale: og
}, Symbol.toStringTag, { value: "Module" })), lg = "ja", cg = {
  AF: "アフガニスタン",
  AL: "アルバニア",
  DZ: "アルジェリア",
  AS: "アメリカ領サモア",
  AD: "アンドラ",
  AO: "アンゴラ",
  AI: "アンギラ",
  AQ: "南極",
  AG: "アンティグア・バーブーダ",
  AR: "アルゼンチン",
  AM: "アルメニア",
  AW: "アルバ",
  AU: "オーストラリア",
  AT: "オーストリア",
  AZ: "アゼルバイジャン",
  BS: "バハマ",
  BH: "バーレーン",
  BD: "バングラデシュ",
  BB: "バルバドス",
  BY: "ベラルーシ",
  BE: "ベルギー",
  BZ: "ベリーズ",
  BJ: "ベナン",
  BM: "バミューダ",
  BT: "ブータン",
  BO: "ボリビア多民族国",
  BA: "ボスニア・ヘルツェゴビナ",
  BW: "ボツワナ",
  BV: "ブーベ島",
  BR: "ブラジル",
  IO: "イギリス領インド洋地域",
  BN: "ブルネイ・ダルサラーム",
  BG: "ブルガリア",
  BF: "ブルキナファソ",
  BI: "ブルンジ",
  KH: "カンボジア",
  CM: "カメルーン",
  CA: "カナダ",
  CV: "カーボベルデ",
  KY: "ケイマン諸島",
  CF: "中央アフリカ共和国",
  TD: "チャド",
  CL: "チリ",
  CN: "中華人民共和国",
  CX: "クリスマス島",
  CC: "ココス（キーリング）諸島",
  CO: "コロンビア",
  KM: "コモロ",
  CG: "コンゴ共和国",
  CD: "コンゴ民主共和国",
  CK: "クック諸島",
  CR: "コスタリカ",
  CI: "コートジボワール",
  HR: "クロアチア",
  CU: "キューバ",
  CY: "キプロス",
  CZ: "チェコ",
  DK: "デンマーク",
  DJ: "ジブチ",
  DM: "ドミニカ国",
  DO: "ドミニカ共和国",
  EC: "エクアドル",
  EG: "エジプト",
  SV: "エルサルバドル",
  GQ: "赤道ギニア",
  ER: "エリトリア",
  EE: "エストニア",
  ET: "エチオピア",
  FK: "フォークランド（マルビナス）諸島",
  FO: "フェロー諸島",
  FJ: "フィジー",
  FI: "フィンランド",
  FR: "フランス",
  GF: "フランス領ギアナ",
  PF: "フランス領ポリネシア",
  TF: "フランス領南方・南極地域",
  GA: "ガボン",
  GM: "ガンビア",
  GE: "ジョージア",
  DE: "ドイツ",
  GH: "ガーナ",
  GI: "ジブラルタル",
  GR: "ギリシャ",
  GL: "グリーンランド",
  GD: "グレナダ",
  GP: "グアドループ",
  GU: "グアム",
  GT: "グアテマラ",
  GN: "ギニア",
  GW: "ギニアビサウ",
  GY: "ガイアナ",
  HT: "ハイチ",
  HM: "ハード島とマクドナルド諸島",
  VA: "バチカン市国",
  HN: "ホンジュラス",
  HK: "香港",
  HU: "ハンガリー",
  IS: "アイスランド",
  IN: "インド",
  ID: "インドネシア",
  IR: "イラン・イスラム共和国",
  IQ: "イラク",
  IE: "アイルランド",
  IL: "イスラエル",
  IT: "イタリア",
  JM: "ジャマイカ",
  JP: "日本",
  JO: "ヨルダン",
  KZ: "カザフスタン",
  KE: "ケニア",
  KI: "キリバス",
  KP: "朝鮮民主主義人民共和国",
  KR: "大韓民国",
  KW: "クウェート",
  KG: "キルギス",
  LA: "ラオス人民民主共和国",
  LV: "ラトビア",
  LB: "レバノン",
  LS: "レソト",
  LR: "リベリア",
  LY: "リビア",
  LI: "リヒテンシュタイン",
  LT: "リトアニア",
  LU: "ルクセンブルク",
  MO: "マカオ",
  MG: "マダガスカル",
  MW: "マラウイ",
  MY: "マレーシア",
  MV: "モルディブ",
  ML: "マリ",
  MT: "マルタ",
  MH: "マーシャル諸島",
  MQ: "マルティニーク",
  MR: "モーリタニア",
  MU: "モーリシャス",
  YT: "マヨット",
  MX: "メキシコ",
  FM: "ミクロネシア連邦",
  MD: "モルドバ共和国",
  MC: "モナコ",
  MN: "モンゴル",
  MS: "モントセラト",
  MA: "モロッコ",
  MZ: "モザンビーク",
  MM: "ミャンマー",
  NA: "ナミビア",
  NR: "ナウル",
  NP: "ネパール",
  NL: "オランダ",
  NC: "ニューカレドニア",
  NZ: "ニュージーランド",
  NI: "ニカラグア",
  NE: "ニジェール",
  NG: "ナイジェリア",
  NU: "ニウエ",
  NF: "ノーフォーク島",
  MK: "北マケドニア",
  MP: "北マリアナ諸島",
  NO: "ノルウェー",
  OM: "オマーン",
  PK: "パキスタン",
  PW: "パラオ",
  PS: "パレスチナ",
  PA: "パナマ",
  PG: "パプアニューギニア",
  PY: "パラグアイ",
  PE: "ペルー",
  PH: "フィリピン",
  PN: "ピトケアン",
  PL: "ポーランド",
  PT: "ポルトガル",
  PR: "プエルトリコ",
  QA: "カタール",
  RE: "レユニオン",
  RO: "ルーマニア",
  RU: "ロシア連邦",
  RW: "ルワンダ",
  SH: "セントヘレナ・アセンションおよびトリスタンダクーニャ",
  KN: "セントクリストファー・ネイビス",
  LC: "セントルシア",
  PM: "サンピエール島・ミクロン島",
  VC: "セントビンセントおよびグレナディーン諸島",
  WS: "サモア",
  SM: "サンマリノ",
  ST: "サントメ・プリンシペ",
  SA: "サウジアラビア",
  SN: "セネガル",
  SC: "セーシェル",
  SL: "シエラレオネ",
  SG: "シンガポール",
  SK: "スロバキア",
  SI: "スロベニア",
  SB: "ソロモン諸島",
  SO: "ソマリア",
  ZA: "南アフリカ",
  GS: "サウスジョージア・サウスサンドウィッチ諸島",
  ES: "スペイン",
  LK: "スリランカ",
  SD: "スーダン",
  SR: "スリナム",
  SJ: "スヴァールバル諸島およびヤンマイエン島",
  SZ: "スワジランド",
  SE: "スウェーデン",
  CH: "スイス",
  SY: "シリア・アラブ共和国",
  TW: "台湾",
  TJ: "タジキスタン",
  TZ: "タンザニア",
  TH: "タイ",
  TL: "東ティモール",
  TG: "トーゴ",
  TK: "トケラウ",
  TO: "トンガ",
  TT: "トリニダード・トバゴ",
  TN: "チュニジア",
  TR: "トルコ",
  TM: "トルクメニスタン",
  TC: "タークス・カイコス諸島",
  TV: "ツバル",
  UG: "ウガンダ",
  UA: "ウクライナ",
  AE: "アラブ首長国連邦",
  GB: "イギリス",
  US: "アメリカ合衆国",
  UM: "合衆国領有小離島",
  UY: "ウルグアイ",
  UZ: "ウズベキスタン",
  VU: "バヌアツ",
  VE: "ベネズエラ・ボリバル共和国",
  VN: "ベトナム",
  VG: "イギリス領ヴァージン諸島",
  VI: "アメリカ領ヴァージン諸島",
  WF: "ウォリス・フツナ",
  EH: "西サハラ",
  YE: "イエメン",
  ZM: "ザンビア",
  ZW: "ジンバブエ",
  AX: "オーランド諸島",
  BQ: "ボネール、シント・ユースタティウスおよびサバ",
  CW: "キュラソー",
  GG: "ガーンジー",
  IM: "マン島",
  JE: "ジャージー",
  ME: "モンテネグロ",
  BL: "サン・バルテルミー",
  MF: "サン・マルタン（フランス領）",
  RS: "セルビア",
  SX: "シント・マールテン（オランダ領）",
  SS: "南スーダン",
  XK: "コソボ"
}, IN = {
  locale: lg,
  countries: cg
}, HN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: cg,
  default: IN,
  locale: lg
}, Symbol.toStringTag, { value: "Module" })), ug = "nl", dg = {
  AF: "Afghanistan",
  AL: "Albanië",
  DZ: "Algerije",
  AS: "Amerikaans-Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua en Barbuda",
  AR: "Argentinië",
  AM: "Armenië",
  AW: "Aruba",
  AU: "Australië",
  AT: "Oostenrijk",
  AZ: "Azerbeidzjan",
  BS: "Bahama's",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Wit-Rusland",
  BE: [
    "België",
    "Koninkrijk België"
  ],
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivië",
  BA: "Bosnië-Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Eiland",
  BR: "Brazilië",
  IO: "Brits Indische oceaan",
  BN: "Brunei Darussalam",
  BG: "Bulgarije",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodja",
  CM: "Kameroen",
  CA: "Canada",
  CV: "Kaapverdië",
  KY: "Kaaimaneilanden",
  CF: "Centraal-Afrikaanse Republiek",
  TD: "Tsjaad",
  CL: "Chili",
  CN: "China",
  CX: "Christmaseiland",
  CC: "Cocoseilanden",
  CO: "Colombia",
  KM: "Comoren",
  CG: "Congo, Volksrepubliek",
  CD: "Congo, Democratische Republiek",
  CK: "Cookeilanden",
  CR: "Costa Rica",
  CI: "Ivoorkust",
  HR: "Kroatië",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Tsjechië",
  DK: "Denemarken",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominicaanse Republiek",
  EC: "Ecuador",
  EG: "Egypte",
  SV: "El Salvador",
  GQ: "Equatoriaal-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Ethiopië",
  FK: "Falklandeilanden",
  FO: "Faeröer",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrijk",
  GF: "Frans-Guyana",
  PF: "Frans-Polynesië",
  TF: "Franse Zuidelijke Gebieden",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgië",
  DE: "Duitsland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Griekenland",
  GL: "Groenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinee-Bissau",
  GY: "Guyana",
  HT: "Haïti",
  HM: "Heard en McDonaldeilanden",
  VA: "Heilige Stoel",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hongarije",
  IS: "IJsland",
  IN: "India",
  ID: "Indonesië",
  IR: "Iran",
  IQ: "Irak",
  IE: "Ierland",
  IL: "Israël",
  IT: "Italië",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordanië",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Noord-Korea",
  KR: "Zuid-Korea",
  KW: "Koeweit",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Letland",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libië",
  LI: "Liechtenstein",
  LT: "Litouwen",
  LU: "Luxemburg",
  MO: "Macao",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Maleisië",
  MV: [
    "Maldiven",
    "Malediven"
  ],
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalleilanden",
  MQ: "Martinique",
  MR: "Mauritanië",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesië, Federale Staten",
  MD: "Moldavië",
  MC: "Monaco",
  MN: "Mongolië",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibië",
  NR: "Nauru",
  NP: "Nepal",
  NL: [
    "Nederland",
    "Koninkrijk der Nederlanden"
  ],
  NC: "Nieuw-Caledonië",
  NZ: "Nieuw-Zeeland",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MP: "Noordelijke Marianen",
  MK: "Noord-Macedonië",
  NO: "Noorwegen",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papoea-Nieuw-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filipijnen",
  PN: "Pitcairn",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Roemenië",
  RU: "Rusland",
  RW: "Rwanda",
  SH: "Sint-Helena",
  KN: "Saint Kitts en Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre en Miquelon",
  VC: "Saint Vincent en de Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé en Principe",
  SA: "Saudi-Arabië",
  SN: "Senegal",
  SC: "Seychellen",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slowakije",
  SI: "Slovenië",
  SB: "Salomonseilanden",
  SO: "Somalië",
  ZA: "Zuid-Afrika",
  GS: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
  ES: "Spanje",
  LK: "Sri Lanka",
  SD: "Soedan",
  SR: "Suriname",
  SJ: "Spitsbergen en Jan Mayen",
  SZ: "Ngwane, Koninkrijk Eswatini",
  SE: "Zweden",
  CH: "Zwitserland",
  SY: "Syrië",
  TW: "Taiwan",
  TJ: "Tadzjikistan",
  TZ: [
    "Tanzania",
    "Tanzania, Verenigde Republiek"
  ],
  TH: "Thailand",
  TL: "Timor Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad en Tobago",
  TN: "Tunesië",
  TR: "Turkije",
  TM: "Turkmenistan",
  TC: "Turks- en Caicoseilanden",
  TV: "Tuvalu",
  UG: "Oeganda",
  UA: "Oekraïne",
  AE: "Verenigde Arabische Emiraten",
  GB: [
    "Groot-Brittannië",
    "Verenigd Koninkrijk"
  ],
  US: [
    "Verenigde Staten van Amerika",
    "Verenigde Staten"
  ],
  UM: "Ver afgelegen eilandjes van de Verenigde Staten",
  UY: "Uruguay",
  UZ: "Oezbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "Maagdeneilanden, Britse",
  VI: "Maagdeneilanden, Amerikaanse",
  WF: "Wallis en Futuna",
  EH: "Westelijke Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Bonaire, Sint Eustatius en Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man Eiland",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint Barthélemy",
  MF: [
    "Sint-Maarten (Frans deel)",
    "Sint-Maarten (Franse Antillen)",
    "Collectiviteit van Sint-Maarten"
  ],
  RS: "Servië",
  SX: [
    "Sint Maarten",
    "Sint-Maarten",
    "Sint Maarten (Nederlands deel)",
    "Land Sint Maarten"
  ],
  SS: "Zuid-Soedan",
  XK: "Kosovo"
}, FN = {
  locale: ug,
  countries: dg
}, VN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: dg,
  default: FN,
  locale: ug
}, Symbol.toStringTag, { value: "Module" })), pg = "no", hg = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algerie",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Østerrike",
  AZ: "Aserbajdsjan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Hviterussland",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia-Hercegovina",
  BW: "Botswana",
  BV: "Bouvetøya",
  BR: "Brasil",
  IO: "Det britiske territoriet i Indiahavet",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodsja",
  CM: "Kamerun",
  CA: "Canada",
  CV: "Kapp Verde",
  KY: "Caymanøyene",
  CF: "Den sentralafrikanske republikk",
  TD: "Tsjad",
  CL: "Chile",
  CN: "Kina",
  CX: "Christmasøya",
  CC: "Kokosøyene",
  CO: "Colombia",
  KM: "Komorene",
  CG: "Kongo-Brazzaville",
  CD: "Kongo",
  CK: "Cookøyene",
  CR: "Costa Rica",
  CI: "Elfenbenskysten",
  HR: "Kroatia",
  CU: "Cuba",
  CY: "Kypros",
  CZ: "Tsjekkia",
  DK: "Danmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den dominikanske republikk",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Ekvatorial-Guinea",
  ER: "Eritrea",
  EE: "Estland",
  ET: "Etiopia",
  FK: "Falklandsøyene",
  FO: "Færøyene",
  FJ: "Fiji",
  FI: "Finland",
  FR: "Frankrike",
  GF: "Fransk Guyana",
  PF: "Fransk Polynesia",
  TF: "De franske sørterritorier",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Tyskland",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Hellas",
  GL: "Grønland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard- og McDonaldøyene",
  VA: "Vatikanstaten",
  HN: "Honduras",
  HK: "Hongkong SAR Kina",
  HU: "Ungarn",
  IS: "Island",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irland",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kasakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Nord-Korea",
  KR: "Sør-Korea",
  KW: "Kuwait",
  KG: "Kirgisistan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Libanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxemburg",
  MO: "Macao SAR Kina",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldivene",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshalløyene",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesiaføderasjonen",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Marokko",
  MZ: "Mosambik",
  MM: "Myanmar (Burma)",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Nederland",
  NC: "Ny-Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolkøya",
  MK: "Nord-Makedonia",
  MP: "Nord-Marianene",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Det palestinske området",
  PA: "Panama",
  PG: "Papua Ny-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Filippinene",
  PN: "Pitcairnøyene",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russland",
  RW: "Rwanda",
  SH: "St. Helena",
  KN: "Saint Kitts og Nevis",
  LC: "St. Lucia",
  PM: "Saint-Pierre-et-Miquelon",
  VC: "St. Vincent og Grenadinene",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabia",
  SN: "Senegal",
  SC: "Seychellene",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Salomonøyene",
  SO: "Somalia",
  ZA: "Sør-Afrika",
  GS: "Sør-Georgia og Sør-Sandwichøyene",
  ES: "Spania",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard og Jan Mayen",
  SZ: "Eswatini",
  SE: "Sverige",
  CH: "Sveits",
  SY: "Syria",
  TW: "Taiwan",
  TJ: "Tadsjikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TL: "Øst-Timor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TN: "Tunisia",
  TR: "Tyrkia",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøyene",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "De forente arabiske emirater",
  GB: "Storbritannia",
  US: "USA",
  UM: "USAs ytre øyer",
  UY: "Uruguay",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  VG: "De britiske jomfruøyene",
  VI: "De amerikanske jomfruøyene",
  WF: "Wallis og Futuna",
  EH: "Vest-Sahara",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Åland",
  BQ: "Karibisk Nederland",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Man",
  JE: "Jersey",
  ME: "Montenegro",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  RS: "Serbia",
  SX: "Sint Maarten",
  SS: "Sør-Sudan",
  XK: "Kosovo"
}, BN = {
  locale: pg,
  countries: hg
}, zN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: hg,
  default: BN,
  locale: pg
}, Symbol.toStringTag, { value: "Module" })), mg = "pl", fg = {
  AF: "Afganistan",
  AL: "Albania",
  DZ: "Algieria",
  AS: "Samoa Amerykańskie",
  AD: "Andora",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktyka",
  AG: "Antigua i Barbuda",
  AR: "Argentyna",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbejdżan",
  BS: "Bahamy",
  BH: "Bahrajn",
  BD: "Bangladesz",
  BB: "Barbados",
  BY: "Białoruś",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermudy",
  BT: "Bhutan",
  BO: "Boliwia",
  BA: "Bośnia i Hercegowina",
  BW: "Botswana",
  BV: "Wyspa Bouveta",
  BR: "Brazylia",
  IO: "Brytyjskie Terytorium Oceanu Indyjskiego",
  BN: "Brunei",
  BG: "Bułgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Kambodża",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Republika Zielonego Przylądka",
  KY: "Kajmany",
  CF: "Republika Środkowoafrykańska",
  TD: "Czad",
  CL: "Chile",
  CN: "Chiny",
  CX: "Wyspa Bożego Narodzenia",
  CC: "Wyspy Kokosowe",
  CO: "Kolumbia",
  KM: "Komory",
  CG: "Kongo",
  CD: "Demokratyczna Republika Konga",
  CK: "Wyspy Cooka",
  CR: "Kostaryka",
  CI: "Wybrzeże Kości Słoniowej",
  HR: "Chorwacja",
  CU: "Kuba",
  CY: "Cypr",
  CZ: "Czechy",
  DK: "Dania",
  DJ: "Dżibuti",
  DM: "Dominika",
  DO: "Dominikana",
  EC: "Ekwador",
  EG: "Egipt",
  SV: "Salwador",
  GQ: "Gwinea Równikowa",
  ER: "Erytrea",
  EE: "Estonia",
  ET: "Etiopia",
  FK: "Falklandy",
  FO: "Wyspy Owcze",
  FJ: "Fidżi",
  FI: "Finlandia",
  FR: "Francja",
  GF: "Gujana Francuska",
  PF: "Polinezja Francuska",
  TF: "Francuskie Terytoria Południowe i Antarktyczne",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gruzja",
  DE: "Niemcy",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Grecja",
  GL: "Grenlandia",
  GD: "Grenada",
  GP: "Gwadelupa",
  GU: "Guam",
  GT: "Gwatemala",
  GN: "Gwinea",
  GW: "Gwinea Bissau",
  GY: "Gujana",
  HT: "Haiti",
  HM: "Wyspy Heard i McDonalda",
  VA: "Watykan",
  HN: "Honduras",
  HK: "Hongkong",
  HU: "Węgry",
  IS: "Islandia",
  IN: "Indie",
  ID: "Indonezja",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandia",
  IL: "Izrael",
  IT: "Włochy",
  JM: "Jamajka",
  JP: "Japonia",
  JO: "Jordania",
  KZ: "Kazachstan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Korea Północna",
  KR: "Korea Południowa",
  KW: "Kuwejt",
  KG: "Kirgistan",
  LA: "Laos",
  LV: "Łotwa",
  LB: "Liban",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libia",
  LI: "Liechtenstein",
  LT: "Litwa",
  LU: "Luksemburg",
  MO: "Makau",
  MK: "Macedonia Północna",
  MG: "Madagaskar",
  MW: "Malawi",
  MY: "Malezja",
  MV: "Malediwy",
  ML: "Mali",
  MT: "Malta",
  MH: "Wyspy Marshalla",
  MQ: "Martynika",
  MR: "Mauretania",
  MU: "Mauritius",
  YT: "Majotta",
  MX: "Meksyk",
  FM: "Mikronezja",
  MD: "Mołdawia",
  MC: "Monako",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Maroko",
  MZ: "Mozambik",
  MM: "Mjanma",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holandia",
  NC: "Nowa Kaledonia",
  NZ: "Nowa Zelandia",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk",
  MP: "Mariany Północne",
  NO: "Norwegia",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestyna",
  PA: "Panama",
  PG: "Papua-Nowa Gwinea",
  PY: "Paragwaj",
  PE: "Peru",
  PH: "Filipiny",
  PN: "Pitcairn",
  PL: "Polska",
  PT: "Portugalia",
  PR: "Portoryko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Rumunia",
  RU: "Rosja",
  RW: "Rwanda",
  SH: "Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha",
  KN: "Saint Kitts i Nevis",
  LC: "Saint Lucia",
  PM: "Saint-Pierre i Miquelon",
  VC: "Saint Vincent i Grenadyny",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Wyspy Świętego Tomasza i Książęca",
  SA: "Arabia Saudyjska",
  SN: "Senegal",
  SC: "Seszele",
  SL: "Sierra Leone",
  SG: "Singapur",
  SK: "Słowacja",
  SI: "Słowenia",
  SB: "Wyspy Salomona",
  SO: "Somalia",
  ZA: "Południowa Afryka",
  GS: "Georgia Południowa i Sandwich Południowy",
  ES: "Hiszpania",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard i Jan Mayen",
  SZ: "Eswatini",
  SE: "Szwecja",
  CH: "Szwajcaria",
  SY: "Syria",
  TW: "Tajwan",
  TJ: "Tadżykistan",
  TZ: "Tanzania",
  TH: "Tajlandia",
  TL: "Timor Wschodni",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trynidad i Tobago",
  TN: "Tunezja",
  TR: "Turcja",
  TM: "Turkmenistan",
  TC: "Turks i Caicos",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraina",
  AE: "Zjednoczone Emiraty Arabskie",
  GB: "Wielka Brytania",
  US: "Stany Zjednoczone",
  UM: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
  UY: "Urugwaj",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Wenezuela",
  VN: "Wietnam",
  VG: "Brytyjskie Wyspy Dziewicze",
  VI: "Wyspy Dziewicze Stanów Zjednoczonych",
  WF: "Wallis i Futuna",
  EH: "Sahara Zachodnia",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AX: "Wyspy Alandzkie",
  BQ: "Bonaire, Sint Eustatius i Saba",
  CW: "Curaçao",
  GG: "Guernsey",
  IM: "Wyspa Man",
  JE: "Jersey",
  ME: "Czarnogóra",
  BL: "Saint-Barthélemy",
  MF: "Saint-Martin",
  RS: "Serbia",
  SX: "Sint Maarten",
  SS: "Sudan Południowy",
  XK: "Kosowo"
}, GN = {
  locale: mg,
  countries: fg
}, UN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: fg,
  default: GN,
  locale: mg
}, Symbol.toStringTag, { value: "Module" })), Cg = "pt", gg = {
  AF: "Afeganistão",
  ZA: "África do Sul",
  AL: "Albânia",
  DE: "Alemanha",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguila",
  AQ: "Antártida",
  AG: "Antígua e Barbuda",
  SA: "Arábia Saudita",
  DZ: "Argélia",
  AR: "Argentina",
  AM: "Arménia",
  AW: "Aruba",
  AU: "Austrália",
  AT: "Áustria",
  AZ: "Azerbaijão",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BE: "Bélgica",
  BZ: "Belize",
  BJ: "Benim",
  BM: "Bermudas",
  BY: "Bielorrússia",
  BO: "Bolívia",
  BA: "Bósnia-Herzegovina",
  BW: "Botsuana",
  BR: "Brasil",
  BN: "Brunei",
  BG: "Bulgária",
  BF: "Burkina Faso",
  BI: "Burundi",
  BT: "Butão",
  CV: "Cabo Verde",
  KH: "Camboja",
  CA: "Canadá",
  QA: "Qatar",
  KZ: "Cazaquistão",
  TD: "Chade",
  CL: "Chile",
  CN: "China",
  CY: "Chipre",
  VA: "Santa Sé",
  SG: "Singapura",
  CO: "Colômbia",
  KM: "Comores",
  CG: "República Democrática do Congo",
  CD: "República Popular do Congo",
  KP: "Coreia do Norte",
  KR: "Coreia do Sul",
  CI: "Costa do Marfim",
  CR: "Costa Rica",
  HR: "Croácia",
  CU: "Cuba",
  CW: "Curaçao",
  DK: "Dinamarca",
  DJ: "Djibouti",
  DM: "Dominica",
  EG: "Egito",
  SV: "El Salvador",
  AE: "Emirados Árabes Unidos",
  EC: "Equador",
  ER: "Eritreia",
  SK: "Eslováquia",
  SI: "Eslovénia",
  ES: "Espanha",
  US: [
    "Estados Unidos",
    "Estados Unidos da América"
  ],
  EE: "Estónia",
  ET: "Etiópia",
  FJ: "Fiji",
  PH: "Filipinas",
  FI: "Finlândia",
  FR: "França",
  GA: "Gabão",
  GM: "Gâmbia",
  GH: "Gana",
  GE: "Geórgia",
  GS: "Geórgia do Sul e Ilhas Sandwich do Sul",
  GI: "Gibraltar",
  GD: "Granada",
  GR: "Grécia",
  GL: "Gronelândia",
  GP: "Guadalupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GY: "Guiana",
  GF: "Guiana Francesa",
  GN: "Guiné",
  GW: "Guiné-Bissau",
  GQ: "Guiné Equatorial",
  HT: "Haiti",
  NL: "Países Baixos",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungria",
  YE: "Iémen",
  BV: "Ilha Bouvet",
  CX: "Ilha de Natal",
  IM: "Ilha de Man",
  NF: "Ilha Norfolk",
  AX: "Ilhas Åland",
  KY: "Ilhas Caimão",
  CC: "Ilhas Cocos (Keeling)",
  CK: "Ilhas Cook",
  UM: "Ilhas Distantes dos EUA",
  HM: "Ilha Heard e Ilhas McDonald",
  FO: "Ilhas Faroé",
  FK: "Ilhas Malvinas",
  MP: "Ilhas Marianas do Norte",
  MH: "Ilhas Marshall",
  PN: "Ilhas Pitcairn",
  SB: "Ilhas Salomão",
  TC: "Ilhas Turcas e Caicos",
  VG: "Ilhas Virgens Britânicas",
  VI: "Ilhas Virgens Americanas",
  IN: "Índia",
  ID: "Indonésia",
  IR: "Irão",
  IQ: "Iraque",
  IE: "Irlanda",
  IS: "Islândia",
  IL: "Israel",
  IT: "Itália",
  JM: "Jamaica",
  JP: "Japão",
  JE: "Jersey",
  JO: "Jordânia",
  KW: "Koweit",
  LA: "Laos",
  LS: "Lesoto",
  LV: "Letónia",
  LB: "Líbano",
  LR: "Libéria",
  LY: "Líbia",
  LI: "Liechtenstein",
  LT: "Lituânia",
  LU: "Luxemburgo",
  MO: "Macau",
  MK: "Macedónia do Norte",
  MG: "Madagáscar",
  MY: "Malásia",
  MW: "Maláui",
  MV: "Maldivas",
  ML: "Mali",
  MT: "Malta",
  MA: "Marrocos",
  MQ: "Martinica",
  MU: "Maurícia",
  MR: "Mauritânia",
  YT: "Mayotte",
  MX: "México",
  MM: "Mianmar (Birmânia)",
  FM: "Micronésia",
  MZ: "Moçambique",
  MD: "Moldávia",
  MC: "Mónaco",
  MN: "Mongólia",
  ME: "Montenegro",
  MS: "Monserrate",
  NA: "Namíbia",
  NR: "Nauru",
  NP: "Nepal",
  NI: "Nicarágua",
  NE: "Níger",
  NG: "Nigéria",
  NU: "Niue",
  NO: "Noruega",
  NC: "Nova Caledónia",
  NZ: "Nova Zelândia",
  OM: "Omã",
  BQ: "Países Baixos Caribenhos",
  PW: "Palau",
  PA: "Panamá",
  PG: "Papua-Nova Guiné",
  PK: "Paquistão",
  PY: "Paraguai",
  PE: "Peru",
  PF: "Polinésia Francesa",
  PL: "Polónia",
  PR: "Porto Rico",
  PT: "Portugal",
  KE: "Quénia",
  KG: "Quirguistão",
  KI: "Quiribati",
  GB: "Reino Unido",
  CF: "República Centro-Africana",
  DO: "República Dominicana",
  CM: "Camarões",
  CZ: "Chéquia",
  RE: "Reunião",
  RO: "Roménia",
  RW: "Ruanda",
  RU: "Rússia",
  EH: "Saara Ocidental",
  PM: "Saint Pierre e Miquelon",
  WS: "Samoa",
  AS: "Samoa Americana",
  SM: "San Marino",
  SH: "Santa Helena",
  LC: "Santa Lúcia",
  BL: "São Bartolomeu",
  KN: "São Cristóvão e Neves",
  MF: "São Martinho",
  ST: "São Tomé e Príncipe",
  VC: "São Vicente e Granadinas",
  SN: "Senegal",
  SL: "Serra Leoa",
  RS: "Sérvia",
  SC: "Seychelles",
  SX: "São Martinho",
  SY: "Síria",
  SO: "Somália",
  LK: "Sri Lanka",
  SZ: "Essuatíni",
  SD: "Sudão",
  SS: "Sudão do Sul",
  SE: "Suécia",
  CH: "Suíça",
  SR: "Suriname",
  SJ: "Svalbard e Jan Mayen",
  TH: "Tailândia",
  TW: "Taiwan",
  TJ: "Tajiquistão",
  TZ: "Tanzânia",
  IO: "Território Britânico do Oceano Índico",
  TF: "Terras Austrais e Antárticas Francesas",
  PS: "Territórios palestinos",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trindade e Tobago",
  TN: "Tunísia",
  TM: "Turquemenistão",
  TR: "Turquia",
  TV: "Tuvalu",
  UA: "Ucrânia",
  UG: "Uganda",
  UY: "Uruguai",
  UZ: "Uzbequistão",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietname",
  WF: "Wallis e Futuna",
  ZM: "Zâmbia",
  ZW: "Zimbábue",
  XK: "Kosovo"
}, ZN = {
  locale: Cg,
  countries: gg
}, KN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: gg,
  default: ZN,
  locale: Cg
}, Symbol.toStringTag, { value: "Module" })), yg = "ro", vg = {
  AD: "Andorra",
  AE: "Emiratele Arabe Unite",
  AF: "Afganistan",
  AG: "Antigua și Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "Samoa Americană",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Insulele Åland",
  AZ: "Azerbaidjan",
  BA: "Bosnia și Herțegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgia",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Sfântul Bartolomeu",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Insulele Caraibe Olandeze",
  BR: "Brazilia",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Insula Bouvet",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Insulele Cocos (Keeling)",
  CD: "Congo - Kinshasa",
  CF: "Republica Centrafricană",
  CG: "Congo - Brazzaville",
  CH: "Elveția",
  CI: "Côte d’Ivoire",
  CK: "Insulele Cook",
  CL: "Chile",
  CM: "Camerun",
  CN: "China",
  CO: "Columbia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Capul Verde",
  CW: "Curaçao",
  CX: "Insula Christmas",
  CY: "Cipru",
  CZ: "Cehia",
  DE: "Germania",
  DJ: "Djibouti",
  DK: "Danemarca",
  DM: "Dominica",
  DO: "Republica Dominicană",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egipt",
  EH: "Sahara Occidentală",
  ER: "Eritreea",
  ES: "Spania",
  ET: "Etiopia",
  FI: "Finlanda",
  FJ: "Fiji",
  FK: "Insulele Falkland",
  FM: "Micronezia",
  FO: "Insulele Feroe",
  FR: "Franța",
  GA: "Gabon",
  GB: "Regatul Unit",
  GD: "Grenada",
  GE: "Georgia",
  GF: "Guyana Franceză",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Groenlanda",
  GM: "Gambia",
  GN: "Guineea",
  GP: "Guadelupa",
  GQ: "Guineea Ecuatorială",
  GR: "Grecia",
  GS: "Georgia de Sud și Insulele Sandwich de Sud",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guineea-Bissau",
  GY: "Guyana",
  HK: "R.A.S. Hong Kong a Chinei",
  HM: "Insula Heard și Insulele McDonald",
  HN: "Honduras",
  HR: "Croația",
  HT: "Haiti",
  HU: "Ungaria",
  ID: "Indonezia",
  IE: "Irlanda",
  IL: "Israel",
  IM: "Insula Man",
  IN: "India",
  IO: "Teritoriul Britanic din Oceanul Indian",
  IQ: "Irak",
  IR: "Iran",
  IS: "Islanda",
  IT: "Italia",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Iordania",
  JP: "Japonia",
  KE: "Kenya",
  KG: "Kârgâzstan",
  KH: "Cambodgia",
  KI: "Kiribati",
  KM: "Comore",
  KN: "Saint Kitts și Nevis",
  KP: "Coreea de Nord",
  KR: "Coreea de Sud",
  KW: "Kuweit",
  KY: "Insulele Cayman",
  KZ: "Kazahstan",
  LA: "Laos",
  LB: "Liban",
  LC: "Sfânta Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lituania",
  LU: "Luxemburg",
  LV: "Letonia",
  LY: "Libia",
  MA: "Maroc",
  MC: "Monaco",
  MD: "Republica Moldova",
  ME: "Muntenegru",
  MF: "Sfântul Martin",
  MG: "Madagascar",
  MH: "Insulele Marshall",
  MK: "Macedonia de Nord",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "R.A.S. Macao a Chinei",
  MP: "Insulele Mariane de Nord",
  MQ: "Martinica",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldive",
  MW: "Malawi",
  MX: "Mexic",
  MY: "Malaysia",
  MZ: "Mozambic",
  NA: "Namibia",
  NC: "Noua Caledonie",
  NE: "Niger",
  NF: "Insula Norfolk",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Țările de Jos",
  NO: "Norvegia",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Noua Zeelandă",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Polinezia Franceză",
  PG: "Papua-Noua Guinee",
  PH: "Filipine",
  PK: "Pakistan",
  PL: "Polonia",
  PM: "Saint-Pierre și Miquelon",
  PN: "Insulele Pitcairn",
  PR: "Puerto Rico",
  PS: "Teritoriile Palestiniene",
  PT: "Portugalia",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "România",
  RS: "Serbia",
  RU: "Rusia",
  RW: "Rwanda",
  SA: "Arabia Saudită",
  SB: "Insulele Solomon",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Suedia",
  SG: "Singapore",
  SH: "Sfânta Elena",
  SI: "Slovenia",
  SJ: "Svalbard și Jan Mayen",
  SK: "Slovacia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "Sudanul de Sud",
  ST: "Sao Tomé și Príncipe",
  SV: "El Salvador",
  SX: "Sint-Maarten",
  SY: "Siria",
  SZ: "Eswatini",
  TC: "Insulele Turks și Caicos",
  TD: "Ciad",
  TF: "Teritoriile Australe și Antarctice Franceze",
  TG: "Togo",
  TH: "Thailanda",
  TJ: "Tadjikistan",
  TK: "Tokelau",
  TL: "Timorul de Est",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turcia",
  TT: "Trinidad și Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ucraina",
  UG: "Uganda",
  UM: "Insulele Îndepărtate ale S.U.A.",
  US: "Statele Unite ale Americii",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Statul Cetății Vaticanului",
  VC: "Saint Vincent și Grenadinele",
  VE: "Venezuela",
  VG: "Insulele Virgine Britanice",
  VI: "Insulele Virgine Americane",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis și Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Africa de Sud",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, $N = {
  locale: yg,
  countries: vg
}, WN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: vg,
  default: $N,
  locale: yg
}, Symbol.toStringTag, { value: "Module" })), bg = "ru", _g = {
  AU: "Австралия",
  AT: "Австрия",
  AZ: "Азербайджан",
  AX: "Аландские острова",
  AL: "Албания",
  DZ: "Алжир",
  VI: "Виргинские Острова (США)",
  AS: "Американское Самоа",
  AI: "Ангилья",
  AO: "Ангола",
  AD: "Андорра",
  AQ: "Антарктида",
  AG: "Антигуа и Барбуда",
  AR: "Аргентина",
  AM: "Армения",
  AW: "Аруба",
  AF: "Афганистан",
  BS: "Багамы",
  BD: "Бангладеш",
  BB: "Барбадос",
  BH: "Бахрейн",
  BZ: "Белиз",
  BY: "Беларусь",
  BE: "Бельгия",
  BJ: "Бенин",
  BM: "Бермуды",
  BG: "Болгария",
  BO: "Боливия",
  BQ: "Бонэйр, Синт-Эстатиус и Саба",
  BA: "Босния и Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилия",
  IO: "Британская территория в Индийском океане",
  VG: "Виргинские Острова (Великобритания)",
  BN: "Бруней",
  BF: "Буркина-Фасо",
  BI: "Бурунди",
  BT: "Бутан",
  VU: "Вануату",
  VA: "Ватикан",
  GB: "Великобритания",
  HU: "Венгрия",
  VE: "Венесуэла",
  UM: "Внешние малые острова (США)",
  TL: "Восточный Тимор",
  VN: "Вьетнам",
  GA: "Габон",
  HT: "Гаити",
  GY: "Гайана",
  GM: "Гамбия",
  GH: "Гана",
  GP: "Гваделупа",
  GT: "Гватемала",
  GF: "Гвиана",
  GN: "Гвинея",
  GW: "Гвинея-Бисау",
  DE: "Германия",
  GG: "Гернси",
  GI: "Гибралтар",
  HN: "Гондурас",
  HK: "Гонконг",
  GD: "Гренада",
  GL: "Гренландия",
  GR: "Греция",
  GE: "Грузия",
  GU: "Гуам",
  DK: "Дания",
  JE: "Джерси",
  DJ: "Джибути",
  DM: "Доминика",
  DO: "Доминиканская Республика",
  CD: "Демократическая Республика Конго",
  EG: "Египет",
  ZM: "Замбия",
  EH: "САДР",
  ZW: "Зимбабве",
  IL: "Израиль",
  IN: "Индия",
  ID: "Индонезия",
  JO: "Иордания",
  IQ: "Ирак",
  IR: "Иран",
  IE: "Ирландия",
  IS: "Исландия",
  ES: "Испания",
  IT: "Италия",
  YE: "Йемен",
  CV: "Кабо-Верде",
  KZ: "Казахстан",
  KY: "Острова Кайман",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  QA: "Катар",
  KE: "Кения",
  CY: "Кипр",
  KG: "Киргизия",
  KI: "Кирибати",
  TW: [
    "Тайвань",
    "Китайская Республика"
  ],
  KP: "КНДР (Корейская Народно-Демократическая Республика)",
  CN: "КНР (Китайская Народная Республика)",
  CC: "Кокосовые острова",
  CO: "Колумбия",
  KM: "Коморы",
  CR: "Коста-Рика",
  CI: "Кот-д’Ивуар",
  CU: "Куба",
  KW: "Кувейт",
  CW: "Кюрасао",
  LA: "Лаос",
  LV: "Латвия",
  LS: "Лесото",
  LR: "Либерия",
  LB: "Ливан",
  LY: "Ливия",
  LT: "Литва",
  LI: "Лихтенштейн",
  LU: "Люксембург",
  MU: "Маврикий",
  MR: "Мавритания",
  MG: "Мадагаскар",
  YT: "Майотта",
  MO: "Макао",
  MW: "Малави",
  MY: "Малайзия",
  ML: "Мали",
  MV: "Мальдивы",
  MT: "Мальта",
  MA: "Марокко",
  MQ: "Мартиника",
  MH: "Маршалловы Острова",
  MX: "Мексика",
  FM: "Микронезия",
  MZ: "Мозамбик",
  MD: "Молдавия",
  MC: "Монако",
  MN: "Монголия",
  MS: "Монтсеррат",
  MM: "Мьянма",
  NA: "Намибия",
  NR: "Науру",
  NP: "Непал",
  NE: "Нигер",
  NG: "Нигерия",
  NL: "Нидерланды",
  NI: "Никарагуа",
  NU: "Ниуэ",
  NZ: "Новая Зеландия",
  NC: "Новая Каледония",
  NO: "Норвегия",
  AE: "ОАЭ",
  OM: "Оман",
  BV: "Остров Буве",
  IM: "Остров Мэн",
  CK: "Острова Кука",
  NF: "Остров Норфолк",
  CX: "Остров Рождества",
  PN: "Острова Питкэрн",
  SH: "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
  PK: "Пакистан",
  PW: "Палау",
  PS: "Государство Палестина",
  PA: "Панама",
  PG: "Папуа — Новая Гвинея",
  PY: "Парагвай",
  PE: "Перу",
  PL: "Польша",
  PT: "Португалия",
  PR: "Пуэрто-Рико",
  CG: "Республика Конго",
  KR: "Республика Корея",
  RE: "Реюньон",
  RU: [
    "Российская Федерация",
    "Россия"
  ],
  RW: "Руанда",
  RO: "Румыния",
  SV: "Сальвадор",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе и Принсипи",
  SA: "Саудовская Аравия",
  SZ: "Эсватини",
  MK: "Северная Македония",
  MP: "Северные Марианские Острова",
  SC: "Сейшельские Острова",
  BL: "Сен-Бартелеми",
  MF: "Сен-Мартен",
  PM: "Сен-Пьер и Микелон",
  SN: "Сенегал",
  VC: "Сент-Винсент и Гренадины",
  KN: "Сент-Китс и Невис",
  LC: "Сент-Люсия",
  RS: "Сербия",
  SG: "Сингапур",
  SX: "Синт-Мартен",
  SY: "Сирия",
  SK: "Словакия",
  SI: "Словения",
  SB: "Соломоновы Острова",
  SO: "Сомали",
  SD: "Судан",
  SR: "Суринам",
  US: "США",
  SL: "Сьерра-Леоне",
  TJ: "Таджикистан",
  TH: "Таиланд",
  TZ: "Танзания",
  TC: "Теркс и Кайкос",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринидад и Тобаго",
  TV: "Тувалу",
  TN: "Тунис",
  TM: "Туркмения",
  TR: "Турция",
  UG: "Уганда",
  UZ: "Узбекистан",
  UA: "Украина",
  WF: "Уоллис и Футуна",
  UY: "Уругвай",
  FO: "Фареры",
  FJ: "Фиджи",
  PH: "Филиппины",
  FI: "Финляндия",
  FK: "Фолклендские острова",
  FR: "Франция",
  PF: "Французская Полинезия",
  TF: "Французские Южные и Антарктические Территории",
  HM: "Херд и Макдональд",
  HR: "Хорватия",
  CF: "ЦАР",
  TD: "Чад",
  ME: "Черногория",
  CZ: "Чехия",
  CL: "Чили",
  CH: "Швейцария",
  SE: "Швеция",
  SJ: "Шпицберген и Ян-Майен",
  LK: "Шри-Ланка",
  EC: "Эквадор",
  GQ: "Экваториальная Гвинея",
  ER: "Эритрея",
  EE: "Эстония",
  ET: "Эфиопия",
  ZA: "ЮАР",
  GS: "Южная Георгия и Южные Сандвичевы Острова",
  SS: "Южный Судан",
  JM: "Ямайка",
  JP: "Япония",
  XK: "Косово"
}, YN = {
  locale: bg,
  countries: _g
}, qN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: _g,
  default: YN,
  locale: bg
}, Symbol.toStringTag, { value: "Module" })), wg = "sk", xg = {
  AD: "Andorra",
  AE: "Spojené arabské emiráty",
  AF: "Afganistan",
  AG: "Antigua a Barbuda",
  AI: "Anguilla",
  AL: "Albánsko",
  AM: "Arménsko",
  AO: "Angola",
  AQ: "Antarktída",
  AR: "Argentína",
  AS: "Americká Samoa",
  AT: "Rakúsko",
  AU: "Austrália",
  AW: "Aruba",
  AX: "Alandy",
  AZ: "Azerbajdžan",
  BA: "Bosna a Hercegovina",
  BB: "Barbados",
  BD: "Bangladéš",
  BE: "Belgicko",
  BF: "Burkina Faso",
  BG: "Bulharsko",
  BH: "Bahrajn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Svätý Bartolomej",
  BM: "Bermudy",
  BN: "Brunej",
  BO: "Bolívia",
  BQ: "Karibské Holandsko",
  BR: "Brazília",
  BS: "Bahamy",
  BT: "Bhután",
  BV: "Bouvetov ostrov",
  BW: "Botswana",
  BY: "Bielorusko",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosové ostrovy",
  CD: "Konžská demokratická republika",
  CF: "Stredoafrická republika",
  CG: "Konžská republika",
  CH: "Švajčiarsko",
  CI: "Pobrežie Slonoviny",
  CK: "Cookove ostrovy",
  CL: "Čile",
  CM: "Kamerun",
  CN: "Čína",
  CO: "Kolumbia",
  CR: "Kostarika",
  CU: "Kuba",
  CV: "Kapverdy",
  CW: "Curaçao",
  CX: "Vianočný ostrov",
  CY: "Cyprus",
  CZ: "Česko",
  DE: "Nemecko",
  DJ: "Džibutsko",
  DK: "Dánsko",
  DM: "Dominika",
  DO: "Dominikánska republika",
  DZ: "Alžírsko",
  EC: "Ekvádor",
  EE: "Estónsko",
  EG: "Egypt",
  EH: "Západná Sahara",
  ER: "Eritrea",
  ES: "Španielsko",
  ET: "Etiópia",
  FI: "Fínsko",
  FJ: "Fidži",
  FK: "Falklandy",
  FM: "Mikronézia",
  FO: "Faerské ostrovy",
  FR: "Francúzsko",
  GA: "Gabon",
  GB: "Spojené kráľovstvo",
  GD: "Grenada",
  GE: "Gruzínsko",
  GF: "Francúzska Guayana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltár",
  GL: "Grónsko",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Rovníková Guinea",
  GR: "Grécko",
  GS: "Južná Georgia a Južné Sandwichove ostrovy",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guayana",
  HK: "Hongkong – OAO Číny",
  HM: "Heardov ostrov a Macdonaldove ostrovy",
  HN: "Honduras",
  HR: "Chorvátsko",
  HT: "Haiti",
  HU: "Maďarsko",
  ID: "Indonézia",
  IE: "Írsko",
  IL: "Izrael",
  IM: "Ostrov Man",
  IN: "India",
  IO: "Britské indickooceánske územie",
  IQ: "Irak",
  IR: "Irán",
  IS: "Island",
  IT: "Taliansko",
  JE: "Jersey",
  JM: "Jamajka",
  JO: "Jordánsko",
  JP: "Japonsko",
  KE: "Keňa",
  KG: "Kirgizsko",
  KH: "Kambodža",
  KI: "Kiribati",
  KM: "Komory",
  KN: "Svätý Krištof a Nevis",
  KP: "Severná Kórea",
  KR: "Južná Kórea",
  KW: "Kuvajt",
  KY: "Kajmanie ostrovy",
  KZ: "Kazachstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Svätá Lucia",
  LI: "Lichtenštajnsko",
  LK: "Srí Lanka",
  LR: "Libéria",
  LS: "Lesotho",
  LT: "Litva",
  LU: "Luxembursko",
  LV: "Lotyšsko",
  LY: "Líbya",
  MA: "Maroko",
  MC: "Monako",
  MD: "Moldavsko",
  ME: "Čierna Hora",
  MF: "Svätý Martin (fr.)",
  MG: "Madagaskar",
  MH: "Marshallove ostrovy",
  MK: "Severné Macedónsko",
  ML: "Mali",
  MM: "Mjanmarsko",
  MN: "Mongolsko",
  MO: "Macao – OAO Číny",
  MP: "Severné Mariány",
  MQ: "Martinik",
  MR: "Mauritánia",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Maurícius",
  MV: "Maldivy",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malajzia",
  MZ: "Mozambik",
  NA: "Namíbia",
  NC: "Nová Kaledónia",
  NE: "Niger",
  NF: "Norfolk",
  NG: "Nigéria",
  NI: "Nikaragua",
  NL: "Holandsko",
  NO: "Nórsko",
  NP: "Nepál",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nový Zéland",
  OM: "Omán",
  PA: "Panama",
  PE: "Peru",
  PF: "Francúzska Polynézia",
  PG: "Papua Nová Guinea",
  PH: "Filipíny",
  PK: "Pakistan",
  PL: "Poľsko",
  PM: "Saint Pierre a Miquelon",
  PN: "Pitcairnove ostrovy",
  PR: "Portoriko",
  PS: "Palestínske územia",
  PT: "Portugalsko",
  PW: "Palau",
  PY: "Paraguaj",
  QA: "Katar",
  RE: "Réunion",
  RO: "Rumunsko",
  RS: "Srbsko",
  RU: "Rusko",
  RW: "Rwanda",
  SA: "Saudská Arábia",
  SB: "Šalamúnove ostrovy",
  SC: "Seychely",
  SD: "Sudán",
  SE: "Švédsko",
  SG: "Singapur",
  SH: "Svätá Helena",
  SI: "Slovinsko",
  SJ: "Svalbard a Jan Mayen",
  SK: "Slovensko",
  SL: "Sierra Leone",
  SM: "San Maríno",
  SN: "Senegal",
  SO: "Somálsko",
  SR: "Surinam",
  SS: "Južný Sudán",
  ST: "Svätý Tomáš a Princov ostrov",
  SV: "Salvádor",
  SX: "Svätý Martin (hol.)",
  SY: "Sýria",
  SZ: "Svazijsko",
  TC: "Turks a Caicos",
  TD: "Čad",
  TF: "Francúzske južné a antarktické územia",
  TG: "Togo",
  TH: "Thajsko",
  TJ: "Tadžikistan",
  TK: "Tokelau",
  TL: "Východný Timor",
  TM: "Turkménsko",
  TN: "Tunisko",
  TO: "Tonga",
  TR: "Turecko",
  TT: "Trinidad a Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzánia",
  UA: "Ukrajina",
  UG: "Uganda",
  UM: "Menšie odľahlé ostrovy USA",
  US: "Spojené štáty",
  UY: "Uruguaj",
  UZ: "Uzbekistan",
  VA: "Vatikán",
  VC: "Svätý Vincent a Grenadíny",
  VE: "Venezuela",
  VG: "Britské Panenské ostrovy",
  VI: "Americké Panenské ostrovy",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis a Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Južná Afrika",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, JN = {
  locale: wg,
  countries: xg
}, XN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: xg,
  default: JN,
  locale: wg
}, Symbol.toStringTag, { value: "Module" })), Sg = "sl", kg = {
  AD: "Andora",
  AE: "Združeni arabski emirati",
  AF: "Afganistan",
  AG: "Antigva in Barbuda",
  AI: "Angvila",
  AL: "Albanija",
  AM: "Armenija",
  AO: "Angola",
  AQ: "Antarktika",
  AR: "Argentina",
  AS: "Ameriška Samoa",
  AT: "Avstrija",
  AU: "Avstralija",
  AW: "Aruba",
  AX: "Ålandski otoki",
  AZ: "Azerbajdžan",
  BA: "Bosna in Hercegovina",
  BB: "Barbados",
  BD: "Bangladeš",
  BE: "Belgija",
  BF: "Burkina Faso",
  BG: "Bolgarija",
  BH: "Bahrajn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermudi",
  BN: "Brunej",
  BO: "Bolivija",
  BQ: "Nizozemski Karibi",
  BR: "Brazilija",
  BS: "Bahami",
  BT: "Butan",
  BV: "Bouvetov otok",
  BW: "Bocvana",
  BY: "Belorusija",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosovi otoki",
  CD: "Demokratična republika Kongo",
  CF: "Centralnoafriška republika",
  CG: "Kongo - Brazzaville",
  CH: "Švica",
  CI: "Slonokoščena obala",
  CK: "Cookovi otoki",
  CL: "Čile",
  CM: "Kamerun",
  CN: "Kitajska",
  CO: "Kolumbija",
  CR: "Kostarika",
  CU: "Kuba",
  CV: "Zelenortski otoki",
  CW: "Curaçao",
  CX: "Božični otok",
  CY: "Ciper",
  CZ: "Češka",
  DE: "Nemčija",
  DJ: "Džibuti",
  DK: "Danska",
  DM: "Dominika",
  DO: "Dominikanska republika",
  DZ: "Alžirija",
  EC: "Ekvador",
  EE: "Estonija",
  EG: "Egipt",
  EH: "Zahodna Sahara",
  ER: "Eritreja",
  ES: "Španija",
  ET: "Etiopija",
  FI: "Finska",
  FJ: "Fidži",
  FK: "Falklandski otoki",
  FM: "Mikronezija",
  FO: "Ferski otoki",
  FR: "Francija",
  GA: "Gabon",
  GB: "Združeno kraljestvo",
  GD: "Grenada",
  GE: "Gruzija",
  GF: "Francoska Gvajana",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Gibraltar",
  GL: "Grenlandija",
  GM: "Gambija",
  GN: "Gvineja",
  GP: "Gvadalupe",
  GQ: "Ekvatorialna Gvineja",
  GR: "Grčija",
  GS: "Južna Georgia in Južni Sandwichevi otoki",
  GT: "Gvatemala",
  GU: "Guam",
  GW: "Gvineja Bissau",
  GY: "Gvajana",
  HK: "Hongkong",
  HM: "Heardov otok in McDonaldovi otoki",
  HN: "Honduras",
  HR: "Hrvaška",
  HT: "Haiti",
  HU: "Madžarska",
  ID: "Indonezija",
  IE: "Irska",
  IL: "Izrael",
  IM: "Otok Man",
  IN: "Indija",
  IO: "Britansko ozemlje v Indijskem oceanu",
  IQ: "Irak",
  IR: "Iran",
  IS: "Islandija",
  IT: "Italija",
  JE: "Jersey",
  JM: "Jamajka",
  JO: "Jordanija",
  JP: "Japonska",
  KE: "Kenija",
  KG: "Kirgizistan",
  KH: "Kambodža",
  KI: "Kiribati",
  KM: "Komori",
  KN: "Saint Kitts in Nevis",
  KP: "Severna Koreja",
  KR: "Južna Koreja",
  KW: "Kuvajt",
  KY: "Kajmanski otoki",
  KZ: "Kazahstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Saint Lucia",
  LI: "Lihtenštajn",
  LK: "Šrilanka",
  LR: "Liberija",
  LS: "Lesoto",
  LT: "Litva",
  LU: "Luksemburg",
  LV: "Latvija",
  LY: "Libija",
  MA: "Maroko",
  MC: "Monako",
  MD: "Moldavija",
  ME: "Črna gora",
  MF: "Saint Martin",
  MG: "Madagaskar",
  MH: "Marshallovi otoki",
  MK: "Severna Makedonija",
  ML: "Mali",
  MM: "Mjanmar (Burma)",
  MN: "Mongolija",
  MO: "Macao",
  MP: "Severni Marianski otoki",
  MQ: "Martinik",
  MR: "Mavretanija",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldivi",
  MW: "Malavi",
  MX: "Mehika",
  MY: "Malezija",
  MZ: "Mozambik",
  NA: "Namibija",
  NC: "Nova Kaledonija",
  NE: "Niger",
  NF: "Norfolški otok",
  NG: "Nigerija",
  NI: "Nikaragva",
  NL: "Nizozemska",
  NO: "Norveška",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nova Zelandija",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Francoska Polinezija",
  PG: "Papua Nova Gvineja",
  PH: "Filipini",
  PK: "Pakistan",
  PL: "Poljska",
  PM: "Saint Pierre in Miquelon",
  PN: "Pitcairn",
  PR: "Portoriko",
  PS: "Palestinsko ozemlje",
  PT: "Portugalska",
  PW: "Palau",
  PY: "Paragvaj",
  QA: "Katar",
  RE: "Reunion",
  RO: "Romunija",
  RS: "Srbija",
  RU: "Rusija",
  RW: "Ruanda",
  SA: "Saudova Arabija",
  SB: "Salomonovi otoki",
  SC: "Sejšeli",
  SD: "Sudan",
  SE: "Švedska",
  SG: "Singapur",
  SH: "Sveta Helena",
  SI: "Slovenija",
  SJ: "Svalbard in Jan Mayen",
  SK: "Slovaška",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalija",
  SR: "Surinam",
  SS: "Južni Sudan",
  ST: "Sao Tome in Principe",
  SV: "Salvador",
  SX: "Sint Maarten",
  SY: "Sirija",
  SZ: "Svazi",
  TC: "Otoki Turks in Caicos",
  TD: "Čad",
  TF: "Francosko južno ozemlje",
  TG: "Togo",
  TH: "Tajska",
  TJ: "Tadžikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunizija",
  TO: "Tonga",
  TR: "Turčija",
  TT: "Trinidad in Tobago",
  TV: "Tuvalu",
  TW: "Tajvan",
  TZ: "Tanzanija",
  UA: "Ukrajina",
  UG: "Uganda",
  UM: "Stranski zunanji otoki Združenih držav",
  US: "Združene države Amerike",
  UY: "Urugvaj",
  UZ: "Uzbekistan",
  VA: "Vatikan",
  VC: "Saint Vincent in Grenadine",
  VE: "Venezuela",
  VG: "Britanski Deviški otoki",
  VI: "Ameriški Deviški otoki",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis in Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Južnoafriška republika",
  ZM: "Zambija",
  ZW: "Zimbabve"
}, QN = {
  locale: Sg,
  countries: kg
}, ej = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: kg,
  default: QN,
  locale: Sg
}, Symbol.toStringTag, { value: "Module" })), Mg = "sq", Pg = {
  AF: "Afganistan",
  AL: "Shqipëri",
  DZ: "Algjeri",
  AS: "Samoa Amerikane",
  AD: "Andorrë",
  AO: "Angolë",
  AI: "Anguilë",
  AQ: "Antarktidë",
  AG: "Antigua & Barbuda",
  AR: "Argjentinë",
  AM: "Armeni",
  AW: "Arubë",
  AU: "Australi",
  AT: "Austri",
  AZ: "Azerbajxhan",
  BS: "Bahamas",
  BH: "Bahrein",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Bjellorusi",
  BE: "Belgjikë",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Butan",
  BO: "Bolivi",
  BA: "Bosnjë & Hercegovinë",
  BW: "Botsvanë",
  BV: "Ishulli Buve",
  BR: "Brazil",
  IO: "Territori Britanik i Oqeanit Indian",
  BN: "Brunej",
  BG: "Bullgari",
  BF: "Burkina Faso",
  BI: "Burund",
  KH: "Kamboxhia",
  CM: "Kamerun",
  CA: "Kanada",
  CV: "Kepi i Gjelbër",
  KY: "Ishujt Kajman",
  CF: "Republika Afrikano-Qendrore",
  TD: "Çad",
  CL: "Kili",
  CN: "Kinë",
  CX: "Ishulli i Krishtlindjes",
  CC: "Ishujt Kokos (Kiling)",
  CO: "Kolumbi",
  KM: "Komore",
  CG: "Kongo-Brazavil",
  CD: "Kongo-Kinshasa",
  CK: "Ishulli Kuk",
  CR: "Kosta Rikë",
  CI: "Bregu i Fildishtë",
  HR: "Kroaci",
  CU: "Kubë",
  CY: "Qipro",
  CZ: "Republika Çeke",
  DK: "Danimarkë",
  DJ: "Xhibut",
  DM: "Dominikë",
  DO: "Republika Dominikane",
  EC: "Ekuador",
  EG: "Egjipt",
  SV: "El Salvador",
  GQ: "Guineja Ekuatoriale",
  ER: "Eritre",
  EE: "Estoni",
  ET: "Etiopi",
  FK: "Ishujt Folkland",
  FO: "Ishujt Faroe",
  FJ: "Fixhi",
  FI: "Finlandë",
  FR: "Francë",
  GF: "Guajana Frënge",
  PF: "Polinezia Frënge",
  TF: "Territoret Frënge Jugore",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Gjeorgji",
  DE: "Gjermani",
  GH: "Gana",
  GI: "Gjibraltar",
  GR: "Greqi",
  GL: "Groenlandë",
  GD: "Grenadë",
  GP: "Guadalup",
  GU: "Guam",
  GT: "Guatemalë",
  GN: "Guine",
  GW: "Guinea-Bisau",
  GY: "Guajanë",
  HT: "Haiti",
  HM: "Ishujt Hërd & Mekdonald",
  VA: "Vatikan",
  HN: "Honduras",
  HK: "RVA i Hong Kongut Kinë",
  HU: "Hungari",
  IS: "Islandë",
  IN: "Indi",
  ID: "Indonezi",
  IR: "Iran",
  IQ: "Irak",
  IE: "Irlandë",
  IL: "Izrael",
  IT: "Itali",
  JM: "Xhamajkë",
  JP: "Japoni",
  JO: "Jordani",
  KZ: "Kazakistan",
  KE: "Kenia",
  KI: "Kiribati",
  KP: "Koreja e Veriut",
  KR: "Koreja e Jugut",
  KW: "Kuvajt",
  KG: "Kirgizstan",
  LA: "Laos",
  LV: "Letoni",
  LB: "Liban",
  LS: "Lesoto",
  LR: "Liberi",
  LY: "Libi",
  LI: "Lihtenshtein",
  LT: "Lituani",
  LU: "Luksemburg",
  MO: "RVA i Makaos Kinë",
  MG: "Madagaskar",
  MW: "Malavi",
  MY: "Malajzi",
  MV: "Maldive",
  ML: "Mali",
  MT: "Maltë",
  MH: "Ishujt Marshall",
  MQ: "Martinikë",
  MR: "Mauritani",
  MU: "Mauritius",
  YT: "Majote",
  MX: "Meksikë",
  FM: "Mikronezi",
  MD: "Moldavi",
  MC: "Monako",
  MN: "Mongoli",
  MS: "Montserat",
  MA: "Marok",
  MZ: "Mozambik",
  MM: "Mianmar (Burma)",
  NA: "Namibi",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Holandë",
  NC: "Kaledonia e Re",
  NZ: "Zelandë e Re",
  NI: "Nikaragua",
  NE: "Niger",
  NG: "Nigeri",
  NU: "Niue",
  NF: "Ishujt Norfolk",
  MK: "Maqedoni",
  MP: "Ishujt Veriorë Mariana",
  NO: "Norvegji",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Territoret Palestineze",
  PA: "Panama",
  PG: "Papua Guineja e Re",
  PY: "Paraguai",
  PE: "Peru",
  PH: "Filipine",
  PN: "Ishujt Pitkern",
  PL: "Poloni",
  PT: "Portugali",
  PR: "Porto Riko",
  QA: "Katar",
  RE: "Reunion",
  RO: "Rumani",
  RU: "Rusi",
  RW: "Ruandë",
  SH: "Shën Helena",
  KN: "Shën Kits e Nevis",
  LC: "Shën Luçia",
  PM: "Shën Pier dhe Mikëlon",
  VC: "Shën Vinsent & Grenadinet",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome & Prinsipe",
  SA: "Arabi Saudite",
  SN: "Senegal",
  SC: "Sejshelle",
  SL: "Sierra Leone",
  SG: "Singapor",
  SK: "Sllovaki",
  SI: "Slloveni",
  SB: "Ishujt Solomon",
  SO: "Somali",
  ZA: "Afrikë e Jugut",
  GS: "Xhorxha Jugore dhe Ishujt Sanduiç të Jugut",
  ES: "Spanjë",
  LK: "Sri Lankë",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard & Zhan Majen",
  SZ: "Svaziland",
  SE: "Suedi",
  CH: "Zvicër",
  SY: "Siri",
  TW: "Tajvan",
  TJ: "Taxhikistan",
  TZ: "Tanzani",
  TH: "Tajlandë",
  TL: "Timori Lindor",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad & Tobago",
  TN: "Tunizi",
  TR: "Turqi",
  TM: "Turkmenistan",
  TC: "Ishujt Turk & Kaikos",
  TV: "Tuvalu",
  UG: "Ugandë",
  UA: "Ukrainë",
  AE: "Emiratet e Bashkuara Arabe",
  GB: "Mbretëria e Bashkuar",
  US: "Shtetet e Bashkuara të Amerikës",
  UM: "Ishujt e Përtejmë SHBA-së",
  UY: "Uruguai",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuelë",
  VN: "Vietnam",
  VG: "Ishujt e Virgjër Britanikë",
  VI: "Ishujt e Virgjër Amerikanë",
  WF: "Uollis e Futuna",
  EH: "Sahara Perëndimore",
  YE: "Jemen",
  ZM: "Zambia",
  ZW: "Zimbabve",
  AX: "Ishujt Aland",
  BQ: "Karaibet Holandeze",
  CW: "Kurasao",
  GG: "Gërnsi",
  IM: "Ishulli i Robit",
  JE: "Xhërsi",
  ME: "Mali i Zi",
  BL: "Shën Bartolomeo",
  MF: "Shën Martin",
  RS: "Serbi",
  SX: "Shën Martin",
  SS: "Sudan i Jugut",
  XK: "Kosovë"
}, tj = {
  locale: Mg,
  countries: Pg
}, rj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Pg,
  default: tj,
  locale: Mg
}, Symbol.toStringTag, { value: "Module" })), Eg = "sr", Tg = {
  AD: "Андора",
  AE: "Уједињени Арапски Емирати",
  AF: "Авганистан",
  AG: "Антигва и Барбуда",
  AI: "Ангвила",
  AL: "Албанија",
  AM: "Јерменија",
  AO: "Ангола",
  AQ: "Антарктик",
  AR: "Аргентина",
  AS: "Америчка Самоа",
  AT: "Аустрија",
  AU: "Аустралија",
  AW: "Аруба",
  AX: "Оландска Острва",
  AZ: "Азербејџан",
  BA: "Босна и Херцеговина",
  BB: "Барбадос",
  BD: "Бангладеш",
  BE: "Белгија",
  BF: "Буркина Фасо",
  BG: "Бугарска",
  BH: "Бахреин",
  BI: "Бурунди",
  BJ: "Бенин",
  BL: "Сен Бартелеми",
  BM: "Бермуда",
  BN: "Брунеј",
  BO: "Боливија",
  BQ: "Карипска Холандија",
  BR: "Бразил",
  BS: "Бахами",
  BT: "Бутан",
  BV: "Острво Буве",
  BW: "Боцвана",
  BY: "Белорусија",
  BZ: "Белизе",
  CA: "Канада",
  CC: "Кокосова (Килингова) Острва",
  CD: "Конго - Киншаса",
  CF: "Централноафричка Република",
  CG: "Конго - Бразавил",
  CH: "Швајцарска",
  CI: "Обала Слоноваче",
  CK: "Кукова Острва",
  CL: "Чиле",
  CM: "Камерун",
  CN: "Кина",
  CO: "Колумбија",
  CR: "Костарика",
  CU: "Куба",
  CV: "Зеленортска Острва",
  CW: "Курасао",
  CX: "Божићно Острво",
  CY: "Кипар",
  CZ: "Чешка",
  DE: "Немачка",
  DJ: "Џибути",
  DK: "Данска",
  DM: "Доминика",
  DO: "Доминиканска Република",
  DZ: "Алжир",
  EC: "Еквадор",
  EE: "Естонија",
  EG: "Египат",
  EH: "Западна Сахара",
  ER: "Еритреја",
  ES: "Шпанија",
  ET: "Етиопија",
  FI: "Финска",
  FJ: "Фиџи",
  FK: "Фокландска Острва",
  FM: "Микронезија",
  FO: "Фарска Острва",
  FR: "Француска",
  GA: "Габон",
  GB: "Уједињено Краљевство",
  GD: "Гренада",
  GE: "Грузија",
  GF: "Француска Гвајана",
  GG: "Гернзи",
  GH: "Гана",
  GI: "Гибралтар",
  GL: "Гренланд",
  GM: "Гамбија",
  GN: "Гвинеја",
  GP: "Гваделуп",
  GQ: "Екваторијална Гвинеја",
  GR: "Грчка",
  GS: "Јужна Џорџија и Јужна Сендвичка Острва",
  GT: "Гватемала",
  GU: "Гуам",
  GW: "Гвинеја-Бисао",
  GY: "Гвајана",
  HK: "САР Хонгконг (Кина)",
  HM: "Острво Херд и Мекдоналдова острва",
  HN: "Хондурас",
  HR: "Хрватска",
  HT: "Хаити",
  HU: "Мађарска",
  ID: "Индонезија",
  IE: "Ирска",
  IL: "Израел",
  IM: "Острво Ман",
  IN: "Индија",
  IO: "Британска територија Индијског океана",
  IQ: "Ирак",
  IR: "Иран",
  IS: "Исланд",
  IT: "Италија",
  JE: "Џерзи",
  JM: "Јамајка",
  JO: "Јордан",
  JP: "Јапан",
  KE: "Кенија",
  KG: "Киргистан",
  KH: "Камбоџа",
  KI: "Кирибати",
  KM: "Коморска Острва",
  KN: "Сент Китс и Невис",
  KP: "Северна Кореја",
  KR: "Јужна Кореја",
  KW: "Кувајт",
  KY: "Кајманска Острва",
  KZ: "Казахстан",
  LA: "Лаос",
  LB: "Либан",
  LC: "Света Луција",
  LI: "Лихтенштајн",
  LK: "Шри Ланка",
  LR: "Либерија",
  LS: "Лесото",
  LT: "Литванија",
  LU: "Луксембург",
  LV: "Летонија",
  LY: "Либија",
  MA: "Мароко",
  MC: "Монако",
  MD: "Молдавија",
  ME: "Црна Гора",
  MF: "Свети Мартин (Француска)",
  MG: "Мадагаскар",
  MH: "Маршалска Острва",
  MK: "Северна Македонија",
  ML: "Мали",
  MM: "Мијанмар (Бурма)",
  MN: "Монголија",
  MO: "САР Макао (Кина)",
  MP: "Северна Маријанска Острва",
  MQ: "Мартиник",
  MR: "Мауританија",
  MS: "Монсерат",
  MT: "Малта",
  MU: "Маурицијус",
  MV: "Малдиви",
  MW: "Малави",
  MX: "Мексико",
  MY: "Малезија",
  MZ: "Мозамбик",
  NA: "Намибија",
  NC: "Нова Каледонија",
  NE: "Нигер",
  NF: "Острво Норфок",
  NG: "Нигерија",
  NI: "Никарагва",
  NL: "Холандија",
  NO: "Норвешка",
  NP: "Непал",
  NR: "Науру",
  NU: "Ниуе",
  NZ: "Нови Зеланд",
  OM: "Оман",
  PA: "Панама",
  PE: "Перу",
  PF: "Француска Полинезија",
  PG: "Папуа Нова Гвинеја",
  PH: "Филипини",
  PK: "Пакистан",
  PL: "Пољска",
  PM: "Сен Пјер и Микелон",
  PN: "Питкерн",
  PR: "Порторико",
  PS: "Палестинске територије",
  PT: "Португалија",
  PW: "Палау",
  PY: "Парагвај",
  QA: "Катар",
  RE: "Реинион",
  RO: "Румунија",
  RS: "Србија",
  RU: "Русија",
  RW: "Руанда",
  SA: "Саудијска Арабија",
  SB: "Соломонска Острва",
  SC: "Сејшели",
  SD: "Судан",
  SE: "Шведска",
  SG: "Сингапур",
  SH: "Света Јелена",
  SI: "Словенија",
  SJ: "Свалбард и Јан Мајен",
  SK: "Словачка",
  SL: "Сијера Леоне",
  SM: "Сан Марино",
  SN: "Сенегал",
  SO: "Сомалија",
  SR: "Суринам",
  SS: "Јужни Судан",
  ST: "Сао Томе и Принципе",
  SV: "Салвадор",
  SX: "Свети Мартин (Холандија)",
  SY: "Сирија",
  SZ: "Свазиленд",
  TC: "Острва Туркс и Каикос",
  TD: "Чад",
  TF: "Француске Јужне Територије",
  TG: "Того",
  TH: "Тајланд",
  TJ: "Таџикистан",
  TK: "Токелау",
  TL: "Источни Тимор",
  TM: "Туркменистан",
  TN: "Тунис",
  TO: "Тонга",
  TR: "Турска",
  TT: "Тринидад и Тобаго",
  TV: "Тувалу",
  TW: "Тајван",
  TZ: "Танзанија",
  UA: "Украјина",
  UG: "Уганда",
  UM: "Удаљена острва САД",
  US: "Сједињене Државе",
  UY: "Уругвај",
  UZ: "Узбекистан",
  VA: "Ватикан",
  VC: "Сент Винсент и Гренадини",
  VE: "Венецуела",
  VG: "Британска Девичанска Острва",
  VI: "Америчка Девичанска Острва",
  VN: "Вијетнам",
  VU: "Вануату",
  WF: "Валис и Футуна",
  WS: "Самоа",
  XK: "Косово",
  YE: "Јемен",
  YT: "Мајот",
  ZA: "Јужноафричка Република",
  ZM: "Замбија",
  ZW: "Зимбабве"
}, nj = {
  locale: Eg,
  countries: Tg
}, aj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Tg,
  default: nj,
  locale: Eg
}, Symbol.toStringTag, { value: "Module" })), Lg = "sv", Ag = {
  AD: "Andorra",
  AE: "Förenade Arabemiraten",
  AF: "Afghanistan",
  AG: "Antigua och Barbuda",
  AI: "Anguilla",
  AL: "Albanien",
  AM: "Armenien",
  AO: "Angola",
  AQ: "Antarktis",
  AR: "Argentina",
  AS: "Amerikanska Samoa",
  AT: "Österrike",
  AU: "Australien",
  AW: "Aruba",
  AX: "Åland",
  AZ: "Azerbajdzjan",
  BA: "Bosnien och Hercegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgien",
  BF: "Burkina Faso",
  BG: "Bulgarien",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint-Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Bonaire, Saint Eustatius och Saba",
  BR: "Brasilien",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvetön",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Kokosöarna",
  CD: "Demokratiska republiken Kongo",
  CF: "Centralafrikanska republiken",
  CG: "Kongo-Brazzaville",
  CH: "Schweiz",
  CI: "Elfenbenskusten",
  CK: "Cooköarna",
  CL: "Chile",
  CM: "Kamerun",
  CN: "Kina",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Kuba",
  CV: "Kap Verde",
  CW: "Curacao",
  CX: "Julön",
  CY: "Cypern",
  CZ: "Tjeckien",
  DE: "Tyskland",
  DJ: "Djibouti",
  DK: "Danmark",
  DM: "Dominica",
  DO: "Dominikanska republiken",
  DZ: "Algeriet",
  EC: "Ecuador",
  EE: "Estland",
  EG: "Egypten",
  EH: "Västsahara",
  ER: "Eritrea",
  ES: "Spanien",
  ET: "Etiopien",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falklandsöarna",
  FM: "Mikronesiska federationen",
  FO: "Färöarna",
  FR: "Frankrike",
  GA: "Gabon",
  GB: "Storbritannien",
  GD: "Grenada",
  GE: "Georgien",
  GF: "Franska Guyana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Grönland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Ekvatorialguinea",
  GR: "Grekland",
  GS: "Sydgeorgien och Sydsandwichöarna",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea Bissau",
  GY: "Guyana",
  HK: "Hongkong",
  HM: "Heard- och McDonaldsöarna",
  HN: "Honduras",
  HR: "Kroatien",
  HT: "Haiti",
  HU: "Ungern",
  ID: "Indonesien",
  IE: "Irland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "Indien",
  IO: "Brittiska territoriet i Indiska Oceanen",
  IQ: "Irak",
  IR: "Iran",
  IS: "Island",
  IT: "Italien",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordanien",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kirgizistan",
  KH: "Kambodja",
  KI: "Kiribati",
  KM: "Komorerna",
  KN: "Saint Kitts och Nevis",
  KP: "Nordkorea",
  KR: "Sydkorea",
  KW: "Kuwait",
  KY: "Caymanöarna",
  KZ: "Kazakstan",
  LA: "Laos",
  LB: "Libanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Litauen",
  LU: "Luxemburg",
  LV: "Lettland",
  LY: "Libyen",
  MA: "Marocko",
  MC: "Monaco",
  MD: "Moldavien",
  ME: "Montenegro",
  MF: "Saint Martin (franska delen)",
  MG: "Madagaskar",
  MH: "Marshallöarna",
  MK: "Nordmakedonien",
  ML: "Mali",
  MM: "Burma",
  MN: "Mongoliet",
  MO: "Macau",
  MP: "Nordmarianerna",
  MQ: "Martinique",
  MR: "Mauretanien",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldiverna",
  MW: "Malawi",
  MX: "Mexiko",
  MY: "Malaysia",
  MZ: "Moçambique",
  NA: "Namibia",
  NC: "Nya Kaledonien",
  NE: "Niger",
  NF: "Norfolkön",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Nederländerna",
  NO: "Norge",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Nya Zeeland",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "Franska Polynesien",
  PG: "Papua Nya Guinea",
  PH: "Filippinerna",
  PK: "Pakistan",
  PL: "Polen",
  PM: "Saint-Pierre och Miquelon",
  PN: "Pitcairnöarna",
  PR: "Puerto Rico",
  PS: "Palestinska territoriet, ockuperade",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Rumänien",
  RS: "Serbien",
  RU: "Ryssland",
  RW: "Rwanda",
  SA: "Saudiarabien",
  SB: "Salomonöarna",
  SC: "Seychellerna",
  SD: "Sudan",
  SE: "Sverige",
  SG: "Singapore",
  SH: "Sankta Helena",
  SI: "Slovenien",
  SJ: "Svalbard och Jan Mayen",
  SK: "Slovakien",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Surinam",
  SS: "Sydsudan",
  ST: "São Tomé och Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten (nederländska delen)",
  SY: "Syrien",
  SZ: "Eswatini",
  TC: "Turks- och Caicosöarna",
  TD: "Tchad",
  TF: "Franska södra territorierna",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tadzjikistan",
  TK: "Tokelauöarna",
  TL: "Östtimor",
  TM: "Turkmenistan",
  TN: "Tunisien",
  TO: "Tonga",
  TR: "Turkiet",
  TT: "Trinidad och Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraina",
  UG: "Uganda",
  UM: "USA:s yttre öar",
  US: "USA",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Vatikanstaten",
  VC: "Saint Vincent och Grenadinerna",
  VE: "Venezuela",
  VG: "Brittiska Jungfruöarna",
  VI: "Amerikanska Jungfruöarna",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis- och Futunaöarna",
  WS: "Samoa",
  YE: "Jemen",
  YT: "Mayotte",
  ZA: "Sydafrika",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo"
}, ij = {
  locale: Lg,
  countries: Ag
}, oj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ag,
  default: ij,
  locale: Lg
}, Symbol.toStringTag, { value: "Module" })), Og = "th", Ng = {
  BD: "บังกลาเทศ",
  BE: "เบลเยียม",
  BF: "บูร์กินาฟาโซ",
  BG: "บัลแกเรีย",
  BA: "บอสเนียและเฮอร์เซโกวีนา",
  BB: "บาร์เบโดส",
  WF: "วาลลิสและฟุตูนา",
  BL: "เซนต์บาร์เธเลมี",
  BM: "เบอร์มิวดา",
  BN: "บรูไน",
  BO: "โบลิเวีย",
  BH: "บาห์เรน",
  BI: "บุรุนดี",
  BJ: "เบนิน",
  BT: "ภูฏาน",
  JM: "จาเมกา",
  BV: "เกาะบูเวต",
  BW: "บอตสวานา",
  WS: "ซามัว",
  BR: "บราซิล",
  BS: "บาฮามาส",
  JE: "เจอร์ซีย์",
  BY: "เบลารุส",
  BZ: "เบลีซ",
  RU: "รัสเซีย",
  RW: "รวันดา",
  RS: "เซอร์เบีย",
  TL: "ติมอร์ตะวันออก",
  RE: "เรอูนียง",
  TM: "เติร์กเมนิสถาน",
  TJ: "ทาจิกิสถาน",
  RO: "โรมาเนีย",
  TK: "โตเกเลา",
  GW: "กินี-บิสเซา",
  GU: "กวม",
  GT: "กัวเตมาลา",
  GS: "เกาะเซาท์จอร์เจียและหมู่เกาะเซาท์แซนด์วิช",
  GR: "กรีซ",
  GQ: "อิเควทอเรียลกินี",
  GP: "กวาเดอลูป",
  JP: "ญี่ปุ่น",
  GY: "กายอานา",
  GG: "เกิร์นซีย์",
  GF: "เฟรนช์เกียนา",
  GE: "จอร์เจีย",
  GD: "เกรเนดา",
  GB: "สหราชอาณาจักร",
  GA: "กาบอง",
  SV: "เอลซัลวาดอร์",
  GN: "กินี",
  GM: "แกมเบีย",
  GL: "กรีนแลนด์",
  GI: "ยิบรอลตาร์",
  GH: "กานา",
  OM: "โอมาน",
  TN: "ตูนิเซีย",
  JO: "จอร์แดน",
  HR: "โครเอเชีย",
  HT: "เฮติ",
  HU: "ฮังการี",
  HK: "ฮ่องกง เขตปกครองพิเศษประเทศจีน",
  HN: "ฮอนดูรัส",
  HM: "เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์",
  VE: "เวเนซุเอลา",
  PR: "เปอร์โตริโก",
  PS: "ปาเลสไตน์",
  PW: "ปาเลา",
  PT: "โปรตุเกส",
  SJ: "สฟาลบาร์และยานไมเอน",
  PY: "ปารากวัย",
  IQ: "อิรัก",
  PA: "ปานามา",
  PF: "เฟรนช์โปลินีเซีย",
  PG: "ปาปัวนิวกินี",
  PE: "เปรู",
  PK: "ปากีสถาน",
  PH: "ฟิลิปปินส์",
  PN: "พิตแคร์น",
  PL: "โปแลนด์",
  PM: "แซงปีแยร์และมีเกอลง",
  ZM: "แซมเบีย",
  EH: "ซาฮาราตะวันตก",
  EE: "เอสโตเนีย",
  EG: "อียิปต์",
  ZA: "แอฟริกาใต้",
  EC: "เอกวาดอร์",
  IT: "อิตาลี",
  VN: "เวียดนาม",
  SB: "หมู่เกาะโซโลมอน",
  ET: "เอธิโอเปีย",
  SO: "โซมาเลีย",
  ZW: "ซิมบับเว",
  SA: "ซาอุดีอาระเบีย",
  ES: "สเปน",
  ER: "เอริเทรีย",
  ME: "มอนเตเนโกร",
  MD: "มอลโดวา",
  MG: "มาดากัสการ์",
  MF: "เซนต์มาติน",
  MA: "โมร็อกโก",
  MC: "โมนาโก",
  UZ: "อุซเบกิสถาน",
  MM: "เมียนม่าร์ [พม่า]",
  ML: "มาลี",
  MO: "มาเก๊า เขตปกครองพิเศษประเทศจีน",
  MN: "มองโกเลีย",
  MH: "หมู่เกาะมาร์แชลล์",
  MK: "มาซิโดเนีย",
  MU: "มอริเชียส",
  MT: "มอลตา",
  MW: "มาลาวี",
  MV: "มัลดีฟส์",
  MQ: "มาร์ตินีก",
  MP: "หมู่เกาะนอร์เทิร์นมาเรียนา",
  MS: "มอนต์เซอร์รัต",
  MR: "มอริเตเนีย",
  IM: "เกาะแมน",
  UG: "ยูกันดา",
  TZ: "แทนซาเนีย",
  MY: "มาเลเซีย",
  MX: "เม็กซิโก",
  IL: "อิสราเอล",
  FR: "ฝรั่งเศส",
  IO: "บริติชอินเดียนโอเชียนเทร์ริทอรี",
  SH: "เซนต์เฮเลนา",
  FI: "ฟินแลนด์",
  FJ: "ฟิจิ",
  FK: "หมู่เกาะฟอล์กแลนด์",
  FM: "ไมโครนีเซีย",
  FO: "หมู่เกาะแฟโร",
  NI: "นิการากัว",
  NL: "เนเธอร์แลนด์",
  NO: "นอร์เวย์",
  NA: "นามิเบีย",
  VU: "วานูอาตู",
  NC: "นิวแคลิโดเนีย",
  NE: "ไนเจอร์",
  NF: "เกาะนอร์ฟอล์ก",
  NG: "ไนจีเรีย",
  NZ: "นิวซีแลนด์",
  NP: "เนปาล",
  NR: "นาอูรู",
  NU: "นีอูเอ",
  CK: "หมู่เกาะคุก",
  CI: "ไอวอรี่โคสต์",
  CH: "สวิตเซอร์แลนด์",
  CO: "โคลอมเบีย",
  CN: "จีน",
  CM: "แคเมอรูน",
  CL: "ชิลี",
  CC: "หมู่เกาะโคโคส",
  CA: "แคนาดา",
  CG: "คองโก-บราซซาวิล",
  CF: "สาธารณรัฐแอฟริกากลาง",
  CD: "คองโก-กินชาซา",
  CZ: "สาธารณรัฐเช็ก",
  CY: "ไซปรัส",
  CX: "เกาะคริสต์มาส",
  CR: "คอสตาริกา",
  CV: "เคปเวิร์ด",
  CU: "คิวบา",
  SZ: "สวาซิแลนด์",
  SY: "ซีเรีย",
  KG: "คีร์กีซสถาน",
  KE: "เคนยา",
  SR: "ซูรินาเม",
  KI: "คิริบาส",
  KH: "กัมพูชา",
  KN: "เซนต์คิตส์และเนวิส",
  KM: "คอโมโรส",
  ST: "เซาตูเมและปรินซิปี",
  SK: "สโลวะเกีย",
  KR: "เกาหลีใต้",
  SI: "สโลวีเนีย",
  KP: "เกาหลีเหนือ",
  KW: "คูเวต",
  SN: "เซเนกัล",
  SM: "ซานมารีโน",
  SL: "เซียร์ราลีโอน",
  SC: "เซเชลส์",
  KZ: "คาซัคสถาน",
  KY: "หมู่เกาะเคย์แมน",
  SG: "สิงคโปร์",
  SE: "สวีเดน",
  SD: "ซูดาน",
  DO: "สาธารณรัฐโดมินิกัน",
  DM: "โดมินิกา",
  DJ: "จิบูตี",
  DK: "เดนมาร์ก",
  VG: "หมู่เกาะบริติชเวอร์จิน",
  DE: "เยอรมนี",
  YE: "เยเมน",
  DZ: "แอลจีเรีย",
  US: "สหรัฐอเมริกา",
  UY: "อุรุกวัย",
  YT: "มายอต",
  UM: "หมู่เกาะสหรัฐไมเนอร์เอาต์ไลอิง",
  LB: "เลบานอน",
  LC: "เซนต์ลูเซีย",
  LA: "ลาว",
  TV: "ตูวาลู",
  TW: "ไต้หวัน",
  TT: "ตรินิแดดและโตเบโก",
  TR: "ตุรกี",
  LK: "ศรีลังกา",
  LI: "ลิกเตนสไตน์",
  LV: "ลัตเวีย",
  TO: "ตองกา",
  LT: "ลิทัวเนีย",
  LU: "ลักเซมเบิร์ก",
  LR: "ไลบีเรีย",
  LS: "เลโซโท",
  TH: "ไทย",
  TF: "เฟรนช์เซาเทิร์นเทร์ริทอรีส์",
  TG: "โตโก",
  TD: "ชาด",
  TC: "หมู่เกาะเติกส์และหมู่เกาะเคคอส",
  LY: "ลิเบีย",
  VA: "วาติกัน",
  VC: "เซนต์วินเซนต์และเกรนาดีนส์",
  AE: "สหรัฐอาหรับเอมิเรตส์",
  AD: "อันดอร์รา",
  AG: "แอนติกาและบาร์บูดา",
  AF: "อัฟกานิสถาน",
  AI: "แองกวิลลา",
  VI: "หมู่เกาะยูเอสเวอร์จิน",
  IS: "ไอซ์แลนด์",
  IR: "อิหร่าน",
  AM: "อาร์เมเนีย",
  AL: "แอลเบเนีย",
  AO: "แองโกลา",
  AQ: "แอนตาร์กติกา",
  AS: "อเมริกันซามัว",
  AR: "อาร์เจนตินา",
  AU: "ออสเตรเลีย",
  AT: "ออสเตรีย",
  AW: "อารูบา",
  IN: "อินเดีย",
  AX: "หมู่เกาะโอลันด์",
  AZ: "อาเซอร์ไบจาน",
  IE: "ไอร์แลนด์",
  ID: "อินโดนีเซีย",
  UA: "ยูเครน",
  QA: "กาตาร์",
  MZ: "โมซัมบิก",
  BQ: "โบแนร์, ซินท์เอิสทาทิอุส, ซาบา",
  CW: "คูราเซา",
  SX: "Sint Maarten (ส่วนดัตช์)",
  SS: "ซูดานใต้",
  XK: "โคโซโว"
}, sj = {
  locale: Og,
  countries: Ng
}, lj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ng,
  default: sj,
  locale: Og
}, Symbol.toStringTag, { value: "Module" })), jg = "tr", Rg = {
  AD: "Andorra",
  AE: "Birleşik Arap Emirlikleri",
  AF: "Afganistan",
  AG: "Antigua ve Barbuda",
  AI: "Anguilla",
  AL: "Arnavutluk",
  AM: "Ermenistan",
  AO: "Angola",
  AQ: "Antarktika",
  AR: "Arjantin",
  AS: "Amerikan Samoası",
  AT: "Avusturya",
  AU: "Avustralya",
  AW: "Aruba",
  AX: "Åland Adaları",
  AZ: "Azerbaycan",
  BA: "Bosna Hersek",
  BB: "Barbados",
  BD: "Bangladeş",
  BE: "Belçika",
  BF: "Burkina Faso",
  BG: "Bulgaristan",
  BH: "Bahreyn",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthelemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivya",
  BQ: "Karayip Hollanda",
  BR: "Brezilya",
  BS: "Bahamalar",
  BT: "Butan",
  BV: "Bouvet Adası",
  BW: "Botsvana",
  BY: "Beyaz Rusya",
  BZ: "Belize",
  CA: "Kanada",
  CC: "Cocos (Keeling) Adaları",
  CD: "Kongo - Kinşasa",
  CF: "Orta Afrika Cumhuriyeti",
  CG: "Kongo - Brazavil",
  CH: "İsviçre",
  CI: "Fildişi Sahili",
  CK: "Cook Adaları",
  CL: "Şili",
  CM: "Kamerun",
  CN: "Çin",
  CO: "Kolombiya",
  CR: "Kosta Rika",
  CU: "Küba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Adası",
  CY: "Güney Kıbrıs Rum Kesimi",
  CZ: "Çek Cumhuriyeti",
  DE: "Almanya",
  DJ: "Cibuti",
  DK: "Danimarka",
  DM: "Dominika",
  DO: "Dominik Cumhuriyeti",
  DZ: "Cezayir",
  EC: "Ekvador",
  EE: "Estonya",
  EG: "Mısır",
  EH: "Batı Sahara",
  ER: "Eritre",
  ES: "İspanya",
  ET: "Etiyopya",
  FI: "Finlandiya",
  FJ: "Fiji",
  FK: "Falkland Adaları",
  FM: "Mikronezya",
  FO: "Faroe Adaları",
  FR: "Fransa",
  GA: "Gabon",
  GB: "Birleşik Krallık",
  GD: "Grenada",
  GE: "Gürcistan",
  GF: "Fransız Guyanası",
  GG: "Guernsey",
  GH: "Gana",
  GI: "Cebelitarık",
  GL: "Grönland",
  GM: "Gambiya",
  GN: "Gine",
  GP: "Guadalupe",
  GQ: "Ekvator Ginesi",
  GR: "Yunanistan",
  GS: "Güney Georgia ve Güney Sandwich Adaları",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Gine-Bissau",
  GY: "Guyana",
  HK: "Çin Hong Kong ÖYB",
  HM: "Heard Adası ve McDonald Adaları",
  HN: "Honduras",
  HR: "Hırvatistan",
  HT: "Haiti",
  HU: "Macaristan",
  ID: "Endonezya",
  IE: "İrlanda",
  IL: "İsrail",
  IM: "Man Adası",
  IN: "Hindistan",
  IO: "Britanya Hint Okyanusu Toprakları",
  IQ: "Irak",
  IR: "İran",
  IS: "İzlanda",
  IT: "İtalya",
  JE: "Jersey",
  JM: "Jamaika",
  JO: "Ürdün",
  JP: "Japonya",
  KE: "Kenya",
  KG: "Kırgızistan",
  KH: "Kamboçya",
  KI: "Kiribati",
  KM: "Komorlar",
  KN: "Saint Kitts ve Nevis",
  KP: "Kuzey Kore",
  KR: "Güney Kore",
  KW: "Kuveyt",
  KY: "Cayman Adaları",
  KZ: "Kazakistan",
  LA: "Laos",
  LB: "Lübnan",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberya",
  LS: "Lesoto",
  LT: "Litvanya",
  LU: "Lüksemburg",
  LV: "Letonya",
  LY: "Libya",
  MA: "Fas",
  MC: "Monako",
  MD: "Moldova",
  ME: "Karadağ",
  MF: "Saint Martin",
  MG: "Madagaskar",
  MH: "Marshall Adaları",
  MK: "Kuzey Makedonya",
  ML: "Mali",
  MM: "Myanmar (Burma)",
  MN: "Moğolistan",
  MO: "Çin Makao ÖYB",
  MP: "Kuzey Mariana Adaları",
  MQ: "Martinik",
  MR: "Moritanya",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldivler",
  MW: "Malavi",
  MX: "Meksika",
  MY: "Malezya",
  MZ: "Mozambik",
  NA: "Namibya",
  NC: "Yeni Kaledonya",
  NE: "Nijer",
  NF: "Norfolk Adası",
  NG: "Nijerya",
  NI: "Nikaragua",
  NL: "Hollanda",
  NO: "Norveç",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "Yeni Zelanda",
  OM: "Umman",
  PA: "Panama",
  PE: "Peru",
  PF: "Fransız Polinezyası",
  PG: "Papua Yeni Gine",
  PH: "Filipinler",
  PK: "Pakistan",
  PL: "Polonya",
  PM: "Saint Pierre ve Miquelon",
  PN: "Pitcairn Adaları",
  PR: "Porto Riko",
  PS: "Filistin Bölgeleri",
  PT: "Portekiz",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Katar",
  RE: "Réunion",
  RO: "Romanya",
  RS: "Sırbistan",
  RU: "Rusya",
  RW: "Ruanda",
  SA: "Suudi Arabistan",
  SB: "Solomon Adaları",
  SC: "Seyşeller",
  SD: "Sudan",
  SE: "İsveç",
  SG: "Singapur",
  SH: "Saint Helena",
  SI: "Slovenya",
  SJ: "Svalbard ve Jan Mayen Adaları",
  SK: "Slovakya",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somali",
  SR: "Surinam",
  SS: "Güney Sudan",
  ST: "São Tomé ve Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Suriye",
  SZ: "Svaziland",
  TC: "Turks ve Caicos Adaları",
  TD: "Çad",
  TF: "Fransız Güney Toprakları",
  TG: "Togo",
  TH: "Tayland",
  TJ: "Tacikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Türkmenistan",
  TN: "Tunus",
  TO: "Tonga",
  TR: "Türkiye",
  TT: "Trinidad ve Tobago",
  TV: "Tuvalu",
  TW: "Tayvan",
  TZ: "Tanzanya",
  UA: "Ukrayna",
  UG: "Uganda",
  UM: "ABD Uzak Adaları",
  US: [
    "ABD",
    "A.B.D.",
    "Amerika Birleşik Devletleri",
    "Birleşik Devletler",
    "Amerika"
  ],
  UY: "Uruguay",
  UZ: "Özbekistan",
  VA: "Vatikan",
  VC: "Saint Vincent ve Grenadinler",
  VE: "Venezuela",
  VG: "Britanya Virjin Adaları",
  VI: "ABD Virjin Adaları",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis ve Futuna Adaları",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "Güney Afrika",
  ZM: "Zambiya",
  ZW: "Zimbabve",
  XK: "Kosova"
}, cj = {
  locale: jg,
  countries: Rg
}, uj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Rg,
  default: cj,
  locale: jg
}, Symbol.toStringTag, { value: "Module" })), Dg = "uk", Ig = {
  AU: "Австралія",
  AT: "Австрія",
  AZ: "Азербайджан",
  AX: "Аландські Острови",
  AL: "Албанія",
  DZ: "Алжир",
  AS: "Американське Самоа",
  AI: "Ангілья",
  AO: "Ангола",
  AD: "Андорра",
  AQ: "Антарктика",
  AG: "Антигуа і Барбуда",
  MO: "Макао",
  AR: "Аргентина",
  AM: "Вірменія",
  AW: "Аруба",
  AF: "Афганістан",
  BS: "Багамські Острови",
  BD: "Бангладеш",
  BB: "Барбадос",
  BH: "Бахрейн",
  BZ: "Беліз",
  BE: "Бельгія",
  BJ: "Бенін",
  BM: "Бермудські Острови",
  BY: "Білорусь",
  BG: "Болгарія",
  BO: "Болівія",
  BA: "Боснія і Герцеговина",
  BW: "Ботсвана",
  BR: "Бразилія",
  IO: "Британська Територія в Індійському Океані",
  VG: "Британські Віргінські Острови",
  BN: "Бруней-Даруссалам",
  BF: "Буркіна-Фасо",
  BI: "Бурунді",
  BT: "Бутан",
  VU: "Вануату",
  VA: "Ватикан",
  GB: "Великобританія",
  VE: "Венесуела",
  VI: "Віргінські Острови (США)",
  WF: "Волліс і Футуна",
  VN: "В'єтнам",
  UM: "Зовнішні Віддалені Острови (США)",
  GA: "Габон",
  HT: "Гаїті",
  GY: "Гаяна",
  GM: "Гамбія",
  GH: "Гана",
  GP: "Гваделупа",
  GT: "Гватемала",
  GF: "Гвіана",
  GN: "Гвінея",
  GW: "Гвінея-Бісау",
  GG: "Гернсі",
  GI: "Гібралтар",
  HN: "Гондурас",
  HK: "Гонконг",
  GD: "Гренада",
  GR: "Греція",
  GE: "Грузія",
  GU: "Гуам",
  GL: "Гренландія",
  DK: "Данія",
  JE: "Джерсі",
  DJ: "Джибуті",
  DM: "Домініка",
  DO: "Домініканська Республіка",
  CD: "Демократична Республіка Конго",
  EC: "Еквадор",
  GQ: "Екваторіальна Гвінея",
  ER: "Еритрея",
  EE: "Естонія",
  ET: "Ефіопія",
  EG: "Єгипет",
  YE: "Ємен",
  ZM: "Замбія",
  ZW: "Зімбабве",
  IL: "Ізраїль",
  IN: "Індія",
  ID: "Індонезія",
  IQ: "Ірак",
  IR: "Іран",
  IE: "Ірландія",
  IS: "Ісландія",
  ES: "Іспанія",
  IT: "Італія",
  JO: "Йорданія",
  CV: "Кабо-Верде",
  KZ: "Казахстан",
  KY: "Кайманові Острови",
  KH: "Камбоджа",
  CM: "Камерун",
  CA: "Канада",
  BQ: "Карибські Нідерланди",
  QA: "Катар",
  KE: "Кенія",
  CY: "Кіпр",
  KI: "Кірибаті",
  KG: "Киргизстан",
  TW: "Тайвань, Провінція Китаю",
  KP: "Корейська Народно-Демократична Республіка",
  CN: "Китай",
  CC: "Кокосові Острови",
  CO: "Колумбія",
  KM: "Комори",
  XK: "Косово",
  CR: "Коста-Рика",
  CI: "Кот-Д'Івуар",
  CU: "Куба",
  KW: "Кувейт",
  CW: "Кюрасао",
  LA: "Лаос",
  LV: "Латвія",
  LS: "Лесото",
  LR: "Ліберія",
  LB: "Ліван",
  LY: "Лівія",
  LT: "Литва",
  LI: "Ліхтенштейн",
  LU: "Люксембург",
  MU: "Маврикій",
  MR: "Мавританія",
  MG: "Мадагаскар",
  YT: "Майотта",
  MW: "Малаві",
  MY: "Малайзія",
  ML: "Малі",
  MV: "Мальдіви",
  MT: "Мальта",
  MA: "Марокко",
  MQ: "Мартиніка",
  MH: "Маршаллові Острови",
  MX: "Мексика",
  FM: "Мікронезія",
  MZ: "Мозамбік",
  MD: "Молдова",
  MC: "Монако",
  MN: "Монголія",
  MS: "Монтсеррат",
  MM: "М'янма",
  NA: "Намібія",
  NR: "Науру",
  NP: "Непал",
  NE: "Нігер",
  NG: "Нігерія",
  NL: "Нідерланди",
  NI: "Нікарагуа",
  DE: "Німеччина",
  NU: "Ніуе",
  NZ: "Нова Зеландія",
  NC: "Нова Каледонія",
  NO: "Норвегія",
  AE: "Об'єднані Арабські Емірати",
  OM: "Оман",
  BV: "Острів Буве",
  HM: "Острів Герд і Острови Макдоналд",
  IM: "Острів Мен",
  NF: "Острів Норфолк",
  CX: "Острів Різдва",
  CK: "Острови Кука",
  SH: "Острів Святої Єлени",
  TC: "Острови Теркс і Кайкос",
  PK: "Пакистан",
  PW: "Палау",
  PS: "Палестина",
  PA: "Панама",
  PG: "Папуа-Нова Гвінея",
  ZA: "Південна Африка",
  PY: "Парагвай",
  PE: "Перу",
  GS: "Південна Джорджія та Південні Сандвічеві Острови",
  KR: "Республіка Корея",
  SS: "Південний Судан",
  MK: "Північна Македонія",
  MP: "Північні Маріанські Острови",
  PN: "Піткерн",
  PL: "Польща",
  PT: "Португалія",
  PR: "Пуерто-Рико",
  CG: "Конго",
  RE: "Реюньйон",
  RU: "Росія",
  RW: "Руанда",
  RO: "Румунія",
  EH: "Західна Сахара",
  SV: "Сальвадор",
  WS: "Самоа",
  SM: "Сан-Марино",
  ST: "Сан-Томе і Принсіпі",
  SA: "Саудівська Аравія",
  SZ: "Есватіні",
  SJ: "Острови Шпіцберген та Ян-Маєн",
  SC: "Сейшельські Острови",
  BL: "Сен-Бартелемі",
  MF: "Сен-Мартен",
  PM: "Сен-П'єр і Мікелон",
  SN: "Сенегал",
  VC: "Сент-Вінсент і Гренадіни",
  KN: "Сент-Кітс і Невіс",
  LC: "Сент-Люсія",
  RS: "Сербія",
  SG: "Сингапур",
  SX: "Сінт-Мартен",
  SY: "Сирія",
  SK: "Словаччина",
  SI: "Словенія",
  SB: "Соломонові Острови",
  SO: "Сомалі",
  SD: "Судан",
  SR: "Суринам",
  TL: "Тимор-Лешті",
  US: "США",
  SL: "Сьєрра-Леоне",
  TJ: "Таджикистан",
  TH: "Таїланд",
  TZ: "Танзанія",
  TG: "Того",
  TK: "Токелау",
  TO: "Тонга",
  TT: "Тринідад і Тобаго",
  TV: "Тувалу",
  TN: "Туніс",
  TM: "Туркменистан",
  TR: "Туреччина",
  UG: "Уганда",
  HU: "Угорщина",
  UZ: "Узбекистан",
  UA: "Україна",
  UY: "Уругвай",
  FO: "Фарерські Острови",
  FJ: "Фіджі",
  PH: "Філіппіни",
  FI: "Фінляндія",
  FK: "Фолклендські Острови",
  FR: "Франція",
  PF: "Французька Полінезія",
  TF: "Французькі Південні і Антарктичні Території",
  HR: "Хорватія",
  CF: "Центральноафриканська Республіка",
  TD: "Чад",
  ME: "Чорногорія",
  CZ: "Чехія",
  CL: "Чилі",
  CH: "Швейцарія",
  SE: "Швеція",
  LK: "Шри-Ланка",
  JM: "Ямайка",
  JP: "Японія"
}, dj = {
  locale: Dg,
  countries: Ig
}, pj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Ig,
  default: dj,
  locale: Dg
}, Symbol.toStringTag, { value: "Module" })), Hg = "zh", Fg = {
  AD: "安道尔",
  AE: "阿联酋",
  AF: "阿富汗",
  AG: "安提瓜和巴布达",
  AI: "安圭拉",
  AL: "阿尔巴尼亚",
  AM: "亚美尼亚",
  AO: "安哥拉",
  AQ: "南极洲",
  AR: "阿根廷",
  AS: "美属萨摩亚",
  AT: "奥地利",
  AU: "澳大利亚",
  AW: "阿鲁巴",
  AX: "奥兰",
  AZ: "阿塞拜疆",
  BA: "波黑",
  BB: "巴巴多斯",
  BD: "孟加拉国",
  BE: "比利时",
  BF: "布基纳法索",
  BG: "保加利亚",
  BH: "巴林",
  BI: "布隆迪",
  BJ: "贝宁",
  BL: "圣巴泰勒米",
  BM: "百慕大",
  BN: "文莱",
  BO: "玻利维亚",
  BQ: "荷兰加勒比区",
  BR: "巴西",
  BS: "巴哈马",
  BT: "不丹",
  BV: "布韦岛",
  BW: "博茨瓦纳",
  BY: "白俄罗斯",
  BZ: "伯利兹",
  CA: "加拿大",
  CC: "科科斯（基林）群岛",
  CD: "刚果（金）",
  CF: "中非",
  CG: "刚果（布）",
  CH: "瑞士",
  CI: "科特迪瓦",
  CK: "库克群岛",
  CL: "智利",
  CM: "喀麦隆",
  CN: "中国",
  CO: "哥伦比亚",
  CR: "哥斯达黎加",
  CU: "古巴",
  CV: "佛得角",
  CW: "库拉索",
  CX: "圣诞岛",
  CY: "塞浦路斯",
  CZ: "捷克",
  DE: "德国",
  DJ: "吉布提",
  DK: "丹麦",
  DM: "多米尼克",
  DO: "多米尼加",
  DZ: "阿尔及利亚",
  EC: "厄瓜多尔",
  EE: "爱沙尼亚",
  EG: "埃及",
  EH: "阿拉伯撒哈拉民主共和国",
  ER: "厄立特里亚",
  ES: "西班牙",
  ET: "埃塞俄比亚",
  FI: "芬兰",
  FJ: "斐济",
  FK: "福克兰群岛",
  FM: "密克罗尼西亚联邦",
  FO: "法罗群岛",
  FR: "法国",
  GA: "加蓬",
  GB: "英国",
  GD: "格林纳达",
  GE: "格鲁吉亚",
  GF: "法属圭亚那",
  GG: "根西",
  GH: "加纳",
  GI: "直布罗陀",
  GL: "格陵兰",
  GM: "冈比亚",
  GN: "几内亚",
  GP: "瓜德罗普",
  GQ: "赤道几内亚",
  GR: "希腊",
  GS: "南乔治亚和南桑威奇群岛",
  GT: "危地马拉",
  GU: "关岛",
  GW: "几内亚比绍",
  GY: "圭亚那",
  HK: "香港",
  HM: "赫德岛和麦克唐纳群岛",
  HN: "洪都拉斯",
  HR: "克罗地亚",
  HT: "海地",
  HU: "匈牙利",
  ID: "印尼",
  IE: "爱尔兰",
  IL: "以色列",
  IM: "马恩岛",
  IN: "印度",
  IO: "英属印度洋领地",
  IQ: "伊拉克",
  IR: "伊朗",
  IS: "冰岛",
  IT: "意大利",
  JE: "泽西",
  JM: "牙买加",
  JO: "约旦",
  JP: "日本",
  KE: "肯尼亚",
  KG: "吉尔吉斯斯坦",
  KH: "柬埔寨",
  KI: "基里巴斯",
  KM: "科摩罗",
  KN: "圣基茨和尼维斯",
  KP: "朝鲜",
  KR: "韩国",
  KW: "科威特",
  KY: "开曼群岛",
  KZ: "哈萨克斯坦",
  LA: "老挝",
  LB: "黎巴嫩",
  LC: "圣卢西亚",
  LI: "列支敦士登",
  LK: "斯里兰卡",
  LR: "利比里亚",
  LS: "莱索托",
  LT: "立陶宛",
  LU: "卢森堡",
  LV: "拉脱维亚",
  LY: "利比亚",
  MA: "摩洛哥",
  MC: "摩纳哥",
  MD: "摩尔多瓦",
  ME: "黑山",
  MF: "法属圣马丁",
  MG: "马达加斯加",
  MH: "马绍尔群岛",
  MK: "北马其顿",
  ML: "马里",
  MM: "缅甸",
  MN: "蒙古",
  MO: "澳门",
  MP: "北马里亚纳群岛",
  MQ: "马提尼克",
  MR: "毛里塔尼亚",
  MS: "蒙特塞拉特",
  MT: "马耳他",
  MU: "毛里求斯",
  MV: "马尔代夫",
  MW: "马拉维",
  MX: "墨西哥",
  MY: "马来西亚",
  MZ: "莫桑比克",
  NA: "纳米比亚",
  NC: "新喀里多尼亚",
  NE: "尼日尔",
  NF: "诺福克岛",
  NG: "尼日利亚",
  NI: "尼加拉瓜",
  NL: "荷兰",
  NO: "挪威",
  NP: "尼泊尔",
  NR: "瑙鲁",
  NU: "纽埃",
  NZ: "新西兰",
  OM: "阿曼",
  PA: "巴拿马",
  PE: "秘鲁",
  PF: "法属波利尼西亚",
  PG: "巴布亚新几内亚",
  PH: "菲律宾",
  PK: "巴基斯坦",
  PL: "波兰",
  PM: "圣皮埃尔和密克隆",
  PN: "皮特凯恩群岛",
  PR: "波多黎各",
  PS: "巴勒斯坦",
  PT: "葡萄牙",
  PW: "帕劳",
  PY: "巴拉圭",
  QA: "卡塔尔",
  RE: "留尼汪",
  RO: "罗马尼亚",
  RS: "塞尔维亚",
  RU: "俄罗斯",
  RW: "卢旺达",
  SA: "沙特阿拉伯",
  SB: "所罗门群岛",
  SC: "塞舌尔",
  SD: "苏丹",
  SE: "瑞典",
  SG: "新加坡",
  SH: "圣赫勒拿、阿森松和特里斯坦-达库尼亚",
  SI: "斯洛文尼亚",
  SJ: "斯瓦尔巴和扬马延",
  SK: "斯洛伐克",
  SL: "塞拉利昂",
  SM: "圣马力诺",
  SN: "塞内加尔",
  SO: "索马里",
  SR: "苏里南",
  SS: "南苏丹",
  ST: "圣多美和普林西比",
  SV: "萨尔瓦多",
  SX: "荷属圣马丁",
  SY: "叙利亚",
  SZ: "斯威士兰",
  TC: "特克斯和凯科斯群岛",
  TD: "乍得",
  TF: "法属南部领地",
  TG: "多哥",
  TH: "泰国",
  TJ: "塔吉克斯坦",
  TK: "托克劳",
  TL: "东帝汶",
  TM: "土库曼斯坦",
  TN: "突尼斯",
  TO: "汤加",
  TR: "土耳其",
  TT: "特立尼达和多巴哥",
  TV: "图瓦卢",
  TW: "中国台湾省",
  TZ: "坦桑尼亚",
  UA: "乌克兰",
  UG: "乌干达",
  UM: "美国本土外小岛屿",
  US: "美国",
  UY: "乌拉圭",
  UZ: "乌兹别克斯坦",
  VA: "梵蒂冈",
  VC: "圣文森特和格林纳丁斯",
  VE: "委内瑞拉",
  VG: "英属维尔京群岛",
  VI: "美属维尔京群岛",
  VN: "越南",
  VU: "瓦努阿图",
  WF: "瓦利斯和富图纳",
  WS: "萨摩亚",
  XK: "科索沃",
  YE: "也门",
  YT: "马约特",
  ZA: "南非",
  ZM: "赞比亚",
  ZW: "津巴布韦"
}, hj = {
  locale: Hg,
  countries: Fg
}, mj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countries: Fg,
  default: hj,
  locale: Hg
}, Symbol.toStringTag, { value: "Module" })), fj = {
  ar: mN,
  cs: CN,
  da: yN,
  de: bN,
  el: wN,
  en: SN,
  es: MN,
  fr: EN,
  hi: LN,
  hu: ON,
  id: jN,
  it: DN,
  ja: HN,
  nl: VN,
  no: zN,
  pl: UN,
  pt: KN,
  ro: WN,
  ru: qN,
  sk: XN,
  sl: ej,
  sq: rj,
  sr: aj,
  sv: oj,
  th: lj,
  tr: uj,
  uk: pj,
  zh: mj
};
Object.values(fj).forEach((e) => {
  R0.registerLocale(e.default);
});
const Cj = (e, t) => {
  const n = C9(t);
  switch (e) {
    case u3.Taiwan:
      return R0.getName(e, n, { select: "alias" });
    default:
      return R0.getName(e, n, { select: "official" });
  }
}, gj = (e = Ct.ENGLISH) => Object.values(u3).map((t) => ({
  id: t,
  caption: Cj(t, e) ?? ""
}));
var Ut = /* @__PURE__ */ ((e) => (e.Email = "email", e.FirstName = "first_name", e.Surname = "surname", e.Country = "country", e.City = "city", e.Neighborhood = "neighborhood", e.StreetAddress = "street_address", e.StreetNumber = "street_number", e.Postcode = "postcode", e.PhoneNumber = "phone_number", e.CompanyName = "company_name", e.TaxNumber = "tax_number", e.State = "state", e))(Ut || {});
const yj = {
  [Ut.Email]: "public_pages_purchase.contact_slug.email",
  [Ut.FirstName]: "public_pages_purchase.contact_slug.first_name",
  [Ut.Surname]: "public_pages_purchase.contact_slug.last_name",
  [Ut.PhoneNumber]: "public_pages_purchase.contact_slug.phone_number",
  [Ut.Country]: "public_pages_purchase.contact_slug.country",
  [Ut.Neighborhood]: "public_pages_purchase.contact_slug.neighborhood",
  [Ut.StreetAddress]: "public_pages_purchase.contact_slug.street_address",
  [Ut.StreetNumber]: "public_pages_purchase.contact_slug.street_number",
  [Ut.City]: "public_pages_purchase.contact_slug.city",
  [Ut.Postcode]: "public_pages_purchase.contact_slug.postal_code",
  [Ut.CompanyName]: "public_pages_purchase.contact_slug.company_name",
  [Ut.TaxNumber]: "public_pages_purchase.contact_slug.tax_number",
  [Ut.State]: "public_pages_purchase.contact_slug.state_province"
}, D0 = (e) => Xe.t(yj[e]), vj = (e) => {
  const { slug: t, fieldName: n } = e;
  return Object.values(Ut).includes(t) ? D0(t) : n;
};
var p1 = /* @__PURE__ */ ((e) => (e.ARGENTINE_PESO = "ars", e.AUSTRALIAN_DOLLAR = "aud", e.BULGARIAN_LEV = "bgn", e.BRAZILIAN_REAL = "brl", e.CANADIAN_DOLLAR = "cad", e.CENTRAL_AFRICAN_FRANC = "xaf", e.CHILEAN_PESO = "clp", e.CHINESE_YUAN = "cny", e.COLOMBIAN_PESO = "cop", e.CZECH_CROWN = "czk", e.DANISH_KRONE = "dkk", e.EGYPTIAN_POUND = "egp", e.EURO = "eur", e.GHANAIAN_CEDI = "ghs", e.GUINEAN_FRANC = "gnf", e.HONG_KONG_DOLLAR = "hkd", e.HUNGARIAN_FORINT = "huf", e.ICELANDIC_KRONA = "isk", e.INDIAN_RUPEE = "inr", e.INDONESIAN_RUPIAH = "idr", e.ISRAELI_NEW_SHEKEL = "ils", e.JAPANESE_YEN = "jpy", e.KENYAN_SHILLING = "kes", e.MALAWIAN_KWACHA = "mwk", e.MALAYSIAN_RINGGIT = "myr", e.MEXICAN_PESO = "mxn", e.MOROCCAN_DIRHAM = "mad", e.NEW_ZEALAND_DOLLAR = "nzd", e.NIGERIAN_NAIRA = "ngn", e.NORWEGIAN_KRONE = "nok", e.PHILIPPINE_PESO = "php", e.POLISH_ZLOTY = "pln", e.POUND_STERLING = "gbp", e.ROMANIA_LEI = "ron", e.RUSSIAN_RUBLE = "rub", e.RWANDAN_FRANC = "rwf", e.SAO_TOME_AND_PRINCIPE_DOBRA = "std", e.SAUDI_RIYAL = "sar", e.SIERRA_LEONEAN_LEONE = "sll", e.SINGAPORE_DOLLAR = "sgd", e.SOUTH_AFRICAN_RAND = "zar", e.SRI_LANKAN_RUPEE = "lkr", e.SWEDISH_KRONA = "sek", e.SWISS_FRANC = "chf", e.TANZANIAN_SHILLING = "tzs", e.THAI_BAHT = "thb", e.TURKISH_LIRA = "try", e.UGANDAN_SHILLING = "ugx", e.US_DOLLAR = "usd", e.UNITED_ARAB_EMIRATES_DIRHAM = "aed", e.WEST_AFRICAN_CFA_FRANC_BCEAO = "xof", e.ZAMBIAN_KWACHA = "zmw", e.SERBIAN_DINAR = "rsd", e.UKRAINIAN_HRYVNIA = "uah", e.ALBANIAN_LEK = "all", e.VIETNAM_DONG = "vnd", e.PERUVIAN_SOL = "pen", e))(p1 || {});
let bj = { data: "" }, _j = (e) => {
  if (typeof window == "object") {
    let t = (e ? e.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), { innerHTML: " ", id: "_goober" });
    return t.nonce = window.__nonce__, t.parentNode || (e || document.head).appendChild(t), t.firstChild;
  }
  return e || bj;
}, wj = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, xj = /\/\*[^]*?\*\/|  +/g, Ou = /\n+/g, Da = (e, t) => {
  let n = "", r = "", a = "";
  for (let i in e) {
    let o = e[i];
    i[0] == "@" ? i[1] == "i" ? n = i + " " + o + ";" : r += i[1] == "f" ? Da(o, i) : i + "{" + Da(o, i[1] == "k" ? "" : t) + "}" : typeof o == "object" ? r += Da(o, t ? t.replace(/([^,])+/g, (s) => i.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (l) => /&/.test(l) ? l.replace(/&/g, s) : s ? s + " " + l : l)) : i) : o != null && (i = /^--/.test(i) ? i : i.replace(/[A-Z]/g, "-$&").toLowerCase(), a += Da.p ? Da.p(i, o) : i + ":" + o + ";");
  }
  return n + (t && a ? t + "{" + a + "}" : a) + r;
}, aa = {}, Vg = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let n in e)
      t += n + Vg(e[n]);
    return t;
  }
  return e;
}, Sj = (e, t, n, r, a) => {
  let i = Vg(e), o = aa[i] || (aa[i] = ((l) => {
    let c = 0, u = 11;
    for (; c < l.length; )
      u = 101 * u + l.charCodeAt(c++) >>> 0;
    return "go" + u;
  })(i));
  if (!aa[o]) {
    let l = i !== e ? e : ((c) => {
      let u, d, p = [{}];
      for (; u = wj.exec(c.replace(xj, "")); )
        u[4] ? p.shift() : u[3] ? (d = u[3].replace(Ou, " ").trim(), p.unshift(p[0][d] = p[0][d] || {})) : p[0][u[1]] = u[2].replace(Ou, " ").trim();
      return p[0];
    })(e);
    aa[o] = Da(a ? { ["@keyframes " + o]: l } : l, n ? "" : "." + o);
  }
  let s = n && aa.g ? aa.g : null;
  return n && (aa.g = aa[o]), ((l, c, u, d) => {
    d ? c.data = c.data.replace(d, l) : c.data.indexOf(l) === -1 && (c.data = u ? l + c.data : c.data + l);
  })(aa[o], t, r, s), o;
}, kj = (e, t, n) => e.reduce((r, a, i) => {
  let o = t[i];
  if (o && o.call) {
    let s = o(n), l = s && s.props && s.props.className || /^go/.test(s) && s;
    o = l ? "." + l : s && typeof s == "object" ? s.props ? "" : Da(s, "") : s === !1 ? "" : s;
  }
  return r + a + (o ?? "");
}, "");
function l8(e) {
  let t = this || {}, n = e.call ? e(t.p) : e;
  return Sj(n.unshift ? n.raw ? kj(n, [].slice.call(arguments, 1), t.p) : n.reduce((r, a) => Object.assign(r, a && a.call ? a(t.p) : a), {}) : n, _j(t.target), t.g, t.o, t.k);
}
let Bg, I0, H0;
l8.bind({ g: 1 });
let ma = l8.bind({ k: 1 });
function Mj(e, t, n, r) {
  Da.p = t, Bg = e, I0 = n, H0 = r;
}
function Ja(e, t) {
  let n = this || {};
  return function() {
    let r = arguments;
    function a(i, o) {
      let s = Object.assign({}, i), l = s.className || a.className;
      n.p = Object.assign({ theme: I0 && I0() }, s), n.o = / *go\d+/.test(l), s.className = l8.apply(n, r) + (l ? " " + l : "");
      let c = e;
      return e[0] && (c = s.as || e, delete s.as), H0 && c[0] && H0(s), Bg(c, s);
    }
    return a;
  };
}
var Pj = (e) => typeof e == "function", F0 = (e, t) => Pj(e) ? e(t) : e, Ej = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), Tj = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), Lj = 20, zg = (e, t) => {
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, Lj) };
    case 1:
      return { ...e, toasts: e.toasts.map((i) => i.id === t.toast.id ? { ...i, ...t.toast } : i) };
    case 2:
      let { toast: n } = t;
      return zg(e, { type: e.toasts.find((i) => i.id === n.id) ? 1 : 0, toast: n });
    case 3:
      let { toastId: r } = t;
      return { ...e, toasts: e.toasts.map((i) => i.id === r || r === void 0 ? { ...i, dismissed: !0, visible: !1 } : i) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((i) => i.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let a = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((i) => ({ ...i, pauseDuration: i.pauseDuration + a })) };
  }
}, Aj = [], p7 = { toasts: [], pausedAt: void 0 }, p3 = (e) => {
  p7 = zg(p7, e), Aj.forEach((t) => {
    t(p7);
  });
}, Oj = (e, t = "blank", n) => ({ createdAt: Date.now(), visible: !0, dismissed: !1, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...n, id: (n == null ? void 0 : n.id) || Ej() }), g9 = (e) => (t, n) => {
  let r = Oj(t, e, n);
  return p3({ type: 2, toast: r }), r.id;
}, Kt = (e, t) => g9("blank")(e, t);
Kt.error = g9("error");
Kt.success = g9("success");
Kt.loading = g9("loading");
Kt.custom = g9("custom");
Kt.dismiss = (e) => {
  p3({ type: 3, toastId: e });
};
Kt.remove = (e) => p3({ type: 4, toastId: e });
Kt.promise = (e, t, n) => {
  let r = Kt.loading(t.loading, { ...n, ...n == null ? void 0 : n.loading });
  return typeof e == "function" && (e = e()), e.then((a) => {
    let i = t.success ? F0(t.success, a) : void 0;
    return i ? Kt.success(i, { id: r, ...n, ...n == null ? void 0 : n.success }) : Kt.dismiss(r), a;
  }).catch((a) => {
    let i = t.error ? F0(t.error, a) : void 0;
    i ? Kt.error(i, { id: r, ...n, ...n == null ? void 0 : n.error }) : Kt.dismiss(r);
  }), e;
};
var Nj = ma`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, jj = ma`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, Rj = ma`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, Dj = Ja("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${Nj} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${jj} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${Rj} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, Ij = ma`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, Hj = Ja("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${Ij} 1s linear infinite;
`, Fj = ma`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, Vj = ma`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, Bj = Ja("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${Fj} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${Vj} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, zj = Ja("div")`
  position: absolute;
`, Gj = Ja("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, Uj = ma`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, Zj = Ja("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${Uj} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, Kj = ({ toast: e }) => {
  let { icon: t, type: n, iconTheme: r } = e;
  return t !== void 0 ? typeof t == "string" ? pe.createElement(Zj, null, t) : t : n === "blank" ? null : pe.createElement(Gj, null, pe.createElement(Hj, { ...r }), n !== "loading" && pe.createElement(zj, null, n === "error" ? pe.createElement(Dj, { ...r }) : pe.createElement(Bj, { ...r })));
}, $j = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, Wj = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, Yj = "0%{opacity:0;} 100%{opacity:1;}", qj = "0%{opacity:1;} 100%{opacity:0;}", Jj = Ja("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, Xj = Ja("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, Qj = (e, t) => {
  let n = e.includes("top") ? 1 : -1, [r, a] = Tj() ? [Yj, qj] : [$j(n), Wj(n)];
  return { animation: t ? `${ma(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${ma(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
};
pe.memo(({ toast: e, position: t, style: n, children: r }) => {
  let a = e.height ? Qj(e.position || t || "top-center", e.visible) : { opacity: 0 }, i = pe.createElement(Kj, { toast: e }), o = pe.createElement(Xj, { ...e.ariaProps }, F0(e.message, e));
  return pe.createElement(Jj, { className: e.className, style: { ...a, ...n, ...e.style } }, typeof r == "function" ? r({ icon: i, message: o }) : pe.createElement(pe.Fragment, null, i, o));
});
Mj(pe.createElement);
l8`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`;
var h3 = {}, Gg = {}, m3 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.instanceOfHashable = e.guessType = e.guessObjectType = e.TYPE_MAP = void 0, e.TYPE_MAP = {
    Array: "array",
    Int8Array: "typedarray",
    Uint8Array: "typedarray",
    Uint8ClampedArray: "typedarray",
    Int16Array: "typedarray",
    Uint16Array: "typedarray",
    Int32Array: "typedarray",
    Uint32Array: "typedarray",
    Float32Array: "typedarray",
    Float64Array: "typedarray",
    BigUint64Array: "typedarray",
    BigInt64Array: "typedarray",
    Buffer: "typedarray",
    Map: "map",
    Set: "set",
    Date: "date",
    String: "string",
    Number: "number",
    BigInt: "bigint",
    Boolean: "boolean",
    Object: "object"
  };
  const t = (a) => {
    var i;
    if (a === null)
      return "null";
    if ((0, e.instanceOfHashable)(a))
      return "hashable";
    const o = ((i = a == null ? void 0 : a.constructor) == null ? void 0 : i.name) ?? "unknown";
    return e.TYPE_MAP[o] || "unknown";
  };
  e.guessObjectType = t;
  const n = (a) => {
    const i = typeof a;
    return i !== "object" ? i : (0, e.guessObjectType)(a);
  };
  e.guessType = n;
  const r = (a) => typeof a.toHashableString == "function";
  e.instanceOfHashable = r;
})(m3);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e._mapSort = e._map = e._objectSort = e._object = e._setCoerce = e._set = e._setSort = e._setSortCoerce = e._typedArray = e._typedArraySort = e._array = e._arraySort = e._date = e._dateCoerce = e._functionTrim = e._functionTrimCoerce = e._function = e._functionCoerce = e._null = e._nullCoerce = e._undefined = e._undefinedCoerce = e._symbol = e._symbolCoerce = e._boolean = e._booleanCoerce = e._bigInt = e._bigIntCoerce = e._number = e._numberCoerce = e._stringTrim = e._stringTrimCoerce = e._string = e._stringCoerce = e._hashable = e.PREFIX = void 0;
  const t = m3;
  e.PREFIX = {
    string: "<:s>",
    number: "<:n>",
    bigint: "<:bi>",
    boolean: "<:b>",
    symbol: "<:smbl>",
    undefined: "<:undf>",
    null: "<:null>",
    function: "<:func>",
    array: "",
    date: "<:date>",
    set: "<:set>",
    map: "<:map>"
  };
  function n(T) {
    return T.toHashableString();
  }
  e._hashable = n;
  function r(T) {
    return T;
  }
  e._stringCoerce = r;
  function a(T) {
    return e.PREFIX.string + ":" + T;
  }
  e._string = a;
  function i(T) {
    return T.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._stringTrimCoerce = i;
  function o(T) {
    return e.PREFIX.string + ":" + T.replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._stringTrim = o;
  function s(T) {
    return T.toString();
  }
  e._numberCoerce = s;
  function l(T) {
    return `${e.PREFIX.number}:${T}`;
  }
  e._number = l;
  function c(T) {
    return T.toString();
  }
  e._bigIntCoerce = c;
  function u(T) {
    return `${e.PREFIX.bigint}:${T.toString()}`;
  }
  e._bigInt = u;
  function d(T) {
    return T ? "1" : "0";
  }
  e._booleanCoerce = d;
  function p(T) {
    return e.PREFIX.boolean + ":" + T.toString();
  }
  e._boolean = p;
  function h() {
    return e.PREFIX.symbol;
  }
  e._symbolCoerce = h;
  function m(T) {
    return e.PREFIX.symbol + ":" + T.toString();
  }
  e._symbol = m;
  function f() {
    return "";
  }
  e._undefinedCoerce = f;
  function C() {
    return e.PREFIX.undefined;
  }
  e._undefined = C;
  function _() {
    return "";
  }
  e._nullCoerce = _;
  function v() {
    return e.PREFIX.null;
  }
  e._null = v;
  function w(T) {
    return T.name + "=>" + T.toString();
  }
  e._functionCoerce = w;
  function k(T) {
    return e.PREFIX.function + ":" + T.name + "=>" + T.toString();
  }
  e._function = k;
  function b(T) {
    return T.name + "=>" + T.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._functionTrimCoerce = b;
  function S(T) {
    return e.PREFIX.function + ":" + T.name + "=>" + T.toString().replace(/(\s+|\t|\r\n|\n|\r)/gm, " ").trim();
  }
  e._functionTrim = S;
  function P(T) {
    return T.toISOString();
  }
  e._dateCoerce = P;
  function O(T) {
    return e.PREFIX.date + ":" + T.toISOString();
  }
  e._date = O;
  function A(T) {
    const F = this;
    return "[" + T.map((N) => F[(0, t.guessType)(N)](N)).sort().toString() + "]";
  }
  e._arraySort = A;
  function L(T) {
    const F = this;
    return "[" + T.map((N) => F[(0, t.guessType)(N)](N)).toString() + "]";
  }
  e._array = L;
  function I(T) {
    const F = this;
    return "[" + Array.prototype.slice.call(T).map((N) => F[(0, t.guessType)(N)](N)).sort().toString() + "]";
  }
  e._typedArraySort = I;
  function D(T) {
    const F = this;
    return "[" + Array.prototype.slice.call(T).map((N) => F[(0, t.guessType)(N)](N)).toString() + "]";
  }
  e._typedArray = D;
  function U(T) {
    return A.call(this, Array.from(T));
  }
  e._setSortCoerce = U;
  function z(T) {
    return `${e.PREFIX.set}:${A.call(this, Array.from(T))}`;
  }
  e._setSort = z;
  function $(T) {
    return `${e.PREFIX.set}:${L.call(this, Array.from(T))}`;
  }
  e._set = $;
  function ee(T) {
    return L.call(this, Array.from(T));
  }
  e._setCoerce = ee;
  function Z(T) {
    const F = this, N = Object.keys(T), Y = [];
    for (const Q of N) {
      const V = T[Q], re = (0, t.guessType)(V);
      Y.push(Q + ":" + F[re](V));
    }
    return "{" + Y.toString() + "}";
  }
  e._object = Z;
  function G(T) {
    const F = this, N = Object.keys(T).sort(), Y = [];
    for (const Q of N) {
      const V = T[Q], re = (0, t.guessType)(V);
      Y.push(Q + ":" + F[re](V));
    }
    return "{" + Y.toString() + "}";
  }
  e._objectSort = G;
  function W(T) {
    const F = this, N = Array.from(T), Y = [];
    for (const Q of N) {
      const [V, re] = Q;
      Y.push([F[(0, t.guessType)(V)](V), F[(0, t.guessType)(re)](re)]);
    }
    return "[" + Y.join(";") + "]";
  }
  e._map = W;
  function j(T) {
    const F = this, N = Array.from(T), Y = [];
    for (const Q of N) {
      const [V, re] = Q;
      Y.push([F[(0, t.guessType)(V)](V), F[(0, t.guessType)(re)](re)]);
    }
    return "[" + Y.sort().join(";") + "]";
  }
  e._mapSort = j;
})(Gg);
var eR = Ri && Ri.__createBinding || (Object.create ? function(e, t, n, r) {
  r === void 0 && (r = n);
  var a = Object.getOwnPropertyDescriptor(t, n);
  (!a || ("get" in a ? !t.__esModule : a.writable || a.configurable)) && (a = { enumerable: !0, get: function() {
    return t[n];
  } }), Object.defineProperty(e, r, a);
} : function(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}), tR = Ri && Ri.__setModuleDefault || (Object.create ? function(e, t) {
  Object.defineProperty(e, "default", { enumerable: !0, value: t });
} : function(e, t) {
  e.default = t;
}), rR = Ri && Ri.__importStar || function(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      n !== "default" && Object.prototype.hasOwnProperty.call(e, n) && eR(t, e, n);
  return tR(t, e), t;
};
Object.defineProperty(h3, "__esModule", { value: !0 });
var V0 = h3.objectSorter = void 0;
const wt = rR(Gg), nR = m3, aR = (e) => {
  const { sort: t, coerce: n, trim: r } = {
    sort: !0,
    coerce: !0,
    trim: !1,
    ...e
  }, a = {
    array: typeof t == "boolean" ? t : (t == null ? void 0 : t.array) ?? !1,
    typedArray: typeof t == "boolean" ? !1 : (t == null ? void 0 : t.typedArray) ?? !1,
    object: typeof t == "boolean" ? t : (t == null ? void 0 : t.object) ?? !1,
    set: typeof t == "boolean" ? t : (t == null ? void 0 : t.set) ?? !1,
    map: typeof t == "boolean" ? t : (t == null ? void 0 : t.map) ?? !1
  }, i = {
    boolean: typeof n == "boolean" ? n : (n == null ? void 0 : n.boolean) ?? !1,
    number: typeof n == "boolean" ? n : (n == null ? void 0 : n.number) ?? !1,
    bigint: typeof n == "boolean" ? n : (n == null ? void 0 : n.bigint) ?? !1,
    string: typeof n == "boolean" ? n : (n == null ? void 0 : n.string) ?? !1,
    undefined: typeof n == "boolean" ? n : (n == null ? void 0 : n.undefined) ?? !1,
    null: typeof n == "boolean" ? n : (n == null ? void 0 : n.null) ?? !1,
    symbol: typeof n == "boolean" ? n : (n == null ? void 0 : n.symbol) ?? !1,
    function: typeof n == "boolean" ? n : (n == null ? void 0 : n.function) ?? !1,
    date: typeof n == "boolean" ? n : (n == null ? void 0 : n.date) ?? !1,
    set: typeof n == "boolean" ? n : (n == null ? void 0 : n.set) ?? !1
  }, o = {
    string: typeof r == "boolean" ? r : (r == null ? void 0 : r.string) ?? !1,
    function: typeof r == "boolean" ? r : (r == null ? void 0 : r.function) ?? !1
  }, s = {
    // eslint-disable-next-line @typescript-eslint/ban-types
    unknown: function(c) {
      var u;
      const d = ((u = c.constructor) == null ? void 0 : u.name) ?? "unknonw";
      let p = "unknown";
      return typeof c.toString == "function" ? p = c.toString() : Object.keys(c).length > 0 && (p = JSON.stringify(c)), `<:${d}>:${p}`;
    }
  };
  s.hashable = wt._hashable.bind(s), o.string ? s.string = i.string ? wt._stringTrimCoerce.bind(s) : wt._stringTrim.bind(s) : s.string = i.string ? wt._stringCoerce.bind(s) : wt._string.bind(s), s.number = i.number ? wt._numberCoerce.bind(s) : wt._number.bind(s), s.bigint = i.bigint ? wt._bigIntCoerce.bind(s) : wt._bigInt.bind(s), s.boolean = i.boolean ? wt._booleanCoerce.bind(s) : wt._boolean.bind(s), s.symbol = i.symbol ? wt._symbolCoerce.bind(s) : wt._symbol.bind(s), s.undefined = i.undefined ? wt._undefinedCoerce.bind(s) : wt._undefined.bind(s), s.null = i.null ? wt._nullCoerce.bind(s) : wt._null.bind(s), o.function ? s.function = i.function ? wt._functionTrimCoerce.bind(s) : wt._functionTrim.bind(s) : s.function = i.function ? wt._functionCoerce.bind(s) : wt._function.bind(s), s.date = i.date ? wt._dateCoerce.bind(s) : wt._date.bind(s), s.array = a.array ? wt._arraySort.bind(s) : wt._array.bind(s), s.typedarray = a.typedArray ? wt._typedArraySort.bind(s) : wt._typedArray.bind(s), a.set ? s.set = i.set ? wt._setSortCoerce.bind(s) : wt._setSort.bind(s) : s.set = i.set ? wt._setCoerce.bind(s) : wt._set.bind(s), s.object = a.object ? wt._objectSort.bind(s) : wt._object.bind(s), s.map = a.map ? wt._mapSort.bind(s) : wt._map.bind(s);
  function l(c) {
    return s[(0, nR.guessType)(c)](c);
  }
  return l;
};
V0 = h3.objectSorter = aR;
const iR = Kt.error, oR = Kt.success, sR = Kt.loading, lR = Kt.custom, c8 = (e) => {
  const t = {
    id: "mock-id",
    type: "blank",
    message: e,
    visible: !0,
    ariaProps: { role: "status", "aria-live": "polite" },
    pauseDuration: 0,
    createdAt: 0,
    dismissed: !1
  };
  let n;
  return typeof e == "string" ? n = e : typeof e == "function" ? n = JSON.stringify(V0()(e(t))) : typeof e == "object" && (n = JSON.stringify(V0()(e))), n;
};
Kt.error = (e, t) => iR(e, {
  id: c8(e),
  ...t
});
Kt.success = (e, t) => oR(e, {
  id: c8(e),
  ...t
});
Kt.loading = (e, t) => sR(e, {
  id: c8(e),
  ...t
});
Kt.custom = (e, t) => lR(e, {
  id: c8(e),
  ...t
});
const yt = (e) => Number(e), h1 = (e) => e / 100, Nu = (e) => {
  switch (e) {
    case Ct.ARABIC:
      return /* @__PURE__ */ y.jsx(YL, {});
    case Ct.ENGLISH:
      return /* @__PURE__ */ y.jsx(uu, {});
    case Ct.FRENCH:
      return /* @__PURE__ */ y.jsx(rA, {});
    case Ct.RUSSIAN:
      return /* @__PURE__ */ y.jsx(qL, {});
    case Ct.CHINESE:
      return /* @__PURE__ */ y.jsx(pA, {});
    case Ct.DEUTSCH:
      return /* @__PURE__ */ y.jsx(XL, {});
    case Ct.SPANISH:
      return /* @__PURE__ */ y.jsx(tA, {});
    case Ct.ITALIAN:
      return /* @__PURE__ */ y.jsx(eA, {});
    case Ct.POLISH:
      return /* @__PURE__ */ y.jsx(iA, {});
    case Ct.PORTUGUESE:
      return /* @__PURE__ */ y.jsx(QL, {});
    case Ct.SWEDISH:
      return /* @__PURE__ */ y.jsx(hA, {});
    case Ct.CZECH:
      return /* @__PURE__ */ y.jsx(uA, {});
    case Ct.UKRAINIAN:
      return /* @__PURE__ */ y.jsx(fA, {});
    case Ct.JAPANESE:
      return /* @__PURE__ */ y.jsx(nA, {});
    case Ct.DANISH:
      return /* @__PURE__ */ y.jsx(sA, {});
    case Ct.DUTCH:
      return /* @__PURE__ */ y.jsx(JL, {});
    case Ct.HINDI:
      return /* @__PURE__ */ y.jsx(vA, {});
    case Ct.INDONESIAN:
      return /* @__PURE__ */ y.jsx(oA, {});
    case Ct.NORWEGIAN:
      return /* @__PURE__ */ y.jsx(yA, {});
    case Ct.THAI:
      return /* @__PURE__ */ y.jsx(gA, {});
    case Ct.SERBIAN:
      return /* @__PURE__ */ y.jsx(aA, {});
    case Ct.SLOVAK:
      return /* @__PURE__ */ y.jsx(lA, {});
    case Ct.HUNGARIAN:
      return /* @__PURE__ */ y.jsx(cA, {});
    case Ct.ROMANIAN:
      return /* @__PURE__ */ y.jsx(dA, {});
    case Ct.ALBANIA:
      return /* @__PURE__ */ y.jsx(mA, {});
    case Ct.SLOVENIAN:
      return /* @__PURE__ */ y.jsx(CA, {});
    case Ct.GREEK:
      return /* @__PURE__ */ y.jsx(bA, {});
    case Ct.TURKISH:
      return /* @__PURE__ */ y.jsx(_A, {});
    default:
      return /* @__PURE__ */ y.jsx(uu, {});
  }
}, cR = "group group min-h-[42px] relative rounded-lg py-2.5 font-medium text-sm main-transition-colors focus-ring whitespace-nowrap [&>*]:font-medium [&>*]:font-inter font-inter cursor-pointer", uR = "flex items-center justify-center gap-2", Ug = (e) => "href" in e, dR = ({
  as: e = "a",
  href: t,
  isFetching: n,
  className: r,
  children: a,
  buttonTextClassName: i,
  ...o
}) => o["aria-disabled"] || n ? /* @__PURE__ */ y.jsx("button", { className: r, disabled: !!o["aria-disabled"], children: /* @__PURE__ */ y.jsx(B0, { buttonTextClassName: i, isFetching: n, children: a }) }) : /* @__PURE__ */ y.jsx(e, { className: r, href: t, ...o, children: /* @__PURE__ */ y.jsx(B0, { buttonTextClassName: i, isFetching: n, children: a }) }), B0 = ({
  children: e,
  isFetching: t,
  buttonTextClassName: n
}) => /* @__PURE__ */ y.jsx(
  "div",
  {
    className: Fe(
      "flex items-center justify-center gap-2 truncate",
      t && "opacity-0",
      n
    ),
    children: e
  }
), Zg = ({
  width: e = "small",
  isFetching: t,
  backgroundColor: n,
  color: r,
  hoverColor: a,
  hoverBackgroundColor: i,
  borderColor: o,
  hoverBorderColor: s,
  loaderType: l,
  testAttributePostfix: c,
  className: u,
  buttonTextClassName: d,
  loaderClassName: p,
  as: h,
  ...m
}) => {
  const f = m, C = Fe(
    F6(
      cR,
      uR,
      n,
      r,
      a,
      i,
      e === "small" ? "px-4" : "px-10",
      o && `border ${o}`,
      s,
      t && "pointer-events-none select-none"
    ),
    u
  ), _ = Fe(
    F6("absolute", t ? "visible" : "invisible", "-translate-x-1/2 left-1/2"),
    p
  );
  if (Ug(f)) {
    const { "aria-disabled": v, ...w } = f;
    return /* @__PURE__ */ y.jsx(
      dR,
      {
        as: h,
        isFetching: t,
        "aria-disabled": v || t,
        className: Fe(C, v && "bg-text-secondary/50 pointer-events-none"),
        ...w,
        ...mu(!!c, `${c}`),
        children: /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          /* @__PURE__ */ y.jsx(V6, { small: !0, type: l, className: _ }),
          f.children
        ] })
      }
    );
  } else {
    const { disabled: v, ...w } = f;
    return /* @__PURE__ */ y.jsxs(
      "button",
      {
        disabled: t || v,
        className: Fe(C, v && "bg-text-secondary/50 pointer-events-none"),
        ...w,
        ...mu(!!c, `${c}`),
        children: [
          /* @__PURE__ */ y.jsx(V6, { small: !0, type: l, className: _ }),
          /* @__PURE__ */ y.jsx(B0, { buttonTextClassName: d, isFetching: t, children: f.children })
        ]
      }
    );
  }
};
function pR({
  arrowButtonClassName: e,
  open: t,
  isDisabled: n,
  As: r = F4
}) {
  return /* @__PURE__ */ y.jsx(
    r,
    {
      as: "div",
      className: Fe(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        n && "cursor-not-allowed",
        e
      ),
      disabled: n,
      children: /* @__PURE__ */ y.jsx(
        c3,
        {
          className: Fe("stroke-text-primary main-transition", t && "rotate-180"),
          "aria-hidden": "true"
        }
      )
    }
  );
}
function hR({ onClick: e, closeButtonClassName: t, isDisabled: n }) {
  return /* @__PURE__ */ y.jsx(
    "button",
    {
      type: "button",
      className: Fe(
        "flex items-center",
        "focus-ring",
        "rounded-md",
        n && "cursor-not-allowed",
        t
      ),
      onClick: e,
      disabled: n,
      children: /* @__PURE__ */ y.jsx(l3, { className: "fill-text-primary h-4 w-4" })
    }
  );
}
function mR({
  children: e,
  selectedData: t,
  virtual: n,
  disabled: r,
  onClose: a,
  onChange: i
}) {
  return /* @__PURE__ */ y.jsx(
    IM,
    {
      immediate: !0,
      value: t,
      virtual: n,
      onChange: (o) => {
        o !== null && i(o == null ? void 0 : o.id);
      },
      disabled: r,
      onClose: a,
      children: ({ open: o }) => e(o)
    }
  );
}
const Kg = "text-[16px] sm:text-sm", f3 = "px-4 py-2.5";
function fR({
  isDisabled: e,
  open: t,
  hasError: n,
  className: r,
  placeholder: a,
  selectedCaption: i,
  isPreFetching: o,
  onFocus: s,
  onChange: l,
  inputRef: c,
  dataTest: u
}) {
  return /* @__PURE__ */ y.jsx(
    Qf,
    {
      ref: c,
      className: Fe(
        "w-full truncate",
        Kg,
        "flex items-center justify-between",
        f3,
        "rounded-lg pr-14",
        "text-text-primary placeholder:text-text-tertiary/70 cursor-default",
        "focus-visible:border-brand-primary border focus:outline-hidden",
        "main-transition-colors",
        e ? "bg-skeleton-primary/20" : "bg-background-secondary",
        t ? "border-brand-primary" : n ? "border-danger" : "border-text-secondary/30",
        o && ["animate-pulse", "text-transparent placeholder:text-transparent"],
        r
      ),
      onChange: (d) => l == null ? void 0 : l(d.target.value),
      onKeyDown: (d) => d.stopPropagation(),
      onFocus: s,
      displayValue: i ? () => i : void 0,
      placeholder: a ?? Xe.t("public_pages_purchase.form_select.select"),
      ...u
    }
  );
}
function CR({ loaderWrapperClassName: e, loaderClassName: t }) {
  return /* @__PURE__ */ y.jsx(
    "div",
    {
      className: Fe(
        "flex h-full items-center justify-center",
        "scale-75",
        e
      ),
      children: /* @__PURE__ */ y.jsx(V6, { className: Fe(t) })
    }
  );
}
const gR = ({
  item: e,
  optionClassName: t,
  optionIconWrapperClassName: n,
  optionRef: r,
  as: a
}) => {
  const i = (e == null ? void 0 : e.customCaption) ?? (e == null ? void 0 : e.caption), o = ({ disabled: l, selected: c }) => Fe(
    "bg-background-secondary text-text-primary",
    f3,
    "border-b last:border-b-0 border-text-secondary/30",
    "group hover:bg-brand-primary hover:text-background-secondary",
    "data-[focus]:bg-brand-primary data-[focus]:text-background-secondary",
    "flex justify-between items-center gap-3 w-full break-all",
    c && "bg-brand-primary text-background-secondary",
    l && "bg-text-secondary hover:bg-text-secondary data-[focus]:bg-text-secondary text-background-secondary hover:text-background-secondary data-[focus]:text-background-secondary cursor-not-allowed",
    t,
    e == null ? void 0 : e.className
  ), s = ({ selected: l }) => /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    i,
    /* @__PURE__ */ y.jsxs("div", { className: Fe("flex items-center gap-3", n), children: [
      l && /* @__PURE__ */ y.jsx(
        IL,
        {
          className: F6(
            "group-hover:stroke-background-secondary stroke-background-secondary h-4 w-4"
          ),
          "aria-hidden": "true"
        }
      ),
      e == null ? void 0 : e.additionalRender
    ] })
  ] });
  return /* @__PURE__ */ y.jsx(
    a,
    {
      disabled: e == null ? void 0 : e.disabled,
      ref: r,
      value: e,
      className: o,
      "data-test-id": e == null ? void 0 : e.dataTestAttribute,
      children: s
    },
    e == null ? void 0 : e.id
  );
}, $g = Ji(
  ({ children: e, style: t, optionsClassName: n, as: r, optionsProps: a }, i) => /* @__PURE__ */ y.jsx(
    r,
    {
      anchor: { to: "bottom", gap: 4 },
      portal: !0,
      transition: !0,
      ref: i,
      style: t,
      className: Fe(
        "h-full w-[var(--input-width)] min-w-[200px]",
        "bg-background-secondary shadow-around-sm rounded-lg",
        "z-20",
        "data-[closed]:opacity-0 transition duration-200 ease-out empty:invisible",
        "customScroll",
        Kg,
        n
      ),
      ...a,
      children: e
    }
  )
);
$g.displayName = "ListOptionsWrapper";
const ju = 240, yR = () => ({
  id: void 0,
  caption: Xe.t("public_pages_purchase.form_select.empty_list"),
  className: "bg-background-secondary hover:bg-background-secondary cursor-default text-text-tertiary/70 hover:text-text-tertiary/70",
  disabled: !0
}), vR = (e, t) => {
  let n = 0;
  return e && (e.querySelectorAll('[role="option"]').forEach((r) => {
    n += r.getBoundingClientRect().height;
  }), n = t ? Math.min(n, ju) || ju : 42), n;
};
function bR({
  optionsClassName: e,
  data: t,
  loaderWrapperClassName: n,
  loaderClassName: r,
  asOptions: a,
  asOption: i,
  ...o
}) {
  const [s, l] = ke(null), c = vR(s, t);
  return /* @__PURE__ */ y.jsx(
    $g,
    {
      as: a,
      ref: l,
      optionsClassName: e,
      style: { height: c },
      children: ({ option: u }) => t ? gR({ ...o, as: i, item: u }) : /* @__PURE__ */ y.jsx(
        CR,
        {
          loaderWrapperClassName: n,
          loaderClassName: r
        }
      )
    }
  );
}
const _R = (e, t) => (t == null ? void 0 : t.find((n) => n.id === e)) ?? null, wR = (e) => {
  const [t, n] = ke(""), [r, a] = ke(e);
  return Re(() => {
    const i = t === "" ? e : (e == null ? void 0 : e.filter(
      (o) => o.caption.toLowerCase().replace(/\s+/g, "").includes(t.toLowerCase().replace(/\s+/g, ""))
    )) ?? [];
    a(() => i);
  }, [e, t]), { filteredData: r, setFilteredData: a, query: t, setQuery: n };
}, xR = (e = []) => ({
  options: e.length > 0 ? e : [yR()],
  disabled: (t) => (t == null ? void 0 : t.disabled) ?? !1
});
function SR({
  label: e,
  data: t,
  staticData: n,
  onChange: r,
  labelClassName: a,
  value: i,
  isPreFetching: o,
  placeholder: s,
  error: l,
  required: c,
  description: u,
  className: d,
  containerClassName: p,
  closeButtonClassName: h,
  arrowButtonClassName: m,
  fieldClassName: f,
  disabled: C,
  withoutCloseIcon: _,
  onOpen: v,
  onClose: w,
  dataTest: k,
  wrapperProps: b,
  loaderClassName: S,
  loaderWrapperClassName: P,
  inputWrapperClassName: O,
  inputRef: A,
  statusIcon: L,
  statusIconClassName: I,
  ...D
}) {
  const [U, z] = ke(!1);
  Re(() => {
    U && v && (v(), z(!1));
  }, [U]);
  const $ = _R(i, t ?? n) ?? null, { filteredData: ee, setQuery: Z } = wR(t), G = i !== void 0, W = C || o || G && !t && !n, j = G && !_ && !W;
  return /* @__PURE__ */ y.jsxs("div", { className: Fe("relative flex flex-col gap-1", p), children: [
    /* @__PURE__ */ y.jsx(
      mR,
      {
        selectedData: $,
        virtual: xR(ee),
        onChange: r,
        disabled: W,
        onClose: () => {
          Z(""), w == null || w();
        },
        children: (T) => /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
          /* @__PURE__ */ y.jsxs(DP, { className: Fe("relative flex flex-col gap-1", f), children: [
            /* @__PURE__ */ y.jsx(
              ba,
              {
                wrapperAs: "label",
                wrapperProps: b,
                label: e,
                required: c,
                labelClassName: Fe("text-sm font-medium", a)
              }
            ),
            /* @__PURE__ */ y.jsxs(F4, { as: "button", className: Fe("relative", O), children: [
              /* @__PURE__ */ y.jsx(
                fR,
                {
                  dataTest: k,
                  inputRef: A,
                  isDisabled: W,
                  hasError: !!l,
                  open: T,
                  className: d,
                  placeholder: s,
                  selectedCaption: ($ == null ? void 0 : $.caption) ?? "",
                  isPreFetching: o,
                  onFocus: () => z(!0),
                  onChange: (F) => {
                    z(!0), Z(F);
                  }
                }
              ),
              L ? /* @__PURE__ */ y.jsx(
                "div",
                {
                  className: Fe(
                    "absolute inset-y-0 right-3 flex h-[46px] items-center justify-center sm:h-[42px]",
                    I
                  ),
                  children: L
                }
              ) : /* @__PURE__ */ y.jsx(
                pR,
                {
                  isDisabled: W,
                  arrowButtonClassName: Fe(
                    "absolute inset-y-0 right-4 h-[46px] sm:h-[42px]",
                    m
                  ),
                  open: T
                }
              )
            ] }),
            j && /* @__PURE__ */ y.jsx(
              hR,
              {
                isDisabled: W,
                closeButtonClassName: Fe(
                  "absolute bottom-0 right-10 h-[46px] sm:h-[42px]",
                  h
                ),
                onClick: () => r(void 0)
              }
            )
          ] }),
          /* @__PURE__ */ y.jsx(
            bR,
            {
              asOptions: eC,
              asOption: tC,
              data: ee,
              ...D
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ y.jsx(oo, { error: l, description: u })
  ] });
}
var Wg = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(Wg);
var kR = Wg.exports;
const U1 = /* @__PURE__ */ A5(kR);
function Me(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function u8(e) {
  return Me(1, arguments), e instanceof Date || Gr(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Oe(e) {
  Me(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Gr(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Os(e) {
  if (Me(1, arguments), !u8(e) && typeof e != "number")
    return !1;
  var t = Oe(e);
  return !isNaN(Number(t));
}
function dt(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function C3(e, t) {
  Me(2, arguments);
  var n = Oe(e).getTime(), r = dt(t);
  return new Date(n + r);
}
function Yg(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return C3(e, -n);
}
var MR = 864e5;
function PR(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), a = n - r;
  return Math.floor(a / MR) + 1;
}
function Hi(e) {
  Me(1, arguments);
  var t = 1, n = Oe(e), r = n.getUTCDay(), a = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function qg(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Hi(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = Hi(i);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function ER(e) {
  Me(1, arguments);
  var t = qg(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Hi(n);
  return r;
}
var TR = 6048e5;
function Jg(e) {
  Me(1, arguments);
  var t = Oe(e), n = Hi(t).getTime() - ER(t).getTime();
  return Math.round(n / TR) + 1;
}
var LR = {};
function ri() {
  return LR;
}
function K2(e, t) {
  var n, r, a, i, o, s, l, c;
  Me(1, arguments);
  var u = ri(), d = dt((n = (r = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Oe(e), h = p.getUTCDay(), m = (h < d ? 7 : 0) + h - d;
  return p.setUTCDate(p.getUTCDate() - m), p.setUTCHours(0, 0, 0, 0), p;
}
function g3(e, t) {
  var n, r, a, i, o, s, l, c;
  Me(1, arguments);
  var u = Oe(e), d = u.getUTCFullYear(), p = ri(), h = dt((n = (r = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = p.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(d + 1, 0, h), m.setUTCHours(0, 0, 0, 0);
  var f = K2(m, t), C = /* @__PURE__ */ new Date(0);
  C.setUTCFullYear(d, 0, h), C.setUTCHours(0, 0, 0, 0);
  var _ = K2(C, t);
  return u.getTime() >= f.getTime() ? d + 1 : u.getTime() >= _.getTime() ? d : d - 1;
}
function AR(e, t) {
  var n, r, a, i, o, s, l, c;
  Me(1, arguments);
  var u = ri(), d = dt((n = (r = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = g3(e, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(p, 0, d), h.setUTCHours(0, 0, 0, 0);
  var m = K2(h, t);
  return m;
}
var OR = 6048e5;
function Xg(e, t) {
  Me(1, arguments);
  var n = Oe(e), r = K2(n, t).getTime() - AR(n, t).getTime();
  return Math.round(r / OR) + 1;
}
function zt(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var xa = {
  // Year
  y: function(e, t) {
    var n = e.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return zt(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M: function(e, t) {
    var n = e.getUTCMonth();
    return t === "M" ? String(n + 1) : zt(n + 1, 2);
  },
  // Day of the month
  d: function(e, t) {
    return zt(e.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(e, t) {
    var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, t) {
    return zt(e.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(e, t) {
    return zt(e.getUTCHours(), t.length);
  },
  // Minute
  m: function(e, t) {
    return zt(e.getUTCMinutes(), t.length);
  },
  // Second
  s: function(e, t) {
    return zt(e.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(e, t) {
    var n = t.length, r = e.getUTCMilliseconds(), a = Math.floor(r * Math.pow(10, n - 3));
    return zt(a, t.length);
  }
}, li = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, NR = {
  // Era
  G: function(e, t, n) {
    var r = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, {
          width: "abbreviated"
        });
      case "GGGGG":
        return n.era(r, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return n.era(r, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      var r = e.getUTCFullYear(), a = r > 0 ? r : 1 - r;
      return n.ordinalNumber(a, {
        unit: "year"
      });
    }
    return xa.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    var a = g3(e, r), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      var o = i % 100;
      return zt(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, {
      unit: "year"
    }) : zt(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    var n = qg(e);
    return zt(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    var n = e.getUTCFullYear();
    return zt(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    var r = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return zt(r, 2);
      case "Qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    var r = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return zt(r, 2);
      case "qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    var r = e.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return xa.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    var r = e.getUTCMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return zt(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    var a = Xg(e, r);
    return t === "wo" ? n.ordinalNumber(a, {
      unit: "week"
    }) : zt(a, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    var r = Jg(e);
    return t === "Io" ? n.ordinalNumber(r, {
      unit: "week"
    }) : zt(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : xa.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    var r = PR(e);
    return t === "Do" ? n.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : zt(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    var r = e.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    var a = e.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return zt(i, 2);
      case "eo":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    var a = e.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return zt(i, t.length);
      case "co":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return n.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    var r = e.getUTCDay(), a = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return zt(a, t.length);
      case "io":
        return n.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    var r = e.getUTCHours(), a = r / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    var r = e.getUTCHours(), a;
    switch (r === 12 ? a = li.noon : r === 0 ? a = li.midnight : a = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    var r = e.getUTCHours(), a;
    switch (r >= 17 ? a = li.evening : r >= 12 ? a = li.afternoon : r >= 4 ? a = li.morning : a = li.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      var r = e.getUTCHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, {
        unit: "hour"
      });
    }
    return xa.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : xa.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    var r = e.getUTCHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : zt(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    var r = e.getUTCHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : zt(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : xa.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : xa.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return xa.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n, r) {
    var a = r._originalDate || e, i = a.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (t) {
      case "X":
        return Du(i);
      case "XXXX":
      case "XX":
        return _2(i);
      case "XXXXX":
      case "XXX":
      default:
        return _2(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n, r) {
    var a = r._originalDate || e, i = a.getTimezoneOffset();
    switch (t) {
      case "x":
        return Du(i);
      case "xxxx":
      case "xx":
        return _2(i);
      case "xxxxx":
      case "xxx":
      default:
        return _2(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n, r) {
    var a = r._originalDate || e, i = a.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ru(i, ":");
      case "OOOO":
      default:
        return "GMT" + _2(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n, r) {
    var a = r._originalDate || e, i = a.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ru(i, ":");
      case "zzzz":
      default:
        return "GMT" + _2(i, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n, r) {
    var a = r._originalDate || e, i = Math.floor(a.getTime() / 1e3);
    return zt(i, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n, r) {
    var a = r._originalDate || e, i = a.getTime();
    return zt(i, t.length);
  }
};
function Ru(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(a);
  var o = t;
  return n + String(a) + o + zt(i, 2);
}
function Du(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + zt(Math.abs(e) / 60, 2);
  }
  return _2(e, t);
}
function _2(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", a = Math.abs(e), i = zt(Math.floor(a / 60), 2), o = zt(a % 60, 2);
  return r + i + n + o;
}
var Iu = function(e, t) {
  switch (e) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, Qg = function(e, t) {
  switch (e) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, jR = function(e, t) {
  var n = e.match(/(P+)(p+)?/) || [], r = n[1], a = n[2];
  if (!a)
    return Iu(e, t);
  var i;
  switch (r) {
    case "P":
      i = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = t.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Iu(r, t)).replace("{{time}}", Qg(a, t));
}, z0 = {
  p: Qg,
  P: jR
};
function Z6(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var RR = ["D", "DD"], DR = ["YY", "YYYY"];
function ey(e) {
  return RR.indexOf(e) !== -1;
}
function ty(e) {
  return DR.indexOf(e) !== -1;
}
function K6(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var IR = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, HR = function(e, t, n) {
  var r, a = IR[e];
  return typeof a == "string" ? r = a : t === 1 ? r = a.one : r = a.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function h7(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var FR = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, VR = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, BR = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zR = {
  date: h7({
    formats: FR,
    defaultWidth: "full"
  }),
  time: h7({
    formats: VR,
    defaultWidth: "full"
  }),
  dateTime: h7({
    formats: BR,
    defaultWidth: "full"
  })
}, GR = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, UR = function(e, t, n, r) {
  return GR[e];
};
function To(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", a;
    if (r === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = n != null && n.width ? String(n.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[l] || e.values[s];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[c];
  };
}
var ZR = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, KR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, $R = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, WR = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, YR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, qR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, JR = function(e, t) {
  var n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, XR = {
  ordinalNumber: JR,
  era: To({
    values: ZR,
    defaultWidth: "wide"
  }),
  quarter: To({
    values: KR,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: To({
    values: $R,
    defaultWidth: "wide"
  }),
  day: To({
    values: WR,
    defaultWidth: "wide"
  }),
  dayPeriod: To({
    values: YR,
    defaultWidth: "wide",
    formattingValues: qR,
    defaultFormattingWidth: "wide"
  })
};
function Lo(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(a);
    if (!i)
      return null;
    var o = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? eD(s, function(d) {
      return d.test(o);
    }) : QR(s, function(d) {
      return d.test(o);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = t.slice(o.length);
    return {
      value: c,
      rest: u
    };
  };
}
function QR(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function eD(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function tD(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var a = r[0], i = t.match(e.parsePattern);
    if (!i)
      return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = t.slice(a.length);
    return {
      value: o,
      rest: s
    };
  };
}
var rD = /^(\d+)(th|st|nd|rd)?/i, nD = /\d+/i, aD = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, iD = {
  any: [/^b/i, /^(a|c)/i]
}, oD = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, sD = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, lD = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, cD = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, uD = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, dD = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, pD = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, hD = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, mD = {
  ordinalNumber: tD({
    matchPattern: rD,
    parsePattern: nD,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: Lo({
    matchPatterns: aD,
    defaultMatchWidth: "wide",
    parsePatterns: iD,
    defaultParseWidth: "any"
  }),
  quarter: Lo({
    matchPatterns: oD,
    defaultMatchWidth: "wide",
    parsePatterns: sD,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: Lo({
    matchPatterns: lD,
    defaultMatchWidth: "wide",
    parsePatterns: cD,
    defaultParseWidth: "any"
  }),
  day: Lo({
    matchPatterns: uD,
    defaultMatchWidth: "wide",
    parsePatterns: dD,
    defaultParseWidth: "any"
  }),
  dayPeriod: Lo({
    matchPatterns: pD,
    defaultMatchWidth: "any",
    parsePatterns: hD,
    defaultParseWidth: "any"
  })
}, ry = {
  code: "en-US",
  formatDistance: HR,
  formatLong: zR,
  formatRelative: UR,
  localize: XR,
  match: mD,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, fD = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, CD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, gD = /^'([^]*?)'?$/, yD = /''/g, vD = /[a-zA-Z]/;
function Hu(e, t, n) {
  var r, a, i, o, s, l, c, u, d, p, h, m, f, C, _, v, w, k;
  Me(2, arguments);
  var b = String(t), S = ri(), P = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : S.locale) !== null && r !== void 0 ? r : ry, O = dt((i = (o = (s = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : S.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = S.locale) === null || d === void 0 || (p = d.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var A = dt((h = (m = (f = (C = n == null ? void 0 : n.weekStartsOn) !== null && C !== void 0 ? C : n == null || (_ = n.locale) === null || _ === void 0 || (v = _.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && f !== void 0 ? f : S.weekStartsOn) !== null && m !== void 0 ? m : (w = S.locale) === null || w === void 0 || (k = w.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(A >= 0 && A <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!P.localize)
    throw new RangeError("locale must contain localize property");
  if (!P.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var L = Oe(e);
  if (!Os(L))
    throw new RangeError("Invalid time value");
  var I = Z6(L), D = Yg(L, I), U = {
    firstWeekContainsDate: O,
    weekStartsOn: A,
    locale: P,
    _originalDate: L
  }, z = b.match(CD).map(function($) {
    var ee = $[0];
    if (ee === "p" || ee === "P") {
      var Z = z0[ee];
      return Z($, P.formatLong);
    }
    return $;
  }).join("").match(fD).map(function($) {
    if ($ === "''")
      return "'";
    var ee = $[0];
    if (ee === "'")
      return bD($);
    var Z = NR[ee];
    if (Z)
      return !(n != null && n.useAdditionalWeekYearTokens) && ty($) && K6($, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && ey($) && K6($, t, String(e)), Z(D, $, P.localize, U);
    if (ee.match(vD))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + ee + "`");
    return $;
  }).join("");
  return z;
}
function bD(e) {
  var t = e.match(gD);
  return t ? t[1].replace(yD, "'") : e;
}
var _D = 6e4;
function G0(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return C3(e, n * _D);
}
var wD = 36e5;
function xD(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return C3(e, n * wD);
}
function so(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function $6(e, t) {
  Me(2, arguments);
  var n = dt(t), r = n * 7;
  return so(e, r);
}
function bn(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var a = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n);
}
function ny(e, t) {
  Me(2, arguments);
  var n = dt(t), r = n * 3;
  return bn(e, r);
}
function Fi(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return bn(e, n * 12);
}
function SD(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return so(e, -n);
}
function Fu(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return $6(e, -n);
}
function Vi(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return bn(e, -n);
}
function kD(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return ny(e, -n);
}
function Ns(e, t) {
  Me(2, arguments);
  var n = dt(t);
  return Fi(e, -n);
}
function Vu(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getSeconds();
  return n;
}
function Un(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getMinutes();
  return n;
}
function Zn(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getHours();
  return n;
}
function MD(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getDay();
  return n;
}
function Bu(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getDate();
  return n;
}
function ay(e, t) {
  var n, r, a, i, o, s, l, c;
  Me(1, arguments);
  var u = ri(), d = dt((n = (r = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = Oe(e), h = p.getDay(), m = (h < d ? 7 : 0) + h - d;
  return p.setDate(p.getDate() - m), p.setHours(0, 0, 0, 0), p;
}
function W6(e) {
  return Me(1, arguments), ay(e, {
    weekStartsOn: 1
  });
}
function PD(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var a = W6(r), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  var o = W6(i);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function ED(e) {
  Me(1, arguments);
  var t = PD(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var r = W6(n);
  return r;
}
var TD = 6048e5;
function LD(e) {
  Me(1, arguments);
  var t = Oe(e), n = W6(t).getTime() - ED(t).getTime();
  return Math.round(n / TD) + 1;
}
function Y1(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getMonth();
  return n;
}
function bi(e) {
  Me(1, arguments);
  var t = Oe(e), n = Math.floor(t.getMonth() / 3) + 1;
  return n;
}
function pt(e) {
  return Me(1, arguments), Oe(e).getFullYear();
}
function U0(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getTime();
  return n;
}
function AD(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t);
  return n.setSeconds(r), n;
}
function s6(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t);
  return n.setMinutes(r), n;
}
function l6(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t);
  return n.setHours(r), n;
}
function OD(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getFullYear(), r = t.getMonth(), a = /* @__PURE__ */ new Date(0);
  return a.setFullYear(n, r + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function or(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t), a = n.getFullYear(), i = n.getDate(), o = /* @__PURE__ */ new Date(0);
  o.setFullYear(a, r, 15), o.setHours(0, 0, 0, 0);
  var s = OD(o);
  return n.setMonth(r, Math.min(i, s)), n;
}
function ci(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t), a = Math.floor(n.getMonth() / 3) + 1, i = r - a;
  return or(n, n.getMonth() + i * 3);
}
function da(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
function zu(e) {
  Me(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (Gr(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return t.forEach(function(r) {
    var a = Oe(r);
    (n === void 0 || n > a || isNaN(a.getDate())) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function Gu(e) {
  Me(1, arguments);
  var t;
  if (e && typeof e.forEach == "function")
    t = e;
  else if (Gr(e) === "object" && e !== null)
    t = Array.prototype.slice.call(e);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return t.forEach(function(r) {
    var a = Oe(r);
    (n === void 0 || n < a || isNaN(Number(a))) && (n = a);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function Kn(e) {
  Me(1, arguments);
  var t = Oe(e);
  return t.setHours(0, 0, 0, 0), t;
}
var ND = 864e5;
function Y6(e, t) {
  Me(2, arguments);
  var n = Kn(e), r = Kn(t), a = n.getTime() - Z6(n), i = r.getTime() - Z6(r);
  return Math.round((a - i) / ND);
}
function q6(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = Oe(t), a = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return a * 12 + i;
}
function J6(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = Oe(t);
  return n.getFullYear() - r.getFullYear();
}
function iy(e) {
  Me(1, arguments);
  var t = Oe(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Z0(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getMonth(), r = n - n % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function oy(e) {
  Me(1, arguments);
  var t = Oe(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function K0(e) {
  Me(1, arguments);
  var t = Oe(e);
  return t.setHours(23, 59, 59, 999), t;
}
function jD(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function RD(e) {
  Me(1, arguments);
  var t = Oe(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function DD(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = Oe(t);
  return n.getTime() === r.getTime();
}
function ID(e, t) {
  Me(2, arguments);
  var n = Kn(e), r = Kn(t);
  return n.getTime() === r.getTime();
}
function HD(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = Oe(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function FD(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = Oe(t);
  return n.getFullYear() === r.getFullYear();
}
function VD(e, t) {
  Me(2, arguments);
  var n = Z0(e), r = Z0(t);
  return n.getTime() === r.getTime();
}
function $a(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = Oe(t);
  return n.getTime() > r.getTime();
}
function Ha(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = Oe(t);
  return n.getTime() < r.getTime();
}
function js(e, t) {
  Me(2, arguments);
  var n = Oe(e).getTime(), r = Oe(t.start).getTime(), a = Oe(t.end).getTime();
  if (!(r <= a))
    throw new RangeError("Invalid interval");
  return n >= r && n <= a;
}
function Uu(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = AA(e)) || t) {
      n && (e = n);
      var r = 0, a = function() {
      };
      return {
        s: a,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: a
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, o = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return o = l.done, l;
    },
    e: function(l) {
      s = !0, i = l;
    },
    f: function() {
      try {
        o || n.return == null || n.return();
      } finally {
        if (s)
          throw i;
      }
    }
  };
}
function BD(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function Ae(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $0(e, t) {
  return $0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, $0(e, t);
}
function Tt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && $0(e, t);
}
function X6(e) {
  return X6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, X6(e);
}
function sy() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (sy = function() {
    return !!e;
  })();
}
function zD(e, t) {
  if (t && (Gr(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Ae(e);
}
function Lt(e) {
  var t = sy();
  return function() {
    var n, r = X6(e);
    if (t) {
      var a = X6(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else
      n = r.apply(this, arguments);
    return zD(this, n);
  };
}
var GD = 10, ly = /* @__PURE__ */ function() {
  function e() {
    vt(this, e), Te(this, "priority", void 0), Te(this, "subPriority", 0);
  }
  return bt(e, [{
    key: "validate",
    value: function(t, n) {
      return !0;
    }
  }]), e;
}(), UD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n(r, a, i, o, s) {
    var l;
    return vt(this, n), l = t.call(this), l.value = r, l.validateValue = a, l.setValue = i, l.priority = o, s && (l.subPriority = s), l;
  }
  return bt(n, [{
    key: "validate",
    value: function(r, a) {
      return this.validateValue(r, this.value, a);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return this.setValue(r, a, this.value, i);
    }
  }]), n;
}(ly), ZD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", GD), Te(Ae(r), "subPriority", -1), r;
  }
  return bt(n, [{
    key: "set",
    value: function(r, a) {
      if (a.timestampIsSet)
        return r;
      var i = /* @__PURE__ */ new Date(0);
      return i.setFullYear(r.getUTCFullYear(), r.getUTCMonth(), r.getUTCDate()), i.setHours(r.getUTCHours(), r.getUTCMinutes(), r.getUTCSeconds(), r.getUTCMilliseconds()), i;
    }
  }]), n;
}(ly), jt = /* @__PURE__ */ function() {
  function e() {
    vt(this, e), Te(this, "incompatibleTokens", void 0), Te(this, "priority", void 0), Te(this, "subPriority", void 0);
  }
  return bt(e, [{
    key: "run",
    value: function(t, n, r, a) {
      var i = this.parse(t, n, r, a);
      return i ? {
        setter: new UD(i.value, this.validate, this.set, this.priority, this.subPriority),
        rest: i.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(t, n, r) {
      return !0;
    }
  }]), e;
}(), KD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 140), Te(Ae(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(r, {
            width: "abbreviated"
          }) || i.era(r, {
            width: "narrow"
          });
        case "GGGGG":
          return i.era(r, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return i.era(r, {
            width: "wide"
          }) || i.era(r, {
            width: "abbreviated"
          }) || i.era(r, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return a.era = i, r.setUTCFullYear(i, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), y3 = 6e4, v3 = 36e5, $D = 1e3, _1 = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Nn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function w1(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function u1(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function jn(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, a = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (a * v3 + i * y3 + o * $D),
    rest: t.slice(n[0].length)
  };
}
function cy(e) {
  return u1(_1.anyDigitsSigned, e);
}
function m1(e, t) {
  switch (e) {
    case 1:
      return u1(_1.singleDigit, t);
    case 2:
      return u1(_1.twoDigits, t);
    case 3:
      return u1(_1.threeDigits, t);
    case 4:
      return u1(_1.fourDigits, t);
    default:
      return u1(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function uy(e, t) {
  switch (e) {
    case 1:
      return u1(_1.singleDigitSigned, t);
    case 2:
      return u1(_1.twoDigitsSigned, t);
    case 3:
      return u1(_1.threeDigitsSigned, t);
    case 4:
      return u1(_1.fourDigitsSigned, t);
    default:
      return u1(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function b3(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function dy(e, t) {
  var n = t > 0, r = n ? t : 1 - t, a;
  if (r <= 50)
    a = e || 100;
  else {
    var i = r + 50, o = Math.floor(i / 100) * 100, s = e >= i % 100;
    a = e + o - (s ? 100 : 0);
  }
  return n ? a : 1 - a;
}
function py(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var WD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 130), Te(Ae(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      var o = function(s) {
        return {
          year: s,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return w1(m1(4, r), o);
        case "yo":
          return w1(i.ordinalNumber(r, {
            unit: "year"
          }), o);
        default:
          return w1(m1(a.length, r), o);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var o = r.getUTCFullYear();
      if (i.isTwoDigitYear) {
        var s = dy(i.year, o);
        return r.setUTCFullYear(s, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
      }
      var l = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
      return r.setUTCFullYear(l, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), YD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 130), Te(Ae(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      var o = function(s) {
        return {
          year: s,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return w1(m1(4, r), o);
        case "Yo":
          return w1(i.ordinalNumber(r, {
            unit: "year"
          }), o);
        default:
          return w1(m1(a.length, r), o);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(r, a, i, o) {
      var s = g3(r, o);
      if (i.isTwoDigitYear) {
        var l = dy(i.year, s);
        return r.setUTCFullYear(l, 0, o.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), K2(r, o);
      }
      var c = !("era" in a) || a.era === 1 ? i.year : 1 - i.year;
      return r.setUTCFullYear(c, 0, o.firstWeekContainsDate), r.setUTCHours(0, 0, 0, 0), K2(r, o);
    }
  }]), n;
}(jt), qD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 130), Te(Ae(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      return uy(a === "R" ? 4 : a.length, r);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(i, 0, 4), o.setUTCHours(0, 0, 0, 0), Hi(o);
    }
  }]), n;
}(jt), JD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 130), Te(Ae(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      return uy(a === "u" ? 4 : a.length, r);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCFullYear(i, 0, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), XD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 120), Te(Ae(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "Q":
        case "QQ":
          return m1(a.length, r);
        case "Qo":
          return i.ordinalNumber(r, {
            unit: "quarter"
          });
        case "QQQ":
          return i.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return i.quarter(r, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth((i - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), QD = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 120), Te(Ae(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "q":
        case "qq":
          return m1(a.length, r);
        case "qo":
          return i.ordinalNumber(r, {
            unit: "quarter"
          });
        case "qqq":
          return i.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return i.quarter(r, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth((i - 1) * 3, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), eI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Te(Ae(r), "priority", 110), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      var o = function(s) {
        return s - 1;
      };
      switch (a) {
        case "M":
          return w1(u1(_1.month, r), o);
        case "MM":
          return w1(m1(2, r), o);
        case "Mo":
          return w1(i.ordinalNumber(r, {
            unit: "month"
          }), o);
        case "MMM":
          return i.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return i.month(r, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return i.month(r, {
            width: "wide",
            context: "formatting"
          }) || i.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth(i, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), tI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 110), Te(Ae(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      var o = function(s) {
        return s - 1;
      };
      switch (a) {
        case "L":
          return w1(u1(_1.month, r), o);
        case "LL":
          return w1(m1(2, r), o);
        case "Lo":
          return w1(i.ordinalNumber(r, {
            unit: "month"
          }), o);
        case "LLL":
          return i.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return i.month(r, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return i.month(r, {
            width: "wide",
            context: "standalone"
          }) || i.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth(i, 1), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt);
function rI(e, t, n) {
  Me(2, arguments);
  var r = Oe(e), a = dt(t), i = Xg(r, n) - a;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var nI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 100), Te(Ae(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "w":
          return u1(_1.week, r);
        case "wo":
          return i.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(r, a, i, o) {
      return K2(rI(r, i, o), o);
    }
  }]), n;
}(jt);
function aI(e, t) {
  Me(2, arguments);
  var n = Oe(e), r = dt(t), a = Jg(n) - r;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
var iI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 100), Te(Ae(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "I":
          return u1(_1.week, r);
        case "Io":
          return i.ordinalNumber(r, {
            unit: "week"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return Hi(aI(r, i));
    }
  }]), n;
}(jt), oI = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], sI = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], lI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 90), Te(Ae(r), "subPriority", 1), Te(Ae(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "d":
          return u1(_1.date, r);
        case "do":
          return i.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      var i = r.getUTCFullYear(), o = py(i), s = r.getUTCMonth();
      return o ? a >= 1 && a <= sI[s] : a >= 1 && a <= oI[s];
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCDate(i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), cI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 90), Te(Ae(r), "subpriority", 1), Te(Ae(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "D":
        case "DD":
          return u1(_1.dayOfYear, r);
        case "Do":
          return i.ordinalNumber(r, {
            unit: "date"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      var i = r.getUTCFullYear(), o = py(i);
      return o ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMonth(0, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt);
function _3(e, t, n) {
  var r, a, i, o, s, l, c, u;
  Me(2, arguments);
  var d = ri(), p = dt((r = (a = (i = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (s = n.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && a !== void 0 ? a : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = Oe(e), m = dt(t), f = h.getUTCDay(), C = m % 7, _ = (C + 7) % 7, v = (_ < p ? 7 : 0) + m - f;
  return h.setUTCDate(h.getUTCDate() + v), h;
}
var uI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 90), Te(Ae(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return i.day(r, {
            width: "wide",
            context: "formatting"
          }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, i, o) {
      return r = _3(r, i, o), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), dI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 90), Te(Ae(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i, o) {
      var s = function(l) {
        var c = Math.floor((l - 1) / 7) * 7;
        return (l + o.weekStartsOn + 6) % 7 + c;
      };
      switch (a) {
        case "e":
        case "ee":
          return w1(m1(a.length, r), s);
        case "eo":
          return w1(i.ordinalNumber(r, {
            unit: "day"
          }), s);
        case "eee":
          return i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return i.day(r, {
            width: "wide",
            context: "formatting"
          }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, i, o) {
      return r = _3(r, i, o), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), pI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 90), Te(Ae(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i, o) {
      var s = function(l) {
        var c = Math.floor((l - 1) / 7) * 7;
        return (l + o.weekStartsOn + 6) % 7 + c;
      };
      switch (a) {
        case "c":
        case "cc":
          return w1(m1(a.length, r), s);
        case "co":
          return w1(i.ordinalNumber(r, {
            unit: "day"
          }), s);
        case "ccc":
          return i.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(r, {
            width: "short",
            context: "standalone"
          }) || i.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return i.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return i.day(r, {
            width: "short",
            context: "standalone"
          }) || i.day(r, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return i.day(r, {
            width: "wide",
            context: "standalone"
          }) || i.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(r, {
            width: "short",
            context: "standalone"
          }) || i.day(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(r, a, i, o) {
      return r = _3(r, i, o), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt);
function hI(e, t) {
  Me(2, arguments);
  var n = dt(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, a = Oe(e), i = a.getUTCDay(), o = n % 7, s = (o + 7) % 7, l = (s < r ? 7 : 0) + n - i;
  return a.setUTCDate(a.getUTCDate() + l), a;
}
var mI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 90), Te(Ae(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      var o = function(s) {
        return s === 0 ? 7 : s;
      };
      switch (a) {
        case "i":
        case "ii":
          return m1(a.length, r);
        case "io":
          return i.ordinalNumber(r, {
            unit: "day"
          });
        case "iii":
          return w1(i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiii":
          return w1(i.day(r, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiiiii":
          return w1(i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          }), o);
        case "iiii":
        default:
          return w1(i.day(r, {
            width: "wide",
            context: "formatting"
          }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, {
            width: "short",
            context: "formatting"
          }) || i.day(r, {
            width: "narrow",
            context: "formatting"
          }), o);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r = hI(r, i), r.setUTCHours(0, 0, 0, 0), r;
    }
  }]), n;
}(jt), fI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 80), Te(Ae(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCHours(b3(i), 0, 0, 0), r;
    }
  }]), n;
}(jt), CI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 80), Te(Ae(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCHours(b3(i), 0, 0, 0), r;
    }
  }]), n;
}(jt), gI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 80), Te(Ae(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCHours(b3(i), 0, 0, 0), r;
    }
  }]), n;
}(jt), yI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 70), Te(Ae(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "h":
          return u1(_1.hour12h, r);
        case "ho":
          return i.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var o = r.getUTCHours() >= 12;
      return o && i < 12 ? r.setUTCHours(i + 12, 0, 0, 0) : !o && i === 12 ? r.setUTCHours(0, 0, 0, 0) : r.setUTCHours(i, 0, 0, 0), r;
    }
  }]), n;
}(jt), vI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 70), Te(Ae(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "H":
          return u1(_1.hour23h, r);
        case "Ho":
          return i.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCHours(i, 0, 0, 0), r;
    }
  }]), n;
}(jt), bI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 70), Te(Ae(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "K":
          return u1(_1.hour11h, r);
        case "Ko":
          return i.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var o = r.getUTCHours() >= 12;
      return o && i < 12 ? r.setUTCHours(i + 12, 0, 0, 0) : r.setUTCHours(i, 0, 0, 0), r;
    }
  }]), n;
}(jt), _I = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 70), Te(Ae(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "k":
          return u1(_1.hour24h, r);
        case "ko":
          return i.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      var o = i <= 24 ? i % 24 : i;
      return r.setUTCHours(o, 0, 0, 0), r;
    }
  }]), n;
}(jt), wI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 60), Te(Ae(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "m":
          return u1(_1.minute, r);
        case "mo":
          return i.ordinalNumber(r, {
            unit: "minute"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMinutes(i, 0, 0), r;
    }
  }]), n;
}(jt), xI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 50), Te(Ae(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a, i) {
      switch (a) {
        case "s":
          return u1(_1.second, r);
        case "so":
          return i.ordinalNumber(r, {
            unit: "second"
          });
        default:
          return m1(a.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCSeconds(i, 0), r;
    }
  }]), n;
}(jt), SI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 30), Te(Ae(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      var i = function(o) {
        return Math.floor(o * Math.pow(10, -a.length + 3));
      };
      return w1(m1(a.length, r), i);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return r.setUTCMilliseconds(i), r;
    }
  }]), n;
}(jt), kI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 10), Te(Ae(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      switch (a) {
        case "X":
          return jn(Nn.basicOptionalMinutes, r);
        case "XX":
          return jn(Nn.basic, r);
        case "XXXX":
          return jn(Nn.basicOptionalSeconds, r);
        case "XXXXX":
          return jn(Nn.extendedOptionalSeconds, r);
        case "XXX":
        default:
          return jn(Nn.extended, r);
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return a.timestampIsSet ? r : new Date(r.getTime() - i);
    }
  }]), n;
}(jt), MI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 10), Te(Ae(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r, a) {
      switch (a) {
        case "x":
          return jn(Nn.basicOptionalMinutes, r);
        case "xx":
          return jn(Nn.basic, r);
        case "xxxx":
          return jn(Nn.basicOptionalSeconds, r);
        case "xxxxx":
          return jn(Nn.extendedOptionalSeconds, r);
        case "xxx":
        default:
          return jn(Nn.extended, r);
      }
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return a.timestampIsSet ? r : new Date(r.getTime() - i);
    }
  }]), n;
}(jt), PI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 40), Te(Ae(r), "incompatibleTokens", "*"), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r) {
      return cy(r);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return [new Date(i * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(jt), EI = /* @__PURE__ */ function(e) {
  Tt(n, e);
  var t = Lt(n);
  function n() {
    var r;
    vt(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Te(Ae(r), "priority", 20), Te(Ae(r), "incompatibleTokens", "*"), r;
  }
  return bt(n, [{
    key: "parse",
    value: function(r) {
      return cy(r);
    }
  }, {
    key: "set",
    value: function(r, a, i) {
      return [new Date(i), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(jt), TI = {
  G: new KD(),
  y: new WD(),
  Y: new YD(),
  R: new qD(),
  u: new JD(),
  Q: new XD(),
  q: new QD(),
  M: new eI(),
  L: new tI(),
  w: new nI(),
  I: new iI(),
  d: new lI(),
  D: new cI(),
  E: new uI(),
  e: new dI(),
  c: new pI(),
  i: new mI(),
  a: new fI(),
  b: new CI(),
  B: new gI(),
  h: new yI(),
  H: new vI(),
  K: new bI(),
  k: new _I(),
  m: new wI(),
  s: new xI(),
  S: new SI(),
  X: new kI(),
  x: new MI(),
  t: new PI(),
  T: new EI()
}, LI = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, AI = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, OI = /^'([^]*?)'?$/, NI = /''/g, jI = /\S/, RI = /[a-zA-Z]/;
function m7(e, t, n, r) {
  var a, i, o, s, l, c, u, d, p, h, m, f, C, _, v, w, k, b;
  Me(3, arguments);
  var S = String(e), P = String(t), O = ri(), A = (a = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : O.locale) !== null && a !== void 0 ? a : ry;
  if (!A.match)
    throw new RangeError("locale must contain match property");
  var L = dt((o = (s = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : O.firstWeekContainsDate) !== null && s !== void 0 ? s : (p = O.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(L >= 1 && L <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var I = dt((m = (f = (C = (_ = r == null ? void 0 : r.weekStartsOn) !== null && _ !== void 0 ? _ : r == null || (v = r.locale) === null || v === void 0 || (w = v.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && C !== void 0 ? C : O.weekStartsOn) !== null && f !== void 0 ? f : (k = O.locale) === null || k === void 0 || (b = k.options) === null || b === void 0 ? void 0 : b.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(I >= 0 && I <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (P === "")
    return S === "" ? Oe(n) : /* @__PURE__ */ new Date(NaN);
  var D = {
    firstWeekContainsDate: L,
    weekStartsOn: I,
    locale: A
  }, U = [new ZD()], z = P.match(AI).map(function(q) {
    var he = q[0];
    if (he in z0) {
      var me = z0[he];
      return me(q, A.formatLong);
    }
    return q;
  }).join("").match(LI), $ = [], ee = Uu(z), Z;
  try {
    var G = function() {
      var q = Z.value;
      !(r != null && r.useAdditionalWeekYearTokens) && ty(q) && K6(q, P, e), !(r != null && r.useAdditionalDayOfYearTokens) && ey(q) && K6(q, P, e);
      var he = q[0], me = TI[he];
      if (me) {
        var Ne = me.incompatibleTokens;
        if (Array.isArray(Ne)) {
          var K = $.find(function(J) {
            return Ne.includes(J.token) || J.token === he;
          });
          if (K)
            throw new RangeError("The format string mustn't contain `".concat(K.fullToken, "` and `").concat(q, "` at the same time"));
        } else if (me.incompatibleTokens === "*" && $.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(q, "` and any other token at the same time"));
        $.push({
          token: he,
          fullToken: q
        });
        var Ee = me.run(S, q, A.match, D);
        if (!Ee)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        U.push(Ee.setter), S = Ee.rest;
      } else {
        if (he.match(RI))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + he + "`");
        if (q === "''" ? q = "'" : he === "'" && (q = DI(q)), S.indexOf(q) === 0)
          S = S.slice(q.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (ee.s(); !(Z = ee.n()).done; ) {
      var W = G();
      if (Gr(W) === "object")
        return W.v;
    }
  } catch (q) {
    ee.e(q);
  } finally {
    ee.f();
  }
  if (S.length > 0 && jI.test(S))
    return /* @__PURE__ */ new Date(NaN);
  var j = U.map(function(q) {
    return q.priority;
  }).sort(function(q, he) {
    return he - q;
  }).filter(function(q, he, me) {
    return me.indexOf(q) === he;
  }).map(function(q) {
    return U.filter(function(he) {
      return he.priority === q;
    }).sort(function(he, me) {
      return me.subPriority - he.subPriority;
    });
  }).map(function(q) {
    return q[0];
  }), T = Oe(n);
  if (isNaN(T.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var F = Yg(T, Z6(T)), N = {}, Y = Uu(j), Q;
  try {
    for (Y.s(); !(Q = Y.n()).done; ) {
      var V = Q.value;
      if (!V.validate(F, D))
        return /* @__PURE__ */ new Date(NaN);
      var re = V.set(F, N, D);
      Array.isArray(re) ? (F = re[0], BD(N, re[1])) : F = re;
    }
  } catch (q) {
    Y.e(q);
  } finally {
    Y.f();
  }
  return F;
}
function DI(e) {
  return e.match(OI)[1].replace(NI, "'");
}
function II(e, t) {
  var n;
  Me(1, arguments);
  var r = dt((n = void 0) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = BI(e), i;
  if (a.date) {
    var o = zI(a.date, r);
    i = GI(o.restDateString, o.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var s = i.getTime(), l = 0, c;
  if (a.time && (l = UI(a.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (a.timezone) {
    if (c = ZI(a.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(s + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), d.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), d;
  }
  return new Date(s + l + c);
}
var D9 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, HI = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, FI = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, VI = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function BI(e) {
  var t = {}, n = e.split(D9.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], D9.timeZoneDelimiter.test(t.date) && (t.date = e.split(D9.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var a = D9.timezone.exec(r);
    a ? (t.time = r.replace(a[1], ""), t.timezone = a[1]) : t.time = r;
  }
  return t;
}
function zI(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var a = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? a : i * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function GI(e, t) {
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = e.match(HI);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], a = Ao(n[1]), i = Ao(n[2]) - 1, o = Ao(n[3]), s = Ao(n[4]), l = Ao(n[5]) - 1;
  if (r)
    return qI(t, s, l) ? KI(t, s, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !WI(t, i, o) || !YI(t, a) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, i, Math.max(a, o)), c);
}
function Ao(e) {
  return e ? parseInt(e) : 1;
}
function UI(e) {
  var t = e.match(FI);
  if (!t)
    return NaN;
  var n = f7(t[1]), r = f7(t[2]), a = f7(t[3]);
  return JI(n, r, a) ? n * v3 + r * y3 + a * 1e3 : NaN;
}
function f7(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function ZI(e) {
  if (e === "Z")
    return 0;
  var t = e.match(VI);
  if (!t)
    return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), a = t[3] && parseInt(t[3]) || 0;
  return XI(r, a) ? n * (r * v3 + a * y3) : NaN;
}
function KI(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var a = r.getUTCDay() || 7, i = (t - 1) * 7 + n + 1 - a;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var $I = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function hy(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function WI(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= ($I[t] || (hy(e) ? 29 : 28));
}
function YI(e, t) {
  return t >= 1 && t <= (hy(e) ? 366 : 365);
}
function qI(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function JI(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function XI(e, t) {
  return t >= 0 && t <= 59;
}
function QI(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, W0(e, t);
}
function W0(e, t) {
  return W0 = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, W0(e, t);
}
function eH(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Zu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tH(e, t, n) {
  return e === t ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(n) : e.classList.contains(n);
}
function rH(e, t, n) {
  if (e === t)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && tH(e, t, n))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function nH(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var aH = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var e = !1, t = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    }), n = function() {
    };
    return window.addEventListener("testPassiveEventSupport", n, t), window.removeEventListener("testPassiveEventSupport", n, t), e;
  }
};
function iH(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var oH = iH(), Y0, I9 = {}, C7 = {}, sH = ["touchstart", "touchmove"], lH = "ignore-react-onclickoutside";
function Ku(e, t) {
  var n = {}, r = sH.indexOf(t) !== -1;
  return r && Y0 && (n.passive = !e.props.preventDefault), n;
}
function d8(e, t) {
  var n, r, a = e.displayName || e.name || "Component";
  return r = n = /* @__PURE__ */ function(i) {
    QI(o, i);
    function o(l) {
      var c;
      return c = i.call(this, l) || this, c.__outsideClickHandler = function(u) {
        if (typeof c.__clickOutsideHandlerProp == "function") {
          c.__clickOutsideHandlerProp(u);
          return;
        }
        var d = c.getInstance();
        if (typeof d.props.handleClickOutside == "function") {
          d.props.handleClickOutside(u);
          return;
        }
        if (typeof d.handleClickOutside == "function") {
          d.handleClickOutside(u);
          return;
        }
        throw new Error("WrappedComponent: " + a + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, c.__getComponentNode = function() {
        var u = c.getInstance();
        return typeof u.setClickOutsideRef == "function" ? u.setClickOutsideRef() : nx(u);
      }, c.enableOnClickOutside = function() {
        if (!(typeof document > "u" || C7[c._uid])) {
          typeof Y0 > "u" && (Y0 = aH()), C7[c._uid] = !0;
          var u = c.props.eventTypes;
          u.forEach || (u = [u]), I9[c._uid] = function(d) {
            if (c.componentNode !== null && !(c.initTimeStamp > d.timeStamp) && (c.props.preventDefault && d.preventDefault(), c.props.stopPropagation && d.stopPropagation(), !(c.props.excludeScrollbar && nH(d)))) {
              var p = d.composed && d.composedPath && d.composedPath().shift() || d.target;
              rH(p, c.componentNode, c.props.outsideClickIgnoreClass) === document && c.__outsideClickHandler(d);
            }
          }, u.forEach(function(d) {
            document.addEventListener(d, I9[c._uid], Ku(Zu(c), d));
          });
        }
      }, c.disableOnClickOutside = function() {
        delete C7[c._uid];
        var u = I9[c._uid];
        if (u && typeof document < "u") {
          var d = c.props.eventTypes;
          d.forEach || (d = [d]), d.forEach(function(p) {
            return document.removeEventListener(p, u, Ku(Zu(c), p));
          }), delete I9[c._uid];
        }
      }, c.getRef = function(u) {
        return c.instanceRef = u;
      }, c._uid = oH(), c.initTimeStamp = performance.now(), c;
    }
    var s = o.prototype;
    return s.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var l = this.instanceRef;
      return l.getInstance ? l.getInstance() : l;
    }, s.componentDidMount = function() {
      typeof document > "u" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
    }, s.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, s.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, s.render = function() {
      var l = this.props;
      l.excludeScrollbar;
      var c = eH(l, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? c.ref = this.getRef : c.wrappedRef = this.getRef, c.disableOnClickOutside = this.disableOnClickOutside, c.enableOnClickOutside = this.enableOnClickOutside, za(e, c);
    }, o;
  }(Qw), n.displayName = "OnClickOutside(" + a + ")", n.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: !1,
    outsideClickIgnoreClass: lH,
    preventDefault: !1,
    stopPropagation: !1
  }, n.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, r;
}
var my = pe.createContext(), fy = pe.createContext();
function cH(e) {
  var t = e.children, n = pe.useState(null), r = n[0], a = n[1], i = pe.useRef(!1);
  pe.useEffect(function() {
    return function() {
      i.current = !0;
    };
  }, []);
  var o = pe.useCallback(function(s) {
    i.current || a(s);
  }, []);
  return /* @__PURE__ */ pe.createElement(my.Provider, {
    value: r
  }, /* @__PURE__ */ pe.createElement(fy.Provider, {
    value: o
  }, t));
}
var Cy = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, gy = function(e) {
  if (typeof e == "function") {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
      n[r - 1] = arguments[r];
    return e.apply(void 0, n);
  }
}, q0 = function(e, t) {
  if (typeof e == "function")
    return gy(e, t);
  e != null && (e.current = t);
}, $u = function(e) {
  return e.reduce(function(t, n) {
    var r = n[0], a = n[1];
    return t[r] = a, t;
  }, {});
}, Wu = typeof window < "u" && window.document && window.document.createElement ? pe.useLayoutEffect : pe.useEffect, Cr = "top", Ur = "bottom", Zr = "right", gr = "left", w3 = "auto", y9 = [Cr, Ur, Zr, gr], Bi = "start", Rs = "end", uH = "clippingParents", yy = "viewport", Oo = "popper", dH = "reference", Yu = /* @__PURE__ */ y9.reduce(function(e, t) {
  return e.concat([t + "-" + Bi, t + "-" + Rs]);
}, []), vy = /* @__PURE__ */ [].concat(y9, [w3]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Bi, t + "-" + Rs]);
}, []), pH = "beforeRead", hH = "read", mH = "afterRead", fH = "beforeMain", CH = "main", gH = "afterMain", yH = "beforeWrite", vH = "write", bH = "afterWrite", _H = [pH, hH, mH, fH, CH, gH, yH, vH, bH];
function Jn(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Rr(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function $2(e) {
  var t = Rr(e).Element;
  return e instanceof t || e instanceof Element;
}
function zr(e) {
  var t = Rr(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function x3(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Rr(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function wH(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, a = t.attributes[n] || {}, i = t.elements[n];
    !zr(i) || !Jn(i) || (Object.assign(i.style, r), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function xH(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var a = t.elements[r], i = t.attributes[r] || {}, o = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !zr(a) || !Jn(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const SH = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: wH,
  effect: xH,
  requires: ["computeStyles"]
};
function $n(e) {
  return e.split("-")[0];
}
var R2 = Math.max, Q6 = Math.min, zi = Math.round;
function J0() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function by() {
  return !/^((?!chrome|android).)*safari/i.test(J0());
}
function Gi(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), a = 1, i = 1;
  t && zr(e) && (a = e.offsetWidth > 0 && zi(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && zi(r.height) / e.offsetHeight || 1);
  var o = $2(e) ? Rr(e) : window, s = o.visualViewport, l = !by() && n, c = (r.left + (l && s ? s.offsetLeft : 0)) / a, u = (r.top + (l && s ? s.offsetTop : 0)) / i, d = r.width / a, p = r.height / i;
  return {
    width: d,
    height: p,
    top: u,
    right: c + d,
    bottom: u + p,
    left: c,
    x: c,
    y: u
  };
}
function S3(e) {
  var t = Gi(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function _y(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && x3(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function fa(e) {
  return Rr(e).getComputedStyle(e);
}
function kH(e) {
  return ["table", "td", "th"].indexOf(Jn(e)) >= 0;
}
function Xa(e) {
  return (($2(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function p8(e) {
  return Jn(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (x3(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Xa(e)
  );
}
function qu(e) {
  return !zr(e) || // https://github.com/popperjs/popper-core/issues/837
  fa(e).position === "fixed" ? null : e.offsetParent;
}
function MH(e) {
  var t = /firefox/i.test(J0()), n = /Trident/i.test(J0());
  if (n && zr(e)) {
    var r = fa(e);
    if (r.position === "fixed")
      return null;
  }
  var a = p8(e);
  for (x3(a) && (a = a.host); zr(a) && ["html", "body"].indexOf(Jn(a)) < 0; ) {
    var i = fa(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function v9(e) {
  for (var t = Rr(e), n = qu(e); n && kH(n) && fa(n).position === "static"; )
    n = qu(n);
  return n && (Jn(n) === "html" || Jn(n) === "body" && fa(n).position === "static") ? t : n || MH(e) || t;
}
function k3(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Cs(e, t, n) {
  return R2(e, Q6(t, n));
}
function PH(e, t, n) {
  var r = Cs(e, t, n);
  return r > n ? n : r;
}
function wy() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function xy(e) {
  return Object.assign({}, wy(), e);
}
function Sy(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var EH = function(e, t) {
  return e = typeof e == "function" ? e(Object.assign({}, t.rects, {
    placement: t.placement
  })) : e, xy(typeof e != "number" ? e : Sy(e, y9));
};
function TH(e) {
  var t, n = e.state, r = e.name, a = e.options, i = n.elements.arrow, o = n.modifiersData.popperOffsets, s = $n(n.placement), l = k3(s), c = [gr, Zr].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!i || !o)) {
    var d = EH(a.padding, n), p = S3(i), h = l === "y" ? Cr : gr, m = l === "y" ? Ur : Zr, f = n.rects.reference[u] + n.rects.reference[l] - o[l] - n.rects.popper[u], C = o[l] - n.rects.reference[l], _ = v9(i), v = _ ? l === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, w = f / 2 - C / 2, k = d[h], b = v - p[u] - d[m], S = v / 2 - p[u] / 2 + w, P = Cs(k, S, b), O = l;
    n.modifiersData[r] = (t = {}, t[O] = P, t.centerOffset = P - S, t);
  }
}
function LH(e) {
  var t = e.state, n = e.options, r = n.element, a = r === void 0 ? "[data-popper-arrow]" : r;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || _y(t.elements.popper, a) && (t.elements.arrow = a));
}
const AH = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: TH,
  effect: LH,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ui(e) {
  return e.split("-")[1];
}
var OH = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function NH(e, t) {
  var n = e.x, r = e.y, a = t.devicePixelRatio || 1;
  return {
    x: zi(n * a) / a || 0,
    y: zi(r * a) / a || 0
  };
}
function Ju(e) {
  var t, n = e.popper, r = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, d = e.isFixed, p = o.x, h = p === void 0 ? 0 : p, m = o.y, f = m === void 0 ? 0 : m, C = typeof u == "function" ? u({
    x: h,
    y: f
  }) : {
    x: h,
    y: f
  };
  h = C.x, f = C.y;
  var _ = o.hasOwnProperty("x"), v = o.hasOwnProperty("y"), w = gr, k = Cr, b = window;
  if (c) {
    var S = v9(n), P = "clientHeight", O = "clientWidth";
    if (S === Rr(n) && (S = Xa(n), fa(S).position !== "static" && s === "absolute" && (P = "scrollHeight", O = "scrollWidth")), S = S, a === Cr || (a === gr || a === Zr) && i === Rs) {
      k = Ur;
      var A = d && S === b && b.visualViewport ? b.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        S[P]
      );
      f -= A - r.height, f *= l ? 1 : -1;
    }
    if (a === gr || (a === Cr || a === Ur) && i === Rs) {
      w = Zr;
      var L = d && S === b && b.visualViewport ? b.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        S[O]
      );
      h -= L - r.width, h *= l ? 1 : -1;
    }
  }
  var I = Object.assign({
    position: s
  }, c && OH), D = u === !0 ? NH({
    x: h,
    y: f
  }, Rr(n)) : {
    x: h,
    y: f
  };
  if (h = D.x, f = D.y, l) {
    var U;
    return Object.assign({}, I, (U = {}, U[k] = v ? "0" : "", U[w] = _ ? "0" : "", U.transform = (b.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + f + "px)" : "translate3d(" + h + "px, " + f + "px, 0)", U));
  }
  return Object.assign({}, I, (t = {}, t[k] = v ? f + "px" : "", t[w] = _ ? h + "px" : "", t.transform = "", t));
}
function jH(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, a = r === void 0 ? !0 : r, i = n.adaptive, o = i === void 0 ? !0 : i, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: $n(t.placement),
    variation: Ui(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Ju(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Ju(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const RH = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: jH,
  data: {}
};
var H9 = {
  passive: !0
};
function DH(e) {
  var t = e.state, n = e.instance, r = e.options, a = r.scroll, i = a === void 0 ? !0 : a, o = r.resize, s = o === void 0 ? !0 : o, l = Rr(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, H9);
  }), s && l.addEventListener("resize", n.update, H9), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, H9);
    }), s && l.removeEventListener("resize", n.update, H9);
  };
}
const IH = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: DH,
  data: {}
};
var HH = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function c6(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return HH[t];
  });
}
var FH = {
  start: "end",
  end: "start"
};
function Xu(e) {
  return e.replace(/start|end/g, function(t) {
    return FH[t];
  });
}
function M3(e) {
  var t = Rr(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function P3(e) {
  return Gi(Xa(e)).left + M3(e).scrollLeft;
}
function VH(e, t) {
  var n = Rr(e), r = Xa(e), a = n.visualViewport, i = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    var c = by();
    (c || !c && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + P3(e),
    y: l
  };
}
function BH(e) {
  var t, n = Xa(e), r = M3(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = R2(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = R2(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -r.scrollLeft + P3(e), l = -r.scrollTop;
  return fa(a || n).direction === "rtl" && (s += R2(n.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function E3(e) {
  var t = fa(e), n = t.overflow, r = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + a + r);
}
function ky(e) {
  return ["html", "body", "#document"].indexOf(Jn(e)) >= 0 ? e.ownerDocument.body : zr(e) && E3(e) ? e : ky(p8(e));
}
function gs(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = ky(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Rr(r), o = a ? [i].concat(i.visualViewport || [], E3(r) ? r : []) : r, s = t.concat(o);
  return a ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(gs(p8(o)))
  );
}
function X0(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function zH(e, t) {
  var n = Gi(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Qu(e, t, n) {
  return t === yy ? X0(VH(e, n)) : $2(t) ? zH(t, n) : X0(BH(Xa(e)));
}
function GH(e) {
  var t = gs(p8(e)), n = ["absolute", "fixed"].indexOf(fa(e).position) >= 0, r = n && zr(e) ? v9(e) : e;
  return $2(r) ? t.filter(function(a) {
    return $2(a) && _y(a, r) && Jn(a) !== "body";
  }) : [];
}
function UH(e, t, n, r) {
  var a = t === "clippingParents" ? GH(e) : [].concat(t), i = [].concat(a, [n]), o = i[0], s = i.reduce(function(l, c) {
    var u = Qu(e, c, r);
    return l.top = R2(u.top, l.top), l.right = Q6(u.right, l.right), l.bottom = Q6(u.bottom, l.bottom), l.left = R2(u.left, l.left), l;
  }, Qu(e, o, r));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function My(e) {
  var t = e.reference, n = e.element, r = e.placement, a = r ? $n(r) : null, i = r ? Ui(r) : null, o = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (a) {
    case Cr:
      l = {
        x: o,
        y: t.y - n.height
      };
      break;
    case Ur:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case Zr:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case gr:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = a ? k3(a) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case Bi:
        l[c] = l[c] - (t[u] / 2 - n[u] / 2);
        break;
      case Rs:
        l[c] = l[c] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Ds(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = r === void 0 ? e.placement : r, i = n.strategy, o = i === void 0 ? e.strategy : i, s = n.boundary, l = s === void 0 ? uH : s, c = n.rootBoundary, u = c === void 0 ? yy : c, d = n.elementContext, p = d === void 0 ? Oo : d, h = n.altBoundary, m = h === void 0 ? !1 : h, f = n.padding, C = f === void 0 ? 0 : f, _ = xy(typeof C != "number" ? C : Sy(C, y9)), v = p === Oo ? dH : Oo, w = e.rects.popper, k = e.elements[m ? v : p], b = UH($2(k) ? k : k.contextElement || Xa(e.elements.popper), l, u, o), S = Gi(e.elements.reference), P = My({
    reference: S,
    element: w,
    strategy: "absolute",
    placement: a
  }), O = X0(Object.assign({}, w, P)), A = p === Oo ? O : S, L = {
    top: b.top - A.top + _.top,
    bottom: A.bottom - b.bottom + _.bottom,
    left: b.left - A.left + _.left,
    right: A.right - b.right + _.right
  }, I = e.modifiersData.offset;
  if (p === Oo && I) {
    var D = I[a];
    Object.keys(L).forEach(function(U) {
      var z = [Zr, Ur].indexOf(U) >= 0 ? 1 : -1, $ = [Cr, Ur].indexOf(U) >= 0 ? "y" : "x";
      L[U] += D[$] * z;
    });
  }
  return L;
}
function ZH(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, a = n.boundary, i = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? vy : l, u = Ui(r), d = u ? s ? Yu : Yu.filter(function(m) {
    return Ui(m) === u;
  }) : y9, p = d.filter(function(m) {
    return c.indexOf(m) >= 0;
  });
  p.length === 0 && (p = d);
  var h = p.reduce(function(m, f) {
    return m[f] = Ds(e, {
      placement: f,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[$n(f)], m;
  }, {});
  return Object.keys(h).sort(function(m, f) {
    return h[m] - h[f];
  });
}
function KH(e) {
  if ($n(e) === w3)
    return [];
  var t = c6(e);
  return [Xu(e), t, Xu(t)];
}
function $H(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, p = n.altBoundary, h = n.flipVariations, m = h === void 0 ? !0 : h, f = n.allowedAutoPlacements, C = t.options.placement, _ = $n(C), v = _ === C, w = l || (v || !m ? [c6(C)] : KH(C)), k = [C].concat(w).reduce(function(Y, Q) {
      return Y.concat($n(Q) === w3 ? ZH(t, {
        placement: Q,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: m,
        allowedAutoPlacements: f
      }) : Q);
    }, []), b = t.rects.reference, S = t.rects.popper, P = /* @__PURE__ */ new Map(), O = !0, A = k[0], L = 0; L < k.length; L++) {
      var I = k[L], D = $n(I), U = Ui(I) === Bi, z = [Cr, Ur].indexOf(D) >= 0, $ = z ? "width" : "height", ee = Ds(t, {
        placement: I,
        boundary: u,
        rootBoundary: d,
        altBoundary: p,
        padding: c
      }), Z = z ? U ? Zr : gr : U ? Ur : Cr;
      b[$] > S[$] && (Z = c6(Z));
      var G = c6(Z), W = [];
      if (i && W.push(ee[D] <= 0), s && W.push(ee[Z] <= 0, ee[G] <= 0), W.every(function(Y) {
        return Y;
      })) {
        A = I, O = !1;
        break;
      }
      P.set(I, W);
    }
    if (O)
      for (var j = m ? 3 : 1, T = function(Y) {
        var Q = k.find(function(V) {
          var re = P.get(V);
          if (re)
            return re.slice(0, Y).every(function(q) {
              return q;
            });
        });
        if (Q)
          return A = Q, "break";
      }, F = j; F > 0; F--) {
        var N = T(F);
        if (N === "break")
          break;
      }
    t.placement !== A && (t.modifiersData[r]._skip = !0, t.placement = A, t.reset = !0);
  }
}
const WH = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: $H,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ed(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function td(e) {
  return [Cr, Zr, Ur, gr].some(function(t) {
    return e[t] >= 0;
  });
}
function YH(e) {
  var t = e.state, n = e.name, r = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = Ds(t, {
    elementContext: "reference"
  }), s = Ds(t, {
    altBoundary: !0
  }), l = ed(o, r), c = ed(s, a, i), u = td(l), d = td(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const qH = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: YH
};
function JH(e, t, n) {
  var r = $n(e), a = [gr, Cr].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [gr, Zr].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function XH(e) {
  var t = e.state, n = e.options, r = e.name, a = n.offset, i = a === void 0 ? [0, 0] : a, o = vy.reduce(function(u, d) {
    return u[d] = JH(d, t.rects, i), u;
  }, {}), s = o[t.placement], l = s.x, c = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = o;
}
const QH = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: XH
};
function eF(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = My({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const tF = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: eF,
  data: {}
};
function rF(e) {
  return e === "x" ? "y" : "x";
}
function nF(e) {
  var t = e.state, n = e.options, r = e.name, a = n.mainAxis, i = a === void 0 ? !0 : a, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, p = n.tether, h = p === void 0 ? !0 : p, m = n.tetherOffset, f = m === void 0 ? 0 : m, C = Ds(t, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), _ = $n(t.placement), v = Ui(t.placement), w = !v, k = k3(_), b = rF(k), S = t.modifiersData.popperOffsets, P = t.rects.reference, O = t.rects.popper, A = typeof f == "function" ? f(Object.assign({}, t.rects, {
    placement: t.placement
  })) : f, L = typeof A == "number" ? {
    mainAxis: A,
    altAxis: A
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, A), I = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (S) {
    if (i) {
      var U, z = k === "y" ? Cr : gr, $ = k === "y" ? Ur : Zr, ee = k === "y" ? "height" : "width", Z = S[k], G = Z + C[z], W = Z - C[$], j = h ? -O[ee] / 2 : 0, T = v === Bi ? P[ee] : O[ee], F = v === Bi ? -O[ee] : -P[ee], N = t.elements.arrow, Y = h && N ? S3(N) : {
        width: 0,
        height: 0
      }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : wy(), V = Q[z], re = Q[$], q = Cs(0, P[ee], Y[ee]), he = w ? P[ee] / 2 - j - q - V - L.mainAxis : T - q - V - L.mainAxis, me = w ? -P[ee] / 2 + j + q + re + L.mainAxis : F + q + re + L.mainAxis, Ne = t.elements.arrow && v9(t.elements.arrow), K = Ne ? k === "y" ? Ne.clientTop || 0 : Ne.clientLeft || 0 : 0, Ee = (U = I == null ? void 0 : I[k]) != null ? U : 0, J = Z + he - Ee - K, te = Z + me - Ee, ye = Cs(h ? Q6(G, J) : G, Z, h ? R2(W, te) : W);
      S[k] = ye, D[k] = ye - Z;
    }
    if (s) {
      var Pe, Ze = k === "x" ? Cr : gr, _t = k === "x" ? Ur : Zr, st = S[b], L1 = b === "y" ? "height" : "width", $t = st + C[Ze], Qt = st - C[_t], Ie = [Cr, gr].indexOf(_) !== -1, lt = (Pe = I == null ? void 0 : I[b]) != null ? Pe : 0, C1 = Ie ? $t : st - P[L1] - O[L1] - lt + L.altAxis, At = Ie ? st + P[L1] + O[L1] - lt - L.altAxis : Qt, g1 = h && Ie ? PH(C1, st, At) : Cs(h ? C1 : $t, st, h ? At : Qt);
      S[b] = g1, D[b] = g1 - st;
    }
    t.modifiersData[r] = D;
  }
}
const aF = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: nF,
  requiresIfExists: ["offset"]
};
function iF(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function oF(e) {
  return e === Rr(e) || !zr(e) ? M3(e) : iF(e);
}
function sF(e) {
  var t = e.getBoundingClientRect(), n = zi(t.width) / e.offsetWidth || 1, r = zi(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function lF(e, t, n) {
  n === void 0 && (n = !1);
  var r = zr(t), a = zr(t) && sF(t), i = Xa(t), o = Gi(e, a, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Jn(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  E3(i)) && (s = oF(t)), zr(t) ? (l = Gi(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = P3(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function cF(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    n.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && a(l);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || a(i);
  }), r;
}
function uF(e) {
  var t = cF(e);
  return _H.reduce(function(n, r) {
    return n.concat(t.filter(function(a) {
      return a.phase === r;
    }));
  }, []);
}
function dF(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function pF(e) {
  var t = e.reduce(function(n, r) {
    var a = n[r.name];
    return n[r.name] = a ? Object.assign({}, a, r, {
      options: Object.assign({}, a.options, r.options),
      data: Object.assign({}, a.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var rd = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function nd() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function hF(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, a = t.defaultOptions, i = a === void 0 ? rd : a;
  return function(o, s, l) {
    l === void 0 && (l = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, rd, i),
      modifiersData: {},
      elements: {
        reference: o,
        popper: s
      },
      attributes: {},
      styles: {}
    }, u = [], d = !1, p = {
      state: c,
      setOptions: function(f) {
        var C = typeof f == "function" ? f(c.options) : f;
        m(), c.options = Object.assign({}, i, c.options, C), c.scrollParents = {
          reference: $2(o) ? gs(o) : o.contextElement ? gs(o.contextElement) : [],
          popper: gs(s)
        };
        var _ = uF(pF([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = _.filter(function(v) {
          return v.enabled;
        }), h(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var f = c.elements, C = f.reference, _ = f.popper;
          if (nd(C, _)) {
            c.rects = {
              reference: lF(C, v9(_), c.options.strategy === "fixed"),
              popper: S3(_)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(O) {
              return c.modifiersData[O.name] = Object.assign({}, O.data);
            });
            for (var v = 0; v < c.orderedModifiers.length; v++) {
              if (c.reset === !0) {
                c.reset = !1, v = -1;
                continue;
              }
              var w = c.orderedModifiers[v], k = w.fn, b = w.options, S = b === void 0 ? {} : b, P = w.name;
              typeof k == "function" && (c = k({
                state: c,
                options: S,
                name: P,
                instance: p
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: dF(function() {
        return new Promise(function(f) {
          p.forceUpdate(), f(c);
        });
      }),
      destroy: function() {
        m(), d = !0;
      }
    };
    if (!nd(o, s))
      return p;
    p.setOptions(l).then(function(f) {
      !d && l.onFirstUpdate && l.onFirstUpdate(f);
    });
    function h() {
      c.orderedModifiers.forEach(function(f) {
        var C = f.name, _ = f.options, v = _ === void 0 ? {} : _, w = f.effect;
        if (typeof w == "function") {
          var k = w({
            state: c,
            name: C,
            instance: p,
            options: v
          }), b = function() {
          };
          u.push(k || b);
        }
      });
    }
    function m() {
      u.forEach(function(f) {
        return f();
      }), u = [];
    }
    return p;
  };
}
var mF = [IH, tF, RH, SH, QH, WH, aF, AH, qH], fF = /* @__PURE__ */ hF({
  defaultModifiers: mF
}), CF = typeof Element < "u", gF = typeof Map == "function", yF = typeof Set == "function", vF = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function u6(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, a;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!u6(e[r], t[r]))
          return !1;
      return !0;
    }
    var i;
    if (gF && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!u6(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (yF && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (vF && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[r]))
        return !1;
    if (CF && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((a[r] === "_owner" || a[r] === "__v" || a[r] === "__o") && e.$$typeof) && !u6(e[a[r]], t[a[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var bF = function(e, t) {
  try {
    return u6(e, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const _F = /* @__PURE__ */ A5(bF);
var wF = [], xF = function(e, t, n) {
  n === void 0 && (n = {});
  var r = pe.useRef(null), a = {
    onFirstUpdate: n.onFirstUpdate,
    placement: n.placement || "bottom",
    strategy: n.strategy || "absolute",
    modifiers: n.modifiers || wF
  }, i = pe.useState({
    styles: {
      popper: {
        position: a.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), o = i[0], s = i[1], l = pe.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(d) {
        var p = d.state, h = Object.keys(p.elements);
        xs.flushSync(function() {
          s({
            styles: $u(h.map(function(m) {
              return [m, p.styles[m] || {}];
            })),
            attributes: $u(h.map(function(m) {
              return [m, p.attributes[m]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), c = pe.useMemo(function() {
    var d = {
      onFirstUpdate: a.onFirstUpdate,
      placement: a.placement,
      strategy: a.strategy,
      modifiers: [].concat(a.modifiers, [l, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return _F(r.current, d) ? r.current || d : (r.current = d, d);
  }, [a.onFirstUpdate, a.placement, a.strategy, a.modifiers, l]), u = pe.useRef();
  return Wu(function() {
    u.current && u.current.setOptions(c);
  }, [c]), Wu(function() {
    if (!(e == null || t == null)) {
      var d = n.createPopper || fF, p = d(e, t, c);
      return u.current = p, function() {
        p.destroy(), u.current = null;
      };
    }
  }, [e, t, n.createPopper]), {
    state: u.current ? u.current.state : null,
    styles: o.styles,
    attributes: o.attributes,
    update: u.current ? u.current.update : null,
    forceUpdate: u.current ? u.current.forceUpdate : null
  };
}, SF = function() {
}, kF = function() {
  return Promise.resolve(null);
}, MF = [];
function PF(e) {
  var t = e.placement, n = t === void 0 ? "bottom" : t, r = e.strategy, a = r === void 0 ? "absolute" : r, i = e.modifiers, o = i === void 0 ? MF : i, s = e.referenceElement, l = e.onFirstUpdate, c = e.innerRef, u = e.children, d = pe.useContext(my), p = pe.useState(null), h = p[0], m = p[1], f = pe.useState(null), C = f[0], _ = f[1];
  pe.useEffect(function() {
    q0(c, h);
  }, [c, h]);
  var v = pe.useMemo(function() {
    return {
      placement: n,
      strategy: a,
      onFirstUpdate: l,
      modifiers: [].concat(o, [{
        name: "arrow",
        enabled: C != null,
        options: {
          element: C
        }
      }])
    };
  }, [n, a, l, o, C]), w = xF(s || d, h, v), k = w.state, b = w.styles, S = w.forceUpdate, P = w.update, O = pe.useMemo(function() {
    return {
      ref: m,
      style: b.popper,
      placement: k ? k.placement : n,
      hasPopperEscaped: k && k.modifiersData.hide ? k.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: k && k.modifiersData.hide ? k.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: b.arrow,
        ref: _
      },
      forceUpdate: S || SF,
      update: P || kF
    };
  }, [m, _, n, k, b, P, S]);
  return Cy(u)(O);
}
var EF = process.env.NODE_ENV !== "production", Py = function() {
};
if (EF) {
  var TF = function(e, t) {
    var n = arguments.length;
    t = new Array(n > 1 ? n - 1 : 0);
    for (var r = 1; r < n; r++)
      t[r - 1] = arguments[r];
    var a = 0, i = "Warning: " + e.replace(/%s/g, function() {
      return t[a++];
    });
    typeof console < "u" && console.error(i);
    try {
      throw new Error(i);
    } catch {
    }
  };
  Py = function(e, t, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var a = 2; a < r; a++)
      n[a - 2] = arguments[a];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || TF.apply(null, [t].concat(n));
  };
}
var LF = Py;
const AF = /* @__PURE__ */ A5(LF);
function OF(e) {
  var t = e.children, n = e.innerRef, r = pe.useContext(fy), a = pe.useCallback(function(i) {
    q0(n, i), gy(r, i);
  }, [n, r]);
  return pe.useEffect(function() {
    return function() {
      return q0(n, null);
    };
  }, []), pe.useEffect(function() {
    AF(!!r, "`Reference` should not be used outside of a `Manager` component.");
  }, [r]), Cy(t)({
    ref: a
  });
}
function NF(e, t) {
  if (Me(2, arguments), Gr(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var n = Oe(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = or(n, t.month)), t.date != null && n.setDate(dt(t.date)), t.hours != null && n.setHours(dt(t.hours)), t.minutes != null && n.setMinutes(dt(t.minutes)), t.seconds != null && n.setSeconds(dt(t.seconds)), t.milliseconds != null && n.setMilliseconds(dt(t.milliseconds)), n);
}
function ad(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function e5(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ad(Object(n), !0).forEach(function(r) {
      H(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ad(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Q0(e) {
  return Q0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Q0(e);
}
function H1(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function id(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Ey(r.key), r);
  }
}
function F1(e, t, n) {
  return t && id(e.prototype, t), n && id(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function H(e, t, n) {
  return (t = Ey(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Zi() {
  return Zi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zi.apply(this, arguments);
}
function V1(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && el(e, t);
}
function t5(e) {
  return t5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, t5(e);
}
function el(e, t) {
  return el = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, el(e, t);
}
function B(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function B1(e) {
  var t = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }();
  return function() {
    var n, r = t5(e);
    if (t) {
      var a = t5(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else
      n = r.apply(this, arguments);
    return function(i, o) {
      if (o && (typeof o == "object" || typeof o == "function"))
        return o;
      if (o !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return B(i);
    }(this, n);
  };
}
function Is(e) {
  return function(t) {
    if (Array.isArray(t))
      return g7(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || function(t, n) {
    if (t) {
      if (typeof t == "string")
        return g7(t, n);
      var r = Object.prototype.toString.call(t).slice(8, -1);
      if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
        return Array.from(t);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
        return g7(t, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function g7(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Ey(e) {
  var t = function(n, r) {
    if (typeof n != "object" || n === null)
      return n;
    var a = n[Symbol.toPrimitive];
    if (a !== void 0) {
      var i = a.call(n, r || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var od = function(e, t) {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, sd = function(e, t) {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, jF = { p: sd, P: function(e, t) {
  var n, r = e.match(/(P+)(p+)?/) || [], a = r[1], i = r[2];
  if (!i)
    return od(e, t);
  switch (a) {
    case "P":
      n = t.dateTime({ width: "short" });
      break;
    case "PP":
      n = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      n = t.dateTime({ width: "long" });
      break;
    default:
      n = t.dateTime({ width: "full" });
  }
  return n.replace("{{date}}", od(a, t)).replace("{{time}}", sd(i, t));
} }, ys = 12, RF = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function qt(e) {
  var t = e ? typeof e == "string" || e instanceof String ? II(e) : Oe(e) : /* @__PURE__ */ new Date();
  return Ra(t) ? t : null;
}
function Ra(e, t) {
  return t = t || /* @__PURE__ */ new Date("1/1/1000"), Os(e) && !Ha(e, t);
}
function s1(e, t, n) {
  if (n === "en")
    return Hu(e, t, { awareOfUnicodeTokens: !0 });
  var r = I2(n);
  return n && !r && console.warn('A locale object was not found for the provided string ["'.concat(n, '"].')), !r && D2() && I2(D2()) && (r = I2(D2())), Hu(e, t, { locale: r || null, awareOfUnicodeTokens: !0 });
}
function Tn(e, t) {
  var n = t.dateFormat, r = t.locale;
  return e && s1(e, Array.isArray(n) ? n[0] : n, r) || "";
}
function ld(e, t) {
  var n = t.hour, r = n === void 0 ? 0 : n, a = t.minute, i = a === void 0 ? 0 : a, o = t.second;
  return l6(s6(AD(e, o === void 0 ? 0 : o), i), r);
}
function Wn(e, t, n) {
  var r = I2(t || D2());
  return ay(e, { locale: r, weekStartsOn: n });
}
function Ua(e) {
  return iy(e);
}
function cs(e) {
  return oy(e);
}
function cd(e) {
  return Z0(e);
}
function ud() {
  return Kn(qt());
}
function Fa(e, t) {
  return e && t ? FD(e, t) : !e && !t;
}
function pn(e, t) {
  return e && t ? HD(e, t) : !e && !t;
}
function r5(e, t) {
  return e && t ? VD(e, t) : !e && !t;
}
function Xt(e, t) {
  return e && t ? ID(e, t) : !e && !t;
}
function T2(e, t) {
  return e && t ? DD(e, t) : !e && !t;
}
function d6(e, t, n) {
  var r, a = Kn(t), i = K0(n);
  try {
    r = js(e, { start: a, end: i });
  } catch {
    r = !1;
  }
  return r;
}
function D2() {
  return (typeof window < "u" ? window : globalThis).__localeId__;
}
function I2(e) {
  if (typeof e == "string") {
    var t = typeof window < "u" ? window : globalThis;
    return t.__localeData__ ? t.__localeData__[e] : null;
  }
  return e;
}
function T3(e, t) {
  return s1(or(qt(), e), "LLLL", t);
}
function Ty(e, t) {
  return s1(or(qt(), e), "LLL", t);
}
function h8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, i = t.excludeDateIntervals, o = t.includeDates, s = t.includeDateIntervals, l = t.filterDate;
  return m8(e, { minDate: n, maxDate: r }) || a && a.some(function(c) {
    return Xt(e, c);
  }) || i && i.some(function(c) {
    var u = c.start, d = c.end;
    return js(e, { start: u, end: d });
  }) || o && !o.some(function(c) {
    return Xt(e, c);
  }) || s && !s.some(function(c) {
    var u = c.start, d = c.end;
    return js(e, { start: u, end: d });
  }) || l && !l(qt(e)) || !1;
}
function L3(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.excludeDates, r = t.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(a) {
    var i = a.start, o = a.end;
    return js(e, { start: i, end: o });
  }) : n && n.some(function(a) {
    return Xt(e, a);
  }) || !1;
}
function Ly(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, i = t.includeDates, o = t.filterDate;
  return m8(e, { minDate: iy(n), maxDate: jD(r) }) || a && a.some(function(s) {
    return pn(e, s);
  }) || i && !i.some(function(s) {
    return pn(e, s);
  }) || o && !o(qt(e)) || !1;
}
function y7(e, t, n, r) {
  var a = pt(e), i = Y1(e), o = pt(t), s = Y1(t), l = pt(r);
  return a === o && a === l ? i <= n && n <= s : a < o ? l === a && i <= n || l === o && s >= n || l < o && l > a : void 0;
}
function DF(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, i = t.includeDates, o = t.filterDate;
  return m8(e, { minDate: n, maxDate: r }) || a && a.some(function(s) {
    return r5(e, s);
  }) || i && !i.some(function(s) {
    return r5(e, s);
  }) || o && !o(qt(e)) || !1;
}
function v7(e, t, n) {
  if (!Os(t) || !Os(n))
    return !1;
  var r = pt(t), a = pt(n);
  return r <= e && a >= e;
}
function Ay(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate, a = t.excludeDates, i = t.includeDates, o = t.filterDate, s = new Date(e, 0, 1);
  return m8(s, { minDate: oy(n), maxDate: RD(r) }) || a && a.some(function(l) {
    return Fa(s, l);
  }) || i && !i.some(function(l) {
    return Fa(s, l);
  }) || o && !o(qt(s)) || !1;
}
function b7(e, t, n, r) {
  var a = pt(e), i = bi(e), o = pt(t), s = bi(t), l = pt(r);
  return a === o && a === l ? i <= n && n <= s : a < o ? l === a && i <= n || l === o && s >= n || l < o && l > a : void 0;
}
function m8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.maxDate;
  return n && Y6(e, n) < 0 || r && Y6(e, r) > 0;
}
function dd(e, t) {
  return t.some(function(n) {
    return Zn(n) === Zn(e) && Un(n) === Un(e);
  });
}
function pd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.excludeTimes, r = t.includeTimes, a = t.filterTime;
  return n && dd(e, n) || r && !dd(e, r) || a && !a(e) || !1;
}
function hd(e, t) {
  var n = t.minTime, r = t.maxTime;
  if (!n || !r)
    throw new Error("Both minTime and maxTime props required");
  var a, i = qt(), o = l6(s6(i, Un(e)), Zn(e)), s = l6(s6(i, Un(n)), Zn(n)), l = l6(s6(i, Un(r)), Zn(r));
  try {
    a = !js(o, { start: s, end: l });
  } catch {
    a = !1;
  }
  return a;
}
function md(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.includeDates, a = Vi(e, 1);
  return n && q6(n, a) > 0 || r && r.every(function(i) {
    return q6(i, a) > 0;
  }) || !1;
}
function fd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.maxDate, r = t.includeDates, a = bn(e, 1);
  return n && q6(a, n) > 0 || r && r.every(function(i) {
    return q6(a, i) > 0;
  }) || !1;
}
function Cd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.minDate, r = t.includeDates, a = Ns(e, 1);
  return n && J6(n, a) > 0 || r && r.every(function(i) {
    return J6(i, a) > 0;
  }) || !1;
}
function gd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.maxDate, r = t.includeDates, a = Fi(e, 1);
  return n && J6(a, n) > 0 || r && r.every(function(i) {
    return J6(a, i) > 0;
  }) || !1;
}
function Oy(e) {
  var t = e.minDate, n = e.includeDates;
  if (n && t) {
    var r = n.filter(function(a) {
      return Y6(a, t) >= 0;
    });
    return zu(r);
  }
  return n ? zu(n) : t;
}
function Ny(e) {
  var t = e.maxDate, n = e.includeDates;
  if (n && t) {
    var r = n.filter(function(a) {
      return Y6(a, t) <= 0;
    });
    return Gu(r);
  }
  return n ? Gu(n) : t;
}
function yd() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", n = /* @__PURE__ */ new Map(), r = 0, a = e.length; r < a; r++) {
    var i = e[r];
    if (u8(i)) {
      var o = s1(i, "MM.dd.yyyy"), s = n.get(o) || [];
      s.includes(t) || (s.push(t), n.set(o, s));
    } else if (Q0(i) === "object") {
      var l = Object.keys(i), c = l[0], u = i[l[0]];
      if (typeof c == "string" && u.constructor === Array)
        for (var d = 0, p = u.length; d < p; d++) {
          var h = s1(u[d], "MM.dd.yyyy"), m = n.get(h) || [];
          m.includes(c) || (m.push(c), n.set(h, m));
        }
    }
  }
  return n;
}
function IF() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", n = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    var a = r.date, i = r.holidayName;
    if (u8(a)) {
      var o = s1(a, "MM.dd.yyyy"), s = n.get(o) || {};
      if (!("className" in s) || s.className !== t || (l = s.holidayNames, c = [i], l.length !== c.length || !l.every(function(d, p) {
        return d === c[p];
      }))) {
        var l, c;
        s.className = t;
        var u = s.holidayNames;
        s.holidayNames = u ? [].concat(Is(u), [i]) : [i], n.set(o, s);
      }
    }
  }), n;
}
function HF(e, t, n, r, a) {
  for (var i = a.length, o = [], s = 0; s < i; s++) {
    var l = G0(xD(e, Zn(a[s])), Un(a[s])), c = G0(e, (n + 1) * r);
    $a(l, t) && Ha(l, c) && o.push(a[s]);
  }
  return o;
}
function vd(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function _i(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ys, n = Math.ceil(pt(e) / t) * t;
  return { startPeriod: n - (t - 1), endPeriod: n };
}
function bd(e) {
  var t = e.getSeconds(), n = e.getMilliseconds();
  return Oe(e.getTime() - 1e3 * t - n);
}
function FF(e, t, n, r) {
  for (var a = [], i = 0; i < 2 * t + 1; i++) {
    var o = e + t - i, s = !0;
    n && (s = pt(n) <= o), r && s && (s = pt(r) >= o), s && a.push(o);
  }
  return a;
}
var VF = d8(function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n(r) {
    var a;
    H1(this, n), H(B(a = t.call(this, r)), "renderOptions", function() {
      var l = a.props.year, c = a.state.yearsList.map(function(p) {
        return M.createElement("div", { className: l === p ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: p, onClick: a.onChange.bind(B(a), p), "aria-selected": l === p ? "true" : void 0 }, l === p ? M.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", p);
      }), u = a.props.minDate ? pt(a.props.minDate) : null, d = a.props.maxDate ? pt(a.props.maxDate) : null;
      return d && a.state.yearsList.find(function(p) {
        return p === d;
      }) || c.unshift(M.createElement("div", { className: "react-datepicker__year-option", key: "upcoming", onClick: a.incrementYears }, M.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), u && a.state.yearsList.find(function(p) {
        return p === u;
      }) || c.push(M.createElement("div", { className: "react-datepicker__year-option", key: "previous", onClick: a.decrementYears }, M.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), c;
    }), H(B(a), "onChange", function(l) {
      a.props.onChange(l);
    }), H(B(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), H(B(a), "shiftYears", function(l) {
      var c = a.state.yearsList.map(function(u) {
        return u + l;
      });
      a.setState({ yearsList: c });
    }), H(B(a), "incrementYears", function() {
      return a.shiftYears(1);
    }), H(B(a), "decrementYears", function() {
      return a.shiftYears(-1);
    });
    var i = r.yearDropdownItemNumber, o = r.scrollableYearDropdown, s = i || (o ? 10 : 5);
    return a.state = { yearsList: FF(a.props.year, s, a.props.minDate, a.props.maxDate) }, a.dropdownRef = N2(), a;
  }
  return F1(n, [{ key: "componentDidMount", value: function() {
    var r = this.dropdownRef.current;
    if (r) {
      var a = r.children ? Array.from(r.children) : null, i = a ? a.find(function(o) {
        return o.ariaSelected;
      }) : null;
      r.scrollTop = i ? i.offsetTop + (i.clientHeight - r.clientHeight) / 2 : (r.scrollHeight - r.clientHeight) / 2;
    }
  } }, { key: "render", value: function() {
    var r = U1({ "react-datepicker__year-dropdown": !0, "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown });
    return M.createElement("div", { className: r, ref: this.dropdownRef }, this.renderOptions());
  } }]), n;
}()), BF = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), H(B(r), "renderSelectOptions", function() {
      for (var s = r.props.minDate ? pt(r.props.minDate) : 1900, l = r.props.maxDate ? pt(r.props.maxDate) : 2100, c = [], u = s; u <= l; u++)
        c.push(M.createElement("option", { key: u, value: u }, u));
      return c;
    }), H(B(r), "onSelectChange", function(s) {
      r.onChange(s.target.value);
    }), H(B(r), "renderSelectMode", function() {
      return M.createElement("select", { value: r.props.year, className: "react-datepicker__year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
    }), H(B(r), "renderReadView", function(s) {
      return M.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(l) {
        return r.toggleDropdown(l);
      } }, M.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), M.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, r.props.year));
    }), H(B(r), "renderDropdown", function() {
      return M.createElement(VF, { key: "dropdown", year: r.props.year, onChange: r.onChange, onCancel: r.toggleDropdown, minDate: r.props.minDate, maxDate: r.props.maxDate, scrollableYearDropdown: r.props.scrollableYearDropdown, yearDropdownItemNumber: r.props.yearDropdownItemNumber });
    }), H(B(r), "renderScrollMode", function() {
      var s = r.state.dropdownVisible, l = [r.renderReadView(!s)];
      return s && l.unshift(r.renderDropdown()), l;
    }), H(B(r), "onChange", function(s) {
      r.toggleDropdown(), s !== r.props.year && r.props.onChange(s);
    }), H(B(r), "toggleDropdown", function(s) {
      r.setState({ dropdownVisible: !r.state.dropdownVisible }, function() {
        r.props.adjustDateOnChange && r.handleYearChange(r.props.date, s);
      });
    }), H(B(r), "handleYearChange", function(s, l) {
      r.onSelect(s, l), r.setOpen();
    }), H(B(r), "onSelect", function(s, l) {
      r.props.onSelect && r.props.onSelect(s, l);
    }), H(B(r), "setOpen", function() {
      r.props.setOpen && r.props.setOpen(!0);
    }), r;
  }
  return F1(n, [{ key: "render", value: function() {
    var r;
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode();
        break;
      case "select":
        r = this.renderSelectMode();
    }
    return M.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}(), zF = d8(function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "isSelectedMonth", function(s) {
      return r.props.month === s;
    }), H(B(r), "renderOptions", function() {
      return r.props.monthNames.map(function(s, l) {
        return M.createElement("div", { className: r.isSelectedMonth(l) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: s, onClick: r.onChange.bind(B(r), l), "aria-selected": r.isSelectedMonth(l) ? "true" : void 0 }, r.isSelectedMonth(l) ? M.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", s);
      });
    }), H(B(r), "onChange", function(s) {
      return r.props.onChange(s);
    }), H(B(r), "handleClickOutside", function() {
      return r.props.onCancel();
    }), r;
  }
  return F1(n, [{ key: "render", value: function() {
    return M.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
  } }]), n;
}()), GF = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), H(B(r), "renderSelectOptions", function(s) {
      return s.map(function(l, c) {
        return M.createElement("option", { key: c, value: c }, l);
      });
    }), H(B(r), "renderSelectMode", function(s) {
      return M.createElement("select", { value: r.props.month, className: "react-datepicker__month-select", onChange: function(l) {
        return r.onChange(l.target.value);
      } }, r.renderSelectOptions(s));
    }), H(B(r), "renderReadView", function(s, l) {
      return M.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: r.toggleDropdown }, M.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), M.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, l[r.props.month]));
    }), H(B(r), "renderDropdown", function(s) {
      return M.createElement(zF, { key: "dropdown", month: r.props.month, monthNames: s, onChange: r.onChange, onCancel: r.toggleDropdown });
    }), H(B(r), "renderScrollMode", function(s) {
      var l = r.state.dropdownVisible, c = [r.renderReadView(!l, s)];
      return l && c.unshift(r.renderDropdown(s)), c;
    }), H(B(r), "onChange", function(s) {
      r.toggleDropdown(), s !== r.props.month && r.props.onChange(s);
    }), H(B(r), "toggleDropdown", function() {
      return r.setState({ dropdownVisible: !r.state.dropdownVisible });
    }), r;
  }
  return F1(n, [{ key: "render", value: function() {
    var r, a = this, i = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
      return Ty(o, a.props.locale);
    } : function(o) {
      return T3(o, a.props.locale);
    });
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode(i);
        break;
      case "select":
        r = this.renderSelectMode(i);
    }
    return M.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}();
function UF(e, t) {
  for (var n = [], r = Ua(e), a = Ua(t); !$a(r, a); )
    n.push(qt(r)), r = bn(r, 1);
  return n;
}
var ZF = d8(function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n(r) {
    var a;
    return H1(this, n), H(B(a = t.call(this, r)), "renderOptions", function() {
      return a.state.monthYearsList.map(function(i) {
        var o = U0(i), s = Fa(a.props.date, i) && pn(a.props.date, i);
        return M.createElement("div", { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: a.onChange.bind(B(a), o), "aria-selected": s ? "true" : void 0 }, s ? M.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", s1(i, a.props.dateFormat, a.props.locale));
      });
    }), H(B(a), "onChange", function(i) {
      return a.props.onChange(i);
    }), H(B(a), "handleClickOutside", function() {
      a.props.onCancel();
    }), a.state = { monthYearsList: UF(a.props.minDate, a.props.maxDate) }, a;
  }
  return F1(n, [{ key: "render", value: function() {
    var r = U1({ "react-datepicker__month-year-dropdown": !0, "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown });
    return M.createElement("div", { className: r }, this.renderOptions());
  } }]), n;
}()), KF = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "state", { dropdownVisible: !1 }), H(B(r), "renderSelectOptions", function() {
      for (var s = Ua(r.props.minDate), l = Ua(r.props.maxDate), c = []; !$a(s, l); ) {
        var u = U0(s);
        c.push(M.createElement("option", { key: u, value: u }, s1(s, r.props.dateFormat, r.props.locale))), s = bn(s, 1);
      }
      return c;
    }), H(B(r), "onSelectChange", function(s) {
      r.onChange(s.target.value);
    }), H(B(r), "renderSelectMode", function() {
      return M.createElement("select", { value: U0(Ua(r.props.date)), className: "react-datepicker__month-year-select", onChange: r.onSelectChange }, r.renderSelectOptions());
    }), H(B(r), "renderReadView", function(s) {
      var l = s1(r.props.date, r.props.dateFormat, r.props.locale);
      return M.createElement("div", { key: "read", style: { visibility: s ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: function(c) {
        return r.toggleDropdown(c);
      } }, M.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), M.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, l));
    }), H(B(r), "renderDropdown", function() {
      return M.createElement(ZF, { key: "dropdown", date: r.props.date, dateFormat: r.props.dateFormat, onChange: r.onChange, onCancel: r.toggleDropdown, minDate: r.props.minDate, maxDate: r.props.maxDate, scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown, locale: r.props.locale });
    }), H(B(r), "renderScrollMode", function() {
      var s = r.state.dropdownVisible, l = [r.renderReadView(!s)];
      return s && l.unshift(r.renderDropdown()), l;
    }), H(B(r), "onChange", function(s) {
      r.toggleDropdown();
      var l = qt(parseInt(s));
      Fa(r.props.date, l) && pn(r.props.date, l) || r.props.onChange(l);
    }), H(B(r), "toggleDropdown", function() {
      return r.setState({ dropdownVisible: !r.state.dropdownVisible });
    }), r;
  }
  return F1(n, [{ key: "render", value: function() {
    var r;
    switch (this.props.dropdownMode) {
      case "scroll":
        r = this.renderScrollMode();
        break;
      case "select":
        r = this.renderSelectMode();
    }
    return M.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, r);
  } }]), n;
}(), $F = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "dayEl", M.createRef()), H(B(r), "handleClick", function(s) {
      !r.isDisabled() && r.props.onClick && r.props.onClick(s);
    }), H(B(r), "handleMouseEnter", function(s) {
      !r.isDisabled() && r.props.onMouseEnter && r.props.onMouseEnter(s);
    }), H(B(r), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), r.props.handleOnKeyDown(s);
    }), H(B(r), "isSameDay", function(s) {
      return Xt(r.props.day, s);
    }), H(B(r), "isKeyboardSelected", function() {
      return !r.props.disabledKeyboardNavigation && !(r.isSameDay(r.props.selected) || r.isSameWeek(r.props.selected)) && (r.isSameDay(r.props.preSelection) || r.isSameWeek(r.props.preSelection));
    }), H(B(r), "isDisabled", function() {
      return h8(r.props.day, r.props);
    }), H(B(r), "isExcluded", function() {
      return L3(r.props.day, r.props);
    }), H(B(r), "isStartOfWeek", function() {
      return Xt(r.props.day, Wn(r.props.day, r.props.locale, r.props.calendarStartDay));
    }), H(B(r), "isSameWeek", function(s) {
      return r.props.showWeekPicker && Xt(s, Wn(r.props.day, r.props.locale, r.props.calendarStartDay));
    }), H(B(r), "getHighLightedClass", function() {
      var s = r.props, l = s.day, c = s.highlightDates;
      if (!c)
        return !1;
      var u = s1(l, "MM.dd.yyyy");
      return c.get(u);
    }), H(B(r), "getHolidaysClass", function() {
      var s = r.props, l = s.day, c = s.holidays;
      if (!c)
        return !1;
      var u = s1(l, "MM.dd.yyyy");
      return c.has(u) ? [c.get(u).className] : void 0;
    }), H(B(r), "isInRange", function() {
      var s = r.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && d6(l, c, u);
    }), H(B(r), "isInSelectingRange", function() {
      var s, l = r.props, c = l.day, u = l.selectsStart, d = l.selectsEnd, p = l.selectsRange, h = l.selectsDisabledDaysInRange, m = l.startDate, f = l.endDate, C = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return !(!(u || d || p) || !C || !h && r.isDisabled()) && (u && f && (Ha(C, f) || T2(C, f)) ? d6(c, C, f) : (d && m && ($a(C, m) || T2(C, m)) || !(!p || !m || f || !$a(C, m) && !T2(C, m))) && d6(c, m, C));
    }), H(B(r), "isSelectingRangeStart", function() {
      var s;
      if (!r.isInSelectingRange())
        return !1;
      var l = r.props, c = l.day, u = l.startDate, d = l.selectsStart, p = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return Xt(c, d ? p : u);
    }), H(B(r), "isSelectingRangeEnd", function() {
      var s;
      if (!r.isInSelectingRange())
        return !1;
      var l = r.props, c = l.day, u = l.endDate, d = l.selectsEnd, p = l.selectsRange, h = (s = r.props.selectingDate) !== null && s !== void 0 ? s : r.props.preSelection;
      return Xt(c, d || p ? h : u);
    }), H(B(r), "isRangeStart", function() {
      var s = r.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && Xt(c, l);
    }), H(B(r), "isRangeEnd", function() {
      var s = r.props, l = s.day, c = s.startDate, u = s.endDate;
      return !(!c || !u) && Xt(u, l);
    }), H(B(r), "isWeekend", function() {
      var s = MD(r.props.day);
      return s === 0 || s === 6;
    }), H(B(r), "isAfterMonth", function() {
      return r.props.month !== void 0 && (r.props.month + 1) % 12 === Y1(r.props.day);
    }), H(B(r), "isBeforeMonth", function() {
      return r.props.month !== void 0 && (Y1(r.props.day) + 1) % 12 === r.props.month;
    }), H(B(r), "isCurrentDay", function() {
      return r.isSameDay(qt());
    }), H(B(r), "isSelected", function() {
      return r.isSameDay(r.props.selected) || r.isSameWeek(r.props.selected);
    }), H(B(r), "getClassNames", function(s) {
      var l, c = r.props.dayClassName ? r.props.dayClassName(s) : void 0;
      return U1("react-datepicker__day", c, "react-datepicker__day--" + s1(r.props.day, "ddd", l), { "react-datepicker__day--disabled": r.isDisabled(), "react-datepicker__day--excluded": r.isExcluded(), "react-datepicker__day--selected": r.isSelected(), "react-datepicker__day--keyboard-selected": r.isKeyboardSelected(), "react-datepicker__day--range-start": r.isRangeStart(), "react-datepicker__day--range-end": r.isRangeEnd(), "react-datepicker__day--in-range": r.isInRange(), "react-datepicker__day--in-selecting-range": r.isInSelectingRange(), "react-datepicker__day--selecting-range-start": r.isSelectingRangeStart(), "react-datepicker__day--selecting-range-end": r.isSelectingRangeEnd(), "react-datepicker__day--today": r.isCurrentDay(), "react-datepicker__day--weekend": r.isWeekend(), "react-datepicker__day--outside-month": r.isAfterMonth() || r.isBeforeMonth() }, r.getHighLightedClass("react-datepicker__day--highlighted"), r.getHolidaysClass());
    }), H(B(r), "getAriaLabel", function() {
      var s = r.props, l = s.day, c = s.ariaLabelPrefixWhenEnabled, u = c === void 0 ? "Choose" : c, d = s.ariaLabelPrefixWhenDisabled, p = d === void 0 ? "Not available" : d, h = r.isDisabled() || r.isExcluded() ? p : u;
      return "".concat(h, " ").concat(s1(l, "PPPP", r.props.locale));
    }), H(B(r), "getTitle", function() {
      var s = r.props, l = s.day, c = s.holidays, u = c === void 0 ? /* @__PURE__ */ new Map() : c, d = s1(l, "MM.dd.yyyy");
      return u.has(d) && u.get(d).holidayNames.length > 0 ? u.get(d).holidayNames.join(", ") : "";
    }), H(B(r), "getTabIndex", function(s, l) {
      var c = s || r.props.selected, u = l || r.props.preSelection;
      return (!r.props.showWeekPicker || !r.props.showWeekNumber && r.isStartOfWeek()) && (r.isKeyboardSelected() || r.isSameDay(c) && Xt(u, c)) ? 0 : -1;
    }), H(B(r), "handleFocusDay", function() {
      var s, l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = !1;
      r.getTabIndex() === 0 && !l.isInputFocused && r.isSameDay(r.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (c = !0), r.props.inline && !r.props.shouldFocusDayInline && (c = !1), r.props.containerRef && r.props.containerRef.current && r.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (c = !0), r.props.monthShowsDuplicateDaysEnd && r.isAfterMonth() && (c = !1), r.props.monthShowsDuplicateDaysStart && r.isBeforeMonth() && (c = !1)), c && ((s = r.dayEl.current) === null || s === void 0 || s.focus({ preventScroll: !0 }));
    }), H(B(r), "renderDayContents", function() {
      return r.props.monthShowsDuplicateDaysEnd && r.isAfterMonth() || r.props.monthShowsDuplicateDaysStart && r.isBeforeMonth() ? null : r.props.renderDayContents ? r.props.renderDayContents(Bu(r.props.day), r.props.day) : Bu(r.props.day);
    }), H(B(r), "render", function() {
      return M.createElement("div", { ref: r.dayEl, className: r.getClassNames(r.props.day), onKeyDown: r.handleOnKeyDown, onClick: r.handleClick, onMouseEnter: r.handleMouseEnter, tabIndex: r.getTabIndex(), "aria-label": r.getAriaLabel(), role: "option", title: r.getTitle(), "aria-disabled": r.isDisabled(), "aria-current": r.isCurrentDay() ? "date" : void 0, "aria-selected": r.isSelected() || r.isInRange() }, r.renderDayContents(), r.getTitle() !== "" && M.createElement("span", { className: "holiday-overlay" }, r.getTitle()));
    }), r;
  }
  return F1(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusDay();
  } }, { key: "componentDidUpdate", value: function(r) {
    this.handleFocusDay(r);
  } }]), n;
}(), WF = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "weekNumberEl", M.createRef()), H(B(r), "handleClick", function(s) {
      r.props.onClick && r.props.onClick(s);
    }), H(B(r), "handleOnKeyDown", function(s) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), r.props.handleOnKeyDown(s);
    }), H(B(r), "isKeyboardSelected", function() {
      return !r.props.disabledKeyboardNavigation && !Xt(r.props.date, r.props.selected) && Xt(r.props.date, r.props.preSelection);
    }), H(B(r), "getTabIndex", function() {
      return r.props.showWeekPicker && r.props.showWeekNumber && (r.isKeyboardSelected() || Xt(r.props.date, r.props.selected) && Xt(r.props.preSelection, r.props.selected)) ? 0 : -1;
    }), H(B(r), "handleFocusWeekNumber", function() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, l = !1;
      r.getTabIndex() === 0 && !s.isInputFocused && Xt(r.props.date, r.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (l = !0), r.props.inline && !r.props.shouldFocusDayInline && (l = !1), r.props.containerRef && r.props.containerRef.current && r.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (l = !0)), l && r.weekNumberEl.current && r.weekNumberEl.current.focus({ preventScroll: !0 });
    }), r;
  }
  return F1(n, [{ key: "componentDidMount", value: function() {
    this.handleFocusWeekNumber();
  } }, { key: "componentDidUpdate", value: function(r) {
    this.handleFocusWeekNumber(r);
  } }, { key: "render", value: function() {
    var r = this.props, a = r.weekNumber, i = r.ariaLabelPrefix, o = i === void 0 ? "week " : i, s = { "react-datepicker__week-number": !0, "react-datepicker__week-number--clickable": !!r.onClick, "react-datepicker__week-number--selected": Xt(this.props.date, this.props.selected), "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected() };
    return M.createElement("div", { ref: this.weekNumberEl, className: U1(s), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, a);
  } }], [{ key: "defaultProps", get: function() {
    return { ariaLabelPrefix: "week " };
  } }]), n;
}(), YF = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "handleDayClick", function(s, l) {
      r.props.onDayClick && r.props.onDayClick(s, l);
    }), H(B(r), "handleDayMouseEnter", function(s) {
      r.props.onDayMouseEnter && r.props.onDayMouseEnter(s);
    }), H(B(r), "handleWeekClick", function(s, l, c) {
      if (typeof r.props.onWeekSelect == "function" && r.props.onWeekSelect(s, l, c), r.props.showWeekPicker) {
        var u = Wn(s, r.props.locale, r.props.calendarStartDay);
        r.handleDayClick(u, c);
      }
      r.props.shouldCloseOnSelect && r.props.setOpen(!1);
    }), H(B(r), "formatWeekNumber", function(s) {
      return r.props.formatWeekNumber ? r.props.formatWeekNumber(s) : function(l, c) {
        var u = D2() && I2(D2());
        return LD(l, u ? { locale: u } : null);
      }(s);
    }), H(B(r), "renderDays", function() {
      var s = Wn(r.props.day, r.props.locale, r.props.calendarStartDay), l = [], c = r.formatWeekNumber(s);
      if (r.props.showWeekNumber) {
        var u = r.props.onWeekSelect || r.props.showWeekPicker ? r.handleWeekClick.bind(B(r), s, c) : void 0;
        l.push(M.createElement(WF, { key: "W", weekNumber: c, date: s, onClick: u, selected: r.props.selected, preSelection: r.props.preSelection, ariaLabelPrefix: r.props.ariaLabelPrefix, showWeekPicker: r.props.showWeekPicker, showWeekNumber: r.props.showWeekNumber, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef }));
      }
      return l.concat([0, 1, 2, 3, 4, 5, 6].map(function(d) {
        var p = so(s, d);
        return M.createElement($F, { ariaLabelPrefixWhenEnabled: r.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: r.props.disabledDayAriaLabelPrefix, key: p.valueOf(), day: p, month: r.props.month, onClick: r.handleDayClick.bind(B(r), p), onMouseEnter: r.handleDayMouseEnter.bind(B(r), p), minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, highlightDates: r.props.highlightDates, holidays: r.props.holidays, selectingDate: r.props.selectingDate, filterDate: r.props.filterDate, preSelection: r.props.preSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, showWeekPicker: r.props.showWeekPicker, showWeekNumber: r.props.showWeekNumber, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, startDate: r.props.startDate, endDate: r.props.endDate, dayClassName: r.props.dayClassName, renderDayContents: r.props.renderDayContents, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart, locale: r.props.locale });
      }));
    }), H(B(r), "startOfWeek", function() {
      return Wn(r.props.day, r.props.locale, r.props.calendarStartDay);
    }), H(B(r), "isKeyboardSelected", function() {
      return !r.props.disabledKeyboardNavigation && !Xt(r.startOfWeek(), r.props.selected) && Xt(r.startOfWeek(), r.props.preSelection);
    }), r;
  }
  return F1(n, [{ key: "render", value: function() {
    var r = { "react-datepicker__week": !0, "react-datepicker__week--selected": Xt(this.startOfWeek(), this.props.selected), "react-datepicker__week--keyboard-selected": this.isKeyboardSelected() };
    return M.createElement("div", { className: U1(r) }, this.renderDays());
  } }], [{ key: "defaultProps", get: function() {
    return { shouldCloseOnSelect: !0 };
  } }]), n;
}(), jy = "two_columns", Ry = "three_columns", Dy = "four_columns", _7 = H(H(H({}, jy, { grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]], verticalNavigationOffset: 2 }), Ry, { grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]], verticalNavigationOffset: 3 }), Dy, { grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]], verticalNavigationOffset: 4 });
function _d(e, t) {
  return e ? Dy : t ? jy : Ry;
}
var qF = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "MONTH_REFS", Is(Array(12)).map(function() {
      return M.createRef();
    })), H(B(r), "QUARTER_REFS", Is(Array(4)).map(function() {
      return M.createRef();
    })), H(B(r), "isDisabled", function(s) {
      return h8(s, r.props);
    }), H(B(r), "isExcluded", function(s) {
      return L3(s, r.props);
    }), H(B(r), "handleDayClick", function(s, l) {
      r.props.onDayClick && r.props.onDayClick(s, l, r.props.orderInDisplay);
    }), H(B(r), "handleDayMouseEnter", function(s) {
      r.props.onDayMouseEnter && r.props.onDayMouseEnter(s);
    }), H(B(r), "handleMouseLeave", function() {
      r.props.onMouseLeave && r.props.onMouseLeave();
    }), H(B(r), "isRangeStartMonth", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && pn(or(c, s), u);
    }), H(B(r), "isRangeStartQuarter", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && r5(ci(c, s), u);
    }), H(B(r), "isRangeEndMonth", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && pn(or(c, s), d);
    }), H(B(r), "isRangeEndQuarter", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate;
      return !(!u || !d) && r5(ci(c, s), d);
    }), H(B(r), "isInSelectingRangeMonth", function(s) {
      var l, c = r.props, u = c.day, d = c.selectsStart, p = c.selectsEnd, h = c.selectsRange, m = c.startDate, f = c.endDate, C = (l = r.props.selectingDate) !== null && l !== void 0 ? l : r.props.preSelection;
      return !(!(d || p || h) || !C) && (d && f ? y7(C, f, s, u) : (p && m || !(!h || !m || f)) && y7(m, C, s, u));
    }), H(B(r), "isSelectingMonthRangeStart", function(s) {
      var l;
      if (!r.isInSelectingRangeMonth(s))
        return !1;
      var c = r.props, u = c.day, d = c.startDate, p = c.selectsStart, h = or(u, s), m = (l = r.props.selectingDate) !== null && l !== void 0 ? l : r.props.preSelection;
      return pn(h, p ? m : d);
    }), H(B(r), "isSelectingMonthRangeEnd", function(s) {
      var l;
      if (!r.isInSelectingRangeMonth(s))
        return !1;
      var c = r.props, u = c.day, d = c.endDate, p = c.selectsEnd, h = c.selectsRange, m = or(u, s), f = (l = r.props.selectingDate) !== null && l !== void 0 ? l : r.props.preSelection;
      return pn(m, p || h ? f : d);
    }), H(B(r), "isInSelectingRangeQuarter", function(s) {
      var l, c = r.props, u = c.day, d = c.selectsStart, p = c.selectsEnd, h = c.selectsRange, m = c.startDate, f = c.endDate, C = (l = r.props.selectingDate) !== null && l !== void 0 ? l : r.props.preSelection;
      return !(!(d || p || h) || !C) && (d && f ? b7(C, f, s, u) : (p && m || !(!h || !m || f)) && b7(m, C, s, u));
    }), H(B(r), "isWeekInMonth", function(s) {
      var l = r.props.day, c = so(s, 6);
      return pn(s, l) || pn(c, l);
    }), H(B(r), "isCurrentMonth", function(s, l) {
      return pt(s) === pt(qt()) && l === Y1(qt());
    }), H(B(r), "isCurrentQuarter", function(s, l) {
      return pt(s) === pt(qt()) && l === bi(qt());
    }), H(B(r), "isSelectedMonth", function(s, l, c) {
      return Y1(c) === l && pt(s) === pt(c);
    }), H(B(r), "isSelectedQuarter", function(s, l, c) {
      return bi(s) === l && pt(s) === pt(c);
    }), H(B(r), "renderWeeks", function() {
      for (var s = [], l = r.props.fixedHeight, c = 0, u = !1, d = Wn(Ua(r.props.day), r.props.locale, r.props.calendarStartDay); s.push(M.createElement(YF, { ariaLabelPrefix: r.props.weekAriaLabelPrefix, chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix, key: c, day: d, month: Y1(r.props.day), onDayClick: r.handleDayClick, onDayMouseEnter: r.handleDayMouseEnter, onWeekSelect: r.props.onWeekSelect, formatWeekNumber: r.props.formatWeekNumber, locale: r.props.locale, minDate: r.props.minDate, maxDate: r.props.maxDate, excludeDates: r.props.excludeDates, excludeDateIntervals: r.props.excludeDateIntervals, includeDates: r.props.includeDates, includeDateIntervals: r.props.includeDateIntervals, inline: r.props.inline, shouldFocusDayInline: r.props.shouldFocusDayInline, highlightDates: r.props.highlightDates, holidays: r.props.holidays, selectingDate: r.props.selectingDate, filterDate: r.props.filterDate, preSelection: r.props.preSelection, selected: r.props.selected, selectsStart: r.props.selectsStart, selectsEnd: r.props.selectsEnd, selectsRange: r.props.selectsRange, selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange, showWeekNumber: r.props.showWeekNumbers, showWeekPicker: r.props.showWeekPicker, startDate: r.props.startDate, endDate: r.props.endDate, dayClassName: r.props.dayClassName, setOpen: r.props.setOpen, shouldCloseOnSelect: r.props.shouldCloseOnSelect, disabledKeyboardNavigation: r.props.disabledKeyboardNavigation, renderDayContents: r.props.renderDayContents, handleOnKeyDown: r.props.handleOnKeyDown, isInputFocused: r.props.isInputFocused, containerRef: r.props.containerRef, calendarStartDay: r.props.calendarStartDay, monthShowsDuplicateDaysEnd: r.props.monthShowsDuplicateDaysEnd, monthShowsDuplicateDaysStart: r.props.monthShowsDuplicateDaysStart })), !u; ) {
        c++, d = $6(d, 1);
        var p = l && c >= 6, h = !l && !r.isWeekInMonth(d);
        if (p || h) {
          if (!r.props.peekNextMonth)
            break;
          u = !0;
        }
      }
      return s;
    }), H(B(r), "onMonthClick", function(s, l) {
      r.handleDayClick(Ua(or(r.props.day, l)), s);
    }), H(B(r), "onMonthMouseEnter", function(s) {
      r.handleDayMouseEnter(Ua(or(r.props.day, s)));
    }), H(B(r), "handleMonthNavigation", function(s, l) {
      r.isDisabled(l) || r.isExcluded(l) || (r.props.setPreSelection(l), r.MONTH_REFS[s].current && r.MONTH_REFS[s].current.focus());
    }), H(B(r), "onMonthKeyDown", function(s, l) {
      var c = r.props, u = c.selected, d = c.preSelection, p = c.disabledKeyboardNavigation, h = c.showTwoColumnMonthYearPicker, m = c.showFourColumnMonthYearPicker, f = c.setPreSelection, C = s.key;
      if (C !== "Tab" && s.preventDefault(), !p) {
        var _ = _d(m, h), v = _7[_].verticalNavigationOffset, w = _7[_].grid;
        switch (C) {
          case "Enter":
            r.onMonthClick(s, l), f(u);
            break;
          case "ArrowRight":
            r.handleMonthNavigation(l === 11 ? 0 : l + 1, bn(d, 1));
            break;
          case "ArrowLeft":
            r.handleMonthNavigation(l === 0 ? 11 : l - 1, Vi(d, 1));
            break;
          case "ArrowUp":
            r.handleMonthNavigation(w[0].includes(l) ? l + 12 - v : l - v, Vi(d, v));
            break;
          case "ArrowDown":
            r.handleMonthNavigation(w[w.length - 1].includes(l) ? l - 12 + v : l + v, bn(d, v));
        }
      }
    }), H(B(r), "onQuarterClick", function(s, l) {
      r.handleDayClick(cd(ci(r.props.day, l)), s);
    }), H(B(r), "onQuarterMouseEnter", function(s) {
      r.handleDayMouseEnter(cd(ci(r.props.day, s)));
    }), H(B(r), "handleQuarterNavigation", function(s, l) {
      r.isDisabled(l) || r.isExcluded(l) || (r.props.setPreSelection(l), r.QUARTER_REFS[s - 1].current && r.QUARTER_REFS[s - 1].current.focus());
    }), H(B(r), "onQuarterKeyDown", function(s, l) {
      var c = s.key;
      if (!r.props.disabledKeyboardNavigation)
        switch (c) {
          case "Enter":
            r.onQuarterClick(s, l), r.props.setPreSelection(r.props.selected);
            break;
          case "ArrowRight":
            r.handleQuarterNavigation(l === 4 ? 1 : l + 1, ny(r.props.preSelection, 1));
            break;
          case "ArrowLeft":
            r.handleQuarterNavigation(l === 1 ? 4 : l - 1, kD(r.props.preSelection, 1));
        }
    }), H(B(r), "getMonthClassNames", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate, p = l.selected, h = l.minDate, m = l.maxDate, f = l.preSelection, C = l.monthClassName, _ = l.excludeDates, v = l.includeDates, w = C ? C(or(c, s)) : void 0, k = or(c, s);
      return U1("react-datepicker__month-text", "react-datepicker__month-".concat(s), w, { "react-datepicker__month-text--disabled": (h || m || _ || v) && Ly(k, r.props), "react-datepicker__month-text--selected": r.isSelectedMonth(c, s, p), "react-datepicker__month-text--keyboard-selected": !r.props.disabledKeyboardNavigation && Y1(f) === s, "react-datepicker__month-text--in-selecting-range": r.isInSelectingRangeMonth(s), "react-datepicker__month-text--in-range": y7(u, d, s, c), "react-datepicker__month-text--range-start": r.isRangeStartMonth(s), "react-datepicker__month-text--range-end": r.isRangeEndMonth(s), "react-datepicker__month-text--selecting-range-start": r.isSelectingMonthRangeStart(s), "react-datepicker__month-text--selecting-range-end": r.isSelectingMonthRangeEnd(s), "react-datepicker__month-text--today": r.isCurrentMonth(c, s) });
    }), H(B(r), "getTabIndex", function(s) {
      var l = Y1(r.props.preSelection);
      return r.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    }), H(B(r), "getQuarterTabIndex", function(s) {
      var l = bi(r.props.preSelection);
      return r.props.disabledKeyboardNavigation || s !== l ? "-1" : "0";
    }), H(B(r), "getAriaLabel", function(s) {
      var l = r.props, c = l.chooseDayAriaLabelPrefix, u = c === void 0 ? "Choose" : c, d = l.disabledDayAriaLabelPrefix, p = d === void 0 ? "Not available" : d, h = l.day, m = or(h, s), f = r.isDisabled(m) || r.isExcluded(m) ? p : u;
      return "".concat(f, " ").concat(s1(m, "MMMM yyyy"));
    }), H(B(r), "getQuarterClassNames", function(s) {
      var l = r.props, c = l.day, u = l.startDate, d = l.endDate, p = l.selected, h = l.minDate, m = l.maxDate, f = l.preSelection, C = l.disabledKeyboardNavigation;
      return U1("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(s), { "react-datepicker__quarter-text--disabled": (h || m) && DF(ci(c, s), r.props), "react-datepicker__quarter-text--selected": r.isSelectedQuarter(c, s, p), "react-datepicker__quarter-text--keyboard-selected": !C && bi(f) === s, "react-datepicker__quarter-text--in-selecting-range": r.isInSelectingRangeQuarter(s), "react-datepicker__quarter-text--in-range": b7(u, d, s, c), "react-datepicker__quarter-text--range-start": r.isRangeStartQuarter(s), "react-datepicker__quarter-text--range-end": r.isRangeEndQuarter(s) });
    }), H(B(r), "getMonthContent", function(s) {
      var l = r.props, c = l.showFullMonthYearPicker, u = l.renderMonthContent, d = l.locale, p = l.day, h = Ty(s, d), m = T3(s, d);
      return u ? u(s, h, m, p) : c ? m : h;
    }), H(B(r), "getQuarterContent", function(s) {
      var l = r.props, c = l.renderQuarterContent, u = function(d, p) {
        return s1(ci(qt(), d), "QQQ", p);
      }(s, l.locale);
      return c ? c(s, u) : u;
    }), H(B(r), "renderMonths", function() {
      var s = r.props, l = s.showTwoColumnMonthYearPicker, c = s.showFourColumnMonthYearPicker, u = s.day, d = s.selected;
      return _7[_d(c, l)].grid.map(function(p, h) {
        return M.createElement("div", { className: "react-datepicker__month-wrapper", key: h }, p.map(function(m, f) {
          return M.createElement("div", { ref: r.MONTH_REFS[m], key: f, onClick: function(C) {
            r.onMonthClick(C, m);
          }, onKeyDown: function(C) {
            r.onMonthKeyDown(C, m);
          }, onMouseEnter: function() {
            return r.onMonthMouseEnter(m);
          }, tabIndex: r.getTabIndex(m), className: r.getMonthClassNames(m), role: "option", "aria-label": r.getAriaLabel(m), "aria-current": r.isCurrentMonth(u, m) ? "date" : void 0, "aria-selected": r.isSelectedMonth(u, m, d) }, r.getMonthContent(m));
        }));
      });
    }), H(B(r), "renderQuarters", function() {
      var s = r.props, l = s.day, c = s.selected;
      return M.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [1, 2, 3, 4].map(function(u, d) {
        return M.createElement("div", { key: d, ref: r.QUARTER_REFS[d], role: "option", onClick: function(p) {
          r.onQuarterClick(p, u);
        }, onKeyDown: function(p) {
          r.onQuarterKeyDown(p, u);
        }, onMouseEnter: function() {
          return r.onQuarterMouseEnter(u);
        }, className: r.getQuarterClassNames(u), "aria-selected": r.isSelectedQuarter(l, u, c), tabIndex: r.getQuarterTabIndex(u), "aria-current": r.isCurrentQuarter(l, u) ? "date" : void 0 }, r.getQuarterContent(u));
      }));
    }), H(B(r), "getClassNames", function() {
      var s = r.props, l = s.selectingDate, c = s.selectsStart, u = s.selectsEnd, d = s.showMonthYearPicker, p = s.showQuarterYearPicker, h = s.showWeekPicker;
      return U1("react-datepicker__month", { "react-datepicker__month--selecting-range": l && (c || u) }, { "react-datepicker__monthPicker": d }, { "react-datepicker__quarterPicker": p }, { "react-datepicker__weekPicker": h });
    }), r;
  }
  return F1(n, [{ key: "render", value: function() {
    var r = this.props, a = r.showMonthYearPicker, i = r.showQuarterYearPicker, o = r.day, s = r.ariaLabelPrefix, l = s === void 0 ? "month " : s;
    return M.createElement("div", { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, "aria-label": "".concat(l, " ").concat(s1(o, "yyyy-MM")), role: "listbox" }, a ? this.renderMonths() : i ? this.renderQuarters() : this.renderWeeks());
  } }]), n;
}(), Iy = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    var r;
    H1(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return H(B(r = t.call.apply(t, [this].concat(i))), "state", { height: null }), H(B(r), "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        r.list && (r.list.scrollTop = r.centerLi && n.calcCenterPosition(r.props.monthRef ? r.props.monthRef.clientHeight - r.header.clientHeight : r.list.clientHeight, r.centerLi));
      });
    }), H(B(r), "handleClick", function(s) {
      (r.props.minTime || r.props.maxTime) && hd(s, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && pd(s, r.props) || r.props.onChange(s);
    }), H(B(r), "isSelectedTime", function(s) {
      return r.props.selected && (l = r.props.selected, c = s, bd(l).getTime() === bd(c).getTime());
      var l, c;
    }), H(B(r), "isDisabledTime", function(s) {
      return (r.props.minTime || r.props.maxTime) && hd(s, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && pd(s, r.props);
    }), H(B(r), "liClasses", function(s) {
      var l = ["react-datepicker__time-list-item", r.props.timeClassName ? r.props.timeClassName(s) : void 0];
      return r.isSelectedTime(s) && l.push("react-datepicker__time-list-item--selected"), r.isDisabledTime(s) && l.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (60 * Zn(s) + Un(s)) % r.props.intervals != 0 && l.push("react-datepicker__time-list-item--injected"), l.join(" ");
    }), H(B(r), "handleOnKeyDown", function(s, l) {
      s.key === " " && (s.preventDefault(), s.key = "Enter"), s.key !== "ArrowUp" && s.key !== "ArrowLeft" || !s.target.previousSibling || (s.preventDefault(), s.target.previousSibling.focus()), s.key !== "ArrowDown" && s.key !== "ArrowRight" || !s.target.nextSibling || (s.preventDefault(), s.target.nextSibling.focus()), s.key === "Enter" && r.handleClick(l), r.props.handleOnKeyDown(s);
    }), H(B(r), "renderTimes", function() {
      for (var s = [], l = r.props.format ? r.props.format : "p", c = r.props.intervals, u = r.props.selected || r.props.openToDate || qt(), d = Kn(u), p = r.props.injectTimes && r.props.injectTimes.sort(function(w, k) {
        return w - k;
      }), h = 60 * function(w) {
        var k = new Date(w.getFullYear(), w.getMonth(), w.getDate()), b = new Date(w.getFullYear(), w.getMonth(), w.getDate(), 24);
        return Math.round((+b - +k) / 36e5);
      }(u), m = h / c, f = 0; f < m; f++) {
        var C = G0(d, f * c);
        if (s.push(C), p) {
          var _ = HF(d, C, f, c, p);
          s = s.concat(_);
        }
      }
      var v = s.reduce(function(w, k) {
        return k.getTime() <= u.getTime() ? k : w;
      }, s[0]);
      return s.map(function(w, k) {
        return M.createElement("li", { key: k, onClick: r.handleClick.bind(B(r), w), className: r.liClasses(w), ref: function(b) {
          w === v && (r.centerLi = b);
        }, onKeyDown: function(b) {
          r.handleOnKeyDown(b, w);
        }, tabIndex: w === v ? 0 : -1, role: "option", "aria-selected": r.isSelectedTime(w) ? "true" : void 0, "aria-disabled": r.isDisabledTime(w) ? "true" : void 0 }, s1(w, l, r.props.locale));
      });
    }), r;
  }
  return F1(n, [{ key: "componentDidMount", value: function() {
    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
  } }, { key: "render", value: function() {
    var r = this, a = this.state.height;
    return M.createElement("div", { className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "") }, M.createElement("div", { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(i) {
      r.header = i;
    } }, M.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)), M.createElement("div", { className: "react-datepicker__time" }, M.createElement("div", { className: "react-datepicker__time-box" }, M.createElement("ul", { className: "react-datepicker__time-list", ref: function(i) {
      r.list = i;
    }, style: a ? { height: a } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes()))));
  } }], [{ key: "defaultProps", get: function() {
    return { intervals: 30, onTimeChange: function() {
    }, todayButton: null, timeCaption: "Time" };
  } }]), n;
}();
H(Iy, "calcCenterPosition", function(e, t) {
  return t.offsetTop - (e / 2 - t.clientHeight / 2);
});
var JF = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n(r) {
    var a;
    return H1(this, n), H(B(a = t.call(this, r)), "YEAR_REFS", Is(Array(a.props.yearItemNumber)).map(function() {
      return M.createRef();
    })), H(B(a), "isDisabled", function(i) {
      return h8(i, a.props);
    }), H(B(a), "isExcluded", function(i) {
      return L3(i, a.props);
    }), H(B(a), "selectingDate", function() {
      var i;
      return (i = a.props.selectingDate) !== null && i !== void 0 ? i : a.props.preSelection;
    }), H(B(a), "updateFocusOnPaginate", function(i) {
      var o = (function() {
        this.YEAR_REFS[i].current.focus();
      }).bind(B(a));
      window.requestAnimationFrame(o);
    }), H(B(a), "handleYearClick", function(i, o) {
      a.props.onDayClick && a.props.onDayClick(i, o);
    }), H(B(a), "handleYearNavigation", function(i, o) {
      var s = a.props, l = s.date, c = s.yearItemNumber, u = _i(l, c).startPeriod;
      a.isDisabled(o) || a.isExcluded(o) || (a.props.setPreSelection(o), i - u == -1 ? a.updateFocusOnPaginate(c - 1) : i - u === c ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[i - u].current.focus());
    }), H(B(a), "isSameDay", function(i, o) {
      return Xt(i, o);
    }), H(B(a), "isCurrentYear", function(i) {
      return i === pt(qt());
    }), H(B(a), "isRangeStart", function(i) {
      return a.props.startDate && a.props.endDate && Fa(da(qt(), i), a.props.startDate);
    }), H(B(a), "isRangeEnd", function(i) {
      return a.props.startDate && a.props.endDate && Fa(da(qt(), i), a.props.endDate);
    }), H(B(a), "isInRange", function(i) {
      return v7(i, a.props.startDate, a.props.endDate);
    }), H(B(a), "isInSelectingRange", function(i) {
      var o = a.props, s = o.selectsStart, l = o.selectsEnd, c = o.selectsRange, u = o.startDate, d = o.endDate;
      return !(!(s || l || c) || !a.selectingDate()) && (s && d ? v7(i, a.selectingDate(), d) : (l && u || !(!c || !u || d)) && v7(i, u, a.selectingDate()));
    }), H(B(a), "isSelectingRangeStart", function(i) {
      if (!a.isInSelectingRange(i))
        return !1;
      var o = a.props, s = o.startDate, l = o.selectsStart, c = da(qt(), i);
      return Fa(c, l ? a.selectingDate() : s);
    }), H(B(a), "isSelectingRangeEnd", function(i) {
      if (!a.isInSelectingRange(i))
        return !1;
      var o = a.props, s = o.endDate, l = o.selectsEnd, c = o.selectsRange, u = da(qt(), i);
      return Fa(u, l || c ? a.selectingDate() : s);
    }), H(B(a), "isKeyboardSelected", function(i) {
      var o = cs(da(a.props.date, i));
      return !a.props.disabledKeyboardNavigation && !a.props.inline && !Xt(o, cs(a.props.selected)) && Xt(o, cs(a.props.preSelection));
    }), H(B(a), "onYearClick", function(i, o) {
      var s = a.props.date;
      a.handleYearClick(cs(da(s, o)), i);
    }), H(B(a), "onYearKeyDown", function(i, o) {
      var s = i.key;
      if (!a.props.disabledKeyboardNavigation)
        switch (s) {
          case "Enter":
            a.onYearClick(i, o), a.props.setPreSelection(a.props.selected);
            break;
          case "ArrowRight":
            a.handleYearNavigation(o + 1, Fi(a.props.preSelection, 1));
            break;
          case "ArrowLeft":
            a.handleYearNavigation(o - 1, Ns(a.props.preSelection, 1));
        }
    }), H(B(a), "getYearClassNames", function(i) {
      var o = a.props, s = o.minDate, l = o.maxDate, c = o.selected, u = o.excludeDates, d = o.includeDates, p = o.filterDate;
      return U1("react-datepicker__year-text", { "react-datepicker__year-text--selected": i === pt(c), "react-datepicker__year-text--disabled": (s || l || u || d || p) && Ay(i, a.props), "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(i), "react-datepicker__year-text--range-start": a.isRangeStart(i), "react-datepicker__year-text--range-end": a.isRangeEnd(i), "react-datepicker__year-text--in-range": a.isInRange(i), "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(i), "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(i), "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(i), "react-datepicker__year-text--today": a.isCurrentYear(i) });
    }), H(B(a), "getYearTabIndex", function(i) {
      return a.props.disabledKeyboardNavigation ? "-1" : i === pt(a.props.preSelection) ? "0" : "-1";
    }), H(B(a), "getYearContainerClassNames", function() {
      var i = a.props, o = i.selectingDate, s = i.selectsStart, l = i.selectsEnd, c = i.selectsRange;
      return U1("react-datepicker__year", { "react-datepicker__year--selecting-range": o && (s || l || c) });
    }), H(B(a), "getYearContent", function(i) {
      return a.props.renderYearContent ? a.props.renderYearContent(i) : i;
    }), a;
  }
  return F1(n, [{ key: "render", value: function() {
    for (var r = this, a = [], i = this.props, o = i.date, s = i.yearItemNumber, l = i.onYearMouseEnter, c = i.onYearMouseLeave, u = _i(o, s), d = u.startPeriod, p = u.endPeriod, h = function(f) {
      a.push(M.createElement("div", { ref: r.YEAR_REFS[f - d], onClick: function(C) {
        r.onYearClick(C, f);
      }, onKeyDown: function(C) {
        r.onYearKeyDown(C, f);
      }, tabIndex: r.getYearTabIndex(f), className: r.getYearClassNames(f), onMouseEnter: function(C) {
        return l(C, f);
      }, onMouseLeave: function(C) {
        return c(C, f);
      }, key: f, "aria-current": r.isCurrentYear(f) ? "date" : void 0 }, r.getYearContent(f)));
    }, m = d; m <= p; m++)
      h(m);
    return M.createElement("div", { className: this.getYearContainerClassNames() }, M.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.clearSelectingDate }, a));
  } }]), n;
}(), XF = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n(r) {
    var a;
    return H1(this, n), H(B(a = t.call(this, r)), "onTimeChange", function(i) {
      a.setState({ time: i });
      var o = a.props.date, s = o instanceof Date && !isNaN(o) ? o : /* @__PURE__ */ new Date();
      s.setHours(i.split(":")[0]), s.setMinutes(i.split(":")[1]), a.props.onChange(s);
    }), H(B(a), "renderTimeInput", function() {
      var i = a.state.time, o = a.props, s = o.date, l = o.timeString, c = o.customTimeInput;
      return c ? M.cloneElement(c, { date: s, value: i, onChange: a.onTimeChange }) : M.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: i, onChange: function(u) {
        a.onTimeChange(u.target.value || l);
      } });
    }), a.state = { time: a.props.timeString }, a;
  }
  return F1(n, [{ key: "render", value: function() {
    return M.createElement("div", { className: "react-datepicker__input-time-container" }, M.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), M.createElement("div", { className: "react-datepicker-time__input-container" }, M.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
  } }], [{ key: "getDerivedStateFromProps", value: function(r, a) {
    return r.timeString !== a.time ? { time: r.timeString } : null;
  } }]), n;
}();
function QF(e) {
  var t = e.className, n = e.children, r = e.showPopperArrow, a = e.arrowProps, i = a === void 0 ? {} : a;
  return M.createElement("div", { className: t }, r && M.createElement("div", Zi({ className: "react-datepicker__triangle" }, i)), n);
}
var eV = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], tV = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n(r) {
    var a;
    return H1(this, n), H(B(a = t.call(this, r)), "handleClickOutside", function(i) {
      a.props.onClickOutside(i);
    }), H(B(a), "setClickOutsideRef", function() {
      return a.containerRef.current;
    }), H(B(a), "handleDropdownFocus", function(i) {
      (function() {
        var o = ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).className || "").split(/\s+/);
        return eV.some(function(s) {
          return o.indexOf(s) >= 0;
        });
      })(i.target) && a.props.onDropdownFocus();
    }), H(B(a), "getDateInView", function() {
      var i = a.props, o = i.preSelection, s = i.selected, l = i.openToDate, c = Oy(a.props), u = Ny(a.props), d = qt(), p = l || s || o;
      return p || (c && Ha(d, c) ? c : u && $a(d, u) ? u : d);
    }), H(B(a), "increaseMonth", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: bn(o, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), H(B(a), "decreaseMonth", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: Vi(o, 1) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), H(B(a), "handleDayClick", function(i, o, s) {
      a.props.onSelect(i, o, s), a.props.setPreSelection && a.props.setPreSelection(i);
    }), H(B(a), "handleDayMouseEnter", function(i) {
      a.setState({ selectingDate: i }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(i);
    }), H(B(a), "handleMonthMouseLeave", function() {
      a.setState({ selectingDate: null }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
    }), H(B(a), "handleYearMouseEnter", function(i, o) {
      a.setState({ selectingDate: da(qt(), o) }), a.props.onYearMouseEnter && a.props.onYearMouseEnter(i, o);
    }), H(B(a), "handleYearMouseLeave", function(i, o) {
      a.props.onYearMouseLeave && a.props.onYearMouseLeave(i, o);
    }), H(B(a), "handleYearChange", function(i) {
      a.props.onYearChange && (a.props.onYearChange(i), a.setState({ isRenderAriaLiveMessage: !0 })), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(i), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(i);
    }), H(B(a), "handleMonthChange", function(i) {
      a.handleCustomMonthChange(i), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(i), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(i);
    }), H(B(a), "handleCustomMonthChange", function(i) {
      a.props.onMonthChange && (a.props.onMonthChange(i), a.setState({ isRenderAriaLiveMessage: !0 }));
    }), H(B(a), "handleMonthYearChange", function(i) {
      a.handleYearChange(i), a.handleMonthChange(i);
    }), H(B(a), "changeYear", function(i) {
      a.setState(function(o) {
        var s = o.date;
        return { date: da(s, i) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), H(B(a), "changeMonth", function(i) {
      a.setState(function(o) {
        var s = o.date;
        return { date: or(s, i) };
      }, function() {
        return a.handleMonthChange(a.state.date);
      });
    }), H(B(a), "changeMonthYear", function(i) {
      a.setState(function(o) {
        var s = o.date;
        return { date: da(or(s, Y1(i)), pt(i)) };
      }, function() {
        return a.handleMonthYearChange(a.state.date);
      });
    }), H(B(a), "header", function() {
      var i = Wn(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, a.props.locale, a.props.calendarStartDay), o = [];
      return a.props.showWeekNumbers && o.push(M.createElement("div", { key: "W", className: "react-datepicker__day-name" }, a.props.weekLabel || "#")), o.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
        var l = so(i, s), c = a.formatWeekday(l, a.props.locale), u = a.props.weekDayClassName ? a.props.weekDayClassName(l) : void 0;
        return M.createElement("div", { key: s, className: U1("react-datepicker__day-name", u) }, c);
      }));
    }), H(B(a), "formatWeekday", function(i, o) {
      return a.props.formatWeekDay ? function(s, l, c) {
        return l(s1(s, "EEEE", c));
      }(i, a.props.formatWeekDay, o) : a.props.useWeekdaysShort ? function(s, l) {
        return s1(s, "EEE", l);
      }(i, o) : function(s, l) {
        return s1(s, "EEEEEE", l);
      }(i, o);
    }), H(B(a), "decreaseYear", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: Ns(o, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), H(B(a), "clearSelectingDate", function() {
      a.setState({ selectingDate: null });
    }), H(B(a), "renderPreviousButton", function() {
      if (!a.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case a.props.showMonthYearPicker:
            i = Cd(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            i = function(_) {
              var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = v.minDate, k = v.yearItemNumber, b = k === void 0 ? ys : k, S = _i(cs(Ns(_, b)), b).endPeriod, P = w && pt(w);
              return P && P > S || !1;
            }(a.state.date, a.props);
            break;
          default:
            i = md(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !i) && !a.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], s = a.decreaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (s = a.decreaseYear), i && a.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--previous--disabled"), s = null);
          var l = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, c = a.props, u = c.previousMonthButtonLabel, d = c.previousYearButtonLabel, p = a.props, h = p.previousMonthAriaLabel, m = h === void 0 ? typeof u == "string" ? u : "Previous Month" : h, f = p.previousYearAriaLabel, C = f === void 0 ? typeof d == "string" ? d : "Previous Year" : f;
          return M.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: a.props.handleOnKeyDown, "aria-label": l ? C : m }, M.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"].join(" ") }, l ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
        }
      }
    }), H(B(a), "increaseYear", function() {
      a.setState(function(i) {
        var o = i.date;
        return { date: Fi(o, a.props.showYearPicker ? a.props.yearItemNumber : 1) };
      }, function() {
        return a.handleYearChange(a.state.date);
      });
    }), H(B(a), "renderNextButton", function() {
      if (!a.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case a.props.showMonthYearPicker:
            i = gd(a.state.date, a.props);
            break;
          case a.props.showYearPicker:
            i = function(_) {
              var v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, w = v.maxDate, k = v.yearItemNumber, b = k === void 0 ? ys : k, S = _i(Fi(_, b), b).startPeriod, P = w && pt(w);
              return P && P < S || !1;
            }(a.state.date, a.props);
            break;
          default:
            i = fd(a.state.date, a.props);
        }
        if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !i) && !a.props.showTimeSelectOnly) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
          a.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
          var s = a.increaseMonth;
          (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (s = a.increaseYear), i && a.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), s = null);
          var l = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, c = a.props, u = c.nextMonthButtonLabel, d = c.nextYearButtonLabel, p = a.props, h = p.nextMonthAriaLabel, m = h === void 0 ? typeof u == "string" ? u : "Next Month" : h, f = p.nextYearAriaLabel, C = f === void 0 ? typeof d == "string" ? d : "Next Year" : f;
          return M.createElement("button", { type: "button", className: o.join(" "), onClick: s, onKeyDown: a.props.handleOnKeyDown, "aria-label": l ? C : m }, M.createElement("span", { className: ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"].join(" ") }, l ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
        }
      }
    }), H(B(a), "renderCurrentMonth", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a.state.date, o = ["react-datepicker__current-month"];
      return a.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), M.createElement("div", { className: o.join(" ") }, s1(i, a.props.dateFormat, a.props.locale));
    }), H(B(a), "renderYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showYearDropdown && !i)
        return M.createElement(BF, { adjustDateOnChange: a.props.adjustDateOnChange, date: a.state.date, onSelect: a.props.onSelect, setOpen: a.props.setOpen, dropdownMode: a.props.dropdownMode, onChange: a.changeYear, minDate: a.props.minDate, maxDate: a.props.maxDate, year: pt(a.state.date), scrollableYearDropdown: a.props.scrollableYearDropdown, yearDropdownItemNumber: a.props.yearDropdownItemNumber });
    }), H(B(a), "renderMonthDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthDropdown && !i)
        return M.createElement(GF, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, onChange: a.changeMonth, month: Y1(a.state.date), useShortMonthInDropdown: a.props.useShortMonthInDropdown });
    }), H(B(a), "renderMonthYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      if (a.props.showMonthYearDropdown && !i)
        return M.createElement(KF, { dropdownMode: a.props.dropdownMode, locale: a.props.locale, dateFormat: a.props.dateFormat, onChange: a.changeMonthYear, minDate: a.props.minDate, maxDate: a.props.maxDate, date: a.state.date, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown });
    }), H(B(a), "handleTodayButtonClick", function(i) {
      a.props.onSelect(ud(), i), a.props.setPreSelection && a.props.setPreSelection(ud());
    }), H(B(a), "renderTodayButton", function() {
      if (a.props.todayButton && !a.props.showTimeSelectOnly)
        return M.createElement("div", { className: "react-datepicker__today-button", onClick: function(i) {
          return a.handleTodayButtonClick(i);
        } }, a.props.todayButton);
    }), H(B(a), "renderDefaultHeader", function(i) {
      var o = i.monthDate, s = i.i;
      return M.createElement("div", { className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") }, a.renderCurrentMonth(o), M.createElement("div", { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode), onFocus: a.handleDropdownFocus }, a.renderMonthDropdown(s !== 0), a.renderMonthYearDropdown(s !== 0), a.renderYearDropdown(s !== 0)), M.createElement("div", { className: "react-datepicker__day-names" }, a.header(o)));
    }), H(B(a), "renderCustomHeader", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = i.monthDate, s = i.i;
      if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly)
        return null;
      var l = md(a.state.date, a.props), c = fd(a.state.date, a.props), u = Cd(a.state.date, a.props), d = gd(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
      return M.createElement("div", { className: "react-datepicker__header react-datepicker__header--custom", onFocus: a.props.onDropdownFocus }, a.props.renderCustomHeader(e5(e5({}, a.state), {}, { customHeaderCount: s, monthDate: o, changeMonth: a.changeMonth, changeYear: a.changeYear, decreaseMonth: a.decreaseMonth, increaseMonth: a.increaseMonth, decreaseYear: a.decreaseYear, increaseYear: a.increaseYear, prevMonthButtonDisabled: l, nextMonthButtonDisabled: c, prevYearButtonDisabled: u, nextYearButtonDisabled: d })), p && M.createElement("div", { className: "react-datepicker__day-names" }, a.header(o)));
    }), H(B(a), "renderYearHeader", function() {
      var i = a.state.date, o = a.props, s = o.showYearPicker, l = _i(i, o.yearItemNumber), c = l.startPeriod, u = l.endPeriod;
      return M.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(c, " - ").concat(u) : pt(i));
    }), H(B(a), "renderHeader", function(i) {
      switch (!0) {
        case a.props.renderCustomHeader !== void 0:
          return a.renderCustomHeader(i);
        case (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker):
          return a.renderYearHeader(i);
        default:
          return a.renderDefaultHeader(i);
      }
    }), H(B(a), "renderMonths", function() {
      var i;
      if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
        for (var o = [], s = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, l = Vi(a.state.date, s), c = (i = a.props.monthSelectedIn) !== null && i !== void 0 ? i : s, u = 0; u < a.props.monthsShown; ++u) {
          var d = bn(l, u - c + s), p = "month-".concat(u), h = u < a.props.monthsShown - 1, m = u > 0;
          o.push(M.createElement("div", { key: p, ref: function(f) {
            a.monthContainer = f;
          }, className: "react-datepicker__month-container" }, a.renderHeader({ monthDate: d, i: u }), M.createElement(qF, { chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, ariaLabelPrefix: a.props.monthAriaLabelPrefix, onChange: a.changeMonthYear, day: d, dayClassName: a.props.dayClassName, calendarStartDay: a.props.calendarStartDay, monthClassName: a.props.monthClassName, onDayClick: a.handleDayClick, handleOnKeyDown: a.props.handleOnDayKeyDown, onDayMouseEnter: a.handleDayMouseEnter, onMouseLeave: a.handleMonthMouseLeave, onWeekSelect: a.props.onWeekSelect, orderInDisplay: u, formatWeekNumber: a.props.formatWeekNumber, locale: a.props.locale, minDate: a.props.minDate, maxDate: a.props.maxDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, highlightDates: a.props.highlightDates, holidays: a.props.holidays, selectingDate: a.state.selectingDate, includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, inline: a.props.inline, shouldFocusDayInline: a.props.shouldFocusDayInline, fixedHeight: a.props.fixedHeight, filterDate: a.props.filterDate, preSelection: a.props.preSelection, setPreSelection: a.props.setPreSelection, selected: a.props.selected, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showWeekNumbers: a.props.showWeekNumbers, startDate: a.props.startDate, endDate: a.props.endDate, peekNextMonth: a.props.peekNextMonth, setOpen: a.props.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, renderDayContents: a.props.renderDayContents, renderMonthContent: a.props.renderMonthContent, renderQuarterContent: a.props.renderQuarterContent, renderYearContent: a.props.renderYearContent, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, showWeekPicker: a.props.showWeekPicker, isInputFocused: a.props.isInputFocused, containerRef: a.containerRef, monthShowsDuplicateDaysEnd: h, monthShowsDuplicateDaysStart: m })));
        }
        return o;
      }
    }), H(B(a), "renderYears", function() {
      if (!a.props.showTimeSelectOnly)
        return a.props.showYearPicker ? M.createElement("div", { className: "react-datepicker__year--container" }, a.renderHeader(), M.createElement(JF, Zi({ onDayClick: a.handleDayClick, selectingDate: a.state.selectingDate, clearSelectingDate: a.clearSelectingDate, date: a.state.date }, a.props, { onYearMouseEnter: a.handleYearMouseEnter, onYearMouseLeave: a.handleYearMouseLeave }))) : void 0;
    }), H(B(a), "renderTimeSection", function() {
      if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly))
        return M.createElement(Iy, { selected: a.props.selected, openToDate: a.props.openToDate, onChange: a.props.onTimeChange, timeClassName: a.props.timeClassName, format: a.props.timeFormat, includeTimes: a.props.includeTimes, intervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, todayButton: a.props.todayButton, showMonthDropdown: a.props.showMonthDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, monthRef: a.state.monthContainer, injectTimes: a.props.injectTimes, locale: a.props.locale, handleOnKeyDown: a.props.handleOnKeyDown, showTimeSelectOnly: a.props.showTimeSelectOnly });
    }), H(B(a), "renderInputTimeSection", function() {
      var i = new Date(a.props.selected), o = Ra(i) && a.props.selected ? "".concat(vd(i.getHours()), ":").concat(vd(i.getMinutes())) : "";
      if (a.props.showTimeInput)
        return M.createElement(XF, { date: i, timeString: o, timeInputLabel: a.props.timeInputLabel, onChange: a.props.onTimeChange, customTimeInput: a.props.customTimeInput });
    }), H(B(a), "renderAriaLiveRegion", function() {
      var i, o = _i(a.state.date, a.props.yearItemNumber), s = o.startPeriod, l = o.endPeriod;
      return i = a.props.showYearPicker ? "".concat(s, " - ").concat(l) : a.props.showMonthYearPicker || a.props.showQuarterYearPicker ? pt(a.state.date) : "".concat(T3(Y1(a.state.date), a.props.locale), " ").concat(pt(a.state.date)), M.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, a.state.isRenderAriaLiveMessage && i);
    }), H(B(a), "renderChildren", function() {
      if (a.props.children)
        return M.createElement("div", { className: "react-datepicker__children-container" }, a.props.children);
    }), a.containerRef = M.createRef(), a.state = { date: a.getDateInView(), selectingDate: null, monthContainer: null, isRenderAriaLiveMessage: !1 }, a;
  }
  return F1(n, [{ key: "componentDidMount", value: function() {
    var r = this;
    this.props.showTimeSelect && (this.assignMonthContainer = void r.setState({ monthContainer: r.monthContainer }));
  } }, { key: "componentDidUpdate", value: function(r) {
    var a = this;
    if (!this.props.preSelection || Xt(this.props.preSelection, r.preSelection) && this.props.monthSelectedIn === r.monthSelectedIn)
      this.props.openToDate && !Xt(this.props.openToDate, r.openToDate) && this.setState({ date: this.props.openToDate });
    else {
      var i = !pn(this.state.date, this.props.preSelection);
      this.setState({ date: this.props.preSelection }, function() {
        return i && a.handleCustomMonthChange(a.state.date);
      });
    }
  } }, { key: "render", value: function() {
    var r = this.props.container || QF;
    return M.createElement("div", { style: { display: "contents" }, ref: this.containerRef }, M.createElement(r, { className: U1("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }), showPopperArrow: this.props.showPopperArrow, arrowProps: this.props.arrowProps }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
  } }], [{ key: "defaultProps", get: function() {
    return { onDropdownFocus: function() {
    }, monthsShown: 1, forceShowMonthNavigation: !1, timeCaption: "Time", previousYearButtonLabel: "Previous Year", nextYearButtonLabel: "Next Year", previousMonthButtonLabel: "Previous Month", nextMonthButtonLabel: "Next Month", customTimeInput: null, yearItemNumber: ys };
  } }]), n;
}(), rV = function(e) {
  var t = e.icon, n = e.className, r = n === void 0 ? "" : n, a = e.onClick, i = "react-datepicker__calendar-icon";
  return M.isValidElement(t) ? M.cloneElement(t, { className: "".concat(t.props.className || "", " ").concat(i, " ").concat(r), onClick: function(o) {
    typeof t.props.onClick == "function" && t.props.onClick(o), typeof a == "function" && a(o);
  } }) : typeof t == "string" ? M.createElement("i", { className: "".concat(i, " ").concat(t, " ").concat(r), "aria-hidden": "true", onClick: a }) : M.createElement("svg", { className: "".concat(i, " ").concat(r), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: a }, M.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, Hy = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n(r) {
    var a;
    return H1(this, n), (a = t.call(this, r)).el = document.createElement("div"), a;
  }
  return F1(n, [{ key: "componentDidMount", value: function() {
    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
  } }, { key: "componentWillUnmount", value: function() {
    this.portalRoot.removeChild(this.el);
  } }, { key: "render", value: function() {
    return rx.createPortal(this.props.children, this.el);
  } }]), n;
}(), nV = function(e) {
  return !e.disabled && e.tabIndex !== -1;
}, Fy = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n(r) {
    var a;
    return H1(this, n), H(B(a = t.call(this, r)), "getTabChildren", function() {
      return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(nV);
    }), H(B(a), "handleFocusStart", function() {
      var i = a.getTabChildren();
      i && i.length > 1 && i[i.length - 1].focus();
    }), H(B(a), "handleFocusEnd", function() {
      var i = a.getTabChildren();
      i && i.length > 1 && i[0].focus();
    }), a.tabLoopRef = M.createRef(), a;
  }
  return F1(n, [{ key: "render", value: function() {
    return this.props.enableTabLoop ? M.createElement("div", { className: "react-datepicker__tab-loop", ref: this.tabLoopRef }, M.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: "0", onFocus: this.handleFocusStart }), this.props.children, M.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: "0", onFocus: this.handleFocusEnd })) : this.props.children;
  } }], [{ key: "defaultProps", get: function() {
    return { enableTabLoop: !0 };
  } }]), n;
}(), aV = function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n() {
    return H1(this, n), t.apply(this, arguments);
  }
  return F1(n, [{ key: "render", value: function() {
    var r, a = this.props, i = a.className, o = a.wrapperClassName, s = a.hidePopper, l = a.popperComponent, c = a.popperModifiers, u = a.popperPlacement, d = a.popperProps, p = a.targetComponent, h = a.enableTabLoop, m = a.popperOnKeyDown, f = a.portalId, C = a.portalHost;
    if (!s) {
      var _ = U1("react-datepicker-popper", i);
      r = M.createElement(PF, Zi({ modifiers: c, placement: u }, d), function(w) {
        var k = w.ref, b = w.style, S = w.placement, P = w.arrowProps;
        return M.createElement(Fy, { enableTabLoop: h }, M.createElement("div", { ref: k, style: b, className: _, "data-placement": S, onKeyDown: m }, M.cloneElement(l, { arrowProps: P })));
      });
    }
    this.props.popperContainer && (r = M.createElement(this.props.popperContainer, {}, r)), f && !s && (r = M.createElement(Hy, { portalId: f, portalHost: C }, r));
    var v = U1("react-datepicker-wrapper", o);
    return M.createElement(cH, { className: "react-datepicker-manager" }, M.createElement(OF, null, function(w) {
      var k = w.ref;
      return M.createElement("div", { ref: k, className: v }, p);
    }), r);
  } }], [{ key: "defaultProps", get: function() {
    return { hidePopper: !0, popperModifiers: [], popperProps: {}, popperPlacement: "bottom-start" };
  } }]), n;
}(), wd = "react-datepicker-ignore-onclickoutside", iV = d8(tV), w7 = "Date input not valid.";
(function(e) {
  V1(n, M.Component);
  var t = B1(n);
  function n(r) {
    var a;
    return H1(this, n), H(B(a = t.call(this, r)), "getPreSelection", function() {
      return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : qt();
    }), H(B(a), "modifyHolidays", function() {
      var i;
      return (i = a.props.holidays) === null || i === void 0 ? void 0 : i.reduce(function(o, s) {
        var l = new Date(s.date);
        return Os(l) ? [].concat(Is(o), [e5(e5({}, s), {}, { date: l })]) : o;
      }, []);
    }), H(B(a), "calcInitialState", function() {
      var i, o = a.getPreSelection(), s = Oy(a.props), l = Ny(a.props), c = s && Ha(o, Kn(s)) ? s : l && $a(o, K0(l)) ? l : o;
      return { open: a.props.startOpen || !1, preventFocus: !1, preSelection: (i = a.props.selectsRange ? a.props.startDate : a.props.selected) !== null && i !== void 0 ? i : c, highlightDates: yd(a.props.highlightDates), focused: !1, shouldFocusDayInline: !1, isRenderAriaLiveMessage: !1 };
    }), H(B(a), "clearPreventFocusTimeout", function() {
      a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
    }), H(B(a), "setFocus", function() {
      a.input && a.input.focus && a.input.focus({ preventScroll: !0 });
    }), H(B(a), "setBlur", function() {
      a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
    }), H(B(a), "setOpen", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      a.setState({ open: i, preSelection: i && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection, lastPreSelectChange: x7 }, function() {
        i || a.setState(function(s) {
          return { focused: !!o && s.focused };
        }, function() {
          !o && a.setBlur(), a.setState({ inputValue: null });
        });
      });
    }), H(B(a), "inputOk", function() {
      return u8(a.state.preSelection);
    }), H(B(a), "isCalendarOpen", function() {
      return a.props.open === void 0 ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
    }), H(B(a), "handleFocus", function(i) {
      a.state.preventFocus || (a.props.onFocus(i), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({ focused: !0 });
    }), H(B(a), "sendFocusBackToInput", function() {
      a.preventFocusTimeout && a.clearPreventFocusTimeout(), a.setState({ preventFocus: !0 }, function() {
        a.preventFocusTimeout = setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      });
    }), H(B(a), "cancelFocusInput", function() {
      clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
    }), H(B(a), "deferFocusInput", function() {
      a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
        return a.setFocus();
      }, 1);
    }), H(B(a), "handleDropdownFocus", function() {
      a.cancelFocusInput();
    }), H(B(a), "handleBlur", function(i) {
      (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(i), a.setState({ focused: !1 });
    }), H(B(a), "handleCalendarClickOutside", function(i) {
      a.props.inline || a.setOpen(!1), a.props.onClickOutside(i), a.props.withPortal && i.preventDefault();
    }), H(B(a), "handleChange", function() {
      for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++)
        o[s] = arguments[s];
      var l = o[0];
      if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(B(a), o), typeof l.isDefaultPrevented == "function" && !l.isDefaultPrevented())) {
        a.setState({ inputValue: l.target.value, lastPreSelectChange: oV });
        var c, u, d, p, h, m, f, C, _ = (c = l.target.value, u = a.props.dateFormat, d = a.props.locale, p = a.props.strictParsing, h = a.props.minDate, m = null, f = I2(d) || I2(D2()), C = !0, Array.isArray(u) ? (u.forEach(function(v) {
          var w = m7(c, v, /* @__PURE__ */ new Date(), { locale: f });
          p && (C = Ra(w, h) && c === s1(w, v, d)), Ra(w, h) && C && (m = w);
        }), m) : (m = m7(c, u, /* @__PURE__ */ new Date(), { locale: f }), p ? C = Ra(m) && c === s1(m, u, d) : Ra(m) || (u = u.match(RF).map(function(v) {
          var w = v[0];
          return w === "p" || w === "P" ? f ? (0, jF[w])(v, f.formatLong) : w : v;
        }).join(""), c.length > 0 && (m = m7(c, u.slice(0, c.length), /* @__PURE__ */ new Date())), Ra(m) || (m = new Date(c))), Ra(m) && C ? m : null));
        a.props.showTimeSelectOnly && a.props.selected && _ && !Xt(_, a.props.selected) && (_ = NF(a.props.selected, { hours: Zn(_), minutes: Un(_), seconds: Vu(_) })), !_ && l.target.value || (a.props.showWeekPicker && (_ = Wn(_, a.props.locale, a.props.calendarStartDay)), a.setSelected(_, l, !0));
      }
    }), H(B(a), "handleSelect", function(i, o, s) {
      if (a.props.shouldCloseOnSelect && !a.props.showTimeSelect && a.sendFocusBackToInput(), a.props.onChangeRaw && a.props.onChangeRaw(o), a.props.showWeekPicker && (i = Wn(i, a.props.locale, a.props.calendarStartDay)), a.setSelected(i, o, !1, s), a.props.showDateSelect && a.setState({ isRenderAriaLiveMessage: !0 }), !a.props.shouldCloseOnSelect || a.props.showTimeSelect)
        a.setPreSelection(i);
      else if (!a.props.inline) {
        a.props.selectsRange || a.setOpen(!1);
        var l = a.props, c = l.startDate, u = l.endDate;
        !c || u || Ha(i, c) || a.setOpen(!1);
      }
    }), H(B(a), "setSelected", function(i, o, s, l) {
      var c = i;
      if (a.props.showYearPicker) {
        if (c !== null && Ay(pt(c), a.props))
          return;
      } else if (a.props.showMonthYearPicker) {
        if (c !== null && Ly(c, a.props))
          return;
      } else if (c !== null && h8(c, a.props))
        return;
      var u = a.props, d = u.onChange, p = u.selectsRange, h = u.startDate, m = u.endDate;
      if (!T2(a.props.selected, c) || a.props.allowSameDay || p)
        if (c !== null && (!a.props.selected || s && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (c = ld(c, { hour: Zn(a.props.selected), minute: Un(a.props.selected), second: Vu(a.props.selected) })), a.props.inline || a.setState({ preSelection: c }), a.props.focusSelectedMonth || a.setState({ monthSelectedIn: l })), p) {
          var f = h && !m, C = h && m;
          !h && !m ? d([c, null], o) : f && (Ha(c, h) ? d([c, null], o) : d([h, c], o)), C && d([c, null], o);
        } else
          d(c, o);
      s || (a.props.onSelect(c, o), a.setState({ inputValue: null }));
    }), H(B(a), "setPreSelection", function(i) {
      var o = a.props.minDate !== void 0, s = a.props.maxDate !== void 0, l = !0;
      if (i) {
        a.props.showWeekPicker && (i = Wn(i, a.props.locale, a.props.calendarStartDay));
        var c = Kn(i);
        if (o && s)
          l = d6(i, a.props.minDate, a.props.maxDate);
        else if (o) {
          var u = Kn(a.props.minDate);
          l = $a(i, u) || T2(c, u);
        } else if (s) {
          var d = K0(a.props.maxDate);
          l = Ha(i, d) || T2(c, d);
        }
      }
      l && a.setState({ preSelection: i });
    }), H(B(a), "toggleCalendar", function() {
      a.setOpen(!a.state.open);
    }), H(B(a), "handleTimeChange", function(i) {
      var o = a.props.selected ? a.props.selected : a.getPreSelection(), s = a.props.selected ? i : ld(o, { hour: Zn(i), minute: Un(i) });
      a.setState({ preSelection: s }), a.props.onChange(s), a.props.shouldCloseOnSelect && (a.sendFocusBackToInput(), a.setOpen(!1)), a.props.showTimeInput && a.setOpen(!0), (a.props.showTimeSelectOnly || a.props.showTimeSelect) && a.setState({ isRenderAriaLiveMessage: !0 }), a.setState({ inputValue: null });
    }), H(B(a), "onInputClick", function() {
      a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
    }), H(B(a), "onInputKeyDown", function(i) {
      a.props.onKeyDown(i);
      var o = i.key;
      if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
        if (a.state.open) {
          if (o === "ArrowDown" || o === "ArrowUp") {
            i.preventDefault();
            var s = a.props.showWeekPicker && a.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', l = a.calendar.componentNode && a.calendar.componentNode.querySelector(s);
            return void (l && l.focus({ preventScroll: !0 }));
          }
          var c = qt(a.state.preSelection);
          o === "Enter" ? (i.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === x7 ? (a.handleSelect(c, i), !a.props.shouldCloseOnSelect && a.setPreSelection(c)) : a.setOpen(!1)) : o === "Escape" ? (i.preventDefault(), a.sendFocusBackToInput(), a.setOpen(!1)) : o === "Tab" && a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: w7 });
        }
      } else
        o !== "ArrowDown" && o !== "ArrowUp" && o !== "Enter" || a.onInputClick();
    }), H(B(a), "onPortalKeyDown", function(i) {
      i.key === "Escape" && (i.preventDefault(), a.setState({ preventFocus: !0 }, function() {
        a.setOpen(!1), setTimeout(function() {
          a.setFocus(), a.setState({ preventFocus: !1 });
        });
      }));
    }), H(B(a), "onDayKeyDown", function(i) {
      a.props.onKeyDown(i);
      var o = i.key, s = qt(a.state.preSelection);
      if (o === "Enter")
        i.preventDefault(), a.handleSelect(s, i), !a.props.shouldCloseOnSelect && a.setPreSelection(s);
      else if (o === "Escape")
        i.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({ code: 1, msg: w7 });
      else if (!a.props.disabledKeyboardNavigation) {
        var l;
        switch (o) {
          case "ArrowLeft":
            l = a.props.showWeekPicker ? Fu(s, 1) : SD(s, 1);
            break;
          case "ArrowRight":
            l = a.props.showWeekPicker ? $6(s, 1) : so(s, 1);
            break;
          case "ArrowUp":
            l = Fu(s, 1);
            break;
          case "ArrowDown":
            l = $6(s, 1);
            break;
          case "PageUp":
            l = Vi(s, 1);
            break;
          case "PageDown":
            l = bn(s, 1);
            break;
          case "Home":
            l = Ns(s, 1);
            break;
          case "End":
            l = Fi(s, 1);
            break;
          default:
            l = null;
        }
        if (!l)
          return void (a.props.onInputError && a.props.onInputError({ code: 1, msg: w7 }));
        if (i.preventDefault(), a.setState({ lastPreSelectChange: x7 }), a.props.adjustDateOnChange && a.setSelected(l), a.setPreSelection(l), a.props.inline) {
          var c = Y1(s), u = Y1(l), d = pt(s), p = pt(l);
          c !== u || d !== p ? a.setState({ shouldFocusDayInline: !0 }) : a.setState({ shouldFocusDayInline: !1 });
        }
      }
    }), H(B(a), "onPopperKeyDown", function(i) {
      i.key === "Escape" && (i.preventDefault(), a.sendFocusBackToInput());
    }), H(B(a), "onClearClick", function(i) {
      i && i.preventDefault && i.preventDefault(), a.sendFocusBackToInput(), a.props.selectsRange ? a.props.onChange([null, null], i) : a.props.onChange(null, i), a.setState({ inputValue: null });
    }), H(B(a), "clear", function() {
      a.onClearClick();
    }), H(B(a), "onScroll", function(i) {
      typeof a.props.closeOnScroll == "boolean" && a.props.closeOnScroll ? i.target !== document && i.target !== document.documentElement && i.target !== document.body || a.setOpen(!1) : typeof a.props.closeOnScroll == "function" && a.props.closeOnScroll(i) && a.setOpen(!1);
    }), H(B(a), "renderCalendar", function() {
      return a.props.inline || a.isCalendarOpen() ? M.createElement(iV, { ref: function(i) {
        a.calendar = i;
      }, locale: a.props.locale, calendarStartDay: a.props.calendarStartDay, chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix, disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix, weekAriaLabelPrefix: a.props.weekAriaLabelPrefix, monthAriaLabelPrefix: a.props.monthAriaLabelPrefix, adjustDateOnChange: a.props.adjustDateOnChange, setOpen: a.setOpen, shouldCloseOnSelect: a.props.shouldCloseOnSelect, dateFormat: a.props.dateFormatCalendar, useWeekdaysShort: a.props.useWeekdaysShort, formatWeekDay: a.props.formatWeekDay, dropdownMode: a.props.dropdownMode, selected: a.props.selected, preSelection: a.state.preSelection, onSelect: a.handleSelect, onWeekSelect: a.props.onWeekSelect, openToDate: a.props.openToDate, minDate: a.props.minDate, maxDate: a.props.maxDate, selectsStart: a.props.selectsStart, selectsEnd: a.props.selectsEnd, selectsRange: a.props.selectsRange, startDate: a.props.startDate, endDate: a.props.endDate, excludeDates: a.props.excludeDates, excludeDateIntervals: a.props.excludeDateIntervals, filterDate: a.props.filterDate, onClickOutside: a.handleCalendarClickOutside, formatWeekNumber: a.props.formatWeekNumber, highlightDates: a.state.highlightDates, holidays: IF(a.modifyHolidays()), includeDates: a.props.includeDates, includeDateIntervals: a.props.includeDateIntervals, includeTimes: a.props.includeTimes, injectTimes: a.props.injectTimes, inline: a.props.inline, shouldFocusDayInline: a.state.shouldFocusDayInline, peekNextMonth: a.props.peekNextMonth, showMonthDropdown: a.props.showMonthDropdown, showPreviousMonths: a.props.showPreviousMonths, useShortMonthInDropdown: a.props.useShortMonthInDropdown, showMonthYearDropdown: a.props.showMonthYearDropdown, showWeekNumbers: a.props.showWeekNumbers, showYearDropdown: a.props.showYearDropdown, withPortal: a.props.withPortal, forceShowMonthNavigation: a.props.forceShowMonthNavigation, showDisabledMonthNavigation: a.props.showDisabledMonthNavigation, scrollableYearDropdown: a.props.scrollableYearDropdown, scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown, todayButton: a.props.todayButton, weekLabel: a.props.weekLabel, outsideClickIgnoreClass: wd, fixedHeight: a.props.fixedHeight, monthsShown: a.props.monthsShown, monthSelectedIn: a.state.monthSelectedIn, onDropdownFocus: a.handleDropdownFocus, onMonthChange: a.props.onMonthChange, onYearChange: a.props.onYearChange, dayClassName: a.props.dayClassName, weekDayClassName: a.props.weekDayClassName, monthClassName: a.props.monthClassName, timeClassName: a.props.timeClassName, showDateSelect: a.props.showDateSelect, showTimeSelect: a.props.showTimeSelect, showTimeSelectOnly: a.props.showTimeSelectOnly, onTimeChange: a.handleTimeChange, timeFormat: a.props.timeFormat, timeIntervals: a.props.timeIntervals, minTime: a.props.minTime, maxTime: a.props.maxTime, excludeTimes: a.props.excludeTimes, filterTime: a.props.filterTime, timeCaption: a.props.timeCaption, className: a.props.calendarClassName, container: a.props.calendarContainer, yearItemNumber: a.props.yearItemNumber, yearDropdownItemNumber: a.props.yearDropdownItemNumber, previousMonthAriaLabel: a.props.previousMonthAriaLabel, previousMonthButtonLabel: a.props.previousMonthButtonLabel, nextMonthAriaLabel: a.props.nextMonthAriaLabel, nextMonthButtonLabel: a.props.nextMonthButtonLabel, previousYearAriaLabel: a.props.previousYearAriaLabel, previousYearButtonLabel: a.props.previousYearButtonLabel, nextYearAriaLabel: a.props.nextYearAriaLabel, nextYearButtonLabel: a.props.nextYearButtonLabel, timeInputLabel: a.props.timeInputLabel, disabledKeyboardNavigation: a.props.disabledKeyboardNavigation, renderCustomHeader: a.props.renderCustomHeader, popperProps: a.props.popperProps, renderDayContents: a.props.renderDayContents, renderMonthContent: a.props.renderMonthContent, renderQuarterContent: a.props.renderQuarterContent, renderYearContent: a.props.renderYearContent, onDayMouseEnter: a.props.onDayMouseEnter, onMonthMouseLeave: a.props.onMonthMouseLeave, onYearMouseEnter: a.props.onYearMouseEnter, onYearMouseLeave: a.props.onYearMouseLeave, selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange, showTimeInput: a.props.showTimeInput, showMonthYearPicker: a.props.showMonthYearPicker, showFullMonthYearPicker: a.props.showFullMonthYearPicker, showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker, showYearPicker: a.props.showYearPicker, showQuarterYearPicker: a.props.showQuarterYearPicker, showWeekPicker: a.props.showWeekPicker, showPopperArrow: a.props.showPopperArrow, excludeScrollbar: a.props.excludeScrollbar, handleOnKeyDown: a.props.onKeyDown, handleOnDayKeyDown: a.onDayKeyDown, isInputFocused: a.state.focused, customTimeInput: a.props.customTimeInput, setPreSelection: a.setPreSelection }, a.props.children) : null;
    }), H(B(a), "renderAriaLiveRegion", function() {
      var i, o = a.props, s = o.dateFormat, l = o.locale, c = a.props.showTimeInput || a.props.showTimeSelect ? "PPPPp" : "PPPP";
      return i = a.props.selectsRange ? "Selected start date: ".concat(Tn(a.props.startDate, { dateFormat: c, locale: l }), ". ").concat(a.props.endDate ? "End date: " + Tn(a.props.endDate, { dateFormat: c, locale: l }) : "") : a.props.showTimeSelectOnly ? "Selected time: ".concat(Tn(a.props.selected, { dateFormat: s, locale: l })) : a.props.showYearPicker ? "Selected year: ".concat(Tn(a.props.selected, { dateFormat: "yyyy", locale: l })) : a.props.showMonthYearPicker ? "Selected month: ".concat(Tn(a.props.selected, { dateFormat: "MMMM yyyy", locale: l })) : a.props.showQuarterYearPicker ? "Selected quarter: ".concat(Tn(a.props.selected, { dateFormat: "yyyy, QQQ", locale: l })) : "Selected date: ".concat(Tn(a.props.selected, { dateFormat: c, locale: l })), M.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, i);
    }), H(B(a), "renderDateInput", function() {
      var i, o = U1(a.props.className, H({}, wd, a.state.open)), s = a.props.customInput || M.createElement("input", { type: "text" }), l = a.props.customInputRef || "ref", c = typeof a.props.value == "string" ? a.props.value : typeof a.state.inputValue == "string" ? a.state.inputValue : a.props.selectsRange ? function(u, d, p) {
        if (!u)
          return "";
        var h = Tn(u, p), m = d ? Tn(d, p) : "";
        return "".concat(h, " - ").concat(m);
      }(a.props.startDate, a.props.endDate, a.props) : Tn(a.props.selected, a.props);
      return M.cloneElement(s, (H(H(H(H(H(H(H(H(H(H(i = {}, l, function(u) {
        a.input = u;
      }), "value", c), "onBlur", a.handleBlur), "onChange", a.handleChange), "onClick", a.onInputClick), "onFocus", a.handleFocus), "onKeyDown", a.onInputKeyDown), "id", a.props.id), "name", a.props.name), "form", a.props.form), H(H(H(H(H(H(H(H(H(H(i, "autoFocus", a.props.autoFocus), "placeholder", a.props.placeholderText), "disabled", a.props.disabled), "autoComplete", a.props.autoComplete), "className", U1(s.props.className, o)), "title", a.props.title), "readOnly", a.props.readOnly), "required", a.props.required), "tabIndex", a.props.tabIndex), "aria-describedby", a.props.ariaDescribedBy), H(H(H(i, "aria-invalid", a.props.ariaInvalid), "aria-labelledby", a.props.ariaLabelledBy), "aria-required", a.props.ariaRequired)));
    }), H(B(a), "renderClearButton", function() {
      var i = a.props, o = i.isClearable, s = i.disabled, l = i.selected, c = i.startDate, u = i.endDate, d = i.clearButtonTitle, p = i.clearButtonClassName, h = p === void 0 ? "" : p, m = i.ariaLabelClose, f = m === void 0 ? "Close" : m;
      return !o || l == null && c == null && u == null ? null : M.createElement("button", { type: "button", className: U1("react-datepicker__close-icon", h, { "react-datepicker__close-icon--disabled": s }), disabled: s, "aria-label": f, onClick: a.onClearClick, title: d, tabIndex: -1 });
    }), a.state = a.calcInitialState(), a.preventFocusTimeout = null, a;
  }
  return F1(n, [{ key: "componentDidMount", value: function() {
    window.addEventListener("scroll", this.onScroll, !0);
  } }, { key: "componentDidUpdate", value: function(r, a) {
    var i, o;
    r.inline && (i = r.selected, o = this.props.selected, i && o ? Y1(i) !== Y1(o) || pt(i) !== pt(o) : i !== o) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && r.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), r.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: yd(this.props.highlightDates) }), a.focused || T2(r.selected, this.props.selected) || this.setState({ inputValue: null }), a.open !== this.state.open && (a.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), a.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
  } }, { key: "componentWillUnmount", value: function() {
    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
  } }, { key: "renderInputContainer", value: function() {
    var r = this.props, a = r.showIcon, i = r.icon, o = r.calendarIconClassname, s = r.toggleCalendarOnIconClick, l = this.state.open;
    return M.createElement("div", { className: "react-datepicker__input-container".concat(a ? " react-datepicker__view-calendar-icon" : "") }, a && M.createElement(rV, Zi({ icon: i, className: "".concat(o, " ").concat(l && "react-datepicker-ignore-onclickoutside") }, s ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
  } }, { key: "render", value: function() {
    var r = this.renderCalendar();
    if (this.props.inline)
      return r;
    if (this.props.withPortal) {
      var a = this.state.open ? M.createElement(Fy, { enableTabLoop: this.props.enableTabLoop }, M.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, r)) : null;
      return this.state.open && this.props.portalId && (a = M.createElement(Hy, { portalId: this.props.portalId, portalHost: this.props.portalHost }, a)), M.createElement("div", null, this.renderInputContainer(), a);
    }
    return M.createElement(aV, { className: this.props.popperClassName, wrapperClassName: this.props.wrapperClassName, hidePopper: !this.isCalendarOpen(), portalId: this.props.portalId, portalHost: this.props.portalHost, popperModifiers: this.props.popperModifiers, targetComponent: this.renderInputContainer(), popperContainer: this.props.popperContainer, popperComponent: r, popperPlacement: this.props.popperPlacement, popperProps: this.props.popperProps, popperOnKeyDown: this.onPopperKeyDown, enableTabLoop: this.props.enableTabLoop });
  } }], [{ key: "defaultProps", get: function() {
    return { allowSameDay: !1, dateFormat: "MM/dd/yyyy", dateFormatCalendar: "LLLL yyyy", onChange: function() {
    }, disabled: !1, disabledKeyboardNavigation: !1, dropdownMode: "scroll", onFocus: function() {
    }, onBlur: function() {
    }, onKeyDown: function() {
    }, onInputClick: function() {
    }, onSelect: function() {
    }, onClickOutside: function() {
    }, onMonthChange: function() {
    }, onCalendarOpen: function() {
    }, onCalendarClose: function() {
    }, preventOpenOnFocus: !1, onYearChange: function() {
    }, onInputError: function() {
    }, monthsShown: 1, readOnly: !1, withPortal: !1, selectsDisabledDaysInRange: !1, shouldCloseOnSelect: !0, showTimeSelect: !1, showTimeInput: !1, showPreviousMonths: !1, showMonthYearPicker: !1, showFullMonthYearPicker: !1, showTwoColumnMonthYearPicker: !1, showFourColumnMonthYearPicker: !1, showYearPicker: !1, showQuarterYearPicker: !1, showWeekPicker: !1, strictParsing: !1, timeIntervals: 30, timeCaption: "Time", previousMonthAriaLabel: "Previous Month", previousMonthButtonLabel: "Previous Month", nextMonthAriaLabel: "Next Month", nextMonthButtonLabel: "Next Month", previousYearAriaLabel: "Previous Year", previousYearButtonLabel: "Previous Year", nextYearAriaLabel: "Next Year", nextYearButtonLabel: "Next Year", timeInputLabel: "Time", enableTabLoop: !0, yearItemNumber: ys, focusSelectedMonth: !1, showPopperArrow: !0, excludeScrollbar: !0, customTimeInput: null, calendarStartDay: void 0, toggleCalendarOnIconClick: !1 };
  } }]), n;
})();
var oV = "input", x7 = "navigate";
const wi = Ji(function({
  error: e,
  label: t,
  labelClassName: n,
  labelRightElement: r,
  htmlFor: a,
  nativeLabelProps: i,
  value: o,
  onChange: s,
  onFocus: l,
  maxLength: c,
  placeholder: u,
  isPreFetching: d,
  required: p,
  description: h,
  className: m,
  addonBefore: f,
  addonAfter: C,
  inputClassName: _,
  success: v,
  addonAfterClassName: w,
  addonBeforeClassName: k,
  statusIcon: b,
  statusIconClassName: S,
  labelContentWrapperClassName: P,
  errorAndDescriptionClassName: O,
  descriptionClassName: A,
  errorClassName: L,
  ...I
}, D) {
  const U = Fe(
    "break-words flex justify-center items-center py-2.5 px-2 sm:px-4  border border-y-text-secondary/50",
    d ? "bg-skeleton-primary/40 text-transparent border-0" : "text-text-tertiary bg-background-tertiary"
  ), z = Fe(f3, b && "pr-9");
  return /* @__PURE__ */ y.jsxs(
    "label",
    {
      className: Fe("flex flex-col gap-1 text-sm font-medium", m),
      ...i,
      children: [
        /* @__PURE__ */ y.jsx(
          ba,
          {
            label: t,
            labelClassName: n,
            labelRightElement: r,
            required: p
          }
        ),
        /* @__PURE__ */ y.jsxs(
          "div",
          {
            className: Fe(
              "text-text-primary main-transition-colors relative flex w-full shrink-0 rounded-lg",
              d && "animate-pulse",
              P
            ),
            children: [
              f && /* @__PURE__ */ y.jsx(
                "div",
                {
                  className: Fe(
                    "border-l-text-secondary/50 rounded-l-lg border-r-transparent",
                    U,
                    k
                  ),
                  children: f
                }
              ),
              /* @__PURE__ */ y.jsx(
                "input",
                {
                  ref: D,
                  className: Fe(
                    "main-transition-colors focus:border-brand-primary placeholder:text-text-tertiary/70 bg-background-secondary min-w-0 basis-full rounded-lg focus:outline-hidden",
                    z,
                    e ? "border-danger" : v ? "border-green" : "border-text-secondary/30",
                    d ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 border-0 text-transparent" : "disabled:bg-background-tertiary/40 border",
                    f && "rounded-l-none",
                    C && "rounded-r-none",
                    _
                  ),
                  type: I.type || "text",
                  value: o,
                  onChange: s,
                  onFocus: l,
                  maxLength: c,
                  placeholder: u,
                  spellCheck: !1,
                  disabled: I.disabled || d,
                  ...I
                }
              ),
              C && /* @__PURE__ */ y.jsx(
                "div",
                {
                  className: Fe(
                    "border-r-text-secondary/50 rounded-r-lg border-l-transparent",
                    U,
                    w
                  ),
                  children: C
                }
              ),
              b && /* @__PURE__ */ y.jsx(
                "div",
                {
                  className: Fe(
                    "absolute right-3 h-[21px] w-[21px] translate-y-1/2",
                    S
                  ),
                  children: b
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ y.jsx(
          oo,
          {
            description: h,
            error: e,
            className: O,
            descriptionClassName: A,
            errorClassName: L
          }
        )
      ]
    }
  );
}), sV = "react-international-phone-", Vy = (...e) => e.filter((t) => !!t).join(" ").trim(), lV = (...e) => Vy(...e).split(" ").map((t) => `${sV}${t}`).join(" "), mr = ({ addPrefix: e, rawClassNames: t }) => Vy(lV(...e), ...t), An = (e) => e.replace(/\D/g, ""), xd = 35, cV = ({
  value: e,
  mask: t,
  maskSymbol: n,
  allowMoreDigitsThanMaskAllows: r,
  offset: a = 0,
  trimNonMaskCharsLeftover: i = !1
}) => {
  if (e.length < a)
    return e;
  const o = e.slice(0, a), s = e.slice(a);
  let l = o, c = 0;
  for (const d of t.split("")) {
    if (c >= s.length) {
      if (!i && d !== n) {
        l += d;
        continue;
      }
      break;
    }
    d === n ? (l += s[c], c += 1) : l += d;
  }
  let u = An(l);
  return r && u.length < e.length && (l += e.slice(u.length), u = An(l)), u.length >= xd && (l = l.slice(0, -(u.length - xd) || void 0)), l;
}, uV = (e, t) => {
  const n = e.style.display;
  n !== "block" && (e.style.display = "block");
  const r = e.getBoundingClientRect(), a = t.getBoundingClientRect(), i = a.top - r.top, o = r.bottom - a.bottom;
  i >= 0 && o >= 0 || (Math.abs(i) < Math.abs(o) ? e.scrollTop += i : e.scrollTop -= o), e.style.display = n;
}, hn = (e) => {
  const [t, n, r, a, i, o, s] = e;
  return {
    name: t,
    regions: n,
    iso2: r,
    dialCode: a,
    format: i,
    priority: o,
    areaCodes: s
  };
}, dV = (e) => `Field "${e}" is not supported`, xi = ({
  value: e,
  field: t,
  countries: n,
  defaultCountry: r
}) => {
  if (["regions", "priority"].includes(t))
    throw new Error(dV(t));
  const a = n.find((i) => {
    const o = hn(i);
    return e === o[t];
  }) || n.find((i) => {
    const o = hn(i);
    return r.toLocaleLowerCase() === o[t];
  });
  if (a)
    return hn(a);
}, Sd = ({
  phone: e,
  countries: t,
  currentCountryIso2: n,
  defaultCountry: r
}) => {
  var a;
  const i = {
    country: void 0,
    fullDialCodeMatch: !1,
    areaCodeMatch: void 0
  };
  if (!e)
    return i;
  const o = An(e);
  if (!o)
    return i;
  let s = i;
  const l = ({
    country: c,
    fullDialCodeMatch: u,
    areaCodeMatch: d
  }) => {
    var p, h;
    const m = c.dialCode === ((p = s.country) == null ? void 0 : p.dialCode), f = (c.priority ?? 0) < (((h = s.country) == null ? void 0 : h.priority) ?? 0);
    (!m || f) && (s = { country: c, fullDialCodeMatch: u, areaCodeMatch: d });
  };
  for (const c of t) {
    const u = hn(c), { dialCode: d, areaCodes: p } = u;
    if (o.startsWith(d)) {
      const h = s.country ? Number(d) >= Number(s.country.dialCode) : !0;
      if (p) {
        const m = o.substring(d.length);
        for (const f of p)
          if (m.startsWith(f))
            return {
              country: u,
              fullDialCodeMatch: !0,
              areaCodeMatch: !0
            };
      }
      (h || d === o || !s.fullDialCodeMatch) && l({
        country: u,
        fullDialCodeMatch: !0,
        areaCodeMatch: p ? !p : void 0
      });
    }
    s.fullDialCodeMatch || o.length < d.length && d.startsWith(o) && (!s.country || Number(d) <= Number(s.country.dialCode)) && l({ country: u, fullDialCodeMatch: !1 });
  }
  if (n) {
    const c = xi({
      value: n,
      field: "iso2",
      countries: t,
      defaultCountry: r
    });
    s && c && // different countries with same dial code
    ((a = s.country) == null ? void 0 : a.dialCode) === c.dialCode && s.country !== c && // full dial code match (without area code)
    s.fullDialCodeMatch && !s.areaCodeMatch && (s = {
      country: c,
      areaCodeMatch: c != null && c.areaCodes ? !1 : void 0,
      fullDialCodeMatch: !0
    });
  }
  return s;
}, pV = ({
  phone: e,
  dialCode: t,
  prefix: n = "+",
  charAfterDialCode: r = " "
}) => {
  if (!e || !t)
    return e;
  let a = e;
  return a.startsWith(n) && (a = a.replace(n, "")), a.startsWith(t) ? (a = a.replace(t, ""), a.startsWith(r) && (a = a.replace(r, "")), a) : e;
}, kd = ({
  phone: e,
  dialCode: t,
  prefix: n = "+",
  charAfterDialCode: r = " "
}) => `${n}${t}${r}${pV({
  phone: e,
  dialCode: t,
  charAfterDialCode: r,
  prefix: n
})}`, hV = (e, t) => {
  const n = t.disableDialCodeAndPrefix ? !1 : t.forceDialCode, r = t.disableDialCodeAndPrefix ? !1 : t.insertDialCodeOnEmpty;
  let a = e;
  const i = (c) => t.trimNonDigitsEnd ? c.trim() : c;
  if (!a)
    return r && !a.length || n ? i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`) : i(a);
  if (a = An(a), a === t.dialCode && !t.disableDialCodeAndPrefix)
    return i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`);
  if (t.dialCode.startsWith(a) && !t.disableDialCodeAndPrefix)
    return i(n ? `${t.prefix}${t.dialCode}${t.charAfterDialCode}` : `${t.prefix}${a}`);
  if (!a.startsWith(t.dialCode) && !t.disableDialCodeAndPrefix) {
    if (n)
      return i(`${t.prefix}${t.dialCode}${t.charAfterDialCode}`);
    if (a.length < t.dialCode.length)
      return i(`${t.prefix}${a}`);
  }
  const o = () => {
    let c = t.dialCode.length;
    t.disableDialCodeAndPrefix && (c = 0);
    const u = a.slice(0, c), d = a.slice(c);
    return {
      phoneLeftSide: u,
      phoneRightSide: d
    };
  };
  let { phoneLeftSide: s, phoneRightSide: l } = o();
  return s = `${t.prefix}${s}${t.charAfterDialCode}`, l = cV({
    value: l,
    mask: t.mask,
    maskSymbol: t.maskChar,
    allowMoreDigitsThanMaskAllows: t.allowMoreDigitsThanMaskAllows,
    trimNonMaskCharsLeftover: t.trimNonDigitsEnd
  }), t.disableDialCodeAndPrefix && (s = ""), i(`${s}${l}`);
}, No = (e) => /\d/.test(e), mV = ({
  phoneBeforeInput: e,
  phoneAfterInput: t,
  phoneAfterFormatted: n,
  cursorPositionAfterInput: r,
  leftOffset: a = 0,
  deletion: i
}) => {
  if (r < a)
    return a;
  if (!e)
    return n.length;
  const o = i === "backward";
  if (r === 0 && t.length > 0 && n.length > 0) {
    if (o)
      return 0;
    for (let d = 0; d < n.length; d += 1)
      if (No(n[d]))
        return d;
    return n.length;
  }
  if (t.length < e.length && t.length === 1)
    return n.length;
  let s = null;
  for (let d = r - 1; d >= 0; d -= 1)
    if (No(t[d])) {
      s = d;
      break;
    }
  if (s === null)
    return r !== 0 ? r : n.length;
  let l = 0;
  for (let d = 0; d < s; d += 1)
    No(t[d]) && (l += 1);
  o && (l -= 1);
  let c = 0, u = 0;
  for (let d = 0; d < n.length && (c += 1, No(n[d]) && (u += 1), u !== l + 1); d += 1)
    ;
  for (; !No(n[c]) && c < n.length; )
    c += 1;
  return o && (c += 1), c;
}, A3 = [
  ["Afghanistan", ["asia"], "af", "93"],
  ["Albania", ["europe"], "al", "355"],
  ["Algeria", ["africa", "north-africa"], "dz", "213"],
  ["Andorra", ["europe"], "ad", "376"],
  ["Angola", ["africa"], "ao", "244"],
  ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"],
  [
    "Argentina",
    ["america", "south-america"],
    "ar",
    "54",
    "(..) ........",
    0,
    [
      "11",
      "221",
      "223",
      "261",
      "264",
      "2652",
      "280",
      "2905",
      "291",
      "2920",
      "2966",
      "299",
      "341",
      "342",
      "343",
      "351",
      "376",
      "379",
      "381",
      "3833",
      "385",
      "387",
      "388"
    ]
  ],
  ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"],
  ["Aruba", ["america", "carribean"], "aw", "297"],
  ["Australia", ["oceania"], "au", "61", ". .... ....", 0, ["2", "3", "4", "7", "8"]],
  ["Austria", ["europe", "eu-union"], "at", "43"],
  ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."],
  ["Bahamas", ["america", "carribean"], "bs", "1242"],
  ["Bahrain", ["middle-east"], "bh", "973"],
  ["Bangladesh", ["asia"], "bd", "880"],
  ["Barbados", ["america", "carribean"], "bb", "1246"],
  ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."],
  ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."],
  ["Belize", ["america", "central-america"], "bz", "501"],
  ["Benin", ["africa"], "bj", "229"],
  ["Bhutan", ["asia"], "bt", "975"],
  ["Bolivia", ["america", "south-america"], "bo", "591"],
  ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"],
  ["Botswana", ["africa"], "bw", "267"],
  ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."],
  ["British Indian Ocean Territory", ["asia"], "io", "246"],
  ["Brunei", ["asia"], "bn", "673"],
  ["Bulgaria", ["europe", "eu-union"], "bg", "359"],
  ["Burkina Faso", ["africa"], "bf", "226"],
  ["Burundi", ["africa"], "bi", "257"],
  ["Cambodia", ["asia"], "kh", "855"],
  ["Cameroon", ["africa"], "cm", "237"],
  [
    "Canada",
    ["america", "north-america"],
    "ca",
    "1",
    "(...) ...-....",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde", ["africa"], "cv", "238"],
  ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1],
  ["Central African Republic", ["africa"], "cf", "236"],
  ["Chad", ["africa"], "td", "235"],
  ["Chile", ["america", "south-america"], "cl", "56"],
  ["China", ["asia"], "cn", "86", "... .... ...."],
  ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."],
  ["Comoros", ["africa"], "km", "269"],
  ["Congo", ["africa"], "cd", "243"],
  ["Congo", ["africa"], "cg", "242"],
  ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."],
  ["Côte d'Ivoire", ["africa"], "ci", "225", ".. .. .. .. .."],
  ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"],
  ["Cuba", ["america", "carribean"], "cu", "53"],
  ["Curaçao", ["america", "carribean"], "cw", "599", "", 0],
  ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"],
  ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."],
  ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."],
  ["Djibouti", ["africa"], "dj", "253"],
  ["Dominica", ["america", "carribean"], "dm", "1767"],
  ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2],
  ["Ecuador", ["america", "south-america"], "ec", "593"],
  ["Egypt", ["africa", "north-africa"], "eg", "20"],
  ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."],
  ["Equatorial Guinea", ["africa"], "gq", "240"],
  ["Eritrea", ["africa"], "er", "291"],
  ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"],
  ["Ethiopia", ["africa"], "et", "251"],
  ["Fiji", ["oceania"], "fj", "679"],
  ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."],
  ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."],
  ["French Guiana", ["america", "south-america"], "gf", "594"],
  ["French Polynesia", ["oceania"], "pf", "689"],
  ["Gabon", ["africa"], "ga", "241"],
  ["Gambia", ["africa"], "gm", "220"],
  ["Georgia", ["asia", "ex-ussr"], "ge", "995"],
  ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"],
  ["Ghana", ["africa"], "gh", "233"],
  ["Gibraltar", ["europe"], "gi", "350"],
  ["Greece", ["europe", "eu-union"], "gr", "30"],
  ["Grenada", ["america", "carribean"], "gd", "1473"],
  ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0],
  ["Guam", ["oceania"], "gu", "1671"],
  ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."],
  ["Guinea", ["africa"], "gn", "224"],
  ["Guinea-Bissau", ["africa"], "gw", "245"],
  ["Guyana", ["america", "south-america"], "gy", "592"],
  ["Haiti", ["america", "carribean"], "ht", "509", "....-...."],
  ["Honduras", ["america", "central-america"], "hn", "504"],
  ["Hong Kong", ["asia"], "hk", "852", ".... ...."],
  ["Hungary", ["europe", "eu-union"], "hu", "36"],
  ["Iceland", ["europe"], "is", "354", "... ...."],
  ["India", ["asia"], "in", "91", ".....-....."],
  ["Indonesia", ["asia"], "id", "62"],
  ["Iran", ["middle-east"], "ir", "98", "... ... ...."],
  ["Iraq", ["middle-east"], "iq", "964"],
  ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."],
  ["Israel", ["middle-east"], "il", "972", "... ... ...."],
  ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0],
  ["Jamaica", ["america", "carribean"], "jm", "1876"],
  ["Japan", ["asia"], "jp", "81", ".. .... ...."],
  ["Jordan", ["middle-east"], "jo", "962"],
  [
    "Kazakhstan",
    ["asia", "ex-ussr"],
    "kz",
    "7",
    "... ...-..-..",
    0,
    [
      "310",
      "311",
      "312",
      "313",
      "315",
      "318",
      "321",
      "324",
      "325",
      "326",
      "327",
      "336",
      "7172",
      "73622"
    ]
  ],
  ["Kenya", ["africa"], "ke", "254"],
  ["Kiribati", ["oceania"], "ki", "686"],
  ["Kosovo", ["europe", "ex-yugos"], "xk", "383"],
  ["Kuwait", ["middle-east"], "kw", "965"],
  ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."],
  ["Laos", ["asia"], "la", "856"],
  ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."],
  ["Lebanon", ["middle-east"], "lb", "961"],
  ["Lesotho", ["africa"], "ls", "266"],
  ["Liberia", ["africa"], "lr", "231"],
  ["Libya", ["africa", "north-africa"], "ly", "218"],
  ["Liechtenstein", ["europe"], "li", "423"],
  ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"],
  ["Luxembourg", ["europe", "eu-union"], "lu", "352"],
  ["Macau", ["asia"], "mo", "853"],
  ["Macedonia", ["europe", "ex-yugos"], "mk", "389"],
  ["Madagascar", ["africa"], "mg", "261"],
  ["Malawi", ["africa"], "mw", "265"],
  ["Malaysia", ["asia"], "my", "60", "..-....-...."],
  ["Maldives", ["asia"], "mv", "960"],
  ["Mali", ["africa"], "ml", "223"],
  ["Malta", ["europe", "eu-union"], "mt", "356"],
  ["Marshall Islands", ["oceania"], "mh", "692"],
  ["Martinique", ["america", "carribean"], "mq", "596"],
  ["Mauritania", ["africa"], "mr", "222"],
  ["Mauritius", ["africa"], "mu", "230"],
  [
    "Mexico",
    ["america", "central-america"],
    "mx",
    "52",
    "... ... ....",
    0,
    ["33", "55", "81", "229", "656", "664", "774", "998"]
  ],
  ["Micronesia", ["oceania"], "fm", "691"],
  ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."],
  ["Monaco", ["europe"], "mc", "377"],
  ["Mongolia", ["asia"], "mn", "976"],
  ["Montenegro", ["europe", "ex-yugos"], "me", "382"],
  ["Morocco", ["africa", "north-africa"], "ma", "212"],
  ["Mozambique", ["africa"], "mz", "258"],
  ["Myanmar", ["asia"], "mm", "95"],
  ["Namibia", ["africa"], "na", "264"],
  ["Nauru", ["africa"], "nr", "674"],
  ["Nepal", ["asia"], "np", "977"],
  ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"],
  ["New Caledonia", ["oceania"], "nc", "687"],
  ["New Zealand", ["oceania"], "nz", "64", "...-...-...."],
  ["Nicaragua", ["america", "central-america"], "ni", "505"],
  ["Niger", ["africa"], "ne", "227"],
  ["Nigeria", ["africa"], "ng", "234"],
  ["North Korea", ["asia"], "kp", "850"],
  ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."],
  ["Oman", ["middle-east"], "om", "968"],
  ["Pakistan", ["asia"], "pk", "92", "...-......."],
  ["Palau", ["oceania"], "pw", "680"],
  ["Palestine", ["middle-east"], "ps", "970"],
  ["Panama", ["america", "central-america"], "pa", "507"],
  ["Papua New Guinea", ["oceania"], "pg", "675"],
  ["Paraguay", ["america", "south-america"], "py", "595"],
  ["Peru", ["america", "south-america"], "pe", "51"],
  ["Philippines", ["asia"], "ph", "63", ".... ......."],
  ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."],
  ["Portugal", ["europe", "eu-union"], "pt", "351"],
  ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3],
  ["Qatar", ["middle-east"], "qa", "974"],
  ["Réunion", ["africa"], "re", "262"],
  ["Romania", ["europe", "eu-union"], "ro", "40"],
  ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 1],
  ["Rwanda", ["africa"], "rw", "250"],
  ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"],
  ["Saint Lucia", ["america", "carribean"], "lc", "1758"],
  ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"],
  ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"],
  ["Samoa", ["oceania"], "ws", "685"],
  ["San Marino", ["europe"], "sm", "378"],
  ["São Tomé and Príncipe", ["africa"], "st", "239"],
  ["Saudi Arabia", ["middle-east"], "sa", "966"],
  ["Senegal", ["africa"], "sn", "221"],
  ["Serbia", ["europe", "ex-yugos"], "rs", "381"],
  ["Seychelles", ["africa"], "sc", "248"],
  ["Sierra Leone", ["africa"], "sl", "232"],
  ["Singapore", ["asia"], "sg", "65", "....-...."],
  ["Slovakia", ["europe", "eu-union"], "sk", "421"],
  ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"],
  ["Solomon Islands", ["oceania"], "sb", "677"],
  ["Somalia", ["africa"], "so", "252"],
  ["South Africa", ["africa"], "za", "27"],
  ["South Korea", ["asia"], "kr", "82", "... .... ...."],
  ["South Sudan", ["africa", "north-africa"], "ss", "211"],
  ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."],
  ["Sri Lanka", ["asia"], "lk", "94"],
  ["Sudan", ["africa"], "sd", "249"],
  ["Suriname", ["america", "south-america"], "sr", "597"],
  ["Swaziland", ["africa"], "sz", "268"],
  ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."],
  ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."],
  ["Syria", ["middle-east"], "sy", "963"],
  ["Taiwan", ["asia"], "tw", "886"],
  ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"],
  ["Tanzania", ["africa"], "tz", "255"],
  ["Thailand", ["asia"], "th", "66"],
  ["Timor-Leste", ["asia"], "tl", "670"],
  ["Togo", ["africa"], "tg", "228"],
  ["Tonga", ["oceania"], "to", "676"],
  ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"],
  ["Tunisia", ["africa", "north-africa"], "tn", "216"],
  ["Turkey", ["europe"], "tr", "90", "... ... .. .."],
  ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"],
  ["Tuvalu", ["asia"], "tv", "688"],
  ["Uganda", ["africa"], "ug", "256"],
  ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."],
  ["United Arab Emirates", ["middle-east"], "ae", "971"],
  ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"],
  [
    "United States",
    ["america", "north-america"],
    "us",
    "1",
    "(...) ...-....",
    0,
    [
      "201",
      "202",
      "203",
      "205",
      "206",
      "207",
      "208",
      "209",
      "210",
      "212",
      "213",
      "214",
      "215",
      "216",
      "217",
      "218",
      "219",
      "224",
      "225",
      "228",
      "229",
      "231",
      "234",
      "239",
      "240",
      "248",
      "251",
      "252",
      "253",
      "254",
      "256",
      "260",
      "262",
      "267",
      "269",
      "270",
      "276",
      "281",
      "301",
      "302",
      "303",
      "304",
      "305",
      "307",
      "308",
      "309",
      "310",
      "312",
      "313",
      "314",
      "315",
      "316",
      "317",
      "318",
      "319",
      "320",
      "321",
      "323",
      "325",
      "330",
      "334",
      "336",
      "337",
      "339",
      "347",
      "351",
      "352",
      "360",
      "361",
      "386",
      "401",
      "402",
      "404",
      "405",
      "406",
      "407",
      "408",
      "409",
      "410",
      "412",
      "413",
      "414",
      "415",
      "417",
      "419",
      "423",
      "424",
      "425",
      "430",
      "432",
      "434",
      "435",
      "440",
      "443",
      "447",
      "469",
      "478",
      "479",
      "480",
      "484",
      "501",
      "502",
      "503",
      "504",
      "505",
      "507",
      "508",
      "509",
      "510",
      "512",
      "513",
      "515",
      "516",
      "517",
      "518",
      "520",
      "530",
      "540",
      "541",
      "551",
      "559",
      "561",
      "562",
      "563",
      "567",
      "570",
      "571",
      "573",
      "574",
      "575",
      "580",
      "585",
      "586",
      "601",
      "602",
      "603",
      "605",
      "606",
      "607",
      "608",
      "609",
      "610",
      "612",
      "614",
      "615",
      "616",
      "617",
      "618",
      "619",
      "620",
      "623",
      "626",
      "630",
      "631",
      "636",
      "641",
      "646",
      "650",
      "651",
      "660",
      "661",
      "662",
      "678",
      "681",
      "682",
      "689",
      "701",
      "702",
      "703",
      "704",
      "706",
      "707",
      "708",
      "712",
      "713",
      "714",
      "715",
      "716",
      "717",
      "718",
      "719",
      "720",
      "724",
      "727",
      "731",
      "732",
      "734",
      "740",
      "754",
      "757",
      "760",
      "762",
      "763",
      "765",
      "769",
      "770",
      "772",
      "773",
      "774",
      "775",
      "779",
      "781",
      "785",
      "786",
      "801",
      "802",
      "803",
      "804",
      "805",
      "806",
      "808",
      "810",
      "812",
      "813",
      "814",
      "815",
      "816",
      "817",
      "818",
      "828",
      "830",
      "831",
      "832",
      "843",
      "845",
      "847",
      "848",
      "850",
      "856",
      "857",
      "858",
      "859",
      "860",
      "862",
      "863",
      "864",
      "865",
      "870",
      "878",
      "901",
      "903",
      "904",
      "906",
      "907",
      "908",
      "909",
      "910",
      "912",
      "913",
      "914",
      "915",
      "916",
      "917",
      "918",
      "919",
      "920",
      "925",
      "928",
      "931",
      "936",
      "937",
      "940",
      "941",
      "947",
      "949",
      "951",
      "952",
      "954",
      "956",
      "970",
      "971",
      "972",
      "973",
      "978",
      "979",
      "980",
      "985",
      "989"
    ]
  ],
  ["Uruguay", ["america", "south-america"], "uy", "598"],
  ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."],
  ["Vanuatu", ["oceania"], "vu", "678"],
  ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1],
  ["Venezuela", ["america", "south-america"], "ve", "58"],
  ["Vietnam", ["asia"], "vn", "84"],
  ["Yemen", ["middle-east"], "ye", "967"],
  ["Zambia", ["africa"], "zm", "260"],
  ["Zimbabwe", ["africa"], "zw", "263"],
  ["Faroe Islands", ["europe"], "fo", "298"]
], n5 = "fr", fV = () => {
  const e = be(), t = be(Date.now());
  return {
    check: () => {
      const n = Date.now(), r = e.current ? n - t.current : void 0;
      return e.current = t.current, t.current = n, r;
    }
  };
}, CV = {
  size: 20,
  overrideLastItemDebounceMS: -1
  // overriding is disabled by default
};
function gV(e, t) {
  const { size: n, overrideLastItemDebounceMS: r, onChange: a } = {
    ...CV,
    ...t
  }, [i, o] = ke(e), [s, l] = ke([i]), [c, u] = ke(0), d = fV();
  return [i, (p, h) => {
    if (
      // compare entries if passed value is object
      typeof p == "object" && Object.entries(p).toString() === Object.entries(i).toString() || p === i
    )
      return;
    const m = r > 0, f = d.check(), C = m && f !== void 0 ? f > r : !0;
    if (
      // use value of config.overrideLastItem if passed
      (h == null ? void 0 : h.overrideLastItem) !== void 0 ? h.overrideLastItem : !C
    )
      l((_) => [..._.slice(0, c), p]);
    else {
      const _ = s.length >= n;
      l((v) => [...v.slice(_ ? 1 : 0, c + 1), p]), _ || u((v) => v + 1);
    }
    o(p), a == null || a(p);
  }, () => {
    if (c <= 0)
      return { success: !1 };
    const p = s[c - 1];
    return o(p), u((h) => h - 1), a == null || a(p), { success: !0, value: p };
  }, () => {
    if (c + 1 >= s.length)
      return { success: !1 };
    const p = s[c + 1];
    return o(p), u((h) => h + 1), a == null || a(p), { success: !0, value: p };
  }];
}
const yV = ".", dr = {
  defaultCountry: n5,
  initialCountry: n5,
  value: "",
  prefix: "+",
  defaultMask: "............",
  // 12 chars
  charAfterDialCode: " ",
  historySaveDebounceMS: 200,
  allowMoreDigitsThanMaskAllows: !0,
  disableCountryGuess: !1,
  disableDialCodePrefill: !1,
  forceDialCode: !1,
  disableDialCodeAndPrefix: !1,
  countries: A3,
  dontShowDialCodePrefillOnFocus: !1
}, vV = ({
  defaultCountry: e = dr.defaultCountry,
  initialCountry: t = dr.initialCountry,
  value: n = dr.value,
  countries: r = dr.countries,
  prefix: a = dr.prefix,
  defaultMask: i = dr.defaultMask,
  allowMoreDigitsThanMaskAllows: o = dr.allowMoreDigitsThanMaskAllows,
  charAfterDialCode: s = dr.charAfterDialCode,
  historySaveDebounceMS: l = dr.historySaveDebounceMS,
  disableCountryGuess: c = dr.disableCountryGuess,
  disableDialCodePrefill: u = dr.disableDialCodePrefill,
  forceDialCode: d = dr.forceDialCode,
  disableDialCodeAndPrefix: p = dr.disableDialCodeAndPrefix,
  dontShowDialCodePrefillOnFocus: h = dr.dontShowDialCodePrefillOnFocus,
  onChange: m
}) => {
  const f = n || "", C = p ? !1 : !c, _ = be(null), v = ({
    value: Z,
    country: G,
    trimNonDigitsEnd: W,
    insertDialCodeOnEmpty: j,
    forceDisableCountryGuess: T
  }) => {
    const F = !T && C ? Sd({
      phone: Z,
      countries: r,
      currentCountryIso2: G.iso2,
      defaultCountry: e
    }) : void 0, N = (F == null ? void 0 : F.country) ?? G;
    return { phone: N ? hV(Z, {
      prefix: a,
      mask: N.format || i,
      maskChar: yV,
      dialCode: N.dialCode,
      allowMoreDigitsThanMaskAllows: o,
      trimNonDigitsEnd: W,
      charAfterDialCode: s,
      forceDialCode: d,
      insertDialCodeOnEmpty: j,
      disableDialCodeAndPrefix: p
    }) : Z, countryGuessResult: F, formatCountry: N };
  }, w = (Z) => {
    typeof document < "u" && document.activeElement === _.current && Promise.resolve().then(() => {
      var G;
      (G = _.current) == null || G.setSelectionRange(Z, Z);
    });
  }, k = ft(
    ({ phone: Z, country: G }) => m == null ? void 0 : m({
      phone: Z,
      unformatedPhone: An(Z),
      country: G,
      prefix: a
    }),
    [m, a]
  ), [{ phone: b, country: S }, P, O, A] = gV(
    () => {
      const Z = Sd({
        phone: f,
        countries: r,
        currentCountryIso2: t,
        defaultCountry: e
      }).country || xi({
        value: t,
        field: "iso2",
        countries: r,
        defaultCountry: e
      });
      Z || console.error(
        `[react-international-phone]: can not find a country with "${e}" iso2 code`
      );
      const G = Z || // set "us" if user provided not valid country
      hn(r.find((j) => hn(j).iso2 === n5)), W = v({
        value: f,
        country: G,
        insertDialCodeOnEmpty: h ? !u : !1
      }).phone;
      return w(W.length), {
        phone: W,
        country: G.iso2
      };
    },
    {
      overrideLastItemDebounceMS: l,
      onChange: k
    }
  ), L = _e(() => xi({
    value: S,
    field: "iso2",
    countries: r,
    defaultCountry: e
  }), [r, S, e]), I = ft(() => {
    var Z;
    h || (Z = _ == null ? void 0 : _.current) != null && Z.value || k == null || k({
      phone: kd({
        phone: b,
        dialCode: L.dialCode,
        charAfterDialCode: s,
        prefix: a
      }),
      country: S
    });
  }, [
    s,
    S,
    L,
    k,
    b,
    a,
    h
  ]), D = (Z, {
    deletion: G,
    cursorPosition: W,
    insertDialCodeOnEmpty: j,
    inserted: T
  } = {}) => {
    var F;
    let N = Z, Y = W;
    d && !p && L && // dial code has been changed
    !An(Z).startsWith(L.dialCode) && Z && (T && Z.startsWith(a) && // cursor position was set to 0 before the input
    Z.length - (W ?? 0) === 0 ? N = Z : (N = b, Y = 0));
    const { phone: Q, countryGuessResult: V } = v({
      value: N,
      country: L,
      trimNonDigitsEnd: G === "backward",
      // trim values if user deleting chars (delete mask's whitespace and brackets)
      insertDialCodeOnEmpty: j,
      forceDisableCountryGuess: d && !!G && An(N).length < L.dialCode.length
    });
    let re = L;
    C && V != null && V.country && V.country.name !== S && V.fullDialCodeMatch && (re = V.country);
    const q = mV({
      cursorPositionAfterInput: Y ?? 0,
      phoneBeforeInput: b,
      phoneAfterInput: Z,
      phoneAfterFormatted: Q,
      leftOffset: d ? a.length + (((F = L == null ? void 0 : L.dialCode) == null ? void 0 : F.length) ?? 0) + s.length : 0,
      deletion: G
    });
    return P({
      phone: Q,
      country: re.iso2
    }), w(q), Q;
  };
  Re(() => {
    const Z = _.current;
    if (!Z)
      return;
    const G = (W) => {
      if (!W.key)
        return;
      const j = W.ctrlKey, T = W.shiftKey, F = W.key.toLowerCase() === "z";
      !j || !F || (T ? A() : O());
    };
    return Z.addEventListener("keydown", G), () => {
      Z.removeEventListener("keydown", G);
    };
  }, [_, O, A]);
  const U = (Z) => {
    Z.preventDefault();
    const G = Z.nativeEvent.inputType, W = () => {
      if ((G == null ? void 0 : G.toLocaleLowerCase().includes("delete")) ?? !1)
        return G != null && G.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
    }, j = G == null ? void 0 : G.startsWith("insertFrom"), T = D(Z.target.value, {
      deletion: W(),
      inserted: j,
      cursorPosition: Z.target.selectionStart ?? 0
    });
    return p && L ? kd({
      phone: T,
      dialCode: L.dialCode,
      charAfterDialCode: s,
      prefix: a
    }) : T;
  }, z = (Z) => {
    const G = xi({
      value: Z,
      field: "iso2",
      countries: r,
      defaultCountry: e
    });
    if (!G)
      return;
    const W = p ? "" : `${a}${G.dialCode}${s}`;
    P({
      phone: W,
      country: G.iso2
    }), Promise.resolve().then(() => {
      var j;
      (j = _.current) == null || j.focus();
    });
  }, [$, ee] = ke(!1);
  return Re(() => {
    if (!$) {
      ee(!0), f !== b && (k == null || k({ phone: b, country: S }));
      return;
    }
    An(f) !== An(b) && D(An(f));
  }, [f]), Re(() => {
    if (!b && t) {
      const Z = xi({
        value: t,
        field: "iso2",
        countries: r,
        defaultCountry: e
      });
      P({
        phone: b,
        country: (Z == null ? void 0 : Z.iso2) || e
      });
    }
  }, [t]), {
    phone: b,
    // Formatted phone string.
    country: S,
    // Current country iso code.
    setCountry: z,
    // Country setter.
    handlePhoneValueChange: U,
    // Change handler for input component
    onFocus: I,
    inputRef: _
    // Ref object for input component (handles caret position, focus and undo/redo).
  };
}, bV = (e, t) => {
  const n = parseInt(e, 16);
  return Number(n + t).toString(16);
}, _V = "abcdefghijklmnopqrstuvwxyz", wV = "1f1e6", Md = _V.split("").reduce((e, t, n) => ({
  ...e,
  // construct alphabet by incrementing A letter codepoint value
  [t]: bV(wV, n)
}), {}), xV = (e) => [Md[e[0]], Md[e[1]]].join("-"), By = ({
  iso2: e,
  size: t = "24px",
  protocol: n = "https",
  disableLazyLoading: r,
  className: a,
  ...i
}) => {
  if (!e)
    return /* @__PURE__ */ y.jsx("img", { width: t, height: t, ...i });
  const o = xV(e), s = `${n}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${o}.svg`;
  return /* @__PURE__ */ y.jsx(
    "img",
    {
      className: mr({
        addPrefix: ["flag-emoji"],
        rawClassNames: [a]
      }),
      src: s,
      width: t,
      height: t,
      draggable: !1,
      "data-country": e,
      loading: r ? void 0 : "lazy",
      ...i
    }
  );
}, zy = ({
  show: e,
  dialCodePrefix: t = "+",
  selectedCountry: n,
  countries: r = A3,
  onSelect: a,
  onClose: i,
  searchInputPlaceholder: o,
  ...s
}) => {
  const l = be(null), c = be(null), u = be(), [d, p] = ke(""), h = _e(() => {
    if (d) {
      const S = d.toLowerCase();
      return r.filter(([P]) => P.toLowerCase().includes(S));
    } else
      return r;
  }, [r, d]), m = ft(
    (S) => h.findIndex((P) => hn(P).iso2 === S),
    [h]
  ), [f, C] = ke(m(n)), _ = () => {
    u.current !== n && C(m(n));
  }, v = ft(
    (S) => {
      C(m(S.iso2)), a == null || a(S);
    },
    [a, m]
  ), w = (S) => {
    const P = h.length - 1, O = (A) => S === "prev" ? A - 1 : S === "next" ? A + 1 : S === "last" ? P : 0;
    C((A) => {
      const L = O(A);
      return L < 0 ? 0 : L > P ? P : L;
    });
  }, k = (S) => {
    if (S.stopPropagation(), S.key === "Enter") {
      const P = hn(h[f]);
      v(P);
      return;
    }
    if (S.key === "Escape") {
      i == null || i();
      return;
    }
    if (S.key === "ArrowUp") {
      S.preventDefault(), w("prev");
      return;
    }
    if (S.key === "ArrowDown") {
      S.preventDefault(), w("next");
      return;
    }
    if (S.key === "PageUp") {
      S.preventDefault(), w("first");
      return;
    }
    if (S.key === "PageDown") {
      S.preventDefault(), w("last");
      return;
    }
    S.key === " " && S.preventDefault();
  }, b = ft(() => {
    if (!c.current || f === void 0 || !h[f])
      return;
    const S = hn(h[f]).iso2;
    if (S === u.current)
      return;
    const P = c.current.querySelector(`[data-country="${S}"]`);
    P && (uV(c.current, P), u.current = S);
  }, [f, h]);
  return Re(() => {
    b();
  }, [f, b]), Re(() => {
    l.current && (e ? Promise.resolve().then(() => {
      var S;
      return (S = l.current) == null ? void 0 : S.focus();
    }) : _());
  }, [e]), Re(() => {
    _();
  }, [n]), /* @__PURE__ */ y.jsxs(
    "div",
    {
      className: mr({
        addPrefix: ["country-selector-dropdown"],
        rawClassNames: [s.className]
      }),
      style: { display: e ? "block" : "none", ...s.style },
      tabIndex: -1,
      "aria-activedescendant": `${h[f] && hn(h[f]).iso2}-option`,
      onBlur: i,
      children: [
        /* @__PURE__ */ y.jsx(
          "input",
          {
            ref: l,
            className: mr({
              addPrefix: ["country-selector-dropdown__search-input"],
              rawClassNames: [s.searchInputClassName]
            }),
            placeholder: o || "",
            style: s.searchInputStyle,
            type: "text",
            value: d,
            onChange: (S) => p(S.target.value),
            onKeyDown: k
          }
        ),
        d && /* @__PURE__ */ y.jsx(
          l3,
          {
            onClick: () => p(""),
            className: mr({
              addPrefix: ["country-selector-dropdown__clear-search-input"],
              rawClassNames: [s.clearSearchInputClassName]
            }),
            style: s.clearSearchInputStyle
          }
        ),
        /* @__PURE__ */ y.jsx(
          "ul",
          {
            ref: c,
            role: "listbox",
            className: mr({
              addPrefix: ["country-selector-dropdown__list"],
              rawClassNames: [s.listClassName]
            }),
            style: s.listStyle,
            children: h.map((S, P) => {
              const O = hn(S), A = O.iso2 === n, L = P === f;
              return /* @__PURE__ */ y.jsxs(
                "li",
                {
                  "data-country": O.iso2,
                  "data-focused": L,
                  role: "option",
                  "aria-selected": A,
                  "aria-label": `${O.name} ${t}${O.dialCode}`,
                  id: `${O.iso2}-option`,
                  className: mr({
                    addPrefix: [
                      "country-selector-dropdown__list-item",
                      A && "country-selector-dropdown__list-item--selected",
                      L && "country-selector-dropdown__list-item--focused"
                    ],
                    rawClassNames: [s.listItemClassName]
                  }),
                  onClick: () => v(O),
                  style: s.listItemStyle,
                  children: [
                    /* @__PURE__ */ y.jsx(
                      By,
                      {
                        iso2: O.iso2,
                        className: mr({
                          addPrefix: ["country-selector-dropdown__list-item-flag-emoji"],
                          rawClassNames: [s.listItemFlagClassName]
                        }),
                        style: s.listItemFlagStyle
                      }
                    ),
                    /* @__PURE__ */ y.jsx(
                      "span",
                      {
                        className: mr({
                          addPrefix: ["country-selector-dropdown__list-item-country-name"],
                          rawClassNames: [s.listItemCountryNameClassName]
                        }),
                        style: s.listItemCountryNameStyle,
                        children: O.name
                      }
                    ),
                    /* @__PURE__ */ y.jsxs(
                      "span",
                      {
                        className: mr({
                          addPrefix: ["country-selector-dropdown__list-item-dial-code"],
                          rawClassNames: [s.listItemDialCodeClassName]
                        }),
                        style: s.listItemDialCodeStyle,
                        children: [
                          t,
                          O.dialCode
                        ]
                      }
                    )
                  ]
                },
                O.iso2
              );
            })
          }
        )
      ]
    }
  );
}, SV = ({
  selectedCountry: e,
  onSelect: t,
  disabled: n,
  hideDropdown: r,
  defaultCountry: a = n5,
  countries: i = A3,
  renderButtonWrapper: o,
  ...s
}) => {
  const [l, c] = ke(!1), u = _e(() => {
    if (e)
      return xi({
        value: e,
        field: "iso2",
        countries: i,
        defaultCountry: a
      });
  }, [i, a, e]), d = be(null), p = (m) => {
    m.key && ["ArrowUp", "ArrowDown"].includes(m.key) && (m.preventDefault(), c(!0));
  }, h = () => {
    const m = {
      title: u == null ? void 0 : u.name,
      onClick: () => c((C) => !C),
      // Need this to close dropdown on selector button click
      // https://stackoverflow.com/a/28963938
      onMouseDown: (C) => C.preventDefault(),
      onKeyDown: p,
      disabled: r || n,
      role: "combobox",
      "aria-label": "Country selector",
      "aria-haspopup": "listbox",
      "aria-expanded": l
    }, f = /* @__PURE__ */ y.jsxs(
      "div",
      {
        className: mr({
          addPrefix: ["country-selector-button__button-content"],
          rawClassNames: [s.buttonContentWrapperClassName]
        }),
        style: s.buttonContentWrapperStyle,
        children: [
          /* @__PURE__ */ y.jsx(
            By,
            {
              iso2: e,
              className: mr({
                addPrefix: [
                  "country-selector-button__flag-emoji",
                  n && "country-selector-button__flag-emoji--disabled"
                ],
                rawClassNames: [s.flagClassName]
              }),
              style: {
                visibility: e ? "visible" : "hidden",
                ...s.flagStyle
              }
            }
          ),
          !r && /* @__PURE__ */ y.jsx(
            "div",
            {
              className: mr({
                addPrefix: [
                  "country-selector-button__dropdown-arrow",
                  n && "country-selector-button__dropdown-arrow--disabled",
                  l && "country-selector-button__dropdown-arrow--active"
                ],
                rawClassNames: [s.dropdownArrowClassName]
              }),
              style: s.dropdownArrowStyle
            }
          )
        ]
      }
    );
    return o ? o({
      children: f,
      rootProps: m
    }) : /* @__PURE__ */ y.jsx(
      "button",
      {
        ...m,
        type: "button",
        className: mr({
          addPrefix: [
            "country-selector-button",
            l && "country-selector-button--active",
            n && "country-selector-button--disabled",
            r && "country-selector-button--hide-dropdown"
          ],
          rawClassNames: [s.buttonClassName]
        }),
        "data-country": e,
        style: s.buttonStyle,
        children: f
      }
    );
  };
  return /* @__PURE__ */ y.jsxs(
    "div",
    {
      className: mr({
        addPrefix: ["country-selector"],
        rawClassNames: [s.className]
      }),
      style: s.style,
      ref: d,
      children: [
        h(),
        /* @__PURE__ */ y.jsx(
          zy,
          {
            show: l,
            countries: i,
            onSelect: (m) => {
              c(!1), t == null || t(m);
            },
            selectedCountry: e,
            onClose: () => {
              c(!1);
            },
            ...s.dropdownStyleProps
          }
        )
      ]
    }
  );
}, kV = ({
  label: e,
  labelClassName: t,
  required: n,
  value: r,
  onChange: a,
  error: i,
  wrapperClassName: o,
  inputClassName: s,
  listClassName: l,
  searchInputClassName: c,
  clearSearchInputClassName: u,
  listItemClassName: d,
  listItemCountryNameClassName: p,
  countrySelectorDropdownClassName: h,
  countrySelectorClassName: m,
  buttonClassName: f,
  listboxButtonClassName: C,
  listboxOptionsClassName: _,
  initialCountry: v,
  ...w
}) => {
  const k = be(null), b = be(null), S = be(null), { country: P, setCountry: O, phone: A, handlePhoneValueChange: L, onFocus: I, inputRef: D } = vV({
    value: r,
    onChange: ({ unformatedPhone: U }) => a(U),
    initialCountry: v == null ? void 0 : v.toLowerCase()
  });
  return /* @__PURE__ */ y.jsx("div", { className: o, children: /* @__PURE__ */ y.jsx(uE, { children: ({ open: U }) => {
    var z;
    return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
      /* @__PURE__ */ y.jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ y.jsx(
          ba,
          {
            label: e,
            required: n,
            labelClassName: Fe("text-sm font-medium", t)
          }
        ),
        /* @__PURE__ */ y.jsxs(
          "div",
          {
            ref: b,
            className: "relative w-full cursor-default overflow-hidden rounded-lg text-left",
            children: [
              /* @__PURE__ */ y.jsxs(
                fC,
                {
                  ref: S,
                  as: "div",
                  disabled: w.disabled,
                  className: Fe(
                    "z-1 absolute left-0 top-2 flex cursor-pointer items-center gap-1 pl-3",
                    C,
                    w.disabled && "cursor-not-allowed"
                  ),
                  children: [
                    /* @__PURE__ */ y.jsx(
                      SV,
                      {
                        className: Fe("flex", m),
                        buttonStyle: { border: "none" },
                        buttonClassName: Fe(
                          w.disabled ? "cursor-not-allowed" : "cursor-pointer",
                          f
                        ),
                        hideDropdown: !0,
                        disabled: w.disabled,
                        selectedCountry: P,
                        defaultCountry: v == null ? void 0 : v.toLowerCase()
                      }
                    ),
                    /* @__PURE__ */ y.jsx(
                      c3,
                      {
                        className: `transition-transform duration-300 ${U && "rotate-180"} `,
                        "aria-hidden": "true"
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ y.jsx(
                wi,
                {
                  ref: D,
                  type: "tel",
                  placeholder: Xe.t("public_pages_purchase.input.phone_number"),
                  inputClassName: Fe(
                    "pl-16",
                    U && "border-brand-primary",
                    s
                  ),
                  value: A,
                  onChange: L,
                  onFocus: I,
                  error: i,
                  ...w
                }
              )
            ]
          }
        )
      ] }),
      /* @__PURE__ */ y.jsx(
        CC,
        {
          className: Fe("focus-visible:outline-hidden", _),
          children: /* @__PURE__ */ y.jsx(
            "div",
            {
              className: "bg-background-secondary absolute z-20 rounded-lg",
              ref: k,
              style: {
                width: `${(z = D.current) == null ? void 0 : z.clientWidth}px`
              },
              children: /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(
                zy,
                {
                  className: Fe(
                    "bg-background-secondary shadow-around-sm rounded-md text-sm",
                    h
                  ),
                  listClassName: Fe(
                    "max-h-60 w-full overflow-auto focus:outline-hidden customScroll rounded-md",
                    l
                  ),
                  searchInputClassName: Fe(
                    `w-full px-4 py-2.5 rounded-t-md border border-t-1 border-b-0 border-text-secondary/30 
                        shadow-around-sm focus:outline-hidden
                      `,
                    c
                  ),
                  clearSearchInputClassName: Fe(
                    "absolute top-0 right-2 w-[21px] h-[21px] translate-y-1/2 z-1 fill-text-primary cursor-pointer scale-75",
                    u
                  ),
                  listItemClassName: Fe(
                    `text-text-primary px-4 py-2.5 border border-t-0 last:rounded-b-md border-text-secondary/30 
                        group hover:bg-brand-primary hover:text-background-secondary flex justify-start gap-2 items-center 
                        data-[focused=true]:bg-brand-primary aria-[selected=true]:font-bold`,
                    d
                  ),
                  listItemCountryNameClassName: Fe(
                    "truncate",
                    p
                  ),
                  searchInputPlaceholder: Xe.t("public_pages_purchase.input.phone_search"),
                  show: U,
                  selectedCountry: P,
                  onSelect: ($) => {
                    var ee;
                    O($.iso2), (ee = S.current) == null || ee.click();
                  }
                }
              ) })
            }
          )
        }
      )
    ] });
  } }) });
};
var p6 = /* @__PURE__ */ ((e) => (e.Last30Days = "last_30_days", e.ThisMonth = "this_month", e.LastMonth = "last_month", e))(p6 || {}), h6 = /* @__PURE__ */ ((e) => (e.AllTime = "all_time", e.Last3Months = "last_3_months", e.EvaluationPeriod = "evaluation_period", e))(h6 || {});
const MV = Ji(
  ({
    onClick: e,
    error: t,
    label: n,
    labelClassName: r,
    required: a,
    wrapperButtonInputClassName: i,
    buttonInputClassName: o,
    description: s,
    children: l,
    value: c
  }, u) => /* @__PURE__ */ y.jsxs("div", { className: Fe("flex flex-col gap-1", i), children: [
    /* @__PURE__ */ y.jsx(ba, { label: n, labelClassName: r, required: a }),
    /* @__PURE__ */ y.jsxs("button", { onClick: e, ref: u, type: "button", className: o, children: [
      l(c),
      /* @__PURE__ */ y.jsx(
        RL,
        {
          className: Fe(
            "fill-fill-primary group-focus:fill-brand-primary main-transition-colors ml-3 hidden h-[20px] w-[20px] sm:block",
            c ? "hidden sm:block" : "block"
          )
        }
      )
    ] }),
    /* @__PURE__ */ y.jsx(oo, { error: t, description: s })
  ] })
);
MV.displayName = "ButtonInput";
p6.Last30Days + "", p6.ThisMonth + "", p6.LastMonth + "";
h6.AllTime + "", h6.Last3Months + "", h6.EvaluationPeriod + "";
const Ye = (e) => typeof e == "string", jo = () => {
  let e, t;
  const n = new Promise((r, a) => {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}, Pd = (e) => e == null ? "" : "" + e, PV = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, EV = /###/g, Ed = (e) => e && e.indexOf("###") > -1 ? e.replace(EV, ".") : e, Td = (e) => !e || Ye(e), vs = (e, t, n) => {
  const r = Ye(t) ? t.split(".") : t;
  let a = 0;
  for (; a < r.length - 1; ) {
    if (Td(e))
      return {};
    const i = Ed(r[a]);
    !e[i] && n && (e[i] = new n()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++a;
  }
  return Td(e) ? {} : {
    obj: e,
    k: Ed(r[a])
  };
}, Ld = (e, t, n) => {
  const {
    obj: r,
    k: a
  } = vs(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[a] = n;
    return;
  }
  let i = t[t.length - 1], o = t.slice(0, t.length - 1), s = vs(e, o, Object);
  for (; s.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), s = vs(e, o, Object), s && s.obj && typeof s.obj[`${s.k}.${i}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = n;
}, TV = (e, t, n, r) => {
  const {
    obj: a,
    k: i
  } = vs(e, t, Object);
  a[i] = a[i] || [], a[i].push(n);
}, a5 = (e, t) => {
  const {
    obj: n,
    k: r
  } = vs(e, t);
  if (n)
    return n[r];
}, LV = (e, t, n) => {
  const r = a5(e, n);
  return r !== void 0 ? r : a5(t, n);
}, Gy = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? Ye(e[r]) || e[r] instanceof String || Ye(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : Gy(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, ui = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var AV = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const OV = (e) => Ye(e) ? e.replace(/[&<>"'\/]/g, (t) => AV[t]) : e;
class NV {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const jV = [" ", ",", "?", "!", ";"], RV = new NV(20), DV = (e, t, n) => {
  t = t || "", n = n || "";
  const r = jV.filter((o) => t.indexOf(o) < 0 && n.indexOf(o) < 0);
  if (r.length === 0)
    return !0;
  const a = RV.getRegExp(`(${r.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !a.test(e);
  if (!i) {
    const o = e.indexOf(n);
    o > 0 && !a.test(e.substring(0, o)) && (i = !0);
  }
  return i;
}, tl = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let a = e;
  for (let i = 0; i < r.length; ) {
    if (!a || typeof a != "object")
      return;
    let o, s = "";
    for (let l = i; l < r.length; ++l)
      if (l !== i && (s += n), s += r[l], o = a[s], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < r.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    a = o;
  }
  return a;
}, i5 = (e) => e && e.replace("_", "-"), IV = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class o5 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || IV, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, a) {
    return a && !this.debug ? null : (Ye(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new o5(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new o5(this.logger, t);
  }
}
var Fn = new o5();
class f8 {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const a = this.observers[r].get(n) || 0;
      this.observers[r].set(n, a + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((o) => {
      let [s, l] = o;
      for (let c = 0; c < l; c++)
        s(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((o) => {
      let [s, l] = o;
      for (let c = 0; c < l; c++)
        s.apply(s, [t, ...r]);
    });
  }
}
class Ad extends f8 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, o = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], r && (Array.isArray(r) ? s.push(...r) : Ye(r) && i ? s.push(...r.split(i)) : s.push(r)));
    const l = a5(this.data, s);
    return !l && !n && !r && t.indexOf(".") > -1 && (t = s[0], n = s[1], r = s.slice(2).join(".")), l || !o || !Ye(r) ? l : tl(this.data && this.data[t] && this.data[t][n], r, i);
  }
  addResource(t, n, r, a) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [t, n];
    r && (s = s.concat(o ? r.split(o) : r)), t.indexOf(".") > -1 && (s = t.split("."), a = n, n = s[1]), this.addNamespaces(n), Ld(this.data, s, a), i.silent || this.emit("added", t, n, r, a);
  }
  addResources(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (Ye(r[i]) || Array.isArray(r[i])) && this.addResource(t, n, i, r[i], {
        silent: !0
      });
    a.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), a = r, r = n, n = s[1]), this.addNamespaces(n);
    let l = a5(this.data, s) || {};
    o.skipCopy || (r = JSON.parse(JSON.stringify(r))), a ? Gy(l, r, i) : l = {
      ...l,
      ...r
    }, Ld(this.data, s, l), o.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((a) => n[a] && Object.keys(n[a]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Uy = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, a) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, n, r, a));
    }), t;
  }
};
const Od = {};
class s5 extends f8 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), PV(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Fn.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const o = r && t.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !DV(t, r, a);
    if (o && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: Ye(i) ? [i] : i
        };
      const c = t.split(r);
      (r !== a || r === a && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: Ye(i) ? [i] : i
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const a = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], n), l = s[s.length - 1], c = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const k = n.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${k}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${k}${o}`;
      }
      return a ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : o;
    }
    const d = this.resolve(t, n);
    let p = d && d.res;
    const h = d && d.usedKey || o, m = d && d.exactUsedKey || o, f = Object.prototype.toString.apply(p), C = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !Ye(p) && typeof p != "boolean" && typeof p != "number";
    if (v && p && w && C.indexOf(f) < 0 && !(Ye(_) && Array.isArray(p))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const k = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, p, {
          ...n,
          ns: s
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return a ? (d.res = k, d.usedParams = this.getUsedParamsDetails(n), d) : k;
      }
      if (i) {
        const k = Array.isArray(p), b = k ? [] : {}, S = k ? m : h;
        for (const P in p)
          if (Object.prototype.hasOwnProperty.call(p, P)) {
            const O = `${S}${i}${P}`;
            b[P] = this.translate(O, {
              ...n,
              joinArrays: !1,
              ns: s
            }), b[P] === O && (b[P] = p[P]);
          }
        p = b;
      }
    } else if (v && Ye(_) && Array.isArray(p))
      p = p.join(_), p && (p = this.extendTranslation(p, t, n, r));
    else {
      let k = !1, b = !1;
      const S = n.count !== void 0 && !Ye(n.count), P = s5.hasDefaultValue(n), O = S ? this.pluralResolver.getSuffix(c, n.count, n) : "", A = n.ordinal && S ? this.pluralResolver.getSuffix(c, n.count, {
        ordinal: !1
      }) : "", L = S && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), I = L && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${O}`] || n[`defaultValue${A}`] || n.defaultValue;
      !this.isValidLookup(p) && P && (k = !0, p = I), this.isValidLookup(p) || (b = !0, p = o);
      const U = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && b ? void 0 : p, z = P && I !== p && this.options.updateMissing;
      if (b || k || z) {
        if (this.logger.log(z ? "updateKey" : "missingKey", c, l, o, z ? I : p), i) {
          const G = this.resolve(o, {
            ...n,
            keySeparator: !1
          });
          G && G.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let $ = [];
        const ee = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && ee && ee[0])
          for (let G = 0; G < ee.length; G++)
            $.push(ee[G]);
        else
          this.options.saveMissingTo === "all" ? $ = this.languageUtils.toResolveHierarchy(n.lng || this.language) : $.push(n.lng || this.language);
        const Z = (G, W, j) => {
          const T = P && j !== p ? j : U;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(G, l, W, T, z, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(G, l, W, T, z, n), this.emit("missingKey", G, l, W, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && S ? $.forEach((G) => {
          const W = this.pluralResolver.getSuffixes(G, n);
          L && n[`defaultValue${this.options.pluralSeparator}zero`] && W.indexOf(`${this.options.pluralSeparator}zero`) < 0 && W.push(`${this.options.pluralSeparator}zero`), W.forEach((j) => {
            Z([G], o + j, n[`defaultValue${j}`] || I);
          });
        }) : Z($, o, I));
      }
      p = this.extendTranslation(p, t, n, d, r), b && p === o && this.options.appendNamespaceToMissingKey && (p = `${l}:${o}`), (b || k) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, k ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return a ? (d.res = p, d.usedParams = this.getUsedParamsDetails(n), d) : p;
  }
  extendTranslation(t, n, r, a, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = Ye(t) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const p = t.match(this.interpolator.nestingRegexp);
        u = p && p.length;
      }
      let d = r.replace && !Ye(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), t = this.interpolator.interpolate(t, d, r.lng || this.language || a.usedLng, r), c) {
        const p = t.match(this.interpolator.nestingRegexp), h = p && p.length;
        u < h && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (r.lng = this.language || a.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var p = arguments.length, h = new Array(p), m = 0; m < p; m++)
          h[m] = arguments[m];
        return i && i[0] === h[0] && !r.context ? (o.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${n[0]}`), null) : o.translate(...h, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = Ye(s) ? [s] : s;
    return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = Uy.handle(l, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, a, i, o, s;
    return Ye(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const c = this.extractFromKey(l, n), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !Ye(n.count), h = p && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = n.context !== void 0 && (Ye(n.context) || typeof n.context == "number") && n.context !== "", f = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((C) => {
        this.isValidLookup(r) || (s = C, !Od[`${f[0]}-${C}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (Od[`${f[0]}-${C}`] = !0, this.logger.warn(`key "${a}" for languages "${f.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach((_) => {
          if (this.isValidLookup(r))
            return;
          o = _;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, _, C, n);
          else {
            let k;
            p && (k = this.pluralResolver.getSuffix(_, n.count, n));
            const b = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (v.push(u + k), n.ordinal && k.indexOf(S) === 0 && v.push(u + k.replace(S, this.options.pluralSeparator)), h && v.push(u + b)), m) {
              const P = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(P), p && (v.push(P + k), n.ordinal && k.indexOf(S) === 0 && v.push(P + k.replace(S, this.options.pluralSeparator)), h && v.push(P + b));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(r) || (i = w, r = this.getResource(_, C, w, n));
        }));
      });
    }), {
      res: r,
      usedKey: a,
      exactUsedKey: i,
      usedLng: o,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, a) : this.resourceStore.getResource(t, n, r, a);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && !Ye(t.replace);
    let a = r ? t.replace : t;
    if (r && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !r) {
      a = {
        ...a
      };
      for (const i of n)
        delete a[i];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
const S7 = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class Nd {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Fn.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = i5(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = i5(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (Ye(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(t)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a)
            return a;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((a) => a.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = S7(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = S7(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = S7(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const a = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const a = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(a))
        return n = a;
      n = this.options.supportedLngs.find((i) => {
        if (i === a)
          return i;
        if (!(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), Ye(t) && (t = [t]), Array.isArray(t))
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), a = [], i = (o) => {
      o && (this.isSupportedCode(o) ? a.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return Ye(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : Ye(t) && i(this.formatLanguageCode(t)), r.forEach((o) => {
      a.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), a;
  }
}
let HV = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], FV = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const VV = ["v1", "v2", "v3"], BV = ["v4"], jd = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, zV = () => {
  const e = {};
  return HV.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: FV[t.fc]
      };
    });
  }), e;
};
class GV {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = Fn.create("pluralResolver"), (!this.options.compatibilityJSON || BV.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = zV(), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = i5(t === "dev" ? "en" : t), a = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: r,
        type: a
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let o;
      try {
        o = new Intl.PluralRules(r, {
          type: a
        });
      } catch {
        if (!t.match(/-|_/))
          return;
        const l = this.languageUtils.getLanguagePartFromCode(t);
        o = this.getRule(l, n);
      }
      return this.pluralRulesCache[i] = o, o;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((a) => `${n}${a}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((a, i) => jd[a] - jd[i]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : r.numbers.map((a) => this.getSuffix(t, a, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(t, r);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : this.getSuffixRetroCompatible(a, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let a = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const i = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !VV.includes(this.options.compatibilityJSON);
  }
}
const Rd = function(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = LV(e, t, n);
  return !i && a && Ye(n) && (i = tl(e, n, r), i === void 0 && (i = tl(t, n, r))), i;
}, k7 = (e) => e.replace(/\$/g, "$$$$");
class UV {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Fn.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: a,
      prefix: i,
      prefixEscaped: o,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: p,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: f,
      nestingOptionsSeparator: C,
      maxReplaces: _,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : OV, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = i ? ui(i) : o || "{{", this.suffix = s ? ui(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = p ? ui(p) : h || ui("$t("), this.nestingSuffix = m ? ui(m) : f || ui(")"), this.nestingOptionsSeparator = C || ",", this.maxReplaces = _ || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, a) {
    let i, o, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const _ = Rd(n, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(_, void 0, r, {
          ...a,
          ...n,
          interpolationkey: h
        }) : _;
      }
      const m = h.split(this.formatSeparator), f = m.shift().trim(), C = m.join(this.formatSeparator).trim();
      return this.format(Rd(n, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), C, r, {
        ...a,
        ...n,
        interpolationkey: f
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => k7(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? k7(this.escape(h)) : k7(h)
    }].forEach((h) => {
      for (s = 0; i = h.regex.exec(t); ) {
        const m = i[1].trim();
        if (o = c(m), o === void 0)
          if (typeof u == "function") {
            const C = u(t, i, a);
            o = Ye(C) ? C : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, m))
            o = "";
          else if (d) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), o = "";
        else
          !Ye(o) && !this.useRawValueToEscape && (o = Pd(o));
        const f = h.safeValue(o);
        if (t = t.replace(i[0], f), d ? (h.regex.lastIndex += o.length, h.regex.lastIndex -= i[0].length) : h.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, i, o;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, o);
      const h = p.match(/'/g), m = p.match(/"/g);
      (h && h.length % 2 === 0 && !m || m.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        o = JSON.parse(p), c && (o = {
          ...c,
          ...o
        });
      } catch (f) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, f), `${l}${u}${p}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      o = {
        ...r
      }, o = o.replace && !Ye(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((d) => d.trim());
        a[1] = u.shift(), l = u, c = !0;
      }
      if (i = n(s.call(this, a[1].trim(), o), o), i && a[0] === t && !Ye(i))
        return i;
      Ye(i) || (i = Pd(i)), i || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), i = ""), c && (i = l.reduce((u, d) => this.format(u, d, r.lng, {
        ...r,
        interpolationkey: a[1].trim()
      }), i.trim())), t = t.replace(a[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const ZV = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const a = r[1].substring(0, r[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((o) => {
      if (o) {
        const [s, ...l] = o.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        n[u] || (n[u] = c), c === "false" && (n[u] = !1), c === "true" && (n[u] = !0), isNaN(c) || (n[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, di = (e) => {
  const t = {};
  return (n, r, a) => {
    let i = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (i = {
      ...i,
      [a.interpolationkey]: void 0
    });
    const o = r + JSON.stringify(i);
    let s = t[o];
    return s || (s = e(i5(r), a), t[o] = s), s(n);
  };
};
class KV {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Fn.create("formatter"), this.options = t, this.formats = {
      number: di((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      currency: di((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (i) => a.format(i);
      }),
      datetime: di((n, r) => {
        const a = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      relativetime: di((n, r) => {
        const a = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i, r.range || "day");
      }),
      list: di((n, r) => {
        const a = new Intl.ListFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = di(n);
  }
  format(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((s) => s.indexOf(")") > -1)) {
      const s = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, s)].join(this.formatSeparator);
    }
    return i.reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = ZV(l);
      if (this.formats[c]) {
        let d = s;
        try {
          const p = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, h = p.locale || p.lng || a.locale || a.lng || r;
          d = this.formats[c](s, h, {
            ...u,
            ...a,
            ...p
          });
        } catch (p) {
          this.logger.warn(p);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, t);
  }
}
const $V = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class WV extends f8 {
  constructor(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = a, this.logger = Fn.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, a.backend, a);
  }
  queueLoad(t, n, r, a) {
    const i = {}, o = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const p = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? o[p] === void 0 && (o[p] = !0) : (this.state[p] = 1, u = !1, o[p] === void 0 && (o[p] = !0), i[p] === void 0 && (i[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const a = t.split("|"), i = a[0], o = a[1];
    n && this.emit("failedLoading", i, o, n), !n && r && this.store.addResourceBundle(i, o, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      TV(l.loaded, [i], o), $V(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: a,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, a + 1, i * 2, o);
        }, i);
        return;
      }
      o(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    Ye(t) && (t = this.languageUtils.toResolveHierarchy(t)), Ye(n) && (n = [n]);
    const i = this.queueLoad(t, n, r, a);
    if (!i.toLoad.length)
      return i.pending.length || a(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), a = r[0], i = r[1];
    this.read(a, i, "read", void 0, void 0, (o, s) => {
      o && this.logger.warn(`${n}loading namespace ${i} for language ${a} failed`, o), !o && s && this.logger.log(`${n}loaded namespace ${i} for language ${a}`, s), this.loaded(t, o, s);
    });
  }
  saveMissing(t, n, r, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...o,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, r, a, l) : u = c(t, n, r, a), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, n, r, a, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, a);
    }
  }
}
const Dd = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), Ye(e[1]) && (t.defaultValue = e[1]), Ye(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Id = (e) => (Ye(e.ns) && (e.ns = [e.ns]), Ye(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), Ye(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), F9 = () => {
}, YV = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
};
class Hs extends f8 {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Id(t), this.services = {}, this.logger = Fn, this.modules = {
      external: []
    }, YV(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (Ye(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const a = Dd();
    this.options = {
      ...a,
      ...this.options,
      ...Id(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const i = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? Fn.init(i(this.modules.logger), this.options) : Fn.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = KV);
      const d = new Nd(this.options);
      this.store = new Ad(this.options.resources, this.options);
      const p = this.services;
      p.logger = Fn, p.resourceStore = this.store, p.languageUtils = d, p.pluralResolver = new GV(d, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (p.formatter = i(u), p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new UV(this.options), p.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, p.backendConnector = new WV(i(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", function(h) {
        for (var m = arguments.length, f = new Array(m > 1 ? m - 1 : 0), C = 1; C < m; C++)
          f[C - 1] = arguments[C];
        t.emit(h, ...f);
      }), this.modules.languageDetector && (p.languageDetector = i(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = i(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new s5(this.services, this.options), this.translator.on("*", function(h) {
        for (var m = arguments.length, f = new Array(m > 1 ? m - 1 : 0), C = 1; C < m; C++)
          f[C - 1] = arguments[C];
        t.emit(h, ...f);
      }), this.modules.external.forEach((h) => {
        h.init && h.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = F9), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments), t;
      };
    });
    const l = jo(), c = () => {
      const u = (d, p) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(p), r(d, p);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : F9;
    const a = Ye(t) ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (a && a.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return r();
      const i = [], o = (s) => {
        if (!s || s === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && i.indexOf(c) < 0 && i.push(c);
        });
      };
      a ? o(a) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => o(l)), this.options.preload && this.options.preload.forEach((s) => o(s)), this.services.backendConnector.load(i, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(s);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const a = jo();
    return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = F9), this.services.backendConnector.reload(t, n, (i) => {
      a.resolve(), r(i);
    }), a;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Uy.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const a = jo();
    this.emit("languageChanging", t);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = Ye(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        o(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), a;
  }
  getFixedT(t, n, r) {
    var a = this;
    const i = function(o, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = a.options.overloadTranslationOptionHandler([o, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || i.keyPrefix);
      const p = a.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(o) ? h = o.map((m) => `${l.keyPrefix}${p}${m}`) : h = l.keyPrefix ? `${l.keyPrefix}${p}${o}` : o, a.t(h, l);
    };
    return Ye(t) ? i.lng = t : i.lngs = t, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const o = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, o);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(r, t) && (!a || o(i, t)));
  }
  loadNamespaces(t, n) {
    const r = jo();
    return this.options.ns ? (Ye(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = jo();
    Ye(t) && (t = [t]);
    const a = this.options.preload || [], i = t.filter((o) => a.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = a.concat(i), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Nd(Dd());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new Hs(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : F9;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new Hs(a);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      i[s] = this[s];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new Ad(this.store.data, a), i.services.resourceStore = i.store), i.translator = new s5(i.services, a), i.translator.on("*", function(s) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      i.emit(s, ...c);
    }), i.init(a, n), i.translator.options = a, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const k1 = Hs.createInstance();
k1.createInstance = Hs.createInstance;
k1.createInstance;
k1.dir;
k1.init;
k1.loadResources;
k1.reloadResources;
k1.use;
k1.changeLanguage;
k1.getFixedT;
k1.t;
k1.exists;
k1.setDefaultNamespace;
k1.hasLoadedNamespace;
k1.loadNamespaces;
k1.loadLanguages;
function qV(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) !== -1)
        continue;
      n[r] = e[r];
    }
  return n;
}
function O3(e, t) {
  if (e == null)
    return {};
  var n, r, a = qV(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
  }
  return a;
}
function Br(e) {
  "@babel/helpers - typeof";
  return Br = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Br(e);
}
function JV(e, t) {
  if (Br(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Br(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Zy(e) {
  var t = JV(e, "string");
  return Br(t) == "symbol" ? t : t + "";
}
function Ke(e, t, n) {
  return (t = Zy(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var XV = {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
};
const QV = /* @__PURE__ */ Js(XV);
var eB = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function Hd(e) {
  var t = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, n = e.match(/<\/?([^\s]+?)[/\s>]/);
  if (n && (t.name = n[1], (QV[n[1]] || e.charAt(e.length - 2) === "/") && (t.voidElement = !0), t.name.startsWith("!--"))) {
    var r = e.indexOf("-->");
    return { type: "comment", comment: r !== -1 ? e.slice(4, r) : "" };
  }
  for (var a = new RegExp(eB), i = null; (i = a.exec(e)) !== null; )
    if (i[0].trim())
      if (i[1]) {
        var o = i[1].trim(), s = [o, ""];
        o.indexOf("=") > -1 && (s = o.split("=")), t.attrs[s[0]] = s[1], a.lastIndex--;
      } else
        i[2] && (t.attrs[i[2]] = i[3].trim().substring(1, i[3].length - 1));
  return t;
}
var tB = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, rB = /^\s*$/, nB = /* @__PURE__ */ Object.create(null);
function Ky(e, t) {
  switch (t.type) {
    case "text":
      return e + t.content;
    case "tag":
      return e += "<" + t.name + (t.attrs ? function(n) {
        var r = [];
        for (var a in n)
          r.push(a + '="' + n[a] + '"');
        return r.length ? " " + r.join(" ") : "";
      }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(Ky, "") + "</" + t.name + ">";
    case "comment":
      return e + "<!--" + t.comment + "-->";
  }
}
var aB = { parse: function(e, t) {
  t || (t = {}), t.components || (t.components = nB);
  var n, r = [], a = [], i = -1, o = !1;
  if (e.indexOf("<") !== 0) {
    var s = e.indexOf("<");
    r.push({ type: "text", content: s === -1 ? e : e.substring(0, s) });
  }
  return e.replace(tB, function(l, c) {
    if (o) {
      if (l !== "</" + n.name + ">")
        return;
      o = !1;
    }
    var u, d = l.charAt(1) !== "/", p = l.startsWith("<!--"), h = c + l.length, m = e.charAt(h);
    if (p) {
      var f = Hd(l);
      return i < 0 ? (r.push(f), r) : ((u = a[i]).children.push(f), r);
    }
    if (d && (i++, (n = Hd(l)).type === "tag" && t.components[n.name] && (n.type = "component", o = !0), n.voidElement || o || !m || m === "<" || n.children.push({ type: "text", content: e.slice(h, e.indexOf("<", h)) }), i === 0 && r.push(n), (u = a[i - 1]) && u.children.push(n), a[i] = n), (!d || n.voidElement) && (i > -1 && (n.voidElement || n.name === l.slice(2, -1)) && (i--, n = i === -1 ? r : a[i]), !o && m !== "<" && m)) {
      u = i === -1 ? r : a[i].children;
      var C = e.indexOf("<", h), _ = e.slice(h, C === -1 ? void 0 : C);
      rB.test(_) && (_ = " "), (C > -1 && i + u.length >= 0 || _ !== " ") && u.push({ type: "text", content: _ });
    }
  }), r;
}, stringify: function(e) {
  return e.reduce(function(t, n) {
    return t + Ky("", n);
  }, "");
} };
function ni(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function iB(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Zy(r.key), r);
  }
}
function ai(e, t, n) {
  return t && iB(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var oB = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, sB = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, lB = function(t) {
  return sB[t];
}, cB = function(t) {
  return t.replace(oB, lB);
};
function Fd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Vd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fd(Object(n), !0).forEach(function(r) {
      Ke(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var rl = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: cB
}, $y, N3 = Qe();
function uB() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  rl = Vd(Vd({}, rl), e);
}
function Wy() {
  return rl;
}
var dB = function() {
  function e() {
    ni(this, e), this.usedNamespaces = {};
  }
  return ai(e, [{
    key: "addUsedNamespaces",
    value: function(n) {
      var r = this;
      n.forEach(function(a) {
        r.usedNamespaces[a] || (r.usedNamespaces[a] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
}();
function pB(e) {
  $y = e;
}
function Yy() {
  return $y;
}
var hB = {
  type: "3rdParty",
  init: function(t) {
    uB(t.options.react), pB(t);
  }
};
function m6() {
  if (console && console.warn) {
    for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    typeof n[0] == "string" && (n[0] = "react-i18next:: ".concat(n[0])), (e = console).warn.apply(e, n);
  }
}
var Bd = {};
function l5() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && Bd[t[0]] || (typeof t[0] == "string" && (Bd[t[0]] = /* @__PURE__ */ new Date()), m6.apply(void 0, t));
}
function zd(e, t, n) {
  e.loadNamespaces(t, function() {
    if (e.isInitialized)
      n();
    else {
      var r = function a() {
        setTimeout(function() {
          e.off("initialized", a);
        }, 0), n();
      };
      e.on("initialized", r);
    }
  });
}
function mB(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = t.languages[0], a = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (r.toLowerCase() === "cimode")
    return !0;
  var o = function(l, c) {
    var u = t.services.backendConnector.state["".concat(l, "|").concat(c)];
    return u === -1 || u === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !o(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || o(r, e) && (!a || o(i, e)));
}
function fB(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!t.languages || !t.languages.length)
    return l5("i18n.languages were undefined or empty", t.languages), !0;
  var r = t.options.ignoreJSONStructure !== void 0;
  return r ? t.hasLoadedNamespace(e, {
    precheck: function(i, o) {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && i.services.backendConnector.backend && i.isLanguageChangingTo && !o(i.isLanguageChangingTo, e))
        return !1;
    }
  }) : mB(e, t, n);
}
var CB = ["format"], gB = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];
function Gd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function A1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gd(Object(n), !0).forEach(function(r) {
      Ke(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function M7(e, t) {
  if (!e)
    return !1;
  var n = e.props ? e.props.children : e.children;
  return t ? n.length > 0 : !!n;
}
function P7(e) {
  return e ? e.props ? e.props.children : e.children : [];
}
function yB(e) {
  return Object.prototype.toString.call(e) !== "[object Array]" ? !1 : e.every(function(t) {
    return ws(t);
  });
}
function us(e) {
  return Array.isArray(e) ? e : [e];
}
function vB(e, t) {
  var n = A1({}, t);
  return n.props = Object.assign(e.props, t.props), n;
}
function qy(e, t) {
  if (!e)
    return "";
  var n = "", r = us(e), a = t.transSupportBasicHtmlNodes && t.transKeepBasicHtmlNodesFor ? t.transKeepBasicHtmlNodesFor : [];
  return r.forEach(function(i, o) {
    if (typeof i == "string")
      n += "".concat(i);
    else if (ws(i)) {
      var s = Object.keys(i.props).length, l = a.indexOf(i.type) > -1, c = i.props.children;
      if (!c && l && s === 0)
        n += "<".concat(i.type, "/>");
      else if (!c && (!l || s !== 0))
        n += "<".concat(o, "></").concat(o, ">");
      else if (i.props.i18nIsDynamicList)
        n += "<".concat(o, "></").concat(o, ">");
      else if (l && s === 1 && typeof c == "string")
        n += "<".concat(i.type, ">").concat(c, "</").concat(i.type, ">");
      else {
        var u = qy(c, t);
        n += "<".concat(o, ">").concat(u, "</").concat(o, ">");
      }
    } else if (i === null)
      m6("Trans: the passed in value is invalid - seems you passed in a null child.");
    else if (Br(i) === "object") {
      var d = i.format, p = O3(i, CB), h = Object.keys(p);
      if (h.length === 1) {
        var m = d ? "".concat(h[0], ", ").concat(d) : h[0];
        n += "{{".concat(m, "}}");
      } else
        m6("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", i);
    } else
      m6("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", i);
  }), n;
}
function bB(e, t, n, r, a, i) {
  if (t === "")
    return [];
  var o = r.transKeepBasicHtmlNodesFor || [], s = t && new RegExp(o.join("|")).test(t);
  if (!e && !s)
    return [t];
  var l = {};
  function c(C) {
    var _ = us(C);
    _.forEach(function(v) {
      typeof v != "string" && (M7(v) ? c(P7(v)) : Br(v) === "object" && !ws(v) && Object.assign(l, v));
    });
  }
  c(e);
  var u = aB.parse("<0>".concat(t, "</0>")), d = A1(A1({}, l), a);
  function p(C, _, v) {
    var w = P7(C), k = m(w, _.children, v);
    return yB(w) && k.length === 0 ? w : k;
  }
  function h(C, _, v, w, k) {
    C.dummy && (C.children = _), v.push(ls(C, A1(A1({}, C.props), {}, {
      key: w
    }), k ? void 0 : _));
  }
  function m(C, _, v) {
    var w = us(C), k = us(_);
    return k.reduce(function(b, S, P) {
      var O = S.children && S.children[0] && S.children[0].content && n.services.interpolator.interpolate(S.children[0].content, d, n.language);
      if (S.type === "tag") {
        var A = w[parseInt(S.name, 10)];
        !A && v.length === 1 && v[0][S.name] && (A = v[0][S.name]), A || (A = {});
        var L = Object.keys(S.attrs).length !== 0 ? vB({
          props: S.attrs
        }, A) : A, I = ws(L), D = I && M7(S, !0) && !S.voidElement, U = s && Br(L) === "object" && L.dummy && !I, z = Br(e) === "object" && e !== null && Object.hasOwnProperty.call(e, S.name);
        if (typeof L == "string") {
          var $ = n.services.interpolator.interpolate(L, d, n.language);
          b.push($);
        } else if (M7(L) || D) {
          var ee = p(L, S, v);
          h(L, ee, b, P);
        } else if (U) {
          var Z = m(w, S.children, v);
          b.push(ls(L, A1(A1({}, L.props), {}, {
            key: P
          }), Z));
        } else if (Number.isNaN(parseFloat(S.name)))
          if (z) {
            var G = p(L, S, v);
            h(L, G, b, P, S.voidElement);
          } else if (r.transSupportBasicHtmlNodes && o.indexOf(S.name) > -1)
            if (S.voidElement)
              b.push(za(S.name, {
                key: "".concat(S.name, "-").concat(P)
              }));
            else {
              var W = m(w, S.children, v);
              b.push(za(S.name, {
                key: "".concat(S.name, "-").concat(P)
              }, W));
            }
          else if (S.voidElement)
            b.push("<".concat(S.name, " />"));
          else {
            var j = m(w, S.children, v);
            b.push("<".concat(S.name, ">").concat(j, "</").concat(S.name, ">"));
          }
        else if (Br(L) === "object" && !I) {
          var T = S.children[0] ? O : null;
          T && b.push(T);
        } else
          S.children.length === 1 && O ? b.push(ls(L, A1(A1({}, L.props), {}, {
            key: P
          }), O)) : b.push(ls(L, A1(A1({}, L.props), {}, {
            key: P
          })));
      } else if (S.type === "text") {
        var F = r.transWrapTextNodes, N = i ? r.unescape(n.services.interpolator.interpolate(S.content, d, n.language)) : n.services.interpolator.interpolate(S.content, d, n.language);
        F ? b.push(za(F, {
          key: "".concat(S.name, "-").concat(P)
        }, N)) : b.push(N);
      }
      return b;
    }, []);
  }
  var f = m([{
    dummy: !0,
    children: e || []
  }], u, us(e || []));
  return P7(f[0]);
}
function Jy(e) {
  var t = e.children, n = e.count, r = e.parent, a = e.i18nKey, i = e.context, o = e.tOptions, s = o === void 0 ? {} : o, l = e.values, c = e.defaults, u = e.components, d = e.ns, p = e.i18n, h = e.t, m = e.shouldUnescape, f = O3(e, gB), C = Ue(N3) || {}, _ = C.i18n, v = C.defaultNS, w = p || _ || Yy();
  if (!w)
    return l5("You will need to pass in an i18next instance by using i18nextReactModule"), t;
  var k = h || w.t.bind(w) || function($) {
    return $;
  };
  i && (s.context = i);
  var b = A1(A1({}, Wy()), w.options && w.options.react), S = d || k.ns || v || w.options && w.options.defaultNS;
  S = typeof S == "string" ? [S] : S || ["translation"];
  var P = c || qy(t, b) || b.transEmptyNodeValue || a, O = b.hashTransKey, A = a || (O ? O(P) : P), L = l ? s.interpolation : {
    interpolation: A1(A1({}, s.interpolation), {}, {
      prefix: "#$?",
      suffix: "?$#"
    })
  }, I = A1(A1(A1(A1({}, s), {}, {
    count: n
  }, l), L), {}, {
    defaultValue: P,
    ns: S
  }), D = A ? k(A, I) : P, U = bB(u || t, D, w, b, I, m), z = r !== void 0 ? r : b.defaultTransParent;
  return z ? za(z, f, U) : U;
}
function _B(e) {
  if (Array.isArray(e))
    return e;
}
function wB(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (n = n.call(e)).next, t !== 0)
        for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && n.return != null && (o = n.return(), Object(o) !== o))
          return;
      } finally {
        if (c)
          throw a;
      }
    }
    return s;
  }
}
function Ud(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function xB(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ud(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ud(e, t) : void 0;
  }
}
function SB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kB(e, t) {
  return _B(e) || wB(e, t) || xB(e, t) || SB();
}
function Zd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function E7(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zd(Object(n), !0).forEach(function(r) {
      Ke(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var MB = function(t, n) {
  var r = be();
  return Re(function() {
    r.current = t;
  }, [t, n]), r.current;
};
function K1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.i18n, r = Ue(N3) || {}, a = r.i18n, i = r.defaultNS, o = n || a || Yy();
  if (o && !o.reportNamespaces && (o.reportNamespaces = new dB()), !o) {
    l5("You will need to pass in an i18next instance by using initReactI18next");
    var s = function(A) {
      return Array.isArray(A) ? A[A.length - 1] : A;
    }, l = [s, {}, !1];
    return l.t = s, l.i18n = {}, l.ready = !1, l;
  }
  o.options.react && o.options.react.wait !== void 0 && l5("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c = E7(E7(E7({}, Wy()), o.options.react), t), u = c.useSuspense, d = c.keyPrefix, p = i || o.options && o.options.defaultNS;
  p = typeof p == "string" ? [p] : p || ["translation"], o.reportNamespaces.addUsedNamespaces && o.reportNamespaces.addUsedNamespaces(p);
  var h = (o.isInitialized || o.initializedStoreOnce) && p.every(function(O) {
    return fB(O, o, c);
  });
  function m() {
    return o.getFixedT(null, c.nsMode === "fallback" ? p : p[0], d);
  }
  var f = ke(m), C = kB(f, 2), _ = C[0], v = C[1], w = p.join(), k = MB(w), b = be(!0);
  Re(function() {
    var O = c.bindI18n, A = c.bindI18nStore;
    b.current = !0, !h && !u && zd(o, p, function() {
      b.current && v(m);
    }), h && k && k !== w && b.current && v(m);
    function L() {
      b.current && v(m);
    }
    return O && o && o.on(O, L), A && o && o.store.on(A, L), function() {
      b.current = !1, O && o && O.split(" ").forEach(function(I) {
        return o.off(I, L);
      }), A && o && A.split(" ").forEach(function(I) {
        return o.store.off(I, L);
      });
    };
  }, [o, w]);
  var S = be(!0);
  Re(function() {
    b.current && !S.current && v(m), S.current = !1;
  }, [o, d]);
  var P = [_, o, h];
  if (P.t = _, P.i18n = o, P.ready = h, h || !h && !u)
    return P;
  throw new Promise(function(O) {
    zd(o, p, function() {
      O();
    });
  });
}
function PB(e) {
  var t = e.i18n, n = e.defaultNS, r = e.children, a = _e(function() {
    return {
      i18n: t,
      defaultNS: n
    };
  }, [t, n]);
  return za(N3.Provider, {
    value: a
  }, r);
}
const EB = {
  "required-field": "الحقل مطلوب",
  payment: {
    price_plan: "عرض",
    stripe_card: "بطاقة ائتمان أو خصم",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "بطاقات الائتمان (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "بطاقات الائتمان (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "الدفع عند الاستلام",
    xendit_card: "بطاقات الائتمان (Xendit)",
    paystack_card: "بطاقات الإئتمان (Paystack)",
    paypal_connect: "ربط paypal",
    paypal_edit_organization_name: "تعديل اسم المنظمة",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "خطأ",
  "Payment-method": "طريقة دفع",
  price_plan: {
    trial_period: {
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      month_0: "{{count}} شهر",
      month_1: "شهر{{count}}",
      month_2: "شهربن {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان {{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    },
    interval: {
      month_0: "{{count}} شهر",
      month_1: "شهر {{count}}",
      month_2: "شهرين {{count}}",
      month_3: "{{count}} أشهر",
      month_4: "{{count}} شهر",
      month_5: "{{count}} شهر",
      day_0: "{{count}} يوم",
      day_1: "يوم {{count}}",
      day_2: "يومين {{count}}",
      day_3: "{{count}} أيام",
      day_4: "{{count}} يوم",
      day_5: "{{count}} يوم",
      week_0: "{{count}} أسبوع",
      week_1: "أسبوع {{count}}",
      week_2: "أسبوعين {{count}}",
      week_3: "{{count}} أسابيع",
      week_4: "{{count}} أسبوع",
      week_5: "{{count}} أسبوع",
      year_0: "{{count}} سنة",
      year_1: "سنة {{count}}",
      year_2: "سنتان{{count}}",
      year_3: "{{count}} سنوات",
      year_4: "{{count}} سنة",
      year_5: "{{count}} سنة"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "مجانا",
        trial_period_new: "{{ trialPeriodPrice }} لمدة {{ trialInterval }} ثم",
        unlimited_new: "<bold>{{amount}}</bold> لكل {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} مرات"
      }
    }
  },
  affiliate_badge: {
    made_with: "يعمل بواسطة"
  },
  form_select: {
    empty_list: "يبدو أن هذه القائمة فارغة",
    select: "حدد"
  },
  contact_slug: {
    email: "البريد الإلكتروني",
    first_name: "الاسم",
    last_name: "اسم العائلة",
    phone_number: "رقم الهاتف",
    country: "البلد",
    street_address: "عنوان الشارع",
    city: "المدينة",
    postal_code: "الرمز البريدي",
    company_name: "اسم الشركة",
    tax_number: "الرقم الضريبي",
    state_province: "الولاية/المقاطعة",
    street_number: "رقم الشارع",
    neighborhood: "الحي"
  },
  date_picker: {
    apply: "تطبيق",
    clear: "إزالة",
    time: "الوقت",
    all_time: "كل الوقت",
    last_3_months: "آخر 3 أشهر",
    last_pool_period: "فترة التقييم الأخيرة للمجموعة",
    last_month: "الشهر الفائت",
    this_month: "هذا الشهر",
    last_30_days: "آخر 30 يوم",
    title_dates: "تواريخ",
    from: "من",
    to: "إلى"
  },
  copy_clipboard: "تم النسخ في الحافظة",
  payment_inputs: {
    empty_card_number: "أدخل رقم البطاقة",
    invalid_card_number: "رقم البطاقة غير صالح",
    empty_expiry_date: "أدخل تاريخ الانتهاء",
    month_out_of_range: "يجب أن يكون شهر الانتهاء بين 01 و 12",
    year_out_of_range: "لا يمكن أن تكون سنة الانتهاء في الماضي",
    date_out_of_range: "لا يمكن أن يكون تاريخ الانتهاء في الماضي",
    invalid_expiry_date: "تاريخ الانتهاء غير صالح",
    invalid_cvc: "رمز التحقق غير صالح",
    empty_cvc: "أدخل رمز التحقق",
    card_number_placeholder: "رقم البطاقة",
    expiry_data_placeholder: "الشهر/السنة",
    cvc_placeholder: "رمز التحقق",
    card_holder_placeholder: "حامل البطاقة",
    empty_card_holder: "أدخل اسم حامل البطاقة"
  },
  copy_clipboard_error: "فشل في نسخ النص",
  input: {
    phone_number: "رقم الهاتف",
    phone_search: "بحث",
    search: "بحث"
  },
  "registered-over": "مسجل أكثر من",
  locale: {
    french: "فرنسية",
    german: "ألمانية",
    italian: "ايطالية",
    dutch: "هولندية",
    english: "إنجليزية",
    portuguese: "البرتغالية",
    russian: "الروسية",
    spanish: "الإسبانية",
    japanese: "اليابانية",
    arabic: "العربية",
    turkish: "التركية",
    chinese: "الصينية",
    swedish: "السويدية",
    romanian: "الرومانية",
    czech: "التشيكية",
    hungarian: "الهنغارية",
    slovak: "السلوفاكية",
    danish: "الدانماركية",
    indonesian: "الأندونيسية",
    polish: "البولندية",
    greek: "اليونانية",
    serbian: "الصربية",
    hindi: "الهندية",
    norwegian: "النرويجية",
    thai: "التايلندية",
    slovenian: "السلوفينية",
    ukrainian: "الأوكرانية",
    albania: "الألبانية"
  },
  product: "منتج",
  quantity: "الكمية",
  order_summary: "ملخص الطلب",
  vat: "ضريبة المبيعات",
  total: "المجموع",
  subtotal: "المجموع الفرعي",
  shipping: {
    shipping_method: "طريقة الشحن",
    not_available: "عذرًا! يبدو أننا لا نقدم الشحن إلى هذا الموقع بعد.",
    condition_label: {
      price: "للطلبات التي تتراوح أسعارها بين {{min}} {{currency}} و {{max}} {{currency}}",
      price_min: "للطلبات التي تتراوح أسعارها عند {{min}} {{currency}} أو أكثر",
      quantity: "للطلبات التي تحتوي على بين {{min}} إلى {{max}} عنصر",
      quantity_min: "للطلبات التي تحتوي على {{min}} عنصر أو أكثر",
      weight: "للطلبات التي يبلغ وزنها الإجمالي بين {{min}} غرام إلى {{max}} غرام",
      weight_min: "للطلبات التي يبلغ وزنها الإجمالي {{min}} غرام أو أكثر"
    }
  },
  shipping_fee: "رسوم الشحن",
  total_amount_with_tax_and_shipping: "المجموع (بما في ذلك الضريبة والشحن)",
  vat_percent: "ضريبة المبيعات ({{percent}}%)",
  including_tax: "يشمل {{percent}}٪ ضريبة القيمة المضافة ({{amount}})",
  total_amount_with_tax: "المجموع (شامل الضرائب)",
  total_amount_with_shipping: "المجموع (شامل الشحن)"
}, TB = {
  public_pages_purchase: EB
}, LB = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditní nebo debetní karta",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditní karty (místní)",
    dlocal_boleto: "Boleto (místní)",
    dlocal_pix: "Pix (místní)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditní karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platební trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Dobírka",
    xendit_card: "Kreditní karty (Xendit)",
    paystack_card: "Kreditní karty (Paystack)",
    paypal_connect: "Připojte PayPal",
    paypal_edit_organization_name: "Upravit název organizace",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečte a zaplaťte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Způsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      day_0: "{{count}} den",
      day_1: "{{count}} dny",
      day_2: "{{count}} dní",
      month_0: "{{count}} měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      year_0: "{{count}} rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    },
    interval: {
      month_0: "měsíc",
      month_1: "{{count}} měsíců",
      month_2: "{{count}} měsíců",
      day_0: "den",
      day_1: "{{count}} dnů",
      day_2: "{{count}} dnů",
      week_0: "týden",
      week_1: "{{count}} týdnů",
      week_2: "{{count}} týdnů",
      year_0: "rok",
      year_1: "{{count}} let",
      year_2: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zdarma",
        trial_period_new: "{{ trialPeriodPrice }} pro {{ trialInterval }} pak",
        unlimited_new: "<bold>{{amount}}</bold> každý {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháněno"
  },
  form_select: {
    empty_list: "Vypadá to, že tento seznam je prázdný",
    select: "Vybrat"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Jméno",
    last_name: "Příjmení",
    phone_number: "Telefonní číslo",
    country: "Země",
    street_address: "Ulice",
    city: "Město",
    postal_code: "PSČ",
    company_name: "Název společnosti",
    tax_number: "DIČ",
    state_province: "Stát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Čtvrť"
  },
  date_picker: {
    apply: "Použít",
    clear: "Vymazat",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Poslední 3 měsíce",
    last_pool_period: "Poslední hodnotící období",
    last_month: "Minulý měsíc",
    this_month: "Tento měsíc",
    last_30_days: "Posledních 30 dní",
    title_dates: "Data",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Zkopírováno do schránky",
  payment_inputs: {
    empty_card_number: "Zadejte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadejte datum vypršení platnosti",
    month_out_of_range: "Měsíc vypršení platnosti musí být mezi 01 a 12",
    year_out_of_range: "Rok expirace nemůže být v minulosti",
    date_out_of_range: "Datum expirace nemůže být v minulosti",
    invalid_expiry_date: "Datum expirace je neplatné",
    invalid_cvc: "CVC je neplatné",
    empty_cvc: "Zadejte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držitel karty",
    empty_card_holder: "Zadejte jméno držitele karty"
  },
  copy_clipboard_error: "Kopírování textu se nezdařilo",
  input: {
    phone_number: "Telefonní číslo",
    phone_search: "Hledat",
    search: "Hledat"
  },
  "registered-over": "registrovaných přes",
  locale: {
    french: "Francouzština",
    german: "Němčina",
    italian: "Italština",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalština",
    russian: "Ruština",
    spanish: "Španělština",
    japanese: "Japonština",
    arabic: "Arabština",
    turkish: "Turečtina",
    chinese: "Čínština",
    swedish: "Švédnština",
    romanian: "Rumunština",
    czech: "Čeština",
    hungarian: "Maďarský",
    slovak: "Slovenština",
    danish: "Dánština",
    indonesian: "Indonéština",
    polish: "Polština",
    greek: "Řečtina",
    serbian: "Srbština",
    hindi: "Hindi",
    norwegian: "Norština",
    thai: "Thajština",
    slovenian: "Slovinský",
    ukrainian: "Ukrajinština",
    albania: "Albánština"
  },
  product: "Produkt",
  quantity: "Množství",
  order_summary: "Shrnutí objednávky",
  vat: "Daň z prodeje",
  total: "Celkem",
  subtotal: "Mezisoučet",
  shipping: {
    shipping_method: "Způsob dopravy",
    not_available: "Omlouváme se! Vypadá to, že zatím nenabízíme dopravu na tuto adresu.",
    condition_label: {
      price: "Pro objednávky v cenovém rozmezí {{min}} {{currency}} až {{max}} {{currency}}",
      price_min: "Pro objednávky v ceně {{min}} {{currency}} nebo více",
      quantity: "Pro objednávky obsahující mezi {{min}} a {{max}} položkami",
      quantity_min: "Pro objednávky obsahující {{min}} nebo více položek",
      weight: "Pro objednávky s celkovou hmotností mezi {{min}}g a {{max}}g",
      weight_min: "Pro objednávky s celkovou hmotností {{min}}g nebo více"
    }
  },
  shipping_fee: "Poplatek za dopravu",
  total_amount_with_tax_and_shipping: "Celkem (včetně daně a dopravy)",
  vat_percent: "Daň z prodeje ({{percent}}%)",
  including_tax: "Včetně DPH {{percent}} % ({{amount}})",
  total_amount_with_tax: "Celkem (včetně daně)",
  total_amount_with_shipping: "Celkem (včetně dopravy)"
}, AB = {
  public_pages_purchase: LB
}, OB = {
  "required-field": "Feltet er påkrævet",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredit- eller betalingskort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontant ved levering",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Tilslut PayPal",
    paypal_edit_organization_name: "Rediger organisationens navn",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fejl",
  "Payment-method": "Betalingsmetode",
  price_plan: {
    trial_period: {
      week: "{{count}} uge",
      week_plural: "{{count}} uger",
      day: "{{count}} dag",
      day_plural: "{{count}} dage",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dage",
      week: "uge",
      week_plural: "{{count}} uger",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} derefter",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gange"
      }
    }
  },
  affiliate_badge: {
    made_with: "Støttet af"
  },
  form_select: {
    empty_list: "Det ser ud til, at denne liste er tom",
    select: "Vælge"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Fornavn",
    last_name: "Efternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gadeadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "stat/provins",
    street_number: "Gadenummer",
    neighborhood: "Kvarter"
  },
  date_picker: {
    apply: "Anvende",
    clear: "Slet",
    time: "Tid",
    all_time: "Hele tiden",
    last_3_months: "Sidste 3 måneder",
    last_pool_period: "Sidste puljeevalueringsperiode",
    last_month: "Sidste måned",
    this_month: "Denne måned",
    last_30_days: "Sidste 30 dage",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopieret til udklipsholder",
  payment_inputs: {
    empty_card_number: "Indtast et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldigt",
    empty_expiry_date: "Indtast en udløbsdato",
    month_out_of_range: "Udløbsmåned skal være mellem 01 og 12",
    year_out_of_range: "Udløbsåret må ikke ligge i fortiden",
    date_out_of_range: "Udløbsdatoen må ikke ligge i fortiden",
    invalid_expiry_date: "Udløbsdatoen er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Indtast en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Indtast et kortholdernavn"
  },
  copy_clipboard_error: "Teksten kunne ikke kopieres",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søge",
    search: "Søge"
  },
  "registered-over": "registreret over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Hollandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumænsk",
    czech: "Tjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Polsk",
    greek: "Græsk",
    serbian: "Serbisk",
    hindi: "Hindi",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mængde",
  order_summary: "Ordreoversigt",
  vat: "Salgsskat",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Forsendelsesmetode",
    not_available: "Ups! Det ser ud til, at vi endnu ikke tilbyder forsendelse til denne placering.",
    condition_label: {
      price: "For ordrer prissat mellem {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For ordrer prissat til {{min}} {{currency}} eller mere",
      quantity: "For ordrer indeholdende mellem {{min}} og {{max}} varer",
      quantity_min: "For ordrer indeholdende {{min}} eller flere varer",
      weight: "For ordrer med en samlet vægt mellem {{min}}g og {{max}}g",
      weight_min: "For ordrer med en samlet vægt på {{min}}g eller mere"
    }
  },
  shipping_fee: "Forsendelsesgebyr",
  total_amount_with_tax_and_shipping: "I alt (inkl. moms og forsendelse)",
  vat_percent: "Moms ({{percent}} %)",
  including_tax: "Inkluderer {{percent}} % moms ({{amount}})",
  total_amount_with_tax: "Total (inkl. skat)",
  total_amount_with_shipping: "Total (inklusive forsendelse)"
}, NB = {
  public_pages_purchase: OB
}, jB = {
  "required-field": "Das Feld ist erforderlich",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredit- oder Debitkarte",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkarten (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkarten (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Lieferung per Nachnahme",
    xendit_card: "Kreditkarten (Xendit)",
    paystack_card: "Kreditkarten (Paystack)",
    paypal_connect: "PayPal verbinden",
    paypal_edit_organization_name: "Organisationsnamen bearbeiten",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fehler",
  "Payment-method": "Zahlungsmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} Woche",
      week_plural: "{{count}} Wochen",
      day: "{{count}} Tag",
      day_plural: "{{count}} Tage",
      month: "{{count}} Monat",
      month_plural: "{{count}} Monate",
      year: "{{count}} Jahr",
      year_plural: "{{count}} Jahre"
    },
    interval: {
      month: "Monat",
      month_plural: "{{count}} Monate",
      day: "Tag",
      day_plural: "{{count}} Tage",
      week: "Woche",
      week_plural: "{{count}} Wochen",
      year: "Jahr",
      year_plural: "{{count}} Jahre"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Kostenlos",
        trial_period_new: "{{ trialPeriodPrice }} für {{ trialInterval }} dann",
        unlimited_new: "<bold>{{amount}}</bold> alle {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} mal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Unterstützt von"
  },
  form_select: {
    empty_list: "Es sieht so aus, als wäre diese Liste leer",
    select: "Auswählen"
  },
  contact_slug: {
    email: "E-Mail",
    first_name: "Vorname",
    last_name: "Nachname",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Straßenadresse",
    city: "Stadt",
    postal_code: "Postleitzahl",
    company_name: "Firmenname",
    tax_number: "Steuernummer",
    state_province: "Bundesland/Provinz",
    street_number: "Hausnummer",
    neighborhood: "Nachbarschaft"
  },
  date_picker: {
    apply: "Anwenden",
    clear: "Löschen",
    time: "Zeit",
    all_time: "Alle Zeiten",
    last_3_months: "Letzte 3 Monate",
    last_pool_period: "Letzter Pool-Auswertungszeitraum",
    last_month: "Letzter Monat",
    this_month: "Dieser Monat",
    last_30_days: "Letzte 30 Tage",
    title_dates: "Termine",
    from: "Von",
    to: "Nach"
  },
  copy_clipboard: "In die Zwischenablage kopiert",
  payment_inputs: {
    empty_card_number: "Eine Kartennummer eingeben",
    invalid_card_number: "Kartennummer ist ungültig",
    empty_expiry_date: "Geben Sie ein Verfallsdatum ein",
    month_out_of_range: "Der Verfallsmonat muss zwischen 01 und 12 liegen",
    year_out_of_range: "Das Verfallsjahr darf nicht in der Vergangenheit liegen",
    date_out_of_range: "Das Verfallsdatum darf nicht in der Vergangenheit liegen",
    invalid_expiry_date: "Verfallsdatum ist ungültig",
    invalid_cvc: "CVC ist ungültig",
    empty_cvc: "Einen CVC eingeben",
    card_number_placeholder: "Kartennummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Karteninhaber",
    empty_card_holder: "Name des Karteninhabers eingeben"
  },
  copy_clipboard_error: "Text konnte nicht kopiert werden",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Suchen",
    search: "Suchen"
  },
  "registered-over": "registriert über",
  locale: {
    french: "Französisch",
    german: "Deutsch",
    italian: "Italienisch",
    dutch: "Niederländisch",
    english: "Englisch",
    portuguese: "Portugiesisch",
    russian: "Russisch",
    spanish: "Spanisch",
    japanese: "Japanisch",
    arabic: "Arabisch",
    turkish: "Türkisch",
    chinese: "Chinesisch",
    swedish: "Schwedisch",
    romanian: "Rumänisch",
    czech: "Tschechisch",
    hungarian: "Ungarisch",
    slovak: "Slowakisch",
    danish: "Dänisch",
    indonesian: "Indonesisch",
    polish: "Polnisch",
    greek: "Griechisch",
    serbian: "Serbisch",
    hindi: "Hindi",
    norwegian: "Norwegisch",
    thai: "Thailändisch",
    slovenian: "Slowenisch",
    ukrainian: "Ukrainisch",
    albania: "Albanisch"
  },
  product: "Produkt",
  quantity: "Menge",
  order_summary: "Bestellübersicht",
  vat: "Mehrwertsteuer",
  total: "Gesamt",
  subtotal: "Zwischensumme",
  shipping: {
    shipping_method: "Versandmethode",
    not_available: "Ups! Es scheint, dass wir noch keinen Versand an diesen Standort anbieten.",
    condition_label: {
      price: "Für Bestellungen im Wert von {{min}} {{currency}} bis {{max}} {{currency}}",
      price_min: "Für Bestellungen im Wert von {{min}} {{currency}} oder mehr",
      quantity: "Für Bestellungen mit {{min}} bis {{max}} Artikeln",
      quantity_min: "Für Bestellungen mit {{min}} oder mehr Artikeln",
      weight: "Für Bestellungen mit einem Gesamtgewicht zwischen {{min}}g und {{max}}g",
      weight_min: "Für Bestellungen mit einem Gesamtgewicht von {{min}}g oder mehr"
    }
  },
  shipping_fee: "Versandgebühr",
  total_amount_with_tax_and_shipping: "Gesamt (inklusive Steuern und Versand)",
  vat_percent: "Umsatzsteuer ({{percent}} %)",
  including_tax: "Enthält {{percent}} % MwSt. ({{amount}})",
  total_amount_with_tax: "Gesamtbetrag (inkl. Steuern)",
  total_amount_with_shipping: "Gesamtbetrag (einschließlich Versand)"
}, RB = {
  public_pages_purchase: jB
}, DB = {
  "required-field": "Το πεδίο είναι υποχρεωτικό",
  payment: {
    price_plan: "Πλάνο",
    stripe_card: "Πιστωτική ή χρεωστική κάρτα",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Τραπεζικές κάρτες (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Τραπεζικές κάρτες (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Με αντικαταβολή",
    xendit_card: "Τραπεζικές κάρτες (Xendit)",
    paystack_card: "Τραπεζικές κάρτες (Paystack)",
    paypal_connect: "Σύνδεση με PayPal",
    paypal_edit_organization_name: "Επεξεργασία ονόματος οργανισμού",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Σφάλμα",
  "Payment-method": "Τρόπος πληρωμής",
  price_plan: {
    trial_period: {
      week: "{{count}} εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      day: "{{count}} ημέρα",
      day_plural: "{{count}} ημέρες",
      month: "{{count}} μήνας",
      month_plural: "{{count}} μήνες",
      year: "{{count}} έτος",
      year_plural: "{{count}} έτη"
    },
    interval: {
      month: "μήνας",
      month_plural: "{{count}} μήνες",
      day: "ημέρα",
      day_plural: "{{count}} ημέρες",
      week: "εβδομάδα",
      week_plural: "{{count}} εβδομάδες",
      year: "έτος",
      year_plural: "{{count}} έτη"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Δωρεάν",
        trial_period_new: "{{ trialPeriodPrice }} για {{ trialInterval }} και έπειτα",
        unlimited_new: "<bold>{{amount}}</bold> κάθε {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} φορές"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Φαίνεται ότι αυτή η λίστα είναι κενή",
    select: "Επιλογή"
  },
  contact_slug: {
    email: "Email",
    first_name: "Όνομα",
    last_name: "Επώνυμο",
    phone_number: "Τηλέφωνο",
    country: "Χώρα",
    street_address: "Διεύθυνση",
    city: "Πόλη",
    postal_code: "Ταχυδρομικός κώδικας",
    company_name: "Επωνυμία εταιρίας",
    tax_number: "Α.Φ.Μ.",
    state_province: "Νομός",
    street_number: "Αριθμός οδού",
    neighborhood: "Γειτονιά"
  },
  date_picker: {
    apply: "Υποβολή",
    clear: "Επαναφορά",
    time: "Χρόνος",
    all_time: "Συνολικά",
    last_3_months: "Τελευταίοι 3 μήνες",
    last_pool_period: "Τελευταία περίοδος αξιολόγησης email",
    last_month: "Προηγούμενος μήνας",
    this_month: "Αυτό το μήνα",
    last_30_days: "Τελευταίες 30 ημέρες",
    title_dates: "Ημερομηνίες",
    from: "Από",
    to: "Προς"
  },
  copy_clipboard: "Επιτυχής αντιγραφή",
  payment_inputs: {
    empty_card_number: "Εισάγετε έναν αριθμό κάρτας",
    invalid_card_number: "Ο αριθμός κάρτας είναι μη έγκυρος",
    empty_expiry_date: "Εισάγετε μια ημερομηνία λήξης",
    month_out_of_range: "Ο μήνας λήξης πρέπει να είναι μεταξύ 01 και 12",
    year_out_of_range: "Η χρονολογία λήξης δεν μπορεί να είναι στο παρελθόν",
    date_out_of_range: "Η ημερομηνία λήξης δεν μπορεί να είναι στο παρελθόν",
    invalid_expiry_date: "Η ημερομηνία λήξης είναι μη έγκυρη",
    invalid_cvc: "Το CVC είναι μη έγκυρο",
    empty_cvc: "Εισάγετε το CVC",
    card_number_placeholder: "Αριθμός κάρτας",
    expiry_data_placeholder: "ΜΜ/ΕΕ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Κάτοχος κάρτας",
    empty_card_holder: "Εισάγετε το όνομα του κατόχου της κάρτας"
  },
  copy_clipboard_error: "Αποτυχία αντιγραφής κειμένου",
  input: {
    phone_number: "Τηλέφωνο",
    phone_search: "Αναζήτηση",
    search: "Αναζήτηση"
  },
  "registered-over": "εγγεγραμμένο πάνω από",
  locale: {
    french: "Γαλλικά",
    german: "Γερμανικά",
    italian: "Ιταλικά",
    dutch: "Ολλανδικά",
    english: "Αγγλικά",
    portuguese: "Πορτογαλικά",
    russian: "Ρωσικά",
    spanish: "Ισπανικά",
    japanese: "Ιαπωνικά",
    arabic: "Αραβικά",
    turkish: "Τούρκικα",
    chinese: "Κινέζικα",
    swedish: "Σουηδικά",
    romanian: "Ρουμανικά",
    czech: "Τσέχικα",
    hungarian: "Ουγγρικά",
    slovak: "Σλοβάκικα",
    danish: "Δανικά",
    indonesian: "Ινδονησιακά",
    polish: "Πολωνικά",
    greek: "Ελληνικά",
    serbian: "Σερβικά",
    hindi: "Ινδικά",
    norwegian: "Νορβηγικά",
    thai: "Ταϊλανδέζικα",
    slovenian: "Σλοβενικά",
    ukrainian: "Ουκρανικά",
    albania: "Αλβανικά"
  },
  product: "Προϊόν",
  quantity: "Ποσότητα",
  order_summary: "Σύνοψη Παραγγελίας",
  vat: "Φόρος πωλήσεων",
  total: "Σύνολο",
  subtotal: "Μερικό σύνολο",
  shipping: {
    shipping_method: "Τρόπος αποστολής",
    not_available: "Ωχ. Φαίνεται ότι δεν προσφέρουμε αποστολή σε αυτήν την τοποθεσία ακόμη",
    condition_label: {
      price: "Για παραγγελίες αξίας από {{min}} {{currency}} έως {{max}} {{currency}}",
      price_min: "Για παραγγελίες αξίας τουλάχιστον {{min}} {{currency}}",
      quantity: "Για παραγγελίες που περιέχουν από {{min}} έως {{max}} αντικείμενα",
      quantity_min: "Για παραγγελίες που περιέχουν τουλάχιστον {{min}} αντικείμενα",
      weight: "Για παραγγελίες με συνολικό βάρος από {{min}}g έως {{max}}g",
      weight_min: "Για παραγγελίες με συνολικό βάρος τουλάχιστον {{min}}g"
    }
  },
  shipping_fee: "Χρέωση αποστολής",
  total_amount_with_tax_and_shipping: "Σύνολο (συμπεριλαμβανομένων φόρων και αποστολής)",
  vat_percent: "ΦΠΑ ({{percent}}%)",
  including_tax: "Συμπεριλαμβάνει {{percent}}% ΦΠΑ ({{amount}})",
  total_amount_with_tax: "Σύνολο (συμπεριλαμβανομένου φόρου)",
  total_amount_with_shipping: "Σύνολο (συμπεριλαμβανομένων των μεταφορικών)"
}, IB = {
  public_pages_purchase: DB
}, HB = {
  "required-field": "Field is required",
  payment: {
    price_plan: "Plan",
    stripe_card: "Credit or debit card",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Credit cards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Credit cards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Cash on delivery",
    xendit_card: "Credit cards (Xendit)",
    paystack_card: "Credit cards (Paystack)",
    paypal_connect: "Connect PayPal",
    paypal_edit_organization_name: "Edit organization name",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Payment method",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weeks",
      day: "{{count}} day",
      day_plural: "{{count}} days",
      month: "{{count}} month",
      month_plural: "{{count}} months",
      year: "{{count}} year",
      year_plural: "{{count}} years"
    },
    interval: {
      month: "month",
      month_plural: "{{count}} months",
      day: "day",
      day_plural: "{{count}} days",
      week: "week",
      week_plural: "{{count}} weeks",
      year: "year",
      year_plural: "{{count}} years"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Free",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} then",
        unlimited_new: "<bold>{{amount}}</bold> every {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} times"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "It looks like this list is empty",
    select: "Select"
  },
  contact_slug: {
    email: "Email",
    first_name: "First name",
    last_name: "Last name",
    phone_number: "Phone number",
    country: "Country",
    street_address: "Street address",
    city: "City",
    postal_code: "Postal code",
    company_name: "Company name",
    tax_number: "Tax number",
    state_province: "State/Province",
    street_number: "Street number",
    neighborhood: "Neighborhood"
  },
  date_picker: {
    apply: "Apply",
    clear: "Clear",
    time: "Time",
    all_time: "All time",
    last_3_months: "Last 3 months",
    last_pool_period: "Last pool evaluation period",
    last_month: "Last month",
    this_month: "This month",
    last_30_days: "Last 30 days",
    title_dates: "Dates",
    from: "From",
    to: "To"
  },
  copy_clipboard: "Copied to clipboard",
  payment_inputs: {
    empty_card_number: "Enter a card number",
    invalid_card_number: "Card number is invalid",
    empty_expiry_date: "Enter an expiry date",
    month_out_of_range: "Expiry month must be between 01 and 12",
    year_out_of_range: "Expiry year cannot be in the past",
    date_out_of_range: "Expiry date cannot be in the past",
    invalid_expiry_date: "Expiry date is invalid",
    invalid_cvc: "CVC is invalid",
    empty_cvc: "Enter a CVC",
    card_number_placeholder: "Card number",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Card holder",
    empty_card_holder: "Enter a card holder name"
  },
  copy_clipboard_error: "Failed to copy text",
  input: {
    phone_number: "Phone number",
    phone_search: "Search",
    search: "Search"
  },
  "registered-over": "registered over",
  locale: {
    french: "French",
    german: "German",
    italian: "Italiano",
    dutch: "Dutch",
    english: "English",
    portuguese: "Portuguese",
    russian: "Russian",
    spanish: "Spanish",
    japanese: "Japanese",
    arabic: "Arabic",
    turkish: "Turkish",
    chinese: "Chinese",
    swedish: "Swedish",
    romanian: "Romanian",
    czech: "Czech",
    hungarian: "Hungarian",
    slovak: "Slovak",
    danish: "Danish",
    indonesian: "Indonesian",
    polish: "Polish",
    greek: "Greek",
    serbian: "Serbian",
    hindi: "Hindi",
    norwegian: "Norwegian",
    thai: "Thai",
    slovenian: "Slovenian",
    ukrainian: "Ukrainian",
    albania: "Albanian"
  },
  product: "Product",
  quantity: "Quantity",
  order_summary: "Order summary",
  vat: "Sales tax",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Shipping method",
    not_available: "Oops! It looks like we don't offer shipping to this location yet",
    condition_label: {
      price: "For orders priced between {{min}} {{currency}} to {{max}} {{currency}}",
      price_min: "For orders priced at {{min}} {{currency}} or more",
      quantity: "For orders containing between {{min}} to {{max}} items",
      quantity_min: "For orders containing {{min}} or more items",
      weight: "For orders with a total weight between {{min}}g to {{max}}g",
      weight_min: "For orders with a total weight of {{min}}g or more"
    }
  },
  shipping_fee: "Shipping fee",
  total_amount_with_tax_and_shipping: "Total (including tax and Shipping)",
  vat_percent: "Sales tax ({{percent}}%)",
  including_tax: "Includes {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "Total (including tax)",
  total_amount_with_shipping: "Total (including Shipping)"
}, FB = {
  public_pages_purchase: HB
}, VB = {
  "required-field": "El campo es necesario",
  payment: {
    price_plan: "Plan",
    stripe_card: "Tarjeta de crédito o débito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Tarjetas de crédito (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Tarjetas de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pago contra entrega",
    xendit_card: "Tarjetas de crédito (Xendit)",
    paystack_card: "Tarjetas de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar el nombre de la organización",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Error",
  "Payment-method": "Método de pago",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} día",
      day_plural: "{{count}} días",
      month: "{{count}} mes",
      month_plural: "{{count}} meses",
      year: "{{count}} año",
      year_plural: "{{count}} años"
    },
    interval: {
      month: "mes",
      month_plural: "{{count}} meses",
      day: "día",
      day_plural: "{{count}} días",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "año",
      year_plural: "{{count}} años"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} luego",
        unlimited_new: "<bold>{{amount}}</bold> cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} veces"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desarrollado por"
  },
  form_select: {
    empty_list: "Parece que esta lista está vacía",
    select: "Seleccionar"
  },
  contact_slug: {
    email: "Correo",
    first_name: "Nombre",
    last_name: "Apellido",
    phone_number: "Número de teléfono",
    country: "País",
    street_address: "Dirección",
    city: "Ciudad",
    postal_code: "Código postal",
    company_name: "Nombre de la empresa",
    tax_number: "Número de IVA",
    state_province: "Estado/Provincia",
    street_number: "Dirección",
    neighborhood: "Barrio"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Borrar",
    time: "Hola",
    all_time: "Desde siempre",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último periodo de evaluación de la pool",
    last_month: "Último mes",
    this_month: "Este mes",
    last_30_days: "Últimos 30 días",
    title_dates: "Fechas",
    from: "Desde",
    to: "Hasta"
  },
  copy_clipboard: "Copiado en el portapapeles",
  payment_inputs: {
    empty_card_number: "Ingresa un número de tarjeta",
    invalid_card_number: "El número de tarjeta no es válido",
    empty_expiry_date: "Ingresa la fecha de expiración",
    month_out_of_range: "El mes de expiración debe estar entre 01 y 12",
    year_out_of_range: "El año de expiración no puede estar situado en el pasado",
    date_out_of_range: "La fecha de expiración no puede estar situada en el pasado",
    invalid_expiry_date: "La fecha de expiracion no es válida",
    invalid_cvc: "El CVC no es válido",
    empty_cvc: "Ingresa un CVC",
    card_number_placeholder: "Número de tarjeta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titular de la tarjeta",
    empty_card_holder: "Ingresa el nombre del titular de la tarjeta"
  },
  copy_clipboard_error: "Error el copiar el texto",
  input: {
    phone_number: "Teléfono",
    phone_search: "Buscar",
    search: "Buscar"
  },
  "registered-over": "registrado hace más de",
  locale: {
    french: "Francés",
    german: "Alemán",
    italian: "Italiano",
    dutch: "Holandés",
    english: "Inglés",
    portuguese: "Portugués",
    russian: "Ruso",
    spanish: "Español",
    japanese: "Japonés",
    arabic: "árabe",
    turkish: "Turco",
    chinese: "Chino",
    swedish: "Sueco",
    romanian: "Rumano",
    czech: "Checo",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Danés",
    indonesian: "Indonesio",
    polish: "Polaco",
    greek: "Griego",
    serbian: "Serbio",
    hindi: "Hindi",
    norwegian: "Noruego",
    thai: "Tailandés",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanés"
  },
  product: "Producto",
  quantity: "Cantidad",
  order_summary: "Resumen del pedido",
  vat: "IVA",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envío",
    not_available: "¡Vaya! Parece que aún no ofrecemos envíos a esta ubicación",
    condition_label: {
      price: "Para pedidos con precio entre {{min}} {{currency}} y {{max}} {{currency}}",
      price_min: "Para pedidos que cuesten {{min}} {{currency}} o más",
      quantity: "Para pedidos de entre {{min}} y {{max}} artículos",
      quantity_min: "Para pedidos con {{min}} o más artículos",
      weight: "Para pedidos con un peso total entre {{min}}g y {{max}}g",
      weight_min: "Para pedidos con un peso total de {{min}}g o más"
    }
  },
  shipping_fee: "Tarifa de envío",
  total_amount_with_tax_and_shipping: "Total (incluyendo impuestos y envío)",
  vat_percent: "IVA ({{percent}}%)",
  including_tax: "Incluye el {{percent}}% de IVA ({{amount}})",
  total_amount_with_tax: "Total (impuestos incluidos)",
  total_amount_with_shipping: "Total (incluyendo envío)"
}, BB = {
  public_pages_purchase: VB
}, zB = {
  "required-field": "Le champ est obligatoire",
  payment: {
    price_plan: "Plan",
    stripe_card: "Carte de crédit ou de débit",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "BanContact (Stripe)",
    dlocal_card: "Cartes de crédit (Dlocal)",
    dlocal_boleto: "Billet (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartes de crédit (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Paiement à la livraison",
    xendit_card: "Cartes de crédit (Xendit)",
    paystack_card: "Cartes de crédit (Paystack)",
    paypal_connect: "Connectez-vous à PayPal",
    paypal_edit_organization_name: "Modifier le nom de l'organisation",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erreur",
  "Payment-method": "Mode de paiement",
  price_plan: {
    trial_period: {
      week: "{{count}} semaine",
      week_plural: "{{count}} semaines",
      day: "{{count}} jour",
      day_plural: "{{count}} jours",
      month: "{{count}} mois",
      month_plural: "{{count}} mois",
      year: "{{count}} an",
      year_plural: "{{count}} ans"
    },
    interval: {
      month: "mois",
      month_plural: "{{count}} mois",
      day: "jour",
      day_plural: "{{count}} jours",
      week: "semaine",
      week_plural: "{{count}} semaines",
      year: "an",
      year_plural: "{{count}} ans"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pendant {{ trialInterval }} puis",
        unlimited_new: "<bold>{{amount}}</bold> tous {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }}  - {{ count }} fois"
      }
    }
  },
  affiliate_badge: {
    made_with: "Développé par"
  },
  form_select: {
    empty_list: "Cette liste semble vide",
    select: "Sélectionner"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prénom",
    last_name: "Nom",
    phone_number: "Numéro de téléphone",
    country: "Pays",
    street_address: "Adresse",
    city: "Ville",
    postal_code: "Code postal",
    company_name: "Nom de l'entreprise",
    tax_number: "Numéro d'identification fiscale",
    state_province: "Région",
    street_number: "Numéro de rue",
    neighborhood: "Quartier"
  },
  date_picker: {
    apply: "Appliquer",
    clear: "Effacer",
    time: "Horaire",
    all_time: "Depuis le début",
    last_3_months: "Les 3 derniers mois",
    last_pool_period: "Dernière période d'évaluation du pool",
    last_month: "Le mois dernier",
    this_month: "Ce mois",
    last_30_days: "Les 30 derniers jours",
    title_dates: "Dates",
    from: "De",
    to: "À"
  },
  copy_clipboard: "Copié dans le presse-papier",
  payment_inputs: {
    empty_card_number: "Entrez un numéro de carte",
    invalid_card_number: "Le numéro de carte est invalide",
    empty_expiry_date: "Entrez une date d'expiration",
    month_out_of_range: "Le mois d’expiration doit être entre 01 et 12",
    year_out_of_range: "L'année d'expiration ne peut pas être dans le passé",
    date_out_of_range: "La date d’expiration ne peut pas être dans le passé",
    invalid_expiry_date: "La date d’expiration est invalide",
    invalid_cvc: "Le code CVC est invalide",
    empty_cvc: "Saisissez le code CVC",
    card_number_placeholder: "Numéro de carte",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titulaire de la carte",
    empty_card_holder: "Saisir le nom du titulaire de la carte"
  },
  copy_clipboard_error: "Échec de la copie du texte",
  input: {
    phone_number: "Numéro de téléphone",
    phone_search: "Recherche",
    search: "Recherche"
  },
  "registered-over": "enregistré plus de",
  locale: {
    french: "Français",
    german: "Allemand",
    italian: "Italiano",
    dutch: "Néerlandais",
    english: "Anglais",
    portuguese: "Portugais",
    russian: "Russe",
    spanish: "Espagnol",
    japanese: "Japonais",
    arabic: "Аrabe",
    turkish: "Turc",
    chinese: "Chinois",
    swedish: "Suédois",
    romanian: "Roumain",
    czech: "Tchèque",
    hungarian: "Hongrois",
    slovak: "Slovaque",
    danish: "Danois",
    indonesian: "Indonésien",
    polish: "Polonais",
    greek: "Grec",
    serbian: "Serbe",
    hindi: "Indien",
    norwegian: "Norvégien",
    thai: "Thaïlandais",
    slovenian: "Slovène",
    ukrainian: "Ukrainien",
    albania: "Albanais"
  },
  product: "Produit",
  quantity: "Quantité",
  order_summary: "Résumé de la commande",
  vat: "TVA",
  total: "Total",
  subtotal: "Sous-total",
  shipping: {
    shipping_method: "Méthode d'expédition",
    not_available: "Oups ! Il semble qu'on ne livre pas encore à cet endroit",
    condition_label: {
      price: "Pour les commandes dont le prix est compris entre {{min}} {{currency}} et {{max}} {{currency}}",
      price_min: "Pour les commandes dont le prix est de {{min}} {{currency}} ou plus",
      quantity: "Pour les commandes contenant entre {{min}} et {{max}} articles",
      quantity_min: "Pour les commandes contenant {{min}} articles ou plus",
      weight: "Pour les commandes avec un poids total compris entre {{min}}g et {{max}}g",
      weight_min: "Pour les commandes avec un poids total de {{min}}g ou plus"
    }
  },
  shipping_fee: "Frais d'expédition",
  total_amount_with_tax_and_shipping: "Total (y compris la TVA et l'expédition)",
  vat_percent: "TVA ({{percent}}%)",
  including_tax: "Comprend {{percent}} % de TVA ({{amount}})",
  total_amount_with_tax: "Total (TVA incluse)",
  total_amount_with_shipping: "Total (y compris livraison)"
}, GB = {
  public_pages_purchase: zB
}, UB = {
  "required-field": "यह फील्ड भरना अनिवार्य है",
  payment: {
    price_plan: "प्लान",
    stripe_card: "क्रेडिट या डेबिट कार्ड",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "बैनकॉन्टैक्ट (Stripe)",
    dlocal_card: "क्रेडिट कार्ड्स (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "क्रेडिट कार्ड्स (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "कैश-ऑन-डिलीवरी",
    xendit_card: "क्रेडिट कार्ड्स (Xendit)",
    paystack_card: "क्रेडिट कार्ड्स (Paystack)",
    paypal_connect: "Paypal से जुड़ें",
    paypal_edit_organization_name: "संगठन का नाम एडिट करें",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "एप्पल पे",
    xendit: {
      "3ds": "3D-सिक्योर"
    }
  },
  error: "एरर",
  "Payment-method": "पेमेंट मेथड",
  price_plan: {
    trial_period: {
      week: "{{count}} सप्ताह",
      week_plural: "{{count}} दिन",
      day: "{{count}} दिन",
      day_plural: "{{count}} दिन",
      month: "{{count}} महीना",
      month_plural: "{{count}} महीने",
      year: "{{count}} वर्ष",
      year_plural: "{{count}} वर्ष"
    },
    interval: {
      month: "महीना",
      month_plural: "{{count}} महीने",
      day: "दिन",
      day_plural: "{{count}} दिन",
      week: "सप्ताह",
      week_plural: "{{count}} सप्ताह",
      year: "वर्ष",
      year_plural: "{{count}} वर्ष"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "मुफ्त",
        trial_period_new: "{{ trialPeriodPrice }} के लिए {{ trialInterval }} फिर",
        unlimited_new: "{{amount}} हर {{interval}} पर",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} बार"
      }
    }
  },
  affiliate_badge: {
    made_with: "द्वारा संचालित"
  },
  form_select: {
    empty_list: "लगता है यह लिस्ट खाली है",
    select: "चूनें"
  },
  contact_slug: {
    email: "ईमेल",
    first_name: "प्रथम नाम",
    last_name: "अंतिम नाम",
    phone_number: "फ़ोन नंबर",
    country: "देश",
    street_address: "सड़क का पता",
    city: "शहर",
    postal_code: "पोस्टल कोड",
    company_name: "कंपनी का नाम",
    tax_number: "टैक्स नंबर",
    state_province: "राज्य/प्रान्त",
    street_number: "सड़क संख्या",
    neighborhood: "पड़ोस"
  },
  date_picker: {
    apply: "लागू करें",
    clear: "हटाएं",
    time: "समय",
    all_time: "सभी समय",
    last_3_months: "पिछले 3 महीने",
    last_pool_period: "पिछले पूल मूल्यांकन अवधि",
    last_month: "पिछले महीने",
    this_month: "इस महीने",
    last_30_days: "पिछले 30 दिन",
    title_dates: "दिनांक",
    from: "से",
    to: "तक"
  },
  copy_clipboard: "क्लिपबोर्ड पर कॉपी किया गया",
  payment_inputs: {
    empty_card_number: "कार्ड नंबर दर्ज करें",
    invalid_card_number: "कार्ड नंबर अमान्य है ",
    empty_expiry_date: "समाप्ति तिथि दर्ज करें",
    month_out_of_range: "समाप्ति माह 01 और 12 के बीच होना चाहिए ",
    year_out_of_range: "समाप्ति वर्ष अतीत में नहीं हो सकता",
    date_out_of_range: "समाप्ति तिथि अतीत में नहीं हो सकती",
    invalid_expiry_date: "समाप्ति तिथि अमान्य है",
    invalid_cvc: "CVC अमान्य है",
    empty_cvc: "CVC दर्ज करें  ",
    card_number_placeholder: "कार्ड नंबर",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "कार्ड धारक",
    empty_card_holder: "एक कार्ड धारक का नाम दर्ज करें"
  },
  copy_clipboard_error: "टेक्स्ट कॉपी करने में असफल",
  input: {
    phone_number: "फोन नंबर",
    phone_search: "खोजें",
    search: "खोजें"
  },
  "registered-over": "पंजीकृत किया गया",
  locale: {
    french: "फ्रेंच",
    german: "जर्मन",
    italian: "इटैलिनो",
    dutch: "डच",
    english: "अंग्रेज़ी",
    portuguese: "पुर्तगाली",
    russian: "रूसी",
    spanish: "स्पैनिश",
    japanese: "जापानी",
    arabic: "अरबी",
    turkish: "तुर्की",
    chinese: "चीनी",
    swedish: "स्वीडिश",
    romanian: "रोमानियाई",
    czech: "चेक",
    hungarian: "हंगेरीअन ",
    slovak: "स्लोवाक",
    danish: "डैनिश",
    indonesian: "इन्डोनेशियाई",
    polish: "पोलिश",
    greek: "यूनानी",
    serbian: "सर्बियाई",
    hindi: "हिंदी ",
    norwegian: "नार्वेजियन",
    thai: "थाई",
    slovenian: "स्लोवेनियाई",
    ukrainian: "यूक्रेनी",
    albania: "अल्बानियन"
  },
  product: "प्रोडक्ट",
  quantity: "क्वान्टिटी",
  order_summary: "ऑर्डर समरी",
  vat: "सेल्स टैक्स",
  total: "टोटल",
  subtotal: "सब टोटल ",
  shipping: {
    shipping_method: "शिपिंग मेथड",
    not_available: "अरे! ऐसा लगता है कि हम अभी इस स्थान पर शिपिंग की पेशकश नहीं करते है ",
    condition_label: {
      price: "{{min}} {{currency}} से {{max}} {{currency}} के बीच प्राइस वाले ऑर्डर्स के लिए",
      price_min: "{{min}} {{currency}} या अधिक प्राइस वाले ऑर्डर्स के लिए",
      quantity: "{{min}} से {{max}} आइटम वाले ऑर्डर्स के लिए",
      quantity_min: "{{min}} या अधिक आइटम वाले ऑर्डर्स के लिए",
      weight: "{{min}}g से {{max}}g के बीच कुल वजन वाले ऑर्डर्स के लिए",
      weight_min: "{{min}}g या अधिक कुल वजन वाले ऑर्डर्स के लिए"
    }
  },
  shipping_fee: "शिपिंग शुल्क",
  total_amount_with_tax_and_shipping: "कुल (कर और शिपिंग सहित)",
  vat_percent: "सेल्स टैक्स ({{percent}}%)",
  including_tax: "शामिल है {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "कुल (कर सहित)",
  total_amount_with_shipping: "कुल (शिपिंग सहित)"
}, ZB = {
  public_pages_purchase: UB
}, KB = {
  "required-field": "A mező kitöltése kötelező",
  payment: {
    price_plan: "Terv",
    stripe_card: "Hitel- vagy betéti kártya",
    stripe_ideal: "iDeal (csík)",
    stripe_bancotact: "Bancontact (csíkos)",
    dlocal_card: "Hitelkártyák (Dlocal)",
    dlocal_boleto: "Boleto (helyi)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Hitelkártyák (Mercado Pago)",
    mercadopago_pix: "PIX (fizetési piac)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Utánvétes fizetés",
    xendit_card: "Hitelkártyák (Xendit)",
    paystack_card: "Hitelkártyák (Paystack)",
    paypal_connect: "Csatlakoztassa a PayPal-t",
    paypal_edit_organization_name: "Szerkessze a szervezet nevét",
    paypal_rest: "PayPal",
    secure_and_pay: "Biztonságos és fizetés",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Hiba",
  "Payment-method": "Fizetési mód",
  price_plan: {
    trial_period: {
      week: "{{count}} hét",
      week_plural: "{{count}} hét",
      day: "{{count}} nap",
      day_plural: "{{count}} nap",
      month: "{{count}} hónap",
      month_plural: "{{count}} hónap",
      year: "{{count}} év",
      year_plural: "{{count}} év"
    },
    interval: {
      month: "hónap",
      month_plural: "{{count}} hónap",
      day: "nap",
      day_plural: "{{count}} nap",
      week: "hét",
      week_plural: "{{count}} hét",
      year: "év",
      year_plural: "{{count}} év"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ingyenes",
        trial_period_new: "{{ trialPeriodPrice }} , akkor {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> minden {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} alkalommal"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Úgy tűnik, hogy ez a lista üres",
    select: "Kiválasztás"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Keresztnév",
    last_name: "Vezetéknév",
    phone_number: "Telefonszám",
    country: "Ország",
    street_address: "Utca cím",
    city: "Város",
    postal_code: "Irányítószám",
    company_name: "Cégnév",
    tax_number: "Adószám",
    state_province: "Állam/Mező",
    street_number: "Utca szám",
    neighborhood: "Környék"
  },
  date_picker: {
    apply: "Alkalmaz",
    clear: "Törlés",
    time: "Idő",
    all_time: "Minden idő",
    last_3_months: "Utolsó 3 hónap",
    last_pool_period: "Utolsó medenceértékelési időszak",
    last_month: "Utolsó hónap",
    this_month: "Ez a hónap",
    last_30_days: "Utolsó 30 nap",
    title_dates: "Dátumok",
    from: "Tól",
    to: "Ig"
  },
  copy_clipboard: "Másolva a vágólapra",
  payment_inputs: {
    empty_card_number: "Adjon meg egy kártyaszámot",
    invalid_card_number: "A kártyaszám érvénytelen",
    empty_expiry_date: "Adjon meg egy lejárati dátumot",
    month_out_of_range: "A lejárati hónapnak 01 és 12 között kell lennie",
    year_out_of_range: "A lejárati év nem lehet a múltban",
    date_out_of_range: "A lejárati dátum nem lehet a múltban",
    invalid_expiry_date: "A lejárati dátum érvénytelen",
    invalid_cvc: "A CVC érvénytelen",
    empty_cvc: "Adja meg a CVC-t",
    card_number_placeholder: "Kártyaszám",
    expiry_data_placeholder: "HH/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kártyabirtokos",
    empty_card_holder: "Adja meg a kártyabirtokos nevét"
  },
  copy_clipboard_error: "A szöveg másolása nem sikerült",
  input: {
    phone_number: "Telefonszám",
    phone_search: "Keresés",
    search: "Keresés"
  },
  "registered-over": "regisztrált több mint",
  locale: {
    french: "Francia",
    german: "Német",
    italian: "Olasz",
    dutch: "Holland",
    english: "Angol",
    portuguese: "Portugál",
    russian: "Orosz",
    spanish: "Spanyol",
    japanese: "Japán",
    arabic: "Arab",
    turkish: "Török",
    chinese: "Kínai",
    swedish: "Svéd",
    romanian: "Román",
    czech: "Cseh",
    hungarian: "Magyar",
    slovak: "Szlovák",
    danish: "Dán",
    indonesian: "Indonéz",
    polish: "Fényesít",
    greek: "Görög",
    serbian: "Szerb",
    hindi: "Dehogy",
    norwegian: "Norvég",
    thai: "Thai",
    slovenian: "Szlovén",
    ukrainian: "Ukrán",
    albania: "Albán"
  },
  product: "Termék",
  quantity: "Mennyiség",
  order_summary: "Rendelés összegzése",
  vat: "Áfa",
  total: "Összesen",
  subtotal: "Részösszeg",
  shipping: {
    shipping_method: "Szállítási mód",
    not_available: "Hoppá! Úgy tűnik, hogy még nem kínálunk szállítást erre a helyre.",
    condition_label: {
      price: "A {{min}} {{currency}} és {{max}} {{currency}} közötti árú rendelésekhez",
      price_min: "A {{min}} {{currency}} vagy annál drágább rendelésekhez",
      quantity: "A {{min}} és {{max}} közötti tételeket tartalmazó rendelésekhez",
      quantity_min: "A {{min}} vagy annál több tételt tartalmazó rendelésekhez",
      weight: "A {{min}}g és {{max}}g közötti összsúlyú rendelésekhez",
      weight_min: "A {{min}}g vagy annál nehezebb rendelésekhez"
    }
  },
  shipping_fee: "Szállítási díj",
  total_amount_with_tax_and_shipping: "Összesen (beleértve az adót és a szállítást)",
  vat_percent: "Áruforgalmi adó ({{percent}}%)",
  including_tax: "ÁFA {{percent}}%-ot tartalmaz ({{amount}})",
  total_amount_with_tax: "Összesen (beleértve az adót)",
  total_amount_with_shipping: "Összesen (beleértve a szállítást)"
}, $B = {
  public_pages_purchase: KB
}, WB = {
  "required-field": "Bidang wajib diisi",
  payment: {
    price_plan: "Rencana",
    stripe_card: "Kartu kredit atau debit",
    stripe_ideal: "iDeal (Garis)",
    stripe_bancotact: "Bancontact (Garis)",
    dlocal_card: "Kartu kredit (Dlokal)",
    dlocal_boleto: "Boleto (Dlokal)",
    dlocal_pix: "Pix (Dlokal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartu kredit (Mercado Pago)",
    mercadopago_pix: "PIX (Pasar Pembayaran)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Pembayaran pisau cukur",
    flutterwave: "Gelombang bergetar",
    mollie: "Mollie",
    gocardless: "Tanpa kartu",
    cash_on_delivery: "Bayar di tempat",
    xendit_card: "Kartu kredit (Xendit)",
    paystack_card: "Kartu kredit (Paystack)",
    paypal_connect: "Hubungkan PayPal",
    paypal_edit_organization_name: "Edit nama organisasi",
    paypal_rest: "PayPal",
    secure_and_pay: "Amankan dan Bayar",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Kesalahan",
  "Payment-method": "Metode pembayaran",
  price_plan: {
    trial_period: {
      week: "{{count}} minggu",
      day: "{{count}} hari",
      month: "{{count}} bulan",
      year: "{{count}} tahun"
    },
    interval: {
      month: "bulan",
      day: "hari",
      week: "pekan",
      year: "tahun"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bebas",
        trial_period_new: "{{ trialPeriodPrice }} untuk {{ trialInterval }} lalu",
        unlimited_new: "<bold>{{amount}}</bold> setiap {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kali"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ditenagai oleh"
  },
  form_select: {
    empty_list: "Sepertinya daftar ini kosong",
    select: "Pilih"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nama depan",
    last_name: "Nama belakang",
    phone_number: "Nomor telepon",
    country: "Negara",
    street_address: "Alamat jalan",
    city: "Kota",
    postal_code: "Kode pos",
    company_name: "Nama perusahaan",
    tax_number: "Nomor pajak",
    state_province: "Negara Bagian/Provinsi",
    street_number: "Nomor jalan",
    neighborhood: "Lingkungan"
  },
  date_picker: {
    apply: "Terapkan",
    clear: "Bersihkan",
    time: "Waktu",
    all_time: "Semua waktu",
    last_3_months: "3 bulan terakhir",
    last_pool_period: "Periode evaluasi kolam terakhir",
    last_month: "Bulan lalu",
    this_month: "Bulan ini",
    last_30_days: "30 hari terakhir",
    title_dates: "Tanggal",
    from: "Dari",
    to: "Ke"
  },
  copy_clipboard: "Disalin ke clipboard",
  payment_inputs: {
    empty_card_number: "Masukkan nomor kartu",
    invalid_card_number: "Nomor kartu tidak valid",
    empty_expiry_date: "Masukkan tanggal kedaluwarsa",
    month_out_of_range: "Bulan kedaluwarsa harus antara 01 dan 12",
    year_out_of_range: "Tahun kedaluwarsa tidak boleh di masa lalu",
    date_out_of_range: "Tanggal kedaluwarsa tidak boleh di masa lalu",
    invalid_expiry_date: "Tanggal kedaluwarsa tidak valid",
    invalid_cvc: "CVC tidak valid",
    empty_cvc: "Masukkan CVC",
    card_number_placeholder: "Nomor kartu",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Pemegang kartu",
    empty_card_holder: "Masukkan nama pemegang kartu"
  },
  copy_clipboard_error: "Gagal menyalin teks",
  input: {
    phone_number: "Nomor telepon",
    phone_search: "Cari",
    search: "Cari"
  },
  "registered-over": "terdaftar lebih dari",
  locale: {
    french: "Perancis",
    german: "Jerman",
    italian: "Italia",
    dutch: "Belanda",
    english: "Bahasa inggris",
    portuguese: "Portugis",
    russian: "Rusia",
    spanish: "Orang Spanyol",
    japanese: "Jepang",
    arabic: "Arab",
    turkish: "Turki",
    chinese: "Cina",
    swedish: "Orang Swedia",
    romanian: "Rumania",
    czech: "Ceko",
    hungarian: "Hongaria",
    slovak: "Orang Slovakia",
    danish: "Orang Denmark",
    indonesian: "Bahasa Indonesia",
    polish: "Polandia",
    greek: "Orang yunani",
    serbian: "Orang Serbia",
    hindi: "Tidak",
    norwegian: "Norwegia",
    thai: "Thai",
    slovenian: "Slovenia",
    ukrainian: "Orang Ukraina",
    albania: "Bahasa Albania"
  },
  product: "Produk",
  quantity: "Kuantitas",
  order_summary: "Ringkasan Pesanan",
  vat: "Pajak penjualan",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metode Pengiriman",
    not_available: "Ups! Sepertinya kami belum menawarkan pengiriman ke lokasi ini.",
    condition_label: {
      price: "Untuk pesanan yang harganya antara {{min}} {{currency}} hingga {{max}} {{currency}}",
      price_min: "Untuk pesanan yang harganya {{min}} {{currency}} atau lebih",
      quantity: "Untuk pesanan yang berisi antara {{min}} hingga {{max}} item",
      quantity_min: "Untuk pesanan yang berisi {{min}} item atau lebih",
      weight: "Untuk pesanan dengan total berat antara {{min}}g hingga {{max}}g",
      weight_min: "Untuk pesanan dengan total berat {{min}}g atau lebih"
    }
  },
  shipping_fee: "Biaya pengiriman",
  total_amount_with_tax_and_shipping: "Total (termasuk pajak dan pengiriman)",
  vat_percent: "Pajak penjualan ({{percent}}%)",
  including_tax: "Termasuk PPN {{percent}}% ({{amount}})",
  total_amount_with_tax: "Total (termasuk pajak)",
  total_amount_with_shipping: "Total (termasuk pengiriman)"
}, YB = {
  public_pages_purchase: WB
}, qB = {
  "required-field": "Il campo è obbligatorio",
  payment: {
    price_plan: "Piano",
    stripe_card: "Carta di credito o di debito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Carte di credito (Dlocal)",
    dlocal_boleto: "Biglietto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carte di credito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Biglietto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contanti alla consegna",
    xendit_card: "Carte di credito (Xendit)",
    paystack_card: "Carte di credito (Paystack)",
    paypal_connect: "Collegare PayPal",
    paypal_edit_organization_name: "Modifica il nome dell'organizzazione",
    paypal_rest: "PayPal",
    secure_and_pay: "Sicurezza e pagamento",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Errore",
  "Payment-method": "Metodo di pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} settimana",
      week_plural: "{{count}} settimane",
      day: "{{count}} giorno",
      day_plural: "{{count}} giorni",
      month: "{{count}} mese",
      month_plural: "{{count}} mesi",
      year: "{{count}} anni",
      year_plural: "{{count}} anni"
    },
    interval: {
      month: "mese",
      month_plural: "{{count}} mesi",
      day: "giorno",
      day_plural: "{{count}} giorni",
      week: "settimana",
      week_plural: "{{count}} settimane",
      year: "anno",
      year_plural: "{{count}} anni"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} per {{ trialInterval }} poi",
        unlimited_new: "<bold>{{amount}}</bold> ogni {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} tempi"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizzato da"
  },
  form_select: {
    empty_list: "Sembra che questo elenco sia vuoto",
    select: "Selezionare"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Cognome",
    phone_number: "Numero di telefono",
    country: "Paese",
    street_address: "Indirizzo",
    city: "Città",
    postal_code: "Codice postale",
    company_name: "Nome azienda",
    tax_number: "Partita IVA",
    state_province: "Stato/Provincia",
    street_number: "Numero civico",
    neighborhood: "Quartiere"
  },
  date_picker: {
    apply: "Applicare",
    clear: "Chiaro",
    time: "Ora",
    all_time: "Per tutto il periodo",
    last_3_months: "Ultimi 3 mesi",
    last_pool_period: "Ultimo periodo di valutazione del pool",
    last_month: "Ultimo mese",
    this_month: "Questo mese",
    last_30_days: "Ultimi 30 giorni",
    title_dates: "Date",
    from: "Da",
    to: "A"
  },
  copy_clipboard: "Copiato negli appunti",
  payment_inputs: {
    empty_card_number: "Inserire un numero di carta",
    invalid_card_number: "Il numero della carta non è valido",
    empty_expiry_date: "Inserire una data di scadenza",
    month_out_of_range: "Il mese di scadenza deve essere compreso tra 01 e 12",
    year_out_of_range: "L'anno di scadenza non può essere passato",
    date_out_of_range: "La data di scadenza non può essere passata",
    invalid_expiry_date: "La data di scadenza non è valida",
    invalid_cvc: "Il CVC non è valido",
    empty_cvc: "Inserire una CVC",
    card_number_placeholder: "Numero della carta",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Portacarte",
    empty_card_holder: "Inserire il nome del titolare della carta"
  },
  copy_clipboard_error: "Impossibile copiare il testo",
  input: {
    phone_number: "Numero di telefono",
    phone_search: "Ricerca",
    search: "Ricerca"
  },
  "registered-over": "registrato oltre",
  locale: {
    french: "Francese",
    german: "Tedesco",
    italian: "Italiano",
    dutch: "Olandese",
    english: "Inglese",
    portuguese: "Portoghese",
    russian: "Russo",
    spanish: "Spagnolo",
    japanese: "Giapponese",
    arabic: "Аrabo",
    turkish: "Turco",
    chinese: "Cinese",
    swedish: "Svedese",
    romanian: "Rumeno",
    czech: "Ceco",
    hungarian: "Ungherese",
    slovak: "Slovacco",
    danish: "Danese",
    indonesian: "Indonesiano",
    polish: "Polacco",
    greek: "Greco",
    serbian: "Serbo",
    hindi: "Hindi",
    norwegian: "Norvegese",
    thai: "Tailandese",
    slovenian: "Sloveno",
    ukrainian: "Ucraino",
    albania: "Albanese"
  },
  product: "Prodotto",
  quantity: "Quantità",
  order_summary: "Riepilogo dell'ordine",
  vat: "Imposta sulle vendite",
  total: "Totale",
  subtotal: "Totale parziale",
  shipping: {
    shipping_method: "Metodo di spedizione",
    not_available: "Ops! Sembra che per ora non offriamo spedizioni in questa località.",
    condition_label: {
      price: "Per ordini con un prezzo compreso tra {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Per ordini con un prezzo di {{min}} {{currency}} o più",
      quantity: "Per ordini contenenti tra {{min}} e {{max}} articoli",
      quantity_min: "Per ordini contenenti {{min}} articoli o più",
      weight: "Per ordini con un peso totale compreso tra {{min}}g e {{max}}g",
      weight_min: "Per ordini con un peso totale di {{min}}g o più"
    }
  },
  shipping_fee: "Spese di spedizione",
  total_amount_with_tax_and_shipping: "Totale (incluso l'imposta e la spedizione)",
  vat_percent: "Imposta sulle vendite ({{percent}}%)",
  including_tax: "Include {{percent}}% di IVA ({{amount}})",
  total_amount_with_tax: "Totale (IVA inclusa)",
  total_amount_with_shipping: "Totale (spedizione inclusa)"
}, JB = {
  public_pages_purchase: qB
}, XB = {
  "required-field": "この項目は必須です",
  payment: {
    price_plan: "プラン",
    stripe_card: "クレジットカードまたはデビットカード",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact（Stripe）",
    dlocal_card: "クレジットカード（Dlocal）",
    dlocal_boleto: "Borelo（Dlocal）",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Paypal",
    mercadopago_card: "クレジットカード (Mercado Pago)",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay ",
    flutterwave: "Flutterwave ",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "着払い",
    xendit_card: "クレジットカード（Xendit）",
    paystack_card: "クレジットカード（Paystack）",
    paypal_connect: "PayPalに接続",
    paypal_edit_organization_name: "組織名を編集",
    paypal_rest: "ペイパル",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Appleペイ",
    xendit: {
      "3ds": "3Dセキュア"
    }
  },
  error: "エラー",
  "Payment-method": "支払い方法",
  price_plan: {
    trial_period: {
      week: `{{count}}週

{{count}}週`,
      day: `{{count}} 日

{{count}} 日`,
      month: `{{count}}ヶ月

{{count}}ヶ月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `ヶ月

{{count}}ヶ月`,
      day: `日

{{count}} 日`,
      week: `週

{{count}}週`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "無料",
        trial_period_new: "{{ trialPeriodPrice }}を{{ trialInterval }}間ご利用いただけます。その後は",
        unlimited_new: "{{interval}}ごとに<bold>{{amount}}</bold>",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 回"
      }
    }
  },
  affiliate_badge: {
    made_with: "提供元"
  },
  form_select: {
    empty_list: "このリストが空のようです",
    select: "選択する"
  },
  contact_slug: {
    email: "Eメール",
    first_name: "名",
    last_name: "姓",
    phone_number: "電話番号",
    country: "国",
    street_address: "住所",
    city: "市区町村",
    postal_code: "郵便番号",
    company_name: "法人名",
    tax_number: "法人番号（税番号）",
    state_province: "都道府県",
    street_number: "番地",
    neighborhood: "地域"
  },
  date_picker: {
    apply: "適用",
    clear: "消去",
    time: "時",
    all_time: "全期間",
    last_3_months: "過去3ヶ月",
    last_pool_period: "前回の集計期間",
    last_month: "先月",
    this_month: "今月",
    last_30_days: "過去30日",
    title_dates: "日",
    from: "から",
    to: "へ"
  },
  copy_clipboard: "クリップボードにコピーされました",
  payment_inputs: {
    empty_card_number: "カード番号を入力",
    invalid_card_number: "カード番号が無効です",
    empty_expiry_date: "有効期限を入力してください。",
    month_out_of_range: "有効期限の月は、1月から12月の間である必要があります。",
    year_out_of_range: "有効期限の年は過去にすることはできません。",
    date_out_of_range: "有効期限は過去の日付にすることはできません。",
    invalid_expiry_date: "有効期限が無効です",
    invalid_cvc: "CVCが無効です",
    empty_cvc: "CVCを入力",
    card_number_placeholder: "カード番号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "カード所有者",
    empty_card_holder: "カード所有者の名前を入力してください"
  },
  copy_clipboard_error: "テキストのコピーに失敗しました",
  input: {
    phone_number: "電話番号",
    phone_search: "検索",
    search: "検索"
  },
  "registered-over": "登録された",
  locale: {
    french: "フランス語",
    german: "ドイツ語",
    italian: "イタリア語",
    dutch: "オランダ語",
    english: "英語",
    portuguese: "ポルトガル語",
    russian: "ロシア語",
    spanish: "スペイン語",
    japanese: "日本語",
    arabic: "アラブ",
    turkish: "トルコ語",
    chinese: "中国語",
    swedish: "スウェーデン語",
    romanian: "ルーマニア語",
    czech: "チェコ語",
    hungarian: "ハンガリー語",
    slovak: "スロバキア語",
    danish: "デンマーク語",
    indonesian: "インドネシア語",
    polish: "ポーランド語",
    greek: "ギリシャ語",
    serbian: "セルビア語",
    hindi: "ヒンズー語",
    norwegian: "ノルウェー語",
    thai: "タイ語",
    slovenian: "スロバニア語",
    ukrainian: "ウクライナ語",
    albania: "アルバニア語"
  },
  product: "商品",
  quantity: "数量",
  order_summary: "ご注文内容",
  vat: "消費税",
  total: "合計",
  subtotal: "小計",
  shipping: {
    shipping_method: "配送方法",
    not_available: "おっと！この地域への配送にはまだ対応していないようです。",
    condition_label: {
      price: "{{min}} {{currency}}から{{max}} {{currency}}までの注文の場合",
      price_min: "{{min}} {{currency}}以上の注文の場合",
      quantity: "{{min}}から{{max}}個の商品を含む注文の場合",
      quantity_min: "{{min}}個以上の商品を含む注文の場合",
      weight: "合計重量が {{min}}g から {{max}}g までの注文の場合",
      weight_min: "合計重量が {{min}}g 以上の注文の場合"
    }
  },
  shipping_fee: "送料",
  total_amount_with_tax_and_shipping: "合計（消費税・送料込み）",
  vat_percent: "消費税（{{percent}}%）",
  including_tax: "消費税 {{percent}}% を含む（{{amount}}）",
  total_amount_with_tax: "合計（税込）",
  total_amount_with_shipping: "合計（送料込み）"
}, QB = {
  public_pages_purchase: XB
}, ez = {
  "required-field": "Veld is vereist",
  payment: {
    price_plan: "Plan",
    stripe_card: "Creditcard of debetkaart",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Creditcards (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlokaal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Creditcards (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Contant bij levering",
    xendit_card: "Creditcards (Xendit)",
    paystack_card: "Creditcards (Paystack)",
    paypal_connect: "Verbind PayPal",
    paypal_edit_organization_name: "Organisatienaam bewerken",
    paypal_rest: "PayPal",
    secure_and_pay: "Beveiligd betalen",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fout",
  "Payment-method": "Betaalmethode",
  price_plan: {
    trial_period: {
      week: "{{count}} week",
      week_plural: "{{count}} weken",
      day: "{{count}} dag",
      day_plural: "{{count}} dagen",
      month: "{{count}} maand",
      month_plural: "{{count}} maanden",
      year: "{{count}} jaar",
      year_plural: "{{count}} jaren"
    },
    interval: {
      month: "maand",
      month_plural: "{{count}} maanden",
      day: "dag",
      day_plural: "{{count}} dagen",
      week: "week",
      week_plural: "{{count}} weken",
      year: "jaar",
      year_plural: "{{count}} jaren"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} voor {{ trialInterval }} dan",
        unlimited_new: "<bold>{{amount}}</bold> elke {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} keer"
      }
    }
  },
  affiliate_badge: {
    made_with: "Ondersteund door"
  },
  form_select: {
    empty_list: "Het lijkt erop dat deze lijst leeg is",
    select: "Selecteer"
  },
  contact_slug: {
    email: "E-mail",
    first_name: "Voornaam",
    last_name: "Achternaam",
    phone_number: "Telefoonnummer",
    country: "Land",
    street_address: "Straatadres",
    city: "Plaats",
    postal_code: "Postcode",
    company_name: "Bedrijfsnaam",
    tax_number: "BTW-nummer",
    state_province: "Staat/Provincie",
    street_number: "Huisnummer",
    neighborhood: "Buurt"
  },
  date_picker: {
    apply: "Toepassen",
    clear: "Wissen",
    time: "Tijd",
    all_time: "Alle tijden",
    last_3_months: "Laatste 3 maanden",
    last_pool_period: "Laatste pool-evaluatieperiode",
    last_month: "Afgelopen maand",
    this_month: "Deze maand",
    last_30_days: "Laatste 30 dagen",
    title_dates: "Datum",
    from: "Van",
    to: "Naar"
  },
  copy_clipboard: "Gekopieerd naar klembord",
  payment_inputs: {
    empty_card_number: "Voer een kaartnummer in",
    invalid_card_number: "Kaartnummer is ongeldig",
    empty_expiry_date: "Voer een vervaldatum in",
    month_out_of_range: "Vervalmaand moet tussen 01 en 12 liggen",
    year_out_of_range: "Vervaljaar mag niet in het verleden liggen",
    date_out_of_range: "Vervaldatum mag niet in het verleden liggen",
    invalid_expiry_date: "Vervaldatum is ongeldig",
    invalid_cvc: "CVC is ongeldig",
    empty_cvc: "Voer een CVC in",
    card_number_placeholder: "Kaartnummer",
    expiry_data_placeholder: "MM/JJ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kaarthouder",
    empty_card_holder: "Voer de naam van de kaarthouder in"
  },
  copy_clipboard_error: "Tekst kopiëren mislukt",
  input: {
    phone_number: "Telefoonnummer",
    phone_search: "Zoek",
    search: "Zoek"
  },
  "registered-over": "geregistreerd over",
  locale: {
    french: "Frans",
    german: "Duits",
    italian: "Italiaans",
    dutch: "Nederlands",
    english: "Engels",
    portuguese: "Portugees",
    russian: "Russisch",
    spanish: "Spaans",
    japanese: "Japans",
    arabic: "Arabisch",
    turkish: "Turks",
    chinese: "Chinees",
    swedish: "Zweeds",
    romanian: "Roemeens",
    czech: "Tsjechisch",
    hungarian: "Hongaars",
    slovak: "Slowaaks",
    danish: "Deens",
    indonesian: "Indonesisch",
    polish: "Pools",
    greek: "Grieks",
    serbian: "Servisch",
    hindi: "Hindi",
    norwegian: "Noors",
    thai: "Thais",
    slovenian: "Sloveens",
    ukrainian: "Oekraïens",
    albania: "Albanees"
  },
  product: "Product",
  quantity: "Aantal",
  order_summary: "Besteloverzicht",
  vat: "Verkoopbelasting",
  total: "Totaal",
  subtotal: "Subtotaal",
  shipping: {
    shipping_method: "Verzendmethode",
    not_available: "Oeps! Het lijkt erop dat we nog geen verzending naar deze locatie aanbieden",
    condition_label: {
      price: "Voor bestellingen geprijsd tussen {{min}} {{currency}} en {{max}} {{currency}}",
      price_min: "Voor bestellingen geprijsd vanaf {{min}} {{currency}} of meer",
      quantity: "Voor bestellingen die tussen de {{min}} en {{max}} artikelen bevatten",
      quantity_min: "Voor bestellingen met {{min}} of meer artikelen",
      weight: "Voor bestellingen met een totaalgewicht tussen {{min}}g en {{max}}g",
      weight_min: "Voor bestellingen met een totaalgewicht van {{min}}g of meer"
    }
  },
  shipping_fee: "Verzendkosten",
  total_amount_with_tax_and_shipping: "Totaal (inclusief BTW en Verzending)",
  vat_percent: "BTW ({{percent}}%)",
  including_tax: "Inclusief {{percent}}% BTW ({{amount}})",
  total_amount_with_tax: "Totaal (incl. belasting)",
  total_amount_with_shipping: "Totaal (incl. verzending)"
}, tz = {
  public_pages_purchase: ez
}, rz = {
  "required-field": "Felt er obligatorisk",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kreditt- eller debetkort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kredittkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredittkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalingsmarked)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterbølge",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kontantbetaling ved levering",
    xendit_card: "Kredittkort (Xendit)",
    paystack_card: "Kredittkort (Paystack)",
    paypal_connect: "Koble til PayPal",
    paypal_edit_organization_name: "Rediger organisasjonsnavn",
    paypal_rest: "PayPal",
    secure_and_pay: "Sikker og betal",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Feil",
  "Payment-method": "Betalingsmåte",
  price_plan: {
    trial_period: {
      week: "{{count}} uke",
      week_plural: "{{count}} uker",
      day: "{{count}} dag",
      day_plural: "{{count}} dager",
      month: "{{count}} måned",
      month_plural: "{{count}} måneder",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "måned",
      month_plural: "{{count}} måneder",
      day: "dag",
      day_plural: "{{count}} dager",
      week: "uke",
      week_plural: "{{count}} uker",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} for {{ trialInterval }} da",
        unlimited_new: "<bold>{{amount}}</bold> hver {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ganger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drevet av"
  },
  form_select: {
    empty_list: "Det ser ut som denne listen er tom",
    select: "Velg"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Fornavn",
    last_name: "Etternavn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gateadresse",
    city: "By",
    postal_code: "Postnummer",
    company_name: "Firmanavn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gate nummer",
    neighborhood: "Nabolag"
  },
  date_picker: {
    apply: "Bruk",
    clear: "Fjern",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Siste 3 måneder",
    last_pool_period: "Siste evalueringsperiode for basseng",
    last_month: "Siste måned",
    this_month: "Denne måneden",
    last_30_days: "Siste 30 dager",
    title_dates: "Datoer",
    from: "Fra",
    to: "Til"
  },
  copy_clipboard: "Kopiert til utklippstavlen",
  payment_inputs: {
    empty_card_number: "Skriv inn et kortnummer",
    invalid_card_number: "Kortnummeret er ugyldig",
    empty_expiry_date: "Skriv inn en utløpsdato",
    month_out_of_range: "Utløpsmåned må være mellom 01 og 12",
    year_out_of_range: "Utløpsår kan ikke være i fortiden",
    date_out_of_range: "Utløpsdato kan ikke være i fortiden",
    invalid_expiry_date: "Utløpsdato er ugyldig",
    invalid_cvc: "CVC er ugyldig",
    empty_cvc: "Skriv inn en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortholder",
    empty_card_holder: "Skriv inn navnet til kortholderen"
  },
  copy_clipboard_error: "Kunne ikke kopiere tekst",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Søk",
    search: "Søk"
  },
  "registered-over": "registrert over",
  locale: {
    french: "Fransk",
    german: "Tysk",
    italian: "Italiensk",
    dutch: "Nederlandsk",
    english: "Engelsk",
    portuguese: "Portugisisk",
    russian: "Russisk",
    spanish: "Spansk",
    japanese: "Japansk",
    arabic: "Arabisk",
    turkish: "Tyrkisk",
    chinese: "Kinesisk",
    swedish: "Svensk",
    romanian: "Rumensk",
    czech: "Tsjekkisk",
    hungarian: "Ungarsk",
    slovak: "Slovakisk",
    danish: "Dansk",
    indonesian: "Indonesisk",
    polish: "Pusse",
    greek: "Gresk",
    serbian: "Serbisk",
    hindi: "Nei",
    norwegian: "Norsk",
    thai: "Thai",
    slovenian: "Slovensk",
    ukrainian: "Ukrainsk",
    albania: "Albansk"
  },
  product: "Produkt",
  quantity: "Mengde",
  order_summary: "Ordresammendrag",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsum",
  shipping: {
    shipping_method: "Fraktmetode",
    not_available: "Oops! Det ser ut som vi ikke tilbyr frakt til dette stedet ennå.",
    condition_label: {
      price: "For bestillinger priset mellom {{min}} {{currency}} og {{max}} {{currency}}",
      price_min: "For bestillinger priset til {{min}} {{currency}} eller mer",
      quantity: "For bestillinger som inneholder mellom {{min}} til {{max}} varer",
      quantity_min: "For bestillinger som inneholder {{min}} eller flere varer",
      weight: "For bestillinger med en totalvekt mellom {{min}}g og {{max}}g",
      weight_min: "For bestillinger med en totalvekt på {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktgebyr",
  total_amount_with_tax_and_shipping: "Totalt (inkludert skatt og frakt)",
  vat_percent: "Merverdiavgift ({{percent}}%)",
  including_tax: "Inkludert {{percent}}% MVA ({{amount}})",
  total_amount_with_tax: "Totalbeløp (inkludert skatt)",
  total_amount_with_shipping: "Totalbeløp (inkludert frakt)"
}, nz = {
  public_pages_purchase: rz
}, az = {
  "required-field": "Pole jest wymagane",
  payment: {
    price_plan: "Plan",
    stripe_card: "Karta kredytowa lub debetowa",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Karty kredytowe (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Karty kredytowe (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Płatność gotówką przy odbiorze",
    xendit_card: "Karty kredytowe (Xendit)",
    paystack_card: "Karty kredytowe (Paystack)",
    paypal_connect: "Połącz PayPala",
    paypal_edit_organization_name: "Edytuj nazwę organizacji",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Błąd",
  "Payment-method": "Metoda płatności",
  price_plan: {
    trial_period: {
      week_0: "{{count}} tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      day_0: "{{count}} dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      month_0: "{{count}} miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      year_0: "{{count}} rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    },
    interval: {
      month_0: "miesiąc",
      month_1: "{{count}} miesięcy",
      month_2: "{{count}} miesięcy",
      day_0: "dzień",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      week_0: "tydzień",
      week_1: "{{count}} tygodni",
      week_2: "{{count}} tygodni",
      year_0: "rok",
      year_1: "{{count}} lat",
      year_2: "{{count}} lat"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Bezpłatny",
        trial_period_new: "{{ trialPeriodPrice }} dla {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> każdy {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} razy"
      }
    }
  },
  affiliate_badge: {
    made_with: "Zasilane przez"
  },
  form_select: {
    empty_list: "Wygląda na to, że ta lista jest pusta",
    select: "Wybierz"
  },
  contact_slug: {
    email: "Email",
    first_name: "Imię",
    last_name: "Nazwisko",
    phone_number: "Numer telefonu",
    country: "Kraj",
    street_address: "Adres",
    city: "Miasto",
    postal_code: "Kod pocztowy",
    company_name: "Nazwa firmy",
    tax_number: "Numer identyfikacji podatkowej",
    state_province: "Stan/Województwo",
    street_number: "Numer ulicy",
    neighborhood: "Osiedle"
  },
  date_picker: {
    apply: "Zastosuj",
    clear: "Wyczyść",
    time: "Czas",
    all_time: "Cały czas",
    last_3_months: "Ostatnie 3 miesiące",
    last_pool_period: "Ostatni okres oceny puli",
    last_month: "Ostatni miesiąc",
    this_month: "Ten miesiąc",
    last_30_days: "Ostatnie 30 dni",
    title_dates: "Daty",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopiowano do schowka",
  payment_inputs: {
    empty_card_number: "Wprowadź numer karty",
    invalid_card_number: "Numer karty jest nieprawidłowy",
    empty_expiry_date: "Wprowadź datę ważności",
    month_out_of_range: "Miesiąc ważności musi być między 01 a 12",
    year_out_of_range: "Rok ważności nie może być w przeszłości",
    date_out_of_range: "Data ważności nie może być w przeszłości",
    invalid_expiry_date: "Data ważności jest nieprawidłowa",
    invalid_cvc: "CVC jest nieprawidłowy",
    empty_cvc: "Wprowadź CVC",
    card_number_placeholder: "Numer karty",
    expiry_data_placeholder: "MM/RR",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Właściciel karty",
    empty_card_holder: "Wprowadź imię i nazwisko właściciela karty"
  },
  copy_clipboard_error: "Nie udało się skopiować tekstu",
  input: {
    phone_number: "Numer telefonu",
    phone_search: "Szukaj",
    search: "Szukaj"
  },
  "registered-over": "zarejestrowano ponad",
  locale: {
    french: "Francuski",
    german: "Niemiecki",
    italian: "Włoski",
    dutch: "Holenderski",
    english: "Angielski",
    portuguese: "Portugalski",
    russian: "Rosyjski",
    spanish: "Hiszpański",
    japanese: "Japoński",
    arabic: "Arabski",
    turkish: "Turecki",
    chinese: "Chiński",
    swedish: "Szwedzki",
    romanian: "Rumuński",
    czech: "Czeski",
    hungarian: "Węgierski",
    slovak: "Słowacki",
    danish: "Duński",
    indonesian: "Indonezyjski",
    polish: "Polski",
    greek: "Grecki",
    serbian: "Serbski",
    hindi: "Hinduski",
    norwegian: "Norweski",
    thai: "Tajski",
    slovenian: "Słoweński",
    ukrainian: "Ukraiński",
    albania: "Albański"
  },
  product: "Produkt",
  quantity: "Ilość",
  order_summary: "Podsumowanie zamówienia",
  vat: "Podatek od sprzedaży",
  total: "Razem",
  subtotal: "Suma częściowa",
  shipping: {
    shipping_method: "Metoda wysyłki",
    not_available: "Ups! Wygląda na to, że nie oferujemy jeszcze wysyłki do tej lokalizacji.",
    condition_label: {
      price: "Dla zamówień w cenie od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Dla zamówień w cenie {{min}} {{currency}} lub więcej",
      quantity: "Dla zamówień zawierających od {{min}} do {{max}} przedmiotów",
      quantity_min: "Dla zamówień zawierających {{min}} lub więcej przedmiotów",
      weight: "Dla zamówień o łącznej wadze od {{min}}g do {{max}}g",
      weight_min: "Dla zamówień o łącznej wadze {{min}}g lub więcej"
    }
  },
  shipping_fee: "Opłata za wysyłkę",
  total_amount_with_tax_and_shipping: "Razem (w tym podatek i wysyłka)",
  vat_percent: "Podatek od sprzedaży ({{percent}}%)",
  including_tax: "Zawiera {{percent}}% VAT ({{amount}})",
  total_amount_with_tax: "Razem (z podatkiem)",
  total_amount_with_shipping: "Razem (z wysyłką)"
}, iz = {
  public_pages_purchase: az
}, oz = {
  "required-field": "O campo é obrigatório",
  payment: {
    price_plan: "Plano",
    stripe_card: "Cartão de crédito ou débito",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Cartão de crédito (Dlocal)",
    dlocal_boleto: "Boleto bancário (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Cartão de crédito (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Pagamento na entrega",
    xendit_card: "Cartão de crédito (Xendit)",
    paystack_card: "Cartão de crédito (Paystack)",
    paypal_connect: "Conectar PayPal",
    paypal_edit_organization_name: "Editar o nome da empresa",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Erro",
  "Payment-method": "Método de pagamento",
  price_plan: {
    trial_period: {
      week: "{{count}} semana",
      week_plural: "{{count}} semanas",
      day: "{{count}} dia",
      day_plural: "{{count}} dias",
      month: "{{count}} mês",
      month_plural: "{{count}} meses",
      year: "{{count}} ano",
      year_plural: "{{count}} anos"
    },
    interval: {
      month: "mês",
      month_plural: "{{count}} meses",
      day: "dia",
      day_plural: "{{count}} dias",
      week: "semana",
      week_plural: "{{count}} semanas",
      year: "ano",
      year_plural: "{{count}} anos"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuito",
        trial_period_new: "{{ trialPeriodPrice }} por {{ trialInterval }} depois",
        unlimited_new: "<bold>{{amount}}</bold> a cada {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} vezes"
      }
    }
  },
  affiliate_badge: {
    made_with: "Desenvolvido por"
  },
  form_select: {
    empty_list: "Parece que essa lista está vazia",
    select: "Selecionar"
  },
  contact_slug: {
    email: "Email",
    first_name: "Nome",
    last_name: "Sobrenome",
    phone_number: "Número de telefone",
    country: "País",
    street_address: "Endereço",
    city: "Cidade",
    postal_code: "Código postal",
    company_name: "Nome da empresa",
    tax_number: "CNPJ/NIF",
    state_province: "Estado/Província",
    street_number: "Número",
    neighborhood: "Bairro"
  },
  date_picker: {
    apply: "Aplicar",
    clear: "Limpar",
    time: "Horário",
    all_time: "Desde o início",
    last_3_months: "Últimos 3 meses",
    last_pool_period: "Último período de avaliação do grupo",
    last_month: "Último mês",
    this_month: "Este mês",
    last_30_days: "Últimos 30 dias",
    title_dates: "Datas",
    from: "De",
    to: "Até"
  },
  copy_clipboard: "Copiado para a área de transferência",
  payment_inputs: {
    empty_card_number: "Insira um número de cartão",
    invalid_card_number: "O número do cartão é inválido",
    empty_expiry_date: "Insira uma data de validade",
    month_out_of_range: "O mês de validade deve estar entre 01 e 12",
    year_out_of_range: "O ano de validade não pode estar no passado",
    date_out_of_range: "A data de validade não pode estar no passado",
    invalid_expiry_date: "A data de validade é inválida",
    invalid_cvc: "O CVV é inválido",
    empty_cvc: "Insira o CVV",
    card_number_placeholder: "Número do cartão",
    expiry_data_placeholder: "MM/AA",
    cvc_placeholder: "CVV",
    card_holder_placeholder: "Titular do cartão",
    empty_card_holder: "Insira o nome do titular do cartão"
  },
  copy_clipboard_error: "Falha ao copiar o texto",
  input: {
    phone_number: "Número de telefone",
    phone_search: "Pesquisar",
    search: "Pesquisar"
  },
  "registered-over": "registrado há mais de",
  locale: {
    french: "Francês",
    german: "Alemão",
    italian: "Italiano",
    dutch: "Holandês",
    english: "Inglês",
    portuguese: "Português",
    russian: "Russo",
    spanish: "Espanhol",
    japanese: "Japonês",
    arabic: "Árabe",
    turkish: "Turco",
    chinese: "Chinês",
    swedish: "Sueco",
    romanian: "Romeno",
    czech: "Tcheco",
    hungarian: "Húngaro",
    slovak: "Eslovaco",
    danish: "Dinamarquês",
    indonesian: "Indonésio",
    polish: "Polonês",
    greek: "Grego",
    serbian: "Sérvio",
    hindi: "Hindi",
    norwegian: "Norueguês",
    thai: "Tailandês",
    slovenian: "Esloveno",
    ukrainian: "Ucraniano",
    albania: "Albanês"
  },
  product: "Produto",
  quantity: "Quantidade",
  order_summary: "Resumo do pedido",
  vat: "Imposto",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Método de envio",
    not_available: "Ops! Parece que ainda não oferecemos envio para este local",
    condition_label: {
      price: "Para pedidos com valor entre {{min}} {{currency}} e {{max}} {{currency}}",
      price_min: "Para pedidos com valor de {{min}} {{currency}} ou mais",
      quantity: "Para pedidos contendo entre {{min}} e {{max}} itens",
      quantity_min: "Para pedidos contendo {{min}} ou mais itens",
      weight: "Para pedidos com peso total entre {{min}}g e {{max}}g",
      weight_min: "Para pedidos com peso total de {{min}}g ou mais"
    }
  },
  shipping_fee: "Taxa de envio",
  total_amount_with_tax_and_shipping: "Total (incluindo imposto e envio)",
  vat_percent: "Imposto ({{percent}}%)",
  including_tax: "Inclui {{percent}}% de imposto (IVA) ({{amount}})",
  total_amount_with_tax: "Total (incluindo impostos)",
  total_amount_with_shipping: "Total (incluindo envio)"
}, sz = {
  public_pages_purchase: oz
}, lz = {
  "required-field": "Câmpul este obligatoriu",
  payment: {
    price_plan: "Plan",
    stripe_card: "Card de credit sau debit",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (stripe)",
    dlocal_card: "Carduri de credit (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Carduri de credit (Mercado Pago)",
    mercadopago_pix: "PIX (piață de plată)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Plata la livrare",
    xendit_card: "Carduri de credit (Xendit)",
    paystack_card: "Carduri de credit (Paystack)",
    paypal_connect: "Conectați PayPal",
    paypal_edit_organization_name: "Editați numele organizației",
    paypal_rest: "PayPal",
    secure_and_pay: "Securizat și plătiți",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Eroare",
  "Payment-method": "Modalitate de plată",
  price_plan: {
    trial_period: {
      week_0: "{{count}} săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      day_0: "{{count}} zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      month_0: "{{count}} lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      year_0: "{{count}} an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    },
    interval: {
      month_0: "lună",
      month_1: "{{count}} luni",
      month_2: "{{count}} luni",
      day_0: "zi",
      day_1: "{{count}} zile",
      day_2: "{{count}} zile",
      week_0: "săptămână",
      week_1: "{{count}} săptămâni",
      week_2: "{{count}} săptămâni",
      year_0: "an",
      year_1: "{{count}} ani",
      year_2: "{{count}} ani"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratuit",
        trial_period_new: "{{ trialPeriodPrice }} pentru {{ trialInterval }} atunci",
        unlimited_new: "<bold>{{amount}}</bold> la fiecare {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - de {{ count }} ori"
      }
    }
  },
  affiliate_badge: {
    made_with: "Realizat de"
  },
  form_select: {
    empty_list: "Se pare că această listă este goală",
    select: "Selectați"
  },
  contact_slug: {
    email: "Email",
    first_name: "Prenume",
    last_name: "Nume de familie",
    phone_number: "Număr de telefon",
    country: "Țară",
    street_address: "Adresă",
    city: "Oraș",
    postal_code: "Cod poștal",
    company_name: "Numele companiei",
    tax_number: "Număr de identificare fiscală",
    state_province: "Stat/Provincie",
    street_number: "Numărul străzii",
    neighborhood: "Cartier"
  },
  date_picker: {
    apply: "Aplică",
    clear: "Șterge",
    time: "Timp",
    all_time: "Tot timpul",
    last_3_months: "Ultimele 3 luni",
    last_pool_period: "Ultima perioadă de evaluare a grupului",
    last_month: "Luna trecută",
    this_month: "Luna aceasta",
    last_30_days: "Ultimele 30 de zile",
    title_dates: "Date",
    from: "De la",
    to: "Către"
  },
  copy_clipboard: "Copiat în clipboard",
  payment_inputs: {
    empty_card_number: "Introduceți un număr de card",
    invalid_card_number: "Numărul cardului este invalid",
    empty_expiry_date: "Introduceți o dată de expirare",
    month_out_of_range: "Luna de expirare trebuie să fie între 01 și 12",
    year_out_of_range: "Anul de expirare nu poate fi în trecut",
    date_out_of_range: "Data de expirare nu poate fi în trecut",
    invalid_expiry_date: "Data de expirare este invalidă",
    invalid_cvc: "CVC este invalid",
    empty_cvc: "Introduceți un CVC",
    card_number_placeholder: "Numărul cardului",
    expiry_data_placeholder: "LL/AA",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Titularul cardului",
    empty_card_holder: "Introduceți un nume al titularului cardului"
  },
  copy_clipboard_error: "Copierea textului a eșuat",
  input: {
    phone_number: "Număr de telefon",
    phone_search: "Căutare",
    search: "Caută"
  },
  "registered-over": "înregistrat peste",
  locale: {
    french: "Limba franceza",
    german: "Limba germana",
    italian: "Italiană",
    dutch: "Olandeză",
    english: "Engleză",
    portuguese: "Portugheză",
    russian: "Rusă",
    spanish: "Spaniolă",
    japanese: "Japonez",
    arabic: "Arabic",
    turkish: "Turc",
    chinese: "Chinez",
    swedish: "Suedez",
    romanian: "Română",
    czech: "Ceh",
    hungarian: "Maghiară",
    slovak: "Slovacă",
    danish: "Danez",
    indonesian: "Indoneziană",
    polish: "Lustrui",
    greek: "Greacă",
    serbian: "Sârb",
    hindi: "Nu",
    norwegian: "Norvegian",
    thai: "Thailandez",
    slovenian: "Slovenă",
    ukrainian: "Ucrainean",
    albania: "Albanez"
  },
  product: "Produs",
  quantity: "Cantitate",
  order_summary: "Rezumatul comenzii",
  vat: "Taxa pe vânzări",
  total: "Total",
  subtotal: "Subtotal",
  shipping: {
    shipping_method: "Metoda de livrare",
    not_available: "Ups! Se pare că nu oferim livrare în această locație încă.",
    condition_label: {
      price: "Pentru comenzi cu prețuri între {{min}} {{currency}} și {{max}} {{currency}}",
      price_min: "Pentru comenzi cu prețuri de {{min}} {{currency}} sau mai mult",
      quantity: "Pentru comenzi care conțin între {{min}} și {{max}} articole",
      quantity_min: "Pentru comenzi care conțin {{min}} sau mai multe articole",
      weight: "Pentru comenzi cu o greutate totală între {{min}}g și {{max}}g",
      weight_min: "Pentru comenzi cu o greutate totală de {{min}}g sau mai mult"
    }
  },
  shipping_fee: "Taxa de livrare",
  total_amount_with_tax_and_shipping: "Total (inclusiv taxe și livrare)",
  vat_percent: "Taxa pe vânzări ({{percent}}%)",
  including_tax: "Incluzând TVA de {{percent}}% ({{amount}})",
  total_amount_with_tax: "Total (inclusiv taxe)",
  total_amount_with_shipping: "Total (inclusiv transport)"
}, cz = {
  public_pages_purchase: lz
}, uz = {
  "required-field": "Поле обязательно для заполнения",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитная или дебетовая карта",
    stripe_ideal: "Разрешить платежи через iDeal",
    stripe_bancotact: "Разрешить платежи через BanContact",
    dlocal_card: "Кредитные карты (Dlocal)",
    dlocal_boleto: "Заготовка (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "Разрешить платежи PayPal",
    mercadopago_card: "Кредитные карты",
    mercadopago_pix: "PIX (Платный рынок)",
    mercadopago_boleto: "Билет (Платный рынок)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Оплата наличными при доставке",
    xendit_card: "Кредитные карты (Xendit)",
    paystack_card: "Кредитные карты (Paystack)",
    paypal_connect: "Подключить PayPal",
    paypal_edit_organization_name: "Изменить название организации",
    paypal_rest: "PayPal",
    secure_and_pay: "Secure and Pay",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Ошибка",
  "Payment-method": "Способ оплаты",
  price_plan: {
    trial_period: {
      week_0: "{{count}} неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} недель",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      month_0: "месяц",
      month_1: "{{count}} месяца",
      month_2: "{{count}} месяцев",
      year_0: "год",
      year_1: "{{count}} года",
      year_2: "{{count}} лет"
    },
    interval: {
      month_0: "месяц",
      month_1: "{{count}} месяцы",
      month_2: "{{count}} месяца",
      day_0: "день",
      day_1: "{{count}} дней",
      day_2: "{{count}} дни",
      week_0: "неделя",
      week_1: "{{count}} недели",
      week_2: "{{count}} неделями",
      year_0: "год",
      year_1: "{{count}} годы",
      year_2: "{{count}} лет"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} для {{ trialInterval }} затем",
        unlimited_new: "<bold>{{amount}}</bold> каждый {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} раз"
      }
    }
  },
  affiliate_badge: {
    made_with: "Создано с "
  },
  form_select: {
    empty_list: "Похоже, что этот список пуст.",
    select: "Выбрать"
  },
  contact_slug: {
    email: "Почта",
    first_name: "Имя",
    last_name: "Фамилия",
    phone_number: "Номер телефона",
    country: "Страна",
    street_address: "Адрес",
    city: "Город",
    postal_code: "Почтовый индекс",
    company_name: "Название компании",
    tax_number: "Налоговый номер",
    state_province: "Штат/Область",
    street_number: "Номер улицы",
    neighborhood: "Соседство"
  },
  date_picker: {
    apply: "Применить",
    clear: "Очистить",
    time: "Время",
    all_time: "Все время",
    last_3_months: "Последние 3 месяца",
    last_pool_period: "Последний период оценки пула",
    last_month: "Последний месяц",
    this_month: "В этом месяце",
    last_30_days: "Последние 30 дней",
    title_dates: "Даты",
    from: "От",
    to: "В"
  },
  copy_clipboard: "Номер карты недействителен",
  payment_inputs: {
    empty_card_number: "Введите номер карты",
    invalid_card_number: "Номер карты недействителен",
    empty_expiry_date: "Введите дату окончания срока действия",
    month_out_of_range: "Месяц окончания срока действия должен быть между 01 и 12",
    year_out_of_range: "Год окончания срока действия не может быть в прошлом",
    date_out_of_range: "Дата окончания срока действия не может быть в прошлом",
    invalid_expiry_date: "Срок годности недействителен",
    invalid_cvc: "CVC код неправильный",
    empty_cvc: "Введите CVC код",
    card_number_placeholder: "Номер карты",
    expiry_data_placeholder: "М/Г",
    cvc_placeholder: "CVC код",
    card_holder_placeholder: "Держатель карты",
    empty_card_holder: "Введите имя держателя карты"
  },
  copy_clipboard_error: "Не удалось скопировать текст",
  input: {
    phone_number: "Номер телефона",
    phone_search: "Поиск",
    search: "Поиск"
  },
  "registered-over": "зарегистрировано более чем",
  locale: {
    french: "Французский",
    german: "Немецкий",
    italian: "Итальянский",
    dutch: "Голландский",
    english: "Английский",
    portuguese: "Португальский",
    russian: "Русский",
    spanish: "Испанский",
    japanese: "Японский",
    arabic: "Арабский",
    turkish: "Турецкий",
    chinese: "Китайский",
    swedish: "Шведский",
    romanian: "Румынский",
    czech: "Чешский",
    hungarian: "Венгерский",
    slovak: "Словацкий",
    danish: "Датский",
    indonesian: "Индонезийский",
    polish: "Польский",
    greek: "Греческий",
    serbian: "Сербский",
    hindi: "Хинди",
    norwegian: "Норвежский",
    thai: "Тайский",
    slovenian: "Словенский",
    ukrainian: "Украинский",
    albania: "Албанский"
  },
  product: "Продукт",
  quantity: "Количество",
  order_summary: "Итог заказа",
  vat: "Налог с продаж",
  total: "Итого",
  subtotal: "Промежуточный итог",
  shipping: {
    shipping_method: "Способ доставки",
    not_available: "Упс! Похоже, что мы еще не предлагаем доставку в это место.",
    condition_label: {
      price: "Для заказов стоимостью от {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для заказов стоимостью {{min}} {{currency}} или более",
      quantity: "Для заказов, содержащих от {{min}} до {{max}} товаров",
      quantity_min: "Для заказов, содержащих {{min}} или более товаров",
      weight: "Для заказов с общим весом от {{min}}g до {{max}}g",
      weight_min: "Для заказов с общим весом {{min}}g или более"
    }
  },
  shipping_fee: "Стоимость доставки",
  total_amount_with_tax_and_shipping: "Итого (включая налог и доставку)",
  vat_percent: "Налог с продаж ({{percent}}%)",
  including_tax: "Включает {{percent}}% НДС ({{amount}})",
  total_amount_with_tax: "Общая сумма (с налогом)",
  total_amount_with_shipping: "Общая сумма (с учетом доставки)"
}, dz = {
  public_pages_purchase: uz
}, pz = {
  "required-field": "Pole je povinné",
  payment: {
    price_plan: "Plán",
    stripe_card: "Kreditná alebo debetná karta",
    stripe_ideal: "iDeal (pruh)",
    stripe_bancotact: "Bancontact (pruh)",
    dlocal_card: "Kreditné karty (miestne)",
    dlocal_boleto: "Boleto (miestne)",
    dlocal_pix: "Pix (miestne)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditné karty (Mercado Pago)",
    mercadopago_pix: "PIX (Platobný trh)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Platba na dobierku",
    xendit_card: "Kreditné karty (Xendit)",
    paystack_card: "Kreditné karty (Paystack)",
    paypal_connect: "Pripojte PayPal",
    paypal_edit_organization_name: "Upravte názov organizácie",
    paypal_rest: "PayPal",
    secure_and_pay: "Zabezpečiť a zaplatiť",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Chyba",
  "Payment-method": "Spôsob platby",
  price_plan: {
    trial_period: {
      week_0: "{{count}} týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      day_0: "{{count}} deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      month_0: "{{count}} mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      year_0: "{{count}} rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    },
    interval: {
      month_0: "mesiac",
      month_1: "{{count}} mesiacov",
      month_2: "{{count}} mesiacov",
      day_0: "deň",
      day_1: "{{count}} dní",
      day_2: "{{count}} dní",
      week_0: "týždeň",
      week_1: "{{count}} týždňov",
      week_2: "{{count}} týždňov",
      year_0: "rok",
      year_1: "{{count}} rokov",
      year_2: "{{count}} rokov"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Zadarmo",
        trial_period_new: "Potom {{ trialPeriodPrice }} za {{ trialInterval }}",
        unlimited_new: "<bold>{{amount}}</bold> každých {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krát"
      }
    }
  },
  affiliate_badge: {
    made_with: "Poháňané"
  },
  form_select: {
    empty_list: "Zdá sa, že tento zoznam je prázdny",
    select: "Vybrať"
  },
  contact_slug: {
    email: "Email",
    first_name: "Meno",
    last_name: "Priezvisko",
    phone_number: "Telefónne číslo",
    country: "Krajina",
    street_address: "Ulica",
    city: "Mesto",
    postal_code: "PSČ",
    company_name: "Názov spoločnosti",
    tax_number: "Daňové číslo",
    state_province: "Štát/Provincie",
    street_number: "Číslo ulice",
    neighborhood: "Štvrť"
  },
  date_picker: {
    apply: "Použiť",
    clear: "Vymazať",
    time: "Čas",
    all_time: "Celý čas",
    last_3_months: "Posledné 3 mesiace",
    last_pool_period: "Posledné hodnotenie bazéna",
    last_month: "Minulý mesiac",
    this_month: "Tento mesiac",
    last_30_days: "Posledných 30 dní",
    title_dates: "Dátumy",
    from: "Z",
    to: "Do"
  },
  copy_clipboard: "Skopírované do schránky",
  payment_inputs: {
    empty_card_number: "Zadajte číslo karty",
    invalid_card_number: "Číslo karty je neplatné",
    empty_expiry_date: "Zadajte dátum expirácie",
    month_out_of_range: "Mesiac expirácie musí byť medzi 01 a 12",
    year_out_of_range: "Rok expirácie nemôže byť v minulosti",
    date_out_of_range: "Dátum expirácie nemôže byť v minulosti",
    invalid_expiry_date: "Dátum expirácie je neplatný",
    invalid_cvc: "CVC je neplatný",
    empty_cvc: "Zadajte CVC",
    card_number_placeholder: "Číslo karty",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Držiteľ karty",
    empty_card_holder: "Zadajte meno držiteľa karty"
  },
  copy_clipboard_error: "Nepodarilo sa skopírovať text",
  input: {
    phone_number: "Telefónne číslo",
    phone_search: "Hľadať",
    search: "Hľadať"
  },
  "registered-over": "registrované viac ako",
  locale: {
    french: "Francúzsky",
    german: "Nemecký",
    italian: "Taliansky",
    dutch: "Holandský",
    english: "Angličtina",
    portuguese: "Portugalčina",
    russian: "Ruský",
    spanish: "španielčina",
    japanese: "Japončina",
    arabic: "Arabčina",
    turkish: "Turecký",
    chinese: "čínsky",
    swedish: "švédsky",
    romanian: "Rumunský",
    czech: "český",
    hungarian: "Maďarský",
    slovak: "Slovenský",
    danish: "Dánčina",
    indonesian: "Indonézsky",
    polish: "Poľský",
    greek: "Grécky",
    serbian: "Srbský",
    hindi: "Nie",
    norwegian: "Nórsky",
    thai: "Thajčina",
    slovenian: "Slovensky",
    ukrainian: "Ukrajinčina",
    albania: "Albánsky"
  },
  product: "Produkt",
  quantity: "Množstvo",
  order_summary: "Zhrnutie objednávky",
  vat: "Daň z predaja",
  total: "Celkom",
  subtotal: "Medzisúčet",
  shipping: {
    shipping_method: "Spôsob dopravy",
    not_available: "Ups! Vyzerá to, že na túto lokalitu zatiaľ nenabízame dopravu.",
    condition_label: {
      price: "Pre objednávky v cene medzi {{min}} {{currency}} a {{max}} {{currency}}",
      price_min: "Pre objednávky v cene {{min}} {{currency}} alebo viac",
      quantity: "Pre objednávky obsahujúce medzi {{min}} a {{max}} položkami",
      quantity_min: "Pre objednávky obsahujúce {{min}} alebo viac položiek",
      weight: "Pre objednávky s celkovou hmotnosťou medzi {{min}}g a {{max}}g",
      weight_min: "Pre objednávky s celkovou hmotnosťou {{min}}g alebo viac"
    }
  },
  shipping_fee: "Poplatok za dopravu",
  total_amount_with_tax_and_shipping: "Celkom (vrátane dane a dopravy)",
  vat_percent: "Daň z predaja ({{percent}}%)",
  including_tax: "Vrátane DPH {{percent}}% ({{amount}})",
  total_amount_with_tax: "Celkom (vrátane dane)",
  total_amount_with_shipping: "Celkom (vrátane dopravy)"
}, hz = {
  public_pages_purchase: pz
}, mz = {
  "required-field": "Polje je obvezno",
  payment: {
    price_plan: "Načrtujte",
    stripe_card: "Kreditna ali debetna kartica",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditne kartice (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditne kartice (Mercado Pago)",
    mercadopago_pix: "PIX (plačilni trg)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Gotovino po povzetju",
    xendit_card: "Kreditne kartice (Xendit)",
    paystack_card: "Kreditne kartice (Paystack)",
    paypal_connect: "Povežite PayPal",
    paypal_edit_organization_name: "Uredi ime organizacije",
    paypal_rest: "PayPal",
    secure_and_pay: "Zavarujte in plačajte",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Napaka",
  "Payment-method": "Način plačila",
  price_plan: {
    trial_period: {
      week_0: "{{count}} teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      day_0: "{{count}} dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      month_0: "{{count}} mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      year_0: "{{count}} leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    },
    interval: {
      month_0: "mesec",
      month_1: "{{count}} mesecev",
      month_2: "{{count}} mesecev",
      month_3: "{{count}} mesecev",
      day_0: "dan",
      day_1: "{{count}} dni",
      day_2: "{{count}} dni",
      day_3: "{{count}} dni",
      week_0: "teden",
      week_1: "{{count}} tednov",
      week_2: "{{count}} tednov",
      week_3: "{{count}} tednov",
      year_0: "leto",
      year_1: "{{count}} let",
      year_2: "{{count}} let",
      year_3: "{{count}} let"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Brezplačno",
        trial_period_new: "{{ trialPeriodPrice }} za {{ trialInterval }} potem",
        unlimited_new: "<bold>{{amount}}</bold> vsak {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} – {{ count }} -krat"
      }
    }
  },
  affiliate_badge: {
    made_with: "Powered by"
  },
  form_select: {
    empty_list: "Zdi se, da je ta seznam prazen",
    select: "Izberi"
  },
  contact_slug: {
    email: "E-pošta",
    first_name: "Ime",
    last_name: "Priimek",
    phone_number: "Telefonska številka",
    country: "Država",
    street_address: "Ulična naslov",
    city: "Mesto",
    postal_code: "Poštna številka",
    company_name: "Ime podjetja",
    tax_number: "Davčna številka",
    state_province: "Država/Provinca",
    street_number: "Številka ulice",
    neighborhood: "Soseska"
  },
  date_picker: {
    apply: "Uporabi",
    clear: "Počisti",
    time: "Čas",
    all_time: "Vse čase",
    last_3_months: "Zadnja 3 meseca",
    last_pool_period: "Zadnje obdobje ocenjevanja bazena",
    last_month: "Zadnji mesec",
    this_month: "Ta mesec",
    last_30_days: "Zadnjih 30 dni",
    title_dates: "Datumi",
    from: "Iz",
    to: "Do"
  },
  copy_clipboard: "Kopirano v odložišče",
  payment_inputs: {
    empty_card_number: "Vnesite številko kartice",
    invalid_card_number: "Številka kartice je neveljavna",
    empty_expiry_date: "Vnesite datum poteka",
    month_out_of_range: "Mesec poteka mora biti med 01 in 12",
    year_out_of_range: "Leto poteka ne more biti v preteklosti",
    date_out_of_range: "Datum poteka ne more biti v preteklosti",
    invalid_expiry_date: "Datum poteka je neveljaven",
    invalid_cvc: "CVC je neveljaven",
    empty_cvc: "Vnesite CVC",
    card_number_placeholder: "Številka kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Imetnik kartice",
    empty_card_holder: "Vnesite ime imetnika kartice"
  },
  copy_clipboard_error: "Kopiranje besedila ni uspelo",
  input: {
    phone_number: "Telefonska številka",
    phone_search: "Iskanje",
    search: "Iskanje"
  },
  "registered-over": "registrirani več kot",
  locale: {
    french: "Francosko",
    german: "Nemški",
    italian: "Italijanski",
    dutch: "Nizozemščina",
    english: "Angleščina",
    portuguese: "Portugalščina",
    russian: "Ruski",
    spanish: "španski",
    japanese: "Japonska",
    arabic: "Arabsko",
    turkish: "Turško",
    chinese: "Kitajski",
    swedish: "švedščina",
    romanian: "Romunščina",
    czech: "češki",
    hungarian: "Madžarski",
    slovak: "Slovaški",
    danish: "Danščina",
    indonesian: "Indonezijski",
    polish: "Poljski",
    greek: "Grški",
    serbian: "Srbsko",
    hindi: "Ne",
    norwegian: "Norveški",
    thai: "Tajska",
    slovenian: "Slovenščina",
    ukrainian: "Ukrajinski",
    albania: "Albanski"
  },
  product: "Izdelek",
  quantity: "Količina",
  order_summary: "Povzetek naročila",
  vat: "Davek na prodajo",
  total: "Skupaj",
  subtotal: "Medseštevek",
  shipping: {
    shipping_method: "Način dostave",
    not_available: "Oups! Zdi se, da še ne ponujamo dostave na to lokacijo.",
    condition_label: {
      price: "Za naročila v vrednosti med {{min}} {{currency}} in {{max}} {{currency}}",
      price_min: "Za naročila v vrednosti {{min}} {{currency}} ali več",
      quantity: "Za naročila, ki vsebujejo med {{min}} in {{max}} artikli",
      quantity_min: "Za naročila, ki vsebujejo {{min}} ali več artiklov",
      weight: "Za naročila s skupno težo med {{min}}g in {{max}}g",
      weight_min: "Za naročila s skupno težo {{min}}g ali več"
    }
  },
  shipping_fee: "Strošek dostave",
  total_amount_with_tax_and_shipping: "Skupaj (vključno z davkom in dostavo)",
  vat_percent: "Davek na prodajo ({{percent}}%)",
  including_tax: "Vključeno {{percent}}% DDV ({{amount}})",
  total_amount_with_tax: "Skupaj (vključno z davkom)",
  total_amount_with_shipping: "Skupaj (vključno s poštnino)"
}, fz = {
  public_pages_purchase: mz
}, Cz = {
  "required-field": "Fusha kërkohet",
  payment: {
    price_plan: "Planifikoni",
    stripe_card: "Kartë krediti ose debiti",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (shirit)",
    dlocal_card: "Kartat e kreditit (Dlokale)",
    dlocal_boleto: "Boleto (lokale)",
    dlocal_pix: "Pix (vendor)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kartat e kreditit (Mercado Pago)",
    mercadopago_pix: "PIX (Tregu i Pagesave)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Pa kartë",
    cash_on_delivery: "Para ne dore gjate dorezimit",
    xendit_card: "Kartat e kreditit (Xendit)",
    paystack_card: "Kartat e kreditit (Paystack)",
    paypal_connect: "Lidhni PayPal",
    paypal_edit_organization_name: "Redakto emrin e organizatës",
    paypal_rest: "PayPal",
    secure_and_pay: "Siguro dhe Paguaj",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Gabim",
  "Payment-method": "Mënyra e pagesës",
  price_plan: {
    trial_period: {
      week: "{{count}} javë",
      week_plural: "{{count}} javë",
      day: "{{count}} ditë",
      day_plural: "{{count}} ditë",
      month: "{{count}} muaj",
      month_plural: "{{count}} muaj",
      year: "{{count}} vit",
      year_plural: "{{count}} vjet"
    },
    interval: {
      month: "muaj",
      month_plural: "{{count}} muaj",
      day: "ditë",
      day_plural: "{{count}} ditë",
      week: "javë",
      week_plural: "{{count}} javë",
      year: "vit",
      year_plural: "{{count}} vjet"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Falas",
        trial_period_new: "{{ trialPeriodPrice }} për {{ trialInterval }} pastaj",
        unlimited_new: "<bold>{{amount}}</bold> çdo {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} herë"
      }
    }
  },
  affiliate_badge: {
    made_with: "E fuqizuar nga"
  },
  form_select: {
    empty_list: "Duket se kjo listë është bosh",
    select: "Zgjidhni"
  },
  contact_slug: {
    email: "Email",
    first_name: "Emri i parë",
    last_name: "Mbiemri",
    phone_number: "Numri i telefonit",
    country: "Shteti",
    street_address: "Adresa e rrugës",
    city: "Qyteti",
    postal_code: "Kodi postar",
    company_name: "Emri i kompanisë",
    tax_number: "Numri i tatimit",
    state_province: "Shteti/Provinca",
    street_number: "Numri i rrugës",
    neighborhood: "Lagja"
  },
  date_picker: {
    apply: "Apliko",
    clear: "Pastro",
    time: "Koha",
    all_time: "Të gjitha kohët",
    last_3_months: "3 muajt e fundit",
    last_pool_period: "Periudha e fundit e vlerësimit të grupit",
    last_month: "Muaji i kaluar",
    this_month: "Ky muaj",
    last_30_days: "30 ditët e fundit",
    title_dates: "Datat",
    from: "Nga",
    to: "Në"
  },
  copy_clipboard: "Kopjuhet në clipboard",
  payment_inputs: {
    empty_card_number: "Shkruani një numër kartelash",
    invalid_card_number: "Numri i kartelës është i pavlefshëm",
    empty_expiry_date: "Shkruani një datë skadimi",
    month_out_of_range: "Muaji i skadimit duhet të jetë midis 01 dhe 12",
    year_out_of_range: "Viti i skadencës nuk mund të jetë në të kaluarën",
    date_out_of_range: "Data e skadencës nuk mund të jetë në të kaluarën",
    invalid_expiry_date: "Data e skadencës është e pavlefshme",
    invalid_cvc: "CVC është i pavlefshëm",
    empty_cvc: "Shkruani një CVC",
    card_number_placeholder: "Numri i kartës",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Emri i mbajtësit të kartës",
    empty_card_holder: "Shkruani emrin e mbajtësit të kartës"
  },
  copy_clipboard_error: "Dështoi të kopjohet teksti",
  input: {
    phone_number: "Numri i telefonit",
    phone_search: "Kërko",
    search: "Kërko"
  },
  "registered-over": "regjistruar mbi",
  locale: {
    french: "Frëngjisht",
    german: "Gjermane",
    italian: "Italisht",
    dutch: "Holandeze",
    english: "Anglisht",
    portuguese: "Portugeze",
    russian: "Rusisht",
    spanish: "Spanjisht",
    japanese: "Japoneze",
    arabic: "Arabisht",
    turkish: "Turk",
    chinese: "Kineze",
    swedish: "Suedeze",
    romanian: "Rumun",
    czech: "çeke",
    hungarian: "Hungareze",
    slovak: "Sllovake",
    danish: "Daneze",
    indonesian: "Indonezisht",
    polish: "Polonisht",
    greek: "Greke",
    serbian: "Serb",
    hindi: "Jo",
    norwegian: "Norvegjeze",
    thai: "Thai",
    slovenian: "Slloven",
    ukrainian: "Ukrainase",
    albania: "Shqiptare"
  },
  product: "Produkt",
  quantity: "Sasia",
  order_summary: "Përmbledhja e Porosisë",
  vat: "Tatimi mbi shitjet",
  total: "Totali",
  subtotal: "Nëntotali",
  shipping: {
    shipping_method: "Metoda e Dërgesës",
    not_available: "Ups! Duket se nuk ofrojmë dërgesa në këtë vend akoma.",
    condition_label: {
      price: "Për porositë me çmim midis {{min}} {{currency}} dhe {{max}} {{currency}}",
      price_min: "Për porositë me çmim {{min}} {{currency}} ose më shumë",
      quantity: "Për porositë që përmbajnë midis {{min}} dhe {{max}} artikuj",
      quantity_min: "Për porositë që përmbajnë {{min}} ose më shumë artikuj",
      weight: "Për porositë me një peshë totale midis {{min}}g dhe {{max}}g",
      weight_min: "Për porositë me një peshë totale prej {{min}}g ose më shumë"
    }
  },
  shipping_fee: "Tarifa e dërgesës",
  total_amount_with_tax_and_shipping: "Totali (duke përfshirë taksën dhe dërgesën)",
  vat_percent: "Tatimi mbi shitjet ({{percent}}%)",
  including_tax: "Duke përfshirë TVSH-në {{percent}}% ({{amount}})",
  total_amount_with_tax: "Totali (përfshirë taksën)",
  total_amount_with_shipping: "Totali (përfshirë Transportin)"
}, gz = {
  public_pages_purchase: Cz
}, yz = {
  "required-field": "Поље је обавезно",
  payment: {
    price_plan: "План",
    stripe_card: "Kreditna ili debitna kartica",
    stripe_ideal: "иДеал (Стрипе)",
    stripe_bancotact: "Банцонтацт (Стрипе)",
    dlocal_card: "Кредитне картице (Длоцал)",
    dlocal_boleto: "Болето (Длоцал)",
    dlocal_pix: "Пик (Длоцал)",
    paypal_soap: "ПаиПал",
    mercadopago_card: "Кредитне картице (Мерцадо Паго)",
    mercadopago_pix: "ПИКС (тржиште плаћања)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Разорпаи",
    flutterwave: "Флуттерваве",
    mollie: "Моллие",
    gocardless: "Гоцардлесс",
    cash_on_delivery: "Плаћање поузећем",
    xendit_card: "Кредитне картице (Ксендит)",
    paystack_card: "Кредитне картице (Паистацк)",
    paypal_connect: "Повежите ПаиПал",
    paypal_edit_organization_name: "Измените назив организације",
    paypal_rest: "ПаиПал",
    secure_and_pay: "Осигурајте и платите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Грешка",
  "Payment-method": "Начин плаћања",
  price_plan: {
    trial_period: {
      week_0: "{{count}} недеља",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      day_0: "{{count}} дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      month_0: "{{count}} месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      year_0: "{{count}} година",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    },
    interval: {
      month_0: "месец",
      month_1: "{{count}} месеци",
      month_2: "{{count}} месеци",
      day_0: "дан",
      day_1: "{{count}} дана",
      day_2: "{{count}} дана",
      week_0: "недељу дана",
      week_1: "{{count}} недеља",
      week_2: "{{count}} недеља",
      year_0: "године",
      year_1: "{{count}} година",
      year_2: "{{count}} година"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Бесплатно",
        trial_period_new: "{{ trialPeriodPrice }} за {{ trialInterval }} онда",
        unlimited_new: "<bold>{{amount}}</bold> сваких {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} пута"
      }
    }
  },
  affiliate_badge: {
    made_with: "Pokreće"
  },
  form_select: {
    empty_list: "Izgleda da je ova lista prazna",
    select: "Izaberi"
  },
  contact_slug: {
    email: "Email",
    first_name: "Ime",
    last_name: "Prezime",
    phone_number: "Broj telefona",
    country: "Zemlja",
    street_address: "Adresa",
    city: "Grad",
    postal_code: "Poštanski broj",
    company_name: "Naziv kompanije",
    tax_number: "Poreski broj",
    state_province: "Država/Provincija",
    street_number: "Broj ulice",
    neighborhood: "Kraj"
  },
  date_picker: {
    apply: "Primeni",
    clear: "Obriši",
    time: "Vreme",
    all_time: "Sve vreme",
    last_3_months: "Poslednja 3 meseca",
    last_pool_period: "Poslednji period evaluacije",
    last_month: "Prošli mesec",
    this_month: "Ovaj mesec",
    last_30_days: "Poslednjih 30 dana",
    title_dates: "Datumi",
    from: "Od",
    to: "Do"
  },
  copy_clipboard: "Kopirano u međuspremnik",
  payment_inputs: {
    empty_card_number: "Unesite broj kartice",
    invalid_card_number: "Broj kartice je nevažeći",
    empty_expiry_date: "Unesite datum isteka",
    month_out_of_range: "Mesec isteka mora biti između 01 i 12",
    year_out_of_range: "Godina isteka ne može biti u prošlosti",
    date_out_of_range: "Datum isteka ne može biti u prošlosti",
    invalid_expiry_date: "Datum isteka je nevažeći",
    invalid_cvc: "CVC je nevažeći",
    empty_cvc: "Unesite CVC",
    card_number_placeholder: "Broj kartice",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Ime vlasnika kartice",
    empty_card_holder: "Unesite ime vlasnika kartice"
  },
  copy_clipboard_error: "Kopiranje teksta nije uspelo",
  input: {
    phone_number: "Broj telefona",
    phone_search: "Pretraži",
    search: "Pretraži"
  },
  "registered-over": "registrovano više od",
  locale: {
    french: "Француски",
    german: "Немачки",
    italian: "Италијан",
    dutch: "холандски",
    english: "енглески језик",
    portuguese: "португалски",
    russian: "Руски",
    spanish: "Шпански",
    japanese: "јапански",
    arabic: "арапски",
    turkish: "турски",
    chinese: "кинески",
    swedish: "Шведски",
    romanian: "румунски",
    czech: "чешки",
    hungarian: "мађарски",
    slovak: "словачки",
    danish: "дански",
    indonesian: "индонезијски",
    polish: "Пољски",
    greek: "грчки",
    serbian: "Српски",
    hindi: "Јок",
    norwegian: "норвешки",
    thai: "тајландски",
    slovenian: "словеначки",
    ukrainian: "украјински",
    albania: "Албанац"
  },
  product: "Proizvod",
  quantity: "Količina",
  order_summary: "Pregled narudžbine",
  vat: "Porez na promet",
  total: "Ukupno",
  subtotal: "Međuzbir",
  shipping: {
    shipping_method: "Metod isporuke",
    not_available: "Ups! Izgleda da još ne nudimo isporuku na ovu lokaciju.",
    condition_label: {
      price: "Za narudžbine u cenovnom rasponu od {{min}} {{currency}} do {{max}} {{currency}}",
      price_min: "Za narudžbine od {{min}} {{currency}} ili više",
      quantity: "Za narudžbine koje sadrže između {{min}} i {{max}} stavki",
      quantity_min: "Za narudžbine koje sadrže {{min}} ili više stavki",
      weight: "Za narudžbine sa ukupnom težinom između {{min}}g i {{max}}g",
      weight_min: "Za narudžbine sa ukupnom težinom od {{min}}g ili više"
    }
  },
  shipping_fee: "Trošak isporuke",
  total_amount_with_tax_and_shipping: "Ukupno (uključujući porez i isporuku)",
  vat_percent: "Porez na promet ({{percent}}%)",
  including_tax: "Uključujući {{percent}}% PDV ({{amount}})",
  total_amount_with_tax: "Ukupno (uključujući porez)",
  total_amount_with_shipping: "Ukupno (uključujući dostavu)"
}, vz = {
  public_pages_purchase: yz
}, bz = {
  "required-field": "Fält är obligatoriskt",
  payment: {
    price_plan: "Planen",
    stripe_card: "Kredit- eller betalkort",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Kreditkort (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kreditkort (Mercado Pago)",
    mercadopago_pix: "PIX (betalningsmarknad)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Fluttervåg",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Postförskott",
    xendit_card: "Kreditkort (Xendit)",
    paystack_card: "Kreditkort (Paystack)",
    paypal_connect: "Anslut PayPal",
    paypal_edit_organization_name: "Redigera organisationens namn",
    paypal_rest: "PayPal",
    secure_and_pay: "Säkra och betala",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Fel",
  "Payment-method": "Betalningsmetod",
  price_plan: {
    trial_period: {
      week: "{{count}} vecka",
      week_plural: "{{count}} veckor",
      day: "{{count}} dag",
      day_plural: "{{count}} dagar",
      month: "{{count}} månad",
      month_plural: "{{count}} månader",
      year: "{{count}} år",
      year_plural: "{{count}} år"
    },
    interval: {
      month: "månad",
      month_plural: "{{count}} månader",
      day: "dag",
      day_plural: "{{count}} dagar",
      week: "vecka",
      week_plural: "{{count}} veckor",
      year: "år",
      year_plural: "{{count}} år"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Gratis",
        trial_period_new: "{{ trialPeriodPrice }} för {{ trialInterval }} sedan",
        unlimited_new: "<bold>{{amount}}</bold> varje {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} gånger"
      }
    }
  },
  affiliate_badge: {
    made_with: "Drivs av"
  },
  form_select: {
    empty_list: "Det verkar som att denna lista är tom",
    select: "Välj"
  },
  contact_slug: {
    email: "E-post",
    first_name: "Förnamn",
    last_name: "Efternamn",
    phone_number: "Telefonnummer",
    country: "Land",
    street_address: "Gatuadress",
    city: "Stad",
    postal_code: "Postnummer",
    company_name: "Företagsnamn",
    tax_number: "Skattenummer",
    state_province: "Stat/Provins",
    street_number: "Gatu nummer",
    neighborhood: "Grannskap"
  },
  date_picker: {
    apply: "Tillämpa",
    clear: "Rensa",
    time: "Tid",
    all_time: "All tid",
    last_3_months: "Senaste 3 månaderna",
    last_pool_period: "Senaste poolutvärderingsperioden",
    last_month: "Senaste månaden",
    this_month: "Denna månad",
    last_30_days: "Senaste 30 dagarna",
    title_dates: "Datum",
    from: "Från",
    to: "Till"
  },
  copy_clipboard: "Kopierad till urklipp",
  payment_inputs: {
    empty_card_number: "Ange ett kortnummer",
    invalid_card_number: "Kortnumret är ogiltigt",
    empty_expiry_date: "Ange ett utgångsdatum",
    month_out_of_range: "Utgångsmånad måste vara mellan 01 och 12",
    year_out_of_range: "Utgångsår kan inte vara i det förflutna",
    date_out_of_range: "Utgångsdatum kan inte vara i det förflutna",
    invalid_expiry_date: "Utgångsdatum är ogiltigt",
    invalid_cvc: "CVC är ogiltigt",
    empty_cvc: "Ange en CVC",
    card_number_placeholder: "Kortnummer",
    expiry_data_placeholder: "MM/ÅÅ",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kortinnehavare",
    empty_card_holder: "Ange ett namn på kortinnehavaren"
  },
  copy_clipboard_error: "Misslyckades med att kopiera text",
  input: {
    phone_number: "Telefonnummer",
    phone_search: "Sök",
    search: "Sök"
  },
  "registered-over": "registrerade över",
  locale: {
    french: "Franska",
    german: "Tysk",
    italian: "Italienska",
    dutch: "Holländska",
    english: "Engelsk",
    portuguese: "Portugisiska",
    russian: "Ryska",
    spanish: "Spanska",
    japanese: "Japanska",
    arabic: "Arabiska",
    turkish: "Turkiska",
    chinese: "Kinesiska",
    swedish: "Svenska",
    romanian: "Rumänska",
    czech: "Tjeckiska",
    hungarian: "Ungerska",
    slovak: "Slovakiska",
    danish: "Danska",
    indonesian: "Indonesiska",
    polish: "Putsa",
    greek: "Grekisk",
    serbian: "Serbiska",
    hindi: "Nej",
    norwegian: "Norska",
    thai: "Thai",
    slovenian: "Slovenska",
    ukrainian: "Ukrainska",
    albania: "Albanska"
  },
  product: "Produkt",
  quantity: "Antal",
  order_summary: "Orderöversikt",
  vat: "Moms",
  total: "Totalt",
  subtotal: "Delsumma",
  shipping: {
    shipping_method: "Fraktmetod",
    not_available: "Oj! Det verkar som om vi inte erbjuder frakt till denna plats än.",
    condition_label: {
      price: "För beställningar prissatta mellan {{min}} {{currency}} och {{max}} {{currency}}",
      price_min: "För beställningar prissatta till {{min}} {{currency}} eller mer",
      quantity: "För beställningar som innehåller mellan {{min}} till {{max}} artiklar",
      quantity_min: "För beställningar som innehåller {{min}} eller fler artiklar",
      weight: "För beställningar med en totalvikt mellan {{min}}g och {{max}}g",
      weight_min: "För beställningar med en totalvikt av {{min}}g eller mer"
    }
  },
  shipping_fee: "Fraktavgift",
  total_amount_with_tax_and_shipping: "Totalt (inklusive skatt och frakt)",
  vat_percent: "Moms ({{percent}}%)",
  including_tax: "Inklusive {{percent}}% moms ({{amount}})",
  total_amount_with_tax: "Totalt (inklusive moms)",
  total_amount_with_shipping: "Totalt (inklusive frakt)"
}, _z = {
  public_pages_purchase: bz
}, wz = {
  "required-field": "จำเป็นต้องกรอกข้อมูล",
  payment: {
    price_plan: "วางแผน",
    stripe_card: "บัตรเครดิตหรือเดบิต",
    stripe_ideal: "ไอดีล (ลายทาง)",
    stripe_bancotact: "แบนคอนแทค (ลายทาง)",
    dlocal_card: "บัตรเครดิต (ดีโลคอล)",
    dlocal_boleto: "โบเลโต (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "เพย์พาล",
    mercadopago_card: "บัตรเครดิต (เมอร์คาโดปาโก)",
    mercadopago_pix: "PIX (ตลาดการชำระเงิน)",
    mercadopago_boleto: "โบเลโต (Mercado Pago)",
    razorpay: "เรเซอร์เพย์",
    flutterwave: "กระพือปีก",
    mollie: "มอลลี่",
    gocardless: "ไร้บัตร",
    cash_on_delivery: "เงินสดในการจัดส่ง",
    xendit_card: "บัตรเครดิต (Xendit)",
    paystack_card: "บัตรเครดิต (เพย์สแต็ค)",
    paypal_connect: "เชื่อมต่อเพย์พาล",
    paypal_edit_organization_name: "แก้ไขชื่อองค์กร",
    paypal_rest: "เพย์พาล",
    secure_and_pay: "ปลอดภัยและชำระเงิน",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "ข้อผิดพลาด",
  "Payment-method": "วิธีการชำระเงิน",
  price_plan: {
    trial_period: {
      week: "{{count}} สัปดาห์",
      day: "{{count}} วัน",
      month: "{{count}} เดือน",
      year: "{{count}} ปี"
    },
    interval: {
      month: "เดือน",
      day: "วัน",
      week: "สัปดาห์",
      year: "ปี"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "ฟรี",
        trial_period_new: "{{ trialPeriodPrice }} สำหรับ {{ trialInterval }} จากนั้น",
        unlimited_new: "<bold>{{amount}}</bold> ทุกๆ {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} ครั้ง"
      }
    }
  },
  affiliate_badge: {
    made_with: "ขับเคลื่อนโดย"
  },
  form_select: {
    empty_list: "ดูเหมือนว่ารายการนี้จะว่างเปล่า",
    select: "เลือก"
  },
  contact_slug: {
    email: "อีเมล",
    first_name: "ชื่อจริง",
    last_name: "นามสกุล",
    phone_number: "หมายเลขโทรศัพท์",
    country: "ประเทศ",
    street_address: "ที่อยู่ถนน",
    city: "เมือง",
    postal_code: "รหัสไปรษณีย์",
    company_name: "ชื่อบริษัท",
    tax_number: "หมายเลขภาษี",
    state_province: "รัฐ/จังหวัด",
    street_number: "หมายเลขถนน",
    neighborhood: "ย่าน"
  },
  date_picker: {
    apply: "สมัคร",
    clear: "ล้าง",
    time: "เวลา",
    all_time: "ทั้งหมด",
    last_3_months: "3 เดือนที่ผ่านมา",
    last_pool_period: "ช่วงเวลาประเมินผลล่าสุด",
    last_month: "เดือนที่แล้ว",
    this_month: "เดือนนี้",
    last_30_days: "30 วันที่ผ่านมา",
    title_dates: "วันที่",
    from: "จาก",
    to: "ถึง"
  },
  copy_clipboard: "คัดลอกไปยังคลิปบอร์ด",
  payment_inputs: {
    empty_card_number: "กรอกหมายเลขบัตร",
    invalid_card_number: "หมายเลขบัตรไม่ถูกต้อง",
    empty_expiry_date: "กรอกวันที่หมดอายุ",
    month_out_of_range: "เดือนหมดอายุต้องอยู่ระหว่าง 01 ถึง 12",
    year_out_of_range: "ปีหมดอายุไม่สามารถอยู่ในอดีตได้",
    date_out_of_range: "วันที่หมดอายุไม่สามารถอยู่ในอดีตได้",
    invalid_expiry_date: "วันที่หมดอายุไม่ถูกต้อง",
    invalid_cvc: "CVC ไม่ถูกต้อง",
    empty_cvc: "กรุณาใส่ CVC",
    card_number_placeholder: "หมายเลขบัตร",
    expiry_data_placeholder: "MM/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "ชื่อผู้ถือบัตร",
    empty_card_holder: "กรุณาใส่ชื่อผู้ถือบัตร"
  },
  copy_clipboard_error: "ไม่สามารถคัดลอกข้อความได้",
  input: {
    phone_number: "หมายเลขโทรศัพท์",
    phone_search: "ค้นหา",
    search: "ค้นหา"
  },
  "registered-over": "ลงทะเบียนมากกว่า",
  locale: {
    french: "ภาษาฝรั่งเศส",
    german: "เยอรมัน",
    italian: "ภาษาอิตาลี",
    dutch: "ภาษาดัตช์",
    english: "ภาษาอังกฤษ",
    portuguese: "โปรตุเกส",
    russian: "ภาษารัสเซีย",
    spanish: "สเปน",
    japanese: "ญี่ปุ่น",
    arabic: "ภาษาอาหรับ",
    turkish: "ภาษาตุรกี",
    chinese: "ชาวจีน",
    swedish: "ภาษาสวีเดน",
    romanian: "โรมาเนีย",
    czech: "เช็ก",
    hungarian: "ภาษาฮังการี",
    slovak: "สโลวัก",
    danish: "ภาษาเดนมาร์ก",
    indonesian: "ชาวอินโดนีเซีย",
    polish: "ขัด",
    greek: "กรีก",
    serbian: "เซอร์เบีย",
    hindi: "ไม่",
    norwegian: "ภาษานอร์เวย์",
    thai: "แบบไทย",
    slovenian: "ภาษาสโลเวเนีย",
    ukrainian: "ภาษายูเครน",
    albania: "แอลเบเนีย"
  },
  product: "ผลิตภัณฑ์",
  quantity: "จำนวน",
  order_summary: "สรุปคำสั่งซื้อ",
  vat: "ภาษีขาย",
  total: "รวม",
  subtotal: "ยอดรวมย่อย",
  shipping: {
    shipping_method: "วิธีการจัดส่ง",
    not_available: "อุ๊บส์! ดูเหมือนว่าเรายังไม่สามารถจัดส่งไปยังสถานที่นี้ได้",
    condition_label: {
      price: "สำหรับคำสั่งซื้อที่มีราคาอยู่ระหว่าง {{min}} {{currency}} ถึง {{max}} {{currency}}",
      price_min: "สำหรับคำสั่งซื้อที่มีราคา {{min}} {{currency}} ขึ้นไป",
      quantity: "สำหรับคำสั่งซื้อที่มีจำนวนระหว่าง {{min}} ถึง {{max}} รายการ",
      quantity_min: "สำหรับคำสั่งซื้อที่มีจำนวน {{min}} รายการขึ้นไป",
      weight: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวมระหว่าง {{min}}g ถึง {{max}}g",
      weight_min: "สำหรับคำสั่งซื้อที่มีน้ำหนักรวม {{min}}g ขึ้นไป"
    }
  },
  shipping_fee: "ค่าจัดส่ง",
  total_amount_with_tax_and_shipping: "รวม (รวมภาษีและค่าจัดส่ง)",
  vat_percent: "ภาษีขาย ({{percent}}%)",
  including_tax: "รวมภาษีมูลค่าเพิ่ม {{percent}}% ({{amount}})",
  total_amount_with_tax: "รวมทั้งภาษีแล้ว",
  total_amount_with_shipping: "รวมค่าส่งแล้ว"
}, xz = {
  public_pages_purchase: wz
}, Sz = {
  "required-field": "Alan gereklidir",
  payment: {
    price_plan: "Plan",
    stripe_card: "Kredi veya banka kartı",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "İletişimi yasakla (Stripe)",
    dlocal_card: "Kredi kartları (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Kredi kartları (Mercado Pago)",
    mercadopago_pix: "PIX (Mercado Pago)",
    mercadopago_boleto: "Boleto (Mercado Pago)",
    razorpay: "Razorpay",
    flutterwave: "Çarpıntı dalgası",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "Kapıda ödeme",
    xendit_card: "Kredi kartları (Xendit)",
    paystack_card: "Kredi kartları (Paystack)",
    paypal_connect: "PayPal'ı bağlayın",
    paypal_edit_organization_name: "Kuruluş adını düzenleyin",
    paypal_rest: "PayPal",
    secure_and_pay: "Güvenli ve Ödemeli",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Güvenlik"
    }
  },
  error: "Hata",
  "Payment-method": "Ödeme yöntemi",
  price_plan: {
    trial_period: {
      week: "{{count}} hafta",
      week_plural: "{{count}} hafta",
      day: "{{count}} gün",
      day_plural: "{{count}} gün",
      month: "{{count}} ay",
      month_plural: "{{count}} ay",
      year: "{{count}} yıl",
      year_plural: "{{count}} yıl"
    },
    interval: {
      month: "ay",
      month_plural: "{{count}} ay",
      day: "gün",
      day_plural: "{{count}} gün",
      week: "hafta",
      week_plural: "{{count}} hafta",
      year: "yıl",
      year_plural: "{{count}} yıl"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "Ücretsiz",
        trial_period_new: "{{ trialInterval }} için {{ trialPeriodPrice }} sonra",
        unlimited_new: "<bold>{{amount}}</bold> her {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} kez"
      }
    }
  },
  affiliate_badge: {
    made_with: "Tarafından desteklenmektedir"
  },
  form_select: {
    empty_list: "Bu liste boş gibi görünüyor",
    select: "Seçin"
  },
  contact_slug: {
    email: "E-posta",
    first_name: "İsim",
    last_name: "Soyisim",
    phone_number: "Telefon numarası",
    country: "Ülke",
    street_address: "Sokak adresi",
    city: "Şehir",
    postal_code: "Posta kodu",
    company_name: "Şirket adı",
    tax_number: "Vergi numarası",
    state_province: "Eyalet/İl",
    street_number: "Sokak numarası",
    neighborhood: "Mahalle"
  },
  date_picker: {
    apply: "Uygula",
    clear: "Temizle",
    time: "Zaman",
    all_time: "Tüm zamanlar",
    last_3_months: "Son 3 ay",
    last_pool_period: "Son havuz değerlendirme dönemi",
    last_month: "Geçen Ay",
    this_month: "Bu Ay",
    last_30_days: "Son 30 gün",
    title_dates: "Tarihler",
    from: "Tarihinden itibaren",
    to: "Tarihine kadar"
  },
  copy_clipboard: "Panoya kopyalandı",
  payment_inputs: {
    empty_card_number: "Bir kart numarası girin",
    invalid_card_number: "Kart numarası geçersiz",
    empty_expiry_date: "Bir son kullanma tarihi girin",
    month_out_of_range: "Son kullanma ayı 01 ile 12 arasında olmalıdır",
    year_out_of_range: "Son kullanma yılı geçmiş tarihte olamaz",
    date_out_of_range: "Son kullanma tarihi geçmiş tarih olamaz",
    invalid_expiry_date: "Son kullanma tarihi geçersiz",
    invalid_cvc: "CVC geçersiz",
    empty_cvc: "CVC girin",
    card_number_placeholder: "Kart numarası",
    expiry_data_placeholder: "AA/YY",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Kart sahibi",
    empty_card_holder: "Bir kart sahibi adı girin"
  },
  copy_clipboard_error: "Metin kopyalanamadı",
  input: {
    phone_number: "Telefon numarası",
    phone_search: "Ara",
    search: "Ara"
  },
  "registered-over": "kaydedilen",
  locale: {
    french: "Fransızca",
    german: "Almanca",
    italian: "İtalyan",
    dutch: "Flemenkçe",
    english: "İngilizce",
    portuguese: "Portekizce",
    russian: "Rusça",
    spanish: "İspanyol",
    japanese: "Japonca",
    arabic: "Arap",
    turkish: "Türkçe",
    chinese: "Çince",
    swedish: "İsveççe",
    romanian: "Romen",
    czech: "Çek",
    hungarian: "Macarca",
    slovak: "Slovak",
    danish: "Danimarka",
    indonesian: "Endonezya dili",
    polish: "Lehçe",
    greek: "Yunan",
    serbian: "Sırpça",
    hindi: "Hintçe",
    norwegian: "Norveççe",
    thai: "Tay dili",
    slovenian: "Slovence",
    ukrainian: "Ukrayna",
    albania: "Arnavut"
  },
  product: "Ürün",
  quantity: "Miktar",
  order_summary: "Sipariş Özeti",
  vat: "Satış vergisi",
  total: "Toplam",
  subtotal: "Ara Toplam",
  shipping: {
    shipping_method: "Gönderim Yöntemi",
    not_available: "Aman! Görünüşe göre bu konuma henüz gönderim yapmıyoruz.",
    condition_label: {
      price: "{{min}} {{currency}} ile {{max}} {{currency}} arasında fiyatlandırılan siparişler için",
      price_min: "{{min}} {{currency}} veya daha fazla fiyatlandırılan siparişler için",
      quantity: "{{min}} ile {{max}} ürün içeren siparişler için",
      quantity_min: "{{min}} veya daha fazla ürün içeren siparişler için",
      weight: "Toplam ağırlığı {{min}}g ile {{max}}g arasında olan siparişler için",
      weight_min: "Toplam ağırlığı {{min}}g veya daha fazla olan siparişler için"
    }
  },
  shipping_fee: "Gönderim ücreti",
  total_amount_with_tax_and_shipping: "Toplam (vergi ve gönderim dahil)",
  vat_percent: "Satış vergisi ({{percent}}%)",
  including_tax: "KDV dahil {{percent}}% ({{amount}})",
  total_amount_with_tax: "Toplam (vergiler dahil)",
  total_amount_with_shipping: "Toplam (kargo dahil)"
}, kz = {
  public_pages_purchase: Sz
}, Mz = {
  "required-field": "Поле обов'язкове",
  payment: {
    price_plan: "План",
    stripe_card: "Кредитна або дебетова карта",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "Кредитні картки (Dlocal)",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Пікс (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "Кредитні картки (Mercado Pago)",
    mercadopago_pix: "PIX (платіжний ринок)",
    mercadopago_boleto: "Болето (Меркадо Паго)",
    razorpay: "Razorpay",
    flutterwave: "Флаттервейв",
    mollie: "Моллі",
    gocardless: "Gocardless",
    cash_on_delivery: "Накладений платіж",
    xendit_card: "Кредитні картки (Xendit)",
    paystack_card: "Кредитні картки (Paystack)",
    paypal_connect: "Підключіть PayPal",
    paypal_edit_organization_name: "Редагувати назву організації",
    paypal_rest: "PayPal",
    secure_and_pay: "Захистіть і заплатите",
    stripe_applepay: "Apple Pay",
    xendit: {
      "3ds": "3D-Secure"
    }
  },
  error: "Помилка",
  "Payment-method": "Спосіб оплати",
  price_plan: {
    trial_period: {
      week_0: "{{count}} тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      day_0: "{{count}} день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      month_0: "{{count}} місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      year_0: "{{count}} рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    },
    interval: {
      month_0: "місяць",
      month_1: "{{count}} місяців",
      month_2: "{{count}} місяців",
      day_0: "день",
      day_1: "{{count}} днів",
      day_2: "{{count}} днів",
      week_0: "тиждень",
      week_1: "{{count}} тижнів",
      week_2: "{{count}} тижнів",
      year_0: "рік",
      year_1: "{{count}} років",
      year_2: "{{count}} років"
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "безкоштовно",
        trial_period_new: "Тоді {{ trialPeriodPrice }} за {{ trialInterval }} ",
        unlimited_new: "<bold>{{amount}}</bold> кожні {{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} разів"
      }
    }
  },
  affiliate_badge: {
    made_with: "Підтримується"
  },
  form_select: {
    empty_list: "Схоже, що цей список порожній",
    select: "Вибрати"
  },
  contact_slug: {
    email: "Електронна пошта",
    first_name: "Ім'я",
    last_name: "Прізвище",
    phone_number: "Номер телефону",
    country: "Країна",
    street_address: "Вулиця",
    city: "Місто",
    postal_code: "Поштовий індекс",
    company_name: "Назва компанії",
    tax_number: "Податковий номер",
    state_province: "Штат/Область",
    street_number: "Номер вулиці",
    neighborhood: "Район"
  },
  date_picker: {
    apply: "Застосувати",
    clear: "Очистити",
    time: "Час",
    all_time: "Весь час",
    last_3_months: "Останні 3 місяці",
    last_pool_period: "Останній період оцінки пулу",
    last_month: "Останній місяць",
    this_month: "Цей місяць",
    last_30_days: "Останні 30 днів",
    title_dates: "Дати",
    from: "З",
    to: "До"
  },
  copy_clipboard: "Скопійовано в буфер обміну",
  payment_inputs: {
    empty_card_number: "Введіть номер картки",
    invalid_card_number: "Номер картки недійсний",
    empty_expiry_date: "Введіть дату закінчення терміну дії",
    month_out_of_range: "Місяць закінчення терміну дії має бути між 01 і 12",
    year_out_of_range: "Рік закінчення не може бути в минулому",
    date_out_of_range: "Дата закінчення не може бути в минулому",
    invalid_expiry_date: "Дата закінчення недійсна",
    invalid_cvc: "CVC недійсний",
    empty_cvc: "Введіть CVC",
    card_number_placeholder: "Номер картки",
    expiry_data_placeholder: "ММ/РР",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "Власник картки",
    empty_card_holder: "Введіть ім'я власника картки"
  },
  copy_clipboard_error: "Не вдалося скопіювати текст",
  input: {
    phone_number: "Номер телефону",
    phone_search: "Пошук",
    search: "Пошук"
  },
  "registered-over": "зареєстровано понад",
  locale: {
    french: "французька",
    german: "Німецький",
    italian: "італійська",
    dutch: "голландська",
    english: "англійська",
    portuguese: "португальська",
    russian: "російський",
    spanish: "Іспанська",
    japanese: "Японський",
    arabic: "арабська",
    turkish: "турецька",
    chinese: "китайський",
    swedish: "шведська",
    romanian: "румунська",
    czech: "чеська",
    hungarian: "угорська",
    slovak: "словацький",
    danish: "датська",
    indonesian: "індонезійська",
    polish: "польський",
    greek: "грецька",
    serbian: "сербська",
    hindi: "ні",
    norwegian: "норвезька",
    thai: "тайська",
    slovenian: "словенська",
    ukrainian: "Українська",
    albania: "албанець"
  },
  product: "Продукт",
  quantity: "Кількість",
  order_summary: "Підсумок замовлення",
  vat: "Податок на продаж",
  total: "Всього",
  subtotal: "Проміжний підсумок",
  shipping: {
    shipping_method: "Спосіб доставки",
    not_available: "Упс! Схоже, що ми ще не пропонуємо доставку в це місце.",
    condition_label: {
      price: "Для замовлень вартістю від {{min}} {{currency}} до {{max}} {{currency}}",
      price_min: "Для замовлень вартістю від {{min}} {{currency}} або більше",
      quantity: "Для замовлень, що містять від {{min}} до {{max}} товарів",
      quantity_min: "Для замовлень, що містять {{min}} або більше товарів",
      weight: "Для замовлень з загальною вагою від {{min}}g до {{max}}g",
      weight_min: "Для замовлень з загальною вагою {{min}}g або більше"
    }
  },
  shipping_fee: "Вартість доставки",
  total_amount_with_tax_and_shipping: "Всього (включаючи податок і доставку)",
  vat_percent: "Податок з продажу ({{percent}}%)",
  including_tax: "З урахуванням ПДВ {{percent}}% ({{amount}})",
  total_amount_with_tax: "Загалом (з урахуванням податку)",
  total_amount_with_shipping: "Загалом (з урахуванням доставки)"
}, Pz = {
  public_pages_purchase: Mz
}, Ez = {
  "required-field": "字段为必填项",
  payment: {
    price_plan: "计划",
    stripe_card: "信用卡或借记卡",
    stripe_ideal: "iDeal (Stripe)",
    stripe_bancotact: "Bancontact (Stripe)",
    dlocal_card: "信用卡（Dlocal）",
    dlocal_boleto: "Boleto (Dlocal)",
    dlocal_pix: "Pix (Dlocal)",
    paypal_soap: "PayPal",
    mercadopago_card: "信用卡（Mercado Pago）",
    mercadopago_pix: "PIX（Mercado Pago）",
    mercadopago_boleto: "Boleto（Mercado Pago）",
    razorpay: "Razorpay",
    flutterwave: "Flutterwave",
    mollie: "Mollie",
    gocardless: "Gocardless",
    cash_on_delivery: "货到付款",
    xendit_card: "信用卡 (Xendit)",
    paystack_card: "信用卡（Paystack）",
    paypal_connect: "连接 PayPal",
    paypal_edit_organization_name: "编辑组织名称",
    paypal_rest: "PayPal",
    secure_and_pay: "安全与支付",
    stripe_applepay: "苹果支付",
    xendit: {
      "3ds": "3D-安全"
    }
  },
  error: "错误",
  "Payment-method": "付款方式",
  price_plan: {
    trial_period: {
      week: `周

{{count}} 周`,
      day: `{{count}} 天

{{count}} 天`,
      month: `{{count}} 月

{{count}} 月`,
      year: `{{count}}年

{{count}}年`
    },
    interval: {
      month: `月

{{count}} 月`,
      day: `天

{{count}} 天`,
      week: `周

{{count}}周`,
      year: `年

{{count}}年`
    }
  },
  components: {
    offer_price: {
      price_plans: {
        trial_period_price: "免费",
        trial_period_new: "{{ trialInterval }} {{ trialPeriodPrice }} 然后",
        unlimited_new: "<bold>{{amount}}</bold>每个{{interval}}",
        limited_with_limit_of_payments: "{{ amount }} / {{ interval }} - {{ count }} 次"
      }
    }
  },
  affiliate_badge: {
    made_with: "技术支持"
  },
  form_select: {
    empty_list: "看起来这个列表是空的",
    select: "选择"
  },
  contact_slug: {
    email: "电子邮件",
    first_name: "名字",
    last_name: "姓氏",
    phone_number: "电话号码",
    country: "国家",
    street_address: "街道地址",
    city: "城市",
    postal_code: "邮政编码",
    company_name: "公司名称",
    tax_number: "税号",
    state_province: "州/省",
    street_number: "街道号码",
    neighborhood: "街道邻里"
  },
  date_picker: {
    apply: "应用",
    clear: "清除",
    time: "时间",
    all_time: "所有的时间",
    last_3_months: "过去3个月",
    last_pool_period: "最后一个池评估期",
    last_month: "次月",
    this_month: "这个月",
    last_30_days: "过去30天",
    title_dates: "日期",
    from: "从",
    to: "到"
  },
  copy_clipboard: "已复制到剪贴板",
  payment_inputs: {
    empty_card_number: "输入卡号",
    invalid_card_number: "卡号无效",
    empty_expiry_date: "输入到期日期",
    month_out_of_range: "到期月份必须在01到12之间",
    year_out_of_range: "到期年不能是过去的年份",
    date_out_of_range: "过期日期不能是过去时间",
    invalid_expiry_date: "过期日期无效",
    invalid_cvc: "CVC无效",
    empty_cvc: "输入CVC",
    card_number_placeholder: "卡号",
    expiry_data_placeholder: "月/年",
    cvc_placeholder: "CVC",
    card_holder_placeholder: "持卡人",
    empty_card_holder: "输入持卡人姓名"
  },
  copy_clipboard_error: "复制文本失败",
  input: {
    phone_number: "电话号码",
    phone_search: "搜索",
    search: "搜索"
  },
  "registered-over": "注册超过",
  locale: {
    french: "法语",
    german: "德语",
    italian: "意大利语",
    dutch: "荷兰语",
    english: "英语",
    portuguese: "葡萄牙语",
    russian: "俄语",
    spanish: "西班牙语",
    japanese: "日语",
    arabic: "阿拉伯语",
    turkish: "土耳其语",
    chinese: "中國人",
    swedish: "瑞典语",
    romanian: "罗马尼亚语",
    czech: "捷克语",
    hungarian: "匈牙利语",
    slovak: "斯洛伐克语",
    danish: "丹麦语",
    indonesian: "印度尼西亚语",
    polish: "波兰语",
    greek: "希腊语",
    serbian: "塞尔维亚语",
    hindi: "印地语",
    norwegian: "挪威语",
    thai: "泰语",
    slovenian: "斯洛文尼亚语",
    ukrainian: "乌克兰语",
    albania: "阿尔巴尼亚语"
  },
  product: "产品",
  quantity: "数量",
  order_summary: "订单摘要",
  vat: "销售税",
  total: "总计",
  subtotal: "小计",
  shipping: {
    shipping_method: "运输方式",
    not_available: "哎呀！看起来我们还不提供该地点的运输服务。",
    condition_label: {
      price: "对于价格在 {{min}} {{currency}} 到 {{max}} {{currency}} 之间的订单",
      price_min: "对于价格在 {{min}} {{currency}} 或以上的订单",
      quantity: "对于包含 {{min}} 到 {{max}} 件商品的订单",
      quantity_min: "对于包含 {{min}} 件或更多商品的订单",
      weight: "对于总重量在 {{min}}g 到 {{max}}g 之间的订单",
      weight_min: "对于总重量在 {{min}}g 或以上的订单"
    }
  },
  shipping_fee: "运费",
  total_amount_with_tax_and_shipping: "总计（包括税费和运费）",
  vat_percent: "销售税 ({{percent}}%)",
  including_tax: "含{{percent}}%增值税（{{amount}}）",
  total_amount_with_tax: "总计（含税）",
  total_amount_with_shipping: "总计（含运费）"
}, Tz = {
  public_pages_purchase: Ez
}, Kd = ["common"], Lz = Object.values(Tr), Xy = {
  ar: { common: TB },
  cs: { common: AB },
  da: { common: NB },
  de: { common: RB },
  el: { common: IB },
  en: { common: FB },
  es: { common: BB },
  fr: { common: GB },
  hi: { common: ZB },
  hu: { common: $B },
  id: { common: YB },
  it: { common: JB },
  ja: { common: QB },
  nl: { common: tz },
  no: { common: nz },
  pl: { common: iz },
  pt: { common: sz },
  ro: { common: cz },
  ru: { common: dz },
  sk: { common: hz },
  sl: { common: fz },
  sq: { common: gz },
  sr: { common: vz },
  sv: { common: _z },
  th: { common: xz },
  tr: { common: kz },
  uk: { common: Pz },
  zh: { common: Tz }
}, Qy = {
  supportedLngs: Lz,
  load: "languageOnly",
  debug: !1,
  defaultNS: Kd[0],
  react: { useSuspense: !1 },
  ns: Kd,
  compatibilityJSON: "v3",
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  }
};
k1.isInitialized || k1.use(hB).init({ ...Qy, resources: Xy });
const Az = (e) => {
  const t = C9(e);
  return k1.cloneInstance({
    ...Qy,
    lng: t,
    resources: Xy
  });
}, dne = ({
  locale: e,
  children: t
}) => /* @__PURE__ */ x.jsx(PB, { i18n: Az(e), children: t }), Oz = (e) => {
  const t = (n) => e((r) => ({ ...r, mercadoPago: { ...r.mercadoPago, ...n } }));
  return {
    initialized: !1,
    setInitialized: (n) => t({ initialized: n })
  };
}, $d = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (c, u) => {
    const d = typeof c == "function" ? c(t) : c;
    if (!Object.is(d, t)) {
      const p = t;
      t = u ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), n.forEach((h) => h(t, p));
    }
  }, a = () => t, s = { setState: r, getState: a, getInitialState: () => l, subscribe: (c) => (n.add(c), () => n.delete(c)) }, l = t = e(r, a, s);
  return s;
}, Nz = (e) => e ? $d(e) : $d, jz = (e) => e;
function Rz(e, t = jz) {
  const n = M.useSyncExternalStore(
    e.subscribe,
    () => t(e.getState()),
    () => t(e.getInitialState())
  );
  return M.useDebugValue(n), n;
}
const Wd = (e) => {
  const t = Nz(e), n = (r) => Rz(t, r);
  return Object.assign(n, t), n;
}, Dz = (e) => e ? Wd(e) : Wd;
var Yd = { BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
const nl = /* @__PURE__ */ new Map(), V9 = (e) => {
  const t = nl.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([n, r]) => [n, r.getState()])
  ) : {};
}, Iz = (e, t, n) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(n)
    };
  const r = nl.get(n.name);
  if (r)
    return { type: "tracked", store: e, ...r };
  const a = {
    connection: t.connect(n),
    stores: {}
  };
  return nl.set(n.name, a), { type: "tracked", store: e, ...a };
}, Hz = (e, t = {}) => (n, r, a) => {
  const { enabled: i, anonymousActionType: o, store: s, ...l } = t;
  let c;
  try {
    c = (i ?? (Yd ? "production" : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!c)
    return e(n, r, a);
  const { connection: u, ...d } = Iz(s, c, l);
  let p = !0;
  a.setState = (f, C, _) => {
    const v = n(f, C);
    if (!p)
      return v;
    const w = _ === void 0 ? { type: o || "anonymous" } : typeof _ == "string" ? { type: _ } : _;
    return s === void 0 ? (u == null || u.send(w, r()), v) : (u == null || u.send(
      {
        ...w,
        type: `${s}/${w.type}`
      },
      {
        ...V9(l.name),
        [s]: a.getState()
      }
    ), v);
  };
  const h = (...f) => {
    const C = p;
    p = !1, n(...f), p = C;
  }, m = e(a.setState, r, a);
  if (d.type === "untracked" ? u == null || u.init(m) : (d.stores[d.store] = a, u == null || u.init(
    Object.fromEntries(
      Object.entries(d.stores).map(([f, C]) => [
        f,
        f === d.store ? m : C.getState()
      ])
    )
  )), a.dispatchFromDevtools && typeof a.dispatch == "function") {
    let f = !1;
    const C = a.dispatch;
    a.dispatch = (..._) => {
      (Yd ? "production" : void 0) !== "production" && _[0].type === "__setState" && !f && (console.warn(
        '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
      ), f = !0), C(..._);
    };
  }
  return u.subscribe((f) => {
    var C;
    switch (f.type) {
      case "ACTION":
        if (typeof f.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return T7(
          f.payload,
          (_) => {
            if (_.type === "__setState") {
              if (s === void 0) {
                h(_.state);
                return;
              }
              Object.keys(_.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const v = _.state[s];
              if (v == null)
                return;
              JSON.stringify(a.getState()) !== JSON.stringify(v) && h(v);
              return;
            }
            a.dispatchFromDevtools && typeof a.dispatch == "function" && a.dispatch(_);
          }
        );
      case "DISPATCH":
        switch (f.payload.type) {
          case "RESET":
            return h(m), s === void 0 ? u == null ? void 0 : u.init(a.getState()) : u == null ? void 0 : u.init(V9(l.name));
          case "COMMIT":
            if (s === void 0) {
              u == null || u.init(a.getState());
              return;
            }
            return u == null ? void 0 : u.init(V9(l.name));
          case "ROLLBACK":
            return T7(f.state, (_) => {
              if (s === void 0) {
                h(_), u == null || u.init(a.getState());
                return;
              }
              h(_[s]), u == null || u.init(V9(l.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return T7(f.state, (_) => {
              if (s === void 0) {
                h(_);
                return;
              }
              JSON.stringify(a.getState()) !== JSON.stringify(_[s]) && h(_[s]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: _ } = f.payload, v = (C = _.computedStates.slice(-1)[0]) == null ? void 0 : C.state;
            if (!v)
              return;
            h(s === void 0 ? v : v[s]), u == null || u.send(
              null,
              // FIXME no-any
              _
            );
            return;
          }
          case "PAUSE_RECORDING":
            return p = !p;
        }
        return;
    }
  }), m;
}, Fz = Hz, T7 = (e, t) => {
  let n;
  try {
    n = JSON.parse(e);
  } catch (r) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      r
    );
  }
  n !== void 0 && t(n);
}, Vz = (e) => {
  const t = (n) => e((r) => ({ ...r, xendit: { ...r.xendit, ...n } }));
  return {
    cardHolderName: "",
    setCardHolderName: (n) => t({ cardHolderName: n }),
    cardNumber: "",
    setCardNumber: (n) => t({ cardNumber: n }),
    expiryMonth: "",
    setExpiryMonth: (n) => t({ expiryMonth: n }),
    expiryYear: "",
    setExpiryYear: (n) => t({ expiryYear: n }),
    cvc: "",
    setCvc: (n) => t({ cvc: n }),
    formInvalid: !0,
    setFormInvalid: (n) => t({ formInvalid: n })
  };
}, Bz = (e, t, n, r) => {
  const a = {
    locale: Ct.ENGLISH
  };
  return {
    locale: (r == null ? void 0 : r.locale) ?? a.locale,
    setLocale: (i) => e({ locale: i })
  };
}, zz = (e, t, n, r) => {
  const a = {
    offerId: void 0,
    productId: void 0,
    paymentMethod: void 0,
    availablePaymentMethods: [],
    currency: void 0,
    pricePlan: void 0,
    finalAmount: void 0,
    contactFields: {}
  }, i = (o) => e((s) => ({ ...s, offer: { ...s.offer, ...o } }));
  return {
    offerId: (r == null ? void 0 : r.offerId) ?? a.offerId,
    setOfferId: (o) => i({ offerId: o }),
    productId: (r == null ? void 0 : r.productId) ?? a.productId,
    setProductId: (o) => i({ productId: o }),
    paymentMethod: (r == null ? void 0 : r.paymentMethod) ?? a.paymentMethod,
    setPaymentMethod: (o) => i({ paymentMethod: o }),
    availablePaymentMethods: (r == null ? void 0 : r.availablePaymentMethods) ?? a.availablePaymentMethods,
    setAvailablePaymentMethods: (o) => i({ availablePaymentMethods: o }),
    currency: (r == null ? void 0 : r.currency) ?? a.currency,
    setCurrency: (o) => i({ currency: o }),
    pricePlan: (r == null ? void 0 : r.pricePlan) ?? a.pricePlan,
    setPricePlan: (o) => i({ pricePlan: o }),
    finalAmount: (r == null ? void 0 : r.finalAmount) ?? a.finalAmount,
    setFinalAmount: (o) => i({ finalAmount: o }),
    contactFields: (r == null ? void 0 : r.contactFields) ?? a.contactFields,
    setContactFields: (o) => i({ contactFields: o })
  };
}, Gz = (e, t, n, r) => {
  const a = {
    quantity: 1,
    selectedShipping: null,
    productVariant: null
  }, i = (o) => e((s) => ({
    ...s,
    physicalProduct: { ...s.physicalProduct, ...o }
  }));
  return {
    quantity: (r == null ? void 0 : r.quantity) ?? a.quantity,
    setQuantity: (o) => i({ quantity: o }),
    selectedShipping: (r == null ? void 0 : r.selectedShipping) ?? a.selectedShipping,
    setSelectedShipping: (o) => i({ selectedShipping: o }),
    productVariant: (r == null ? void 0 : r.productVariant) ?? a.productVariant,
    setProductVariant: (o) => i({ productVariant: o })
  };
}, Uz = (e, t, n, r) => {
  const a = {
    stripeAccountId: void 0,
    mercadoPublicKey: null,
    xenditPublicKey: null
  }, i = (o) => e((s) => ({ ...s, publicKeys: { ...s.publicKeys, ...o } }));
  return {
    stripeAccountId: (r == null ? void 0 : r.stripeAccountId) ?? a.stripeAccountId,
    mercadoPublicKey: (r == null ? void 0 : r.mercadoPublicKey) ?? a.mercadoPublicKey,
    xenditPublicKey: (r == null ? void 0 : r.xenditPublicKey) ?? a.xenditPublicKey,
    setStripeAccountId: (o) => i({ stripeAccountId: o }),
    setMercadoPublicKey: (o) => i({ mercadoPublicKey: o }),
    setXenditPublicKey: (o) => i({ xenditPublicKey: o })
  };
}, Zz = (e) => {
  const t = (n) => e((r) => ({ ...r, visitorInfo: { ...r.visitorInfo, ...n } }));
  return {
    visitorInfo: null,
    setVisitorInfo: (n) => t({ visitorInfo: n })
  };
}, ev = (e) => Dz()(
  Fz((t, n, r) => {
    const a = Bz(t, n, r, e == null ? void 0 : e.base), i = zz(t, n, r, e == null ? void 0 : e.offer), o = Zz(t), s = Uz(t, n, r, e == null ? void 0 : e.publicKeys), l = Gz(
      t,
      n,
      r,
      e == null ? void 0 : e.physicalProduct
    );
    return {
      ...a,
      offer: i,
      publicKeys: s,
      xendit: Vz(t),
      physicalProduct: l,
      visitorInfo: o,
      mercadoPago: Oz(t)
    };
  })
);
let L7 = null;
const Kz = (e) => (L7 || (L7 = ev(e)), L7), tv = Qe(null), $z = () => Ue(tv) ?? Kz(), Rt = () => $z()(), Dr = () => {
  const { offer: e } = Rt();
  return e;
}, Wz = () => {
  const { publicKeys: e } = Rt();
  return e;
}, rv = () => {
  const { xendit: e } = Rt();
  return e;
}, nv = () => {
  const { visitorInfo: e } = Rt();
  return e;
}, b9 = () => {
  const { physicalProduct: e } = Rt();
  return e;
}, av = () => {
  const { mercadoPago: e } = Rt();
  return e;
};
function pne({ children: e, initProps: t }) {
  const n = M.useMemo(() => ev(t), [t]), r = typeof e == "function" ? e({ store: n }) : e;
  return M.createElement(tv.Provider, { value: n }, r);
}
var Yz = Object.defineProperty, qz = (e, t, n) => t in e ? Yz(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, C8 = (e, t, n) => (qz(e, typeof t != "symbol" ? t + "" : t, n), n);
let Jz = class extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}, j3 = class extends Error {
  constructor(t) {
    super(t.detail), C8(this, "errors"), this.errors = t, this.violationsTitleToMessage();
  }
  // TODO: delete this method after BE decide what to use title or message
  violationsTitleToMessage() {
    var t;
    (t = this.errors.violations) == null || t.forEach((n) => {
      "title" in n && (n.message = n.title, delete n.title);
    });
  }
}, iv = class extends Error {
  constructor(t) {
    var n;
    super((n = t.errors.common) == null ? void 0 : n.join("")), C8(this, "errors"), this.errors = t.errors;
  }
  toErrorWithViolations({
    type: t,
    status: n,
    title: r,
    code: a
  }) {
    return new j3({
      type: t,
      status: n,
      title: r,
      detail: this.message,
      violations: this.flattenObjectToViolations(this.errors.fields, a, "")
    });
  }
  flattenObjectToViolations(t, n, r = "") {
    const a = [];
    return typeof t == "string" ? (a.push({ propertyPath: r, message: t, code: n }), a) : (Array.isArray(t) ? t.length === 1 ? a.push({ propertyPath: r, message: t[0], code: n }) : t.forEach((i, o) => {
      const s = `${r}[${o}]`;
      a.push(...this.flattenObjectToViolations(i, n, s));
    }) : t !== null && typeof t == "object" && Object.entries(t).forEach(([i, o]) => {
      const s = r ? `${r}.${i}` : i;
      a.push(...this.flattenObjectToViolations(o, n, s));
    }), a);
  }
};
class xn extends iv {
  toErrorWithViolations() {
    return super.toErrorWithViolations({
      type: "",
      status: c5.code,
      title: "",
      code: c5.code
    });
  }
}
let c5 = class extends j3 {
};
C8(c5, "code", 422);
class Xz extends iv {
}
class Qz extends Error {
  constructor(t) {
    super(t), this.name = this.constructor.name;
  }
}
class eG extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
const tG = [
  "Invalid JWT Token",
  "JWT Token not found",
  "Expired JWT Token"
];
class rG extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}
let nG = class extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
}, qd = class extends Error {
  constructor(t) {
    super(t == null ? void 0 : t.error.message), this.name = this.constructor.name;
  }
  static isNotFoundResponse(t) {
    return !(!t || typeof t != "object" || !("error" in t) || !t.error || typeof t.error != "object" || !("code" in t.error) || !("message" in t.error));
  }
}, aG = class extends Error {
  constructor() {
    super(), this.name = this.constructor.name;
  }
};
class iG extends Error {
  constructor(t) {
    super(t), C8(this, "location"), this.location = t;
  }
}
class ov extends j3 {
}
function sv(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: oG } = Object.prototype, { getPrototypeOf: R3 } = Object, g8 = /* @__PURE__ */ ((e) => (t) => {
  const n = oG.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Sn = (e) => (e = e.toLowerCase(), (t) => g8(t) === e), y8 = (e) => (t) => typeof t === e, { isArray: lo } = Array, Fs = y8("undefined");
function sG(e) {
  return e !== null && !Fs(e) && e.constructor !== null && !Fs(e.constructor) && Lr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const lv = Sn("ArrayBuffer");
function lG(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && lv(e.buffer), t;
}
const cG = y8("string"), Lr = y8("function"), cv = y8("number"), v8 = (e) => e !== null && typeof e == "object", uG = (e) => e === !0 || e === !1, f6 = (e) => {
  if (g8(e) !== "object")
    return !1;
  const t = R3(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, dG = Sn("Date"), pG = Sn("File"), hG = Sn("Blob"), mG = Sn("FileList"), fG = (e) => v8(e) && Lr(e.pipe), CG = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Lr(e.append) && ((t = g8(e)) === "formdata" || // detect form-data instance
  t === "object" && Lr(e.toString) && e.toString() === "[object FormData]"));
}, gG = Sn("URLSearchParams"), [yG, vG, bG, _G] = ["ReadableStream", "Request", "Response", "Headers"].map(Sn), wG = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function _9(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, a;
  if (typeof e != "object" && (e = [e]), lo(e))
    for (r = 0, a = e.length; r < a; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let s;
    for (r = 0; r < o; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function uv(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], t === a.toLowerCase())
      return a;
  return null;
}
const L2 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, dv = (e) => !Fs(e) && e !== L2;
function al() {
  const { caseless: e } = dv(this) && this || {}, t = {}, n = (r, a) => {
    const i = e && uv(t, a) || a;
    f6(t[i]) && f6(r) ? t[i] = al(t[i], r) : f6(r) ? t[i] = al({}, r) : lo(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && _9(arguments[r], n);
  return t;
}
const xG = (e, t, n, { allOwnKeys: r } = {}) => (_9(t, (a, i) => {
  n && Lr(a) ? e[i] = sv(a, n) : e[i] = a;
}, { allOwnKeys: r }), e), SG = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), kG = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, MG = (e, t, n, r) => {
  let a, i, o;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (a = Object.getOwnPropertyNames(e), i = a.length; i-- > 0; )
      o = a[i], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
    e = n !== !1 && R3(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, PG = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, EG = (e) => {
  if (!e)
    return null;
  if (lo(e))
    return e;
  let t = e.length;
  if (!cv(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, TG = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && R3(Uint8Array)), LG = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const a = r.value;
    t.call(e, a[0], a[1]);
  }
}, AG = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, OG = Sn("HTMLFormElement"), NG = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, r) {
    return n.toUpperCase() + r;
  }
), Jd = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), jG = Sn("RegExp"), pv = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  _9(n, (a, i) => {
    let o;
    (o = t(a, i, e)) !== !1 && (r[i] = o || a);
  }), Object.defineProperties(e, r);
}, RG = (e) => {
  pv(e, (t, n) => {
    if (Lr(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Lr(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, DG = (e, t) => {
  const n = {}, r = (a) => {
    a.forEach((i) => {
      n[i] = !0;
    });
  };
  return lo(e) ? r(e) : r(String(e).split(t)), n;
}, IG = () => {
}, HG = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, A7 = "abcdefghijklmnopqrstuvwxyz", Xd = "0123456789", hv = {
  DIGIT: Xd,
  ALPHA: A7,
  ALPHA_DIGIT: A7 + A7.toUpperCase() + Xd
}, FG = (e = 16, t = hv.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function VG(e) {
  return !!(e && Lr(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const BG = (e) => {
  const t = new Array(10), n = (r, a) => {
    if (v8(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[a] = r;
        const i = lo(r) ? [] : {};
        return _9(r, (o, s) => {
          const l = n(o, a + 1);
          !Fs(l) && (i[s] = l);
        }), t[a] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, zG = Sn("AsyncFunction"), GG = (e) => e && (v8(e) || Lr(e)) && Lr(e.then) && Lr(e.catch), mv = ((e, t) => e ? setImmediate : t ? ((n, r) => (L2.addEventListener("message", ({ source: a, data: i }) => {
  a === L2 && i === n && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), L2.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Lr(L2.postMessage)
), UG = typeof queueMicrotask < "u" ? queueMicrotask.bind(L2) : typeof process < "u" && process.nextTick || mv, oe = {
  isArray: lo,
  isArrayBuffer: lv,
  isBuffer: sG,
  isFormData: CG,
  isArrayBufferView: lG,
  isString: cG,
  isNumber: cv,
  isBoolean: uG,
  isObject: v8,
  isPlainObject: f6,
  isReadableStream: yG,
  isRequest: vG,
  isResponse: bG,
  isHeaders: _G,
  isUndefined: Fs,
  isDate: dG,
  isFile: pG,
  isBlob: hG,
  isRegExp: jG,
  isFunction: Lr,
  isStream: fG,
  isURLSearchParams: gG,
  isTypedArray: TG,
  isFileList: mG,
  forEach: _9,
  merge: al,
  extend: xG,
  trim: wG,
  stripBOM: SG,
  inherits: kG,
  toFlatObject: MG,
  kindOf: g8,
  kindOfTest: Sn,
  endsWith: PG,
  toArray: EG,
  forEachEntry: LG,
  matchAll: AG,
  isHTMLForm: OG,
  hasOwnProperty: Jd,
  hasOwnProp: Jd,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: pv,
  freezeMethods: RG,
  toObjectSet: DG,
  toCamelCase: NG,
  noop: IG,
  toFiniteNumber: HG,
  findKey: uv,
  global: L2,
  isContextDefined: dv,
  ALPHABET: hv,
  generateString: FG,
  isSpecCompliantForm: VG,
  toJSONObject: BG,
  isAsyncFn: zG,
  isThenable: GG,
  setImmediate: mv,
  asap: UG
};
function tt(e, t, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), a && (this.response = a);
}
oe.inherits(tt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: oe.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const fv = tt.prototype, Cv = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Cv[e] = { value: e };
});
Object.defineProperties(tt, Cv);
Object.defineProperty(fv, "isAxiosError", { value: !0 });
tt.from = (e, t, n, r, a, i) => {
  const o = Object.create(fv);
  return oe.toFlatObject(e, o, function(s) {
    return s !== Error.prototype;
  }, (s) => s !== "isAxiosError"), tt.call(o, e.message, t, n, r, a), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const ZG = null;
function il(e) {
  return oe.isPlainObject(e) || oe.isArray(e);
}
function gv(e) {
  return oe.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Qd(e, t, n) {
  return e ? e.concat(t).map(function(r, a) {
    return r = gv(r), !n && a ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function KG(e) {
  return oe.isArray(e) && !e.some(il);
}
const $G = oe.toFlatObject(oe, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function b8(e, t, n) {
  if (!oe.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = oe.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, m) {
    return !oe.isUndefined(m[h]);
  });
  const r = n.metaTokens, a = n.visitor || c, i = n.dots, o = n.indexes, s = (n.Blob || typeof Blob < "u" && Blob) && oe.isSpecCompliantForm(t);
  if (!oe.isFunction(a))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null)
      return "";
    if (oe.isDate(h))
      return h.toISOString();
    if (!s && oe.isBlob(h))
      throw new tt("Blob is not supported. Use a Buffer instead.");
    return oe.isArrayBuffer(h) || oe.isTypedArray(h) ? s && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, m, f) {
    let C = h;
    if (h && !f && typeof h == "object") {
      if (oe.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), h = JSON.stringify(h);
      else if (oe.isArray(h) && KG(h) || (oe.isFileList(h) || oe.endsWith(m, "[]")) && (C = oe.toArray(h)))
        return m = gv(m), C.forEach(function(_, v) {
          !(oe.isUndefined(_) || _ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Qd([m], v, i) : o === null ? m : m + "[]",
            l(_)
          );
        }), !1;
    }
    return il(h) ? !0 : (t.append(Qd(f, m, i), l(h)), !1);
  }
  const u = [], d = Object.assign($G, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: il
  });
  function p(h, m) {
    if (!oe.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      u.push(h), oe.forEach(h, function(f, C) {
        (!(oe.isUndefined(f) || f === null) && a.call(
          t,
          f,
          oe.isString(C) ? C.trim() : C,
          m,
          d
        )) === !0 && p(f, m ? m.concat(C) : [C]);
      }), u.pop();
    }
  }
  if (!oe.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function ep(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function D3(e, t) {
  this._pairs = [], e && b8(e, this, t);
}
const yv = D3.prototype;
yv.append = function(e, t) {
  this._pairs.push([e, t]);
};
yv.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, ep);
  } : ep;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function WG(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function vv(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || WG, a = n && n.serialize;
  let i;
  if (a ? i = a(t, n) : i = oe.isURLSearchParams(t) ? t.toString() : new D3(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class tp {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    oe.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const bv = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, YG = typeof URLSearchParams < "u" ? URLSearchParams : D3, qG = typeof FormData < "u" ? FormData : null, JG = typeof Blob < "u" ? Blob : null, XG = {
  isBrowser: !0,
  classes: {
    URLSearchParams: YG,
    FormData: qG,
    Blob: JG
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, I3 = typeof window < "u" && typeof document < "u", QG = ((e) => I3 && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), eU = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", tU = I3 && window.location.href || "http://localhost", rU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: I3,
  hasStandardBrowserEnv: QG,
  hasStandardBrowserWebWorkerEnv: eU,
  origin: tU
}, Symbol.toStringTag, { value: "Module" })), mn = {
  ...rU,
  ...XG
};
function nU(e, t) {
  return b8(e, new mn.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, i) {
      return mn.isNode && oe.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function aU(e) {
  return oe.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function iU(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const a = n.length;
  let i;
  for (r = 0; r < a; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function _v(e) {
  function t(n, r, a, i) {
    let o = n[i++];
    if (o === "__proto__")
      return !0;
    const s = Number.isFinite(+o), l = i >= n.length;
    return o = !o && oe.isArray(a) ? a.length : o, l ? (oe.hasOwnProp(a, o) ? a[o] = [a[o], r] : a[o] = r, !s) : ((!a[o] || !oe.isObject(a[o])) && (a[o] = []), t(n, r, a[o], i) && oe.isArray(a[o]) && (a[o] = iU(a[o])), !s);
  }
  if (oe.isFormData(e) && oe.isFunction(e.entries)) {
    const n = {};
    return oe.forEachEntry(e, (r, a) => {
      t(aU(r), a, n, 0);
    }), n;
  }
  return null;
}
function oU(e, t, n) {
  if (oe.isString(e))
    try {
      return (t || JSON.parse)(e), oe.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const w9 = {
  transitional: bv,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, a = oe.isObject(e);
    if (a && oe.isHTMLForm(e) && (e = new FormData(e)), oe.isFormData(e))
      return r ? JSON.stringify(_v(e)) : e;
    if (oe.isArrayBuffer(e) || oe.isBuffer(e) || oe.isStream(e) || oe.isFile(e) || oe.isBlob(e) || oe.isReadableStream(e))
      return e;
    if (oe.isArrayBufferView(e))
      return e.buffer;
    if (oe.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return nU(e, this.formSerializer).toString();
      if ((i = oe.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const o = this.env && this.env.FormData;
        return b8(
          i ? { "files[]": e } : e,
          o && new o(),
          this.formSerializer
        );
      }
    }
    return a || r ? (t.setContentType("application/json", !1), oU(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || w9.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (oe.isResponse(e) || oe.isReadableStream(e))
      return e;
    if (e && oe.isString(e) && (n && !this.responseType || r)) {
      const a = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (a)
          throw i.name === "SyntaxError" ? tt.from(i, tt.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: mn.classes.FormData,
    Blob: mn.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
oe.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  w9.headers[e] = {};
});
const sU = oe.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), lU = (e) => {
  const t = {};
  let n, r, a;
  return e && e.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), n = i.substring(0, a).trim().toLowerCase(), r = i.substring(a + 1).trim(), !(!n || t[n] && sU[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, rp = Symbol("internals");
function Ro(e) {
  return e && String(e).trim().toLowerCase();
}
function C6(e) {
  return e === !1 || e == null ? e : oe.isArray(e) ? e.map(C6) : String(e);
}
function cU(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const uU = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function O7(e, t, n, r, a) {
  if (oe.isFunction(r))
    return r.call(this, t, n);
  if (a && (t = n), !!oe.isString(t)) {
    if (oe.isString(r))
      return t.indexOf(r) !== -1;
    if (oe.isRegExp(r))
      return r.test(t);
  }
}
function dU(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function pU(e, t) {
  const n = oe.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(a, i, o) {
        return this[r].call(this, t, a, i, o);
      },
      configurable: !0
    });
  });
}
let yr = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const a = this;
    function i(s, l, c) {
      const u = Ro(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = oe.findKey(a, u);
      (!d || a[d] === void 0 || c === !0 || c === void 0 && a[d] !== !1) && (a[d || l] = C6(s));
    }
    const o = (s, l) => oe.forEach(s, (c, u) => i(c, u, l));
    if (oe.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (oe.isString(t) && (t = t.trim()) && !uU(t))
      o(lU(t), n);
    else if (oe.isHeaders(t))
      for (const [s, l] of t.entries())
        i(l, s, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Ro(t), t) {
      const r = oe.findKey(this, t);
      if (r) {
        const a = this[r];
        if (!n)
          return a;
        if (n === !0)
          return cU(a);
        if (oe.isFunction(n))
          return n.call(this, a, r);
        if (oe.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Ro(t), t) {
      const r = oe.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || O7(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let a = !1;
    function i(o) {
      if (o = Ro(o), o) {
        const s = oe.findKey(r, o);
        s && (!n || O7(r, r[s], s, n)) && (delete r[s], a = !0);
      }
    }
    return oe.isArray(t) ? t.forEach(i) : i(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, a = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || O7(this, this[i], i, t, !0)) && (delete this[i], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, r = {};
    return oe.forEach(this, (a, i) => {
      const o = oe.findKey(r, i);
      if (o) {
        n[o] = C6(a), delete n[i];
        return;
      }
      const s = t ? dU(i) : String(i).trim();
      s !== i && delete n[i], n[s] = C6(a), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return oe.forEach(this, (r, a) => {
      r != null && r !== !1 && (n[a] = t && oe.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((a) => r.set(a)), r;
  }
  static accessor(t) {
    const n = (this[rp] = this[rp] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function a(i) {
      const o = Ro(i);
      n[o] || (pU(r, i), n[o] = !0);
    }
    return oe.isArray(t) ? t.forEach(a) : a(t), this;
  }
};
yr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
oe.reduceDescriptors(yr.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
oe.freezeMethods(yr);
function N7(e, t) {
  const n = this || w9, r = t || n, a = yr.from(r.headers);
  let i = r.data;
  return oe.forEach(e, function(o) {
    i = o.call(n, i, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), i;
}
function wv(e) {
  return !!(e && e.__CANCEL__);
}
function co(e, t, n) {
  tt.call(this, e ?? "canceled", tt.ERR_CANCELED, t, n), this.name = "CanceledError";
}
oe.inherits(co, tt, {
  __CANCEL__: !0
});
function xv(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new tt(
    "Request failed with status code " + n.status,
    [tt.ERR_BAD_REQUEST, tt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function hU(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function mU(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let a = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = r[i];
    o || (o = l), n[a] = s, r[a] = l;
    let u = i, d = 0;
    for (; u !== a; )
      d += n[u++], u = u % e;
    if (a = (a + 1) % e, a === i && (i = (i + 1) % e), l - o < t)
      return;
    const p = c && l - c;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function fU(e, t) {
  let n = 0, r = 1e3 / t, a, i;
  const o = (s, l = Date.now()) => {
    n = l, a = null, i && (clearTimeout(i), i = null), e.apply(null, s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - n;
    c >= r ? o(s, l) : (a = s, i || (i = setTimeout(() => {
      i = null, o(a);
    }, r - c)));
  }, () => a && o(a)];
}
const u5 = (e, t, n = 3) => {
  let r = 0;
  const a = mU(50, 250);
  return fU((i) => {
    const o = i.loaded, s = i.lengthComputable ? i.total : void 0, l = o - r, c = a(l), u = o <= s;
    r = o;
    const d = {
      loaded: o,
      total: s,
      progress: s ? o / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - o) / c : void 0,
      event: i,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, np = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, ap = (e) => (...t) => oe.asap(() => e(...t)), CU = mn.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let n;
    function r(a) {
      let i = a;
      return e && (t.setAttribute("href", i), i = t.href), t.setAttribute("href", i), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return n = r(window.location.href), function(a) {
      const i = oe.isString(a) ? r(a) : a;
      return i.protocol === n.protocol && i.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), gU = mn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, a, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      oe.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), oe.isString(r) && o.push("path=" + r), oe.isString(a) && o.push("domain=" + a), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function yU(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function vU(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Sv(e, t) {
  return e && !yU(t) ? vU(e, t) : t;
}
const ip = (e) => e instanceof yr ? { ...e } : e;
function W2(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return oe.isPlainObject(c) && oe.isPlainObject(u) ? oe.merge.call({ caseless: d }, c, u) : oe.isPlainObject(u) ? oe.merge({}, u) : oe.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d) {
    if (oe.isUndefined(u)) {
      if (!oe.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function i(c, u) {
    if (!oe.isUndefined(u))
      return r(void 0, u);
  }
  function o(c, u) {
    if (oe.isUndefined(u)) {
      if (!oe.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (c, u) => a(ip(c), ip(u), !0)
  };
  return oe.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const u = l[c] || a, d = u(e[c], t[c], c);
    oe.isUndefined(d) && u !== s || (n[c] = d);
  }), n;
}
const kv = (e) => {
  const t = W2({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: i, headers: o, auth: s } = t;
  t.headers = o = yr.from(o), t.url = vv(Sv(t.baseURL, t.url), e.params, e.paramsSerializer), s && o.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (oe.isFormData(n)) {
    if (mn.hasStandardBrowserEnv || mn.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      o.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (mn.hasStandardBrowserEnv && (r && oe.isFunction(r) && (r = r(t)), r || r !== !1 && CU(t.url))) {
    const c = a && i && gU.read(i);
    c && o.set(a, c);
  }
  return t;
}, bU = typeof XMLHttpRequest < "u", _U = bU && function(e) {
  return new Promise(function(t, n) {
    const r = kv(e);
    let a = r.data;
    const i = yr.from(r.headers).normalize();
    let { responseType: o, onUploadProgress: s, onDownloadProgress: l } = r, c, u, d, p, h;
    function m() {
      p && p(), h && h(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let f = new XMLHttpRequest();
    f.open(r.method.toUpperCase(), r.url, !0), f.timeout = r.timeout;
    function C() {
      if (!f)
        return;
      const v = yr.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), w = {
        data: !o || o === "text" || o === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: v,
        config: e,
        request: f
      };
      xv(function(k) {
        t(k), m();
      }, function(k) {
        n(k), m();
      }, w), f = null;
    }
    "onloadend" in f ? f.onloadend = C : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(C);
    }, f.onabort = function() {
      f && (n(new tt("Request aborted", tt.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function() {
      n(new tt("Network Error", tt.ERR_NETWORK, e, f)), f = null;
    }, f.ontimeout = function() {
      let v = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const w = r.transitional || bv;
      r.timeoutErrorMessage && (v = r.timeoutErrorMessage), n(new tt(
        v,
        w.clarifyTimeoutError ? tt.ETIMEDOUT : tt.ECONNABORTED,
        e,
        f
      )), f = null;
    }, a === void 0 && i.setContentType(null), "setRequestHeader" in f && oe.forEach(i.toJSON(), function(v, w) {
      f.setRequestHeader(w, v);
    }), oe.isUndefined(r.withCredentials) || (f.withCredentials = !!r.withCredentials), o && o !== "json" && (f.responseType = r.responseType), l && ([d, h] = u5(l, !0), f.addEventListener("progress", d)), s && f.upload && ([u, p] = u5(s), f.upload.addEventListener("progress", u), f.upload.addEventListener("loadend", p)), (r.cancelToken || r.signal) && (c = (v) => {
      f && (n(!v || v.type ? new co(null, e, f) : v), f.abort(), f = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const _ = hU(r.url);
    if (_ && mn.protocols.indexOf(_) === -1) {
      n(new tt("Unsupported protocol " + _ + ":", tt.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(a || null);
  });
}, wU = (e, t) => {
  let n = new AbortController(), r;
  const a = function(l) {
    if (!r) {
      r = !0, o();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof tt ? c : new co(c instanceof Error ? c.message : c));
    }
  };
  let i = t && setTimeout(() => {
    a(new tt(`timeout ${t} of ms exceeded`, tt.ETIMEDOUT));
  }, t);
  const o = () => {
    e && (i && clearTimeout(i), i = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", a) : l.unsubscribe(a));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", a));
  const { signal: s } = n;
  return s.unsubscribe = o, [s, () => {
    i && clearTimeout(i), i = null;
  }];
}, xU = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + t, yield e.slice(r, a), r = a;
}, SU = async function* (e, t, n) {
  for await (const r of e)
    yield* xU(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, op = (e, t, n, r, a) => {
  const i = SU(e, t, a);
  let o = 0, s, l = (c) => {
    s || (s = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await i.next();
        if (u) {
          l(), c.close();
          return;
        }
        let p = d.byteLength;
        if (n) {
          let h = o += p;
          n(h);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, _8 = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Mv = _8 && typeof ReadableStream == "function", ol = _8 && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Pv = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, kU = Mv && Pv(() => {
  let e = !1;
  const t = new Request(mn.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), sp = 64 * 1024, sl = Mv && Pv(() => oe.isReadableStream(new Response("").body)), d5 = {
  stream: sl && ((e) => e.body)
};
_8 && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !d5[t] && (d5[t] = oe.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new tt(`Response type '${t}' is not supported`, tt.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const MU = async (e) => {
  if (e == null)
    return 0;
  if (oe.isBlob(e))
    return e.size;
  if (oe.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (oe.isArrayBufferView(e) || oe.isArrayBuffer(e))
    return e.byteLength;
  if (oe.isURLSearchParams(e) && (e = e + ""), oe.isString(e))
    return (await ol(e)).byteLength;
}, PU = async (e, t) => oe.toFiniteNumber(e.getContentLength()) ?? MU(t), EU = _8 && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: a,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = kv(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, m] = a || i || o ? wU([a, i], o) : [], f, C;
  const _ = () => {
    !f && setTimeout(() => {
      h && h.unsubscribe();
    }), f = !0;
  };
  let v;
  try {
    if (l && kU && n !== "get" && n !== "head" && (v = await PU(u, r)) !== 0) {
      let S = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), P;
      if (oe.isFormData(r) && (P = S.headers.get("content-type")) && u.setContentType(P), S.body) {
        const [O, A] = np(
          v,
          u5(ap(l))
        );
        r = op(S.body, sp, O, A, ol);
      }
    }
    oe.isString(d) || (d = d ? "include" : "omit"), C = new Request(t, {
      ...p,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: d
    });
    let w = await fetch(C);
    const k = sl && (c === "stream" || c === "response");
    if (sl && (s || k)) {
      const S = {};
      ["status", "statusText", "headers"].forEach((L) => {
        S[L] = w[L];
      });
      const P = oe.toFiniteNumber(w.headers.get("content-length")), [O, A] = s && np(
        P,
        u5(ap(s), !0)
      ) || [];
      w = new Response(
        op(w.body, sp, O, () => {
          A && A(), k && _();
        }, ol),
        S
      );
    }
    c = c || "text";
    let b = await d5[oe.findKey(d5, c) || "text"](w, e);
    return !k && _(), m && m(), await new Promise((S, P) => {
      xv(S, P, {
        data: b,
        headers: yr.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: e,
        request: C
      });
    });
  } catch (w) {
    throw _(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new tt("Network Error", tt.ERR_NETWORK, e, C),
      {
        cause: w.cause || w
      }
    ) : tt.from(w, w && w.code, e, C);
  }
}), ll = {
  http: ZG,
  xhr: _U,
  fetch: EU
};
oe.forEach(ll, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const lp = (e) => `- ${e}`, TU = (e) => oe.isFunction(e) || e === null || e === !1, Ev = {
  getAdapter: (e) => {
    e = oe.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const a = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let o;
      if (r = n, !TU(n) && (r = ll[(o = String(n)).toLowerCase()], r === void 0))
        throw new tt(`Unknown adapter '${o}'`);
      if (r)
        break;
      a[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(lp).join(`
`) : " " + lp(i[0]) : "as no adapter specified";
      throw new tt(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: ll
};
function j7(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new co(null, e);
}
function cp(e) {
  return j7(e), e.headers = yr.from(e.headers), e.data = N7.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ev.getAdapter(e.adapter || w9.adapter)(e).then(function(t) {
    return j7(e), t.data = N7.call(
      e,
      e.transformResponse,
      t
    ), t.headers = yr.from(t.headers), t;
  }, function(t) {
    return wv(t) || (j7(e), t && t.response && (t.response.data = N7.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = yr.from(t.response.headers))), Promise.reject(t);
  });
}
const Tv = "1.7.4", H3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  H3[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const up = {};
H3.transitional = function(e, t, n) {
  function r(a, i) {
    return "[Axios v" + Tv + "] Transitional option '" + a + "'" + i + (n ? ". " + n : "");
  }
  return (a, i, o) => {
    if (e === !1)
      throw new tt(
        r(i, " has been removed" + (t ? " in " + t : "")),
        tt.ERR_DEPRECATED
      );
    return t && !up[i] && (up[i] = !0, console.warn(
      r(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(a, i, o) : !0;
  };
};
function LU(e, t, n) {
  if (typeof e != "object")
    throw new tt("options must be an object", tt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let a = r.length;
  for (; a-- > 0; ) {
    const i = r[a], o = t[i];
    if (o) {
      const s = e[i], l = s === void 0 || o(s, i, e);
      if (l !== !0)
        throw new tt("option " + i + " must be " + l, tt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new tt("Unknown option " + i, tt.ERR_BAD_OPTION);
  }
}
const cl = {
  assertOptions: LU,
  validators: H3
}, Sa = cl.validators;
let H2 = class {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new tp(),
      response: new tp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let r;
        Error.captureStackTrace ? Error.captureStackTrace(r = {}) : r = new Error();
        const a = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? a && !String(n.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + a) : n.stack = a;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = W2(this.defaults, t);
    const { transitional: n, paramsSerializer: r, headers: a } = t;
    n !== void 0 && cl.assertOptions(n, {
      silentJSONParsing: Sa.transitional(Sa.boolean),
      forcedJSONParsing: Sa.transitional(Sa.boolean),
      clarifyTimeoutError: Sa.transitional(Sa.boolean)
    }, !1), r != null && (oe.isFunction(r) ? t.paramsSerializer = {
      serialize: r
    } : cl.assertOptions(r, {
      encode: Sa.function,
      serialize: Sa.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = a && oe.merge(
      a.common,
      a[t.method]
    );
    a && oe.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete a[h];
      }
    ), t.headers = yr.concat(i, a);
    const o = [];
    let s = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(t) === !1 || (s = s && h.synchronous, o.unshift(h.fulfilled, h.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(h) {
      l.push(h.fulfilled, h.rejected);
    });
    let c, u = 0, d;
    if (!s) {
      const h = [cp.bind(this), void 0];
      for (h.unshift.apply(h, o), h.push.apply(h, l), d = h.length, c = Promise.resolve(t); u < d; )
        c = c.then(h[u++], h[u++]);
      return c;
    }
    d = o.length;
    let p = t;
    for (u = 0; u < d; ) {
      const h = o[u++], m = o[u++];
      try {
        p = h(p);
      } catch (f) {
        m.call(this, f);
        break;
      }
    }
    try {
      c = cp.call(this, p);
    } catch (h) {
      return Promise.reject(h);
    }
    for (u = 0, d = l.length; u < d; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(e) {
    e = W2(this.defaults, e);
    const t = Sv(e.baseURL, e.url);
    return vv(t, e.params, e.paramsSerializer);
  }
};
oe.forEach(["delete", "get", "head", "options"], function(e) {
  H2.prototype[e] = function(t, n) {
    return this.request(W2(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
oe.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, a, i) {
      return this.request(W2(i || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: a
      }));
    };
  }
  H2.prototype[e] = t(), H2.prototype[e + "Form"] = t(!0);
});
let AU = class Lv {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let i;
      const o = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(a);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(a, i, o) {
      r.reason || (r.reason = new co(a, i, o), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Lv(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function OU(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function NU(e) {
  return oe.isObject(e) && e.isAxiosError === !0;
}
const ul = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ul).forEach(([e, t]) => {
  ul[t] = e;
});
function Av(e) {
  const t = new H2(e), n = sv(H2.prototype.request, t);
  return oe.extend(n, H2.prototype, t, { allOwnKeys: !0 }), oe.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return Av(W2(e, r));
  }, n;
}
const x1 = Av(w9);
x1.Axios = H2;
x1.CanceledError = co;
x1.CancelToken = AU;
x1.isCancel = wv;
x1.VERSION = Tv;
x1.toFormData = b8;
x1.AxiosError = tt;
x1.Cancel = x1.CanceledError;
x1.all = function(e) {
  return Promise.all(e);
};
x1.spread = OU;
x1.isAxiosError = NU;
x1.mergeConfig = W2;
x1.AxiosHeaders = yr;
x1.formToJSON = (e) => _v(oe.isHTMLForm(e) ? new FormData(e) : e);
x1.getAdapter = Ev.getAdapter;
x1.HttpStatusCode = ul;
x1.default = x1;
const {
  Axios: _ne,
  AxiosError: jU,
  CanceledError: wne,
  isCancel: RU,
  CancelToken: xne,
  VERSION: Sne,
  all: kne,
  Cancel: Mne,
  isAxiosError: Pne,
  spread: Ene,
  toFormData: Tne,
  AxiosHeaders: Lne,
  HttpStatusCode: Ane,
  formToJSON: One,
  getAdapter: Nne,
  mergeConfig: jne
} = x1, Ti = x1.create({
  withCredentials: !0,
  headers: { "X-Requested-With": "XMLHttpRequest" }
}), DU = (e) => Ti.interceptors.response.use((t) => t, Ov()), Ov = (e) => {
  let t = !1, n = [];
  const r = () => Ti.post("/api/user/token/regenerate"), a = (s) => {
    n.push(s);
  }, i = () => {
    n.forEach((s) => s()), n = [];
  }, o = async (s) => {
    const l = s.config;
    if (!t) {
      t = !0;
      try {
        return await r(), t = !1, i(), await Ti(l);
      } catch (c) {
        throw t = !1, n = [], c;
      }
    }
    return new Promise((c) => {
      a(() => {
        c(Ti(l));
      });
    });
  };
  return async (s) => {
    if (RU(s))
      throw s;
    if (s = s, s.code === jU.ERR_NETWORK)
      throw new nG();
    const l = s.response;
    if (!l)
      throw s;
    switch (l.status) {
      case 400:
        throw "errors" in l.data ? new xn(l.data) : new c5(l.data);
      case 401:
        if (tG.includes(l.data.message))
          return await o(s);
        if (l.data.location)
          throw new iG(l.data.location);
        break;
      case 403:
        throw new Jz();
      case 404:
        throw new qd(qd.isNotFoundResponse(l.data) ? l.data : void 0);
      case 409:
        throw new Xz(l.data);
      case 413:
        throw new aG();
      case 422:
        throw new ov(l.data);
      case 423:
        throw new rG();
      case 424:
        throw new Qz(l.data.title);
      case 500:
      case 502:
        throw new eG();
    }
    throw s;
  };
};
var Do = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dp;
function IU() {
  if (dp)
    return Do;
  dp = 1;
  var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return Do.Fragment = n, Do.jsx = o, Do.jsxs = o, Do;
}
var B9 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pp;
function HU() {
  return pp || (pp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, f = "@@iterator";
    function C(g) {
      if (g === null || typeof g != "object")
        return null;
      var E = m && g[m] || g[f];
      return typeof E == "function" ? E : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(g) {
      {
        for (var E = arguments.length, R = new Array(E > 1 ? E - 1 : 0), X = 1; X < E; X++)
          R[X - 1] = arguments[X];
        w("error", g, R);
      }
    }
    function w(g, E, R) {
      {
        var X = _.ReactDebugCurrentFrame, ce = X.getStackAddendum();
        ce !== "" && (E += "%s", R = R.concat([ce]));
        var ue = R.map(function(ie) {
          return String(ie);
        });
        ue.unshift("Warning: " + E), Function.prototype.apply.call(console[g], console, ue);
      }
    }
    var k = !1, b = !1, S = !1, P = !1, O = !1, A;
    A = Symbol.for("react.module.reference");
    function L(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || O || g === a || g === c || g === u || P || g === h || k || b || S || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === d || g.$$typeof === o || g.$$typeof === s || g.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === A || g.getModuleId !== void 0));
    }
    function I(g, E, R) {
      var X = g.displayName;
      if (X)
        return X;
      var ce = E.displayName || E.name || "";
      return ce !== "" ? R + "(" + ce + ")" : R;
    }
    function D(g) {
      return g.displayName || "Context";
    }
    function U(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case s:
            var E = g;
            return D(E) + ".Consumer";
          case o:
            var R = g;
            return D(R._context) + ".Provider";
          case l:
            return I(g, g.render, "ForwardRef");
          case d:
            var X = g.displayName || null;
            return X !== null ? X : U(g.type) || "Memo";
          case p: {
            var ce = g, ue = ce._payload, ie = ce._init;
            try {
              return U(ie(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, $ = 0, ee, Z, G, W, j, T, F;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function Y() {
      {
        if ($ === 0) {
          ee = console.log, Z = console.info, G = console.warn, W = console.error, j = console.group, T = console.groupCollapsed, F = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        $++;
      }
    }
    function Q() {
      {
        if ($--, $ === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, g, {
              value: ee
            }),
            info: z({}, g, {
              value: Z
            }),
            warn: z({}, g, {
              value: G
            }),
            error: z({}, g, {
              value: W
            }),
            group: z({}, g, {
              value: j
            }),
            groupCollapsed: z({}, g, {
              value: T
            }),
            groupEnd: z({}, g, {
              value: F
            })
          });
        }
        $ < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = _.ReactCurrentDispatcher, re;
    function q(g, E, R) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ce) {
            var X = ce.stack.trim().match(/\n( *(at )?)/);
            re = X && X[1] || "";
          }
        return `
` + re + g;
      }
    }
    var he = !1, me;
    {
      var Ne = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Ne();
    }
    function K(g, E) {
      if (!g || he)
        return "";
      {
        var R = me.get(g);
        if (R !== void 0)
          return R;
      }
      var X;
      he = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = V.current, V.current = null, Y();
      try {
        if (E) {
          var ie = function() {
            throw Error();
          };
          if (Object.defineProperty(ie.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ie, []);
            } catch (He) {
              X = He;
            }
            Reflect.construct(g, [], ie);
          } else {
            try {
              ie.call();
            } catch (He) {
              X = He;
            }
            g.call(ie.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (He) {
            X = He;
          }
          g();
        }
      } catch (He) {
        if (He && X && typeof He.stack == "string") {
          for (var ne = He.stack.split(`
`), je = X.stack.split(`
`), we = ne.length - 1, xe = je.length - 1; we >= 1 && xe >= 0 && ne[we] !== je[xe]; )
            xe--;
          for (; we >= 1 && xe >= 0; we--, xe--)
            if (ne[we] !== je[xe]) {
              if (we !== 1 || xe !== 1)
                do
                  if (we--, xe--, xe < 0 || ne[we] !== je[xe]) {
                    var ze = `
` + ne[we].replace(" at new ", " at ");
                    return g.displayName && ze.includes("<anonymous>") && (ze = ze.replace("<anonymous>", g.displayName)), typeof g == "function" && me.set(g, ze), ze;
                  }
                while (we >= 1 && xe >= 0);
              break;
            }
        }
      } finally {
        he = !1, V.current = ue, Q(), Error.prepareStackTrace = ce;
      }
      var Yt = g ? g.displayName || g.name : "", Nt = Yt ? q(Yt) : "";
      return typeof g == "function" && me.set(g, Nt), Nt;
    }
    function Ee(g, E, R) {
      return K(g, !1);
    }
    function J(g) {
      var E = g.prototype;
      return !!(E && E.isReactComponent);
    }
    function te(g, E, R) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return K(g, J(g));
      if (typeof g == "string")
        return q(g);
      switch (g) {
        case c:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case l:
            return Ee(g.render);
          case d:
            return te(g.type, E, R);
          case p: {
            var X = g, ce = X._payload, ue = X._init;
            try {
              return te(ue(ce), E, R);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, Pe = {}, Ze = _.ReactDebugCurrentFrame;
    function _t(g) {
      if (g) {
        var E = g._owner, R = te(g.type, g._source, E ? E.type : null);
        Ze.setExtraStackFrame(R);
      } else
        Ze.setExtraStackFrame(null);
    }
    function st(g, E, R, X, ce) {
      {
        var ue = Function.call.bind(ye);
        for (var ie in g)
          if (ue(g, ie)) {
            var ne = void 0;
            try {
              if (typeof g[ie] != "function") {
                var je = Error((X || "React class") + ": " + R + " type `" + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw je.name = "Invariant Violation", je;
              }
              ne = g[ie](E, ie, X, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (we) {
              ne = we;
            }
            ne && !(ne instanceof Error) && (_t(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", R, ie, typeof ne), _t(null)), ne instanceof Error && !(ne.message in Pe) && (Pe[ne.message] = !0, _t(ce), v("Failed %s type: %s", R, ne.message), _t(null));
          }
      }
    }
    var L1 = Array.isArray;
    function $t(g) {
      return L1(g);
    }
    function Qt(g) {
      {
        var E = typeof Symbol == "function" && Symbol.toStringTag, R = E && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return R;
      }
    }
    function Ie(g) {
      try {
        return lt(g), !1;
      } catch {
        return !0;
      }
    }
    function lt(g) {
      return "" + g;
    }
    function C1(g) {
      if (Ie(g))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qt(g)), lt(g);
    }
    var At = _.ReactCurrentOwner, g1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, Ce, Le;
    Le = {};
    function ct(g) {
      if (ye.call(g, "ref")) {
        var E = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function y1(g) {
      if (ye.call(g, "key")) {
        var E = Object.getOwnPropertyDescriptor(g, "key").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function $1(g, E) {
      if (typeof g.ref == "string" && At.current && E && At.current.stateNode !== E) {
        var R = U(At.current.type);
        Le[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(At.current.type), g.ref), Le[R] = !0);
      }
    }
    function Xr(g, E) {
      {
        var R = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        R.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function e2(g, E) {
      {
        var R = function() {
          Ce || (Ce = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        R.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var t2 = function(g, E, R, X, ce, ue, ie) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: g,
        key: E,
        ref: R,
        props: ie,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function r2(g, E, R, X, ce) {
      {
        var ue, ie = {}, ne = null, je = null;
        R !== void 0 && (C1(R), ne = "" + R), y1(E) && (C1(E.key), ne = "" + E.key), ct(E) && (je = E.ref, $1(E, ce));
        for (ue in E)
          ye.call(E, ue) && !g1.hasOwnProperty(ue) && (ie[ue] = E[ue]);
        if (g && g.defaultProps) {
          var we = g.defaultProps;
          for (ue in we)
            ie[ue] === void 0 && (ie[ue] = we[ue]);
        }
        if (ne || je) {
          var xe = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          ne && Xr(ie, xe), je && e2(ie, xe);
        }
        return t2(g, ne, je, ce, X, At.current, ie);
      }
    }
    var er = _.ReactCurrentOwner, Qr = _.ReactDebugCurrentFrame;
    function Wt(g) {
      if (g) {
        var E = g._owner, R = te(g.type, g._source, E ? E.type : null);
        Qr.setExtraStackFrame(R);
      } else
        Qr.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function rr(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function en() {
      {
        if (er.current) {
          var g = U(er.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function n2(g) {
      return "";
    }
    var tn = {};
    function a2(g) {
      {
        var E = en();
        if (!E) {
          var R = typeof g == "string" ? g : g.displayName || g.name;
          R && (E = `

Check the top-level render call using <` + R + ">.");
        }
        return E;
      }
    }
    function rn(g, E) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var R = a2(E);
        if (tn[R])
          return;
        tn[R] = !0;
        var X = "";
        g && g._owner && g._owner !== er.current && (X = " It was passed a child from " + U(g._owner.type) + "."), Wt(g), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, X), Wt(null);
      }
    }
    function nn(g, E) {
      {
        if (typeof g != "object")
          return;
        if ($t(g))
          for (var R = 0; R < g.length; R++) {
            var X = g[R];
            rr(X) && rn(X, E);
          }
        else if (rr(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var ce = C(g);
          if (typeof ce == "function" && ce !== g.entries)
            for (var ue = ce.call(g), ie; !(ie = ue.next()).done; )
              rr(ie.value) && rn(ie.value, E);
        }
      }
    }
    function i2(g) {
      {
        var E = g.type;
        if (E == null || typeof E == "string")
          return;
        var R;
        if (typeof E == "function")
          R = E.propTypes;
        else if (typeof E == "object" && (E.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        E.$$typeof === d))
          R = E.propTypes;
        else
          return;
        if (R) {
          var X = U(E);
          st(R, g.props, "prop", X, g);
        } else if (E.PropTypes !== void 0 && !tr) {
          tr = !0;
          var ce = U(E);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof E.getDefaultProps == "function" && !E.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function o2(g) {
      {
        for (var E = Object.keys(g.props), R = 0; R < E.length; R++) {
          var X = E[R];
          if (X !== "children" && X !== "key") {
            Wt(g), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Wt(null);
            break;
          }
        }
        g.ref !== null && (Wt(g), v("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var an = {};
    function on(g, E, R, X, ce, ue) {
      {
        var ie = L(g);
        if (!ie) {
          var ne = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var je = n2();
          je ? ne += je : ne += en();
          var we;
          g === null ? we = "null" : $t(g) ? we = "array" : g !== void 0 && g.$$typeof === t ? (we = "<" + (U(g.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : we = typeof g, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", we, ne);
        }
        var xe = r2(g, E, R, ce, ue);
        if (xe == null)
          return xe;
        if (ie) {
          var ze = E.children;
          if (ze !== void 0)
            if (X)
              if ($t(ze)) {
                for (var Yt = 0; Yt < ze.length; Yt++)
                  nn(ze[Yt], g);
                Object.freeze && Object.freeze(ze);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              nn(ze, g);
        }
        if (ye.call(E, "key")) {
          var Nt = U(g), He = Object.keys(E).filter(function(p2) {
            return p2 !== "key";
          }), nr = He.length > 0 ? "{key: someKey, " + He.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!an[Nt + nr]) {
            var d2 = He.length > 0 ? "{" + He.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nr, Nt, d2, Nt), an[Nt + nr] = !0;
          }
        }
        return g === r ? o2(xe) : i2(xe), xe;
      }
    }
    function s2(g, E, R) {
      return on(g, E, R, !0);
    }
    function l2(g, E, R) {
      return on(g, E, R, !1);
    }
    var c2 = l2, u2 = s2;
    B9.Fragment = r, B9.jsx = c2, B9.jsxs = u2;
  }()), B9;
}
process.env.NODE_ENV === "production" ? IU() : HU();
var dl = function(e, t) {
  return dl = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, dl(e, t);
};
function w8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  dl(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Rn = function() {
  return Rn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Rn.apply(this, arguments);
};
function FU(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function R7(e, t, n) {
  if (arguments.length === 2)
    for (var r = 0, a = t.length, i; r < a; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var p5 = function() {
  return p5 = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, p5.apply(this, arguments);
}, xt;
(function(e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})(xt || (xt = {}));
var a1;
(function(e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(a1 || (a1 = {}));
var Ki;
(function(e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(Ki || (Ki = {}));
function hp(e) {
  return e.type === a1.literal;
}
function VU(e) {
  return e.type === a1.argument;
}
function Nv(e) {
  return e.type === a1.number;
}
function jv(e) {
  return e.type === a1.date;
}
function Rv(e) {
  return e.type === a1.time;
}
function Dv(e) {
  return e.type === a1.select;
}
function Iv(e) {
  return e.type === a1.plural;
}
function BU(e) {
  return e.type === a1.pound;
}
function Hv(e) {
  return e.type === a1.tag;
}
function Fv(e) {
  return !!(e && typeof e == "object" && e.type === Ki.number);
}
function pl(e) {
  return !!(e && typeof e == "object" && e.type === Ki.dateTime);
}
var Vv = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, zU = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function GU(e) {
  var t = {};
  return e.replace(zU, function(n) {
    var r = n.length;
    switch (n[0]) {
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4)
          throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4)
          throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var d1 = function() {
  return d1 = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, d1.apply(this, arguments);
}, UU = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function ZU(e) {
  if (e.length === 0)
    throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(UU).filter(function(p) {
    return p.length > 0;
  }), n = [], r = 0, a = t; r < a.length; r++) {
    var i = a[r], o = i.split("/");
    if (o.length === 0)
      throw new Error("Invalid number skeleton");
    for (var s = o[0], l = o.slice(1), c = 0, u = l; c < u.length; c++) {
      var d = u[c];
      if (d.length === 0)
        throw new Error("Invalid number skeleton");
    }
    n.push({ stem: s, options: l });
  }
  return n;
}
function KU(e) {
  return e.replace(/^(.*?)-/, "");
}
var mp = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g, Bv = /^(@+)?(\+|#+)?[rs]?$/g, $U = /(\*)(0+)|(#+)(0+)|(0+)/g, zv = /^(0+)$/;
function fp(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(Bv, function(n, r, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : a === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function Gv(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function WU(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !zv.test(e))
      throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function Cp(e) {
  var t = {}, n = Gv(e);
  return n || t;
}
function YU(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var a = r[n];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = KU(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = d1(d1(d1({}, t), { notation: "scientific" }), a.options.reduce(function(l, c) {
          return d1(d1({}, l), Cp(c));
        }, {}));
        continue;
      case "engineering":
        t = d1(d1(d1({}, t), { notation: "engineering" }), a.options.reduce(function(l, c) {
          return d1(d1({}, l), Cp(c));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "rounding-mode-floor":
        t.roundingMode = "floor";
        continue;
      case "rounding-mode-ceiling":
        t.roundingMode = "ceil";
        continue;
      case "rounding-mode-down":
        t.roundingMode = "trunc";
        continue;
      case "rounding-mode-up":
        t.roundingMode = "expand";
        continue;
      case "rounding-mode-half-even":
        t.roundingMode = "halfEven";
        continue;
      case "rounding-mode-half-down":
        t.roundingMode = "halfTrunc";
        continue;
      case "rounding-mode-half-up":
        t.roundingMode = "halfExpand";
        continue;
      case "integer-width":
        if (a.options.length > 1)
          throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace($U, function(l, c, u, d, p, h) {
          if (c)
            t.minimumIntegerDigits = u.length;
          else {
            if (d && p)
              throw new Error("We currently do not support maximum integer digits");
            if (h)
              throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (zv.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (mp.test(a.stem)) {
      if (a.options.length > 1)
        throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(mp, function(l, c, u, d, p, h) {
        return u === "*" ? t.minimumFractionDigits = c.length : d && d[0] === "#" ? t.maximumFractionDigits = d.length : p && h ? (t.minimumFractionDigits = p.length, t.maximumFractionDigits = p.length + h.length) : (t.minimumFractionDigits = c.length, t.maximumFractionDigits = c.length), "";
      });
      var i = a.options[0];
      i === "w" ? t = d1(d1({}, t), { trailingZeroDisplay: "stripIfInteger" }) : i && (t = d1(d1({}, t), fp(i)));
      continue;
    }
    if (Bv.test(a.stem)) {
      t = d1(d1({}, t), fp(a.stem));
      continue;
    }
    var o = Gv(a.stem);
    o && (t = d1(d1({}, t), o));
    var s = WU(a.stem);
    s && (t = d1(d1({}, t), s));
  }
  return t;
}
var z9 = {
  "001": [
    "H",
    "h"
  ],
  AC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AD: [
    "H",
    "hB"
  ],
  AE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  AF: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  AG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  AL: [
    "h",
    "H",
    "hB"
  ],
  AM: [
    "H",
    "hB"
  ],
  AO: [
    "H",
    "hB"
  ],
  AR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  AS: [
    "h",
    "H"
  ],
  AT: [
    "H",
    "hB"
  ],
  AU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  AW: [
    "H",
    "hB"
  ],
  AX: [
    "H"
  ],
  AZ: [
    "H",
    "hB",
    "h"
  ],
  BA: [
    "H",
    "hB",
    "h"
  ],
  BB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BD: [
    "h",
    "hB",
    "H"
  ],
  BE: [
    "H",
    "hB"
  ],
  BF: [
    "H",
    "hB"
  ],
  BG: [
    "H",
    "hB",
    "h"
  ],
  BH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  BI: [
    "H",
    "h"
  ],
  BJ: [
    "H",
    "hB"
  ],
  BL: [
    "H",
    "hB"
  ],
  BM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BN: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  BO: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  BQ: [
    "H"
  ],
  BR: [
    "H",
    "hB"
  ],
  BS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  BT: [
    "h",
    "H"
  ],
  BW: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  BY: [
    "H",
    "h"
  ],
  BZ: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CA: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  CC: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CD: [
    "hB",
    "H"
  ],
  CF: [
    "H",
    "h",
    "hB"
  ],
  CG: [
    "H",
    "hB"
  ],
  CH: [
    "H",
    "hB",
    "h"
  ],
  CI: [
    "H",
    "hB"
  ],
  CK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CL: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CM: [
    "H",
    "h",
    "hB"
  ],
  CN: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  CO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  CP: [
    "H"
  ],
  CR: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CU: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  CV: [
    "H",
    "hB"
  ],
  CW: [
    "H",
    "hB"
  ],
  CX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  CY: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  CZ: [
    "H"
  ],
  DE: [
    "H",
    "hB"
  ],
  DG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  DJ: [
    "h",
    "H"
  ],
  DK: [
    "H"
  ],
  DM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  DO: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  DZ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  EC: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  EE: [
    "H",
    "hB"
  ],
  EG: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  EH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  ER: [
    "h",
    "H"
  ],
  ES: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  ET: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  FI: [
    "H"
  ],
  FJ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  FM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  FO: [
    "H",
    "h"
  ],
  FR: [
    "H",
    "hB"
  ],
  GA: [
    "H",
    "hB"
  ],
  GB: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GD: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GE: [
    "H",
    "hB",
    "h"
  ],
  GF: [
    "H",
    "hB"
  ],
  GG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GH: [
    "h",
    "H"
  ],
  GI: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  GL: [
    "H",
    "h"
  ],
  GM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GN: [
    "H",
    "hB"
  ],
  GP: [
    "H",
    "hB"
  ],
  GQ: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  GR: [
    "h",
    "H",
    "hb",
    "hB"
  ],
  GT: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  GU: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  GW: [
    "H",
    "hB"
  ],
  GY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  HK: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  HN: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  HR: [
    "H",
    "hB"
  ],
  HU: [
    "H",
    "h"
  ],
  IC: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  ID: [
    "H"
  ],
  IE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IL: [
    "H",
    "hB"
  ],
  IM: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IN: [
    "h",
    "H"
  ],
  IO: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  IQ: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  IR: [
    "hB",
    "H"
  ],
  IS: [
    "H"
  ],
  IT: [
    "H",
    "hB"
  ],
  JE: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  JM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  JO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  JP: [
    "H",
    "K",
    "h"
  ],
  KE: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  KG: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KH: [
    "hB",
    "h",
    "H",
    "hb"
  ],
  KI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KM: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  KN: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KP: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  KW: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  KY: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  KZ: [
    "H",
    "hB"
  ],
  LA: [
    "H",
    "hb",
    "hB",
    "h"
  ],
  LB: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  LC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LI: [
    "H",
    "hB",
    "h"
  ],
  LK: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  LR: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  LS: [
    "h",
    "H"
  ],
  LT: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  LU: [
    "H",
    "h",
    "hB"
  ],
  LV: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  LY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MA: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MC: [
    "H",
    "hB"
  ],
  MD: [
    "H",
    "hB"
  ],
  ME: [
    "H",
    "hB",
    "h"
  ],
  MF: [
    "H",
    "hB"
  ],
  MG: [
    "H",
    "h"
  ],
  MH: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MK: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ML: [
    "H"
  ],
  MM: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  MN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MO: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MP: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MQ: [
    "H",
    "hB"
  ],
  MR: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  MS: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  MT: [
    "H",
    "h"
  ],
  MU: [
    "H",
    "h"
  ],
  MV: [
    "H",
    "h"
  ],
  MW: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  MX: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  MY: [
    "hb",
    "hB",
    "h",
    "H"
  ],
  MZ: [
    "H",
    "hB"
  ],
  NA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  NC: [
    "H",
    "hB"
  ],
  NE: [
    "H"
  ],
  NF: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NG: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NI: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  NL: [
    "H",
    "hB"
  ],
  NO: [
    "H",
    "h"
  ],
  NP: [
    "H",
    "h",
    "hB"
  ],
  NR: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NU: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  NZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  OM: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PA: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PE: [
    "H",
    "hB",
    "h",
    "hb"
  ],
  PF: [
    "H",
    "h",
    "hB"
  ],
  PG: [
    "h",
    "H"
  ],
  PH: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PK: [
    "h",
    "hB",
    "H"
  ],
  PL: [
    "H",
    "h"
  ],
  PM: [
    "H",
    "hB"
  ],
  PN: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  PR: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  PS: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  PT: [
    "H",
    "hB"
  ],
  PW: [
    "h",
    "H"
  ],
  PY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  QA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  RE: [
    "H",
    "hB"
  ],
  RO: [
    "H",
    "hB"
  ],
  RS: [
    "H",
    "hB",
    "h"
  ],
  RU: [
    "H"
  ],
  RW: [
    "H",
    "h"
  ],
  SA: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SB: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SC: [
    "H",
    "h",
    "hB"
  ],
  SD: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SE: [
    "H"
  ],
  SG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SH: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SI: [
    "H",
    "hB"
  ],
  SJ: [
    "H"
  ],
  SK: [
    "H"
  ],
  SL: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  SM: [
    "H",
    "h",
    "hB"
  ],
  SN: [
    "H",
    "h",
    "hB"
  ],
  SO: [
    "h",
    "H"
  ],
  SR: [
    "H",
    "hB"
  ],
  SS: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ST: [
    "H",
    "hB"
  ],
  SV: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  SX: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  SY: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  SZ: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  TC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TD: [
    "h",
    "H",
    "hB"
  ],
  TF: [
    "H",
    "h",
    "hB"
  ],
  TG: [
    "H",
    "hB"
  ],
  TH: [
    "H",
    "h"
  ],
  TJ: [
    "H",
    "h"
  ],
  TL: [
    "H",
    "hB",
    "hb",
    "h"
  ],
  TM: [
    "H",
    "h"
  ],
  TN: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  TO: [
    "h",
    "H"
  ],
  TR: [
    "H",
    "hB"
  ],
  TT: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  TW: [
    "hB",
    "hb",
    "h",
    "H"
  ],
  TZ: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UA: [
    "H",
    "hB",
    "h"
  ],
  UG: [
    "hB",
    "hb",
    "H",
    "h"
  ],
  UM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  US: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  UY: [
    "H",
    "h",
    "hB",
    "hb"
  ],
  UZ: [
    "H",
    "hB",
    "h"
  ],
  VA: [
    "H",
    "h",
    "hB"
  ],
  VC: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VE: [
    "h",
    "H",
    "hB",
    "hb"
  ],
  VG: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VI: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  VN: [
    "H",
    "h"
  ],
  VU: [
    "h",
    "H"
  ],
  WF: [
    "H",
    "hB"
  ],
  WS: [
    "h",
    "H"
  ],
  XK: [
    "H",
    "hB",
    "h"
  ],
  YE: [
    "h",
    "hB",
    "hb",
    "H"
  ],
  YT: [
    "H",
    "hB"
  ],
  ZA: [
    "H",
    "h",
    "hb",
    "hB"
  ],
  ZM: [
    "h",
    "hb",
    "H",
    "hB"
  ],
  ZW: [
    "H",
    "h"
  ],
  "af-ZA": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "ar-001": [
    "h",
    "hB",
    "hb",
    "H"
  ],
  "ca-ES": [
    "H",
    "h",
    "hB"
  ],
  "en-001": [
    "h",
    "hb",
    "H",
    "hB"
  ],
  "es-BO": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-BR": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-EC": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-ES": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-GQ": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "es-PE": [
    "H",
    "h",
    "hB",
    "hb"
  ],
  "fr-CA": [
    "H",
    "h",
    "hB"
  ],
  "gl-ES": [
    "H",
    "h",
    "hB"
  ],
  "gu-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "hi-IN": [
    "hB",
    "h",
    "H"
  ],
  "it-CH": [
    "H",
    "h",
    "hB"
  ],
  "it-IT": [
    "H",
    "h",
    "hB"
  ],
  "kn-IN": [
    "hB",
    "h",
    "H"
  ],
  "ml-IN": [
    "hB",
    "h",
    "H"
  ],
  "mr-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "pa-IN": [
    "hB",
    "hb",
    "h",
    "H"
  ],
  "ta-IN": [
    "hB",
    "h",
    "hb",
    "H"
  ],
  "te-IN": [
    "hB",
    "h",
    "H"
  ],
  "zu-ZA": [
    "H",
    "hB",
    "hb",
    "h"
  ]
};
function qU(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r);
    if (a === "j") {
      for (var i = 0; r + 1 < e.length && e.charAt(r + 1) === a; )
        i++, r++;
      var o = 1 + (i & 1), s = i < 2 ? 1 : 3 + (i >> 1), l = "a", c = JU(t);
      for ((c == "H" || c == "k") && (s = 0); s-- > 0; )
        n += l;
      for (; o-- > 0; )
        n = c + n;
    } else
      a === "J" ? n += "H" : n += a;
  }
  return n;
}
function JU(e) {
  var t = e.hourCycle;
  if (t === void 0 && // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles && // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t)
    switch (t) {
      case "h24":
        return "k";
      case "h23":
        return "H";
      case "h12":
        return "h";
      case "h11":
        return "K";
      default:
        throw new Error("Invalid hourCycle");
    }
  var n = e.language, r;
  n !== "root" && (r = e.maximize().region);
  var a = z9[r || ""] || z9[n || ""] || z9["".concat(n, "-001")] || z9["001"];
  return a[0];
}
var D7, XU = new RegExp("^".concat(Vv.source, "*")), QU = new RegExp("".concat(Vv.source, "*$"));
function kt(e, t) {
  return { start: e, end: t };
}
var eZ = !!String.prototype.startsWith && "_a".startsWith("a", 1), tZ = !!String.fromCodePoint, rZ = !!Object.fromEntries, nZ = !!String.prototype.codePointAt, aZ = !!String.prototype.trimStart, iZ = !!String.prototype.trimEnd, oZ = !!Number.isSafeInteger, sZ = oZ ? Number.isSafeInteger : function(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
}, hl = !0;
try {
  var lZ = Zv("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  hl = ((D7 = lZ.exec("a")) === null || D7 === void 0 ? void 0 : D7[0]) === "a";
} catch {
  hl = !1;
}
var gp = eZ ? (
  // Native
  function(e, t, n) {
    return e.startsWith(t, n);
  }
) : (
  // For IE11
  function(e, t, n) {
    return e.slice(n, n + t.length) === t;
  }
), ml = tZ ? String.fromCodePoint : (
  // IE11
  function() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    for (var n = "", r = e.length, a = 0, i; r > a; ) {
      if (i = e[a++], i > 1114111)
        throw RangeError(i + " is not a valid code point");
      n += i < 65536 ? String.fromCharCode(i) : String.fromCharCode(((i -= 65536) >> 10) + 55296, i % 1024 + 56320);
    }
    return n;
  }
), yp = (
  // native
  rZ ? Object.fromEntries : (
    // Ponyfill
    function(e) {
      for (var t = {}, n = 0, r = e; n < r.length; n++) {
        var a = r[n], i = a[0], o = a[1];
        t[i] = o;
      }
      return t;
    }
  )
), Uv = nZ ? (
  // Native
  function(e, t) {
    return e.codePointAt(t);
  }
) : (
  // IE 11
  function(e, t) {
    var n = e.length;
    if (!(t < 0 || t >= n)) {
      var r = e.charCodeAt(t), a;
      return r < 55296 || r > 56319 || t + 1 === n || (a = e.charCodeAt(t + 1)) < 56320 || a > 57343 ? r : (r - 55296 << 10) + (a - 56320) + 65536;
    }
  }
), cZ = aZ ? (
  // Native
  function(e) {
    return e.trimStart();
  }
) : (
  // Ponyfill
  function(e) {
    return e.replace(XU, "");
  }
), uZ = iZ ? (
  // Native
  function(e) {
    return e.trimEnd();
  }
) : (
  // Ponyfill
  function(e) {
    return e.replace(QU, "");
  }
);
function Zv(e, t) {
  return new RegExp(e, t);
}
var fl;
if (hl) {
  var vp = Zv("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  fl = function(e, t) {
    var n;
    vp.lastIndex = t;
    var r = vp.exec(e);
    return (n = r[1]) !== null && n !== void 0 ? n : "";
  };
} else
  fl = function(e, t) {
    for (var n = []; ; ) {
      var r = Uv(e, t);
      if (r === void 0 || Kv(r) || mZ(r))
        break;
      n.push(r), t += r >= 65536 ? 2 : 1;
    }
    return ml.apply(void 0, n);
  };
var dZ = (
  /** @class */
  function() {
    function e(t, n) {
      n === void 0 && (n = {}), this.message = t, this.position = { offset: 0, line: 1, column: 1 }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
    }
    return e.prototype.parse = function() {
      if (this.offset() !== 0)
        throw Error("parser can only be used once");
      return this.parseMessage(0, "", !1);
    }, e.prototype.parseMessage = function(t, n, r) {
      for (var a = []; !this.isEOF(); ) {
        var i = this.char();
        if (i === 123) {
          var o = this.parseArgument(t, r);
          if (o.err)
            return o;
          a.push(o.val);
        } else {
          if (i === 125 && t > 0)
            break;
          if (i === 35 && (n === "plural" || n === "selectordinal")) {
            var s = this.clonePosition();
            this.bump(), a.push({
              type: a1.pound,
              location: kt(s, this.clonePosition())
            });
          } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
            if (r)
              break;
            return this.error(xt.UNMATCHED_CLOSING_TAG, kt(this.clonePosition(), this.clonePosition()));
          } else if (i === 60 && !this.ignoreTag && Cl(this.peek() || 0)) {
            var o = this.parseTag(t, n);
            if (o.err)
              return o;
            a.push(o.val);
          } else {
            var o = this.parseLiteral(t, n);
            if (o.err)
              return o;
            a.push(o.val);
          }
        }
      }
      return { val: a, err: null };
    }, e.prototype.parseTag = function(t, n) {
      var r = this.clonePosition();
      this.bump();
      var a = this.parseTagName();
      if (this.bumpSpace(), this.bumpIf("/>"))
        return {
          val: {
            type: a1.literal,
            value: "<".concat(a, "/>"),
            location: kt(r, this.clonePosition())
          },
          err: null
        };
      if (this.bumpIf(">")) {
        var i = this.parseMessage(t + 1, n, !0);
        if (i.err)
          return i;
        var o = i.val, s = this.clonePosition();
        if (this.bumpIf("</")) {
          if (this.isEOF() || !Cl(this.char()))
            return this.error(xt.INVALID_TAG, kt(s, this.clonePosition()));
          var l = this.clonePosition(), c = this.parseTagName();
          return a !== c ? this.error(xt.UNMATCHED_CLOSING_TAG, kt(l, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
            val: {
              type: a1.tag,
              value: a,
              children: o,
              location: kt(r, this.clonePosition())
            },
            err: null
          } : this.error(xt.INVALID_TAG, kt(s, this.clonePosition())));
        } else
          return this.error(xt.UNCLOSED_TAG, kt(r, this.clonePosition()));
      } else
        return this.error(xt.INVALID_TAG, kt(r, this.clonePosition()));
    }, e.prototype.parseTagName = function() {
      var t = this.offset();
      for (this.bump(); !this.isEOF() && hZ(this.char()); )
        this.bump();
      return this.message.slice(t, this.offset());
    }, e.prototype.parseLiteral = function(t, n) {
      for (var r = this.clonePosition(), a = ""; ; ) {
        var i = this.tryParseQuote(n);
        if (i) {
          a += i;
          continue;
        }
        var o = this.tryParseUnquoted(t, n);
        if (o) {
          a += o;
          continue;
        }
        var s = this.tryParseLeftAngleBracket();
        if (s) {
          a += s;
          continue;
        }
        break;
      }
      var l = kt(r, this.clonePosition());
      return {
        val: { type: a1.literal, value: a, location: l },
        err: null
      };
    }, e.prototype.tryParseLeftAngleBracket = function() {
      return !this.isEOF() && this.char() === 60 && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
      !pZ(this.peek() || 0)) ? (this.bump(), "<") : null;
    }, e.prototype.tryParseQuote = function(t) {
      if (this.isEOF() || this.char() !== 39)
        return null;
      switch (this.peek()) {
        case 39:
          return this.bump(), this.bump(), "'";
        case 123:
        case 60:
        case 62:
        case 125:
          break;
        case 35:
          if (t === "plural" || t === "selectordinal")
            break;
          return null;
        default:
          return null;
      }
      this.bump();
      var n = [this.char()];
      for (this.bump(); !this.isEOF(); ) {
        var r = this.char();
        if (r === 39)
          if (this.peek() === 39)
            n.push(39), this.bump();
          else {
            this.bump();
            break;
          }
        else
          n.push(r);
        this.bump();
      }
      return ml.apply(void 0, n);
    }, e.prototype.tryParseUnquoted = function(t, n) {
      if (this.isEOF())
        return null;
      var r = this.char();
      return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), ml(r));
    }, e.prototype.parseArgument = function(t, n) {
      var r = this.clonePosition();
      if (this.bump(), this.bumpSpace(), this.isEOF())
        return this.error(xt.EXPECT_ARGUMENT_CLOSING_BRACE, kt(r, this.clonePosition()));
      if (this.char() === 125)
        return this.bump(), this.error(xt.EMPTY_ARGUMENT, kt(r, this.clonePosition()));
      var a = this.parseIdentifierIfPossible().value;
      if (!a)
        return this.error(xt.MALFORMED_ARGUMENT, kt(r, this.clonePosition()));
      if (this.bumpSpace(), this.isEOF())
        return this.error(xt.EXPECT_ARGUMENT_CLOSING_BRACE, kt(r, this.clonePosition()));
      switch (this.char()) {
        case 125:
          return this.bump(), {
            val: {
              type: a1.argument,
              // value does not include the opening and closing braces.
              value: a,
              location: kt(r, this.clonePosition())
            },
            err: null
          };
        case 44:
          return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(xt.EXPECT_ARGUMENT_CLOSING_BRACE, kt(r, this.clonePosition())) : this.parseArgumentOptions(t, n, a, r);
        default:
          return this.error(xt.MALFORMED_ARGUMENT, kt(r, this.clonePosition()));
      }
    }, e.prototype.parseIdentifierIfPossible = function() {
      var t = this.clonePosition(), n = this.offset(), r = fl(this.message, n), a = n + r.length;
      this.bumpTo(a);
      var i = this.clonePosition(), o = kt(t, i);
      return { value: r, location: o };
    }, e.prototype.parseArgumentOptions = function(t, n, r, a) {
      var i, o = this.clonePosition(), s = this.parseIdentifierIfPossible().value, l = this.clonePosition();
      switch (s) {
        case "":
          return this.error(xt.EXPECT_ARGUMENT_TYPE, kt(o, l));
        case "number":
        case "date":
        case "time": {
          this.bumpSpace();
          var c = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var u = this.clonePosition(), d = this.parseSimpleArgStyleIfPossible();
            if (d.err)
              return d;
            var p = uZ(d.val);
            if (p.length === 0)
              return this.error(xt.EXPECT_ARGUMENT_STYLE, kt(this.clonePosition(), this.clonePosition()));
            var h = kt(u, this.clonePosition());
            c = { style: p, styleLocation: h };
          }
          var m = this.tryParseArgumentClose(a);
          if (m.err)
            return m;
          var f = kt(a, this.clonePosition());
          if (c && gp(c == null ? void 0 : c.style, "::", 0)) {
            var C = cZ(c.style.slice(2));
            if (s === "number") {
              var d = this.parseNumberSkeletonFromString(C, c.styleLocation);
              return d.err ? d : {
                val: { type: a1.number, value: r, location: f, style: d.val },
                err: null
              };
            } else {
              if (C.length === 0)
                return this.error(xt.EXPECT_DATE_TIME_SKELETON, f);
              var _ = C;
              this.locale && (_ = qU(C, this.locale));
              var p = {
                type: Ki.dateTime,
                pattern: _,
                location: c.styleLocation,
                parsedOptions: this.shouldParseSkeletons ? GU(_) : {}
              }, v = s === "date" ? a1.date : a1.time;
              return {
                val: { type: v, value: r, location: f, style: p },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? a1.number : s === "date" ? a1.date : a1.time,
              value: r,
              location: f,
              style: (i = c == null ? void 0 : c.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
        case "plural":
        case "selectordinal":
        case "select": {
          var w = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(","))
            return this.error(xt.EXPECT_SELECT_ARGUMENT_OPTIONS, kt(w, p5({}, w)));
          this.bumpSpace();
          var k = this.parseIdentifierIfPossible(), b = 0;
          if (s !== "select" && k.value === "offset") {
            if (!this.bumpIf(":"))
              return this.error(xt.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, kt(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var d = this.tryParseDecimalInteger(xt.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, xt.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (d.err)
              return d;
            this.bumpSpace(), k = this.parseIdentifierIfPossible(), b = d.val;
          }
          var S = this.tryParsePluralOrSelectOptions(t, s, n, k);
          if (S.err)
            return S;
          var m = this.tryParseArgumentClose(a);
          if (m.err)
            return m;
          var P = kt(a, this.clonePosition());
          return s === "select" ? {
            val: {
              type: a1.select,
              value: r,
              options: yp(S.val),
              location: P
            },
            err: null
          } : {
            val: {
              type: a1.plural,
              value: r,
              options: yp(S.val),
              offset: b,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: P
            },
            err: null
          };
        }
        default:
          return this.error(xt.INVALID_ARGUMENT_TYPE, kt(o, l));
      }
    }, e.prototype.tryParseArgumentClose = function(t) {
      return this.isEOF() || this.char() !== 125 ? this.error(xt.EXPECT_ARGUMENT_CLOSING_BRACE, kt(t, this.clonePosition())) : (this.bump(), { val: !0, err: null });
    }, e.prototype.parseSimpleArgStyleIfPossible = function() {
      for (var t = 0, n = this.clonePosition(); !this.isEOF(); ) {
        var r = this.char();
        switch (r) {
          case 39: {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'"))
              return this.error(xt.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, kt(a, this.clonePosition()));
            this.bump();
            break;
          }
          case 123: {
            t += 1, this.bump();
            break;
          }
          case 125: {
            if (t > 0)
              t -= 1;
            else
              return {
                val: this.message.slice(n.offset, this.offset()),
                err: null
              };
            break;
          }
          default:
            this.bump();
            break;
        }
      }
      return {
        val: this.message.slice(n.offset, this.offset()),
        err: null
      };
    }, e.prototype.parseNumberSkeletonFromString = function(t, n) {
      var r = [];
      try {
        r = ZU(t);
      } catch {
        return this.error(xt.INVALID_NUMBER_SKELETON, n);
      }
      return {
        val: {
          type: Ki.number,
          tokens: r,
          location: n,
          parsedOptions: this.shouldParseSkeletons ? YU(r) : {}
        },
        err: null
      };
    }, e.prototype.tryParsePluralOrSelectOptions = function(t, n, r, a) {
      for (var i, o = !1, s = [], l = /* @__PURE__ */ new Set(), c = a.value, u = a.location; ; ) {
        if (c.length === 0) {
          var d = this.clonePosition();
          if (n !== "select" && this.bumpIf("=")) {
            var p = this.tryParseDecimalInteger(xt.EXPECT_PLURAL_ARGUMENT_SELECTOR, xt.INVALID_PLURAL_ARGUMENT_SELECTOR);
            if (p.err)
              return p;
            u = kt(d, this.clonePosition()), c = this.message.slice(d.offset, this.offset());
          } else
            break;
        }
        if (l.has(c))
          return this.error(n === "select" ? xt.DUPLICATE_SELECT_ARGUMENT_SELECTOR : xt.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, u);
        c === "other" && (o = !0), this.bumpSpace();
        var h = this.clonePosition();
        if (!this.bumpIf("{"))
          return this.error(n === "select" ? xt.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : xt.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, kt(this.clonePosition(), this.clonePosition()));
        var m = this.parseMessage(t + 1, n, r);
        if (m.err)
          return m;
        var f = this.tryParseArgumentClose(h);
        if (f.err)
          return f;
        s.push([
          c,
          {
            value: m.val,
            location: kt(h, this.clonePosition())
          }
        ]), l.add(c), this.bumpSpace(), i = this.parseIdentifierIfPossible(), c = i.value, u = i.location;
      }
      return s.length === 0 ? this.error(n === "select" ? xt.EXPECT_SELECT_ARGUMENT_SELECTOR : xt.EXPECT_PLURAL_ARGUMENT_SELECTOR, kt(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !o ? this.error(xt.MISSING_OTHER_CLAUSE, kt(this.clonePosition(), this.clonePosition())) : { val: s, err: null };
    }, e.prototype.tryParseDecimalInteger = function(t, n) {
      var r = 1, a = this.clonePosition();
      this.bumpIf("+") || this.bumpIf("-") && (r = -1);
      for (var i = !1, o = 0; !this.isEOF(); ) {
        var s = this.char();
        if (s >= 48 && s <= 57)
          i = !0, o = o * 10 + (s - 48), this.bump();
        else
          break;
      }
      var l = kt(a, this.clonePosition());
      return i ? (o *= r, sZ(o) ? { val: o, err: null } : this.error(n, l)) : this.error(t, l);
    }, e.prototype.offset = function() {
      return this.position.offset;
    }, e.prototype.isEOF = function() {
      return this.offset() === this.message.length;
    }, e.prototype.clonePosition = function() {
      return {
        offset: this.position.offset,
        line: this.position.line,
        column: this.position.column
      };
    }, e.prototype.char = function() {
      var t = this.position.offset;
      if (t >= this.message.length)
        throw Error("out of bound");
      var n = Uv(this.message, t);
      if (n === void 0)
        throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      return n;
    }, e.prototype.error = function(t, n) {
      return {
        val: null,
        err: {
          kind: t,
          message: this.message,
          location: n
        }
      };
    }, e.prototype.bump = function() {
      if (!this.isEOF()) {
        var t = this.char();
        t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
      }
    }, e.prototype.bumpIf = function(t) {
      if (gp(this.message, t, this.offset())) {
        for (var n = 0; n < t.length; n++)
          this.bump();
        return !0;
      }
      return !1;
    }, e.prototype.bumpUntil = function(t) {
      var n = this.offset(), r = this.message.indexOf(t, n);
      return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
    }, e.prototype.bumpTo = function(t) {
      if (this.offset() > t)
        throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
      for (t = Math.min(t, this.message.length); ; ) {
        var n = this.offset();
        if (n === t)
          break;
        if (n > t)
          throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
        if (this.bump(), this.isEOF())
          break;
      }
    }, e.prototype.bumpSpace = function() {
      for (; !this.isEOF() && Kv(this.char()); )
        this.bump();
    }, e.prototype.peek = function() {
      if (this.isEOF())
        return null;
      var t = this.char(), n = this.offset(), r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
      return r ?? null;
    }, e;
  }()
);
function Cl(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function pZ(e) {
  return Cl(e) || e === 47;
}
function hZ(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function Kv(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function mZ(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function gl(e) {
  e.forEach(function(t) {
    if (delete t.location, Dv(t) || Iv(t))
      for (var n in t.options)
        delete t.options[n].location, gl(t.options[n].value);
    else
      Nv(t) && Fv(t.style) || (jv(t) || Rv(t)) && pl(t.style) ? delete t.style.location : Hv(t) && gl(t.children);
  });
}
function fZ(e, t) {
  t === void 0 && (t = {}), t = p5({ shouldParseSkeletons: !0, requiresOtherClause: !0 }, t);
  var n = new dZ(e, t).parse();
  if (n.err) {
    var r = SyntaxError(xt[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t != null && t.captureLocation || gl(n.val), n.val;
}
function I7(e, t) {
  var n = t && t.cache ? t.cache : _Z, r = t && t.serializer ? t.serializer : bZ, a = t && t.strategy ? t.strategy : gZ;
  return a(e, {
    cache: n,
    serializer: r
  });
}
function CZ(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function $v(e, t, n, r) {
  var a = CZ(r) ? r : n(r), i = t.get(a);
  return typeof i > "u" && (i = e.call(this, r), t.set(a, i)), i;
}
function Wv(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3), a = n(r), i = t.get(a);
  return typeof i > "u" && (i = e.apply(this, r), t.set(a, i)), i;
}
function F3(e, t, n, r, a) {
  return n.bind(t, e, r, a);
}
function gZ(e, t) {
  var n = e.length === 1 ? $v : Wv;
  return F3(e, this, n, t.cache.create(), t.serializer);
}
function yZ(e, t) {
  return F3(e, this, Wv, t.cache.create(), t.serializer);
}
function vZ(e, t) {
  return F3(e, this, $v, t.cache.create(), t.serializer);
}
var bZ = function() {
  return JSON.stringify(arguments);
};
function V3() {
  this.cache = /* @__PURE__ */ Object.create(null);
}
V3.prototype.get = function(e) {
  return this.cache[e];
};
V3.prototype.set = function(e, t) {
  this.cache[e] = t;
};
var _Z = {
  create: function() {
    return new V3();
  }
}, H7 = {
  variadic: yZ,
  monadic: vZ
}, $i;
(function(e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})($i || ($i = {}));
var x8 = (
  /** @class */
  function(e) {
    w8(t, e);
    function t(n, r, a) {
      var i = e.call(this, n) || this;
      return i.code = r, i.originalMessage = a, i;
    }
    return t.prototype.toString = function() {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error)
), bp = (
  /** @class */
  function(e) {
    w8(t, e);
    function t(n, r, a, i) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(a).join('", "'), '"'), $i.INVALID_VALUE, i) || this;
    }
    return t;
  }(x8)
), wZ = (
  /** @class */
  function(e) {
    w8(t, e);
    function t(n, r, a) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), $i.INVALID_VALUE, a) || this;
    }
    return t;
  }(x8)
), xZ = (
  /** @class */
  function(e) {
    w8(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), $i.MISSING_VALUE, r) || this;
    }
    return t;
  }(x8)
), ir;
(function(e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(ir || (ir = {}));
function SZ(e) {
  return e.length < 2 ? e : e.reduce(function(t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== ir.literal || n.type !== ir.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function kZ(e) {
  return typeof e == "function";
}
function g6(e, t, n, r, a, i, o) {
  if (e.length === 1 && hp(e[0]))
    return [
      {
        type: ir.literal,
        value: e[0].value
      }
    ];
  for (var s = [], l = 0, c = e; l < c.length; l++) {
    var u = c[l];
    if (hp(u)) {
      s.push({
        type: ir.literal,
        value: u.value
      });
      continue;
    }
    if (BU(u)) {
      typeof i == "number" && s.push({
        type: ir.literal,
        value: n.getNumberFormat(t).format(i)
      });
      continue;
    }
    var d = u.value;
    if (!(a && d in a))
      throw new xZ(d, o);
    var p = a[d];
    if (VU(u)) {
      (!p || typeof p == "string" || typeof p == "number") && (p = typeof p == "string" || typeof p == "number" ? String(p) : ""), s.push({
        type: typeof p == "string" ? ir.literal : ir.object,
        value: p
      });
      continue;
    }
    if (jv(u)) {
      var h = typeof u.style == "string" ? r.date[u.style] : pl(u.style) ? u.style.parsedOptions : void 0;
      s.push({
        type: ir.literal,
        value: n.getDateTimeFormat(t, h).format(p)
      });
      continue;
    }
    if (Rv(u)) {
      var h = typeof u.style == "string" ? r.time[u.style] : pl(u.style) ? u.style.parsedOptions : r.time.medium;
      s.push({
        type: ir.literal,
        value: n.getDateTimeFormat(t, h).format(p)
      });
      continue;
    }
    if (Nv(u)) {
      var h = typeof u.style == "string" ? r.number[u.style] : Fv(u.style) ? u.style.parsedOptions : void 0;
      h && h.scale && (p = p * (h.scale || 1)), s.push({
        type: ir.literal,
        value: n.getNumberFormat(t, h).format(p)
      });
      continue;
    }
    if (Hv(u)) {
      var m = u.children, f = u.value, C = a[f];
      if (!kZ(C))
        throw new wZ(f, "function", o);
      var _ = g6(m, t, n, r, a, i), v = C(_.map(function(b) {
        return b.value;
      }));
      Array.isArray(v) || (v = [v]), s.push.apply(s, v.map(function(b) {
        return {
          type: typeof b == "string" ? ir.literal : ir.object,
          value: b
        };
      }));
    }
    if (Dv(u)) {
      var w = u.options[p] || u.options.other;
      if (!w)
        throw new bp(u.value, p, Object.keys(u.options), o);
      s.push.apply(s, g6(w.value, t, n, r, a));
      continue;
    }
    if (Iv(u)) {
      var w = u.options["=".concat(p)];
      if (!w) {
        if (!Intl.PluralRules)
          throw new x8(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, $i.MISSING_INTL_API, o);
        var k = n.getPluralRules(t, { type: u.pluralType }).select(p - (u.offset || 0));
        w = u.options[k] || u.options.other;
      }
      if (!w)
        throw new bp(u.value, p, Object.keys(u.options), o);
      s.push.apply(s, g6(w.value, t, n, r, a, p - (u.offset || 0)));
      continue;
    }
  }
  return SZ(s);
}
function MZ(e, t) {
  return t ? Rn(Rn(Rn({}, e || {}), t || {}), Object.keys(e).reduce(function(n, r) {
    return n[r] = Rn(Rn({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function PZ(e, t) {
  return t ? Object.keys(e).reduce(function(n, r) {
    return n[r] = MZ(e[r], t[r]), n;
  }, Rn({}, e)) : e;
}
function F7(e) {
  return {
    create: function() {
      return {
        get: function(t) {
          return e[t];
        },
        set: function(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function EZ(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: I7(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, R7([void 0], n, !1)))();
    }, {
      cache: F7(e.number),
      strategy: H7.variadic
    }),
    getDateTimeFormat: I7(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, R7([void 0], n, !1)))();
    }, {
      cache: F7(e.dateTime),
      strategy: H7.variadic
    }),
    getPluralRules: I7(function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, R7([void 0], n, !1)))();
    }, {
      cache: F7(e.pluralRules),
      strategy: H7.variadic
    })
  };
}
/** @class */
(function() {
  function e(t, n, r, a) {
    var i = this;
    if (n === void 0 && (n = e.defaultLocale), this.formatterCache = {
      number: {},
      dateTime: {},
      pluralRules: {}
    }, this.format = function(l) {
      var c = i.formatToParts(l);
      if (c.length === 1)
        return c[0].value;
      var u = c.reduce(function(d, p) {
        return !d.length || p.type !== ir.literal || typeof d[d.length - 1] != "string" ? d.push(p.value) : d[d.length - 1] += p.value, d;
      }, []);
      return u.length <= 1 ? u[0] || "" : u;
    }, this.formatToParts = function(l) {
      return g6(i.ast, i.locales, i.formatters, i.formats, l, void 0, i.message);
    }, this.resolvedOptions = function() {
      var l;
      return {
        locale: ((l = i.resolvedLocale) === null || l === void 0 ? void 0 : l.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
      };
    }, this.getAst = function() {
      return i.ast;
    }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
      if (this.message = t, !e.__parse)
        throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
      var o = a || {};
      o.formatters;
      var s = FU(o, ["formatters"]);
      this.ast = e.__parse(t, Rn(Rn({}, s), { locale: this.resolvedLocale }));
    } else
      this.ast = t;
    if (!Array.isArray(this.ast))
      throw new TypeError("A message must be provided as a String or AST.");
    this.formats = PZ(e.formats, r), this.formatters = a && a.formatters || EZ(this.formatterCache);
  }
  return Object.defineProperty(e, "defaultLocale", {
    get: function() {
      return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
    },
    enumerable: !1,
    configurable: !0
  }), e.memoizedDefaultLocale = null, e.resolveLocale = function(t) {
    if (!(typeof Intl.Locale > "u")) {
      var n = Intl.NumberFormat.supportedLocalesOf(t);
      return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
    }
  }, e.__parse = fZ, e.formats = {
    number: {
      integer: {
        maximumFractionDigits: 0
      },
      currency: {
        style: "currency"
      },
      percent: {
        style: "percent"
      }
    },
    date: {
      short: {
        month: "numeric",
        day: "numeric",
        year: "2-digit"
      },
      medium: {
        month: "short",
        day: "numeric",
        year: "numeric"
      },
      long: {
        month: "long",
        day: "numeric",
        year: "numeric"
      },
      full: {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      }
    },
    time: {
      short: {
        hour: "numeric",
        minute: "numeric"
      },
      medium: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      },
      long: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
      },
      full: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZoneName: "short"
      }
    }
  }, e;
})();
const y6 = (e) => e, z1 = (e, t) => {
  Re(() => {
    t(e);
  }, [e]);
};
var yl = /* @__PURE__ */ ((e) => (e.Editor = "editor", e.Community = "community", e.BlockPreview = "block_preview", e.Membership = "membership", e.Marketplace = "marketplace", e.Settings = "settings", e.Email = "email", e.Ckeditor = "ckeditor", e.TextEditor = "text_editor", e.BlogPost = "blog_post", e.PageTemplate = "page_template", e.PageTemplatePreview = "page_template_preview", e.BlogTemplatePreview = "blog_template_preview", e.EmailTemplate = "email_template", e.WebsiteTemplate = "website_template", e.Product = "product", e.FunnelTemplatePreview = "funnel_template_preview", e.DigitalStore = "digital_store", e.DigitalProductResource = "digital_product_resource", e.CalendarHostAvatar = "calendar_host_avatar", e.FileManager = "file_manager", e.WhiteLabel = "white_label", e))(yl || {}), vl = /* @__PURE__ */ ((e) => (e.Image = "image", e.ImageOther = "image_other", e.Video = "video", e.Audio = "audio", e.Font = "font", e.Document = "document", e))(vl || {});
yl.WhiteLabel, vl.Image, yl.WhiteLabel, vl.Image;
const Yv = Qe(null), Rne = ({
  children: e,
  locale: t
}) => {
  const { setLocale: n } = Rt();
  return z1(t, (r) => {
    const a = C9(r);
    k1.language !== a && k1.changeLanguage(a), n(r);
  }), /* @__PURE__ */ x.jsx(cN, { locale: t, children: /* @__PURE__ */ x.jsx(Yv.Provider, { value: { locale: t }, children: e }) });
}, qr = () => {
  const e = Ue(Yv);
  if (!e)
    throw new Error("useLocaleContext must be used within a LocaleProvider");
  return e;
};
var mt = /* @__PURE__ */ ((e) => (e.default = "default", e.luminous = "luminous", e.night = "night", e.camilla = "camilla", e.creamy = "creamy", e.sepia = "sepia", e.urban = "urban", e.solarized = "solarized", e.cosmopolitan = "cosmopolitan", e.new_york = "new_york", e.cyberpunk = "cyberpunk", e))(mt || {}), R1 = /* @__PURE__ */ ((e) => (e.Arizonia = "arizonia", e.Inter = "inter", e.Kanit = "kanit", e.Lato = "lato", e.Lora = "lora", e.Merriweather = "merriweather", e.Montserrat = "montserrat", e.NotoSans = "notosans", e.Nunito = "nunito", e.OpenSans = "opensans", e.PlayfairDisplay = "playfairdisplay", e.Poppins = "poppins", e.Roboto = "roboto", e.SourceSansPro = "sourcesanspro", e.Ubuntu = "ubuntu", e))(R1 || {}), w2 = /* @__PURE__ */ ((e) => (e.primaryColor = "--THEME-primary", e.secondaryColor = "--THEME-secondary", e.tertiaryColor = "--THEME-tertiary", e.textColorPrimary = "--THEME-text-primary", e.textColorSecondary = "--THEME-text-secondary", e.borderColorTertiary = "--THEME-border-tertiary", e))(w2 || {}), bl = /* @__PURE__ */ ((e) => (e.primaryFont = "--THEME-font-primary", e.secondaryFont = "--THEME-font-secondary", e))(bl || {});
const sn = {
  primaryFont: R1.Inter,
  secondaryFont: R1.Inter
}, _l = {
  [mt.default]: {
    theme: mt.default,
    primaryColor: "#00A0FF",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F1F4F8",
    ...sn
  },
  [mt.luminous]: {
    theme: mt.luminous,
    primaryColor: "#6620FA",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F8F5FF",
    ...sn
  },
  [mt.night]: {
    theme: mt.night,
    primaryColor: "#FC3C67",
    secondaryColor: "#0A1733",
    tertiaryColor: "#142D63",
    ...sn
  },
  [mt.camilla]: {
    theme: mt.camilla,
    primaryColor: "#EEFF34",
    secondaryColor: "#121212",
    tertiaryColor: "#121212",
    ...sn
  },
  [mt.creamy]: {
    theme: mt.creamy,
    primaryColor: "#E40160",
    secondaryColor: "#FCF1E3",
    tertiaryColor: "#FFFAF4",
    ...sn
  },
  [mt.sepia]: {
    theme: mt.sepia,
    primaryColor: "#E7961B",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#FFF7EB",
    ...sn
  },
  [mt.solarized]: {
    theme: mt.solarized,
    primaryColor: "#00A0FF",
    secondaryColor: "#011420",
    tertiaryColor: "#011420",
    ...sn
  },
  [mt.new_york]: {
    theme: mt.new_york,
    primaryColor: "#FFC634",
    secondaryColor: "#01133A",
    tertiaryColor: "#01133A",
    ...sn
  },
  [mt.urban]: {
    theme: mt.urban,
    primaryColor: "#F57F29",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F9F9F9",
    ...sn
  },
  [mt.cyberpunk]: {
    theme: mt.cyberpunk,
    primaryColor: "#AE3ECA",
    secondaryColor: "#131114",
    tertiaryColor: "#1e1533",
    ...sn
  },
  [mt.cosmopolitan]: {
    theme: mt.cosmopolitan,
    primaryColor: "#D9335a",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F9F9F9",
    ...sn
  }
}, _p = "root-design-css", wp = "root-font-css", TZ = (e) => {
  const {
    primaryColor: t,
    secondaryColor: n,
    tertiaryColor: r,
    textColorPrimary: a,
    textColorSecondary: i,
    borderColorTertiary: o
  } = S8(e);
  return `
  :root {
      /* Colors */
      /* Default primary color */
      ${w2.primaryColor}: ${t}; /* Default primary color */

      /* Default secondary color */
      ${w2.secondaryColor}: ${n}; /* Default secondary color */

      /* Default background color */
      ${w2.tertiaryColor}: ${r}; /* Default background color */

      /* Default text primary color */
      ${w2.textColorPrimary}: ${a}; /* Default text primary color */
      ${w2.textColorSecondary}: ${i}; /* Default text secondary color */
      ${w2.borderColorTertiary}: ${o}; /* Default border tertiry color */
      
      /* Fonts */
      ${bl.primaryFont}: ${e.primaryFont};
      ${bl.secondaryFont}: ${e.secondaryFont};
  }
  `;
}, LZ = (e, t) => {
  const n = t ?? document, r = TZ(e), a = n.createElement("style");
  a.id = _p;
  const i = n.getElementById(_p);
  i && i.remove(), a.append(r), n.head.append(a);
  const o = AZ(e.primaryFont, e.secondaryFont), s = n.createElement("style");
  s.id = wp;
  const l = n.getElementById(wp);
  l && l.remove(), s.append(o), n.head.append(s);
}, qv = "https://d1asgbu35ychbr.cloudfront.net", Jv = "https://d3syewzhvzylbl.cloudfront.net/fonts/google-fonts", xp = {
  [R1.Inter]: [400, 500, 600, 700],
  [R1.Roboto]: [400, 500, 700],
  [R1.Lato]: [400, 700],
  [R1.Montserrat]: [400, 500, 600, 700],
  [R1.OpenSans]: [400, 600, 700],
  [R1.Poppins]: [400, 500, 600, 700],
  [R1.Arizonia]: [400],
  [R1.Kanit]: [400, 500, 600, 700],
  [R1.Merriweather]: [400, 700],
  [R1.NotoSans]: [400, 700],
  [R1.Nunito]: [400, 600, 700],
  [R1.PlayfairDisplay]: [400, 500, 600, 700],
  [R1.SourceSansPro]: [400, 600, 700],
  [R1.Ubuntu]: [400, 500, 700],
  [R1.Lora]: [400, 500, 600, 700]
}, AZ = (e, t) => {
  const n = [];
  return xp[e].forEach((r) => {
    n.push(Sp({ fontFamily: e, fontWeight: r }));
  }), xp[t].forEach((r) => {
    n.push(Sp({ fontFamily: t, fontWeight: r }));
  }), n.join(`
`);
}, Sp = ({
  fontFamily: e,
  fontWeight: t
}) => `@font-face {
  font-family: '${e}';
  font-style: normal;
  font-weight: ${t};
  font-display: swap;
  src: url('${Jv}/${e}/${OZ(
  t
)}.woff2') format('woff2');
  }
  `, OZ = (e) => e === 400 ? "regular" : e, Dne = ({
  fontFamily: e
}) => `@font-face {
  font-family: '${e}';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('${Jv}/${e}/preview/preview.woff2') format('woff2');
  }
  `;
function V7(e) {
  return parseInt(e, 16) || 0;
}
function B7(e) {
  return V7(e) / 255 <= 0.03928 ? V7(e) / 255 / 12.92 : Math.pow((V7(e) / 255 + 0.055) / 1.055, 2.4);
}
function kp(e) {
  return 0.2126 * B7(e.substr(1, 2)) + 0.7152 * B7(e.substr(3, 2)) + 0.0722 * B7(e.substr(-2));
}
function h5(e, t) {
  const n = kp(e), r = kp(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
const Mp = "#ffffff", wl = "#000000", Pp = "#ffffff33", Ep = "#00000033";
function v6(e) {
  const t = h5(e, Mp), n = h5(e, wl);
  return t > n ? Mp : wl;
}
const NZ = (e) => {
  const t = h5(e, Pp), n = h5(e, Ep);
  return t > n ? Pp : Ep;
}, Xv = (e) => v6(e) === wl, S8 = (e) => {
  const { primaryColor: t, secondaryColor: n, tertiaryColor: r } = e, a = v6(t), i = v6(n), o = v6(r), s = NZ(r);
  return {
    primaryColor: t,
    secondaryColor: n,
    tertiaryColor: r,
    textColorPrimary: a,
    textColorSecondary: i,
    textColorTertiary: o,
    borderColorTertiary: s
  };
}, Qv = Qe(null), Ine = ({
  children: e,
  design: t,
  customRoot: n
}) => {
  const [r, a] = ke(t);
  return Re(() => {
    a(t);
  }, [t]), Re(() => {
    LZ(r, n);
  }, [r, n]), /* @__PURE__ */ x.jsx(Qv.Provider, { value: { state: r, setState: a }, children: e });
}, wr = () => {
  const e = Ue(Qv), t = (e == null ? void 0 : e.state.theme) === mt.default, n = (e == null ? void 0 : e.state.primaryColor) === _l[mt.default].primaryColor && (e == null ? void 0 : e.state.theme) === mt.default;
  if (!e)
    throw new Error("useDesignContext must be used within a DesignProvider");
  return { ...e, isDefaultTheme: t, isDefaultSioColor: n };
}, eb = "w-full h-full flex items-center flex-col gap-5", B3 = ({ children: e }) => /* @__PURE__ */ x.jsx("div", { className: eb, children: e }), jZ = "flex w-full min-h-screen py-5 [&>*]:h-fit [&>*]:m-auto", Hne = ({ children: e }) => /* @__PURE__ */ x.jsx("div", { className: jZ, children: e });
var $e = /* @__PURE__ */ ((e) => (e.link_thumbnail = "link_thumbnail", e.optin_thumbnail = "optin_thumbnail", e.profile = "profile", e.product_download_thumbnail = "product_download_thumbnail", e.product_download_cover = "product_download_cover", e.e_course_thumbnail = "e_course_thumbnail", e.e_course_cover = "e_course_cover", e.physical_product_thumbnail = "physical_product_thumbnail", e.physical_product_cover = "physical_product_cover", e))($e || {}), Vn = /* @__PURE__ */ ((e) => (e.link = "link", e.optin = "optin", e.header = "header", e.product = "product", e))(Vn || {}), RZ = /* @__PURE__ */ ((e) => (e.button = "button", e.callout = "callout", e.preview = "preview", e))(RZ || {});
function DZ({ primaryColor: e, secondaryColor: t, ...n }) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "128",
      height: "128",
      viewBox: "0 0 128 128",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ x.jsxs("g", { clipPath: "url(#clip0_34300_1538)", children: [
          /* @__PURE__ */ x.jsx("path", { d: "M128 64.0015C128 80.9749 121.257 97.2532 109.255 109.255C97.2532 121.257 80.975 128 64.0015 128C47.0281 128 30.7498 121.257 18.7478 109.255C6.74573 97.2532 0.00305176 80.9749 0.00305176 64.0015C0.00305176 28.6553 28.6569 0.00299072 64.0015 0.00299072C99.3461 0.00299072 128 28.6538 128 64.0015Z" }),
          /* @__PURE__ */ x.jsx(
            "path",
            {
              d: "M64 67.4342C78.44 67.4342 90.146 55.7282 90.146 41.2882C90.146 26.8482 78.44 15.1422 64 15.1422C49.56 15.1422 37.854 26.8482 37.854 41.2882C37.854 55.7282 49.56 67.4342 64 67.4342Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ x.jsx(
            "path",
            {
              d: "M108.05 102.978C107.539 103.557 107.014 104.128 106.478 104.685C100.988 110.417 94.3938 114.979 87.0937 118.096C79.7936 121.212 71.9382 122.819 64.0007 122.819C56.0632 122.819 48.2078 121.212 40.9077 118.096C33.6076 114.979 27.0139 110.417 21.5236 104.685C20.9878 104.128 20.4626 103.557 19.9497 102.978C19.9497 92.1073 23.7345 79.2693 34.0171 72.528C38.6639 69.4812 44.7223 69.7017 49.2083 72.9873C52.6517 75.5059 57.0948 77.0692 63.9999 77.0692C70.905 77.0692 75.3497 75.5059 78.7931 72.9873C83.2791 69.7078 89.3375 69.4873 93.9843 72.528C104.267 79.2693 108.05 92.1073 108.05 102.978Z",
              fill: "white"
            }
          )
        ] }),
        /* @__PURE__ */ x.jsx("defs", { children: /* @__PURE__ */ x.jsx("clipPath", { id: "clip0_34300_1538", children: /* @__PURE__ */ x.jsx("rect", { width: "128", height: "128", fill: "white" }) }) })
      ]
    }
  );
}
function IZ({ primaryColor: e, secondaryColor: t, ...n }) {
  return /* @__PURE__ */ x.jsx("svg", { width: "50", height: "50", viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg", ...n, children: /* @__PURE__ */ x.jsx("path", { d: "M24.9486 49.5817C20.0334 49.5817 15.1168 49.5844 10.2016 49.5817C5.13151 49.5778 1.10694 46.3184 0.160213 41.4345C0.0493842 40.8593 0.0106611 40.2631 0.00932579 39.6761C-2.12604e-05 29.8939 -0.00402697 20.113 0.00532007 10.3308C0.0106612 4.78766 4.4238 0.434324 10.0521 0.426445C20.016 0.413312 29.9813 0.413312 39.9452 0.426445C45.5748 0.433011 49.9853 4.78372 49.992 10.3282C50.0027 20.1104 50.0027 29.8913 49.992 39.6735C49.9853 45.2376 45.5655 49.5673 39.8945 49.5778C34.9125 49.5883 29.9306 49.5804 24.9472 49.5804L24.9486 49.5817ZM15.6416 34.2052V18.8641C15.8659 18.8641 16.0609 18.8641 16.2558 18.8641C18.2054 18.8641 20.1535 18.8641 22.1031 18.8641C22.2366 18.8641 22.3701 18.8681 22.5023 18.8615C23.1499 18.8313 23.4063 18.5791 23.4183 17.9527C23.425 17.5601 23.4223 17.1661 23.4183 16.7735C23.4117 16.0459 23.1606 15.7885 22.4329 15.7872C19.9346 15.7833 17.4349 15.778 14.9366 15.7885C13.4838 15.7951 12.5023 16.7787 12.501 18.2154C12.497 23.769 12.497 29.3226 12.501 34.8749C12.501 36.3103 13.4904 37.2886 14.9459 37.29C20.6102 37.2952 26.2745 37.2952 31.9388 37.29C33.3022 37.29 34.3277 36.3812 34.3584 35.0535C34.4051 33.0075 34.3798 30.9589 34.3677 28.9103C34.3651 28.3758 34.0633 28.1013 33.5185 28.079C33.1032 28.0619 32.6853 28.0711 32.2687 28.0751C31.5049 28.0816 31.2512 28.3246 31.2485 29.0836C31.2431 30.607 31.2472 32.1303 31.2472 33.6536C31.2472 33.8296 31.2472 34.0056 31.2472 34.2039H15.6403L15.6416 34.2052ZM31.0188 16.3769C29.2829 18.0814 27.6098 19.7243 25.9367 21.3684C23.6987 23.5681 21.4595 25.7677 19.2242 27.9713C18.5872 28.599 18.5886 29.2202 19.2135 29.8545C19.4458 30.0896 19.6835 30.3194 19.9199 30.5505C20.7464 31.3608 21.2912 31.3608 22.1204 30.5452C25.8539 26.8735 29.5887 23.203 33.3182 19.5273C33.4544 19.3933 33.5305 19.199 33.668 18.9784C34.3584 19.6744 34.9018 20.2286 35.4507 20.7749C35.8259 21.1478 36.2692 21.2752 36.7726 21.0625C37.268 20.8523 37.4977 20.4636 37.4977 19.9344C37.4963 17.9527 37.5017 15.9711 37.495 13.9881C37.4923 13.1752 37.017 12.7169 36.1824 12.7143C34.1835 12.7077 32.1845 12.7143 30.1856 12.7103C29.6301 12.7103 29.2148 12.9178 28.9932 13.43C28.7702 13.9487 28.9278 14.3847 29.3257 14.7616C29.8771 15.2829 30.4246 15.8096 31.0175 16.3756L31.0188 16.3769Z" }) });
}
function HZ({ primaryColor: e, secondaryColor: t, ...n }) {
  return /* @__PURE__ */ x.jsx("svg", { width: "50", height: "47", viewBox: "0 0 50 47", xmlns: "http://www.w3.org/2000/svg", ...n, children: /* @__PURE__ */ x.jsx("path", { d: "M49.9985 16.8733V40.7569C49.9694 40.8466 49.933 40.9335 49.9141 41.0262C49.266 44.2437 46.8221 46.2651 43.5451 46.2651C31.1756 46.2695 18.8076 46.2709 6.43808 46.2651C2.72272 46.2637 0.000647304 43.5429 0.000647304 39.8533C-0.00080913 32.5394 0.000647304 25.2255 0.000647304 17.9115C0.000647304 15.2747 1.15997 13.3329 3.4888 12.0717C10.2263 8.42125 16.9652 4.77371 23.691 1.10444C24.5969 0.610663 25.4139 0.60342 26.3126 1.10154C28.7681 2.46267 31.2455 3.78761 33.7142 5.12703C37.9815 7.44095 42.2445 9.76067 46.5162 12.0645C48.1256 12.9318 49.2354 14.1916 49.7568 15.9466C49.8485 16.2536 49.9199 16.5649 50 16.8748L49.9985 16.8733ZM45.8244 18.734C45.8244 18.443 45.8142 18.1519 45.8259 17.8609C45.8666 16.8632 45.4093 16.1797 44.5369 15.7091C38.1577 12.2585 31.7815 8.79919 25.4096 5.33409C25.1256 5.17915 24.9042 5.14006 24.6158 5.32395C24.2211 5.57736 23.7929 5.77863 23.3793 6.00307C17.3744 9.26111 11.371 12.5206 5.36469 15.7743C4.57676 16.2014 4.16896 16.8386 4.17478 17.7349C4.17915 18.414 4.19809 19.0946 4.16605 19.7722C4.14857 20.1371 4.28984 20.3066 4.60298 20.4702C10.8147 23.6848 17.0278 26.8921 23.2162 30.1502C24.4644 30.8076 25.5625 30.796 26.8034 30.1429C32.6757 27.0514 38.5641 23.9889 44.4757 20.9741C45.4792 20.4629 46.1871 19.9692 45.8244 18.734Z" }) });
}
function FZ({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) {
  return /* @__PURE__ */ x.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "50", height: "50", viewBox: "0 0 50 50", ...n, children: /* @__PURE__ */ x.jsx("path", { d: "M8.4003 0.636108C19.4679 0.636108 30.5342 0.636108 41.6018 0.636108C41.709 0.666399 41.8148 0.70986 41.9246 0.726981C45.5946 1.31436 48.1101 3.31224 49.4361 6.72194C49.7053 7.41467 49.8152 8.16799 50 8.89366V41.5393C49.9692 41.646 49.925 41.75 49.9076 41.858C49.1749 46.5439 45.3777 49.7863 40.5557 49.7929C30.1927 49.8061 19.8296 49.8113 9.46648 49.7745C8.41101 49.7705 7.30867 49.6072 6.31214 49.274C2.41978 47.9728 0.0128507 44.5684 0.00615361 40.4897C-0.00456175 33.9956 0.00347216 27.5001 0.00347216 21.006C0.00347216 17.3106 -0.00590117 13.6151 0.00615361 9.92091C0.0195478 5.81189 2.48943 2.41405 6.42063 1.10628C7.06087 0.892922 7.73996 0.790197 8.40164 0.636108H8.4003ZM23.5357 26.5572C23.4822 26.5954 23.4286 26.6322 23.375 26.6704C23.2625 26.5163 23.1687 26.3425 23.0348 26.2095C21.4623 24.6568 19.8898 23.104 18.3053 21.5631C17.7736 21.0456 17.1119 20.9586 16.5212 21.2866C15.9519 21.6026 15.6345 22.2532 15.8381 22.8828C15.9412 23.2002 16.1663 23.507 16.41 23.748C18.8384 26.1555 21.2815 28.5498 23.7206 30.9454C24.6327 31.841 25.3667 31.8436 26.2708 30.9559C28.1808 29.0792 30.0909 27.2025 32.0009 25.3245C32.6103 24.7252 33.2251 24.13 33.8238 23.5202C34.235 23.1014 34.3221 22.5891 34.1346 22.0504C33.9511 21.5236 33.5452 21.2115 32.9907 21.118C32.4281 21.0219 31.9861 21.2629 31.5964 21.6474C30.0359 23.1896 28.4702 24.7252 26.9044 26.2622C26.7852 26.3794 26.6553 26.4874 26.4651 26.6586V26.0462C26.4651 21.28 26.4651 16.5138 26.4651 11.7476C26.4651 11.5711 26.4731 11.3946 26.4557 11.2208C26.3713 10.3397 25.577 9.76419 24.693 9.93672C23.963 10.079 23.5371 10.6637 23.5357 11.5421C23.5344 16.3729 23.5357 21.2023 23.5357 26.033C23.5357 26.2082 23.5357 26.382 23.5357 26.5572ZM25.0533 37.666C20.4819 37.666 15.9104 37.666 11.339 37.666C11.1274 37.666 10.9144 37.6647 10.7054 37.6871C9.89375 37.774 9.33655 38.4799 9.44103 39.2741C9.5522 40.1209 10.1536 40.5436 11.2573 40.545C20.4162 40.545 29.5752 40.545 38.7355 40.545C38.9458 40.545 39.1601 40.5384 39.3663 40.5028C40.1834 40.3659 40.6857 39.6599 40.5491 38.8553C40.4178 38.0848 39.8378 37.6673 38.8654 37.6673C34.2618 37.6647 29.6569 37.6673 25.0533 37.6673V37.666Z" }) });
}
const VZ = ({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) => /* @__PURE__ */ x.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "398",
    height: "240",
    viewBox: "0 0 398 240",
    ...n,
    children: [
      /* @__PURE__ */ x.jsx("rect", { x: "0.5", width: "397", height: "240", rx: "47" }),
      /* @__PURE__ */ x.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M121.997 98.5457V101.851C122.145 102.825 122.296 103.798 122.448 104.771C122.809 107.093 123.17 109.416 123.487 111.745C125.072 123.386 126.634 135.037 128.185 146.682C128.373 148.085 128.563 149.489 128.752 150.892C129.513 156.524 130.274 162.158 130.925 167.806C131.791 175.334 138.051 181.27 145.654 181.454C148.495 181.522 151.339 181.509 154.182 181.497C155.301 181.492 156.421 181.487 157.54 181.487C164.734 181.487 171.929 181.486 179.123 181.486C203.116 181.483 227.11 181.481 251.105 181.506C256.414 181.511 260.776 179.674 264.079 175.494C265.962 173.114 266.865 170.356 267.249 167.367C268.597 156.803 269.984 146.243 271.375 135.683C271.767 132.711 272.148 129.736 272.528 126.761C273.557 118.725 274.585 110.687 275.846 102.687C276.787 96.7134 273.348 89.4454 267.4 86.7016C265.129 85.658 262.763 85.1243 260.275 85.1243C249.142 85.1243 238.01 85.1233 226.878 85.1222C197.193 85.1194 167.51 85.1166 137.824 85.1338C129.879 85.1385 124.041 89.9318 122.266 97.7098C122.225 97.8987 122.159 98.0834 122.093 98.2681C122.06 98.3605 122.027 98.4528 121.997 98.5457ZM159.9 135.161C159.86 135.354 159.819 135.547 159.777 135.739H159.775V138.826C159.788 138.854 159.803 138.881 159.819 138.908C159.854 138.97 159.889 139.032 159.897 139.098C160.694 146.032 166.865 151.814 174.696 151.676C179.548 151.591 184.402 151.608 189.257 151.626C191.748 151.635 194.239 151.643 196.73 151.639C197.242 151.639 197.566 151.785 197.889 152.195C200.401 155.391 202.931 158.575 205.48 161.742C205.929 162.298 206.429 162.841 206.999 163.265C209.967 165.48 213.843 164.863 216.305 161.795C216.473 161.586 216.641 161.377 216.809 161.168C218.993 158.447 221.177 155.725 223.306 152.962C223.992 152.076 224.661 151.391 225.882 151.599C226.012 151.622 226.15 151.59 226.289 151.558C226.357 151.542 226.425 151.526 226.492 151.517C233.278 150.589 238.453 145.071 238.924 138.261C239.388 131.535 235.069 125.364 228.533 123.51C227.666 123.264 226.768 123.125 225.861 122.984C225.437 122.918 225.012 122.852 224.587 122.774C224.356 117.688 222.215 113.55 217.813 110.785C213.386 108.003 208.705 107.888 203.946 109.925C199.169 102.446 190.654 99.8649 183.812 102.071C173.554 105.378 169.703 112.863 170.829 123.302C170.787 123.314 170.741 123.326 170.691 123.339C170.607 123.36 170.515 123.384 170.424 123.412C165.063 125.042 161.626 128.539 160.175 133.954C160.068 134.352 159.984 134.756 159.9 135.161ZM205.024 140.871H205.974L205.978 140.874V139.834V123.329C205.978 121.636 206.497 121.119 208.193 121.119C208.503 121.118 208.812 121.118 209.122 121.118C210.667 121.116 212.211 121.114 213.756 121.119C215.264 121.123 215.871 121.721 215.871 123.22C215.873 126.923 215.872 130.625 215.872 134.327C215.872 136.178 215.871 138.029 215.871 139.88V140.874H216.778C217.672 140.874 218.567 140.874 219.461 140.874C220.653 140.874 221.845 140.873 223.038 140.876C223.761 140.876 224.349 141.14 224.682 141.814C225.017 142.492 224.858 143.109 224.403 143.678C223.178 145.217 221.954 146.757 220.729 148.297C217.936 151.811 215.143 155.324 212.341 158.83C211.451 159.944 210.337 159.917 209.439 158.789C207.581 156.458 205.725 154.125 203.869 151.791C201.754 149.133 199.639 146.474 197.521 143.818C197.035 143.21 196.781 142.577 197.133 141.83C197.486 141.082 198.141 140.867 198.919 140.869C200.344 140.875 201.768 140.874 203.193 140.873C203.803 140.872 204.414 140.871 205.024 140.871Z",
          fill: t
        }
      ),
      /* @__PURE__ */ x.jsx(
        "path",
        {
          d: "M260.79 79.7267H137.383C137.289 79.5331 137.171 79.4056 137.175 79.2734C137.213 75.4245 137.104 71.5662 137.346 67.7268C137.686 62.3857 142.247 57.9276 147.589 57.7435C152.997 57.5593 158.415 57.6537 163.828 57.649C171.748 57.6396 179.669 57.6726 187.589 57.6254C188.971 57.6159 189.931 58.0551 190.807 59.1272C193.461 62.3857 196.229 65.5545 198.898 68.8083C199.593 69.6583 200.303 70.0078 201.429 70.0078C217.223 69.9653 233.012 69.9747 248.805 69.9842C254.299 69.9842 258.235 72.5485 260.099 77.2994C260.383 78.0266 260.53 78.8058 260.785 79.7267H260.79Z",
          fill: t
        }
      )
    ]
  }
);
function BZ({ primaryColor: e, secondaryColor: t, ...n }) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "59",
      height: "61",
      viewBox: "0 0 59 61",
      style: { maxHeight: 61 },
      ...n,
      children: [
        /* @__PURE__ */ x.jsx("path", { d: "M53.6899 23.3603C53.4756 22.7929 53.0763 22.4258 52.5326 22.1498C44.384 18.0012 36.2381 13.8498 28.1034 9.67457C27.3216 9.27386 26.6589 9.28647 25.8855 9.68297C17.8433 13.8078 9.78845 17.9115 1.73363 22.0125C1.00507 22.3838 0.325541 22.7747 0.32414 23.7148C0.322739 24.6535 0.99386 25.05 1.72382 25.4227C9.79405 29.5307 17.8629 33.6443 25.9219 37.7761C26.6575 38.1529 27.3006 38.1782 28.0473 37.7957C36.1834 33.6232 44.3293 29.469 52.478 25.3232C53.0342 25.0402 53.4616 24.6787 53.6899 24.0959V23.3603Z" }),
        /* @__PURE__ */ x.jsx("path", { d: "M1.53892 28.9366C1.53892 29.6666 1.53892 30.2761 1.53892 30.8855C1.53892 33.3654 1.54452 35.8454 1.53051 38.3239C1.52911 38.6279 1.46186 38.9474 1.35537 39.2346C0.971479 40.2812 0.52173 41.3054 0.163053 42.3618C-0.395978 44.0095 0.528738 45.7818 2.1666 46.3002C3.84089 46.8298 5.64268 45.9093 6.08683 44.207C6.23394 43.6466 6.14287 43.0091 6.08262 42.4136C6.049 42.0774 5.88647 41.7425 5.72955 41.4343C4.84967 39.7109 4.58487 37.8937 4.68995 35.9687C4.78102 34.3154 4.69976 32.6523 4.71657 30.9934C4.71937 30.674 4.63671 30.496 4.33688 30.3517C3.43038 29.9174 2.54069 29.4466 1.53751 28.9352L1.53892 28.9366Z" }),
        /* @__PURE__ */ x.jsx("path", { d: "M39.2665 35.6672C40.9767 33.9985 43.3452 32.9774 45.9084 32.9746C51.028 32.9676 55.2648 37.1624 55.2732 42.2259C55.2802 47.3889 51.0672 51.6314 45.9364 51.6202C42.6898 51.6128 40.0607 50.1878 38.4238 47.9398C35.3523 49.4673 32.049 50.159 28.6344 50.3508C24.277 50.596 20.0584 49.9613 16.0667 48.1665C14.95 47.6649 13.923 46.9363 12.9184 46.2218C12.1451 45.6712 11.8102 44.8739 11.8284 43.861C11.8656 41.7052 11.8588 39.5488 11.852 37.3921C11.8493 36.5436 11.8466 35.695 11.8466 34.8464V34.2089C11.9332 34.252 12.0127 34.2914 12.0873 34.3284C12.2675 34.4178 12.4185 34.4927 12.5682 34.569C13.8658 35.2312 15.1638 35.8927 16.4619 36.5544C19.1738 37.9366 21.886 39.319 24.5951 40.7071C26.2063 41.5324 27.7937 41.5366 29.4078 40.7043C31.7914 39.4761 34.1806 38.259 36.5699 37.0417C37.4688 36.5838 38.3678 36.1258 39.2665 35.6672ZM45.9645 45.4624C46.8836 44.86 47.7816 44.2197 48.6629 43.5626C49.5484 42.9013 49.5428 41.7902 48.6517 41.1261C47.9273 40.5866 47.1833 40.0705 46.4402 39.555C46.2937 39.4534 46.1472 39.3518 46.0009 39.25C45.5091 38.9068 44.9837 38.8493 44.4443 39.1394C43.9105 39.428 43.6555 39.8875 43.6527 40.4886C43.6508 40.8912 43.6514 41.2937 43.6521 41.6963C43.6524 41.8976 43.6527 42.0989 43.6527 42.3002C43.6527 42.5004 43.6513 42.7005 43.6499 42.9005C43.6469 43.3402 43.6439 43.7796 43.6555 44.2197C43.6877 45.4708 44.9206 46.1462 45.9645 45.4624Z" })
      ]
    }
  );
}
const zZ = ({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) => /* @__PURE__ */ x.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "398",
    height: "240",
    viewBox: "0 0 398 240",
    ...n,
    children: [
      /* @__PURE__ */ x.jsx("rect", { x: "0.5", width: "397", height: "240", rx: "47", fill: e }),
      /* @__PURE__ */ x.jsxs("g", { children: [
        /* @__PURE__ */ x.jsx("path", { d: "M 108 120 L 203 157 L 292 120 L 203 84 L 108 120 Z", fill: t }),
        /* @__PURE__ */ x.jsx("ellipse", { cx: "35", cy: "40", rx: "7.327", ry: "7.352", fill: t }),
        /* @__PURE__ */ x.jsx("ellipse", { fill: t, cx: "65", cy: "40", rx: "7.706", ry: "7.706" }),
        /* @__PURE__ */ x.jsx("ellipse", { fill: t, cx: "95", cy: "40", rx: "7.449", ry: "7.449" }),
        /* @__PURE__ */ x.jsx("path", { fill: t, d: "M 126 155 L 126 130 L 119 127 L 119 153 L 126 155 Z" }),
        /* @__PURE__ */ x.jsx("rect", { fill: t, x: "0", y: "63", width: "398", height: "7" }),
        /* @__PURE__ */ x.jsx("path", { fill: t, d: "M 105 0 L 142 65 L 152 65 L 114 0 L 105 0 Z" }),
        /* @__PURE__ */ x.jsx(
          "path",
          {
            fill: t,
            d: "M 262 140 L 203 163 L 143 140 L 143 172 C 162 203 264 191 263 169 L 262 140 Z"
          }
        ),
        /* @__PURE__ */ x.jsx("ellipse", { fill: t, cx: "122", cy: "159", rx: "6.87", ry: "6.87" })
      ] })
    ]
  }
);
function GZ({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "60",
      height: "60",
      viewBox: "0 0 60 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ x.jsxs("g", { clipPath: "url(#clip0_111300_11839)", children: [
          /* @__PURE__ */ x.jsx("path", { d: "M26.4843 56.3672C29.3967 56.3672 31.7577 54.0062 31.7577 51.0938C31.7577 48.1813 29.3967 45.8203 26.4843 45.8203C23.5718 45.8203 21.2108 48.1813 21.2108 51.0938C21.2108 54.0062 23.5718 56.3672 26.4843 56.3672Z" }),
          /* @__PURE__ */ x.jsx("path", { d: "M44.1794 56.3672C47.0919 56.3672 49.4529 54.0062 49.4529 51.0938C49.4529 48.1813 47.0919 45.8203 44.1794 45.8203C41.267 45.8203 38.906 48.1813 38.906 51.0938C38.906 54.0062 41.267 56.3672 44.1794 56.3672Z" }),
          /* @__PURE__ */ x.jsx("path", { d: "M1.7578 7.14853H9.08819L17.5746 36.8569L16.909 38.1882C15.1564 41.6897 17.7006 45.8202 21.6262 45.8202H51.2106C52.1822 45.8202 52.9684 45.034 52.9684 44.0624C52.9684 43.0908 52.1822 42.3046 51.2106 42.3046H21.6262C20.3209 42.3046 19.4678 40.9301 20.0538 39.7606L20.5397 38.789H51.2106C51.9951 38.789 52.6852 38.2689 52.9015 37.5135L59.9327 12.9043C60.0838 12.3739 59.9774 11.8039 59.6461 11.3628C59.3131 10.9234 58.793 10.6641 58.242 10.6641H13.7487L12.1042 4.90827C11.8879 4.153 11.1979 3.63281 10.4133 3.63281H1.7578C0.786206 3.63281 0 4.41902 0 5.39061C0 6.36221 0.786206 7.14853 1.7578 7.14853Z" })
        ] }),
        /* @__PURE__ */ x.jsx("defs", { children: /* @__PURE__ */ x.jsx("clipPath", { id: "clip0_111300_11839", children: /* @__PURE__ */ x.jsx("rect", { width: "60", height: "60", fill: "white" }) }) })
      ]
    }
  );
}
const UZ = ({
  primaryColor: e,
  secondaryColor: t,
  ...n
}) => /* @__PURE__ */ x.jsxs(
  "svg",
  {
    width: "397",
    height: "215",
    viewBox: "0 0 397 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ x.jsx("rect", { width: "397", height: "215", rx: "47", fill: e }),
      /* @__PURE__ */ x.jsxs("g", { clipPath: "url(#clip0_125303_20216)", children: [
        /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "M165.077 64.627L143.429 76.1167C143.058 76.311 142.708 76.5323 142.377 76.7744L197.734 105.641L220.915 94.1751L165.077 64.627Z",
            fill: "url(#paint0_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "M258.989 83.1848L231.295 96.8826V112.315C231.295 114.255 229.721 115.829 227.78 115.829C225.839 115.829 224.266 114.255 224.266 112.315V100.359L201.207 111.765V167.615C201.279 167.582 201.352 167.551 201.423 167.515L254.435 140.654C257.251 139.246 259 136.417 259 133.267V83.4953C259 83.391 258.993 83.2881 258.989 83.1848Z",
            fill: "url(#paint1_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "M254.435 76.1078L201.445 49.2585L201.423 49.2475C199.064 48.0728 196.26 48.0991 193.923 49.3178L172.58 60.6449L228.682 90.333L255.762 76.9392C255.351 76.626 254.91 76.345 254.435 76.1078Z",
            fill: "url(#paint2_linear_125303_20216)"
          }
        ),
        /* @__PURE__ */ x.jsx(
          "path",
          {
            d: "M139.017 82.9492C139.007 83.1102 139 83.2715 139 83.4342V133.328C139 136.413 140.697 139.215 143.429 140.646L193.9 167.433L193.923 167.445C194.007 167.489 194.093 167.527 194.178 167.568V111.713L139.017 82.9492Z",
            fill: "url(#paint3_linear_125303_20216)"
          }
        )
      ] }),
      /* @__PURE__ */ x.jsxs("defs", { children: [
        /* @__PURE__ */ x.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ x.jsx("stop", { stopColor: t }),
              /* @__PURE__ */ x.jsx("stop", { offset: "1", stopColor: t, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ x.jsxs(
          "linearGradient",
          {
            id: "paint1_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ x.jsx("stop", { stopColor: t }),
              /* @__PURE__ */ x.jsx("stop", { offset: "1", stopColor: t, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ x.jsxs(
          "linearGradient",
          {
            id: "paint2_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ x.jsx("stop", { stopColor: t }),
              /* @__PURE__ */ x.jsx("stop", { offset: "1", stopColor: t, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ x.jsxs(
          "linearGradient",
          {
            id: "paint3_linear_125303_20216",
            x1: "259",
            y1: "48",
            x2: "139",
            y2: "168",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ x.jsx("stop", { stopColor: t }),
              /* @__PURE__ */ x.jsx("stop", { offset: "1", stopColor: t, stopOpacity: "0.16" })
            ]
          }
        ),
        /* @__PURE__ */ x.jsx("clipPath", { id: "clip0_125303_20216", children: /* @__PURE__ */ x.jsx("rect", { width: "120", height: "120", fill: t, transform: "translate(139 48)" }) })
      ] })
    ]
  }
), ZZ = (e, t) => {
  switch (e) {
    case $e.profile:
      return /* @__PURE__ */ x.jsx(DZ, { ...t });
    case $e.link_thumbnail:
      return /* @__PURE__ */ x.jsx(IZ, { ...t });
    case $e.optin_thumbnail:
      return /* @__PURE__ */ x.jsx(HZ, { ...t });
    case $e.product_download_thumbnail:
      return /* @__PURE__ */ x.jsx(FZ, { ...t });
    case $e.product_download_cover:
      return /* @__PURE__ */ x.jsx(VZ, { ...t });
    case $e.e_course_thumbnail:
      return /* @__PURE__ */ x.jsx(BZ, { ...t });
    case $e.e_course_cover:
      return /* @__PURE__ */ x.jsx(zZ, { ...t });
    case $e.physical_product_thumbnail:
      return /* @__PURE__ */ x.jsx(GZ, { ...t });
    case $e.physical_product_cover:
      return /* @__PURE__ */ x.jsx(UZ, { ...t });
  }
}, tb = ({ children: e }) => /* @__PURE__ */ x.jsx("div", { className: "w-full max-w-xl", children: e }), z3 = "-", KZ = (e) => {
  const t = WZ(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (o) => {
      const s = o.split(z3);
      return s[0] === "" && s.length !== 1 && s.shift(), rb(s, t) || $Z(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const l = n[o] || [];
      return s && r[o] ? [...l, ...r[o]] : l;
    }
  };
}, rb = (e, t) => {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), a = r ? rb(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const i = e.join(z3);
  return (o = t.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : o.classGroupId;
}, Tp = /^\[(.+)\]$/, $Z = (e) => {
  if (Tp.test(e)) {
    const t = Tp.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, WZ = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return qZ(Object.entries(e.classGroups), n).forEach(([i, o]) => {
    xl(o, r, i, t);
  }), r;
}, xl = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? t : Lp(t, a);
      i.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (YZ(a)) {
        xl(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      xl(o, Lp(t, i), n, r);
    });
  });
}, Lp = (e, t) => {
  let n = e;
  return t.split(z3).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, YZ = (e) => e.isThemeGetter, qZ = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, s]) => [t + o, s])) : i);
  return [n, a];
}) : e, JZ = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (i, o) => {
    n.set(i, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = n.get(i);
      if (o !== void 0)
        return o;
      if ((o = r.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      n.has(i) ? n.set(i, o) : a(i, o);
    }
  };
}, nb = "!", XZ = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], i = t.length, o = (s) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let C = 0; C < s.length; C++) {
      let _ = s[C];
      if (c === 0) {
        if (_ === a && (r || s.slice(C, C + i) === t)) {
          l.push(s.slice(u, C)), u = C + i;
          continue;
        }
        if (_ === "/") {
          d = C;
          continue;
        }
      }
      _ === "[" ? c++ : _ === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(u), h = p.startsWith(nb), m = h ? p.substring(1) : p, f = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: f
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: o
  }) : o;
}, QZ = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, eK = (e) => ({
  cache: JZ(e.cacheSize),
  parseClassName: XZ(e),
  ...KZ(e)
}), tK = /\s+/, rK = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, i = [], o = e.trim().split(tK);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const c = o[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(c);
    let m = !!h, f = r(m ? p.substring(0, h) : p);
    if (!f) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (f = r(p), !f) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const C = QZ(u).join(":"), _ = d ? C + nb : C, v = _ + f;
    if (i.includes(v))
      continue;
    i.push(v);
    const w = a(f, m);
    for (let k = 0; k < w.length; ++k) {
      const b = w[k];
      i.push(_ + b);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function M1() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = ab(t)) && (r && (r += " "), r += n);
  return r;
}
const ab = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = ab(e[r])) && (n && (n += " "), n += t);
  return n;
};
function nK(e, ...t) {
  let n, r, a, i = o;
  function o(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = eK(c), r = n.cache.get, a = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = rK(l, n);
    return a(l, u), u;
  }
  return function() {
    return i(M1.apply(null, arguments));
  };
}
const t1 = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, ib = /^\[(?:([a-z-]+):)?(.+)\]$/i, aK = /^\d+\/\d+$/, iK = /* @__PURE__ */ new Set(["px", "full", "screen"]), oK = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, sK = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, lK = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, cK = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, uK = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ia = (e) => Li(e) || iK.has(e) || aK.test(e), ka = (e) => uo(e, "length", yK), Li = (e) => !!e && !Number.isNaN(Number(e)), z7 = (e) => uo(e, "number", Li), Io = (e) => !!e && Number.isInteger(Number(e)), dK = (e) => e.endsWith("%") && Li(e.slice(0, -1)), it = (e) => ib.test(e), Ma = (e) => oK.test(e), pK = /* @__PURE__ */ new Set(["length", "size", "percentage"]), hK = (e) => uo(e, pK, ob), mK = (e) => uo(e, "position", ob), fK = /* @__PURE__ */ new Set(["image", "url"]), CK = (e) => uo(e, fK, bK), gK = (e) => uo(e, "", vK), Ho = () => !0, uo = (e, t, n) => {
  const r = ib.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, yK = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  sK.test(e) && !lK.test(e)
), ob = () => !1, vK = (e) => cK.test(e), bK = (e) => uK.test(e), _K = () => {
  const e = t1("colors"), t = t1("spacing"), n = t1("blur"), r = t1("brightness"), a = t1("borderColor"), i = t1("borderRadius"), o = t1("borderSpacing"), s = t1("borderWidth"), l = t1("contrast"), c = t1("grayscale"), u = t1("hueRotate"), d = t1("invert"), p = t1("gap"), h = t1("gradientColorStops"), m = t1("gradientColorStopPositions"), f = t1("inset"), C = t1("margin"), _ = t1("opacity"), v = t1("padding"), w = t1("saturate"), k = t1("scale"), b = t1("sepia"), S = t1("skew"), P = t1("space"), O = t1("translate"), A = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", it, t], D = () => [it, t], U = () => ["", ia, ka], z = () => ["auto", Li, it], $ = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ee = () => ["solid", "dashed", "dotted", "double", "none"], Z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], W = () => ["", "0", it], j = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [Li, it];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Ho],
      spacing: [ia, ka],
      blur: ["none", "", Ma, it],
      brightness: T(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ma, it],
      borderSpacing: D(),
      borderWidth: U(),
      contrast: T(),
      grayscale: W(),
      hueRotate: T(),
      invert: W(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [dK, ka],
      inset: I(),
      margin: I(),
      opacity: T(),
      padding: D(),
      saturate: T(),
      scale: T(),
      sepia: W(),
      skew: T(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", it]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ma]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": j()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": j()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...$(), it]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: A()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": A()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": A()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Io, it]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", it]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: W()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: W()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Io, it]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ho]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Io, it]
        }, it]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": z()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": z()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ho]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Io, it]
        }, it]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": z()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": z()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", it]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", it]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...G()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...G(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...G(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [C]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [C]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [C]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [C]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [C]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [C]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [C]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [C]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [C]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", it, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [it, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [it, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ma]
        }, Ma]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [it, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [it, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [it, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [it, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ma, ka]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", z7]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ho]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", it]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Li, z7]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ia, it]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", it]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", it]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ee(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ia, ka]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ia, it]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", it]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", it]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...$(), mK]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", hK]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, CK]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ee(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ee()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ee()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ia, it]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ia, ka]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: U()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ia, ka]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ma, gK]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ho]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ma, it]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [b]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [b]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", it]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: T()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", it]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: T()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", it]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [k]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [k]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [k]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Io, it]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", it]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", it]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", it]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ia, ka, z7]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Ot = /* @__PURE__ */ nK(_K), k8 = ({ children: e }) => {
  const {
    state: { tertiaryColor: t }
  } = wr();
  return /* @__PURE__ */ x.jsx(tb, { children: /* @__PURE__ */ x.jsx(
    "div",
    {
      className: M1(
        "bg-THEME-secondary mx-5 rounded-lg border p-5 sm:mx-0",
        Xv(t) ? "shadow-around-sm border-transparent" : "border-THEME-border-tertiary"
      ),
      children: e
    }
  ) });
}, G3 = ({ title: e, subTitle: t, thumbnail: n, imageType: r }) => {
  const { isDefaultTheme: a } = wr();
  return /* @__PURE__ */ x.jsxs("div", { className: "flex gap-3", children: [
    /* @__PURE__ */ x.jsx(
      xr,
      {
        className: "h-full shrink-0 rounded-xl",
        thumbnail: n,
        imageType: r,
        alt: e
      }
    ),
    /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ x.jsx("h3", { className: M1(a ? "text-text-primary" : "text-THEME-primary"), children: e }),
      /* @__PURE__ */ x.jsx("span", { className: "whitespace-pre-wrap font-medium", children: t })
    ] })
  ] });
}, Jr = (e) => {
  const { isDefaultSioColor: t } = wr(), n = Ug(e) ? e["aria-disabled"] : e.disabled;
  return /* @__PURE__ */ x.jsx(
    Zg,
    {
      color: t ? "text-background-secondary" : "text-THEME-text-primary",
      hoverColor: t ? "hover:text-background-secondary" : "hover:text-THEME-text-primary",
      backgroundColor: t ? "bg-brand-primary" : "bg-THEME-primary",
      hoverBackgroundColor: t ? "hover:bg-brand-primary" : "hover:bg-THEME-primary",
      ...e,
      className: Ot(
        e.className,
        !t && "ring-THEME-primary",
        n && "bg-text-secondary/50"
      ),
      loaderClassName: t ? "text-background-secondary fill-brand-primary" : "text-THEME-text-primary fill-THEME-primary"
    }
  );
}, cr = ({ currency: e }) => /* @__PURE__ */ x.jsxs("div", { className: "text-xxs relative rounded-md px-2 py-1 font-bold uppercase", children: [
  /* @__PURE__ */ x.jsx("div", { className: "bg-THEME-primary absolute left-0 top-0 h-full w-full rounded-md opacity-30" }),
  e
] }), U3 = ({ className: e, ...t }) => /* @__PURE__ */ x.jsx(
  "svg",
  {
    width: 20,
    height: 20,
    className: Ot("main-transition-colors fill-green absolute", e),
    ...t,
    children: /* @__PURE__ */ x.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.084 10.042C20.084 15.588 15.588 20.084 10.042 20.084C4.49594 20.084 0 15.588 0 10.042C0 4.49594 4.49594 0 10.042 0C15.588 0 20.084 4.49594 20.084 10.042ZM8.88044 15.3591L16.3309 7.90864C16.5839 7.65565 16.5839 7.24542 16.3309 6.99243L15.4147 6.07622C15.1618 5.82319 14.7515 5.82319 14.4985 6.07622L8.42231 12.1523L5.58549 9.31553C5.3325 9.06254 4.92227 9.06254 4.66924 9.31553L3.75303 10.2317C3.50004 10.4847 3.50004 10.895 3.75303 11.1479L7.96419 15.3591C8.21722 15.6121 8.62741 15.6121 8.88044 15.3591Z"
      }
    )
  }
), Sl = ({
  options: e,
  selected: t,
  onChange: n,
  disabled: r,
  error: a,
  label: i,
  required: o,
  className: s,
  labelClassName: l,
  optionsWrapperClassName: c,
  optionWrapperClassName: u,
  selectedOptionWrapperClassName: d,
  optionClassName: p,
  selectedOptionClassName: h
}) => /* @__PURE__ */ x.jsxs("div", { className: Ot("flex flex-col gap-1", s), children: [
  /* @__PURE__ */ x.jsx(ba, { label: i, labelClassName: l, required: o }),
  /* @__PURE__ */ x.jsx("ul", { className: Ot("flex flex-col gap-5", c), children: e ? e.map((m) => /* @__PURE__ */ x.jsxs(
    "li",
    {
      className: Ot(
        u,
        m.id === t && d,
        "border-text-secondary/30 rounded-lg border"
      ),
      children: [
        /* @__PURE__ */ x.jsxs(
          "label",
          {
            className: Ot(
              "relative flex items-center gap-2",
              !r && "cursor-pointer",
              "p-4"
            ),
            children: [
              /* @__PURE__ */ x.jsx(
                "input",
                {
                  className: Ot(
                    "border-2 outline-hidden",
                    r ? "border-fill-primary/70" : "border-fill-primary",
                    "h-[20px] w-[20px] rounded-full",
                    m.id === t ? "bg-background-secondary" : "bg-transparent",
                    "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
                  ),
                  disabled: r,
                  checked: m.id === t,
                  value: m.caption,
                  onChange: () => n(m.id),
                  type: "radio"
                }
              ),
              /* @__PURE__ */ x.jsx(
                U3,
                {
                  className: M1(
                    m.id !== t && "fill-transparent",
                    r && "opacity-70"
                  )
                }
              ),
              /* @__PURE__ */ x.jsxs("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: [
                /* @__PURE__ */ x.jsx(
                  "span",
                  {
                    className: Ot(
                      "main-transition-colors",
                      m.id === t ? "text-text-primary" : "text-text-primary/50",
                      r && "opacity-70",
                      p,
                      m.id === t ? h : void 0,
                      "text-left"
                    ),
                    children: m.caption
                  }
                ),
                m.additionalInfo
              ] })
            ]
          }
        ),
        m.content && m.id === t && /* @__PURE__ */ x.jsx("div", { className: "px-4 pb-4", children: m.content })
      ]
    },
    m.id
  )) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "first-skeleton"
    ),
    /* @__PURE__ */ x.jsx(
      "li",
      {
        className: "bg-skeleton-primary h-[20px] w-[20px] animate-pulse rounded-full text-transparent",
        children: "."
      },
      "second-skeleton"
    )
  ] }) }),
  /* @__PURE__ */ x.jsx(oo, { error: a })
] }), wK = ({
  thumbnail: e,
  url: t,
  buttonTitle: n,
  subTitle: r,
  title: a
}) => /* @__PURE__ */ x.jsx(k8, { children: /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col gap-3", children: [
  /* @__PURE__ */ x.jsx(
    G3,
    {
      title: a,
      subTitle: r,
      imageType: $e.link_thumbnail,
      thumbnail: e
    }
  ),
  /* @__PURE__ */ x.jsx(Jr, { href: t, children: n })
] }) }), Z3 = ({
  value: e,
  error: t,
  field: n,
  onChange: r,
  contactFields: a
}) => {
  var l;
  const { locale: i } = qr(), { visitorInfo: o } = nv(), s = (l = a[Ut.Country]) != null && l.value ? a[Ut.Country].value : (o == null ? void 0 : o.country) ?? void 0;
  switch (n.slug) {
    case Ut.Country:
      return /* @__PURE__ */ x.jsx(
        SR,
        {
          label: D0(n.slug),
          className: "focus:!border-THEME-primary",
          required: n.required,
          data: gj(i),
          value: e,
          withoutCloseIcon: !0,
          onChange: (c) => r(c),
          error: t == null ? void 0 : t.join(", ")
        }
      );
    case Ut.PhoneNumber:
      return /* @__PURE__ */ x.jsx(
        kV,
        {
          label: D0(n.slug),
          inputClassName: "focus:!border-THEME-primary",
          required: n.required,
          value: e,
          onChange: r,
          initialCountry: s,
          error: t == null ? void 0 : t.join(", ")
        }
      );
    default:
      return /* @__PURE__ */ x.jsx(
        wi,
        {
          label: vj(n),
          inputClassName: "focus:!border-THEME-primary",
          required: n.required,
          value: e,
          onChange: ({ target: { value: c } }) => r(c),
          error: t == null ? void 0 : t.join(", ")
        },
        n.slug
      );
  }
}, m5 = (e) => e.reduce(
  (t, n) => ({ ...t, [n.slug]: { ...n, value: void 0 } }),
  {}
), xK = async (e) => A8.post("/api/public/digital-store/opt-in", e), SK = ({
  id: e,
  title: t,
  subTitle: n,
  thumbnail: r,
  fields: a,
  buttonTitle: i,
  thankYouPage: o
}) => {
  const [s, l] = ke(!1), [c, u] = ke({}), [d, p] = ke(
    m5(a)
  ), { visitorInfo: h } = nv();
  z1(a, (f) => p(m5(f))), z1(h, (f) => {
    if (!f)
      return;
    const C = Object.prototype.hasOwnProperty.call(d, Ut.Country) && !d[Ut.Country].value;
    f.country && C && p({
      ...d,
      [Ut.Country]: {
        ...d[Ut.Country],
        value: f.country
      }
    });
  });
  const m = async () => {
    var C;
    if (!e)
      return;
    const f = Object.values(d).map((_) => ({
      slug: _.slug,
      value: _.value ?? ""
    }));
    try {
      u({}), l(!0);
      const _ = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await xK({
        itemOptIn: `/api/dashboard/digital-store/item-opt-ins/${e}`,
        values: f,
        timezone: _
      }), o.path && window.location.assign(o.path);
    } catch (_) {
      _ instanceof ov && ((C = _.errors.violations) == null || C.forEach((v) => {
        var b;
        const w = /values\[(\d+)]/, k = v.propertyPath.match(w);
        if (k) {
          const S = parseInt(k[1]), P = (b = f.find((O, A) => A === S)) == null ? void 0 : b.slug;
          P && u((O) => ({ ...O, [P]: v.message }));
        }
      }));
    } finally {
      l(!1);
    }
  };
  return /* @__PURE__ */ x.jsx(k8, { children: /* @__PURE__ */ x.jsxs(
    "form",
    {
      onSubmit: (f) => {
        f.preventDefault(), m();
      },
      className: "flex flex-col gap-3",
      children: [
        /* @__PURE__ */ x.jsx(
          G3,
          {
            title: t,
            subTitle: n,
            imageType: $e.optin_thumbnail,
            thumbnail: r
          }
        ),
        Object.values(d).map((f) => {
          const C = (_) => p({
            ...d,
            [f.slug]: { ...f, value: _ }
          });
          return /* @__PURE__ */ x.jsx(
            Z3,
            {
              contactFields: d,
              field: f,
              value: d[f.slug].value,
              error: c[f.slug] ? [c[f.slug]] : [],
              onChange: C
            },
            f.slug
          );
        }),
        /* @__PURE__ */ x.jsx(Jr, { isFetching: s, type: "submit", children: i })
      ]
    }
  ) });
}, kK = ({ text: e }) => {
  const { isDefaultTheme: t } = wr();
  return /* @__PURE__ */ x.jsx(tb, { children: /* @__PURE__ */ x.jsx(
    "h2",
    {
      className: M1(
        "w-full px-5 py-2.5 text-2xl font-bold sm:px-0",
        t ? "text-text-primary" : "text-THEME-primary"
      ),
      children: e
    }
  ) });
};
var Ar = /* @__PURE__ */ ((e) => (e.download = "download", e.eCourse = "e-course", e.physicalProduct = "physical", e))(Ar || {});
const MK = (e) => {
  switch (e) {
    case Ar.download:
      return $e.product_download_thumbnail;
    case Ar.eCourse:
      return $e.e_course_thumbnail;
    case Ar.physicalProduct:
      return $e.physical_product_thumbnail;
  }
}, K3 = ({
  productType: e,
  thumbnail: t,
  buttonTitle: n,
  subTitle: r,
  title: a,
  checkoutPage: i
}) => {
  const o = () => {
    i.path && window.location.assign(i.path);
  };
  return /* @__PURE__ */ x.jsx(k8, { children: /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ x.jsx(
      G3,
      {
        title: a,
        subTitle: r,
        imageType: MK(e),
        thumbnail: t
      }
    ),
    /* @__PURE__ */ x.jsx(Jr, { onClick: o, children: n })
  ] }) });
}, PK = K3, EK = K3, TK = K3, LK = ({ ...e }) => {
  switch (e.productType) {
    case Ar.download:
      return /* @__PURE__ */ x.jsx(PK, { ...e });
    case Ar.eCourse:
      return /* @__PURE__ */ x.jsx(EK, { ...e });
    case Ar.physicalProduct:
      return /* @__PURE__ */ x.jsx(TK, { ...e });
  }
}, AK = (e) => {
  switch (e.type) {
    case Vn.link:
      return /* @__PURE__ */ x.jsx(wK, { ...e });
    case Vn.optin:
      return /* @__PURE__ */ x.jsx(SK, { ...e });
    case Vn.header:
      return /* @__PURE__ */ x.jsx(kK, { ...e });
    case Vn.product:
      return /* @__PURE__ */ x.jsx(LK, { ...e });
  }
}, OK = (e) => {
  switch (e) {
    case $e.link_thumbnail:
    case $e.optin_thumbnail:
    case $e.product_download_thumbnail:
    case $e.e_course_thumbnail:
    case $e.physical_product_thumbnail:
      return 60;
    case $e.profile:
      return 128;
    case $e.product_download_cover:
    case $e.e_course_cover:
    case $e.physical_product_cover:
      return 300;
  }
}, NK = (e) => {
  switch (e) {
    case $e.link_thumbnail:
    case $e.optin_thumbnail:
    case $e.product_download_thumbnail:
    case $e.e_course_thumbnail:
    case $e.physical_product_thumbnail:
      return 60;
    case $e.profile:
      return 128;
    case $e.product_download_cover:
    case $e.e_course_cover:
    case $e.physical_product_cover:
      return 180;
  }
}, J1 = (e, t, n, r) => {
  let a = C9(n);
  switch (a) {
    case Tr.ARABIC:
      a = "ar-AE";
      break;
    case Tr.ALBANIA:
      a = Tr.ENGLISH;
      break;
  }
  return Intl.NumberFormat(a, {
    style: "currency",
    currency: t,
    currencyDisplay: "symbol",
    maximumFractionDigits: r ? 0 : void 0,
    minimumFractionDigits: r ? 0 : 2
    // we need 2 fractional digits for tests
  }).format(e);
};
function sb(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: jK } = Object.prototype, { getPrototypeOf: $3 } = Object, M8 = /* @__PURE__ */ ((e) => (t) => {
  const n = jK.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kn = (e) => (e = e.toLowerCase(), (t) => M8(t) === e), P8 = (e) => (t) => typeof t === e, { isArray: po } = Array, Vs = P8("undefined");
function RK(e) {
  return e !== null && !Vs(e) && e.constructor !== null && !Vs(e.constructor) && Or(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const lb = kn("ArrayBuffer");
function DK(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && lb(e.buffer), t;
}
const IK = P8("string"), Or = P8("function"), cb = P8("number"), E8 = (e) => e !== null && typeof e == "object", HK = (e) => e === !0 || e === !1, b6 = (e) => {
  if (M8(e) !== "object")
    return !1;
  const t = $3(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, FK = kn("Date"), VK = kn("File"), BK = kn("Blob"), zK = kn("FileList"), GK = (e) => E8(e) && Or(e.pipe), UK = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Or(e.append) && ((t = M8(e)) === "formdata" || // detect form-data instance
  t === "object" && Or(e.toString) && e.toString() === "[object FormData]"));
}, ZK = kn("URLSearchParams"), [KK, $K, WK, YK] = ["ReadableStream", "Request", "Response", "Headers"].map(kn), qK = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function x9(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, a;
  if (typeof e != "object" && (e = [e]), po(e))
    for (r = 0, a = e.length; r < a; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let s;
    for (r = 0; r < o; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function ub(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], t === a.toLowerCase())
      return a;
  return null;
}
const A2 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, db = (e) => !Vs(e) && e !== A2;
function kl() {
  const { caseless: e } = db(this) && this || {}, t = {}, n = (r, a) => {
    const i = e && ub(t, a) || a;
    b6(t[i]) && b6(r) ? t[i] = kl(t[i], r) : b6(r) ? t[i] = kl({}, r) : po(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && x9(arguments[r], n);
  return t;
}
const JK = (e, t, n, { allOwnKeys: r } = {}) => (x9(t, (a, i) => {
  n && Or(a) ? e[i] = sb(a, n) : e[i] = a;
}, { allOwnKeys: r }), e), XK = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), QK = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, e$ = (e, t, n, r) => {
  let a, i, o;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (a = Object.getOwnPropertyNames(e), i = a.length; i-- > 0; )
      o = a[i], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
    e = n !== !1 && $3(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, t$ = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, r$ = (e) => {
  if (!e)
    return null;
  if (po(e))
    return e;
  let t = e.length;
  if (!cb(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, n$ = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && $3(Uint8Array)), a$ = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let a;
  for (; (a = r.next()) && !a.done; ) {
    const i = a.value;
    t.call(e, i[0], i[1]);
  }
}, i$ = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, o$ = kn("HTMLFormElement"), s$ = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, a) {
    return r.toUpperCase() + a;
  }
), Ap = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), l$ = kn("RegExp"), pb = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  x9(n, (a, i) => {
    let o;
    (o = t(a, i, e)) !== !1 && (r[i] = o || a);
  }), Object.defineProperties(e, r);
}, c$ = (e) => {
  pb(e, (t, n) => {
    if (Or(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Or(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, u$ = (e, t) => {
  const n = {}, r = (a) => {
    a.forEach((i) => {
      n[i] = !0;
    });
  };
  return po(e) ? r(e) : r(String(e).split(t)), n;
}, d$ = () => {
}, p$ = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, G7 = "abcdefghijklmnopqrstuvwxyz", Op = "0123456789", hb = {
  DIGIT: Op,
  ALPHA: G7,
  ALPHA_DIGIT: G7 + G7.toUpperCase() + Op
}, h$ = (e = 16, t = hb.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function m$(e) {
  return !!(e && Or(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const f$ = (e) => {
  const t = new Array(10), n = (r, a) => {
    if (E8(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[a] = r;
        const i = po(r) ? [] : {};
        return x9(r, (o, s) => {
          const l = n(o, a + 1);
          !Vs(l) && (i[s] = l);
        }), t[a] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, C$ = kn("AsyncFunction"), g$ = (e) => e && (E8(e) || Or(e)) && Or(e.then) && Or(e.catch), mb = ((e, t) => e ? setImmediate : t ? ((n, r) => (A2.addEventListener("message", ({ source: a, data: i }) => {
  a === A2 && i === n && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), A2.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Or(A2.postMessage)
), y$ = typeof queueMicrotask < "u" ? queueMicrotask.bind(A2) : typeof process < "u" && process.nextTick || mb, se = {
  isArray: po,
  isArrayBuffer: lb,
  isBuffer: RK,
  isFormData: UK,
  isArrayBufferView: DK,
  isString: IK,
  isNumber: cb,
  isBoolean: HK,
  isObject: E8,
  isPlainObject: b6,
  isReadableStream: KK,
  isRequest: $K,
  isResponse: WK,
  isHeaders: YK,
  isUndefined: Vs,
  isDate: FK,
  isFile: VK,
  isBlob: BK,
  isRegExp: l$,
  isFunction: Or,
  isStream: GK,
  isURLSearchParams: ZK,
  isTypedArray: n$,
  isFileList: zK,
  forEach: x9,
  merge: kl,
  extend: JK,
  trim: qK,
  stripBOM: XK,
  inherits: QK,
  toFlatObject: e$,
  kindOf: M8,
  kindOfTest: kn,
  endsWith: t$,
  toArray: r$,
  forEachEntry: a$,
  matchAll: i$,
  isHTMLForm: o$,
  hasOwnProperty: Ap,
  hasOwnProp: Ap,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: pb,
  freezeMethods: c$,
  toObjectSet: u$,
  toCamelCase: s$,
  noop: d$,
  toFiniteNumber: p$,
  findKey: ub,
  global: A2,
  isContextDefined: db,
  ALPHABET: hb,
  generateString: h$,
  isSpecCompliantForm: m$,
  toJSONObject: f$,
  isAsyncFn: C$,
  isThenable: g$,
  setImmediate: mb,
  asap: y$
};
function rt(e, t, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), a && (this.response = a);
}
se.inherits(rt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: se.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const fb = rt.prototype, Cb = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Cb[e] = { value: e };
});
Object.defineProperties(rt, Cb);
Object.defineProperty(fb, "isAxiosError", { value: !0 });
rt.from = (e, t, n, r, a, i) => {
  const o = Object.create(fb);
  return se.toFlatObject(e, o, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), rt.call(o, e.message, t, n, r, a), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const v$ = null;
function Ml(e) {
  return se.isPlainObject(e) || se.isArray(e);
}
function gb(e) {
  return se.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Np(e, t, n) {
  return e ? e.concat(t).map(function(a, i) {
    return a = gb(a), !n && i ? "[" + a + "]" : a;
  }).join(n ? "." : "") : t;
}
function b$(e) {
  return se.isArray(e) && !e.some(Ml);
}
const _$ = se.toFlatObject(se, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function T8(e, t, n) {
  if (!se.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = se.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(f, C) {
    return !se.isUndefined(C[f]);
  });
  const r = n.metaTokens, a = n.visitor || u, i = n.dots, o = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && se.isSpecCompliantForm(t);
  if (!se.isFunction(a))
    throw new TypeError("visitor must be a function");
  function c(m) {
    if (m === null)
      return "";
    if (se.isDate(m))
      return m.toISOString();
    if (!l && se.isBlob(m))
      throw new rt("Blob is not supported. Use a Buffer instead.");
    return se.isArrayBuffer(m) || se.isTypedArray(m) ? l && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function u(m, f, C) {
    let _ = m;
    if (m && !C && typeof m == "object") {
      if (se.endsWith(f, "{}"))
        f = r ? f : f.slice(0, -2), m = JSON.stringify(m);
      else if (se.isArray(m) && b$(m) || (se.isFileList(m) || se.endsWith(f, "[]")) && (_ = se.toArray(m)))
        return f = gb(f), _.forEach(function(w, k) {
          !(se.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? Np([f], k, i) : o === null ? f : f + "[]",
            c(w)
          );
        }), !1;
    }
    return Ml(m) ? !0 : (t.append(Np(C, f, i), c(m)), !1);
  }
  const d = [], p = Object.assign(_$, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Ml
  });
  function h(m, f) {
    if (!se.isUndefined(m)) {
      if (d.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      d.push(m), se.forEach(m, function(_, v) {
        (!(se.isUndefined(_) || _ === null) && a.call(
          t,
          _,
          se.isString(v) ? v.trim() : v,
          f,
          p
        )) === !0 && h(_, f ? f.concat(v) : [v]);
      }), d.pop();
    }
  }
  if (!se.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function jp(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function W3(e, t) {
  this._pairs = [], e && T8(e, this, t);
}
const yb = W3.prototype;
yb.append = function(t, n) {
  this._pairs.push([t, n]);
};
yb.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, jp);
  } : jp;
  return this._pairs.map(function(a) {
    return n(a[0]) + "=" + n(a[1]);
  }, "").join("&");
};
function w$(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function vb(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || w$, a = n && n.serialize;
  let i;
  if (a ? i = a(t, n) : i = se.isURLSearchParams(t) ? t.toString() : new W3(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Rp {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    se.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const bb = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, x$ = typeof URLSearchParams < "u" ? URLSearchParams : W3, S$ = typeof FormData < "u" ? FormData : null, k$ = typeof Blob < "u" ? Blob : null, M$ = {
  isBrowser: !0,
  classes: {
    URLSearchParams: x$,
    FormData: S$,
    Blob: k$
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Y3 = typeof window < "u" && typeof document < "u", P$ = ((e) => Y3 && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), E$ = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", T$ = Y3 && window.location.href || "http://localhost", L$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Y3,
  hasStandardBrowserEnv: P$,
  hasStandardBrowserWebWorkerEnv: E$,
  origin: T$
}, Symbol.toStringTag, { value: "Module" })), fn = {
  ...L$,
  ...M$
};
function A$(e, t) {
  return T8(e, new fn.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, i) {
      return fn.isNode && se.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function O$(e) {
  return se.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function N$(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const a = n.length;
  let i;
  for (r = 0; r < a; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function _b(e) {
  function t(n, r, a, i) {
    let o = n[i++];
    if (o === "__proto__")
      return !0;
    const s = Number.isFinite(+o), l = i >= n.length;
    return o = !o && se.isArray(a) ? a.length : o, l ? (se.hasOwnProp(a, o) ? a[o] = [a[o], r] : a[o] = r, !s) : ((!a[o] || !se.isObject(a[o])) && (a[o] = []), t(n, r, a[o], i) && se.isArray(a[o]) && (a[o] = N$(a[o])), !s);
  }
  if (se.isFormData(e) && se.isFunction(e.entries)) {
    const n = {};
    return se.forEachEntry(e, (r, a) => {
      t(O$(r), a, n, 0);
    }), n;
  }
  return null;
}
function j$(e, t, n) {
  if (se.isString(e))
    try {
      return (t || JSON.parse)(e), se.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const S9 = {
  transitional: bb,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", a = r.indexOf("application/json") > -1, i = se.isObject(t);
    if (i && se.isHTMLForm(t) && (t = new FormData(t)), se.isFormData(t))
      return a ? JSON.stringify(_b(t)) : t;
    if (se.isArrayBuffer(t) || se.isBuffer(t) || se.isStream(t) || se.isFile(t) || se.isBlob(t) || se.isReadableStream(t))
      return t;
    if (se.isArrayBufferView(t))
      return t.buffer;
    if (se.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return A$(t, this.formSerializer).toString();
      if ((s = se.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return T8(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || a ? (n.setContentType("application/json", !1), j$(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || S9.transitional, r = n && n.forcedJSONParsing, a = this.responseType === "json";
    if (se.isResponse(t) || se.isReadableStream(t))
      return t;
    if (t && se.isString(t) && (r && !this.responseType || a)) {
      const o = !(n && n.silentJSONParsing) && a;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (o)
          throw s.name === "SyntaxError" ? rt.from(s, rt.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: fn.classes.FormData,
    Blob: fn.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
se.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  S9.headers[e] = {};
});
const R$ = se.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), D$ = (e) => {
  const t = {};
  let n, r, a;
  return e && e.split(`
`).forEach(function(o) {
    a = o.indexOf(":"), n = o.substring(0, a).trim().toLowerCase(), r = o.substring(a + 1).trim(), !(!n || t[n] && R$[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Dp = Symbol("internals");
function Fo(e) {
  return e && String(e).trim().toLowerCase();
}
function _6(e) {
  return e === !1 || e == null ? e : se.isArray(e) ? e.map(_6) : String(e);
}
function I$(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const H$ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function U7(e, t, n, r, a) {
  if (se.isFunction(r))
    return r.call(this, t, n);
  if (a && (t = n), !!se.isString(t)) {
    if (se.isString(r))
      return t.indexOf(r) !== -1;
    if (se.isRegExp(r))
      return r.test(t);
  }
}
function F$(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function V$(e, t) {
  const n = se.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(a, i, o) {
        return this[r].call(this, t, a, i, o);
      },
      configurable: !0
    });
  });
}
class vr {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const a = this;
    function i(s, l, c) {
      const u = Fo(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = se.findKey(a, u);
      (!d || a[d] === void 0 || c === !0 || c === void 0 && a[d] !== !1) && (a[d || l] = _6(s));
    }
    const o = (s, l) => se.forEach(s, (c, u) => i(c, u, l));
    if (se.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (se.isString(t) && (t = t.trim()) && !H$(t))
      o(D$(t), n);
    else if (se.isHeaders(t))
      for (const [s, l] of t.entries())
        i(l, s, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Fo(t), t) {
      const r = se.findKey(this, t);
      if (r) {
        const a = this[r];
        if (!n)
          return a;
        if (n === !0)
          return I$(a);
        if (se.isFunction(n))
          return n.call(this, a, r);
        if (se.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Fo(t), t) {
      const r = se.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || U7(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let a = !1;
    function i(o) {
      if (o = Fo(o), o) {
        const s = se.findKey(r, o);
        s && (!n || U7(r, r[s], s, n)) && (delete r[s], a = !0);
      }
    }
    return se.isArray(t) ? t.forEach(i) : i(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, a = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || U7(this, this[i], i, t, !0)) && (delete this[i], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, r = {};
    return se.forEach(this, (a, i) => {
      const o = se.findKey(r, i);
      if (o) {
        n[o] = _6(a), delete n[i];
        return;
      }
      const s = t ? F$(i) : String(i).trim();
      s !== i && delete n[i], n[s] = _6(a), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return se.forEach(this, (r, a) => {
      r != null && r !== !1 && (n[a] = t && se.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((a) => r.set(a)), r;
  }
  static accessor(t) {
    const r = (this[Dp] = this[Dp] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function i(o) {
      const s = Fo(o);
      r[s] || (V$(a, o), r[s] = !0);
    }
    return se.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
vr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
se.reduceDescriptors(vr.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
se.freezeMethods(vr);
function Z7(e, t) {
  const n = this || S9, r = t || n, a = vr.from(r.headers);
  let i = r.data;
  return se.forEach(e, function(s) {
    i = s.call(n, i, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), i;
}
function wb(e) {
  return !!(e && e.__CANCEL__);
}
function ho(e, t, n) {
  rt.call(this, e ?? "canceled", rt.ERR_CANCELED, t, n), this.name = "CanceledError";
}
se.inherits(ho, rt, {
  __CANCEL__: !0
});
function xb(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new rt(
    "Request failed with status code " + n.status,
    [rt.ERR_BAD_REQUEST, rt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function B$(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function z$(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let a = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = r[i];
    o || (o = c), n[a] = l, r[a] = c;
    let d = i, p = 0;
    for (; d !== a; )
      p += n[d++], d = d % e;
    if (a = (a + 1) % e, a === i && (i = (i + 1) % e), c - o < t)
      return;
    const h = u && c - u;
    return h ? Math.round(p * 1e3 / h) : void 0;
  };
}
function G$(e, t) {
  let n = 0, r = 1e3 / t, a, i;
  const o = (c, u = Date.now()) => {
    n = u, a = null, i && (clearTimeout(i), i = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - n;
    d >= r ? o(c, u) : (a = c, i || (i = setTimeout(() => {
      i = null, o(a);
    }, r - d)));
  }, () => a && o(a)];
}
const f5 = (e, t, n = 3) => {
  let r = 0;
  const a = z$(50, 250);
  return G$((i) => {
    const o = i.loaded, s = i.lengthComputable ? i.total : void 0, l = o - r, c = a(l), u = o <= s;
    r = o;
    const d = {
      loaded: o,
      total: s,
      progress: s ? o / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - o) / c : void 0,
      event: i,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, Ip = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Hp = (e) => (...t) => se.asap(() => e(...t)), U$ = fn.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function a(i) {
      let o = i;
      return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = a(window.location.href), function(o) {
      const s = se.isString(o) ? a(o) : o;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Z$ = fn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, a, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      se.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), se.isString(r) && o.push("path=" + r), se.isString(a) && o.push("domain=" + a), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function K$(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function $$(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Sb(e, t) {
  return e && !K$(t) ? $$(e, t) : t;
}
const Fp = (e) => e instanceof vr ? { ...e } : e;
function Y2(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return se.isPlainObject(c) && se.isPlainObject(u) ? se.merge.call({ caseless: d }, c, u) : se.isPlainObject(u) ? se.merge({}, u) : se.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d) {
    if (se.isUndefined(u)) {
      if (!se.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function i(c, u) {
    if (!se.isUndefined(u))
      return r(void 0, u);
  }
  function o(c, u) {
    if (se.isUndefined(u)) {
      if (!se.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (c, u) => a(Fp(c), Fp(u), !0)
  };
  return se.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || a, p = d(e[u], t[u], u);
    se.isUndefined(p) && d !== s || (n[u] = p);
  }), n;
}
const kb = (e) => {
  const t = Y2({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: i, headers: o, auth: s } = t;
  t.headers = o = vr.from(o), t.url = vb(Sb(t.baseURL, t.url), e.params, e.paramsSerializer), s && o.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (se.isFormData(n)) {
    if (fn.hasStandardBrowserEnv || fn.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      o.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (fn.hasStandardBrowserEnv && (r && se.isFunction(r) && (r = r(t)), r || r !== !1 && U$(t.url))) {
    const c = a && i && Z$.read(i);
    c && o.set(a, c);
  }
  return t;
}, W$ = typeof XMLHttpRequest < "u", Y$ = W$ && function(e) {
  return new Promise(function(n, r) {
    const a = kb(e);
    let i = a.data;
    const o = vr.from(a.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: c } = a, u, d, p, h, m;
    function f() {
      h && h(), m && m(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let C = new XMLHttpRequest();
    C.open(a.method.toUpperCase(), a.url, !0), C.timeout = a.timeout;
    function _() {
      if (!C)
        return;
      const w = vr.from(
        "getAllResponseHeaders" in C && C.getAllResponseHeaders()
      ), b = {
        data: !s || s === "text" || s === "json" ? C.responseText : C.response,
        status: C.status,
        statusText: C.statusText,
        headers: w,
        config: e,
        request: C
      };
      xb(function(P) {
        n(P), f();
      }, function(P) {
        r(P), f();
      }, b), C = null;
    }
    "onloadend" in C ? C.onloadend = _ : C.onreadystatechange = function() {
      !C || C.readyState !== 4 || C.status === 0 && !(C.responseURL && C.responseURL.indexOf("file:") === 0) || setTimeout(_);
    }, C.onabort = function() {
      C && (r(new rt("Request aborted", rt.ECONNABORTED, e, C)), C = null);
    }, C.onerror = function() {
      r(new rt("Network Error", rt.ERR_NETWORK, e, C)), C = null;
    }, C.ontimeout = function() {
      let k = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const b = a.transitional || bb;
      a.timeoutErrorMessage && (k = a.timeoutErrorMessage), r(new rt(
        k,
        b.clarifyTimeoutError ? rt.ETIMEDOUT : rt.ECONNABORTED,
        e,
        C
      )), C = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in C && se.forEach(o.toJSON(), function(k, b) {
      C.setRequestHeader(b, k);
    }), se.isUndefined(a.withCredentials) || (C.withCredentials = !!a.withCredentials), s && s !== "json" && (C.responseType = a.responseType), c && ([p, m] = f5(c, !0), C.addEventListener("progress", p)), l && C.upload && ([d, h] = f5(l), C.upload.addEventListener("progress", d), C.upload.addEventListener("loadend", h)), (a.cancelToken || a.signal) && (u = (w) => {
      C && (r(!w || w.type ? new ho(null, e, C) : w), C.abort(), C = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const v = B$(a.url);
    if (v && fn.protocols.indexOf(v) === -1) {
      r(new rt("Unsupported protocol " + v + ":", rt.ERR_BAD_REQUEST, e));
      return;
    }
    C.send(i || null);
  });
}, q$ = (e, t) => {
  let n = new AbortController(), r;
  const a = function(l) {
    if (!r) {
      r = !0, o();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof rt ? c : new ho(c instanceof Error ? c.message : c));
    }
  };
  let i = t && setTimeout(() => {
    a(new rt(`timeout ${t} of ms exceeded`, rt.ETIMEDOUT));
  }, t);
  const o = () => {
    e && (i && clearTimeout(i), i = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", a) : l.unsubscribe(a));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", a));
  const { signal: s } = n;
  return s.unsubscribe = o, [s, () => {
    i && clearTimeout(i), i = null;
  }];
}, J$ = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + t, yield e.slice(r, a), r = a;
}, X$ = async function* (e, t, n) {
  for await (const r of e)
    yield* J$(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, Vp = (e, t, n, r, a) => {
  const i = X$(e, t, a);
  let o = 0, s, l = (c) => {
    s || (s = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await i.next();
        if (u) {
          l(), c.close();
          return;
        }
        let p = d.byteLength;
        if (n) {
          let h = o += p;
          n(h);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, L8 = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Mb = L8 && typeof ReadableStream == "function", Pl = L8 && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Pb = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Q$ = Mb && Pb(() => {
  let e = !1;
  const t = new Request(fn.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Bp = 64 * 1024, El = Mb && Pb(() => se.isReadableStream(new Response("").body)), C5 = {
  stream: El && ((e) => e.body)
};
L8 && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !C5[t] && (C5[t] = se.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new rt(`Response type '${t}' is not supported`, rt.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const eW = async (e) => {
  if (e == null)
    return 0;
  if (se.isBlob(e))
    return e.size;
  if (se.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (se.isArrayBufferView(e) || se.isArrayBuffer(e))
    return e.byteLength;
  if (se.isURLSearchParams(e) && (e = e + ""), se.isString(e))
    return (await Pl(e)).byteLength;
}, tW = async (e, t) => {
  const n = se.toFiniteNumber(e.getContentLength());
  return n ?? eW(t);
}, rW = L8 && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: a,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = kb(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, m] = a || i || o ? q$([a, i], o) : [], f, C;
  const _ = () => {
    !f && setTimeout(() => {
      h && h.unsubscribe();
    }), f = !0;
  };
  let v;
  try {
    if (l && Q$ && n !== "get" && n !== "head" && (v = await tW(u, r)) !== 0) {
      let S = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), P;
      if (se.isFormData(r) && (P = S.headers.get("content-type")) && u.setContentType(P), S.body) {
        const [O, A] = Ip(
          v,
          f5(Hp(l))
        );
        r = Vp(S.body, Bp, O, A, Pl);
      }
    }
    se.isString(d) || (d = d ? "include" : "omit"), C = new Request(t, {
      ...p,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: d
    });
    let w = await fetch(C);
    const k = El && (c === "stream" || c === "response");
    if (El && (s || k)) {
      const S = {};
      ["status", "statusText", "headers"].forEach((L) => {
        S[L] = w[L];
      });
      const P = se.toFiniteNumber(w.headers.get("content-length")), [O, A] = s && Ip(
        P,
        f5(Hp(s), !0)
      ) || [];
      w = new Response(
        Vp(w.body, Bp, O, () => {
          A && A(), k && _();
        }, Pl),
        S
      );
    }
    c = c || "text";
    let b = await C5[se.findKey(C5, c) || "text"](w, e);
    return !k && _(), m && m(), await new Promise((S, P) => {
      xb(S, P, {
        data: b,
        headers: vr.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: e,
        request: C
      });
    });
  } catch (w) {
    throw _(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new rt("Network Error", rt.ERR_NETWORK, e, C),
      {
        cause: w.cause || w
      }
    ) : rt.from(w, w && w.code, e, C);
  }
}), Tl = {
  http: v$,
  xhr: Y$,
  fetch: rW
};
se.forEach(Tl, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const zp = (e) => `- ${e}`, nW = (e) => se.isFunction(e) || e === null || e === !1, Eb = {
  getAdapter: (e) => {
    e = se.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const a = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let o;
      if (r = n, !nW(n) && (r = Tl[(o = String(n)).toLowerCase()], r === void 0))
        throw new rt(`Unknown adapter '${o}'`);
      if (r)
        break;
      a[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(zp).join(`
`) : " " + zp(i[0]) : "as no adapter specified";
      throw new rt(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Tl
};
function K7(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ho(null, e);
}
function Gp(e) {
  return K7(e), e.headers = vr.from(e.headers), e.data = Z7.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Eb.getAdapter(e.adapter || S9.adapter)(e).then(function(r) {
    return K7(e), r.data = Z7.call(
      e,
      e.transformResponse,
      r
    ), r.headers = vr.from(r.headers), r;
  }, function(r) {
    return wb(r) || (K7(e), r && r.response && (r.response.data = Z7.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = vr.from(r.response.headers))), Promise.reject(r);
  });
}
const Tb = "1.7.4", q3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  q3[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Up = {};
q3.transitional = function(t, n, r) {
  function a(i, o) {
    return "[Axios v" + Tb + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, s) => {
    if (t === !1)
      throw new rt(
        a(o, " has been removed" + (n ? " in " + n : "")),
        rt.ERR_DEPRECATED
      );
    return n && !Up[o] && (Up[o] = !0, console.warn(
      a(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, s) : !0;
  };
};
function aW(e, t, n) {
  if (typeof e != "object")
    throw new rt("options must be an object", rt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let a = r.length;
  for (; a-- > 0; ) {
    const i = r[a], o = t[i];
    if (o) {
      const s = e[i], l = s === void 0 || o(s, i, e);
      if (l !== !0)
        throw new rt("option " + i + " must be " + l, rt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new rt("Unknown option " + i, rt.ERR_BAD_OPTION);
  }
}
const Ll = {
  assertOptions: aW,
  validators: q3
}, Pa = Ll.validators;
class F2 {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Rp(),
      response: new Rp()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let a;
        Error.captureStackTrace ? Error.captureStackTrace(a = {}) : a = new Error();
        const i = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Y2(this.defaults, n);
    const { transitional: r, paramsSerializer: a, headers: i } = n;
    r !== void 0 && Ll.assertOptions(r, {
      silentJSONParsing: Pa.transitional(Pa.boolean),
      forcedJSONParsing: Pa.transitional(Pa.boolean),
      clarifyTimeoutError: Pa.transitional(Pa.boolean)
    }, !1), a != null && (se.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : Ll.assertOptions(a, {
      encode: Pa.function,
      serialize: Pa.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && se.merge(
      i.common,
      i[n.method]
    );
    i && se.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete i[m];
      }
    ), n.headers = vr.concat(o, i);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(f) {
      typeof f.runWhen == "function" && f.runWhen(n) === !1 || (l = l && f.synchronous, s.unshift(f.fulfilled, f.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(f) {
      c.push(f.fulfilled, f.rejected);
    });
    let u, d = 0, p;
    if (!l) {
      const m = [Gp.bind(this), void 0];
      for (m.unshift.apply(m, s), m.push.apply(m, c), p = m.length, u = Promise.resolve(n); d < p; )
        u = u.then(m[d++], m[d++]);
      return u;
    }
    p = s.length;
    let h = n;
    for (d = 0; d < p; ) {
      const m = s[d++], f = s[d++];
      try {
        h = m(h);
      } catch (C) {
        f.call(this, C);
        break;
      }
    }
    try {
      u = Gp.call(this, h);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, p = c.length; d < p; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = Y2(this.defaults, t);
    const n = Sb(t.baseURL, t.url);
    return vb(n, t.params, t.paramsSerializer);
  }
}
se.forEach(["delete", "get", "head", "options"], function(t) {
  F2.prototype[t] = function(n, r) {
    return this.request(Y2(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
se.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, o, s) {
      return this.request(Y2(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  F2.prototype[t] = n(), F2.prototype[t + "Form"] = n(!0);
});
class J3 {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let i;
      const o = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(a);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(i, o, s) {
      r.reason || (r.reason = new ho(i, o, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new J3(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
}
function iW(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function oW(e) {
  return se.isObject(e) && e.isAxiosError === !0;
}
const Al = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Al).forEach(([e, t]) => {
  Al[t] = e;
});
function Lb(e) {
  const t = new F2(e), n = sb(F2.prototype.request, t);
  return se.extend(n, F2.prototype, t, { allOwnKeys: !0 }), se.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(a) {
    return Lb(Y2(e, a));
  }, n;
}
const P1 = Lb(S9);
P1.Axios = F2;
P1.CanceledError = ho;
P1.CancelToken = J3;
P1.isCancel = wb;
P1.VERSION = Tb;
P1.toFormData = T8;
P1.AxiosError = rt;
P1.Cancel = P1.CanceledError;
P1.all = function(t) {
  return Promise.all(t);
};
P1.spread = iW;
P1.isAxiosError = oW;
P1.mergeConfig = Y2;
P1.AxiosHeaders = vr;
P1.formToJSON = (e) => _b(se.isHTMLForm(e) ? new FormData(e) : e);
P1.getAdapter = Eb.getAdapter;
P1.HttpStatusCode = Al;
P1.default = P1;
const A8 = P1.create(Ti.defaults);
A8.interceptors.response.use((e) => e.data, Ov());
const xr = ({
  thumbnail: e,
  imageType: t,
  alt: n,
  className: r,
  width: a = OK(t),
  height: i = NK(t),
  skipTheme: o
}) => {
  const { isDefaultTheme: s, state: l } = wr(), { primaryColor: c, secondaryColor: u } = S8(l), d = !e, p = d ? "" : e.path, h = d && !s && !o, m = d ? ZZ(t, {
    width: a,
    height: i,
    fill: h ? c : "rgb(var(--text-primary))",
    className: r,
    primaryColor: h ? c : _l.default.primaryColor,
    secondaryColor: h ? u : _l.default.secondaryColor
  }) : null;
  return d ? m : /* @__PURE__ */ x.jsx("img", { className: r, alt: n, width: a, height: i, src: p });
}, Mn = (e) => {
  switch (e.type) {
    case l1.instagram:
      return "https://www.instagram.com/" + e.url;
    case l1.twitter:
      return "https://twitter.com/" + e.url;
    case l1.tiktok:
      return "https://www.tiktok.com/@" + e.url;
    case l1.telegram:
      return "https://t.me/" + e.url;
    case l1.email:
      return "mailto:" + e.url;
    default:
      return e.url;
  }
}, sW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      style: {
        backgroundImage: `url(${qv}/images/profile-background/luminous-profile-background.png)`
      },
      className: "bg-THEME-secondary shadow-around-sm flex w-full flex-col items-center justify-center gap-5 rounded-none p-10 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ x.jsx(
          xr,
          {
            width: 96,
            height: 96,
            imageType: $e.profile,
            alt: e.sellerName,
            thumbnail: e.sellerPhoto,
            className: "border-THEME-primary rounded-full border-2 object-cover"
          }
        ),
        /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col items-center justify-center gap-3", children: [
          /* @__PURE__ */ x.jsx("h1", { lang: n, className: "text-THEME-primary break-all text-center text-2xl font-bold", children: e.sellerName }),
          /* @__PURE__ */ x.jsx("span", { lang: n, className: "hyphens-auto text-center text-[16px] font-normal ", children: e.bio })
        ] }),
        !!t.length && /* @__PURE__ */ x.jsx("div", { className: "flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ x.jsx(
          "a",
          {
            href: Mn(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-1",
            children: Pn(r.type, "fill-THEME-text-secondary")
          },
          r.type
        )) })
      ]
    }
  );
}, lW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      className: "bg-THEME-secondary shadow-around-sm flex w-full flex-col items-center justify-center gap-5 rounded-none px-5 py-10 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ x.jsx(
          xr,
          {
            imageType: $e.profile,
            alt: e.sellerName,
            thumbnail: e.sellerPhoto,
            className: "border-THEME-primary rounded-full border-2 object-cover"
          }
        ),
        /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ x.jsx("h1", { lang: n, className: "text-text-primary break-all text-center text-2xl font-bold", children: e.sellerName }),
          /* @__PURE__ */ x.jsx("span", { lang: n, className: "hyphens-auto text-center text-lg font-medium", children: e.bio })
        ] }),
        !!t.length && /* @__PURE__ */ x.jsx("div", { className: "flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ x.jsx(
          "a",
          {
            href: Mn(r),
            target: "_blank",
            rel: "noreferrer",
            className: "border-text-secondary/30 rounded-md border p-1",
            children: Pn(r.type, "fill-THEME-primary")
          },
          r.type
        )) })
      ]
    }
  );
}, cW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[500px] w-full flex-col items-center justify-end gap-5 overflow-hidden rounded-none bg-cover bg-center px-10 pb-10 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ x.jsx(
          xr,
          {
            width: 500,
            height: 500,
            alt: e.sellerName,
            imageType: $e.profile,
            className: "-z-1 absolute top-0 w-full "
          }
        ),
        /* @__PURE__ */ x.jsxs("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ x.jsx(
            "h1",
            {
              lang: n,
              className: "text-THEME-primary break-all text-center text-[40px] font-bold leading-[50px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ x.jsx(
            "span",
            {
              lang: n,
              className: "hyphens-auto text-center text-lg font-normal text-[#FAFAFA]",
              children: e.bio
            }
          )
        ] }),
        !!t.length && /* @__PURE__ */ x.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ x.jsx(
          "a",
          {
            href: Mn(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-1",
            children: Pn(r.type, "fill-THEME-text-secondary")
          },
          r.type
        )) }),
        /* @__PURE__ */ x.jsx(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-[300px] w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, uW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsx("div", { className: "flex w-full max-w-xl flex-col gap-5 px-5 py-10 sm:px-0", children: /* @__PURE__ */ x.jsxs("div", { className: "flex flex-row gap-5", children: [
    /* @__PURE__ */ x.jsx("div", { className: "border-3 border-THEME-primary self-start rounded-full", children: /* @__PURE__ */ x.jsx(
      xr,
      {
        width: 99,
        height: 99,
        imageType: $e.profile,
        alt: e.sellerName,
        thumbnail: e.sellerPhoto,
        className: "rounded-full border-2 border-transparent object-cover"
      }
    ) }),
    /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col justify-between", children: [
      /* @__PURE__ */ x.jsx(
        "h1",
        {
          lang: n,
          className: "text-THEME-primary mb-1 break-all text-[22px] font-bold leading-7",
          children: e.sellerName
        }
      ),
      /* @__PURE__ */ x.jsx("span", { lang: n, className: "mb-2.5 hyphens-auto text-[14px] font-normal leading-4", children: e.bio }),
      !!t.length && /* @__PURE__ */ x.jsx("div", { className: "flex flex-wrap items-start gap-1.5", children: t.map((r) => /* @__PURE__ */ x.jsx(
        "a",
        {
          href: Mn(r),
          target: "_blank",
          rel: "noreferrer",
          className: "rounded-full bg-[#F1F4F8] p-2",
          children: Pn(r.type, "fill-THEME-primary")
        },
        r.type
      )) })
    ] })
  ] }) });
}, dW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      className: "flex w-full flex-col items-center justify-center gap-5 px-5 py-10 sm:max-w-xl sm:px-0",
      children: [
        /* @__PURE__ */ x.jsx(
          xr,
          {
            width: 200,
            height: 200,
            alt: e.sellerName,
            imageType: $e.profile,
            thumbnail: e.sellerPhoto,
            className: "rounded-full object-cover"
          }
        ),
        /* @__PURE__ */ x.jsxs(
          "div",
          {
            className: "z-1 flex flex-col items-center justify-center gap-4 text-center font-normal",
            children: [
              /* @__PURE__ */ x.jsx("h1", { lang: n, className: "text-THEME-primary break-all text-[48px] leading-[62px]", children: e.sellerName }),
              /* @__PURE__ */ x.jsx("span", { lang: n, className: "hyphens-auto text-[18px] leading-[27px] text-[#242424]", children: e.bio }),
              !!t.length && /* @__PURE__ */ x.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ x.jsx(
                "a",
                {
                  href: Mn(r),
                  target: "_blank",
                  rel: "noreferrer",
                  className: "p-1",
                  children: Pn(r.type, "fill-[#242424] ")
                },
                r.type
              )) })
            ]
          }
        )
      ]
    }
  );
}, pW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsx("div", { className: "flex w-full max-w-xl flex-col gap-5 px-5 py-10 sm:px-0", children: /* @__PURE__ */ x.jsxs("div", { className: "flex flex-row gap-5", children: [
    /* @__PURE__ */ x.jsx("div", { className: "border-3 border-THEME-primary self-start rounded-full", children: /* @__PURE__ */ x.jsx(
      xr,
      {
        width: 99,
        height: 99,
        imageType: $e.profile,
        alt: e.sellerName,
        thumbnail: e.sellerPhoto,
        className: "rounded-full border-2 border-transparent object-cover"
      }
    ) }),
    /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col justify-center", children: [
      /* @__PURE__ */ x.jsx(
        "h1",
        {
          lang: n,
          className: "text-THEME-primary mb-1 break-all text-[22px] font-bold leading-7",
          children: e.sellerName
        }
      ),
      /* @__PURE__ */ x.jsx("span", { lang: n, className: "mb-2.5 hyphens-auto text-[14px] font-normal leading-4", children: e.bio }),
      !!t.length && /* @__PURE__ */ x.jsx("div", { className: "flex flex-wrap items-start gap-1.5", children: t.map((r) => /* @__PURE__ */ x.jsx(
        "a",
        {
          href: Mn(r),
          target: "_blank",
          rel: "noreferrer",
          className: "bg-THEME-secondary rounded-full p-2",
          children: Pn(r.type, "fill-THEME-primary")
        },
        r.type
      )) })
    ] })
  ] }) });
}, hW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[500px] w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-none bg-cover bg-center px-10 pb-8 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ x.jsx(
          xr,
          {
            width: 500,
            height: 500,
            alt: e.sellerName,
            imageType: $e.profile,
            className: "-z-1 absolute top-0 w-full"
          }
        ),
        /* @__PURE__ */ x.jsxs("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ x.jsx("h1", { lang: n, className: "break-all text-center text-[28px] font-bold leading-[36px]", children: e.sellerName }),
          /* @__PURE__ */ x.jsx(
            "span",
            {
              lang: n,
              className: "hyphens-auto text-center text-base font-normal text-[#F1F4F8]",
              children: e.bio
            }
          )
        ] }),
        !!t.length && /* @__PURE__ */ x.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-4", children: t.map((r) => /* @__PURE__ */ x.jsx(
          "a",
          {
            href: Mn(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-0.5",
            children: Pn(r.type, "fill-THEME-primary")
          },
          r.type
        )) }),
        /* @__PURE__ */ x.jsx(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-[300px] w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, mW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      style: {
        backgroundImage: e.sellerPhoto ? `url(${e.sellerPhoto.path})` : "none"
      },
      className: "bg-THEME-secondary relative z-0 flex min-h-[520px] w-full flex-col items-center justify-end gap-4 overflow-hidden rounded-none bg-cover bg-center px-10 pb-12 pt-5 sm:max-w-xl sm:rounded-lg",
      children: [
        !e.sellerPhoto && /* @__PURE__ */ x.jsx(
          xr,
          {
            width: 500,
            height: 520,
            alt: e.sellerName,
            imageType: $e.profile,
            className: "-z-1 absolute top-0 w-full"
          }
        ),
        /* @__PURE__ */ x.jsxs("div", { className: "z-1 flex flex-col items-center justify-center", children: [
          /* @__PURE__ */ x.jsx(
            "h1",
            {
              lang: n,
              className: "mb-2 break-all text-center text-[40px] font-bold leading-[50px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ x.jsx(
            "span",
            {
              lang: n,
              className: "mb-4 hyphens-auto text-center text-lg font-normal text-[#FAFAFA]",
              children: e.bio
            }
          )
        ] }),
        !!t.length && /* @__PURE__ */ x.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-6", children: t.map((r) => /* @__PURE__ */ x.jsx(
          "a",
          {
            href: Mn(r),
            target: "_blank",
            rel: "noreferrer",
            className: "rounded-md p-0.5",
            children: Pn(r.type, "fill-[#FAFAFA]")
          },
          r.type
        )) }),
        /* @__PURE__ */ x.jsx(
          "div",
          {
            className: "from-THEME-secondary -z-1 absolute bottom-0 h-full w-full bg-gradient-to-t to-transparent sm:rounded-b-lg"
          }
        )
      ]
    }
  );
}, fW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsxs(
    "div",
    {
      style: {
        backgroundImage: `linear-gradient(to top, rgba(5, 0, 33, 1) 0%, rgba(6, 1, 36, 0.64) 100%), 
          url(${qv}/images/profile-background/urban-profile-background.jpeg)`
      },
      className: "flex min-h-[500px] w-full flex-col items-center justify-center gap-20 bg-cover bg-center px-5 py-12 sm:max-w-xl sm:rounded-lg",
      children: [
        /* @__PURE__ */ x.jsx("div", { className: "border-3 border-THEME-secondary rounded-full", children: /* @__PURE__ */ x.jsx(
          xr,
          {
            className: "rounded-full border-0 border-transparent",
            width: 149,
            height: 149,
            alt: e.sellerName,
            imageType: $e.profile,
            thumbnail: e.sellerPhoto
          }
        ) }),
        /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col items-center", children: [
          /* @__PURE__ */ x.jsx(
            "h1",
            {
              lang: n,
              className: "text-THEME-primary mb-2 break-all text-center text-[40px] font-bold leading-[50.4px]",
              children: e.sellerName
            }
          ),
          /* @__PURE__ */ x.jsx(
            "span",
            {
              lang: n,
              className: "text-THEME-secondary mb-4 hyphens-auto text-center text-lg font-normal",
              children: e.bio
            }
          ),
          !!t.length && /* @__PURE__ */ x.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1.5", children: t.map((r) => /* @__PURE__ */ x.jsx(
            "a",
            {
              href: Mn(r),
              target: "_blank",
              rel: "noreferrer",
              className: "rounded-md p-1",
              children: Pn(r.type, "fill-THEME-secondary")
            },
            r.type
          )) })
        ] })
      ]
    }
  );
}, CW = ({ profile: e, socialLinks: t }) => {
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: "mx-5 w-full overflow-hidden py-9 sm:max-w-xl ",
      style: { width: "calc(100% - 2.5rem)" },
      children: /* @__PURE__ */ x.jsxs("div", { className: "border-THEME-primary/50 relative flex rounded-b-lg border-2 border-t-0", children: [
        /* @__PURE__ */ x.jsx("div", { className: "border-THEME-primary absolute -left-[15%] top-[20%] -z-10 h-[60%] w-[130%] rounded-t-full border-[15px] border-b-0 blur-[20px] sm:-left-[15%] sm:top-[25%] sm:h-[65%] sm:w-[130%]" }),
        /* @__PURE__ */ x.jsx("div", { className: "from-THEME-primary/30 to -z-1 absolute -inset-x-[1px] -bottom-[0.5px] top-0 rounded-b-lg bg-gradient-to-t to-transparent opacity-70" }),
        /* @__PURE__ */ x.jsx("div", { className: "border-THEME-tertiary absolute inset-y-0 -left-[3px] bottom-[3px] z-0 border-l-4" }),
        /* @__PURE__ */ x.jsx(
          "div",
          {
            className: "z-1 absolute inset-y-0 -left-[2px] bottom-[3px] border-l-2 opacity-50 md:-left-[1.5px]",
            style: {
              borderImage: "linear-gradient(to bottom, transparent, var(--THEME-primary)) 2"
            }
          }
        ),
        /* @__PURE__ */ x.jsx("div", { className: "border-THEME-tertiary absolute inset-y-0 -right-[3px] bottom-[3px] z-0 border-l-4" }),
        /* @__PURE__ */ x.jsx(
          "div",
          {
            className: "z-1 absolute inset-y-0 -right-[1.5px] bottom-[3px] border-l-2 opacity-50",
            style: {
              borderImage: "linear-gradient(to bottom, transparent, var(--THEME-primary)) 2"
            }
          }
        ),
        /* @__PURE__ */ x.jsxs("div", { className: "flex w-full flex-col items-center justify-end gap-10 px-5 py-9", children: [
          /* @__PURE__ */ x.jsx("div", { className: "border-THEME-primary rounded-full border-[15px]", children: /* @__PURE__ */ x.jsx(
            xr,
            {
              className: "rounded-full border-0 border-transparent",
              width: 149,
              height: 149,
              alt: e.sellerName,
              imageType: $e.profile,
              thumbnail: e.sellerPhoto
            }
          ) }),
          /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col items-center", children: [
            /* @__PURE__ */ x.jsx(
              "h1",
              {
                lang: n,
                className: "text-THEME-text-primary break-all text-center text-[35px] font-bold leading-[45.57px]",
                children: e.sellerName
              }
            ),
            e.bio && /* @__PURE__ */ x.jsx(
              "span",
              {
                lang: n,
                className: "text-THEME-text-primary mb-4 mt-2 hyphens-auto text-center text-lg font-normal",
                children: e.bio
              }
            ),
            !!t.length && /* @__PURE__ */ x.jsx("div", { className: "z-1 flex flex-wrap items-center justify-center gap-1", children: t.map((r) => /* @__PURE__ */ x.jsx(
              "a",
              {
                href: Mn(r),
                target: "_blank",
                rel: "noreferrer",
                className: "rounded-md p-1",
                children: Pn(r.type, "fill-THEME-text-primary")
              },
              r.type
            )) })
          ] })
        ] })
      ] })
    }
  );
}, gW = ({ profile: e, socialLinks: t }) => {
  var r;
  const { locale: n } = Rt();
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      style: {
        backgroundImage: (r = e.sellerPhoto) != null && r.path ? `url(${e.sellerPhoto.path})` : void 0
      },
      className: " bg-center-left w-full overflow-hidden bg-contain bg-no-repeat sm:max-w-xl sm:rounded-lg sm:bg-[length:50%_120%]",
      children: /* @__PURE__ */ x.jsxs(
        "div",
        {
          className: `
          from-THEME-primary min-[460px]:from-78% flex min-h-[215px] bg-gradient-to-l from-70% to-[transparent] bg-[length:70%]
          bg-right bg-no-repeat 
          p-5 min-[460px]:bg-[length:78%] 
          min-[500px]:from-80% min-[500px]:bg-[length:80%] 
          sm:from-70% sm:bg-[length:73%]
        `,
          children: [
            !e.sellerPhoto && /* @__PURE__ */ x.jsx("div", { className: "border-3 border-THEME-primary my-auto rounded-full", children: /* @__PURE__ */ x.jsx(
              xr,
              {
                className: "rounded-full border-0 border-transparent",
                width: 104,
                height: 104,
                alt: e.sellerName,
                imageType: $e.profile,
                thumbnail: e.sellerPhoto
              }
            ) }),
            /* @__PURE__ */ x.jsxs("div", { className: "my-auto ml-auto flex w-[60%] flex-col", children: [
              /* @__PURE__ */ x.jsx(
                "h1",
                {
                  lang: n,
                  className: "text-THEME-text-primary mb-1 break-all text-left text-[22px] font-medium leading-[26.82px]",
                  children: e.sellerName
                }
              ),
              /* @__PURE__ */ x.jsx(
                "span",
                {
                  lang: n,
                  className: "text-THEME-text-primary mb-2.5 hyphens-auto text-left text-lg font-normal",
                  children: e.bio
                }
              ),
              !!t.length && /* @__PURE__ */ x.jsx("div", { className: "justify-left z-1 flex flex-wrap items-center gap-1.5", children: t.map((a) => /* @__PURE__ */ x.jsx(
                "a",
                {
                  href: Mn(a),
                  target: "_blank",
                  rel: "noreferrer",
                  className: "bg-THEME-secondary rounded-full p-2",
                  children: Pn(a.type, "fill-THEME-primary")
                },
                a.type
              )) })
            ] })
          ]
        }
      )
    }
  );
};
var l1 = /* @__PURE__ */ ((e) => (e.tiktok = "tiktok", e.youtube = "youtube", e.instagram = "instagram", e.twitter = "twitter", e.facebook = "facebook", e.spotify = "spotify", e.linkedin = "linkedin", e.pinterest = "pinterest", e.snapchat = "snapchat", e.twitch = "twitch", e.discord = "discord", e.telegram = "telegram", e.vimeo = "vimeo", e.etsy = "etsy", e.email = "email", e.website = "website", e.whatsapp = "whatsapp", e))(l1 || {});
function yW(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      width: "27",
      height: "20",
      viewBox: "0 0 27 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx("path", { d: "M22.2137 1.65786C20.5409 0.890326 18.7478 0.325064 16.8727 0.00143234C16.8388 -0.00512776 16.8049 0.0112724 16.7863 0.0418862C16.5556 0.451893 16.2998 0.987634 16.1215 1.40748C14.1043 1.10572 12.098 1.10572 10.1223 1.40748C9.94412 0.977794 9.67843 0.451893 9.44774 0.0418862C9.42915 0.0112724 9.39526 -0.00403441 9.36136 0.00143234C7.48736 0.323971 5.69427 0.889233 4.02035 1.65786C4.00613 1.66332 3.99301 1.67426 3.98536 1.68738C0.583945 6.76927 -0.348683 11.7265 0.108337 16.6225C0.110524 16.6466 0.123644 16.6696 0.142231 16.6838C2.38688 18.3325 4.56046 19.333 6.69468 19.9955C6.72857 20.0065 6.76465 19.9933 6.78652 19.9649C7.29165 19.2761 7.74102 18.549 8.12697 17.7848C8.14993 17.74 8.12806 17.6864 8.08105 17.6689C7.36709 17.3977 6.68812 17.0675 6.0343 16.6936C5.98291 16.663 5.97854 16.5897 6.02555 16.5537C6.16331 16.4509 6.30107 16.3437 6.43228 16.2355C6.45633 16.2158 6.48913 16.2114 6.51756 16.2246C10.8122 18.1849 15.4612 18.1849 19.7045 16.2246C19.7329 16.2114 19.7657 16.2147 19.7908 16.2355C19.922 16.3437 20.0598 16.452 20.1987 16.5548C20.2468 16.5897 20.2435 16.6641 20.191 16.6947C19.5372 17.0763 18.8582 17.3999 18.1432 17.6689C18.0961 17.6864 18.0765 17.741 18.0983 17.7859C18.4919 18.549 18.9424 19.2761 19.4377 19.9649C19.4585 19.9944 19.4956 20.0065 19.5295 19.9966C21.6736 19.333 23.8483 18.3325 26.0918 16.6849C26.1115 16.6707 26.1235 16.6488 26.1257 16.6247C26.6724 10.9645 25.2095 6.04766 22.2465 1.68957C22.241 1.67426 22.2279 1.66332 22.2137 1.65786ZM8.76877 13.6421C7.47533 13.6421 6.41041 12.4547 6.41041 10.9973C6.41041 9.53982 7.45456 8.35244 8.76877 8.35244C10.0928 8.35244 11.1479 9.54966 11.1271 10.9973C11.1271 12.4558 10.0819 13.6421 8.76877 13.6421ZM17.4882 13.6421C16.1959 13.6421 15.1299 12.4547 15.1299 10.9973C15.1299 9.53982 16.174 8.35244 17.4882 8.35244C18.8123 8.35244 19.8674 9.54966 19.8466 10.9973C19.8466 12.4558 18.8123 13.6421 17.4882 13.6421Z" })
    }
  );
}
function vW(e) {
  return /* @__PURE__ */ x.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...e, children: [
    /* @__PURE__ */ x.jsx("path", { d: "M23.2,3.71l-1.86,1.65-8.84,7.83c-.29,.26-.72,.26-1.01,0L2.66,5.36,.8,3.71c.46-.44,1.08-.71,1.76-.71H21.44c.68,0,1.3,.27,1.76,.71Z" }),
    /* @__PURE__ */ x.jsx("path", { d: "M24,5.56v12.88c0,1.41-1.15,2.56-2.56,2.56H2.56c-1.41,0-2.56-1.15-2.56-2.56V5.56l.15-.07L11.02,15.13c.56,.49,1.39,.49,1.95,0L23.85,5.49l.15,.07Z" })
  ] });
}
function bW(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx("path", { d: "M17.2792 13.3805H16.5578C16.4251 13.3805 16.3095 13.471 16.2776 13.5998L15.8153 15.4677C15.5602 16.4988 14.6348 17.2231 13.5727 17.2231H8.73963C8.16746 17.2231 7.70363 16.7592 7.70363 16.187V11.0263C7.70363 10.9303 7.78153 10.8524 7.87758 10.8524H11.1943C11.9565 10.8524 12.5744 11.4703 12.5744 12.2324V12.6976C12.5744 12.857 12.7036 12.9862 12.863 12.9862H13.4919C13.6513 12.9862 13.7805 12.857 13.7805 12.6976V6.89647C13.7805 6.73706 13.6513 6.60786 13.4919 6.60786H12.7703C12.6109 6.60786 12.4816 6.73706 12.4816 6.89647V7.69409C12.4816 8.45626 11.8637 9.07417 11.1016 9.07417H7.87758C7.78152 9.07417 7.70363 8.99627 7.70363 8.90018V3.88638C7.70363 3.26725 8.20553 2.76535 8.82469 2.76535H13.5408C14.493 2.76535 15.2649 3.53726 15.2649 4.48944V5.87852C15.2649 6.03794 15.3942 6.16714 15.5535 6.16714H16.2292C16.3791 6.16714 16.504 6.05243 16.5168 5.90308L16.8475 2.03151C16.8834 1.6111 16.5519 1.25 16.1299 1.25H2.37926C2.21985 1.25 2.09064 1.37921 2.09064 1.53862V2.58495C2.09064 2.74437 2.21985 2.87357 2.37926 2.87357H3.52867C4.20761 2.87357 4.75796 3.42396 4.75796 4.10286V16.0015C4.75796 16.6804 4.20761 17.2308 3.52867 17.2308H2.37926C2.21984 17.2308 2.09064 17.36 2.09064 17.5194V18.4613C2.09064 18.6208 2.21985 18.75 2.37926 18.75H16.3012C16.6518 18.75 16.9479 18.4897 16.9928 18.142L17.5655 13.7061C17.5878 13.5335 17.4533 13.3805 17.2792 13.3805Z" })
    }
  );
}
function _W(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx("path", { d: "M9.999 0C4.477 0 0 4.47698 0 9.99898C0 14.989 3.656 19.125 8.437 19.878V12.89H5.897V9.99898H8.437V7.79598C8.437 5.28798 9.93 3.90498 12.213 3.90498C13.307 3.90498 14.453 4.09998 14.453 4.09998V6.55898H13.189C11.949 6.55898 11.561 7.33098 11.561 8.12198V9.99698H14.332L13.889 12.888H11.561V19.876C16.342 19.127 19.998 14.99 19.998 9.99898C19.998 4.47698 15.521 0 9.999 0Z" })
    }
  );
}
function wW(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 24 24",
      width: "512",
      height: "512",
      fill: "rgb(var(--brand-primary))",
      ...e,
      children: /* @__PURE__ */ x.jsxs("g", { children: [
        /* @__PURE__ */ x.jsx("path", { d: "M12,2.162c3.204,0,3.584,0.012,4.849,0.07c1.308,0.06,2.655,0.358,3.608,1.311c0.962,0.962,1.251,2.296,1.311,3.608   c0.058,1.265,0.07,1.645,0.07,4.849c0,3.204-0.012,3.584-0.07,4.849c-0.059,1.301-0.364,2.661-1.311,3.608   c-0.962,0.962-2.295,1.251-3.608,1.311c-1.265,0.058-1.645,0.07-4.849,0.07s-3.584-0.012-4.849-0.07   c-1.291-0.059-2.669-0.371-3.608-1.311c-0.957-0.957-1.251-2.304-1.311-3.608c-0.058-1.265-0.07-1.645-0.07-4.849   c0-3.204,0.012-3.584,0.07-4.849c0.059-1.296,0.367-2.664,1.311-3.608c0.96-0.96,2.299-1.251,3.608-1.311   C8.416,2.174,8.796,2.162,12,2.162 M12,0C8.741,0,8.332,0.014,7.052,0.072C5.197,0.157,3.355,0.673,2.014,2.014   C0.668,3.36,0.157,5.198,0.072,7.052C0.014,8.332,0,8.741,0,12c0,3.259,0.014,3.668,0.072,4.948c0.085,1.853,0.603,3.7,1.942,5.038   c1.345,1.345,3.186,1.857,5.038,1.942C8.332,23.986,8.741,24,12,24c3.259,0,3.668-0.014,4.948-0.072   c1.854-0.085,3.698-0.602,5.038-1.942c1.347-1.347,1.857-3.184,1.942-5.038C23.986,15.668,24,15.259,24,12   c0-3.259-0.014-3.668-0.072-4.948c-0.085-1.855-0.602-3.698-1.942-5.038c-1.343-1.343-3.189-1.858-5.038-1.942   C15.668,0.014,15.259,0,12,0z" }),
        /* @__PURE__ */ x.jsx("path", { d: "M12,5.838c-3.403,0-6.162,2.759-6.162,6.162c0,3.403,2.759,6.162,6.162,6.162s6.162-2.759,6.162-6.162   C18.162,8.597,15.403,5.838,12,5.838z M12,16c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S14.209,16,12,16z" }),
        /* @__PURE__ */ x.jsx("circle", { cx: "18.406", cy: "5.594", r: "1.44" })
      ] })
    }
  );
}
function Zp(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      width: "21",
      height: "22",
      viewBox: "0 0 21 22",
      fill: "#CBD5E1",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.4388 7.42975C9.94619 7.92232 9.14741 7.92232 8.65484 7.42975C8.16227 6.93718 8.16227 6.1384 8.65484 5.64583L12.223 2.0775C14.1937 0.106979 17.3883 0.106979 19.3589 2.0775C21.3294 4.04818 21.3294 7.24282 19.3589 9.21342L15.7909 12.7814C15.2983 13.274 14.4996 13.274 14.007 12.7814C13.5143 12.2888 13.5143 11.4901 14.007 10.9973L17.575 7.4295C18.5602 6.44416 18.5602 4.84668 17.575 3.8615C16.5897 2.87616 14.9922 2.87616 14.007 3.8615L10.4388 7.42975ZM10.4391 14.5653C10.9316 14.0727 11.7304 14.0727 12.223 14.5653C12.7157 15.058 12.7157 15.8566 12.223 16.3493L8.65483 19.9175C6.68431 21.888 3.48951 21.888 1.51891 19.9175C-0.451614 17.947 -0.451614 14.7522 1.51891 12.7816L5.0869 9.21359C5.57964 8.72102 6.37825 8.72102 6.87099 9.21359C7.36356 9.70632 7.36356 10.5051 6.87099 10.9977L3.30298 14.5657C2.31764 15.5508 2.31764 17.1483 3.30298 18.1337C4.28816 19.1189 5.88565 19.1189 6.87099 18.1337L10.4391 14.5653ZM14.0071 7.42934C14.4996 7.92191 14.4996 8.72069 14.0071 9.21326L8.65483 14.5651C8.16226 15.0578 7.36348 15.0578 6.87091 14.5651C6.37834 14.0725 6.37834 13.2737 6.87091 12.7812L12.2227 7.42934C12.7155 6.93661 13.5141 6.93661 14.0068 7.42934H14.0071Z"
        }
      )
    }
  );
}
function xW(e) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "21",
      height: "20",
      viewBox: "0 0 21 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ x.jsx("path", { d: "M4.66575 6.42578H0.641865C0.463278 6.42578 0.318573 6.57055 0.318573 6.74907V19.6761C0.318573 19.8547 0.463278 19.9994 0.641865 19.9994H4.66575C4.84434 19.9994 4.98904 19.8547 4.98904 19.6761V6.74907C4.98904 6.57055 4.84434 6.42578 4.66575 6.42578Z" }),
        /* @__PURE__ */ x.jsx("path", { d: "M2.65526 0C1.19114 0 0 1.18984 0 2.65235C0 4.11551 1.19114 5.3058 2.65526 5.3058C4.11822 5.3058 5.30839 4.11544 5.30839 2.65235C5.30845 1.18984 4.11822 0 2.65526 0Z" }),
        /* @__PURE__ */ x.jsx("path", { d: "M14.9008 6.10547C13.2847 6.10547 12.09 6.80022 11.3653 7.58964V6.75005C11.3653 6.57153 11.2206 6.42676 11.042 6.42676H7.18847C7.00988 6.42676 6.86517 6.57153 6.86517 6.75005V19.6771C6.86517 19.8557 7.00988 20.0004 7.18847 20.0004H11.2036C11.3821 20.0004 11.5268 19.8557 11.5268 19.6771V13.2812C11.5268 11.1259 12.1123 10.2863 13.6147 10.2863C15.2509 10.2863 15.3809 11.6323 15.3809 13.3921V19.6771C15.3809 19.8557 15.5256 20.0004 15.7042 20.0004H19.7208C19.8994 20.0004 20.0441 19.8557 20.0441 19.6771V12.5864C20.0441 9.38164 19.433 6.10547 14.9008 6.10547Z" })
      ]
    }
  );
}
function SW(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx("path", { d: "M10.2719 0C4.79037 0 1.87524 3.51266 1.87524 7.34283C1.87524 9.11916 2.86779 11.3343 4.45661 12.0368C4.69787 12.1455 4.82913 12.0993 4.88288 11.8755C4.93038 11.7055 5.13914 10.8867 5.2404 10.5005C5.27165 10.3767 5.2554 10.2692 5.15539 10.153C4.62787 9.54293 4.2091 8.43163 4.2091 7.38908C4.2091 4.71771 6.33294 2.12385 9.94686 2.12385C13.072 2.12385 15.2583 4.15394 15.2583 7.05782C15.2583 10.3392 13.522 12.6093 11.2657 12.6093C10.0169 12.6093 9.08682 11.6293 9.38183 10.4167C9.7381 8.9729 10.4369 7.42033 10.4369 6.37904C10.4369 5.44524 9.90936 4.67271 8.83181 4.67271C7.5605 4.67271 6.5292 5.93152 6.5292 7.62159C6.5292 8.69539 6.90922 9.42042 6.90922 9.42042C6.90922 9.42042 5.65166 14.5007 5.4179 15.4494C5.02289 17.0558 5.47166 19.6571 5.51041 19.8809C5.53416 20.0046 5.67291 20.0434 5.75042 19.9421C5.87417 19.7796 7.39424 17.6108 7.82051 16.0432C7.97552 15.4719 8.6118 13.1556 8.6118 13.1556C9.03057 13.9119 10.2394 14.5457 11.5269 14.5457C15.3571 14.5457 18.1247 11.1793 18.1247 7.00156C18.111 2.99638 14.6833 0 10.2719 0Z" })
    }
  );
}
function kW(e) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ x.jsx("g", { clipPath: "url(#clip0_683_607)", children: /* @__PURE__ */ x.jsx("path", { d: "M9.99114 1.43967C12.6754 1.44057 14.9113 3.67528 14.9146 6.36602C14.9153 6.99625 14.9348 7.5766 14.9704 8.11121C14.9923 8.44105 15.2666 8.68549 15.5812 8.68549C15.6276 8.68549 15.6748 8.6802 15.7222 8.66909L16.563 8.47197C16.5988 8.46356 16.6347 8.45955 16.6702 8.45955C16.8838 8.45955 17.0804 8.60547 17.1284 8.82159C17.1962 9.12701 17.0251 9.43559 16.7291 9.53936L15.4527 10.0546C15.1305 10.1847 14.9574 10.5354 15.0481 10.8709C16.0722 14.6568 18.9324 14.2631 18.9324 14.7563C18.9324 15.3757 16.7765 15.4631 16.5817 15.658C16.387 15.8528 16.5733 16.7982 16.1381 16.9812C16.0561 17.0157 15.9395 17.0277 15.7974 17.0277C15.4696 17.0277 15.006 16.9638 14.5173 16.9638C14.0935 16.9638 13.6508 17.0119 13.2617 17.1917C12.2293 17.6686 11.2339 18.5594 10 18.5594C8.76613 18.5594 7.77078 17.6686 6.73837 17.1917C6.34912 17.0119 5.90658 16.9638 5.4827 16.9638C4.99412 16.9638 4.53044 17.0277 4.20268 17.0277C4.06061 17.0277 3.94394 17.0157 3.86195 16.9812C3.42675 16.7982 3.61307 15.8528 3.41829 15.658C3.22352 15.4631 1.0676 15.3756 1.0676 14.7563C1.0676 14.263 3.92788 14.6567 4.95193 10.8709C5.04267 10.5354 4.86959 10.1847 4.5473 10.0546L3.27088 9.53932C2.9749 9.43555 2.80378 9.12697 2.8716 8.82155C2.91955 8.60538 3.1162 8.45946 3.32977 8.4595C3.36521 8.4595 3.40117 8.46352 3.43695 8.47193L4.27784 8.66905C4.32524 8.68016 4.37243 8.68545 4.41876 8.68545C4.73332 8.68545 5.0077 8.44097 5.02965 8.11117C5.06522 7.57655 5.08469 6.9962 5.08546 6.36598C5.08871 3.67528 7.30684 1.44061 9.99114 1.43967ZM9.99148 0.37207H9.9911H9.99071C9.1895 0.372327 8.40899 0.533321 7.67098 0.850613C6.96256 1.15514 6.32499 1.58935 5.77599 2.14122C5.22771 2.69236 4.79623 3.33219 4.49354 4.04296C4.17881 4.78204 4.01876 5.56318 4.01777 6.3647C4.0173 6.75821 4.00915 7.14012 3.99343 7.50583L3.68058 7.43247C3.56579 7.40557 3.44776 7.3919 3.32985 7.39186C2.98937 7.39181 2.65351 7.5069 2.38413 7.7159C2.10309 7.93394 1.90601 8.24444 1.82927 8.59022C1.64663 9.41326 2.10108 10.2442 2.88863 10.5363L3.82543 10.9145C3.20511 12.8185 2.06128 13.1833 1.29103 13.4291C1.08665 13.4943 0.91011 13.5506 0.742027 13.634C0.072298 13.9665 0 14.5296 0 14.7563C0 15.1904 0.205492 15.5866 0.578683 15.8719C0.764489 16.0139 0.994664 16.1311 1.28232 16.2301C1.67439 16.3651 2.12889 16.4508 2.49828 16.5194C2.51613 16.6563 2.5423 16.8033 2.58642 16.9515C2.76958 17.5669 3.15609 17.8425 3.4481 17.9653C3.72516 18.0818 4.01145 18.0953 4.20268 18.0953C4.38973 18.0953 4.58745 18.0806 4.79678 18.0651C5.02136 18.0485 5.25359 18.0313 5.4827 18.0313C5.83774 18.0313 6.10203 18.0736 6.29066 18.1608C6.54966 18.2804 6.82433 18.4418 7.11515 18.6125C7.92473 19.088 8.84231 19.6269 10 19.6269C11.1577 19.6269 12.0753 19.088 12.8849 18.6125C13.1757 18.4417 13.4503 18.2804 13.7094 18.1608C13.898 18.0736 14.1623 18.0313 14.5173 18.0313C14.7465 18.0313 14.9787 18.0485 15.2032 18.0651C15.4126 18.0806 15.6103 18.0953 15.7973 18.0953C15.9885 18.0953 16.2748 18.0818 16.5519 17.9653C16.8439 17.8425 17.2304 17.5669 17.4136 16.9515C17.4577 16.8033 17.4839 16.6563 17.5017 16.5194C17.8711 16.4507 18.3257 16.3651 18.7177 16.2301C19.0054 16.1311 19.2355 16.0139 19.4213 15.8719C19.7945 15.5866 20 15.1904 20 14.7563C20 14.5296 19.9277 13.9665 19.2579 13.6341C19.0898 13.5507 18.9133 13.4944 18.7089 13.4292C17.9386 13.1834 16.7948 12.8185 16.1745 10.9145L17.1112 10.5364C17.8988 10.2442 18.3533 9.41326 18.1706 8.59022C18.0939 8.24444 17.8968 7.93394 17.6158 7.7159C17.3464 7.50694 17.0106 7.39186 16.6702 7.39186C16.5523 7.39186 16.4343 7.40552 16.3194 7.43243L16.0065 7.50579C15.9908 7.14012 15.9827 6.75821 15.9822 6.36465C15.9812 5.5625 15.8199 4.78059 15.5026 4.04052C15.1981 3.3301 14.7643 2.69043 14.2132 2.13925C13.6622 1.58811 13.0228 1.15437 12.313 0.8501C11.5735 0.533193 10.7925 0.372369 9.99148 0.37207Z" }) }),
        /* @__PURE__ */ x.jsx("defs", { children: /* @__PURE__ */ x.jsx("clipPath", { id: "clip0_683_607", children: /* @__PURE__ */ x.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function MW(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      height: "512",
      viewBox: "0 0 176 176",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx("g", { id: "Layer_2", "data-name": "Layer 2", children: /* @__PURE__ */ x.jsxs("g", { id: "_62.spotify", "data-name": "62.spotify", children: [
        /* @__PURE__ */ x.jsx("circle", { id: "background", cx: "88", cy: "88", r: "88" }),
        /* @__PURE__ */ x.jsxs("g", { id: "icon", fill: "#fff", children: [
          /* @__PURE__ */ x.jsx("path", { d: "m119.79 120.53a5.21 5.21 0 0 1 -7.12 1.87c-13.69-8-29.5-9.28-40.36-9a100.22 100.22 0 0 0 -20.93 2.76 5.21 5.21 0 0 1 -2.76-10 108.5 108.5 0 0 1 23.08-3.16 102.33 102.33 0 0 1 22.24 1.61 75.11 75.11 0 0 1 24 8.76 5.2 5.2 0 0 1 1.85 7.16z" }),
          /* @__PURE__ */ x.jsx("path", { d: "m129.47 100.42a6.16 6.16 0 0 1 -5.33 3.06 6.08 6.08 0 0 1 -3.11-.85c-16.21-9.47-34.93-11-47.8-10.6a118.31 118.31 0 0 0 -24.79 3.27 6.17 6.17 0 0 1 -3.27-11.89 127.88 127.88 0 0 1 27.34-3.7 119.43 119.43 0 0 1 26.35 1.91 88.81 88.81 0 0 1 28.4 10.38 6.17 6.17 0 0 1 2.21 8.42z" }),
          /* @__PURE__ */ x.jsx("path", { d: "m142 78.39a7.55 7.55 0 0 1 -10.35 2.71c-38.54-22.52-88.53-9.13-89-9a7.57 7.57 0 1 1 -4-14.59 157.1 157.1 0 0 1 33.45-4.51 148.15 148.15 0 0 1 32.31 2.34 109.15 109.15 0 0 1 34.84 12.66 7.57 7.57 0 0 1 2.75 10.39z" })
        ] })
      ] }) })
    }
  );
}
function PW(e) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ x.jsx("g", { clipPath: "url(#clip0_683_665)", children: /* @__PURE__ */ x.jsx("path", { d: "M7.8475 12.6505L7.51667 17.3039C7.99 17.3039 8.195 17.1005 8.44083 16.8564L10.66 14.7355L15.2583 18.103C16.1017 18.573 16.6958 18.3255 16.9233 17.3272L19.9417 3.18385L19.9425 3.18302C20.21 1.93635 19.4917 1.44885 18.67 1.75469L0.928333 8.54719C-0.282501 9.01719 -0.264167 9.69219 0.722499 9.99802L5.25833 11.4089L15.7942 4.81635C16.29 4.48802 16.7408 4.66969 16.37 4.99802L7.8475 12.6505Z" }) }),
        /* @__PURE__ */ x.jsx("defs", { children: /* @__PURE__ */ x.jsx("clipPath", { id: "clip0_683_665", children: /* @__PURE__ */ x.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function EW(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      width: "18",
      height: "20",
      viewBox: "0 0 18 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx("path", { d: "M16.3909 4.69C15.3941 4.4708 14.4923 3.9414 13.815 3.1779C13.1377 2.4144 12.7197 1.4559 12.6209 0.440001V0H9.17091V13.67C9.17161 14.2766 8.98151 14.868 8.62741 15.3604C8.27331 15.8529 7.77321 16.2215 7.19801 16.414C6.62281 16.6065 6.00161 16.6131 5.42241 16.4329C4.84321 16.2527 4.33541 15.8948 3.97091 15.41C3.64441 14.9808 3.44441 14.4689 3.39371 13.932C3.34291 13.3951 3.44341 12.8548 3.68371 12.372C3.92401 11.8892 4.29471 11.4834 4.75361 11.2003C5.21261 10.9172 5.74171 10.7681 6.28091 10.77C6.57921 10.7683 6.87591 10.8121 7.16091 10.9V7.4C6.82931 7.3589 6.49501 7.3422 6.16091 7.35C4.93021 7.3829 3.73581 7.7739 2.72401 8.4753C1.71221 9.1766 0.926813 10.1578 0.464113 11.2986C0.00141284 12.4395 -0.118588 13.6905 0.118812 14.8986C0.356312 16.1066 0.940813 17.2191 1.80091 18.1C2.68241 18.9962 3.81041 19.6101 5.04161 19.8638C6.27281 20.1175 7.55161 19.9994 8.71561 19.5246C9.87951 19.0498 10.8761 18.2397 11.5785 17.1973C12.281 16.1548 12.6578 14.9271 12.6609 13.67V6.67C14.0524 7.6639 15.7209 8.1956 17.4309 8.19V4.79C17.095 4.7914 16.7599 4.7579 16.4309 4.69H16.3909Z" })
    }
  );
}
function TW(e) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ x.jsxs("g", { clipPath: "url(#clip0_683_603)", children: [
          /* @__PURE__ */ x.jsx("path", { d: "M0.8125 3.47917V17.3908H5.60333V20H8.21917L10.8308 17.39H14.7517L19.98 12.175V0H2.11833L0.8125 3.47917ZM3.86083 1.7375H18.2375V11.3033L15.1875 14.3467H10.395L7.78333 16.9525V14.3467H3.86083V1.7375Z" }),
          /* @__PURE__ */ x.jsx("path", { d: "M8.65417 5.21875H10.3958V10.4354H8.65417V5.21875Z" }),
          /* @__PURE__ */ x.jsx("path", { d: "M13.4442 5.21875H15.1867V10.4354H13.4442V5.21875Z" })
        ] }),
        /* @__PURE__ */ x.jsx("defs", { children: /* @__PURE__ */ x.jsx("clipPath", { id: "clip0_683_603", children: /* @__PURE__ */ x.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function LW(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      width: "23",
      height: "20",
      viewBox: "0 0 23 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx("path", { d: "M17.4231 0H20.8173L13.4038 8.47115L22.125 20H15.2981L9.94711 13.0096L3.83173 20H0.432692L8.36058 10.9375L0 0H7L11.8317 6.38942L17.4231 0ZM16.2308 17.9712H18.1106L5.97596 1.92308H3.95673L16.2308 17.9712Z" })
    }
  );
}
function AW(e) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ x.jsx("g", { clipPath: "url(#clip0_683_643)", children: /* @__PURE__ */ x.jsx("path", { d: "M11.476 5.96933C13.7535 4.60186 14.9809 6.52932 13.8135 8.70802C12.6435 10.8955 11.5698 12.3217 11.0135 12.3217C10.4673 12.3217 10.0348 10.8542 9.3948 8.30678C8.73856 5.66809 8.73856 0.910692 5.99362 1.45068C3.39868 1.96317 0 6.02558 0 6.02558L0.807483 7.08931C0.807483 7.08931 2.48245 5.76809 3.03993 6.42557C3.60492 7.08931 5.74363 15.0591 6.45111 16.5329C7.0686 17.8241 8.78231 19.5278 10.6548 18.3128C12.5447 17.0903 18.7833 11.763 19.9008 5.45934C21.0158 -0.833021 12.381 0.484451 11.476 5.96933Z" }) }),
        /* @__PURE__ */ x.jsx("defs", { children: /* @__PURE__ */ x.jsx("clipPath", { id: "clip0_683_643", children: /* @__PURE__ */ x.jsx("rect", { width: "20", height: "20", fill: "white" }) }) })
      ]
    }
  );
}
function OW(e) {
  return /* @__PURE__ */ x.jsxs(
    "svg",
    {
      fill: "#00A0FF",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      ...e,
      children: [
        /* @__PURE__ */ x.jsx("defs", { children: /* @__PURE__ */ x.jsx("clipPath", { id: "clip1", children: /* @__PURE__ */ x.jsx("path", { d: "M 0 0 L 23.9375 0 L 23.9375 23.972656 L 0 23.972656 Z M 0 0 " }) }) }),
        /* @__PURE__ */ x.jsxs("g", { id: "surface1", children: [
          /* @__PURE__ */ x.jsx("path", { d: "M 17.453125 14.285156 L 17.445312 14.359375 C 15.253906 13.265625 15.023438 13.121094 14.738281 13.546875 C 14.542969 13.839844 13.972656 14.507812 13.796875 14.707031 C 13.625 14.898438 13.449219 14.914062 13.15625 14.78125 C 12.855469 14.628906 11.894531 14.316406 10.757812 13.296875 C 9.875 12.503906 9.28125 11.53125 9.105469 11.230469 C 8.8125 10.726562 9.421875 10.652344 9.980469 9.597656 C 10.078125 9.390625 10.027344 9.226562 9.953125 9.074219 C 9.878906 8.925781 9.285156 7.457031 9.035156 6.875 C 8.796875 6.289062 8.550781 6.363281 8.367188 6.363281 C 7.792969 6.3125 7.371094 6.320312 7 6.707031 C 5.390625 8.480469 5.796875 10.304688 7.175781 12.25 C 9.878906 15.796875 11.324219 16.449219 13.957031 17.355469 C 14.671875 17.582031 15.320312 17.550781 15.832031 17.476562 C 16.40625 17.386719 17.59375 16.753906 17.84375 16.050781 C 18.097656 15.347656 18.097656 14.765625 18.023438 14.628906 C 17.949219 14.496094 17.753906 14.417969 17.453125 14.285156 Z M 17.453125 14.285156 " }),
          /* @__PURE__ */ x.jsx("g", { clipPath: "url(#clip1)", clipRule: "nonzero", children: /* @__PURE__ */ x.jsx("path", { d: "M 20.457031 3.445312 C 12.792969 -3.976562 0.105469 1.40625 0.101562 11.875 C 0.101562 13.96875 0.648438 16.007812 1.691406 17.808594 L 0 23.960938 L 6.316406 22.3125 C 14.195312 26.578125 23.921875 20.914062 23.925781 11.878906 C 23.925781 8.710938 22.691406 5.726562 20.441406 3.484375 Z M 21.933594 11.847656 C 21.929688 19.46875 13.574219 24.226562 6.96875 20.339844 L 6.609375 20.125 L 2.871094 21.097656 L 3.875 17.457031 L 3.636719 17.085938 C -0.476562 10.53125 4.246094 1.964844 12.035156 1.964844 C 14.679688 1.964844 17.164062 2.996094 19.035156 4.867188 C 20.902344 6.722656 21.933594 9.210938 21.933594 11.847656 Z M 21.933594 11.847656 " }) })
        ] })
      ]
    }
  );
}
function NW(e) {
  return /* @__PURE__ */ x.jsx(
    "svg",
    {
      width: "21",
      height: "15",
      viewBox: "0 0 21 15",
      fill: "rgb(var(--brand-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ x.jsx("path", { d: "M19.607 2.20301C19.4931 1.78041 19.2705 1.39501 18.9614 1.08521C18.6523 0.775308 18.2674 0.551908 17.845 0.437008C16.279 0.00700787 10.014 7.59499e-06 10.014 7.59499e-06C10.014 7.59499e-06 3.74998 -0.00699213 2.18298 0.404008C1.76088 0.524208 1.37678 0.750808 1.06758 1.06211C0.758282 1.37351 0.534281 1.75911 0.416981 2.18201C0.00400126 3.74801 1.46519e-06 6.99601 1.46519e-06 6.99601C1.46519e-06 6.99601 -0.00399843 10.26 0.405982 11.81C0.635982 12.667 1.31098 13.344 2.16898 13.575C3.75098 14.005 9.99898 14.012 9.99898 14.012C9.99898 14.012 16.264 14.019 17.83 13.609C18.2525 13.4943 18.6378 13.2714 18.9477 12.9622C19.2576 12.653 19.4814 12.2682 19.597 11.846C20.011 10.281 20.014 7.03401 20.014 7.03401C20.014 7.03401 20.034 3.76901 19.607 2.20301ZM8.00998 10.005L8.01498 4.00501L13.222 7.01001L8.00998 10.005Z" })
    }
  );
}
const j1 = "w-[20px] h-[20px] shrink-0", Pn = (e, t) => {
  switch (e) {
    case l1.instagram:
      return /* @__PURE__ */ x.jsx(wW, { className: Ot(j1, t) });
    case l1.pinterest:
      return /* @__PURE__ */ x.jsx(SW, { className: Ot(j1, t) });
    case l1.telegram:
      return /* @__PURE__ */ x.jsx(PW, { className: Ot(j1, t) });
    case l1.vimeo:
      return /* @__PURE__ */ x.jsx(AW, { className: Ot(j1, t) });
    case l1.twitter:
      return /* @__PURE__ */ x.jsx(LW, { className: Ot(j1, t) });
    case l1.facebook:
      return /* @__PURE__ */ x.jsx(_W, { className: Ot(j1, t) });
    case l1.spotify:
      return /* @__PURE__ */ x.jsx(MW, { className: Ot(j1, t) });
    case l1.linkedin:
      return /* @__PURE__ */ x.jsx(xW, { className: Ot(j1, t) });
    case l1.youtube:
      return /* @__PURE__ */ x.jsx(NW, { className: Ot(j1, t) });
    case l1.tiktok:
      return /* @__PURE__ */ x.jsx(EW, { className: Ot(j1, t) });
    case l1.discord:
      return /* @__PURE__ */ x.jsx(yW, { className: Ot(j1, t) });
    case l1.etsy:
      return /* @__PURE__ */ x.jsx(bW, { className: Ot(j1, t) });
    case l1.snapchat:
      return /* @__PURE__ */ x.jsx(kW, { className: Ot(j1, t) });
    case l1.website:
      return /* @__PURE__ */ x.jsx(Zp, { className: Ot(j1, t) });
    case l1.twitch:
      return /* @__PURE__ */ x.jsx(TW, { className: Ot(j1, t) });
    case l1.email:
      return /* @__PURE__ */ x.jsx(vW, { className: Ot(j1, t) });
    case l1.whatsapp:
      return /* @__PURE__ */ x.jsx(OW, { className: Ot(j1, t) });
    default:
      return /* @__PURE__ */ x.jsx(Zp, { className: Ot(j1, t) });
  }
}, jW = (e) => {
  const {
    state: { theme: t }
  } = wr();
  switch (t) {
    case mt.luminous:
      return /* @__PURE__ */ x.jsx(sW, { ...e });
    case mt.camilla:
      return /* @__PURE__ */ x.jsx(cW, { ...e });
    case mt.night:
      return /* @__PURE__ */ x.jsx(uW, { ...e });
    case mt.creamy:
      return /* @__PURE__ */ x.jsx(dW, { ...e });
    case mt.sepia:
      return /* @__PURE__ */ x.jsx(pW, { ...e });
    case mt.solarized:
      return /* @__PURE__ */ x.jsx(hW, { ...e });
    case mt.new_york:
      return /* @__PURE__ */ x.jsx(mW, { ...e });
    case mt.urban:
      return /* @__PURE__ */ x.jsx(fW, { ...e });
    case mt.cyberpunk:
      return /* @__PURE__ */ x.jsx(CW, { ...e });
    case mt.cosmopolitan:
      return /* @__PURE__ */ x.jsx(gW, { ...e });
    case mt.default:
    default:
      return /* @__PURE__ */ x.jsx(lW, { ...e });
  }
}, Fne = {
  type: Vn.link,
  url: "",
  title: "Check it out!",
  subTitle: `Visit my Affiliate Link \r
and get a DISCOUNT!`,
  buttonTitle: "Click Me!",
  thumbnail: null
}, Vne = {
  type: Vn.optin,
  title: "Subscribe to our newsletter",
  subTitle: `Get the latest news and updates \r
from our store!`,
  buttonTitle: "Subscribe",
  fields: [],
  thumbnail: null,
  thankYouPage: {
    title: "Thank you!",
    text: `Thank you for your subscription! \r
And have a good day!`
  }
}, Bne = {
  type: Vn.product,
  productType: Ar.download,
  title: "Check it out!",
  subTitle: `Check it out! \r
and get a DISCOUNT!`,
  buttonTitle: "Click Me!",
  thumbnail: null,
  checkoutPage: {}
}, zne = {
  type: Vn.product,
  productType: Ar.eCourse,
  title: "My 12-week Program!",
  subTitle: "A 2-line course summary to close the sale. What will they learn?",
  buttonTitle: "GET MY COURSE",
  thumbnail: null,
  checkoutPage: {}
}, Gne = {
  type: Vn.product,
  productType: Ar.physicalProduct,
  title: "My Physical Product!",
  subTitle: "My Physical Product subtitle",
  buttonTitle: "BUY NOW",
  thumbnail: null,
  checkoutPage: {}
}, O8 = ({
  affiliateLink: e
}) => {
  const { locale: t } = Rt();
  return /* @__PURE__ */ x.jsx("div", { className: "fixed bottom-1 right-1 z-[3]", children: e ? /* @__PURE__ */ x.jsx("a", { href: e, target: "_blank", rel: "noopener noreferrer", children: Nu(t) }) : Nu(t) });
}, Une = ({
  profile: e,
  socialLinks: t,
  items: n,
  affiliateLink: r,
  displayAffiliateLink: a
}) => /* @__PURE__ */ x.jsx(B3, { children: /* @__PURE__ */ x.jsxs("div", { className: Ot(eb, "relative mb-5 sm:mt-5"), children: [
  /* @__PURE__ */ x.jsx(jW, { profile: e, socialLinks: t }),
  n.map((i, o) => /* @__PURE__ */ x.jsx(n1, { children: AK(i) }, o)),
  a && /* @__PURE__ */ x.jsx(O8, { affiliateLink: r })
] }) }), Zne = ({
  thankYouPage: { title: e, text: t },
  affiliateLink: n,
  displayAffiliateLink: r
}) => {
  const { isDefaultTheme: a } = wr();
  return /* @__PURE__ */ x.jsx(k8, { children: /* @__PURE__ */ x.jsxs("div", { className: "relative flex flex-col justify-center gap-5", children: [
    /* @__PURE__ */ x.jsx(
      "h1",
      {
        className: M1(
          "self-center text-center text-4xl",
          a ? "text-text-primary" : "text-THEME-primary"
        ),
        children: e
      }
    ),
    /* @__PURE__ */ x.jsx("p", { className: "whitespace-pre-wrap text-center text-lg", children: t }),
    r && /* @__PURE__ */ x.jsx(O8, { affiliateLink: n })
  ] }) });
}, Ab = ({ children: e }) => {
  const {
    state: { tertiaryColor: t }
  } = wr();
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: M1(
        "bg-THEME-secondary relative w-full rounded-none border pb-5 sm:mb-5 sm:mt-5 sm:max-w-xl sm:rounded-lg sm:pb-0",
        Xv(t) ? "sm:shadow-around-sm border-transparent" : "sm:border-THEME-border-tertiary border-transparent"
      ),
      children: e
    }
  );
}, Ob = ({ paymentMethod: e }) => /* @__PURE__ */ x.jsx("div", { className: "[&>svg]:fill-THEME-primary/70", children: sN(e, { className: "w-5 h-5" }) }), RW = "pk_test_O3PjYFYA7hqkDM12lU32xgRT";
function w6(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? w6 = function(t) {
    return typeof t;
  } : w6 = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, w6(e);
}
var Nb = "https://js.stripe.com/v3", DW = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, Kp = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", IW = function() {
  for (var t = document.querySelectorAll('script[src^="'.concat(Nb, '"]')), n = 0; n < t.length; n++) {
    var r = t[n];
    if (DW.test(r.src))
      return r;
  }
  return null;
}, $p = function(t) {
  var n = t && !t.advancedFraudSignals ? "?advancedFraudSignals=false" : "", r = document.createElement("script");
  r.src = "".concat(Nb).concat(n);
  var a = document.head || document.body;
  if (!a)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return a.appendChild(r), r;
}, HW = function(t, n) {
  !t || !t._registerWrapper || t._registerWrapper({
    name: "stripe-js",
    version: "4.6.0",
    startTime: n
  });
}, Vo = null, G9 = null, U9 = null, FW = function(t) {
  return function() {
    t(new Error("Failed to load Stripe.js"));
  };
}, VW = function(t, n) {
  return function() {
    window.Stripe ? t(window.Stripe) : n(new Error("Stripe.js not available"));
  };
}, BW = function(t) {
  return Vo !== null ? Vo : (Vo = new Promise(function(n, r) {
    if (typeof window > "u" || typeof document > "u") {
      n(null);
      return;
    }
    if (window.Stripe && t && console.warn(Kp), window.Stripe) {
      n(window.Stripe);
      return;
    }
    try {
      var a = IW();
      if (a && t)
        console.warn(Kp);
      else if (!a)
        a = $p(t);
      else if (a && U9 !== null && G9 !== null) {
        var i;
        a.removeEventListener("load", U9), a.removeEventListener("error", G9), (i = a.parentNode) === null || i === void 0 || i.removeChild(a), a = $p(t);
      }
      U9 = VW(n, r), G9 = FW(r), a.addEventListener("load", U9), a.addEventListener("error", G9);
    } catch (o) {
      r(o);
      return;
    }
  }), Vo.catch(function(n) {
    return Vo = null, Promise.reject(n);
  }));
}, zW = function(t, n, r) {
  if (t === null)
    return null;
  var a = t.apply(void 0, n);
  return HW(a, r), a;
}, Wp = function(t) {
  var n = `invalid load parameters; expected object of shape

    {advancedFraudSignals: boolean}

but received

    `.concat(JSON.stringify(t), `
`);
  if (t === null || w6(t) !== "object")
    throw new Error(n);
  if (Object.keys(t).length === 1 && typeof t.advancedFraudSignals == "boolean")
    return t;
  throw new Error(n);
}, x6, Ol = !1, jb = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  Ol = !0;
  var a = Date.now();
  return BW(x6).then(function(i) {
    return zW(i, n, a);
  });
};
jb.setLoadParameters = function(e) {
  if (Ol && x6) {
    var t = Wp(e), n = Object.keys(t), r = n.reduce(function(a, i) {
      var o;
      return a && e[i] === ((o = x6) === null || o === void 0 ? void 0 : o[i]);
    }, !0);
    if (r)
      return;
  }
  if (Ol)
    throw new Error("You cannot change load parameters after calling loadStripe");
  x6 = Wp(e);
};
const Rb = Qe(void 0);
function GW() {
  const e = Ue(Rb);
  if (!e)
    throw new Error("useStripeProvider must be used within a StripeContext.Provider");
  return e;
}
function Kne({
  children: e,
  publishableKey: t,
  stripeAccountId: n,
  forceLoad: r
}) {
  const [a, i] = ke(null), { paymentMethod: o } = Dr(), s = _e(
    () => o === ge.stripe_ideal || o === ge.stripe_card || o === ge.stripe_bancontact || r,
    [r, o]
  );
  return Re(() => {
    s && n && i(
      jb(t || RW, {
        stripeAccount: n
      })
    );
  }, [t, s, n]), /* @__PURE__ */ x.jsx(
    Rb.Provider,
    {
      value: {
        stripePromise: a
      },
      children: e
    }
  );
}
const ur = {
  offer: [],
  customer: { fields: {} },
  page: [],
  digitalProduct: [],
  purchaseProductModel: [],
  pricePlan: [],
  thankYouPageUrl: [],
  failedReturnUrl: [],
  paymentMethod: [],
  common: []
}, Qa = async (e, t) => A8.post("/api/purchase-service/buy-offer", e, {
  headers: {
    "accept-language": t
  }
});
function UW({
  isFetching: e,
  buttonTitle: t,
  setErrors: n,
  setIsFetching: r,
  preSubmit: a,
  handleBadRequest: i,
  hasErrors: o,
  buttonDisabled: s
}) {
  const { locale: l } = Rt(), c = async (u) => {
    u.preventDefault();
    try {
      r(!0), n(ur);
      const d = a();
      if (!d)
        throw new Error();
      const { redirect: p } = await Qa(d, l);
      p && (window.location.href = p);
    } catch (d) {
      d instanceof xn && i(d);
    } finally {
      r(!1);
    }
  };
  return /* @__PURE__ */ x.jsx(
    Jr,
    {
      disabled: s,
      className: M1("main-transition-colors", o && "bg-danger focus:bg-danger"),
      onClick: c,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
const ZW = (e, t) => Qa(e, t), KW = ({ threeDsInfo: e, opened: t, onComplete: n }) => {
  const r = be(null);
  return Re(() => {
    if (!t)
      return;
    const a = (i) => {
      i.origin === "https://api.mercadopago.com" && i.data.status === "COMPLETE" && n();
    };
    return window.addEventListener("message", a), () => window.removeEventListener("message", a);
  }, [t, n]), Re(() => {
    t && r.current && r.current.requestSubmit();
  }, [t]), /* @__PURE__ */ x.jsx(
    PC,
    {
      id: "three-ds-modal",
      size: MC.small,
      title: "",
      isFetching: !0,
      opened: t,
      onClose: () => {
      },
      closeIconClassName: "hidden",
      closeIconWrapperClassName: "hidden",
      contentClassName: "flex justify-center min-h-[500px]",
      children: /* @__PURE__ */ x.jsx("iframe", { name: "mercado-3ds-iframe", id: "mercado-3ds-iframe", title: "Mercado Pago 3DS iframe", children: /* @__PURE__ */ x.jsx(
        "form",
        {
          name: "mercado-3ds-form",
          target: "mercado-3ds-iframe",
          method: "post",
          action: e.external_resource_url,
          ref: r,
          children: /* @__PURE__ */ x.jsx("input", { type: "hidden", name: "creq", value: e.creq })
        }
      ) })
    }
  );
};
function $W({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o
}) {
  const { locale: s } = Rt(), [l, c] = ke(!1), [u, d] = ke(), [p, h] = ke(), m = (C) => {
    window.location.assign(C);
  }, f = async (C) => {
    C.preventDefault(), a(!0), r(ur);
    try {
      const _ = i();
      if (!_)
        throw new Error("Request data is undefined");
      const v = await window.cardPaymentBrickController.getFormData(), w = await ZW(
        {
          ..._,
          options: {
            token: v.token,
            mercadoPagoPaymentMethod: v.payment_method_id,
            installments: v.installments
          }
        },
        s
      );
      if (w.threeDsInfo) {
        h(w.threeDsInfo), d(w.redirect), c(!0);
        return;
      }
      m(w.redirect);
    } catch (_) {
      _ instanceof xn && o(_);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      Jr,
      {
        disabled: n,
        type: "submit",
        onClick: f,
        isFetching: e,
        children: t
      }
    ),
    p && /* @__PURE__ */ x.jsx(
      KW,
      {
        opened: l,
        onComplete: () => {
          c(!1), u && m(u);
        },
        threeDsInfo: p
      }
    )
  ] });
}
async function WW(e) {
  const t = await Ti.get(e, {
    maxRedirects: 0
    // Prevent axios from automatically following redirects
  });
  if (t.status === 200) {
    window.location.assign(t.data.options.paypalLink);
    return;
  }
  if (t.status >= 300 && t.status < 400) {
    const n = t.headers.location;
    if (n) {
      window.location.assign(n);
      return;
    }
  }
  throw new Error("No redirect URL found");
}
function YW({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { locale: l } = Rt(), c = async (u) => {
    u.preventDefault();
    try {
      a(!0), r(ur);
      const d = i();
      if (!d)
        throw new Error();
      const { redirect: p } = await Qa(d, l);
      await WW(p);
    } catch (d) {
      d instanceof xn && o(d), console.error(d);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ x.jsx(
    Jr,
    {
      disabled: n,
      className: M1("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: c,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
function Db(e, t, n) {
  const r = document.createElement("script");
  r.onload = n, r.id = t, r.src = e, document.head.appendChild(r);
}
function qW(e, t) {
  return new Promise((n, r) => {
    const a = t || document, i = a.createElement("script");
    i.src = e, i.onload = (o) => n(o), i.onerror = (o) => r(o), a.head.appendChild(i);
  });
}
const JW = () => {
  const e = typeof window < "u" && !!window.paypal, [t, n] = ke(!e);
  return Re(() => {
    e || Db(
      "https://www.paypalobjects.com/api/checkout.min.js",
      "paypal-js",
      () => n(!1)
    );
  }, [e]), {
    isScriptLoading: t
  };
};
function XW({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o
}) {
  const { locale: s } = Rt(), { isScriptLoading: l } = JW(), c = async (u) => {
    var d, p, h, m;
    u.preventDefault(), a(!0), r(ur);
    try {
      const f = i();
      if (!f)
        throw new Error("Request data is undefined");
      (d = window.paypal) == null || d.checkout.initXO();
      const { redirect: C, approvalUrl: _ } = await Qa(f, s);
      if (!_) {
        (p = window.paypal) == null || p.checkout.closeFlow(), C && window.location.assign(C);
        return;
      }
      (h = window.paypal) == null || h.checkout.startFlow(_);
    } catch (f) {
      f instanceof xn && o(f), (m = window.paypal) == null || m.checkout.closeFlow();
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ x.jsx(
    Jr,
    {
      onClick: c,
      isFetching: e,
      disabled: l || n,
      type: "submit",
      children: t
    }
  );
}
const QW = (e, t) => Qa(e, t), eY = "https://checkout.razorpay.com/v1/checkout.js";
class tY {
  constructor(t) {
    Y8(this, "options");
    Y8(this, "razorpayInstance");
    this.options = t, typeof window < "u" && "Razorpay" in window && (this.razorpayInstance = new window.Razorpay(this.options));
  }
  on(t, n) {
    this.razorpayInstance.on(t, n);
  }
  open() {
    this.razorpayInstance.open();
  }
}
function rY() {
  const [e, t] = ke(!1), [n, r] = ke(!1), { currency: a, pricePlan: i, finalAmount: o } = Dr(), {
    state: { primaryColor: s }
  } = wr(), l = function(c) {
    const u = {
      key: c.keyId,
      amount: o,
      currency: a == null ? void 0 : a.toUpperCase(),
      name: c.vendorName,
      description: i == null ? void 0 : i.name,
      prefill: {
        name: c.prefill.name,
        email: c.prefill.email,
        contact: c.prefill.phone
      },
      theme: {
        color: s
      },
      handler: async () => {
        window.location.assign(c.redirectUrl);
      }
    };
    if (c.rpOrderId)
      u.order_id = c.rpOrderId;
    else if (c.rpSubscriptionId)
      u.subscription_id = c.rpSubscriptionId;
    else
      throw Error("RP order id and subscription id is missing");
    return u;
  };
  return Re(() => {
    const c = async () => {
      try {
        t(!0), await qW(eY, document), r(!0);
      } catch (u) {
        Kt.error(u.message);
      } finally {
        t(!1);
      }
    };
    "Razorpay" in window ? r(!0) : c();
  }, []), { Razorpay: tY, generateOptions: l, isRazorpayReady: n, isRazorpayFetching: e };
}
function nY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  handleBadRequest: i,
  preSubmit: o
}) {
  const { locale: s } = Rt(), { generateOptions: l, isRazorpayReady: c, Razorpay: u, isRazorpayFetching: d } = rY(), p = async (h) => {
    h.preventDefault(), a(!0), r(ur);
    try {
      const m = o();
      if (!m)
        throw new Error("Request data is undefined");
      const f = await QW(m, s), C = l(f);
      if (c)
        new u(C).open();
      else
        throw new Error("form submitted before razorpay was ready");
    } catch (m) {
      m instanceof xn && i(m);
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ x.jsx(
    Jr,
    {
      disabled: n,
      type: "submit",
      onClick: p,
      isFetching: e || d,
      children: t
    }
  );
}
var Nl = { exports: {} }, Z9 = { exports: {} }, Dt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yp;
function aY() {
  if (Yp)
    return Dt;
  Yp = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var S = b.$$typeof;
      switch (S) {
        case t:
          switch (b = b.type, b) {
            case l:
            case c:
            case r:
            case i:
            case a:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case u:
                case m:
                case h:
                case o:
                  return b;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function k(b) {
    return w(b) === c;
  }
  return Dt.AsyncMode = l, Dt.ConcurrentMode = c, Dt.ContextConsumer = s, Dt.ContextProvider = o, Dt.Element = t, Dt.ForwardRef = u, Dt.Fragment = r, Dt.Lazy = m, Dt.Memo = h, Dt.Portal = n, Dt.Profiler = i, Dt.StrictMode = a, Dt.Suspense = d, Dt.isAsyncMode = function(b) {
    return k(b) || w(b) === l;
  }, Dt.isConcurrentMode = k, Dt.isContextConsumer = function(b) {
    return w(b) === s;
  }, Dt.isContextProvider = function(b) {
    return w(b) === o;
  }, Dt.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, Dt.isForwardRef = function(b) {
    return w(b) === u;
  }, Dt.isFragment = function(b) {
    return w(b) === r;
  }, Dt.isLazy = function(b) {
    return w(b) === m;
  }, Dt.isMemo = function(b) {
    return w(b) === h;
  }, Dt.isPortal = function(b) {
    return w(b) === n;
  }, Dt.isProfiler = function(b) {
    return w(b) === i;
  }, Dt.isStrictMode = function(b) {
    return w(b) === a;
  }, Dt.isSuspense = function(b) {
    return w(b) === d;
  }, Dt.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === c || b === i || b === a || b === d || b === p || typeof b == "object" && b !== null && (b.$$typeof === m || b.$$typeof === h || b.$$typeof === o || b.$$typeof === s || b.$$typeof === u || b.$$typeof === C || b.$$typeof === _ || b.$$typeof === v || b.$$typeof === f);
  }, Dt.typeOf = w, Dt;
}
var It = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qp;
function iY() {
  return qp || (qp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function w(K) {
      return typeof K == "string" || typeof K == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      K === r || K === c || K === i || K === a || K === d || K === p || typeof K == "object" && K !== null && (K.$$typeof === m || K.$$typeof === h || K.$$typeof === o || K.$$typeof === s || K.$$typeof === u || K.$$typeof === C || K.$$typeof === _ || K.$$typeof === v || K.$$typeof === f);
    }
    function k(K) {
      if (typeof K == "object" && K !== null) {
        var Ee = K.$$typeof;
        switch (Ee) {
          case t:
            var J = K.type;
            switch (J) {
              case l:
              case c:
              case r:
              case i:
              case a:
              case d:
                return J;
              default:
                var te = J && J.$$typeof;
                switch (te) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case o:
                    return te;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var b = l, S = c, P = s, O = o, A = t, L = u, I = r, D = m, U = h, z = n, $ = i, ee = a, Z = d, G = !1;
    function W(K) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(K) || k(K) === l;
    }
    function j(K) {
      return k(K) === c;
    }
    function T(K) {
      return k(K) === s;
    }
    function F(K) {
      return k(K) === o;
    }
    function N(K) {
      return typeof K == "object" && K !== null && K.$$typeof === t;
    }
    function Y(K) {
      return k(K) === u;
    }
    function Q(K) {
      return k(K) === r;
    }
    function V(K) {
      return k(K) === m;
    }
    function re(K) {
      return k(K) === h;
    }
    function q(K) {
      return k(K) === n;
    }
    function he(K) {
      return k(K) === i;
    }
    function me(K) {
      return k(K) === a;
    }
    function Ne(K) {
      return k(K) === d;
    }
    It.AsyncMode = b, It.ConcurrentMode = S, It.ContextConsumer = P, It.ContextProvider = O, It.Element = A, It.ForwardRef = L, It.Fragment = I, It.Lazy = D, It.Memo = U, It.Portal = z, It.Profiler = $, It.StrictMode = ee, It.Suspense = Z, It.isAsyncMode = W, It.isConcurrentMode = j, It.isContextConsumer = T, It.isContextProvider = F, It.isElement = N, It.isForwardRef = Y, It.isFragment = Q, It.isLazy = V, It.isMemo = re, It.isPortal = q, It.isProfiler = he, It.isStrictMode = me, It.isSuspense = Ne, It.isValidElementType = w, It.typeOf = k;
  }()), It;
}
var Jp;
function Ib() {
  return Jp || (Jp = 1, process.env.NODE_ENV === "production" ? Z9.exports = aY() : Z9.exports = iY()), Z9.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var $7, Xp;
function oY() {
  if (Xp)
    return $7;
  Xp = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return $7 = a() ? Object.assign : function(i, o) {
    for (var s, l = r(i), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var p = 0; p < c.length; p++)
          n.call(s, c[p]) && (l[c[p]] = s[c[p]]);
      }
    }
    return l;
  }, $7;
}
var W7, Qp;
function X3() {
  if (Qp)
    return W7;
  Qp = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return W7 = e, W7;
}
var Y7, eh;
function Hb() {
  return eh || (eh = 1, Y7 = Function.call.bind(Object.prototype.hasOwnProperty)), Y7;
}
var q7, th;
function sY() {
  if (th)
    return q7;
  th = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = X3(), n = {}, r = Hb();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = i[u](o, u, l, s, null, t);
          } catch (m) {
            d = m;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, q7 = a, q7;
}
var J7, rh;
function lY() {
  if (rh)
    return J7;
  rh = 1;
  var e = Ib(), t = oY(), n = X3(), r = Hb(), a = sY(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return J7 = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(j) {
      var T = j && (c && j[c] || j[u]);
      if (typeof T == "function")
        return T;
    }
    var p = "<<anonymous>>", h = {
      array: _("array"),
      bigint: _("bigint"),
      bool: _("boolean"),
      func: _("function"),
      number: _("number"),
      object: _("object"),
      string: _("string"),
      symbol: _("symbol"),
      any: v(),
      arrayOf: w,
      element: k(),
      elementType: b(),
      instanceOf: S,
      node: L(),
      objectOf: O,
      oneOf: P,
      oneOfType: A,
      shape: D,
      exact: U
    };
    function m(j, T) {
      return j === T ? j !== 0 || 1 / j === 1 / T : j !== j && T !== T;
    }
    function f(j, T) {
      this.message = j, this.data = T && typeof T == "object" ? T : {}, this.stack = "";
    }
    f.prototype = Error.prototype;
    function C(j) {
      if (process.env.NODE_ENV !== "production")
        var T = {}, F = 0;
      function N(Q, V, re, q, he, me, Ne) {
        if (q = q || p, me = me || re, Ne !== n) {
          if (l) {
            var K = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw K.name = "Invariant Violation", K;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ee = q + ":" + re;
            !T[Ee] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + me + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), T[Ee] = !0, F++);
          }
        }
        return V[re] == null ? Q ? V[re] === null ? new f("The " + he + " `" + me + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new f("The " + he + " `" + me + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : j(V, re, q, he, me);
      }
      var Y = N.bind(null, !1);
      return Y.isRequired = N.bind(null, !0), Y;
    }
    function _(j) {
      function T(F, N, Y, Q, V, re) {
        var q = F[N], he = ee(q);
        if (he !== j) {
          var me = Z(q);
          return new f(
            "Invalid " + Q + " `" + V + "` of type " + ("`" + me + "` supplied to `" + Y + "`, expected ") + ("`" + j + "`."),
            { expectedType: j }
          );
        }
        return null;
      }
      return C(T);
    }
    function v() {
      return C(o);
    }
    function w(j) {
      function T(F, N, Y, Q, V) {
        if (typeof j != "function")
          return new f("Property `" + V + "` of component `" + Y + "` has invalid PropType notation inside arrayOf.");
        var re = F[N];
        if (!Array.isArray(re)) {
          var q = ee(re);
          return new f("Invalid " + Q + " `" + V + "` of type " + ("`" + q + "` supplied to `" + Y + "`, expected an array."));
        }
        for (var he = 0; he < re.length; he++) {
          var me = j(re, he, Y, Q, V + "[" + he + "]", n);
          if (me instanceof Error)
            return me;
        }
        return null;
      }
      return C(T);
    }
    function k() {
      function j(T, F, N, Y, Q) {
        var V = T[F];
        if (!s(V)) {
          var re = ee(V);
          return new f("Invalid " + Y + " `" + Q + "` of type " + ("`" + re + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(j);
    }
    function b() {
      function j(T, F, N, Y, Q) {
        var V = T[F];
        if (!e.isValidElementType(V)) {
          var re = ee(V);
          return new f("Invalid " + Y + " `" + Q + "` of type " + ("`" + re + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(j);
    }
    function S(j) {
      function T(F, N, Y, Q, V) {
        if (!(F[N] instanceof j)) {
          var re = j.name || p, q = W(F[N]);
          return new f("Invalid " + Q + " `" + V + "` of type " + ("`" + q + "` supplied to `" + Y + "`, expected ") + ("instance of `" + re + "`."));
        }
        return null;
      }
      return C(T);
    }
    function P(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function T(F, N, Y, Q, V) {
        for (var re = F[N], q = 0; q < j.length; q++)
          if (m(re, j[q]))
            return null;
        var he = JSON.stringify(j, function(Ne, K) {
          var Ee = Z(K);
          return Ee === "symbol" ? String(K) : K;
        });
        return new f("Invalid " + Q + " `" + V + "` of value `" + String(re) + "` " + ("supplied to `" + Y + "`, expected one of " + he + "."));
      }
      return C(T);
    }
    function O(j) {
      function T(F, N, Y, Q, V) {
        if (typeof j != "function")
          return new f("Property `" + V + "` of component `" + Y + "` has invalid PropType notation inside objectOf.");
        var re = F[N], q = ee(re);
        if (q !== "object")
          return new f("Invalid " + Q + " `" + V + "` of type " + ("`" + q + "` supplied to `" + Y + "`, expected an object."));
        for (var he in re)
          if (r(re, he)) {
            var me = j(re, he, Y, Q, V + "." + he, n);
            if (me instanceof Error)
              return me;
          }
        return null;
      }
      return C(T);
    }
    function A(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var T = 0; T < j.length; T++) {
        var F = j[T];
        if (typeof F != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + G(F) + " at index " + T + "."
          ), o;
      }
      function N(Y, Q, V, re, q) {
        for (var he = [], me = 0; me < j.length; me++) {
          var Ne = j[me], K = Ne(Y, Q, V, re, q, n);
          if (K == null)
            return null;
          K.data && r(K.data, "expectedType") && he.push(K.data.expectedType);
        }
        var Ee = he.length > 0 ? ", expected one of type [" + he.join(", ") + "]" : "";
        return new f("Invalid " + re + " `" + q + "` supplied to " + ("`" + V + "`" + Ee + "."));
      }
      return C(N);
    }
    function L() {
      function j(T, F, N, Y, Q) {
        return z(T[F]) ? null : new f("Invalid " + Y + " `" + Q + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return C(j);
    }
    function I(j, T, F, N, Y) {
      return new f(
        (j || "React class") + ": " + T + " type `" + F + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Y + "`."
      );
    }
    function D(j) {
      function T(F, N, Y, Q, V) {
        var re = F[N], q = ee(re);
        if (q !== "object")
          return new f("Invalid " + Q + " `" + V + "` of type `" + q + "` " + ("supplied to `" + Y + "`, expected `object`."));
        for (var he in j) {
          var me = j[he];
          if (typeof me != "function")
            return I(Y, Q, V, he, Z(me));
          var Ne = me(re, he, Y, Q, V + "." + he, n);
          if (Ne)
            return Ne;
        }
        return null;
      }
      return C(T);
    }
    function U(j) {
      function T(F, N, Y, Q, V) {
        var re = F[N], q = ee(re);
        if (q !== "object")
          return new f("Invalid " + Q + " `" + V + "` of type `" + q + "` " + ("supplied to `" + Y + "`, expected `object`."));
        var he = t({}, F[N], j);
        for (var me in he) {
          var Ne = j[me];
          if (r(j, me) && typeof Ne != "function")
            return I(Y, Q, V, me, Z(Ne));
          if (!Ne)
            return new f(
              "Invalid " + Q + " `" + V + "` key `" + me + "` supplied to `" + Y + "`.\nBad object: " + JSON.stringify(F[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(j), null, "  ")
            );
          var K = Ne(re, me, Y, Q, V + "." + me, n);
          if (K)
            return K;
        }
        return null;
      }
      return C(T);
    }
    function z(j) {
      switch (typeof j) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !j;
        case "object":
          if (Array.isArray(j))
            return j.every(z);
          if (j === null || s(j))
            return !0;
          var T = d(j);
          if (T) {
            var F = T.call(j), N;
            if (T !== j.entries) {
              for (; !(N = F.next()).done; )
                if (!z(N.value))
                  return !1;
            } else
              for (; !(N = F.next()).done; ) {
                var Y = N.value;
                if (Y && !z(Y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function $(j, T) {
      return j === "symbol" ? !0 : T ? T["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && T instanceof Symbol : !1;
    }
    function ee(j) {
      var T = typeof j;
      return Array.isArray(j) ? "array" : j instanceof RegExp ? "object" : $(T, j) ? "symbol" : T;
    }
    function Z(j) {
      if (typeof j > "u" || j === null)
        return "" + j;
      var T = ee(j);
      if (T === "object") {
        if (j instanceof Date)
          return "date";
        if (j instanceof RegExp)
          return "regexp";
      }
      return T;
    }
    function G(j) {
      var T = Z(j);
      switch (T) {
        case "array":
        case "object":
          return "an " + T;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + T;
        default:
          return T;
      }
    }
    function W(j) {
      return !j.constructor || !j.constructor.name ? p : j.constructor.name;
    }
    return h.checkPropTypes = a, h.resetWarningCache = a.resetWarningCache, h.PropTypes = h, h;
  }, J7;
}
var X7, nh;
function cY() {
  if (nh)
    return X7;
  nh = 1;
  var e = X3();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, X7 = function() {
    function r(o, s, l, c, u, d) {
      if (d !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, X7;
}
if (process.env.NODE_ENV !== "production") {
  var uY = Ib(), dY = !0;
  Nl.exports = lY()(uY.isElement, dY);
} else
  Nl.exports = cY()();
var pY = Nl.exports;
const c1 = /* @__PURE__ */ Js(pY);
function ah(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ih(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ah(Object(n), !0).forEach(function(r) {
      Fb(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ah(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function S6(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? S6 = function(t) {
    return typeof t;
  } : S6 = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, S6(e);
}
function Fb(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Vb(e, t) {
  return hY(e) || mY(e, t) || fY(e, t) || CY();
}
function hY(e) {
  if (Array.isArray(e))
    return e;
}
function mY(e, t) {
  var n = e && (typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"]);
  if (n != null) {
    var r = [], a = !0, i = !1, o, s;
    try {
      for (n = n.call(e); !(a = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); a = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return r;
  }
}
function fY(e, t) {
  if (e) {
    if (typeof e == "string")
      return oh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return oh(e, t);
  }
}
function oh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function CY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Sr = function(t, n, r) {
  var a = !!r, i = M.useRef(r);
  M.useEffect(function() {
    i.current = r;
  }, [r]), M.useEffect(function() {
    if (!a || !t)
      return function() {
      };
    var o = function() {
      i.current && i.current.apply(i, arguments);
    };
    return t.on(n, o), function() {
      t.off(n, o);
    };
  }, [a, n, t, i]);
}, jl = function(t) {
  var n = M.useRef(t);
  return M.useEffect(function() {
    n.current = t;
  }, [t]), n.current;
}, Wi = function(t) {
  return t !== null && S6(t) === "object";
}, gY = function(t) {
  return Wi(t) && typeof t.then == "function";
}, yY = function(t) {
  return Wi(t) && typeof t.elements == "function" && typeof t.createToken == "function" && typeof t.createPaymentMethod == "function" && typeof t.confirmCardPayment == "function";
}, sh = "[object Object]", vY = function e(t, n) {
  if (!Wi(t) || !Wi(n))
    return t === n;
  var r = Array.isArray(t), a = Array.isArray(n);
  if (r !== a)
    return !1;
  var i = Object.prototype.toString.call(t) === sh, o = Object.prototype.toString.call(n) === sh;
  if (i !== o)
    return !1;
  if (!i && !r)
    return t === n;
  var s = Object.keys(t), l = Object.keys(n);
  if (s.length !== l.length)
    return !1;
  for (var c = {}, u = 0; u < s.length; u += 1)
    c[s[u]] = !0;
  for (var d = 0; d < l.length; d += 1)
    c[l[d]] = !0;
  var p = Object.keys(c);
  if (p.length !== s.length)
    return !1;
  var h = t, m = n, f = function(_) {
    return e(h[_], m[_]);
  };
  return p.every(f);
}, Bb = function(t, n, r) {
  return Wi(t) ? Object.keys(t).reduce(function(a, i) {
    var o = !Wi(n) || !vY(t[i], n[i]);
    return r.includes(i) ? (o && console.warn("Unsupported prop change: options.".concat(i, " is not a mutable property.")), a) : o ? ih(ih({}, a || {}), {}, Fb({}, i, t[i])) : a;
  }, null) : null;
}, zb = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.", lh = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : zb;
  if (t === null || yY(t))
    return t;
  throw new Error(n);
}, bY = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : zb;
  if (gY(t))
    return {
      tag: "async",
      stripePromise: Promise.resolve(t).then(function(a) {
        return lh(a, n);
      })
    };
  var r = lh(t, n);
  return r === null ? {
    tag: "empty"
  } : {
    tag: "sync",
    stripe: r
  };
}, _Y = function(t) {
  !t || !t._registerWrapper || !t.registerAppInfo || (t._registerWrapper({
    name: "react-stripe-js",
    version: "2.8.1"
  }), t.registerAppInfo({
    name: "react-stripe-js",
    version: "2.8.1",
    url: "https://stripe.com/docs/stripe-js/react"
  }));
}, N8 = /* @__PURE__ */ M.createContext(null);
N8.displayName = "ElementsContext";
var Gb = function(t, n) {
  if (!t)
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(n, " in an <Elements> provider."));
  return t;
}, Ub = function(t) {
  var n = t.stripe, r = t.options, a = t.children, i = M.useMemo(function() {
    return bY(n);
  }, [n]), o = M.useState(function() {
    return {
      stripe: i.tag === "sync" ? i.stripe : null,
      elements: i.tag === "sync" ? i.stripe.elements(r) : null
    };
  }), s = Vb(o, 2), l = s[0], c = s[1];
  M.useEffect(function() {
    var p = !0, h = function(f) {
      c(function(C) {
        return C.stripe ? C : {
          stripe: f,
          elements: f.elements(r)
        };
      });
    };
    return i.tag === "async" && !l.stripe ? i.stripePromise.then(function(m) {
      m && p && h(m);
    }) : i.tag === "sync" && !l.stripe && h(i.stripe), function() {
      p = !1;
    };
  }, [i, l, r]);
  var u = jl(n);
  M.useEffect(function() {
    u !== null && u !== n && console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
  }, [u, n]);
  var d = jl(r);
  return M.useEffect(function() {
    if (l.elements) {
      var p = Bb(r, d, ["clientSecret", "fonts"]);
      p && l.elements.update(p);
    }
  }, [r, d, l.elements]), M.useEffect(function() {
    _Y(l.stripe);
  }, [l.stripe]), /* @__PURE__ */ M.createElement(N8.Provider, {
    value: l
  }, a);
};
Ub.propTypes = {
  stripe: c1.any,
  options: c1.object
};
var wY = function(t) {
  var n = M.useContext(N8);
  return Gb(n, t);
}, j8 = function() {
  var t = wY("calls useElements()"), n = t.elements;
  return n;
};
c1.func.isRequired;
var Zb = /* @__PURE__ */ M.createContext(null);
Zb.displayName = "CustomCheckoutSdkContext";
var xY = function(t, n) {
  if (!t)
    throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(n, " in an <CustomCheckoutProvider> provider."));
  return t;
}, SY = /* @__PURE__ */ M.createContext(null);
SY.displayName = "CustomCheckoutContext";
c1.any, c1.shape({
  clientSecret: c1.string.isRequired,
  elementsOptions: c1.object
}).isRequired;
var Rl = function(t) {
  var n = M.useContext(Zb), r = M.useContext(N8);
  if (n && r)
    throw new Error("You cannot wrap the part of your app that ".concat(t, " in both <CustomCheckoutProvider> and <Elements> providers."));
  return n ? xY(n, t) : Gb(r, t);
}, kY = function(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}, E1 = function(t, n) {
  var r = "".concat(kY(t), "Element"), a = function(l) {
    var c = l.id, u = l.className, d = l.options, p = d === void 0 ? {} : d, h = l.onBlur, m = l.onFocus, f = l.onReady, C = l.onChange, _ = l.onEscape, v = l.onClick, w = l.onLoadError, k = l.onLoaderStart, b = l.onNetworksChange, S = l.onConfirm, P = l.onCancel, O = l.onShippingAddressChange, A = l.onShippingRateChange, L = Rl("mounts <".concat(r, ">")), I = "elements" in L ? L.elements : null, D = "customCheckoutSdk" in L ? L.customCheckoutSdk : null, U = M.useState(null), z = Vb(U, 2), $ = z[0], ee = z[1], Z = M.useRef(null), G = M.useRef(null);
    Sr($, "blur", h), Sr($, "focus", m), Sr($, "escape", _), Sr($, "click", v), Sr($, "loaderror", w), Sr($, "loaderstart", k), Sr($, "networkschange", b), Sr($, "confirm", S), Sr($, "cancel", P), Sr($, "shippingaddresschange", O), Sr($, "shippingratechange", A), Sr($, "change", C);
    var W;
    f && (t === "expressCheckout" ? W = f : W = function() {
      f($);
    }), Sr($, "ready", W), M.useLayoutEffect(function() {
      if (Z.current === null && G.current !== null && (I || D)) {
        var T = null;
        D ? T = D.createElement(t, p) : I && (T = I.create(t, p)), Z.current = T, ee(T), T && T.mount(G.current);
      }
    }, [I, D, p]);
    var j = jl(p);
    return M.useEffect(function() {
      if (Z.current) {
        var T = Bb(p, j, ["paymentRequest"]);
        T && "update" in Z.current && Z.current.update(T);
      }
    }, [p, j]), M.useLayoutEffect(function() {
      return function() {
        if (Z.current && typeof Z.current.destroy == "function")
          try {
            Z.current.destroy(), Z.current = null;
          } catch {
          }
      };
    }, []), /* @__PURE__ */ M.createElement("div", {
      id: c,
      className: u,
      ref: G
    });
  }, i = function(l) {
    Rl("mounts <".concat(r, ">"));
    var c = l.id, u = l.className;
    return /* @__PURE__ */ M.createElement("div", {
      id: c,
      className: u
    });
  }, o = n ? i : a;
  return o.propTypes = {
    id: c1.string,
    className: c1.string,
    onChange: c1.func,
    onBlur: c1.func,
    onFocus: c1.func,
    onReady: c1.func,
    onEscape: c1.func,
    onClick: c1.func,
    onLoadError: c1.func,
    onLoaderStart: c1.func,
    onNetworksChange: c1.func,
    onConfirm: c1.func,
    onCancel: c1.func,
    onShippingAddressChange: c1.func,
    onShippingRateChange: c1.func,
    options: c1.object
  }, o.displayName = r, o.__elementType = t, o;
}, T1 = typeof window > "u", MY = /* @__PURE__ */ M.createContext(null);
MY.displayName = "EmbeddedCheckoutProviderContext";
var mo = function() {
  var t = Rl("calls useStripe()"), n = t.stripe;
  return n;
};
E1("auBankAccount", T1);
E1("card", T1);
E1("cardNumber", T1);
E1("cardExpiry", T1);
E1("cardCvc", T1);
E1("fpxBank", T1);
E1("iban", T1);
E1("idealBank", T1);
E1("p24Bank", T1);
E1("epsBank", T1);
var Kb = E1("payment", T1), PY = E1("expressCheckout", T1);
E1("currencySelector", T1);
E1("paymentRequestButton", T1);
E1("linkAuthentication", T1);
E1("address", T1);
E1("shippingAddress", T1);
E1("paymentMethodMessaging", T1);
E1("affirmMessage", T1);
E1("afterpayClearpayMessage", T1);
const $b = (e, t) => Qa(e, t), Wb = (e, t) => Qa(e, t), R8 = () => A8.get("api/payment/confirm");
var D8 = /* @__PURE__ */ ((e) => (e.payment = "payment", e.setup = "setup", e))(D8 || {});
const EY = (e, t) => t === D8.setup ? e.confirmBancontactSetup : e.confirmBancontactPayment;
function TY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { locale: l } = Rt(), c = mo(), u = j8(), d = async (p) => {
    if (p.preventDefault(), !(!c || !u))
      try {
        a(!0), r(ur);
        const h = i();
        if (!h)
          throw new Error("Request data is undefined");
        const { redirect: m, intentSecret: f, intentType: C } = await Wb(h, l);
        if (!f)
          return window.location.href = m;
        const _ = EY(c, C), { error: v } = await _(f, {
          payment_method: {
            billing_details: {
              name: h.customer.fields.first_name,
              email: h.customer.fields.email
            }
          },
          return_url: m
        });
        v ? r((w) => ({ ...w, common: [...w.common, v.message] })) : (await R8(), window.location.assign(m));
      } catch (h) {
        h instanceof xn && o(h);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ x.jsx(
    Jr,
    {
      disabled: n,
      className: M1("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: d,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
const Yb = (e, t) => t === D8.setup ? e.confirmCardSetup : e.confirmCardPayment;
function LY({
  setIsFetching: e,
  handleBadRequest: t,
  setErrors: n,
  preSubmit: r
}) {
  const a = mo(), i = j8(), { locale: o } = Rt(), s = async (l) => {
    if (!(!a || !i))
      try {
        const c = r();
        if (!c)
          throw new Error("Request data is undefined");
        const { error: u } = await i.submit();
        if (u) {
          l.paymentFailed();
          return;
        }
        const { error: d, paymentMethod: p } = await a.createPaymentMethod({
          elements: i
        });
        if (d || !p) {
          l.paymentFailed();
          return;
        }
        const { redirect: h, intentSecret: m, intentType: f } = await $b(
          {
            ...c,
            paymentMethod: ge.stripe_applepay,
            options: { stripePaymentMethodId: p.id }
          },
          o
        );
        if (!m)
          return window.location.href = h;
        const C = Yb(a, f), { error: _ } = await C(m, {
          payment_method: p.id
        });
        _ ? n((v) => ({
          ...v,
          common: [...v.common, _.message]
        })) : (await R8(), window.location.assign(h));
      } catch (c) {
        l.paymentFailed({ reason: "fail" }), c instanceof xn && t(c);
      } finally {
        e(!1);
      }
  };
  return /* @__PURE__ */ x.jsx(
    PY,
    {
      options: {
        paymentMethods: {
          applePay: "always",
          googlePay: "never",
          amazonPay: "never",
          link: "never",
          paypal: "never"
        }
      },
      onConfirm: s
    }
  );
}
function AY(e) {
  const t = mo(), { availablePaymentMethods: n } = Dr();
  if (!t)
    return null;
  const r = n.includes(ge.stripe_applepay);
  return /* @__PURE__ */ x.jsxs("div", { children: [
    r && /* @__PURE__ */ x.jsx(LY, { ...e }),
    /* @__PURE__ */ x.jsx(
      Kb,
      {
        options: {
          fields: {
            billingDetails: {
              address: "never"
            }
          }
        }
      }
    )
  ] });
}
function OY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { locale: l } = Rt(), c = mo(), u = j8(), d = async (p) => {
    if (p.preventDefault(), !(!c || !u))
      try {
        const { error: h } = await u.submit();
        if (h)
          throw new Error("Stripe elements validation failed");
        const m = i();
        if (!m)
          throw new Error("Request data is undefined");
        a(!0), r(ur);
        const { paymentMethod: f, error: C } = await c.createPaymentMethod({
          elements: u,
          params: {
            billing_details: {
              address: {
                country: null,
                line1: null,
                line2: null,
                city: null,
                state: null,
                postal_code: null
              }
            }
          }
        });
        if (C) {
          r((S) => ({
            ...S,
            common: [...S.common, C.message]
          }));
          return;
        }
        if (!f)
          throw Error("undefined payment method");
        const { redirect: _, intentSecret: v, intentType: w } = await $b(
          { ...m, options: { stripePaymentMethodId: f.id } },
          l
        );
        if (!v)
          return window.location.href = _;
        const k = Yb(c, w), { error: b } = await k(v, {
          payment_method: f.id
        });
        b ? r((S) => ({ ...S, common: [...S.common, b.message] })) : (await R8(), window.location.assign(_));
      } catch (h) {
        h instanceof xn && o(h);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ x.jsx(
    Jr,
    {
      disabled: n,
      className: M1("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: d,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
function NY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { locale: l } = Rt(), c = mo(), u = j8(), d = async (p) => {
    if (p.preventDefault(), !(!c || !u))
      try {
        a(!0), r(ur);
        const { error: h } = await u.submit();
        if (h)
          throw new Error("Stripe elements validation failed");
        const m = i();
        if (!m)
          throw new Error("Request data is undefined");
        const { redirect: f, intentSecret: C, intentType: _ } = await Wb(m, l);
        if (!C)
          return window.location.href = f;
        const v = _ === D8.setup ? c.confirmSetup : c.confirmPayment, { error: w } = await v({
          elements: u,
          clientSecret: C,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: [m.customer.fields.first_name, m.customer.fields.last_name].filter(Boolean).join(" "),
                email: m.customer.fields.email
              }
            },
            return_url: f
          }
        });
        w ? r((k) => ({ ...k, common: [...k.common, w.message] })) : (await R8(), window.location.assign(f));
      } catch (h) {
        h instanceof xn && o(h);
      } finally {
        a(!1);
      }
  };
  return /* @__PURE__ */ x.jsx(
    Jr,
    {
      disabled: n,
      className: M1("main-transition-colors", s && "bg-danger focus:bg-danger"),
      onClick: d,
      isFetching: e,
      type: "submit",
      children: t
    }
  );
}
function jY() {
  return mo() ? /* @__PURE__ */ x.jsx("div", { children: /* @__PURE__ */ x.jsx(
    Kb,
    {
      options: {
        fields: {
          billingDetails: {
            name: "never",
            email: "never"
          }
        }
      }
    }
  ) }) : null;
}
const RY = (e) => {
  const [t, n] = e.split(" ");
  return { firstName: t, lastName: n };
}, DY = (e, t) => Qa(e, t), IY = () => {
  const { t: e } = K1(), t = typeof window < "u" && !!window.Xendit, [n, r] = ke(!t), { xenditPublicKey: a } = Wz();
  return Re(() => {
    t || Db("https://js.xendit.co/v1/xendit.min.js", "xendit-js", () => {
      window.Xendit && a ? window.Xendit.setPublishableKey(a) : Kt.error(e("public_pages_purchase.error")), r(!1);
    });
  }, [t]), {
    isScriptLoading: n
  };
}, Bo = "xendit-3ds-frame", HY = (e) => {
  const [t, n] = ke(!1), [r, a] = ke(!1), { t: i } = K1();
  return { threeDsModal: /* @__PURE__ */ x.jsxs(
    PC,
    {
      opened: t,
      onClose: () => {
        n(!1), e();
      },
      title: i("public_pages_purchase.payment.xendit.3ds"),
      children: [
        r && /* @__PURE__ */ x.jsx(V6, { className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }),
        /* @__PURE__ */ x.jsx(
          "iframe",
          {
            className: Ot("h-[650px] w-full", r && "invisible"),
            id: Bo,
            title: Bo,
            name: Bo
          }
        )
      ]
    }
  ), openLinkInIframe: (c) => {
    n(!0);
    const u = 10;
    let d = 0;
    a(!0);
    const p = setInterval(() => {
      d++, document.getElementById(Bo) ? (clearInterval(p), a(!1), window.open(c, Bo)) : d >= u && (clearInterval(p), Kt.error(i("public_pages_purchase.error")), n(!1), a(!1), e());
    }, 500);
  }, closeThreeDsModal: () => {
    n(!1);
  } };
};
var vi = /* @__PURE__ */ ((e) => (e.verified = "VERIFIED", e.in_review = "IN_REVIEW", e.failed = "FAILED", e.approved = "APPROVED", e.card_enrolled = "CARD_ENROLLED", e.fraud = "FRAUD", e))(vi || {});
function FY({
  isFetching: e,
  buttonTitle: t,
  buttonDisabled: n,
  setErrors: r,
  setIsFetching: a,
  preSubmit: i,
  handleBadRequest: o,
  hasErrors: s
}) {
  const { t: l } = K1(), { locale: c } = Rt(), { currency: u, finalAmount: d } = Dr(), { cardNumber: p, cardHolderName: h, cvc: m, expiryMonth: f, expiryYear: C, formInvalid: _ } = rv(), { isScriptLoading: v } = IY(), { openLinkInIframe: w, threeDsModal: k, closeThreeDsModal: b } = HY(
    () => a(!1)
  ), S = async (A, L) => {
    if (A) {
      Kt.error(A.message), a(!1);
      return;
    } else if (L.status === vi.in_review)
      w(L.payer_authentication_url);
    else if (L.status === vi.verified) {
      setTimeout(() => {
        b();
      }, 1e3);
      try {
        const I = i();
        if (!I)
          throw new Error("Request data is undefined");
        const { redirect: D } = await DY(
          {
            ...I,
            options: { token: L.credit_card_token_id }
          },
          c
        );
        if (D) {
          window.location.assign(D);
          return;
        } else
          Kt.error(l("public_pages_purchase.error"));
      } catch (I) {
        I instanceof xn && o(I);
      } finally {
        a(!1);
      }
    }
  }, P = async (A, L) => {
    if (A) {
      Kt.error(A.message), a(!1);
      return;
    }
    if (!window.Xendit || !d) {
      Kt.error(l("public_pages_purchase.error")), a(!1);
      return;
    }
    L.status === vi.verified ? window.Xendit.card.createAuthentication(
      {
        amount: d,
        token_id: L.id
      },
      S
    ) : L.status === vi.in_review ? w(L.payer_authentication_url) : L.status === vi.failed && (Kt.error(l("public_pages_purchase.error")), a(!1));
  }, O = async (A) => {
    A.preventDefault();
    try {
      const L = i();
      if (!L || !d || !u)
        throw new Error("Request data is undefined");
      if (a(!0), r(ur), window.Xendit) {
        const I = `20${C}`, { firstName: D, lastName: U } = RY(h), z = L.customer.fields[Ut.Email] ?? "", $ = L.customer.fields[Ut.PhoneNumber] ?? "", ee = $ ? `+${$}` : "";
        window.Xendit.card.createToken(
          {
            amount: d,
            card_number: p,
            card_exp_month: f,
            card_exp_year: I,
            card_cvn: m,
            card_holder_first_name: D,
            card_holder_last_name: U,
            card_holder_email: z,
            card_holder_phone_number: ee,
            is_multiple_use: !0,
            should_authenticate: !0,
            currency: u
          },
          P
        );
      }
    } catch {
      a(!1);
    }
  };
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    k,
    /* @__PURE__ */ x.jsx(
      Jr,
      {
        className: M1(
          "main-transition-colors",
          (s || _) && "bg-danger focus:bg-danger"
        ),
        onClick: O,
        isFetching: e,
        disabled: v || _ || n,
        type: "submit",
        children: t
      }
    )
  ] });
}
const VY = (e, t) => {
  switch (e) {
    case ge.stripe_card:
      return /* @__PURE__ */ x.jsx(OY, { ...t });
    case ge.stripe_ideal:
      return /* @__PURE__ */ x.jsx(NY, { ...t });
    case ge.stripe_bancontact:
      return /* @__PURE__ */ x.jsx(TY, { ...t });
    case ge.paypal_rest:
      return /* @__PURE__ */ x.jsx(YW, { ...t });
    case ge.paypal_soap:
      return /* @__PURE__ */ x.jsx(XW, { ...t });
    case ge.mercadopago_ar_card:
    case ge.mercadopago_br_card:
    case ge.mercadopago_cl_card:
    case ge.mercadopago_co_card:
    case ge.mercadopago_mx_card:
      return /* @__PURE__ */ x.jsx($W, { ...t });
    case ge.razorpay:
      return /* @__PURE__ */ x.jsx(nY, { ...t });
    case ge.xendit_id_card:
    case ge.xendit_ph_card:
      return /* @__PURE__ */ x.jsx(FY, { ...t });
    default:
      return /* @__PURE__ */ x.jsx(UW, { ...t });
  }
};
var Q3 = {};
Object.defineProperty(Q3, "__esModule", { value: !0 });
var qb = Q3.loadMercadoPago = void 0;
const Jb = "https://sdk.mercadopago.com/js/v2", BY = /^https:\/\/sdk\.mercadopago\.com\/js\/v2\/?(\?.*)?$/, ch = "MercadoPago has already been initialized in your window, please remove the duplicate import", zY = "MercadoPago.js not available", GY = "Failed to load MercadoPago.js", UY = () => {
  for (var e = document.querySelectorAll(`script[src^="${Jb}"`), t = 0; t < e.length; t++) {
    var n = e[t];
    if (BY.test(n.src))
      return n;
  }
  return null;
}, ZY = () => {
  const e = document.createElement("script");
  e.src = Jb;
  const t = document.head || document.body;
  if (!t)
    throw new Error("Expected document.body or document.head not to be null. MercadoPago requires a <body> or a <head> element, please add on your project.");
  return t.appendChild(e), e;
};
let K9 = null;
const KY = () => (K9 !== null || (K9 = new Promise((e, t) => {
  if (typeof window > "u") {
    e(null);
    return;
  }
  if (window.MercadoPago) {
    console.warn(ch), e(window.MercadoPago);
    return;
  }
  try {
    let n = UY();
    n ? console.warn(ch) : n || (n = ZY()), n.addEventListener("load", () => {
      window.MercadoPago ? e(window.MercadoPago) : t(new Error(zY));
    }), n.addEventListener("error", () => {
      t(new Error(GY));
    });
  } catch (n) {
    t(n);
    return;
  }
})), K9);
qb = Q3.loadMercadoPago = KY;
var $Y = function(e, t, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        o(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        o(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
};
class Dn {
  static getInstance() {
    return $Y(this, void 0, void 0, function* () {
      if (this.publicKey)
        return this.loadedInstanceMercadoPago || (yield qb(), this.loadedInstanceMercadoPago = !0), this.instanceMercadoPago || (this.instanceMercadoPago = new window.MercadoPago(this.publicKey, this.options)), this.instanceMercadoPago;
      console.error("Expected the PUBLIC_KEY to render the MercadoPago SDK React");
    });
  }
}
Dn.publicKey = null;
Dn.options = {};
Dn.instanceMercadoPago = void 0;
Dn.loadedInstanceMercadoPago = !1;
function WY(e, t) {
  return Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((r) => Object.prototype.hasOwnProperty.call(t, r) && e[r] === t[r]);
}
const YY = (e, t) => {
  const n = Object.assign(Object.assign({}, t), { frontEndStack: "react" }), r = !WY(Dn.options, n);
  (e !== Dn.publicKey || r) && (Dn.publicKey = e, Dn.options = n, Dn.instanceMercadoPago = void 0);
}, qY = 200;
var JY = function(e, t, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        o(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        o(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
};
const XY = () => JY(void 0, void 0, void 0, function* () {
}), QY = () => {
}, eq = (e) => {
  console.error(e);
}, tq = (e) => {
  console.log(e);
};
var rq = function(e, t, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        o(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        o(d);
      }
    }
    function c(u) {
      u.done ? i(u.value) : a(u.value).then(s, l);
    }
    c((r = r.apply(e, t || [])).next());
  });
};
const nq = ({ settings: e, name: t, containerId: n, controller: r }) => rq(void 0, void 0, void 0, function* () {
  const a = yield Dn.getInstance(), i = a == null ? void 0 : a.bricks();
  window[r] = yield i == null ? void 0 : i.create(t, n, e);
}), aq = ({ onReady: e = QY, onError: t = eq, onSubmit: n = XY, onBinChange: r = tq, initialization: a, customization: i, locale: o, id: s = "cardPaymentBrick_container" }) => (Re(() => {
  const l = {
    settings: {
      initialization: a,
      customization: i,
      callbacks: {
        onReady: e,
        onSubmit: n,
        onError: t,
        onBinChange: r
      },
      locale: o
    },
    name: "cardPayment",
    containerId: s,
    controller: "cardPaymentBrickController"
  }, c = setTimeout(() => {
    nq(l);
  }, qY);
  return () => {
    var u;
    clearTimeout(c), (u = window.cardPaymentBrickController) === null || u === void 0 || u.unmount();
  };
}, [a, i, r, e, t, n]), M.createElement("div", { id: s })), iq = () => ({ update: (t) => {
  window.cardPaymentBrickController ? window.cardPaymentBrickController.update(t) : console.warn("[Checkout Bricks] Card Payment Brick is not initialized yet, please try again after a few seconds.");
} });
function oq() {
  var m;
  const { state: e } = wr(), { initialized: t } = av(), [n, r] = ke(!1), { primaryColor: a, secondaryColor: i, textColorPrimary: o, textColorTertiary: s, tertiaryColor: l } = S8(e), { finalAmount: c, contactFields: u } = Dr(), d = (m = u == null ? void 0 : u[Ut.Email]) == null ? void 0 : m.value, { update: p } = iq();
  return Re(() => {
    c && t && n && p({ amount: h1(c) });
  }, [c, t, n]), _e(() => !c || !t ? null : /* @__PURE__ */ x.jsx(
    aq,
    {
      initialization: { amount: h1(c), payer: { email: d } },
      customization: {
        visual: {
          hidePaymentButton: !0,
          style: {
            customVariables: {
              textPrimaryColor: s,
              inputBackgroundColor: l,
              formBackgroundColor: i,
              baseColor: a,
              baseColorFirstVariant: a,
              baseColorSecondVariant: i,
              outlinePrimaryColor: "var(--THEME-border-tertiary)",
              outlineSecondaryColor: "var(--THEME-border-tertiary)",
              buttonTextColor: o
            }
          }
        }
      },
      onSubmit: async (f) => {
      },
      onError: (f) => console.log("MP error", f),
      onReady: () => {
        r(!0);
      }
    }
  ), [t]);
}
var sq = 3, lq = 5, un = /(\d{1,4})/g, ec = [{
  displayName: "Visa",
  type: "visa",
  format: un,
  startPattern: /^4/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "Mastercard",
  type: "mastercard",
  format: un,
  startPattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "American Express",
  type: "amex",
  format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  startPattern: /^3[47]/,
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: "CID",
    length: 4
  }
}, {
  displayName: "Diners Club",
  type: "dinersclub",
  format: un,
  startPattern: /^(36|38|30[0-5])/,
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "Discover",
  type: "discover",
  format: un,
  startPattern: /^(6011|65|64[4-9]|622)/,
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: "CID",
    length: 3
  }
}, {
  displayName: "JCB",
  type: "jcb",
  format: un,
  startPattern: /^35/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: "CVV",
    length: 3
  }
}, {
  displayName: "UnionPay",
  type: "unionpay",
  format: un,
  startPattern: /^62/,
  gaps: [4, 8, 12],
  lengths: [14, 15, 16, 17, 18, 19],
  code: {
    name: "CVN",
    length: 3
  }
}, {
  displayName: "Maestro",
  type: "maestro",
  format: un,
  startPattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "Elo",
  type: "elo",
  format: un,
  startPattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVE",
    length: 3
  }
}, {
  displayName: "Hipercard",
  type: "hipercard",
  format: un,
  startPattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVC",
    length: 3
  }
}, {
  displayName: "Troy",
  type: "troy",
  format: un,
  startPattern: /^9792/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: "CVV",
    length: 3
  }
}], I8 = function(t) {
  return ec.filter(function(n) {
    return n.startPattern.test(t);
  })[0];
}, cq = function(t) {
  return ec.filter(function(n) {
    return n.type === t;
  })[0];
}, uq = /* @__PURE__ */ Object.freeze({
  DEFAULT_CVC_LENGTH: sq,
  DEFAULT_ZIP_LENGTH: lq,
  DEFAULT_CARD_FORMAT: un,
  CARD_TYPES: ec,
  getCardTypeByValue: I8,
  getCardTypeByType: cq
}), dq = /(0[1-9]|1[0-2])/, Xb = "Enter a card number", Qb = "Enter an expiry date", e_ = "Enter a CVC", t_ = "Enter a ZIP code", r_ = "Card number is invalid", n_ = "Expiry date is invalid", Dl = "CVC is invalid", a_ = "Expiry month must be between 01 and 12", i_ = "Expiry year cannot be in the past", o_ = "Expiry date cannot be in the past", pq = function(t) {
  var n = I8(t);
  return n && t.length >= n.lengths[n.lengths.length - 1];
}, hq = function(t) {
  return /^\d*$/.test(t.key);
}, s_ = function(t) {
  return t.split("").reverse().map(function(n) {
    return parseInt(n, 10);
  }).map(function(n, r) {
    return r % 2 ? n * 2 : n;
  }).map(function(n) {
    return n > 9 ? n % 10 + 1 : n;
  }).reduce(function(n, r) {
    return n += r;
  }) % 10 === 0;
}, mq = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.errorMessages, i = a === void 0 ? {} : a;
  if (!t)
    return i.emptyCardNumber || Xb;
  var o = t.replace(/\s/g, ""), s = I8(o);
  if (s && s.lengths) {
    var l = s.lengths.includes(o.length);
    if (l) {
      var c = s_(o);
      if (c)
        return n ? n({
          cardNumber: o,
          cardType: s,
          errorMessages: i
        }) : void 0;
    }
  }
  return i.invalidCardNumber || r_;
}, fq = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.errorMessages, i = a === void 0 ? {} : a;
  if (!t)
    return i.emptyExpiryDate || Qb;
  var o = t.replace(" / ", "").replace("/", "");
  if (o.length === 4) {
    var s = o.slice(0, 2), l = "20".concat(o.slice(2, 4));
    return dq.test(s) ? parseInt(l) < (/* @__PURE__ */ new Date()).getFullYear() ? i.yearOutOfRange || i_ : parseInt(l) === (/* @__PURE__ */ new Date()).getFullYear() && parseInt(s) < (/* @__PURE__ */ new Date()).getMonth() + 1 ? i.dateOutOfRange || o_ : n ? n({
      expiryDate: {
        month: s,
        year: l
      },
      errorMessages: i
    }) : void 0 : i.monthOutOfRange || a_;
  }
  return i.invalidExpiryDate || n_;
}, Cq = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = r.cardType, i = r.errorMessages, o = i === void 0 ? {} : i;
  if (!t)
    return o.emptyCVC || e_;
  if (t.length < 3 || a && t.length !== a.code.length)
    return o.invalidCVC || Dl;
  if (n)
    return n({
      cvc: t,
      cardType: a,
      errorMessages: o
    });
}, gq = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.errorMessages, a = r === void 0 ? {} : r;
  if (!t)
    return a.emptyZIP || t_;
}, yq = /* @__PURE__ */ Object.freeze({
  EMPTY_CARD_NUMBER: Xb,
  EMPTY_EXPIRY_DATE: Qb,
  EMPTY_CVC: e_,
  EMPTY_ZIP: t_,
  INVALID_CARD_NUMBER: r_,
  INVALID_EXPIRY_DATE: n_,
  INVALID_CVC: Dl,
  MONTH_OUT_OF_RANGE: a_,
  YEAR_OUT_OF_RANGE: i_,
  DATE_OUT_OF_RANGE: o_,
  hasCardNumberReachedMaxLength: pq,
  isNumeric: hq,
  validateLuhn: s_,
  getCardNumberError: mq,
  getExpiryDateError: fq,
  getCVCError: Cq,
  getZIPError: gq
});
function Na(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function h2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(a) {
      return Object.getOwnPropertyDescriptor(n, a).enumerable;
    }))), r.forEach(function(a) {
      Na(e, a, n[a]);
    });
  }
  return e;
}
function vq(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function $9(e, t) {
  if (e == null)
    return {};
  var n = vq(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function k9(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function x2(e, t) {
  return l_(e) || wq(e, t) || c_();
}
function bq(e) {
  return l_(e) || _q(e) || c_();
}
function l_(e) {
  if (Array.isArray(e))
    return e;
}
function _q(e) {
  if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]")
    return Array.from(e);
}
function wq(e, t) {
  var n = [], r = !0, a = !1, i = void 0;
  try {
    for (var o = e[Symbol.iterator](), s; !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0)
      ;
  } catch (l) {
    a = !0, i = l;
  } finally {
    try {
      !r && o.return != null && o.return();
    } finally {
      if (a)
        throw i;
    }
  }
  return n;
}
function c_() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var xq = function(t) {
  var n = I8(t);
  if (!n)
    return (t.match(/\d+/g) || []).join("");
  var r = n.format;
  if (r && r.global)
    return (t.match(r) || []).join(" ");
  if (r) {
    var a = r.exec(t.split(" ").join(""));
    if (a)
      return a.splice(1, 3).filter(function(i) {
        return i;
      }).join(" ");
  }
  return t;
}, Sq = function(t) {
  var n = t.nativeEvent && t.nativeEvent.data, r = t.target.value.split(" / ").join("/");
  if (!r)
    return null;
  var a = r;
  if (/^[2-9]$/.test(a) && (a = "0".concat(a)), r.length === 2 && +r > 12) {
    var i = r.split(""), o = bq(i), s = o[0], l = o.slice(1);
    a = "0".concat(s, "/").concat(l.join(""));
  }
  if (/^1[/-]$/.test(a))
    return "01 / ";
  if (a = a.match(/(\d{1,2})/g) || [], a.length === 1) {
    if (!n && r.includes("/"))
      return a[0];
    if (/\d{2}/.test(a))
      return "".concat(a[0], " / ");
  }
  if (a.length > 2) {
    var c = a.join("").match(/^(\d{2}).*(\d{2})$/) || [], u = x2(c, 3), d = u[1], p = d === void 0 ? null : d, h = u[2], m = h === void 0 ? null : h;
    return [p, m].join(" / ");
  }
  return a.join(" / ");
}, kq = /* @__PURE__ */ Object.freeze({
  formatCardNumber: xq,
  formatExpiry: Sq
}), Mq = "Backspace", Pq = "Enter", Eq = function() {
  return (window.getSelection() || {
    type: void 0
  }).type === "Range";
}, Jt = {
  cardTypes: uq,
  formatter: kq,
  validator: yq,
  BACKSPACE_KEY_CODE: Mq,
  ENTER_KEY_CODE: Pq,
  isHighlighted: Eq
};
function Tq() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.autoFocus, n = t === void 0 ? !0 : t, r = e.errorMessages, a = e.onBlur, i = e.onChange, o = e.onError, s = e.onTouch, l = e.cardNumberValidator, c = e.cvcValidator, u = e.expiryValidator, d = M.useRef(), p = M.useRef(), h = M.useRef(), m = M.useRef(), f = M.useState({
    cardNumber: !1,
    expiryDate: !1,
    cvc: !1,
    zip: !1
  }), C = x2(f, 2), _ = C[0], v = C[1], w = M.useState(!1), k = x2(w, 2), b = k[0], S = k[1], P = M.useState({
    cardNumber: void 0,
    expiryDate: void 0,
    cvc: void 0,
    zip: void 0
  }), O = x2(P, 2), A = O[0], L = O[1], I = M.useState(), D = x2(I, 2), U = D[0], z = D[1], $ = M.useState(), ee = x2($, 2), Z = ee[0], G = ee[1], W = M.useState(), j = x2(W, 2), T = j[0], F = j[1], N = M.useCallback(function(fe, Ce) {
    L(function(Le) {
      if (Le[fe] === Ce)
        return Le;
      var ct = Ce, y1 = h2({}, Le, Na({}, fe, Ce));
      return Ce ? z(Ce) : (ct = Object.values(y1).find(Boolean), z(ct)), o && o(ct, y1), y1;
    });
  }, []), Y = M.useCallback(function(fe, Ce) {
    requestAnimationFrame(function() {
      document.activeElement.tagName !== "INPUT" ? S(!0) : Ce === !1 && S(!1);
    }), v(function(Le) {
      if (Le[fe] === Ce)
        return Le;
      var ct = h2({}, Le, Na({}, fe, Ce));
      return s && s(Na({}, fe, Ce), ct), ct;
    });
  }, []), Q = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onBlur && fe.onBlur(Ce), a && a(Ce), F(void 0), Y("cardNumber", !0);
    };
  }, [a, Y]), V = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      var Le = Ce.target.value || "", ct = Le.replace(/\s/g, ""), y1 = d.current.selectionStart, $1 = Jt.cardTypes.getCardTypeByValue(ct);
      G($1), Y("cardNumber", !1), d.current.value = Jt.formatter.formatCardNumber(ct), fe.onChange && fe.onChange(Ce), i && i(Ce), requestAnimationFrame(function() {
        document.activeElement === d.current && (d.current.value[y1 - 1] === " " && (y1 = y1 + 1), d.current.setSelectionRange(y1, y1));
      });
      var Xr = Jt.validator.getCardNumberError(ct, l, {
        errorMessages: r
      });
      !Xr && n && p.current && p.current.focus(), N("cardNumber", Xr), fe.onError && fe.onError(Xr);
    };
  }, [n, l, r, i, N, Y]), re = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onFocus && fe.onFocus(Ce), F("cardNumber");
    };
  }, []), q = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      var Le = Ce.target.value || "", ct = Le.replace(/\s/g, "");
      fe.onKeyPress && fe.onKeyPress(Ce), Ce.key !== Jt.ENTER_KEY_CODE && (Jt.validator.isNumeric(Ce) || Ce.preventDefault(), Jt.validator.hasCardNumberReachedMaxLength(ct) && Ce.preventDefault());
    };
  }, []), he = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = fe.refKey, Le = $9(fe, ["refKey"]);
    return h2(Na({
      "aria-label": "Card number",
      autoComplete: "cc-number",
      id: "cardNumber",
      name: "cardNumber",
      placeholder: "Card number",
      type: "tel"
    }, Ce || "ref", d), Le, {
      onBlur: Q(Le),
      onChange: V(Le),
      onFocus: re(Le),
      onKeyPress: q(Le)
    });
  }, [Q, V, re, q]), me = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onBlur && fe.onBlur(Ce), a && a(Ce), F(void 0), Y("expiryDate", !0);
    };
  }, [a, Y]), Ne = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      Y("expiryDate", !1), p.current.value = Jt.formatter.formatExpiry(Ce), fe.onChange && fe.onChange(Ce), i && i(Ce);
      var Le = Jt.validator.getExpiryDateError(p.current.value, u, {
        errorMessages: r
      });
      !Le && n && h.current && h.current.focus(), N("expiryDate", Le), fe.onError && fe.onError(Le);
    };
  }, [n, r, u, i, N, Y]), K = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onFocus && fe.onFocus(Ce), F("expiryDate");
    };
  }, []), Ee = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onKeyDown && fe.onKeyDown(Ce), Ce.key === Jt.BACKSPACE_KEY_CODE && !Ce.target.value && n && d.current && d.current.focus();
    };
  }, [n]), J = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      var Le = Ce.target.value || "", ct = Le.replace(" / ", "");
      fe.onKeyPress && fe.onKeyPress(Ce), Ce.key !== Jt.ENTER_KEY_CODE && (Jt.validator.isNumeric(Ce) || Ce.preventDefault(), ct.length >= 4 && Ce.preventDefault());
    };
  }, []), te = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = fe.refKey, Le = $9(fe, ["refKey"]);
    return h2(Na({
      "aria-label": "Expiry date in format MM YY",
      autoComplete: "cc-exp",
      id: "expiryDate",
      name: "expiryDate",
      placeholder: "MM/YY",
      type: "tel"
    }, Ce || "ref", p), Le, {
      onBlur: me(Le),
      onChange: Ne(Le),
      onFocus: K(Le),
      onKeyDown: Ee(Le),
      onKeyPress: J(Le)
    });
  }, [me, Ne, K, Ee, J]), ye = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onBlur && fe.onBlur(Ce), a && a(Ce), F(void 0), Y("cvc", !0);
    };
  }, [a, Y]), Pe = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Le = Ce.cardType;
    return function(ct) {
      var y1 = ct.target.value;
      Y("cvc", !1), fe.onChange && fe.onChange(ct), i && i(ct);
      var $1 = Jt.validator.getCVCError(y1, c, {
        cardType: Le,
        errorMessages: r
      });
      !$1 && n && m.current && m.current.focus(), N("cvc", $1), fe.onError && fe.onError($1);
    };
  }, [n, c, r, i, N, Y]), Ze = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onFocus && fe.onFocus(Ce), F("cvc");
    };
  }, []), _t = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onKeyDown && fe.onKeyDown(Ce), Ce.key === Jt.BACKSPACE_KEY_CODE && !Ce.target.value && n && p.current && p.current.focus();
    };
  }, [n]), st = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = arguments.length > 1 ? arguments[1] : void 0, Le = Ce.cardType;
    return function(ct) {
      var y1 = ct.target.value || "", $1 = y1.replace(" / ", "");
      fe.onKeyPress && fe.onKeyPress(ct), ct.key !== Jt.ENTER_KEY_CODE && (Jt.validator.isNumeric(ct) || ct.preventDefault(), Le && $1.length >= Le.code.length && ct.preventDefault(), $1.length >= 4 && ct.preventDefault());
    };
  }, []), L1 = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = fe.refKey, Le = $9(fe, ["refKey"]);
    return h2(Na({
      "aria-label": "CVC",
      autoComplete: "cc-csc",
      id: "cvc",
      name: "cvc",
      placeholder: Z ? Z.code.name : "CVC",
      type: "tel"
    }, Ce || "ref", h), Le, {
      onBlur: ye(Le),
      onChange: Pe(Le, {
        cardType: Z
      }),
      onFocus: Ze(Le),
      onKeyDown: _t(Le),
      onKeyPress: st(Le, {
        cardType: Z
      })
    });
  }, [Z, ye, Pe, Ze, _t, st]), $t = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onBlur && fe.onBlur(Ce), a && a(Ce), F(void 0), Y("zip", !0);
    };
  }, [a, Y]), Qt = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      var Le = Ce.target.value;
      Y("zip", !1), fe.onChange && fe.onChange(Ce), i && i(Ce);
      var ct = Jt.validator.getZIPError(Le, {
        errorMessages: r
      });
      N("zip", ct), fe.onError && fe.onError(ct);
    };
  }, [r, i, N, Y]), Ie = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onFocus && fe.onFocus(Ce), F("zip");
    };
  }, []), lt = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onKeyDown && fe.onKeyDown(Ce), Ce.key === Jt.BACKSPACE_KEY_CODE && !Ce.target.value && n && h.current && h.current.focus();
    };
  }, [n]), C1 = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return function(Ce) {
      fe.onKeyPress && fe.onKeyPress(Ce), Ce.key !== Jt.ENTER_KEY_CODE && (Jt.validator.isNumeric(Ce) || Ce.preventDefault());
    };
  }, []), At = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = fe.refKey, Le = $9(fe, ["refKey"]);
    return h2(Na({
      autoComplete: "off",
      id: "zip",
      maxLength: "6",
      name: "zip",
      placeholder: "ZIP",
      type: "tel"
    }, Ce || "ref", m), Le, {
      onBlur: $t(Le),
      onChange: Qt(Le),
      onFocus: Ie(Le),
      onKeyDown: lt(Le),
      onKeyPress: C1(Le)
    });
  }, [$t, Qt, Ie, lt, C1]), g1 = M.useCallback(function() {
    var fe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ce = fe.images || {};
    return h2({
      "aria-label": Z ? Z.displayName : "Placeholder card",
      children: Ce[Z ? Z.type : "placeholder"] || Ce.placeholder,
      width: "1.5em",
      height: "1em",
      viewBox: "0 0 24 16"
    }, fe);
  }, [Z]);
  return M.useLayoutEffect(function() {
    if (m.current) {
      var fe = Jt.validator.getZIPError(m.current.value, {
        errorMessages: r
      });
      N("zip", fe);
    }
    if (h.current) {
      var Ce = Jt.validator.getCVCError(h.current.value, c, {
        errorMessages: r
      });
      N("cvc", Ce);
    }
    if (p.current) {
      var Le = Jt.validator.getExpiryDateError(p.current.value, u, {
        errorMessages: r
      });
      N("expiryDate", Le);
    }
    if (d.current) {
      var ct = Jt.validator.getCardNumberError(d.current.value, l, {
        errorMessages: r
      });
      N("cardNumber", ct);
    }
  }, [l, c, r, u, N]), M.useLayoutEffect(function() {
    d.current && (d.current.value = Jt.formatter.formatCardNumber(d.current.value)), p.current && (p.current.value = Jt.formatter.formatExpiry({
      target: p.current
    }));
  }, []), M.useLayoutEffect(function() {
    if (d.current) {
      var fe = Jt.cardTypes.getCardTypeByValue(d.current.value);
      G(fe);
    }
  }, []), {
    getCardImageProps: g1,
    getCardNumberProps: he,
    getExpiryDateProps: te,
    getCVCProps: L1,
    getZIPProps: At,
    wrapperProps: {
      error: U,
      focused: T,
      isTouched: b
    },
    meta: {
      cardType: Z,
      erroredInputs: A,
      error: U,
      focused: T,
      isTouched: b,
      touchedInputs: _
    }
  };
}
var Il = { exports: {} }, Ht = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uh;
function Lq() {
  if (uh)
    return Ht;
  uh = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function f(C) {
    if (typeof C == "object" && C !== null) {
      var _ = C.$$typeof;
      switch (_) {
        case e:
          switch (C = C.type, C) {
            case n:
            case a:
            case r:
            case c:
            case u:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case s:
                case o:
                case l:
                case p:
                case d:
                case i:
                  return C;
                default:
                  return _;
              }
          }
        case t:
          return _;
      }
    }
  }
  return Ht.ContextConsumer = o, Ht.ContextProvider = i, Ht.Element = e, Ht.ForwardRef = l, Ht.Fragment = n, Ht.Lazy = p, Ht.Memo = d, Ht.Portal = t, Ht.Profiler = a, Ht.StrictMode = r, Ht.Suspense = c, Ht.SuspenseList = u, Ht.isAsyncMode = function() {
    return !1;
  }, Ht.isConcurrentMode = function() {
    return !1;
  }, Ht.isContextConsumer = function(C) {
    return f(C) === o;
  }, Ht.isContextProvider = function(C) {
    return f(C) === i;
  }, Ht.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === e;
  }, Ht.isForwardRef = function(C) {
    return f(C) === l;
  }, Ht.isFragment = function(C) {
    return f(C) === n;
  }, Ht.isLazy = function(C) {
    return f(C) === p;
  }, Ht.isMemo = function(C) {
    return f(C) === d;
  }, Ht.isPortal = function(C) {
    return f(C) === t;
  }, Ht.isProfiler = function(C) {
    return f(C) === a;
  }, Ht.isStrictMode = function(C) {
    return f(C) === r;
  }, Ht.isSuspense = function(C) {
    return f(C) === c;
  }, Ht.isSuspenseList = function(C) {
    return f(C) === u;
  }, Ht.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === a || C === r || C === c || C === u || C === h || typeof C == "object" && C !== null && (C.$$typeof === p || C.$$typeof === d || C.$$typeof === i || C.$$typeof === o || C.$$typeof === l || C.$$typeof === m || C.getModuleId !== void 0);
  }, Ht.typeOf = f, Ht;
}
var Ft = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dh;
function Aq() {
  return dh || (dh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = !1, f = !1, C = !1, _ = !1, v = !1, w;
    w = Symbol.for("react.module.reference");
    function k(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === n || J === a || v || J === r || J === c || J === u || _ || J === h || m || f || C || typeof J == "object" && J !== null && (J.$$typeof === p || J.$$typeof === d || J.$$typeof === i || J.$$typeof === o || J.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      J.$$typeof === w || J.getModuleId !== void 0));
    }
    function b(J) {
      if (typeof J == "object" && J !== null) {
        var te = J.$$typeof;
        switch (te) {
          case e:
            var ye = J.type;
            switch (ye) {
              case n:
              case a:
              case r:
              case c:
              case u:
                return ye;
              default:
                var Pe = ye && ye.$$typeof;
                switch (Pe) {
                  case s:
                  case o:
                  case l:
                  case p:
                  case d:
                  case i:
                    return Pe;
                  default:
                    return te;
                }
            }
          case t:
            return te;
        }
      }
    }
    var S = o, P = i, O = e, A = l, L = n, I = p, D = d, U = t, z = a, $ = r, ee = c, Z = u, G = !1, W = !1;
    function j(J) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function T(J) {
      return W || (W = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(J) {
      return b(J) === o;
    }
    function N(J) {
      return b(J) === i;
    }
    function Y(J) {
      return typeof J == "object" && J !== null && J.$$typeof === e;
    }
    function Q(J) {
      return b(J) === l;
    }
    function V(J) {
      return b(J) === n;
    }
    function re(J) {
      return b(J) === p;
    }
    function q(J) {
      return b(J) === d;
    }
    function he(J) {
      return b(J) === t;
    }
    function me(J) {
      return b(J) === a;
    }
    function Ne(J) {
      return b(J) === r;
    }
    function K(J) {
      return b(J) === c;
    }
    function Ee(J) {
      return b(J) === u;
    }
    Ft.ContextConsumer = S, Ft.ContextProvider = P, Ft.Element = O, Ft.ForwardRef = A, Ft.Fragment = L, Ft.Lazy = I, Ft.Memo = D, Ft.Portal = U, Ft.Profiler = z, Ft.StrictMode = $, Ft.Suspense = ee, Ft.SuspenseList = Z, Ft.isAsyncMode = j, Ft.isConcurrentMode = T, Ft.isContextConsumer = F, Ft.isContextProvider = N, Ft.isElement = Y, Ft.isForwardRef = Q, Ft.isFragment = V, Ft.isLazy = re, Ft.isMemo = q, Ft.isPortal = he, Ft.isProfiler = me, Ft.isStrictMode = Ne, Ft.isSuspense = K, Ft.isSuspenseList = Ee, Ft.isValidElementType = k, Ft.typeOf = b;
  }()), Ft;
}
process.env.NODE_ENV === "production" ? Il.exports = Lq() : Il.exports = Aq();
var tc = Il.exports;
function Oq(e) {
  function t(F, N, Y, Q, V) {
    for (var re = 0, q = 0, he = 0, me = 0, Ne, K, Ee = 0, J = 0, te, ye = te = Ne = 0, Pe = 0, Ze = 0, _t = 0, st = 0, L1 = Y.length, $t = L1 - 1, Qt, Ie = "", lt = "", C1 = "", At = "", g1; Pe < L1; ) {
      if (K = Y.charCodeAt(Pe), Pe === $t && q + me + he + re !== 0 && (q !== 0 && (K = q === 47 ? 10 : 47), me = he = re = 0, L1++, $t++), q + me + he + re === 0) {
        if (Pe === $t && (0 < Ze && (Ie = Ie.replace(p, "")), 0 < Ie.trim().length)) {
          switch (K) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              Ie += Y.charAt(Pe);
          }
          K = 59;
        }
        switch (K) {
          case 123:
            for (Ie = Ie.trim(), Ne = Ie.charCodeAt(0), te = 1, st = ++Pe; Pe < L1; ) {
              switch (K = Y.charCodeAt(Pe)) {
                case 123:
                  te++;
                  break;
                case 125:
                  te--;
                  break;
                case 47:
                  switch (K = Y.charCodeAt(Pe + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (ye = Pe + 1; ye < $t; ++ye)
                          switch (Y.charCodeAt(ye)) {
                            case 47:
                              if (K === 42 && Y.charCodeAt(ye - 1) === 42 && Pe + 2 !== ye) {
                                Pe = ye + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (K === 47) {
                                Pe = ye + 1;
                                break e;
                              }
                          }
                        Pe = ye;
                      }
                  }
                  break;
                case 91:
                  K++;
                case 40:
                  K++;
                case 34:
                case 39:
                  for (; Pe++ < $t && Y.charCodeAt(Pe) !== K; )
                    ;
              }
              if (te === 0)
                break;
              Pe++;
            }
            switch (te = Y.substring(st, Pe), Ne === 0 && (Ne = (Ie = Ie.replace(d, "").trim()).charCodeAt(0)), Ne) {
              case 64:
                switch (0 < Ze && (Ie = Ie.replace(p, "")), K = Ie.charCodeAt(1), K) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    Ze = N;
                    break;
                  default:
                    Ze = ee;
                }
                if (te = t(N, Ze, te, K, V + 1), st = te.length, 0 < G && (Ze = n(ee, Ie, _t), g1 = s(3, te, Ze, N, U, D, st, K, V, Q), Ie = Ze.join(""), g1 !== void 0 && (st = (te = g1.trim()).length) === 0 && (K = 0, te = "")), 0 < st)
                  switch (K) {
                    case 115:
                      Ie = Ie.replace(S, o);
                    case 100:
                    case 109:
                    case 45:
                      te = Ie + "{" + te + "}";
                      break;
                    case 107:
                      Ie = Ie.replace(v, "$1 $2"), te = Ie + "{" + te + "}", te = $ === 1 || $ === 2 && i("@" + te, 3) ? "@-webkit-" + te + "@" + te : "@" + te;
                      break;
                    default:
                      te = Ie + te, Q === 112 && (te = (lt += te, ""));
                  }
                else
                  te = "";
                break;
              default:
                te = t(N, n(N, Ie, _t), te, Q, V + 1);
            }
            C1 += te, te = _t = Ze = ye = Ne = 0, Ie = "", K = Y.charCodeAt(++Pe);
            break;
          case 125:
          case 59:
            if (Ie = (0 < Ze ? Ie.replace(p, "") : Ie).trim(), 1 < (st = Ie.length))
              switch (ye === 0 && (Ne = Ie.charCodeAt(0), Ne === 45 || 96 < Ne && 123 > Ne) && (st = (Ie = Ie.replace(" ", ":")).length), 0 < G && (g1 = s(1, Ie, N, F, U, D, lt.length, Q, V, Q)) !== void 0 && (st = (Ie = g1.trim()).length) === 0 && (Ie = "\0\0"), Ne = Ie.charCodeAt(0), K = Ie.charCodeAt(1), Ne) {
                case 0:
                  break;
                case 64:
                  if (K === 105 || K === 99) {
                    At += Ie + Y.charAt(Pe);
                    break;
                  }
                default:
                  Ie.charCodeAt(st - 1) !== 58 && (lt += a(Ie, Ne, K, Ie.charCodeAt(2)));
              }
            _t = Ze = ye = Ne = 0, Ie = "", K = Y.charCodeAt(++Pe);
        }
      }
      switch (K) {
        case 13:
        case 10:
          q === 47 ? q = 0 : 1 + Ne === 0 && Q !== 107 && 0 < Ie.length && (Ze = 1, Ie += "\0"), 0 < G * j && s(0, Ie, N, F, U, D, lt.length, Q, V, Q), D = 1, U++;
          break;
        case 59:
        case 125:
          if (q + me + he + re === 0) {
            D++;
            break;
          }
        default:
          switch (D++, Qt = Y.charAt(Pe), K) {
            case 9:
            case 32:
              if (me + re + q === 0)
                switch (Ee) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    Qt = "";
                    break;
                  default:
                    K !== 32 && (Qt = " ");
                }
              break;
            case 0:
              Qt = "\\0";
              break;
            case 12:
              Qt = "\\f";
              break;
            case 11:
              Qt = "\\v";
              break;
            case 38:
              me + q + re === 0 && (Ze = _t = 1, Qt = "\f" + Qt);
              break;
            case 108:
              if (me + q + re + z === 0 && 0 < ye)
                switch (Pe - ye) {
                  case 2:
                    Ee === 112 && Y.charCodeAt(Pe - 3) === 58 && (z = Ee);
                  case 8:
                    J === 111 && (z = J);
                }
              break;
            case 58:
              me + q + re === 0 && (ye = Pe);
              break;
            case 44:
              q + he + me + re === 0 && (Ze = 1, Qt += "\r");
              break;
            case 34:
            case 39:
              q === 0 && (me = me === K ? 0 : me === 0 ? K : me);
              break;
            case 91:
              me + q + he === 0 && re++;
              break;
            case 93:
              me + q + he === 0 && re--;
              break;
            case 41:
              me + q + re === 0 && he--;
              break;
            case 40:
              if (me + q + re === 0) {
                if (Ne === 0)
                  switch (2 * Ee + 3 * J) {
                    case 533:
                      break;
                    default:
                      Ne = 1;
                  }
                he++;
              }
              break;
            case 64:
              q + he + me + re + ye + te === 0 && (te = 1);
              break;
            case 42:
            case 47:
              if (!(0 < me + re + he))
                switch (q) {
                  case 0:
                    switch (2 * K + 3 * Y.charCodeAt(Pe + 1)) {
                      case 235:
                        q = 47;
                        break;
                      case 220:
                        st = Pe, q = 42;
                    }
                    break;
                  case 42:
                    K === 47 && Ee === 42 && st + 2 !== Pe && (Y.charCodeAt(st + 2) === 33 && (lt += Y.substring(st, Pe + 1)), Qt = "", q = 0);
                }
          }
          q === 0 && (Ie += Qt);
      }
      J = Ee, Ee = K, Pe++;
    }
    if (st = lt.length, 0 < st) {
      if (Ze = N, 0 < G && (g1 = s(2, lt, Ze, F, U, D, st, Q, V, Q), g1 !== void 0 && (lt = g1).length === 0))
        return At + lt + C1;
      if (lt = Ze.join(",") + "{" + lt + "}", $ * z !== 0) {
        switch ($ !== 2 || i(lt, 2) || (z = 0), z) {
          case 111:
            lt = lt.replace(k, ":-moz-$1") + lt;
            break;
          case 112:
            lt = lt.replace(w, "::-webkit-input-$1") + lt.replace(w, "::-moz-$1") + lt.replace(w, ":-ms-input-$1") + lt;
        }
        z = 0;
      }
    }
    return At + lt + C1;
  }
  function n(F, N, Y) {
    var Q = N.trim().split(C);
    N = Q;
    var V = Q.length, re = F.length;
    switch (re) {
      case 0:
      case 1:
        var q = 0;
        for (F = re === 0 ? "" : F[0] + " "; q < V; ++q)
          N[q] = r(F, N[q], Y).trim();
        break;
      default:
        var he = q = 0;
        for (N = []; q < V; ++q)
          for (var me = 0; me < re; ++me)
            N[he++] = r(F[me] + " ", Q[q], Y).trim();
    }
    return N;
  }
  function r(F, N, Y) {
    var Q = N.charCodeAt(0);
    switch (33 > Q && (Q = (N = N.trim()).charCodeAt(0)), Q) {
      case 38:
        return N.replace(_, "$1" + F.trim());
      case 58:
        return F.trim() + N.replace(_, "$1" + F.trim());
      default:
        if (0 < 1 * Y && 0 < N.indexOf("\f"))
          return N.replace(_, (F.charCodeAt(0) === 58 ? "" : "$1") + F.trim());
    }
    return F + N;
  }
  function a(F, N, Y, Q) {
    var V = F + ";", re = 2 * N + 3 * Y + 4 * Q;
    if (re === 944) {
      F = V.indexOf(":", 9) + 1;
      var q = V.substring(F, V.length - 1).trim();
      return q = V.substring(0, F).trim() + q + ";", $ === 1 || $ === 2 && i(q, 1) ? "-webkit-" + q + q : q;
    }
    if ($ === 0 || $ === 2 && !i(V, 1))
      return V;
    switch (re) {
      case 1015:
        return V.charCodeAt(10) === 97 ? "-webkit-" + V + V : V;
      case 951:
        return V.charCodeAt(3) === 116 ? "-webkit-" + V + V : V;
      case 963:
        return V.charCodeAt(5) === 110 ? "-webkit-" + V + V : V;
      case 1009:
        if (V.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + V + V;
      case 978:
        return "-webkit-" + V + "-moz-" + V + V;
      case 1019:
      case 983:
        return "-webkit-" + V + "-moz-" + V + "-ms-" + V + V;
      case 883:
        if (V.charCodeAt(8) === 45)
          return "-webkit-" + V + V;
        if (0 < V.indexOf("image-set(", 11))
          return V.replace(I, "$1-webkit-$2") + V;
        break;
      case 932:
        if (V.charCodeAt(4) === 45)
          switch (V.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + V.replace("-grow", "") + "-webkit-" + V + "-ms-" + V.replace("grow", "positive") + V;
            case 115:
              return "-webkit-" + V + "-ms-" + V.replace("shrink", "negative") + V;
            case 98:
              return "-webkit-" + V + "-ms-" + V.replace("basis", "preferred-size") + V;
          }
        return "-webkit-" + V + "-ms-" + V + V;
      case 964:
        return "-webkit-" + V + "-ms-flex-" + V + V;
      case 1023:
        if (V.charCodeAt(8) !== 99)
          break;
        return q = V.substring(V.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + q + "-webkit-" + V + "-ms-flex-pack" + q + V;
      case 1005:
        return m.test(V) ? V.replace(h, ":-webkit-") + V.replace(h, ":-moz-") + V : V;
      case 1e3:
        switch (q = V.substring(13).trim(), N = q.indexOf("-") + 1, q.charCodeAt(0) + q.charCodeAt(N)) {
          case 226:
            q = V.replace(b, "tb");
            break;
          case 232:
            q = V.replace(b, "tb-rl");
            break;
          case 220:
            q = V.replace(b, "lr");
            break;
          default:
            return V;
        }
        return "-webkit-" + V + "-ms-" + q + V;
      case 1017:
        if (V.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (N = (V = F).length - 10, q = (V.charCodeAt(N) === 33 ? V.substring(0, N) : V).substring(F.indexOf(":", 7) + 1).trim(), re = q.charCodeAt(0) + (q.charCodeAt(7) | 0)) {
          case 203:
            if (111 > q.charCodeAt(8))
              break;
          case 115:
            V = V.replace(q, "-webkit-" + q) + ";" + V;
            break;
          case 207:
          case 102:
            V = V.replace(q, "-webkit-" + (102 < re ? "inline-" : "") + "box") + ";" + V.replace(q, "-webkit-" + q) + ";" + V.replace(q, "-ms-" + q + "box") + ";" + V;
        }
        return V + ";";
      case 938:
        if (V.charCodeAt(5) === 45)
          switch (V.charCodeAt(6)) {
            case 105:
              return q = V.replace("-items", ""), "-webkit-" + V + "-webkit-box-" + q + "-ms-flex-" + q + V;
            case 115:
              return "-webkit-" + V + "-ms-flex-item-" + V.replace(O, "") + V;
            default:
              return "-webkit-" + V + "-ms-flex-line-pack" + V.replace("align-content", "").replace(O, "") + V;
          }
        break;
      case 973:
      case 989:
        if (V.charCodeAt(3) !== 45 || V.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (L.test(F) === !0)
          return (q = F.substring(F.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(F.replace("stretch", "fill-available"), N, Y, Q).replace(":fill-available", ":stretch") : V.replace(q, "-webkit-" + q) + V.replace(q, "-moz-" + q.replace("fill-", "")) + V;
        break;
      case 962:
        if (V = "-webkit-" + V + (V.charCodeAt(5) === 102 ? "-ms-" + V : "") + V, Y + Q === 211 && V.charCodeAt(13) === 105 && 0 < V.indexOf("transform", 10))
          return V.substring(0, V.indexOf(";", 27) + 1).replace(f, "$1-webkit-$2") + V;
    }
    return V;
  }
  function i(F, N) {
    var Y = F.indexOf(N === 1 ? ":" : "{"), Q = F.substring(0, N !== 3 ? Y : 10);
    return Y = F.substring(Y + 1, F.length - 1), W(N !== 2 ? Q : Q.replace(A, "$1"), Y, N);
  }
  function o(F, N) {
    var Y = a(N, N.charCodeAt(0), N.charCodeAt(1), N.charCodeAt(2));
    return Y !== N + ";" ? Y.replace(P, " or ($1)").substring(4) : "(" + N + ")";
  }
  function s(F, N, Y, Q, V, re, q, he, me, Ne) {
    for (var K = 0, Ee = N, J; K < G; ++K)
      switch (J = Z[K].call(u, F, Ee, Y, Q, V, re, q, he, me, Ne)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          Ee = J;
      }
    if (Ee !== N)
      return Ee;
  }
  function l(F) {
    switch (F) {
      case void 0:
      case null:
        G = Z.length = 0;
        break;
      default:
        if (typeof F == "function")
          Z[G++] = F;
        else if (typeof F == "object")
          for (var N = 0, Y = F.length; N < Y; ++N)
            l(F[N]);
        else
          j = !!F | 0;
    }
    return l;
  }
  function c(F) {
    return F = F.prefix, F !== void 0 && (W = null, F ? typeof F != "function" ? $ = 1 : ($ = 2, W = F) : $ = 0), c;
  }
  function u(F, N) {
    var Y = F;
    if (33 > Y.charCodeAt(0) && (Y = Y.trim()), T = Y, Y = [T], 0 < G) {
      var Q = s(-1, N, Y, Y, U, D, 0, 0, 0, 0);
      Q !== void 0 && typeof Q == "string" && (N = Q);
    }
    var V = t(ee, Y, N, 0, 0);
    return 0 < G && (Q = s(-2, V, Y, Y, U, D, V.length, 0, 0, 0), Q !== void 0 && (V = Q)), T = "", z = 0, D = U = 1, V;
  }
  var d = /^\0+/g, p = /[\0\r\f]/g, h = /: */g, m = /zoo|gra/, f = /([,: ])(transform)/g, C = /,\r+?/g, _ = /([\t\r\n ])*\f?&/g, v = /@(k\w+)\s*(\S*)\s*/, w = /::(place)/g, k = /:(read-only)/g, b = /[svh]\w+-[tblr]{2}/, S = /\(\s*(.*)\s*\)/g, P = /([\s\S]*?);/g, O = /-self|flex-/g, A = /[^]*?(:[rp][el]a[\w-]+)[^]*/, L = /stretch|:\s*\w+\-(?:conte|avail)/, I = /([^-])(image-set\()/, D = 1, U = 1, z = 0, $ = 1, ee = [], Z = [], G = 0, W = null, j = 0, T = "";
  return u.use = l, u.set = c, e !== void 0 && c(e), u;
}
var Nq = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function jq(e) {
  var t = {};
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Rq = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, ph = jq(
  function(e) {
    return Rq.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Hl = { exports: {} }, Vt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hh;
function Dq() {
  if (hh)
    return Vt;
  hh = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
  function w(b) {
    if (typeof b == "object" && b !== null) {
      var S = b.$$typeof;
      switch (S) {
        case t:
          switch (b = b.type, b) {
            case l:
            case c:
            case r:
            case i:
            case a:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case u:
                case m:
                case h:
                case o:
                  return b;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function k(b) {
    return w(b) === c;
  }
  return Vt.AsyncMode = l, Vt.ConcurrentMode = c, Vt.ContextConsumer = s, Vt.ContextProvider = o, Vt.Element = t, Vt.ForwardRef = u, Vt.Fragment = r, Vt.Lazy = m, Vt.Memo = h, Vt.Portal = n, Vt.Profiler = i, Vt.StrictMode = a, Vt.Suspense = d, Vt.isAsyncMode = function(b) {
    return k(b) || w(b) === l;
  }, Vt.isConcurrentMode = k, Vt.isContextConsumer = function(b) {
    return w(b) === s;
  }, Vt.isContextProvider = function(b) {
    return w(b) === o;
  }, Vt.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, Vt.isForwardRef = function(b) {
    return w(b) === u;
  }, Vt.isFragment = function(b) {
    return w(b) === r;
  }, Vt.isLazy = function(b) {
    return w(b) === m;
  }, Vt.isMemo = function(b) {
    return w(b) === h;
  }, Vt.isPortal = function(b) {
    return w(b) === n;
  }, Vt.isProfiler = function(b) {
    return w(b) === i;
  }, Vt.isStrictMode = function(b) {
    return w(b) === a;
  }, Vt.isSuspense = function(b) {
    return w(b) === d;
  }, Vt.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === c || b === i || b === a || b === d || b === p || typeof b == "object" && b !== null && (b.$$typeof === m || b.$$typeof === h || b.$$typeof === o || b.$$typeof === s || b.$$typeof === u || b.$$typeof === C || b.$$typeof === _ || b.$$typeof === v || b.$$typeof === f);
  }, Vt.typeOf = w, Vt;
}
var Bt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mh;
function Iq() {
  return mh || (mh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, v = e ? Symbol.for("react.scope") : 60119;
    function w(K) {
      return typeof K == "string" || typeof K == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      K === r || K === c || K === i || K === a || K === d || K === p || typeof K == "object" && K !== null && (K.$$typeof === m || K.$$typeof === h || K.$$typeof === o || K.$$typeof === s || K.$$typeof === u || K.$$typeof === C || K.$$typeof === _ || K.$$typeof === v || K.$$typeof === f);
    }
    function k(K) {
      if (typeof K == "object" && K !== null) {
        var Ee = K.$$typeof;
        switch (Ee) {
          case t:
            var J = K.type;
            switch (J) {
              case l:
              case c:
              case r:
              case i:
              case a:
              case d:
                return J;
              default:
                var te = J && J.$$typeof;
                switch (te) {
                  case s:
                  case u:
                  case m:
                  case h:
                  case o:
                    return te;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var b = l, S = c, P = s, O = o, A = t, L = u, I = r, D = m, U = h, z = n, $ = i, ee = a, Z = d, G = !1;
    function W(K) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(K) || k(K) === l;
    }
    function j(K) {
      return k(K) === c;
    }
    function T(K) {
      return k(K) === s;
    }
    function F(K) {
      return k(K) === o;
    }
    function N(K) {
      return typeof K == "object" && K !== null && K.$$typeof === t;
    }
    function Y(K) {
      return k(K) === u;
    }
    function Q(K) {
      return k(K) === r;
    }
    function V(K) {
      return k(K) === m;
    }
    function re(K) {
      return k(K) === h;
    }
    function q(K) {
      return k(K) === n;
    }
    function he(K) {
      return k(K) === i;
    }
    function me(K) {
      return k(K) === a;
    }
    function Ne(K) {
      return k(K) === d;
    }
    Bt.AsyncMode = b, Bt.ConcurrentMode = S, Bt.ContextConsumer = P, Bt.ContextProvider = O, Bt.Element = A, Bt.ForwardRef = L, Bt.Fragment = I, Bt.Lazy = D, Bt.Memo = U, Bt.Portal = z, Bt.Profiler = $, Bt.StrictMode = ee, Bt.Suspense = Z, Bt.isAsyncMode = W, Bt.isConcurrentMode = j, Bt.isContextConsumer = T, Bt.isContextProvider = F, Bt.isElement = N, Bt.isForwardRef = Y, Bt.isFragment = Q, Bt.isLazy = V, Bt.isMemo = re, Bt.isPortal = q, Bt.isProfiler = he, Bt.isStrictMode = me, Bt.isSuspense = Ne, Bt.isValidElementType = w, Bt.typeOf = k;
  }()), Bt;
}
process.env.NODE_ENV === "production" ? Hl.exports = Dq() : Hl.exports = Iq();
var Hq = Hl.exports, rc = Hq, Fq = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, Vq = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, Bq = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, u_ = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, nc = {};
nc[rc.ForwardRef] = Bq;
nc[rc.Memo] = u_;
function fh(e) {
  return rc.isMemo(e) ? u_ : nc[e.$$typeof] || Fq;
}
var zq = Object.defineProperty, Gq = Object.getOwnPropertyNames, Ch = Object.getOwnPropertySymbols, Uq = Object.getOwnPropertyDescriptor, Zq = Object.getPrototypeOf, gh = Object.prototype;
function d_(e, t, n) {
  if (typeof t != "string") {
    if (gh) {
      var r = Zq(t);
      r && r !== gh && d_(e, r, n);
    }
    var a = Gq(t);
    Ch && (a = a.concat(Ch(t)));
    for (var i = fh(e), o = fh(t), s = 0; s < a.length; ++s) {
      var l = a[s];
      if (!Vq[l] && !(n && n[l]) && !(o && o[l]) && !(i && i[l])) {
        var c = Uq(t, l);
        try {
          zq(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var Kq = d_;
const $q = /* @__PURE__ */ Js(Kq);
function Xn() {
  return Xn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xn.apply(this, arguments);
}
function Wq(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var yh = function(e, t) {
  for (var n = [e[0]], r = 0, a = t.length; r < a; r += 1)
    n.push(t[r], e[r + 1]);
  return n;
}, ac = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !tc.typeOf(e);
}, g5 = Object.freeze([]), q2 = Object.freeze({});
function M9(e) {
  return typeof e == "function";
}
function ic(e) {
  return (process.env.NODE_ENV !== "production" ? typeof e == "string" && e : !1) || // $FlowFixMe
  e.displayName || // $FlowFixMe
  e.name || "Component";
}
function Yq(e) {
  return typeof e == "function" && !(e.prototype && e.prototype.isReactComponent);
}
function oc(e) {
  return e && typeof e.styledComponentId == "string";
}
var fo = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", p_ = "active", h_ = "data-styled-version", m_ = "5.1.1", sc = `/*!sc*/
`, lc = typeof window < "u" && "HTMLElement" in window, qq = typeof SC_DISABLE_SPEEDY == "boolean" && SC_DISABLE_SPEEDY || typeof process < "u" && (process.env.REACT_APP_SC_DISABLE_SPEEDY || process.env.SC_DISABLE_SPEEDY) || process.env.NODE_ENV !== "production", Jq = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, Xq = {
  1: `Cannot create styled-component for component: %s.

`,
  2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`,
  3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`,
  4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`,
  5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`,
  6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`,
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: `ThemeProvider: Please make your "theme" prop an object.

`,
  9: "Missing document `<head>`\n\n",
  10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`,
  11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`,
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`,
  14: `ThemeProvider: "theme" prop is required.

`,
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`,
  17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`
}, Qq = process.env.NODE_ENV !== "production" ? Xq : {};
function eJ() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)
    t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
  return t.forEach(function(a) {
    e = e.replace(/%[a-z]/, a);
  }), e;
}
function Co(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + e + " for more information." + (n.length > 0 ? " Additional arguments: " + n.join(", ") : "")) : new Error(eJ.apply(void 0, [Qq[e]].concat(n)).trim());
}
var tJ = 1, rJ = function(t) {
  for (var n = t.childNodes, r = n.length; r >= 0; r--) {
    var a = n[r];
    if (a && a.nodeType === tJ && a.hasAttribute(fo))
      return a;
  }
}, f_ = function(t) {
  var n = document.head, r = t || n, a = document.createElement("style"), i = rJ(r), o = i !== void 0 ? i.nextSibling : null;
  a.setAttribute(fo, p_), a.setAttribute(h_, m_);
  var s = Jq();
  return s && a.setAttribute("nonce", s), r.insertBefore(a, o), a;
}, nJ = function(t) {
  if (t.sheet)
    return t.sheet;
  for (var n = document, r = n.styleSheets, a = 0, i = r.length; a < i; a++) {
    var o = r[a];
    if (o.ownerNode === t)
      return o;
  }
  Co(17);
}, aJ = function(t) {
  var n = t.isServer, r = t.useCSSOMInjection, a = t.target;
  return n ? new sJ(a) : r ? new iJ(a) : new oJ(a);
}, iJ = /* @__PURE__ */ function() {
  function e(n) {
    var r = this.element = f_(n);
    r.appendChild(document.createTextNode("")), this.sheet = nJ(r), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(r, a) {
    try {
      return this.sheet.insertRule(a, r), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(r) {
    this.sheet.deleteRule(r), this.length--;
  }, t.getRule = function(r) {
    var a = this.sheet.cssRules[r];
    return a !== void 0 && typeof a.cssText == "string" ? a.cssText : "";
  }, e;
}(), oJ = /* @__PURE__ */ function() {
  function e(n) {
    var r = this.element = f_(n);
    this.nodes = r.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(r, a) {
    if (r <= this.length && r >= 0) {
      var i = document.createTextNode(a), o = this.nodes[r];
      return this.element.insertBefore(i, o || null), this.length++, !0;
    } else
      return !1;
  }, t.deleteRule = function(r) {
    this.element.removeChild(this.nodes[r]), this.length--;
  }, t.getRule = function(r) {
    return r < this.length ? this.nodes[r].textContent : "";
  }, e;
}(), sJ = /* @__PURE__ */ function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(r, a) {
    return r <= this.length ? (this.rules.splice(r, 0, a), this.length++, !0) : !1;
  }, t.deleteRule = function(r) {
    this.rules.splice(r, 1), this.length--;
  }, t.getRule = function(r) {
    return r < this.length ? this.rules[r] : "";
  }, e;
}(), lJ = function(t) {
  return new cJ(t);
}, vh = 512, cJ = /* @__PURE__ */ function() {
  function e(n) {
    this.groupSizes = new Uint32Array(vh), this.length = vh, this.tag = n;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(r) {
    for (var a = 0, i = 0; i < r; i++)
      a += this.groupSizes[i];
    return a;
  }, t.insertRules = function(r, a) {
    if (r >= this.groupSizes.length) {
      for (var i = this.groupSizes, o = i.length, s = o; r >= s; )
        s <<= 1, s < 0 && Co(16, "" + r);
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(i), this.length = s;
      for (var l = o; l < s; l++)
        this.groupSizes[l] = 0;
    }
    for (var c = this.indexOfGroup(r + 1), u = 0, d = a.length; u < d; u++)
      this.tag.insertRule(c, a[u]) && (this.groupSizes[r]++, c++);
  }, t.clearGroup = function(r) {
    if (r < this.length) {
      var a = this.groupSizes[r], i = this.indexOfGroup(r), o = i + a;
      this.groupSizes[r] = 0;
      for (var s = i; s < o; s++)
        this.tag.deleteRule(i);
    }
  }, t.getGroup = function(r) {
    var a = "";
    if (r >= this.length || this.groupSizes[r] === 0)
      return a;
    for (var i = this.groupSizes[r], o = this.indexOfGroup(r), s = o + i, l = o; l < s; l++)
      a += "" + this.tag.getRule(l) + sc;
    return a;
  }, e;
}(), uJ = 1 << 30, k6 = /* @__PURE__ */ new Map(), cc = /* @__PURE__ */ new Map(), Fl = 1, W9 = function(t) {
  if (k6.has(t))
    return k6.get(t);
  var n = Fl++;
  return process.env.NODE_ENV !== "production" && ((n | 0) < 0 || n > uJ) && Co(16, "" + n), k6.set(t, n), cc.set(n, t), n;
}, dJ = function(t) {
  return cc.get(t);
}, pJ = function(t, n) {
  n >= Fl && (Fl = n + 1), k6.set(t, n), cc.set(n, t);
}, hJ = "style[" + fo + "][" + h_ + '="' + m_ + '"]', mJ = new RegExp("^" + fo + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), fJ = function(t) {
  for (var n = t.getTag(), r = n.length, a = "", i = 0; i < r; i++) {
    var o = dJ(i);
    if (o !== void 0) {
      var s = t.names.get(o), l = n.getGroup(i);
      if (!(s === void 0 || l.length === 0)) {
        var c = fo + ".g" + i + '[id="' + o + '"]', u = "";
        s !== void 0 && s.forEach(function(d) {
          d.length > 0 && (u += d + ",");
        }), a += "" + l + c + '{content:"' + u + '"}' + sc;
      }
    }
  }
  return a;
}, CJ = function(t, n, r) {
  for (var a = r.split(","), i, o = 0, s = a.length; o < s; o++)
    (i = a[o]) && t.registerName(n, i);
}, gJ = function(t, n) {
  for (var r = n.innerHTML.split(sc), a = [], i = 0, o = r.length; i < o; i++) {
    var s = r[i].trim();
    if (s) {
      var l = s.match(mJ);
      if (l) {
        var c = parseInt(l[1], 10) | 0, u = l[2];
        c !== 0 && (pJ(u, c), CJ(t, u, l[3]), t.getTag().insertRules(c, a)), a.length = 0;
      } else
        a.push(s);
    }
  }
}, yJ = function(t) {
  for (var n = document.querySelectorAll(hJ), r = 0, a = n.length; r < a; r++) {
    var i = n[r];
    i && i.getAttribute(fo) !== p_ && (gJ(t, i), i.parentNode && i.parentNode.removeChild(i));
  }
}, bh = lc, _h = {
  isServer: !lc,
  useCSSOMInjection: !qq
}, C_ = /* @__PURE__ */ function() {
  e.registerId = function(r) {
    return W9(r);
  };
  function e(n, r, a) {
    n === void 0 && (n = _h), r === void 0 && (r = {}), this.options = Xn({}, _h, {}, n), this.gs = r, this.names = new Map(a), !this.options.isServer && lc && bh && (bh = !1, yJ(this));
  }
  var t = e.prototype;
  return t.reconstructWithOptions = function(r) {
    return new e(Xn({}, this.options, {}, r), this.gs, this.names);
  }, t.allocateGSInstance = function(r) {
    return this.gs[r] = (this.gs[r] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = lJ(aJ(this.options)));
  }, t.hasNameForId = function(r, a) {
    return this.names.has(r) && this.names.get(r).has(a);
  }, t.registerName = function(r, a) {
    if (W9(r), this.names.has(r))
      this.names.get(r).add(a);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(a), this.names.set(r, i);
    }
  }, t.insertRules = function(r, a, i) {
    this.registerName(r, a), this.getTag().insertRules(W9(r), i);
  }, t.clearNames = function(r) {
    this.names.has(r) && this.names.get(r).clear();
  }, t.clearRules = function(r) {
    this.getTag().clearGroup(W9(r)), this.clearNames(r);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return fJ(this);
  }, e;
}(), g_ = 5381, Si = function(t, n) {
  for (var r = n.length; r; )
    t = t * 33 ^ n.charCodeAt(--r);
  return t;
}, y_ = function(t) {
  return Si(g_, t);
};
function vJ(e) {
  var t = "/*|*/", n = t + "}";
  function r(a) {
    if (a)
      try {
        e(a + "}");
      } catch {
      }
  }
  return function(i, o, s, l, c, u, d, p, h, m) {
    switch (i) {
      case 1:
        if (h === 0 && o.charCodeAt(0) === 64)
          return e(o + ";"), "";
        break;
      case 2:
        if (p === 0)
          return o + t;
        break;
      case 3:
        switch (p) {
          case 102:
          case 112:
            return e(s[0] + o), "";
          default:
            return o + (m === 0 ? t : "");
        }
      case -2:
        o.split(n).forEach(r);
    }
  };
}
var bJ = /^\s*\/\/.*$/gm;
function _J(e) {
  var t = q2, n = t.options, r = n === void 0 ? q2 : n, a = t.plugins, i = a === void 0 ? g5 : a, o = new Oq(r), s = [], l = function(_) {
    if (_ === -2) {
      var v = s;
      return s = [], v;
    }
  }, c = vJ(function(C) {
    s.push(C);
  }), u, d, p, h = function(_, v, w) {
    return (
      // the first self-ref is always untouched
      v > 0 && // there should be at least two self-refs to do a replacement (.b > .b)
      w.slice(0, v).indexOf(d) !== -1 && // no consecutive self refs (.b.b); that is a precedence boost and treated differently
      w.slice(v - d.length, v) !== d ? "." + u : _
    );
  }, m = function(_, v, w) {
    _ === 2 && w.length && w[0].lastIndexOf(d) > 0 && (w[0] = w[0].replace(p, h));
  };
  o.use([].concat(i, [m, c, l]));
  function f(C, _, v, w) {
    w === void 0 && (w = "&");
    var k = C.replace(bJ, ""), b = _ && v ? v + " " + _ + " { " + k + " }" : k;
    return u = w, d = _, p = new RegExp("\\" + d + "\\b", "g"), o(v || !_ ? "" : _, b);
  }
  return f.hash = i.length ? i.reduce(function(C, _) {
    return _.name || Co(15), Si(C, _.name);
  }, g_).toString() : "", f;
}
var v_ = M.createContext();
v_.Consumer;
var b_ = M.createContext();
b_.Consumer;
var wJ = new C_(), __ = _J();
function xJ() {
  return Ue(v_) || wJ;
}
function SJ() {
  return Ue(b_) || __;
}
var kJ = /* @__PURE__ */ function() {
  function e(n, r) {
    var a = this;
    this.inject = function(i) {
      i.hasNameForId(a.id, a.name) || i.insertRules(a.id, a.name, __.apply(void 0, a.stringifyArgs));
    }, this.toString = function() {
      return Co(12, String(a.name));
    }, this.name = n, this.id = "sc-keyframes-" + n, this.stringifyArgs = r;
  }
  var t = e.prototype;
  return t.getName = function() {
    return this.name;
  }, e;
}(), MJ = /([A-Z])/g, PJ = /^ms-/;
function wh(e) {
  return e.replace(MJ, "-$1").toLowerCase().replace(PJ, "-ms-");
}
function EJ(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !(e in Nq) ? t + "px" : String(t).trim();
}
var w_ = function(t) {
  return t == null || t === !1 || t === "";
}, TJ = function e(t, n) {
  var r = [], a = Object.keys(t);
  return a.forEach(function(i) {
    if (!w_(t[i])) {
      if (ac(t[i]))
        return r.push.apply(r, e(t[i], i)), r;
      if (M9(t[i]))
        return r.push(wh(i) + ":", t[i], ";"), r;
      r.push(wh(i) + ": " + EJ(i, t[i]) + ";");
    }
    return r;
  }), n ? [n + " {"].concat(r, ["}"]) : r;
};
function Yi(e, t, n) {
  if (Array.isArray(e)) {
    for (var r = [], a = 0, i = e.length, o; a < i; a += 1)
      o = Yi(e[a], t, n), o !== "" && (Array.isArray(o) ? r.push.apply(r, o) : r.push(o));
    return r;
  }
  if (w_(e))
    return "";
  if (oc(e))
    return "." + e.styledComponentId;
  if (M9(e))
    if (Yq(e) && t) {
      var s = e(t);
      return process.env.NODE_ENV !== "production" && tc.isElement(s) && console.warn(ic(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), Yi(s, t, n);
    } else
      return e;
  return e instanceof kJ ? n ? (e.inject(n), e.getName()) : e : ac(e) ? TJ(e) : e.toString();
}
function Vl(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return M9(e) || ac(e) ? Yi(yh(g5, [e].concat(n))) : n.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : Yi(yh(e, n));
}
function Bl(e, t, n) {
  if (n === void 0 && (n = q2), !tc.isValidElementType(t))
    return Co(1, String(t));
  var r = function() {
    return e(t, n, Vl.apply(void 0, arguments));
  };
  return r.withConfig = function(a) {
    return Bl(e, t, Xn({}, n, {}, a));
  }, r.attrs = function(a) {
    return Bl(e, t, Xn({}, n, {
      attrs: Array.prototype.concat(n.attrs, a).filter(Boolean)
    }));
  }, r;
}
var zl = function(t) {
  return typeof t == "function" || typeof t == "object" && t !== null && !Array.isArray(t);
}, LJ = function(t) {
  return t !== "__proto__" && t !== "constructor" && t !== "prototype";
};
function AJ(e, t, n) {
  var r = e[n];
  zl(t) && zl(r) ? x_(r, t) : e[n] = t;
}
function x_(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  for (var a = 0, i = n; a < i.length; a++) {
    var o = i[a];
    if (zl(o))
      for (var s in o)
        LJ(s) && AJ(e, o[s], s);
  }
  return e;
}
var OJ = /(a)(d)/gi, Y9 = 52, xh = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function Gl(e) {
  var t = "", n;
  for (n = Math.abs(e); n > Y9; n = n / Y9 | 0)
    t = xh(n % Y9) + t;
  return (xh(n % Y9) + t).replace(OJ, "$1-$2");
}
function NJ(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (M9(n) && !oc(n))
      return !1;
  }
  return !0;
}
var jJ = /* @__PURE__ */ function() {
  function e(n, r) {
    this.rules = n, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && NJ(n), this.componentId = r, this.baseHash = y_(r), C_.registerId(r);
  }
  var t = e.prototype;
  return t.generateAndInjectStyles = function(r, a, i) {
    var o = this.componentId;
    if (this.isStatic && !i.hash) {
      if (this.staticRulesId && a.hasNameForId(o, this.staticRulesId))
        return this.staticRulesId;
      var s = Yi(this.rules, r, a).join(""), l = Gl(Si(this.baseHash, s.length) >>> 0);
      if (!a.hasNameForId(o, l)) {
        var c = i(s, "." + l, void 0, o);
        a.insertRules(o, l, c);
      }
      return this.staticRulesId = l, l;
    } else {
      for (var u = this.rules.length, d = Si(this.baseHash, i.hash), p = "", h = 0; h < u; h++) {
        var m = this.rules[h];
        if (typeof m == "string")
          p += m, process.env.NODE_ENV !== "production" && (d = Si(d, m + h));
        else {
          var f = Yi(m, r, a), C = Array.isArray(f) ? f.join("") : f;
          d = Si(d, C + h), p += C;
        }
      }
      var _ = Gl(d >>> 0);
      if (!a.hasNameForId(o, _)) {
        var v = i(p, "." + _, void 0, o);
        a.insertRules(o, _, v);
      }
      return _;
    }
  }, e;
}(), Sh = 200, RJ = function(e, t) {
  var n = {}, r = !1;
  return function(a) {
    if (!r && (n[a] = !0, Object.keys(n).length >= Sh)) {
      var i = t ? ' with the id of "' + t + '"' : "";
      console.warn("Over " + Sh + " classes were generated for component " + e + i + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), r = !0, n = {};
    }
  };
}, DJ = /invalid hook call/i, Q7 = /* @__PURE__ */ new Set(), IJ = function(t, n) {
  if (process.env.NODE_ENV !== "production") {
    var r = n ? ' with the id of "' + n + '"' : "", a = "The component " + t + r + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`;
    try {
      be(), Q7.has(a) || (console.warn(a), Q7.add(a));
    } catch (i) {
      DJ.test(i.message) && Q7.delete(a);
    }
  }
}, HJ = function(e, t, n) {
  return n === void 0 && (n = q2), e.theme !== n.theme && e.theme || t || n.theme;
}, FJ = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, VJ = /(^-|-$)/g;
function Ul(e) {
  return e.replace(FJ, "-").replace(VJ, "");
}
function y5(e) {
  return typeof e == "string" && (process.env.NODE_ENV !== "production" ? e.charAt(0) === e.charAt(0).toLowerCase() : !0);
}
function BJ(e) {
  return y5(e) ? "styled." + e : "Styled(" + ic(e) + ")";
}
var zJ = function(e) {
  return Gl(y_(e) >>> 0);
};
function GJ(e, t) {
  return e && t ? e + " " + t : e || t;
}
var S_ = M.createContext();
S_.Consumer;
var e0 = {};
function UJ(e, t) {
  var n = typeof e != "string" ? "sc" : Ul(e);
  e0[n] = (e0[n] || 0) + 1;
  var r = n + "-" + zJ(n + e0[n]);
  return t ? t + "-" + r : r;
}
function ZJ(e, t, n) {
  e === void 0 && (e = q2);
  var r = Xn({}, t, {
    theme: e
  }), a = {};
  return n.forEach(function(i) {
    var o = i, s;
    M9(o) && (o = o(r));
    for (s in o)
      r[s] = a[s] = s === "className" ? GJ(a[s], o[s]) : o[s];
  }), [r, a];
}
function KJ(e, t, n, r) {
  var a = xJ(), i = SJ(), o = e.isStatic && !t, s = o ? e.generateAndInjectStyles(q2, a, i) : e.generateAndInjectStyles(n, a, i);
  return $m(s), process.env.NODE_ENV !== "production" && !o && r && r(s), s;
}
function $J(e, t, n) {
  var r = e.attrs, a = e.componentStyle, i = e.defaultProps, o = e.foldedComponentIds, s = e.shouldForwardProp, l = e.styledComponentId, c = e.target;
  $m(l);
  var u = HJ(t, Ue(S_), i), d = ZJ(u || q2, t, r), p = d[0], h = d[1], m = KJ(a, r.length > 0, p, process.env.NODE_ENV !== "production" ? e.warnTooManyClasses : void 0), f = n, C = h.$as || t.$as || h.as || t.as || c, _ = y5(C), v = h !== t ? Xn({}, t, {}, h) : t, w = s || _ && ph, k = {};
  for (var b in v)
    b[0] === "$" || b === "as" || (b === "forwardedAs" ? k.as = v[b] : (!w || w(b, ph)) && (k[b] = v[b]));
  return t.style && h.style !== t.style && (k.style = Xn({}, t.style, {}, h.style)), k.className = Array.prototype.concat(o, l, m !== l ? m : null, t.className, h.className).filter(Boolean).join(" "), k.ref = f, za(C, k);
}
function k_(e, t, n) {
  var r = oc(e), a = !y5(e), i = t.displayName, o = i === void 0 ? BJ(e) : i, s = t.componentId, l = s === void 0 ? UJ(t.displayName, t.parentComponentId) : s, c = t.attrs, u = c === void 0 ? g5 : c, d = t.displayName && t.componentId ? Ul(t.displayName) + "-" + t.componentId : t.componentId || l, p = (
    // $FlowFixMe
    r && e.attrs ? Array.prototype.concat(e.attrs, u).filter(Boolean) : u
  ), h = t.shouldForwardProp;
  r && e.shouldForwardProp && (h ? h = function(v, w) {
    return (
      // $FlowFixMe
      e.shouldForwardProp(v, w) && t.shouldForwardProp(v, w)
    );
  } : h = e.shouldForwardProp);
  var m = new jJ(r ? (
    // fold the underlying StyledComponent rules up (implicit extend)
    // $FlowFixMe
    e.componentStyle.rules.concat(n)
  ) : n, d), f, C = function(v, w) {
    return $J(f, v, w);
  };
  return C.displayName = o, f = M.forwardRef(C), f.attrs = p, f.componentStyle = m, f.displayName = o, f.shouldForwardProp = h, f.foldedComponentIds = r ? (
    // $FlowFixMe
    Array.prototype.concat(e.foldedComponentIds, e.styledComponentId)
  ) : g5, f.styledComponentId = d, f.target = r ? (
    // $FlowFixMe
    e.target
  ) : e, f.withComponent = function(v) {
    var w = t.componentId, k = Wq(t, ["componentId"]), b = w && w + "-" + (y5(v) ? v : Ul(ic(v))), S = Xn({}, k, {
      attrs: p,
      componentId: b
    });
    return k_(v, S, n);
  }, Object.defineProperty(f, "defaultProps", {
    get: function() {
      return this._foldedDefaultProps;
    },
    set: function(v) {
      this._foldedDefaultProps = r ? x_({}, e.defaultProps, v) : v;
    }
  }), process.env.NODE_ENV !== "production" && (IJ(o, d), f.warnTooManyClasses = RJ(o, d)), f.toString = function() {
    return "." + f.styledComponentId;
  }, a && $q(f, e, {
    // all SC-specific things should not be hoisted
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    self: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), f;
}
var WJ = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Bs = function(t) {
  return Bl(k_, t);
};
WJ.forEach(function(e) {
  Bs[e] = Bs(e);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles not rendering properly, errors happening during rehydration process, missing theme prop, and makes your application bigger without a good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
function M_() {
  var e = k9([`
  color: #c9444d;
  font-size: 0.75rem;
  margin-top: 0.25rem;

  & {
    `, `;
  }
`]);
  return M_ = function() {
    return e;
  }, e;
}
function P_() {
  var e = k9([`
        border-color: #444bc9;
        box-shadow: #444bc9 0px 0px 0px 1px;
        `, `;
      `]);
  return P_ = function() {
    return e;
  }, e;
}
function E_() {
  var e = k9([`
        border-color: #c9444d;
        box-shadow: #c9444d 0px 0px 0px 1px;
        `, `;
      `]);
  return E_ = function() {
    return e;
  }, e;
}
function T_() {
  var e = k9([`
  align-items: center;
  background-color: white;
  border: 1px solid #bdbdbd;
  box-shadow: inset 0px 1px 2px #e5e5e5;
  border-radius: 0.2em;
  display: flex;
  height: 2.5em;
  padding: 0.4em 0.6em;

  & {
    `, `;
  }

  & {
    `, `;
  }

  & input {
    border: unset;
    margin: unset;
    padding: unset;
    outline: unset;
    font-size: inherit;

    & {
      `, `;
    }

    `, `;
  }

  & svg {
    margin-right: 0.6em;
    & {
      `, `;
    }
  }

  & input#cardNumber {
    width: 11em;
    & {
      `, `;
    }
  }

  & input#expiryDate {
    width: 4em;
    & {
      `, `;
    }
  }

  & input#cvc {
    width: 2.5em;
    & {
      `, `;
    }
  }

  & input#zip {
    width: 4em;
    & {
      `, `;
    }
  }

  `, `;
`]);
  return T_ = function() {
    return e;
  }, e;
}
function L_() {
  var e = k9([`
  display: inline-flex;
  flex-direction: column;

  & {
    `, `;
  }

  `, `;
`]);
  return L_ = function() {
    return e;
  }, e;
}
Bs.div(L_(), function(e) {
  return e.hasErrored && e.styles.fieldWrapper ? e.styles.fieldWrapper.errored : void 0;
}, function(e) {
  return e.styles.fieldWrapper ? e.styles.fieldWrapper.base : void 0;
});
Bs.div(T_(), function(e) {
  return e.hasErrored && Vl(E_(), function(t) {
    return t.styles.inputWrapper && t.styles.inputWrapper.errored;
  });
}, function(e) {
  return e.focused && Vl(P_(), function(t) {
    return t.styles.inputWrapper && t.styles.inputWrapper.focused;
  });
}, function(e) {
  return e.hasErrored && e.styles.input ? e.styles.input.errored : void 0;
}, function(e) {
  return e.styles.input && e.styles.input.base;
}, function(e) {
  return e.styles.cardImage;
}, function(e) {
  return e.styles.input && e.styles.input.cardNumber;
}, function(e) {
  return e.styles.input && e.styles.input.expiryDate;
}, function(e) {
  return e.styles.input && e.styles.input.cvc;
}, function(e) {
  return e.styles.input && e.styles.input.zip;
}, function(e) {
  return e.styles.inputWrapper ? e.styles.inputWrapper.base : void 0;
});
Bs.div(M_(), function(e) {
  return e.styles.errorText ? e.styles.errorText.base : void 0;
});
var YJ = M.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, M.createElement("g", {
  id: "New-Icons",
  transform: "translate(-80.000000, -280.000000)",
  fillRule: "nonzero"
}, M.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, M.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, M.createElement("g", {
  id: "Visa",
  transform: "translate(40.000000, 0.000000)"
}, M.createElement("rect", {
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF",
  x: "0.25",
  y: "0.25",
  width: "23.5",
  height: "15.5",
  rx: "2"
}), M.createElement("path", {
  d: "M2.78773262,5.91443732 C2.26459089,5.62750595 1.6675389,5.39673777 1,5.23659312 L1.0280005,5.1118821 L3.76497922,5.1118821 C4.13596254,5.12488556 4.43699113,5.23650585 4.53494636,5.63071135 L5.12976697,8.46659052 L5.31198338,9.32072617 L6.97796639,5.1118821 L8.77678896,5.1118821 L6.10288111,11.2775284 L4.30396552,11.2775284 L2.78773262,5.91443732 L2.78773262,5.91443732 Z M10.0999752,11.2840738 L8.39882877,11.2840738 L9.46284763,5.1118821 L11.163901,5.1118821 L10.0999752,11.2840738 Z M16.2667821,5.26277458 L16.0354292,6.59558538 L15.881566,6.53004446 C15.5737466,6.40524617 15.1674138,6.28053516 14.6143808,6.29371316 C13.942741,6.29371316 13.6415263,6.56277129 13.6345494,6.82545859 C13.6345494,7.11441463 13.998928,7.3048411 14.5939153,7.58725177 C15.5740257,8.02718756 16.0286384,8.56556562 16.0218476,9.26818871 C16.0080799,10.5486366 14.8460128,11.376058 13.0610509,11.376058 C12.2978746,11.3694253 11.5627918,11.2180965 11.163808,11.0475679 L11.4018587,9.66204513 L11.6258627,9.76066195 C12.1788958,9.99070971 12.5428092,10.0889775 13.221984,10.0889775 C13.7117601,10.0889775 14.2368857,9.89837643 14.2435835,9.48488392 C14.2435835,9.21565125 14.0198586,9.01850486 13.3617074,8.7164581 C12.717789,8.42086943 11.8568435,7.92848346 11.8707973,7.04197926 C11.8780532,5.84042483 13.0610509,5 14.7409877,5 C15.3990458,5 15.9312413,5.13788902 16.2667821,5.26277458 Z M18.5277524,9.0974856 L19.941731,9.0974856 C19.8717762,8.78889347 19.549631,7.31147374 19.549631,7.31147374 L19.4307452,6.77964104 C19.3467437,7.00942698 19.1998574,7.38373457 19.2069273,7.37055657 C19.2069273,7.37055657 18.6678479,8.74290137 18.5277524,9.0974856 Z M20.6276036,5.1118821 L22,11.2839865 L20.4249023,11.2839865 C20.4249023,11.2839865 20.2707601,10.5748181 20.221922,10.3581228 L18.0377903,10.3581228 C17.9746264,10.5221933 17.6807607,11.2839865 17.6807607,11.2839865 L15.8957988,11.2839865 L18.4226343,5.62399144 C18.5977072,5.22341512 18.9059917,5.1118821 19.3117663,5.1118821 L20.6276036,5.1118821 L20.6276036,5.1118821 Z",
  id: "Shape",
  fill: "#171E6C"
})))))), qJ = M.createElement("g", {
  fill: "none"
}, M.createElement("path", {
  d: "m4.54588254.00006676h5.79377466c.8087588 0 1.3117793.72566459 1.1231113 1.61890981l-2.69741608 12.74856503c-.19036262.8901361-1.00010994 1.6164225-1.80943362 1.6164225h-5.79320976c-.80762905 0-1.31177937-.7262864-1.12311135-1.6164225l2.69854581-12.74856503c.18866803-.89324522.9979917-1.61890981 1.80773904-1.61890981",
  fill: "#dd2423"
}), M.createElement("path", {
  d: "m9.85756516.00006676h6.66269264c.8086174 0 .4439911.72566459.2537697 1.61890981l-2.6969924 12.74856503c-.1892329.8901361-.1302036 1.6164225-.9405158 1.6164225h-6.66269248c-.81031221 0-1.31177939-.7262864-1.12141672-1.6164225l2.69685116-12.74856503c.19149238-.89324522.99912144-1.61890981 1.8083039-1.61890981",
  fill: "#16315e"
}), M.createElement("path", {
  d: "m16.2559813.00006676h5.7937745c.8098886 0 1.3129092.72566459 1.1226878 1.61890981l-2.6969924 12.74856503c-.1903626.8901361-1.0006749 1.6164225-1.8104222 1.6164225h-5.7910915c-.8103122 0-1.3129091-.7262864-1.1231113-1.6164225l2.697416-12.74856503c.1886681-.89324522.9974268-1.61890981 1.8077391-1.61890981",
  fill: "#036862"
}), M.createElement("path", {
  d: "m6.05901135 4.08561434c-.59580116.00668457-.77175951 0-.8279645-.01461278-.02160646.11301588-.42365577 2.15460824-.42478553 2.15631824-.08656699.4130443-.14955043.7074763-.36349659.89759795-.12144798.1105286-.26323144.1638497-.42760986.1638497-.26421996 0-.41814822-.1444178-.44399122-.41832975l-.00494264-.09405035s.08049458-.55326485.08049458-.55637395c0 0 .42196112-1.86048711.49751306-2.10641713.00395412-.01399096.00508387-.02129736.00607239-.02798193-.82132725.00792821-.9669236 0-.97695012-.01461278-.00550753.02005371-.025843.13540142-.025843.13540142l-.43085788 2.09693437-.03699927.1778407-.07159782.5817131c0 .1725552.03078565.31339755.09207452.4324762.19629382.37760055.75622549.4341862 1.07297875.4341862.40812169 0 .79096525-.09544945 1.04967767-.26971465.44907509-.2921002.56656897-.74867195.67135315-1.15440985l.04857917-.20815445s.43467082-1.93230737.5085281-2.18367833c.00282441-.01399096.00395413-.02129736.00776704-.02798193zm1.47893982 1.55881086c-.10478422 0-.29627659.0279819-.46828081.12078865-.0624186.0352883-.12144796.07601755-.18372539.11659135l.056205-.22338905-.03078563-.03762015c-.36476761.08130305-.44639193.0921849-.78333945.14441785l-.02824374.0206755c-.03911752.3570805-.07385733.6255515-.21888878 1.32743145-.05521646.25867735-.11255121.519842-.17002718.7778975l.01553403.03280105c.34527946-.0200537.45006363-.0200537.75015309-.0146128l.02428961-.0290701c.03812903-.21499445.04307165-.2653619.12752039-.70079175.03968242-.20644445.1224365-.66006255.16324868-.8215804.07498704-.038242.14898558-.07586215.21959486-.07586215.16819135 0 .14771465.1615179.14121858.22587635-.00720213.1080413-.06849101.4609245-.13133325.76390655l-.04194194.19556255c-.02923223.14441785-.06128888.2847938-.09052111.427968l.01270966.02860375c.34033679-.0200537.44413246-.0200537.73476028-.0146128l.0341749-.0290701c.0525333-.3357831.06792611-.42563615.16113038-.9145426l.04688457-.22463265c.09108601-.43962715.13684082-.6625498.06792616-.8441214-.07286879-.2034908-.24769738-.2526146-.40826291-.2526146zm1.65214439.4602871c-.18090101.038242-.29627659.0637366-.41094606.08021485-.11368097.02005375-.22453757.038242-.39936616.06498025l-.01383941.0138355-.01270966.01103735c-.01821719.14332965-.0309269.26722735-.05507525.41288885-.02047669.150636-.05196844.3217921-.10323077.56772215-.03968243.18825615-.06015913.25385825-.08275412.32008215-.0220301.06622385-.04631967.1305823-.09094476.31572935l.01045019.0171001.00875554.01570095c.1633899-.00855005.27029237-.0146128.38016043-.01570095.10972684-.00435275.22340776 0 .39936611.00108815l.01539286-.0138355.01652257-.0152346c.02541932-.1669588.02923224-.21188535.04476626-.29334385.01539282-.0873658.04194194-.20830985.10704369-.53134565.03078568-.1517242.06510179-.30298205.09701718-.4578154.03318641-.1542115.06792612-.30609115.10097127-.45781535l-.00494263-.0183437zm.00385525-.620608c-.1643784-.10679765-.45288796-.07290845-.64706354.0746185-.19361063.14457325-.21564072.34977405-.05182718.4579708.16155403.10384405.45119334.0729085.64367421-.0758621.19318708-.14768235.21733543-.3510177.05521651-.4567272zm.99410809 2.473369c.3325698 0 .6734715-.1008904.9300657-.400297.1974235-.2428209.2879446-.60409865.3192952-.7528692.1021011-.4931037.0225949-.7233328-.0772466-.8635533-.1516687-.21375085-.4197016-.28230655-.697761-.28230655-.1672028 0-.5654392.01818825-.87654364.33391765-.22340786.22774175-.32663863.5367866-.38891601.83308405-.06284224.3018939-.13514621.84536505.31887154 1.0476122.14008884.0662239.34203141.08441215.47223481.08441215zm-.0259841-1.10948335c.0766817-.3734032.1672028-.6868008.3982364-.6868008.1810422 0 .1941755.23318275.1136809.6078296-.0144042.0831685-.0804945.3923688-.1698859.5240393-.0624186.09715945-.1362759.15607695-.2179003.15607695-.0242896 0-.1687562 0-.1710157-.23613635-.0011297-.11659135.0204767-.23567.0468846-.3650087zm2.1066988 1.06146325.0259841-.0290701c.0368581-.21499445.0429305-.2655174.1245549-.70079175.0408121-.20644445.1252608-.66006255.1649433-.82158045.0751282-.0383974.1478558-.07601755.2207245-.07601755.1670616 0 .1467262.1615179.140089.2258763-.0060725.1081968-.0673613.4609245-.1313334.76390655l-.0396824.1955626c-.030362.14457325-.0634071.2847938-.0926394.42812345l.0127097.02860375c.3414665-.02005375.441308-.02005375.7336305-.0146128l.0353047-.0290701c.0512623-.33593855.0651017-.42579165.1611304-.9145426l.0457548-.2247881c.0915096-.43962715.1378292-.66239435.0700444-.84396595-.0749871-.2034908-.2509454-.2526146-.4092515-.2526146-.1049254 0-.2974063.02782645-.468422.12078865-.0611476.0352883-.1224365.0758621-.1825956.11659135l.0523921-.22338905-.0281025-.0377756c-.3646263.0814585-.4479453.09234035-.7844692.1445733l-.025843.0206755c-.0408122.35708045-.0739986.62539605-.21903 1.32743145-.0552164.25867735-.1125512.51984195-.1698859.7778975l.0153928.03280105c.3458442-.02005375.4490751-.02005375.7485997-.0146128zm2.5088186.01453505c.0214652-.1153477.1489856-.7990394.1501153-.7990394 0 0 .1085971-.50165375.1152345-.519842 0 0 .0341748-.0522329.0683497-.07290845h.0502738c.4743532 0 1.0099953 0 1.4298381-.3399804.2856852-.2331827.4809905-.57751585.5681223-.99600105.022595-.1026004.0392588-.22463269.0392588-.34666496 0-.16027425-.0292322-.3188385-.1136809-.44273624-.2140874-.32972035-.6404262-.3357831-1.132573-.33827039-.0015534 0-.2426136.00248729-.2426136.00248729-.629976.00855003-.8826161.00606275-.9864117-.00792821-.0087556.05052291-.0252782.14037599-.0252782.14037599s-.2256673 1.15130077-.2256673 1.15316622c0 0-.5400198 2.4477966-.5654392 2.5631443.5500464-.00730635.7755725-.00730635.8704714.0041973zm.4181482-2.0451678s.2399304-1.14896892.2388007-1.14461618l.0077669-.05891749.0033893-.04492654.0958874.01088185s.4948299.046792.5064099.04803565c.1953052.0831685.2757998.29754113.2195948.57736036-.0512623.2557237-.2019425.4707182-.3955532.5745622-.1594358.0879876-.3547411.095294-.5559775.095294h-.1302035zm1.4938667.99045135c-.0634072.2975411-.136276.8410123.3154822 1.0347094.1440429.0674675.2731167.0875212.4043088.08021485.1385355-.00823915.2669031-.08472305.3858092-.1947853-.0107326.04523745-.0214652.0904749-.0321978.1358678l.0204766.0290701c.324944-.01507915.4257741-.01507915.7778319-.0121255l.0319154-.0267383c.0514036-.332674.0998416-.65570975.2334344-1.2921431.0651017-.30484755.1300622-.6067414.1968587-.9103453l-.0104501-.03342285c-.3634967.0741521-.4606551.09000855-.8103124.1445733l-.026549.0237846c-.0035305.0309356-.0072021.0606275-.0105914.09031945-.0543692-.0966931-.1331691-.17923975-.2547583-.2306954-.1554817-.0673121-.5206729.01943185-.8346018.33407305-.2205834.2246327-.3264973.53243385-.3866564.8276432zm.7634275.01818825c.0778115-.3667187.1672028-.67700715.3988014-.67700715.1464436 0 .2235489.14877055.2078737.40247335-.0124272.06327025-.025843.1299605-.0418008.20535625-.0231597.10897405-.0482967.21701535-.0727275.32521215-.0248545.07399665-.0538043.143796-.0855784.1902771-.0595943.09296215-.2013777.150636-.2830021.150636-.0231599 0-.1660731 0-.1710157-.23193905-.0011298-.11550315.0204767-.23442635.0474494-.36500865zm3.9866711-1.21085565-.0281024-.0352883c-.3596838.08021485-.4247856.09296215-.755237.142086l-.0242897.02673825c-.0011296.00435275-.0021182.01103735-.0038128.0171001l-.0011298-.00606275c-.2460027.6247742-.2388006.4899946-.4390485.98185465-.0011298-.02238555-.0011298-.0363765-.0022595-.06016115l-.0501327-1.0662668-.0314917-.0352883c-.3767711.08021485-.3856679.09296215-.7336305.142086l-.0271139.02673825c-.003813.01274735-.003813.0267383-.0060724.0419729l.0022594.00544095c.0434954.2446864.0330452.19012165.0766818.5762722.0203354.1894998.0474494.3800878.0677848.5672558.0343162.3132421.0535219.4674536.0954638.94547815-.2349878.4268798-.2906279.5883977-.51686.9630446l.0015534.0037309-.1592946.27733195c-.0182171.0292256-.0347397.0492793-.0578996.05782935-.0254193.0138355-.0584644.01632275-.1043605.01632275h-.0882616l-.131192.4803564.4500635.00855005c.26422-.00124365.4302931-.1372669.5196844-.32008215l.283002-.53383295h-.004519l.0297972-.03762015c.1903626-.4511308 1.6384179-3.1855867 1.6384179-3.1855867zm-4.7501128 6.3087581h-.1909276l.7066579-2.57293795h.2344228l.0744221-.265051.0072022.29474295c-.0087556.1821934.121448.3437113.4634794.31697305h.3955532l.1361347-.49543555h-.1488443c-.0855785 0-.1252609-.02378465-.1203182-.0747739l-.0072022-.299873h-.7325008v.00155455c-.2368235.00544095-.9440462.0250283-1.0872418.0670012-.1732752.0491238-.3558709.1936971-.3558709.1936971l.071739-.26536195h-.6851925l-.1427719.52652655-.7161194 2.61226815h-.1389591l-.136276.4918601h1.3647364l-.0457548.1640051h.6724828l.0446251-.1640051h.1886681zm-.5599316-2.0501423c-.1097268.03342285-.313929.1347796-.313929.1347796l.1816071-.65757525h.5443977l-.1313333.47911275s-.1681914.01088185-.2807425.0436829zm.0104502.9394154s-.1710158.0236292-.283567.0516111c-.1108566.0369984-.3187303.1535897-.3187303.1535897l.1875382-.6843135h.5472221zm-.3050322 1.1167897h-.5460922l.158306-.5775158h.5443976zm1.315112-1.5959024h.7871525l-.1131162.4032506h-.7976024l-.1197535.4408708h.6979023l-.5284398.8190931c-.0369994.0601612-.0701858.0814585-.1070437.0984031-.0369994.0206755-.0855785.0449265-.1417835.0449265h-.1936107l-.133028.4828437h.5064098c.2632315 0 .4187131-.131826.5335239-.3048476l.3623669-.5459584.0778115.5543531c.0165225.1038439.0843074.1646269.1302034.1882561.0506975.0279819.1030897.0760176.1770882.0831685.0793648.0037309.1366995.0066846.1748285.0066846h.2488272l.1494092-.5403621h-.0981469c-.0563463 0-.1533633-.0104155-.1698859-.0298474-.0165226-.0236292-.0165226-.0600057-.0254194-.1153477l-.0789412-.5555967h-.3232494l.1417836-.1857688h.796049l.1224365-.4408708h-.7370197l.1148107-.4032506h.7347603l.1362759-.497301h-2.1905826zm-6.6483163 1.7081877.1837253-.6728098h.7550958l.1379705-.5004101h-.7558018l.1153756-.4141325h.7385731l.1368408-.4845537h-1.84798632l-.13401641.4845537h.41984283l-.1119863.4141325h-.42097264l-.13952389.5089601h.41970155l-.24487301.8901361c-.03304514.117835.01553408.1627615.04631971.2174817.03149175.0533211.06340718.0886094.13514621.1086631.07399857.0181883.12469597.0290701.19361067.0290701h.8512656l.1516688-.554353-.3773361.0570521c-.0728688 0-.2746701-.0096382-.25264-.0837903zm.0866093-3.22084395-.1913512.38070965c-.0409534.08316845-.0778114.1347796-.1109978.1585642-.0292322.02005375-.0871318.0284483-.1710157.0284483h-.0998415l-.13345158.48704095h.33158128c.1594357 0 .2818722-.0643584.3403368-.09653765.0628422-.0369983.0793647-.0158564.1279439-.0674675l.1119864-.1067977h1.0354146l.1374057-.50709465h-.7579202l.1323219-.2768656zm1.5286064 3.23062205c-.0176524-.027982-.0049427-.0772612.0220301-.1798616l.283002-1.0311339h1.0067472c.1467262-.0023318.25264-.0041973.3215547-.0096382.0739985-.0085501.1544932-.0376202.2421899-.0898531.0905212-.0547202.1368408-.1123941.1759583-.178618.0436366-.0660684.113681-.2106417.1738401-.4335643l.3557296-1.3048905-1.044735.0066846s-.3216959.0522329-.4633381.10990675c-.1429132.06435845-.3471154.2440646-.3471154.2440646l.0943341-.3577023h-.645369l-.9035164 3.29860265c-.0320566.1280949-.0535218.2210571-.0584645.2768655-.0016946.0601612.0689147.1197005.1146695.164627.0540867.0449266.1340164.0376202.2106981.0449266.0806358.0066846.1953053.0108818.3536113.0108818h.4959597l.1522336-.5658567-.4439912.0461702c-.0474494 0-.0817655-.027982-.0960286-.0516111zm.4876277-1.9074346h1.0574447l-.06722.2319391c-.0094616.0054409-.0320566-.0115037-.1396652.0024873h-.9156612zm.2118279-.77789745h1.0663414l-.0766816.27935285s-.5025969-.0054409-.5830915.01088185c-.3541763.06746755-.5610614.27577745-.5610614.27577745zm.802065 1.78653705c-.0087555.0346665-.0225949.0558084-.0419418.0716648-.0214654.0152346-.0562051.0206755-.1080323.0206755h-.1506803l.0088968-.2824619h-.626728l-.0254193 1.380908c-.0009886.0996467.007767.1573206.0739985.2034908.0662315.0576738.2702923.0649802.5449624.0649802h.392729l.1417834-.5168883-.3418902.0206755-.1136809.0073064c-.0155341-.0073064-.030362-.013991-.0468846-.0321792-.0144043-.015701-.0386939-.0060627-.0347398-.1057095l.0026831-.3539713.3585541-.0163228c.1936107 0 .2763648-.0693331.346974-.1354015.0673612-.0632702.0893913-.1360232.1148107-.2344264l.0601592-.3133975h-.4927118z",
  fill: "#fefefe"
})), JJ = M.createElement("g", null, M.createElement("path", {
  transform: "scale(0.6)",
  d: "m33.6 24h-31.2c-1.325 0-2.4-1.075-2.4-2.4v-19.2c0-1.325 1.075-2.4 2.4-2.4h31.2c1.325 0 2.4 1.075 2.4 2.4v19.2c0 1.325-1.075 2.4-2.4 2.4zm-8.689-15.321c-.07-.002-.151-.004-.233-.004-.213 0-.424.01-.632.028l.027-.002c-.01.03.542 1.996 1.066 3.83l.064.224c1.114 3.896 1.114 3.896.937 4.274-.153.313-.392.565-.686.729l-.008.004-.231.116-.994.019c-.96.02-.998.024-1.12.111-.228.164-.315.425-.489 1.467-.09.55-.16.982-.16 1.006.148.031.318.049.492.049.084 0 .167-.004.249-.012l-.01.001c.214 0 .48 0 .812-.006.17.016.367.025.566.025.484 0 .956-.054 1.409-.157l-.043.008c1.072-.313 1.958-.975 2.55-1.852l.01-.016c.197-.286 5.257-9.732 5.257-9.814-.167-.024-.359-.038-.555-.038-.09 0-.178.003-.267.009l.012-.001h-.594l-1.4.011-.266.132c-.149.071-.277.163-.385.274-.067.08-.528 1.088-1.12 2.445-.344.887-.691 1.622-1.083 2.33l.049-.096c-.022-.046-.218-1.266-.378-2.282-.187-1.218-.366-2.27-.4-2.346-.065-.168-.191-.3-.349-.372l-.004-.002c-.151-.08-.223-.08-1.539-.095h-.553zm-3.77.131c-.043 0-.052.027-.062.071-.027.123-.418 2.354-.418 2.386.042.047.092.087.148.117l.003.001c.41.281.69.725.746 1.237l.001.008c.003.04.005.087.005.134 0 .787-.538 1.448-1.266 1.637l-.012.003c-.136.032-.19.067-.203.131-.035.168-.418 2.357-.418 2.39 0 .006.023.015.179.015.07 0 .16 0 .25-.007 1.958-.11 3.55-1.545 3.9-3.417l.004-.026c.026-.2.041-.431.041-.665 0-.321-.028-.636-.082-.942l.005.032c-.291-1.35-1.207-2.439-2.423-2.964l-.027-.01c-.108-.056-.232-.101-.364-.129l-.01-.002zm-16.966-.136c-.167 0-.603 0-.612.008s-.025.13-.058.32l-.137.758c-.104.588-.179 1.074-.167 1.082s.32.012.621.012h.596l-.012.091c0 .026-.037.211-.085.489l-.185 1.058c-.172.615-.271 1.322-.271 2.051 0 .156.005.31.013.464l-.001-.021c.182 1.082 1.114 1.766 2.624 1.925.198.021.466.031.701.031.038.003.081.004.125.004.138 0 .273-.016.403-.046l-.012.002c.022-.027.413-2.182.418-2.306 0-.052-.069-.068-.386-.088-.778-.043-1.126-.297-1.126-.823 0-.16.367-2.381.457-2.763.013-.059.032-.075.433-.075h.606c.053.003.116.004.179.004.174 0 .344-.012.512-.034l-.019.002c.025-.042.378-2 .378-2.099 0-.037-.198-.047-.847-.047h-.846l.107-.609c.195-1.063.149-1.32-.278-1.527-.214-.107-.231-.107-1.152-.123l-.953-.012-.024.111c-.012.064-.096.525-.183 1.03s-.171.96-.183 1.022l-.024.112zm6-.008-.025.111c-.04.186-1.415 8.014-1.415 8.053.294.026.637.042.983.042.135 0 .27-.002.404-.007l-.019.001h1.369l.04-.21c.025-.111.16-.871.302-1.686.14-.8.297-1.6.342-1.75.238-.867.892-1.541 1.727-1.805l.018-.005c.2-.061.43-.096.668-.096.056 0 .111.002.165.006h-.007c.499 0 .53-.005.545-.08.045-.195.452-2.57.445-2.593-.066-.021-.141-.034-.22-.034-.024 0-.048.001-.072.003h.003c-.006 0-.014 0-.021 0-.16 0-.317.013-.47.038l.017-.002c-.622.133-1.164.417-1.603.813l.003-.003c-.292.27-.546.576-.756.912l-.011.019c-.022.056-.054.104-.094.144.015-.157.037-.297.066-.435l-.004.024c.166-.885.076-1.192-.4-1.371-.269-.047-.578-.074-.894-.074-.058 0-.115.001-.173.003h.008zm9.704-.026h-.141c-.236 0-.467.022-.691.064l.023-.004c-1.274.263-2.314 1.086-2.869 2.195l-.011.024c-.272.488-.432 1.07-.432 1.689 0 .051.001.101.003.151v-.007c-.001.041-.002.09-.002.139 0 .262.024.518.069.767l-.004-.026c.249 1.142.939 2.09 1.879 2.674l.018.01c.276.177.595.325.933.427l.027.007c.025-.018.139-.633.247-1.233l.218-1.213-.103-.08c-.27-.187-.487-.434-.635-.721l-.005-.011c-.099-.162-.157-.359-.157-.569 0-.052.004-.103.01-.153l-.001.006c-.006-.044-.009-.095-.009-.147 0-.2.051-.387.14-.551l-.003.006c.228-.47.651-.815 1.161-.931l.011-.002c.08-.008.151-.031.151-.052 0-.054.4-2.314.422-2.394-.015-.056-.07-.064-.249-.064z"
})), XJ = M.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, M.createElement("g", null, M.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  x: "0",
  y: "0",
  width: "24",
  height: "16",
  rx: "1"
}), M.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "0.923076923",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), M.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: "16.6153846",
  y: "3.76470588",
  width: "4.61538462",
  height: "2.82352941",
  rx: "1"
}), M.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "6.46153846",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), M.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "11.9230769",
  y: "10.3529412",
  width: "5.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}), M.createElement("rect", {
  id: "Rectangle",
  fill: "#A6A6A6",
  x: "18.4615385",
  y: "10.3529412",
  width: "4.61538462",
  height: "1.88235294",
  rx: "0.941176471"
}))), QJ = M.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, M.createElement("rect", {
  fill: "#252525",
  height: "16",
  rx: "2",
  width: "24"
}), M.createElement("circle", {
  cx: "9",
  cy: "8",
  fill: "#eb001b",
  r: "5"
}), M.createElement("circle", {
  cx: "15",
  cy: "8",
  fill: "#f79e1b",
  r: "5"
}), M.createElement("path", {
  d: "m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z",
  fill: "#ff5f00"
})), eX = M.createElement("g", {
  fill: "none"
}, M.createElement("path", {
  d: "m.20535714 16h4.51785715c1.0278125 0 2.25892857-1.1946667 2.25892857-2.1333333v-13.8666667h-4.51785715c-1.0278125 0-2.25892857 1.19466667-2.25892857 3.2z",
  fill: "#047ab1"
}), M.createElement("path", {
  d: "m2.76924107 10.816c-.86733559.0001606-1.73039558-.1147397-2.56388393-.3413333v-1.17333337c.64678874.37770431 1.38610045.59084099 2.14598215.61866667.8696875 0 1.35535714-.576 1.35535714-1.36533333v-3.22133334h2.14598214v3.22133334c0 1.25866666-.70026786 2.26133333-3.0834375 2.26133333z",
  fill: "#fff"
}), M.createElement("path", {
  d: "m8.11160714 16h4.51785716c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.02781249 0-2.25892856 1.19466667-2.25892856 3.2z",
  fill: "#d42d06"
}), M.createElement("path", {
  d: "m8.11160714 6.08c.65508929-.59733333 1.78455357-.97066667 3.61428576-.88533333.9939285.04266666 2.0330357.32 2.0330357.32v1.184c-.5943231-.3394747-1.2623758-.54734656-1.9539732-.608-1.3892411-.11733334-2.23633933.61866666-2.23633933 1.90933333s.84709823 2.0266667 2.23633933 1.92c.6920185-.06606555 1.3596342-.27744592 1.9539732-.61866667v1.17333337s-1.0391072.288-2.0330357.3306666c-1.82973219.0853334-2.95919647-.288-3.61428576-.8853333z",
  fill: "#fff"
}), M.createElement("path", {
  d: "m16.0178571 16h4.5178572c1.0278125 0 2.2589286-1.1946667 2.2589286-2.1333333v-13.8666667h-4.5178572c-1.0278125 0-2.2589286 1.19466667-2.2589286 3.2z",
  fill: "#67b637"
}), M.createElement("path", {
  d: "m21.6651786 9.28c0 .8533333-.7002679 1.3866667-1.6377232 1.3866667h-4.0095983v-5.33333337h3.6481697l.2597768.01066667c.8245089.04266667 1.4344196.50133333 1.4344196 1.29066667 0 .61866666-.4179018 1.152-1.1746428 1.28v.032c.8358035.05333333 1.4795982.55466666 1.4795982 1.33333333zm-2.880134-3.104c-.0486104-.00686658-.0976798-.01043129-.1468303-.01066667h-1.3553572v1.344h1.5021875c.2823661-.064.5195536-.30933333.5195536-.672 0-.36266666-.2371875-.608-.5195536-.66133333zm.1694197 2.176c-.059755-.00886168-.1202559-.01243275-.1807143-.01066667h-1.4908929v1.46133334h1.4908929l.1807143-.02133334c.2823661-.064.5195536-.34133333.5195536-.71466666 0-.37333334-.2258929-.64-.5195536-.71466667z",
  fill: "#fff"
})), tX = M.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, M.createElement("rect", {
  fill: "#016fd0",
  height: "16",
  rx: "2",
  width: "24"
}), M.createElement("path", {
  d: "m13.7640663 13.3938564v-5.70139231l10.1475359.00910497v1.57489503l-1.1728619 1.25339231 1.1728619 1.2648839v1.6083094h-1.8726188l-.9951823-1.0981657-.9881105 1.1023204z",
  fill: "#fffffe"
}), M.createElement("path", {
  d: "m14.4418122 12.7687956v-4.448884h3.7722872v1.02488398h-2.550895v.69569062h2.4900774v1.0078232h-2.4900774v.6833149h2.550895v1.0371713z",
  fill: "#016fd0"
}), M.createElement("path", {
  d: "m18.1952707 12.7687956 2.087337-2.2270055-2.0874254-2.2217901h1.6156464l1.2754917 1.41003315 1.2791161-1.41003315h1.5461657v.03500552l-2.0428729 2.18678458 2.0428729 2.1638895v.063116h-1.5617237l-1.2981216-1.4241768-1.2847735 1.4241768z",
  fill: "#016fd0"
}), M.createElement("path", {
  d: "m14.2373481 2.6319558h2.4460552l.8591381 1.95085083v-1.95085083h3.0198453l.5207514 1.46156906.5225194-1.46156906h2.3059447v5.70139227h-12.1865193z",
  fill: "#fffffe"
}), M.createElement("g", {
  fill: "#016fd0"
}, M.createElement("path", {
  d: "m14.7004641 3.25135912-1.9740111 4.44517127h1.3539006l.3724199-.89016575h2.0179447l.3721547.89016575h1.3875801l-1.96579-4.44517127zm.1696353 2.55743646.592-1.41507182.5915581 1.41507182z"
}), M.createElement("path", {
  d: "m18.2119779 7.69573481v-4.44508288l1.903116.00654144.9792707 2.73272928.9856354-2.73927072h1.8316022v4.44508288l-1.1786077.01043094v-3.05334807l-1.1125746 3.04291713h-1.0758011l-1.1356464-3.05334807v3.05334807z"
}))), rX = M.createElement("g", {
  id: "319",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, M.createElement("g", {
  id: "New-Icons",
  transform: "translate(-320.000000, -280.000000)",
  fillRule: "nonzero"
}, M.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, M.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, M.createElement("g", {
  id: "Diners-Club",
  transform: "translate(280.000000, 0.000000)"
}, M.createElement("path", {
  d: "M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z",
  id: "shape",
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF"
}), M.createElement("path", {
  d: "M10.0021142,2.05179033 L10.0021142,2.03579033 L14.0021142,2.03579033 L14.0021142,2.05179033 C17.1375481,2.28122918 19.5642283,4.89197286 19.5642283,8.03579033 C19.5642283,11.1796078 17.1375481,13.7903515 14.0021142,14.0197903 L14.0021142,14.0357903 L10.0021142,14.0357903 L10.0021142,14.0197903 C6.86668021,13.7903515 4.44,11.1796078 4.44,8.03579033 C4.44,4.89197286 6.86668021,2.28122918 10.0021142,2.05179033 Z",
  id: "shape",
  fill: "#0165AC"
}), M.createElement("path", {
  d: "M11.6021142,11.4277903 C13.0374002,10.9175027 13.9961556,9.55908923 13.9961556,8.03579033 C13.9961556,6.51249143 13.0374002,5.15407792 11.6021142,4.64379033 L11.6021142,11.4277903 L11.6021142,11.4277903 Z M9.20211417,4.64379033 C7.76682809,5.15407792 6.80807271,6.51249143 6.80807271,8.03579033 C6.80807271,9.55908923 7.76682809,10.9175027 9.20211417,11.4277903 L9.20211417,4.64379033 L9.20211417,4.64379033 Z M10.4021142,13.2357903 C7.53023347,13.2357903 5.20211417,10.907671 5.20211417,8.03579033 C5.20211417,5.16390963 7.53023347,2.83579033 10.4021142,2.83579033 C13.2739949,2.83579033 15.6021142,5.16390963 15.6021142,8.03579033 C15.6021142,10.907671 13.2739949,13.2357903 10.4021142,13.2357903 Z",
  id: "shape",
  fill: "#FFFFFF"
})))))), nX = M.createElement("g", {
  id: "319",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, M.createElement("g", {
  id: "New-Icons",
  transform: "translate(-280.000000, -280.000000)",
  fillRule: "nonzero"
}, M.createElement("g", {
  id: "Card-Brands",
  transform: "translate(40.000000, 200.000000)"
}, M.createElement("g", {
  id: "Color",
  transform: "translate(0.000000, 80.000000)"
}, M.createElement("g", {
  id: "Discover",
  transform: "translate(240.000000, 0.000000)"
}, M.createElement("path", {
  d: "M21.9972414,15.749927 L21.999381,15.7499362 C22.9544683,15.7581106 23.73806,14.9772525 23.75,14.0041555 L23.7500083,2.00630219 C23.7461702,1.53568921 23.5588633,1.08617106 23.2297297,0.756801782 C22.9014319,0.428268884 22.4589161,0.246148853 21.9972414,0.250070854 L2.00063,0.250061791 C1.54108393,0.246148853 1.09856813,0.428268884 0.77027028,0.756801782 C0.441136651,1.08617106 0.253829819,1.53568921 0.25,2.00426336 L0.249991686,13.9936957 C0.253829819,14.4643086 0.441136651,14.9138268 0.77027028,15.2431961 C1.09856813,15.571729 1.54108393,15.753849 2.00275862,15.749927 L21.9972414,15.749927 Z M21.996203,16.249927 C21.9958359,16.249924 21.9954688,16.249921 21.9951018,16.2499178 L21.9972414,16.249927 L21.996203,16.249927 Z",
  id: "shape",
  strokeOpacity: "0.2",
  stroke: "#000000",
  strokeWidth: "0.5",
  fill: "#FFFFFF"
}), M.createElement("path", {
  d: "M12.6124138,15.9999283 L21.9972414,15.9999283 C22.5240217,16.0043364 23.0309756,15.7992919 23.4065697,15.4299059 C23.7821638,15.06052 23.9956285,14.5570537 24,14.0302731 L24,11.6716524 C20.4561668,13.7059622 16.6127929,15.1667795 12.6124138,15.9999283 L12.6124138,15.9999283 Z",
  id: "shape",
  fill: "#F27712"
}), M.createElement("path", {
  d: "M23.1724138,9.29647999 L22.32,9.29647999 L21.36,8.03027309 L21.2689655,8.03027309 L21.2689655,9.29647999 L20.5737931,9.29647999 L20.5737931,6.1516524 L21.6,6.1516524 C22.4027586,6.1516524 22.8662069,6.48268688 22.8662069,7.07854895 C22.8662069,7.56682481 22.5765517,7.88130757 22.0551724,7.98061792 L23.1724138,9.29647999 Z M22.1462069,7.10337654 C22.1462069,6.79716964 21.9144828,6.63992826 21.4841379,6.63992826 L21.2689655,6.63992826 L21.2689655,7.5916524 L21.4675862,7.5916524 C21.9144828,7.5916524 22.1462069,7.42613516 22.1462069,7.10337654 L22.1462069,7.10337654 Z M18.1406897,6.1516524 L20.1103448,6.1516524 L20.1103448,6.68130757 L18.8358621,6.68130757 L18.8358621,7.38475585 L20.0606897,7.38475585 L20.0606897,7.92268688 L18.8358621,7.92268688 L18.8358621,8.77510068 L20.1103448,8.77510068 L20.1103448,9.30475585 L18.1406897,9.30475585 L18.1406897,6.1516524 Z M15.9062069,9.37923861 L14.4,6.14337654 L15.1613793,6.14337654 L16.1131034,8.26199723 L17.0731034,6.14337654 L17.817931,6.14337654 L16.2951724,9.37923861 L15.9227586,9.37923861 L15.9062069,9.37923861 Z M9.60827586,9.37096274 C8.54896552,9.37096274 7.72137931,8.65096274 7.72137931,7.71579033 C7.72137931,6.8054455 8.56551724,6.06889378 9.62482759,6.06889378 C9.92275862,6.06889378 10.1710345,6.12682481 10.4772414,6.25923861 L10.4772414,6.98751447 C10.2453534,6.75969251 9.93335245,6.63192067 9.60827586,6.6316524 C8.9462069,6.6316524 8.44137931,7.1116524 8.44137931,7.71579033 C8.44137931,8.35303171 8.93793103,8.80820412 9.64137931,8.80820412 C9.95586207,8.80820412 10.1958621,8.70889378 10.4772414,8.46061792 L10.4772414,9.18889378 C10.1627586,9.32130757 9.89793103,9.37096274 9.60827586,9.37096274 L9.60827586,9.37096274 Z M7.5062069,8.33647999 C7.5062069,8.94889378 7.00137931,9.37096274 6.27310345,9.37096274 C5.74344828,9.37096274 5.36275862,9.18889378 5.04,8.77510068 L5.49517241,8.38613516 C5.65241379,8.66751447 5.91724138,8.80820412 6.24827586,8.80820412 C6.56275862,8.80820412 6.7862069,8.6178593 6.7862069,8.36958343 C6.7862069,8.22889378 6.72,8.12130757 6.57931034,8.03854895 C6.42504922,7.96369158 6.26441119,7.90275992 6.09931034,7.85647999 C5.44551724,7.64958343 5.22206897,7.42613516 5.22206897,6.98751447 C5.22206897,6.47441102 5.70206897,6.0854455 6.33103448,6.0854455 C6.72827586,6.0854455 7.08413793,6.20958343 7.38206897,6.44130757 L7.01793103,6.85510068 C6.87360928,6.69688076 6.66932728,6.60675635 6.45517241,6.60682481 C6.15724138,6.60682481 5.94206897,6.75579033 5.94206897,6.95441102 C5.94206897,7.11992826 6.0662069,7.21096274 6.48,7.3516524 C7.27448276,7.59992826 7.5062069,7.8316524 7.5062069,8.34475585 L7.5062069,8.33647999 Z M4.08827586,6.1516524 L4.78344828,6.1516524 L4.78344828,9.30475585 L4.08827586,9.30475585 L4.08827586,6.1516524 Z M1.8537931,9.30475585 L0.827586207,9.30475585 L0.827586207,6.1516524 L1.8537931,6.1516524 C2.97931034,6.1516524 3.75724138,6.79716964 3.75724138,7.72406619 C3.75724138,8.19579033 3.52551724,8.64268688 3.12,8.94061792 C2.77241379,9.18889378 2.38344828,9.30475585 1.84551724,9.30475585 L1.8537931,9.30475585 Z M2.66482759,6.9378593 C2.43310345,6.75579033 2.16827586,6.68958343 1.71310345,6.68958343 L1.52275862,6.68958343 L1.52275862,8.77510068 L1.71310345,8.77510068 C2.16,8.77510068 2.44137931,8.69234206 2.66482759,8.52682481 C2.90482759,8.32820412 3.04551724,8.03027309 3.04551724,7.72406619 C3.04551724,7.4178593 2.90482759,7.12820412 2.66482759,6.9378593 Z",
  id: "shape",
  fill: "#000000"
}), M.createElement("path", {
  d: "M12.4137931,6.06889378 C11.5034483,6.06889378 10.7586207,6.79716964 10.7586207,7.69923861 C10.7586207,8.65923861 11.4703448,9.37923861 12.4137931,9.37923861 C13.3406897,9.37923861 14.0689655,8.65096274 14.0689655,7.72406619 C14.0689655,6.79716964 13.3489655,6.06889378 12.4137931,6.06889378 Z",
  id: "shape",
  fill: "#F27712"
})))))), aX = M.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, M.createElement("g", {
  id: "Group-2"
}, M.createElement("rect", {
  id: "Rectangle",
  fill: "#B3131B",
  x: "0",
  y: "0",
  width: "24",
  height: "16",
  rx: "2"
}), M.createElement("g", {
  id: "Hipercard_logo",
  transform: "translate(2.000000, 6.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, M.createElement("path", {
  d: "M4.45845797,4.72911206 L4.71934477,4.72911206 L4.72670967,4.71021617 C4.73076043,4.69982332 4.73407456,4.67539055 4.73407456,4.65592007 C4.73407456,4.63644958 4.74267391,4.56566228 4.75318417,4.49861521 C4.76369454,4.43156695 4.78836018,4.27726169 4.80799675,4.15571305 C4.82763331,4.0341644 4.85703646,3.85139347 4.87333717,3.74955542 C4.88963776,3.64771736 4.90953167,3.51735868 4.91754595,3.45986946 C4.92556023,3.40238023 4.93534271,3.3553436 4.93928464,3.3553436 C4.94322668,3.3553436 4.96009268,3.38074637 4.9767648,3.41179473 L5.0070776,3.46824705 L5.07434118,3.5349692 L5.14160488,3.60169134 L5.22440039,3.63432372 L5.30719578,3.66695609 L5.40587279,3.67955056 L5.5045498,3.69214384 L5.62980554,3.68457856 L5.75506139,3.67701327 L5.8906751,3.64246001 L6.02628894,3.60790675 L6.09908975,3.57519075 C6.13913019,3.55719677 6.21011098,3.51796553 6.25682484,3.48801021 L6.34175912,3.43354447 L6.42095111,3.35561954 C6.46450662,3.31276155 6.5259323,3.24403729 6.55745263,3.20290069 C6.58897283,3.16176409 6.61476215,3.12510239 6.61476215,3.12143264 C6.61476215,3.11776169 6.63024834,3.09228724 6.64917582,3.06482382 C6.66810343,3.0373592 6.70683989,2.96113177 6.73525696,2.8954298 C6.76367415,2.82972783 6.80808531,2.71146429 6.83394853,2.63262192 L6.88097263,2.48927217 L6.90527961,2.36510142 C6.91864839,2.29680721 6.93584673,2.18391928 6.94349809,2.11423935 L6.95740984,1.98754804 L6.9493753,1.88003572 L6.94134076,1.77252341 L6.91602234,1.66501109 L6.89070392,1.55749878 L6.84971924,1.47700311 L6.80873457,1.39650745 L6.72956721,1.31388424 L6.65039973,1.23125983 L6.55674682,1.18360201 L6.4630938,1.13594299 L6.35995932,1.11163207 L6.25682484,1.08732115 L6.15369036,1.07986696 L6.05055588,1.07241397 L5.93566831,1.0854122 L5.82078075,1.09840925 L5.7270093,1.12198192 L5.63323773,1.1455534 L5.55177641,1.18267501 C5.50697261,1.2030916 5.44177912,1.23776791 5.40690207,1.25973387 C5.3720249,1.28169983 5.33604735,1.30697239 5.32695174,1.31589472 C5.31785613,1.32481824 5.29608043,1.34134766 5.27856116,1.3526257 L5.24670802,1.37313308 L5.26898276,1.26820942 C5.28123392,1.21050159 5.29147275,1.15656744 5.2917358,1.14835469 L5.29221386,1.13342243 L5.06976516,1.13342243 L4.84731634,1.13342243 L4.80831003,1.37532513 C4.78685648,1.50837162 4.75298372,1.71398893 4.73303727,1.83225247 C4.7130907,1.95051602 4.68301183,2.12791134 4.66619545,2.22646429 C4.64937895,2.32501725 4.61938307,2.49972476 4.59953794,2.61470321 C4.5796928,2.72968165 4.54689191,2.91245259 4.52664697,3.02086084 C4.50640216,3.12926909 4.47674372,3.28784975 4.46073931,3.37326231 C4.44473502,3.45867488 4.41461296,3.61994335 4.39380151,3.7316367 C4.37299019,3.84333005 4.33954562,4.02072536 4.31948026,4.12584852 C4.29941502,4.23097167 4.26676167,4.39761576 4.24691738,4.49616871 C4.2270731,4.59472167 4.20785211,4.68745104 4.20420394,4.70223398 L4.19757093,4.72911206 L4.45845773,4.72911206 L4.45845797,4.72911206 Z M5.58158434,3.34795511 L5.48028286,3.35395071 L5.41406652,3.34244331 L5.34785018,3.33093472 L5.28059837,3.30070464 L5.21334656,3.27047457 L5.16636177,3.22630134 L5.11937709,3.18212931 L5.09225746,3.12240025 C5.07734166,3.08954926 5.0581828,3.0337432 5.04968233,2.99838718 L5.03422684,2.93410437 L5.04041916,2.8311458 L5.04661147,2.72818843 L5.07787505,2.56691995 C5.09507,2.47822229 5.12594421,2.31157821 5.14648436,2.19659976 C5.1670245,2.08162131 5.19812318,1.9131519 5.21559259,1.82222277 L5.24735509,1.6568975 L5.3169102,1.5999088 C5.35516545,1.56856538 5.41576424,1.52655673 5.45157423,1.50655705 L5.51668327,1.470194 L5.60161755,1.44430981 L5.68655183,1.41842563 L5.79575304,1.41211346 L5.90495426,1.40580129 L5.99387134,1.42445946 L6.08278843,1.44311762 L6.1455397,1.47157016 L6.20829096,1.50002269 L6.2609103,1.55210763 L6.31352963,1.60419138 L6.34191746,1.65934519 C6.3575308,1.68968039 6.37946059,1.74905705 6.39065044,1.79129506 L6.41099548,1.86808991 L6.40476348,2.09506035 L6.39853137,2.32203079 L6.36736983,2.45618705 C6.35023095,2.52997394 6.31760514,2.64286188 6.29486799,2.70704912 L6.25352781,2.82375493 L6.20290006,2.91822719 C6.17505485,2.9701879 6.1321162,3.04040419 6.10748089,3.07426459 C6.08284558,3.10812381 6.04357913,3.15198525 6.0202222,3.17173287 C5.99686528,3.19148049 5.95774892,3.22234369 5.93329695,3.24031617 L5.8888387,3.27299275 L5.7858622,3.30747553 L5.6828857,3.34195951 L5.58158434,3.34795511 Z M8.10111202,3.67635864 L8.23458018,3.67786023 L8.36804833,3.665875 C8.44145581,3.6592833 8.56157715,3.64555995 8.63498463,3.63537973 C8.70839211,3.62519831 8.83520336,3.60240928 8.91678734,3.58473665 L9.06512179,3.5526048 L9.07250973,3.498771 C9.07657311,3.4691621 9.093232,3.38101873 9.10952955,3.3028967 L9.1391613,3.16085621 L9.1326233,3.1544198 L9.12608543,3.1479822 L9.0807372,3.1695444 C9.05579576,3.181403 8.97811171,3.20969069 8.90810597,3.23240685 L8.78082285,3.27370711 L8.6472364,3.29918394 L8.51364995,3.32466077 L8.30131425,3.32506693 L8.08897856,3.32547309 L8.01617775,3.30258252 C7.9761373,3.28999283 7.91724557,3.26695772 7.88530737,3.25139472 L7.82723768,3.22309628 L7.7793106,3.18046765 L7.73138352,3.13783782 L7.69398963,3.07349051 L7.65659562,3.00914319 L7.63315109,2.92843011 L7.60970656,2.84771703 L7.60953911,2.69835615 L7.60937167,2.54899526 L7.63018579,2.41575047 L7.65099978,2.28250449 L7.83358895,2.27410658 L8.01617823,2.26570748 L8.69111697,2.26997453 L9.3660557,2.27424157 L9.38643459,2.18913124 C9.39764288,2.14232038 9.41477886,2.04555929 9.42451439,1.97410661 L9.44221542,1.84419231 L9.44258913,1.73490963 L9.44296284,1.62562694 L9.42374501,1.54404301 L9.40452717,1.46245909 L9.37275132,1.40843654 C9.35527451,1.37872491 9.32448062,1.33566504 9.3043205,1.31274938 C9.28416037,1.28983373 9.24816377,1.25752509 9.22432794,1.24095266 C9.20049222,1.22438023 9.15368992,1.19652977 9.12032288,1.17906499 L9.05965554,1.14730824 L8.95365525,1.12215633 L8.84765497,1.09700442 L8.71705262,1.08471099 L8.58645027,1.07241636 L8.46511559,1.08019547 L8.34378091,1.08797458 L8.19817929,1.11550012 L8.05257767,1.14302686 L7.96157665,1.17884877 C7.9115261,1.198551 7.83508525,1.23447922 7.7917081,1.2586898 C7.74833095,1.28290038 7.68827028,1.32231081 7.65823994,1.34626814 C7.62820961,1.37022427 7.57621515,1.4167998 7.54269681,1.44976786 C7.50917834,1.48273591 7.45959784,1.54196325 7.43251788,1.58138443 C7.40543792,1.62080561 7.36392374,1.69068862 7.34026433,1.73668 C7.31660479,1.78267138 7.28577559,1.84717876 7.27175488,1.88002975 C7.25773417,1.91288073 7.23225571,1.98007593 7.21513599,2.02935241 C7.1980164,2.07862889 7.17110667,2.17270216 7.15533656,2.23840413 C7.13956645,2.3041061 7.11795686,2.41225991 7.10731533,2.47874552 L7.08796742,2.59963476 L7.08814699,2.77739681 L7.08832657,2.95515887 L7.10676835,3.03280665 C7.11691132,3.07551293 7.13630473,3.14002032 7.14986473,3.1761564 C7.16342485,3.21229249 7.18849963,3.26604864 7.20558671,3.29561453 C7.22267367,3.32518042 7.2591652,3.37278329 7.28667905,3.40139948 C7.31419278,3.43001568 7.36400431,3.47343751 7.39737135,3.49789178 C7.43073838,3.52234606 7.49013972,3.55674044 7.52937438,3.57432587 L7.60070995,3.60629765 L7.70017273,3.62996947 C7.75487732,3.64298921 7.83743756,3.65841484 7.88363999,3.66425037 C7.92984242,3.6700847 8.02770503,3.67553319 8.10111251,3.67635864 L8.10111202,3.67635864 Z M8.32965888,1.99352094 C7.99374575,1.99352094 7.71890777,1.99115328 7.71890777,1.98826001 C7.71890777,1.98536673 7.73323995,1.94370571 7.75075703,1.89567996 C7.76827412,1.84765421 7.79903902,1.77617166 7.81912342,1.73682932 L7.85564031,1.66529779 L7.93590903,1.58670271 L8.01617775,1.50810762 L8.09504529,1.47097884 C8.13842244,1.45055747 8.19575308,1.42832273 8.22244671,1.42156738 C8.24914034,1.41481202 8.32558119,1.40585027 8.39231526,1.40165251 L8.51364995,1.39401794 L8.60682685,1.40580726 L8.70000364,1.41759659 L8.76771701,1.44811814 L8.8354305,1.4786385 L8.87257529,1.51806804 C8.89300502,1.53975447 8.9173507,1.5716916 8.92667697,1.58903811 L8.94363374,1.62057745 L8.95483159,1.69057752 L8.96602945,1.76057759 L8.95321966,1.87704927 L8.94040987,1.99352094 L8.32965888,1.99352094 Z M11.959629,3.67642315 L12.0931723,3.67788054 L12.2447655,3.66019237 C12.328143,3.6504637 12.4391291,3.63434164 12.4914025,3.62436569 C12.5436771,3.61438974 12.628308,3.59458597 12.6794712,3.58035851 C12.7306357,3.56612985 12.7769248,3.55074723 12.7823351,3.54617318 C12.7877455,3.54159912 12.8022037,3.48738425 12.8144634,3.42569488 C12.826723,3.3640055 12.8421665,3.28127956 12.8487817,3.24185837 C12.8553968,3.20243719 12.858816,3.16807267 12.8563809,3.16549477 C12.8539445,3.16291567 12.8449948,3.16624735 12.8364917,3.1728952 C12.8279885,3.17954304 12.7684545,3.20420995 12.7041944,3.22770736 L12.5873588,3.27043156 L12.420981,3.302168 L12.2546045,3.33390325 L12.1131465,3.32915121 L11.9716884,3.32439797 L11.8913406,3.29696441 L11.8109916,3.26953085 L11.7489046,3.21605781 L11.6868164,3.16258596 L11.6456318,3.08873695 L11.6044472,3.01488793 L11.5848322,2.91609248 L11.5652172,2.81729702 L11.5653386,2.68912203 L11.5654599,2.56094705 L11.5892961,2.40565148 L11.6131335,2.25035592 L11.6383541,2.16673523 C11.6522263,2.12074385 11.6679222,2.06698769 11.6732342,2.0472771 C11.678545,2.02756651 11.7007978,1.97112254 11.722683,1.92184607 C11.7445681,1.87256959 11.7836087,1.79641025 11.8094409,1.75260257 L11.8564059,1.67295267 L11.9140896,1.61410998 L11.9717721,1.5552673 L12.0328581,1.51796531 L12.0939452,1.48066331 L12.172393,1.45687442 C12.2155396,1.44379137 12.2917924,1.42680322 12.3418429,1.41912326 L12.4328439,1.40516219 L12.5663121,1.41175628 L12.6997802,1.41835037 L12.8575153,1.44943457 L13.0152504,1.48051877 L13.0794061,1.50407591 C13.1146915,1.51703353 13.145104,1.52763425 13.1469871,1.52763425 C13.1488715,1.52763425 13.1573345,1.48328542 13.1657928,1.42908129 C13.1742522,1.37487717 13.1893087,1.28569809 13.1992508,1.23090743 C13.209193,1.17611557 13.2149333,1.12892841 13.2120067,1.12604708 C13.2090789,1.12316575 13.1616662,1.11575337 13.1066446,1.109575 C13.0516217,1.10339663 12.9020779,1.09242679 12.7743246,1.08519718 L12.5420452,1.0720532 L12.3782433,1.08442906 L12.2144415,1.09680493 L12.0931068,1.12190786 L11.9717721,1.14701198 L11.8936314,1.17778201 C11.8506546,1.19470683 11.787705,1.2252463 11.7537446,1.24564856 C11.7197843,1.26605201 11.6765552,1.29349632 11.6576803,1.30663671 C11.6388043,1.3197771 11.5815404,1.37104495 11.5304257,1.42056632 L11.4374894,1.5106043 L11.3856128,1.58542809 C11.3570809,1.62658022 11.3077232,1.71239058 11.2759299,1.77611671 L11.2181236,1.89198153 L11.1738182,2.01741257 C11.1494494,2.08639964 11.1154271,2.19928757 11.098211,2.26827464 L11.0669102,2.39370567 L11.0555485,2.50719089 L11.0441879,2.62067611 L11.0443092,2.76999877 L11.0444306,2.91932143 L11.0558894,3.0061878 L11.0673483,3.09305536 L11.1036916,3.18241243 L11.1400338,3.27176949 L11.1820095,3.33637364 L11.2239841,3.4009766 L11.2907327,3.46565123 L11.3574813,3.53032586 L11.4280836,3.56706401 L11.4986858,3.60380216 L11.591451,3.6291691 C11.642471,3.64312061 11.7161818,3.65913278 11.7552528,3.6647509 C11.7943226,3.67037021 11.8863841,3.67562278 11.9598316,3.67642315 L11.959629,3.67642315 Z M13.9555105,3.67201037 L14.1193123,3.66738973 L14.2224468,3.64140161 L14.3255813,3.6154123 L14.3923154,3.5843508 C14.4290191,3.56726709 14.4890798,3.53354287 14.5257835,3.50940874 C14.5624872,3.48527462 14.6192998,3.43939314 14.6520322,3.40745004 C14.6847659,3.37550574 14.7333071,3.32100536 14.7599012,3.28633861 C14.7864953,3.25167066 14.8098571,3.22488337 14.8118155,3.22681143 C14.8137726,3.22873948 14.8076537,3.2839817 14.7982163,3.34957257 C14.7887801,3.41516345 14.7809516,3.50242641 14.7808217,3.54349015 L14.7805912,3.61815148 L15.003278,3.61815148 L15.2259647,3.61815148 L15.2327728,3.44792364 L15.2395797,3.27769581 L15.2713548,3.05669828 C15.2888318,2.93514963 15.3170592,2.75506651 15.3340824,2.65651355 C15.3511044,2.55796059 15.3806943,2.39131651 15.3998373,2.28619336 C15.4189803,2.1810702 15.4493055,2.01711392 15.4672278,1.92184607 L15.4998135,1.74863178 L15.5009055,1.59901287 L15.5019975,1.44939515 L15.4676343,1.38024561 L15.4332723,1.31109728 L15.3866749,1.26705665 L15.3400776,1.22301602 L15.2635748,1.18484915 L15.1870721,1.14668347 L15.0730551,1.12171553 L14.9590393,1.09674639 L14.8020602,1.08498574 L14.645081,1.07322389 L14.4428707,1.08554122 C14.3316553,1.09231569 14.1751408,1.10569261 14.0950599,1.11526718 L13.9494583,1.13267701 L13.8502272,1.13304733 L13.750996,1.13341765 L13.7365584,1.20210607 C13.7286171,1.2398847 13.7065499,1.32964076 13.687521,1.40156411 C13.6684909,1.47348627 13.6546854,1.53406946 13.6568415,1.53619223 C13.6589976,1.538315 13.7120682,1.52645639 13.7747764,1.50983976 C13.8374846,1.49322194 13.9706919,1.4658947 14.070793,1.44911203 L14.252795,1.41859765 L14.4165969,1.411951 L14.5803987,1.40530435 L14.6859089,1.42351335 L14.7914191,1.44172116 L14.8618442,1.47594352 L14.9322693,1.51016469 L14.971703,1.56803021 L15.0111368,1.62589572 L15.0105787,1.7171259 L15.0100205,1.80835607 L14.989117,1.90846915 L14.9682134,2.00858342 L14.5316331,2.01013398 L14.0950539,2.01168455 L13.9521677,2.05025639 C13.8735792,2.07147095 13.786558,2.09963679 13.7587857,2.11284647 C13.7310146,2.12605735 13.7032351,2.13686592 13.6970543,2.13686592 C13.6908735,2.13686592 13.6441232,2.16238934 13.5931651,2.19358344 L13.5005139,2.25030097 L13.4275457,2.32200093 C13.387413,2.36143645 13.3361406,2.42057897 13.3136063,2.45342996 C13.2910733,2.48628094 13.2544617,2.55490844 13.232249,2.60593498 L13.1918603,2.69871094 L13.173324,2.80304089 L13.1547877,2.90737084 L13.1547877,3.01681838 L13.1547877,3.12626711 L13.1724965,3.21739215 L13.1902065,3.3085184 L13.2230615,3.3679524 C13.2411331,3.40064092 13.2742951,3.44852332 13.2967566,3.47435973 L13.3375954,3.52133305 L13.4101681,3.56473577 L13.4827396,3.60813849 L13.5658078,3.63128231 C13.6114963,3.64401177 13.6810332,3.65942187 13.720336,3.66552618 L13.7917948,3.67662623 L13.9555966,3.67200559 L13.9555105,3.67201037 Z M14.1071788,3.33797677 L14.0101111,3.34295937 L13.9458219,3.32683969 C13.9104626,3.31797351 13.8568096,3.2982008 13.8265924,3.2829006 L13.771652,3.25508 L13.7416666,3.21999634 C13.7251748,3.20069908 13.6999809,3.16278307 13.6856804,3.13573655 L13.6596808,3.08656281 L13.6545823,2.97172771 L13.649485,2.85689381 L13.6700525,2.78723658 C13.6813657,2.74892516 13.7079052,2.68244671 13.7290308,2.6395051 L13.7674417,2.56143085 L13.840996,2.48951348 L13.9145503,2.4175973 L13.9926644,2.38056886 L14.0707784,2.34354042 L14.1678462,2.3208398 L14.2649139,2.29813917 L14.5682506,2.29813917 L14.8715874,2.29813917 L14.8907789,2.30595173 L14.9099692,2.31376429 L14.8938183,2.40749114 C14.8849342,2.4590409 14.8637479,2.55228633 14.8467356,2.61470321 C14.8297232,2.67712008 14.7996905,2.76887348 14.7799954,2.81860031 C14.7603004,2.86832714 14.7441859,2.91229012 14.7441859,2.91629675 C14.7441859,2.92030338 14.7242458,2.95653742 14.6998745,2.99681631 L14.6555643,3.07005131 L14.5828035,3.14102257 C14.5427861,3.18005671 14.5056371,3.21199384 14.5002523,3.21199384 C14.4948674,3.21199384 14.4703372,3.22543885 14.4457427,3.24187151 L14.4010235,3.27174799 L14.3026357,3.30237108 L14.2042466,3.33299417 L14.1071788,3.33797677 Z M18.0566228,3.67628099 L18.1718907,3.67771091 L18.281092,3.66026166 C18.3411526,3.65066439 18.4175935,3.63520412 18.4509605,3.6259067 C18.4843276,3.61660808 18.5443882,3.59247515 18.5844287,3.57227836 L18.6572295,3.53555693 L18.7198576,3.48128471 L18.7824857,3.4270125 L18.8484444,3.34040775 C18.8847223,3.29277621 18.9175725,3.24574076 18.9214467,3.23588547 L18.9284889,3.21796675 L18.922364,3.27769581 C18.9189945,3.3105468 18.9114402,3.36430295 18.9055761,3.39715394 C18.8997132,3.43000492 18.8913059,3.49316841 18.8868942,3.53751724 L18.8788715,3.61815148 L19.1168877,3.61815148 L19.3549039,3.61815148 L19.3549039,3.53751724 L19.3549039,3.456883 L19.391166,3.15226478 C19.411111,2.98472475 19.4406038,2.7616367 19.4567061,2.65651355 C19.4728085,2.5513904 19.4976627,2.40087316 19.5119389,2.32203079 C19.5262139,2.24318843 19.5514964,2.10073461 19.5681205,2.00546676 C19.5847433,1.9101989 19.6147725,1.74355481 19.6348497,1.63514656 C19.654927,1.52673831 19.68706,1.35471861 19.7062552,1.25288055 C19.7254515,1.1510425 19.7552865,0.992461836 19.7725549,0.900479078 C19.7898244,0.80849632 19.8207636,0.647227848 19.841308,0.542104696 C19.8618536,0.436981544 19.8918657,0.289152111 19.9080008,0.213594845 C19.9241371,0.13803758 19.9373165,0.0721862871 19.9372885,0.0672586394 L19.9372886,0.0582992798 L19.6776105,0.0582992798 L19.4179324,0.0582992798 L19.4102629,0.132960609 C19.4060453,0.174024341 19.386167,0.309758638 19.3660873,0.434592381 C19.3460089,0.559426124 19.3132764,0.758323906 19.2933496,0.876587452 C19.2734228,0.994850998 19.2542119,1.109532 19.2506592,1.13143345 L19.2442006,1.17125601 L19.2237071,1.16267653 C19.2124364,1.15795674 19.1513431,1.14127321 19.0879458,1.12560031 L18.9726778,1.09710477 L18.8149427,1.08501083 L18.6572076,1.07291569 L18.5237395,1.08516015 L18.3902713,1.09740461 L18.2689366,1.12760004 L18.147602,1.15779547 L18.032334,1.21314639 L17.9170661,1.26849731 L17.8321318,1.33040529 L17.7471975,1.39231447 L17.6738471,1.46974245 C17.6335045,1.51232808 17.5752238,1.58276537 17.5443344,1.62626963 L17.488171,1.70537002 L17.4222183,1.84048553 C17.3859453,1.91479923 17.3418026,2.01323153 17.3241241,2.05922291 C17.3064456,2.10521429 17.2752675,2.20716464 17.2548384,2.28577884 L17.2176966,2.42871287 L17.1993969,2.61428869 L17.1810984,2.7998633 L17.1948396,2.94918596 L17.2085795,3.09850862 L17.224825,3.15226478 C17.2337589,3.18183067 17.2525985,3.23450692 17.2666891,3.26932419 L17.2923089,3.33262744 L17.3390179,3.39487707 L17.3857281,3.45712789 L17.4390608,3.5001364 L17.4923947,3.54314491 L17.5651955,3.57873388 C17.6052359,3.59830709 17.6724044,3.62360354 17.714459,3.63494729 C17.7565136,3.64629103 17.8247643,3.65990926 17.8661273,3.66521081 C17.9074903,3.67051236 17.9932036,3.67549377 18.056601,3.67628099 L18.0566228,3.67628099 Z M18.2635057,3.33735678 L18.1718907,3.34214706 L18.1100549,3.33118916 C18.0760448,3.3251625 18.0216226,3.30900698 17.989117,3.29528841 L17.9300149,3.27034555 L17.8802835,3.23022554 L17.830552,3.19010433 L17.7935947,3.12041485 L17.7566361,3.05072537 L17.7397949,2.97307759 L17.7229524,2.8954298 L17.7243805,2.74013424 L17.7258074,2.58483867 L17.7453666,2.44746183 L17.7649257,2.31008498 L17.7953249,2.21451848 C17.8120436,2.1619569 17.8258042,2.11236625 17.8259049,2.10431836 C17.8260262,2.09627046 17.8425132,2.05326554 17.8625892,2.00875185 C17.8826665,1.96423817 17.9162082,1.89556528 17.9371288,1.8561441 C17.9580481,1.81672291 17.9971506,1.75526768 18.0240226,1.71957718 C18.0508934,1.68388667 18.0987648,1.63013051 18.1304016,1.60011905 C18.1620384,1.57010758 18.2123656,1.53074374 18.2422382,1.51264345 L18.2965536,1.47973512 L18.3919567,1.44723295 L18.4873609,1.41473079 L18.6875631,1.41461133 L18.8877654,1.41461133 L19.0030333,1.44609571 C19.0664307,1.46341117 19.1337447,1.48349327 19.1526184,1.49072169 L19.1869367,1.50386327 L19.1802341,1.53665453 C19.176548,1.55468912 19.1621274,1.63395198 19.1481884,1.71279434 C19.1342495,1.79163671 19.1067842,1.94215395 19.0871522,2.0472771 C19.0675203,2.15240025 19.0373589,2.31098092 19.0201245,2.39967858 C19.0028914,2.48837624 18.9779292,2.60126417 18.9646527,2.65054064 C18.9513763,2.69981712 18.9326471,2.76806952 18.9230301,2.80221304 C18.9134143,2.83635657 18.890516,2.89548834 18.872146,2.93361698 C18.8537759,2.97174563 18.8216307,3.02713239 18.8007126,3.05669828 C18.7797957,3.08626416 18.7444145,3.12722038 18.7220889,3.14771103 C18.6997633,3.16820288 18.6514661,3.2046173 18.6147623,3.22863316 L18.5480283,3.2722975 L18.4515745,3.30243201 L18.3551207,3.33256771 L18.2635057,3.33735798 L18.2635057,3.33735678 Z M0.406035224,3.61815148 L0.700846957,3.61815148 L0.721999232,3.48973399 C0.733631588,3.41910437 0.756352721,3.28337007 0.772489021,3.18810222 C0.78862532,3.09283436 0.818658081,2.91543904 0.839229163,2.7938904 C0.859799032,2.67234175 0.890636242,2.49225862 0.907755352,2.39370567 C0.924874463,2.29515271 0.952074059,2.14227379 0.968198225,2.05397392 C0.984323604,1.96567525 1.00057639,1.89041663 1.00431713,1.88673254 L1.01111794,1.88003572 L1.80383747,1.88003572 L2.596557,1.88003572 L2.60535861,1.88869883 L2.61416145,1.89736193 L2.60041544,1.96634661 C2.59285507,2.0042877 2.57049188,2.12134114 2.55072039,2.22646429 C2.53094769,2.33158744 2.49770806,2.50898276 2.47685426,2.62067611 C2.45600047,2.73236946 2.42584638,2.89095012 2.40984597,2.97307759 C2.39384435,3.05520505 2.36146377,3.22722475 2.33788965,3.3553436 C2.31431432,3.48346244 2.29507549,3.59500646 2.29513616,3.60321921 L2.2952575,3.61815148 L2.59128136,3.61815148 L2.88730644,3.61815148 L2.90040452,3.54349015 C2.90760938,3.50242641 2.91920048,3.4285117 2.92616388,3.37923522 C2.93312606,3.32995874 2.9499115,3.22513424 2.96346337,3.14629187 C2.97701646,3.06744951 3.00409472,2.91155665 3.02363688,2.7998633 C3.04317905,2.68816995 3.07588966,2.4973356 3.09632728,2.37578695 C3.11676368,2.25423831 3.14708242,2.07684299 3.16370127,1.98157513 C3.18032,1.88630727 3.2099327,1.7250388 3.22950738,1.62320075 C3.24908194,1.52136269 3.28168651,1.34934299 3.30196202,1.24093474 C3.32223741,1.13252649 3.3526127,0.96857021 3.36946269,0.876587452 C3.3863128,0.784604694 3.41703596,0.617960606 3.43773662,0.506267257 C3.45843729,0.394573908 3.48457667,0.264215227 3.49582403,0.216581299 L3.5162739,0.129974156 L3.21654665,0.129974156 L2.91681989,0.129974156 L2.90866742,0.186716767 C2.9041841,0.217925202 2.88970402,0.305278958 2.87649067,0.380836224 C2.86327611,0.456393489 2.83924092,0.590783883 2.82307672,0.679481542 C2.80691251,0.768179202 2.77737358,0.937511097 2.75743465,1.05577464 C2.73749451,1.17403819 2.7120846,1.33059045 2.7009667,1.40366896 L2.68075113,1.53653985 L2.24076366,1.54530688 L1.80077498,1.55407391 L1.43224272,1.54546337 C1.22954949,1.54072805 1.0625869,1.53591269 1.06121339,1.53476231 C1.05983988,1.53361551 1.06674383,1.4871905 1.07655495,1.43160066 C1.08636486,1.37601082 1.10492543,1.27945999 1.11780025,1.21704312 C1.13067507,1.15462624 1.15508154,1.03098708 1.17203685,0.942289422 C1.18899095,0.853591763 1.20819702,0.74339164 1.21471511,0.697400261 C1.22123321,0.651408882 1.23489429,0.574806358 1.24507305,0.52717243 C1.25525061,0.479538501 1.27456709,0.379202037 1.28799762,0.304203835 C1.30142816,0.229204439 1.31573716,0.159321434 1.3197958,0.148908269 L1.32717538,0.129974156 L1.02986779,0.129974156 L0.732560203,0.129974156 L0.713517938,0.234500018 C0.703043115,0.291989241 0.689078706,0.373967381 0.682484166,0.416673662 C0.675889626,0.459379942 0.653744833,0.596458144 0.633273245,0.721291887 C0.612802871,0.84612563 0.582582041,1.03158437 0.566118138,1.13342243 C0.549653021,1.23526048 0.519668795,1.42071922 0.499487197,1.54555297 C0.479305599,1.67038671 0.446005295,1.86390887 0.4254876,1.97560222 C0.404969905,2.08729557 0.375264748,2.24587624 0.359476679,2.3280037 C0.343687397,2.41013116 0.313600035,2.56602402 0.292613988,2.67443227 C0.271629155,2.78284052 0.241013987,2.93604557 0.224581631,3.01488793 C0.208148062,3.0937303 0.189981833,3.18511576 0.184209942,3.21796675 C0.178439265,3.25081773 0.159657869,3.34556595 0.142475664,3.42851887 C0.125292247,3.51147178 0.111233197,3.58807431 0.111233197,3.5987467 L0.111233197,3.61815148 L0.40604493,3.61815148 L0.406035224,3.61815148 Z M3.6696828,3.61815148 L3.93066933,3.61815148 L3.93803423,3.59925559 C3.94208498,3.58886273 3.94539912,3.56160239 3.94539912,3.53867598 C3.94539912,3.51574958 3.96181061,3.39658174 3.98186905,3.27385882 C4.00192749,3.1511347 4.03506982,2.95127648 4.0555186,2.82972783 C4.07596737,2.70817919 4.10616636,2.53078387 4.12262747,2.43551601 C4.13908859,2.34024816 4.16836313,2.18166749 4.18768216,2.08311454 C4.20700119,1.98456158 4.23665805,1.83135654 4.2535863,1.74265888 C4.27051468,1.65396122 4.3038043,1.48521228 4.32756345,1.3676607 C4.3513226,1.25010912 4.37372499,1.14921121 4.37734671,1.14344138 L4.38393166,1.13295176 L4.1200058,1.13617355 L3.85607993,1.13939533 L3.83409918,1.2946909 C3.82200988,1.38010346 3.79557869,1.54943535 3.77536324,1.670984 C3.75514791,1.79253264 3.72457012,1.97799139 3.70741291,2.08311454 C3.69025558,2.18823769 3.66033444,2.35756959 3.64092138,2.45940764 C3.62150844,2.56124569 3.59175924,2.71713855 3.57481193,2.80583621 C3.55786476,2.89453387 3.52745513,3.05042672 3.50723495,3.15226478 C3.48701476,3.25410283 3.45988239,3.38849323 3.44694071,3.4509101 C3.43399891,3.51332697 3.42009966,3.57649045 3.41605327,3.5912734 L3.40869626,3.61815148 L3.6696828,3.61815148 Z M9.77371379,3.61815148 L10.0327662,3.61815148 L10.0405474,3.5102342 C10.0448257,3.45088023 10.0594866,3.33127278 10.0731246,3.24443986 C10.0867638,3.15760695 10.1146878,2.98442611 10.1351788,2.85959237 C10.155671,2.73475862 10.1937543,2.52697555 10.2198085,2.39785326 C10.2458627,2.26872977 10.2753155,2.14038396 10.2852589,2.11263742 C10.295201,2.08489208 10.3033365,2.05482685 10.3033365,2.04582568 C10.3033365,2.03682332 10.3228132,1.98777501 10.346619,1.9368285 C10.3704237,1.885882 10.4147873,1.80786868 10.4452047,1.76346729 L10.5005078,1.6827351 L10.5745377,1.61525798 L10.6485665,1.54777966 L10.7398538,1.50485597 L10.8311424,1.46193228 L10.9706773,1.46264903 L11.1102122,1.46336577 L11.1788136,1.48354942 C11.216545,1.49465186 11.2506704,1.50373426 11.2546478,1.50373426 C11.2586263,1.50373426 11.2618805,1.49103467 11.2618805,1.47551228 C11.2618805,1.45999108 11.2755307,1.38130521 11.2922142,1.30065544 C11.3088977,1.22000687 11.3225479,1.15061842 11.3225479,1.14646009 C11.3225479,1.14230175 11.2829624,1.12704814 11.2345802,1.11256384 C11.186198,1.09807954 11.1193123,1.08290836 11.0859452,1.07885156 L11.0252779,1.07147502 L10.9464103,1.08520913 C10.9030332,1.09276246 10.8385341,1.10943762 10.8030789,1.12226504 C10.7676249,1.13509245 10.7090846,1.16418528 10.6729899,1.18691816 C10.6368953,1.20964985 10.5807489,1.25394851 10.5482203,1.28535763 C10.5156916,1.31676676 10.4609794,1.3800951 10.4266368,1.42608648 C10.392293,1.47207786 10.356378,1.5204584 10.3468229,1.53359879 L10.3294514,1.55749042 L10.339999,1.50970717 C10.3458012,1.48342638 10.3619594,1.39741653 10.375908,1.31857416 C10.3898566,1.2397318 10.4041729,1.16581708 10.4077208,1.15431924 L10.4141733,1.13341406 L10.1828196,1.13341406 L9.95146594,1.13341406 L9.95146594,1.16220945 C9.95146594,1.1780472 9.93781118,1.27346438 9.92112208,1.37424762 C9.90443298,1.47503205 9.87691282,1.64350027 9.85996613,1.74862342 C9.84301943,1.85374657 9.8129425,2.03651751 9.79312843,2.15478105 C9.77331448,2.2730446 9.74322906,2.44237649 9.72627205,2.53107415 C9.70931504,2.61977181 9.67920475,2.77566467 9.65936022,2.87750272 C9.63951569,2.97934078 9.60656725,3.14598486 9.58614129,3.24782292 C9.56571544,3.34966097 9.54127633,3.46992783 9.53183225,3.515083 C9.52238804,3.56023818 9.51466108,3.6018992 9.51466108,3.60766305 L9.51466108,3.61815148 L9.77371379,3.61814311 L9.77371379,3.61815148 Z M15.9231926,3.61815148 L16.1880687,3.61815148 L16.1880687,3.53834508 L16.1880687,3.4585375 L16.2185916,3.26060494 C16.2353807,3.15174036 16.2630766,2.97934914 16.2801399,2.87751109 C16.2972031,2.77567303 16.3184719,2.64665825 16.3274021,2.59081158 C16.3363336,2.53496491 16.3600011,2.41401355 16.3799983,2.32203079 C16.3999955,2.23004804 16.4249722,2.13059914 16.4355041,2.10103326 C16.4460347,2.07146737 16.4547308,2.04044768 16.4548278,2.03210114 C16.4549492,2.0237546 16.4775041,1.97007848 16.5050034,1.9128222 L16.555003,1.80871922 L16.6209641,1.72243342 L16.6869253,1.63614762 L16.7591146,1.58271997 C16.7988189,1.55333566 16.862664,1.51433975 16.9009912,1.49606385 L16.9706774,1.46283419 L17.1223457,1.46386153 L17.2740141,1.46488886 L17.3337192,1.48376564 L17.3934244,1.50264122 L17.4034867,1.49651779 L17.413549,1.49039556 L17.4140586,1.45227648 C17.4143376,1.43131157 17.4273241,1.35330183 17.4429192,1.27892123 L17.4712752,1.14368388 L17.4393799,1.13139044 C17.4218386,1.12462911 17.3801856,1.1106334 17.3468185,1.10028833 L17.2861512,1.08147964 L17.17695,1.0817544 L17.0677488,1.08202915 L16.9787546,1.11285532 L16.8897605,1.1436803 L16.8229391,1.18334995 L16.7561176,1.22301961 L16.669242,1.3126132 L16.5823676,1.4022068 L16.5356913,1.47170873 C16.5100193,1.50993414 16.4874171,1.53950002 16.4854648,1.5374107 C16.4835113,1.53532018 16.4974648,1.45566431 16.5164719,1.36039645 C16.535479,1.2651286 16.5512658,1.17508703 16.5515534,1.16030409 L16.5520751,1.1334272 L16.327606,1.1334272 L16.1031368,1.1334272 L16.1031368,1.14103908 C16.1031368,1.14522489 16.0919461,1.22182741 16.0782681,1.31126691 C16.0645912,1.40070521 16.0371283,1.57333176 16.0172416,1.6948804 C15.9973536,1.81642905 15.9647218,2.01263902 15.9447271,2.13090257 C15.9247312,2.24916611 15.894588,2.41849801 15.8777419,2.50719567 C15.8608958,2.59589333 15.8309746,2.75178618 15.8112517,2.85362424 C15.7915287,2.95546229 15.7591214,3.11941857 15.7392359,3.21797153 C15.7193504,3.31652448 15.6930086,3.44688316 15.6806992,3.50765749 L15.6583178,3.61815625 L15.9231951,3.61815625 L15.9231926,3.61815148 Z M4.18287366,0.70311036 L4.25654638,0.703373168 L4.31510626,0.683728279 L4.37366602,0.664083389 L4.42549425,0.612324572 L4.47732236,0.56056456 L4.50462182,0.491606161 L4.53192127,0.422646568 L4.5328968,0.32110716 L4.53387233,0.219567752 L4.5096054,0.179918405 L4.48533846,0.140270252 L4.4430896,0.114516275 L4.40084074,0.0887622969 L4.30962145,0.0887622969 L4.21840216,0.0887611023 L4.15629991,0.116134932 L4.09419767,0.143508762 L4.05814865,0.181538257 L4.0220995,0.219567752 L3.99378945,0.285269722 L3.96547928,0.350971692 L3.96012782,0.453313859 L3.95477635,0.555656026 L3.98113328,0.606521296 L4.00749008,0.657385372 L4.05834557,0.680117059 L4.10920094,0.702848746 L4.18287366,0.703111554 L4.18287366,0.70311036 Z",
  id: "path2997"
})))), iX = {
  amex: tX,
  dinersclub: rX,
  discover: nX,
  hipercard: aX,
  jcb: eX,
  unionpay: qJ,
  mastercard: QJ,
  placeholder: XJ,
  visa: YJ,
  troy: JJ
};
function oX() {
  const { t: e } = K1(), [t, n] = ke(!1), {
    setCardNumber: r,
    setExpiryMonth: a,
    setExpiryYear: i,
    setCvc: o,
    setFormInvalid: s,
    cardHolderName: l,
    setCardHolderName: c
  } = rv(), { meta: u, getCardImageProps: d, getCardNumberProps: p, getExpiryDateProps: h, getCVCProps: m } = Tq({
    errorMessages: {
      dateOutOfRange: e("public_pages_purchase.payment_inputs.date_out_of_range"),
      emptyCVC: e("public_pages_purchase.payment_inputs.empty_cvc"),
      invalidCVC: e("public_pages_purchase.payment_inputs.invalid_cvc"),
      emptyCardNumber: e("public_pages_purchase.payment_inputs.empty_card_number"),
      invalidCardNumber: e("public_pages_purchase.payment_inputs.invalid_card_number"),
      emptyExpiryDate: e("public_pages_purchase.payment_inputs.empty_expiry_date"),
      invalidExpiryDate: e("public_pages_purchase.payment_inputs.invalid_expiry_date"),
      monthOutOfRange: e("public_pages_purchase.payment_inputs.month_out_of_range"),
      yearOutOfRange: e("public_pages_purchase.payment_inputs.year_out_of_range")
    }
  }), f = l === "", C = t && f;
  Re(() => {
    const b = l.match(/^[a-zA-Z]+ [a-zA-Z]+$/);
    s(!!u.error || f || !b);
  }, [l, C, f, u.error, s]);
  const _ = (b) => {
    r(b.target.value.replace(/\s/g, ""));
  }, v = (b) => {
    const [S, P] = b.target.value.replace(/\s/g, "").split("/");
    S && P && S.length === 2 && P.length === 2 && (a(S), i(P));
  }, w = (b) => {
    o(b.target.value);
  }, {
    state: { primaryColor: k }
  } = wr();
  return /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ x.jsxs("div", { className: "flex flex-wrap gap-3", children: [
      /* @__PURE__ */ x.jsx(
        wi,
        {
          ...p({ onChange: _ }),
          addonBefore: /* @__PURE__ */ x.jsx("svg", { ...d({ images: iX }) }),
          placeholder: e("public_pages_purchase.payment_inputs.card_number_placeholder"),
          inputClassName: "focus:!border-THEME-primary",
          error: u.touchedInputs.cardNumber ? u.erroredInputs.cardNumber : ""
        }
      ),
      /* @__PURE__ */ x.jsx(
        wi,
        {
          ...h({ onChange: v }),
          placeholder: e("public_pages_purchase.payment_inputs.expiry_data_placeholder"),
          error: u.touchedInputs.expiryDate ? u.erroredInputs.expiryDate : "",
          inputClassName: "focus:!border-THEME-primary",
          className: "w-24"
        }
      )
    ] }),
    /* @__PURE__ */ x.jsxs("div", { className: "flex flex-wrap gap-3", children: [
      /* @__PURE__ */ x.jsx(
        wi,
        {
          addonBefore: /* @__PURE__ */ x.jsx(ZL, { height: 14, width: 21, fill: k }),
          type: "text",
          autoComplete: "cc-name",
          id: "cardName",
          name: "cardName",
          spellCheck: "false",
          "aria-label": e("public_pages_purchase.payment_inputs.card_holder_placeholder"),
          value: l,
          inputClassName: "focus:!border-THEME-primary",
          onChange: (b) => c(b.target.value),
          placeholder: e("public_pages_purchase.payment_inputs.card_holder_placeholder"),
          onBlur: () => n(!0),
          error: C ? e("public_pages_purchase.payment_inputs.empty_card_holder") : ""
        }
      ),
      /* @__PURE__ */ x.jsx(
        wi,
        {
          ...m({ onChange: w }),
          placeholder: e("public_pages_purchase.payment_inputs.cvc_placeholder"),
          error: u.touchedInputs.cvc ? u.erroredInputs.cvc : "",
          inputClassName: "focus:!border-THEME-primary",
          className: "w-24"
        }
      )
    ] })
  ] });
}
const sX = (e, t) => {
  switch (e) {
    case ge.stripe_card:
      return /* @__PURE__ */ x.jsx(AY, { ...t });
    case ge.stripe_ideal:
      return /* @__PURE__ */ x.jsx(jY, {});
    case ge.mercadopago_ar_card:
    case ge.mercadopago_br_card:
    case ge.mercadopago_cl_card:
    case ge.mercadopago_co_card:
    case ge.mercadopago_mx_card:
      return /* @__PURE__ */ x.jsx(oq, {});
    case ge.xendit_id_card:
    case ge.xendit_ph_card:
      return /* @__PURE__ */ x.jsx(oX, {});
  }
};
function lX(e) {
  switch (e) {
    case Ct.SPANISH:
      return "es-AR";
    case Ct.PORTUGUESE:
      return "pt-BR";
    case Ct.ENGLISH:
      return "en-US";
    default:
      return "en-US";
  }
}
function $ne({
  children: e,
  publicKey: t,
  forceInitialization: n
}) {
  const { locale: r } = Rt(), { paymentMethod: a } = Dr(), { setInitialized: i } = av();
  return Re(() => {
    !t || !(a === ge.mercadopago_ar_card || a === ge.mercadopago_br_card || a === ge.mercadopago_br_pix || a === ge.mercadopago_br_boleto || a === ge.mercadopago_cl_card || a === ge.mercadopago_co_card || a === ge.mercadopago_mx_card || n) || (YY(t, { locale: lX(r) }), i(!0));
  }, [a, n, t, r]), e;
}
const cX = [
  p1.CHILEAN_PESO,
  p1.GUINEAN_FRANC,
  p1.JAPANESE_YEN,
  p1.RWANDAN_FRANC,
  p1.UGANDAN_SHILLING,
  p1.CENTRAL_AFRICAN_FRANC,
  p1.WEST_AFRICAN_CFA_FRANC_BCEAO
];
function t0({ children: e, paymentMethodType: t }) {
  const { stripePromise: n } = GW(), { locale: r } = Rt(), { currency: a, finalAmount: i } = Dr(), { state: o } = wr(), { primaryColor: s, textColorSecondary: l } = S8(o), c = i && i > 0 && t !== "ideal" ? "payment" : "setup", u = (() => {
    if (i && c === "payment" && a)
      return cX.includes(a) ? h1(i) : i;
  })(), d = {
    mode: c,
    amount: u,
    payment_method_types: [t],
    currency: a,
    paymentMethodCreation: "manual",
    locale: r,
    appearance: {
      variables: {
        colorPrimary: s
      },
      rules: {
        ".Label": {
          color: l
        }
      }
    }
  };
  return /* @__PURE__ */ x.jsx(
    Ub,
    {
      stripe: n,
      options: d,
      children: e
    },
    [d.mode, d.amount, d.payment_method_types].flat().filter(Boolean).join("-")
  );
}
const uX = (e) => {
  switch (e) {
    case ge.stripe_bancontact:
      return ({ children: t }) => /* @__PURE__ */ x.jsx(t0, { paymentMethodType: "bancontact", children: t });
    case ge.stripe_applepay:
    case ge.stripe_card:
      return ({ children: t }) => /* @__PURE__ */ x.jsx(t0, { paymentMethodType: "card", children: t });
    case ge.stripe_ideal:
      return ({ children: t }) => /* @__PURE__ */ x.jsx(t0, { paymentMethodType: "ideal", children: t });
    default:
      return M.Fragment;
  }
}, A_ = (e) => {
  const { paymentMethod: t } = Dr();
  return {
    PaymentProcessorProvider: _e(
      () => uX(t),
      [t]
    ),
    paymentProcessorDetails: sX(t, e),
    paymentProcessorPaymentButton: VY(t, e)
  };
}, uc = (e) => JSON.parse(JSON.stringify(e)), dc = (e) => Object.values(e).some(
  (t) => Array.isArray(t) ? t.length > 0 : dc(t)
), O_ = (e, t) => {
  var o;
  const { common: n, ...r } = uc(t), a = { ...r, ...((o = e.errors) == null ? void 0 : o.fields) || {} };
  return {
    common: e.errors.common ?? n,
    ...a
  };
};
/*! js-cookie v3.0.5 | MIT */
function q9(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var dX = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Zl(e, t) {
  function n(a, i, o) {
    if (!(typeof document > "u")) {
      o = q9({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var l in o)
        o[l] && (s += "; " + l, o[l] !== !0 && (s += "=" + o[l].split(";")[0]));
      return document.cookie = a + "=" + e.write(i, a) + s;
    }
  }
  function r(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], o = {}, s = 0; s < i.length; s++) {
        var l = i[s].split("="), c = l.slice(1).join("=");
        try {
          var u = decodeURIComponent(l[0]);
          if (o[u] = e.read(c, u), a === u)
            break;
        } catch {
        }
      }
      return a ? o[a] : o;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(a, i) {
        n(
          a,
          "",
          q9({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return Zl(this.converter, q9({}, this.attributes, a));
      },
      withConverter: function(a) {
        return Zl(q9({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var kh = Zl(dX, { path: "/" });
const N_ = ({
  pagePath: e,
  handlerError: t
}) => {
  const n = "error_message", r = kh.get(n);
  Re(() => {
    r && (t(r), kh.remove(n, {
      path: e
    }));
  }, [r, e]);
}, j_ = (e) => {
  switch (e) {
    case Ar.download:
      return $e.product_download_cover;
    case Ar.eCourse:
      return $e.e_course_cover;
    case Ar.physicalProduct:
      return $e.physical_product_cover;
  }
}, Mh = (e, t) => Object.keys(e).includes(t), R_ = (e, t) => {
  const n = [];
  return Object.values(Ut).forEach((r) => {
    const a = Mh(t, r), i = Mh(e, r);
    !a && i && n.push(...e[r]);
  }), n;
}, D_ = (e, t) => yt(e.price * (t ?? 0) / 100), pX = (e, t) => {
  const n = D_(e, t);
  return yt(n + e.price);
}, hX = ({
  calculatePrice: e,
  productVariant: t,
  product: n,
  quantity: r
}) => e != null && e.netAmount ? e.netAmount : t != null && t.price ? yt((t == null ? void 0 : t.price) * r) : yt(n.price * r), mX = ({ product: e, hasShipping: t, calculatePrice: n }) => {
  const { locale: r } = qr(), { quantity: a, productVariant: i } = b9(), { t: o } = K1();
  return e && e.name && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ x.jsxs("div", { className: "flex gap-1 text-[16px]", children: [
        /* @__PURE__ */ x.jsx("span", { children: e.name }),
        /* @__PURE__ */ x.jsxs("span", { className: "font-bold", children: [
          "x",
          a
        ] })
      ] }),
      /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ x.jsx(cr, { currency: e.currency }),
        /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
          h1(
            hX({
              calculatePrice: n,
              productVariant: i,
              product: e,
              quantity: a
            })
          ),
          e.currency,
          r
        ) })
      ] })
    ] }),
    !!(n != null && n.tax) && /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ x.jsx("span", { className: "text-[16px]", children: o("public_pages_purchase.vat_percent", {
        percent: n.tax.rate
      }) }),
      /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ x.jsx(cr, { currency: e.currency }),
        /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
          h1(n.tax.amount),
          e.currency,
          r
        ) })
      ] })
    ] }),
    !!(n != null && n.grossAmount) && /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ x.jsx("span", { className: "text-[16px]", children: o(t ? "public_pages_purchase.subtotal" : "public_pages_purchase.total") }),
      /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ x.jsx(cr, { currency: e.currency }),
        /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
          h1(n.grossAmount),
          e.currency,
          r
        ) })
      ] })
    ] })
  ] });
}, fX = ({
  product: e,
  selectedShipping: t,
  calculatePrice: n
}) => {
  var o;
  const { locale: r } = qr(), { t: a } = K1(), i = D_(t, (o = n == null ? void 0 : n.tax) == null ? void 0 : o.rate);
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
    /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ x.jsx("span", { className: "text-[16px]", children: a("public_pages_purchase.shipping_fee") }),
      /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ x.jsx(cr, { currency: t.currency }),
        /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
          h1(t.price),
          e.currency,
          r
        ) })
      ] })
    ] }),
    i > 0 && /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ x.jsx("span", { className: "text-[16px]", children: a("public_pages_purchase.vat_percent", {
        percent: n == null ? void 0 : n.tax.rate
      }) }),
      /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ x.jsx(cr, { currency: t.currency }),
        /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
          h1(i),
          t.currency,
          r
        ) })
      ] })
    ] })
  ] });
}, CX = ({ product: e, calculatePrice: t, isLoading: n }) => {
  const { t: r } = K1(), { locale: a } = qr(), { selectedShipping: i } = b9(), { finalAmount: o } = Dr(), s = !!i, l = s ? pX(i, (t == null ? void 0 : t.tax.rate) ?? 0) : 0, c = yt(Math.ceil(o ?? 0) + l);
  return /* @__PURE__ */ x.jsxs("div", { className: M1("flex flex-col gap-1", n && "animate-pulse"), children: [
    /* @__PURE__ */ x.jsx(ba, { label: r("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ x.jsxs("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      /* @__PURE__ */ x.jsx(mX, { product: e, hasShipping: s, calculatePrice: t }),
      s && /* @__PURE__ */ x.jsx(
        fX,
        {
          product: e,
          selectedShipping: i,
          calculatePrice: t
        }
      ),
      c > 0 && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx("div", { className: "bg-text-secondary/30 h-[1px] w-full" }),
        /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
          /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: r("public_pages_purchase.total_amount_with_tax_and_shipping") }),
          /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ x.jsx(cr, { currency: e.currency }),
            /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
              h1(c),
              e.currency,
              a
            ) })
          ] })
        ] })
      ] })
    ] })
  ] });
}, I_ = (e, t, n, r) => {
  const i = t.optionValueIds.map((o) => n.optionValues.map((l) => l.id).includes(o) ? r.id : o);
  return e.productVariants.find(
    (o) => JSON.stringify(o.optionValueIds) === JSON.stringify(i)
  );
}, gX = (e, t, n, r) => !!I_(e, t, n, r), yX = ({ product: e, activeVariant: t, changeActiveVariant: n }) => {
  const r = (a, i) => {
    const o = I_(e, t, a, i);
    o && n(o);
  };
  return /* @__PURE__ */ x.jsx("div", { className: "flex flex-col gap-2", children: e.options.map((a) => /* @__PURE__ */ x.jsxs("div", { children: [
    /* @__PURE__ */ x.jsx("span", { children: a.name }),
    /* @__PURE__ */ x.jsx("div", { className: "flex flex-wrap gap-2", children: a.optionValues.map((i) => {
      const o = t.optionValueIds.includes(i.id);
      return /* @__PURE__ */ x.jsx(
        Zg,
        {
          type: "button",
          onClick: () => r(a, i),
          disabled: !gX(e, t, a, i),
          color: o ? "text-THEME-primary" : "text-THEME-text-secondary",
          hoverColor: `hover:${o ? "text-THEME-primary" : "text-THEME-text-secondary"}`,
          backgroundColor: o ? "bg-THEME-tertiary" : "bg-THEME-secondary",
          hoverBackgroundColor: o ? "hover:bg-THEME-tertiary" : "hover:bg-THEME-secondary",
          borderColor: o ? "border-THEME-tertiary" : "border-THEME-border-tertiary",
          children: i.value
        },
        i.id
      );
    }) })
  ] }, a.id)) });
}, Ph = "w-8 h-full main-transition-colors hover:bg-THEME-tertiary text-THEME-text-secondary hover:text-THEME-text-secondary", vX = ({
  quantity: e,
  onIncrease: t,
  onDecrease: n,
  disabledIncreaseButton: r,
  disabledDecreaseButton: a
}) => {
  const { t: i } = K1();
  return /* @__PURE__ */ x.jsxs("div", { className: "flex justify-between", children: [
    /* @__PURE__ */ x.jsx("span", { children: i("public_pages_purchase.quantity") }),
    /* @__PURE__ */ x.jsxs(
      "div",
      {
        className: "border-THEME-border-tertiary flex h-8 items-center overflow-hidden rounded-md border text-[16px]",
        children: [
          /* @__PURE__ */ x.jsx(
            "button",
            {
              disabled: a,
              type: "button",
              onClick: n,
              className: Ph,
              children: "-"
            }
          ),
          /* @__PURE__ */ x.jsx("span", { className: "inline-block min-w-8 text-center font-bold", children: e }),
          /* @__PURE__ */ x.jsx(
            "button",
            {
              disabled: r,
              type: "button",
              onClick: t,
              className: Ph,
              children: "+"
            }
          )
        ]
      }
    )
  ] });
};
function Wa() {
  return Wa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Wa.apply(null, arguments);
}
function Eh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ve(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Eh(Object(n), !0).forEach(function(r) {
      Ke(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Eh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bX(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function P9(e, t) {
  if (t && (Br(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return bX(e);
}
function go() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (go = function() {
    return !!e;
  })();
}
function Kr(e) {
  return Kr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Kr(e);
}
function Kl(e, t) {
  return Kl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Kl(e, t);
}
function yo(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Kl(e, t);
}
var _X = {
  animating: !1,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: !1,
  edgeDragged: !1,
  initialized: !1,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: !1,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: !1,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: !1,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0,
  targetSlide: 0
};
function wX(e, t, n) {
  var r = n || {}, a = r.noTrailing, i = a === void 0 ? !1 : a, o = r.noLeading, s = o === void 0 ? !1 : o, l = r.debounceMode, c = l === void 0 ? void 0 : l, u, d = !1, p = 0;
  function h() {
    u && clearTimeout(u);
  }
  function m(C) {
    var _ = C || {}, v = _.upcomingOnly, w = v === void 0 ? !1 : v;
    h(), d = !w;
  }
  function f() {
    for (var C = arguments.length, _ = new Array(C), v = 0; v < C; v++)
      _[v] = arguments[v];
    var w = this, k = Date.now() - p;
    if (d)
      return;
    function b() {
      p = Date.now(), t.apply(w, _);
    }
    function S() {
      u = void 0;
    }
    !s && c && !u && b(), h(), c === void 0 && k > e ? s ? (p = Date.now(), i || (u = setTimeout(c ? S : b, e))) : b() : i !== !0 && (u = setTimeout(c ? S : b, c === void 0 ? e - k : e));
  }
  return f.cancel = m, f;
}
function xX(e, t, n) {
  var r = {}, a = r.atBegin, i = a === void 0 ? !1 : a;
  return wX(e, t, {
    debounceMode: i !== !1
  });
}
var H_ = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        s && (i = a(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var o = "";
      for (var s in i)
        t.call(i, s) && i[s] && (o = a(o, s));
      return o;
    }
    function a(i, o) {
      return o ? i ? i + " " + o : i + o : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(H_);
var SX = H_.exports;
const V2 = /* @__PURE__ */ Js(SX);
var $l = {
  accessibility: !0,
  adaptiveHeight: !1,
  afterChange: null,
  appendDots: function(t) {
    return /* @__PURE__ */ M.createElement("ul", {
      style: {
        display: "block"
      }
    }, t);
  },
  arrows: !0,
  autoplay: !1,
  autoplaySpeed: 3e3,
  beforeChange: null,
  centerMode: !1,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function(t) {
    return /* @__PURE__ */ M.createElement("button", null, t + 1);
  },
  dots: !1,
  dotsClass: "slick-dots",
  draggable: !0,
  easing: "linear",
  edgeFriction: 0.35,
  fade: !1,
  focusOnSelect: !1,
  infinite: !0,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: !1,
  pauseOnFocus: !1,
  pauseOnHover: !0,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: !1,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: !0,
  swipeEvent: null,
  swipeToSlide: !1,
  touchMove: !0,
  touchThreshold: 5,
  useCSS: !0,
  useTransform: !0,
  variableWidth: !1,
  vertical: !1,
  waitForAnimate: !0,
  asNavFor: null
};
function Wl(e, t, n) {
  return Math.max(t, Math.min(e, n));
}
var Ai = function(t) {
  var n = ["onTouchStart", "onTouchMove", "onWheel"];
  n.includes(t._reactName) || t.preventDefault();
}, v5 = function(t) {
  for (var n = [], r = F_(t), a = V_(t), i = r; i < a; i++)
    t.lazyLoadedList.indexOf(i) < 0 && n.push(i);
  return n;
}, F_ = function(t) {
  return t.currentSlide - kX(t);
}, V_ = function(t) {
  return t.currentSlide + MX(t);
}, kX = function(t) {
  return t.centerMode ? Math.floor(t.slidesToShow / 2) + (parseInt(t.centerPadding) > 0 ? 1 : 0) : 0;
}, MX = function(t) {
  return t.centerMode ? Math.floor((t.slidesToShow - 1) / 2) + 1 + (parseInt(t.centerPadding) > 0 ? 1 : 0) : t.slidesToShow;
}, Yl = function(t) {
  return t && t.offsetWidth || 0;
}, pc = function(t) {
  return t && t.offsetHeight || 0;
}, B_ = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r, a, i, o;
  return r = t.startX - t.curX, a = t.startY - t.curY, i = Math.atan2(a, r), o = Math.round(i * 180 / Math.PI), o < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 || o <= 360 && o >= 315 ? "left" : o >= 135 && o <= 225 ? "right" : n === !0 ? o >= 35 && o <= 135 ? "up" : "down" : "vertical";
}, H8 = function(t) {
  var n = !0;
  return t.infinite || (t.centerMode && t.currentSlide >= t.slideCount - 1 || t.slideCount <= t.slidesToShow || t.currentSlide >= t.slideCount - t.slidesToShow) && (n = !1), n;
}, r0 = function(t, n) {
  var r = {};
  return n.forEach(function(a) {
    return r[a] = t[a];
  }), r;
}, PX = function(t) {
  var n = M.Children.count(t.children), r = t.listRef, a = Math.ceil(Yl(r)), i = t.trackRef && t.trackRef.node, o = Math.ceil(Yl(i)), s;
  if (t.vertical)
    s = a;
  else {
    var l = t.centerMode && parseInt(t.centerPadding) * 2;
    typeof t.centerPadding == "string" && t.centerPadding.slice(-1) === "%" && (l *= a / 100), s = Math.ceil((a - l) / t.slidesToShow);
  }
  var c = r && pc(r.querySelector('[data-index="0"]')), u = c * t.slidesToShow, d = t.currentSlide === void 0 ? t.initialSlide : t.currentSlide;
  t.rtl && t.currentSlide === void 0 && (d = n - 1 - t.initialSlide);
  var p = t.lazyLoadedList || [], h = v5(ve(ve({}, t), {}, {
    currentSlide: d,
    lazyLoadedList: p
  }));
  p = p.concat(h);
  var m = {
    slideCount: n,
    slideWidth: s,
    listWidth: a,
    trackWidth: o,
    currentSlide: d,
    slideHeight: c,
    listHeight: u,
    lazyLoadedList: p
  };
  return t.autoplaying === null && t.autoplay && (m.autoplaying = "playing"), m;
}, EX = function(t) {
  var n = t.waitForAnimate, r = t.animating, a = t.fade, i = t.infinite, o = t.index, s = t.slideCount, l = t.lazyLoad, c = t.currentSlide, u = t.centerMode, d = t.slidesToScroll, p = t.slidesToShow, h = t.useCSS, m = t.lazyLoadedList;
  if (n && r)
    return {};
  var f = o, C, _, v, w = {}, k = {}, b = i ? o : Wl(o, 0, s - 1);
  if (a) {
    if (!i && (o < 0 || o >= s))
      return {};
    o < 0 ? f = o + s : o >= s && (f = o - s), l && m.indexOf(f) < 0 && (m = m.concat(f)), w = {
      animating: !0,
      currentSlide: f,
      lazyLoadedList: m,
      targetSlide: f
    }, k = {
      animating: !1,
      targetSlide: f
    };
  } else
    C = f, f < 0 ? (C = f + s, i ? s % d !== 0 && (C = s - s % d) : C = 0) : !H8(t) && f > c ? f = C = c : u && f >= s ? (f = i ? s : s - 1, C = i ? 0 : s - 1) : f >= s && (C = f - s, i ? s % d !== 0 && (C = 0) : C = s - p), !i && f + p >= s && (C = s - p), _ = Gs(ve(ve({}, t), {}, {
      slideIndex: f
    })), v = Gs(ve(ve({}, t), {}, {
      slideIndex: C
    })), i || (_ === v && (f = C), _ = v), l && (m = m.concat(v5(ve(ve({}, t), {}, {
      currentSlide: f
    })))), h ? (w = {
      animating: !0,
      currentSlide: C,
      trackStyle: z_(ve(ve({}, t), {}, {
        left: _
      })),
      lazyLoadedList: m,
      targetSlide: b
    }, k = {
      animating: !1,
      currentSlide: C,
      trackStyle: zs(ve(ve({}, t), {}, {
        left: v
      })),
      swipeLeft: null,
      targetSlide: b
    }) : w = {
      currentSlide: C,
      trackStyle: zs(ve(ve({}, t), {}, {
        left: v
      })),
      lazyLoadedList: m,
      targetSlide: b
    };
  return {
    state: w,
    nextState: k
  };
}, TX = function(t, n) {
  var r, a, i, o, s, l = t.slidesToScroll, c = t.slidesToShow, u = t.slideCount, d = t.currentSlide, p = t.targetSlide, h = t.lazyLoad, m = t.infinite;
  if (o = u % l !== 0, r = o ? 0 : (u - d) % l, n.message === "previous")
    i = r === 0 ? l : c - r, s = d - i, h && !m && (a = d - i, s = a === -1 ? u - 1 : a), m || (s = p - l);
  else if (n.message === "next")
    i = r === 0 ? l : r, s = d + i, h && !m && (s = (d + l) % u + r), m || (s = p + l);
  else if (n.message === "dots")
    s = n.index * n.slidesToScroll;
  else if (n.message === "children") {
    if (s = n.index, m) {
      var f = DX(ve(ve({}, t), {}, {
        targetSlide: s
      }));
      s > n.currentSlide && f === "left" ? s = s - u : s < n.currentSlide && f === "right" && (s = s + u);
    }
  } else
    n.message === "index" && (s = Number(n.index));
  return s;
}, LX = function(t, n, r) {
  return t.target.tagName.match("TEXTAREA|INPUT|SELECT") || !n ? "" : t.keyCode === 37 ? r ? "next" : "previous" : t.keyCode === 39 ? r ? "previous" : "next" : "";
}, AX = function(t, n, r) {
  return t.target.tagName === "IMG" && Ai(t), !n || !r && t.type.indexOf("mouse") !== -1 ? "" : {
    dragging: !0,
    touchObject: {
      startX: t.touches ? t.touches[0].pageX : t.clientX,
      startY: t.touches ? t.touches[0].pageY : t.clientY,
      curX: t.touches ? t.touches[0].pageX : t.clientX,
      curY: t.touches ? t.touches[0].pageY : t.clientY
    }
  };
}, OX = function(t, n) {
  var r = n.scrolling, a = n.animating, i = n.vertical, o = n.swipeToSlide, s = n.verticalSwiping, l = n.rtl, c = n.currentSlide, u = n.edgeFriction, d = n.edgeDragged, p = n.onEdge, h = n.swiped, m = n.swiping, f = n.slideCount, C = n.slidesToScroll, _ = n.infinite, v = n.touchObject, w = n.swipeEvent, k = n.listHeight, b = n.listWidth;
  if (!r) {
    if (a)
      return Ai(t);
    i && o && s && Ai(t);
    var S, P = {}, O = Gs(n);
    v.curX = t.touches ? t.touches[0].pageX : t.clientX, v.curY = t.touches ? t.touches[0].pageY : t.clientY, v.swipeLength = Math.round(Math.sqrt(Math.pow(v.curX - v.startX, 2)));
    var A = Math.round(Math.sqrt(Math.pow(v.curY - v.startY, 2)));
    if (!s && !m && A > 10)
      return {
        scrolling: !0
      };
    s && (v.swipeLength = A);
    var L = (l ? -1 : 1) * (v.curX > v.startX ? 1 : -1);
    s && (L = v.curY > v.startY ? 1 : -1);
    var I = Math.ceil(f / C), D = B_(n.touchObject, s), U = v.swipeLength;
    return _ || (c === 0 && (D === "right" || D === "down") || c + 1 >= I && (D === "left" || D === "up") || !H8(n) && (D === "left" || D === "up")) && (U = v.swipeLength * u, d === !1 && p && (p(D), P.edgeDragged = !0)), !h && w && (w(D), P.swiped = !0), i ? S = O + U * (k / b) * L : l ? S = O - U * L : S = O + U * L, s && (S = O + U * L), P = ve(ve({}, P), {}, {
      touchObject: v,
      swipeLeft: S,
      trackStyle: zs(ve(ve({}, n), {}, {
        left: S
      }))
    }), Math.abs(v.curX - v.startX) < Math.abs(v.curY - v.startY) * 0.8 || v.swipeLength > 10 && (P.swiping = !0, Ai(t)), P;
  }
}, NX = function(t, n) {
  var r = n.dragging, a = n.swipe, i = n.touchObject, o = n.listWidth, s = n.touchThreshold, l = n.verticalSwiping, c = n.listHeight, u = n.swipeToSlide, d = n.scrolling, p = n.onSwipe, h = n.targetSlide, m = n.currentSlide, f = n.infinite;
  if (!r)
    return a && Ai(t), {};
  var C = l ? c / s : o / s, _ = B_(i, l), v = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (d || !i.swipeLength)
    return v;
  if (i.swipeLength > C) {
    Ai(t), p && p(_);
    var w, k, b = f ? m : h;
    switch (_) {
      case "left":
      case "up":
        k = b + Lh(n), w = u ? Th(n, k) : k, v.currentDirection = 0;
        break;
      case "right":
      case "down":
        k = b - Lh(n), w = u ? Th(n, k) : k, v.currentDirection = 1;
        break;
      default:
        w = b;
    }
    v.triggerSlideHandler = w;
  } else {
    var S = Gs(n);
    v.trackStyle = z_(ve(ve({}, n), {}, {
      left: S
    }));
  }
  return v;
}, jX = function(t) {
  for (var n = t.infinite ? t.slideCount * 2 : t.slideCount, r = t.infinite ? t.slidesToShow * -1 : 0, a = t.infinite ? t.slidesToShow * -1 : 0, i = []; r < n; )
    i.push(r), r = a + t.slidesToScroll, a += Math.min(t.slidesToScroll, t.slidesToShow);
  return i;
}, Th = function(t, n) {
  var r = jX(t), a = 0;
  if (n > r[r.length - 1])
    n = r[r.length - 1];
  else
    for (var i in r) {
      if (n < r[i]) {
        n = a;
        break;
      }
      a = r[i];
    }
  return n;
}, Lh = function(t) {
  var n = t.centerMode ? t.slideWidth * Math.floor(t.slidesToShow / 2) : 0;
  if (t.swipeToSlide) {
    var r, a = t.listRef, i = a.querySelectorAll && a.querySelectorAll(".slick-slide") || [];
    if (Array.from(i).every(function(l) {
      if (t.vertical) {
        if (l.offsetTop + pc(l) / 2 > t.swipeLeft * -1)
          return r = l, !1;
      } else if (l.offsetLeft - n + Yl(l) / 2 > t.swipeLeft * -1)
        return r = l, !1;
      return !0;
    }), !r)
      return 0;
    var o = t.rtl === !0 ? t.slideCount - t.currentSlide : t.currentSlide, s = Math.abs(r.dataset.index - o) || 1;
    return s;
  } else
    return t.slidesToScroll;
}, hc = function(t, n) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    n.reduce(function(r, a) {
      return r && t.hasOwnProperty(a);
    }, !0) ? null : console.error("Keys Missing:", t)
  );
}, zs = function(t) {
  hc(t, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var n, r;
  if (!t.vertical)
    n = RX(t) * t.slideWidth;
  else {
    var a = t.unslick ? t.slideCount : t.slideCount + 2 * t.slidesToShow;
    r = a * t.slideHeight;
  }
  var i = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (t.useTransform) {
    var o = t.vertical ? "translate3d(0px, " + t.left + "px, 0px)" : "translate3d(" + t.left + "px, 0px, 0px)", s = t.vertical ? "translate3d(0px, " + t.left + "px, 0px)" : "translate3d(" + t.left + "px, 0px, 0px)", l = t.vertical ? "translateY(" + t.left + "px)" : "translateX(" + t.left + "px)";
    i = ve(ve({}, i), {}, {
      WebkitTransform: o,
      transform: s,
      msTransform: l
    });
  } else
    t.vertical ? i.top = t.left : i.left = t.left;
  return t.fade && (i = {
    opacity: 1
  }), n && (i.width = n), r && (i.height = r), window && !window.addEventListener && window.attachEvent && (t.vertical ? i.marginTop = t.left + "px" : i.marginLeft = t.left + "px"), i;
}, z_ = function(t) {
  hc(t, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var n = zs(t);
  return t.useTransform ? (n.WebkitTransition = "-webkit-transform " + t.speed + "ms " + t.cssEase, n.transition = "transform " + t.speed + "ms " + t.cssEase) : t.vertical ? n.transition = "top " + t.speed + "ms " + t.cssEase : n.transition = "left " + t.speed + "ms " + t.cssEase, n;
}, Gs = function(t) {
  if (t.unslick)
    return 0;
  hc(t, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
  var n = t.slideIndex, r = t.trackRef, a = t.infinite, i = t.centerMode, o = t.slideCount, s = t.slidesToShow, l = t.slidesToScroll, c = t.slideWidth, u = t.listWidth, d = t.variableWidth, p = t.slideHeight, h = t.fade, m = t.vertical, f = 0, C, _, v = 0;
  if (h || t.slideCount === 1)
    return 0;
  var w = 0;
  if (a ? (w = -ha(t), o % l !== 0 && n + l > o && (w = -(n > o ? s - (n - o) : o % l)), i && (w += parseInt(s / 2))) : (o % l !== 0 && n + l > o && (w = s - o % l), i && (w = parseInt(s / 2))), f = w * c, v = w * p, m ? C = n * p * -1 + v : C = n * c * -1 + f, d === !0) {
    var k, b = r && r.node;
    if (k = n + ha(t), _ = b && b.childNodes[k], C = _ ? _.offsetLeft * -1 : 0, i === !0) {
      k = a ? n + ha(t) : n, _ = b && b.children[k], C = 0;
      for (var S = 0; S < k; S++)
        C -= b && b.children[S] && b.children[S].offsetWidth;
      C -= parseInt(t.centerPadding), C += _ && (u - _.offsetWidth) / 2;
    }
  }
  return C;
}, ha = function(t) {
  return t.unslick || !t.infinite ? 0 : t.variableWidth ? t.slideCount : t.slidesToShow + (t.centerMode ? 1 : 0);
}, M6 = function(t) {
  return t.unslick || !t.infinite ? 0 : t.slideCount;
}, RX = function(t) {
  return t.slideCount === 1 ? 1 : ha(t) + t.slideCount + M6(t);
}, DX = function(t) {
  return t.targetSlide > t.currentSlide ? t.targetSlide > t.currentSlide + IX(t) ? "left" : "right" : t.targetSlide < t.currentSlide - HX(t) ? "right" : "left";
}, IX = function(t) {
  var n = t.slidesToShow, r = t.centerMode, a = t.rtl, i = t.centerPadding;
  if (r) {
    var o = (n - 1) / 2 + 1;
    return parseInt(i) > 0 && (o += 1), a && n % 2 === 0 && (o += 1), o;
  }
  return a ? 0 : n - 1;
}, HX = function(t) {
  var n = t.slidesToShow, r = t.centerMode, a = t.rtl, i = t.centerPadding;
  if (r) {
    var o = (n - 1) / 2 + 1;
    return parseInt(i) > 0 && (o += 1), !a && n % 2 === 0 && (o += 1), o;
  }
  return a ? n - 1 : 0;
}, Ah = function() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}, FX = Object.keys($l);
function VX(e) {
  return FX.reduce(function(t, n) {
    return e.hasOwnProperty(n) && (t[n] = e[n]), t;
  }, {});
}
function BX(e, t, n) {
  return t = Kr(t), P9(e, go() ? Reflect.construct(t, n || [], Kr(e).constructor) : t.apply(e, n));
}
var n0 = function(t) {
  var n, r, a, i, o;
  t.rtl ? o = t.slideCount - 1 - t.index : o = t.index, a = o < 0 || o >= t.slideCount, t.centerMode ? (i = Math.floor(t.slidesToShow / 2), r = (o - t.currentSlide) % t.slideCount === 0, o > t.currentSlide - i - 1 && o <= t.currentSlide + i && (n = !0)) : n = t.currentSlide <= o && o < t.currentSlide + t.slidesToShow;
  var s;
  t.targetSlide < 0 ? s = t.targetSlide + t.slideCount : t.targetSlide >= t.slideCount ? s = t.targetSlide - t.slideCount : s = t.targetSlide;
  var l = o === s;
  return {
    "slick-slide": !0,
    "slick-active": n,
    "slick-center": r,
    "slick-cloned": a,
    "slick-current": l
    // dubious in case of RTL
  };
}, zX = function(t) {
  var n = {};
  return (t.variableWidth === void 0 || t.variableWidth === !1) && (n.width = t.slideWidth), t.fade && (n.position = "relative", t.vertical && t.slideHeight ? n.top = -t.index * parseInt(t.slideHeight) : n.left = -t.index * parseInt(t.slideWidth), n.opacity = t.currentSlide === t.index ? 1 : 0, n.zIndex = t.currentSlide === t.index ? 999 : 998, t.useCSS && (n.transition = "opacity " + t.speed + "ms " + t.cssEase + ", visibility " + t.speed + "ms " + t.cssEase)), n;
}, a0 = function(t, n) {
  return t.key + "-" + n;
}, GX = function(t) {
  var n, r = [], a = [], i = [], o = M.Children.count(t.children), s = F_(t), l = V_(t);
  return M.Children.forEach(t.children, function(c, u) {
    var d, p = {
      message: "children",
      index: u,
      slidesToScroll: t.slidesToScroll,
      currentSlide: t.currentSlide
    };
    !t.lazyLoad || t.lazyLoad && t.lazyLoadedList.indexOf(u) >= 0 ? d = c : d = /* @__PURE__ */ M.createElement("div", null);
    var h = zX(ve(ve({}, t), {}, {
      index: u
    })), m = d.props.className || "", f = n0(ve(ve({}, t), {}, {
      index: u
    }));
    if (r.push(/* @__PURE__ */ M.cloneElement(d, {
      key: "original" + a0(d, u),
      "data-index": u,
      className: V2(f, m),
      tabIndex: "-1",
      "aria-hidden": !f["slick-active"],
      style: ve(ve({
        outline: "none"
      }, d.props.style || {}), h),
      onClick: function(v) {
        d.props && d.props.onClick && d.props.onClick(v), t.focusOnSelect && t.focusOnSelect(p);
      }
    })), t.infinite && o > 1 && t.fade === !1 && !t.unslick) {
      var C = o - u;
      C <= ha(t) && (n = -C, n >= s && (d = c), f = n0(ve(ve({}, t), {}, {
        index: n
      })), a.push(/* @__PURE__ */ M.cloneElement(d, {
        key: "precloned" + a0(d, n),
        "data-index": n,
        tabIndex: "-1",
        className: V2(f, m),
        "aria-hidden": !f["slick-active"],
        style: ve(ve({}, d.props.style || {}), h),
        onClick: function(v) {
          d.props && d.props.onClick && d.props.onClick(v), t.focusOnSelect && t.focusOnSelect(p);
        }
      }))), n = o + u, n < l && (d = c), f = n0(ve(ve({}, t), {}, {
        index: n
      })), i.push(/* @__PURE__ */ M.cloneElement(d, {
        key: "postcloned" + a0(d, n),
        "data-index": n,
        tabIndex: "-1",
        className: V2(f, m),
        "aria-hidden": !f["slick-active"],
        style: ve(ve({}, d.props.style || {}), h),
        onClick: function(v) {
          d.props && d.props.onClick && d.props.onClick(v), t.focusOnSelect && t.focusOnSelect(p);
        }
      }));
    }
  }), t.rtl ? a.concat(r, i).reverse() : a.concat(r, i);
}, UX = /* @__PURE__ */ function(e) {
  function t() {
    var n;
    ni(this, t);
    for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++)
      a[i] = arguments[i];
    return n = BX(this, t, [].concat(a)), Ke(n, "node", null), Ke(n, "handleRef", function(o) {
      n.node = o;
    }), n;
  }
  return yo(t, e), ai(t, [{
    key: "render",
    value: function() {
      var r = GX(this.props), a = this.props, i = a.onMouseEnter, o = a.onMouseOver, s = a.onMouseLeave, l = {
        onMouseEnter: i,
        onMouseOver: o,
        onMouseLeave: s
      };
      return /* @__PURE__ */ M.createElement("div", Wa({
        ref: this.handleRef,
        className: "slick-track",
        style: this.props.trackStyle
      }, l), r);
    }
  }]);
}(M.PureComponent);
function ZX(e, t, n) {
  return t = Kr(t), P9(e, go() ? Reflect.construct(t, n || [], Kr(e).constructor) : t.apply(e, n));
}
var KX = function(t) {
  var n;
  return t.infinite ? n = Math.ceil(t.slideCount / t.slidesToScroll) : n = Math.ceil((t.slideCount - t.slidesToShow) / t.slidesToScroll) + 1, n;
}, $X = /* @__PURE__ */ function(e) {
  function t() {
    return ni(this, t), ZX(this, t, arguments);
  }
  return yo(t, e), ai(t, [{
    key: "clickHandler",
    value: function(r, a) {
      a.preventDefault(), this.props.clickHandler(r);
    }
  }, {
    key: "render",
    value: function() {
      for (var r = this.props, a = r.onMouseEnter, i = r.onMouseOver, o = r.onMouseLeave, s = r.infinite, l = r.slidesToScroll, c = r.slidesToShow, u = r.slideCount, d = r.currentSlide, p = KX({
        slideCount: u,
        slidesToScroll: l,
        slidesToShow: c,
        infinite: s
      }), h = {
        onMouseEnter: a,
        onMouseOver: i,
        onMouseLeave: o
      }, m = [], f = 0; f < p; f++) {
        var C = (f + 1) * l - 1, _ = s ? C : Wl(C, 0, u - 1), v = _ - (l - 1), w = s ? v : Wl(v, 0, u - 1), k = V2({
          "slick-active": s ? d >= w && d <= _ : d === w
        }), b = {
          message: "dots",
          index: f,
          slidesToScroll: l,
          currentSlide: d
        }, S = this.clickHandler.bind(this, b);
        m = m.concat(/* @__PURE__ */ M.createElement("li", {
          key: f,
          className: k
        }, /* @__PURE__ */ M.cloneElement(this.props.customPaging(f), {
          onClick: S
        })));
      }
      return /* @__PURE__ */ M.cloneElement(this.props.appendDots(m), ve({
        className: this.props.dotsClass
      }, h));
    }
  }]);
}(M.PureComponent);
function G_(e, t, n) {
  return t = Kr(t), P9(e, go() ? Reflect.construct(t, n || [], Kr(e).constructor) : t.apply(e, n));
}
var WX = /* @__PURE__ */ function(e) {
  function t() {
    return ni(this, t), G_(this, t, arguments);
  }
  return yo(t, e), ai(t, [{
    key: "clickHandler",
    value: function(r, a) {
      a && a.preventDefault(), this.props.clickHandler(r, a);
    }
  }, {
    key: "render",
    value: function() {
      var r = {
        "slick-arrow": !0,
        "slick-prev": !0
      }, a = this.clickHandler.bind(this, {
        message: "previous"
      });
      !this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow) && (r["slick-disabled"] = !0, a = null);
      var i = {
        key: "0",
        "data-role": "none",
        className: V2(r),
        style: {
          display: "block"
        },
        onClick: a
      }, o = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, s;
      return this.props.prevArrow ? s = /* @__PURE__ */ M.cloneElement(this.props.prevArrow, ve(ve({}, i), o)) : s = /* @__PURE__ */ M.createElement("button", Wa({
        key: "0",
        type: "button"
      }, i), " ", "Previous"), s;
    }
  }]);
}(M.PureComponent), YX = /* @__PURE__ */ function(e) {
  function t() {
    return ni(this, t), G_(this, t, arguments);
  }
  return yo(t, e), ai(t, [{
    key: "clickHandler",
    value: function(r, a) {
      a && a.preventDefault(), this.props.clickHandler(r, a);
    }
  }, {
    key: "render",
    value: function() {
      var r = {
        "slick-arrow": !0,
        "slick-next": !0
      }, a = this.clickHandler.bind(this, {
        message: "next"
      });
      H8(this.props) || (r["slick-disabled"] = !0, a = null);
      var i = {
        key: "1",
        "data-role": "none",
        className: V2(r),
        style: {
          display: "block"
        },
        onClick: a
      }, o = {
        currentSlide: this.props.currentSlide,
        slideCount: this.props.slideCount
      }, s;
      return this.props.nextArrow ? s = /* @__PURE__ */ M.cloneElement(this.props.nextArrow, ve(ve({}, i), o)) : s = /* @__PURE__ */ M.createElement("button", Wa({
        key: "1",
        type: "button"
      }, i), " ", "Next"), s;
    }
  }]);
}(M.PureComponent), U_ = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, n) {
    var r = -1;
    return t.some(function(a, i) {
      return a[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function t() {
        this.__entries__ = [];
      }
      return Object.defineProperty(t.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), t.prototype.get = function(n) {
        var r = e(this.__entries__, n), a = this.__entries__[r];
        return a && a[1];
      }, t.prototype.set = function(n, r) {
        var a = e(this.__entries__, n);
        ~a ? this.__entries__[a][1] = r : this.__entries__.push([n, r]);
      }, t.prototype.delete = function(n) {
        var r = this.__entries__, a = e(r, n);
        ~a && r.splice(a, 1);
      }, t.prototype.has = function(n) {
        return !!~e(this.__entries__, n);
      }, t.prototype.clear = function() {
        this.__entries__.splice(0);
      }, t.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var a = 0, i = this.__entries__; a < i.length; a++) {
          var o = i[a];
          n.call(r, o[1], o[0]);
        }
      }, t;
    }()
  );
}(), ql = typeof window < "u" && typeof document < "u" && window.document === document, b5 = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), qX = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(b5) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), JX = 2;
function XX(e, t) {
  var n = !1, r = !1, a = 0;
  function i() {
    n && (n = !1, e()), r && s();
  }
  function o() {
    qX(i);
  }
  function s() {
    var l = Date.now();
    if (n) {
      if (l - a < JX)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(o, t);
    a = l;
  }
  return s;
}
var QX = 20, eQ = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], tQ = typeof MutationObserver < "u", rQ = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = XX(this.refresh.bind(this), QX);
    }
    return e.prototype.addObserver = function(t) {
      ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(t) {
      var n = this.observers_, r = n.indexOf(t);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var t = this.updateObservers_();
      t && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var t = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return t.forEach(function(n) {
        return n.broadcastActive();
      }), t.length > 0;
    }, e.prototype.connect_ = function() {
      !ql || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), tQ ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !ql || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(t) {
      var n = t.propertyName, r = n === void 0 ? "" : n, a = eQ.some(function(i) {
        return !!~r.indexOf(i);
      });
      a && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), Z_ = function(e, t) {
  for (var n = 0, r = Object.keys(t); n < r.length; n++) {
    var a = r[n];
    Object.defineProperty(e, a, {
      value: t[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, qi = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || b5;
}, K_ = F8(0, 0, 0, 0);
function _5(e) {
  return parseFloat(e) || 0;
}
function Oh(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return t.reduce(function(r, a) {
    var i = e["border-" + a + "-width"];
    return r + _5(i);
  }, 0);
}
function nQ(e) {
  for (var t = ["top", "right", "bottom", "left"], n = {}, r = 0, a = t; r < a.length; r++) {
    var i = a[r], o = e["padding-" + i];
    n[i] = _5(o);
  }
  return n;
}
function aQ(e) {
  var t = e.getBBox();
  return F8(0, 0, t.width, t.height);
}
function iQ(e) {
  var t = e.clientWidth, n = e.clientHeight;
  if (!t && !n)
    return K_;
  var r = qi(e).getComputedStyle(e), a = nQ(r), i = a.left + a.right, o = a.top + a.bottom, s = _5(r.width), l = _5(r.height);
  if (r.boxSizing === "border-box" && (Math.round(s + i) !== t && (s -= Oh(r, "left", "right") + i), Math.round(l + o) !== n && (l -= Oh(r, "top", "bottom") + o)), !sQ(e)) {
    var c = Math.round(s + i) - t, u = Math.round(l + o) - n;
    Math.abs(c) !== 1 && (s -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return F8(a.left, a.top, s, l);
}
var oQ = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof qi(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof qi(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function sQ(e) {
  return e === qi(e).document.documentElement;
}
function lQ(e) {
  return ql ? oQ(e) ? aQ(e) : iQ(e) : K_;
}
function cQ(e) {
  var t = e.x, n = e.y, r = e.width, a = e.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, o = Object.create(i.prototype);
  return Z_(o, {
    x: t,
    y: n,
    width: r,
    height: a,
    top: n,
    right: t + r,
    bottom: a + n,
    left: t
  }), o;
}
function F8(e, t, n, r) {
  return { x: e, y: t, width: n, height: r };
}
var uQ = (
  /** @class */
  function() {
    function e(t) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = F8(0, 0, 0, 0), this.target = t;
    }
    return e.prototype.isActive = function() {
      var t = lQ(this.target);
      return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var t = this.contentRect_;
      return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
    }, e;
  }()
), dQ = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = cQ(n);
      Z_(this, { target: t, contentRect: r });
    }
    return e;
  }()
), pQ = (
  /** @class */
  function() {
    function e(t, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new U_(), typeof t != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = t, this.controller_ = n, this.callbackCtx_ = r;
    }
    return e.prototype.observe = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof qi(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) || (n.set(t, new uQ(t)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(t) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(t instanceof qi(t).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(t) && (n.delete(t), n.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var t = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && t.activeObservations_.push(n);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var t = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new dQ(r.target, r.broadcastRect());
        });
        this.callback_.call(t, n, t), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), $_ = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new U_(), W_ = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = rQ.getInstance(), r = new pQ(t, n, this);
      $_.set(this, r);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  W_.prototype[e] = function() {
    var t;
    return (t = $_.get(this))[e].apply(t, arguments);
  };
});
var hQ = function() {
  return typeof b5.ResizeObserver < "u" ? b5.ResizeObserver : W_;
}(), mQ = ["animating"];
function fQ(e, t, n) {
  return t = Kr(t), P9(e, go() ? Reflect.construct(t, n || [], Kr(e).constructor) : t.apply(e, n));
}
var CQ = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    ni(this, t), r = fQ(this, t, [n]), Ke(r, "listRefHandler", function(i) {
      return r.list = i;
    }), Ke(r, "trackRefHandler", function(i) {
      return r.track = i;
    }), Ke(r, "adaptHeight", function() {
      if (r.props.adaptiveHeight && r.list) {
        var i = r.list.querySelector('[data-index="'.concat(r.state.currentSlide, '"]'));
        r.list.style.height = pc(i) + "px";
      }
    }), Ke(r, "componentDidMount", function() {
      if (r.props.onInit && r.props.onInit(), r.props.lazyLoad) {
        var i = v5(ve(ve({}, r.props), r.state));
        i.length > 0 && (r.setState(function(s) {
          return {
            lazyLoadedList: s.lazyLoadedList.concat(i)
          };
        }), r.props.onLazyLoad && r.props.onLazyLoad(i));
      }
      var o = ve({
        listRef: r.list,
        trackRef: r.track
      }, r.props);
      r.updateState(o, !0, function() {
        r.adaptHeight(), r.props.autoplay && r.autoPlay("playing");
      }), r.props.lazyLoad === "progressive" && (r.lazyLoadTimer = setInterval(r.progressiveLazyLoad, 1e3)), r.ro = new hQ(function() {
        r.state.animating ? (r.onWindowResized(!1), r.callbackTimers.push(setTimeout(function() {
          return r.onWindowResized();
        }, r.props.speed))) : r.onWindowResized();
      }), r.ro.observe(r.list), document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(s) {
        s.onfocus = r.props.pauseOnFocus ? r.onSlideFocus : null, s.onblur = r.props.pauseOnFocus ? r.onSlideBlur : null;
      }), window.addEventListener ? window.addEventListener("resize", r.onWindowResized) : window.attachEvent("onresize", r.onWindowResized);
    }), Ke(r, "componentWillUnmount", function() {
      r.animationEndCallback && clearTimeout(r.animationEndCallback), r.lazyLoadTimer && clearInterval(r.lazyLoadTimer), r.callbackTimers.length && (r.callbackTimers.forEach(function(i) {
        return clearTimeout(i);
      }), r.callbackTimers = []), window.addEventListener ? window.removeEventListener("resize", r.onWindowResized) : window.detachEvent("onresize", r.onWindowResized), r.autoplayTimer && clearInterval(r.autoplayTimer), r.ro.disconnect();
    }), Ke(r, "componentDidUpdate", function(i) {
      if (r.checkImagesLoad(), r.props.onReInit && r.props.onReInit(), r.props.lazyLoad) {
        var o = v5(ve(ve({}, r.props), r.state));
        o.length > 0 && (r.setState(function(c) {
          return {
            lazyLoadedList: c.lazyLoadedList.concat(o)
          };
        }), r.props.onLazyLoad && r.props.onLazyLoad(o));
      }
      r.adaptHeight();
      var s = ve(ve({
        listRef: r.list,
        trackRef: r.track
      }, r.props), r.state), l = r.didPropsChange(i);
      l && r.updateState(s, l, function() {
        r.state.currentSlide >= M.Children.count(r.props.children) && r.changeSlide({
          message: "index",
          index: M.Children.count(r.props.children) - r.props.slidesToShow,
          currentSlide: r.state.currentSlide
        }), (i.autoplay !== r.props.autoplay || i.autoplaySpeed !== r.props.autoplaySpeed) && (!i.autoplay && r.props.autoplay ? r.autoPlay("playing") : r.props.autoplay ? r.autoPlay("update") : r.pause("paused"));
      });
    }), Ke(r, "onWindowResized", function(i) {
      r.debouncedResize && r.debouncedResize.cancel(), r.debouncedResize = xX(50, function() {
        return r.resizeWindow(i);
      }), r.debouncedResize();
    }), Ke(r, "resizeWindow", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, o = !!(r.track && r.track.node);
      if (o) {
        var s = ve(ve({
          listRef: r.list,
          trackRef: r.track
        }, r.props), r.state);
        r.updateState(s, i, function() {
          r.props.autoplay ? r.autoPlay("update") : r.pause("paused");
        }), r.setState({
          animating: !1
        }), clearTimeout(r.animationEndCallback), delete r.animationEndCallback;
      }
    }), Ke(r, "updateState", function(i, o, s) {
      var l = PX(i);
      i = ve(ve(ve({}, i), l), {}, {
        slideIndex: l.currentSlide
      });
      var c = Gs(i);
      i = ve(ve({}, i), {}, {
        left: c
      });
      var u = zs(i);
      (o || M.Children.count(r.props.children) !== M.Children.count(i.children)) && (l.trackStyle = u), r.setState(l, s);
    }), Ke(r, "ssrInit", function() {
      if (r.props.variableWidth) {
        var i = 0, o = 0, s = [], l = ha(ve(ve(ve({}, r.props), r.state), {}, {
          slideCount: r.props.children.length
        })), c = M6(ve(ve(ve({}, r.props), r.state), {}, {
          slideCount: r.props.children.length
        }));
        r.props.children.forEach(function(S) {
          s.push(S.props.style.width), i += S.props.style.width;
        });
        for (var u = 0; u < l; u++)
          o += s[s.length - 1 - u], i += s[s.length - 1 - u];
        for (var d = 0; d < c; d++)
          i += s[d];
        for (var p = 0; p < r.state.currentSlide; p++)
          o += s[p];
        var h = {
          width: i + "px",
          left: -o + "px"
        };
        if (r.props.centerMode) {
          var m = "".concat(s[r.state.currentSlide], "px");
          h.left = "calc(".concat(h.left, " + (100% - ").concat(m, ") / 2 ) ");
        }
        return {
          trackStyle: h
        };
      }
      var f = M.Children.count(r.props.children), C = ve(ve(ve({}, r.props), r.state), {}, {
        slideCount: f
      }), _ = ha(C) + M6(C) + f, v = 100 / r.props.slidesToShow * _, w = 100 / _, k = -w * (ha(C) + r.state.currentSlide) * v / 100;
      r.props.centerMode && (k += (100 - w * v / 100) / 2);
      var b = {
        width: v + "%",
        left: k + "%"
      };
      return {
        slideWidth: w + "%",
        trackStyle: b
      };
    }), Ke(r, "checkImagesLoad", function() {
      var i = r.list && r.list.querySelectorAll && r.list.querySelectorAll(".slick-slide img") || [], o = i.length, s = 0;
      Array.prototype.forEach.call(i, function(l) {
        var c = function() {
          return ++s && s >= o && r.onWindowResized();
        };
        if (!l.onclick)
          l.onclick = function() {
            return l.parentNode.focus();
          };
        else {
          var u = l.onclick;
          l.onclick = function(d) {
            u(d), l.parentNode.focus();
          };
        }
        l.onload || (r.props.lazyLoad ? l.onload = function() {
          r.adaptHeight(), r.callbackTimers.push(setTimeout(r.onWindowResized, r.props.speed));
        } : (l.onload = c, l.onerror = function() {
          c(), r.props.onLazyLoadError && r.props.onLazyLoadError();
        }));
      });
    }), Ke(r, "progressiveLazyLoad", function() {
      for (var i = [], o = ve(ve({}, r.props), r.state), s = r.state.currentSlide; s < r.state.slideCount + M6(o); s++)
        if (r.state.lazyLoadedList.indexOf(s) < 0) {
          i.push(s);
          break;
        }
      for (var l = r.state.currentSlide - 1; l >= -ha(o); l--)
        if (r.state.lazyLoadedList.indexOf(l) < 0) {
          i.push(l);
          break;
        }
      i.length > 0 ? (r.setState(function(c) {
        return {
          lazyLoadedList: c.lazyLoadedList.concat(i)
        };
      }), r.props.onLazyLoad && r.props.onLazyLoad(i)) : r.lazyLoadTimer && (clearInterval(r.lazyLoadTimer), delete r.lazyLoadTimer);
    }), Ke(r, "slideHandler", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = r.props, l = s.asNavFor, c = s.beforeChange, u = s.onLazyLoad, d = s.speed, p = s.afterChange, h = r.state.currentSlide, m = EX(ve(ve(ve({
        index: i
      }, r.props), r.state), {}, {
        trackRef: r.track,
        useCSS: r.props.useCSS && !o
      })), f = m.state, C = m.nextState;
      if (f) {
        c && c(h, f.currentSlide);
        var _ = f.lazyLoadedList.filter(function(v) {
          return r.state.lazyLoadedList.indexOf(v) < 0;
        });
        u && _.length > 0 && u(_), !r.props.waitForAnimate && r.animationEndCallback && (clearTimeout(r.animationEndCallback), p && p(h), delete r.animationEndCallback), r.setState(f, function() {
          l && r.asNavForIndex !== i && (r.asNavForIndex = i, l.innerSlider.slideHandler(i)), C && (r.animationEndCallback = setTimeout(function() {
            var v = C.animating, w = O3(C, mQ);
            r.setState(w, function() {
              r.callbackTimers.push(setTimeout(function() {
                return r.setState({
                  animating: v
                });
              }, 10)), p && p(f.currentSlide), delete r.animationEndCallback;
            });
          }, d));
        });
      }
    }), Ke(r, "changeSlide", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, s = ve(ve({}, r.props), r.state), l = TX(s, i);
      if (!(l !== 0 && !l) && (o === !0 ? r.slideHandler(l, o) : r.slideHandler(l), r.props.autoplay && r.autoPlay("update"), r.props.focusOnSelect)) {
        var c = r.list.querySelectorAll(".slick-current");
        c[0] && c[0].focus();
      }
    }), Ke(r, "clickHandler", function(i) {
      r.clickable === !1 && (i.stopPropagation(), i.preventDefault()), r.clickable = !0;
    }), Ke(r, "keyHandler", function(i) {
      var o = LX(i, r.props.accessibility, r.props.rtl);
      o !== "" && r.changeSlide({
        message: o
      });
    }), Ke(r, "selectHandler", function(i) {
      r.changeSlide(i);
    }), Ke(r, "disableBodyScroll", function() {
      var i = function(s) {
        s = s || window.event, s.preventDefault && s.preventDefault(), s.returnValue = !1;
      };
      window.ontouchmove = i;
    }), Ke(r, "enableBodyScroll", function() {
      window.ontouchmove = null;
    }), Ke(r, "swipeStart", function(i) {
      r.props.verticalSwiping && r.disableBodyScroll();
      var o = AX(i, r.props.swipe, r.props.draggable);
      o !== "" && r.setState(o);
    }), Ke(r, "swipeMove", function(i) {
      var o = OX(i, ve(ve(ve({}, r.props), r.state), {}, {
        trackRef: r.track,
        listRef: r.list,
        slideIndex: r.state.currentSlide
      }));
      o && (o.swiping && (r.clickable = !1), r.setState(o));
    }), Ke(r, "swipeEnd", function(i) {
      var o = NX(i, ve(ve(ve({}, r.props), r.state), {}, {
        trackRef: r.track,
        listRef: r.list,
        slideIndex: r.state.currentSlide
      }));
      if (o) {
        var s = o.triggerSlideHandler;
        delete o.triggerSlideHandler, r.setState(o), s !== void 0 && (r.slideHandler(s), r.props.verticalSwiping && r.enableBodyScroll());
      }
    }), Ke(r, "touchEnd", function(i) {
      r.swipeEnd(i), r.clickable = !0;
    }), Ke(r, "slickPrev", function() {
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "previous"
        });
      }, 0));
    }), Ke(r, "slickNext", function() {
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "next"
        });
      }, 0));
    }), Ke(r, "slickGoTo", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      if (i = Number(i), isNaN(i))
        return "";
      r.callbackTimers.push(setTimeout(function() {
        return r.changeSlide({
          message: "index",
          index: i,
          currentSlide: r.state.currentSlide
        }, o);
      }, 0));
    }), Ke(r, "play", function() {
      var i;
      if (r.props.rtl)
        i = r.state.currentSlide - r.props.slidesToScroll;
      else if (H8(ve(ve({}, r.props), r.state)))
        i = r.state.currentSlide + r.props.slidesToScroll;
      else
        return !1;
      r.slideHandler(i);
    }), Ke(r, "autoPlay", function(i) {
      r.autoplayTimer && clearInterval(r.autoplayTimer);
      var o = r.state.autoplaying;
      if (i === "update") {
        if (o === "hovered" || o === "focused" || o === "paused")
          return;
      } else if (i === "leave") {
        if (o === "paused" || o === "focused")
          return;
      } else if (i === "blur" && (o === "paused" || o === "hovered"))
        return;
      r.autoplayTimer = setInterval(r.play, r.props.autoplaySpeed + 50), r.setState({
        autoplaying: "playing"
      });
    }), Ke(r, "pause", function(i) {
      r.autoplayTimer && (clearInterval(r.autoplayTimer), r.autoplayTimer = null);
      var o = r.state.autoplaying;
      i === "paused" ? r.setState({
        autoplaying: "paused"
      }) : i === "focused" ? (o === "hovered" || o === "playing") && r.setState({
        autoplaying: "focused"
      }) : o === "playing" && r.setState({
        autoplaying: "hovered"
      });
    }), Ke(r, "onDotsOver", function() {
      return r.props.autoplay && r.pause("hovered");
    }), Ke(r, "onDotsLeave", function() {
      return r.props.autoplay && r.state.autoplaying === "hovered" && r.autoPlay("leave");
    }), Ke(r, "onTrackOver", function() {
      return r.props.autoplay && r.pause("hovered");
    }), Ke(r, "onTrackLeave", function() {
      return r.props.autoplay && r.state.autoplaying === "hovered" && r.autoPlay("leave");
    }), Ke(r, "onSlideFocus", function() {
      return r.props.autoplay && r.pause("focused");
    }), Ke(r, "onSlideBlur", function() {
      return r.props.autoplay && r.state.autoplaying === "focused" && r.autoPlay("blur");
    }), Ke(r, "render", function() {
      var i = V2("slick-slider", r.props.className, {
        "slick-vertical": r.props.vertical,
        "slick-initialized": !0
      }), o = ve(ve({}, r.props), r.state), s = r0(o, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding", "targetSlide", "useCSS"]), l = r.props.pauseOnHover;
      s = ve(ve({}, s), {}, {
        onMouseEnter: l ? r.onTrackOver : null,
        onMouseLeave: l ? r.onTrackLeave : null,
        onMouseOver: l ? r.onTrackOver : null,
        focusOnSelect: r.props.focusOnSelect && r.clickable ? r.selectHandler : null
      });
      var c;
      if (r.props.dots === !0 && r.state.slideCount >= r.props.slidesToShow) {
        var u = r0(o, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]), d = r.props.pauseOnDotsHover;
        u = ve(ve({}, u), {}, {
          clickHandler: r.changeSlide,
          onMouseEnter: d ? r.onDotsLeave : null,
          onMouseOver: d ? r.onDotsOver : null,
          onMouseLeave: d ? r.onDotsLeave : null
        }), c = /* @__PURE__ */ M.createElement($X, u);
      }
      var p, h, m = r0(o, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      m.clickHandler = r.changeSlide, r.props.arrows && (p = /* @__PURE__ */ M.createElement(WX, m), h = /* @__PURE__ */ M.createElement(YX, m));
      var f = null;
      r.props.vertical && (f = {
        height: r.state.listHeight
      });
      var C = null;
      r.props.vertical === !1 ? r.props.centerMode === !0 && (C = {
        padding: "0px " + r.props.centerPadding
      }) : r.props.centerMode === !0 && (C = {
        padding: r.props.centerPadding + " 0px"
      });
      var _ = ve(ve({}, f), C), v = r.props.touchMove, w = {
        className: "slick-list",
        style: _,
        onClick: r.clickHandler,
        onMouseDown: v ? r.swipeStart : null,
        onMouseMove: r.state.dragging && v ? r.swipeMove : null,
        onMouseUp: v ? r.swipeEnd : null,
        onMouseLeave: r.state.dragging && v ? r.swipeEnd : null,
        onTouchStart: v ? r.swipeStart : null,
        onTouchMove: r.state.dragging && v ? r.swipeMove : null,
        onTouchEnd: v ? r.touchEnd : null,
        onTouchCancel: r.state.dragging && v ? r.swipeEnd : null,
        onKeyDown: r.props.accessibility ? r.keyHandler : null
      }, k = {
        className: i,
        dir: "ltr",
        style: r.props.style
      };
      return r.props.unslick && (w = {
        className: "slick-list"
      }, k = {
        className: i,
        style: r.props.style
      }), /* @__PURE__ */ M.createElement("div", k, r.props.unslick ? "" : p, /* @__PURE__ */ M.createElement("div", Wa({
        ref: r.listRefHandler
      }, w), /* @__PURE__ */ M.createElement(UX, Wa({
        ref: r.trackRefHandler
      }, s), r.props.children)), r.props.unslick ? "" : h, r.props.unslick ? "" : c);
    }), r.list = null, r.track = null, r.state = ve(ve({}, _X), {}, {
      currentSlide: r.props.initialSlide,
      targetSlide: r.props.initialSlide ? r.props.initialSlide : 0,
      slideCount: M.Children.count(r.props.children)
    }), r.callbackTimers = [], r.clickable = !0, r.debouncedResize = null;
    var a = r.ssrInit();
    return r.state = ve(ve({}, r.state), a), r;
  }
  return yo(t, e), ai(t, [{
    key: "didPropsChange",
    value: function(r) {
      for (var a = !1, i = 0, o = Object.keys(this.props); i < o.length; i++) {
        var s = o[i];
        if (!r.hasOwnProperty(s)) {
          a = !0;
          break;
        }
        if (!(Br(r[s]) === "object" || typeof r[s] == "function" || isNaN(r[s])) && r[s] !== this.props[s]) {
          a = !0;
          break;
        }
      }
      return a || M.Children.count(this.props.children) !== M.Children.count(r.children);
    }
  }]);
}(M.Component), gQ = function(e) {
  return e.replace(/[A-Z]/g, function(t) {
    return "-" + t.toLowerCase();
  }).toLowerCase();
}, yQ = gQ, vQ = yQ, bQ = function(e) {
  var t = /[height|width]$/;
  return t.test(e);
}, Nh = function(e) {
  var t = "", n = Object.keys(e);
  return n.forEach(function(r, a) {
    var i = e[r];
    r = vQ(r), bQ(r) && typeof i == "number" && (i = i + "px"), i === !0 ? t += r : i === !1 ? t += "not " + r : t += "(" + r + ": " + i + ")", a < n.length - 1 && (t += " and ");
  }), t;
}, _Q = function(e) {
  var t = "";
  return typeof e == "string" ? e : e instanceof Array ? (e.forEach(function(n, r) {
    t += Nh(n), r < e.length - 1 && (t += ", ");
  }), t) : Nh(e);
}, wQ = _Q;
const i0 = /* @__PURE__ */ Js(wQ);
function xQ(e, t, n) {
  return t = Kr(t), P9(e, go() ? Reflect.construct(t, n || [], Kr(e).constructor) : t.apply(e, n));
}
var SQ = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    return ni(this, t), r = xQ(this, t, [n]), Ke(r, "innerSliderRefHandler", function(a) {
      return r.innerSlider = a;
    }), Ke(r, "slickPrev", function() {
      return r.innerSlider.slickPrev();
    }), Ke(r, "slickNext", function() {
      return r.innerSlider.slickNext();
    }), Ke(r, "slickGoTo", function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      return r.innerSlider.slickGoTo(a, i);
    }), Ke(r, "slickPause", function() {
      return r.innerSlider.pause("paused");
    }), Ke(r, "slickPlay", function() {
      return r.innerSlider.autoPlay("play");
    }), r.state = {
      breakpoint: null
    }, r._responsiveMediaHandlers = [], r;
  }
  return yo(t, e), ai(t, [{
    key: "media",
    value: function(r, a) {
      var i = window.matchMedia(r), o = function(l) {
        var c = l.matches;
        c && a();
      };
      i.addListener(o), o(i), this._responsiveMediaHandlers.push({
        mql: i,
        query: r,
        listener: o
      });
    }
    // handles responsive breakpoints
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this;
      if (this.props.responsive) {
        var a = this.props.responsive.map(function(o) {
          return o.breakpoint;
        });
        a.sort(function(o, s) {
          return o - s;
        }), a.forEach(function(o, s) {
          var l;
          s === 0 ? l = i0({
            minWidth: 0,
            maxWidth: o
          }) : l = i0({
            minWidth: a[s - 1] + 1,
            maxWidth: o
          }), Ah() && r.media(l, function() {
            r.setState({
              breakpoint: o
            });
          });
        });
        var i = i0({
          minWidth: a.slice(-1)[0]
        });
        Ah() && this.media(i, function() {
          r.setState({
            breakpoint: null
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._responsiveMediaHandlers.forEach(function(r) {
        r.mql.removeListener(r.listener);
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, a, i;
      this.state.breakpoint ? (i = this.props.responsive.filter(function(f) {
        return f.breakpoint === r.state.breakpoint;
      }), a = i[0].settings === "unslick" ? "unslick" : ve(ve(ve({}, $l), this.props), i[0].settings)) : a = ve(ve({}, $l), this.props), a.centerMode && (a.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(a.slidesToScroll)), a.slidesToScroll = 1), a.fade && (a.slidesToShow > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(a.slidesToShow)), a.slidesToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(a.slidesToScroll)), a.slidesToShow = 1, a.slidesToScroll = 1);
      var o = M.Children.toArray(this.props.children);
      o = o.filter(function(f) {
        return typeof f == "string" ? !!f.trim() : !!f;
      }), a.variableWidth && (a.rows > 1 || a.slidesPerRow > 1) && (console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1"), a.variableWidth = !1);
      for (var s = [], l = null, c = 0; c < o.length; c += a.rows * a.slidesPerRow) {
        for (var u = [], d = c; d < c + a.rows * a.slidesPerRow; d += a.slidesPerRow) {
          for (var p = [], h = d; h < d + a.slidesPerRow && (a.variableWidth && o[h].props.style && (l = o[h].props.style.width), !(h >= o.length)); h += 1)
            p.push(/* @__PURE__ */ M.cloneElement(o[h], {
              key: 100 * c + 10 * d + h,
              tabIndex: -1,
              style: {
                width: "".concat(100 / a.slidesPerRow, "%"),
                display: "inline-block"
              }
            }));
          u.push(/* @__PURE__ */ M.createElement("div", {
            key: 10 * c + d
          }, p));
        }
        a.variableWidth ? s.push(/* @__PURE__ */ M.createElement("div", {
          key: c,
          style: {
            width: l
          }
        }, u)) : s.push(/* @__PURE__ */ M.createElement("div", {
          key: c
        }, u));
      }
      if (a === "unslick") {
        var m = "regular slider " + (this.props.className || "");
        return /* @__PURE__ */ M.createElement("div", {
          className: m
        }, o);
      } else
        s.length <= a.slidesToShow && !a.infinite && (a.unslick = !0);
      return /* @__PURE__ */ M.createElement(CQ, Wa({
        style: this.props.style,
        ref: this.innerSliderRefHandler
      }, VX(a)), s);
    }
  }]);
}(M.Component), Jl = /* @__PURE__ */ ((e) => (e[e.left = 0] = "left", e[e.right = 1] = "right", e))(Jl || {});
const jh = ({ className: e, onClick: t, variant: n }) => {
  const { isDefaultSioColor: r } = wr();
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: M1(
        e,
        n === 0 ? "!left-2" : "!right-2",
        "!z-20 !h-[24px] !w-[24px] before:!content-none"
      ),
      onClick: t,
      children: /* @__PURE__ */ x.jsx(
        c3,
        {
          className: M1(
            "before:!display-none !flex !h-[24px] !w-[24px] justify-center",
            r ? "stroke-brand-primary" : "stroke-THEME-text-primary",
            n === 0 ? "rotate-90" : "-rotate-90"
          )
        }
      )
    }
  );
}, kQ = ({ goToSlide: e, index: t, slidesCount: n }) => {
  const r = be(null), [a, i] = ke(!1), { isDefaultSioColor: o } = wr();
  let s = "";
  return a ? s = o ? "!bg-brand-primary" : "!bg-THEME-primary" : s = o ? "bg-THEME-tertiary" : "bg-THEME-secondary", Re(() => {
    if (!r.current)
      return;
    const l = r.current.parentElement;
    if (!l)
      return;
    l.style.width = `${100 / n}%`, i(l.classList.contains("slick-active"));
    const c = new MutationObserver((u) => {
      u.forEach((d) => {
        d.attributeName === "class" && i(l.classList.contains("slick-active"));
      });
    });
    return c.observe(l, { attributes: !0 }), () => c.disconnect();
  }, []), /* @__PURE__ */ x.jsx(
    "div",
    {
      onClick: () => e(t),
      className: Ot("flex h-[4px] cursor-pointer rounded-[30px]", s),
      ref: r
    }
  );
}, Y_ = M.forwardRef(
  ({ images: e, goToSlide: t }, n) => {
    if (!e || e.length === 0)
      return null;
    const r = e.length > 1;
    return /* @__PURE__ */ x.jsx(
      SQ,
      {
        ref: n,
        swipe: r,
        arrows: r,
        infinite: r,
        swipeToSlide: r,
        dots: r,
        prevArrow: /* @__PURE__ */ x.jsx(jh, { variant: Jl.left }),
        nextArrow: /* @__PURE__ */ x.jsx(jh, { variant: Jl.right }),
        customPaging: (a) => /* @__PURE__ */ x.jsx(kQ, { slidesCount: e.length, index: a, goToSlide: t }),
        dotsClass: "relative bottom-5 !flex flex-row justify-center items-center gap-[9px] w-[calc(100%-90px)] max-w-[120px] mx-auto",
        children: e.map(({ path: a, id: i }) => /* @__PURE__ */ x.jsx("div", { className: "!flex items-center justify-center", children: /* @__PURE__ */ x.jsx("img", { src: a }) }, i))
      }
    );
  }
);
Y_.displayName = "Slider";
const MQ = ({ product: e }) => {
  const { currency: t, productVariants: n, images: r = [], name: a, stock: i, limitStock: o } = e, [s, l] = ke([]), { setPricePlan: c, setFinalAmount: u } = Dr(), { locale: d } = qr(), { quantity: p, setQuantity: h, productVariant: m, setProductVariant: f } = b9(), { t: C } = K1(), _ = be(null), v = (I) => {
    var D;
    (D = _ == null ? void 0 : _.current) == null || D.slickGoTo(I);
  }, w = (I, D) => {
    const U = _4(I, D);
    U && (c(U), u(U.amount));
  }, k = (I) => {
    var D;
    if (f(I), I.image) {
      const U = [I.image, ...s.slice(1)];
      l(U), (D = _.current) == null || D.slickGoTo(0);
    }
    w(e, I);
  };
  z1(e, (I) => {
    if (!I)
      c(void 0), u(void 0);
    else {
      const D = [...r], U = m ?? n[0];
      f(U), U != null && U.image && D.unshift(U.image), l(D), w(I, U);
    }
  });
  const b = (m == null ? void 0 : m.stock) ?? i ?? 0, S = () => h(p + 1), P = () => h(p - 1), O = b > 0 && o ? b : void 0, A = !!O && p >= O, L = p <= 1;
  return /* @__PURE__ */ x.jsx("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ x.jsx(ba, { label: C("public_pages_purchase.product") }),
    /* @__PURE__ */ x.jsxs(
      "div",
      {
        className: "border-text-secondary/30 flex flex-col gap-3.5 rounded-lg border px-3.5 py-5",
        children: [
          m && /* @__PURE__ */ x.jsx(
            yX,
            {
              product: e,
              activeVariant: m,
              changeActiveVariant: k
            }
          ),
          /* @__PURE__ */ x.jsx(
            vX,
            {
              quantity: p,
              onIncrease: S,
              onDecrease: P,
              disabledIncreaseButton: A,
              disabledDecreaseButton: L
            }
          ),
          /* @__PURE__ */ x.jsx(Y_, { goToSlide: v, ref: _, images: s }),
          /* @__PURE__ */ x.jsxs("div", { className: "items flex justify-between", children: [
            /* @__PURE__ */ x.jsx("h2", { className: "text-[16px] font-normal", children: a }),
            /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
              /* @__PURE__ */ x.jsx(cr, { currency: t }),
              /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
                h1((m == null ? void 0 : m.price) ?? e.price),
                e.currency,
                d
              ) })
            ] })
          ] })
        ]
      }
    )
  ] }) });
}, PQ = (e, t) => t ? e.some(
  (n) => n.rules.some((r) => r.id !== t.ruleId ? !1 : t.conditionId ? r.shippingConditions.some((a) => a.id === t.conditionId) : !0)
) : !1, EQ = ({ service: e, rule: t, onChange: n, isSelected: r }) => {
  const { locale: a } = qr(), i = J1(
    h1(t.price),
    t.currency,
    a
  );
  return /* @__PURE__ */ x.jsxs("label", { className: "relative flex cursor-pointer items-center gap-2", children: [
    /* @__PURE__ */ x.jsx(
      "input",
      {
        className: Ot(
          "border-fill-primary h-[20px] w-[20px] rounded-full border-2 outline-hidden",
          r ? "bg-background-secondary" : "bg-transparent",
          "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
        ),
        checked: r,
        value: t.id,
        onChange: () => {
          n({
            ruleId: t.id,
            currency: t.currency,
            price: t.price
          });
        },
        type: "radio"
      }
    ),
    /* @__PURE__ */ x.jsx(U3, { className: M1(!r && "fill-transparent") }),
    /* @__PURE__ */ x.jsx("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: /* @__PURE__ */ x.jsxs(
      "div",
      {
        className: "main-transition-colors flex flex-col flex-wrap gap-2 text-left text-[16px]",
        children: [
          /* @__PURE__ */ x.jsxs("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ x.jsx("span", { className: "flex shrink-0", children: e.name }),
            /* @__PURE__ */ x.jsx("span", { className: "flex shrink-0", children: t.name })
          ] }),
          t.description
        ]
      }
    ) }),
    /* @__PURE__ */ x.jsxs("div", { className: "ml-auto flex items-center gap-2.5", children: [
      /* @__PURE__ */ x.jsx(cr, { currency: t.currency }),
      /* @__PURE__ */ x.jsx("span", { className: "main-transition-colors text-[16px] font-bold", children: i })
    ] })
  ] });
};
var kr = /* @__PURE__ */ ((e) => (e.Inclusive = "inclusive", e.Exclusive = "exclusive", e))(kr || {}), Mr = /* @__PURE__ */ ((e) => (e.one_shot = "one_shot", e.subscription = "subscription", e.limited_subscription = "limited_subscription", e))(Mr || {}), B2 = /* @__PURE__ */ ((e) => (e.price = "price", e.quantity = "quantity", e.weight = "weight", e))(B2 || {});
const P6 = (e, t, n, r = "narrowSymbol") => {
  try {
    return new Intl.NumberFormat(n, {
      style: "currency",
      currency: t,
      currencyDisplay: r
    }).format(e);
  } catch (a) {
    if (a instanceof RangeError && r !== "symbol")
      return P6(e, t, n, "symbol");
    throw a;
  }
}, TQ = (e, t, n, r) => {
  switch (t.type) {
    case B2.price:
      return e.max ? n("public_pages_purchase.shipping.condition_label.price", {
        min: P6(h1(e.min), t.currency, r),
        max: P6(h1(e.max), t.currency, r),
        currency: ""
      }) : n("public_pages_purchase.shipping.condition_label.price_min", {
        min: P6(h1(e.min), t.currency, r),
        currency: ""
      });
    case B2.quantity:
      return e.max ? n("public_pages_purchase.shipping.condition_label.quantity", {
        min: e.min,
        max: e.max
      }) : n("public_pages_purchase.shipping.condition_label.quantity_min", {
        min: e.min
      });
    case B2.weight:
      return e.max ? n("public_pages_purchase.shipping.condition_label.weight", {
        min: e.min,
        max: e.max
      }) : n("public_pages_purchase.shipping.condition_label.weight_min", {
        min: e.min
      });
    default:
      return "";
  }
}, LQ = ({
  onChange: e,
  service: t,
  rule: n,
  condition: r,
  isSelected: a
}) => {
  const { t: i } = K1(), { locale: o } = qr();
  return /* @__PURE__ */ x.jsxs("label", { className: Ot("relative flex cursor-pointer items-center gap-2"), children: [
    /* @__PURE__ */ x.jsx(
      "input",
      {
        className: Ot(
          "border-fill-primary h-[20px] w-[20px] rounded-full border-2 outline-hidden",
          a ? "bg-background-secondary" : "bg-transparent",
          "main-transition-colors ring-brand-primary shrink-0 appearance-none ring-offset-1 focus-visible:ring-2"
        ),
        checked: a,
        value: n.id,
        onChange: () => {
          e({
            ruleId: n.id,
            currency: n.currency,
            conditionId: r.id,
            price: r.price
          });
        },
        type: "radio"
      }
    ),
    /* @__PURE__ */ x.jsx(U3, { className: M1(!a && "fill-transparent") }),
    /* @__PURE__ */ x.jsx("div", { className: "flex w-full flex-wrap items-center justify-between gap-3", children: /* @__PURE__ */ x.jsxs(
      "div",
      {
        className: "main-transition-colors flex max-w-full flex-col flex-wrap gap-2 text-left text-[16px] md:max-w-[70%]",
        children: [
          /* @__PURE__ */ x.jsxs("div", { className: "flex flex-wrap gap-1", children: [
            /* @__PURE__ */ x.jsx("span", { className: "flex shrink-0", children: t.name }),
            /* @__PURE__ */ x.jsx("span", { className: "flex shrink-0", children: n.name })
          ] }),
          TQ(r, n, i, o)
        ]
      }
    ) }),
    /* @__PURE__ */ x.jsxs("div", { className: "ml-auto flex items-center gap-2.5", children: [
      /* @__PURE__ */ x.jsx(cr, { currency: n.currency }),
      /* @__PURE__ */ x.jsx("span", { className: "main-transition-colors text-[16px] font-bold", children: J1(h1(r.price), n.currency, o) })
    ] })
  ] });
}, AQ = ({ shipping: e, isLoading: t }) => {
  const { t: n } = K1(), { setSelectedShipping: r, selectedShipping: a } = b9();
  z1(a, (o) => {
    if (!(!e || !e.length) && !PQ(e, o))
      if (e[0]) {
        const s = e[0].rules[0], l = s.shippingConditions[0];
        r(l ? {
          ruleId: s.id,
          currency: s.currency,
          conditionId: l.id,
          price: l.price
        } : {
          ruleId: s.id,
          currency: s.currency,
          price: s.price
        });
      } else
        r(null);
  });
  const i = (o) => {
    r(o);
  };
  return typeof e > "u" ? null : /* @__PURE__ */ x.jsxs("div", { className: M1("flex flex-col gap-1", t && "animate-pulse"), children: [
    /* @__PURE__ */ x.jsx(ba, { label: n("public_pages_purchase.shipping.shipping_method") }),
    /* @__PURE__ */ x.jsx("div", { className: "border-text-secondary/30 flex flex-col gap-4 rounded-lg border p-4", children: e.length ? e.map(
      (o, s) => o.rules.map(
        (l) => l.shippingConditions.length ? l.shippingConditions.map((c) => {
          const u = c.id === (a == null ? void 0 : a.conditionId) && l.id === (a == null ? void 0 : a.ruleId);
          return /* @__PURE__ */ x.jsx(
            LQ,
            {
              isSelected: u,
              onChange: i,
              service: o,
              rule: l,
              condition: c
            },
            c.id
          );
        }) : /* @__PURE__ */ x.jsx(
          EQ,
          {
            isSelected: l.id === (a == null ? void 0 : a.ruleId),
            onChange: i,
            service: o,
            rule: l
          },
          l.id
        )
      )
    ) : n("public_pages_purchase.shipping.not_available") })
  ] });
};
var mc = (e, t, n) => {
  if (!t.has(e))
    throw TypeError("Cannot " + n);
}, de = (e, t, n) => (mc(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Gt = (e, t, n) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, n);
}, ut = (e, t, n, r) => (mc(e, t, "write to private field"), t.set(e, n), n), Xl = (e, t, n, r) => ({
  set _(a) {
    ut(e, t, a);
  },
  get _() {
    return de(e, t, r);
  }
}), sr = (e, t, n) => (mc(e, t, "access private method"), n), Ql = { exports: {} }, zo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rh;
function OQ() {
  if (Rh)
    return zo;
  Rh = 1;
  var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, d = {}, p = null, h = null;
    c !== void 0 && (p = "" + c), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (s && s.defaultProps)
      for (u in l = s.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: t, type: s, key: p, ref: h, props: d, _owner: a.current };
  }
  return zo.Fragment = n, zo.jsx = o, zo.jsxs = o, zo;
}
var J9 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dh;
function NQ() {
  return Dh || (Dh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = M, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, f = "@@iterator";
    function C(g) {
      if (g === null || typeof g != "object")
        return null;
      var E = m && g[m] || g[f];
      return typeof E == "function" ? E : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(g) {
      {
        for (var E = arguments.length, R = new Array(E > 1 ? E - 1 : 0), X = 1; X < E; X++)
          R[X - 1] = arguments[X];
        w("error", g, R);
      }
    }
    function w(g, E, R) {
      {
        var X = _.ReactDebugCurrentFrame, ce = X.getStackAddendum();
        ce !== "" && (E += "%s", R = R.concat([ce]));
        var ue = R.map(function(ie) {
          return String(ie);
        });
        ue.unshift("Warning: " + E), Function.prototype.apply.call(console[g], console, ue);
      }
    }
    var k = !1, b = !1, S = !1, P = !1, O = !1, A;
    A = Symbol.for("react.module.reference");
    function L(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || O || g === a || g === c || g === u || P || g === h || k || b || S || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === d || g.$$typeof === o || g.$$typeof === s || g.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === A || g.getModuleId !== void 0));
    }
    function I(g, E, R) {
      var X = g.displayName;
      if (X)
        return X;
      var ce = E.displayName || E.name || "";
      return ce !== "" ? R + "(" + ce + ")" : R;
    }
    function D(g) {
      return g.displayName || "Context";
    }
    function U(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case s:
            var E = g;
            return D(E) + ".Consumer";
          case o:
            var R = g;
            return D(R._context) + ".Provider";
          case l:
            return I(g, g.render, "ForwardRef");
          case d:
            var X = g.displayName || null;
            return X !== null ? X : U(g.type) || "Memo";
          case p: {
            var ce = g, ue = ce._payload, ie = ce._init;
            try {
              return U(ie(ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, $ = 0, ee, Z, G, W, j, T, F;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function Y() {
      {
        if ($ === 0) {
          ee = console.log, Z = console.info, G = console.warn, W = console.error, j = console.group, T = console.groupCollapsed, F = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        $++;
      }
    }
    function Q() {
      {
        if ($--, $ === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, g, {
              value: ee
            }),
            info: z({}, g, {
              value: Z
            }),
            warn: z({}, g, {
              value: G
            }),
            error: z({}, g, {
              value: W
            }),
            group: z({}, g, {
              value: j
            }),
            groupCollapsed: z({}, g, {
              value: T
            }),
            groupEnd: z({}, g, {
              value: F
            })
          });
        }
        $ < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var V = _.ReactCurrentDispatcher, re;
    function q(g, E, R) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (ce) {
            var X = ce.stack.trim().match(/\n( *(at )?)/);
            re = X && X[1] || "";
          }
        return `
` + re + g;
      }
    }
    var he = !1, me;
    {
      var Ne = typeof WeakMap == "function" ? WeakMap : Map;
      me = new Ne();
    }
    function K(g, E) {
      if (!g || he)
        return "";
      {
        var R = me.get(g);
        if (R !== void 0)
          return R;
      }
      var X;
      he = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ue;
      ue = V.current, V.current = null, Y();
      try {
        if (E) {
          var ie = function() {
            throw Error();
          };
          if (Object.defineProperty(ie.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ie, []);
            } catch (He) {
              X = He;
            }
            Reflect.construct(g, [], ie);
          } else {
            try {
              ie.call();
            } catch (He) {
              X = He;
            }
            g.call(ie.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (He) {
            X = He;
          }
          g();
        }
      } catch (He) {
        if (He && X && typeof He.stack == "string") {
          for (var ne = He.stack.split(`
`), je = X.stack.split(`
`), we = ne.length - 1, xe = je.length - 1; we >= 1 && xe >= 0 && ne[we] !== je[xe]; )
            xe--;
          for (; we >= 1 && xe >= 0; we--, xe--)
            if (ne[we] !== je[xe]) {
              if (we !== 1 || xe !== 1)
                do
                  if (we--, xe--, xe < 0 || ne[we] !== je[xe]) {
                    var ze = `
` + ne[we].replace(" at new ", " at ");
                    return g.displayName && ze.includes("<anonymous>") && (ze = ze.replace("<anonymous>", g.displayName)), typeof g == "function" && me.set(g, ze), ze;
                  }
                while (we >= 1 && xe >= 0);
              break;
            }
        }
      } finally {
        he = !1, V.current = ue, Q(), Error.prepareStackTrace = ce;
      }
      var Yt = g ? g.displayName || g.name : "", Nt = Yt ? q(Yt) : "";
      return typeof g == "function" && me.set(g, Nt), Nt;
    }
    function Ee(g, E, R) {
      return K(g, !1);
    }
    function J(g) {
      var E = g.prototype;
      return !!(E && E.isReactComponent);
    }
    function te(g, E, R) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return K(g, J(g));
      if (typeof g == "string")
        return q(g);
      switch (g) {
        case c:
          return q("Suspense");
        case u:
          return q("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case l:
            return Ee(g.render);
          case d:
            return te(g.type, E, R);
          case p: {
            var X = g, ce = X._payload, ue = X._init;
            try {
              return te(ue(ce), E, R);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, Pe = {}, Ze = _.ReactDebugCurrentFrame;
    function _t(g) {
      if (g) {
        var E = g._owner, R = te(g.type, g._source, E ? E.type : null);
        Ze.setExtraStackFrame(R);
      } else
        Ze.setExtraStackFrame(null);
    }
    function st(g, E, R, X, ce) {
      {
        var ue = Function.call.bind(ye);
        for (var ie in g)
          if (ue(g, ie)) {
            var ne = void 0;
            try {
              if (typeof g[ie] != "function") {
                var je = Error((X || "React class") + ": " + R + " type `" + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw je.name = "Invariant Violation", je;
              }
              ne = g[ie](E, ie, X, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (we) {
              ne = we;
            }
            ne && !(ne instanceof Error) && (_t(ce), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", R, ie, typeof ne), _t(null)), ne instanceof Error && !(ne.message in Pe) && (Pe[ne.message] = !0, _t(ce), v("Failed %s type: %s", R, ne.message), _t(null));
          }
      }
    }
    var L1 = Array.isArray;
    function $t(g) {
      return L1(g);
    }
    function Qt(g) {
      {
        var E = typeof Symbol == "function" && Symbol.toStringTag, R = E && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return R;
      }
    }
    function Ie(g) {
      try {
        return lt(g), !1;
      } catch {
        return !0;
      }
    }
    function lt(g) {
      return "" + g;
    }
    function C1(g) {
      if (Ie(g))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qt(g)), lt(g);
    }
    var At = _.ReactCurrentOwner, g1 = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fe, Ce, Le;
    Le = {};
    function ct(g) {
      if (ye.call(g, "ref")) {
        var E = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function y1(g) {
      if (ye.call(g, "key")) {
        var E = Object.getOwnPropertyDescriptor(g, "key").get;
        if (E && E.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function $1(g, E) {
      if (typeof g.ref == "string" && At.current && E && At.current.stateNode !== E) {
        var R = U(At.current.type);
        Le[R] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(At.current.type), g.ref), Le[R] = !0);
      }
    }
    function Xr(g, E) {
      {
        var R = function() {
          fe || (fe = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        R.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function e2(g, E) {
      {
        var R = function() {
          Ce || (Ce = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", E));
        };
        R.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var t2 = function(g, E, R, X, ce, ue, ie) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: g,
        key: E,
        ref: R,
        props: ie,
        // Record the component responsible for creating this element.
        _owner: ue
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ce
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function r2(g, E, R, X, ce) {
      {
        var ue, ie = {}, ne = null, je = null;
        R !== void 0 && (C1(R), ne = "" + R), y1(E) && (C1(E.key), ne = "" + E.key), ct(E) && (je = E.ref, $1(E, ce));
        for (ue in E)
          ye.call(E, ue) && !g1.hasOwnProperty(ue) && (ie[ue] = E[ue]);
        if (g && g.defaultProps) {
          var we = g.defaultProps;
          for (ue in we)
            ie[ue] === void 0 && (ie[ue] = we[ue]);
        }
        if (ne || je) {
          var xe = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          ne && Xr(ie, xe), je && e2(ie, xe);
        }
        return t2(g, ne, je, ce, X, At.current, ie);
      }
    }
    var er = _.ReactCurrentOwner, Qr = _.ReactDebugCurrentFrame;
    function Wt(g) {
      if (g) {
        var E = g._owner, R = te(g.type, g._source, E ? E.type : null);
        Qr.setExtraStackFrame(R);
      } else
        Qr.setExtraStackFrame(null);
    }
    var tr;
    tr = !1;
    function rr(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }
    function en() {
      {
        if (er.current) {
          var g = U(er.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function n2(g) {
      return "";
    }
    var tn = {};
    function a2(g) {
      {
        var E = en();
        if (!E) {
          var R = typeof g == "string" ? g : g.displayName || g.name;
          R && (E = `

Check the top-level render call using <` + R + ">.");
        }
        return E;
      }
    }
    function rn(g, E) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var R = a2(E);
        if (tn[R])
          return;
        tn[R] = !0;
        var X = "";
        g && g._owner && g._owner !== er.current && (X = " It was passed a child from " + U(g._owner.type) + "."), Wt(g), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, X), Wt(null);
      }
    }
    function nn(g, E) {
      {
        if (typeof g != "object")
          return;
        if ($t(g))
          for (var R = 0; R < g.length; R++) {
            var X = g[R];
            rr(X) && rn(X, E);
          }
        else if (rr(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var ce = C(g);
          if (typeof ce == "function" && ce !== g.entries)
            for (var ue = ce.call(g), ie; !(ie = ue.next()).done; )
              rr(ie.value) && rn(ie.value, E);
        }
      }
    }
    function i2(g) {
      {
        var E = g.type;
        if (E == null || typeof E == "string")
          return;
        var R;
        if (typeof E == "function")
          R = E.propTypes;
        else if (typeof E == "object" && (E.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        E.$$typeof === d))
          R = E.propTypes;
        else
          return;
        if (R) {
          var X = U(E);
          st(R, g.props, "prop", X, g);
        } else if (E.PropTypes !== void 0 && !tr) {
          tr = !0;
          var ce = U(E);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof E.getDefaultProps == "function" && !E.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function o2(g) {
      {
        for (var E = Object.keys(g.props), R = 0; R < E.length; R++) {
          var X = E[R];
          if (X !== "children" && X !== "key") {
            Wt(g), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), Wt(null);
            break;
          }
        }
        g.ref !== null && (Wt(g), v("Invalid attribute `ref` supplied to `React.Fragment`."), Wt(null));
      }
    }
    var an = {};
    function on(g, E, R, X, ce, ue) {
      {
        var ie = L(g);
        if (!ie) {
          var ne = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var je = n2();
          je ? ne += je : ne += en();
          var we;
          g === null ? we = "null" : $t(g) ? we = "array" : g !== void 0 && g.$$typeof === t ? (we = "<" + (U(g.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : we = typeof g, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", we, ne);
        }
        var xe = r2(g, E, R, ce, ue);
        if (xe == null)
          return xe;
        if (ie) {
          var ze = E.children;
          if (ze !== void 0)
            if (X)
              if ($t(ze)) {
                for (var Yt = 0; Yt < ze.length; Yt++)
                  nn(ze[Yt], g);
                Object.freeze && Object.freeze(ze);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              nn(ze, g);
        }
        if (ye.call(E, "key")) {
          var Nt = U(g), He = Object.keys(E).filter(function(p2) {
            return p2 !== "key";
          }), nr = He.length > 0 ? "{key: someKey, " + He.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!an[Nt + nr]) {
            var d2 = He.length > 0 ? "{" + He.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, nr, Nt, d2, Nt), an[Nt + nr] = !0;
          }
        }
        return g === r ? o2(xe) : i2(xe), xe;
      }
    }
    function s2(g, E, R) {
      return on(g, E, R, !0);
    }
    function l2(g, E, R) {
      return on(g, E, R, !1);
    }
    var c2 = l2, u2 = s2;
    J9.Fragment = r, J9.jsx = c2, J9.jsxs = u2;
  }()), J9;
}
process.env.NODE_ENV === "production" ? Ql.exports = OQ() : Ql.exports = NQ();
var Ge = Ql.exports, Pt = /* @__PURE__ */ ((e) => (e.Editor = "editor", e.Community = "community", e.BlockPreview = "block_preview", e.Membership = "membership", e.Marketplace = "marketplace", e.Settings = "settings", e.Email = "email", e.Ckeditor = "ckeditor", e.TextEditor = "text_editor", e.BlogPost = "blog_post", e.PageTemplate = "page_template", e.PageTemplatePreview = "page_template_preview", e.BlogTemplatePreview = "blog_template_preview", e.EmailTemplate = "email_template", e.WebsiteTemplate = "website_template", e.Product = "product", e.FunnelTemplatePreview = "funnel_template_preview", e.DigitalStore = "digital_store", e.DigitalProductResource = "digital_product_resource", e.CalendarHostAvatar = "calendar_host_avatar", e.FileManager = "file_manager", e.WhiteLabel = "white_label", e))(Pt || {}), Zt = /* @__PURE__ */ ((e) => (e.Image = "image", e.ImageOther = "image_other", e.Video = "video", e.Audio = "audio", e.Font = "font", e.Document = "document", e))(Zt || {});
Pt.Editor + "", Pt.Community + "", Pt.BlockPreview + "", Pt.Membership + "", Pt.Marketplace + "", Pt.Settings + "", Pt.Email + "", Pt.Ckeditor + "", Pt.BlogPost + "", Pt.PageTemplate + "", Pt.PageTemplatePreview + "", Pt.BlogTemplatePreview + "", Pt.EmailTemplate + "", Pt.Product + "", Pt.FunnelTemplatePreview + "", Pt.DigitalStore + "", Pt.DigitalProductResource + "", Pt.CalendarHostAvatar + "", Pt.FileManager + "", Pt.TextEditor + "", Pt.WhiteLabel + "", Pt.WebsiteTemplate + "";
Zt.Image + "", Zt.ImageOther + "", Zt.Video + "", Zt.Audio + "", Zt.Font + "", Zt.Document + "";
function jQ(e) {
  return /* @__PURE__ */ Ge.jsx(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 28 28",
      height: "512",
      viewBox: "0 0 28 28",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ Ge.jsx("g", { id: "_x35_3", children: /* @__PURE__ */ Ge.jsx("path", { d: "m4.6 8.7c-.2.5-.3 1-.3 1.5v12.2c0 2 1.6 3.6 3.6 3.6h12.2c2 0 3.6-1.6 3.6-3.6v-16.8c0-2-1.6-3.6-3.6-3.6h-7.6c-.5 0-1 .1-1.5.3-.4.2-.7.4-1 .7l-4.6 4.6c-.3.3-.6.7-.8 1.1zm8.1 5.7c.3 0 .7.1 1 .2v-6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l2.7 2.7c.4.4.4 1 0 1.4s-1 .4-1.4 0l-1-1v6.3c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-2.9 3-2.9z" }) })
    }
  );
}
function Ih(e) {
  return /* @__PURE__ */ Ge.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      ...e,
      children: [
        /* @__PURE__ */ Ge.jsx("path", { d: "m106 512h300c24.814 0 45-20.186 45-45v-317h-105c-24.814 0-45-20.186-45-45v-105h-195c-24.814 0-45 20.186-45 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15s6.709-15 15-15z" }),
        /* @__PURE__ */ Ge.jsx("path", { d: "m346 120h96.211l-111.211-111.211v96.211c0 8.276 6.724 15 15 15z" })
      ]
    }
  );
}
function RQ(e) {
  return /* @__PURE__ */ Ge.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "512pt",
      viewBox: "0 -64 512 512",
      width: "512pt",
      ...e,
      children: [
        /* @__PURE__ */ Ge.jsx("path", { d: "m149.332031 106.667969c0 23.5625-19.101562 42.664062-42.664062 42.664062-23.566407 0-42.667969-19.101562-42.667969-42.664062 0-23.566407 19.101562-42.667969 42.667969-42.667969 23.5625 0 42.664062 19.101562 42.664062 42.667969zm0 0" }),
        /* @__PURE__ */ Ge.jsx("path", { d: "m448 0h-384c-35.285156 0-64 28.714844-64 64v256c0 1.195312.296875 2.324219.363281 3.519531-.300781 2.558594-.171875 5.140625.765625 7.574219 5.269532 29.996094 31.382813 52.90625 62.871094 52.90625h384c35.285156 0 64-28.714844 64-64v-256c0-35.285156-28.714844-64-64-64zm-384 42.667969h384c11.753906 0 21.332031 9.578125 21.332031 21.332031v169.367188l-112.210937-112.214844c-14.59375-14.59375-38.335938-14.59375-52.90625 0l-101.546875 101.546875-26.882813-26.878907c-14.589844-14.59375-38.335937-14.59375-52.90625 0l-80.210937 80.210938v-212.03125c0-11.753906 9.578125-21.332031 21.332031-21.332031zm0 0" })
      ]
    }
  );
}
function DQ(e) {
  return /* @__PURE__ */ Ge.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 467.968 467.968",
      ...e,
      children: [
        /* @__PURE__ */ Ge.jsx("g", { children: /* @__PURE__ */ Ge.jsx("g", { children: /* @__PURE__ */ Ge.jsx("path", { d: "M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504    c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" }) }) }),
        /* @__PURE__ */ Ge.jsx("g", { children: /* @__PURE__ */ Ge.jsx("g", { children: /* @__PURE__ */ Ge.jsx("path", { d: "M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08    c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368    C467.968,135.424,450.048,120.064,430.08,124.672z" }) }) }),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {}),
        /* @__PURE__ */ Ge.jsx("g", {})
      ]
    }
  );
}
function IQ(e) {
  switch (e) {
    case Zt.Audio:
      return /* @__PURE__ */ Ge.jsx(jQ, { className: "fill-text-secondary", width: 40, height: 40 });
    case Zt.Image:
    case Zt.ImageOther:
      return /* @__PURE__ */ Ge.jsx(RQ, { className: "fill-text-secondary", width: 40, height: 40 });
    case Zt.Video:
      return /* @__PURE__ */ Ge.jsx(DQ, { className: "fill-text-secondary", width: 40, height: 40 });
    case Zt.Font:
    case Zt.Document:
      return /* @__PURE__ */ Ge.jsx(Ih, { className: "fill-text-secondary", width: 40, height: 40 });
    default:
      return /* @__PURE__ */ Ge.jsx(Ih, { className: "fill-text-secondary", width: 40, height: 40 });
  }
}
const fc = "-", HQ = (e) => {
  const t = VQ(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const i = a.split(fc);
      return i[0] === "" && i.length !== 1 && i.shift(), q_(i, t) || FQ(a);
    },
    getConflictingClassGroupIds: (a, i) => {
      const o = n[a] || [];
      return i && r[a] ? [...o, ...r[a]] : o;
    }
  };
}, q_ = (e, t) => {
  var n;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], a = t.nextPart.get(r), i = a ? q_(e.slice(1), a) : void 0;
  if (i)
    return i;
  if (t.validators.length === 0)
    return;
  const o = e.join(fc);
  return (n = t.validators.find(({
    validator: s
  }) => s(o))) == null ? void 0 : n.classGroupId;
}, Hh = /^\[(.+)\]$/, FQ = (e) => {
  if (Hh.test(e)) {
    const t = Hh.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, VQ = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return zQ(Object.entries(e.classGroups), n).forEach(([a, i]) => {
    e4(i, r, a, t);
  }), r;
}, e4 = (e, t, n, r) => {
  e.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? t : Fh(t, a);
      i.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (BQ(a)) {
        e4(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      e4(o, Fh(t, i), n, r);
    });
  });
}, Fh = (e, t) => {
  let n = e;
  return t.split(fc).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, BQ = (e) => e.isThemeGetter, zQ = (e, t) => t ? e.map(([n, r]) => {
  const a = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, s]) => [t + o, s])) : i);
  return [n, a];
}) : e, GQ = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const a = (i, o) => {
    n.set(i, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = n.get(i);
      if (o !== void 0)
        return o;
      if ((o = r.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      n.has(i) ? n.set(i, o) : a(i, o);
    }
  };
}, J_ = "!", UQ = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, a = t[0], i = t.length, o = (s) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let C = 0; C < s.length; C++) {
      let _ = s[C];
      if (c === 0) {
        if (_ === a && (r || s.slice(C, C + i) === t)) {
          l.push(s.slice(u, C)), u = C + i;
          continue;
        }
        if (_ === "/") {
          d = C;
          continue;
        }
      }
      _ === "[" ? c++ : _ === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(u), h = p.startsWith(J_), m = h ? p.substring(1) : p, f = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: f
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: o
  }) : o;
}, ZQ = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, KQ = (e) => ({
  cache: GQ(e.cacheSize),
  parseClassName: UQ(e),
  ...HQ(e)
}), $Q = /\s+/, WQ = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, i = [], o = e.trim().split($Q);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const c = o[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(c);
    let m = !!h, f = r(m ? p.substring(0, h) : p);
    if (!f) {
      if (!m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (f = r(p), !f) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      m = !1;
    }
    const C = ZQ(u).join(":"), _ = d ? C + J_ : C, v = _ + f;
    if (i.includes(v))
      continue;
    i.push(v);
    const w = a(f, m);
    for (let k = 0; k < w.length; ++k) {
      const b = w[k];
      i.push(_ + b);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function YQ() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = X_(t)) && (r && (r += " "), r += n);
  return r;
}
const X_ = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = X_(e[r])) && (n && (n += " "), n += t);
  return n;
};
function qQ(e, ...t) {
  let n, r, a, i = o;
  function o(l) {
    const c = t.reduce((u, d) => d(u), e());
    return n = KQ(c), r = n.cache.get, a = n.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const u = WQ(l, n);
    return a(l, u), u;
  }
  return function() {
    return i(YQ.apply(null, arguments));
  };
}
const r1 = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Q_ = /^\[(?:([a-z-]+):)?(.+)\]$/i, JQ = /^\d+\/\d+$/, XQ = /* @__PURE__ */ new Set(["px", "full", "screen"]), QQ = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, eee = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, tee = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, ree = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, nee = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, oa = (e) => Oi(e) || XQ.has(e) || JQ.test(e), Ea = (e) => vo(e, "length", dee), Oi = (e) => !!e && !Number.isNaN(Number(e)), o0 = (e) => vo(e, "number", Oi), Go = (e) => !!e && Number.isInteger(Number(e)), aee = (e) => e.endsWith("%") && Oi(e.slice(0, -1)), ot = (e) => Q_.test(e), Ta = (e) => QQ.test(e), iee = /* @__PURE__ */ new Set(["length", "size", "percentage"]), oee = (e) => vo(e, iee, ew), see = (e) => vo(e, "position", ew), lee = /* @__PURE__ */ new Set(["image", "url"]), cee = (e) => vo(e, lee, hee), uee = (e) => vo(e, "", pee), Uo = () => !0, vo = (e, t, n) => {
  const r = Q_.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, dee = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  eee.test(e) && !tee.test(e)
), ew = () => !1, pee = (e) => ree.test(e), hee = (e) => nee.test(e), mee = () => {
  const e = r1("colors"), t = r1("spacing"), n = r1("blur"), r = r1("brightness"), a = r1("borderColor"), i = r1("borderRadius"), o = r1("borderSpacing"), s = r1("borderWidth"), l = r1("contrast"), c = r1("grayscale"), u = r1("hueRotate"), d = r1("invert"), p = r1("gap"), h = r1("gradientColorStops"), m = r1("gradientColorStopPositions"), f = r1("inset"), C = r1("margin"), _ = r1("opacity"), v = r1("padding"), w = r1("saturate"), k = r1("scale"), b = r1("sepia"), S = r1("skew"), P = r1("space"), O = r1("translate"), A = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", ot, t], D = () => [ot, t], U = () => ["", oa, Ea], z = () => ["auto", Oi, ot], $ = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], ee = () => ["solid", "dashed", "dotted", "double", "none"], Z = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], W = () => ["", "0", ot], j = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [Oi, ot];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Uo],
      spacing: [oa, Ea],
      blur: ["none", "", Ta, ot],
      brightness: T(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Ta, ot],
      borderSpacing: D(),
      borderWidth: U(),
      contrast: T(),
      grayscale: W(),
      hueRotate: T(),
      invert: W(),
      gap: D(),
      gradientColorStops: [e],
      gradientColorStopPositions: [aee, Ea],
      inset: I(),
      margin: I(),
      opacity: T(),
      padding: D(),
      saturate: T(),
      scale: T(),
      sepia: W(),
      skew: T(),
      space: D(),
      translate: D()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ot]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ta]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": j()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": j()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...$(), ot]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: A()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": A()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": A()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [f]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [f]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [f]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [f]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [f]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [f]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [f]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [f]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [f]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Go, ot]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ot]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: W()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: W()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Go, ot]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Uo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Go, ot]
        }, ot]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": z()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": z()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Uo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Go, ot]
        }, ot]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": z()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": z()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ot]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ot]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...G()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...G(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...G(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [C]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [C]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [C]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [C]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [C]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [C]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [C]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [C]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [C]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ot, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ot, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ot, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Ta]
        }, Ta]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ot, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ot, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ot, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ot, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Ta, Ea]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", o0]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Uo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ot]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Oi, o0]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", oa, ot]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ot]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ot]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...ee(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", oa, Ea]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", oa, ot]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ot]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ot]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...$(), see]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", oee]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, cee]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...ee(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: ee()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...ee()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [oa, ot]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [oa, Ea]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: U()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [oa, Ea]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Ta, uee]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Uo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Z(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Z()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Ta, ot]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [b]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [b]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ot]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: T()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ot]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: T()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ot]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [k]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [k]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [k]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Go, ot]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ot]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ot]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ot]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [oa, Ea, o0]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, ds = /* @__PURE__ */ qQ(mee), Zo = /* @__PURE__ */ new Set(), Ko = /* @__PURE__ */ new Set(), E6 = M.memo(
  ({
    src: e,
    fileType: t,
    alt: n,
    className: r,
    isThumbnail: a = !1,
    width: i,
    height: o,
    title: s
  }) => {
    const [l, c] = M.useState(Ko.has(e)), [u, d] = M.useState(Zo.has(e));
    return /* @__PURE__ */ Ge.jsxs(
      "div",
      {
        className: ds("flex items-center justify-center", r),
        style: {
          width: i,
          height: o,
          minHeight: o
        },
        title: s,
        children: [
          t !== Zt.Video && /* @__PURE__ */ Ge.jsx(
            "img",
            {
              src: e,
              alt: n,
              className: ds(
                "flex-2 w-full rounded-md object-cover",
                a && "h-full object-cover",
                !l && u ? "block" : "hidden"
              ),
              onLoad: () => {
                d(!0), Zo.add(e), Ko.delete(e);
              },
              onError: () => {
                c(!0), Zo.delete(e), Ko.add(e);
              }
            }
          ),
          t === Zt.Video && /* @__PURE__ */ Ge.jsx(
            "video",
            {
              src: e,
              className: ds(
                "flex-2 w-full rounded-md object-cover",
                a && "h-full object-cover",
                !l && u ? "block" : "hidden"
              ),
              onLoadedData: () => {
                d(!0), Zo.add(e), Ko.delete(e);
              },
              onError: () => {
                c(!0), Zo.delete(e), Ko.add(e);
              },
              controls: !a
            }
          ),
          /* @__PURE__ */ Ge.jsx(
            "div",
            {
              className: ds(
                "flex-2 flex items-center justify-center rounded-md",
                !a && "min-h-[300px]",
                !e || l ? "flex" : "hidden"
              ),
              children: IQ(t)
            }
          )
        ]
      }
    );
  }
);
E6.displayName = "FilePreview";
const qe = (e) => typeof e == "string", $o = () => {
  let e, t;
  const n = new Promise((r, a) => {
    e = r, t = a;
  });
  return n.resolve = e, n.reject = t, n;
}, Vh = (e) => e == null ? "" : "" + e, fee = (e, t, n) => {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}, Cee = /###/g, Bh = (e) => e && e.indexOf("###") > -1 ? e.replace(Cee, ".") : e, zh = (e) => !e || qe(e), bs = (e, t, n) => {
  const r = qe(t) ? t.split(".") : t;
  let a = 0;
  for (; a < r.length - 1; ) {
    if (zh(e))
      return {};
    const i = Bh(r[a]);
    !e[i] && n && (e[i] = new n()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++a;
  }
  return zh(e) ? {} : {
    obj: e,
    k: Bh(r[a])
  };
}, Gh = (e, t, n) => {
  const {
    obj: r,
    k: a
  } = bs(e, t, Object);
  if (r !== void 0 || t.length === 1) {
    r[a] = n;
    return;
  }
  let i = t[t.length - 1], o = t.slice(0, t.length - 1), s = bs(e, o, Object);
  for (; s.obj === void 0 && o.length; )
    i = `${o[o.length - 1]}.${i}`, o = o.slice(0, o.length - 1), s = bs(e, o, Object), s && s.obj && typeof s.obj[`${s.k}.${i}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${i}`] = n;
}, gee = (e, t, n, r) => {
  const {
    obj: a,
    k: i
  } = bs(e, t, Object);
  a[i] = a[i] || [], a[i].push(n);
}, w5 = (e, t) => {
  const {
    obj: n,
    k: r
  } = bs(e, t);
  if (n)
    return n[r];
}, yee = (e, t, n) => {
  const r = w5(e, n);
  return r !== void 0 ? r : w5(t, n);
}, tw = (e, t, n) => {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? qe(e[r]) || e[r] instanceof String || qe(t[r]) || t[r] instanceof String ? n && (e[r] = t[r]) : tw(e[r], t[r], n) : e[r] = t[r]);
  return e;
}, pi = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var vee = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const bee = (e) => qe(e) ? e.replace(/[&<>"'\/]/g, (t) => vee[t]) : e;
class _ee {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const n = this.regExpMap.get(t);
    if (n !== void 0)
      return n;
    const r = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, r), this.regExpQueue.push(t), r;
  }
}
const wee = [" ", ",", "?", "!", ";"], xee = new _ee(20), See = (e, t, n) => {
  t = t || "", n = n || "";
  const r = wee.filter((o) => t.indexOf(o) < 0 && n.indexOf(o) < 0);
  if (r.length === 0)
    return !0;
  const a = xee.getRegExp(`(${r.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let i = !a.test(e);
  if (!i) {
    const o = e.indexOf(n);
    o > 0 && !a.test(e.substring(0, o)) && (i = !0);
  }
  return i;
}, t4 = function(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let a = e;
  for (let i = 0; i < r.length; ) {
    if (!a || typeof a != "object")
      return;
    let o, s = "";
    for (let l = i; l < r.length; ++l)
      if (l !== i && (s += n), s += r[l], o = a[s], o !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof o) > -1 && l < r.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    a = o;
  }
  return a;
}, x5 = (e) => e && e.replace("_", "-"), kee = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class S5 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || kee, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, a) {
    return a && !this.debug ? null : (qe(t[0]) && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new S5(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new S5(this.logger, t);
  }
}
var Bn = new S5();
class V8 {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] || (this.observers[r] = /* @__PURE__ */ new Map());
      const a = this.observers[r].get(n) || 0;
      this.observers[r].set(n, a + 1);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    this.observers[t] && Array.from(this.observers[t].entries()).forEach((i) => {
      let [o, s] = i;
      for (let l = 0; l < s; l++)
        o(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((i) => {
      let [o, s] = i;
      for (let l = 0; l < s; l++)
        o.apply(o, [t, ...r]);
    });
  }
}
class Uh extends V8 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator, o = a.ignoreJSONStructure !== void 0 ? a.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, n], r && (Array.isArray(r) ? s.push(...r) : qe(r) && i ? s.push(...r.split(i)) : s.push(r)));
    const l = w5(this.data, s);
    return !l && !n && !r && t.indexOf(".") > -1 && (t = s[0], n = s[1], r = s.slice(2).join(".")), l || !o || !qe(r) ? l : t4(this.data && this.data[t] && this.data[t][n], r, i);
  }
  addResource(t, n, r, a) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let s = [t, n];
    r && (s = s.concat(o ? r.split(o) : r)), t.indexOf(".") > -1 && (s = t.split("."), a = n, n = s[1]), this.addNamespaces(n), Gh(this.data, s, a), i.silent || this.emit("added", t, n, r, a);
  }
  addResources(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in r)
      (qe(r[i]) || Array.isArray(r[i])) && this.addResource(t, n, i, r[i], {
        silent: !0
      });
    a.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, s = [t, n];
    t.indexOf(".") > -1 && (s = t.split("."), a = r, r = n, n = s[1]), this.addNamespaces(n);
    let l = w5(this.data, s) || {};
    o.skipCopy || (r = JSON.parse(JSON.stringify(r))), a ? tw(l, r, i) : l = {
      ...l,
      ...r
    }, Gh(this.data, s, l), o.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(t, n)
    } : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((r) => n[r] && Object.keys(n[r]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var rw = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, a) {
    return e.forEach((i) => {
      this.processors[i] && (t = this.processors[i].process(t, n, r, a));
    }), t;
  }
};
const Zh = {};
class k5 extends V8 {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), fee(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Bn.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let i = n.ns || this.options.defaultNS || [];
    const o = r && t.indexOf(r) > -1, s = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !See(t, r, a);
    if (o && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: qe(i) ? [i] : i
        };
      const c = t.split(r);
      (r !== a || r === a && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), t = c.join(a);
    }
    return {
      key: t,
      namespaces: qe(i) ? [i] : i
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const a = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: s
    } = this.extractFromKey(t[t.length - 1], n), l = s[s.length - 1], c = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const k = n.nsSeparator || this.options.nsSeparator;
        return a ? {
          res: `${l}${k}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${k}${o}`;
      }
      return a ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : o;
    }
    const d = this.resolve(t, n);
    let p = d && d.res;
    const h = d && d.usedKey || o, m = d && d.exactUsedKey || o, f = Object.prototype.toString.apply(p), C = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, w = !qe(p) && typeof p != "boolean" && typeof p != "number";
    if (v && p && w && C.indexOf(f) < 0 && !(qe(_) && Array.isArray(p))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const k = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, p, {
          ...n,
          ns: s
        }) : `key '${o} (${this.language})' returned an object instead of string.`;
        return a ? (d.res = k, d.usedParams = this.getUsedParamsDetails(n), d) : k;
      }
      if (i) {
        const k = Array.isArray(p), b = k ? [] : {}, S = k ? m : h;
        for (const P in p)
          if (Object.prototype.hasOwnProperty.call(p, P)) {
            const O = `${S}${i}${P}`;
            b[P] = this.translate(O, {
              ...n,
              joinArrays: !1,
              ns: s
            }), b[P] === O && (b[P] = p[P]);
          }
        p = b;
      }
    } else if (v && qe(_) && Array.isArray(p))
      p = p.join(_), p && (p = this.extendTranslation(p, t, n, r));
    else {
      let k = !1, b = !1;
      const S = n.count !== void 0 && !qe(n.count), P = k5.hasDefaultValue(n), O = S ? this.pluralResolver.getSuffix(c, n.count, n) : "", A = n.ordinal && S ? this.pluralResolver.getSuffix(c, n.count, {
        ordinal: !1
      }) : "", L = S && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), I = L && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${O}`] || n[`defaultValue${A}`] || n.defaultValue;
      !this.isValidLookup(p) && P && (k = !0, p = I), this.isValidLookup(p) || (b = !0, p = o);
      const D = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && b ? void 0 : p, U = P && I !== p && this.options.updateMissing;
      if (b || k || U) {
        if (this.logger.log(U ? "updateKey" : "missingKey", c, l, o, U ? I : p), i) {
          const Z = this.resolve(o, {
            ...n,
            keySeparator: !1
          });
          Z && Z.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let z = [];
        const $ = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && $ && $[0])
          for (let Z = 0; Z < $.length; Z++)
            z.push($[Z]);
        else
          this.options.saveMissingTo === "all" ? z = this.languageUtils.toResolveHierarchy(n.lng || this.language) : z.push(n.lng || this.language);
        const ee = (Z, G, W) => {
          const j = P && W !== p ? W : D;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(Z, l, G, j, U, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(Z, l, G, j, U, n), this.emit("missingKey", Z, l, G, p);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && S ? z.forEach((Z) => {
          const G = this.pluralResolver.getSuffixes(Z, n);
          L && n[`defaultValue${this.options.pluralSeparator}zero`] && G.indexOf(`${this.options.pluralSeparator}zero`) < 0 && G.push(`${this.options.pluralSeparator}zero`), G.forEach((W) => {
            ee([Z], o + W, n[`defaultValue${W}`] || I);
          });
        }) : ee(z, o, I));
      }
      p = this.extendTranslation(p, t, n, d, r), b && p === o && this.options.appendNamespaceToMissingKey && (p = `${l}:${o}`), (b || k) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? p = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, k ? p : void 0) : p = this.options.parseMissingKeyHandler(p));
    }
    return a ? (d.res = p, d.usedParams = this.getUsedParamsDetails(n), d) : p;
  }
  extendTranslation(t, n, r, a, i) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...r
      }, r.lng || this.language || a.usedLng, a.usedNS, a.usedKey, {
        resolved: a
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init({
        ...r,
        interpolation: {
          ...this.options.interpolation,
          ...r.interpolation
        }
      });
      const c = qe(t) && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const p = t.match(this.interpolator.nestingRegexp);
        u = p && p.length;
      }
      let d = r.replace && !qe(r.replace) ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (d = {
        ...this.options.interpolation.defaultVariables,
        ...d
      }), t = this.interpolator.interpolate(t, d, r.lng || this.language || a.usedLng, r), c) {
        const p = t.match(this.interpolator.nestingRegexp), h = p && p.length;
        u < h && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && a && a.res && (r.lng = this.language || a.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var p = arguments.length, h = new Array(p), m = 0; m < p; m++)
          h[m] = arguments[m];
        return i && i[0] === h[0] && !r.context ? (o.logger.warn(`It seems you are nesting recursively key: ${h[0]} in key: ${n[0]}`), null) : o.translate(...h, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const s = r.postProcess || this.options.postProcess, l = qe(s) ? [s] : s;
    return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = rw.handle(l, t, n, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...a,
        usedParams: this.getUsedParamsDetails(r)
      },
      ...r
    } : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, a, i, o, s;
    return qe(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const c = this.extractFromKey(l, n), u = c.key;
      a = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const p = n.count !== void 0 && !qe(n.count), h = p && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = n.context !== void 0 && (qe(n.context) || typeof n.context == "number") && n.context !== "", f = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      d.forEach((C) => {
        this.isValidLookup(r) || (s = C, !Zh[`${f[0]}-${C}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(s) && (Zh[`${f[0]}-${C}`] = !0, this.logger.warn(`key "${a}" for languages "${f.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), f.forEach((_) => {
          if (this.isValidLookup(r))
            return;
          o = _;
          const v = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(v, u, _, C, n);
          else {
            let k;
            p && (k = this.pluralResolver.getSuffix(_, n.count, n));
            const b = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (p && (v.push(u + k), n.ordinal && k.indexOf(S) === 0 && v.push(u + k.replace(S, this.options.pluralSeparator)), h && v.push(u + b)), m) {
              const P = `${u}${this.options.contextSeparator}${n.context}`;
              v.push(P), p && (v.push(P + k), n.ordinal && k.indexOf(S) === 0 && v.push(P + k.replace(S, this.options.pluralSeparator)), h && v.push(P + b));
            }
          }
          let w;
          for (; w = v.pop(); )
            this.isValidLookup(r) || (i = w, r = this.getResource(_, C, w, n));
        }));
      });
    }), {
      res: r,
      usedKey: a,
      exactUsedKey: i,
      usedLng: o,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, a) : this.resourceStore.getResource(t, n, r, a);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && !qe(t.replace);
    let a = r ? t.replace : t;
    if (r && typeof t.count < "u" && (a.count = t.count), this.options.interpolation.defaultVariables && (a = {
      ...this.options.interpolation.defaultVariables,
      ...a
    }), !r) {
      a = {
        ...a
      };
      for (const i of n)
        delete a[i];
    }
    return a;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
const s0 = (e) => e.charAt(0).toUpperCase() + e.slice(1);
class Kh {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Bn.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = x5(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = x5(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (qe(t) && t.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let a = Intl.getCanonicalLocales(t)[0];
          if (a && this.options.lowerCaseLng && (a = a.toLowerCase()), a)
            return a;
        } catch {
        }
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((a) => a.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = s0(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = s0(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = s0(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const a = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(a)) && (n = a);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const a = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(a))
        return n = a;
      n = this.options.supportedLngs.find((i) => {
        if (i === a || !(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), qe(t) && (t = [t]), Array.isArray(t))
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), a = [], i = (o) => {
      o && (this.isSupportedCode(o) ? a.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return qe(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : qe(t) && i(this.formatLanguageCode(t)), r.forEach((o) => {
      a.indexOf(o) < 0 && i(this.formatLanguageCode(o));
    }), a;
  }
}
let Mee = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], Pee = {
  1: (e) => +(e > 1),
  2: (e) => +(e != 1),
  3: (e) => 0,
  4: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  5: (e) => e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5,
  6: (e) => e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2,
  7: (e) => e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  8: (e) => e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3,
  9: (e) => +(e >= 2),
  10: (e) => e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4,
  11: (e) => e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3,
  12: (e) => +(e % 10 != 1 || e % 100 == 11),
  13: (e) => +(e !== 0),
  14: (e) => e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3,
  15: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2,
  16: (e) => e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2,
  17: (e) => e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1,
  18: (e) => e == 0 ? 0 : e == 1 ? 1 : 2,
  19: (e) => e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3,
  20: (e) => e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2,
  21: (e) => e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0,
  22: (e) => e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
};
const Eee = ["v1", "v2", "v3"], Tee = ["v4"], $h = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Lee = () => {
  const e = {};
  return Mee.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: Pee[t.fc]
      };
    });
  }), e;
};
class Aee {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = Bn.create("pluralResolver"), (!this.options.compatibilityJSON || Tee.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Lee(), this.pluralRulesCache = {};
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const r = x5(t === "dev" ? "en" : t), a = n.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: r,
        type: a
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let o;
      try {
        o = new Intl.PluralRules(r, {
          type: a
        });
      } catch {
        if (!t.match(/-|_/))
          return;
        const s = this.languageUtils.getLanguagePartFromCode(t);
        o = this.getRule(s, n);
      }
      return this.pluralRulesCache[i] = o, o;
    }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((a) => `${n}${a}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((a, i) => $h[a] - $h[i]).map((a) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${a}`) : r.numbers.map((a) => this.getSuffix(t, a, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const a = this.getRule(t, r);
    return a ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${a.select(n)}` : this.getSuffixRetroCompatible(a, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let a = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (a === 2 ? a = "plural" : a === 1 && (a = ""));
    const i = () => this.options.prepend && a.toString() ? this.options.prepend + a.toString() : a.toString();
    return this.options.compatibilityJSON === "v1" ? a === 1 ? "" : typeof a == "number" ? `_plural_${a.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? i() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !Eee.includes(this.options.compatibilityJSON);
  }
}
const Wh = function(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = yee(e, t, n);
  return !i && a && qe(n) && (i = t4(e, n, r), i === void 0 && (i = t4(t, n, r))), i;
}, l0 = (e) => e.replace(/\$/g, "$$$$");
class Oee {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Bn.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: n,
      escapeValue: r,
      useRawValueToEscape: a,
      prefix: i,
      prefixEscaped: o,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: p,
      nestingPrefixEscaped: h,
      nestingSuffix: m,
      nestingSuffixEscaped: f,
      nestingOptionsSeparator: C,
      maxReplaces: _,
      alwaysFormat: v
    } = t.interpolation;
    this.escape = n !== void 0 ? n : bee, this.escapeValue = r !== void 0 ? r : !0, this.useRawValueToEscape = a !== void 0 ? a : !1, this.prefix = i ? pi(i) : o || "{{", this.suffix = s ? pi(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = p ? pi(p) : h || pi("$t("), this.nestingSuffix = m ? pi(m) : f || pi(")"), this.nestingOptionsSeparator = C || ",", this.maxReplaces = _ || 1e3, this.alwaysFormat = v !== void 0 ? v : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (n, r) => n && n.source === r ? (n.lastIndex = 0, n) : new RegExp(r, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(t, n, r, a) {
    let i, o, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const C = Wh(n, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(C, void 0, r, {
          ...a,
          ...n,
          interpolationkey: p
        }) : C;
      }
      const h = p.split(this.formatSeparator), m = h.shift().trim(), f = h.join(this.formatSeparator).trim();
      return this.format(Wh(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure), f, r, {
        ...a,
        ...n,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = a && a.missingInterpolationHandler || this.options.missingInterpolationHandler, d = a && a.interpolation && a.interpolation.skipOnVariables !== void 0 ? a.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => l0(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? l0(this.escape(p)) : l0(p)
    }].forEach((p) => {
      for (s = 0; i = p.regex.exec(t); ) {
        const h = i[1].trim();
        if (o = c(h), o === void 0)
          if (typeof u == "function") {
            const f = u(t, i, a);
            o = qe(f) ? f : "";
          } else if (a && Object.prototype.hasOwnProperty.call(a, h))
            o = "";
          else if (d) {
            o = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), o = "";
        else
          !qe(o) && !this.useRawValueToEscape && (o = Vh(o));
        const m = p.safeValue(o);
        if (t = t.replace(i[0], m), d ? (p.regex.lastIndex += o.length, p.regex.lastIndex -= i[0].length) : p.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a, i, o;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let p = `{${d[1]}`;
      l = d[0], p = this.interpolate(p, o);
      const h = p.match(/'/g), m = p.match(/"/g);
      (h && h.length % 2 === 0 && !m || m.length % 2 !== 0) && (p = p.replace(/'/g, '"'));
      try {
        o = JSON.parse(p), c && (o = {
          ...c,
          ...o
        });
      } catch (f) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, f), `${l}${u}${p}`;
      }
      return o.defaultValue && o.defaultValue.indexOf(this.prefix) > -1 && delete o.defaultValue, l;
    };
    for (; a = this.nestingRegexp.exec(t); ) {
      let l = [];
      o = {
        ...r
      }, o = o.replace && !qe(o.replace) ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let c = !1;
      if (a[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(a[1])) {
        const u = a[1].split(this.formatSeparator).map((d) => d.trim());
        a[1] = u.shift(), l = u, c = !0;
      }
      if (i = n(s.call(this, a[1].trim(), o), o), i && a[0] === t && !qe(i))
        return i;
      qe(i) || (i = Vh(i)), i || (this.logger.warn(`missed to resolve ${a[1]} for nesting ${t}`), i = ""), c && (i = l.reduce((u, d) => this.format(u, d, r.lng, {
        ...r,
        interpolationkey: a[1].trim()
      }), i.trim())), t = t.replace(a[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const Nee = (e) => {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const a = r[1].substring(0, r[1].length - 1);
    t === "currency" && a.indexOf(":") < 0 ? n.currency || (n.currency = a.trim()) : t === "relativetime" && a.indexOf(":") < 0 ? n.range || (n.range = a.trim()) : a.split(";").forEach((i) => {
      if (i) {
        const [o, ...s] = i.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = o.trim();
        n[c] || (n[c] = l), l === "false" && (n[c] = !1), l === "true" && (n[c] = !0), isNaN(l) || (n[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}, hi = (e) => {
  const t = {};
  return (n, r, a) => {
    let i = a;
    a && a.interpolationkey && a.formatParams && a.formatParams[a.interpolationkey] && a[a.interpolationkey] && (i = {
      ...i,
      [a.interpolationkey]: void 0
    });
    const o = r + JSON.stringify(i);
    let s = t[o];
    return s || (s = e(x5(r), a), t[o] = s), s(n);
  };
};
class jee {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Bn.create("formatter"), this.options = t, this.formats = {
      number: hi((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      currency: hi((n, r) => {
        const a = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (i) => a.format(i);
      }),
      datetime: hi((n, r) => {
        const a = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      }),
      relativetime: hi((n, r) => {
        const a = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (i) => a.format(i, r.range || "day");
      }),
      list: hi((n, r) => {
        const a = new Intl.ListFormat(n, {
          ...r
        });
        return (i) => a.format(i);
      })
    }, this.init(t);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = n.interpolation.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = hi(n);
  }
  format(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = n.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((s) => s.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = Nee(s);
      if (this.formats[l]) {
        let u = o;
        try {
          const d = a && a.formatParams && a.formatParams[a.interpolationkey] || {}, p = d.locale || d.lng || a.locale || a.lng || r;
          u = this.formats[l](o, p, {
            ...c,
            ...a,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return o;
    }, t);
  }
}
const Ree = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class Dee extends V8 {
  constructor(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = a, this.logger = Bn.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = a.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, this.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, a.backend, a);
  }
  queueLoad(t, n, r, a) {
    const i = {}, o = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      n.forEach((d) => {
        const p = `${c}|${d}`;
        !r.reload && this.store.hasResourceBundle(c, d) ? this.state[p] = 2 : this.state[p] < 0 || (this.state[p] === 1 ? o[p] === void 0 && (o[p] = !0) : (this.state[p] = 1, u = !1, o[p] === void 0 && (o[p] = !0), i[p] === void 0 && (i[p] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(i).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: a
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const a = t.split("|"), i = a[0], o = a[1];
    n && this.emit("failedLoading", i, o, n), !n && r && this.store.addResourceBundle(i, o, r, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = n ? -1 : 2, n && r && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      gee(l.loaded, [i], o), Ree(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r) {
    let a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: a,
        wait: i,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && a < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, a + 1, i * 2, o);
        }, i);
        return;
      }
      o(c, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, n);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, n, s);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), a && a();
    qe(t) && (t = this.languageUtils.toResolveHierarchy(t)), qe(n) && (n = [n]);
    const i = this.queueLoad(t, n, r, a);
    if (!i.toLoad.length)
      return i.pending.length || a(), null;
    i.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), a = r[0], i = r[1];
    this.read(a, i, "read", void 0, void 0, (o, s) => {
      o && this.logger.warn(`${n}loading namespace ${i} for language ${a} failed`, o), !o && s && this.logger.log(`${n}loaded namespace ${i} for language ${a}`, s), this.loaded(t, o, s);
    });
  }
  saveMissing(t, n, r, a, i) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, s = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...o,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, n, r, a, l) : u = c(t, n, r, a), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, n, r, a, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, a);
    }
  }
}
const Yh = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), qe(e[1]) && (t.defaultValue = e[1]), qe(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const n = e[3] || e[2];
      Object.keys(n).forEach((r) => {
        t[r] = n[r];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), qh = (e) => (qe(e.ns) && (e.ns = [e.ns]), qe(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), qe(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e), X9 = () => {
}, Iee = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class Us extends V8 {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = qh(t), this.services = {}, this.logger = Bn, this.modules = {
      external: []
    }, Iee(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (qe(n.ns) ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const a = Yh();
    this.options = {
      ...a,
      ...this.options,
      ...qh(n)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...a.interpolation,
      ...this.options.interpolation
    }), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    const i = (l) => l ? typeof l == "function" ? new l() : l : null;
    if (!this.options.isClone) {
      this.modules.logger ? Bn.init(i(this.modules.logger), this.options) : Bn.init(null, this.options);
      let l;
      this.modules.formatter ? l = this.modules.formatter : typeof Intl < "u" && (l = jee);
      const c = new Kh(this.options);
      this.store = new Uh(this.options.resources, this.options);
      const u = this.services;
      u.logger = Bn, u.resourceStore = this.store, u.languageUtils = c, u.pluralResolver = new Aee(c, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), l && (!this.options.interpolation.format || this.options.interpolation.format === a.interpolation.format) && (u.formatter = i(l), u.formatter.init(u, this.options), this.options.interpolation.format = u.formatter.format.bind(u.formatter)), u.interpolator = new Oee(this.options), u.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, u.backendConnector = new Dee(i(this.modules.backend), u.resourceStore, u, this.options), u.backendConnector.on("*", function(d) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          h[m - 1] = arguments[m];
        t.emit(d, ...h);
      }), this.modules.languageDetector && (u.languageDetector = i(this.modules.languageDetector), u.languageDetector.init && u.languageDetector.init(u, this.options.detection, this.options)), this.modules.i18nFormat && (u.i18nFormat = i(this.modules.i18nFormat), u.i18nFormat.init && u.i18nFormat.init(this)), this.translator = new k5(this.services, this.options), this.translator.on("*", function(d) {
        for (var p = arguments.length, h = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          h[m - 1] = arguments[m];
        t.emit(d, ...h);
      }), this.modules.external.forEach((d) => {
        d.init && d.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = X9), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const l = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      l.length > 0 && l[0] !== "dev" && (this.options.lng = l[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((l) => {
      this[l] = function() {
        return t.store[l](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((l) => {
      this[l] = function() {
        return t.store[l](...arguments), t;
      };
    });
    const o = $o(), s = () => {
      const l = (c, u) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), o.resolve(u), r(c, u);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return l(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, l);
    };
    return this.options.resources || !this.options.initImmediate ? s() : setTimeout(s, 0), o;
  }
  loadResources(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : X9;
    const r = qe(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (r && r.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const a = [], i = (o) => {
        !o || o === "cimode" || this.services.languageUtils.toResolveHierarchy(o).forEach((s) => {
          s !== "cimode" && a.indexOf(s) < 0 && a.push(s);
        });
      };
      r ? i(r) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((o) => i(o)), this.options.preload && this.options.preload.forEach((o) => i(o)), this.services.backendConnector.load(a, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(o);
      });
    } else
      n(null);
  }
  reloadResources(t, n, r) {
    const a = $o();
    return typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = void 0), t || (t = this.languages), n || (n = this.options.ns), r || (r = X9), this.services.backendConnector.reload(t, n, (i) => {
      a.resolve(), r(i);
    }), a;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && rw.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const a = $o();
    this.emit("languageChanging", t);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, a.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, s = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const c = qe(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        o(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? s(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(s) : this.services.languageDetector.detect(s) : s(t), a;
  }
  getFixedT(t, n, r) {
    var a = this;
    const i = function(o, s) {
      let l;
      if (typeof s != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), d = 2; d < c; d++)
          u[d - 2] = arguments[d];
        l = a.options.overloadTranslationOptionHandler([o, s].concat(u));
      } else
        l = {
          ...s
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || r || i.keyPrefix);
      const p = a.options.keySeparator || ".";
      let h;
      return l.keyPrefix && Array.isArray(o) ? h = o.map((m) => `${l.keyPrefix}${p}${m}`) : h = l.keyPrefix ? `${l.keyPrefix}${p}${o}` : o, a.t(h, l);
    };
    return qe(t) ? i.lng = t : i.lngs = t, i.ns = n, i.keyPrefix = r, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], a = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const o = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (n.precheck) {
      const s = n.precheck(this, o);
      if (s !== void 0)
        return s;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(r, t) && (!a || o(i, t)));
  }
  loadNamespaces(t, n) {
    const r = $o();
    return this.options.ns ? (qe(t) && (t = [t]), t.forEach((a) => {
      this.options.ns.indexOf(a) < 0 && this.options.ns.push(a);
    }), this.loadResources((a) => {
      r.resolve(), n && n(a);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = $o();
    qe(t) && (t = [t]);
    const a = this.options.preload || [], i = t.filter((o) => a.indexOf(o) < 0 && this.services.languageUtils.isSupportedCode(o));
    return i.length ? (this.options.preload = a.concat(i), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Kh(Yh());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new Us(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : X9;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const a = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new Us(a);
    return (t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, r && (i.store = new Uh(this.store.data, a), i.services.resourceStore = i.store), i.translator = new k5(i.services, a), i.translator.on("*", function(o) {
      for (var s = arguments.length, l = new Array(s > 1 ? s - 1 : 0), c = 1; c < s; c++)
        l[c - 1] = arguments[c];
      i.emit(o, ...l);
    }), i.init(a, n), i.translator.options = a, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const Q1 = Us.createInstance();
Q1.createInstance = Us.createInstance;
Q1.createInstance;
Q1.dir;
Q1.init;
Q1.loadResources;
Q1.reloadResources;
Q1.use;
Q1.changeLanguage;
Q1.getFixedT;
Q1.t;
Q1.exists;
Q1.setDefaultNamespace;
Q1.hasLoadedNamespace;
Q1.loadNamespaces;
Q1.loadLanguages;
function Zs(e) {
  "@babel/helpers - typeof";
  return Zs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zs(e);
}
function Hee(e, t) {
  if (Zs(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (Zs(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function nw(e) {
  var t = Hee(e, "string");
  return Zs(t) == "symbol" ? t : t + "";
}
function Fee(e, t, n) {
  return (t = nw(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Vee(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Bee(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, nw(r.key), r);
  }
}
function zee(e, t, n) {
  return t && Bee(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var Gee = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Uee = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Zee = function(e) {
  return Uee[e];
}, Kee = function(e) {
  return e.replace(Gee, Zee);
};
function Jh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Jh(Object(n), !0).forEach(function(r) {
      Fee(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Qh = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Kee
};
Qe();
function $ee() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Qh = Xh(Xh({}, Qh), e);
}
(function() {
  function e() {
    Vee(this, e), this.usedNamespaces = {};
  }
  return zee(e, [{
    key: "addUsedNamespaces",
    value: function(t) {
      var n = this;
      t.forEach(function(r) {
        n.usedNamespaces[r] || (n.usedNamespaces[r] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), e;
})();
var Wee = {
  type: "3rdParty",
  init: function(e) {
    $ee(e.options.react);
  }
};
const Yee = {
  title: "File Manager",
  file_upload: {
    file_not_supported: "File type not supported",
    drop_files_here: "Drag and drop your files here, or click to browse",
    upload_files: "Upload files",
    uploaded_successfully: "Successfully uploaded",
    crop_file: "Crop image ",
    crop_and_select_file: "Crop and select an image",
    upload_and_select_file: "Upload and select"
  },
  cancelled: "Cancelled",
  error: "Error",
  something_went_wrong: "Something went wrong",
  confirm_action: "Confirm action",
  confirm: "Confirm",
  cancel: "Cancel",
  file_details: "File details",
  download: "Download",
  rename: "Rename",
  delete: "Delete",
  name: "Name",
  size: "Size",
  file_source: {
    editor: "Editor",
    community: "Community",
    block_preview: "Block preview",
    membership: "Membership",
    marketplace: "Marketplace",
    settings: "Settings",
    email: "Email",
    ckeditor: "CKEditor",
    blog_post: "Blog post",
    page_template: "Page template",
    page_template_preview: "Page template preview",
    blog_template_preview: "Blog template preview",
    email_template: "Email template",
    product: "Product",
    funnel_template_preview: "Funnel template preview",
    digital_store: "Digital store",
    digital_product_resource: "Digital product resource",
    file_manager: "File manager",
    calendar_host_avatar: "Calendar",
    text_editor: "Text editor",
    website_template: "Website template",
    white_label: "White Label"
  },
  file_type: {
    image: "Image",
    image_other: "Other image",
    video: "Video",
    audio: "Audio",
    font: "Font",
    document: "Document"
  },
  select: "Select",
  file_selector: {
    files_selected: "file selected",
    search_file: "Search file",
    rename_file: "Rename file",
    file_name: "File name",
    enter_new_file_name: "Enter a new file name",
    failed_rename_file: "Failed to rename file",
    failed_delete_file: "Failed to delete file",
    failed_download_file: "Failed to download file",
    file_deletion_confirmation_text: 'Are you sure you want to delete "{{file}}"?',
    choose_file: "Choose a file"
  },
  search: "Search",
  upload: "Upload",
  file: "File",
  select_type: "Select file type",
  select_source: "Select source",
  type: "Type",
  created_at: "Created at",
  processing_size: "Processing",
  preview: "Preview",
  image_cropper: {
    aspect_ratio: {
      need_to_crop: "Crop image before selecting",
      need_to_crop_note: "The image has a different aspect ratio. Please crop it to match the required one"
    }
  },
  errors: {
    payload_to_large_error_message: "The file size is too big",
    conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!",
    fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue",
    internal_error_message: "Something went wrong. Please try again"
  },
  file_renamed_successfully: "Renamed successfully",
  file_deleted_successfully: "Deleted successfully"
}, qee = {
  file_manager: Yee
}, aw = ["common"], Jee = aw[0], Xee = Object.values(Tr), Qee = {
  en: { common: qee }
}, ete = {
  supportedLngs: Xee,
  load: "languageOnly",
  debug: !1,
  defaultNS: Jee,
  react: { useSuspense: !1 },
  ns: aw,
  fallbackLng: Tr.ENGLISH,
  lng: Tr.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: Qee,
  returnEmptyString: !1
};
Q1.use(Wee).init(ete);
DU();
function tte(e, t = 0.02) {
  const n = [
    { label: "(1:1)", value: 1 },
    { label: "(16:9)", value: 1.7777777777777777 },
    { label: "(21:9)", value: 2.3333333333333335 },
    { label: "(4:3)", value: 1.3333333333333333 },
    { label: "(1.43:1)", value: 1.43 },
    { label: "(32:9)", value: 3.5555555555555554 },
    { label: "(1.41:1)", value: 1.41 },
    { label: "(9:16)", value: 0.5625 },
    { label: "(19.5:9)", value: 2.1666666666666665 },
    { label: "(12:7)", value: 1.7142857142857142 }
  ].find((r) => Math.abs(e - r.value) < t);
  return n == null ? void 0 : n.label;
}
function em(e, t) {
  if (!t || isNaN(t))
    return e;
  const n = tte(t);
  if (!n)
    return e;
  const r = n.replace(/[\s:]+/g, "_"), a = e.name.split(".").pop(), i = `${e.name.replace(/\.[^.]+$/, "")}_${r}.${a}`;
  return new File([e], i, {
    type: e.type,
    lastModified: e.lastModified
  });
}
function tm(e, t) {
  const n = `${e.name.replace(/\.[^.]+$/, "")}.png`;
  return new File([t], n, {
    type: "image/png",
    lastModified: e.lastModified
  });
}
const rte = M.memo(({ file: e, className: t }) => e.type.startsWith("image/") ? /* @__PURE__ */ Ge.jsx(
  E6,
  {
    src: URL.createObjectURL(e),
    fileType: Zt.Image,
    alt: e.name,
    className: t,
    isThumbnail: !0,
    title: e.name
  }
) : e.type === "application/pdf" ? /* @__PURE__ */ Ge.jsx(
  "div",
  {
    className: ds(
      "pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md",
      t
    ),
    title: e.name,
    children: /* @__PURE__ */ Ge.jsx(
      "embed",
      {
        src: URL.createObjectURL(e),
        type: e.type,
        className: "h-full w-full",
        style: { border: "none" }
      }
    )
  }
) : e.type.startsWith("video/") ? /* @__PURE__ */ Ge.jsx(
  E6,
  {
    src: URL.createObjectURL(e),
    fileType: Zt.Video,
    alt: e.name,
    className: t,
    isThumbnail: !0,
    title: e.name
  }
) : /* @__PURE__ */ Ge.jsx(
  E6,
  {
    src: "",
    fileType: Zt.Document,
    className: t,
    isThumbnail: !0,
    title: e.name
  }
));
rte.displayName = "FilePreviewFromOS";
var B8 = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    return this.listeners.add(e), this.onSubscribe(), () => {
      this.listeners.delete(e), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, z8 = typeof window > "u" || "Deno" in globalThis;
function dn() {
}
function nte(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ate(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function ite(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function rm(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ote(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function nm(e, t) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: a,
    predicate: i,
    queryKey: o,
    stale: s
  } = e;
  if (o) {
    if (r) {
      if (t.queryHash !== Cc(o, t.options))
        return !1;
    } else if (!$s(t.queryKey, o))
      return !1;
  }
  if (n !== "all") {
    const l = t.isActive();
    if (n === "active" && !l || n === "inactive" && l)
      return !1;
  }
  return !(typeof s == "boolean" && t.isStale() !== s || a && a !== t.state.fetchStatus || i && !i(t));
}
function am(e, t) {
  const { exact: n, status: r, predicate: a, mutationKey: i } = e;
  if (i) {
    if (!t.options.mutationKey)
      return !1;
    if (n) {
      if (Ks(t.options.mutationKey) !== Ks(i))
        return !1;
    } else if (!$s(t.options.mutationKey, i))
      return !1;
  }
  return !(r && t.state.status !== r || a && !a(t));
}
function Cc(e, t) {
  return ((t == null ? void 0 : t.queryKeyHashFn) || Ks)(e);
}
function Ks(e) {
  return JSON.stringify(
    e,
    (t, n) => n4(n) ? Object.keys(n).sort().reduce((r, a) => (r[a] = n[a], r), {}) : n
  );
}
function $s(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some((n) => !$s(e[n], t[n])) : !1;
}
function r4(e, t) {
  if (e === t)
    return e;
  const n = im(e) && im(t);
  if (n || n4(e) && n4(t)) {
    const r = n ? e : Object.keys(e), a = r.length, i = n ? t : Object.keys(t), o = i.length, s = n ? [] : {};
    let l = 0;
    for (let c = 0; c < o; c++) {
      const u = n ? c : i[c];
      (!n && r.includes(u) || n) && e[u] === void 0 && t[u] === void 0 ? (s[u] = void 0, l++) : (s[u] = r4(e[u], t[u]), s[u] === e[u] && e[u] !== void 0 && l++);
    }
    return a === o && l === a ? e : s;
  }
  return t;
}
function im(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function n4(e) {
  if (!om(e))
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(!om(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function om(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ste(e) {
  return new Promise((t) => {
    setTimeout(t, e);
  });
}
function lte(e, t, n) {
  if (typeof n.structuralSharing == "function")
    return n.structuralSharing(e, t);
  if (n.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return r4(e, t);
      } catch (r) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${n.queryHash}]: ${r}`
        );
      }
    return r4(e, t);
  }
  return t;
}
function cte(e, t, n = 0) {
  const r = [...e, t];
  return n && r.length > n ? r.slice(1) : r;
}
function ute(e, t, n = 0) {
  const r = [t, ...e];
  return n && r.length > n ? r.slice(0, -1) : r;
}
var M5 = Symbol();
function iw(e, t) {
  return process.env.NODE_ENV !== "production" && e.queryFn === M5 && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.queryHash}'`
  ), !e.queryFn && t != null && t.initialPromise ? () => t.initialPromise : !e.queryFn || e.queryFn === M5 ? () => Promise.reject(new Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
var mi, m2, Wo, sm, dte = (sm = class extends B8 {
  constructor() {
    super(), Gt(this, mi, void 0), Gt(this, m2, void 0), Gt(this, Wo, void 0), ut(this, Wo, (e) => {
      if (!z8 && window.addEventListener) {
        const t = () => e();
        return window.addEventListener("visibilitychange", t, !1), () => {
          window.removeEventListener("visibilitychange", t);
        };
      }
    });
  }
  onSubscribe() {
    de(this, m2) || this.setEventListener(de(this, Wo));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = de(this, m2)) == null || e.call(this), ut(this, m2, void 0));
  }
  setEventListener(e) {
    var t;
    ut(this, Wo, e), (t = de(this, m2)) == null || t.call(this), ut(this, m2, e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    }));
  }
  setFocused(e) {
    de(this, mi) !== e && (ut(this, mi, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((t) => {
      t(e);
    });
  }
  isFocused() {
    var e;
    return typeof de(this, mi) == "boolean" ? de(this, mi) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, mi = /* @__PURE__ */ new WeakMap(), m2 = /* @__PURE__ */ new WeakMap(), Wo = /* @__PURE__ */ new WeakMap(), sm), ow = new dte(), Yo, f2, qo, lm, pte = (lm = class extends B8 {
  constructor() {
    super(), Gt(this, Yo, !0), Gt(this, f2, void 0), Gt(this, qo, void 0), ut(this, qo, (e) => {
      if (!z8 && window.addEventListener) {
        const t = () => e(!0), n = () => e(!1);
        return window.addEventListener("online", t, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", t), window.removeEventListener("offline", n);
        };
      }
    });
  }
  onSubscribe() {
    de(this, f2) || this.setEventListener(de(this, qo));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = de(this, f2)) == null || e.call(this), ut(this, f2, void 0));
  }
  setEventListener(e) {
    var t;
    ut(this, qo, e), (t = de(this, f2)) == null || t.call(this), ut(this, f2, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    de(this, Yo) !== e && (ut(this, Yo, e), this.listeners.forEach((t) => {
      t(e);
    }));
  }
  isOnline() {
    return de(this, Yo);
  }
}, Yo = /* @__PURE__ */ new WeakMap(), f2 = /* @__PURE__ */ new WeakMap(), qo = /* @__PURE__ */ new WeakMap(), lm), P5 = new pte();
function hte() {
  let e, t;
  const n = new Promise((a, i) => {
    e = a, t = i;
  });
  n.status = "pending", n.catch(() => {
  });
  function r(a) {
    Object.assign(n, a), delete n.resolve, delete n.reject;
  }
  return n.resolve = (a) => {
    r({
      status: "fulfilled",
      value: a
    }), e(a);
  }, n.reject = (a) => {
    r({
      status: "rejected",
      reason: a
    }), t(a);
  }, n;
}
function mte(e) {
  return Math.min(1e3 * 2 ** e, 3e4);
}
function sw(e) {
  return (e ?? "online") === "online" ? P5.isOnline() : !0;
}
var lw = class extends Error {
  constructor(e) {
    super("CancelledError"), this.revert = e == null ? void 0 : e.revert, this.silent = e == null ? void 0 : e.silent;
  }
};
function c0(e) {
  return e instanceof lw;
}
function cw(e) {
  let t = !1, n = 0, r = !1, a;
  const i = hte(), o = (f) => {
    var C;
    r || (p(new lw(f)), (C = e.abort) == null || C.call(e));
  }, s = () => {
    t = !0;
  }, l = () => {
    t = !1;
  }, c = () => ow.isFocused() && (e.networkMode === "always" || P5.isOnline()) && e.canRun(), u = () => sw(e.networkMode) && e.canRun(), d = (f) => {
    var C;
    r || (r = !0, (C = e.onSuccess) == null || C.call(e, f), a == null || a(), i.resolve(f));
  }, p = (f) => {
    var C;
    r || (r = !0, (C = e.onError) == null || C.call(e, f), a == null || a(), i.reject(f));
  }, h = () => new Promise((f) => {
    var C;
    a = (_) => {
      (r || c()) && f(_);
    }, (C = e.onPause) == null || C.call(e);
  }).then(() => {
    var f;
    a = void 0, r || (f = e.onContinue) == null || f.call(e);
  }), m = () => {
    if (r)
      return;
    let f;
    const C = n === 0 ? e.initialPromise : void 0;
    try {
      f = C ?? e.fn();
    } catch (_) {
      f = Promise.reject(_);
    }
    Promise.resolve(f).then(d).catch((_) => {
      var v;
      if (r)
        return;
      const w = e.retry ?? (z8 ? 0 : 3), k = e.retryDelay ?? mte, b = typeof k == "function" ? k(n, _) : k, S = w === !0 || typeof w == "number" && n < w || typeof w == "function" && w(n, _);
      if (t || !S) {
        p(_);
        return;
      }
      n++, (v = e.onFail) == null || v.call(e, n, _), ste(b).then(() => c() ? void 0 : h()).then(() => {
        t ? p(_) : m();
      });
    });
  };
  return {
    promise: i,
    cancel: o,
    continue: () => (a == null || a(), i),
    cancelRetry: s,
    continueRetry: l,
    canStart: u,
    start: () => (u() ? m() : h().then(m), i)
  };
}
function fte() {
  let e = [], t = 0, n = (s) => {
    s();
  }, r = (s) => {
    s();
  }, a = (s) => setTimeout(s, 0);
  const i = (s) => {
    t ? e.push(s) : a(() => {
      n(s);
    });
  }, o = () => {
    const s = e;
    e = [], s.length && a(() => {
      r(() => {
        s.forEach((l) => {
          n(l);
        });
      });
    });
  };
  return {
    batch: (s) => {
      let l;
      t++;
      try {
        l = s();
      } finally {
        t--, t || o();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (s) => (...l) => {
      i(() => {
        s(...l);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (s) => {
      n = s;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (s) => {
      r = s;
    },
    setScheduler: (s) => {
      a = s;
    }
  };
}
var lr = fte(), fi, cm, uw = (cm = class {
  constructor() {
    Gt(this, fi, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), ate(this.gcTime) && ut(this, fi, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(e) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      e ?? (z8 ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    de(this, fi) && (clearTimeout(de(this, fi)), ut(this, fi, void 0));
  }
}, fi = /* @__PURE__ */ new WeakMap(), cm), Jo, Xo, ln, ar, Q9, Ci, Ln, sa, um, Cte = (um = class extends uw {
  constructor(e) {
    super(), Gt(this, Ln), Gt(this, Jo, void 0), Gt(this, Xo, void 0), Gt(this, ln, void 0), Gt(this, ar, void 0), Gt(this, Q9, void 0), Gt(this, Ci, void 0), ut(this, Ci, !1), ut(this, Q9, e.defaultOptions), this.setOptions(e.options), this.observers = [], ut(this, ln, e.cache), this.queryKey = e.queryKey, this.queryHash = e.queryHash, ut(this, Jo, yte(this.options)), this.state = e.state ?? de(this, Jo), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = de(this, ar)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...de(this, Q9), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && de(this, ln).remove(this);
  }
  setData(e, t) {
    const n = lte(this.state.data, e, this.options);
    return sr(this, Ln, sa).call(this, {
      data: n,
      type: "success",
      dataUpdatedAt: t == null ? void 0 : t.updatedAt,
      manual: t == null ? void 0 : t.manual
    }), n;
  }
  setState(e, t) {
    sr(this, Ln, sa).call(this, { type: "setState", state: e, setStateOptions: t });
  }
  cancel(e) {
    var t, n;
    const r = (t = de(this, ar)) == null ? void 0 : t.promise;
    return (n = de(this, ar)) == null || n.cancel(e), r ? r.then(dn).catch(dn) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(de(this, Jo));
  }
  isActive() {
    return this.observers.some(
      (e) => ote(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === M5 || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !ite(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const t = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    t == null || t.refetch({ cancelRefetch: !1 }), (e = de(this, ar)) == null || e.continue();
  }
  onOnline() {
    var e;
    const t = this.observers.find((n) => n.shouldFetchOnReconnect());
    t == null || t.refetch({ cancelRefetch: !1 }), (e = de(this, ar)) == null || e.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), de(this, ln).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((t) => t !== e), this.observers.length || (de(this, ar) && (de(this, Ci) ? de(this, ar).cancel({ revert: !0 }) : de(this, ar).cancelRetry()), this.scheduleGc()), de(this, ln).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || sr(this, Ln, sa).call(this, { type: "invalidate" });
  }
  fetch(e, t) {
    var n, r, a;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && t != null && t.cancelRefetch)
        this.cancel({ silent: !0 });
      else if (de(this, ar))
        return de(this, ar).continueRetry(), de(this, ar).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const u = this.observers.find((d) => d.options.queryFn);
      u && this.setOptions(u.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const i = new AbortController(), o = (u) => {
      Object.defineProperty(u, "signal", {
        enumerable: !0,
        get: () => (ut(this, Ci, !0), i.signal)
      });
    }, s = () => {
      const u = iw(this.options, t), d = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return o(d), ut(this, Ci, !1), this.options.persister ? this.options.persister(
        u,
        d,
        this
      ) : u(d);
    }, l = {
      fetchOptions: t,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: s
    };
    o(l), (n = this.options.behavior) == null || n.onFetch(
      l,
      this
    ), ut(this, Xo, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((r = l.fetchOptions) == null ? void 0 : r.meta)) && sr(this, Ln, sa).call(this, { type: "fetch", meta: (a = l.fetchOptions) == null ? void 0 : a.meta });
    const c = (u) => {
      var d, p, h, m;
      c0(u) && u.silent || sr(this, Ln, sa).call(this, {
        type: "error",
        error: u
      }), c0(u) || ((p = (d = de(this, ln).config).onError) == null || p.call(
        d,
        u,
        this
      ), (m = (h = de(this, ln).config).onSettled) == null || m.call(
        h,
        this.state.data,
        u,
        this
      )), this.scheduleGc();
    };
    return ut(this, ar, cw({
      initialPromise: t == null ? void 0 : t.initialPromise,
      fn: l.fetchFn,
      abort: i.abort.bind(i),
      onSuccess: (u) => {
        var d, p, h, m;
        if (u === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), c(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(u);
        } catch (f) {
          c(f);
          return;
        }
        (p = (d = de(this, ln).config).onSuccess) == null || p.call(d, u, this), (m = (h = de(this, ln).config).onSettled) == null || m.call(
          h,
          u,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: c,
      onFail: (u, d) => {
        sr(this, Ln, sa).call(this, { type: "failed", failureCount: u, error: d });
      },
      onPause: () => {
        sr(this, Ln, sa).call(this, { type: "pause" });
      },
      onContinue: () => {
        sr(this, Ln, sa).call(this, { type: "continue" });
      },
      retry: l.options.retry,
      retryDelay: l.options.retryDelay,
      networkMode: l.options.networkMode,
      canRun: () => !0
    })), de(this, ar).start();
  }
}, Jo = /* @__PURE__ */ new WeakMap(), Xo = /* @__PURE__ */ new WeakMap(), ln = /* @__PURE__ */ new WeakMap(), ar = /* @__PURE__ */ new WeakMap(), Q9 = /* @__PURE__ */ new WeakMap(), Ci = /* @__PURE__ */ new WeakMap(), Ln = /* @__PURE__ */ new WeakSet(), sa = function(e) {
  const t = (n) => {
    switch (e.type) {
      case "failed":
        return {
          ...n,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...n,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...n,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...n,
          ...gte(n.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...n,
          data: e.data,
          dataUpdateCount: n.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const r = e.error;
        return c0(r) && r.revert && de(this, Xo) ? { ...de(this, Xo), fetchStatus: "idle" } : {
          ...n,
          error: r,
          errorUpdateCount: n.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: n.fetchFailureCount + 1,
          fetchFailureReason: r,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...n,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...n,
          ...e.state
        };
    }
  };
  this.state = t(this.state), lr.batch(() => {
    this.observers.forEach((n) => {
      n.onQueryUpdate();
    }), de(this, ln).notify({ query: this, type: "updated", action: e });
  });
}, um);
function gte(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: sw(t.networkMode) ? "fetching" : "paused",
    ...e === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function yte(e) {
  const t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var la, dm, vte = (dm = class extends B8 {
  constructor(e = {}) {
    super(), Gt(this, la, void 0), this.config = e, ut(this, la, /* @__PURE__ */ new Map());
  }
  build(e, t, n) {
    const r = t.queryKey, a = t.queryHash ?? Cc(r, t);
    let i = this.get(a);
    return i || (i = new Cte({
      cache: this,
      queryKey: r,
      queryHash: a,
      options: e.defaultQueryOptions(t),
      state: n,
      defaultOptions: e.getQueryDefaults(r)
    }), this.add(i)), i;
  }
  add(e) {
    de(this, la).has(e.queryHash) || (de(this, la).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const t = de(this, la).get(e.queryHash);
    t && (e.destroy(), t === e && de(this, la).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    lr.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return de(this, la).get(e);
  }
  getAll() {
    return [...de(this, la).values()];
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (n) => nm(t, n)
    );
  }
  findAll(e = {}) {
    const t = this.getAll();
    return Object.keys(e).length > 0 ? t.filter((n) => nm(e, n)) : t;
  }
  notify(e) {
    lr.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  onFocus() {
    lr.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    lr.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, la = /* @__PURE__ */ new WeakMap(), dm), ca, pr, gi, ua, La, pm, bte = (pm = class extends uw {
  constructor(e) {
    super(), Gt(this, ua), Gt(this, ca, void 0), Gt(this, pr, void 0), Gt(this, gi, void 0), this.mutationId = e.mutationId, ut(this, pr, e.mutationCache), ut(this, ca, []), this.state = e.state || _te(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    de(this, ca).includes(e) || (de(this, ca).push(e), this.clearGcTimeout(), de(this, pr).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    ut(this, ca, de(this, ca).filter((t) => t !== e)), this.scheduleGc(), de(this, pr).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    de(this, ca).length || (this.state.status === "pending" ? this.scheduleGc() : de(this, pr).remove(this));
  }
  continue() {
    var e;
    return ((e = de(this, gi)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var t, n, r, a, i, o, s, l, c, u, d, p, h, m, f, C, _, v, w, k;
    ut(this, gi, cw({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (P, O) => {
        sr(this, ua, La).call(this, { type: "failed", failureCount: P, error: O });
      },
      onPause: () => {
        sr(this, ua, La).call(this, { type: "pause" });
      },
      onContinue: () => {
        sr(this, ua, La).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => de(this, pr).canRun(this)
    }));
    const b = this.state.status === "pending", S = !de(this, gi).canStart();
    try {
      if (!b) {
        sr(this, ua, La).call(this, { type: "pending", variables: e, isPaused: S }), await ((n = (t = de(this, pr).config).onMutate) == null ? void 0 : n.call(
          t,
          e,
          this
        ));
        const O = await ((a = (r = this.options).onMutate) == null ? void 0 : a.call(r, e));
        O !== this.state.context && sr(this, ua, La).call(this, {
          type: "pending",
          context: O,
          variables: e,
          isPaused: S
        });
      }
      const P = await de(this, gi).start();
      return await ((o = (i = de(this, pr).config).onSuccess) == null ? void 0 : o.call(
        i,
        P,
        e,
        this.state.context,
        this
      )), await ((l = (s = this.options).onSuccess) == null ? void 0 : l.call(s, P, e, this.state.context)), await ((u = (c = de(this, pr).config).onSettled) == null ? void 0 : u.call(
        c,
        P,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((p = (d = this.options).onSettled) == null ? void 0 : p.call(d, P, null, e, this.state.context)), sr(this, ua, La).call(this, { type: "success", data: P }), P;
    } catch (P) {
      try {
        throw await ((m = (h = de(this, pr).config).onError) == null ? void 0 : m.call(
          h,
          P,
          e,
          this.state.context,
          this
        )), await ((C = (f = this.options).onError) == null ? void 0 : C.call(
          f,
          P,
          e,
          this.state.context
        )), await ((v = (_ = de(this, pr).config).onSettled) == null ? void 0 : v.call(
          _,
          void 0,
          P,
          this.state.variables,
          this.state.context,
          this
        )), await ((k = (w = this.options).onSettled) == null ? void 0 : k.call(
          w,
          void 0,
          P,
          e,
          this.state.context
        )), P;
      } finally {
        sr(this, ua, La).call(this, { type: "error", error: P });
      }
    } finally {
      de(this, pr).runNext(this);
    }
  }
}, ca = /* @__PURE__ */ new WeakMap(), pr = /* @__PURE__ */ new WeakMap(), gi = /* @__PURE__ */ new WeakMap(), ua = /* @__PURE__ */ new WeakSet(), La = function(e) {
  const t = (n) => {
    switch (e.type) {
      case "failed":
        return {
          ...n,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...n,
          isPaused: !0
        };
      case "continue":
        return {
          ...n,
          isPaused: !1
        };
      case "pending":
        return {
          ...n,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...n,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...n,
          data: void 0,
          error: e.error,
          failureCount: n.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = t(this.state), lr.batch(() => {
    de(this, ca).forEach((n) => {
      n.onMutationUpdate(e);
    }), de(this, pr).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, pm);
function _te() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Ir, e6, hm, wte = (hm = class extends B8 {
  constructor(e = {}) {
    super(), Gt(this, Ir, void 0), Gt(this, e6, void 0), this.config = e, ut(this, Ir, /* @__PURE__ */ new Map()), ut(this, e6, Date.now());
  }
  build(e, t, n) {
    const r = new bte({
      mutationCache: this,
      mutationId: ++Xl(this, e6)._,
      options: e.defaultMutationOptions(t),
      state: n
    });
    return this.add(r), r;
  }
  add(e) {
    const t = t6(e), n = de(this, Ir).get(t) ?? [];
    n.push(e), de(this, Ir).set(t, n), this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    var t;
    const n = t6(e);
    if (de(this, Ir).has(n)) {
      const r = (t = de(this, Ir).get(n)) == null ? void 0 : t.filter((a) => a !== e);
      r && (r.length === 0 ? de(this, Ir).delete(n) : de(this, Ir).set(n, r));
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    var t;
    const n = (t = de(this, Ir).get(t6(e))) == null ? void 0 : t.find((r) => r.state.status === "pending");
    return !n || n === e;
  }
  runNext(e) {
    var t;
    const n = (t = de(this, Ir).get(t6(e))) == null ? void 0 : t.find((r) => r !== e && r.state.isPaused);
    return (n == null ? void 0 : n.continue()) ?? Promise.resolve();
  }
  clear() {
    lr.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return [...de(this, Ir).values()].flat();
  }
  find(e) {
    const t = { exact: !0, ...e };
    return this.getAll().find(
      (n) => am(t, n)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((t) => am(e, t));
  }
  notify(e) {
    lr.batch(() => {
      this.listeners.forEach((t) => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((t) => t.state.isPaused);
    return lr.batch(
      () => Promise.all(
        e.map((t) => t.continue().catch(dn))
      )
    );
  }
}, Ir = /* @__PURE__ */ new WeakMap(), e6 = /* @__PURE__ */ new WeakMap(), hm);
function t6(e) {
  var t;
  return ((t = e.options.scope) == null ? void 0 : t.id) ?? String(e.mutationId);
}
function mm(e) {
  return {
    onFetch: (t, n) => {
      var r, a, i, o, s;
      const l = t.options, c = (i = (a = (r = t.fetchOptions) == null ? void 0 : r.meta) == null ? void 0 : a.fetchMore) == null ? void 0 : i.direction, u = ((o = t.state.data) == null ? void 0 : o.pages) || [], d = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
      let p = { pages: [], pageParams: [] }, h = 0;
      const m = async () => {
        let f = !1;
        const C = (w) => {
          Object.defineProperty(w, "signal", {
            enumerable: !0,
            get: () => (t.signal.aborted ? f = !0 : t.signal.addEventListener("abort", () => {
              f = !0;
            }), t.signal)
          });
        }, _ = iw(t.options, t.fetchOptions), v = async (w, k, b) => {
          if (f)
            return Promise.reject();
          if (k == null && w.pages.length)
            return Promise.resolve(w);
          const S = {
            queryKey: t.queryKey,
            pageParam: k,
            direction: b ? "backward" : "forward",
            meta: t.options.meta
          };
          C(S);
          const P = await _(
            S
          ), { maxPages: O } = t.options, A = b ? ute : cte;
          return {
            pages: A(w.pages, P, O),
            pageParams: A(w.pageParams, k, O)
          };
        };
        if (c && u.length) {
          const w = c === "backward", k = w ? xte : fm, b = {
            pages: u,
            pageParams: d
          }, S = k(l, b);
          p = await v(b, S, w);
        } else {
          const w = e ?? u.length;
          do {
            const k = h === 0 ? d[0] ?? l.initialPageParam : fm(l, p);
            if (h > 0 && k == null)
              break;
            p = await v(p, k), h++;
          } while (h < w);
        }
        return p;
      };
      t.options.persister ? t.fetchFn = () => {
        var f, C;
        return (C = (f = t.options).persister) == null ? void 0 : C.call(
          f,
          m,
          {
            queryKey: t.queryKey,
            meta: t.options.meta,
            signal: t.signal
          },
          n
        );
      } : t.fetchFn = m;
    }
  };
}
function fm(e, { pages: t, pageParams: n }) {
  const r = t.length - 1;
  return t.length > 0 ? e.getNextPageParam(
    t[r],
    t,
    n[r],
    n
  ) : void 0;
}
function xte(e, { pages: t, pageParams: n }) {
  var r;
  return t.length > 0 ? (r = e.getPreviousPageParam) == null ? void 0 : r.call(e, t[0], t, n[0], n) : void 0;
}
var v1, C2, g2, Qo, es, y2, ts, rs, Cm, Ste = (Cm = class {
  constructor(e = {}) {
    Gt(this, v1, void 0), Gt(this, C2, void 0), Gt(this, g2, void 0), Gt(this, Qo, void 0), Gt(this, es, void 0), Gt(this, y2, void 0), Gt(this, ts, void 0), Gt(this, rs, void 0), ut(this, v1, e.queryCache || new vte()), ut(this, C2, e.mutationCache || new wte()), ut(this, g2, e.defaultOptions || {}), ut(this, Qo, /* @__PURE__ */ new Map()), ut(this, es, /* @__PURE__ */ new Map()), ut(this, y2, 0);
  }
  mount() {
    Xl(this, y2)._++, de(this, y2) === 1 && (ut(this, ts, ow.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), de(this, v1).onFocus());
    })), ut(this, rs, P5.subscribe(async (e) => {
      e && (await this.resumePausedMutations(), de(this, v1).onOnline());
    })));
  }
  unmount() {
    var e, t;
    Xl(this, y2)._--, de(this, y2) === 0 && ((e = de(this, ts)) == null || e.call(this), ut(this, ts, void 0), (t = de(this, rs)) == null || t.call(this), ut(this, rs, void 0));
  }
  isFetching(e) {
    return de(this, v1).findAll({ ...e, fetchStatus: "fetching" }).length;
  }
  isMutating(e) {
    return de(this, C2).findAll({ ...e, status: "pending" }).length;
  }
  getQueryData(e) {
    var t;
    const n = this.defaultQueryOptions({ queryKey: e });
    return (t = de(this, v1).get(n.queryHash)) == null ? void 0 : t.state.data;
  }
  ensureQueryData(e) {
    const t = this.getQueryData(e.queryKey);
    if (t === void 0)
      return this.fetchQuery(e);
    {
      const n = this.defaultQueryOptions(e), r = de(this, v1).build(this, n);
      return e.revalidateIfStale && r.isStaleByTime(rm(n.staleTime, r)) && this.prefetchQuery(n), Promise.resolve(t);
    }
  }
  getQueriesData(e) {
    return de(this, v1).findAll(e).map(({ queryKey: t, state: n }) => {
      const r = n.data;
      return [t, r];
    });
  }
  setQueryData(e, t, n) {
    const r = this.defaultQueryOptions({ queryKey: e }), a = de(this, v1).get(
      r.queryHash
    ), i = a == null ? void 0 : a.state.data, o = nte(t, i);
    if (o !== void 0)
      return de(this, v1).build(this, r).setData(o, { ...n, manual: !0 });
  }
  setQueriesData(e, t, n) {
    return lr.batch(
      () => de(this, v1).findAll(e).map(({ queryKey: r }) => [
        r,
        this.setQueryData(r, t, n)
      ])
    );
  }
  getQueryState(e) {
    var t;
    const n = this.defaultQueryOptions({ queryKey: e });
    return (t = de(this, v1).get(n.queryHash)) == null ? void 0 : t.state;
  }
  removeQueries(e) {
    const t = de(this, v1);
    lr.batch(() => {
      t.findAll(e).forEach((n) => {
        t.remove(n);
      });
    });
  }
  resetQueries(e, t) {
    const n = de(this, v1), r = {
      type: "active",
      ...e
    };
    return lr.batch(() => (n.findAll(e).forEach((a) => {
      a.reset();
    }), this.refetchQueries(r, t)));
  }
  cancelQueries(e = {}, t = {}) {
    const n = { revert: !0, ...t }, r = lr.batch(
      () => de(this, v1).findAll(e).map((a) => a.cancel(n))
    );
    return Promise.all(r).then(dn).catch(dn);
  }
  invalidateQueries(e = {}, t = {}) {
    return lr.batch(() => {
      if (de(this, v1).findAll(e).forEach((r) => {
        r.invalidate();
      }), e.refetchType === "none")
        return Promise.resolve();
      const n = {
        ...e,
        type: e.refetchType ?? e.type ?? "active"
      };
      return this.refetchQueries(n, t);
    });
  }
  refetchQueries(e = {}, t) {
    const n = {
      ...t,
      cancelRefetch: (t == null ? void 0 : t.cancelRefetch) ?? !0
    }, r = lr.batch(
      () => de(this, v1).findAll(e).filter((a) => !a.isDisabled()).map((a) => {
        let i = a.fetch(void 0, n);
        return n.throwOnError || (i = i.catch(dn)), a.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(r).then(dn);
  }
  fetchQuery(e) {
    const t = this.defaultQueryOptions(e);
    t.retry === void 0 && (t.retry = !1);
    const n = de(this, v1).build(this, t);
    return n.isStaleByTime(
      rm(t.staleTime, n)
    ) ? n.fetch(t) : Promise.resolve(n.state.data);
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(dn).catch(dn);
  }
  fetchInfiniteQuery(e) {
    return e.behavior = mm(e.pages), this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(dn).catch(dn);
  }
  ensureInfiniteQueryData(e) {
    return e.behavior = mm(e.pages), this.ensureQueryData(e);
  }
  resumePausedMutations() {
    return P5.isOnline() ? de(this, C2).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return de(this, v1);
  }
  getMutationCache() {
    return de(this, C2);
  }
  getDefaultOptions() {
    return de(this, g2);
  }
  setDefaultOptions(e) {
    ut(this, g2, e);
  }
  setQueryDefaults(e, t) {
    de(this, Qo).set(Ks(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    const t = [...de(this, Qo).values()];
    let n = {};
    return t.forEach((r) => {
      $s(e, r.queryKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  setMutationDefaults(e, t) {
    de(this, es).set(Ks(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    const t = [...de(this, es).values()];
    let n = {};
    return t.forEach((r) => {
      $s(e, r.mutationKey) && (n = { ...n, ...r.defaultOptions });
    }), n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted)
      return e;
    const t = {
      ...de(this, g2).queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: !0
    };
    return t.queryHash || (t.queryHash = Cc(
      t.queryKey,
      t
    )), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.enabled !== !0 && t.queryFn === M5 && (t.enabled = !1), t;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...de(this, g2).mutations,
      ...(e == null ? void 0 : e.mutationKey) && this.getMutationDefaults(e.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    de(this, v1).clear(), de(this, C2).clear();
  }
}, v1 = /* @__PURE__ */ new WeakMap(), C2 = /* @__PURE__ */ new WeakMap(), g2 = /* @__PURE__ */ new WeakMap(), Qo = /* @__PURE__ */ new WeakMap(), es = /* @__PURE__ */ new WeakMap(), y2 = /* @__PURE__ */ new WeakMap(), ts = /* @__PURE__ */ new WeakMap(), rs = /* @__PURE__ */ new WeakMap(), Cm);
pe.createContext(
  void 0
);
var kte = pe.createContext(!1);
kte.Provider;
function Mte() {
  let e = !1;
  return {
    clearReset: () => {
      e = !1;
    },
    reset: () => {
      e = !0;
    },
    isReset: () => e
  };
}
pe.createContext(Mte());
new Ste({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
Qe(null);
function dw(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Pte } = Object.prototype, { getPrototypeOf: gc } = Object, G8 = /* @__PURE__ */ ((e) => (t) => {
  const n = Pte.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), En = (e) => (e = e.toLowerCase(), (t) => G8(t) === e), U8 = (e) => (t) => typeof t === e, { isArray: bo } = Array, Ws = U8("undefined");
function Ete(e) {
  return e !== null && !Ws(e) && e.constructor !== null && !Ws(e.constructor) && Nr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const pw = En("ArrayBuffer");
function Tte(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && pw(e.buffer), t;
}
const Lte = U8("string"), Nr = U8("function"), hw = U8("number"), Z8 = (e) => e !== null && typeof e == "object", Ate = (e) => e === !0 || e === !1, T6 = (e) => {
  if (G8(e) !== "object")
    return !1;
  const t = gc(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Ote = En("Date"), Nte = En("File"), jte = En("Blob"), Rte = En("FileList"), Dte = (e) => Z8(e) && Nr(e.pipe), Ite = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Nr(e.append) && ((t = G8(e)) === "formdata" || // detect form-data instance
  t === "object" && Nr(e.toString) && e.toString() === "[object FormData]"));
}, Hte = En("URLSearchParams"), [Fte, Vte, Bte, zte] = ["ReadableStream", "Request", "Response", "Headers"].map(En), Gte = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function E9(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, a;
  if (typeof e != "object" && (e = [e]), bo(e))
    for (r = 0, a = e.length; r < a; r++)
      t.call(null, e[r], r, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let s;
    for (r = 0; r < o; r++)
      s = i[r], t.call(null, e[s], s, e);
  }
}
function mw(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, a;
  for (; r-- > 0; )
    if (a = n[r], t === a.toLowerCase())
      return a;
  return null;
}
const O2 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, fw = (e) => !Ws(e) && e !== O2;
function a4() {
  const { caseless: e } = fw(this) && this || {}, t = {}, n = (r, a) => {
    const i = e && mw(t, a) || a;
    T6(t[i]) && T6(r) ? t[i] = a4(t[i], r) : T6(r) ? t[i] = a4({}, r) : bo(r) ? t[i] = r.slice() : t[i] = r;
  };
  for (let r = 0, a = arguments.length; r < a; r++)
    arguments[r] && E9(arguments[r], n);
  return t;
}
const Ute = (e, t, n, { allOwnKeys: r } = {}) => (E9(t, (a, i) => {
  n && Nr(a) ? e[i] = dw(a, n) : e[i] = a;
}, { allOwnKeys: r }), e), Zte = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Kte = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, $te = (e, t, n, r) => {
  let a, i, o;
  const s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (a = Object.getOwnPropertyNames(e), i = a.length; i-- > 0; )
      o = a[i], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
    e = n !== !1 && gc(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Wte = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Yte = (e) => {
  if (!e)
    return null;
  if (bo(e))
    return e;
  let t = e.length;
  if (!hw(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, qte = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && gc(Uint8Array)), Jte = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const a = r.value;
    t.call(e, a[0], a[1]);
  }
}, Xte = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Qte = En("HTMLFormElement"), e1e = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, r) {
    return n.toUpperCase() + r;
  }
), gm = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), t1e = En("RegExp"), Cw = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  E9(n, (a, i) => {
    let o;
    (o = t(a, i, e)) !== !1 && (r[i] = o || a);
  }), Object.defineProperties(e, r);
}, r1e = (e) => {
  Cw(e, (t, n) => {
    if (Nr(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Nr(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, n1e = (e, t) => {
  const n = {}, r = (a) => {
    a.forEach((i) => {
      n[i] = !0;
    });
  };
  return bo(e) ? r(e) : r(String(e).split(t)), n;
}, a1e = () => {
}, i1e = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, u0 = "abcdefghijklmnopqrstuvwxyz", ym = "0123456789", gw = {
  DIGIT: ym,
  ALPHA: u0,
  ALPHA_DIGIT: u0 + u0.toUpperCase() + ym
}, o1e = (e = 16, t = gw.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function s1e(e) {
  return !!(e && Nr(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const l1e = (e) => {
  const t = new Array(10), n = (r, a) => {
    if (Z8(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[a] = r;
        const i = bo(r) ? [] : {};
        return E9(r, (o, s) => {
          const l = n(o, a + 1);
          !Ws(l) && (i[s] = l);
        }), t[a] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, c1e = En("AsyncFunction"), u1e = (e) => e && (Z8(e) || Nr(e)) && Nr(e.then) && Nr(e.catch), yw = ((e, t) => e ? setImmediate : t ? ((n, r) => (O2.addEventListener("message", ({ source: a, data: i }) => {
  a === O2 && i === n && r.length && r.shift()();
}, !1), (a) => {
  r.push(a), O2.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Nr(O2.postMessage)
), d1e = typeof queueMicrotask < "u" ? queueMicrotask.bind(O2) : typeof process < "u" && process.nextTick || yw, le = {
  isArray: bo,
  isArrayBuffer: pw,
  isBuffer: Ete,
  isFormData: Ite,
  isArrayBufferView: Tte,
  isString: Lte,
  isNumber: hw,
  isBoolean: Ate,
  isObject: Z8,
  isPlainObject: T6,
  isReadableStream: Fte,
  isRequest: Vte,
  isResponse: Bte,
  isHeaders: zte,
  isUndefined: Ws,
  isDate: Ote,
  isFile: Nte,
  isBlob: jte,
  isRegExp: t1e,
  isFunction: Nr,
  isStream: Dte,
  isURLSearchParams: Hte,
  isTypedArray: qte,
  isFileList: Rte,
  forEach: E9,
  merge: a4,
  extend: Ute,
  trim: Gte,
  stripBOM: Zte,
  inherits: Kte,
  toFlatObject: $te,
  kindOf: G8,
  kindOfTest: En,
  endsWith: Wte,
  toArray: Yte,
  forEachEntry: Jte,
  matchAll: Xte,
  isHTMLForm: Qte,
  hasOwnProperty: gm,
  hasOwnProp: gm,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Cw,
  freezeMethods: r1e,
  toObjectSet: n1e,
  toCamelCase: e1e,
  noop: a1e,
  toFiniteNumber: i1e,
  findKey: mw,
  global: O2,
  isContextDefined: fw,
  ALPHABET: gw,
  generateString: o1e,
  isSpecCompliantForm: s1e,
  toJSONObject: l1e,
  isAsyncFn: c1e,
  isThenable: u1e,
  setImmediate: yw,
  asap: d1e
};
function nt(e, t, n, r, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), a && (this.response = a);
}
le.inherits(nt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: le.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const vw = nt.prototype, bw = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  bw[e] = { value: e };
});
Object.defineProperties(nt, bw);
Object.defineProperty(vw, "isAxiosError", { value: !0 });
nt.from = (e, t, n, r, a, i) => {
  const o = Object.create(vw);
  return le.toFlatObject(e, o, function(s) {
    return s !== Error.prototype;
  }, (s) => s !== "isAxiosError"), nt.call(o, e.message, t, n, r, a), o.cause = e, o.name = e.name, i && Object.assign(o, i), o;
};
const p1e = null;
function i4(e) {
  return le.isPlainObject(e) || le.isArray(e);
}
function _w(e) {
  return le.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function vm(e, t, n) {
  return e ? e.concat(t).map(function(r, a) {
    return r = _w(r), !n && a ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function h1e(e) {
  return le.isArray(e) && !e.some(i4);
}
const m1e = le.toFlatObject(le, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function K8(e, t, n) {
  if (!le.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = le.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, m) {
    return !le.isUndefined(m[h]);
  });
  const r = n.metaTokens, a = n.visitor || c, i = n.dots, o = n.indexes, s = (n.Blob || typeof Blob < "u" && Blob) && le.isSpecCompliantForm(t);
  if (!le.isFunction(a))
    throw new TypeError("visitor must be a function");
  function l(h) {
    if (h === null)
      return "";
    if (le.isDate(h))
      return h.toISOString();
    if (!s && le.isBlob(h))
      throw new nt("Blob is not supported. Use a Buffer instead.");
    return le.isArrayBuffer(h) || le.isTypedArray(h) ? s && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function c(h, m, f) {
    let C = h;
    if (h && !f && typeof h == "object") {
      if (le.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), h = JSON.stringify(h);
      else if (le.isArray(h) && h1e(h) || (le.isFileList(h) || le.endsWith(m, "[]")) && (C = le.toArray(h)))
        return m = _w(m), C.forEach(function(_, v) {
          !(le.isUndefined(_) || _ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? vm([m], v, i) : o === null ? m : m + "[]",
            l(_)
          );
        }), !1;
    }
    return i4(h) ? !0 : (t.append(vm(f, m, i), l(h)), !1);
  }
  const u = [], d = Object.assign(m1e, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: i4
  });
  function p(h, m) {
    if (!le.isUndefined(h)) {
      if (u.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      u.push(h), le.forEach(h, function(f, C) {
        (!(le.isUndefined(f) || f === null) && a.call(
          t,
          f,
          le.isString(C) ? C.trim() : C,
          m,
          d
        )) === !0 && p(f, m ? m.concat(C) : [C]);
      }), u.pop();
    }
  }
  if (!le.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function bm(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function yc(e, t) {
  this._pairs = [], e && K8(e, this, t);
}
const ww = yc.prototype;
ww.append = function(e, t) {
  this._pairs.push([e, t]);
};
ww.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, bm);
  } : bm;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function f1e(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function xw(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || f1e, a = n && n.serialize;
  let i;
  if (a ? i = a(t, n) : i = le.isURLSearchParams(t) ? t.toString() : new yc(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class _m {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    le.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const Sw = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, C1e = typeof URLSearchParams < "u" ? URLSearchParams : yc, g1e = typeof FormData < "u" ? FormData : null, y1e = typeof Blob < "u" ? Blob : null, v1e = {
  isBrowser: !0,
  classes: {
    URLSearchParams: C1e,
    FormData: g1e,
    Blob: y1e
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, vc = typeof window < "u" && typeof document < "u", b1e = ((e) => vc && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), _1e = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", w1e = vc && window.location.href || "http://localhost", x1e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: vc,
  hasStandardBrowserEnv: b1e,
  hasStandardBrowserWebWorkerEnv: _1e,
  origin: w1e
}, Symbol.toStringTag, { value: "Module" })), Cn = {
  ...x1e,
  ...v1e
};
function S1e(e, t) {
  return K8(e, new Cn.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, a, i) {
      return Cn.isNode && le.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function k1e(e) {
  return le.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function M1e(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const a = n.length;
  let i;
  for (r = 0; r < a; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function kw(e) {
  function t(n, r, a, i) {
    let o = n[i++];
    if (o === "__proto__")
      return !0;
    const s = Number.isFinite(+o), l = i >= n.length;
    return o = !o && le.isArray(a) ? a.length : o, l ? (le.hasOwnProp(a, o) ? a[o] = [a[o], r] : a[o] = r, !s) : ((!a[o] || !le.isObject(a[o])) && (a[o] = []), t(n, r, a[o], i) && le.isArray(a[o]) && (a[o] = M1e(a[o])), !s);
  }
  if (le.isFormData(e) && le.isFunction(e.entries)) {
    const n = {};
    return le.forEachEntry(e, (r, a) => {
      t(k1e(r), a, n, 0);
    }), n;
  }
  return null;
}
function P1e(e, t, n) {
  if (le.isString(e))
    try {
      return (t || JSON.parse)(e), le.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (0, JSON.stringify)(e);
}
const T9 = {
  transitional: Sw,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", r = n.indexOf("application/json") > -1, a = le.isObject(e);
    if (a && le.isHTMLForm(e) && (e = new FormData(e)), le.isFormData(e))
      return r ? JSON.stringify(kw(e)) : e;
    if (le.isArrayBuffer(e) || le.isBuffer(e) || le.isStream(e) || le.isFile(e) || le.isBlob(e) || le.isReadableStream(e))
      return e;
    if (le.isArrayBufferView(e))
      return e.buffer;
    if (le.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return S1e(e, this.formSerializer).toString();
      if ((i = le.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const o = this.env && this.env.FormData;
        return K8(
          i ? { "files[]": e } : e,
          o && new o(),
          this.formSerializer
        );
      }
    }
    return a || r ? (t.setContentType("application/json", !1), P1e(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || T9.transitional, n = t && t.forcedJSONParsing, r = this.responseType === "json";
    if (le.isResponse(e) || le.isReadableStream(e))
      return e;
    if (e && le.isString(e) && (n && !this.responseType || r)) {
      const a = !(t && t.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (i) {
        if (a)
          throw i.name === "SyntaxError" ? nt.from(i, nt.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Cn.classes.FormData,
    Blob: Cn.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
le.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  T9.headers[e] = {};
});
const E1e = le.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), T1e = (e) => {
  const t = {};
  let n, r, a;
  return e && e.split(`
`).forEach(function(i) {
    a = i.indexOf(":"), n = i.substring(0, a).trim().toLowerCase(), r = i.substring(a + 1).trim(), !(!n || t[n] && E1e[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, wm = Symbol("internals");
function ns(e) {
  return e && String(e).trim().toLowerCase();
}
function L6(e) {
  return e === !1 || e == null ? e : le.isArray(e) ? e.map(L6) : String(e);
}
function L1e(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const A1e = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function d0(e, t, n, r, a) {
  if (le.isFunction(r))
    return r.call(this, t, n);
  if (a && (t = n), !!le.isString(t)) {
    if (le.isString(r))
      return t.indexOf(r) !== -1;
    if (le.isRegExp(r))
      return r.test(t);
  }
}
function O1e(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function N1e(e, t) {
  const n = le.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(a, i, o) {
        return this[r].call(this, t, a, i, o);
      },
      configurable: !0
    });
  });
}
class br {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const a = this;
    function i(s, l, c) {
      const u = ns(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = le.findKey(a, u);
      (!d || a[d] === void 0 || c === !0 || c === void 0 && a[d] !== !1) && (a[d || l] = L6(s));
    }
    const o = (s, l) => le.forEach(s, (c, u) => i(c, u, l));
    if (le.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (le.isString(t) && (t = t.trim()) && !A1e(t))
      o(T1e(t), n);
    else if (le.isHeaders(t))
      for (const [s, l] of t.entries())
        i(l, s, r);
    else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = ns(t), t) {
      const r = le.findKey(this, t);
      if (r) {
        const a = this[r];
        if (!n)
          return a;
        if (n === !0)
          return L1e(a);
        if (le.isFunction(n))
          return n.call(this, a, r);
        if (le.isRegExp(n))
          return n.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = ns(t), t) {
      const r = le.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || d0(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let a = !1;
    function i(o) {
      if (o = ns(o), o) {
        const s = le.findKey(r, o);
        s && (!n || d0(r, r[s], s, n)) && (delete r[s], a = !0);
      }
    }
    return le.isArray(t) ? t.forEach(i) : i(t), a;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, a = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || d0(this, this[i], i, t, !0)) && (delete this[i], a = !0);
    }
    return a;
  }
  normalize(t) {
    const n = this, r = {};
    return le.forEach(this, (a, i) => {
      const o = le.findKey(r, i);
      if (o) {
        n[o] = L6(a), delete n[i];
        return;
      }
      const s = t ? O1e(i) : String(i).trim();
      s !== i && delete n[i], n[s] = L6(a), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return le.forEach(this, (r, a) => {
      r != null && r !== !1 && (n[a] = t && le.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((a) => r.set(a)), r;
  }
  static accessor(t) {
    const n = (this[wm] = this[wm] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function a(i) {
      const o = ns(i);
      n[o] || (N1e(r, i), n[o] = !0);
    }
    return le.isArray(t) ? t.forEach(a) : a(t), this;
  }
}
br.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
le.reduceDescriptors(br.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
le.freezeMethods(br);
function p0(e, t) {
  const n = this || T9, r = t || n, a = br.from(r.headers);
  let i = r.data;
  return le.forEach(e, function(o) {
    i = o.call(n, i, a.normalize(), t ? t.status : void 0);
  }), a.normalize(), i;
}
function Mw(e) {
  return !!(e && e.__CANCEL__);
}
function _o(e, t, n) {
  nt.call(this, e ?? "canceled", nt.ERR_CANCELED, t, n), this.name = "CanceledError";
}
le.inherits(_o, nt, {
  __CANCEL__: !0
});
function Pw(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new nt(
    "Request failed with status code " + n.status,
    [nt.ERR_BAD_REQUEST, nt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function j1e(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function R1e(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let a = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = r[i];
    o || (o = l), n[a] = s, r[a] = l;
    let u = i, d = 0;
    for (; u !== a; )
      d += n[u++], u = u % e;
    if (a = (a + 1) % e, a === i && (i = (i + 1) % e), l - o < t)
      return;
    const p = c && l - c;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function D1e(e, t) {
  let n = 0, r = 1e3 / t, a, i;
  const o = (s, l = Date.now()) => {
    n = l, a = null, i && (clearTimeout(i), i = null), e.apply(null, s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - n;
    c >= r ? o(s, l) : (a = s, i || (i = setTimeout(() => {
      i = null, o(a);
    }, r - c)));
  }, () => a && o(a)];
}
const E5 = (e, t, n = 3) => {
  let r = 0;
  const a = R1e(50, 250);
  return D1e((i) => {
    const o = i.loaded, s = i.lengthComputable ? i.total : void 0, l = o - r, c = a(l), u = o <= s;
    r = o;
    const d = {
      loaded: o,
      total: s,
      progress: s ? o / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - o) / c : void 0,
      event: i,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, xm = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, Sm = (e) => (...t) => le.asap(() => e(...t)), I1e = Cn.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let n;
    function r(a) {
      let i = a;
      return e && (t.setAttribute("href", i), i = t.href), t.setAttribute("href", i), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return n = r(window.location.href), function(a) {
      const i = le.isString(a) ? r(a) : a;
      return i.protocol === n.protocol && i.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), H1e = Cn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, a, i) {
      const o = [e + "=" + encodeURIComponent(t)];
      le.isNumber(n) && o.push("expires=" + new Date(n).toGMTString()), le.isString(r) && o.push("path=" + r), le.isString(a) && o.push("domain=" + a), i === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function F1e(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function V1e(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Ew(e, t) {
  return e && !F1e(t) ? V1e(e, t) : t;
}
const km = (e) => e instanceof br ? { ...e } : e;
function J2(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d) {
    return le.isPlainObject(c) && le.isPlainObject(u) ? le.merge.call({ caseless: d }, c, u) : le.isPlainObject(u) ? le.merge({}, u) : le.isArray(u) ? u.slice() : u;
  }
  function a(c, u, d) {
    if (le.isUndefined(u)) {
      if (!le.isUndefined(c))
        return r(void 0, c, d);
    } else
      return r(c, u, d);
  }
  function i(c, u) {
    if (!le.isUndefined(u))
      return r(void 0, u);
  }
  function o(c, u) {
    if (le.isUndefined(u)) {
      if (!le.isUndefined(c))
        return r(void 0, c);
    } else
      return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (c, u) => a(km(c), km(u), !0)
  };
  return le.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const u = l[c] || a, d = u(e[c], t[c], c);
    le.isUndefined(d) && u !== s || (n[c] = d);
  }), n;
}
const Tw = (e) => {
  const t = J2({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: a, xsrfCookieName: i, headers: o, auth: s } = t;
  t.headers = o = br.from(o), t.url = xw(Ew(t.baseURL, t.url), e.params, e.paramsSerializer), s && o.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (le.isFormData(n)) {
    if (Cn.hasStandardBrowserEnv || Cn.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((l = o.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      o.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Cn.hasStandardBrowserEnv && (r && le.isFunction(r) && (r = r(t)), r || r !== !1 && I1e(t.url))) {
    const c = a && i && H1e.read(i);
    c && o.set(a, c);
  }
  return t;
}, B1e = typeof XMLHttpRequest < "u", z1e = B1e && function(e) {
  return new Promise(function(t, n) {
    const r = Tw(e);
    let a = r.data;
    const i = br.from(r.headers).normalize();
    let { responseType: o, onUploadProgress: s, onDownloadProgress: l } = r, c, u, d, p, h;
    function m() {
      p && p(), h && h(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let f = new XMLHttpRequest();
    f.open(r.method.toUpperCase(), r.url, !0), f.timeout = r.timeout;
    function C() {
      if (!f)
        return;
      const v = br.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), w = {
        data: !o || o === "text" || o === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: v,
        config: e,
        request: f
      };
      Pw(function(k) {
        t(k), m();
      }, function(k) {
        n(k), m();
      }, w), f = null;
    }
    "onloadend" in f ? f.onloadend = C : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(C);
    }, f.onabort = function() {
      f && (n(new nt("Request aborted", nt.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function() {
      n(new nt("Network Error", nt.ERR_NETWORK, e, f)), f = null;
    }, f.ontimeout = function() {
      let v = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const w = r.transitional || Sw;
      r.timeoutErrorMessage && (v = r.timeoutErrorMessage), n(new nt(
        v,
        w.clarifyTimeoutError ? nt.ETIMEDOUT : nt.ECONNABORTED,
        e,
        f
      )), f = null;
    }, a === void 0 && i.setContentType(null), "setRequestHeader" in f && le.forEach(i.toJSON(), function(v, w) {
      f.setRequestHeader(w, v);
    }), le.isUndefined(r.withCredentials) || (f.withCredentials = !!r.withCredentials), o && o !== "json" && (f.responseType = r.responseType), l && ([d, h] = E5(l, !0), f.addEventListener("progress", d)), s && f.upload && ([u, p] = E5(s), f.upload.addEventListener("progress", u), f.upload.addEventListener("loadend", p)), (r.cancelToken || r.signal) && (c = (v) => {
      f && (n(!v || v.type ? new _o(null, e, f) : v), f.abort(), f = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const _ = j1e(r.url);
    if (_ && Cn.protocols.indexOf(_) === -1) {
      n(new nt("Unsupported protocol " + _ + ":", nt.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(a || null);
  });
}, G1e = (e, t) => {
  let n = new AbortController(), r;
  const a = function(l) {
    if (!r) {
      r = !0, o();
      const c = l instanceof Error ? l : this.reason;
      n.abort(c instanceof nt ? c : new _o(c instanceof Error ? c.message : c));
    }
  };
  let i = t && setTimeout(() => {
    a(new nt(`timeout ${t} of ms exceeded`, nt.ETIMEDOUT));
  }, t);
  const o = () => {
    e && (i && clearTimeout(i), i = null, e.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", a) : l.unsubscribe(a));
    }), e = null);
  };
  e.forEach((l) => l && l.addEventListener && l.addEventListener("abort", a));
  const { signal: s } = n;
  return s.unsubscribe = o, [s, () => {
    i && clearTimeout(i), i = null;
  }];
}, U1e = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, a;
  for (; r < n; )
    a = r + t, yield e.slice(r, a), r = a;
}, Z1e = async function* (e, t, n) {
  for await (const r of e)
    yield* U1e(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, Mm = (e, t, n, r, a) => {
  const i = Z1e(e, t, a);
  let o = 0, s, l = (c) => {
    s || (s = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: d } = await i.next();
        if (u) {
          l(), c.close();
          return;
        }
        let p = d.byteLength;
        if (n) {
          let h = o += p;
          n(h);
        }
        c.enqueue(new Uint8Array(d));
      } catch (u) {
        throw l(u), u;
      }
    },
    cancel(c) {
      return l(c), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, $8 = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Lw = $8 && typeof ReadableStream == "function", o4 = $8 && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Aw = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, K1e = Lw && Aw(() => {
  let e = !1;
  const t = new Request(Cn.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Pm = 64 * 1024, s4 = Lw && Aw(() => le.isReadableStream(new Response("").body)), T5 = {
  stream: s4 && ((e) => e.body)
};
$8 && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !T5[t] && (T5[t] = le.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new nt(`Response type '${t}' is not supported`, nt.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const $1e = async (e) => {
  if (e == null)
    return 0;
  if (le.isBlob(e))
    return e.size;
  if (le.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (le.isArrayBufferView(e) || le.isArrayBuffer(e))
    return e.byteLength;
  if (le.isURLSearchParams(e) && (e = e + ""), le.isString(e))
    return (await o4(e)).byteLength;
}, W1e = async (e, t) => le.toFiniteNumber(e.getContentLength()) ?? $1e(t), Y1e = $8 && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: a,
    cancelToken: i,
    timeout: o,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = Tw(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [h, m] = a || i || o ? G1e([a, i], o) : [], f, C;
  const _ = () => {
    !f && setTimeout(() => {
      h && h.unsubscribe();
    }), f = !0;
  };
  let v;
  try {
    if (l && K1e && n !== "get" && n !== "head" && (v = await W1e(u, r)) !== 0) {
      let S = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), P;
      if (le.isFormData(r) && (P = S.headers.get("content-type")) && u.setContentType(P), S.body) {
        const [O, A] = xm(
          v,
          E5(Sm(l))
        );
        r = Mm(S.body, Pm, O, A, o4);
      }
    }
    le.isString(d) || (d = d ? "include" : "omit"), C = new Request(t, {
      ...p,
      signal: h,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: d
    });
    let w = await fetch(C);
    const k = s4 && (c === "stream" || c === "response");
    if (s4 && (s || k)) {
      const S = {};
      ["status", "statusText", "headers"].forEach((L) => {
        S[L] = w[L];
      });
      const P = le.toFiniteNumber(w.headers.get("content-length")), [O, A] = s && xm(
        P,
        E5(Sm(s), !0)
      ) || [];
      w = new Response(
        Mm(w.body, Pm, O, () => {
          A && A(), k && _();
        }, o4),
        S
      );
    }
    c = c || "text";
    let b = await T5[le.findKey(T5, c) || "text"](w, e);
    return !k && _(), m && m(), await new Promise((S, P) => {
      Pw(S, P, {
        data: b,
        headers: br.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: e,
        request: C
      });
    });
  } catch (w) {
    throw _(), w && w.name === "TypeError" && /fetch/i.test(w.message) ? Object.assign(
      new nt("Network Error", nt.ERR_NETWORK, e, C),
      {
        cause: w.cause || w
      }
    ) : nt.from(w, w && w.code, e, C);
  }
}), l4 = {
  http: p1e,
  xhr: z1e,
  fetch: Y1e
};
le.forEach(l4, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Em = (e) => `- ${e}`, q1e = (e) => le.isFunction(e) || e === null || e === !1, Ow = {
  getAdapter: (e) => {
    e = le.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const a = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let o;
      if (r = n, !q1e(n) && (r = l4[(o = String(n)).toLowerCase()], r === void 0))
        throw new nt(`Unknown adapter '${o}'`);
      if (r)
        break;
      a[o || "#" + i] = r;
    }
    if (!r) {
      const i = Object.entries(a).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? i.length > 1 ? `since :
` + i.map(Em).join(`
`) : " " + Em(i[0]) : "as no adapter specified";
      throw new nt(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: l4
};
function h0(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new _o(null, e);
}
function Tm(e) {
  return h0(e), e.headers = br.from(e.headers), e.data = p0.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ow.getAdapter(e.adapter || T9.adapter)(e).then(function(t) {
    return h0(e), t.data = p0.call(
      e,
      e.transformResponse,
      t
    ), t.headers = br.from(t.headers), t;
  }, function(t) {
    return Mw(t) || (h0(e), t && t.response && (t.response.data = p0.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = br.from(t.response.headers))), Promise.reject(t);
  });
}
const Nw = "1.7.4", bc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  bc[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Lm = {};
bc.transitional = function(e, t, n) {
  function r(a, i) {
    return "[Axios v" + Nw + "] Transitional option '" + a + "'" + i + (n ? ". " + n : "");
  }
  return (a, i, o) => {
    if (e === !1)
      throw new nt(
        r(i, " has been removed" + (t ? " in " + t : "")),
        nt.ERR_DEPRECATED
      );
    return t && !Lm[i] && (Lm[i] = !0, console.warn(
      r(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(a, i, o) : !0;
  };
};
function J1e(e, t, n) {
  if (typeof e != "object")
    throw new nt("options must be an object", nt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let a = r.length;
  for (; a-- > 0; ) {
    const i = r[a], o = t[i];
    if (o) {
      const s = e[i], l = s === void 0 || o(s, i, e);
      if (l !== !0)
        throw new nt("option " + i + " must be " + l, nt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new nt("Unknown option " + i, nt.ERR_BAD_OPTION);
  }
}
const c4 = {
  assertOptions: J1e,
  validators: bc
}, Aa = c4.validators;
class z2 {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new _m(),
      response: new _m()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let a;
        Error.captureStackTrace ? Error.captureStackTrace(a = {}) : a = new Error();
        const i = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = J2(this.defaults, n);
    const { transitional: r, paramsSerializer: a, headers: i } = n;
    r !== void 0 && c4.assertOptions(r, {
      silentJSONParsing: Aa.transitional(Aa.boolean),
      forcedJSONParsing: Aa.transitional(Aa.boolean),
      clarifyTimeoutError: Aa.transitional(Aa.boolean)
    }, !1), a != null && (le.isFunction(a) ? n.paramsSerializer = {
      serialize: a
    } : c4.assertOptions(a, {
      encode: Aa.function,
      serialize: Aa.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && le.merge(
      i.common,
      i[n.method]
    );
    i && le.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete i[m];
      }
    ), n.headers = br.concat(o, i);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (l = l && m.synchronous, s.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let u, d = 0, p;
    if (!l) {
      const m = [Tm.bind(this), void 0];
      for (m.unshift.apply(m, s), m.push.apply(m, c), p = m.length, u = Promise.resolve(n); d < p; )
        u = u.then(m[d++], m[d++]);
      return u;
    }
    p = s.length;
    let h = n;
    for (d = 0; d < p; ) {
      const m = s[d++], f = s[d++];
      try {
        h = m(h);
      } catch (C) {
        f.call(this, C);
        break;
      }
    }
    try {
      u = Tm.call(this, h);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, p = c.length; d < p; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = J2(this.defaults, t);
    const n = Ew(t.baseURL, t.url);
    return xw(n, t.params, t.paramsSerializer);
  }
}
le.forEach(["delete", "get", "head", "options"], function(e) {
  z2.prototype[e] = function(t, n) {
    return this.request(J2(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
le.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(r, a, i) {
      return this.request(J2(i || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: r,
        data: a
      }));
    };
  }
  z2.prototype[e] = t(), z2.prototype[e + "Form"] = t(!0);
});
class _c {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const r = this;
    this.promise.then((a) => {
      if (!r._listeners)
        return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](a);
      r._listeners = null;
    }), this.promise.then = (a) => {
      let i;
      const o = new Promise((s) => {
        r.subscribe(s), i = s;
      }).then(a);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(a, i, o) {
      r.reason || (r.reason = new _o(a, i, o), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new _c(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
}
function X1e(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function Q1e(e) {
  return le.isObject(e) && e.isAxiosError === !0;
}
const u4 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(u4).forEach(([e, t]) => {
  u4[t] = e;
});
function jw(e) {
  const t = new z2(e), n = dw(z2.prototype.request, t);
  return le.extend(n, z2.prototype, t, { allOwnKeys: !0 }), le.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return jw(J2(e, r));
  }, n;
}
const N1 = jw(T9);
N1.Axios = z2;
N1.CanceledError = _o;
N1.CancelToken = _c;
N1.isCancel = Mw;
N1.VERSION = Nw;
N1.toFormData = K8;
N1.AxiosError = nt;
N1.Cancel = N1.CanceledError;
N1.all = function(e) {
  return Promise.all(e);
};
N1.spread = X1e;
N1.isAxiosError = Q1e;
N1.mergeConfig = J2;
N1.AxiosHeaders = br;
N1.formToJSON = (e) => kw(le.isHTMLForm(e) ? new FormData(e) : e);
N1.getAdapter = Ow.getAdapter;
N1.HttpStatusCode = u4;
N1.default = N1;
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function Am(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Rw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Am(Object(n), !0).forEach(function(r) {
      nre(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Am(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ere(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Dw(e) {
  var t = ere(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function d4(e) {
  "@babel/helpers - typeof";
  return d4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, d4(e);
}
function tre(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Om(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Dw(r.key), r);
  }
}
function rre(e, t, n) {
  return t && Om(e.prototype, t), n && Om(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function nre(e, t, n) {
  return t = Dw(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Iw(e) {
  return are(e) || ire(e) || ore(e) || sre();
}
function are(e) {
  if (Array.isArray(e))
    return p4(e);
}
function ire(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ore(e, t) {
  if (e) {
    if (typeof e == "string")
      return p4(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return p4(e, t);
  }
}
function p4(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function sre() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var W8 = typeof window < "u" && typeof window.document < "u", Qn = W8 ? window : {}, wc = W8 && Qn.document.documentElement ? "ontouchstart" in Qn.document.documentElement : !1, xc = W8 ? "PointerEvent" in Qn : !1, i1 = "cropper", Sc = "all", Hw = "crop", Fw = "move", Vw = "zoom", v2 = "e", b2 = "w", yi = "s", Oa = "n", as = "ne", is = "nw", os = "se", ss = "sw", h4 = "".concat(i1, "-crop"), Nm = "".concat(i1, "-disabled"), fr = "".concat(i1, "-hidden"), jm = "".concat(i1, "-hide"), lre = "".concat(i1, "-invisible"), L5 = "".concat(i1, "-modal"), m4 = "".concat(i1, "-move"), Ys = "".concat(i1, "Action"), r6 = "".concat(i1, "Preview"), kc = "crop", Bw = "move", zw = "none", f4 = "crop", C4 = "cropend", g4 = "cropmove", y4 = "cropstart", Rm = "dblclick", cre = wc ? "touchstart" : "mousedown", ure = wc ? "touchmove" : "mousemove", dre = wc ? "touchend touchcancel" : "mouseup", Dm = xc ? "pointerdown" : cre, Im = xc ? "pointermove" : ure, Hm = xc ? "pointerup pointercancel" : dre, Fm = "ready", Vm = "resize", Bm = "wheel", v4 = "zoom", zm = "image/jpeg", pre = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, hre = /^data:/, mre = /^data:image\/jpeg;base64,/, fre = /^img|canvas$/i, Gw = 200, Uw = 100, Gm = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: kc,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: Gw,
  minContainerHeight: Uw,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, Cre = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', gre = Number.isNaN || Qn.isNaN;
function gt(e) {
  return typeof e == "number" && !gre(e);
}
var Um = function(e) {
  return e > 0 && e < 1 / 0;
};
function m0(e) {
  return typeof e > "u";
}
function X2(e) {
  return d4(e) === "object" && e !== null;
}
var yre = Object.prototype.hasOwnProperty;
function ki(e) {
  if (!X2(e))
    return !1;
  try {
    var t = e.constructor, n = t.prototype;
    return t && n && yre.call(n, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function hr(e) {
  return typeof e == "function";
}
var vre = Array.prototype.slice;
function Zw(e) {
  return Array.from ? Array.from(e) : vre.call(e);
}
function S1(e, t) {
  return e && hr(t) && (Array.isArray(e) || gt(e.length) ? Zw(e).forEach(function(n, r) {
    t.call(e, n, r, e);
  }) : X2(e) && Object.keys(e).forEach(function(n) {
    t.call(e, e[n], n, e);
  })), e;
}
var o1 = Object.assign || function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return X2(e) && n.length > 0 && n.forEach(function(a) {
    X2(a) && Object.keys(a).forEach(function(i) {
      e[i] = a[i];
    });
  }), e;
}, bre = /\.\d*(?:0|9){12}\d*$/;
function Ni(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return bre.test(e) ? Math.round(e * t) / t : e;
}
var _re = /^width|height|left|top|marginLeft|marginTop$/;
function Va(e, t) {
  var n = e.style;
  S1(t, function(r, a) {
    _re.test(a) && gt(r) && (r = "".concat(r, "px")), n[a] = r;
  });
}
function wre(e, t) {
  return e.classList ? e.classList.contains(t) : e.className.indexOf(t) > -1;
}
function D1(e, t) {
  if (t) {
    if (gt(e.length)) {
      S1(e, function(r) {
        D1(r, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.add(t);
      return;
    }
    var n = e.className.trim();
    n ? n.indexOf(t) < 0 && (e.className = "".concat(n, " ").concat(t)) : e.className = t;
  }
}
function Yn(e, t) {
  if (t) {
    if (gt(e.length)) {
      S1(e, function(n) {
        Yn(n, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.remove(t);
      return;
    }
    e.className.indexOf(t) >= 0 && (e.className = e.className.replace(t, ""));
  }
}
function Mi(e, t, n) {
  if (t) {
    if (gt(e.length)) {
      S1(e, function(r) {
        Mi(r, t, n);
      });
      return;
    }
    n ? D1(e, t) : Yn(e, t);
  }
}
var xre = /([a-z\d])([A-Z])/g;
function Mc(e) {
  return e.replace(xre, "$1-$2").toLowerCase();
}
function b4(e, t) {
  return X2(e[t]) ? e[t] : e.dataset ? e.dataset[t] : e.getAttribute("data-".concat(Mc(t)));
}
function qs(e, t, n) {
  X2(n) ? e[t] = n : e.dataset ? e.dataset[t] = n : e.setAttribute("data-".concat(Mc(t)), n);
}
function Sre(e, t) {
  if (X2(e[t]))
    try {
      delete e[t];
    } catch {
      e[t] = void 0;
    }
  else if (e.dataset)
    try {
      delete e.dataset[t];
    } catch {
      e.dataset[t] = void 0;
    }
  else
    e.removeAttribute("data-".concat(Mc(t)));
}
var Kw = /\s\s*/, $w = function() {
  var e = !1;
  if (W8) {
    var t = !1, n = function() {
    }, r = Object.defineProperty({}, "once", {
      get: function() {
        return e = !0, t;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(a) {
        t = a;
      }
    });
    Qn.addEventListener("test", n, r), Qn.removeEventListener("test", n, r);
  }
  return e;
}();
function cn(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = n;
  t.trim().split(Kw).forEach(function(i) {
    if (!$w) {
      var o = e.listeners;
      o && o[i] && o[i][n] && (a = o[i][n], delete o[i][n], Object.keys(o[i]).length === 0 && delete o[i], Object.keys(o).length === 0 && delete e.listeners);
    }
    e.removeEventListener(i, a, r);
  });
}
function Hr(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, a = n;
  t.trim().split(Kw).forEach(function(i) {
    if (r.once && !$w) {
      var o = e.listeners, s = o === void 0 ? {} : o;
      a = function() {
        delete s[i][n], e.removeEventListener(i, a, r);
        for (var l = arguments.length, c = new Array(l), u = 0; u < l; u++)
          c[u] = arguments[u];
        n.apply(e, c);
      }, s[i] || (s[i] = {}), s[i][n] && e.removeEventListener(i, s[i][n], r), s[i][n] = a, e.listeners = s;
    }
    e.addEventListener(i, a, r);
  });
}
function ji(e, t, n) {
  var r;
  return hr(Event) && hr(CustomEvent) ? r = new CustomEvent(t, {
    detail: n,
    bubbles: !0,
    cancelable: !0
  }) : (r = document.createEvent("CustomEvent"), r.initCustomEvent(t, !0, !0, n)), e.dispatchEvent(r);
}
function Ww(e) {
  var t = e.getBoundingClientRect();
  return {
    left: t.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: t.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var f0 = Qn.location, kre = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function Zm(e) {
  var t = e.match(kre);
  return t !== null && (t[1] !== f0.protocol || t[2] !== f0.hostname || t[3] !== f0.port);
}
function Km(e) {
  var t = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return e + (e.indexOf("?") === -1 ? "?" : "&") + t;
}
function _s(e) {
  var t = e.rotate, n = e.scaleX, r = e.scaleY, a = e.translateX, i = e.translateY, o = [];
  gt(a) && a !== 0 && o.push("translateX(".concat(a, "px)")), gt(i) && i !== 0 && o.push("translateY(".concat(i, "px)")), gt(t) && t !== 0 && o.push("rotate(".concat(t, "deg)")), gt(n) && n !== 1 && o.push("scaleX(".concat(n, ")")), gt(r) && r !== 1 && o.push("scaleY(".concat(r, ")"));
  var s = o.length ? o.join(" ") : "none";
  return {
    WebkitTransform: s,
    msTransform: s,
    transform: s
  };
}
function Mre(e) {
  var t = Rw({}, e), n = 0;
  return S1(e, function(r, a) {
    delete t[a], S1(t, function(i) {
      var o = Math.abs(r.startX - i.startX), s = Math.abs(r.startY - i.startY), l = Math.abs(r.endX - i.endX), c = Math.abs(r.endY - i.endY), u = Math.sqrt(o * o + s * s), d = Math.sqrt(l * l + c * c), p = (d - u) / u;
      Math.abs(p) > Math.abs(n) && (n = p);
    });
  }), n;
}
function n6(e, t) {
  var n = e.pageX, r = e.pageY, a = {
    endX: n,
    endY: r
  };
  return t ? a : Rw({
    startX: n,
    startY: r
  }, a);
}
function Pre(e) {
  var t = 0, n = 0, r = 0;
  return S1(e, function(a) {
    var i = a.startX, o = a.startY;
    t += i, n += o, r += 1;
  }), t /= r, n /= r, {
    pageX: t,
    pageY: n
  };
}
function Ba(e) {
  var t = e.aspectRatio, n = e.height, r = e.width, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", i = Um(r), o = Um(n);
  if (i && o) {
    var s = n * t;
    a === "contain" && s > r || a === "cover" && s < r ? n = r / t : r = n * t;
  } else
    i ? n = r / t : o && (r = n * t);
  return {
    width: r,
    height: n
  };
}
function Ere(e) {
  var t = e.width, n = e.height, r = e.degree;
  if (r = Math.abs(r) % 180, r === 90)
    return {
      width: n,
      height: t
    };
  var a = r % 90 * Math.PI / 180, i = Math.sin(a), o = Math.cos(a), s = t * o + n * i, l = t * i + n * o;
  return r > 90 ? {
    width: l,
    height: s
  } : {
    width: s,
    height: l
  };
}
function Tre(e, t, n, r) {
  var a = t.aspectRatio, i = t.naturalWidth, o = t.naturalHeight, s = t.rotate, l = s === void 0 ? 0 : s, c = t.scaleX, u = c === void 0 ? 1 : c, d = t.scaleY, p = d === void 0 ? 1 : d, h = n.aspectRatio, m = n.naturalWidth, f = n.naturalHeight, C = r.fillColor, _ = C === void 0 ? "transparent" : C, v = r.imageSmoothingEnabled, w = v === void 0 ? !0 : v, k = r.imageSmoothingQuality, b = k === void 0 ? "low" : k, S = r.maxWidth, P = S === void 0 ? 1 / 0 : S, O = r.maxHeight, A = O === void 0 ? 1 / 0 : O, L = r.minWidth, I = L === void 0 ? 0 : L, D = r.minHeight, U = D === void 0 ? 0 : D, z = document.createElement("canvas"), $ = z.getContext("2d"), ee = Ba({
    aspectRatio: h,
    width: P,
    height: A
  }), Z = Ba({
    aspectRatio: h,
    width: I,
    height: U
  }, "cover"), G = Math.min(ee.width, Math.max(Z.width, m)), W = Math.min(ee.height, Math.max(Z.height, f)), j = Ba({
    aspectRatio: a,
    width: P,
    height: A
  }), T = Ba({
    aspectRatio: a,
    width: I,
    height: U
  }, "cover"), F = Math.min(j.width, Math.max(T.width, i)), N = Math.min(j.height, Math.max(T.height, o)), Y = [-F / 2, -N / 2, F, N];
  return z.width = Ni(G), z.height = Ni(W), $.fillStyle = _, $.fillRect(0, 0, G, W), $.save(), $.translate(G / 2, W / 2), $.rotate(l * Math.PI / 180), $.scale(u, p), $.imageSmoothingEnabled = w, $.imageSmoothingQuality = b, $.drawImage.apply($, [e].concat(Iw(Y.map(function(Q) {
    return Math.floor(Ni(Q));
  })))), $.restore(), z;
}
var Yw = String.fromCharCode;
function Lre(e, t, n) {
  var r = "";
  n += t;
  for (var a = t; a < n; a += 1)
    r += Yw(e.getUint8(a));
  return r;
}
var Are = /^data:.*,/;
function Ore(e) {
  var t = e.replace(Are, ""), n = atob(t), r = new ArrayBuffer(n.length), a = new Uint8Array(r);
  return S1(a, function(i, o) {
    a[o] = n.charCodeAt(o);
  }), r;
}
function Nre(e, t) {
  for (var n = [], r = 8192, a = new Uint8Array(e); a.length > 0; )
    n.push(Yw.apply(null, Zw(a.subarray(0, r)))), a = a.subarray(r);
  return "data:".concat(t, ";base64,").concat(btoa(n.join("")));
}
function jre(e) {
  var t = new DataView(e), n;
  try {
    var r, a, i;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var o = t.byteLength, s = 2; s + 1 < o; ) {
        if (t.getUint8(s) === 255 && t.getUint8(s + 1) === 225) {
          a = s;
          break;
        }
        s += 1;
      }
    if (a) {
      var l = a + 4, c = a + 10;
      if (Lre(t, l, 4) === "Exif") {
        var u = t.getUint16(c);
        if (r = u === 18761, (r || u === 19789) && t.getUint16(c + 2, r) === 42) {
          var d = t.getUint32(c + 4, r);
          d >= 8 && (i = c + d);
        }
      }
    }
    if (i) {
      var p = t.getUint16(i, r), h, m;
      for (m = 0; m < p; m += 1)
        if (h = i + m * 12 + 2, t.getUint16(h, r) === 274) {
          h += 8, n = t.getUint16(h, r), t.setUint16(h, 1, r);
          break;
        }
    }
  } catch {
    n = 1;
  }
  return n;
}
function Rre(e) {
  var t = 0, n = 1, r = 1;
  switch (e) {
    case 2:
      n = -1;
      break;
    case 3:
      t = -180;
      break;
    case 4:
      r = -1;
      break;
    case 5:
      t = 90, r = -1;
      break;
    case 6:
      t = 90;
      break;
    case 7:
      t = 90, n = -1;
      break;
    case 8:
      t = -90;
      break;
  }
  return {
    rotate: t,
    scaleX: n,
    scaleY: r
  };
}
var Dre = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, t = this.options, n = this.container, r = this.cropper, a = Number(t.minContainerWidth), i = Number(t.minContainerHeight);
    D1(r, fr), Yn(e, fr);
    var o = {
      width: Math.max(n.offsetWidth, a >= 0 ? a : Gw),
      height: Math.max(n.offsetHeight, i >= 0 ? i : Uw)
    };
    this.containerData = o, Va(r, {
      width: o.width,
      height: o.height
    }), D1(e, fr), Yn(r, fr);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, t = this.imageData, n = this.options.viewMode, r = Math.abs(t.rotate) % 180 === 90, a = r ? t.naturalHeight : t.naturalWidth, i = r ? t.naturalWidth : t.naturalHeight, o = a / i, s = e.width, l = e.height;
    e.height * o > e.width ? n === 3 ? s = e.height * o : l = e.width / o : n === 3 ? l = e.width / o : s = e.height * o;
    var c = {
      aspectRatio: o,
      naturalWidth: a,
      naturalHeight: i,
      width: s,
      height: l
    };
    this.canvasData = c, this.limited = n === 1 || n === 2, this.limitCanvas(!0, !0), c.width = Math.min(Math.max(c.width, c.minWidth), c.maxWidth), c.height = Math.min(Math.max(c.height, c.minHeight), c.maxHeight), c.left = (e.width - c.width) / 2, c.top = (e.height - c.height) / 2, c.oldLeft = c.left, c.oldTop = c.top, this.initialCanvasData = o1({}, c);
  },
  limitCanvas: function(e, t) {
    var n = this.options, r = this.containerData, a = this.canvasData, i = this.cropBoxData, o = n.viewMode, s = a.aspectRatio, l = this.cropped && i;
    if (e) {
      var c = Number(n.minCanvasWidth) || 0, u = Number(n.minCanvasHeight) || 0;
      o > 1 ? (c = Math.max(c, r.width), u = Math.max(u, r.height), o === 3 && (u * s > c ? c = u * s : u = c / s)) : o > 0 && (c ? c = Math.max(c, l ? i.width : 0) : u ? u = Math.max(u, l ? i.height : 0) : l && (c = i.width, u = i.height, u * s > c ? c = u * s : u = c / s));
      var d = Ba({
        aspectRatio: s,
        width: c,
        height: u
      });
      c = d.width, u = d.height, a.minWidth = c, a.minHeight = u, a.maxWidth = 1 / 0, a.maxHeight = 1 / 0;
    }
    if (t)
      if (o > (l ? 0 : 1)) {
        var p = r.width - a.width, h = r.height - a.height;
        a.minLeft = Math.min(0, p), a.minTop = Math.min(0, h), a.maxLeft = Math.max(0, p), a.maxTop = Math.max(0, h), l && this.limited && (a.minLeft = Math.min(i.left, i.left + (i.width - a.width)), a.minTop = Math.min(i.top, i.top + (i.height - a.height)), a.maxLeft = i.left, a.maxTop = i.top, o === 2 && (a.width >= r.width && (a.minLeft = Math.min(0, p), a.maxLeft = Math.max(0, p)), a.height >= r.height && (a.minTop = Math.min(0, h), a.maxTop = Math.max(0, h))));
      } else
        a.minLeft = -a.width, a.minTop = -a.height, a.maxLeft = r.width, a.maxTop = r.height;
  },
  renderCanvas: function(e, t) {
    var n = this.canvasData, r = this.imageData;
    if (t) {
      var a = Ere({
        width: r.naturalWidth * Math.abs(r.scaleX || 1),
        height: r.naturalHeight * Math.abs(r.scaleY || 1),
        degree: r.rotate || 0
      }), i = a.width, o = a.height, s = n.width * (i / n.naturalWidth), l = n.height * (o / n.naturalHeight);
      n.left -= (s - n.width) / 2, n.top -= (l - n.height) / 2, n.width = s, n.height = l, n.aspectRatio = i / o, n.naturalWidth = i, n.naturalHeight = o, this.limitCanvas(!0, !1);
    }
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCanvas(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, Va(this.canvas, o1({
      width: n.width,
      height: n.height
    }, _s({
      translateX: n.left,
      translateY: n.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var t = this.canvasData, n = this.imageData, r = n.naturalWidth * (t.width / t.naturalWidth), a = n.naturalHeight * (t.height / t.naturalHeight);
    o1(n, {
      width: r,
      height: a,
      left: (t.width - r) / 2,
      top: (t.height - a) / 2
    }), Va(this.image, o1({
      width: n.width,
      height: n.height
    }, _s(o1({
      translateX: n.left,
      translateY: n.top
    }, n)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, t = this.canvasData, n = e.aspectRatio || e.initialAspectRatio, r = Number(e.autoCropArea) || 0.8, a = {
      width: t.width,
      height: t.height
    };
    n && (t.height * n > t.width ? a.height = a.width / n : a.width = a.height * n), this.cropBoxData = a, this.limitCropBox(!0, !0), a.width = Math.min(Math.max(a.width, a.minWidth), a.maxWidth), a.height = Math.min(Math.max(a.height, a.minHeight), a.maxHeight), a.width = Math.max(a.minWidth, a.width * r), a.height = Math.max(a.minHeight, a.height * r), a.left = t.left + (t.width - a.width) / 2, a.top = t.top + (t.height - a.height) / 2, a.oldLeft = a.left, a.oldTop = a.top, this.initialCropBoxData = o1({}, a);
  },
  limitCropBox: function(e, t) {
    var n = this.options, r = this.containerData, a = this.canvasData, i = this.cropBoxData, o = this.limited, s = n.aspectRatio;
    if (e) {
      var l = Number(n.minCropBoxWidth) || 0, c = Number(n.minCropBoxHeight) || 0, u = o ? Math.min(r.width, a.width, a.width + a.left, r.width - a.left) : r.width, d = o ? Math.min(r.height, a.height, a.height + a.top, r.height - a.top) : r.height;
      l = Math.min(l, r.width), c = Math.min(c, r.height), s && (l && c ? c * s > l ? c = l / s : l = c * s : l ? c = l / s : c && (l = c * s), d * s > u ? d = u / s : u = d * s), i.minWidth = Math.min(l, u), i.minHeight = Math.min(c, d), i.maxWidth = u, i.maxHeight = d;
    }
    t && (o ? (i.minLeft = Math.max(0, a.left), i.minTop = Math.max(0, a.top), i.maxLeft = Math.min(r.width, a.left + a.width) - i.width, i.maxTop = Math.min(r.height, a.top + a.height) - i.height) : (i.minLeft = 0, i.minTop = 0, i.maxLeft = r.width - i.width, i.maxTop = r.height - i.height));
  },
  renderCropBox: function() {
    var e = this.options, t = this.containerData, n = this.cropBoxData;
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCropBox(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, e.movable && e.cropBoxMovable && qs(this.face, Ys, n.width >= t.width && n.height >= t.height ? Fw : Sc), Va(this.cropBox, o1({
      width: n.width,
      height: n.height
    }, _s({
      translateX: n.left,
      translateY: n.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), ji(this.element, f4, this.getData());
  }
}, Ire = {
  initPreview: function() {
    var e = this.element, t = this.crossOrigin, n = this.options.preview, r = t ? this.crossOriginUrl : this.url, a = e.alt || "The image to preview", i = document.createElement("img");
    if (t && (i.crossOrigin = t), i.src = r, i.alt = a, this.viewBox.appendChild(i), this.viewBoxImage = i, !!n) {
      var o = n;
      typeof n == "string" ? o = e.ownerDocument.querySelectorAll(n) : n.querySelector && (o = [n]), this.previews = o, S1(o, function(s) {
        var l = document.createElement("img");
        qs(s, r6, {
          width: s.offsetWidth,
          height: s.offsetHeight,
          html: s.innerHTML
        }), t && (l.crossOrigin = t), l.src = r, l.alt = a, l.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', s.innerHTML = "", s.appendChild(l);
      });
    }
  },
  resetPreview: function() {
    S1(this.previews, function(e) {
      var t = b4(e, r6);
      Va(e, {
        width: t.width,
        height: t.height
      }), e.innerHTML = t.html, Sre(e, r6);
    });
  },
  preview: function() {
    var e = this.imageData, t = this.canvasData, n = this.cropBoxData, r = n.width, a = n.height, i = e.width, o = e.height, s = n.left - t.left - e.left, l = n.top - t.top - e.top;
    !this.cropped || this.disabled || (Va(this.viewBoxImage, o1({
      width: i,
      height: o
    }, _s(o1({
      translateX: -s,
      translateY: -l
    }, e)))), S1(this.previews, function(c) {
      var u = b4(c, r6), d = u.width, p = u.height, h = d, m = p, f = 1;
      r && (f = d / r, m = a * f), a && m > p && (f = p / a, h = r * f, m = p), Va(c, {
        width: h,
        height: m
      }), Va(c.getElementsByTagName("img")[0], o1({
        width: i * f,
        height: o * f
      }, _s(o1({
        translateX: -s * f,
        translateY: -l * f
      }, e))));
    }));
  }
}, Hre = {
  bind: function() {
    var e = this.element, t = this.options, n = this.cropper;
    hr(t.cropstart) && Hr(e, y4, t.cropstart), hr(t.cropmove) && Hr(e, g4, t.cropmove), hr(t.cropend) && Hr(e, C4, t.cropend), hr(t.crop) && Hr(e, f4, t.crop), hr(t.zoom) && Hr(e, v4, t.zoom), Hr(n, Dm, this.onCropStart = this.cropStart.bind(this)), t.zoomable && t.zoomOnWheel && Hr(n, Bm, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && Hr(n, Rm, this.onDblclick = this.dblclick.bind(this)), Hr(e.ownerDocument, Im, this.onCropMove = this.cropMove.bind(this)), Hr(e.ownerDocument, Hm, this.onCropEnd = this.cropEnd.bind(this)), t.responsive && Hr(window, Vm, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, t = this.options, n = this.cropper;
    hr(t.cropstart) && cn(e, y4, t.cropstart), hr(t.cropmove) && cn(e, g4, t.cropmove), hr(t.cropend) && cn(e, C4, t.cropend), hr(t.crop) && cn(e, f4, t.crop), hr(t.zoom) && cn(e, v4, t.zoom), cn(n, Dm, this.onCropStart), t.zoomable && t.zoomOnWheel && cn(n, Bm, this.onWheel, {
      passive: !1,
      capture: !0
    }), t.toggleDragModeOnDblclick && cn(n, Rm, this.onDblclick), cn(e.ownerDocument, Im, this.onCropMove), cn(e.ownerDocument, Hm, this.onCropEnd), t.responsive && cn(window, Vm, this.onResize);
  }
}, Fre = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, t = this.container, n = this.containerData, r = t.offsetWidth / n.width, a = t.offsetHeight / n.height, i = Math.abs(r - 1) > Math.abs(a - 1) ? r : a;
      if (i !== 1) {
        var o, s;
        e.restore && (o = this.getCanvasData(), s = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(S1(o, function(l, c) {
          o[c] = l * i;
        })), this.setCropBoxData(S1(s, function(l, c) {
          s[c] = l * i;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === zw || this.setDragMode(wre(this.dragBox, h4) ? Bw : kc);
  },
  wheel: function(e) {
    var t = this, n = Number(this.options.wheelZoomRatio) || 0.1, r = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      t.wheeling = !1;
    }, 50), e.deltaY ? r = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? r = -e.wheelDelta / 120 : e.detail && (r = e.detail > 0 ? 1 : -1), this.zoom(-r * n, e)));
  },
  cropStart: function(e) {
    var t = e.buttons, n = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (gt(t) && t !== 1 || gt(n) && n !== 0 || e.ctrlKey))) {
      var r = this.options, a = this.pointers, i;
      e.changedTouches ? S1(e.changedTouches, function(o) {
        a[o.identifier] = n6(o);
      }) : a[e.pointerId || 0] = n6(e), Object.keys(a).length > 1 && r.zoomable && r.zoomOnTouch ? i = Vw : i = b4(e.target, Ys), pre.test(i) && ji(this.element, y4, {
        originalEvent: e,
        action: i
      }) !== !1 && (e.preventDefault(), this.action = i, this.cropping = !1, i === Hw && (this.cropping = !0, D1(this.dragBox, L5)));
    }
  },
  cropMove: function(e) {
    var t = this.action;
    if (!(this.disabled || !t)) {
      var n = this.pointers;
      e.preventDefault(), ji(this.element, g4, {
        originalEvent: e,
        action: t
      }) !== !1 && (e.changedTouches ? S1(e.changedTouches, function(r) {
        o1(n[r.identifier] || {}, n6(r, !0));
      }) : o1(n[e.pointerId || 0] || {}, n6(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var t = this.action, n = this.pointers;
      e.changedTouches ? S1(e.changedTouches, function(r) {
        delete n[r.identifier];
      }) : delete n[e.pointerId || 0], t && (e.preventDefault(), Object.keys(n).length || (this.action = ""), this.cropping && (this.cropping = !1, Mi(this.dragBox, L5, this.cropped && this.options.modal)), ji(this.element, C4, {
        originalEvent: e,
        action: t
      }));
    }
  }
}, Vre = {
  change: function(e) {
    var t = this.options, n = this.canvasData, r = this.containerData, a = this.cropBoxData, i = this.pointers, o = this.action, s = t.aspectRatio, l = a.left, c = a.top, u = a.width, d = a.height, p = l + u, h = c + d, m = 0, f = 0, C = r.width, _ = r.height, v = !0, w;
    !s && e.shiftKey && (s = u && d ? u / d : 1), this.limited && (m = a.minLeft, f = a.minTop, C = m + Math.min(r.width, n.width, n.left + n.width), _ = f + Math.min(r.height, n.height, n.top + n.height));
    var k = i[Object.keys(i)[0]], b = {
      x: k.endX - k.startX,
      y: k.endY - k.startY
    }, S = function(P) {
      switch (P) {
        case v2:
          p + b.x > C && (b.x = C - p);
          break;
        case b2:
          l + b.x < m && (b.x = m - l);
          break;
        case Oa:
          c + b.y < f && (b.y = f - c);
          break;
        case yi:
          h + b.y > _ && (b.y = _ - h);
          break;
      }
    };
    switch (o) {
      case Sc:
        l += b.x, c += b.y;
        break;
      case v2:
        if (b.x >= 0 && (p >= C || s && (c <= f || h >= _))) {
          v = !1;
          break;
        }
        S(v2), u += b.x, u < 0 && (o = b2, u = -u, l -= u), s && (d = u / s, c += (a.height - d) / 2);
        break;
      case Oa:
        if (b.y <= 0 && (c <= f || s && (l <= m || p >= C))) {
          v = !1;
          break;
        }
        S(Oa), d -= b.y, c += b.y, d < 0 && (o = yi, d = -d, c -= d), s && (u = d * s, l += (a.width - u) / 2);
        break;
      case b2:
        if (b.x <= 0 && (l <= m || s && (c <= f || h >= _))) {
          v = !1;
          break;
        }
        S(b2), u -= b.x, l += b.x, u < 0 && (o = v2, u = -u, l -= u), s && (d = u / s, c += (a.height - d) / 2);
        break;
      case yi:
        if (b.y >= 0 && (h >= _ || s && (l <= m || p >= C))) {
          v = !1;
          break;
        }
        S(yi), d += b.y, d < 0 && (o = Oa, d = -d, c -= d), s && (u = d * s, l += (a.width - u) / 2);
        break;
      case as:
        if (s) {
          if (b.y <= 0 && (c <= f || p >= C)) {
            v = !1;
            break;
          }
          S(Oa), d -= b.y, c += b.y, u = d * s;
        } else
          S(Oa), S(v2), b.x >= 0 ? p < C ? u += b.x : b.y <= 0 && c <= f && (v = !1) : u += b.x, b.y <= 0 ? c > f && (d -= b.y, c += b.y) : (d -= b.y, c += b.y);
        u < 0 && d < 0 ? (o = ss, d = -d, u = -u, c -= d, l -= u) : u < 0 ? (o = is, u = -u, l -= u) : d < 0 && (o = os, d = -d, c -= d);
        break;
      case is:
        if (s) {
          if (b.y <= 0 && (c <= f || l <= m)) {
            v = !1;
            break;
          }
          S(Oa), d -= b.y, c += b.y, u = d * s, l += a.width - u;
        } else
          S(Oa), S(b2), b.x <= 0 ? l > m ? (u -= b.x, l += b.x) : b.y <= 0 && c <= f && (v = !1) : (u -= b.x, l += b.x), b.y <= 0 ? c > f && (d -= b.y, c += b.y) : (d -= b.y, c += b.y);
        u < 0 && d < 0 ? (o = os, d = -d, u = -u, c -= d, l -= u) : u < 0 ? (o = as, u = -u, l -= u) : d < 0 && (o = ss, d = -d, c -= d);
        break;
      case ss:
        if (s) {
          if (b.x <= 0 && (l <= m || h >= _)) {
            v = !1;
            break;
          }
          S(b2), u -= b.x, l += b.x, d = u / s;
        } else
          S(yi), S(b2), b.x <= 0 ? l > m ? (u -= b.x, l += b.x) : b.y >= 0 && h >= _ && (v = !1) : (u -= b.x, l += b.x), b.y >= 0 ? h < _ && (d += b.y) : d += b.y;
        u < 0 && d < 0 ? (o = as, d = -d, u = -u, c -= d, l -= u) : u < 0 ? (o = os, u = -u, l -= u) : d < 0 && (o = is, d = -d, c -= d);
        break;
      case os:
        if (s) {
          if (b.x >= 0 && (p >= C || h >= _)) {
            v = !1;
            break;
          }
          S(v2), u += b.x, d = u / s;
        } else
          S(yi), S(v2), b.x >= 0 ? p < C ? u += b.x : b.y >= 0 && h >= _ && (v = !1) : u += b.x, b.y >= 0 ? h < _ && (d += b.y) : d += b.y;
        u < 0 && d < 0 ? (o = is, d = -d, u = -u, c -= d, l -= u) : u < 0 ? (o = ss, u = -u, l -= u) : d < 0 && (o = as, d = -d, c -= d);
        break;
      case Fw:
        this.move(b.x, b.y), v = !1;
        break;
      case Vw:
        this.zoom(Mre(i), e), v = !1;
        break;
      case Hw:
        if (!b.x || !b.y) {
          v = !1;
          break;
        }
        w = Ww(this.cropper), l = k.startX - w.left, c = k.startY - w.top, u = a.minWidth, d = a.minHeight, b.x > 0 ? o = b.y > 0 ? os : as : b.x < 0 && (l -= u, o = b.y > 0 ? ss : is), b.y < 0 && (c -= d), this.cropped || (Yn(this.cropBox, fr), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    v && (a.width = u, a.height = d, a.left = l, a.top = c, this.action = o, this.renderCropBox()), S1(i, function(P) {
      P.startX = P.endX, P.startY = P.endY;
    });
  }
}, Bre = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && D1(this.dragBox, L5), Yn(this.cropBox, fr), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = o1({}, this.initialImageData), this.canvasData = o1({}, this.initialCanvasData), this.cropBoxData = o1({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (o1(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), Yn(this.dragBox, L5), D1(this.cropBox, fr)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), t ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, S1(this.previews, function(n) {
      n.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, Yn(this.cropper, Nm)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, D1(this.cropper, Nm)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[i1] ? (e[i1] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, r = n.left, a = n.top;
    return this.moveTo(m0(e) ? e : r + Number(e), m0(t) ? t : a + Number(t));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, r = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.movable && (gt(e) && (n.left = e, r = !0), gt(t) && (n.top = t, r = !0), r && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, t) {
    var n = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(n.width * e / n.naturalWidth, null, t);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, t, n) {
    var r = this.options, a = this.canvasData, i = a.width, o = a.height, s = a.naturalWidth, l = a.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && r.zoomable) {
      var c = s * e, u = l * e;
      if (ji(this.element, v4, {
        ratio: e,
        oldRatio: i / s,
        originalEvent: n
      }) === !1)
        return this;
      if (n) {
        var d = this.pointers, p = Ww(this.cropper), h = d && Object.keys(d).length ? Pre(d) : {
          pageX: n.pageX,
          pageY: n.pageY
        };
        a.left -= (c - i) * ((h.pageX - p.left - a.left) / i), a.top -= (u - o) * ((h.pageY - p.top - a.top) / o);
      } else
        ki(t) && gt(t.x) && gt(t.y) ? (a.left -= (c - i) * ((t.x - a.left) / i), a.top -= (u - o) * ((t.y - a.top) / o)) : (a.left -= (c - i) / 2, a.top -= (u - o) / 2);
      a.width = c, a.height = u, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), gt(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var t = this.imageData.scaleY;
    return this.scale(e, gt(t) ? t : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var t = this.imageData.scaleX;
    return this.scale(gt(t) ? t : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.imageData, r = !1;
    return e = Number(e), t = Number(t), this.ready && !this.disabled && this.options.scalable && (gt(e) && (n.scaleX = e, r = !0), gt(t) && (n.scaleY = t, r = !0), r && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = this.options, n = this.imageData, r = this.canvasData, a = this.cropBoxData, i;
    if (this.ready && this.cropped) {
      i = {
        x: a.left - r.left,
        y: a.top - r.top,
        width: a.width,
        height: a.height
      };
      var o = n.width / n.naturalWidth;
      if (S1(i, function(c, u) {
        i[u] = c / o;
      }), e) {
        var s = Math.round(i.y + i.height), l = Math.round(i.x + i.width);
        i.x = Math.round(i.x), i.y = Math.round(i.y), i.width = l - i.x, i.height = s - i.y;
      }
    } else
      i = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return t.rotatable && (i.rotate = n.rotate || 0), t.scalable && (i.scaleX = n.scaleX || 1, i.scaleY = n.scaleY || 1), i;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var t = this.options, n = this.imageData, r = this.canvasData, a = {};
    if (this.ready && !this.disabled && ki(e)) {
      var i = !1;
      t.rotatable && gt(e.rotate) && e.rotate !== n.rotate && (n.rotate = e.rotate, i = !0), t.scalable && (gt(e.scaleX) && e.scaleX !== n.scaleX && (n.scaleX = e.scaleX, i = !0), gt(e.scaleY) && e.scaleY !== n.scaleY && (n.scaleY = e.scaleY, i = !0)), i && this.renderCanvas(!0, !0);
      var o = n.width / n.naturalWidth;
      gt(e.x) && (a.left = e.x * o + r.left), gt(e.y) && (a.top = e.y * o + r.top), gt(e.width) && (a.width = e.width * o), gt(e.height) && (a.height = e.height * o), this.setCropBoxData(a);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? o1({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? o1({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, t = {};
    return this.ready && S1(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n) {
      t[n] = e[n];
    }), t;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var t = this.canvasData, n = t.aspectRatio;
    return this.ready && !this.disabled && ki(e) && (gt(e.left) && (t.left = e.left), gt(e.top) && (t.top = e.top), gt(e.width) ? (t.width = e.width, t.height = e.width / n) : gt(e.height) && (t.height = e.height, t.width = e.height * n), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, t;
    return this.ready && this.cropped && (t = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), t || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var t = this.cropBoxData, n = this.options.aspectRatio, r, a;
    return this.ready && this.cropped && !this.disabled && ki(e) && (gt(e.left) && (t.left = e.left), gt(e.top) && (t.top = e.top), gt(e.width) && e.width !== t.width && (r = !0, t.width = e.width), gt(e.height) && e.height !== t.height && (a = !0, t.height = e.height), n && (r ? t.height = t.width / n : a && (t.width = t.height * n)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var t = this.canvasData, n = Tre(this.image, this.imageData, t, e);
    if (!this.cropped)
      return n;
    var r = this.getData(e.rounded), a = r.x, i = r.y, o = r.width, s = r.height, l = n.width / Math.floor(t.naturalWidth);
    l !== 1 && (a *= l, i *= l, o *= l, s *= l);
    var c = o / s, u = Ba({
      aspectRatio: c,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), d = Ba({
      aspectRatio: c,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), p = Ba({
      aspectRatio: c,
      width: e.width || (l !== 1 ? n.width : o),
      height: e.height || (l !== 1 ? n.height : s)
    }), h = p.width, m = p.height;
    h = Math.min(u.width, Math.max(d.width, h)), m = Math.min(u.height, Math.max(d.height, m));
    var f = document.createElement("canvas"), C = f.getContext("2d");
    f.width = Ni(h), f.height = Ni(m), C.fillStyle = e.fillColor || "transparent", C.fillRect(0, 0, h, m);
    var _ = e.imageSmoothingEnabled, v = _ === void 0 ? !0 : _, w = e.imageSmoothingQuality;
    C.imageSmoothingEnabled = v, w && (C.imageSmoothingQuality = w);
    var k = n.width, b = n.height, S = a, P = i, O, A, L, I, D, U;
    S <= -o || S > k ? (S = 0, O = 0, L = 0, D = 0) : S <= 0 ? (L = -S, S = 0, O = Math.min(k, o + S), D = O) : S <= k && (L = 0, O = Math.min(o, k - S), D = O), O <= 0 || P <= -s || P > b ? (P = 0, A = 0, I = 0, U = 0) : P <= 0 ? (I = -P, P = 0, A = Math.min(b, s + P), U = A) : P <= b && (I = 0, A = Math.min(s, b - P), U = A);
    var z = [S, P, O, A];
    if (D > 0 && U > 0) {
      var $ = h / o;
      z.push(L * $, I * $, D * $, U * $);
    }
    return C.drawImage.apply(C, [n].concat(Iw(z.map(function(ee) {
      return Math.floor(Ni(ee));
    })))), f;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var t = this.options;
    return !this.disabled && !m0(e) && (t.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var t = this.options, n = this.dragBox, r = this.face;
    if (this.ready && !this.disabled) {
      var a = e === kc, i = t.movable && e === Bw;
      e = a || i ? e : zw, t.dragMode = e, qs(n, Ys, e), Mi(n, h4, a), Mi(n, m4, i), t.cropBoxMovable || (qs(r, Ys, e), Mi(r, h4, a), Mi(r, m4, i));
    }
    return this;
  }
}, zre = Qn.Cropper, qw = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (tre(this, e), !t || !fre.test(t.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = t, this.options = o1({}, Gm, ki(n) && n), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return rre(e, [{
    key: "init",
    value: function() {
      var t = this.element, n = t.tagName.toLowerCase(), r;
      if (!t[i1]) {
        if (t[i1] = this, n === "img") {
          if (this.isImg = !0, r = t.getAttribute("src") || "", this.originalUrl = r, !r)
            return;
          r = t.src;
        } else
          n === "canvas" && window.HTMLCanvasElement && (r = t.toDataURL());
        this.load(r);
      }
    }
  }, {
    key: "load",
    value: function(t) {
      var n = this;
      if (t) {
        this.url = t, this.imageData = {};
        var r = this.element, a = this.options;
        if (!a.rotatable && !a.scalable && (a.checkOrientation = !1), !a.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (hre.test(t)) {
          mre.test(t) ? this.read(Ore(t)) : this.clone();
          return;
        }
        var i = new XMLHttpRequest(), o = this.clone.bind(this);
        this.reloading = !0, this.xhr = i, i.onabort = o, i.onerror = o, i.ontimeout = o, i.onprogress = function() {
          i.getResponseHeader("content-type") !== zm && i.abort();
        }, i.onload = function() {
          n.read(i.response);
        }, i.onloadend = function() {
          n.reloading = !1, n.xhr = null;
        }, a.checkCrossOrigin && Zm(t) && r.crossOrigin && (t = Km(t)), i.open("GET", t, !0), i.responseType = "arraybuffer", i.withCredentials = r.crossOrigin === "use-credentials", i.send();
      }
    }
  }, {
    key: "read",
    value: function(t) {
      var n = this.options, r = this.imageData, a = jre(t), i = 0, o = 1, s = 1;
      if (a > 1) {
        this.url = Nre(t, zm);
        var l = Rre(a);
        i = l.rotate, o = l.scaleX, s = l.scaleY;
      }
      n.rotatable && (r.rotate = i), n.scalable && (r.scaleX = o, r.scaleY = s), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var t = this.element, n = this.url, r = t.crossOrigin, a = n;
      this.options.checkCrossOrigin && Zm(n) && (r || (r = "anonymous"), a = Km(n)), this.crossOrigin = r, this.crossOriginUrl = a;
      var i = document.createElement("img");
      r && (i.crossOrigin = r), i.src = a || n, i.alt = t.alt || "The image to crop", this.image = i, i.onload = this.start.bind(this), i.onerror = this.stop.bind(this), D1(i, jm), t.parentNode.insertBefore(i, t.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var t = this, n = this.image;
      n.onload = null, n.onerror = null, this.sizing = !0;
      var r = Qn.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(Qn.navigator.userAgent), a = function(s, l) {
        o1(t.imageData, {
          naturalWidth: s,
          naturalHeight: l,
          aspectRatio: s / l
        }), t.initialImageData = o1({}, t.imageData), t.sizing = !1, t.sized = !0, t.build();
      };
      if (n.naturalWidth && !r) {
        a(n.naturalWidth, n.naturalHeight);
        return;
      }
      var i = document.createElement("img"), o = document.body || document.documentElement;
      this.sizingImage = i, i.onload = function() {
        a(i.width, i.height), r || o.removeChild(i);
      }, i.src = n.src, r || (i.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", o.appendChild(i));
    }
  }, {
    key: "stop",
    value: function() {
      var t = this.image;
      t.onload = null, t.onerror = null, t.parentNode.removeChild(t), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var t = this.element, n = this.options, r = this.image, a = t.parentNode, i = document.createElement("div");
        i.innerHTML = Cre;
        var o = i.querySelector(".".concat(i1, "-container")), s = o.querySelector(".".concat(i1, "-canvas")), l = o.querySelector(".".concat(i1, "-drag-box")), c = o.querySelector(".".concat(i1, "-crop-box")), u = c.querySelector(".".concat(i1, "-face"));
        this.container = a, this.cropper = o, this.canvas = s, this.dragBox = l, this.cropBox = c, this.viewBox = o.querySelector(".".concat(i1, "-view-box")), this.face = u, s.appendChild(r), D1(t, fr), a.insertBefore(o, t.nextSibling), Yn(r, jm), this.initPreview(), this.bind(), n.initialAspectRatio = Math.max(0, n.initialAspectRatio) || NaN, n.aspectRatio = Math.max(0, n.aspectRatio) || NaN, n.viewMode = Math.max(0, Math.min(3, Math.round(n.viewMode))) || 0, D1(c, fr), n.guides || D1(c.getElementsByClassName("".concat(i1, "-dashed")), fr), n.center || D1(c.getElementsByClassName("".concat(i1, "-center")), fr), n.background && D1(o, "".concat(i1, "-bg")), n.highlight || D1(u, lre), n.cropBoxMovable && (D1(u, m4), qs(u, Ys, Sc)), n.cropBoxResizable || (D1(c.getElementsByClassName("".concat(i1, "-line")), fr), D1(c.getElementsByClassName("".concat(i1, "-point")), fr)), this.render(), this.ready = !0, this.setDragMode(n.dragMode), n.autoCrop && this.crop(), this.setData(n.data), hr(n.ready) && Hr(t, Fm, n.ready, {
          once: !0
        }), ji(t, Fm);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var t = this.cropper.parentNode;
        t && t.removeChild(this.cropper), Yn(this.element, fr);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = zre, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(t) {
      o1(Gm, ki(t) && t);
    }
  }]);
}();
o1(qw.prototype, Dre, Ire, Hre, Fre, Vre, Bre);
var k2 = function() {
  return k2 = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++)
      for (var a in t = arguments[n])
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }, k2.apply(this, arguments);
};
function C0(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var a = 0;
    for (r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  }
  return n;
}
var Gre = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], Ure = { opacity: 0, maxWidth: "100%" }, Zre = M.forwardRef(function(e, t) {
  var n = C0(e, []), r = n.dragMode, a = r === void 0 ? "crop" : r, i = n.src, o = n.style, s = n.className, l = n.crossOrigin, c = n.scaleX, u = n.scaleY, d = n.enable, p = n.zoomTo, h = n.rotateTo, m = n.alt, f = m === void 0 ? "picture" : m, C = n.ready, _ = n.onInitialized, v = C0(n, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), w = { scaleY: u, scaleX: c, enable: d, zoomTo: p, rotateTo: h }, k = function() {
    for (var S = [], P = 0; P < arguments.length; P++)
      S[P] = arguments[P];
    var O = be(null);
    return M.useEffect(function() {
      S.forEach(function(A) {
        A && (typeof A == "function" ? A(O.current) : A.current = O.current);
      });
    }, [S]), O;
  }(t, be(null));
  Re(function() {
    var S;
    !((S = k.current) === null || S === void 0) && S.cropper && typeof p == "number" && k.current.cropper.zoomTo(p);
  }, [n.zoomTo]), Re(function() {
    var S;
    !((S = k.current) === null || S === void 0) && S.cropper && i !== void 0 && k.current.cropper.reset().clear().replace(i);
  }, [i]), Re(function() {
    if (k.current !== null) {
      var S = new qw(k.current, k2(k2({ dragMode: a }, v), { ready: function(P) {
        P.currentTarget !== null && function(O, A) {
          A === void 0 && (A = {});
          var L = A.enable, I = L === void 0 || L, D = A.scaleX, U = D === void 0 ? 1 : D, z = A.scaleY, $ = z === void 0 ? 1 : z, ee = A.zoomTo, Z = ee === void 0 ? 0 : ee, G = A.rotateTo;
          I ? O.enable() : O.disable(), O.scaleX(U), O.scaleY($), G !== void 0 && O.rotateTo(G), Z > 0 && O.zoomTo(Z);
        }(P.currentTarget.cropper, w), C && C(P);
      } }));
      _ && _(S);
    }
    return function() {
      var P, O;
      (O = (P = k.current) === null || P === void 0 ? void 0 : P.cropper) === null || O === void 0 || O.destroy();
    };
  }, [k]);
  var b = function(S) {
    return Gre.reduce(function(P, O) {
      var A = P, L = O;
      return A[L], C0(A, [typeof L == "symbol" ? L : L + ""]);
    }, S);
  }(k2(k2({}, v), { crossOrigin: l, src: i, alt: f }));
  return M.createElement("div", { style: o, className: s }, M.createElement("img", k2({}, b, { style: Ure, ref: k })));
});
const Kre = tx(
  ({ imageCropperRef: e, isRounded: t, imageFile: n, imageCropperProps: r }) => {
    const {
      viewMode: a = 1,
      autoCropArea: i = 1,
      aspectRatio: o = 1,
      checkOrientation: s = !1,
      // NOTE: it fixes this issue https://github.com/fengyuanchen/cropperjs/issues/671
      background: l = !0,
      dragMode: c = "move",
      toggleDragModeOnDblclick: u = !1,
      style: d = { height: 400, width: "100%" },
      ...p
    } = r || {}, h = be(null), m = be(null), f = be(null), C = be(null), _ = () => {
      m.current && (m.current.style.opacity = ""), f.current && (f.current.style.display = "block"), C.current && (C.current.style.zIndex = "", C.current.innerText = "");
    }, v = () => {
      f.current && C.current && (C.current.appendChild(f.current.cloneNode(!0)), C.current.style.zIndex = "1000", f.current.style.display = "none"), m.current && (m.current.style.opacity = "0");
    }, w = (k) => new Promise((b, S) => {
      var P;
      try {
        const O = (P = h.current) == null ? void 0 : P.cropper;
        if (!O)
          throw new Error();
        if (t) {
          const A = O == null ? void 0 : O.getCroppedCanvas();
          if (!A)
            throw new Error();
          const L = Math.min(A.width, A.height), I = document.createElement("canvas");
          I.width = L, I.height = L;
          const D = I.getContext("2d");
          if (!D)
            throw new Error();
          D.beginPath(), D.arc(L / 2, L / 2, L / 2, 0, Math.PI * 2), D.closePath(), D.clip(), D.drawImage(A, 0, 0, L, L), I.toBlob((U) => {
            if (!n || !U)
              return S(new Error());
            const z = em(
              tm(n, U),
              o
            );
            b(z);
          });
        } else
          O.getCroppedCanvas(k).toBlob((A) => {
            if (!n || !A)
              return S(new Error());
            const L = em(
              tm(n, A),
              o
            );
            b(L);
          });
      } catch (O) {
        S(O);
      }
    });
    return e && (e.current = {
      hidePreview: _,
      showPreview: v,
      getCroppedFile: w
    }), /* @__PURE__ */ Ge.jsx("div", { children: /* @__PURE__ */ Ge.jsxs("div", { className: "relative w-full overflow-hidden", children: [
      /* @__PURE__ */ Ge.jsx(
        "div",
        {
          ref: C,
          className: "absolute inset-0 flex items-center justify-center"
        }
      ),
      /* @__PURE__ */ Ge.jsx(
        "div",
        {
          ref: f,
          style: {
            position: "absolute",
            overflow: "hidden",
            width: d.width,
            height: d.height,
            borderRadius: t ? "50%" : 0
          }
        }
      ),
      /* @__PURE__ */ Ge.jsx("div", { ref: m, children: /* @__PURE__ */ Ge.jsx(
        Zre,
        {
          className: t ? "sio-cropper-rounded" : "",
          ref: h,
          src: n && URL.createObjectURL(n),
          preview: f || void 0,
          style: d,
          viewMode: a,
          background: l,
          autoCropArea: i,
          aspectRatio: o,
          checkOrientation: s,
          dragMode: c,
          toggleDragModeOnDblclick: u,
          ...p
        }
      ) })
    ] }) });
  }
);
Kre.displayName = "ImageCropper";
const $re = {
  id: 123,
  type: Mr.one_shot,
  currency: p1.EURO,
  name: "Default Price plan",
  amount: yt(1),
  taxBehavior: kr.Inclusive,
  innerName: "Default Price plan",
  statementDescriptor: "Default Price plan",
  removedAt: null
}, Wre = {
  id: 112651,
  name: "T-shirt",
  tax: y6(20),
  createdAt: "2025-01-01T00:00:00.000Z",
  updatedAt: "2025-01-01T00:00:00.000Z",
  taxBehavior: kr.Inclusive,
  options: [
    {
      id: "01JTG214EFTGZQ486S90TTNZ9P",
      name: "Color",
      optionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        }
      ]
    },
    {
      id: "01JTG226Z40D4GP8P4X9MA49XS",
      name: "Size",
      optionValues: [
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ]
    }
  ],
  productVariants: [
    {
      id: "01JTG21EHKEMWGEBH704F0V5EX",
      sku: "WHI-737",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG226Z41H5Q9QPCG1VS57V8"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: Pt.Product,
        size: 1024,
        type: Zt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(799),
      stock: null,
      pricePlan: {
        id: 123,
        type: Mr.one_shot,
        currency: p1.EURO,
        name: "Default Price plan",
        amount: yt(1),
        taxBehavior: kr.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG21HT1GC9S77WEJMY8H2KF",
      sku: "BLA-213",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG226Z41H5Q9QPCG1VS57V8"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG226Z41H5Q9QPCG1VS57V8",
          value: "S"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: Pt.Product,
        size: 1024,
        type: Zt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(699),
      stock: null,
      pricePlan: {
        id: 124,
        type: Mr.one_shot,
        currency: p1.EURO,
        name: "Default Price plan",
        amount: yt(699),
        taxBehavior: kr.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22C0H1PTYQGZ8Z576M09H",
      sku: "BLA-649",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22ANKHJZFR5G74R9K8P5T"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: Pt.Product,
        size: 1024,
        type: Zt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(799),
      stock: null,
      pricePlan: {
        id: 125,
        type: Mr.one_shot,
        currency: p1.EURO,
        name: "Default Price plan",
        amount: yt(799),
        taxBehavior: kr.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22C0HMC23MHK814V8CPA4",
      sku: "WHI-332",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22ANKHJZFR5G74R9K8P5T"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22ANKHJZFR5G74R9K8P5T",
          value: "M"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: Pt.Product,
        size: 1024,
        type: Zt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(799),
      stock: null,
      pricePlan: {
        id: 126,
        type: Mr.one_shot,
        currency: p1.EURO,
        name: "Default Price plan",
        amount: yt(799),
        taxBehavior: kr.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22DJH1CNT3RHRGC9TT0AQ",
      sku: "BLA-298",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22C024FRBMX3055G1AD45"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: Pt.Product,
        size: 1024,
        type: Zt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(899),
      stock: null,
      pricePlan: {
        id: 127,
        type: Mr.one_shot,
        currency: p1.EURO,
        name: "Default Price plan",
        amount: yt(899),
        taxBehavior: kr.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22DJHAM47QZGNW8B8A9AR",
      sku: "WHI-220",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22C024FRBMX3055G1AD45"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22C024FRBMX3055G1AD45",
          value: "L"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: Pt.Product,
        size: 1024,
        type: Zt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(899),
      stock: null,
      pricePlan: {
        id: 128,
        type: Mr.one_shot,
        currency: p1.EURO,
        name: "Default Price plan",
        amount: yt(899),
        taxBehavior: kr.Exclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22ERSQSJ084P417PRG46W",
      sku: "BLA-217",
      optionValueIds: ["01JTG21FZB99TBWGW6ZD7RTXVF", "01JTG22DJ2PM2CT42C3AXTGZTM"],
      productOptionValues: [
        {
          id: "01JTG21FZB99TBWGW6ZD7RTXVF",
          value: "Black"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ],
      image: {
        id: 31121528,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
        name: "Black T-shirt",
        filename: "black-t-shirt.jpg",
        source: Pt.Product,
        size: 1024,
        type: Zt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(899),
      stock: null,
      pricePlan: {
        id: 129,
        type: Mr.one_shot,
        currency: p1.EURO,
        name: "Default Price plan",
        amount: yt(899),
        taxBehavior: kr.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    },
    {
      id: "01JTG22ERSSH236MH8ZMQWRQRA",
      sku: "WHI-855",
      optionValueIds: ["01JTG214EG046HQWF9R8Q77YHH", "01JTG22DJ2PM2CT42C3AXTGZTM"],
      productOptionValues: [
        {
          id: "01JTG214EG046HQWF9R8Q77YHH",
          value: "White"
        },
        {
          id: "01JTG22DJ2PM2CT42C3AXTGZTM",
          value: "XL"
        }
      ],
      image: {
        id: 31121503,
        path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
        thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
        name: "White T-shirt",
        filename: "white-t-shirt.webp",
        source: Pt.Product,
        size: 1024,
        type: Zt.Image,
        createdAt: "2025-01-01T00:00:00.000Z"
      },
      price: yt(999),
      stock: null,
      pricePlan: {
        id: 130,
        type: Mr.one_shot,
        currency: p1.EURO,
        name: "Default Price plan",
        amount: yt(999),
        taxBehavior: kr.Inclusive,
        innerName: "Default Price plan",
        statementDescriptor: "Default Price plan",
        removedAt: null
      }
    }
  ],
  sku: "T-S-887",
  images: [
    {
      id: 31121503,
      path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189bc52faad_white-t-shirt.webp",
      thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189bc52faad_white-t-shirt.webp",
      name: "White T-shirt",
      filename: "white-t-shirt.webp",
      source: Pt.Product,
      size: 1024,
      type: Zt.Image,
      createdAt: "2025-01-01T00:00:00.000Z"
    },
    {
      id: 31121528,
      path: "https://d1yei2z3i6k35z.cloudfront.net/9990270/68189be845028_black-t-shirt.jpg",
      thumbnail: "https://d1yei2z3i6k35z.cloudfront.net/thumb_150/68189be845028_black-t-shirt.jpg",
      name: "Black T-shirt",
      filename: "black-t-shirt.jpg",
      source: Pt.Product,
      size: 1024,
      type: Zt.Image,
      createdAt: "2025-01-01T00:00:00.000Z"
    }
  ],
  currency: p1.EURO,
  price: yt(799),
  description: "T-shirt description",
  limitStock: !1,
  stock: null,
  weight: 250,
  shippingFeesDisabled: !1,
  pricePlan: $re
}, Yre = [
  {
    rules: [
      {
        id: 5056,
        name: "Rule",
        description: "Desc",
        price: yt(1e3),
        shippingConditions: [
          {
            id: 7180,
            min: 1,
            max: 100,
            price: yt(500)
          }
        ],
        currency: p1.EURO,
        type: B2.quantity
      }
    ],
    id: 1739821,
    name: "Custom"
  },
  {
    rules: [
      {
        id: 5075,
        name: "Fixed Rate",
        description: "Fixed price rate delivery",
        price: yt(599),
        shippingConditions: [],
        currency: p1.EURO,
        type: B2.quantity
      }
    ],
    id: 1739887,
    name: "Fixed Delivery"
  },
  {
    rules: [
      {
        id: 5074,
        name: "Multizone",
        description: "Multizone Description",
        price: yt(1100),
        shippingConditions: [
          {
            id: 7191,
            min: 1,
            max: 1e4,
            price: yt(999)
          }
        ],
        currency: p1.EURO,
        type: B2.quantity
      }
    ],
    id: 1739886,
    name: "New Custom"
  }
], qre = {
  pricePlan: 1,
  quantity: 1,
  originalAmount: yt(999),
  netAmount: yt(999),
  discountedNetAmount: yt(999),
  tax: {
    amount: yt(200),
    rate: y6(20)
  },
  grossAmount: yt(1199),
  discount: {
    amount: yt(0),
    percent: y6(0)
  },
  shippingFee: {
    amount: yt(599),
    tax: {
      amount: yt(119.8),
      rate: y6(20)
    }
  },
  currencyCode: p1.EURO
}, Wne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  calculatePrice: qre,
  physicalProduct: Wre,
  shippingRules: Yre
}, Symbol.toStringTag, { value: "Module" })), _4 = (e, t) => t != null && t.pricePlan ? t.pricePlan : e != null && e.pricePlan ? e.pricePlan : null, Yne = (e) => {
  var J;
  const { title: t, description: n, buttonTitle: r, fields: a, cover: i, offerId: o, id: s } = e.checkoutPage, {
    currency: l,
    paymentMethods: c,
    thankYouPage: u,
    affiliateLink: d,
    displayAffiliateLink: p,
    productType: h,
    physicalProduct: m,
    shippingRules: f,
    calculatePrice: C,
    isLoadingShippingRules: _ = !1,
    isLoadingCalculatePrice: v = !1,
    skipDisabledButton: w = !1
  } = e, { t: k } = K1(), [b, S] = ke(!1), [P, O] = ke(ur), { productVariant: A, quantity: L, selectedShipping: I } = b9();
  N_({
    handlerError: (te) => O((ye) => ({ ...ye, common: [te] })),
    pagePath: e.checkoutPage.path
  });
  const {
    availablePaymentMethods: D,
    setAvailablePaymentMethods: U,
    setPaymentMethod: z,
    paymentMethod: $,
    setCurrency: ee,
    setPricePlan: Z,
    setOfferId: G,
    setProductId: W,
    finalAmount: j,
    setFinalAmount: T,
    contactFields: F,
    setContactFields: N
  } = Dr();
  z1(m == null ? void 0 : m.id, (te) => te && W(te)), z1(o, (te) => te && G(te)), z1(c, (te) => te && U(te)), z1(l, (te) => te && ee(te)), z1(a, (te) => te && N(m5(te))), z1(m, (te) => {
    if (!te)
      Z(void 0), T(void 0);
    else {
      const ye = _4(te, A);
      ye && (Z(ye), T(ye.amount));
    }
  });
  const Y = () => {
    let te = !1;
    const ye = uc(ur);
    return Object.values(F).forEach(({ slug: Pe, value: Ze, required: _t }) => {
      _t && (Ze == null || Ze === "") && (ye.customer.fields[Pe] = [k("public_pages_purchase.required-field")], te = !0);
    }), $ || (ye.paymentMethod = [k("public_pages_purchase.required-field")], te = !0), { errors: ye, isFailed: te };
  }, Q = !!j && !!$ && !!o && !!m && !!s, V = () => {
    if (!Q)
      return;
    const te = _4(m, A);
    if (!te)
      return;
    const ye = Object.values(F).reduce((_t, st) => (_t[st.slug] = st.value ?? "", _t), {}), Pe = `${window.location.origin}${(u == null ? void 0 : u.path) ?? ""}`, Ze = window.location.href;
    return {
      page: s,
      customer: {
        fields: ye
      },
      offer: o,
      digitalProduct: null,
      pricePlan: te.id,
      purchaseProductModel: {
        product: m.id,
        productVariant: (A == null ? void 0 : A.id) ?? null,
        quantity: L,
        shippingRule: (I == null ? void 0 : I.ruleId) ?? null,
        shippingCondition: (I == null ? void 0 : I.conditionId) ?? null
      },
      thankYouPageUrl: Pe,
      failedReturnUrl: Ze,
      paymentMethod: $
    };
  }, re = () => {
    const { errors: te, isFailed: ye } = Y();
    if (ye) {
      O((Pe) => ({ ...Pe, ...te }));
      return;
    }
    return V();
  }, q = (te) => {
    const ye = O_(te, ur), Pe = R_(ye.customer.fields, F);
    O({
      ...ye,
      common: ye.common.concat(Pe)
    });
  }, { paymentProcessorPaymentButton: he, paymentProcessorDetails: me, PaymentProcessorProvider: Ne } = A_({
    isFetching: b,
    setIsFetching: S,
    handleBadRequest: q,
    buttonTitle: r,
    buttonDisabled: !Q && !w,
    preSubmit: re,
    setErrors: O,
    hasErrors: dc(P)
  }), K = Object.values(D).filter((te) => te !== ge.stripe_applepay).map((te) => ({
    id: te,
    caption: k(DC(te)),
    content: me,
    additionalInfo: /* @__PURE__ */ x.jsx(Ob, { paymentMethod: te })
  })), Ee = (te, ye) => {
    N({
      ...F,
      [te.slug]: { ...te, value: ye }
    });
  };
  return /* @__PURE__ */ x.jsx(B3, { children: /* @__PURE__ */ x.jsxs(Ab, { children: [
    /* @__PURE__ */ x.jsxs("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5 ", children: [
      /* @__PURE__ */ x.jsx(
        xr,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          thumbnail: i,
          imageType: j_(h),
          alt: t
        }
      ),
      /* @__PURE__ */ x.jsx("h2", { className: "text-xl font-bold sm:text-3xl", children: t }),
      /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
        /* @__PURE__ */ x.jsx(
          "div",
          {
            className: "ckeditor-default text-sm sm:text-base sm:leading-5",
            dangerouslySetInnerHTML: {
              __html: Ym.sanitize(n)
            }
          }
        ),
        m && /* @__PURE__ */ x.jsx(MQ, { product: m }),
        F[Ut.Country] && /* @__PURE__ */ x.jsx(AQ, { shipping: f, isLoading: _ }),
        m && /* @__PURE__ */ x.jsx(
          CX,
          {
            product: m,
            calculatePrice: C,
            isLoading: v
          }
        ),
        Object.values(F).map((te) => /* @__PURE__ */ x.jsx(
          Z3,
          {
            contactFields: F,
            field: te,
            value: F[te.slug].value,
            error: P.customer.fields[te.slug],
            onChange: (ye) => Ee(te, ye)
          },
          te.slug
        )),
        /* @__PURE__ */ x.jsxs(Ne, { children: [
          D.length > 0 && /* @__PURE__ */ x.jsx(
            Sl,
            {
              label: k("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: K,
              selected: $,
              onChange: (te) => z(te),
              required: !0,
              error: (J = P.paymentMethod) == null ? void 0 : J.join(", ")
            }
          ),
          P.common && /* @__PURE__ */ x.jsx(
            oo,
            {
              error: P.common.join(", "),
              errorClassName: "flex justify-center"
            }
          ),
          he
        ] })
      ] })
    ] }),
    p && /* @__PURE__ */ x.jsx(O8, { affiliateLink: d })
  ] }) });
}, Jre = ({ children: e }) => /* @__PURE__ */ x.jsx("span", { className: "font-medium", children: e }), Xre = ({ type: e, amount: t, currency: n, recurringOptions: r }) => {
  if (e === Mr.one_shot)
    return /* @__PURE__ */ x.jsx(Qre, { amount: t, currency: n });
  if (e === Mr.subscription)
    return /* @__PURE__ */ x.jsx(
      ene,
      {
        amount: t,
        currency: n,
        recurringOptions: r
      }
    );
  if (e === Mr.limited_subscription)
    return /* @__PURE__ */ x.jsx(
      tne,
      {
        amount: t,
        currency: n,
        recurringOptions: r
      }
    );
}, Qre = ({
  amount: e,
  currency: t
}) => {
  const { locale: n } = qr(), r = J1(
    h1(e),
    t,
    n
  );
  return /* @__PURE__ */ x.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ x.jsx(cr, { currency: t }),
    /* @__PURE__ */ x.jsx("div", { className: " ml-1 text-xs font-medium", children: r })
  ] });
}, ene = ({
  amount: e,
  currency: t,
  recurringOptions: n
}) => {
  const { locale: r } = qr(), { t: a } = K1(), i = J1(
    h1(e),
    t,
    r
  ), o = n.trialPeriod ? `${a("public_pages_purchase.components.offer_price.price_plans.trial_period_new", {
    trialPeriodPrice: a(
      "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
    ),
    trialInterval: a(
      `public_pages_purchase.price_plan.trial_period.${n.trialInterval}`,
      {
        count: n.trialPeriod
      }
    )
  })} ` : void 0, s = /* @__PURE__ */ x.jsx(
    Jy,
    {
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.unlimited_new",
      values: {
        amount: i,
        interval: a(`public_pages_purchase.price_plan.interval.${n.interval}`, {
          count: n.intervalCount
        })
      },
      components: {
        bold: /* @__PURE__ */ x.jsx(Jre, {})
      }
    }
  );
  return /* @__PURE__ */ x.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ x.jsx(cr, { currency: t }),
    /* @__PURE__ */ x.jsxs("div", { className: "ml-3", children: [
      o && /* @__PURE__ */ x.jsx("div", { className: "text-xs font-medium", children: o }),
      /* @__PURE__ */ x.jsx("div", { className: "text-xs", children: s })
    ] })
  ] });
}, tne = ({
  amount: e,
  currency: t,
  recurringOptions: n
}) => {
  const { locale: r } = qr(), { t: a } = K1(), i = J1(
    h1(e),
    t,
    r
  ), o = n.trialPeriod ? `${a("public_pages_purchase.components.offer_price.price_plans.trial_period_new", {
    trialPeriodPrice: a(
      "public_pages_purchase.components.offer_price.price_plans.trial_period_price"
    ),
    trialInterval: a(
      `public_pages_purchase.price_plan.trial_period.${n.trialInterval}`,
      {
        count: n.trialPeriod
      }
    )
  })} ` : void 0, s = /* @__PURE__ */ x.jsx(
    Jy,
    {
      i18nKey: "public_pages_purchase.components.offer_price.price_plans.limited_with_limit_of_payments",
      values: {
        amount: i,
        count: n.limitOfPayments,
        interval: a(`public_pages_purchase.price_plan.interval.${n.interval}`, {
          count: n.intervalCount
        })
      }
    }
  );
  return /* @__PURE__ */ x.jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ x.jsx(cr, { currency: t }),
    /* @__PURE__ */ x.jsxs("div", { className: "ml-3", children: [
      o && /* @__PURE__ */ x.jsx("div", { className: "text-xs font-medium", children: o }),
      /* @__PURE__ */ x.jsx("div", { className: "text-xs font-medium", children: s })
    ] })
  ] });
}, rne = ({ calculatePrice: e, pricePlan: t }) => {
  const { locale: n } = qr(), { t: r } = K1();
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    !!(e != null && e.netAmount) && /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ x.jsx("span", { className: "text-[16px]", children: r("public_pages_purchase.subtotal") }),
      /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ x.jsx(cr, { currency: t.currency }),
        /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
          h1(e.netAmount),
          t.currency,
          n
        ) })
      ] })
    ] }),
    !!(e != null && e.tax) && /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ x.jsx("span", { className: "text-[16px]", children: r("public_pages_purchase.vat_percent", {
        percent: e.tax.rate
      }) }),
      /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ x.jsx(cr, { currency: t.currency }),
        /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
          h1(e.tax.amount),
          t.currency,
          n
        ) })
      ] })
    ] })
  ] });
}, nne = ({
  calculatePrice: e,
  isLoading: t,
  pricePlan: n
}) => {
  const { t: r } = K1(), { locale: a } = qr(), { finalAmount: i } = Dr();
  return /* @__PURE__ */ x.jsxs("div", { className: M1("flex flex-col gap-1", t && "animate-pulse"), children: [
    /* @__PURE__ */ x.jsx(ba, { label: r("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ x.jsxs("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      (n == null ? void 0 : n.taxBehavior) === kr.Exclusive && e && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx(rne, { calculatePrice: e, pricePlan: n }),
        /* @__PURE__ */ x.jsx("div", { className: "bg-text-secondary/30 h-[1px] w-full" })
      ] }),
      i && i > 0 && /* @__PURE__ */ x.jsxs("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: r("public_pages_purchase.total") }),
        /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col items-center gap-1.5", children: [
          /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ x.jsx(cr, { currency: n.currency }),
            /* @__PURE__ */ x.jsx("span", { className: "text-[16px] font-bold", children: J1(
              h1(i),
              n.currency,
              a
            ) })
          ] }),
          (n == null ? void 0 : n.taxBehavior) === kr.Inclusive && e && /* @__PURE__ */ x.jsx("span", { className: "text-text-tertiary text-xs", children: r("public_pages_purchase.including_tax", {
            percent: e.tax.rate,
            amount: J1(
              h1(e.tax.amount),
              n.currency,
              a
            )
          }) })
        ] })
      ] })
    ] })
  ] });
}, qne = (e) => {
  var Ne, K, Ee;
  const { title: t, description: n, buttonTitle: r, fields: a, cover: i, offerId: o, digitalProductId: s, id: l } = e.checkoutPage, {
    currency: c,
    paymentMethods: u,
    pricePlans: d,
    thankYouPage: p,
    affiliateLink: h,
    displayAffiliateLink: m,
    productType: f,
    calculatePrice: C,
    isLoadingCalculatePrice: _,
    skipDisabledButton: v = !1
  } = e, { t: w } = K1(), [k, b] = ke(!1), [S, P] = ke(ur);
  N_({
    handlerError: (J) => P((te) => ({ ...te, common: [J] })),
    pagePath: e.checkoutPage.path
  });
  const {
    setAvailablePaymentMethods: O,
    setPaymentMethod: A,
    paymentMethod: L,
    availablePaymentMethods: I,
    setCurrency: D,
    setPricePlan: U,
    pricePlan: z,
    setOfferId: $,
    setProductId: ee,
    finalAmount: Z,
    setFinalAmount: G,
    contactFields: W,
    setContactFields: j
  } = Dr();
  z1(s, (J) => J && ee(J)), z1(o, (J) => J && $(J)), z1(u, (J) => J && O(J)), z1(c, (J) => J && D(J)), z1(a, (J) => J && j(m5(J))), z1(d, (J) => {
    if (J) {
      if (J.length === 0)
        U(void 0), G(void 0);
      else if (!z) {
        const te = J[0];
        U(te), G(te.amount);
      }
    }
  });
  const T = () => {
    let J = !1;
    const te = uc(ur);
    return Object.values(W).forEach(({ slug: ye, value: Pe, required: Ze }) => {
      Ze && (Pe == null || Pe === "") && (te.customer.fields[ye] = [w("public_pages_purchase.required-field")], J = !0);
    }), L || (te.paymentMethod = [w("public_pages_purchase.required-field")], J = !0), z || (te.pricePlan = [w("public_pages_purchase.required-field")], J = !0), { errors: te, isFailed: J };
  }, F = !!Z && !!L && !!o && !!s && !!z && !!l, N = () => {
    if (!F)
      return;
    const J = Object.values(W).reduce((Pe, Ze) => (Pe[Ze.slug] = Ze.value ?? "", Pe), {}), te = `${window.location.origin}${(p == null ? void 0 : p.path) ?? ""}`, ye = window.location.href;
    return {
      page: l,
      customer: {
        fields: J
      },
      offer: o,
      digitalProduct: s,
      purchaseProductModel: null,
      pricePlan: z.id,
      thankYouPageUrl: te,
      failedReturnUrl: ye,
      paymentMethod: L
    };
  }, Y = () => {
    const { errors: J, isFailed: te } = T();
    if (te) {
      P((ye) => ({ ...ye, ...J }));
      return;
    }
    return N();
  }, Q = (J) => {
    const te = O_(J, ur), ye = R_(te.customer.fields, W);
    P({
      ...te,
      common: te.common.concat(ye)
    });
  }, { paymentProcessorPaymentButton: V, paymentProcessorDetails: re, PaymentProcessorProvider: q } = A_({
    isFetching: k,
    setIsFetching: b,
    handleBadRequest: Q,
    buttonTitle: r,
    buttonDisabled: !F && !v,
    preSubmit: Y,
    setErrors: P,
    hasErrors: dc(S)
  }), he = Object.values(I).filter((J) => J !== ge.stripe_applepay).filter((J) => J !== ge.cash_on_delivery).map((J) => ({
    id: J,
    caption: w(DC(J)),
    content: re,
    additionalInfo: /* @__PURE__ */ x.jsx(Ob, { paymentMethod: J })
  })), me = d == null ? void 0 : d.map((J) => ({
    id: String(J.id),
    caption: J.name,
    additionalInfo: /* @__PURE__ */ x.jsx(Xre, { ...J })
  }));
  return /* @__PURE__ */ x.jsx(B3, { children: /* @__PURE__ */ x.jsxs(Ab, { children: [
    /* @__PURE__ */ x.jsx(q, { children: /* @__PURE__ */ x.jsxs("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5", children: [
      /* @__PURE__ */ x.jsx(
        xr,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          thumbnail: i,
          imageType: j_(f),
          alt: t
        }
      ),
      /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col gap-5 sm:gap-10", children: [
        /* @__PURE__ */ x.jsx("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ x.jsx("h2", { className: "text-xl font-bold sm:text-3xl", children: t }) }),
        /* @__PURE__ */ x.jsxs("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
          /* @__PURE__ */ x.jsx(
            "div",
            {
              className: "ckeditor-default text-sm sm:text-base sm:leading-5",
              dangerouslySetInnerHTML: {
                __html: Ym.sanitize(n)
              }
            }
          ),
          Object.values(W).map((J) => {
            const te = (ye) => j({
              ...W,
              [J.slug]: { ...J, value: ye }
            });
            return /* @__PURE__ */ x.jsx(
              Z3,
              {
                contactFields: W,
                field: J,
                value: W[J.slug].value,
                error: S.customer.fields[J.slug],
                onChange: te
              },
              J.slug
            );
          }),
          d && (d == null ? void 0 : d.length) > 0 && /* @__PURE__ */ x.jsx(
            Sl,
            {
              label: w("public_pages_purchase.payment.price_plan"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: me,
              selected: String(z == null ? void 0 : z.id),
              onChange: (J) => {
                const te = Number(J), ye = d.find((Pe) => Pe.id === te);
                ye && (U(ye), G(ye.amount));
              },
              required: !0,
              error: (Ne = S.pricePlan) == null ? void 0 : Ne.join(", ")
            }
          ),
          z && /* @__PURE__ */ x.jsx(
            nne,
            {
              calculatePrice: C,
              isLoading: _ ?? !1,
              pricePlan: z
            }
          ),
          I && (I == null ? void 0 : I.length) > 0 && /* @__PURE__ */ x.jsx(
            Sl,
            {
              label: w("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: he,
              selected: L,
              onChange: (J) => A(J),
              required: !0,
              error: (K = S.paymentMethod) == null ? void 0 : K.join(", ")
            }
          ),
          S.common && /* @__PURE__ */ x.jsx(
            oo,
            {
              error: (Ee = S.common) == null ? void 0 : Ee.join(", "),
              errorClassName: "flex justify-center"
            }
          )
        ] }),
        V
      ] })
    ] }) }),
    m && /* @__PURE__ */ x.jsx(O8, { affiliateLink: h })
  ] }) });
};
export {
  jZ as CENTERED_LAYOUT_BASE_CLASSNAME,
  k8 as CardWrapper,
  Hne as CenteredLayout,
  cr as CurrencyBadge,
  Qv as DesignContext,
  Ine as DesignProvider,
  qne as DigitalCheckout,
  dne as DigitalStoreI18Provider,
  bl as FontRootNamesEnum,
  Une as Home,
  eb as LAYOUT_BASE_CLASSNAME,
  B3 as Layout,
  Yv as LocaleContext,
  Rne as LocaleProvider,
  $ne as MercadoPagoProvider,
  Yne as PhysicalCheckout,
  Ar as ProductTypeEnum,
  jW as Profile,
  _p as ROOT_DESIGN_ID,
  wp as ROOT_FONT_ID,
  Sl as RadioGroupAccordion,
  qv as S3_BUCKET_URL,
  Jv as S3_FONTS_BUCKET_URL,
  l1 as SocialLinksEnum,
  R1 as StoreFontEnum,
  xr as StoreImage,
  $e as StoreImageEnum,
  Vn as StoreItemEnum,
  RZ as StoreItemStyleEnum,
  pne as StoreProvider,
  mt as StoreThemeEnum,
  Kne as StripeProvider,
  U3 as SuccessIcon,
  Zne as ThankYou,
  Jr as ThemeButton,
  w2 as ThemeRootNamesEnum,
  LZ as applyDesign,
  ev as createStore,
  _l as defaultDesignValues,
  zne as defaultECourseValues,
  sn as defaultFontValues,
  Fne as defaultLinkValues,
  Vne as defaultOptinValues,
  Gne as defaultPhysicalProductValues,
  Bne as defaultProductDownloadValues,
  J1 as getAmountWithCurrencySymbol,
  S8 as getColors,
  AK as getCommonItem,
  m5 as getDefaultFieldValues,
  AZ as getFontCss,
  Az as getI18nInstance,
  _4 as getPhysicalProductPricePlan,
  TZ as getRootDesignCss,
  Sp as getSingleFontCssString,
  Dne as getSingleFontPreviewCssString,
  Pn as getSocialLinkIcon,
  NK as getStoreImageHeight,
  OK as getStoreImageWidth,
  A8 as httpClient,
  Wne as mocks,
  wr as useDesignContext,
  qr as useLocaleContext,
  av as useMercadoPagoStore,
  Dr as useOfferStore,
  A_ as usePaymentProcessors,
  b9 as usePhysicalProductStore,
  Wz as usePublicKeysStore,
  Rt as useStore,
  nv as useVisitorInfoStore,
  rv as useXenditStore
};
